(function (f) {
    if (typeof exports === "object" && typeof module !== "undefined") {
      module.exports = f();
    } else if (typeof define === "function" && define.amd) {
      define([], f);
    } else {
      var g;
      if (typeof window !== "undefined") {
        g = window;
      } else if (typeof global !== "undefined") {
        g = global;
      } else if (typeof self !== "undefined") {
        g = self;
      } else {
        g = this;
      }
      g.PDFDocument = f();
    }
  })(function () {
    var define, module, exports;
    return (function () {
      function r(e, n, t) {
        function o(i, f) {
          if (!n[i]) {
            if (!e[i]) {
              var c = "function" == typeof require && require;
              if (!f && c) return c(i, !0);
              if (u) return u(i, !0);
              var a = new Error("Cannot find module '" + i + "'");
              throw ((a.code = "MODULE_NOT_FOUND"), a);
            }
            var p = (n[i] = { exports: {} });
            e[i][0].call(
              p.exports,
              function (r) {
                var n = e[i][1][r];
                return o(n || r);
              },
              p,
              p.exports,
              r,
              e,
              n,
              t
            );
          }
          return n[i].exports;
        }
        for (
          var u = "function" == typeof require && require, i = 0;
          i < t.length;
          i++
        )
          o(t[i]);
        return o;
      }
      return r;
    })()(
      {
        1: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                "use strict";
  
                var stream = require("stream");
                var fs = require("fs");
                var zlib = require("zlib");
                var CryptoJS = require("crypto-js");
                var fontkit = require("fontkit");
                var events = require("events");
                var LineBreaker = require("linebreak");
                var PNG = require("png-js");
  
                /*
  PDFAbstractReference - abstract class for PDF reference
  */
                class PDFAbstractReference {
                  toString() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }
  
                /*
  PDFTree - abstract base class for name and number tree objects
  */
  
                class PDFTree {
                  constructor(options = {}) {
                    this._items = {}; // disable /Limits output for this tree
  
                    this.limits =
                      typeof options.limits === "boolean" ? options.limits : true;
                  }
  
                  add(key, val) {
                    return (this._items[key] = val);
                  }
  
                  get(key) {
                    return this._items[key];
                  }
  
                  toString() {
                    // Needs to be sorted by key
                    const sortedKeys = Object.keys(this._items).sort((a, b) =>
                      this._compareKeys(a, b)
                    );
                    const out = ["<<"];
  
                    if (this.limits && sortedKeys.length > 1) {
                      const first = sortedKeys[0],
                        last = sortedKeys[sortedKeys.length - 1];
                      out.push(
                        `  /Limits ${PDFObject.convert([
                          this._dataForKey(first),
                          this._dataForKey(last),
                        ])}`
                      );
                    }
  
                    out.push(`  /${this._keysName()} [`);
  
                    for (let key of sortedKeys) {
                      out.push(
                        `    ${PDFObject.convert(
                          this._dataForKey(key)
                        )} ${PDFObject.convert(this._items[key])}`
                      );
                    }
  
                    out.push("]");
                    out.push(">>");
                    return out.join("\n");
                  }
  
                  _compareKeys() {
                    throw new Error("Must be implemented by subclasses");
                  }
  
                  _keysName() {
                    throw new Error("Must be implemented by subclasses");
                  }
  
                  _dataForKey() {
                    throw new Error("Must be implemented by subclasses");
                  }
                }
  
                /*
  PDFObject - converts JavaScript types into their corresponding PDF types.
  By Devon Govett
  */
  
                const pad = (str, length) =>
                  (Array(length + 1).join("0") + str).slice(-length);
  
                const escapableRe = /[\n\r\t\b\f()\\]/g;
                const escapable = {
                  "\n": "\\n",
                  "\r": "\\r",
                  "\t": "\\t",
                  "\b": "\\b",
                  "\f": "\\f",
                  "\\": "\\\\",
                  "(": "\\(",
                  ")": "\\)",
                }; // Convert little endian UTF-16 to big endian
  
                const swapBytes = function (buff) {
                  const l = buff.length;
  
                  if (l & 0x01) {
                    throw new Error("Buffer length must be even");
                  } else {
                    for (let i = 0, end = l - 1; i < end; i += 2) {
                      const a = buff[i];
                      buff[i] = buff[i + 1];
                      buff[i + 1] = a;
                    }
                  }
  
                  return buff;
                };
  
                class PDFObject {
                  static convert(object, encryptFn = null) {
                    // String literals are converted to the PDF name type
                    if (typeof object === "string") {
                      return `/${object}`; // String objects are converted to PDF strings (UTF-16)
                    } else if (object instanceof String) {
                      let string = object; // Detect if this is a unicode string
  
                      let isUnicode = false;
  
                      for (let i = 0, end = string.length; i < end; i++) {
                        if (string.charCodeAt(i) > 0x7f) {
                          isUnicode = true;
                          break;
                        }
                      } // If so, encode it as big endian UTF-16
  
                      let stringBuffer;
  
                      if (isUnicode) {
                        stringBuffer = swapBytes(
                          Buffer.from(`\ufeff${string}`, "utf16le")
                        );
                      } else {
                        stringBuffer = Buffer.from(string.valueOf(), "ascii");
                      } // Encrypt the string when necessary
  
                      if (encryptFn) {
                        string = encryptFn(stringBuffer).toString("binary");
                      } else {
                        string = stringBuffer.toString("binary");
                      } // Escape characters as required by the spec
  
                      string = string.replace(escapableRe, (c) => escapable[c]);
                      return `(${string})`; // Buffers are converted to PDF hex strings
                    } else if (Buffer.isBuffer(object)) {
                      return `<${object.toString("hex")}>`;
                    } else if (
                      object instanceof PDFAbstractReference ||
                      object instanceof PDFTree
                    ) {
                      return object.toString();
                    } else if (object instanceof Date) {
                      let string =
                        `D:${pad(object.getUTCFullYear(), 4)}` +
                        pad(object.getUTCMonth() + 1, 2) +
                        pad(object.getUTCDate(), 2) +
                        pad(object.getUTCHours(), 2) +
                        pad(object.getUTCMinutes(), 2) +
                        pad(object.getUTCSeconds(), 2) +
                        "Z"; // Encrypt the string when necessary
  
                      if (encryptFn) {
                        string = encryptFn(Buffer.from(string, "ascii")).toString(
                          "binary"
                        ); // Escape characters as required by the spec
  
                        string = string.replace(escapableRe, (c) => escapable[c]);
                      }
  
                      return `(${string})`;
                    } else if (Array.isArray(object)) {
                      const items = object
                        .map((e) => PDFObject.convert(e, encryptFn))
                        .join(" ");
                      return `[${items}]`;
                    } else if ({}.toString.call(object) === "[object Object]") {
                      const out = ["<<"];
  
                      for (let key in object) {
                        const val = object[key];
                        out.push(`/${key} ${PDFObject.convert(val, encryptFn)}`);
                      }
  
                      out.push(">>");
                      return out.join("\n");
                    } else if (typeof object === "number") {
                      return PDFObject.number(object);
                    } else {
                      return `${object}`;
                    }
                  }
  
                  static number(n) {
                    if (n > -1e21 && n < 1e21) {
                      return Math.round(n * 1e6) / 1e6;
                    }
  
                    throw new Error(`unsupported number: ${n}`);
                  }
                }
  
                /*
  PDFReference - represents a reference to another object in the PDF object heirarchy
  By Devon Govett
  */
  
                class PDFReference extends PDFAbstractReference {
                  constructor(document, id, data = {}) {
                    super();
                    this.document = document;
                    this.id = id;
                    this.data = data;
                    this.gen = 0;
                    this.compress = this.document.compress && !this.data.Filter;
                    this.uncompressedLength = 0;
                    this.buffer = [];
                  }
  
                  write(chunk) {
                    if (!Buffer.isBuffer(chunk)) {
                      chunk = Buffer.from(chunk + "\n", "binary");
                    }
  
                    this.uncompressedLength += chunk.length;
  
                    if (this.data.Length == null) {
                      this.data.Length = 0;
                    }
  
                    this.buffer.push(chunk);
                    this.data.Length += chunk.length;
  
                    if (this.compress) {
                      return (this.data.Filter = "FlateDecode");
                    }
                  }
  
                  end(chunk) {
                    if (chunk) {
                      this.write(chunk);
                    }
  
                    return this.finalize();
                  }
  
                  finalize() {
                    this.offset = this.document._offset;
                    const encryptFn = this.document._security
                      ? this.document._security.getEncryptFn(this.id, this.gen)
                      : null;
  
                    if (this.buffer.length) {
                      this.buffer = Buffer.concat(this.buffer);
  
                      if (this.compress) {
                        this.buffer = zlib.deflateSync(this.buffer);
                      }
  
                      if (encryptFn) {
                        this.buffer = encryptFn(this.buffer);
                      }
  
                      this.data.Length = this.buffer.length;
                    }
  
                    this.document._write(`${this.id} ${this.gen} obj`);
  
                    this.document._write(PDFObject.convert(this.data, encryptFn));
  
                    if (this.buffer.length) {
                      this.document._write("stream");
  
                      this.document._write(this.buffer);
  
                      this.buffer = []; // free up memory
  
                      this.document._write("\nendstream");
                    }
  
                    this.document._write("endobj");
  
                    this.document._refEnd(this);
                  }
  
                  toString() {
                    return `${this.id} ${this.gen} R`;
                  }
                }
  
                /*
  PDFPage - represents a single page in the PDF document
  By Devon Govett
  */
                const DEFAULT_MARGINS = {
                  top: 72,
                  left: 72,
                  bottom: 72,
                  right: 72,
                };
                const SIZES = {
                  "4A0": [4767.87, 6740.79],
                  "2A0": [3370.39, 4767.87],
                  A0: [2383.94, 3370.39],
                  A1: [1683.78, 2383.94],
                  A2: [1190.55, 1683.78],
                  A3: [841.89, 1190.55],
                  A4: [595.28, 841.89],
                  A5: [419.53, 595.28],
                  A6: [297.64, 419.53],
                  A7: [209.76, 297.64],
                  A8: [147.4, 209.76],
                  A9: [104.88, 147.4],
                  A10: [73.7, 104.88],
                  B0: [2834.65, 4008.19],
                  B1: [2004.09, 2834.65],
                  B2: [1417.32, 2004.09],
                  B3: [1000.63, 1417.32],
                  B4: [708.66, 1000.63],
                  B5: [498.9, 708.66],
                  B6: [354.33, 498.9],
                  B7: [249.45, 354.33],
                  B8: [175.75, 249.45],
                  B9: [124.72, 175.75],
                  B10: [87.87, 124.72],
                  C0: [2599.37, 3676.54],
                  C1: [1836.85, 2599.37],
                  C2: [1298.27, 1836.85],
                  C3: [918.43, 1298.27],
                  C4: [649.13, 918.43],
                  C5: [459.21, 649.13],
                  C6: [323.15, 459.21],
                  C7: [229.61, 323.15],
                  C8: [161.57, 229.61],
                  C9: [113.39, 161.57],
                  C10: [79.37, 113.39],
                  RA0: [2437.8, 3458.27],
                  RA1: [1729.13, 2437.8],
                  RA2: [1218.9, 1729.13],
                  RA3: [864.57, 1218.9],
                  RA4: [609.45, 864.57],
                  SRA0: [2551.18, 3628.35],
                  SRA1: [1814.17, 2551.18],
                  SRA2: [1275.59, 1814.17],
                  SRA3: [907.09, 1275.59],
                  SRA4: [637.8, 907.09],
                  EXECUTIVE: [521.86, 756.0],
                  FOLIO: [612.0, 936.0],
                  LEGAL: [612.0, 1008.0],
                  LETTER: [612.0, 792.0],
                  TABLOID: [792.0, 1224.0],
                };
  
                class PDFPage {
                  constructor(document, options = {}) {
                    this.document = document;
                    this.size = options.size || "letter";
                    this.layout = options.layout || "portrait"; // process margins
  
                    if (typeof options.margin === "number") {
                      this.margins = {
                        top: options.margin,
                        left: options.margin,
                        bottom: options.margin,
                        right: options.margin,
                      }; // default to 1 inch margins
                    } else {
                      this.margins = options.margins || DEFAULT_MARGINS;
                    } // calculate page dimensions
  
                    const dimensions = Array.isArray(this.size)
                      ? this.size
                      : SIZES[this.size.toUpperCase()];
                    this.width = dimensions[this.layout === "portrait" ? 0 : 1];
                    this.height = dimensions[this.layout === "portrait" ? 1 : 0];
                    this.content = this.document.ref(); // Initialize the Font, XObject, and ExtGState dictionaries
  
                    this.resources = this.document.ref({
                      ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                    }); // The page dictionary
  
                    this.dictionary = this.document.ref({
                      Type: "Page",
                      Parent: this.document._root.data.Pages,
                      MediaBox: [0, 0, this.width, this.height],
                      Contents: this.content,
                      Resources: this.resources,
                    });
                    this.markings = [];
                  } // Lazily create these objects
  
                  get fonts() {
                    const data = this.resources.data;
                    return data.Font != null ? data.Font : (data.Font = {});
                  }
  
                  get xobjects() {
                    const data = this.resources.data;
                    return data.XObject != null
                      ? data.XObject
                      : (data.XObject = {});
                  }
  
                  get ext_gstates() {
                    const data = this.resources.data;
                    return data.ExtGState != null
                      ? data.ExtGState
                      : (data.ExtGState = {});
                  }
  
                  get patterns() {
                    const data = this.resources.data;
                    return data.Pattern != null
                      ? data.Pattern
                      : (data.Pattern = {});
                  }
  
                  get colorSpaces() {
                    const data = this.resources.data;
                    return data.ColorSpace || (data.ColorSpace = {});
                  }
  
                  get annotations() {
                    const data = this.dictionary.data;
                    return data.Annots != null ? data.Annots : (data.Annots = []);
                  }
  
                  get structParentTreeKey() {
                    const data = this.dictionary.data;
                    return data.StructParents != null
                      ? data.StructParents
                      : (data.StructParents =
                          this.document.createStructParentTreeNextKey());
                  }
  
                  maxY() {
                    return this.height - this.margins.bottom;
                  }
  
                  write(chunk) {
                    return this.content.write(chunk);
                  }
  
                  end() {
                    this.dictionary.end();
                    this.resources.end();
                    return this.content.end();
                  }
                }
  
                /*
  PDFNameTree - represents a name tree object
  */
  
                class PDFNameTree extends PDFTree {
                  _compareKeys(a, b) {
                    return a.localeCompare(b);
                  }
  
                  _keysName() {
                    return "Names";
                  }
  
                  _dataForKey(k) {
                    return new String(k);
                  }
                }
  
                /**
                 * Check if value is in a range group.
                 * @param {number} value
                 * @param {number[]} rangeGroup
                 * @returns {boolean}
                 */
                function inRange(value, rangeGroup) {
                  if (value < rangeGroup[0]) return false;
                  let startRange = 0;
                  let endRange = rangeGroup.length / 2;
  
                  while (startRange <= endRange) {
                    const middleRange = Math.floor((startRange + endRange) / 2); // actual array index
  
                    const arrayIndex = middleRange * 2; // Check if value is in range pointed by actual index
  
                    if (
                      value >= rangeGroup[arrayIndex] &&
                      value <= rangeGroup[arrayIndex + 1]
                    ) {
                      return true;
                    }
  
                    if (value > rangeGroup[arrayIndex + 1]) {
                      // Search Right Side Of Array
                      startRange = middleRange + 1;
                    } else {
                      // Search Left Side Of Array
                      endRange = middleRange - 1;
                    }
                  }
  
                  return false;
                }
  
                /**
                 * A.1 Unassigned code points in Unicode 3.2
                 * @link https://tools.ietf.org/html/rfc3454#appendix-A.1
                 */
  
                const unassigned_code_points = [
                  0x0221, 0x0221, 0x0234, 0x024f, 0x02ae, 0x02af, 0x02ef, 0x02ff,
                  0x0350, 0x035f, 0x0370, 0x0373, 0x0376, 0x0379, 0x037b, 0x037d,
                  0x037f, 0x0383, 0x038b, 0x038b, 0x038d, 0x038d, 0x03a2, 0x03a2,
                  0x03cf, 0x03cf, 0x03f7, 0x03ff, 0x0487, 0x0487, 0x04cf, 0x04cf,
                  0x04f6, 0x04f7, 0x04fa, 0x04ff, 0x0510, 0x0530, 0x0557, 0x0558,
                  0x0560, 0x0560, 0x0588, 0x0588, 0x058b, 0x0590, 0x05a2, 0x05a2,
                  0x05ba, 0x05ba, 0x05c5, 0x05cf, 0x05eb, 0x05ef, 0x05f5, 0x060b,
                  0x060d, 0x061a, 0x061c, 0x061e, 0x0620, 0x0620, 0x063b, 0x063f,
                  0x0656, 0x065f, 0x06ee, 0x06ef, 0x06ff, 0x06ff, 0x070e, 0x070e,
                  0x072d, 0x072f, 0x074b, 0x077f, 0x07b2, 0x0900, 0x0904, 0x0904,
                  0x093a, 0x093b, 0x094e, 0x094f, 0x0955, 0x0957, 0x0971, 0x0980,
                  0x0984, 0x0984, 0x098d, 0x098e, 0x0991, 0x0992, 0x09a9, 0x09a9,
                  0x09b1, 0x09b1, 0x09b3, 0x09b5, 0x09ba, 0x09bb, 0x09bd, 0x09bd,
                  0x09c5, 0x09c6, 0x09c9, 0x09ca, 0x09ce, 0x09d6, 0x09d8, 0x09db,
                  0x09de, 0x09de, 0x09e4, 0x09e5, 0x09fb, 0x0a01, 0x0a03, 0x0a04,
                  0x0a0b, 0x0a0e, 0x0a11, 0x0a12, 0x0a29, 0x0a29, 0x0a31, 0x0a31,
                  0x0a34, 0x0a34, 0x0a37, 0x0a37, 0x0a3a, 0x0a3b, 0x0a3d, 0x0a3d,
                  0x0a43, 0x0a46, 0x0a49, 0x0a4a, 0x0a4e, 0x0a58, 0x0a5d, 0x0a5d,
                  0x0a5f, 0x0a65, 0x0a75, 0x0a80, 0x0a84, 0x0a84, 0x0a8c, 0x0a8c,
                  0x0a8e, 0x0a8e, 0x0a92, 0x0a92, 0x0aa9, 0x0aa9, 0x0ab1, 0x0ab1,
                  0x0ab4, 0x0ab4, 0x0aba, 0x0abb, 0x0ac6, 0x0ac6, 0x0aca, 0x0aca,
                  0x0ace, 0x0acf, 0x0ad1, 0x0adf, 0x0ae1, 0x0ae5, 0x0af0, 0x0b00,
                  0x0b04, 0x0b04, 0x0b0d, 0x0b0e, 0x0b11, 0x0b12, 0x0b29, 0x0b29,
                  0x0b31, 0x0b31, 0x0b34, 0x0b35, 0x0b3a, 0x0b3b, 0x0b44, 0x0b46,
                  0x0b49, 0x0b4a, 0x0b4e, 0x0b55, 0x0b58, 0x0b5b, 0x0b5e, 0x0b5e,
                  0x0b62, 0x0b65, 0x0b71, 0x0b81, 0x0b84, 0x0b84, 0x0b8b, 0x0b8d,
                  0x0b91, 0x0b91, 0x0b96, 0x0b98, 0x0b9b, 0x0b9b, 0x0b9d, 0x0b9d,
                  0x0ba0, 0x0ba2, 0x0ba5, 0x0ba7, 0x0bab, 0x0bad, 0x0bb6, 0x0bb6,
                  0x0bba, 0x0bbd, 0x0bc3, 0x0bc5, 0x0bc9, 0x0bc9, 0x0bce, 0x0bd6,
                  0x0bd8, 0x0be6, 0x0bf3, 0x0c00, 0x0c04, 0x0c04, 0x0c0d, 0x0c0d,
                  0x0c11, 0x0c11, 0x0c29, 0x0c29, 0x0c34, 0x0c34, 0x0c3a, 0x0c3d,
                  0x0c45, 0x0c45, 0x0c49, 0x0c49, 0x0c4e, 0x0c54, 0x0c57, 0x0c5f,
                  0x0c62, 0x0c65, 0x0c70, 0x0c81, 0x0c84, 0x0c84, 0x0c8d, 0x0c8d,
                  0x0c91, 0x0c91, 0x0ca9, 0x0ca9, 0x0cb4, 0x0cb4, 0x0cba, 0x0cbd,
                  0x0cc5, 0x0cc5, 0x0cc9, 0x0cc9, 0x0cce, 0x0cd4, 0x0cd7, 0x0cdd,
                  0x0cdf, 0x0cdf, 0x0ce2, 0x0ce5, 0x0cf0, 0x0d01, 0x0d04, 0x0d04,
                  0x0d0d, 0x0d0d, 0x0d11, 0x0d11, 0x0d29, 0x0d29, 0x0d3a, 0x0d3d,
                  0x0d44, 0x0d45, 0x0d49, 0x0d49, 0x0d4e, 0x0d56, 0x0d58, 0x0d5f,
                  0x0d62, 0x0d65, 0x0d70, 0x0d81, 0x0d84, 0x0d84, 0x0d97, 0x0d99,
                  0x0db2, 0x0db2, 0x0dbc, 0x0dbc, 0x0dbe, 0x0dbf, 0x0dc7, 0x0dc9,
                  0x0dcb, 0x0dce, 0x0dd5, 0x0dd5, 0x0dd7, 0x0dd7, 0x0de0, 0x0df1,
                  0x0df5, 0x0e00, 0x0e3b, 0x0e3e, 0x0e5c, 0x0e80, 0x0e83, 0x0e83,
                  0x0e85, 0x0e86, 0x0e89, 0x0e89, 0x0e8b, 0x0e8c, 0x0e8e, 0x0e93,
                  0x0e98, 0x0e98, 0x0ea0, 0x0ea0, 0x0ea4, 0x0ea4, 0x0ea6, 0x0ea6,
                  0x0ea8, 0x0ea9, 0x0eac, 0x0eac, 0x0eba, 0x0eba, 0x0ebe, 0x0ebf,
                  0x0ec5, 0x0ec5, 0x0ec7, 0x0ec7, 0x0ece, 0x0ecf, 0x0eda, 0x0edb,
                  0x0ede, 0x0eff, 0x0f48, 0x0f48, 0x0f6b, 0x0f70, 0x0f8c, 0x0f8f,
                  0x0f98, 0x0f98, 0x0fbd, 0x0fbd, 0x0fcd, 0x0fce, 0x0fd0, 0x0fff,
                  0x1022, 0x1022, 0x1028, 0x1028, 0x102b, 0x102b, 0x1033, 0x1035,
                  0x103a, 0x103f, 0x105a, 0x109f, 0x10c6, 0x10cf, 0x10f9, 0x10fa,
                  0x10fc, 0x10ff, 0x115a, 0x115e, 0x11a3, 0x11a7, 0x11fa, 0x11ff,
                  0x1207, 0x1207, 0x1247, 0x1247, 0x1249, 0x1249, 0x124e, 0x124f,
                  0x1257, 0x1257, 0x1259, 0x1259, 0x125e, 0x125f, 0x1287, 0x1287,
                  0x1289, 0x1289, 0x128e, 0x128f, 0x12af, 0x12af, 0x12b1, 0x12b1,
                  0x12b6, 0x12b7, 0x12bf, 0x12bf, 0x12c1, 0x12c1, 0x12c6, 0x12c7,
                  0x12cf, 0x12cf, 0x12d7, 0x12d7, 0x12ef, 0x12ef, 0x130f, 0x130f,
                  0x1311, 0x1311, 0x1316, 0x1317, 0x131f, 0x131f, 0x1347, 0x1347,
                  0x135b, 0x1360, 0x137d, 0x139f, 0x13f5, 0x1400, 0x1677, 0x167f,
                  0x169d, 0x169f, 0x16f1, 0x16ff, 0x170d, 0x170d, 0x1715, 0x171f,
                  0x1737, 0x173f, 0x1754, 0x175f, 0x176d, 0x176d, 0x1771, 0x1771,
                  0x1774, 0x177f, 0x17dd, 0x17df, 0x17ea, 0x17ff, 0x180f, 0x180f,
                  0x181a, 0x181f, 0x1878, 0x187f, 0x18aa, 0x1dff, 0x1e9c, 0x1e9f,
                  0x1efa, 0x1eff, 0x1f16, 0x1f17, 0x1f1e, 0x1f1f, 0x1f46, 0x1f47,
                  0x1f4e, 0x1f4f, 0x1f58, 0x1f58, 0x1f5a, 0x1f5a, 0x1f5c, 0x1f5c,
                  0x1f5e, 0x1f5e, 0x1f7e, 0x1f7f, 0x1fb5, 0x1fb5, 0x1fc5, 0x1fc5,
                  0x1fd4, 0x1fd5, 0x1fdc, 0x1fdc, 0x1ff0, 0x1ff1, 0x1ff5, 0x1ff5,
                  0x1fff, 0x1fff, 0x2053, 0x2056, 0x2058, 0x205e, 0x2064, 0x2069,
                  0x2072, 0x2073, 0x208f, 0x209f, 0x20b2, 0x20cf, 0x20eb, 0x20ff,
                  0x213b, 0x213c, 0x214c, 0x2152, 0x2184, 0x218f, 0x23cf, 0x23ff,
                  0x2427, 0x243f, 0x244b, 0x245f, 0x24ff, 0x24ff, 0x2614, 0x2615,
                  0x2618, 0x2618, 0x267e, 0x267f, 0x268a, 0x2700, 0x2705, 0x2705,
                  0x270a, 0x270b, 0x2728, 0x2728, 0x274c, 0x274c, 0x274e, 0x274e,
                  0x2753, 0x2755, 0x2757, 0x2757, 0x275f, 0x2760, 0x2795, 0x2797,
                  0x27b0, 0x27b0, 0x27bf, 0x27cf, 0x27ec, 0x27ef, 0x2b00, 0x2e7f,
                  0x2e9a, 0x2e9a, 0x2ef4, 0x2eff, 0x2fd6, 0x2fef, 0x2ffc, 0x2fff,
                  0x3040, 0x3040, 0x3097, 0x3098, 0x3100, 0x3104, 0x312d, 0x3130,
                  0x318f, 0x318f, 0x31b8, 0x31ef, 0x321d, 0x321f, 0x3244, 0x3250,
                  0x327c, 0x327e, 0x32cc, 0x32cf, 0x32ff, 0x32ff, 0x3377, 0x337a,
                  0x33de, 0x33df, 0x33ff, 0x33ff, 0x4db6, 0x4dff, 0x9fa6, 0x9fff,
                  0xa48d, 0xa48f, 0xa4c7, 0xabff, 0xd7a4, 0xd7ff, 0xfa2e, 0xfa2f,
                  0xfa6b, 0xfaff, 0xfb07, 0xfb12, 0xfb18, 0xfb1c, 0xfb37, 0xfb37,
                  0xfb3d, 0xfb3d, 0xfb3f, 0xfb3f, 0xfb42, 0xfb42, 0xfb45, 0xfb45,
                  0xfbb2, 0xfbd2, 0xfd40, 0xfd4f, 0xfd90, 0xfd91, 0xfdc8, 0xfdcf,
                  0xfdfd, 0xfdff, 0xfe10, 0xfe1f, 0xfe24, 0xfe2f, 0xfe47, 0xfe48,
                  0xfe53, 0xfe53, 0xfe67, 0xfe67, 0xfe6c, 0xfe6f, 0xfe75, 0xfe75,
                  0xfefd, 0xfefe, 0xff00, 0xff00, 0xffbf, 0xffc1, 0xffc8, 0xffc9,
                  0xffd0, 0xffd1, 0xffd8, 0xffd9, 0xffdd, 0xffdf, 0xffe7, 0xffe7,
                  0xffef, 0xfff8, 0x10000, 0x102ff, 0x1031f, 0x1031f, 0x10324,
                  0x1032f, 0x1034b, 0x103ff, 0x10426, 0x10427, 0x1044e, 0x1cfff,
                  0x1d0f6, 0x1d0ff, 0x1d127, 0x1d129, 0x1d1de, 0x1d3ff, 0x1d455,
                  0x1d455, 0x1d49d, 0x1d49d, 0x1d4a0, 0x1d4a1, 0x1d4a3, 0x1d4a4,
                  0x1d4a7, 0x1d4a8, 0x1d4ad, 0x1d4ad, 0x1d4ba, 0x1d4ba, 0x1d4bc,
                  0x1d4bc, 0x1d4c1, 0x1d4c1, 0x1d4c4, 0x1d4c4, 0x1d506, 0x1d506,
                  0x1d50b, 0x1d50c, 0x1d515, 0x1d515, 0x1d51d, 0x1d51d, 0x1d53a,
                  0x1d53a, 0x1d53f, 0x1d53f, 0x1d545, 0x1d545, 0x1d547, 0x1d549,
                  0x1d551, 0x1d551, 0x1d6a4, 0x1d6a7, 0x1d7ca, 0x1d7cd, 0x1d800,
                  0x1fffd, 0x2a6d7, 0x2f7ff, 0x2fa1e, 0x2fffd, 0x30000, 0x3fffd,
                  0x40000, 0x4fffd, 0x50000, 0x5fffd, 0x60000, 0x6fffd, 0x70000,
                  0x7fffd, 0x80000, 0x8fffd, 0x90000, 0x9fffd, 0xa0000, 0xafffd,
                  0xb0000, 0xbfffd, 0xc0000, 0xcfffd, 0xd0000, 0xdfffd, 0xe0000,
                  0xe0000, 0xe0002, 0xe001f, 0xe0080, 0xefffd,
                ]; // prettier-ignore-end
  
                const isUnassignedCodePoint = (character) =>
                  inRange(character, unassigned_code_points); // prettier-ignore-start
  
                /**
                 * B.1 Commonly mapped to nothing
                 * @link https://tools.ietf.org/html/rfc3454#appendix-B.1
                 */
  
                const commonly_mapped_to_nothing = [
                  0x00ad, 0x00ad, 0x034f, 0x034f, 0x1806, 0x1806, 0x180b, 0x180b,
                  0x180c, 0x180c, 0x180d, 0x180d, 0x200b, 0x200b, 0x200c, 0x200c,
                  0x200d, 0x200d, 0x2060, 0x2060, 0xfe00, 0xfe00, 0xfe01, 0xfe01,
                  0xfe02, 0xfe02, 0xfe03, 0xfe03, 0xfe04, 0xfe04, 0xfe05, 0xfe05,
                  0xfe06, 0xfe06, 0xfe07, 0xfe07, 0xfe08, 0xfe08, 0xfe09, 0xfe09,
                  0xfe0a, 0xfe0a, 0xfe0b, 0xfe0b, 0xfe0c, 0xfe0c, 0xfe0d, 0xfe0d,
                  0xfe0e, 0xfe0e, 0xfe0f, 0xfe0f, 0xfeff, 0xfeff,
                ]; // prettier-ignore-end
  
                const isCommonlyMappedToNothing = (character) =>
                  inRange(character, commonly_mapped_to_nothing); // prettier-ignore-start
  
                /**
                 * C.1.2 Non-ASCII space characters
                 * @link https://tools.ietf.org/html/rfc3454#appendix-C.1.2
                 */
  
                const non_ASCII_space_characters = [
                  0x00a0, 0x00a0, /* NO-BREAK SPACE */
                  0x1680, 0x1680, /* OGHAM SPACE MARK */
                  0x2000, 0x2000, /* EN QUAD */
                  0x2001, 0x2001, /* EM QUAD */
                  0x2002, 0x2002, /* EN SPACE */
                  0x2003, 0x2003, /* EM SPACE */
                  0x2004, 0x2004, /* THREE-PER-EM SPACE */
                  0x2005, 0x2005, /* FOUR-PER-EM SPACE */
                  0x2006, 0x2006, /* SIX-PER-EM SPACE */
                  0x2007, 0x2007, /* FIGURE SPACE */
                  0x2008, 0x2008, /* PUNCTUATION SPACE */
                  0x2009, 0x2009, /* THIN SPACE */
                  0x200a, 0x200a, /* HAIR SPACE */
                  0x200b, 0x200b, /* ZERO WIDTH SPACE */
                  0x202f, 0x202f, /* NARROW NO-BREAK SPACE */
                  0x205f, 0x205f, /* MEDIUM MATHEMATICAL SPACE */
                  0x3000, 0x3000,
                  /* IDEOGRAPHIC SPACE */
                ]; // prettier-ignore-end
  
                const isNonASCIISpaceCharacter = (character) =>
                  inRange(character, non_ASCII_space_characters); // prettier-ignore-start
  
                const non_ASCII_controls_characters = [
                  /**
                   * C.2.2 Non-ASCII control characters
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.2
                   */
                  0x0080, 0x009f, /* [CONTROL CHARACTERS] */
                  0x06dd, 0x06dd, /* ARABIC END OF AYAH */
                  0x070f, 0x070f, /* SYRIAC ABBREVIATION MARK */
                  0x180e, 0x180e, /* MONGOLIAN VOWEL SEPARATOR */
                  0x200c, 0x200c, /* ZERO WIDTH NON-JOINER */
                  0x200d, 0x200d, /* ZERO WIDTH JOINER */
                  0x2028, 0x2028, /* LINE SEPARATOR */
                  0x2029, 0x2029, /* PARAGRAPH SEPARATOR */
                  0x2060, 0x2060, /* WORD JOINER */
                  0x2061, 0x2061, /* FUNCTION APPLICATION */
                  0x2062, 0x2062, /* INVISIBLE TIMES */
                  0x2063, 0x2063, /* INVISIBLE SEPARATOR */
                  0x206a, 0x206f, /* [CONTROL CHARACTERS] */
                  0xfeff, 0xfeff, /* ZERO WIDTH NO-BREAK SPACE */
                  0xfff9, 0xfffc, /* [CONTROL CHARACTERS] */
                  0x1d173, 0x1d17a,
                  /* [MUSICAL CONTROL CHARACTERS] */
                ];
                const non_character_codepoints = [
                  /**
                   * C.4 Non-character code points
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.4
                   */
                  0xfdd0, 0xfdef, /* [NONCHARACTER CODE POINTS] */
                  0xfffe, 0xffff, /* [NONCHARACTER CODE POINTS] */
                  0x1fffe, 0x1ffff, /* [NONCHARACTER CODE POINTS] */
                  0x2fffe, 0x2ffff, /* [NONCHARACTER CODE POINTS] */
                  0x3fffe, 0x3ffff, /* [NONCHARACTER CODE POINTS] */
                  0x4fffe, 0x4ffff, /* [NONCHARACTER CODE POINTS] */
                  0x5fffe, 0x5ffff, /* [NONCHARACTER CODE POINTS] */
                  0x6fffe, 0x6ffff, /* [NONCHARACTER CODE POINTS] */
                  0x7fffe, 0x7ffff, /* [NONCHARACTER CODE POINTS] */
                  0x8fffe, 0x8ffff, /* [NONCHARACTER CODE POINTS] */
                  0x9fffe, 0x9ffff, /* [NONCHARACTER CODE POINTS] */
                  0xafffe, 0xaffff, /* [NONCHARACTER CODE POINTS] */
                  0xbfffe, 0xbffff, /* [NONCHARACTER CODE POINTS] */
                  0xcfffe, 0xcffff, /* [NONCHARACTER CODE POINTS] */
                  0xdfffe, 0xdffff, /* [NONCHARACTER CODE POINTS] */
                  0xefffe, 0xeffff, /* [NONCHARACTER CODE POINTS] */
                  0x10fffe, 0x10ffff,
                  /* [NONCHARACTER CODE POINTS] */
                ];
                /**
                 * 2.3.  Prohibited Output
                 */
  
                const prohibited_characters = [
                  /**
                   * C.2.1 ASCII control characters
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.2.1
                   */
                  0, 0x001f, /* [CONTROL CHARACTERS] */
                  0x007f, 0x007f, /* DELETE */
                  /**
                   * C.8 Change display properties or are deprecated
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.8
                   */
                  0x0340, 0x0340, /* COMBINING GRAVE TONE MARK */
                  0x0341, 0x0341, /* COMBINING ACUTE TONE MARK */
                  0x200e, 0x200e, /* LEFT-TO-RIGHT MARK */
                  0x200f, 0x200f, /* RIGHT-TO-LEFT MARK */
                  0x202a, 0x202a, /* LEFT-TO-RIGHT EMBEDDING */
                  0x202b, 0x202b, /* RIGHT-TO-LEFT EMBEDDING */
                  0x202c, 0x202c, /* POP DIRECTIONAL FORMATTING */
                  0x202d, 0x202d, /* LEFT-TO-RIGHT OVERRIDE */
                  0x202e, 0x202e, /* RIGHT-TO-LEFT OVERRIDE */
                  0x206a, 0x206a, /* INHIBIT SYMMETRIC SWAPPING */
                  0x206b, 0x206b, /* ACTIVATE SYMMETRIC SWAPPING */
                  0x206c, 0x206c, /* INHIBIT ARABIC FORM SHAPING */
                  0x206d, 0x206d, /* ACTIVATE ARABIC FORM SHAPING */
                  0x206e, 0x206e, /* NATIONAL DIGIT SHAPES */
                  0x206f, 0x206f, /* NOMINAL DIGIT SHAPES */
                  /**
                   * C.7 Inappropriate for canonical representation
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.7
                   */
                  0x2ff0, 0x2ffb, /* [IDEOGRAPHIC DESCRIPTION CHARACTERS] */
                  /**
                   * C.5 Surrogate codes
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.5
                   */
                  0xd800, 0xdfff, /**
                   * C.3 Private use
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
                   */
                  0xe000, 0xf8ff, /* [PRIVATE USE, PLANE 0] */
                  /**
                   * C.6 Inappropriate for plain text
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.6
                   */
                  0xfff9, 0xfff9, /* INTERLINEAR ANNOTATION ANCHOR */
                  0xfffa, 0xfffa, /* INTERLINEAR ANNOTATION SEPARATOR */
                  0xfffb, 0xfffb, /* INTERLINEAR ANNOTATION TERMINATOR */
                  0xfffc, 0xfffc, /* OBJECT REPLACEMENT CHARACTER */
                  0xfffd, 0xfffd, /* REPLACEMENT CHARACTER */
                  /**
                   * C.9 Tagging characters
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.9
                   */
                  0xe0001, 0xe0001, /* LANGUAGE TAG */
                  0xe0020, 0xe007f, /* [TAGGING CHARACTERS] */
                  /**
                   * C.3 Private use
                   * @link https://tools.ietf.org/html/rfc3454#appendix-C.3
                   */
                  0xf0000, 0xffffd, /* [PRIVATE USE, PLANE 15] */
                  0x100000, 0x10fffd,
                  /* [PRIVATE USE, PLANE 16] */
                ]; // prettier-ignore-end
  
                const isProhibitedCharacter = (character) =>
                  inRange(character, non_ASCII_space_characters) ||
                  inRange(character, prohibited_characters) ||
                  inRange(character, non_ASCII_controls_characters) ||
                  inRange(character, non_character_codepoints); // prettier-ignore-start
  
                /**
                 * D.1 Characters with bidirectional property "R" or "AL"
                 * @link https://tools.ietf.org/html/rfc3454#appendix-D.1
                 */
  
                const bidirectional_r_al = [
                  0x05be, 0x05be, 0x05c0, 0x05c0, 0x05c3, 0x05c3, 0x05d0, 0x05ea,
                  0x05f0, 0x05f4, 0x061b, 0x061b, 0x061f, 0x061f, 0x0621, 0x063a,
                  0x0640, 0x064a, 0x066d, 0x066f, 0x0671, 0x06d5, 0x06dd, 0x06dd,
                  0x06e5, 0x06e6, 0x06fa, 0x06fe, 0x0700, 0x070d, 0x0710, 0x0710,
                  0x0712, 0x072c, 0x0780, 0x07a5, 0x07b1, 0x07b1, 0x200f, 0x200f,
                  0xfb1d, 0xfb1d, 0xfb1f, 0xfb28, 0xfb2a, 0xfb36, 0xfb38, 0xfb3c,
                  0xfb3e, 0xfb3e, 0xfb40, 0xfb41, 0xfb43, 0xfb44, 0xfb46, 0xfbb1,
                  0xfbd3, 0xfd3d, 0xfd50, 0xfd8f, 0xfd92, 0xfdc7, 0xfdf0, 0xfdfc,
                  0xfe70, 0xfe74, 0xfe76, 0xfefc,
                ]; // prettier-ignore-end
  
                const isBidirectionalRAL = (character) =>
                  inRange(character, bidirectional_r_al); // prettier-ignore-start
  
                /**
                 * D.2 Characters with bidirectional property "L"
                 * @link https://tools.ietf.org/html/rfc3454#appendix-D.2
                 */
  
                const bidirectional_l = [
                  0x0041, 0x005a, 0x0061, 0x007a, 0x00aa, 0x00aa, 0x00b5, 0x00b5,
                  0x00ba, 0x00ba, 0x00c0, 0x00d6, 0x00d8, 0x00f6, 0x00f8, 0x0220,
                  0x0222, 0x0233, 0x0250, 0x02ad, 0x02b0, 0x02b8, 0x02bb, 0x02c1,
                  0x02d0, 0x02d1, 0x02e0, 0x02e4, 0x02ee, 0x02ee, 0x037a, 0x037a,
                  0x0386, 0x0386, 0x0388, 0x038a, 0x038c, 0x038c, 0x038e, 0x03a1,
                  0x03a3, 0x03ce, 0x03d0, 0x03f5, 0x0400, 0x0482, 0x048a, 0x04ce,
                  0x04d0, 0x04f5, 0x04f8, 0x04f9, 0x0500, 0x050f, 0x0531, 0x0556,
                  0x0559, 0x055f, 0x0561, 0x0587, 0x0589, 0x0589, 0x0903, 0x0903,
                  0x0905, 0x0939, 0x093d, 0x0940, 0x0949, 0x094c, 0x0950, 0x0950,
                  0x0958, 0x0961, 0x0964, 0x0970, 0x0982, 0x0983, 0x0985, 0x098c,
                  0x098f, 0x0990, 0x0993, 0x09a8, 0x09aa, 0x09b0, 0x09b2, 0x09b2,
                  0x09b6, 0x09b9, 0x09be, 0x09c0, 0x09c7, 0x09c8, 0x09cb, 0x09cc,
                  0x09d7, 0x09d7, 0x09dc, 0x09dd, 0x09df, 0x09e1, 0x09e6, 0x09f1,
                  0x09f4, 0x09fa, 0x0a05, 0x0a0a, 0x0a0f, 0x0a10, 0x0a13, 0x0a28,
                  0x0a2a, 0x0a30, 0x0a32, 0x0a33, 0x0a35, 0x0a36, 0x0a38, 0x0a39,
                  0x0a3e, 0x0a40, 0x0a59, 0x0a5c, 0x0a5e, 0x0a5e, 0x0a66, 0x0a6f,
                  0x0a72, 0x0a74, 0x0a83, 0x0a83, 0x0a85, 0x0a8b, 0x0a8d, 0x0a8d,
                  0x0a8f, 0x0a91, 0x0a93, 0x0aa8, 0x0aaa, 0x0ab0, 0x0ab2, 0x0ab3,
                  0x0ab5, 0x0ab9, 0x0abd, 0x0ac0, 0x0ac9, 0x0ac9, 0x0acb, 0x0acc,
                  0x0ad0, 0x0ad0, 0x0ae0, 0x0ae0, 0x0ae6, 0x0aef, 0x0b02, 0x0b03,
                  0x0b05, 0x0b0c, 0x0b0f, 0x0b10, 0x0b13, 0x0b28, 0x0b2a, 0x0b30,
                  0x0b32, 0x0b33, 0x0b36, 0x0b39, 0x0b3d, 0x0b3e, 0x0b40, 0x0b40,
                  0x0b47, 0x0b48, 0x0b4b, 0x0b4c, 0x0b57, 0x0b57, 0x0b5c, 0x0b5d,
                  0x0b5f, 0x0b61, 0x0b66, 0x0b70, 0x0b83, 0x0b83, 0x0b85, 0x0b8a,
                  0x0b8e, 0x0b90, 0x0b92, 0x0b95, 0x0b99, 0x0b9a, 0x0b9c, 0x0b9c,
                  0x0b9e, 0x0b9f, 0x0ba3, 0x0ba4, 0x0ba8, 0x0baa, 0x0bae, 0x0bb5,
                  0x0bb7, 0x0bb9, 0x0bbe, 0x0bbf, 0x0bc1, 0x0bc2, 0x0bc6, 0x0bc8,
                  0x0bca, 0x0bcc, 0x0bd7, 0x0bd7, 0x0be7, 0x0bf2, 0x0c01, 0x0c03,
                  0x0c05, 0x0c0c, 0x0c0e, 0x0c10, 0x0c12, 0x0c28, 0x0c2a, 0x0c33,
                  0x0c35, 0x0c39, 0x0c41, 0x0c44, 0x0c60, 0x0c61, 0x0c66, 0x0c6f,
                  0x0c82, 0x0c83, 0x0c85, 0x0c8c, 0x0c8e, 0x0c90, 0x0c92, 0x0ca8,
                  0x0caa, 0x0cb3, 0x0cb5, 0x0cb9, 0x0cbe, 0x0cbe, 0x0cc0, 0x0cc4,
                  0x0cc7, 0x0cc8, 0x0cca, 0x0ccb, 0x0cd5, 0x0cd6, 0x0cde, 0x0cde,
                  0x0ce0, 0x0ce1, 0x0ce6, 0x0cef, 0x0d02, 0x0d03, 0x0d05, 0x0d0c,
                  0x0d0e, 0x0d10, 0x0d12, 0x0d28, 0x0d2a, 0x0d39, 0x0d3e, 0x0d40,
                  0x0d46, 0x0d48, 0x0d4a, 0x0d4c, 0x0d57, 0x0d57, 0x0d60, 0x0d61,
                  0x0d66, 0x0d6f, 0x0d82, 0x0d83, 0x0d85, 0x0d96, 0x0d9a, 0x0db1,
                  0x0db3, 0x0dbb, 0x0dbd, 0x0dbd, 0x0dc0, 0x0dc6, 0x0dcf, 0x0dd1,
                  0x0dd8, 0x0ddf, 0x0df2, 0x0df4, 0x0e01, 0x0e30, 0x0e32, 0x0e33,
                  0x0e40, 0x0e46, 0x0e4f, 0x0e5b, 0x0e81, 0x0e82, 0x0e84, 0x0e84,
                  0x0e87, 0x0e88, 0x0e8a, 0x0e8a, 0x0e8d, 0x0e8d, 0x0e94, 0x0e97,
                  0x0e99, 0x0e9f, 0x0ea1, 0x0ea3, 0x0ea5, 0x0ea5, 0x0ea7, 0x0ea7,
                  0x0eaa, 0x0eab, 0x0ead, 0x0eb0, 0x0eb2, 0x0eb3, 0x0ebd, 0x0ebd,
                  0x0ec0, 0x0ec4, 0x0ec6, 0x0ec6, 0x0ed0, 0x0ed9, 0x0edc, 0x0edd,
                  0x0f00, 0x0f17, 0x0f1a, 0x0f34, 0x0f36, 0x0f36, 0x0f38, 0x0f38,
                  0x0f3e, 0x0f47, 0x0f49, 0x0f6a, 0x0f7f, 0x0f7f, 0x0f85, 0x0f85,
                  0x0f88, 0x0f8b, 0x0fbe, 0x0fc5, 0x0fc7, 0x0fcc, 0x0fcf, 0x0fcf,
                  0x1000, 0x1021, 0x1023, 0x1027, 0x1029, 0x102a, 0x102c, 0x102c,
                  0x1031, 0x1031, 0x1038, 0x1038, 0x1040, 0x1057, 0x10a0, 0x10c5,
                  0x10d0, 0x10f8, 0x10fb, 0x10fb, 0x1100, 0x1159, 0x115f, 0x11a2,
                  0x11a8, 0x11f9, 0x1200, 0x1206, 0x1208, 0x1246, 0x1248, 0x1248,
                  0x124a, 0x124d, 0x1250, 0x1256, 0x1258, 0x1258, 0x125a, 0x125d,
                  0x1260, 0x1286, 0x1288, 0x1288, 0x128a, 0x128d, 0x1290, 0x12ae,
                  0x12b0, 0x12b0, 0x12b2, 0x12b5, 0x12b8, 0x12be, 0x12c0, 0x12c0,
                  0x12c2, 0x12c5, 0x12c8, 0x12ce, 0x12d0, 0x12d6, 0x12d8, 0x12ee,
                  0x12f0, 0x130e, 0x1310, 0x1310, 0x1312, 0x1315, 0x1318, 0x131e,
                  0x1320, 0x1346, 0x1348, 0x135a, 0x1361, 0x137c, 0x13a0, 0x13f4,
                  0x1401, 0x1676, 0x1681, 0x169a, 0x16a0, 0x16f0, 0x1700, 0x170c,
                  0x170e, 0x1711, 0x1720, 0x1731, 0x1735, 0x1736, 0x1740, 0x1751,
                  0x1760, 0x176c, 0x176e, 0x1770, 0x1780, 0x17b6, 0x17be, 0x17c5,
                  0x17c7, 0x17c8, 0x17d4, 0x17da, 0x17dc, 0x17dc, 0x17e0, 0x17e9,
                  0x1810, 0x1819, 0x1820, 0x1877, 0x1880, 0x18a8, 0x1e00, 0x1e9b,
                  0x1ea0, 0x1ef9, 0x1f00, 0x1f15, 0x1f18, 0x1f1d, 0x1f20, 0x1f45,
                  0x1f48, 0x1f4d, 0x1f50, 0x1f57, 0x1f59, 0x1f59, 0x1f5b, 0x1f5b,
                  0x1f5d, 0x1f5d, 0x1f5f, 0x1f7d, 0x1f80, 0x1fb4, 0x1fb6, 0x1fbc,
                  0x1fbe, 0x1fbe, 0x1fc2, 0x1fc4, 0x1fc6, 0x1fcc, 0x1fd0, 0x1fd3,
                  0x1fd6, 0x1fdb, 0x1fe0, 0x1fec, 0x1ff2, 0x1ff4, 0x1ff6, 0x1ffc,
                  0x200e, 0x200e, 0x2071, 0x2071, 0x207f, 0x207f, 0x2102, 0x2102,
                  0x2107, 0x2107, 0x210a, 0x2113, 0x2115, 0x2115, 0x2119, 0x211d,
                  0x2124, 0x2124, 0x2126, 0x2126, 0x2128, 0x2128, 0x212a, 0x212d,
                  0x212f, 0x2131, 0x2133, 0x2139, 0x213d, 0x213f, 0x2145, 0x2149,
                  0x2160, 0x2183, 0x2336, 0x237a, 0x2395, 0x2395, 0x249c, 0x24e9,
                  0x3005, 0x3007, 0x3021, 0x3029, 0x3031, 0x3035, 0x3038, 0x303c,
                  0x3041, 0x3096, 0x309d, 0x309f, 0x30a1, 0x30fa, 0x30fc, 0x30ff,
                  0x3105, 0x312c, 0x3131, 0x318e, 0x3190, 0x31b7, 0x31f0, 0x321c,
                  0x3220, 0x3243, 0x3260, 0x327b, 0x327f, 0x32b0, 0x32c0, 0x32cb,
                  0x32d0, 0x32fe, 0x3300, 0x3376, 0x337b, 0x33dd, 0x33e0, 0x33fe,
                  0x3400, 0x4db5, 0x4e00, 0x9fa5, 0xa000, 0xa48c, 0xac00, 0xd7a3,
                  0xd800, 0xfa2d, 0xfa30, 0xfa6a, 0xfb00, 0xfb06, 0xfb13, 0xfb17,
                  0xff21, 0xff3a, 0xff41, 0xff5a, 0xff66, 0xffbe, 0xffc2, 0xffc7,
                  0xffca, 0xffcf, 0xffd2, 0xffd7, 0xffda, 0xffdc, 0x10300,
                  0x1031e, 0x10320, 0x10323, 0x10330, 0x1034a, 0x10400, 0x10425,
                  0x10428, 0x1044d, 0x1d000, 0x1d0f5, 0x1d100, 0x1d126, 0x1d12a,
                  0x1d166, 0x1d16a, 0x1d172, 0x1d183, 0x1d184, 0x1d18c, 0x1d1a9,
                  0x1d1ae, 0x1d1dd, 0x1d400, 0x1d454, 0x1d456, 0x1d49c, 0x1d49e,
                  0x1d49f, 0x1d4a2, 0x1d4a2, 0x1d4a5, 0x1d4a6, 0x1d4a9, 0x1d4ac,
                  0x1d4ae, 0x1d4b9, 0x1d4bb, 0x1d4bb, 0x1d4bd, 0x1d4c0, 0x1d4c2,
                  0x1d4c3, 0x1d4c5, 0x1d505, 0x1d507, 0x1d50a, 0x1d50d, 0x1d514,
                  0x1d516, 0x1d51c, 0x1d51e, 0x1d539, 0x1d53b, 0x1d53e, 0x1d540,
                  0x1d544, 0x1d546, 0x1d546, 0x1d54a, 0x1d550, 0x1d552, 0x1d6a3,
                  0x1d6a8, 0x1d7c9, 0x20000, 0x2a6d6, 0x2f800, 0x2fa1d, 0xf0000,
                  0xffffd, 0x100000, 0x10fffd,
                ]; // prettier-ignore-end
  
                const isBidirectionalL = (character) =>
                  inRange(character, bidirectional_l);
  
                /**
                 * non-ASCII space characters [StringPrep, C.1.2] that can be
                 * mapped to SPACE (U+0020)
                 */
  
                const mapping2space = isNonASCIISpaceCharacter;
                /**
                 * the "commonly mapped to nothing" characters [StringPrep, B.1]
                 * that can be mapped to nothing.
                 */
  
                const mapping2nothing = isCommonlyMappedToNothing; // utils
  
                const getCodePoint = (character) => character.codePointAt(0);
  
                const first = (x) => x[0];
  
                const last = (x) => x[x.length - 1];
                /**
                 * Convert provided string into an array of Unicode Code Points.
                 * Based on https://stackoverflow.com/a/21409165/1556249
                 * and https://www.npmjs.com/package/code-point-at.
                 * @param {string} input
                 * @returns {number[]}
                 */
  
                function toCodePoints(input) {
                  const codepoints = [];
                  const size = input.length;
  
                  for (let i = 0; i < size; i += 1) {
                    const before = input.charCodeAt(i);
  
                    if (before >= 0xd800 && before <= 0xdbff && size > i + 1) {
                      const next = input.charCodeAt(i + 1);
  
                      if (next >= 0xdc00 && next <= 0xdfff) {
                        codepoints.push(
                          (before - 0xd800) * 0x400 + next - 0xdc00 + 0x10000
                        );
                        i += 1;
                        continue;
                      }
                    }
  
                    codepoints.push(before);
                  }
  
                  return codepoints;
                }
                /**
                 * SASLprep.
                 * @param {string} input
                 * @param {Object} opts
                 * @param {boolean} opts.allowUnassigned
                 * @returns {string}
                 */
  
                function saslprep(input, opts = {}) {
                  if (typeof input !== "string") {
                    throw new TypeError("Expected string.");
                  }
  
                  if (input.length === 0) {
                    return "";
                  } // 1. Map
  
                  const mapped_input = toCodePoints(input) // 1.1 mapping to space
                    .map((character) =>
                      mapping2space(character) ? 0x20 : character
                    ) // 1.2 mapping to nothing
                    .filter((character) => !mapping2nothing(character)); // 2. Normalize
  
                  const normalized_input = String.fromCodePoint
                    .apply(null, mapped_input)
                    .normalize("NFKC");
                  const normalized_map = toCodePoints(normalized_input); // 3. Prohibit
  
                  const hasProhibited = normalized_map.some(
                    isProhibitedCharacter
                  );
  
                  if (hasProhibited) {
                    throw new Error(
                      "Prohibited character, see https://tools.ietf.org/html/rfc4013#section-2.3"
                    );
                  } // Unassigned Code Points
  
                  if (opts.allowUnassigned !== true) {
                    const hasUnassigned = normalized_map.some(
                      isUnassignedCodePoint
                    );
  
                    if (hasUnassigned) {
                      throw new Error(
                        "Unassigned code point, see https://tools.ietf.org/html/rfc4013#section-2.5"
                      );
                    }
                  } // 4. check bidi
  
                  const hasBidiRAL = normalized_map.some(isBidirectionalRAL);
                  const hasBidiL = normalized_map.some(isBidirectionalL); // 4.1 If a string contains any RandALCat character, the string MUST NOT
                  // contain any LCat character.
  
                  if (hasBidiRAL && hasBidiL) {
                    throw new Error(
                      "String must not contain RandALCat and LCat at the same time," +
                        " see https://tools.ietf.org/html/rfc3454#section-6"
                    );
                  }
                  /**
                   * 4.2 If a string contains any RandALCat character, a RandALCat
                   * character MUST be the first character of the string, and a
                   * RandALCat character MUST be the last character of the string.
                   */
  
                  const isFirstBidiRAL = isBidirectionalRAL(
                    getCodePoint(first(normalized_input))
                  );
                  const isLastBidiRAL = isBidirectionalRAL(
                    getCodePoint(last(normalized_input))
                  );
  
                  if (hasBidiRAL && !(isFirstBidiRAL && isLastBidiRAL)) {
                    throw new Error(
                      "Bidirectional RandALCat character must be the first and the last" +
                        " character of the string, see https://tools.ietf.org/html/rfc3454#section-6"
                    );
                  }
  
                  return normalized_input;
                }
  
                /*
     PDFSecurity - represents PDF security settings
     By Yang Liu <hi@zesik.com>
   */
  
                class PDFSecurity {
                  static generateFileID(info = {}) {
                    let infoStr = `${info.CreationDate.getTime()}\n`;
  
                    for (let key in info) {
                      // eslint-disable-next-line no-prototype-builtins
                      if (!info.hasOwnProperty(key)) {
                        continue;
                      }
  
                      infoStr += `${key}: ${info[key].valueOf()}\n`;
                    }
  
                    return wordArrayToBuffer(CryptoJS.MD5(infoStr));
                  }
  
                  static generateRandomWordArray(bytes) {
                    return CryptoJS.lib.WordArray.random(bytes);
                  }
  
                  static create(document, options = {}) {
                    if (!options.ownerPassword && !options.userPassword) {
                      return null;
                    }
  
                    return new PDFSecurity(document, options);
                  }
  
                  constructor(document, options = {}) {
                    if (!options.ownerPassword && !options.userPassword) {
                      throw new Error(
                        "None of owner password and user password is defined."
                      );
                    }
  
                    this.document = document;
  
                    this._setupEncryption(options);
                  }
  
                  _setupEncryption(options) {
                    switch (options.pdfVersion) {
                      case "1.4":
                      case "1.5":
                        this.version = 2;
                        break;
  
                      case "1.6":
                      case "1.7":
                        this.version = 4;
                        break;
  
                      case "1.7ext3":
                        this.version = 5;
                        break;
  
                      default:
                        this.version = 1;
                        break;
                    }
  
                    const encDict = {
                      Filter: "Standard",
                    };
  
                    switch (this.version) {
                      case 1:
                      case 2:
                      case 4:
                        this._setupEncryptionV1V2V4(
                          this.version,
                          encDict,
                          options
                        );
  
                        break;
  
                      case 5:
                        this._setupEncryptionV5(encDict, options);
  
                        break;
                    }
  
                    this.dictionary = this.document.ref(encDict);
                  }
  
                  _setupEncryptionV1V2V4(v, encDict, options) {
                    let r, permissions;
  
                    switch (v) {
                      case 1:
                        r = 2;
                        this.keyBits = 40;
                        permissions = getPermissionsR2(options.permissions);
                        break;
  
                      case 2:
                        r = 3;
                        this.keyBits = 128;
                        permissions = getPermissionsR3(options.permissions);
                        break;
  
                      case 4:
                        r = 4;
                        this.keyBits = 128;
                        permissions = getPermissionsR3(options.permissions);
                        break;
                    }
  
                    const paddedUserPassword = processPasswordR2R3R4(
                      options.userPassword
                    );
                    const paddedOwnerPassword = options.ownerPassword
                      ? processPasswordR2R3R4(options.ownerPassword)
                      : paddedUserPassword;
                    const ownerPasswordEntry = getOwnerPasswordR2R3R4(
                      r,
                      this.keyBits,
                      paddedUserPassword,
                      paddedOwnerPassword
                    );
                    this.encryptionKey = getEncryptionKeyR2R3R4(
                      r,
                      this.keyBits,
                      this.document._id,
                      paddedUserPassword,
                      ownerPasswordEntry,
                      permissions
                    );
                    let userPasswordEntry;
  
                    if (r === 2) {
                      userPasswordEntry = getUserPasswordR2(this.encryptionKey);
                    } else {
                      userPasswordEntry = getUserPasswordR3R4(
                        this.document._id,
                        this.encryptionKey
                      );
                    }
  
                    encDict.V = v;
  
                    if (v >= 2) {
                      encDict.Length = this.keyBits;
                    }
  
                    if (v === 4) {
                      encDict.CF = {
                        StdCF: {
                          AuthEvent: "DocOpen",
                          CFM: "AESV2",
                          Length: this.keyBits / 8,
                        },
                      };
                      encDict.StmF = "StdCF";
                      encDict.StrF = "StdCF";
                    }
  
                    encDict.R = r;
                    encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                    encDict.U = wordArrayToBuffer(userPasswordEntry);
                    encDict.P = permissions;
                  }
  
                  _setupEncryptionV5(encDict, options) {
                    this.keyBits = 256;
                    const permissions = getPermissionsR3(options.permissions);
                    const processedUserPassword = processPasswordR5(
                      options.userPassword
                    );
                    const processedOwnerPassword = options.ownerPassword
                      ? processPasswordR5(options.ownerPassword)
                      : processedUserPassword;
                    this.encryptionKey = getEncryptionKeyR5(
                      PDFSecurity.generateRandomWordArray
                    );
                    const userPasswordEntry = getUserPasswordR5(
                      processedUserPassword,
                      PDFSecurity.generateRandomWordArray
                    );
                    const userKeySalt = CryptoJS.lib.WordArray.create(
                      userPasswordEntry.words.slice(10, 12),
                      8
                    );
                    const userEncryptionKeyEntry = getUserEncryptionKeyR5(
                      processedUserPassword,
                      userKeySalt,
                      this.encryptionKey
                    );
                    const ownerPasswordEntry = getOwnerPasswordR5(
                      processedOwnerPassword,
                      userPasswordEntry,
                      PDFSecurity.generateRandomWordArray
                    );
                    const ownerKeySalt = CryptoJS.lib.WordArray.create(
                      ownerPasswordEntry.words.slice(10, 12),
                      8
                    );
                    const ownerEncryptionKeyEntry = getOwnerEncryptionKeyR5(
                      processedOwnerPassword,
                      ownerKeySalt,
                      userPasswordEntry,
                      this.encryptionKey
                    );
                    const permsEntry = getEncryptedPermissionsR5(
                      permissions,
                      this.encryptionKey,
                      PDFSecurity.generateRandomWordArray
                    );
                    encDict.V = 5;
                    encDict.Length = this.keyBits;
                    encDict.CF = {
                      StdCF: {
                        AuthEvent: "DocOpen",
                        CFM: "AESV3",
                        Length: this.keyBits / 8,
                      },
                    };
                    encDict.StmF = "StdCF";
                    encDict.StrF = "StdCF";
                    encDict.R = 5;
                    encDict.O = wordArrayToBuffer(ownerPasswordEntry);
                    encDict.OE = wordArrayToBuffer(ownerEncryptionKeyEntry);
                    encDict.U = wordArrayToBuffer(userPasswordEntry);
                    encDict.UE = wordArrayToBuffer(userEncryptionKeyEntry);
                    encDict.P = permissions;
                    encDict.Perms = wordArrayToBuffer(permsEntry);
                  }
  
                  getEncryptFn(obj, gen) {
                    let digest;
  
                    if (this.version < 5) {
                      digest = this.encryptionKey
                        .clone()
                        .concat(
                          CryptoJS.lib.WordArray.create(
                            [
                              ((obj & 0xff) << 24) |
                                ((obj & 0xff00) << 8) |
                                ((obj >> 8) & 0xff00) |
                                (gen & 0xff),
                              (gen & 0xff00) << 16,
                            ],
                            5
                          )
                        );
                    }
  
                    if (this.version === 1 || this.version === 2) {
                      let key = CryptoJS.MD5(digest);
                      key.sigBytes = Math.min(16, this.keyBits / 8 + 5);
                      return (buffer) =>
                        wordArrayToBuffer(
                          CryptoJS.RC4.encrypt(
                            CryptoJS.lib.WordArray.create(buffer),
                            key
                          ).ciphertext
                        );
                    }
  
                    let key;
  
                    if (this.version === 4) {
                      key = CryptoJS.MD5(
                        digest.concat(
                          CryptoJS.lib.WordArray.create([0x73416c54], 4)
                        )
                      );
                    } else {
                      key = this.encryptionKey;
                    }
  
                    const iv = PDFSecurity.generateRandomWordArray(16);
                    const options = {
                      mode: CryptoJS.mode.CBC,
                      padding: CryptoJS.pad.Pkcs7,
                      iv,
                    };
                    return (buffer) =>
                      wordArrayToBuffer(
                        iv
                          .clone()
                          .concat(
                            CryptoJS.AES.encrypt(
                              CryptoJS.lib.WordArray.create(buffer),
                              key,
                              options
                            ).ciphertext
                          )
                      );
                  }
  
                  end() {
                    this.dictionary.end();
                  }
                }
  
                function getPermissionsR2(permissionObject = {}) {
                  let permissions = 0xffffffc0 >> 0;
  
                  if (permissionObject.printing) {
                    permissions |= 0b000000000100;
                  }
  
                  if (permissionObject.modifying) {
                    permissions |= 0b000000001000;
                  }
  
                  if (permissionObject.copying) {
                    permissions |= 0b000000010000;
                  }
  
                  if (permissionObject.annotating) {
                    permissions |= 0b000000100000;
                  }
  
                  return permissions;
                }
  
                function getPermissionsR3(permissionObject = {}) {
                  let permissions = 0xfffff0c0 >> 0;
  
                  if (permissionObject.printing === "lowResolution") {
                    permissions |= 0b000000000100;
                  }
  
                  if (permissionObject.printing === "highResolution") {
                    permissions |= 0b100000000100;
                  }
  
                  if (permissionObject.modifying) {
                    permissions |= 0b000000001000;
                  }
  
                  if (permissionObject.copying) {
                    permissions |= 0b000000010000;
                  }
  
                  if (permissionObject.annotating) {
                    permissions |= 0b000000100000;
                  }
  
                  if (permissionObject.fillingForms) {
                    permissions |= 0b000100000000;
                  }
  
                  if (permissionObject.contentAccessibility) {
                    permissions |= 0b001000000000;
                  }
  
                  if (permissionObject.documentAssembly) {
                    permissions |= 0b010000000000;
                  }
  
                  return permissions;
                }
  
                function getUserPasswordR2(encryptionKey) {
                  return CryptoJS.RC4.encrypt(
                    processPasswordR2R3R4(),
                    encryptionKey
                  ).ciphertext;
                }
  
                function getUserPasswordR3R4(documentId, encryptionKey) {
                  const key = encryptionKey.clone();
                  let cipher = CryptoJS.MD5(
                    processPasswordR2R3R4().concat(
                      CryptoJS.lib.WordArray.create(documentId)
                    )
                  );
  
                  for (let i = 0; i < 20; i++) {
                    const xorRound = Math.ceil(key.sigBytes / 4);
  
                    for (let j = 0; j < xorRound; j++) {
                      key.words[j] =
                        encryptionKey.words[j] ^
                        (i | (i << 8) | (i << 16) | (i << 24));
                    }
  
                    cipher = CryptoJS.RC4.encrypt(cipher, key).ciphertext;
                  }
  
                  return cipher.concat(CryptoJS.lib.WordArray.create(null, 16));
                }
  
                function getOwnerPasswordR2R3R4(
                  r,
                  keyBits,
                  paddedUserPassword,
                  paddedOwnerPassword
                ) {
                  let digest = paddedOwnerPassword;
                  let round = r >= 3 ? 51 : 1;
  
                  for (let i = 0; i < round; i++) {
                    digest = CryptoJS.MD5(digest);
                  }
  
                  const key = digest.clone();
                  key.sigBytes = keyBits / 8;
                  let cipher = paddedUserPassword;
                  round = r >= 3 ? 20 : 1;
  
                  for (let i = 0; i < round; i++) {
                    const xorRound = Math.ceil(key.sigBytes / 4);
  
                    for (let j = 0; j < xorRound; j++) {
                      key.words[j] =
                        digest.words[j] ^ (i | (i << 8) | (i << 16) | (i << 24));
                    }
  
                    cipher = CryptoJS.RC4.encrypt(cipher, key).ciphertext;
                  }
  
                  return cipher;
                }
  
                function getEncryptionKeyR2R3R4(
                  r,
                  keyBits,
                  documentId,
                  paddedUserPassword,
                  ownerPasswordEntry,
                  permissions
                ) {
                  let key = paddedUserPassword
                    .clone()
                    .concat(ownerPasswordEntry)
                    .concat(
                      CryptoJS.lib.WordArray.create(
                        [lsbFirstWord(permissions)],
                        4
                      )
                    )
                    .concat(CryptoJS.lib.WordArray.create(documentId));
                  const round = r >= 3 ? 51 : 1;
  
                  for (let i = 0; i < round; i++) {
                    key = CryptoJS.MD5(key);
                    key.sigBytes = keyBits / 8;
                  }
  
                  return key;
                }
  
                function getUserPasswordR5(
                  processedUserPassword,
                  generateRandomWordArray
                ) {
                  const validationSalt = generateRandomWordArray(8);
                  const keySalt = generateRandomWordArray(8);
                  return CryptoJS.SHA256(
                    processedUserPassword.clone().concat(validationSalt)
                  )
                    .concat(validationSalt)
                    .concat(keySalt);
                }
  
                function getUserEncryptionKeyR5(
                  processedUserPassword,
                  userKeySalt,
                  encryptionKey
                ) {
                  const key = CryptoJS.SHA256(
                    processedUserPassword.clone().concat(userKeySalt)
                  );
                  const options = {
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.NoPadding,
                    iv: CryptoJS.lib.WordArray.create(null, 16),
                  };
                  return CryptoJS.AES.encrypt(encryptionKey, key, options)
                    .ciphertext;
                }
  
                function getOwnerPasswordR5(
                  processedOwnerPassword,
                  userPasswordEntry,
                  generateRandomWordArray
                ) {
                  const validationSalt = generateRandomWordArray(8);
                  const keySalt = generateRandomWordArray(8);
                  return CryptoJS.SHA256(
                    processedOwnerPassword
                      .clone()
                      .concat(validationSalt)
                      .concat(userPasswordEntry)
                  )
                    .concat(validationSalt)
                    .concat(keySalt);
                }
  
                function getOwnerEncryptionKeyR5(
                  processedOwnerPassword,
                  ownerKeySalt,
                  userPasswordEntry,
                  encryptionKey
                ) {
                  const key = CryptoJS.SHA256(
                    processedOwnerPassword
                      .clone()
                      .concat(ownerKeySalt)
                      .concat(userPasswordEntry)
                  );
                  const options = {
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.NoPadding,
                    iv: CryptoJS.lib.WordArray.create(null, 16),
                  };
                  return CryptoJS.AES.encrypt(encryptionKey, key, options)
                    .ciphertext;
                }
  
                function getEncryptionKeyR5(generateRandomWordArray) {
                  return generateRandomWordArray(32);
                }
  
                function getEncryptedPermissionsR5(
                  permissions,
                  encryptionKey,
                  generateRandomWordArray
                ) {
                  const cipher = CryptoJS.lib.WordArray.create(
                    [lsbFirstWord(permissions), 0xffffffff, 0x54616462],
                    12
                  ).concat(generateRandomWordArray(4));
                  const options = {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.NoPadding,
                  };
                  return CryptoJS.AES.encrypt(cipher, encryptionKey, options)
                    .ciphertext;
                }
  
                function processPasswordR2R3R4(password = "") {
                  const out = Buffer.alloc(32);
                  const length = password.length;
                  let index = 0;
  
                  while (index < length && index < 32) {
                    const code = password.charCodeAt(index);
  
                    if (code > 0xff) {
                      throw new Error(
                        "Password contains one or more invalid characters."
                      );
                    }
  
                    out[index] = code;
                    index++;
                  }
  
                  while (index < 32) {
                    out[index] = PASSWORD_PADDING[index - length];
                    index++;
                  }
  
                  return CryptoJS.lib.WordArray.create(out);
                }
  
                function processPasswordR5(password = "") {
                  password = unescape(encodeURIComponent(saslprep(password)));
                  const length = Math.min(127, password.length);
                  const out = Buffer.alloc(length);
  
                  for (let i = 0; i < length; i++) {
                    out[i] = password.charCodeAt(i);
                  }
  
                  return CryptoJS.lib.WordArray.create(out);
                }
  
                function lsbFirstWord(data) {
                  return (
                    ((data & 0xff) << 24) |
                    ((data & 0xff00) << 8) |
                    ((data >> 8) & 0xff00) |
                    ((data >> 24) & 0xff)
                  );
                }
  
                function wordArrayToBuffer(wordArray) {
                  const byteArray = [];
  
                  for (let i = 0; i < wordArray.sigBytes; i++) {
                    byteArray.push(
                      (wordArray.words[Math.floor(i / 4)] >>
                        (8 * (3 - (i % 4)))) &
                        0xff
                    );
                  }
  
                  return Buffer.from(byteArray);
                }
  
                const PASSWORD_PADDING = [
                  0x28, 0xbf, 0x4e, 0x5e, 0x4e, 0x75, 0x8a, 0x41, 0x64, 0x00,
                  0x4e, 0x56, 0xff, 0xfa, 0x01, 0x08, 0x2e, 0x2e, 0x00, 0xb6,
                  0xd0, 0x68, 0x3e, 0x80, 0x2f, 0x0c, 0xa9, 0xfe, 0x64, 0x53,
                  0x69, 0x7a,
                ];
  
                const { number } = PDFObject;
  
                class PDFGradient {
                  constructor(doc) {
                    this.doc = doc;
                    this.stops = [];
                    this.embedded = false;
                    this.transform = [1, 0, 0, 1, 0, 0];
                  }
  
                  stop(pos, color, opacity) {
                    if (opacity == null) {
                      opacity = 1;
                    }
  
                    color = this.doc._normalizeColor(color);
  
                    if (this.stops.length === 0) {
                      if (color.length === 3) {
                        this._colorSpace = "DeviceRGB";
                      } else if (color.length === 4) {
                        this._colorSpace = "DeviceCMYK";
                      } else if (color.length === 1) {
                        this._colorSpace = "DeviceGray";
                      } else {
                        throw new Error("Unknown color space");
                      }
                    } else if (
                      (this._colorSpace === "DeviceRGB" && color.length !== 3) ||
                      (this._colorSpace === "DeviceCMYK" && color.length !== 4) ||
                      (this._colorSpace === "DeviceGray" && color.length !== 1)
                    ) {
                      throw new Error(
                        "All gradient stops must use the same color space"
                      );
                    }
  
                    opacity = Math.max(0, Math.min(1, opacity));
                    this.stops.push([pos, color, opacity]);
                    return this;
                  }
  
                  setTransform(m11, m12, m21, m22, dx, dy) {
                    this.transform = [m11, m12, m21, m22, dx, dy];
                    return this;
                  }
  
                  embed(m) {
                    let fn;
                    const stopsLength = this.stops.length;
  
                    if (stopsLength === 0) {
                      return;
                    }
  
                    this.embedded = true;
                    this.matrix = m; // if the last stop comes before 100%, add a copy at 100%
  
                    const last = this.stops[stopsLength - 1];
  
                    if (last[0] < 1) {
                      this.stops.push([1, last[1], last[2]]);
                    }
  
                    const bounds = [];
                    const encode = [];
                    const stops = [];
  
                    for (let i = 0; i < stopsLength - 1; i++) {
                      encode.push(0, 1);
  
                      if (i + 2 !== stopsLength) {
                        bounds.push(this.stops[i + 1][0]);
                      }
  
                      fn = this.doc.ref({
                        FunctionType: 2,
                        Domain: [0, 1],
                        C0: this.stops[i + 0][1],
                        C1: this.stops[i + 1][1],
                        N: 1,
                      });
                      stops.push(fn);
                      fn.end();
                    } // if there are only two stops, we don't need a stitching function
  
                    if (stopsLength === 1) {
                      fn = stops[0];
                    } else {
                      fn = this.doc.ref({
                        FunctionType: 3,
                        // stitching function
                        Domain: [0, 1],
                        Functions: stops,
                        Bounds: bounds,
                        Encode: encode,
                      });
                      fn.end();
                    }
  
                    this.id = `Sh${++this.doc._gradCount}`;
                    const shader = this.shader(fn);
                    shader.end();
                    const pattern = this.doc.ref({
                      Type: "Pattern",
                      PatternType: 2,
                      Shading: shader,
                      Matrix: this.matrix.map(number),
                    });
                    pattern.end();
  
                    if (this.stops.some((stop) => stop[2] < 1)) {
                      let grad = this.opacityGradient();
                      grad._colorSpace = "DeviceGray";
  
                      for (let stop of this.stops) {
                        grad.stop(stop[0], [stop[2]]);
                      }
  
                      grad = grad.embed(this.matrix);
                      const pageBBox = [
                        0,
                        0,
                        this.doc.page.width,
                        this.doc.page.height,
                      ];
                      const form = this.doc.ref({
                        Type: "XObject",
                        Subtype: "Form",
                        FormType: 1,
                        BBox: pageBBox,
                        Group: {
                          Type: "Group",
                          S: "Transparency",
                          CS: "DeviceGray",
                        },
                        Resources: {
                          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                          Pattern: {
                            Sh1: grad,
                          },
                        },
                      });
                      form.write("/Pattern cs /Sh1 scn");
                      form.end(`${pageBBox.join(" ")} re f`);
                      const gstate = this.doc.ref({
                        Type: "ExtGState",
                        SMask: {
                          Type: "Mask",
                          S: "Luminosity",
                          G: form,
                        },
                      });
                      gstate.end();
                      const opacityPattern = this.doc.ref({
                        Type: "Pattern",
                        PatternType: 1,
                        PaintType: 1,
                        TilingType: 2,
                        BBox: pageBBox,
                        XStep: pageBBox[2],
                        YStep: pageBBox[3],
                        Resources: {
                          ProcSet: ["PDF", "Text", "ImageB", "ImageC", "ImageI"],
                          Pattern: {
                            Sh1: pattern,
                          },
                          ExtGState: {
                            Gs1: gstate,
                          },
                        },
                      });
                      opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
                      opacityPattern.end(`${pageBBox.join(" ")} re f`);
                      this.doc.page.patterns[this.id] = opacityPattern;
                    } else {
                      this.doc.page.patterns[this.id] = pattern;
                    }
  
                    return pattern;
                  }
  
                  apply(stroke) {
                    // apply gradient transform to existing document ctm
                    const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
                    const [m11, m12, m21, m22, dx, dy] = this.transform;
                    const m = [
                      m0 * m11 + m2 * m12,
                      m1 * m11 + m3 * m12,
                      m0 * m21 + m2 * m22,
                      m1 * m21 + m3 * m22,
                      m0 * dx + m2 * dy + m4,
                      m1 * dx + m3 * dy + m5,
                    ];
  
                    if (!this.embedded || m.join(" ") !== this.matrix.join(" ")) {
                      this.embed(m);
                    }
  
                    this.doc._setColorSpace("Pattern", stroke);
  
                    const op = stroke ? "SCN" : "scn";
                    return this.doc.addContent(`/${this.id} ${op}`);
                  }
                }
  
                class PDFLinearGradient extends PDFGradient {
                  constructor(doc, x1, y1, x2, y2) {
                    super(doc);
                    this.x1 = x1;
                    this.y1 = y1;
                    this.x2 = x2;
                    this.y2 = y2;
                  }
  
                  shader(fn) {
                    return this.doc.ref({
                      ShadingType: 2,
                      ColorSpace: this._colorSpace,
                      Coords: [this.x1, this.y1, this.x2, this.y2],
                      Function: fn,
                      Extend: [true, true],
                    });
                  }
  
                  opacityGradient() {
                    return new PDFLinearGradient(
                      this.doc,
                      this.x1,
                      this.y1,
                      this.x2,
                      this.y2
                    );
                  }
                }
  
                class PDFRadialGradient extends PDFGradient {
                  constructor(doc, x1, y1, r1, x2, y2, r2) {
                    super(doc);
                    this.doc = doc;
                    this.x1 = x1;
                    this.y1 = y1;
                    this.r1 = r1;
                    this.x2 = x2;
                    this.y2 = y2;
                    this.r2 = r2;
                  }
  
                  shader(fn) {
                    return this.doc.ref({
                      ShadingType: 3,
                      ColorSpace: this._colorSpace,
                      Coords: [
                        this.x1,
                        this.y1,
                        this.r1,
                        this.x2,
                        this.y2,
                        this.r2,
                      ],
                      Function: fn,
                      Extend: [true, true],
                    });
                  }
  
                  opacityGradient() {
                    return new PDFRadialGradient(
                      this.doc,
                      this.x1,
                      this.y1,
                      this.r1,
                      this.x2,
                      this.y2,
                      this.r2
                    );
                  }
                }
  
                var Gradient = {
                  PDFGradient,
                  PDFLinearGradient,
                  PDFRadialGradient,
                };
  
                /*
  PDF tiling pattern support. Uncolored only.
   */
                const underlyingColorSpaces = ["DeviceCMYK", "DeviceRGB"];
  
                class PDFTilingPattern {
                  constructor(doc, bBox, xStep, yStep, stream) {
                    this.doc = doc;
                    this.bBox = bBox;
                    this.xStep = xStep;
                    this.yStep = yStep;
                    this.stream = stream;
                  }
  
                  createPattern() {
                    // no resources needed for our current usage
                    // required entry
                    const resources = this.doc.ref();
                    resources.end(); // apply default transform matrix (flipped in the default doc._ctm)
                    // see document.js & gradient.js
  
                    const [m0, m1, m2, m3, m4, m5] = this.doc._ctm;
                    const [m11, m12, m21, m22, dx, dy] = [1, 0, 0, 1, 0, 0];
                    const m = [
                      m0 * m11 + m2 * m12,
                      m1 * m11 + m3 * m12,
                      m0 * m21 + m2 * m22,
                      m1 * m21 + m3 * m22,
                      m0 * dx + m2 * dy + m4,
                      m1 * dx + m3 * dy + m5,
                    ];
                    const pattern = this.doc.ref({
                      Type: "Pattern",
                      PatternType: 1,
                      // tiling
                      PaintType: 2,
                      // 1-colored, 2-uncolored
                      TilingType: 2,
                      // 2-no distortion
                      BBox: this.bBox,
                      XStep: this.xStep,
                      YStep: this.yStep,
                      Matrix: m.map((v) => +v.toFixed(5)),
                      Resources: resources,
                    });
                    pattern.end(this.stream);
                    return pattern;
                  }
  
                  embedPatternColorSpaces() {
                    // map each pattern to an underlying color space
                    // and embed on each page
                    underlyingColorSpaces.forEach((csName) => {
                      const csId = this.getPatternColorSpaceId(csName);
                      if (this.doc.page.colorSpaces[csId]) return;
                      const cs = this.doc.ref(["Pattern", csName]);
                      cs.end();
                      this.doc.page.colorSpaces[csId] = cs;
                    });
                  }
  
                  getPatternColorSpaceId(underlyingColorspace) {
                    return `CsP${underlyingColorspace}`;
                  }
  
                  embed() {
                    if (!this.id) {
                      this.doc._patternCount = this.doc._patternCount + 1;
                      this.id = "P" + this.doc._patternCount;
                      this.pattern = this.createPattern();
                    } // patterns are embedded in each page
  
                    if (!this.doc.page.patterns[this.id]) {
                      this.doc.page.patterns[this.id] = this.pattern;
                    }
                  }
  
                  apply(stroke, patternColor) {
                    // do any embedding/creating that might be needed
                    this.embedPatternColorSpaces();
                    this.embed();
  
                    const normalizedColor =
                      this.doc._normalizeColor(patternColor);
  
                    if (!normalizedColor)
                      throw Error(
                        `invalid pattern color. (value: ${patternColor})`
                      ); // select one of the pattern color spaces
  
                    const csId = this.getPatternColorSpaceId(
                      this.doc._getColorSpace(normalizedColor)
                    );
  
                    this.doc._setColorSpace(csId, stroke); // stroke/fill using the pattern and color (in the above underlying color space)
  
                    const op = stroke ? "SCN" : "scn";
                    return this.doc.addContent(
                      `${normalizedColor.join(" ")} /${this.id} ${op}`
                    );
                  }
                }
  
                var pattern = {
                  PDFTilingPattern,
                };
  
                const {
                  PDFGradient: PDFGradient$1,
                  PDFLinearGradient: PDFLinearGradient$1,
                  PDFRadialGradient: PDFRadialGradient$1,
                } = Gradient;
                const { PDFTilingPattern: PDFTilingPattern$1 } = pattern;
                var ColorMixin = {
                  initColor() {
                    // The opacity dictionaries
                    this._opacityRegistry = {};
                    this._opacityCount = 0;
                    this._patternCount = 0;
                    return (this._gradCount = 0);
                  },
  
                  _normalizeColor(color) {
                    if (typeof color === "string") {
                      if (color.charAt(0) === "#") {
                        if (color.length === 4) {
                          color = color.replace(
                            /#([0-9A-F])([0-9A-F])([0-9A-F])/i,
                            "#$1$1$2$2$3$3"
                          );
                        }
  
                        const hex = parseInt(color.slice(1), 16);
                        color = [hex >> 16, (hex >> 8) & 0xff, hex & 0xff];
                      } else if (namedColors[color]) {
                        color = namedColors[color];
                      }
                    }
  
                    if (Array.isArray(color)) {
                      // RGB
                      if (color.length === 3) {
                        color = color.map((part) => part / 255); // CMYK
                      } else if (color.length === 4) {
                        color = color.map((part) => part / 100);
                      }
  
                      return color;
                    }
  
                    return null;
                  },
  
                  _setColor(color, stroke) {
                    if (color instanceof PDFGradient$1) {
                      color.apply(stroke);
                      return true; // see if tiling pattern, decode & apply it it
                    } else if (
                      Array.isArray(color) &&
                      color[0] instanceof PDFTilingPattern$1
                    ) {
                      color[0].apply(stroke, color[1]);
                      return true;
                    } // any other case should be a normal color and not a pattern
  
                    return this._setColorCore(color, stroke);
                  },
  
                  _setColorCore(color, stroke) {
                    color = this._normalizeColor(color);
  
                    if (!color) {
                      return false;
                    }
  
                    const op = stroke ? "SCN" : "scn";
  
                    const space = this._getColorSpace(color);
  
                    this._setColorSpace(space, stroke);
  
                    color = color.join(" ");
                    this.addContent(`${color} ${op}`);
                    return true;
                  },
  
                  _setColorSpace(space, stroke) {
                    const op = stroke ? "CS" : "cs";
                    return this.addContent(`/${space} ${op}`);
                  },
  
                  _getColorSpace(color) {
                    return color.length === 4 ? "DeviceCMYK" : "DeviceRGB";
                  },
  
                  fillColor(color, opacity) {
                    const set = this._setColor(color, false);
  
                    if (set) {
                      this.fillOpacity(opacity);
                    } // save this for text wrapper, which needs to reset
                    // the fill color on new pages
  
                    this._fillColor = [color, opacity];
                    return this;
                  },
  
                  strokeColor(color, opacity) {
                    const set = this._setColor(color, true);
  
                    if (set) {
                      this.strokeOpacity(opacity);
                    }
  
                    return this;
                  },
  
                  opacity(opacity) {
                    this._doOpacity(opacity, opacity);
  
                    return this;
                  },
  
                  fillOpacity(opacity) {
                    this._doOpacity(opacity, null);
  
                    return this;
                  },
  
                  strokeOpacity(opacity) {
                    this._doOpacity(null, opacity);
  
                    return this;
                  },
  
                  _doOpacity(fillOpacity, strokeOpacity) {
                    let dictionary, name;
  
                    if (fillOpacity == null && strokeOpacity == null) {
                      return;
                    }
  
                    if (fillOpacity != null) {
                      fillOpacity = Math.max(0, Math.min(1, fillOpacity));
                    }
  
                    if (strokeOpacity != null) {
                      strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
                    }
  
                    const key = `${fillOpacity}_${strokeOpacity}`;
  
                    if (this._opacityRegistry[key]) {
                      [dictionary, name] = this._opacityRegistry[key];
                    } else {
                      dictionary = {
                        Type: "ExtGState",
                      };
  
                      if (fillOpacity != null) {
                        dictionary.ca = fillOpacity;
                      }
  
                      if (strokeOpacity != null) {
                        dictionary.CA = strokeOpacity;
                      }
  
                      dictionary = this.ref(dictionary);
                      dictionary.end();
                      const id = ++this._opacityCount;
                      name = `Gs${id}`;
                      this._opacityRegistry[key] = [dictionary, name];
                    }
  
                    this.page.ext_gstates[name] = dictionary;
                    return this.addContent(`/${name} gs`);
                  },
  
                  linearGradient(x1, y1, x2, y2) {
                    return new PDFLinearGradient$1(this, x1, y1, x2, y2);
                  },
  
                  radialGradient(x1, y1, r1, x2, y2, r2) {
                    return new PDFRadialGradient$1(this, x1, y1, r1, x2, y2, r2);
                  },
  
                  pattern(bbox, xStep, yStep, stream) {
                    return new PDFTilingPattern$1(
                      this,
                      bbox,
                      xStep,
                      yStep,
                      stream
                    );
                  },
                };
                var namedColors = {
                  aliceblue: [240, 248, 255],
                  antiquewhite: [250, 235, 215],
                  aqua: [0, 255, 255],
                  aquamarine: [127, 255, 212],
                  azure: [240, 255, 255],
                  beige: [245, 245, 220],
                  bisque: [255, 228, 196],
                  black: [0, 0, 0],
                  blanchedalmond: [255, 235, 205],
                  blue: [0, 0, 255],
                  blueviolet: [138, 43, 226],
                  brown: [165, 42, 42],
                  burlywood: [222, 184, 135],
                  cadetblue: [95, 158, 160],
                  chartreuse: [127, 255, 0],
                  chocolate: [210, 105, 30],
                  coral: [255, 127, 80],
                  cornflowerblue: [100, 149, 237],
                  cornsilk: [255, 248, 220],
                  crimson: [220, 20, 60],
                  cyan: [0, 255, 255],
                  darkblue: [0, 0, 139],
                  darkcyan: [0, 139, 139],
                  darkgoldenrod: [184, 134, 11],
                  darkgray: [169, 169, 169],
                  darkgreen: [0, 100, 0],
                  darkgrey: [169, 169, 169],
                  darkkhaki: [189, 183, 107],
                  darkmagenta: [139, 0, 139],
                  darkolivegreen: [85, 107, 47],
                  darkorange: [255, 140, 0],
                  darkorchid: [153, 50, 204],
                  darkred: [139, 0, 0],
                  darksalmon: [233, 150, 122],
                  darkseagreen: [143, 188, 143],
                  darkslateblue: [72, 61, 139],
                  darkslategray: [47, 79, 79],
                  darkslategrey: [47, 79, 79],
                  darkturquoise: [0, 206, 209],
                  darkviolet: [148, 0, 211],
                  deeppink: [255, 20, 147],
                  deepskyblue: [0, 191, 255],
                  dimgray: [105, 105, 105],
                  dimgrey: [105, 105, 105],
                  dodgerblue: [30, 144, 255],
                  firebrick: [178, 34, 34],
                  floralwhite: [255, 250, 240],
                  forestgreen: [34, 139, 34],
                  fuchsia: [255, 0, 255],
                  gainsboro: [220, 220, 220],
                  ghostwhite: [248, 248, 255],
                  gold: [255, 215, 0],
                  goldenrod: [218, 165, 32],
                  gray: [128, 128, 128],
                  grey: [128, 128, 128],
                  green: [0, 128, 0],
                  greenyellow: [173, 255, 47],
                  honeydew: [240, 255, 240],
                  hotpink: [255, 105, 180],
                  indianred: [205, 92, 92],
                  indigo: [75, 0, 130],
                  ivory: [255, 255, 240],
                  khaki: [240, 230, 140],
                  lavender: [230, 230, 250],
                  lavenderblush: [255, 240, 245],
                  lawngreen: [124, 252, 0],
                  lemonchiffon: [255, 250, 205],
                  lightblue: [173, 216, 230],
                  lightcoral: [240, 128, 128],
                  lightcyan: [224, 255, 255],
                  lightgoldenrodyellow: [250, 250, 210],
                  lightgray: [211, 211, 211],
                  lightgreen: [144, 238, 144],
                  lightgrey: [211, 211, 211],
                  lightpink: [255, 182, 193],
                  lightsalmon: [255, 160, 122],
                  lightseagreen: [32, 178, 170],
                  lightskyblue: [135, 206, 250],
                  lightslategray: [119, 136, 153],
                  lightslategrey: [119, 136, 153],
                  lightsteelblue: [176, 196, 222],
                  lightyellow: [255, 255, 224],
                  lime: [0, 255, 0],
                  limegreen: [50, 205, 50],
                  linen: [250, 240, 230],
                  magenta: [255, 0, 255],
                  maroon: [128, 0, 0],
                  mediumaquamarine: [102, 205, 170],
                  mediumblue: [0, 0, 205],
                  mediumorchid: [186, 85, 211],
                  mediumpurple: [147, 112, 219],
                  mediumseagreen: [60, 179, 113],
                  mediumslateblue: [123, 104, 238],
                  mediumspringgreen: [0, 250, 154],
                  mediumturquoise: [72, 209, 204],
                  mediumvioletred: [199, 21, 133],
                  midnightblue: [25, 25, 112],
                  mintcream: [245, 255, 250],
                  mistyrose: [255, 228, 225],
                  moccasin: [255, 228, 181],
                  navajowhite: [255, 222, 173],
                  navy: [0, 0, 128],
                  oldlace: [253, 245, 230],
                  olive: [128, 128, 0],
                  olivedrab: [107, 142, 35],
                  orange: [255, 165, 0],
                  orangered: [255, 69, 0],
                  orchid: [218, 112, 214],
                  palegoldenrod: [238, 232, 170],
                  palegreen: [152, 251, 152],
                  paleturquoise: [175, 238, 238],
                  palevioletred: [219, 112, 147],
                  papayawhip: [255, 239, 213],
                  peachpuff: [255, 218, 185],
                  peru: [205, 133, 63],
                  pink: [255, 192, 203],
                  plum: [221, 160, 221],
                  powderblue: [176, 224, 230],
                  purple: [128, 0, 128],
                  red: [255, 0, 0],
                  rosybrown: [188, 143, 143],
                  royalblue: [65, 105, 225],
                  saddlebrown: [139, 69, 19],
                  salmon: [250, 128, 114],
                  sandybrown: [244, 164, 96],
                  seagreen: [46, 139, 87],
                  seashell: [255, 245, 238],
                  sienna: [160, 82, 45],
                  silver: [192, 192, 192],
                  skyblue: [135, 206, 235],
                  slateblue: [106, 90, 205],
                  slategray: [112, 128, 144],
                  slategrey: [112, 128, 144],
                  snow: [255, 250, 250],
                  springgreen: [0, 255, 127],
                  steelblue: [70, 130, 180],
                  tan: [210, 180, 140],
                  teal: [0, 128, 128],
                  thistle: [216, 191, 216],
                  tomato: [255, 99, 71],
                  turquoise: [64, 224, 208],
                  violet: [238, 130, 238],
                  wheat: [245, 222, 179],
                  white: [255, 255, 255],
                  whitesmoke: [245, 245, 245],
                  yellow: [255, 255, 0],
                  yellowgreen: [154, 205, 50],
                };
  
                let cx, cy, px, py, sx, sy;
                cx = cy = px = py = sx = sy = 0;
                const parameters = {
                  A: 7,
                  a: 7,
                  C: 6,
                  c: 6,
                  H: 1,
                  h: 1,
                  L: 2,
                  l: 2,
                  M: 2,
                  m: 2,
                  Q: 4,
                  q: 4,
                  S: 4,
                  s: 4,
                  T: 2,
                  t: 2,
                  V: 1,
                  v: 1,
                  Z: 0,
                  z: 0,
                };
  
                const parse = function (path) {
                  let cmd;
                  const ret = [];
                  let args = [];
                  let curArg = "";
                  let foundDecimal = false;
                  let params = 0;
  
                  for (let c of path) {
                    if (parameters[c] != null) {
                      params = parameters[c];
  
                      if (cmd) {
                        // save existing command
                        if (curArg.length > 0) {
                          args[args.length] = +curArg;
                        }
  
                        ret[ret.length] = {
                          cmd,
                          args,
                        };
                        args = [];
                        curArg = "";
                        foundDecimal = false;
                      }
  
                      cmd = c;
                    } else if (
                      [" ", ","].includes(c) ||
                      (c === "-" &&
                        curArg.length > 0 &&
                        curArg[curArg.length - 1] !== "e") ||
                      (c === "." && foundDecimal)
                    ) {
                      if (curArg.length === 0) {
                        continue;
                      }
  
                      if (args.length === params) {
                        // handle reused commands
                        ret[ret.length] = {
                          cmd,
                          args,
                        };
                        args = [+curArg]; // handle assumed commands
  
                        if (cmd === "M") {
                          cmd = "L";
                        }
  
                        if (cmd === "m") {
                          cmd = "l";
                        }
                      } else {
                        args[args.length] = +curArg;
                      }
  
                      foundDecimal = c === "."; // fix for negative numbers or repeated decimals with no delimeter between commands
  
                      curArg = ["-", "."].includes(c) ? c : "";
                    } else {
                      curArg += c;
  
                      if (c === ".") {
                        foundDecimal = true;
                      }
                    }
                  } // add the last command
  
                  if (curArg.length > 0) {
                    if (args.length === params) {
                      // handle reused commands
                      ret[ret.length] = {
                        cmd,
                        args,
                      };
                      args = [+curArg]; // handle assumed commands
  
                      if (cmd === "M") {
                        cmd = "L";
                      }
  
                      if (cmd === "m") {
                        cmd = "l";
                      }
                    } else {
                      args[args.length] = +curArg;
                    }
                  }
  
                  ret[ret.length] = {
                    cmd,
                    args,
                  };
                  return ret;
                };
  
                const apply = function (commands, doc) {
                  // current point, control point, and subpath starting point
                  cx = cy = px = py = sx = sy = 0; // run the commands
  
                  for (let i = 0; i < commands.length; i++) {
                    const c = commands[i];
  
                    if (typeof runners[c.cmd] === "function") {
                      runners[c.cmd](doc, c.args);
                    }
                  }
                };
  
                const runners = {
                  M(doc, a) {
                    cx = a[0];
                    cy = a[1];
                    px = py = null;
                    sx = cx;
                    sy = cy;
                    return doc.moveTo(cx, cy);
                  },
  
                  m(doc, a) {
                    cx += a[0];
                    cy += a[1];
                    px = py = null;
                    sx = cx;
                    sy = cy;
                    return doc.moveTo(cx, cy);
                  },
  
                  C(doc, a) {
                    cx = a[4];
                    cy = a[5];
                    px = a[2];
                    py = a[3];
                    return doc.bezierCurveTo(...a);
                  },
  
                  c(doc, a) {
                    doc.bezierCurveTo(
                      a[0] + cx,
                      a[1] + cy,
                      a[2] + cx,
                      a[3] + cy,
                      a[4] + cx,
                      a[5] + cy
                    );
                    px = cx + a[2];
                    py = cy + a[3];
                    cx += a[4];
                    return (cy += a[5]);
                  },
  
                  S(doc, a) {
                    if (px === null) {
                      px = cx;
                      py = cy;
                    }
  
                    doc.bezierCurveTo(
                      cx - (px - cx),
                      cy - (py - cy),
                      a[0],
                      a[1],
                      a[2],
                      a[3]
                    );
                    px = a[0];
                    py = a[1];
                    cx = a[2];
                    return (cy = a[3]);
                  },
  
                  s(doc, a) {
                    if (px === null) {
                      px = cx;
                      py = cy;
                    }
  
                    doc.bezierCurveTo(
                      cx - (px - cx),
                      cy - (py - cy),
                      cx + a[0],
                      cy + a[1],
                      cx + a[2],
                      cy + a[3]
                    );
                    px = cx + a[0];
                    py = cy + a[1];
                    cx += a[2];
                    return (cy += a[3]);
                  },
  
                  Q(doc, a) {
                    px = a[0];
                    py = a[1];
                    cx = a[2];
                    cy = a[3];
                    return doc.quadraticCurveTo(a[0], a[1], cx, cy);
                  },
  
                  q(doc, a) {
                    doc.quadraticCurveTo(
                      a[0] + cx,
                      a[1] + cy,
                      a[2] + cx,
                      a[3] + cy
                    );
                    px = cx + a[0];
                    py = cy + a[1];
                    cx += a[2];
                    return (cy += a[3]);
                  },
  
                  T(doc, a) {
                    if (px === null) {
                      px = cx;
                      py = cy;
                    } else {
                      px = cx - (px - cx);
                      py = cy - (py - cy);
                    }
  
                    doc.quadraticCurveTo(px, py, a[0], a[1]);
                    px = cx - (px - cx);
                    py = cy - (py - cy);
                    cx = a[0];
                    return (cy = a[1]);
                  },
  
                  t(doc, a) {
                    if (px === null) {
                      px = cx;
                      py = cy;
                    } else {
                      px = cx - (px - cx);
                      py = cy - (py - cy);
                    }
  
                    doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
                    cx += a[0];
                    return (cy += a[1]);
                  },
  
                  A(doc, a) {
                    solveArc(doc, cx, cy, a);
                    cx = a[5];
                    return (cy = a[6]);
                  },
  
                  a(doc, a) {
                    a[5] += cx;
                    a[6] += cy;
                    solveArc(doc, cx, cy, a);
                    cx = a[5];
                    return (cy = a[6]);
                  },
  
                  L(doc, a) {
                    cx = a[0];
                    cy = a[1];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  l(doc, a) {
                    cx += a[0];
                    cy += a[1];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  H(doc, a) {
                    cx = a[0];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  h(doc, a) {
                    cx += a[0];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  V(doc, a) {
                    cy = a[0];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  v(doc, a) {
                    cy += a[0];
                    px = py = null;
                    return doc.lineTo(cx, cy);
                  },
  
                  Z(doc) {
                    doc.closePath();
                    cx = sx;
                    return (cy = sy);
                  },
  
                  z(doc) {
                    doc.closePath();
                    cx = sx;
                    return (cy = sy);
                  },
                };
  
                const solveArc = function (doc, x, y, coords) {
                  const [rx, ry, rot, large, sweep, ex, ey] = coords;
                  const segs = arcToSegments(
                    ex,
                    ey,
                    rx,
                    ry,
                    large,
                    sweep,
                    rot,
                    x,
                    y
                  );
  
                  for (let seg of segs) {
                    const bez = segmentToBezier(...seg);
                    doc.bezierCurveTo(...bez);
                  }
                }; // from Inkscape svgtopdf, thanks!
  
                const arcToSegments = function (
                  x,
                  y,
                  rx,
                  ry,
                  large,
                  sweep,
                  rotateX,
                  ox,
                  oy
                ) {
                  const th = rotateX * (Math.PI / 180);
                  const sin_th = Math.sin(th);
                  const cos_th = Math.cos(th);
                  rx = Math.abs(rx);
                  ry = Math.abs(ry);
                  px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
                  py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
                  let pl = (px * px) / (rx * rx) + (py * py) / (ry * ry);
  
                  if (pl > 1) {
                    pl = Math.sqrt(pl);
                    rx *= pl;
                    ry *= pl;
                  }
  
                  const a00 = cos_th / rx;
                  const a01 = sin_th / rx;
                  const a10 = -sin_th / ry;
                  const a11 = cos_th / ry;
                  const x0 = a00 * ox + a01 * oy;
                  const y0 = a10 * ox + a11 * oy;
                  const x1 = a00 * x + a01 * y;
                  const y1 = a10 * x + a11 * y;
                  const d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
                  let sfactor_sq = 1 / d - 0.25;
  
                  if (sfactor_sq < 0) {
                    sfactor_sq = 0;
                  }
  
                  let sfactor = Math.sqrt(sfactor_sq);
  
                  if (sweep === large) {
                    sfactor = -sfactor;
                  }
  
                  const xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
                  const yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
                  const th0 = Math.atan2(y0 - yc, x0 - xc);
                  const th1 = Math.atan2(y1 - yc, x1 - xc);
                  let th_arc = th1 - th0;
  
                  if (th_arc < 0 && sweep === 1) {
                    th_arc += 2 * Math.PI;
                  } else if (th_arc > 0 && sweep === 0) {
                    th_arc -= 2 * Math.PI;
                  }
  
                  const segments = Math.ceil(
                    Math.abs(th_arc / (Math.PI * 0.5 + 0.001))
                  );
                  const result = [];
  
                  for (let i = 0; i < segments; i++) {
                    const th2 = th0 + (i * th_arc) / segments;
                    const th3 = th0 + ((i + 1) * th_arc) / segments;
                    result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
                  }
  
                  return result;
                };
  
                const segmentToBezier = function (
                  cx,
                  cy,
                  th0,
                  th1,
                  rx,
                  ry,
                  sin_th,
                  cos_th
                ) {
                  const a00 = cos_th * rx;
                  const a01 = -sin_th * ry;
                  const a10 = sin_th * rx;
                  const a11 = cos_th * ry;
                  const th_half = 0.5 * (th1 - th0);
                  const t =
                    ((8 / 3) *
                      Math.sin(th_half * 0.5) *
                      Math.sin(th_half * 0.5)) /
                    Math.sin(th_half);
                  const x1 = cx + Math.cos(th0) - t * Math.sin(th0);
                  const y1 = cy + Math.sin(th0) + t * Math.cos(th0);
                  const x3 = cx + Math.cos(th1);
                  const y3 = cy + Math.sin(th1);
                  const x2 = x3 + t * Math.sin(th1);
                  const y2 = y3 - t * Math.cos(th1);
                  return [
                    a00 * x1 + a01 * y1,
                    a10 * x1 + a11 * y1,
                    a00 * x2 + a01 * y2,
                    a10 * x2 + a11 * y2,
                    a00 * x3 + a01 * y3,
                    a10 * x3 + a11 * y3,
                  ];
                };
  
                class SVGPath {
                  static apply(doc, path) {
                    const commands = parse(path);
                    apply(commands, doc);
                  }
                }
  
                const { number: number$1 } = PDFObject; // This constant is used to approximate a symmetrical arc using a cubic
                // Bezier curve.
  
                const KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
                var VectorMixin = {
                  initVector() {
                    this._ctm = [1, 0, 0, 1, 0, 0]; // current transformation matrix
  
                    return (this._ctmStack = []);
                  },
  
                  save() {
                    this._ctmStack.push(this._ctm.slice()); // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
  
                    return this.addContent("q");
                  },
  
                  restore() {
                    this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
                    return this.addContent("Q");
                  },
  
                  closePath() {
                    return this.addContent("h");
                  },
  
                  lineWidth(w) {
                    return this.addContent(`${number$1(w)} w`);
                  },
  
                  _CAP_STYLES: {
                    BUTT: 0,
                    ROUND: 1,
                    SQUARE: 2,
                  },
  
                  lineCap(c) {
                    if (typeof c === "string") {
                      c = this._CAP_STYLES[c.toUpperCase()];
                    }
  
                    return this.addContent(`${c} J`);
                  },
  
                  _JOIN_STYLES: {
                    MITER: 0,
                    ROUND: 1,
                    BEVEL: 2,
                  },
  
                  lineJoin(j) {
                    if (typeof j === "string") {
                      j = this._JOIN_STYLES[j.toUpperCase()];
                    }
  
                    return this.addContent(`${j} j`);
                  },
  
                  miterLimit(m) {
                    return this.addContent(`${number$1(m)} M`);
                  },
  
                  dash(length, options = {}) {
                    const originalLength = length;
  
                    if (!Array.isArray(length)) {
                      length = [length, options.space || length];
                    }
  
                    const valid = length.every(
                      (x) => Number.isFinite(x) && x > 0
                    );
  
                    if (!valid) {
                      throw new Error(
                        `dash(${JSON.stringify(originalLength)}, ${JSON.stringify(
                          options
                        )}) invalid, lengths must be numeric and greater than zero`
                      );
                    }
  
                    length = length.map(number$1).join(" ");
                    return this.addContent(
                      `[${length}] ${number$1(options.phase || 0)} d`
                    );
                  },
  
                  undash() {
                    return this.addContent("[] 0 d");
                  },
  
                  moveTo(x, y) {
                    return this.addContent(`${number$1(x)} ${number$1(y)} m`);
                  },
  
                  lineTo(x, y) {
                    return this.addContent(`${number$1(x)} ${number$1(y)} l`);
                  },
  
                  bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
                    return this.addContent(
                      `${number$1(cp1x)} ${number$1(cp1y)} ${number$1(
                        cp2x
                      )} ${number$1(cp2y)} ${number$1(x)} ${number$1(y)} c`
                    );
                  },
  
                  quadraticCurveTo(cpx, cpy, x, y) {
                    return this.addContent(
                      `${number$1(cpx)} ${number$1(cpy)} ${number$1(
                        x
                      )} ${number$1(y)} v`
                    );
                  },
  
                  rect(x, y, w, h) {
                    return this.addContent(
                      `${number$1(x)} ${number$1(y)} ${number$1(w)} ${number$1(
                        h
                      )} re`
                    );
                  },
  
                  roundedRect(x, y, w, h, r) {
                    if (r == null) {
                      r = 0;
                    }
  
                    r = Math.min(r, 0.5 * w, 0.5 * h); // amount to inset control points from corners (see `ellipse`)
  
                    const c = r * (1.0 - KAPPA);
                    this.moveTo(x + r, y);
                    this.lineTo(x + w - r, y);
                    this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
                    this.lineTo(x + w, y + h - r);
                    this.bezierCurveTo(
                      x + w,
                      y + h - c,
                      x + w - c,
                      y + h,
                      x + w - r,
                      y + h
                    );
                    this.lineTo(x + r, y + h);
                    this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
                    this.lineTo(x, y + r);
                    this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
                    return this.closePath();
                  },
  
                  ellipse(x, y, r1, r2) {
                    // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
                    if (r2 == null) {
                      r2 = r1;
                    }
  
                    x -= r1;
                    y -= r2;
                    const ox = r1 * KAPPA;
                    const oy = r2 * KAPPA;
                    const xe = x + r1 * 2;
                    const ye = y + r2 * 2;
                    const xm = x + r1;
                    const ym = y + r2;
                    this.moveTo(x, ym);
                    this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                    this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                    this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                    this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                    return this.closePath();
                  },
  
                  circle(x, y, radius) {
                    return this.ellipse(x, y, radius);
                  },
  
                  arc(x, y, radius, startAngle, endAngle, anticlockwise) {
                    if (anticlockwise == null) {
                      anticlockwise = false;
                    }
  
                    const TWO_PI = 2.0 * Math.PI;
                    const HALF_PI = 0.5 * Math.PI;
                    let deltaAng = endAngle - startAngle;
  
                    if (Math.abs(deltaAng) > TWO_PI) {
                      // draw only full circle if more than that is specified
                      deltaAng = TWO_PI;
                    } else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
                      // necessary to flip direction of rendering
                      const dir = anticlockwise ? -1 : 1;
                      deltaAng = dir * TWO_PI + deltaAng;
                    }
  
                    const numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
                    const segAng = deltaAng / numSegs;
                    const handleLen = (segAng / HALF_PI) * KAPPA * radius;
                    let curAng = startAngle; // component distances between anchor point and control point
  
                    let deltaCx = -Math.sin(curAng) * handleLen;
                    let deltaCy = Math.cos(curAng) * handleLen; // anchor point
  
                    let ax = x + Math.cos(curAng) * radius;
                    let ay = y + Math.sin(curAng) * radius; // calculate and render segments
  
                    this.moveTo(ax, ay);
  
                    for (let segIdx = 0; segIdx < numSegs; segIdx++) {
                      // starting control point
                      const cp1x = ax + deltaCx;
                      const cp1y = ay + deltaCy; // step angle
  
                      curAng += segAng; // next anchor point
  
                      ax = x + Math.cos(curAng) * radius;
                      ay = y + Math.sin(curAng) * radius; // next control point delta
  
                      deltaCx = -Math.sin(curAng) * handleLen;
                      deltaCy = Math.cos(curAng) * handleLen; // ending control point
  
                      const cp2x = ax - deltaCx;
                      const cp2y = ay - deltaCy; // render segment
  
                      this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
                    }
  
                    return this;
                  },
  
                  polygon(...points) {
                    this.moveTo(...(points.shift() || []));
  
                    for (let point of points) {
                      this.lineTo(...(point || []));
                    }
  
                    return this.closePath();
                  },
  
                  path(path) {
                    SVGPath.apply(this, path);
                    return this;
                  },
  
                  _windingRule(rule) {
                    if (/even-?odd/.test(rule)) {
                      return "*";
                    }
  
                    return "";
                  },
  
                  fill(color, rule) {
                    if (/(even-?odd)|(non-?zero)/.test(color)) {
                      rule = color;
                      color = null;
                    }
  
                    if (color) {
                      this.fillColor(color);
                    }
  
                    return this.addContent(`f${this._windingRule(rule)}`);
                  },
  
                  stroke(color) {
                    if (color) {
                      this.strokeColor(color);
                    }
  
                    return this.addContent("S");
                  },
  
                  fillAndStroke(fillColor, strokeColor, rule) {
                    if (strokeColor == null) {
                      strokeColor = fillColor;
                    }
  
                    const isFillRule = /(even-?odd)|(non-?zero)/;
  
                    if (isFillRule.test(fillColor)) {
                      rule = fillColor;
                      fillColor = null;
                    }
  
                    if (isFillRule.test(strokeColor)) {
                      rule = strokeColor;
                      strokeColor = fillColor;
                    }
  
                    if (fillColor) {
                      this.fillColor(fillColor);
                      this.strokeColor(strokeColor);
                    }
  
                    return this.addContent(`B${this._windingRule(rule)}`);
                  },
  
                  clip(rule) {
                    return this.addContent(`W${this._windingRule(rule)}`);
                  },
  
                  endPath() {
                    return this.addContent("n");
                  },
  
                  transform(m11, m12, m21, m22, dx, dy) {
                    // keep track of the current transformation matrix
                    const m = this._ctm;
                    const [m0, m1, m2, m3, m4, m5] = m;
                    m[0] = m0 * m11 + m2 * m12;
                    m[1] = m1 * m11 + m3 * m12;
                    m[2] = m0 * m21 + m2 * m22;
                    m[3] = m1 * m21 + m3 * m22;
                    m[4] = m0 * dx + m2 * dy + m4;
                    m[5] = m1 * dx + m3 * dy + m5;
                    const values = [m11, m12, m21, m22, dx, dy]
                      .map((v) => number$1(v))
                      .join(" ");
                    return this.addContent(`${values} cm`);
                  },
  
                  translate(x, y) {
                    return this.transform(1, 0, 0, 1, x, y);
                  },
  
                  rotate(angle, options = {}) {
                    let y;
                    const rad = (angle * Math.PI) / 180;
                    const cos = Math.cos(rad);
                    const sin = Math.sin(rad);
                    let x = (y = 0);
  
                    if (options.origin != null) {
                      [x, y] = options.origin;
                      const x1 = x * cos - y * sin;
                      const y1 = x * sin + y * cos;
                      x -= x1;
                      y -= y1;
                    }
  
                    return this.transform(cos, sin, -sin, cos, x, y);
                  },
  
                  scale(xFactor, yFactor, options = {}) {
                    let y;
  
                    if (yFactor == null) {
                      yFactor = xFactor;
                    }
  
                    if (typeof yFactor === "object") {
                      options = yFactor;
                      yFactor = xFactor;
                    }
  
                    let x = (y = 0);
  
                    if (options.origin != null) {
                      [x, y] = options.origin;
                      x -= xFactor * x;
                      y -= yFactor * y;
                    }
  
                    return this.transform(xFactor, 0, 0, yFactor, x, y);
                  },
                };
  
                const WIN_ANSI_MAP = {
                  402: 131,
                  8211: 150,
                  8212: 151,
                  8216: 145,
                  8217: 146,
                  8218: 130,
                  8220: 147,
                  8221: 148,
                  8222: 132,
                  8224: 134,
                  8225: 135,
                  8226: 149,
                  8230: 133,
                  8364: 128,
                  8240: 137,
                  8249: 139,
                  8250: 155,
                  710: 136,
                  8482: 153,
                  338: 140,
                  339: 156,
                  732: 152,
                  352: 138,
                  353: 154,
                  376: 159,
                  381: 142,
                  382: 158,
                };
                const characters = `\
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
  .notdef       .notdef        .notdef        .notdef
    
  space         exclam         quotedbl       numbersign
  dollar        percent        ampersand      quotesingle
  parenleft     parenright     asterisk       plus
  comma         hyphen         period         slash
  zero          one            two            three
  four          five           six            seven
  eight         nine           colon          semicolon
  less          equal          greater        question
    
  at            A              B              C
  D             E              F              G
  H             I              J              K
  L             M              N              O
  P             Q              R              S
  T             U              V              W
  X             Y              Z              bracketleft
  backslash     bracketright   asciicircum    underscore
    
  grave         a              b              c
  d             e              f              g
  h             i              j              k
  l             m              n              o
  p             q              r              s
  t             u              v              w
  x             y              z              braceleft
  bar           braceright     asciitilde     .notdef
    
  Euro          .notdef        quotesinglbase florin
  quotedblbase  ellipsis       dagger         daggerdbl
  circumflex    perthousand    Scaron         guilsinglleft
  OE            .notdef        Zcaron         .notdef
  .notdef       quoteleft      quoteright     quotedblleft
  quotedblright bullet         endash         emdash
  tilde         trademark      scaron         guilsinglright
  oe            .notdef        zcaron         ydieresis
    
  space         exclamdown     cent           sterling
  currency      yen            brokenbar      section
  dieresis      copyright      ordfeminine    guillemotleft
  logicalnot    hyphen         registered     macron
  degree        plusminus      twosuperior    threesuperior
  acute         mu             paragraph      periodcentered
  cedilla       onesuperior    ordmasculine   guillemotright
  onequarter    onehalf        threequarters  questiondown
    
  Agrave        Aacute         Acircumflex    Atilde
  Adieresis     Aring          AE             Ccedilla
  Egrave        Eacute         Ecircumflex    Edieresis
  Igrave        Iacute         Icircumflex    Idieresis
  Eth           Ntilde         Ograve         Oacute
  Ocircumflex   Otilde         Odieresis      multiply
  Oslash        Ugrave         Uacute         Ucircumflex
  Udieresis     Yacute         Thorn          germandbls
    
  agrave        aacute         acircumflex    atilde
  adieresis     aring          ae             ccedilla
  egrave        eacute         ecircumflex    edieresis
  igrave        iacute         icircumflex    idieresis
  eth           ntilde         ograve         oacute
  ocircumflex   otilde         odieresis      divide
  oslash        ugrave         uacute         ucircumflex
  udieresis     yacute         thorn          ydieresis\
  `.split(/\s+/);
  
                class AFMFont {
                  static open(filename) {
                    return new AFMFont(fs.readFileSync(filename, "utf8"));
                  }
  
                  constructor(contents) {
                    this.contents = contents;
                    this.attributes = {};
                    this.glyphWidths = {};
                    this.boundingBoxes = {};
                    this.kernPairs = {};
                    this.parse(); // todo: remove charWidths since appears to not be used
  
                    this.charWidths = new Array(256);
  
                    for (let char = 0; char <= 255; char++) {
                      this.charWidths[char] = this.glyphWidths[characters[char]];
                    }
  
                    this.bbox = this.attributes["FontBBox"]
                      .split(/\s+/)
                      .map((e) => +e);
                    this.ascender = +(this.attributes["Ascender"] || 0);
                    this.descender = +(this.attributes["Descender"] || 0);
                    this.xHeight = +(this.attributes["XHeight"] || 0);
                    this.capHeight = +(this.attributes["CapHeight"] || 0);
                    this.lineGap =
                      this.bbox[3] -
                      this.bbox[1] -
                      (this.ascender - this.descender);
                  }
  
                  parse() {
                    let section = "";
  
                    for (let line of this.contents.split("\n")) {
                      var match;
                      var a;
  
                      if ((match = line.match(/^Start(\w+)/))) {
                        section = match[1];
                        continue;
                      } else if ((match = line.match(/^End(\w+)/))) {
                        section = "";
                        continue;
                      }
  
                      switch (section) {
                        case "FontMetrics":
                          match = line.match(/(^\w+)\s+(.*)/);
                          var key = match[1];
                          var value = match[2];
  
                          if ((a = this.attributes[key])) {
                            if (!Array.isArray(a)) {
                              a = this.attributes[key] = [a];
                            }
  
                            a.push(value);
                          } else {
                            this.attributes[key] = value;
                          }
  
                          break;
  
                        case "CharMetrics":
                          if (!/^CH?\s/.test(line)) {
                            continue;
                          }
  
                          var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                          this.glyphWidths[name] =
                            +line.match(/\bWX\s+(\d+)\s*;/)[1];
                          break;
  
                        case "KernPairs":
                          match = line.match(
                            /^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/
                          );
  
                          if (match) {
                            this.kernPairs[match[1] + "\0" + match[2]] = parseInt(
                              match[3]
                            );
                          }
  
                          break;
                      }
                    }
                  }
  
                  encodeText(text) {
                    const res = [];
  
                    for (let i = 0, len = text.length; i < len; i++) {
                      let char = text.charCodeAt(i);
                      char = WIN_ANSI_MAP[char] || char;
                      res.push(char.toString(16));
                    }
  
                    return res;
                  }
  
                  glyphsForString(string) {
                    const glyphs = [];
  
                    for (let i = 0, len = string.length; i < len; i++) {
                      const charCode = string.charCodeAt(i);
                      glyphs.push(this.characterToGlyph(charCode));
                    }
  
                    return glyphs;
                  }
  
                  characterToGlyph(character) {
                    return (
                      characters[WIN_ANSI_MAP[character] || character] ||
                      ".notdef"
                    );
                  }
  
                  widthOfGlyph(glyph) {
                    return this.glyphWidths[glyph] || 0;
                  }
  
                  getKernPair(left, right) {
                    return this.kernPairs[left + "\0" + right] || 0;
                  }
  
                  advancesForGlyphs(glyphs) {
                    const advances = [];
  
                    for (let index = 0; index < glyphs.length; index++) {
                      const left = glyphs[index];
                      const right = glyphs[index + 1];
                      advances.push(
                        this.widthOfGlyph(left) + this.getKernPair(left, right)
                      );
                    }
  
                    return advances;
                  }
                }
  
                class PDFFont {
                  constructor() {}
  
                  encode() {
                    throw new Error("Must be implemented by subclasses");
                  }
  
                  widthOfString() {
                    throw new Error("Must be implemented by subclasses");
                  }
  
                  ref() {
                    return this.dictionary != null
                      ? this.dictionary
                      : (this.dictionary = this.document.ref());
                  }
  
                  finalize() {
                    if (this.embedded || this.dictionary == null) {
                      return;
                    }
  
                    this.embed();
                    return (this.embedded = true);
                  }
  
                  embed() {
                    throw new Error("Must be implemented by subclasses");
                  }
  
                  lineHeight(size, includeGap) {
                    if (includeGap == null) {
                      includeGap = false;
                    }
  
                    const gap = includeGap ? this.lineGap : 0;
                    return ((this.ascender + gap - this.descender) / 1000) * size;
                  }
                }
  
                const STANDARD_FONTS = {
                  Courier() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 17:27:09 1997\r\nComment UniqueID 43050\r\nComment VMusage 39754 50779\r\nFontName Courier\r\nFullName Courier\r\nFamilyName Courier\r\nWeight Medium\r\nItalicAngle 0\r\nIsFixedPitch true\r\nCharacterSet ExtendedRoman\r\nFontBBox -23 -250 715 805 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 003.000\r\nNotice Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 562\r\nXHeight 426\r\nAscender 629\r\nDescender -157\r\nStdHW 51\r\nStdVW 51\r\nStartCharMetrics 315\r\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 600 ; N exclam ; B 236 -15 364 572 ;\r\nC 34 ; WX 600 ; N quotedbl ; B 187 328 413 562 ;\r\nC 35 ; WX 600 ; N numbersign ; B 93 -32 507 639 ;\r\nC 36 ; WX 600 ; N dollar ; B 105 -126 496 662 ;\r\nC 37 ; WX 600 ; N percent ; B 81 -15 518 622 ;\r\nC 38 ; WX 600 ; N ampersand ; B 63 -15 538 543 ;\r\nC 39 ; WX 600 ; N quoteright ; B 213 328 376 562 ;\r\nC 40 ; WX 600 ; N parenleft ; B 269 -108 440 622 ;\r\nC 41 ; WX 600 ; N parenright ; B 160 -108 331 622 ;\r\nC 42 ; WX 600 ; N asterisk ; B 116 257 484 607 ;\r\nC 43 ; WX 600 ; N plus ; B 80 44 520 470 ;\r\nC 44 ; WX 600 ; N comma ; B 181 -112 344 122 ;\r\nC 45 ; WX 600 ; N hyphen ; B 103 231 497 285 ;\r\nC 46 ; WX 600 ; N period ; B 229 -15 371 109 ;\r\nC 47 ; WX 600 ; N slash ; B 125 -80 475 629 ;\r\nC 48 ; WX 600 ; N zero ; B 106 -15 494 622 ;\r\nC 49 ; WX 600 ; N one ; B 96 0 505 622 ;\r\nC 50 ; WX 600 ; N two ; B 70 0 471 622 ;\r\nC 51 ; WX 600 ; N three ; B 75 -15 466 622 ;\r\nC 52 ; WX 600 ; N four ; B 78 0 500 622 ;\r\nC 53 ; WX 600 ; N five ; B 92 -15 497 607 ;\r\nC 54 ; WX 600 ; N six ; B 111 -15 497 622 ;\r\nC 55 ; WX 600 ; N seven ; B 82 0 483 607 ;\r\nC 56 ; WX 600 ; N eight ; B 102 -15 498 622 ;\r\nC 57 ; WX 600 ; N nine ; B 96 -15 489 622 ;\r\nC 58 ; WX 600 ; N colon ; B 229 -15 371 385 ;\r\nC 59 ; WX 600 ; N semicolon ; B 181 -112 371 385 ;\r\nC 60 ; WX 600 ; N less ; B 41 42 519 472 ;\r\nC 61 ; WX 600 ; N equal ; B 80 138 520 376 ;\r\nC 62 ; WX 600 ; N greater ; B 66 42 544 472 ;\r\nC 63 ; WX 600 ; N question ; B 129 -15 492 572 ;\r\nC 64 ; WX 600 ; N at ; B 77 -15 533 622 ;\r\nC 65 ; WX 600 ; N A ; B 3 0 597 562 ;\r\nC 66 ; WX 600 ; N B ; B 43 0 559 562 ;\r\nC 67 ; WX 600 ; N C ; B 41 -18 540 580 ;\r\nC 68 ; WX 600 ; N D ; B 43 0 574 562 ;\r\nC 69 ; WX 600 ; N E ; B 53 0 550 562 ;\r\nC 70 ; WX 600 ; N F ; B 53 0 545 562 ;\r\nC 71 ; WX 600 ; N G ; B 31 -18 575 580 ;\r\nC 72 ; WX 600 ; N H ; B 32 0 568 562 ;\r\nC 73 ; WX 600 ; N I ; B 96 0 504 562 ;\r\nC 74 ; WX 600 ; N J ; B 34 -18 566 562 ;\r\nC 75 ; WX 600 ; N K ; B 38 0 582 562 ;\r\nC 76 ; WX 600 ; N L ; B 47 0 554 562 ;\r\nC 77 ; WX 600 ; N M ; B 4 0 596 562 ;\r\nC 78 ; WX 600 ; N N ; B 7 -13 593 562 ;\r\nC 79 ; WX 600 ; N O ; B 43 -18 557 580 ;\r\nC 80 ; WX 600 ; N P ; B 79 0 558 562 ;\r\nC 81 ; WX 600 ; N Q ; B 43 -138 557 580 ;\r\nC 82 ; WX 600 ; N R ; B 38 0 588 562 ;\r\nC 83 ; WX 600 ; N S ; B 72 -20 529 580 ;\r\nC 84 ; WX 600 ; N T ; B 38 0 563 562 ;\r\nC 85 ; WX 600 ; N U ; B 17 -18 583 562 ;\r\nC 86 ; WX 600 ; N V ; B -4 -13 604 562 ;\r\nC 87 ; WX 600 ; N W ; B -3 -13 603 562 ;\r\nC 88 ; WX 600 ; N X ; B 23 0 577 562 ;\r\nC 89 ; WX 600 ; N Y ; B 24 0 576 562 ;\r\nC 90 ; WX 600 ; N Z ; B 86 0 514 562 ;\r\nC 91 ; WX 600 ; N bracketleft ; B 269 -108 442 622 ;\r\nC 92 ; WX 600 ; N backslash ; B 118 -80 482 629 ;\r\nC 93 ; WX 600 ; N bracketright ; B 158 -108 331 622 ;\r\nC 94 ; WX 600 ; N asciicircum ; B 94 354 506 622 ;\r\nC 95 ; WX 600 ; N underscore ; B 0 -125 600 -75 ;\r\nC 96 ; WX 600 ; N quoteleft ; B 224 328 387 562 ;\r\nC 97 ; WX 600 ; N a ; B 53 -15 559 441 ;\r\nC 98 ; WX 600 ; N b ; B 14 -15 575 629 ;\r\nC 99 ; WX 600 ; N c ; B 66 -15 529 441 ;\r\nC 100 ; WX 600 ; N d ; B 45 -15 591 629 ;\r\nC 101 ; WX 600 ; N e ; B 66 -15 548 441 ;\r\nC 102 ; WX 600 ; N f ; B 114 0 531 629 ; L i fi ; L l fl ;\r\nC 103 ; WX 600 ; N g ; B 45 -157 566 441 ;\r\nC 104 ; WX 600 ; N h ; B 18 0 582 629 ;\r\nC 105 ; WX 600 ; N i ; B 95 0 505 657 ;\r\nC 106 ; WX 600 ; N j ; B 82 -157 410 657 ;\r\nC 107 ; WX 600 ; N k ; B 43 0 580 629 ;\r\nC 108 ; WX 600 ; N l ; B 95 0 505 629 ;\r\nC 109 ; WX 600 ; N m ; B -5 0 605 441 ;\r\nC 110 ; WX 600 ; N n ; B 26 0 575 441 ;\r\nC 111 ; WX 600 ; N o ; B 62 -15 538 441 ;\r\nC 112 ; WX 600 ; N p ; B 9 -157 555 441 ;\r\nC 113 ; WX 600 ; N q ; B 45 -157 591 441 ;\r\nC 114 ; WX 600 ; N r ; B 60 0 559 441 ;\r\nC 115 ; WX 600 ; N s ; B 80 -15 513 441 ;\r\nC 116 ; WX 600 ; N t ; B 87 -15 530 561 ;\r\nC 117 ; WX 600 ; N u ; B 21 -15 562 426 ;\r\nC 118 ; WX 600 ; N v ; B 10 -10 590 426 ;\r\nC 119 ; WX 600 ; N w ; B -4 -10 604 426 ;\r\nC 120 ; WX 600 ; N x ; B 20 0 580 426 ;\r\nC 121 ; WX 600 ; N y ; B 7 -157 592 426 ;\r\nC 122 ; WX 600 ; N z ; B 99 0 502 426 ;\r\nC 123 ; WX 600 ; N braceleft ; B 182 -108 437 622 ;\r\nC 124 ; WX 600 ; N bar ; B 275 -250 326 750 ;\r\nC 125 ; WX 600 ; N braceright ; B 163 -108 418 622 ;\r\nC 126 ; WX 600 ; N asciitilde ; B 63 197 540 320 ;\r\nC 161 ; WX 600 ; N exclamdown ; B 236 -157 364 430 ;\r\nC 162 ; WX 600 ; N cent ; B 96 -49 500 614 ;\r\nC 163 ; WX 600 ; N sterling ; B 84 -21 521 611 ;\r\nC 164 ; WX 600 ; N fraction ; B 92 -57 509 665 ;\r\nC 165 ; WX 600 ; N yen ; B 26 0 574 562 ;\r\nC 166 ; WX 600 ; N florin ; B 4 -143 539 622 ;\r\nC 167 ; WX 600 ; N section ; B 113 -78 488 580 ;\r\nC 168 ; WX 600 ; N currency ; B 73 58 527 506 ;\r\nC 169 ; WX 600 ; N quotesingle ; B 259 328 341 562 ;\r\nC 170 ; WX 600 ; N quotedblleft ; B 143 328 471 562 ;\r\nC 171 ; WX 600 ; N guillemotleft ; B 37 70 563 446 ;\r\nC 172 ; WX 600 ; N guilsinglleft ; B 149 70 451 446 ;\r\nC 173 ; WX 600 ; N guilsinglright ; B 149 70 451 446 ;\r\nC 174 ; WX 600 ; N fi ; B 3 0 597 629 ;\r\nC 175 ; WX 600 ; N fl ; B 3 0 597 629 ;\r\nC 177 ; WX 600 ; N endash ; B 75 231 525 285 ;\r\nC 178 ; WX 600 ; N dagger ; B 141 -78 459 580 ;\r\nC 179 ; WX 600 ; N daggerdbl ; B 141 -78 459 580 ;\r\nC 180 ; WX 600 ; N periodcentered ; B 222 189 378 327 ;\r\nC 182 ; WX 600 ; N paragraph ; B 50 -78 511 562 ;\r\nC 183 ; WX 600 ; N bullet ; B 172 130 428 383 ;\r\nC 184 ; WX 600 ; N quotesinglbase ; B 213 -134 376 100 ;\r\nC 185 ; WX 600 ; N quotedblbase ; B 143 -134 457 100 ;\r\nC 186 ; WX 600 ; N quotedblright ; B 143 328 457 562 ;\r\nC 187 ; WX 600 ; N guillemotright ; B 37 70 563 446 ;\r\nC 188 ; WX 600 ; N ellipsis ; B 37 -15 563 111 ;\r\nC 189 ; WX 600 ; N perthousand ; B 3 -15 600 622 ;\r\nC 191 ; WX 600 ; N questiondown ; B 108 -157 471 430 ;\r\nC 193 ; WX 600 ; N grave ; B 151 497 378 672 ;\r\nC 194 ; WX 600 ; N acute ; B 242 497 469 672 ;\r\nC 195 ; WX 600 ; N circumflex ; B 124 477 476 654 ;\r\nC 196 ; WX 600 ; N tilde ; B 105 489 503 606 ;\r\nC 197 ; WX 600 ; N macron ; B 120 525 480 565 ;\r\nC 198 ; WX 600 ; N breve ; B 153 501 447 609 ;\r\nC 199 ; WX 600 ; N dotaccent ; B 249 537 352 640 ;\r\nC 200 ; WX 600 ; N dieresis ; B 148 537 453 640 ;\r\nC 202 ; WX 600 ; N ring ; B 218 463 382 627 ;\r\nC 203 ; WX 600 ; N cedilla ; B 224 -151 362 10 ;\r\nC 205 ; WX 600 ; N hungarumlaut ; B 133 497 540 672 ;\r\nC 206 ; WX 600 ; N ogonek ; B 211 -172 407 4 ;\r\nC 207 ; WX 600 ; N caron ; B 124 492 476 669 ;\r\nC 208 ; WX 600 ; N emdash ; B 0 231 600 285 ;\r\nC 225 ; WX 600 ; N AE ; B 3 0 550 562 ;\r\nC 227 ; WX 600 ; N ordfeminine ; B 156 249 442 580 ;\r\nC 232 ; WX 600 ; N Lslash ; B 47 0 554 562 ;\r\nC 233 ; WX 600 ; N Oslash ; B 43 -80 557 629 ;\r\nC 234 ; WX 600 ; N OE ; B 7 0 567 562 ;\r\nC 235 ; WX 600 ; N ordmasculine ; B 157 249 443 580 ;\r\nC 241 ; WX 600 ; N ae ; B 19 -15 570 441 ;\r\nC 245 ; WX 600 ; N dotlessi ; B 95 0 505 426 ;\r\nC 248 ; WX 600 ; N lslash ; B 95 0 505 629 ;\r\nC 249 ; WX 600 ; N oslash ; B 62 -80 538 506 ;\r\nC 250 ; WX 600 ; N oe ; B 19 -15 559 441 ;\r\nC 251 ; WX 600 ; N germandbls ; B 48 -15 588 629 ;\r\nC -1 ; WX 600 ; N Idieresis ; B 96 0 504 753 ;\r\nC -1 ; WX 600 ; N eacute ; B 66 -15 548 672 ;\r\nC -1 ; WX 600 ; N abreve ; B 53 -15 559 609 ;\r\nC -1 ; WX 600 ; N uhungarumlaut ; B 21 -15 580 672 ;\r\nC -1 ; WX 600 ; N ecaron ; B 66 -15 548 669 ;\r\nC -1 ; WX 600 ; N Ydieresis ; B 24 0 576 753 ;\r\nC -1 ; WX 600 ; N divide ; B 87 48 513 467 ;\r\nC -1 ; WX 600 ; N Yacute ; B 24 0 576 805 ;\r\nC -1 ; WX 600 ; N Acircumflex ; B 3 0 597 787 ;\r\nC -1 ; WX 600 ; N aacute ; B 53 -15 559 672 ;\r\nC -1 ; WX 600 ; N Ucircumflex ; B 17 -18 583 787 ;\r\nC -1 ; WX 600 ; N yacute ; B 7 -157 592 672 ;\r\nC -1 ; WX 600 ; N scommaaccent ; B 80 -250 513 441 ;\r\nC -1 ; WX 600 ; N ecircumflex ; B 66 -15 548 654 ;\r\nC -1 ; WX 600 ; N Uring ; B 17 -18 583 760 ;\r\nC -1 ; WX 600 ; N Udieresis ; B 17 -18 583 753 ;\r\nC -1 ; WX 600 ; N aogonek ; B 53 -172 587 441 ;\r\nC -1 ; WX 600 ; N Uacute ; B 17 -18 583 805 ;\r\nC -1 ; WX 600 ; N uogonek ; B 21 -172 590 426 ;\r\nC -1 ; WX 600 ; N Edieresis ; B 53 0 550 753 ;\r\nC -1 ; WX 600 ; N Dcroat ; B 30 0 574 562 ;\r\nC -1 ; WX 600 ; N commaaccent ; B 198 -250 335 -58 ;\r\nC -1 ; WX 600 ; N copyright ; B 0 -18 600 580 ;\r\nC -1 ; WX 600 ; N Emacron ; B 53 0 550 698 ;\r\nC -1 ; WX 600 ; N ccaron ; B 66 -15 529 669 ;\r\nC -1 ; WX 600 ; N aring ; B 53 -15 559 627 ;\r\nC -1 ; WX 600 ; N Ncommaaccent ; B 7 -250 593 562 ;\r\nC -1 ; WX 600 ; N lacute ; B 95 0 505 805 ;\r\nC -1 ; WX 600 ; N agrave ; B 53 -15 559 672 ;\r\nC -1 ; WX 600 ; N Tcommaaccent ; B 38 -250 563 562 ;\r\nC -1 ; WX 600 ; N Cacute ; B 41 -18 540 805 ;\r\nC -1 ; WX 600 ; N atilde ; B 53 -15 559 606 ;\r\nC -1 ; WX 600 ; N Edotaccent ; B 53 0 550 753 ;\r\nC -1 ; WX 600 ; N scaron ; B 80 -15 513 669 ;\r\nC -1 ; WX 600 ; N scedilla ; B 80 -151 513 441 ;\r\nC -1 ; WX 600 ; N iacute ; B 95 0 505 672 ;\r\nC -1 ; WX 600 ; N lozenge ; B 18 0 443 706 ;\r\nC -1 ; WX 600 ; N Rcaron ; B 38 0 588 802 ;\r\nC -1 ; WX 600 ; N Gcommaaccent ; B 31 -250 575 580 ;\r\nC -1 ; WX 600 ; N ucircumflex ; B 21 -15 562 654 ;\r\nC -1 ; WX 600 ; N acircumflex ; B 53 -15 559 654 ;\r\nC -1 ; WX 600 ; N Amacron ; B 3 0 597 698 ;\r\nC -1 ; WX 600 ; N rcaron ; B 60 0 559 669 ;\r\nC -1 ; WX 600 ; N ccedilla ; B 66 -151 529 441 ;\r\nC -1 ; WX 600 ; N Zdotaccent ; B 86 0 514 753 ;\r\nC -1 ; WX 600 ; N Thorn ; B 79 0 538 562 ;\r\nC -1 ; WX 600 ; N Omacron ; B 43 -18 557 698 ;\r\nC -1 ; WX 600 ; N Racute ; B 38 0 588 805 ;\r\nC -1 ; WX 600 ; N Sacute ; B 72 -20 529 805 ;\r\nC -1 ; WX 600 ; N dcaron ; B 45 -15 715 629 ;\r\nC -1 ; WX 600 ; N Umacron ; B 17 -18 583 698 ;\r\nC -1 ; WX 600 ; N uring ; B 21 -15 562 627 ;\r\nC -1 ; WX 600 ; N threesuperior ; B 155 240 406 622 ;\r\nC -1 ; WX 600 ; N Ograve ; B 43 -18 557 805 ;\r\nC -1 ; WX 600 ; N Agrave ; B 3 0 597 805 ;\r\nC -1 ; WX 600 ; N Abreve ; B 3 0 597 732 ;\r\nC -1 ; WX 600 ; N multiply ; B 87 43 515 470 ;\r\nC -1 ; WX 600 ; N uacute ; B 21 -15 562 672 ;\r\nC -1 ; WX 600 ; N Tcaron ; B 38 0 563 802 ;\r\nC -1 ; WX 600 ; N partialdiff ; B 17 -38 459 710 ;\r\nC -1 ; WX 600 ; N ydieresis ; B 7 -157 592 620 ;\r\nC -1 ; WX 600 ; N Nacute ; B 7 -13 593 805 ;\r\nC -1 ; WX 600 ; N icircumflex ; B 94 0 505 654 ;\r\nC -1 ; WX 600 ; N Ecircumflex ; B 53 0 550 787 ;\r\nC -1 ; WX 600 ; N adieresis ; B 53 -15 559 620 ;\r\nC -1 ; WX 600 ; N edieresis ; B 66 -15 548 620 ;\r\nC -1 ; WX 600 ; N cacute ; B 66 -15 529 672 ;\r\nC -1 ; WX 600 ; N nacute ; B 26 0 575 672 ;\r\nC -1 ; WX 600 ; N umacron ; B 21 -15 562 565 ;\r\nC -1 ; WX 600 ; N Ncaron ; B 7 -13 593 802 ;\r\nC -1 ; WX 600 ; N Iacute ; B 96 0 504 805 ;\r\nC -1 ; WX 600 ; N plusminus ; B 87 44 513 558 ;\r\nC -1 ; WX 600 ; N brokenbar ; B 275 -175 326 675 ;\r\nC -1 ; WX 600 ; N registered ; B 0 -18 600 580 ;\r\nC -1 ; WX 600 ; N Gbreve ; B 31 -18 575 732 ;\r\nC -1 ; WX 600 ; N Idotaccent ; B 96 0 504 753 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\r\nC -1 ; WX 600 ; N Egrave ; B 53 0 550 805 ;\r\nC -1 ; WX 600 ; N racute ; B 60 0 559 672 ;\r\nC -1 ; WX 600 ; N omacron ; B 62 -15 538 565 ;\r\nC -1 ; WX 600 ; N Zacute ; B 86 0 514 805 ;\r\nC -1 ; WX 600 ; N Zcaron ; B 86 0 514 802 ;\r\nC -1 ; WX 600 ; N greaterequal ; B 98 0 502 710 ;\r\nC -1 ; WX 600 ; N Eth ; B 30 0 574 562 ;\r\nC -1 ; WX 600 ; N Ccedilla ; B 41 -151 540 580 ;\r\nC -1 ; WX 600 ; N lcommaaccent ; B 95 -250 505 629 ;\r\nC -1 ; WX 600 ; N tcaron ; B 87 -15 530 717 ;\r\nC -1 ; WX 600 ; N eogonek ; B 66 -172 548 441 ;\r\nC -1 ; WX 600 ; N Uogonek ; B 17 -172 583 562 ;\r\nC -1 ; WX 600 ; N Aacute ; B 3 0 597 805 ;\r\nC -1 ; WX 600 ; N Adieresis ; B 3 0 597 753 ;\r\nC -1 ; WX 600 ; N egrave ; B 66 -15 548 672 ;\r\nC -1 ; WX 600 ; N zacute ; B 99 0 502 672 ;\r\nC -1 ; WX 600 ; N iogonek ; B 95 -172 505 657 ;\r\nC -1 ; WX 600 ; N Oacute ; B 43 -18 557 805 ;\r\nC -1 ; WX 600 ; N oacute ; B 62 -15 538 672 ;\r\nC -1 ; WX 600 ; N amacron ; B 53 -15 559 565 ;\r\nC -1 ; WX 600 ; N sacute ; B 80 -15 513 672 ;\r\nC -1 ; WX 600 ; N idieresis ; B 95 0 505 620 ;\r\nC -1 ; WX 600 ; N Ocircumflex ; B 43 -18 557 787 ;\r\nC -1 ; WX 600 ; N Ugrave ; B 17 -18 583 805 ;\r\nC -1 ; WX 600 ; N Delta ; B 6 0 598 688 ;\r\nC -1 ; WX 600 ; N thorn ; B -6 -157 555 629 ;\r\nC -1 ; WX 600 ; N twosuperior ; B 177 249 424 622 ;\r\nC -1 ; WX 600 ; N Odieresis ; B 43 -18 557 753 ;\r\nC -1 ; WX 600 ; N mu ; B 21 -157 562 426 ;\r\nC -1 ; WX 600 ; N igrave ; B 95 0 505 672 ;\r\nC -1 ; WX 600 ; N ohungarumlaut ; B 62 -15 580 672 ;\r\nC -1 ; WX 600 ; N Eogonek ; B 53 -172 561 562 ;\r\nC -1 ; WX 600 ; N dcroat ; B 45 -15 591 629 ;\r\nC -1 ; WX 600 ; N threequarters ; B 8 -56 593 666 ;\r\nC -1 ; WX 600 ; N Scedilla ; B 72 -151 529 580 ;\r\nC -1 ; WX 600 ; N lcaron ; B 95 0 533 629 ;\r\nC -1 ; WX 600 ; N Kcommaaccent ; B 38 -250 582 562 ;\r\nC -1 ; WX 600 ; N Lacute ; B 47 0 554 805 ;\r\nC -1 ; WX 600 ; N trademark ; B -23 263 623 562 ;\r\nC -1 ; WX 600 ; N edotaccent ; B 66 -15 548 620 ;\r\nC -1 ; WX 600 ; N Igrave ; B 96 0 504 805 ;\r\nC -1 ; WX 600 ; N Imacron ; B 96 0 504 698 ;\r\nC -1 ; WX 600 ; N Lcaron ; B 47 0 554 562 ;\r\nC -1 ; WX 600 ; N onehalf ; B 0 -57 611 665 ;\r\nC -1 ; WX 600 ; N lessequal ; B 98 0 502 710 ;\r\nC -1 ; WX 600 ; N ocircumflex ; B 62 -15 538 654 ;\r\nC -1 ; WX 600 ; N ntilde ; B 26 0 575 606 ;\r\nC -1 ; WX 600 ; N Uhungarumlaut ; B 17 -18 590 805 ;\r\nC -1 ; WX 600 ; N Eacute ; B 53 0 550 805 ;\r\nC -1 ; WX 600 ; N emacron ; B 66 -15 548 565 ;\r\nC -1 ; WX 600 ; N gbreve ; B 45 -157 566 609 ;\r\nC -1 ; WX 600 ; N onequarter ; B 0 -57 600 665 ;\r\nC -1 ; WX 600 ; N Scaron ; B 72 -20 529 802 ;\r\nC -1 ; WX 600 ; N Scommaaccent ; B 72 -250 529 580 ;\r\nC -1 ; WX 600 ; N Ohungarumlaut ; B 43 -18 580 805 ;\r\nC -1 ; WX 600 ; N degree ; B 123 269 477 622 ;\r\nC -1 ; WX 600 ; N ograve ; B 62 -15 538 672 ;\r\nC -1 ; WX 600 ; N Ccaron ; B 41 -18 540 802 ;\r\nC -1 ; WX 600 ; N ugrave ; B 21 -15 562 672 ;\r\nC -1 ; WX 600 ; N radical ; B 3 -15 597 792 ;\r\nC -1 ; WX 600 ; N Dcaron ; B 43 0 574 802 ;\r\nC -1 ; WX 600 ; N rcommaaccent ; B 60 -250 559 441 ;\r\nC -1 ; WX 600 ; N Ntilde ; B 7 -13 593 729 ;\r\nC -1 ; WX 600 ; N otilde ; B 62 -15 538 606 ;\r\nC -1 ; WX 600 ; N Rcommaaccent ; B 38 -250 588 562 ;\r\nC -1 ; WX 600 ; N Lcommaaccent ; B 47 -250 554 562 ;\r\nC -1 ; WX 600 ; N Atilde ; B 3 0 597 729 ;\r\nC -1 ; WX 600 ; N Aogonek ; B 3 -172 608 562 ;\r\nC -1 ; WX 600 ; N Aring ; B 3 0 597 750 ;\r\nC -1 ; WX 600 ; N Otilde ; B 43 -18 557 729 ;\r\nC -1 ; WX 600 ; N zdotaccent ; B 99 0 502 620 ;\r\nC -1 ; WX 600 ; N Ecaron ; B 53 0 550 802 ;\r\nC -1 ; WX 600 ; N Iogonek ; B 96 -172 504 562 ;\r\nC -1 ; WX 600 ; N kcommaaccent ; B 43 -250 580 629 ;\r\nC -1 ; WX 600 ; N minus ; B 80 232 520 283 ;\r\nC -1 ; WX 600 ; N Icircumflex ; B 96 0 504 787 ;\r\nC -1 ; WX 600 ; N ncaron ; B 26 0 575 669 ;\r\nC -1 ; WX 600 ; N tcommaaccent ; B 87 -250 530 561 ;\r\nC -1 ; WX 600 ; N logicalnot ; B 87 108 513 369 ;\r\nC -1 ; WX 600 ; N odieresis ; B 62 -15 538 620 ;\r\nC -1 ; WX 600 ; N udieresis ; B 21 -15 562 620 ;\r\nC -1 ; WX 600 ; N notequal ; B 15 -16 540 529 ;\r\nC -1 ; WX 600 ; N gcommaaccent ; B 45 -157 566 708 ;\r\nC -1 ; WX 600 ; N eth ; B 62 -15 538 629 ;\r\nC -1 ; WX 600 ; N zcaron ; B 99 0 502 669 ;\r\nC -1 ; WX 600 ; N ncommaaccent ; B 26 -250 575 441 ;\r\nC -1 ; WX 600 ; N onesuperior ; B 172 249 428 622 ;\r\nC -1 ; WX 600 ; N imacron ; B 95 0 505 565 ;\r\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
  
                  "Courier-Bold"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Mon Jun 23 16:28:00 1997\r\nComment UniqueID 43048\r\nComment VMusage 41139 52164\r\nFontName Courier-Bold\r\nFullName Courier Bold\r\nFamilyName Courier\r\nWeight Bold\r\nItalicAngle 0\r\nIsFixedPitch true\r\nCharacterSet ExtendedRoman\r\nFontBBox -113 -250 749 801 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 003.000\r\nNotice Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 562\r\nXHeight 439\r\nAscender 629\r\nDescender -157\r\nStdHW 84\r\nStdVW 106\r\nStartCharMetrics 315\r\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 600 ; N exclam ; B 202 -15 398 572 ;\r\nC 34 ; WX 600 ; N quotedbl ; B 135 277 465 562 ;\r\nC 35 ; WX 600 ; N numbersign ; B 56 -45 544 651 ;\r\nC 36 ; WX 600 ; N dollar ; B 82 -126 519 666 ;\r\nC 37 ; WX 600 ; N percent ; B 5 -15 595 616 ;\r\nC 38 ; WX 600 ; N ampersand ; B 36 -15 546 543 ;\r\nC 39 ; WX 600 ; N quoteright ; B 171 277 423 562 ;\r\nC 40 ; WX 600 ; N parenleft ; B 219 -102 461 616 ;\r\nC 41 ; WX 600 ; N parenright ; B 139 -102 381 616 ;\r\nC 42 ; WX 600 ; N asterisk ; B 91 219 509 601 ;\r\nC 43 ; WX 600 ; N plus ; B 71 39 529 478 ;\r\nC 44 ; WX 600 ; N comma ; B 123 -111 393 174 ;\r\nC 45 ; WX 600 ; N hyphen ; B 100 203 500 313 ;\r\nC 46 ; WX 600 ; N period ; B 192 -15 408 171 ;\r\nC 47 ; WX 600 ; N slash ; B 98 -77 502 626 ;\r\nC 48 ; WX 600 ; N zero ; B 87 -15 513 616 ;\r\nC 49 ; WX 600 ; N one ; B 81 0 539 616 ;\r\nC 50 ; WX 600 ; N two ; B 61 0 499 616 ;\r\nC 51 ; WX 600 ; N three ; B 63 -15 501 616 ;\r\nC 52 ; WX 600 ; N four ; B 53 0 507 616 ;\r\nC 53 ; WX 600 ; N five ; B 70 -15 521 601 ;\r\nC 54 ; WX 600 ; N six ; B 90 -15 521 616 ;\r\nC 55 ; WX 600 ; N seven ; B 55 0 494 601 ;\r\nC 56 ; WX 600 ; N eight ; B 83 -15 517 616 ;\r\nC 57 ; WX 600 ; N nine ; B 79 -15 510 616 ;\r\nC 58 ; WX 600 ; N colon ; B 191 -15 407 425 ;\r\nC 59 ; WX 600 ; N semicolon ; B 123 -111 408 425 ;\r\nC 60 ; WX 600 ; N less ; B 66 15 523 501 ;\r\nC 61 ; WX 600 ; N equal ; B 71 118 529 398 ;\r\nC 62 ; WX 600 ; N greater ; B 77 15 534 501 ;\r\nC 63 ; WX 600 ; N question ; B 98 -14 501 580 ;\r\nC 64 ; WX 600 ; N at ; B 16 -15 584 616 ;\r\nC 65 ; WX 600 ; N A ; B -9 0 609 562 ;\r\nC 66 ; WX 600 ; N B ; B 30 0 573 562 ;\r\nC 67 ; WX 600 ; N C ; B 22 -18 560 580 ;\r\nC 68 ; WX 600 ; N D ; B 30 0 594 562 ;\r\nC 69 ; WX 600 ; N E ; B 25 0 560 562 ;\r\nC 70 ; WX 600 ; N F ; B 39 0 570 562 ;\r\nC 71 ; WX 600 ; N G ; B 22 -18 594 580 ;\r\nC 72 ; WX 600 ; N H ; B 20 0 580 562 ;\r\nC 73 ; WX 600 ; N I ; B 77 0 523 562 ;\r\nC 74 ; WX 600 ; N J ; B 37 -18 601 562 ;\r\nC 75 ; WX 600 ; N K ; B 21 0 599 562 ;\r\nC 76 ; WX 600 ; N L ; B 39 0 578 562 ;\r\nC 77 ; WX 600 ; N M ; B -2 0 602 562 ;\r\nC 78 ; WX 600 ; N N ; B 8 -12 610 562 ;\r\nC 79 ; WX 600 ; N O ; B 22 -18 578 580 ;\r\nC 80 ; WX 600 ; N P ; B 48 0 559 562 ;\r\nC 81 ; WX 600 ; N Q ; B 32 -138 578 580 ;\r\nC 82 ; WX 600 ; N R ; B 24 0 599 562 ;\r\nC 83 ; WX 600 ; N S ; B 47 -22 553 582 ;\r\nC 84 ; WX 600 ; N T ; B 21 0 579 562 ;\r\nC 85 ; WX 600 ; N U ; B 4 -18 596 562 ;\r\nC 86 ; WX 600 ; N V ; B -13 0 613 562 ;\r\nC 87 ; WX 600 ; N W ; B -18 0 618 562 ;\r\nC 88 ; WX 600 ; N X ; B 12 0 588 562 ;\r\nC 89 ; WX 600 ; N Y ; B 12 0 589 562 ;\r\nC 90 ; WX 600 ; N Z ; B 62 0 539 562 ;\r\nC 91 ; WX 600 ; N bracketleft ; B 245 -102 475 616 ;\r\nC 92 ; WX 600 ; N backslash ; B 99 -77 503 626 ;\r\nC 93 ; WX 600 ; N bracketright ; B 125 -102 355 616 ;\r\nC 94 ; WX 600 ; N asciicircum ; B 108 250 492 616 ;\r\nC 95 ; WX 600 ; N underscore ; B 0 -125 600 -75 ;\r\nC 96 ; WX 600 ; N quoteleft ; B 178 277 428 562 ;\r\nC 97 ; WX 600 ; N a ; B 35 -15 570 454 ;\r\nC 98 ; WX 600 ; N b ; B 0 -15 584 626 ;\r\nC 99 ; WX 600 ; N c ; B 40 -15 545 459 ;\r\nC 100 ; WX 600 ; N d ; B 20 -15 591 626 ;\r\nC 101 ; WX 600 ; N e ; B 40 -15 563 454 ;\r\nC 102 ; WX 600 ; N f ; B 83 0 547 626 ; L i fi ; L l fl ;\r\nC 103 ; WX 600 ; N g ; B 30 -146 580 454 ;\r\nC 104 ; WX 600 ; N h ; B 5 0 592 626 ;\r\nC 105 ; WX 600 ; N i ; B 77 0 523 658 ;\r\nC 106 ; WX 600 ; N j ; B 63 -146 440 658 ;\r\nC 107 ; WX 600 ; N k ; B 20 0 585 626 ;\r\nC 108 ; WX 600 ; N l ; B 77 0 523 626 ;\r\nC 109 ; WX 600 ; N m ; B -22 0 626 454 ;\r\nC 110 ; WX 600 ; N n ; B 18 0 592 454 ;\r\nC 111 ; WX 600 ; N o ; B 30 -15 570 454 ;\r\nC 112 ; WX 600 ; N p ; B -1 -142 570 454 ;\r\nC 113 ; WX 600 ; N q ; B 20 -142 591 454 ;\r\nC 114 ; WX 600 ; N r ; B 47 0 580 454 ;\r\nC 115 ; WX 600 ; N s ; B 68 -17 535 459 ;\r\nC 116 ; WX 600 ; N t ; B 47 -15 532 562 ;\r\nC 117 ; WX 600 ; N u ; B -1 -15 569 439 ;\r\nC 118 ; WX 600 ; N v ; B -1 0 601 439 ;\r\nC 119 ; WX 600 ; N w ; B -18 0 618 439 ;\r\nC 120 ; WX 600 ; N x ; B 6 0 594 439 ;\r\nC 121 ; WX 600 ; N y ; B -4 -142 601 439 ;\r\nC 122 ; WX 600 ; N z ; B 81 0 520 439 ;\r\nC 123 ; WX 600 ; N braceleft ; B 160 -102 464 616 ;\r\nC 124 ; WX 600 ; N bar ; B 255 -250 345 750 ;\r\nC 125 ; WX 600 ; N braceright ; B 136 -102 440 616 ;\r\nC 126 ; WX 600 ; N asciitilde ; B 71 153 530 356 ;\r\nC 161 ; WX 600 ; N exclamdown ; B 202 -146 398 449 ;\r\nC 162 ; WX 600 ; N cent ; B 66 -49 518 614 ;\r\nC 163 ; WX 600 ; N sterling ; B 72 -28 558 611 ;\r\nC 164 ; WX 600 ; N fraction ; B 25 -60 576 661 ;\r\nC 165 ; WX 600 ; N yen ; B 10 0 590 562 ;\r\nC 166 ; WX 600 ; N florin ; B -30 -131 572 616 ;\r\nC 167 ; WX 600 ; N section ; B 83 -70 517 580 ;\r\nC 168 ; WX 600 ; N currency ; B 54 49 546 517 ;\r\nC 169 ; WX 600 ; N quotesingle ; B 227 277 373 562 ;\r\nC 170 ; WX 600 ; N quotedblleft ; B 71 277 535 562 ;\r\nC 171 ; WX 600 ; N guillemotleft ; B 8 70 553 446 ;\r\nC 172 ; WX 600 ; N guilsinglleft ; B 141 70 459 446 ;\r\nC 173 ; WX 600 ; N guilsinglright ; B 141 70 459 446 ;\r\nC 174 ; WX 600 ; N fi ; B 12 0 593 626 ;\r\nC 175 ; WX 600 ; N fl ; B 12 0 593 626 ;\r\nC 177 ; WX 600 ; N endash ; B 65 203 535 313 ;\r\nC 178 ; WX 600 ; N dagger ; B 106 -70 494 580 ;\r\nC 179 ; WX 600 ; N daggerdbl ; B 106 -70 494 580 ;\r\nC 180 ; WX 600 ; N periodcentered ; B 196 165 404 351 ;\r\nC 182 ; WX 600 ; N paragraph ; B 6 -70 576 580 ;\r\nC 183 ; WX 600 ; N bullet ; B 140 132 460 430 ;\r\nC 184 ; WX 600 ; N quotesinglbase ; B 175 -142 427 143 ;\r\nC 185 ; WX 600 ; N quotedblbase ; B 65 -142 529 143 ;\r\nC 186 ; WX 600 ; N quotedblright ; B 61 277 525 562 ;\r\nC 187 ; WX 600 ; N guillemotright ; B 47 70 592 446 ;\r\nC 188 ; WX 600 ; N ellipsis ; B 26 -15 574 116 ;\r\nC 189 ; WX 600 ; N perthousand ; B -113 -15 713 616 ;\r\nC 191 ; WX 600 ; N questiondown ; B 99 -146 502 449 ;\r\nC 193 ; WX 600 ; N grave ; B 132 508 395 661 ;\r\nC 194 ; WX 600 ; N acute ; B 205 508 468 661 ;\r\nC 195 ; WX 600 ; N circumflex ; B 103 483 497 657 ;\r\nC 196 ; WX 600 ; N tilde ; B 89 493 512 636 ;\r\nC 197 ; WX 600 ; N macron ; B 88 505 512 585 ;\r\nC 198 ; WX 600 ; N breve ; B 83 468 517 631 ;\r\nC 199 ; WX 600 ; N dotaccent ; B 230 498 370 638 ;\r\nC 200 ; WX 600 ; N dieresis ; B 128 498 472 638 ;\r\nC 202 ; WX 600 ; N ring ; B 198 481 402 678 ;\r\nC 203 ; WX 600 ; N cedilla ; B 205 -206 387 0 ;\r\nC 205 ; WX 600 ; N hungarumlaut ; B 68 488 588 661 ;\r\nC 206 ; WX 600 ; N ogonek ; B 169 -199 400 0 ;\r\nC 207 ; WX 600 ; N caron ; B 103 493 497 667 ;\r\nC 208 ; WX 600 ; N emdash ; B -10 203 610 313 ;\r\nC 225 ; WX 600 ; N AE ; B -29 0 602 562 ;\r\nC 227 ; WX 600 ; N ordfeminine ; B 147 196 453 580 ;\r\nC 232 ; WX 600 ; N Lslash ; B 39 0 578 562 ;\r\nC 233 ; WX 600 ; N Oslash ; B 22 -22 578 584 ;\r\nC 234 ; WX 600 ; N OE ; B -25 0 595 562 ;\r\nC 235 ; WX 600 ; N ordmasculine ; B 147 196 453 580 ;\r\nC 241 ; WX 600 ; N ae ; B -4 -15 601 454 ;\r\nC 245 ; WX 600 ; N dotlessi ; B 77 0 523 439 ;\r\nC 248 ; WX 600 ; N lslash ; B 77 0 523 626 ;\r\nC 249 ; WX 600 ; N oslash ; B 30 -24 570 463 ;\r\nC 250 ; WX 600 ; N oe ; B -18 -15 611 454 ;\r\nC 251 ; WX 600 ; N germandbls ; B 22 -15 596 626 ;\r\nC -1 ; WX 600 ; N Idieresis ; B 77 0 523 761 ;\r\nC -1 ; WX 600 ; N eacute ; B 40 -15 563 661 ;\r\nC -1 ; WX 600 ; N abreve ; B 35 -15 570 661 ;\r\nC -1 ; WX 600 ; N uhungarumlaut ; B -1 -15 628 661 ;\r\nC -1 ; WX 600 ; N ecaron ; B 40 -15 563 667 ;\r\nC -1 ; WX 600 ; N Ydieresis ; B 12 0 589 761 ;\r\nC -1 ; WX 600 ; N divide ; B 71 16 529 500 ;\r\nC -1 ; WX 600 ; N Yacute ; B 12 0 589 784 ;\r\nC -1 ; WX 600 ; N Acircumflex ; B -9 0 609 780 ;\r\nC -1 ; WX 600 ; N aacute ; B 35 -15 570 661 ;\r\nC -1 ; WX 600 ; N Ucircumflex ; B 4 -18 596 780 ;\r\nC -1 ; WX 600 ; N yacute ; B -4 -142 601 661 ;\r\nC -1 ; WX 600 ; N scommaaccent ; B 68 -250 535 459 ;\r\nC -1 ; WX 600 ; N ecircumflex ; B 40 -15 563 657 ;\r\nC -1 ; WX 600 ; N Uring ; B 4 -18 596 801 ;\r\nC -1 ; WX 600 ; N Udieresis ; B 4 -18 596 761 ;\r\nC -1 ; WX 600 ; N aogonek ; B 35 -199 586 454 ;\r\nC -1 ; WX 600 ; N Uacute ; B 4 -18 596 784 ;\r\nC -1 ; WX 600 ; N uogonek ; B -1 -199 585 439 ;\r\nC -1 ; WX 600 ; N Edieresis ; B 25 0 560 761 ;\r\nC -1 ; WX 600 ; N Dcroat ; B 30 0 594 562 ;\r\nC -1 ; WX 600 ; N commaaccent ; B 205 -250 397 -57 ;\r\nC -1 ; WX 600 ; N copyright ; B 0 -18 600 580 ;\r\nC -1 ; WX 600 ; N Emacron ; B 25 0 560 708 ;\r\nC -1 ; WX 600 ; N ccaron ; B 40 -15 545 667 ;\r\nC -1 ; WX 600 ; N aring ; B 35 -15 570 678 ;\r\nC -1 ; WX 600 ; N Ncommaaccent ; B 8 -250 610 562 ;\r\nC -1 ; WX 600 ; N lacute ; B 77 0 523 801 ;\r\nC -1 ; WX 600 ; N agrave ; B 35 -15 570 661 ;\r\nC -1 ; WX 600 ; N Tcommaaccent ; B 21 -250 579 562 ;\r\nC -1 ; WX 600 ; N Cacute ; B 22 -18 560 784 ;\r\nC -1 ; WX 600 ; N atilde ; B 35 -15 570 636 ;\r\nC -1 ; WX 600 ; N Edotaccent ; B 25 0 560 761 ;\r\nC -1 ; WX 600 ; N scaron ; B 68 -17 535 667 ;\r\nC -1 ; WX 600 ; N scedilla ; B 68 -206 535 459 ;\r\nC -1 ; WX 600 ; N iacute ; B 77 0 523 661 ;\r\nC -1 ; WX 600 ; N lozenge ; B 66 0 534 740 ;\r\nC -1 ; WX 600 ; N Rcaron ; B 24 0 599 790 ;\r\nC -1 ; WX 600 ; N Gcommaaccent ; B 22 -250 594 580 ;\r\nC -1 ; WX 600 ; N ucircumflex ; B -1 -15 569 657 ;\r\nC -1 ; WX 600 ; N acircumflex ; B 35 -15 570 657 ;\r\nC -1 ; WX 600 ; N Amacron ; B -9 0 609 708 ;\r\nC -1 ; WX 600 ; N rcaron ; B 47 0 580 667 ;\r\nC -1 ; WX 600 ; N ccedilla ; B 40 -206 545 459 ;\r\nC -1 ; WX 600 ; N Zdotaccent ; B 62 0 539 761 ;\r\nC -1 ; WX 600 ; N Thorn ; B 48 0 557 562 ;\r\nC -1 ; WX 600 ; N Omacron ; B 22 -18 578 708 ;\r\nC -1 ; WX 600 ; N Racute ; B 24 0 599 784 ;\r\nC -1 ; WX 600 ; N Sacute ; B 47 -22 553 784 ;\r\nC -1 ; WX 600 ; N dcaron ; B 20 -15 727 626 ;\r\nC -1 ; WX 600 ; N Umacron ; B 4 -18 596 708 ;\r\nC -1 ; WX 600 ; N uring ; B -1 -15 569 678 ;\r\nC -1 ; WX 600 ; N threesuperior ; B 138 222 433 616 ;\r\nC -1 ; WX 600 ; N Ograve ; B 22 -18 578 784 ;\r\nC -1 ; WX 600 ; N Agrave ; B -9 0 609 784 ;\r\nC -1 ; WX 600 ; N Abreve ; B -9 0 609 784 ;\r\nC -1 ; WX 600 ; N multiply ; B 81 39 520 478 ;\r\nC -1 ; WX 600 ; N uacute ; B -1 -15 569 661 ;\r\nC -1 ; WX 600 ; N Tcaron ; B 21 0 579 790 ;\r\nC -1 ; WX 600 ; N partialdiff ; B 63 -38 537 728 ;\r\nC -1 ; WX 600 ; N ydieresis ; B -4 -142 601 638 ;\r\nC -1 ; WX 600 ; N Nacute ; B 8 -12 610 784 ;\r\nC -1 ; WX 600 ; N icircumflex ; B 73 0 523 657 ;\r\nC -1 ; WX 600 ; N Ecircumflex ; B 25 0 560 780 ;\r\nC -1 ; WX 600 ; N adieresis ; B 35 -15 570 638 ;\r\nC -1 ; WX 600 ; N edieresis ; B 40 -15 563 638 ;\r\nC -1 ; WX 600 ; N cacute ; B 40 -15 545 661 ;\r\nC -1 ; WX 600 ; N nacute ; B 18 0 592 661 ;\r\nC -1 ; WX 600 ; N umacron ; B -1 -15 569 585 ;\r\nC -1 ; WX 600 ; N Ncaron ; B 8 -12 610 790 ;\r\nC -1 ; WX 600 ; N Iacute ; B 77 0 523 784 ;\r\nC -1 ; WX 600 ; N plusminus ; B 71 24 529 515 ;\r\nC -1 ; WX 600 ; N brokenbar ; B 255 -175 345 675 ;\r\nC -1 ; WX 600 ; N registered ; B 0 -18 600 580 ;\r\nC -1 ; WX 600 ; N Gbreve ; B 22 -18 594 784 ;\r\nC -1 ; WX 600 ; N Idotaccent ; B 77 0 523 761 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 586 706 ;\r\nC -1 ; WX 600 ; N Egrave ; B 25 0 560 784 ;\r\nC -1 ; WX 600 ; N racute ; B 47 0 580 661 ;\r\nC -1 ; WX 600 ; N omacron ; B 30 -15 570 585 ;\r\nC -1 ; WX 600 ; N Zacute ; B 62 0 539 784 ;\r\nC -1 ; WX 600 ; N Zcaron ; B 62 0 539 790 ;\r\nC -1 ; WX 600 ; N greaterequal ; B 26 0 523 696 ;\r\nC -1 ; WX 600 ; N Eth ; B 30 0 594 562 ;\r\nC -1 ; WX 600 ; N Ccedilla ; B 22 -206 560 580 ;\r\nC -1 ; WX 600 ; N lcommaaccent ; B 77 -250 523 626 ;\r\nC -1 ; WX 600 ; N tcaron ; B 47 -15 532 703 ;\r\nC -1 ; WX 600 ; N eogonek ; B 40 -199 563 454 ;\r\nC -1 ; WX 600 ; N Uogonek ; B 4 -199 596 562 ;\r\nC -1 ; WX 600 ; N Aacute ; B -9 0 609 784 ;\r\nC -1 ; WX 600 ; N Adieresis ; B -9 0 609 761 ;\r\nC -1 ; WX 600 ; N egrave ; B 40 -15 563 661 ;\r\nC -1 ; WX 600 ; N zacute ; B 81 0 520 661 ;\r\nC -1 ; WX 600 ; N iogonek ; B 77 -199 523 658 ;\r\nC -1 ; WX 600 ; N Oacute ; B 22 -18 578 784 ;\r\nC -1 ; WX 600 ; N oacute ; B 30 -15 570 661 ;\r\nC -1 ; WX 600 ; N amacron ; B 35 -15 570 585 ;\r\nC -1 ; WX 600 ; N sacute ; B 68 -17 535 661 ;\r\nC -1 ; WX 600 ; N idieresis ; B 77 0 523 618 ;\r\nC -1 ; WX 600 ; N Ocircumflex ; B 22 -18 578 780 ;\r\nC -1 ; WX 600 ; N Ugrave ; B 4 -18 596 784 ;\r\nC -1 ; WX 600 ; N Delta ; B 6 0 594 688 ;\r\nC -1 ; WX 600 ; N thorn ; B -14 -142 570 626 ;\r\nC -1 ; WX 600 ; N twosuperior ; B 143 230 436 616 ;\r\nC -1 ; WX 600 ; N Odieresis ; B 22 -18 578 761 ;\r\nC -1 ; WX 600 ; N mu ; B -1 -142 569 439 ;\r\nC -1 ; WX 600 ; N igrave ; B 77 0 523 661 ;\r\nC -1 ; WX 600 ; N ohungarumlaut ; B 30 -15 668 661 ;\r\nC -1 ; WX 600 ; N Eogonek ; B 25 -199 576 562 ;\r\nC -1 ; WX 600 ; N dcroat ; B 20 -15 591 626 ;\r\nC -1 ; WX 600 ; N threequarters ; B -47 -60 648 661 ;\r\nC -1 ; WX 600 ; N Scedilla ; B 47 -206 553 582 ;\r\nC -1 ; WX 600 ; N lcaron ; B 77 0 597 626 ;\r\nC -1 ; WX 600 ; N Kcommaaccent ; B 21 -250 599 562 ;\r\nC -1 ; WX 600 ; N Lacute ; B 39 0 578 784 ;\r\nC -1 ; WX 600 ; N trademark ; B -9 230 749 562 ;\r\nC -1 ; WX 600 ; N edotaccent ; B 40 -15 563 638 ;\r\nC -1 ; WX 600 ; N Igrave ; B 77 0 523 784 ;\r\nC -1 ; WX 600 ; N Imacron ; B 77 0 523 708 ;\r\nC -1 ; WX 600 ; N Lcaron ; B 39 0 637 562 ;\r\nC -1 ; WX 600 ; N onehalf ; B -47 -60 648 661 ;\r\nC -1 ; WX 600 ; N lessequal ; B 26 0 523 696 ;\r\nC -1 ; WX 600 ; N ocircumflex ; B 30 -15 570 657 ;\r\nC -1 ; WX 600 ; N ntilde ; B 18 0 592 636 ;\r\nC -1 ; WX 600 ; N Uhungarumlaut ; B 4 -18 638 784 ;\r\nC -1 ; WX 600 ; N Eacute ; B 25 0 560 784 ;\r\nC -1 ; WX 600 ; N emacron ; B 40 -15 563 585 ;\r\nC -1 ; WX 600 ; N gbreve ; B 30 -146 580 661 ;\r\nC -1 ; WX 600 ; N onequarter ; B -56 -60 656 661 ;\r\nC -1 ; WX 600 ; N Scaron ; B 47 -22 553 790 ;\r\nC -1 ; WX 600 ; N Scommaaccent ; B 47 -250 553 582 ;\r\nC -1 ; WX 600 ; N Ohungarumlaut ; B 22 -18 628 784 ;\r\nC -1 ; WX 600 ; N degree ; B 86 243 474 616 ;\r\nC -1 ; WX 600 ; N ograve ; B 30 -15 570 661 ;\r\nC -1 ; WX 600 ; N Ccaron ; B 22 -18 560 790 ;\r\nC -1 ; WX 600 ; N ugrave ; B -1 -15 569 661 ;\r\nC -1 ; WX 600 ; N radical ; B -19 -104 473 778 ;\r\nC -1 ; WX 600 ; N Dcaron ; B 30 0 594 790 ;\r\nC -1 ; WX 600 ; N rcommaaccent ; B 47 -250 580 454 ;\r\nC -1 ; WX 600 ; N Ntilde ; B 8 -12 610 759 ;\r\nC -1 ; WX 600 ; N otilde ; B 30 -15 570 636 ;\r\nC -1 ; WX 600 ; N Rcommaaccent ; B 24 -250 599 562 ;\r\nC -1 ; WX 600 ; N Lcommaaccent ; B 39 -250 578 562 ;\r\nC -1 ; WX 600 ; N Atilde ; B -9 0 609 759 ;\r\nC -1 ; WX 600 ; N Aogonek ; B -9 -199 625 562 ;\r\nC -1 ; WX 600 ; N Aring ; B -9 0 609 801 ;\r\nC -1 ; WX 600 ; N Otilde ; B 22 -18 578 759 ;\r\nC -1 ; WX 600 ; N zdotaccent ; B 81 0 520 638 ;\r\nC -1 ; WX 600 ; N Ecaron ; B 25 0 560 790 ;\r\nC -1 ; WX 600 ; N Iogonek ; B 77 -199 523 562 ;\r\nC -1 ; WX 600 ; N kcommaaccent ; B 20 -250 585 626 ;\r\nC -1 ; WX 600 ; N minus ; B 71 203 529 313 ;\r\nC -1 ; WX 600 ; N Icircumflex ; B 77 0 523 780 ;\r\nC -1 ; WX 600 ; N ncaron ; B 18 0 592 667 ;\r\nC -1 ; WX 600 ; N tcommaaccent ; B 47 -250 532 562 ;\r\nC -1 ; WX 600 ; N logicalnot ; B 71 103 529 413 ;\r\nC -1 ; WX 600 ; N odieresis ; B 30 -15 570 638 ;\r\nC -1 ; WX 600 ; N udieresis ; B -1 -15 569 638 ;\r\nC -1 ; WX 600 ; N notequal ; B 12 -47 537 563 ;\r\nC -1 ; WX 600 ; N gcommaaccent ; B 30 -146 580 714 ;\r\nC -1 ; WX 600 ; N eth ; B 58 -27 543 626 ;\r\nC -1 ; WX 600 ; N zcaron ; B 81 0 520 667 ;\r\nC -1 ; WX 600 ; N ncommaaccent ; B 18 -250 592 454 ;\r\nC -1 ; WX 600 ; N onesuperior ; B 153 230 447 616 ;\r\nC -1 ; WX 600 ; N imacron ; B 77 0 523 585 ;\r\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
  
                  "Courier-Oblique"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 17:37:52 1997\r\nComment UniqueID 43051\r\nComment VMusage 16248 75829\r\nFontName Courier-Oblique\r\nFullName Courier Oblique\r\nFamilyName Courier\r\nWeight Medium\r\nItalicAngle -12\r\nIsFixedPitch true\r\nCharacterSet ExtendedRoman\r\nFontBBox -27 -250 849 805 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 003.000\r\nNotice Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 562\r\nXHeight 426\r\nAscender 629\r\nDescender -157\r\nStdHW 51\r\nStdVW 51\r\nStartCharMetrics 315\r\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 600 ; N exclam ; B 243 -15 464 572 ;\r\nC 34 ; WX 600 ; N quotedbl ; B 273 328 532 562 ;\r\nC 35 ; WX 600 ; N numbersign ; B 133 -32 596 639 ;\r\nC 36 ; WX 600 ; N dollar ; B 108 -126 596 662 ;\r\nC 37 ; WX 600 ; N percent ; B 134 -15 599 622 ;\r\nC 38 ; WX 600 ; N ampersand ; B 87 -15 580 543 ;\r\nC 39 ; WX 600 ; N quoteright ; B 283 328 495 562 ;\r\nC 40 ; WX 600 ; N parenleft ; B 313 -108 572 622 ;\r\nC 41 ; WX 600 ; N parenright ; B 137 -108 396 622 ;\r\nC 42 ; WX 600 ; N asterisk ; B 212 257 580 607 ;\r\nC 43 ; WX 600 ; N plus ; B 129 44 580 470 ;\r\nC 44 ; WX 600 ; N comma ; B 157 -112 370 122 ;\r\nC 45 ; WX 600 ; N hyphen ; B 152 231 558 285 ;\r\nC 46 ; WX 600 ; N period ; B 238 -15 382 109 ;\r\nC 47 ; WX 600 ; N slash ; B 112 -80 604 629 ;\r\nC 48 ; WX 600 ; N zero ; B 154 -15 575 622 ;\r\nC 49 ; WX 600 ; N one ; B 98 0 515 622 ;\r\nC 50 ; WX 600 ; N two ; B 70 0 568 622 ;\r\nC 51 ; WX 600 ; N three ; B 82 -15 538 622 ;\r\nC 52 ; WX 600 ; N four ; B 108 0 541 622 ;\r\nC 53 ; WX 600 ; N five ; B 99 -15 589 607 ;\r\nC 54 ; WX 600 ; N six ; B 155 -15 629 622 ;\r\nC 55 ; WX 600 ; N seven ; B 182 0 612 607 ;\r\nC 56 ; WX 600 ; N eight ; B 132 -15 588 622 ;\r\nC 57 ; WX 600 ; N nine ; B 93 -15 574 622 ;\r\nC 58 ; WX 600 ; N colon ; B 238 -15 441 385 ;\r\nC 59 ; WX 600 ; N semicolon ; B 157 -112 441 385 ;\r\nC 60 ; WX 600 ; N less ; B 96 42 610 472 ;\r\nC 61 ; WX 600 ; N equal ; B 109 138 600 376 ;\r\nC 62 ; WX 600 ; N greater ; B 85 42 599 472 ;\r\nC 63 ; WX 600 ; N question ; B 222 -15 583 572 ;\r\nC 64 ; WX 600 ; N at ; B 127 -15 582 622 ;\r\nC 65 ; WX 600 ; N A ; B 3 0 607 562 ;\r\nC 66 ; WX 600 ; N B ; B 43 0 616 562 ;\r\nC 67 ; WX 600 ; N C ; B 93 -18 655 580 ;\r\nC 68 ; WX 600 ; N D ; B 43 0 645 562 ;\r\nC 69 ; WX 600 ; N E ; B 53 0 660 562 ;\r\nC 70 ; WX 600 ; N F ; B 53 0 660 562 ;\r\nC 71 ; WX 600 ; N G ; B 83 -18 645 580 ;\r\nC 72 ; WX 600 ; N H ; B 32 0 687 562 ;\r\nC 73 ; WX 600 ; N I ; B 96 0 623 562 ;\r\nC 74 ; WX 600 ; N J ; B 52 -18 685 562 ;\r\nC 75 ; WX 600 ; N K ; B 38 0 671 562 ;\r\nC 76 ; WX 600 ; N L ; B 47 0 607 562 ;\r\nC 77 ; WX 600 ; N M ; B 4 0 715 562 ;\r\nC 78 ; WX 600 ; N N ; B 7 -13 712 562 ;\r\nC 79 ; WX 600 ; N O ; B 94 -18 625 580 ;\r\nC 80 ; WX 600 ; N P ; B 79 0 644 562 ;\r\nC 81 ; WX 600 ; N Q ; B 95 -138 625 580 ;\r\nC 82 ; WX 600 ; N R ; B 38 0 598 562 ;\r\nC 83 ; WX 600 ; N S ; B 76 -20 650 580 ;\r\nC 84 ; WX 600 ; N T ; B 108 0 665 562 ;\r\nC 85 ; WX 600 ; N U ; B 125 -18 702 562 ;\r\nC 86 ; WX 600 ; N V ; B 105 -13 723 562 ;\r\nC 87 ; WX 600 ; N W ; B 106 -13 722 562 ;\r\nC 88 ; WX 600 ; N X ; B 23 0 675 562 ;\r\nC 89 ; WX 600 ; N Y ; B 133 0 695 562 ;\r\nC 90 ; WX 600 ; N Z ; B 86 0 610 562 ;\r\nC 91 ; WX 600 ; N bracketleft ; B 246 -108 574 622 ;\r\nC 92 ; WX 600 ; N backslash ; B 249 -80 468 629 ;\r\nC 93 ; WX 600 ; N bracketright ; B 135 -108 463 622 ;\r\nC 94 ; WX 600 ; N asciicircum ; B 175 354 587 622 ;\r\nC 95 ; WX 600 ; N underscore ; B -27 -125 584 -75 ;\r\nC 96 ; WX 600 ; N quoteleft ; B 343 328 457 562 ;\r\nC 97 ; WX 600 ; N a ; B 76 -15 569 441 ;\r\nC 98 ; WX 600 ; N b ; B 29 -15 625 629 ;\r\nC 99 ; WX 600 ; N c ; B 106 -15 608 441 ;\r\nC 100 ; WX 600 ; N d ; B 85 -15 640 629 ;\r\nC 101 ; WX 600 ; N e ; B 106 -15 598 441 ;\r\nC 102 ; WX 600 ; N f ; B 114 0 662 629 ; L i fi ; L l fl ;\r\nC 103 ; WX 600 ; N g ; B 61 -157 657 441 ;\r\nC 104 ; WX 600 ; N h ; B 33 0 592 629 ;\r\nC 105 ; WX 600 ; N i ; B 95 0 515 657 ;\r\nC 106 ; WX 600 ; N j ; B 52 -157 550 657 ;\r\nC 107 ; WX 600 ; N k ; B 58 0 633 629 ;\r\nC 108 ; WX 600 ; N l ; B 95 0 515 629 ;\r\nC 109 ; WX 600 ; N m ; B -5 0 615 441 ;\r\nC 110 ; WX 600 ; N n ; B 26 0 585 441 ;\r\nC 111 ; WX 600 ; N o ; B 102 -15 588 441 ;\r\nC 112 ; WX 600 ; N p ; B -24 -157 605 441 ;\r\nC 113 ; WX 600 ; N q ; B 85 -157 682 441 ;\r\nC 114 ; WX 600 ; N r ; B 60 0 636 441 ;\r\nC 115 ; WX 600 ; N s ; B 78 -15 584 441 ;\r\nC 116 ; WX 600 ; N t ; B 167 -15 561 561 ;\r\nC 117 ; WX 600 ; N u ; B 101 -15 572 426 ;\r\nC 118 ; WX 600 ; N v ; B 90 -10 681 426 ;\r\nC 119 ; WX 600 ; N w ; B 76 -10 695 426 ;\r\nC 120 ; WX 600 ; N x ; B 20 0 655 426 ;\r\nC 121 ; WX 600 ; N y ; B -4 -157 683 426 ;\r\nC 122 ; WX 600 ; N z ; B 99 0 593 426 ;\r\nC 123 ; WX 600 ; N braceleft ; B 233 -108 569 622 ;\r\nC 124 ; WX 600 ; N bar ; B 222 -250 485 750 ;\r\nC 125 ; WX 600 ; N braceright ; B 140 -108 477 622 ;\r\nC 126 ; WX 600 ; N asciitilde ; B 116 197 600 320 ;\r\nC 161 ; WX 600 ; N exclamdown ; B 225 -157 445 430 ;\r\nC 162 ; WX 600 ; N cent ; B 151 -49 588 614 ;\r\nC 163 ; WX 600 ; N sterling ; B 124 -21 621 611 ;\r\nC 164 ; WX 600 ; N fraction ; B 84 -57 646 665 ;\r\nC 165 ; WX 600 ; N yen ; B 120 0 693 562 ;\r\nC 166 ; WX 600 ; N florin ; B -26 -143 671 622 ;\r\nC 167 ; WX 600 ; N section ; B 104 -78 590 580 ;\r\nC 168 ; WX 600 ; N currency ; B 94 58 628 506 ;\r\nC 169 ; WX 600 ; N quotesingle ; B 345 328 460 562 ;\r\nC 170 ; WX 600 ; N quotedblleft ; B 262 328 541 562 ;\r\nC 171 ; WX 600 ; N guillemotleft ; B 92 70 652 446 ;\r\nC 172 ; WX 600 ; N guilsinglleft ; B 204 70 540 446 ;\r\nC 173 ; WX 600 ; N guilsinglright ; B 170 70 506 446 ;\r\nC 174 ; WX 600 ; N fi ; B 3 0 619 629 ;\r\nC 175 ; WX 600 ; N fl ; B 3 0 619 629 ;\r\nC 177 ; WX 600 ; N endash ; B 124 231 586 285 ;\r\nC 178 ; WX 600 ; N dagger ; B 217 -78 546 580 ;\r\nC 179 ; WX 600 ; N daggerdbl ; B 163 -78 546 580 ;\r\nC 180 ; WX 600 ; N periodcentered ; B 275 189 434 327 ;\r\nC 182 ; WX 600 ; N paragraph ; B 100 -78 630 562 ;\r\nC 183 ; WX 600 ; N bullet ; B 224 130 485 383 ;\r\nC 184 ; WX 600 ; N quotesinglbase ; B 185 -134 397 100 ;\r\nC 185 ; WX 600 ; N quotedblbase ; B 115 -134 478 100 ;\r\nC 186 ; WX 600 ; N quotedblright ; B 213 328 576 562 ;\r\nC 187 ; WX 600 ; N guillemotright ; B 58 70 618 446 ;\r\nC 188 ; WX 600 ; N ellipsis ; B 46 -15 575 111 ;\r\nC 189 ; WX 600 ; N perthousand ; B 59 -15 627 622 ;\r\nC 191 ; WX 600 ; N questiondown ; B 105 -157 466 430 ;\r\nC 193 ; WX 600 ; N grave ; B 294 497 484 672 ;\r\nC 194 ; WX 600 ; N acute ; B 348 497 612 672 ;\r\nC 195 ; WX 600 ; N circumflex ; B 229 477 581 654 ;\r\nC 196 ; WX 600 ; N tilde ; B 212 489 629 606 ;\r\nC 197 ; WX 600 ; N macron ; B 232 525 600 565 ;\r\nC 198 ; WX 600 ; N breve ; B 279 501 576 609 ;\r\nC 199 ; WX 600 ; N dotaccent ; B 373 537 478 640 ;\r\nC 200 ; WX 600 ; N dieresis ; B 272 537 579 640 ;\r\nC 202 ; WX 600 ; N ring ; B 332 463 500 627 ;\r\nC 203 ; WX 600 ; N cedilla ; B 197 -151 344 10 ;\r\nC 205 ; WX 600 ; N hungarumlaut ; B 239 497 683 672 ;\r\nC 206 ; WX 600 ; N ogonek ; B 189 -172 377 4 ;\r\nC 207 ; WX 600 ; N caron ; B 262 492 614 669 ;\r\nC 208 ; WX 600 ; N emdash ; B 49 231 661 285 ;\r\nC 225 ; WX 600 ; N AE ; B 3 0 655 562 ;\r\nC 227 ; WX 600 ; N ordfeminine ; B 209 249 512 580 ;\r\nC 232 ; WX 600 ; N Lslash ; B 47 0 607 562 ;\r\nC 233 ; WX 600 ; N Oslash ; B 94 -80 625 629 ;\r\nC 234 ; WX 600 ; N OE ; B 59 0 672 562 ;\r\nC 235 ; WX 600 ; N ordmasculine ; B 210 249 535 580 ;\r\nC 241 ; WX 600 ; N ae ; B 41 -15 626 441 ;\r\nC 245 ; WX 600 ; N dotlessi ; B 95 0 515 426 ;\r\nC 248 ; WX 600 ; N lslash ; B 95 0 587 629 ;\r\nC 249 ; WX 600 ; N oslash ; B 102 -80 588 506 ;\r\nC 250 ; WX 600 ; N oe ; B 54 -15 615 441 ;\r\nC 251 ; WX 600 ; N germandbls ; B 48 -15 617 629 ;\r\nC -1 ; WX 600 ; N Idieresis ; B 96 0 623 753 ;\r\nC -1 ; WX 600 ; N eacute ; B 106 -15 612 672 ;\r\nC -1 ; WX 600 ; N abreve ; B 76 -15 576 609 ;\r\nC -1 ; WX 600 ; N uhungarumlaut ; B 101 -15 723 672 ;\r\nC -1 ; WX 600 ; N ecaron ; B 106 -15 614 669 ;\r\nC -1 ; WX 600 ; N Ydieresis ; B 133 0 695 753 ;\r\nC -1 ; WX 600 ; N divide ; B 136 48 573 467 ;\r\nC -1 ; WX 600 ; N Yacute ; B 133 0 695 805 ;\r\nC -1 ; WX 600 ; N Acircumflex ; B 3 0 607 787 ;\r\nC -1 ; WX 600 ; N aacute ; B 76 -15 612 672 ;\r\nC -1 ; WX 600 ; N Ucircumflex ; B 125 -18 702 787 ;\r\nC -1 ; WX 600 ; N yacute ; B -4 -157 683 672 ;\r\nC -1 ; WX 600 ; N scommaaccent ; B 78 -250 584 441 ;\r\nC -1 ; WX 600 ; N ecircumflex ; B 106 -15 598 654 ;\r\nC -1 ; WX 600 ; N Uring ; B 125 -18 702 760 ;\r\nC -1 ; WX 600 ; N Udieresis ; B 125 -18 702 753 ;\r\nC -1 ; WX 600 ; N aogonek ; B 76 -172 569 441 ;\r\nC -1 ; WX 600 ; N Uacute ; B 125 -18 702 805 ;\r\nC -1 ; WX 600 ; N uogonek ; B 101 -172 572 426 ;\r\nC -1 ; WX 600 ; N Edieresis ; B 53 0 660 753 ;\r\nC -1 ; WX 600 ; N Dcroat ; B 43 0 645 562 ;\r\nC -1 ; WX 600 ; N commaaccent ; B 145 -250 323 -58 ;\r\nC -1 ; WX 600 ; N copyright ; B 53 -18 667 580 ;\r\nC -1 ; WX 600 ; N Emacron ; B 53 0 660 698 ;\r\nC -1 ; WX 600 ; N ccaron ; B 106 -15 614 669 ;\r\nC -1 ; WX 600 ; N aring ; B 76 -15 569 627 ;\r\nC -1 ; WX 600 ; N Ncommaaccent ; B 7 -250 712 562 ;\r\nC -1 ; WX 600 ; N lacute ; B 95 0 640 805 ;\r\nC -1 ; WX 600 ; N agrave ; B 76 -15 569 672 ;\r\nC -1 ; WX 600 ; N Tcommaaccent ; B 108 -250 665 562 ;\r\nC -1 ; WX 600 ; N Cacute ; B 93 -18 655 805 ;\r\nC -1 ; WX 600 ; N atilde ; B 76 -15 629 606 ;\r\nC -1 ; WX 600 ; N Edotaccent ; B 53 0 660 753 ;\r\nC -1 ; WX 600 ; N scaron ; B 78 -15 614 669 ;\r\nC -1 ; WX 600 ; N scedilla ; B 78 -151 584 441 ;\r\nC -1 ; WX 600 ; N iacute ; B 95 0 612 672 ;\r\nC -1 ; WX 600 ; N lozenge ; B 94 0 519 706 ;\r\nC -1 ; WX 600 ; N Rcaron ; B 38 0 642 802 ;\r\nC -1 ; WX 600 ; N Gcommaaccent ; B 83 -250 645 580 ;\r\nC -1 ; WX 600 ; N ucircumflex ; B 101 -15 572 654 ;\r\nC -1 ; WX 600 ; N acircumflex ; B 76 -15 581 654 ;\r\nC -1 ; WX 600 ; N Amacron ; B 3 0 607 698 ;\r\nC -1 ; WX 600 ; N rcaron ; B 60 0 636 669 ;\r\nC -1 ; WX 600 ; N ccedilla ; B 106 -151 614 441 ;\r\nC -1 ; WX 600 ; N Zdotaccent ; B 86 0 610 753 ;\r\nC -1 ; WX 600 ; N Thorn ; B 79 0 606 562 ;\r\nC -1 ; WX 600 ; N Omacron ; B 94 -18 628 698 ;\r\nC -1 ; WX 600 ; N Racute ; B 38 0 670 805 ;\r\nC -1 ; WX 600 ; N Sacute ; B 76 -20 650 805 ;\r\nC -1 ; WX 600 ; N dcaron ; B 85 -15 849 629 ;\r\nC -1 ; WX 600 ; N Umacron ; B 125 -18 702 698 ;\r\nC -1 ; WX 600 ; N uring ; B 101 -15 572 627 ;\r\nC -1 ; WX 600 ; N threesuperior ; B 213 240 501 622 ;\r\nC -1 ; WX 600 ; N Ograve ; B 94 -18 625 805 ;\r\nC -1 ; WX 600 ; N Agrave ; B 3 0 607 805 ;\r\nC -1 ; WX 600 ; N Abreve ; B 3 0 607 732 ;\r\nC -1 ; WX 600 ; N multiply ; B 103 43 607 470 ;\r\nC -1 ; WX 600 ; N uacute ; B 101 -15 602 672 ;\r\nC -1 ; WX 600 ; N Tcaron ; B 108 0 665 802 ;\r\nC -1 ; WX 600 ; N partialdiff ; B 45 -38 546 710 ;\r\nC -1 ; WX 600 ; N ydieresis ; B -4 -157 683 620 ;\r\nC -1 ; WX 600 ; N Nacute ; B 7 -13 712 805 ;\r\nC -1 ; WX 600 ; N icircumflex ; B 95 0 551 654 ;\r\nC -1 ; WX 600 ; N Ecircumflex ; B 53 0 660 787 ;\r\nC -1 ; WX 600 ; N adieresis ; B 76 -15 575 620 ;\r\nC -1 ; WX 600 ; N edieresis ; B 106 -15 598 620 ;\r\nC -1 ; WX 600 ; N cacute ; B 106 -15 612 672 ;\r\nC -1 ; WX 600 ; N nacute ; B 26 0 602 672 ;\r\nC -1 ; WX 600 ; N umacron ; B 101 -15 600 565 ;\r\nC -1 ; WX 600 ; N Ncaron ; B 7 -13 712 802 ;\r\nC -1 ; WX 600 ; N Iacute ; B 96 0 640 805 ;\r\nC -1 ; WX 600 ; N plusminus ; B 96 44 594 558 ;\r\nC -1 ; WX 600 ; N brokenbar ; B 238 -175 469 675 ;\r\nC -1 ; WX 600 ; N registered ; B 53 -18 667 580 ;\r\nC -1 ; WX 600 ; N Gbreve ; B 83 -18 645 732 ;\r\nC -1 ; WX 600 ; N Idotaccent ; B 96 0 623 753 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 670 706 ;\r\nC -1 ; WX 600 ; N Egrave ; B 53 0 660 805 ;\r\nC -1 ; WX 600 ; N racute ; B 60 0 636 672 ;\r\nC -1 ; WX 600 ; N omacron ; B 102 -15 600 565 ;\r\nC -1 ; WX 600 ; N Zacute ; B 86 0 670 805 ;\r\nC -1 ; WX 600 ; N Zcaron ; B 86 0 642 802 ;\r\nC -1 ; WX 600 ; N greaterequal ; B 98 0 594 710 ;\r\nC -1 ; WX 600 ; N Eth ; B 43 0 645 562 ;\r\nC -1 ; WX 600 ; N Ccedilla ; B 93 -151 658 580 ;\r\nC -1 ; WX 600 ; N lcommaaccent ; B 95 -250 515 629 ;\r\nC -1 ; WX 600 ; N tcaron ; B 167 -15 587 717 ;\r\nC -1 ; WX 600 ; N eogonek ; B 106 -172 598 441 ;\r\nC -1 ; WX 600 ; N Uogonek ; B 124 -172 702 562 ;\r\nC -1 ; WX 600 ; N Aacute ; B 3 0 660 805 ;\r\nC -1 ; WX 600 ; N Adieresis ; B 3 0 607 753 ;\r\nC -1 ; WX 600 ; N egrave ; B 106 -15 598 672 ;\r\nC -1 ; WX 600 ; N zacute ; B 99 0 612 672 ;\r\nC -1 ; WX 600 ; N iogonek ; B 95 -172 515 657 ;\r\nC -1 ; WX 600 ; N Oacute ; B 94 -18 640 805 ;\r\nC -1 ; WX 600 ; N oacute ; B 102 -15 612 672 ;\r\nC -1 ; WX 600 ; N amacron ; B 76 -15 600 565 ;\r\nC -1 ; WX 600 ; N sacute ; B 78 -15 612 672 ;\r\nC -1 ; WX 600 ; N idieresis ; B 95 0 545 620 ;\r\nC -1 ; WX 600 ; N Ocircumflex ; B 94 -18 625 787 ;\r\nC -1 ; WX 600 ; N Ugrave ; B 125 -18 702 805 ;\r\nC -1 ; WX 600 ; N Delta ; B 6 0 598 688 ;\r\nC -1 ; WX 600 ; N thorn ; B -24 -157 605 629 ;\r\nC -1 ; WX 600 ; N twosuperior ; B 230 249 535 622 ;\r\nC -1 ; WX 600 ; N Odieresis ; B 94 -18 625 753 ;\r\nC -1 ; WX 600 ; N mu ; B 72 -157 572 426 ;\r\nC -1 ; WX 600 ; N igrave ; B 95 0 515 672 ;\r\nC -1 ; WX 600 ; N ohungarumlaut ; B 102 -15 723 672 ;\r\nC -1 ; WX 600 ; N Eogonek ; B 53 -172 660 562 ;\r\nC -1 ; WX 600 ; N dcroat ; B 85 -15 704 629 ;\r\nC -1 ; WX 600 ; N threequarters ; B 73 -56 659 666 ;\r\nC -1 ; WX 600 ; N Scedilla ; B 76 -151 650 580 ;\r\nC -1 ; WX 600 ; N lcaron ; B 95 0 667 629 ;\r\nC -1 ; WX 600 ; N Kcommaaccent ; B 38 -250 671 562 ;\r\nC -1 ; WX 600 ; N Lacute ; B 47 0 607 805 ;\r\nC -1 ; WX 600 ; N trademark ; B 75 263 742 562 ;\r\nC -1 ; WX 600 ; N edotaccent ; B 106 -15 598 620 ;\r\nC -1 ; WX 600 ; N Igrave ; B 96 0 623 805 ;\r\nC -1 ; WX 600 ; N Imacron ; B 96 0 628 698 ;\r\nC -1 ; WX 600 ; N Lcaron ; B 47 0 632 562 ;\r\nC -1 ; WX 600 ; N onehalf ; B 65 -57 669 665 ;\r\nC -1 ; WX 600 ; N lessequal ; B 98 0 645 710 ;\r\nC -1 ; WX 600 ; N ocircumflex ; B 102 -15 588 654 ;\r\nC -1 ; WX 600 ; N ntilde ; B 26 0 629 606 ;\r\nC -1 ; WX 600 ; N Uhungarumlaut ; B 125 -18 761 805 ;\r\nC -1 ; WX 600 ; N Eacute ; B 53 0 670 805 ;\r\nC -1 ; WX 600 ; N emacron ; B 106 -15 600 565 ;\r\nC -1 ; WX 600 ; N gbreve ; B 61 -157 657 609 ;\r\nC -1 ; WX 600 ; N onequarter ; B 65 -57 674 665 ;\r\nC -1 ; WX 600 ; N Scaron ; B 76 -20 672 802 ;\r\nC -1 ; WX 600 ; N Scommaaccent ; B 76 -250 650 580 ;\r\nC -1 ; WX 600 ; N Ohungarumlaut ; B 94 -18 751 805 ;\r\nC -1 ; WX 600 ; N degree ; B 214 269 576 622 ;\r\nC -1 ; WX 600 ; N ograve ; B 102 -15 588 672 ;\r\nC -1 ; WX 600 ; N Ccaron ; B 93 -18 672 802 ;\r\nC -1 ; WX 600 ; N ugrave ; B 101 -15 572 672 ;\r\nC -1 ; WX 600 ; N radical ; B 85 -15 765 792 ;\r\nC -1 ; WX 600 ; N Dcaron ; B 43 0 645 802 ;\r\nC -1 ; WX 600 ; N rcommaaccent ; B 60 -250 636 441 ;\r\nC -1 ; WX 600 ; N Ntilde ; B 7 -13 712 729 ;\r\nC -1 ; WX 600 ; N otilde ; B 102 -15 629 606 ;\r\nC -1 ; WX 600 ; N Rcommaaccent ; B 38 -250 598 562 ;\r\nC -1 ; WX 600 ; N Lcommaaccent ; B 47 -250 607 562 ;\r\nC -1 ; WX 600 ; N Atilde ; B 3 0 655 729 ;\r\nC -1 ; WX 600 ; N Aogonek ; B 3 -172 607 562 ;\r\nC -1 ; WX 600 ; N Aring ; B 3 0 607 750 ;\r\nC -1 ; WX 600 ; N Otilde ; B 94 -18 655 729 ;\r\nC -1 ; WX 600 ; N zdotaccent ; B 99 0 593 620 ;\r\nC -1 ; WX 600 ; N Ecaron ; B 53 0 660 802 ;\r\nC -1 ; WX 600 ; N Iogonek ; B 96 -172 623 562 ;\r\nC -1 ; WX 600 ; N kcommaaccent ; B 58 -250 633 629 ;\r\nC -1 ; WX 600 ; N minus ; B 129 232 580 283 ;\r\nC -1 ; WX 600 ; N Icircumflex ; B 96 0 623 787 ;\r\nC -1 ; WX 600 ; N ncaron ; B 26 0 614 669 ;\r\nC -1 ; WX 600 ; N tcommaaccent ; B 165 -250 561 561 ;\r\nC -1 ; WX 600 ; N logicalnot ; B 155 108 591 369 ;\r\nC -1 ; WX 600 ; N odieresis ; B 102 -15 588 620 ;\r\nC -1 ; WX 600 ; N udieresis ; B 101 -15 575 620 ;\r\nC -1 ; WX 600 ; N notequal ; B 43 -16 621 529 ;\r\nC -1 ; WX 600 ; N gcommaaccent ; B 61 -157 657 708 ;\r\nC -1 ; WX 600 ; N eth ; B 102 -15 639 629 ;\r\nC -1 ; WX 600 ; N zcaron ; B 99 0 624 669 ;\r\nC -1 ; WX 600 ; N ncommaaccent ; B 26 -250 585 441 ;\r\nC -1 ; WX 600 ; N onesuperior ; B 231 249 491 622 ;\r\nC -1 ; WX 600 ; N imacron ; B 95 0 543 565 ;\r\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
  
                  "Courier-BoldOblique"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Mon Jun 23 16:28:46 1997\r\nComment UniqueID 43049\r\nComment VMusage 17529 79244\r\nFontName Courier-BoldOblique\r\nFullName Courier Bold Oblique\r\nFamilyName Courier\r\nWeight Bold\r\nItalicAngle -12\r\nIsFixedPitch true\r\nCharacterSet ExtendedRoman\r\nFontBBox -57 -250 869 801 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 003.000\r\nNotice Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 562\r\nXHeight 439\r\nAscender 629\r\nDescender -157\r\nStdHW 84\r\nStdVW 106\r\nStartCharMetrics 315\r\nC 32 ; WX 600 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 600 ; N exclam ; B 215 -15 495 572 ;\r\nC 34 ; WX 600 ; N quotedbl ; B 211 277 585 562 ;\r\nC 35 ; WX 600 ; N numbersign ; B 88 -45 641 651 ;\r\nC 36 ; WX 600 ; N dollar ; B 87 -126 630 666 ;\r\nC 37 ; WX 600 ; N percent ; B 101 -15 625 616 ;\r\nC 38 ; WX 600 ; N ampersand ; B 61 -15 595 543 ;\r\nC 39 ; WX 600 ; N quoteright ; B 229 277 543 562 ;\r\nC 40 ; WX 600 ; N parenleft ; B 265 -102 592 616 ;\r\nC 41 ; WX 600 ; N parenright ; B 117 -102 444 616 ;\r\nC 42 ; WX 600 ; N asterisk ; B 179 219 598 601 ;\r\nC 43 ; WX 600 ; N plus ; B 114 39 596 478 ;\r\nC 44 ; WX 600 ; N comma ; B 99 -111 430 174 ;\r\nC 45 ; WX 600 ; N hyphen ; B 143 203 567 313 ;\r\nC 46 ; WX 600 ; N period ; B 206 -15 427 171 ;\r\nC 47 ; WX 600 ; N slash ; B 90 -77 626 626 ;\r\nC 48 ; WX 600 ; N zero ; B 135 -15 593 616 ;\r\nC 49 ; WX 600 ; N one ; B 93 0 562 616 ;\r\nC 50 ; WX 600 ; N two ; B 61 0 594 616 ;\r\nC 51 ; WX 600 ; N three ; B 71 -15 571 616 ;\r\nC 52 ; WX 600 ; N four ; B 81 0 559 616 ;\r\nC 53 ; WX 600 ; N five ; B 77 -15 621 601 ;\r\nC 54 ; WX 600 ; N six ; B 135 -15 652 616 ;\r\nC 55 ; WX 600 ; N seven ; B 147 0 622 601 ;\r\nC 56 ; WX 600 ; N eight ; B 115 -15 604 616 ;\r\nC 57 ; WX 600 ; N nine ; B 75 -15 592 616 ;\r\nC 58 ; WX 600 ; N colon ; B 205 -15 480 425 ;\r\nC 59 ; WX 600 ; N semicolon ; B 99 -111 481 425 ;\r\nC 60 ; WX 600 ; N less ; B 120 15 613 501 ;\r\nC 61 ; WX 600 ; N equal ; B 96 118 614 398 ;\r\nC 62 ; WX 600 ; N greater ; B 97 15 589 501 ;\r\nC 63 ; WX 600 ; N question ; B 183 -14 592 580 ;\r\nC 64 ; WX 600 ; N at ; B 65 -15 642 616 ;\r\nC 65 ; WX 600 ; N A ; B -9 0 632 562 ;\r\nC 66 ; WX 600 ; N B ; B 30 0 630 562 ;\r\nC 67 ; WX 600 ; N C ; B 74 -18 675 580 ;\r\nC 68 ; WX 600 ; N D ; B 30 0 664 562 ;\r\nC 69 ; WX 600 ; N E ; B 25 0 670 562 ;\r\nC 70 ; WX 600 ; N F ; B 39 0 684 562 ;\r\nC 71 ; WX 600 ; N G ; B 74 -18 675 580 ;\r\nC 72 ; WX 600 ; N H ; B 20 0 700 562 ;\r\nC 73 ; WX 600 ; N I ; B 77 0 643 562 ;\r\nC 74 ; WX 600 ; N J ; B 58 -18 721 562 ;\r\nC 75 ; WX 600 ; N K ; B 21 0 692 562 ;\r\nC 76 ; WX 600 ; N L ; B 39 0 636 562 ;\r\nC 77 ; WX 600 ; N M ; B -2 0 722 562 ;\r\nC 78 ; WX 600 ; N N ; B 8 -12 730 562 ;\r\nC 79 ; WX 600 ; N O ; B 74 -18 645 580 ;\r\nC 80 ; WX 600 ; N P ; B 48 0 643 562 ;\r\nC 81 ; WX 600 ; N Q ; B 83 -138 636 580 ;\r\nC 82 ; WX 600 ; N R ; B 24 0 617 562 ;\r\nC 83 ; WX 600 ; N S ; B 54 -22 673 582 ;\r\nC 84 ; WX 600 ; N T ; B 86 0 679 562 ;\r\nC 85 ; WX 600 ; N U ; B 101 -18 716 562 ;\r\nC 86 ; WX 600 ; N V ; B 84 0 733 562 ;\r\nC 87 ; WX 600 ; N W ; B 79 0 738 562 ;\r\nC 88 ; WX 600 ; N X ; B 12 0 690 562 ;\r\nC 89 ; WX 600 ; N Y ; B 109 0 709 562 ;\r\nC 90 ; WX 600 ; N Z ; B 62 0 637 562 ;\r\nC 91 ; WX 600 ; N bracketleft ; B 223 -102 606 616 ;\r\nC 92 ; WX 600 ; N backslash ; B 222 -77 496 626 ;\r\nC 93 ; WX 600 ; N bracketright ; B 103 -102 486 616 ;\r\nC 94 ; WX 600 ; N asciicircum ; B 171 250 556 616 ;\r\nC 95 ; WX 600 ; N underscore ; B -27 -125 585 -75 ;\r\nC 96 ; WX 600 ; N quoteleft ; B 297 277 487 562 ;\r\nC 97 ; WX 600 ; N a ; B 61 -15 593 454 ;\r\nC 98 ; WX 600 ; N b ; B 13 -15 636 626 ;\r\nC 99 ; WX 600 ; N c ; B 81 -15 631 459 ;\r\nC 100 ; WX 600 ; N d ; B 60 -15 645 626 ;\r\nC 101 ; WX 600 ; N e ; B 81 -15 605 454 ;\r\nC 102 ; WX 600 ; N f ; B 83 0 677 626 ; L i fi ; L l fl ;\r\nC 103 ; WX 600 ; N g ; B 40 -146 674 454 ;\r\nC 104 ; WX 600 ; N h ; B 18 0 615 626 ;\r\nC 105 ; WX 600 ; N i ; B 77 0 546 658 ;\r\nC 106 ; WX 600 ; N j ; B 36 -146 580 658 ;\r\nC 107 ; WX 600 ; N k ; B 33 0 643 626 ;\r\nC 108 ; WX 600 ; N l ; B 77 0 546 626 ;\r\nC 109 ; WX 600 ; N m ; B -22 0 649 454 ;\r\nC 110 ; WX 600 ; N n ; B 18 0 615 454 ;\r\nC 111 ; WX 600 ; N o ; B 71 -15 622 454 ;\r\nC 112 ; WX 600 ; N p ; B -32 -142 622 454 ;\r\nC 113 ; WX 600 ; N q ; B 60 -142 685 454 ;\r\nC 114 ; WX 600 ; N r ; B 47 0 655 454 ;\r\nC 115 ; WX 600 ; N s ; B 66 -17 608 459 ;\r\nC 116 ; WX 600 ; N t ; B 118 -15 567 562 ;\r\nC 117 ; WX 600 ; N u ; B 70 -15 592 439 ;\r\nC 118 ; WX 600 ; N v ; B 70 0 695 439 ;\r\nC 119 ; WX 600 ; N w ; B 53 0 712 439 ;\r\nC 120 ; WX 600 ; N x ; B 6 0 671 439 ;\r\nC 121 ; WX 600 ; N y ; B -21 -142 695 439 ;\r\nC 122 ; WX 600 ; N z ; B 81 0 614 439 ;\r\nC 123 ; WX 600 ; N braceleft ; B 203 -102 595 616 ;\r\nC 124 ; WX 600 ; N bar ; B 201 -250 505 750 ;\r\nC 125 ; WX 600 ; N braceright ; B 114 -102 506 616 ;\r\nC 126 ; WX 600 ; N asciitilde ; B 120 153 590 356 ;\r\nC 161 ; WX 600 ; N exclamdown ; B 196 -146 477 449 ;\r\nC 162 ; WX 600 ; N cent ; B 121 -49 605 614 ;\r\nC 163 ; WX 600 ; N sterling ; B 106 -28 650 611 ;\r\nC 164 ; WX 600 ; N fraction ; B 22 -60 708 661 ;\r\nC 165 ; WX 600 ; N yen ; B 98 0 710 562 ;\r\nC 166 ; WX 600 ; N florin ; B -57 -131 702 616 ;\r\nC 167 ; WX 600 ; N section ; B 74 -70 620 580 ;\r\nC 168 ; WX 600 ; N currency ; B 77 49 644 517 ;\r\nC 169 ; WX 600 ; N quotesingle ; B 303 277 493 562 ;\r\nC 170 ; WX 600 ; N quotedblleft ; B 190 277 594 562 ;\r\nC 171 ; WX 600 ; N guillemotleft ; B 62 70 639 446 ;\r\nC 172 ; WX 600 ; N guilsinglleft ; B 195 70 545 446 ;\r\nC 173 ; WX 600 ; N guilsinglright ; B 165 70 514 446 ;\r\nC 174 ; WX 600 ; N fi ; B 12 0 644 626 ;\r\nC 175 ; WX 600 ; N fl ; B 12 0 644 626 ;\r\nC 177 ; WX 600 ; N endash ; B 108 203 602 313 ;\r\nC 178 ; WX 600 ; N dagger ; B 175 -70 586 580 ;\r\nC 179 ; WX 600 ; N daggerdbl ; B 121 -70 587 580 ;\r\nC 180 ; WX 600 ; N periodcentered ; B 248 165 461 351 ;\r\nC 182 ; WX 600 ; N paragraph ; B 61 -70 700 580 ;\r\nC 183 ; WX 600 ; N bullet ; B 196 132 523 430 ;\r\nC 184 ; WX 600 ; N quotesinglbase ; B 144 -142 458 143 ;\r\nC 185 ; WX 600 ; N quotedblbase ; B 34 -142 560 143 ;\r\nC 186 ; WX 600 ; N quotedblright ; B 119 277 645 562 ;\r\nC 187 ; WX 600 ; N guillemotright ; B 71 70 647 446 ;\r\nC 188 ; WX 600 ; N ellipsis ; B 35 -15 587 116 ;\r\nC 189 ; WX 600 ; N perthousand ; B -45 -15 743 616 ;\r\nC 191 ; WX 600 ; N questiondown ; B 100 -146 509 449 ;\r\nC 193 ; WX 600 ; N grave ; B 272 508 503 661 ;\r\nC 194 ; WX 600 ; N acute ; B 312 508 609 661 ;\r\nC 195 ; WX 600 ; N circumflex ; B 212 483 607 657 ;\r\nC 196 ; WX 600 ; N tilde ; B 199 493 643 636 ;\r\nC 197 ; WX 600 ; N macron ; B 195 505 637 585 ;\r\nC 198 ; WX 600 ; N breve ; B 217 468 652 631 ;\r\nC 199 ; WX 600 ; N dotaccent ; B 348 498 493 638 ;\r\nC 200 ; WX 600 ; N dieresis ; B 246 498 595 638 ;\r\nC 202 ; WX 600 ; N ring ; B 319 481 528 678 ;\r\nC 203 ; WX 600 ; N cedilla ; B 168 -206 368 0 ;\r\nC 205 ; WX 600 ; N hungarumlaut ; B 171 488 729 661 ;\r\nC 206 ; WX 600 ; N ogonek ; B 143 -199 367 0 ;\r\nC 207 ; WX 600 ; N caron ; B 238 493 633 667 ;\r\nC 208 ; WX 600 ; N emdash ; B 33 203 677 313 ;\r\nC 225 ; WX 600 ; N AE ; B -29 0 708 562 ;\r\nC 227 ; WX 600 ; N ordfeminine ; B 188 196 526 580 ;\r\nC 232 ; WX 600 ; N Lslash ; B 39 0 636 562 ;\r\nC 233 ; WX 600 ; N Oslash ; B 48 -22 673 584 ;\r\nC 234 ; WX 600 ; N OE ; B 26 0 701 562 ;\r\nC 235 ; WX 600 ; N ordmasculine ; B 188 196 543 580 ;\r\nC 241 ; WX 600 ; N ae ; B 21 -15 652 454 ;\r\nC 245 ; WX 600 ; N dotlessi ; B 77 0 546 439 ;\r\nC 248 ; WX 600 ; N lslash ; B 77 0 587 626 ;\r\nC 249 ; WX 600 ; N oslash ; B 54 -24 638 463 ;\r\nC 250 ; WX 600 ; N oe ; B 18 -15 662 454 ;\r\nC 251 ; WX 600 ; N germandbls ; B 22 -15 629 626 ;\r\nC -1 ; WX 600 ; N Idieresis ; B 77 0 643 761 ;\r\nC -1 ; WX 600 ; N eacute ; B 81 -15 609 661 ;\r\nC -1 ; WX 600 ; N abreve ; B 61 -15 658 661 ;\r\nC -1 ; WX 600 ; N uhungarumlaut ; B 70 -15 769 661 ;\r\nC -1 ; WX 600 ; N ecaron ; B 81 -15 633 667 ;\r\nC -1 ; WX 600 ; N Ydieresis ; B 109 0 709 761 ;\r\nC -1 ; WX 600 ; N divide ; B 114 16 596 500 ;\r\nC -1 ; WX 600 ; N Yacute ; B 109 0 709 784 ;\r\nC -1 ; WX 600 ; N Acircumflex ; B -9 0 632 780 ;\r\nC -1 ; WX 600 ; N aacute ; B 61 -15 609 661 ;\r\nC -1 ; WX 600 ; N Ucircumflex ; B 101 -18 716 780 ;\r\nC -1 ; WX 600 ; N yacute ; B -21 -142 695 661 ;\r\nC -1 ; WX 600 ; N scommaaccent ; B 66 -250 608 459 ;\r\nC -1 ; WX 600 ; N ecircumflex ; B 81 -15 607 657 ;\r\nC -1 ; WX 600 ; N Uring ; B 101 -18 716 801 ;\r\nC -1 ; WX 600 ; N Udieresis ; B 101 -18 716 761 ;\r\nC -1 ; WX 600 ; N aogonek ; B 61 -199 593 454 ;\r\nC -1 ; WX 600 ; N Uacute ; B 101 -18 716 784 ;\r\nC -1 ; WX 600 ; N uogonek ; B 70 -199 592 439 ;\r\nC -1 ; WX 600 ; N Edieresis ; B 25 0 670 761 ;\r\nC -1 ; WX 600 ; N Dcroat ; B 30 0 664 562 ;\r\nC -1 ; WX 600 ; N commaaccent ; B 151 -250 385 -57 ;\r\nC -1 ; WX 600 ; N copyright ; B 53 -18 667 580 ;\r\nC -1 ; WX 600 ; N Emacron ; B 25 0 670 708 ;\r\nC -1 ; WX 600 ; N ccaron ; B 81 -15 633 667 ;\r\nC -1 ; WX 600 ; N aring ; B 61 -15 593 678 ;\r\nC -1 ; WX 600 ; N Ncommaaccent ; B 8 -250 730 562 ;\r\nC -1 ; WX 600 ; N lacute ; B 77 0 639 801 ;\r\nC -1 ; WX 600 ; N agrave ; B 61 -15 593 661 ;\r\nC -1 ; WX 600 ; N Tcommaaccent ; B 86 -250 679 562 ;\r\nC -1 ; WX 600 ; N Cacute ; B 74 -18 675 784 ;\r\nC -1 ; WX 600 ; N atilde ; B 61 -15 643 636 ;\r\nC -1 ; WX 600 ; N Edotaccent ; B 25 0 670 761 ;\r\nC -1 ; WX 600 ; N scaron ; B 66 -17 633 667 ;\r\nC -1 ; WX 600 ; N scedilla ; B 66 -206 608 459 ;\r\nC -1 ; WX 600 ; N iacute ; B 77 0 609 661 ;\r\nC -1 ; WX 600 ; N lozenge ; B 145 0 614 740 ;\r\nC -1 ; WX 600 ; N Rcaron ; B 24 0 659 790 ;\r\nC -1 ; WX 600 ; N Gcommaaccent ; B 74 -250 675 580 ;\r\nC -1 ; WX 600 ; N ucircumflex ; B 70 -15 597 657 ;\r\nC -1 ; WX 600 ; N acircumflex ; B 61 -15 607 657 ;\r\nC -1 ; WX 600 ; N Amacron ; B -9 0 633 708 ;\r\nC -1 ; WX 600 ; N rcaron ; B 47 0 655 667 ;\r\nC -1 ; WX 600 ; N ccedilla ; B 81 -206 631 459 ;\r\nC -1 ; WX 600 ; N Zdotaccent ; B 62 0 637 761 ;\r\nC -1 ; WX 600 ; N Thorn ; B 48 0 620 562 ;\r\nC -1 ; WX 600 ; N Omacron ; B 74 -18 663 708 ;\r\nC -1 ; WX 600 ; N Racute ; B 24 0 665 784 ;\r\nC -1 ; WX 600 ; N Sacute ; B 54 -22 673 784 ;\r\nC -1 ; WX 600 ; N dcaron ; B 60 -15 861 626 ;\r\nC -1 ; WX 600 ; N Umacron ; B 101 -18 716 708 ;\r\nC -1 ; WX 600 ; N uring ; B 70 -15 592 678 ;\r\nC -1 ; WX 600 ; N threesuperior ; B 193 222 526 616 ;\r\nC -1 ; WX 600 ; N Ograve ; B 74 -18 645 784 ;\r\nC -1 ; WX 600 ; N Agrave ; B -9 0 632 784 ;\r\nC -1 ; WX 600 ; N Abreve ; B -9 0 684 784 ;\r\nC -1 ; WX 600 ; N multiply ; B 104 39 606 478 ;\r\nC -1 ; WX 600 ; N uacute ; B 70 -15 599 661 ;\r\nC -1 ; WX 600 ; N Tcaron ; B 86 0 679 790 ;\r\nC -1 ; WX 600 ; N partialdiff ; B 91 -38 627 728 ;\r\nC -1 ; WX 600 ; N ydieresis ; B -21 -142 695 638 ;\r\nC -1 ; WX 600 ; N Nacute ; B 8 -12 730 784 ;\r\nC -1 ; WX 600 ; N icircumflex ; B 77 0 577 657 ;\r\nC -1 ; WX 600 ; N Ecircumflex ; B 25 0 670 780 ;\r\nC -1 ; WX 600 ; N adieresis ; B 61 -15 595 638 ;\r\nC -1 ; WX 600 ; N edieresis ; B 81 -15 605 638 ;\r\nC -1 ; WX 600 ; N cacute ; B 81 -15 649 661 ;\r\nC -1 ; WX 600 ; N nacute ; B 18 0 639 661 ;\r\nC -1 ; WX 600 ; N umacron ; B 70 -15 637 585 ;\r\nC -1 ; WX 600 ; N Ncaron ; B 8 -12 730 790 ;\r\nC -1 ; WX 600 ; N Iacute ; B 77 0 643 784 ;\r\nC -1 ; WX 600 ; N plusminus ; B 76 24 614 515 ;\r\nC -1 ; WX 600 ; N brokenbar ; B 217 -175 489 675 ;\r\nC -1 ; WX 600 ; N registered ; B 53 -18 667 580 ;\r\nC -1 ; WX 600 ; N Gbreve ; B 74 -18 684 784 ;\r\nC -1 ; WX 600 ; N Idotaccent ; B 77 0 643 761 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 672 706 ;\r\nC -1 ; WX 600 ; N Egrave ; B 25 0 670 784 ;\r\nC -1 ; WX 600 ; N racute ; B 47 0 655 661 ;\r\nC -1 ; WX 600 ; N omacron ; B 71 -15 637 585 ;\r\nC -1 ; WX 600 ; N Zacute ; B 62 0 665 784 ;\r\nC -1 ; WX 600 ; N Zcaron ; B 62 0 659 790 ;\r\nC -1 ; WX 600 ; N greaterequal ; B 26 0 627 696 ;\r\nC -1 ; WX 600 ; N Eth ; B 30 0 664 562 ;\r\nC -1 ; WX 600 ; N Ccedilla ; B 74 -206 675 580 ;\r\nC -1 ; WX 600 ; N lcommaaccent ; B 77 -250 546 626 ;\r\nC -1 ; WX 600 ; N tcaron ; B 118 -15 627 703 ;\r\nC -1 ; WX 600 ; N eogonek ; B 81 -199 605 454 ;\r\nC -1 ; WX 600 ; N Uogonek ; B 101 -199 716 562 ;\r\nC -1 ; WX 600 ; N Aacute ; B -9 0 655 784 ;\r\nC -1 ; WX 600 ; N Adieresis ; B -9 0 632 761 ;\r\nC -1 ; WX 600 ; N egrave ; B 81 -15 605 661 ;\r\nC -1 ; WX 600 ; N zacute ; B 81 0 614 661 ;\r\nC -1 ; WX 600 ; N iogonek ; B 77 -199 546 658 ;\r\nC -1 ; WX 600 ; N Oacute ; B 74 -18 645 784 ;\r\nC -1 ; WX 600 ; N oacute ; B 71 -15 649 661 ;\r\nC -1 ; WX 600 ; N amacron ; B 61 -15 637 585 ;\r\nC -1 ; WX 600 ; N sacute ; B 66 -17 609 661 ;\r\nC -1 ; WX 600 ; N idieresis ; B 77 0 561 618 ;\r\nC -1 ; WX 600 ; N Ocircumflex ; B 74 -18 645 780 ;\r\nC -1 ; WX 600 ; N Ugrave ; B 101 -18 716 784 ;\r\nC -1 ; WX 600 ; N Delta ; B 6 0 594 688 ;\r\nC -1 ; WX 600 ; N thorn ; B -32 -142 622 626 ;\r\nC -1 ; WX 600 ; N twosuperior ; B 191 230 542 616 ;\r\nC -1 ; WX 600 ; N Odieresis ; B 74 -18 645 761 ;\r\nC -1 ; WX 600 ; N mu ; B 49 -142 592 439 ;\r\nC -1 ; WX 600 ; N igrave ; B 77 0 546 661 ;\r\nC -1 ; WX 600 ; N ohungarumlaut ; B 71 -15 809 661 ;\r\nC -1 ; WX 600 ; N Eogonek ; B 25 -199 670 562 ;\r\nC -1 ; WX 600 ; N dcroat ; B 60 -15 712 626 ;\r\nC -1 ; WX 600 ; N threequarters ; B 8 -60 699 661 ;\r\nC -1 ; WX 600 ; N Scedilla ; B 54 -206 673 582 ;\r\nC -1 ; WX 600 ; N lcaron ; B 77 0 731 626 ;\r\nC -1 ; WX 600 ; N Kcommaaccent ; B 21 -250 692 562 ;\r\nC -1 ; WX 600 ; N Lacute ; B 39 0 636 784 ;\r\nC -1 ; WX 600 ; N trademark ; B 86 230 869 562 ;\r\nC -1 ; WX 600 ; N edotaccent ; B 81 -15 605 638 ;\r\nC -1 ; WX 600 ; N Igrave ; B 77 0 643 784 ;\r\nC -1 ; WX 600 ; N Imacron ; B 77 0 663 708 ;\r\nC -1 ; WX 600 ; N Lcaron ; B 39 0 757 562 ;\r\nC -1 ; WX 600 ; N onehalf ; B 22 -60 716 661 ;\r\nC -1 ; WX 600 ; N lessequal ; B 26 0 671 696 ;\r\nC -1 ; WX 600 ; N ocircumflex ; B 71 -15 622 657 ;\r\nC -1 ; WX 600 ; N ntilde ; B 18 0 643 636 ;\r\nC -1 ; WX 600 ; N Uhungarumlaut ; B 101 -18 805 784 ;\r\nC -1 ; WX 600 ; N Eacute ; B 25 0 670 784 ;\r\nC -1 ; WX 600 ; N emacron ; B 81 -15 637 585 ;\r\nC -1 ; WX 600 ; N gbreve ; B 40 -146 674 661 ;\r\nC -1 ; WX 600 ; N onequarter ; B 13 -60 707 661 ;\r\nC -1 ; WX 600 ; N Scaron ; B 54 -22 689 790 ;\r\nC -1 ; WX 600 ; N Scommaaccent ; B 54 -250 673 582 ;\r\nC -1 ; WX 600 ; N Ohungarumlaut ; B 74 -18 795 784 ;\r\nC -1 ; WX 600 ; N degree ; B 173 243 570 616 ;\r\nC -1 ; WX 600 ; N ograve ; B 71 -15 622 661 ;\r\nC -1 ; WX 600 ; N Ccaron ; B 74 -18 689 790 ;\r\nC -1 ; WX 600 ; N ugrave ; B 70 -15 592 661 ;\r\nC -1 ; WX 600 ; N radical ; B 67 -104 635 778 ;\r\nC -1 ; WX 600 ; N Dcaron ; B 30 0 664 790 ;\r\nC -1 ; WX 600 ; N rcommaaccent ; B 47 -250 655 454 ;\r\nC -1 ; WX 600 ; N Ntilde ; B 8 -12 730 759 ;\r\nC -1 ; WX 600 ; N otilde ; B 71 -15 643 636 ;\r\nC -1 ; WX 600 ; N Rcommaaccent ; B 24 -250 617 562 ;\r\nC -1 ; WX 600 ; N Lcommaaccent ; B 39 -250 636 562 ;\r\nC -1 ; WX 600 ; N Atilde ; B -9 0 669 759 ;\r\nC -1 ; WX 600 ; N Aogonek ; B -9 -199 632 562 ;\r\nC -1 ; WX 600 ; N Aring ; B -9 0 632 801 ;\r\nC -1 ; WX 600 ; N Otilde ; B 74 -18 669 759 ;\r\nC -1 ; WX 600 ; N zdotaccent ; B 81 0 614 638 ;\r\nC -1 ; WX 600 ; N Ecaron ; B 25 0 670 790 ;\r\nC -1 ; WX 600 ; N Iogonek ; B 77 -199 643 562 ;\r\nC -1 ; WX 600 ; N kcommaaccent ; B 33 -250 643 626 ;\r\nC -1 ; WX 600 ; N minus ; B 114 203 596 313 ;\r\nC -1 ; WX 600 ; N Icircumflex ; B 77 0 643 780 ;\r\nC -1 ; WX 600 ; N ncaron ; B 18 0 633 667 ;\r\nC -1 ; WX 600 ; N tcommaaccent ; B 118 -250 567 562 ;\r\nC -1 ; WX 600 ; N logicalnot ; B 135 103 617 413 ;\r\nC -1 ; WX 600 ; N odieresis ; B 71 -15 622 638 ;\r\nC -1 ; WX 600 ; N udieresis ; B 70 -15 595 638 ;\r\nC -1 ; WX 600 ; N notequal ; B 30 -47 626 563 ;\r\nC -1 ; WX 600 ; N gcommaaccent ; B 40 -146 674 714 ;\r\nC -1 ; WX 600 ; N eth ; B 93 -27 661 626 ;\r\nC -1 ; WX 600 ; N zcaron ; B 81 0 643 667 ;\r\nC -1 ; WX 600 ; N ncommaaccent ; B 18 -250 615 454 ;\r\nC -1 ; WX 600 ; N onesuperior ; B 212 230 514 616 ;\r\nC -1 ; WX 600 ; N imacron ; B 77 0 575 585 ;\r\nC -1 ; WX 600 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
  
                  Helvetica() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:38:23 1997\r\nComment UniqueID 43054\r\nComment VMusage 37069 48094\r\nFontName Helvetica\r\nFullName Helvetica\r\nFamilyName Helvetica\r\nWeight Medium\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -166 -225 1000 931 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 718\r\nXHeight 523\r\nAscender 718\r\nDescender -207\r\nStdHW 76\r\nStdVW 88\r\nStartCharMetrics 315\r\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 278 ; N exclam ; B 90 0 187 718 ;\r\nC 34 ; WX 355 ; N quotedbl ; B 70 463 285 718 ;\r\nC 35 ; WX 556 ; N numbersign ; B 28 0 529 688 ;\r\nC 36 ; WX 556 ; N dollar ; B 32 -115 520 775 ;\r\nC 37 ; WX 889 ; N percent ; B 39 -19 850 703 ;\r\nC 38 ; WX 667 ; N ampersand ; B 44 -15 645 718 ;\r\nC 39 ; WX 222 ; N quoteright ; B 53 463 157 718 ;\r\nC 40 ; WX 333 ; N parenleft ; B 68 -207 299 733 ;\r\nC 41 ; WX 333 ; N parenright ; B 34 -207 265 733 ;\r\nC 42 ; WX 389 ; N asterisk ; B 39 431 349 718 ;\r\nC 43 ; WX 584 ; N plus ; B 39 0 545 505 ;\r\nC 44 ; WX 278 ; N comma ; B 87 -147 191 106 ;\r\nC 45 ; WX 333 ; N hyphen ; B 44 232 289 322 ;\r\nC 46 ; WX 278 ; N period ; B 87 0 191 106 ;\r\nC 47 ; WX 278 ; N slash ; B -17 -19 295 737 ;\r\nC 48 ; WX 556 ; N zero ; B 37 -19 519 703 ;\r\nC 49 ; WX 556 ; N one ; B 101 0 359 703 ;\r\nC 50 ; WX 556 ; N two ; B 26 0 507 703 ;\r\nC 51 ; WX 556 ; N three ; B 34 -19 522 703 ;\r\nC 52 ; WX 556 ; N four ; B 25 0 523 703 ;\r\nC 53 ; WX 556 ; N five ; B 32 -19 514 688 ;\r\nC 54 ; WX 556 ; N six ; B 38 -19 518 703 ;\r\nC 55 ; WX 556 ; N seven ; B 37 0 523 688 ;\r\nC 56 ; WX 556 ; N eight ; B 38 -19 517 703 ;\r\nC 57 ; WX 556 ; N nine ; B 42 -19 514 703 ;\r\nC 58 ; WX 278 ; N colon ; B 87 0 191 516 ;\r\nC 59 ; WX 278 ; N semicolon ; B 87 -147 191 516 ;\r\nC 60 ; WX 584 ; N less ; B 48 11 536 495 ;\r\nC 61 ; WX 584 ; N equal ; B 39 115 545 390 ;\r\nC 62 ; WX 584 ; N greater ; B 48 11 536 495 ;\r\nC 63 ; WX 556 ; N question ; B 56 0 492 727 ;\r\nC 64 ; WX 1015 ; N at ; B 147 -19 868 737 ;\r\nC 65 ; WX 667 ; N A ; B 14 0 654 718 ;\r\nC 66 ; WX 667 ; N B ; B 74 0 627 718 ;\r\nC 67 ; WX 722 ; N C ; B 44 -19 681 737 ;\r\nC 68 ; WX 722 ; N D ; B 81 0 674 718 ;\r\nC 69 ; WX 667 ; N E ; B 86 0 616 718 ;\r\nC 70 ; WX 611 ; N F ; B 86 0 583 718 ;\r\nC 71 ; WX 778 ; N G ; B 48 -19 704 737 ;\r\nC 72 ; WX 722 ; N H ; B 77 0 646 718 ;\r\nC 73 ; WX 278 ; N I ; B 91 0 188 718 ;\r\nC 74 ; WX 500 ; N J ; B 17 -19 428 718 ;\r\nC 75 ; WX 667 ; N K ; B 76 0 663 718 ;\r\nC 76 ; WX 556 ; N L ; B 76 0 537 718 ;\r\nC 77 ; WX 833 ; N M ; B 73 0 761 718 ;\r\nC 78 ; WX 722 ; N N ; B 76 0 646 718 ;\r\nC 79 ; WX 778 ; N O ; B 39 -19 739 737 ;\r\nC 80 ; WX 667 ; N P ; B 86 0 622 718 ;\r\nC 81 ; WX 778 ; N Q ; B 39 -56 739 737 ;\r\nC 82 ; WX 722 ; N R ; B 88 0 684 718 ;\r\nC 83 ; WX 667 ; N S ; B 49 -19 620 737 ;\r\nC 84 ; WX 611 ; N T ; B 14 0 597 718 ;\r\nC 85 ; WX 722 ; N U ; B 79 -19 644 718 ;\r\nC 86 ; WX 667 ; N V ; B 20 0 647 718 ;\r\nC 87 ; WX 944 ; N W ; B 16 0 928 718 ;\r\nC 88 ; WX 667 ; N X ; B 19 0 648 718 ;\r\nC 89 ; WX 667 ; N Y ; B 14 0 653 718 ;\r\nC 90 ; WX 611 ; N Z ; B 23 0 588 718 ;\r\nC 91 ; WX 278 ; N bracketleft ; B 63 -196 250 722 ;\r\nC 92 ; WX 278 ; N backslash ; B -17 -19 295 737 ;\r\nC 93 ; WX 278 ; N bracketright ; B 28 -196 215 722 ;\r\nC 94 ; WX 469 ; N asciicircum ; B -14 264 483 688 ;\r\nC 95 ; WX 556 ; N underscore ; B 0 -125 556 -75 ;\r\nC 96 ; WX 222 ; N quoteleft ; B 65 470 169 725 ;\r\nC 97 ; WX 556 ; N a ; B 36 -15 530 538 ;\r\nC 98 ; WX 556 ; N b ; B 58 -15 517 718 ;\r\nC 99 ; WX 500 ; N c ; B 30 -15 477 538 ;\r\nC 100 ; WX 556 ; N d ; B 35 -15 499 718 ;\r\nC 101 ; WX 556 ; N e ; B 40 -15 516 538 ;\r\nC 102 ; WX 278 ; N f ; B 14 0 262 728 ; L i fi ; L l fl ;\r\nC 103 ; WX 556 ; N g ; B 40 -220 499 538 ;\r\nC 104 ; WX 556 ; N h ; B 65 0 491 718 ;\r\nC 105 ; WX 222 ; N i ; B 67 0 155 718 ;\r\nC 106 ; WX 222 ; N j ; B -16 -210 155 718 ;\r\nC 107 ; WX 500 ; N k ; B 67 0 501 718 ;\r\nC 108 ; WX 222 ; N l ; B 67 0 155 718 ;\r\nC 109 ; WX 833 ; N m ; B 65 0 769 538 ;\r\nC 110 ; WX 556 ; N n ; B 65 0 491 538 ;\r\nC 111 ; WX 556 ; N o ; B 35 -14 521 538 ;\r\nC 112 ; WX 556 ; N p ; B 58 -207 517 538 ;\r\nC 113 ; WX 556 ; N q ; B 35 -207 494 538 ;\r\nC 114 ; WX 333 ; N r ; B 77 0 332 538 ;\r\nC 115 ; WX 500 ; N s ; B 32 -15 464 538 ;\r\nC 116 ; WX 278 ; N t ; B 14 -7 257 669 ;\r\nC 117 ; WX 556 ; N u ; B 68 -15 489 523 ;\r\nC 118 ; WX 500 ; N v ; B 8 0 492 523 ;\r\nC 119 ; WX 722 ; N w ; B 14 0 709 523 ;\r\nC 120 ; WX 500 ; N x ; B 11 0 490 523 ;\r\nC 121 ; WX 500 ; N y ; B 11 -214 489 523 ;\r\nC 122 ; WX 500 ; N z ; B 31 0 469 523 ;\r\nC 123 ; WX 334 ; N braceleft ; B 42 -196 292 722 ;\r\nC 124 ; WX 260 ; N bar ; B 94 -225 167 775 ;\r\nC 125 ; WX 334 ; N braceright ; B 42 -196 292 722 ;\r\nC 126 ; WX 584 ; N asciitilde ; B 61 180 523 326 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 118 -195 215 523 ;\r\nC 162 ; WX 556 ; N cent ; B 51 -115 513 623 ;\r\nC 163 ; WX 556 ; N sterling ; B 33 -16 539 718 ;\r\nC 164 ; WX 167 ; N fraction ; B -166 -19 333 703 ;\r\nC 165 ; WX 556 ; N yen ; B 3 0 553 688 ;\r\nC 166 ; WX 556 ; N florin ; B -11 -207 501 737 ;\r\nC 167 ; WX 556 ; N section ; B 43 -191 512 737 ;\r\nC 168 ; WX 556 ; N currency ; B 28 99 528 603 ;\r\nC 169 ; WX 191 ; N quotesingle ; B 59 463 132 718 ;\r\nC 170 ; WX 333 ; N quotedblleft ; B 38 470 307 725 ;\r\nC 171 ; WX 556 ; N guillemotleft ; B 97 108 459 446 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 88 108 245 446 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 88 108 245 446 ;\r\nC 174 ; WX 500 ; N fi ; B 14 0 434 728 ;\r\nC 175 ; WX 500 ; N fl ; B 14 0 432 728 ;\r\nC 177 ; WX 556 ; N endash ; B 0 240 556 313 ;\r\nC 178 ; WX 556 ; N dagger ; B 43 -159 514 718 ;\r\nC 179 ; WX 556 ; N daggerdbl ; B 43 -159 514 718 ;\r\nC 180 ; WX 278 ; N periodcentered ; B 77 190 202 315 ;\r\nC 182 ; WX 537 ; N paragraph ; B 18 -173 497 718 ;\r\nC 183 ; WX 350 ; N bullet ; B 18 202 333 517 ;\r\nC 184 ; WX 222 ; N quotesinglbase ; B 53 -149 157 106 ;\r\nC 185 ; WX 333 ; N quotedblbase ; B 26 -149 295 106 ;\r\nC 186 ; WX 333 ; N quotedblright ; B 26 463 295 718 ;\r\nC 187 ; WX 556 ; N guillemotright ; B 97 108 459 446 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 115 0 885 106 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 7 -19 994 703 ;\r\nC 191 ; WX 611 ; N questiondown ; B 91 -201 527 525 ;\r\nC 193 ; WX 333 ; N grave ; B 14 593 211 734 ;\r\nC 194 ; WX 333 ; N acute ; B 122 593 319 734 ;\r\nC 195 ; WX 333 ; N circumflex ; B 21 593 312 734 ;\r\nC 196 ; WX 333 ; N tilde ; B -4 606 337 722 ;\r\nC 197 ; WX 333 ; N macron ; B 10 627 323 684 ;\r\nC 198 ; WX 333 ; N breve ; B 13 595 321 731 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 121 604 212 706 ;\r\nC 200 ; WX 333 ; N dieresis ; B 40 604 293 706 ;\r\nC 202 ; WX 333 ; N ring ; B 75 572 259 756 ;\r\nC 203 ; WX 333 ; N cedilla ; B 45 -225 259 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 31 593 409 734 ;\r\nC 206 ; WX 333 ; N ogonek ; B 73 -225 287 0 ;\r\nC 207 ; WX 333 ; N caron ; B 21 593 312 734 ;\r\nC 208 ; WX 1000 ; N emdash ; B 0 240 1000 313 ;\r\nC 225 ; WX 1000 ; N AE ; B 8 0 951 718 ;\r\nC 227 ; WX 370 ; N ordfeminine ; B 24 405 346 737 ;\r\nC 232 ; WX 556 ; N Lslash ; B -20 0 537 718 ;\r\nC 233 ; WX 778 ; N Oslash ; B 39 -19 740 737 ;\r\nC 234 ; WX 1000 ; N OE ; B 36 -19 965 737 ;\r\nC 235 ; WX 365 ; N ordmasculine ; B 25 405 341 737 ;\r\nC 241 ; WX 889 ; N ae ; B 36 -15 847 538 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 95 0 183 523 ;\r\nC 248 ; WX 222 ; N lslash ; B -20 0 242 718 ;\r\nC 249 ; WX 611 ; N oslash ; B 28 -22 537 545 ;\r\nC 250 ; WX 944 ; N oe ; B 35 -15 902 538 ;\r\nC 251 ; WX 611 ; N germandbls ; B 67 -15 571 728 ;\r\nC -1 ; WX 278 ; N Idieresis ; B 13 0 266 901 ;\r\nC -1 ; WX 556 ; N eacute ; B 40 -15 516 734 ;\r\nC -1 ; WX 556 ; N abreve ; B 36 -15 530 731 ;\r\nC -1 ; WX 556 ; N uhungarumlaut ; B 68 -15 521 734 ;\r\nC -1 ; WX 556 ; N ecaron ; B 40 -15 516 734 ;\r\nC -1 ; WX 667 ; N Ydieresis ; B 14 0 653 901 ;\r\nC -1 ; WX 584 ; N divide ; B 39 -19 545 524 ;\r\nC -1 ; WX 667 ; N Yacute ; B 14 0 653 929 ;\r\nC -1 ; WX 667 ; N Acircumflex ; B 14 0 654 929 ;\r\nC -1 ; WX 556 ; N aacute ; B 36 -15 530 734 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 79 -19 644 929 ;\r\nC -1 ; WX 500 ; N yacute ; B 11 -214 489 734 ;\r\nC -1 ; WX 500 ; N scommaaccent ; B 32 -225 464 538 ;\r\nC -1 ; WX 556 ; N ecircumflex ; B 40 -15 516 734 ;\r\nC -1 ; WX 722 ; N Uring ; B 79 -19 644 931 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 79 -19 644 901 ;\r\nC -1 ; WX 556 ; N aogonek ; B 36 -220 547 538 ;\r\nC -1 ; WX 722 ; N Uacute ; B 79 -19 644 929 ;\r\nC -1 ; WX 556 ; N uogonek ; B 68 -225 519 523 ;\r\nC -1 ; WX 667 ; N Edieresis ; B 86 0 616 901 ;\r\nC -1 ; WX 722 ; N Dcroat ; B 0 0 674 718 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 87 -225 181 -40 ;\r\nC -1 ; WX 737 ; N copyright ; B -14 -19 752 737 ;\r\nC -1 ; WX 667 ; N Emacron ; B 86 0 616 879 ;\r\nC -1 ; WX 500 ; N ccaron ; B 30 -15 477 734 ;\r\nC -1 ; WX 556 ; N aring ; B 36 -15 530 756 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 76 -225 646 718 ;\r\nC -1 ; WX 222 ; N lacute ; B 67 0 264 929 ;\r\nC -1 ; WX 556 ; N agrave ; B 36 -15 530 734 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 14 -225 597 718 ;\r\nC -1 ; WX 722 ; N Cacute ; B 44 -19 681 929 ;\r\nC -1 ; WX 556 ; N atilde ; B 36 -15 530 722 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B 86 0 616 901 ;\r\nC -1 ; WX 500 ; N scaron ; B 32 -15 464 734 ;\r\nC -1 ; WX 500 ; N scedilla ; B 32 -225 464 538 ;\r\nC -1 ; WX 278 ; N iacute ; B 95 0 292 734 ;\r\nC -1 ; WX 471 ; N lozenge ; B 10 0 462 728 ;\r\nC -1 ; WX 722 ; N Rcaron ; B 88 0 684 929 ;\r\nC -1 ; WX 778 ; N Gcommaaccent ; B 48 -225 704 737 ;\r\nC -1 ; WX 556 ; N ucircumflex ; B 68 -15 489 734 ;\r\nC -1 ; WX 556 ; N acircumflex ; B 36 -15 530 734 ;\r\nC -1 ; WX 667 ; N Amacron ; B 14 0 654 879 ;\r\nC -1 ; WX 333 ; N rcaron ; B 61 0 352 734 ;\r\nC -1 ; WX 500 ; N ccedilla ; B 30 -225 477 538 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B 23 0 588 901 ;\r\nC -1 ; WX 667 ; N Thorn ; B 86 0 622 718 ;\r\nC -1 ; WX 778 ; N Omacron ; B 39 -19 739 879 ;\r\nC -1 ; WX 722 ; N Racute ; B 88 0 684 929 ;\r\nC -1 ; WX 667 ; N Sacute ; B 49 -19 620 929 ;\r\nC -1 ; WX 643 ; N dcaron ; B 35 -15 655 718 ;\r\nC -1 ; WX 722 ; N Umacron ; B 79 -19 644 879 ;\r\nC -1 ; WX 556 ; N uring ; B 68 -15 489 756 ;\r\nC -1 ; WX 333 ; N threesuperior ; B 5 270 325 703 ;\r\nC -1 ; WX 778 ; N Ograve ; B 39 -19 739 929 ;\r\nC -1 ; WX 667 ; N Agrave ; B 14 0 654 929 ;\r\nC -1 ; WX 667 ; N Abreve ; B 14 0 654 926 ;\r\nC -1 ; WX 584 ; N multiply ; B 39 0 545 506 ;\r\nC -1 ; WX 556 ; N uacute ; B 68 -15 489 734 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 14 0 597 929 ;\r\nC -1 ; WX 476 ; N partialdiff ; B 13 -38 463 714 ;\r\nC -1 ; WX 500 ; N ydieresis ; B 11 -214 489 706 ;\r\nC -1 ; WX 722 ; N Nacute ; B 76 0 646 929 ;\r\nC -1 ; WX 278 ; N icircumflex ; B -6 0 285 734 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B 86 0 616 929 ;\r\nC -1 ; WX 556 ; N adieresis ; B 36 -15 530 706 ;\r\nC -1 ; WX 556 ; N edieresis ; B 40 -15 516 706 ;\r\nC -1 ; WX 500 ; N cacute ; B 30 -15 477 734 ;\r\nC -1 ; WX 556 ; N nacute ; B 65 0 491 734 ;\r\nC -1 ; WX 556 ; N umacron ; B 68 -15 489 684 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 76 0 646 929 ;\r\nC -1 ; WX 278 ; N Iacute ; B 91 0 292 929 ;\r\nC -1 ; WX 584 ; N plusminus ; B 39 0 545 506 ;\r\nC -1 ; WX 260 ; N brokenbar ; B 94 -150 167 700 ;\r\nC -1 ; WX 737 ; N registered ; B -14 -19 752 737 ;\r\nC -1 ; WX 778 ; N Gbreve ; B 48 -19 704 926 ;\r\nC -1 ; WX 278 ; N Idotaccent ; B 91 0 188 901 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 586 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B 86 0 616 929 ;\r\nC -1 ; WX 333 ; N racute ; B 77 0 332 734 ;\r\nC -1 ; WX 556 ; N omacron ; B 35 -14 521 684 ;\r\nC -1 ; WX 611 ; N Zacute ; B 23 0 588 929 ;\r\nC -1 ; WX 611 ; N Zcaron ; B 23 0 588 929 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 674 ;\r\nC -1 ; WX 722 ; N Eth ; B 0 0 674 718 ;\r\nC -1 ; WX 722 ; N Ccedilla ; B 44 -225 681 737 ;\r\nC -1 ; WX 222 ; N lcommaaccent ; B 67 -225 167 718 ;\r\nC -1 ; WX 317 ; N tcaron ; B 14 -7 329 808 ;\r\nC -1 ; WX 556 ; N eogonek ; B 40 -225 516 538 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 79 -225 644 718 ;\r\nC -1 ; WX 667 ; N Aacute ; B 14 0 654 929 ;\r\nC -1 ; WX 667 ; N Adieresis ; B 14 0 654 901 ;\r\nC -1 ; WX 556 ; N egrave ; B 40 -15 516 734 ;\r\nC -1 ; WX 500 ; N zacute ; B 31 0 469 734 ;\r\nC -1 ; WX 222 ; N iogonek ; B -31 -225 183 718 ;\r\nC -1 ; WX 778 ; N Oacute ; B 39 -19 739 929 ;\r\nC -1 ; WX 556 ; N oacute ; B 35 -14 521 734 ;\r\nC -1 ; WX 556 ; N amacron ; B 36 -15 530 684 ;\r\nC -1 ; WX 500 ; N sacute ; B 32 -15 464 734 ;\r\nC -1 ; WX 278 ; N idieresis ; B 13 0 266 706 ;\r\nC -1 ; WX 778 ; N Ocircumflex ; B 39 -19 739 929 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 79 -19 644 929 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 556 ; N thorn ; B 58 -207 517 718 ;\r\nC -1 ; WX 333 ; N twosuperior ; B 4 281 323 703 ;\r\nC -1 ; WX 778 ; N Odieresis ; B 39 -19 739 901 ;\r\nC -1 ; WX 556 ; N mu ; B 68 -207 489 523 ;\r\nC -1 ; WX 278 ; N igrave ; B -13 0 184 734 ;\r\nC -1 ; WX 556 ; N ohungarumlaut ; B 35 -14 521 734 ;\r\nC -1 ; WX 667 ; N Eogonek ; B 86 -220 633 718 ;\r\nC -1 ; WX 556 ; N dcroat ; B 35 -15 550 718 ;\r\nC -1 ; WX 834 ; N threequarters ; B 45 -19 810 703 ;\r\nC -1 ; WX 667 ; N Scedilla ; B 49 -225 620 737 ;\r\nC -1 ; WX 299 ; N lcaron ; B 67 0 311 718 ;\r\nC -1 ; WX 667 ; N Kcommaaccent ; B 76 -225 663 718 ;\r\nC -1 ; WX 556 ; N Lacute ; B 76 0 537 929 ;\r\nC -1 ; WX 1000 ; N trademark ; B 46 306 903 718 ;\r\nC -1 ; WX 556 ; N edotaccent ; B 40 -15 516 706 ;\r\nC -1 ; WX 278 ; N Igrave ; B -13 0 188 929 ;\r\nC -1 ; WX 278 ; N Imacron ; B -17 0 296 879 ;\r\nC -1 ; WX 556 ; N Lcaron ; B 76 0 537 718 ;\r\nC -1 ; WX 834 ; N onehalf ; B 43 -19 773 703 ;\r\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 674 ;\r\nC -1 ; WX 556 ; N ocircumflex ; B 35 -14 521 734 ;\r\nC -1 ; WX 556 ; N ntilde ; B 65 0 491 722 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 79 -19 644 929 ;\r\nC -1 ; WX 667 ; N Eacute ; B 86 0 616 929 ;\r\nC -1 ; WX 556 ; N emacron ; B 40 -15 516 684 ;\r\nC -1 ; WX 556 ; N gbreve ; B 40 -220 499 731 ;\r\nC -1 ; WX 834 ; N onequarter ; B 73 -19 756 703 ;\r\nC -1 ; WX 667 ; N Scaron ; B 49 -19 620 929 ;\r\nC -1 ; WX 667 ; N Scommaaccent ; B 49 -225 620 737 ;\r\nC -1 ; WX 778 ; N Ohungarumlaut ; B 39 -19 739 929 ;\r\nC -1 ; WX 400 ; N degree ; B 54 411 346 703 ;\r\nC -1 ; WX 556 ; N ograve ; B 35 -14 521 734 ;\r\nC -1 ; WX 722 ; N Ccaron ; B 44 -19 681 929 ;\r\nC -1 ; WX 556 ; N ugrave ; B 68 -15 489 734 ;\r\nC -1 ; WX 453 ; N radical ; B -4 -80 458 762 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 81 0 674 929 ;\r\nC -1 ; WX 333 ; N rcommaaccent ; B 77 -225 332 538 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 76 0 646 917 ;\r\nC -1 ; WX 556 ; N otilde ; B 35 -14 521 722 ;\r\nC -1 ; WX 722 ; N Rcommaaccent ; B 88 -225 684 718 ;\r\nC -1 ; WX 556 ; N Lcommaaccent ; B 76 -225 537 718 ;\r\nC -1 ; WX 667 ; N Atilde ; B 14 0 654 917 ;\r\nC -1 ; WX 667 ; N Aogonek ; B 14 -225 654 718 ;\r\nC -1 ; WX 667 ; N Aring ; B 14 0 654 931 ;\r\nC -1 ; WX 778 ; N Otilde ; B 39 -19 739 917 ;\r\nC -1 ; WX 500 ; N zdotaccent ; B 31 0 469 706 ;\r\nC -1 ; WX 667 ; N Ecaron ; B 86 0 616 929 ;\r\nC -1 ; WX 278 ; N Iogonek ; B -3 -225 211 718 ;\r\nC -1 ; WX 500 ; N kcommaaccent ; B 67 -225 501 718 ;\r\nC -1 ; WX 584 ; N minus ; B 39 216 545 289 ;\r\nC -1 ; WX 278 ; N Icircumflex ; B -6 0 285 929 ;\r\nC -1 ; WX 556 ; N ncaron ; B 65 0 491 734 ;\r\nC -1 ; WX 278 ; N tcommaaccent ; B 14 -225 257 669 ;\r\nC -1 ; WX 584 ; N logicalnot ; B 39 108 545 390 ;\r\nC -1 ; WX 556 ; N odieresis ; B 35 -14 521 706 ;\r\nC -1 ; WX 556 ; N udieresis ; B 68 -15 489 706 ;\r\nC -1 ; WX 549 ; N notequal ; B 12 -35 537 551 ;\r\nC -1 ; WX 556 ; N gcommaaccent ; B 40 -220 499 822 ;\r\nC -1 ; WX 556 ; N eth ; B 35 -15 522 737 ;\r\nC -1 ; WX 500 ; N zcaron ; B 31 0 469 734 ;\r\nC -1 ; WX 556 ; N ncommaaccent ; B 65 -225 491 538 ;\r\nC -1 ; WX 333 ; N onesuperior ; B 43 281 222 703 ;\r\nC -1 ; WX 278 ; N imacron ; B 5 0 272 684 ;\r\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2705\r\nKPX A C -30\r\nKPX A Cacute -30\r\nKPX A Ccaron -30\r\nKPX A Ccedilla -30\r\nKPX A G -30\r\nKPX A Gbreve -30\r\nKPX A Gcommaaccent -30\r\nKPX A O -30\r\nKPX A Oacute -30\r\nKPX A Ocircumflex -30\r\nKPX A Odieresis -30\r\nKPX A Ograve -30\r\nKPX A Ohungarumlaut -30\r\nKPX A Omacron -30\r\nKPX A Oslash -30\r\nKPX A Otilde -30\r\nKPX A Q -30\r\nKPX A T -120\r\nKPX A Tcaron -120\r\nKPX A Tcommaaccent -120\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -70\r\nKPX A W -50\r\nKPX A Y -100\r\nKPX A Yacute -100\r\nKPX A Ydieresis -100\r\nKPX A u -30\r\nKPX A uacute -30\r\nKPX A ucircumflex -30\r\nKPX A udieresis -30\r\nKPX A ugrave -30\r\nKPX A uhungarumlaut -30\r\nKPX A umacron -30\r\nKPX A uogonek -30\r\nKPX A uring -30\r\nKPX A v -40\r\nKPX A w -40\r\nKPX A y -40\r\nKPX A yacute -40\r\nKPX A ydieresis -40\r\nKPX Aacute C -30\r\nKPX Aacute Cacute -30\r\nKPX Aacute Ccaron -30\r\nKPX Aacute Ccedilla -30\r\nKPX Aacute G -30\r\nKPX Aacute Gbreve -30\r\nKPX Aacute Gcommaaccent -30\r\nKPX Aacute O -30\r\nKPX Aacute Oacute -30\r\nKPX Aacute Ocircumflex -30\r\nKPX Aacute Odieresis -30\r\nKPX Aacute Ograve -30\r\nKPX Aacute Ohungarumlaut -30\r\nKPX Aacute Omacron -30\r\nKPX Aacute Oslash -30\r\nKPX Aacute Otilde -30\r\nKPX Aacute Q -30\r\nKPX Aacute T -120\r\nKPX Aacute Tcaron -120\r\nKPX Aacute Tcommaaccent -120\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -70\r\nKPX Aacute W -50\r\nKPX Aacute Y -100\r\nKPX Aacute Yacute -100\r\nKPX Aacute Ydieresis -100\r\nKPX Aacute u -30\r\nKPX Aacute uacute -30\r\nKPX Aacute ucircumflex -30\r\nKPX Aacute udieresis -30\r\nKPX Aacute ugrave -30\r\nKPX Aacute uhungarumlaut -30\r\nKPX Aacute umacron -30\r\nKPX Aacute uogonek -30\r\nKPX Aacute uring -30\r\nKPX Aacute v -40\r\nKPX Aacute w -40\r\nKPX Aacute y -40\r\nKPX Aacute yacute -40\r\nKPX Aacute ydieresis -40\r\nKPX Abreve C -30\r\nKPX Abreve Cacute -30\r\nKPX Abreve Ccaron -30\r\nKPX Abreve Ccedilla -30\r\nKPX Abreve G -30\r\nKPX Abreve Gbreve -30\r\nKPX Abreve Gcommaaccent -30\r\nKPX Abreve O -30\r\nKPX Abreve Oacute -30\r\nKPX Abreve Ocircumflex -30\r\nKPX Abreve Odieresis -30\r\nKPX Abreve Ograve -30\r\nKPX Abreve Ohungarumlaut -30\r\nKPX Abreve Omacron -30\r\nKPX Abreve Oslash -30\r\nKPX Abreve Otilde -30\r\nKPX Abreve Q -30\r\nKPX Abreve T -120\r\nKPX Abreve Tcaron -120\r\nKPX Abreve Tcommaaccent -120\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -70\r\nKPX Abreve W -50\r\nKPX Abreve Y -100\r\nKPX Abreve Yacute -100\r\nKPX Abreve Ydieresis -100\r\nKPX Abreve u -30\r\nKPX Abreve uacute -30\r\nKPX Abreve ucircumflex -30\r\nKPX Abreve udieresis -30\r\nKPX Abreve ugrave -30\r\nKPX Abreve uhungarumlaut -30\r\nKPX Abreve umacron -30\r\nKPX Abreve uogonek -30\r\nKPX Abreve uring -30\r\nKPX Abreve v -40\r\nKPX Abreve w -40\r\nKPX Abreve y -40\r\nKPX Abreve yacute -40\r\nKPX Abreve ydieresis -40\r\nKPX Acircumflex C -30\r\nKPX Acircumflex Cacute -30\r\nKPX Acircumflex Ccaron -30\r\nKPX Acircumflex Ccedilla -30\r\nKPX Acircumflex G -30\r\nKPX Acircumflex Gbreve -30\r\nKPX Acircumflex Gcommaaccent -30\r\nKPX Acircumflex O -30\r\nKPX Acircumflex Oacute -30\r\nKPX Acircumflex Ocircumflex -30\r\nKPX Acircumflex Odieresis -30\r\nKPX Acircumflex Ograve -30\r\nKPX Acircumflex Ohungarumlaut -30\r\nKPX Acircumflex Omacron -30\r\nKPX Acircumflex Oslash -30\r\nKPX Acircumflex Otilde -30\r\nKPX Acircumflex Q -30\r\nKPX Acircumflex T -120\r\nKPX Acircumflex Tcaron -120\r\nKPX Acircumflex Tcommaaccent -120\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -70\r\nKPX Acircumflex W -50\r\nKPX Acircumflex Y -100\r\nKPX Acircumflex Yacute -100\r\nKPX Acircumflex Ydieresis -100\r\nKPX Acircumflex u -30\r\nKPX Acircumflex uacute -30\r\nKPX Acircumflex ucircumflex -30\r\nKPX Acircumflex udieresis -30\r\nKPX Acircumflex ugrave -30\r\nKPX Acircumflex uhungarumlaut -30\r\nKPX Acircumflex umacron -30\r\nKPX Acircumflex uogonek -30\r\nKPX Acircumflex uring -30\r\nKPX Acircumflex v -40\r\nKPX Acircumflex w -40\r\nKPX Acircumflex y -40\r\nKPX Acircumflex yacute -40\r\nKPX Acircumflex ydieresis -40\r\nKPX Adieresis C -30\r\nKPX Adieresis Cacute -30\r\nKPX Adieresis Ccaron -30\r\nKPX Adieresis Ccedilla -30\r\nKPX Adieresis G -30\r\nKPX Adieresis Gbreve -30\r\nKPX Adieresis Gcommaaccent -30\r\nKPX Adieresis O -30\r\nKPX Adieresis Oacute -30\r\nKPX Adieresis Ocircumflex -30\r\nKPX Adieresis Odieresis -30\r\nKPX Adieresis Ograve -30\r\nKPX Adieresis Ohungarumlaut -30\r\nKPX Adieresis Omacron -30\r\nKPX Adieresis Oslash -30\r\nKPX Adieresis Otilde -30\r\nKPX Adieresis Q -30\r\nKPX Adieresis T -120\r\nKPX Adieresis Tcaron -120\r\nKPX Adieresis Tcommaaccent -120\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -70\r\nKPX Adieresis W -50\r\nKPX Adieresis Y -100\r\nKPX Adieresis Yacute -100\r\nKPX Adieresis Ydieresis -100\r\nKPX Adieresis u -30\r\nKPX Adieresis uacute -30\r\nKPX Adieresis ucircumflex -30\r\nKPX Adieresis udieresis -30\r\nKPX Adieresis ugrave -30\r\nKPX Adieresis uhungarumlaut -30\r\nKPX Adieresis umacron -30\r\nKPX Adieresis uogonek -30\r\nKPX Adieresis uring -30\r\nKPX Adieresis v -40\r\nKPX Adieresis w -40\r\nKPX Adieresis y -40\r\nKPX Adieresis yacute -40\r\nKPX Adieresis ydieresis -40\r\nKPX Agrave C -30\r\nKPX Agrave Cacute -30\r\nKPX Agrave Ccaron -30\r\nKPX Agrave Ccedilla -30\r\nKPX Agrave G -30\r\nKPX Agrave Gbreve -30\r\nKPX Agrave Gcommaaccent -30\r\nKPX Agrave O -30\r\nKPX Agrave Oacute -30\r\nKPX Agrave Ocircumflex -30\r\nKPX Agrave Odieresis -30\r\nKPX Agrave Ograve -30\r\nKPX Agrave Ohungarumlaut -30\r\nKPX Agrave Omacron -30\r\nKPX Agrave Oslash -30\r\nKPX Agrave Otilde -30\r\nKPX Agrave Q -30\r\nKPX Agrave T -120\r\nKPX Agrave Tcaron -120\r\nKPX Agrave Tcommaaccent -120\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -70\r\nKPX Agrave W -50\r\nKPX Agrave Y -100\r\nKPX Agrave Yacute -100\r\nKPX Agrave Ydieresis -100\r\nKPX Agrave u -30\r\nKPX Agrave uacute -30\r\nKPX Agrave ucircumflex -30\r\nKPX Agrave udieresis -30\r\nKPX Agrave ugrave -30\r\nKPX Agrave uhungarumlaut -30\r\nKPX Agrave umacron -30\r\nKPX Agrave uogonek -30\r\nKPX Agrave uring -30\r\nKPX Agrave v -40\r\nKPX Agrave w -40\r\nKPX Agrave y -40\r\nKPX Agrave yacute -40\r\nKPX Agrave ydieresis -40\r\nKPX Amacron C -30\r\nKPX Amacron Cacute -30\r\nKPX Amacron Ccaron -30\r\nKPX Amacron Ccedilla -30\r\nKPX Amacron G -30\r\nKPX Amacron Gbreve -30\r\nKPX Amacron Gcommaaccent -30\r\nKPX Amacron O -30\r\nKPX Amacron Oacute -30\r\nKPX Amacron Ocircumflex -30\r\nKPX Amacron Odieresis -30\r\nKPX Amacron Ograve -30\r\nKPX Amacron Ohungarumlaut -30\r\nKPX Amacron Omacron -30\r\nKPX Amacron Oslash -30\r\nKPX Amacron Otilde -30\r\nKPX Amacron Q -30\r\nKPX Amacron T -120\r\nKPX Amacron Tcaron -120\r\nKPX Amacron Tcommaaccent -120\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -70\r\nKPX Amacron W -50\r\nKPX Amacron Y -100\r\nKPX Amacron Yacute -100\r\nKPX Amacron Ydieresis -100\r\nKPX Amacron u -30\r\nKPX Amacron uacute -30\r\nKPX Amacron ucircumflex -30\r\nKPX Amacron udieresis -30\r\nKPX Amacron ugrave -30\r\nKPX Amacron uhungarumlaut -30\r\nKPX Amacron umacron -30\r\nKPX Amacron uogonek -30\r\nKPX Amacron uring -30\r\nKPX Amacron v -40\r\nKPX Amacron w -40\r\nKPX Amacron y -40\r\nKPX Amacron yacute -40\r\nKPX Amacron ydieresis -40\r\nKPX Aogonek C -30\r\nKPX Aogonek Cacute -30\r\nKPX Aogonek Ccaron -30\r\nKPX Aogonek Ccedilla -30\r\nKPX Aogonek G -30\r\nKPX Aogonek Gbreve -30\r\nKPX Aogonek Gcommaaccent -30\r\nKPX Aogonek O -30\r\nKPX Aogonek Oacute -30\r\nKPX Aogonek Ocircumflex -30\r\nKPX Aogonek Odieresis -30\r\nKPX Aogonek Ograve -30\r\nKPX Aogonek Ohungarumlaut -30\r\nKPX Aogonek Omacron -30\r\nKPX Aogonek Oslash -30\r\nKPX Aogonek Otilde -30\r\nKPX Aogonek Q -30\r\nKPX Aogonek T -120\r\nKPX Aogonek Tcaron -120\r\nKPX Aogonek Tcommaaccent -120\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -70\r\nKPX Aogonek W -50\r\nKPX Aogonek Y -100\r\nKPX Aogonek Yacute -100\r\nKPX Aogonek Ydieresis -100\r\nKPX Aogonek u -30\r\nKPX Aogonek uacute -30\r\nKPX Aogonek ucircumflex -30\r\nKPX Aogonek udieresis -30\r\nKPX Aogonek ugrave -30\r\nKPX Aogonek uhungarumlaut -30\r\nKPX Aogonek umacron -30\r\nKPX Aogonek uogonek -30\r\nKPX Aogonek uring -30\r\nKPX Aogonek v -40\r\nKPX Aogonek w -40\r\nKPX Aogonek y -40\r\nKPX Aogonek yacute -40\r\nKPX Aogonek ydieresis -40\r\nKPX Aring C -30\r\nKPX Aring Cacute -30\r\nKPX Aring Ccaron -30\r\nKPX Aring Ccedilla -30\r\nKPX Aring G -30\r\nKPX Aring Gbreve -30\r\nKPX Aring Gcommaaccent -30\r\nKPX Aring O -30\r\nKPX Aring Oacute -30\r\nKPX Aring Ocircumflex -30\r\nKPX Aring Odieresis -30\r\nKPX Aring Ograve -30\r\nKPX Aring Ohungarumlaut -30\r\nKPX Aring Omacron -30\r\nKPX Aring Oslash -30\r\nKPX Aring Otilde -30\r\nKPX Aring Q -30\r\nKPX Aring T -120\r\nKPX Aring Tcaron -120\r\nKPX Aring Tcommaaccent -120\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -70\r\nKPX Aring W -50\r\nKPX Aring Y -100\r\nKPX Aring Yacute -100\r\nKPX Aring Ydieresis -100\r\nKPX Aring u -30\r\nKPX Aring uacute -30\r\nKPX Aring ucircumflex -30\r\nKPX Aring udieresis -30\r\nKPX Aring ugrave -30\r\nKPX Aring uhungarumlaut -30\r\nKPX Aring umacron -30\r\nKPX Aring uogonek -30\r\nKPX Aring uring -30\r\nKPX Aring v -40\r\nKPX Aring w -40\r\nKPX Aring y -40\r\nKPX Aring yacute -40\r\nKPX Aring ydieresis -40\r\nKPX Atilde C -30\r\nKPX Atilde Cacute -30\r\nKPX Atilde Ccaron -30\r\nKPX Atilde Ccedilla -30\r\nKPX Atilde G -30\r\nKPX Atilde Gbreve -30\r\nKPX Atilde Gcommaaccent -30\r\nKPX Atilde O -30\r\nKPX Atilde Oacute -30\r\nKPX Atilde Ocircumflex -30\r\nKPX Atilde Odieresis -30\r\nKPX Atilde Ograve -30\r\nKPX Atilde Ohungarumlaut -30\r\nKPX Atilde Omacron -30\r\nKPX Atilde Oslash -30\r\nKPX Atilde Otilde -30\r\nKPX Atilde Q -30\r\nKPX Atilde T -120\r\nKPX Atilde Tcaron -120\r\nKPX Atilde Tcommaaccent -120\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -70\r\nKPX Atilde W -50\r\nKPX Atilde Y -100\r\nKPX Atilde Yacute -100\r\nKPX Atilde Ydieresis -100\r\nKPX Atilde u -30\r\nKPX Atilde uacute -30\r\nKPX Atilde ucircumflex -30\r\nKPX Atilde udieresis -30\r\nKPX Atilde ugrave -30\r\nKPX Atilde uhungarumlaut -30\r\nKPX Atilde umacron -30\r\nKPX Atilde uogonek -30\r\nKPX Atilde uring -30\r\nKPX Atilde v -40\r\nKPX Atilde w -40\r\nKPX Atilde y -40\r\nKPX Atilde yacute -40\r\nKPX Atilde ydieresis -40\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX B comma -20\r\nKPX B period -20\r\nKPX C comma -30\r\nKPX C period -30\r\nKPX Cacute comma -30\r\nKPX Cacute period -30\r\nKPX Ccaron comma -30\r\nKPX Ccaron period -30\r\nKPX Ccedilla comma -30\r\nKPX Ccedilla period -30\r\nKPX D A -40\r\nKPX D Aacute -40\r\nKPX D Abreve -40\r\nKPX D Acircumflex -40\r\nKPX D Adieresis -40\r\nKPX D Agrave -40\r\nKPX D Amacron -40\r\nKPX D Aogonek -40\r\nKPX D Aring -40\r\nKPX D Atilde -40\r\nKPX D V -70\r\nKPX D W -40\r\nKPX D Y -90\r\nKPX D Yacute -90\r\nKPX D Ydieresis -90\r\nKPX D comma -70\r\nKPX D period -70\r\nKPX Dcaron A -40\r\nKPX Dcaron Aacute -40\r\nKPX Dcaron Abreve -40\r\nKPX Dcaron Acircumflex -40\r\nKPX Dcaron Adieresis -40\r\nKPX Dcaron Agrave -40\r\nKPX Dcaron Amacron -40\r\nKPX Dcaron Aogonek -40\r\nKPX Dcaron Aring -40\r\nKPX Dcaron Atilde -40\r\nKPX Dcaron V -70\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -90\r\nKPX Dcaron Yacute -90\r\nKPX Dcaron Ydieresis -90\r\nKPX Dcaron comma -70\r\nKPX Dcaron period -70\r\nKPX Dcroat A -40\r\nKPX Dcroat Aacute -40\r\nKPX Dcroat Abreve -40\r\nKPX Dcroat Acircumflex -40\r\nKPX Dcroat Adieresis -40\r\nKPX Dcroat Agrave -40\r\nKPX Dcroat Amacron -40\r\nKPX Dcroat Aogonek -40\r\nKPX Dcroat Aring -40\r\nKPX Dcroat Atilde -40\r\nKPX Dcroat V -70\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -90\r\nKPX Dcroat Yacute -90\r\nKPX Dcroat Ydieresis -90\r\nKPX Dcroat comma -70\r\nKPX Dcroat period -70\r\nKPX F A -80\r\nKPX F Aacute -80\r\nKPX F Abreve -80\r\nKPX F Acircumflex -80\r\nKPX F Adieresis -80\r\nKPX F Agrave -80\r\nKPX F Amacron -80\r\nKPX F Aogonek -80\r\nKPX F Aring -80\r\nKPX F Atilde -80\r\nKPX F a -50\r\nKPX F aacute -50\r\nKPX F abreve -50\r\nKPX F acircumflex -50\r\nKPX F adieresis -50\r\nKPX F agrave -50\r\nKPX F amacron -50\r\nKPX F aogonek -50\r\nKPX F aring -50\r\nKPX F atilde -50\r\nKPX F comma -150\r\nKPX F e -30\r\nKPX F eacute -30\r\nKPX F ecaron -30\r\nKPX F ecircumflex -30\r\nKPX F edieresis -30\r\nKPX F edotaccent -30\r\nKPX F egrave -30\r\nKPX F emacron -30\r\nKPX F eogonek -30\r\nKPX F o -30\r\nKPX F oacute -30\r\nKPX F ocircumflex -30\r\nKPX F odieresis -30\r\nKPX F ograve -30\r\nKPX F ohungarumlaut -30\r\nKPX F omacron -30\r\nKPX F oslash -30\r\nKPX F otilde -30\r\nKPX F period -150\r\nKPX F r -45\r\nKPX F racute -45\r\nKPX F rcaron -45\r\nKPX F rcommaaccent -45\r\nKPX J A -20\r\nKPX J Aacute -20\r\nKPX J Abreve -20\r\nKPX J Acircumflex -20\r\nKPX J Adieresis -20\r\nKPX J Agrave -20\r\nKPX J Amacron -20\r\nKPX J Aogonek -20\r\nKPX J Aring -20\r\nKPX J Atilde -20\r\nKPX J a -20\r\nKPX J aacute -20\r\nKPX J abreve -20\r\nKPX J acircumflex -20\r\nKPX J adieresis -20\r\nKPX J agrave -20\r\nKPX J amacron -20\r\nKPX J aogonek -20\r\nKPX J aring -20\r\nKPX J atilde -20\r\nKPX J comma -30\r\nKPX J period -30\r\nKPX J u -20\r\nKPX J uacute -20\r\nKPX J ucircumflex -20\r\nKPX J udieresis -20\r\nKPX J ugrave -20\r\nKPX J uhungarumlaut -20\r\nKPX J umacron -20\r\nKPX J uogonek -20\r\nKPX J uring -20\r\nKPX K O -50\r\nKPX K Oacute -50\r\nKPX K Ocircumflex -50\r\nKPX K Odieresis -50\r\nKPX K Ograve -50\r\nKPX K Ohungarumlaut -50\r\nKPX K Omacron -50\r\nKPX K Oslash -50\r\nKPX K Otilde -50\r\nKPX K e -40\r\nKPX K eacute -40\r\nKPX K ecaron -40\r\nKPX K ecircumflex -40\r\nKPX K edieresis -40\r\nKPX K edotaccent -40\r\nKPX K egrave -40\r\nKPX K emacron -40\r\nKPX K eogonek -40\r\nKPX K o -40\r\nKPX K oacute -40\r\nKPX K ocircumflex -40\r\nKPX K odieresis -40\r\nKPX K ograve -40\r\nKPX K ohungarumlaut -40\r\nKPX K omacron -40\r\nKPX K oslash -40\r\nKPX K otilde -40\r\nKPX K u -30\r\nKPX K uacute -30\r\nKPX K ucircumflex -30\r\nKPX K udieresis -30\r\nKPX K ugrave -30\r\nKPX K uhungarumlaut -30\r\nKPX K umacron -30\r\nKPX K uogonek -30\r\nKPX K uring -30\r\nKPX K y -50\r\nKPX K yacute -50\r\nKPX K ydieresis -50\r\nKPX Kcommaaccent O -50\r\nKPX Kcommaaccent Oacute -50\r\nKPX Kcommaaccent Ocircumflex -50\r\nKPX Kcommaaccent Odieresis -50\r\nKPX Kcommaaccent Ograve -50\r\nKPX Kcommaaccent Ohungarumlaut -50\r\nKPX Kcommaaccent Omacron -50\r\nKPX Kcommaaccent Oslash -50\r\nKPX Kcommaaccent Otilde -50\r\nKPX Kcommaaccent e -40\r\nKPX Kcommaaccent eacute -40\r\nKPX Kcommaaccent ecaron -40\r\nKPX Kcommaaccent ecircumflex -40\r\nKPX Kcommaaccent edieresis -40\r\nKPX Kcommaaccent edotaccent -40\r\nKPX Kcommaaccent egrave -40\r\nKPX Kcommaaccent emacron -40\r\nKPX Kcommaaccent eogonek -40\r\nKPX Kcommaaccent o -40\r\nKPX Kcommaaccent oacute -40\r\nKPX Kcommaaccent ocircumflex -40\r\nKPX Kcommaaccent odieresis -40\r\nKPX Kcommaaccent ograve -40\r\nKPX Kcommaaccent ohungarumlaut -40\r\nKPX Kcommaaccent omacron -40\r\nKPX Kcommaaccent oslash -40\r\nKPX Kcommaaccent otilde -40\r\nKPX Kcommaaccent u -30\r\nKPX Kcommaaccent uacute -30\r\nKPX Kcommaaccent ucircumflex -30\r\nKPX Kcommaaccent udieresis -30\r\nKPX Kcommaaccent ugrave -30\r\nKPX Kcommaaccent uhungarumlaut -30\r\nKPX Kcommaaccent umacron -30\r\nKPX Kcommaaccent uogonek -30\r\nKPX Kcommaaccent uring -30\r\nKPX Kcommaaccent y -50\r\nKPX Kcommaaccent yacute -50\r\nKPX Kcommaaccent ydieresis -50\r\nKPX L T -110\r\nKPX L Tcaron -110\r\nKPX L Tcommaaccent -110\r\nKPX L V -110\r\nKPX L W -70\r\nKPX L Y -140\r\nKPX L Yacute -140\r\nKPX L Ydieresis -140\r\nKPX L quotedblright -140\r\nKPX L quoteright -160\r\nKPX L y -30\r\nKPX L yacute -30\r\nKPX L ydieresis -30\r\nKPX Lacute T -110\r\nKPX Lacute Tcaron -110\r\nKPX Lacute Tcommaaccent -110\r\nKPX Lacute V -110\r\nKPX Lacute W -70\r\nKPX Lacute Y -140\r\nKPX Lacute Yacute -140\r\nKPX Lacute Ydieresis -140\r\nKPX Lacute quotedblright -140\r\nKPX Lacute quoteright -160\r\nKPX Lacute y -30\r\nKPX Lacute yacute -30\r\nKPX Lacute ydieresis -30\r\nKPX Lcaron T -110\r\nKPX Lcaron Tcaron -110\r\nKPX Lcaron Tcommaaccent -110\r\nKPX Lcaron V -110\r\nKPX Lcaron W -70\r\nKPX Lcaron Y -140\r\nKPX Lcaron Yacute -140\r\nKPX Lcaron Ydieresis -140\r\nKPX Lcaron quotedblright -140\r\nKPX Lcaron quoteright -160\r\nKPX Lcaron y -30\r\nKPX Lcaron yacute -30\r\nKPX Lcaron ydieresis -30\r\nKPX Lcommaaccent T -110\r\nKPX Lcommaaccent Tcaron -110\r\nKPX Lcommaaccent Tcommaaccent -110\r\nKPX Lcommaaccent V -110\r\nKPX Lcommaaccent W -70\r\nKPX Lcommaaccent Y -140\r\nKPX Lcommaaccent Yacute -140\r\nKPX Lcommaaccent Ydieresis -140\r\nKPX Lcommaaccent quotedblright -140\r\nKPX Lcommaaccent quoteright -160\r\nKPX Lcommaaccent y -30\r\nKPX Lcommaaccent yacute -30\r\nKPX Lcommaaccent ydieresis -30\r\nKPX Lslash T -110\r\nKPX Lslash Tcaron -110\r\nKPX Lslash Tcommaaccent -110\r\nKPX Lslash V -110\r\nKPX Lslash W -70\r\nKPX Lslash Y -140\r\nKPX Lslash Yacute -140\r\nKPX Lslash Ydieresis -140\r\nKPX Lslash quotedblright -140\r\nKPX Lslash quoteright -160\r\nKPX Lslash y -30\r\nKPX Lslash yacute -30\r\nKPX Lslash ydieresis -30\r\nKPX O A -20\r\nKPX O Aacute -20\r\nKPX O Abreve -20\r\nKPX O Acircumflex -20\r\nKPX O Adieresis -20\r\nKPX O Agrave -20\r\nKPX O Amacron -20\r\nKPX O Aogonek -20\r\nKPX O Aring -20\r\nKPX O Atilde -20\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -30\r\nKPX O X -60\r\nKPX O Y -70\r\nKPX O Yacute -70\r\nKPX O Ydieresis -70\r\nKPX O comma -40\r\nKPX O period -40\r\nKPX Oacute A -20\r\nKPX Oacute Aacute -20\r\nKPX Oacute Abreve -20\r\nKPX Oacute Acircumflex -20\r\nKPX Oacute Adieresis -20\r\nKPX Oacute Agrave -20\r\nKPX Oacute Amacron -20\r\nKPX Oacute Aogonek -20\r\nKPX Oacute Aring -20\r\nKPX Oacute Atilde -20\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -30\r\nKPX Oacute X -60\r\nKPX Oacute Y -70\r\nKPX Oacute Yacute -70\r\nKPX Oacute Ydieresis -70\r\nKPX Oacute comma -40\r\nKPX Oacute period -40\r\nKPX Ocircumflex A -20\r\nKPX Ocircumflex Aacute -20\r\nKPX Ocircumflex Abreve -20\r\nKPX Ocircumflex Acircumflex -20\r\nKPX Ocircumflex Adieresis -20\r\nKPX Ocircumflex Agrave -20\r\nKPX Ocircumflex Amacron -20\r\nKPX Ocircumflex Aogonek -20\r\nKPX Ocircumflex Aring -20\r\nKPX Ocircumflex Atilde -20\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -30\r\nKPX Ocircumflex X -60\r\nKPX Ocircumflex Y -70\r\nKPX Ocircumflex Yacute -70\r\nKPX Ocircumflex Ydieresis -70\r\nKPX Ocircumflex comma -40\r\nKPX Ocircumflex period -40\r\nKPX Odieresis A -20\r\nKPX Odieresis Aacute -20\r\nKPX Odieresis Abreve -20\r\nKPX Odieresis Acircumflex -20\r\nKPX Odieresis Adieresis -20\r\nKPX Odieresis Agrave -20\r\nKPX Odieresis Amacron -20\r\nKPX Odieresis Aogonek -20\r\nKPX Odieresis Aring -20\r\nKPX Odieresis Atilde -20\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -30\r\nKPX Odieresis X -60\r\nKPX Odieresis Y -70\r\nKPX Odieresis Yacute -70\r\nKPX Odieresis Ydieresis -70\r\nKPX Odieresis comma -40\r\nKPX Odieresis period -40\r\nKPX Ograve A -20\r\nKPX Ograve Aacute -20\r\nKPX Ograve Abreve -20\r\nKPX Ograve Acircumflex -20\r\nKPX Ograve Adieresis -20\r\nKPX Ograve Agrave -20\r\nKPX Ograve Amacron -20\r\nKPX Ograve Aogonek -20\r\nKPX Ograve Aring -20\r\nKPX Ograve Atilde -20\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -30\r\nKPX Ograve X -60\r\nKPX Ograve Y -70\r\nKPX Ograve Yacute -70\r\nKPX Ograve Ydieresis -70\r\nKPX Ograve comma -40\r\nKPX Ograve period -40\r\nKPX Ohungarumlaut A -20\r\nKPX Ohungarumlaut Aacute -20\r\nKPX Ohungarumlaut Abreve -20\r\nKPX Ohungarumlaut Acircumflex -20\r\nKPX Ohungarumlaut Adieresis -20\r\nKPX Ohungarumlaut Agrave -20\r\nKPX Ohungarumlaut Amacron -20\r\nKPX Ohungarumlaut Aogonek -20\r\nKPX Ohungarumlaut Aring -20\r\nKPX Ohungarumlaut Atilde -20\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -30\r\nKPX Ohungarumlaut X -60\r\nKPX Ohungarumlaut Y -70\r\nKPX Ohungarumlaut Yacute -70\r\nKPX Ohungarumlaut Ydieresis -70\r\nKPX Ohungarumlaut comma -40\r\nKPX Ohungarumlaut period -40\r\nKPX Omacron A -20\r\nKPX Omacron Aacute -20\r\nKPX Omacron Abreve -20\r\nKPX Omacron Acircumflex -20\r\nKPX Omacron Adieresis -20\r\nKPX Omacron Agrave -20\r\nKPX Omacron Amacron -20\r\nKPX Omacron Aogonek -20\r\nKPX Omacron Aring -20\r\nKPX Omacron Atilde -20\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -30\r\nKPX Omacron X -60\r\nKPX Omacron Y -70\r\nKPX Omacron Yacute -70\r\nKPX Omacron Ydieresis -70\r\nKPX Omacron comma -40\r\nKPX Omacron period -40\r\nKPX Oslash A -20\r\nKPX Oslash Aacute -20\r\nKPX Oslash Abreve -20\r\nKPX Oslash Acircumflex -20\r\nKPX Oslash Adieresis -20\r\nKPX Oslash Agrave -20\r\nKPX Oslash Amacron -20\r\nKPX Oslash Aogonek -20\r\nKPX Oslash Aring -20\r\nKPX Oslash Atilde -20\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -30\r\nKPX Oslash X -60\r\nKPX Oslash Y -70\r\nKPX Oslash Yacute -70\r\nKPX Oslash Ydieresis -70\r\nKPX Oslash comma -40\r\nKPX Oslash period -40\r\nKPX Otilde A -20\r\nKPX Otilde Aacute -20\r\nKPX Otilde Abreve -20\r\nKPX Otilde Acircumflex -20\r\nKPX Otilde Adieresis -20\r\nKPX Otilde Agrave -20\r\nKPX Otilde Amacron -20\r\nKPX Otilde Aogonek -20\r\nKPX Otilde Aring -20\r\nKPX Otilde Atilde -20\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -30\r\nKPX Otilde X -60\r\nKPX Otilde Y -70\r\nKPX Otilde Yacute -70\r\nKPX Otilde Ydieresis -70\r\nKPX Otilde comma -40\r\nKPX Otilde period -40\r\nKPX P A -120\r\nKPX P Aacute -120\r\nKPX P Abreve -120\r\nKPX P Acircumflex -120\r\nKPX P Adieresis -120\r\nKPX P Agrave -120\r\nKPX P Amacron -120\r\nKPX P Aogonek -120\r\nKPX P Aring -120\r\nKPX P Atilde -120\r\nKPX P a -40\r\nKPX P aacute -40\r\nKPX P abreve -40\r\nKPX P acircumflex -40\r\nKPX P adieresis -40\r\nKPX P agrave -40\r\nKPX P amacron -40\r\nKPX P aogonek -40\r\nKPX P aring -40\r\nKPX P atilde -40\r\nKPX P comma -180\r\nKPX P e -50\r\nKPX P eacute -50\r\nKPX P ecaron -50\r\nKPX P ecircumflex -50\r\nKPX P edieresis -50\r\nKPX P edotaccent -50\r\nKPX P egrave -50\r\nKPX P emacron -50\r\nKPX P eogonek -50\r\nKPX P o -50\r\nKPX P oacute -50\r\nKPX P ocircumflex -50\r\nKPX P odieresis -50\r\nKPX P ograve -50\r\nKPX P ohungarumlaut -50\r\nKPX P omacron -50\r\nKPX P oslash -50\r\nKPX P otilde -50\r\nKPX P period -180\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX R O -20\r\nKPX R Oacute -20\r\nKPX R Ocircumflex -20\r\nKPX R Odieresis -20\r\nKPX R Ograve -20\r\nKPX R Ohungarumlaut -20\r\nKPX R Omacron -20\r\nKPX R Oslash -20\r\nKPX R Otilde -20\r\nKPX R T -30\r\nKPX R Tcaron -30\r\nKPX R Tcommaaccent -30\r\nKPX R U -40\r\nKPX R Uacute -40\r\nKPX R Ucircumflex -40\r\nKPX R Udieresis -40\r\nKPX R Ugrave -40\r\nKPX R Uhungarumlaut -40\r\nKPX R Umacron -40\r\nKPX R Uogonek -40\r\nKPX R Uring -40\r\nKPX R V -50\r\nKPX R W -30\r\nKPX R Y -50\r\nKPX R Yacute -50\r\nKPX R Ydieresis -50\r\nKPX Racute O -20\r\nKPX Racute Oacute -20\r\nKPX Racute Ocircumflex -20\r\nKPX Racute Odieresis -20\r\nKPX Racute Ograve -20\r\nKPX Racute Ohungarumlaut -20\r\nKPX Racute Omacron -20\r\nKPX Racute Oslash -20\r\nKPX Racute Otilde -20\r\nKPX Racute T -30\r\nKPX Racute Tcaron -30\r\nKPX Racute Tcommaaccent -30\r\nKPX Racute U -40\r\nKPX Racute Uacute -40\r\nKPX Racute Ucircumflex -40\r\nKPX Racute Udieresis -40\r\nKPX Racute Ugrave -40\r\nKPX Racute Uhungarumlaut -40\r\nKPX Racute Umacron -40\r\nKPX Racute Uogonek -40\r\nKPX Racute Uring -40\r\nKPX Racute V -50\r\nKPX Racute W -30\r\nKPX Racute Y -50\r\nKPX Racute Yacute -50\r\nKPX Racute Ydieresis -50\r\nKPX Rcaron O -20\r\nKPX Rcaron Oacute -20\r\nKPX Rcaron Ocircumflex -20\r\nKPX Rcaron Odieresis -20\r\nKPX Rcaron Ograve -20\r\nKPX Rcaron Ohungarumlaut -20\r\nKPX Rcaron Omacron -20\r\nKPX Rcaron Oslash -20\r\nKPX Rcaron Otilde -20\r\nKPX Rcaron T -30\r\nKPX Rcaron Tcaron -30\r\nKPX Rcaron Tcommaaccent -30\r\nKPX Rcaron U -40\r\nKPX Rcaron Uacute -40\r\nKPX Rcaron Ucircumflex -40\r\nKPX Rcaron Udieresis -40\r\nKPX Rcaron Ugrave -40\r\nKPX Rcaron Uhungarumlaut -40\r\nKPX Rcaron Umacron -40\r\nKPX Rcaron Uogonek -40\r\nKPX Rcaron Uring -40\r\nKPX Rcaron V -50\r\nKPX Rcaron W -30\r\nKPX Rcaron Y -50\r\nKPX Rcaron Yacute -50\r\nKPX Rcaron Ydieresis -50\r\nKPX Rcommaaccent O -20\r\nKPX Rcommaaccent Oacute -20\r\nKPX Rcommaaccent Ocircumflex -20\r\nKPX Rcommaaccent Odieresis -20\r\nKPX Rcommaaccent Ograve -20\r\nKPX Rcommaaccent Ohungarumlaut -20\r\nKPX Rcommaaccent Omacron -20\r\nKPX Rcommaaccent Oslash -20\r\nKPX Rcommaaccent Otilde -20\r\nKPX Rcommaaccent T -30\r\nKPX Rcommaaccent Tcaron -30\r\nKPX Rcommaaccent Tcommaaccent -30\r\nKPX Rcommaaccent U -40\r\nKPX Rcommaaccent Uacute -40\r\nKPX Rcommaaccent Ucircumflex -40\r\nKPX Rcommaaccent Udieresis -40\r\nKPX Rcommaaccent Ugrave -40\r\nKPX Rcommaaccent Uhungarumlaut -40\r\nKPX Rcommaaccent Umacron -40\r\nKPX Rcommaaccent Uogonek -40\r\nKPX Rcommaaccent Uring -40\r\nKPX Rcommaaccent V -50\r\nKPX Rcommaaccent W -30\r\nKPX Rcommaaccent Y -50\r\nKPX Rcommaaccent Yacute -50\r\nKPX Rcommaaccent Ydieresis -50\r\nKPX S comma -20\r\nKPX S period -20\r\nKPX Sacute comma -20\r\nKPX Sacute period -20\r\nKPX Scaron comma -20\r\nKPX Scaron period -20\r\nKPX Scedilla comma -20\r\nKPX Scedilla period -20\r\nKPX Scommaaccent comma -20\r\nKPX Scommaaccent period -20\r\nKPX T A -120\r\nKPX T Aacute -120\r\nKPX T Abreve -120\r\nKPX T Acircumflex -120\r\nKPX T Adieresis -120\r\nKPX T Agrave -120\r\nKPX T Amacron -120\r\nKPX T Aogonek -120\r\nKPX T Aring -120\r\nKPX T Atilde -120\r\nKPX T O -40\r\nKPX T Oacute -40\r\nKPX T Ocircumflex -40\r\nKPX T Odieresis -40\r\nKPX T Ograve -40\r\nKPX T Ohungarumlaut -40\r\nKPX T Omacron -40\r\nKPX T Oslash -40\r\nKPX T Otilde -40\r\nKPX T a -120\r\nKPX T aacute -120\r\nKPX T abreve -60\r\nKPX T acircumflex -120\r\nKPX T adieresis -120\r\nKPX T agrave -120\r\nKPX T amacron -60\r\nKPX T aogonek -120\r\nKPX T aring -120\r\nKPX T atilde -60\r\nKPX T colon -20\r\nKPX T comma -120\r\nKPX T e -120\r\nKPX T eacute -120\r\nKPX T ecaron -120\r\nKPX T ecircumflex -120\r\nKPX T edieresis -120\r\nKPX T edotaccent -120\r\nKPX T egrave -60\r\nKPX T emacron -60\r\nKPX T eogonek -120\r\nKPX T hyphen -140\r\nKPX T o -120\r\nKPX T oacute -120\r\nKPX T ocircumflex -120\r\nKPX T odieresis -120\r\nKPX T ograve -120\r\nKPX T ohungarumlaut -120\r\nKPX T omacron -60\r\nKPX T oslash -120\r\nKPX T otilde -60\r\nKPX T period -120\r\nKPX T r -120\r\nKPX T racute -120\r\nKPX T rcaron -120\r\nKPX T rcommaaccent -120\r\nKPX T semicolon -20\r\nKPX T u -120\r\nKPX T uacute -120\r\nKPX T ucircumflex -120\r\nKPX T udieresis -120\r\nKPX T ugrave -120\r\nKPX T uhungarumlaut -120\r\nKPX T umacron -60\r\nKPX T uogonek -120\r\nKPX T uring -120\r\nKPX T w -120\r\nKPX T y -120\r\nKPX T yacute -120\r\nKPX T ydieresis -60\r\nKPX Tcaron A -120\r\nKPX Tcaron Aacute -120\r\nKPX Tcaron Abreve -120\r\nKPX Tcaron Acircumflex -120\r\nKPX Tcaron Adieresis -120\r\nKPX Tcaron Agrave -120\r\nKPX Tcaron Amacron -120\r\nKPX Tcaron Aogonek -120\r\nKPX Tcaron Aring -120\r\nKPX Tcaron Atilde -120\r\nKPX Tcaron O -40\r\nKPX Tcaron Oacute -40\r\nKPX Tcaron Ocircumflex -40\r\nKPX Tcaron Odieresis -40\r\nKPX Tcaron Ograve -40\r\nKPX Tcaron Ohungarumlaut -40\r\nKPX Tcaron Omacron -40\r\nKPX Tcaron Oslash -40\r\nKPX Tcaron Otilde -40\r\nKPX Tcaron a -120\r\nKPX Tcaron aacute -120\r\nKPX Tcaron abreve -60\r\nKPX Tcaron acircumflex -120\r\nKPX Tcaron adieresis -120\r\nKPX Tcaron agrave -120\r\nKPX Tcaron amacron -60\r\nKPX Tcaron aogonek -120\r\nKPX Tcaron aring -120\r\nKPX Tcaron atilde -60\r\nKPX Tcaron colon -20\r\nKPX Tcaron comma -120\r\nKPX Tcaron e -120\r\nKPX Tcaron eacute -120\r\nKPX Tcaron ecaron -120\r\nKPX Tcaron ecircumflex -120\r\nKPX Tcaron edieresis -120\r\nKPX Tcaron edotaccent -120\r\nKPX Tcaron egrave -60\r\nKPX Tcaron emacron -60\r\nKPX Tcaron eogonek -120\r\nKPX Tcaron hyphen -140\r\nKPX Tcaron o -120\r\nKPX Tcaron oacute -120\r\nKPX Tcaron ocircumflex -120\r\nKPX Tcaron odieresis -120\r\nKPX Tcaron ograve -120\r\nKPX Tcaron ohungarumlaut -120\r\nKPX Tcaron omacron -60\r\nKPX Tcaron oslash -120\r\nKPX Tcaron otilde -60\r\nKPX Tcaron period -120\r\nKPX Tcaron r -120\r\nKPX Tcaron racute -120\r\nKPX Tcaron rcaron -120\r\nKPX Tcaron rcommaaccent -120\r\nKPX Tcaron semicolon -20\r\nKPX Tcaron u -120\r\nKPX Tcaron uacute -120\r\nKPX Tcaron ucircumflex -120\r\nKPX Tcaron udieresis -120\r\nKPX Tcaron ugrave -120\r\nKPX Tcaron uhungarumlaut -120\r\nKPX Tcaron umacron -60\r\nKPX Tcaron uogonek -120\r\nKPX Tcaron uring -120\r\nKPX Tcaron w -120\r\nKPX Tcaron y -120\r\nKPX Tcaron yacute -120\r\nKPX Tcaron ydieresis -60\r\nKPX Tcommaaccent A -120\r\nKPX Tcommaaccent Aacute -120\r\nKPX Tcommaaccent Abreve -120\r\nKPX Tcommaaccent Acircumflex -120\r\nKPX Tcommaaccent Adieresis -120\r\nKPX Tcommaaccent Agrave -120\r\nKPX Tcommaaccent Amacron -120\r\nKPX Tcommaaccent Aogonek -120\r\nKPX Tcommaaccent Aring -120\r\nKPX Tcommaaccent Atilde -120\r\nKPX Tcommaaccent O -40\r\nKPX Tcommaaccent Oacute -40\r\nKPX Tcommaaccent Ocircumflex -40\r\nKPX Tcommaaccent Odieresis -40\r\nKPX Tcommaaccent Ograve -40\r\nKPX Tcommaaccent Ohungarumlaut -40\r\nKPX Tcommaaccent Omacron -40\r\nKPX Tcommaaccent Oslash -40\r\nKPX Tcommaaccent Otilde -40\r\nKPX Tcommaaccent a -120\r\nKPX Tcommaaccent aacute -120\r\nKPX Tcommaaccent abreve -60\r\nKPX Tcommaaccent acircumflex -120\r\nKPX Tcommaaccent adieresis -120\r\nKPX Tcommaaccent agrave -120\r\nKPX Tcommaaccent amacron -60\r\nKPX Tcommaaccent aogonek -120\r\nKPX Tcommaaccent aring -120\r\nKPX Tcommaaccent atilde -60\r\nKPX Tcommaaccent colon -20\r\nKPX Tcommaaccent comma -120\r\nKPX Tcommaaccent e -120\r\nKPX Tcommaaccent eacute -120\r\nKPX Tcommaaccent ecaron -120\r\nKPX Tcommaaccent ecircumflex -120\r\nKPX Tcommaaccent edieresis -120\r\nKPX Tcommaaccent edotaccent -120\r\nKPX Tcommaaccent egrave -60\r\nKPX Tcommaaccent emacron -60\r\nKPX Tcommaaccent eogonek -120\r\nKPX Tcommaaccent hyphen -140\r\nKPX Tcommaaccent o -120\r\nKPX Tcommaaccent oacute -120\r\nKPX Tcommaaccent ocircumflex -120\r\nKPX Tcommaaccent odieresis -120\r\nKPX Tcommaaccent ograve -120\r\nKPX Tcommaaccent ohungarumlaut -120\r\nKPX Tcommaaccent omacron -60\r\nKPX Tcommaaccent oslash -120\r\nKPX Tcommaaccent otilde -60\r\nKPX Tcommaaccent period -120\r\nKPX Tcommaaccent r -120\r\nKPX Tcommaaccent racute -120\r\nKPX Tcommaaccent rcaron -120\r\nKPX Tcommaaccent rcommaaccent -120\r\nKPX Tcommaaccent semicolon -20\r\nKPX Tcommaaccent u -120\r\nKPX Tcommaaccent uacute -120\r\nKPX Tcommaaccent ucircumflex -120\r\nKPX Tcommaaccent udieresis -120\r\nKPX Tcommaaccent ugrave -120\r\nKPX Tcommaaccent uhungarumlaut -120\r\nKPX Tcommaaccent umacron -60\r\nKPX Tcommaaccent uogonek -120\r\nKPX Tcommaaccent uring -120\r\nKPX Tcommaaccent w -120\r\nKPX Tcommaaccent y -120\r\nKPX Tcommaaccent yacute -120\r\nKPX Tcommaaccent ydieresis -60\r\nKPX U A -40\r\nKPX U Aacute -40\r\nKPX U Abreve -40\r\nKPX U Acircumflex -40\r\nKPX U Adieresis -40\r\nKPX U Agrave -40\r\nKPX U Amacron -40\r\nKPX U Aogonek -40\r\nKPX U Aring -40\r\nKPX U Atilde -40\r\nKPX U comma -40\r\nKPX U period -40\r\nKPX Uacute A -40\r\nKPX Uacute Aacute -40\r\nKPX Uacute Abreve -40\r\nKPX Uacute Acircumflex -40\r\nKPX Uacute Adieresis -40\r\nKPX Uacute Agrave -40\r\nKPX Uacute Amacron -40\r\nKPX Uacute Aogonek -40\r\nKPX Uacute Aring -40\r\nKPX Uacute Atilde -40\r\nKPX Uacute comma -40\r\nKPX Uacute period -40\r\nKPX Ucircumflex A -40\r\nKPX Ucircumflex Aacute -40\r\nKPX Ucircumflex Abreve -40\r\nKPX Ucircumflex Acircumflex -40\r\nKPX Ucircumflex Adieresis -40\r\nKPX Ucircumflex Agrave -40\r\nKPX Ucircumflex Amacron -40\r\nKPX Ucircumflex Aogonek -40\r\nKPX Ucircumflex Aring -40\r\nKPX Ucircumflex Atilde -40\r\nKPX Ucircumflex comma -40\r\nKPX Ucircumflex period -40\r\nKPX Udieresis A -40\r\nKPX Udieresis Aacute -40\r\nKPX Udieresis Abreve -40\r\nKPX Udieresis Acircumflex -40\r\nKPX Udieresis Adieresis -40\r\nKPX Udieresis Agrave -40\r\nKPX Udieresis Amacron -40\r\nKPX Udieresis Aogonek -40\r\nKPX Udieresis Aring -40\r\nKPX Udieresis Atilde -40\r\nKPX Udieresis comma -40\r\nKPX Udieresis period -40\r\nKPX Ugrave A -40\r\nKPX Ugrave Aacute -40\r\nKPX Ugrave Abreve -40\r\nKPX Ugrave Acircumflex -40\r\nKPX Ugrave Adieresis -40\r\nKPX Ugrave Agrave -40\r\nKPX Ugrave Amacron -40\r\nKPX Ugrave Aogonek -40\r\nKPX Ugrave Aring -40\r\nKPX Ugrave Atilde -40\r\nKPX Ugrave comma -40\r\nKPX Ugrave period -40\r\nKPX Uhungarumlaut A -40\r\nKPX Uhungarumlaut Aacute -40\r\nKPX Uhungarumlaut Abreve -40\r\nKPX Uhungarumlaut Acircumflex -40\r\nKPX Uhungarumlaut Adieresis -40\r\nKPX Uhungarumlaut Agrave -40\r\nKPX Uhungarumlaut Amacron -40\r\nKPX Uhungarumlaut Aogonek -40\r\nKPX Uhungarumlaut Aring -40\r\nKPX Uhungarumlaut Atilde -40\r\nKPX Uhungarumlaut comma -40\r\nKPX Uhungarumlaut period -40\r\nKPX Umacron A -40\r\nKPX Umacron Aacute -40\r\nKPX Umacron Abreve -40\r\nKPX Umacron Acircumflex -40\r\nKPX Umacron Adieresis -40\r\nKPX Umacron Agrave -40\r\nKPX Umacron Amacron -40\r\nKPX Umacron Aogonek -40\r\nKPX Umacron Aring -40\r\nKPX Umacron Atilde -40\r\nKPX Umacron comma -40\r\nKPX Umacron period -40\r\nKPX Uogonek A -40\r\nKPX Uogonek Aacute -40\r\nKPX Uogonek Abreve -40\r\nKPX Uogonek Acircumflex -40\r\nKPX Uogonek Adieresis -40\r\nKPX Uogonek Agrave -40\r\nKPX Uogonek Amacron -40\r\nKPX Uogonek Aogonek -40\r\nKPX Uogonek Aring -40\r\nKPX Uogonek Atilde -40\r\nKPX Uogonek comma -40\r\nKPX Uogonek period -40\r\nKPX Uring A -40\r\nKPX Uring Aacute -40\r\nKPX Uring Abreve -40\r\nKPX Uring Acircumflex -40\r\nKPX Uring Adieresis -40\r\nKPX Uring Agrave -40\r\nKPX Uring Amacron -40\r\nKPX Uring Aogonek -40\r\nKPX Uring Aring -40\r\nKPX Uring Atilde -40\r\nKPX Uring comma -40\r\nKPX Uring period -40\r\nKPX V A -80\r\nKPX V Aacute -80\r\nKPX V Abreve -80\r\nKPX V Acircumflex -80\r\nKPX V Adieresis -80\r\nKPX V Agrave -80\r\nKPX V Amacron -80\r\nKPX V Aogonek -80\r\nKPX V Aring -80\r\nKPX V Atilde -80\r\nKPX V G -40\r\nKPX V Gbreve -40\r\nKPX V Gcommaaccent -40\r\nKPX V O -40\r\nKPX V Oacute -40\r\nKPX V Ocircumflex -40\r\nKPX V Odieresis -40\r\nKPX V Ograve -40\r\nKPX V Ohungarumlaut -40\r\nKPX V Omacron -40\r\nKPX V Oslash -40\r\nKPX V Otilde -40\r\nKPX V a -70\r\nKPX V aacute -70\r\nKPX V abreve -70\r\nKPX V acircumflex -70\r\nKPX V adieresis -70\r\nKPX V agrave -70\r\nKPX V amacron -70\r\nKPX V aogonek -70\r\nKPX V aring -70\r\nKPX V atilde -70\r\nKPX V colon -40\r\nKPX V comma -125\r\nKPX V e -80\r\nKPX V eacute -80\r\nKPX V ecaron -80\r\nKPX V ecircumflex -80\r\nKPX V edieresis -80\r\nKPX V edotaccent -80\r\nKPX V egrave -80\r\nKPX V emacron -80\r\nKPX V eogonek -80\r\nKPX V hyphen -80\r\nKPX V o -80\r\nKPX V oacute -80\r\nKPX V ocircumflex -80\r\nKPX V odieresis -80\r\nKPX V ograve -80\r\nKPX V ohungarumlaut -80\r\nKPX V omacron -80\r\nKPX V oslash -80\r\nKPX V otilde -80\r\nKPX V period -125\r\nKPX V semicolon -40\r\nKPX V u -70\r\nKPX V uacute -70\r\nKPX V ucircumflex -70\r\nKPX V udieresis -70\r\nKPX V ugrave -70\r\nKPX V uhungarumlaut -70\r\nKPX V umacron -70\r\nKPX V uogonek -70\r\nKPX V uring -70\r\nKPX W A -50\r\nKPX W Aacute -50\r\nKPX W Abreve -50\r\nKPX W Acircumflex -50\r\nKPX W Adieresis -50\r\nKPX W Agrave -50\r\nKPX W Amacron -50\r\nKPX W Aogonek -50\r\nKPX W Aring -50\r\nKPX W Atilde -50\r\nKPX W O -20\r\nKPX W Oacute -20\r\nKPX W Ocircumflex -20\r\nKPX W Odieresis -20\r\nKPX W Ograve -20\r\nKPX W Ohungarumlaut -20\r\nKPX W Omacron -20\r\nKPX W Oslash -20\r\nKPX W Otilde -20\r\nKPX W a -40\r\nKPX W aacute -40\r\nKPX W abreve -40\r\nKPX W acircumflex -40\r\nKPX W adieresis -40\r\nKPX W agrave -40\r\nKPX W amacron -40\r\nKPX W aogonek -40\r\nKPX W aring -40\r\nKPX W atilde -40\r\nKPX W comma -80\r\nKPX W e -30\r\nKPX W eacute -30\r\nKPX W ecaron -30\r\nKPX W ecircumflex -30\r\nKPX W edieresis -30\r\nKPX W edotaccent -30\r\nKPX W egrave -30\r\nKPX W emacron -30\r\nKPX W eogonek -30\r\nKPX W hyphen -40\r\nKPX W o -30\r\nKPX W oacute -30\r\nKPX W ocircumflex -30\r\nKPX W odieresis -30\r\nKPX W ograve -30\r\nKPX W ohungarumlaut -30\r\nKPX W omacron -30\r\nKPX W oslash -30\r\nKPX W otilde -30\r\nKPX W period -80\r\nKPX W u -30\r\nKPX W uacute -30\r\nKPX W ucircumflex -30\r\nKPX W udieresis -30\r\nKPX W ugrave -30\r\nKPX W uhungarumlaut -30\r\nKPX W umacron -30\r\nKPX W uogonek -30\r\nKPX W uring -30\r\nKPX W y -20\r\nKPX W yacute -20\r\nKPX W ydieresis -20\r\nKPX Y A -110\r\nKPX Y Aacute -110\r\nKPX Y Abreve -110\r\nKPX Y Acircumflex -110\r\nKPX Y Adieresis -110\r\nKPX Y Agrave -110\r\nKPX Y Amacron -110\r\nKPX Y Aogonek -110\r\nKPX Y Aring -110\r\nKPX Y Atilde -110\r\nKPX Y O -85\r\nKPX Y Oacute -85\r\nKPX Y Ocircumflex -85\r\nKPX Y Odieresis -85\r\nKPX Y Ograve -85\r\nKPX Y Ohungarumlaut -85\r\nKPX Y Omacron -85\r\nKPX Y Oslash -85\r\nKPX Y Otilde -85\r\nKPX Y a -140\r\nKPX Y aacute -140\r\nKPX Y abreve -70\r\nKPX Y acircumflex -140\r\nKPX Y adieresis -140\r\nKPX Y agrave -140\r\nKPX Y amacron -70\r\nKPX Y aogonek -140\r\nKPX Y aring -140\r\nKPX Y atilde -140\r\nKPX Y colon -60\r\nKPX Y comma -140\r\nKPX Y e -140\r\nKPX Y eacute -140\r\nKPX Y ecaron -140\r\nKPX Y ecircumflex -140\r\nKPX Y edieresis -140\r\nKPX Y edotaccent -140\r\nKPX Y egrave -140\r\nKPX Y emacron -70\r\nKPX Y eogonek -140\r\nKPX Y hyphen -140\r\nKPX Y i -20\r\nKPX Y iacute -20\r\nKPX Y iogonek -20\r\nKPX Y o -140\r\nKPX Y oacute -140\r\nKPX Y ocircumflex -140\r\nKPX Y odieresis -140\r\nKPX Y ograve -140\r\nKPX Y ohungarumlaut -140\r\nKPX Y omacron -140\r\nKPX Y oslash -140\r\nKPX Y otilde -140\r\nKPX Y period -140\r\nKPX Y semicolon -60\r\nKPX Y u -110\r\nKPX Y uacute -110\r\nKPX Y ucircumflex -110\r\nKPX Y udieresis -110\r\nKPX Y ugrave -110\r\nKPX Y uhungarumlaut -110\r\nKPX Y umacron -110\r\nKPX Y uogonek -110\r\nKPX Y uring -110\r\nKPX Yacute A -110\r\nKPX Yacute Aacute -110\r\nKPX Yacute Abreve -110\r\nKPX Yacute Acircumflex -110\r\nKPX Yacute Adieresis -110\r\nKPX Yacute Agrave -110\r\nKPX Yacute Amacron -110\r\nKPX Yacute Aogonek -110\r\nKPX Yacute Aring -110\r\nKPX Yacute Atilde -110\r\nKPX Yacute O -85\r\nKPX Yacute Oacute -85\r\nKPX Yacute Ocircumflex -85\r\nKPX Yacute Odieresis -85\r\nKPX Yacute Ograve -85\r\nKPX Yacute Ohungarumlaut -85\r\nKPX Yacute Omacron -85\r\nKPX Yacute Oslash -85\r\nKPX Yacute Otilde -85\r\nKPX Yacute a -140\r\nKPX Yacute aacute -140\r\nKPX Yacute abreve -70\r\nKPX Yacute acircumflex -140\r\nKPX Yacute adieresis -140\r\nKPX Yacute agrave -140\r\nKPX Yacute amacron -70\r\nKPX Yacute aogonek -140\r\nKPX Yacute aring -140\r\nKPX Yacute atilde -70\r\nKPX Yacute colon -60\r\nKPX Yacute comma -140\r\nKPX Yacute e -140\r\nKPX Yacute eacute -140\r\nKPX Yacute ecaron -140\r\nKPX Yacute ecircumflex -140\r\nKPX Yacute edieresis -140\r\nKPX Yacute edotaccent -140\r\nKPX Yacute egrave -140\r\nKPX Yacute emacron -70\r\nKPX Yacute eogonek -140\r\nKPX Yacute hyphen -140\r\nKPX Yacute i -20\r\nKPX Yacute iacute -20\r\nKPX Yacute iogonek -20\r\nKPX Yacute o -140\r\nKPX Yacute oacute -140\r\nKPX Yacute ocircumflex -140\r\nKPX Yacute odieresis -140\r\nKPX Yacute ograve -140\r\nKPX Yacute ohungarumlaut -140\r\nKPX Yacute omacron -70\r\nKPX Yacute oslash -140\r\nKPX Yacute otilde -140\r\nKPX Yacute period -140\r\nKPX Yacute semicolon -60\r\nKPX Yacute u -110\r\nKPX Yacute uacute -110\r\nKPX Yacute ucircumflex -110\r\nKPX Yacute udieresis -110\r\nKPX Yacute ugrave -110\r\nKPX Yacute uhungarumlaut -110\r\nKPX Yacute umacron -110\r\nKPX Yacute uogonek -110\r\nKPX Yacute uring -110\r\nKPX Ydieresis A -110\r\nKPX Ydieresis Aacute -110\r\nKPX Ydieresis Abreve -110\r\nKPX Ydieresis Acircumflex -110\r\nKPX Ydieresis Adieresis -110\r\nKPX Ydieresis Agrave -110\r\nKPX Ydieresis Amacron -110\r\nKPX Ydieresis Aogonek -110\r\nKPX Ydieresis Aring -110\r\nKPX Ydieresis Atilde -110\r\nKPX Ydieresis O -85\r\nKPX Ydieresis Oacute -85\r\nKPX Ydieresis Ocircumflex -85\r\nKPX Ydieresis Odieresis -85\r\nKPX Ydieresis Ograve -85\r\nKPX Ydieresis Ohungarumlaut -85\r\nKPX Ydieresis Omacron -85\r\nKPX Ydieresis Oslash -85\r\nKPX Ydieresis Otilde -85\r\nKPX Ydieresis a -140\r\nKPX Ydieresis aacute -140\r\nKPX Ydieresis abreve -70\r\nKPX Ydieresis acircumflex -140\r\nKPX Ydieresis adieresis -140\r\nKPX Ydieresis agrave -140\r\nKPX Ydieresis amacron -70\r\nKPX Ydieresis aogonek -140\r\nKPX Ydieresis aring -140\r\nKPX Ydieresis atilde -70\r\nKPX Ydieresis colon -60\r\nKPX Ydieresis comma -140\r\nKPX Ydieresis e -140\r\nKPX Ydieresis eacute -140\r\nKPX Ydieresis ecaron -140\r\nKPX Ydieresis ecircumflex -140\r\nKPX Ydieresis edieresis -140\r\nKPX Ydieresis edotaccent -140\r\nKPX Ydieresis egrave -140\r\nKPX Ydieresis emacron -70\r\nKPX Ydieresis eogonek -140\r\nKPX Ydieresis hyphen -140\r\nKPX Ydieresis i -20\r\nKPX Ydieresis iacute -20\r\nKPX Ydieresis iogonek -20\r\nKPX Ydieresis o -140\r\nKPX Ydieresis oacute -140\r\nKPX Ydieresis ocircumflex -140\r\nKPX Ydieresis odieresis -140\r\nKPX Ydieresis ograve -140\r\nKPX Ydieresis ohungarumlaut -140\r\nKPX Ydieresis omacron -140\r\nKPX Ydieresis oslash -140\r\nKPX Ydieresis otilde -140\r\nKPX Ydieresis period -140\r\nKPX Ydieresis semicolon -60\r\nKPX Ydieresis u -110\r\nKPX Ydieresis uacute -110\r\nKPX Ydieresis ucircumflex -110\r\nKPX Ydieresis udieresis -110\r\nKPX Ydieresis ugrave -110\r\nKPX Ydieresis uhungarumlaut -110\r\nKPX Ydieresis umacron -110\r\nKPX Ydieresis uogonek -110\r\nKPX Ydieresis uring -110\r\nKPX a v -20\r\nKPX a w -20\r\nKPX a y -30\r\nKPX a yacute -30\r\nKPX a ydieresis -30\r\nKPX aacute v -20\r\nKPX aacute w -20\r\nKPX aacute y -30\r\nKPX aacute yacute -30\r\nKPX aacute ydieresis -30\r\nKPX abreve v -20\r\nKPX abreve w -20\r\nKPX abreve y -30\r\nKPX abreve yacute -30\r\nKPX abreve ydieresis -30\r\nKPX acircumflex v -20\r\nKPX acircumflex w -20\r\nKPX acircumflex y -30\r\nKPX acircumflex yacute -30\r\nKPX acircumflex ydieresis -30\r\nKPX adieresis v -20\r\nKPX adieresis w -20\r\nKPX adieresis y -30\r\nKPX adieresis yacute -30\r\nKPX adieresis ydieresis -30\r\nKPX agrave v -20\r\nKPX agrave w -20\r\nKPX agrave y -30\r\nKPX agrave yacute -30\r\nKPX agrave ydieresis -30\r\nKPX amacron v -20\r\nKPX amacron w -20\r\nKPX amacron y -30\r\nKPX amacron yacute -30\r\nKPX amacron ydieresis -30\r\nKPX aogonek v -20\r\nKPX aogonek w -20\r\nKPX aogonek y -30\r\nKPX aogonek yacute -30\r\nKPX aogonek ydieresis -30\r\nKPX aring v -20\r\nKPX aring w -20\r\nKPX aring y -30\r\nKPX aring yacute -30\r\nKPX aring ydieresis -30\r\nKPX atilde v -20\r\nKPX atilde w -20\r\nKPX atilde y -30\r\nKPX atilde yacute -30\r\nKPX atilde ydieresis -30\r\nKPX b b -10\r\nKPX b comma -40\r\nKPX b l -20\r\nKPX b lacute -20\r\nKPX b lcommaaccent -20\r\nKPX b lslash -20\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -20\r\nKPX b y -20\r\nKPX b yacute -20\r\nKPX b ydieresis -20\r\nKPX c comma -15\r\nKPX c k -20\r\nKPX c kcommaaccent -20\r\nKPX cacute comma -15\r\nKPX cacute k -20\r\nKPX cacute kcommaaccent -20\r\nKPX ccaron comma -15\r\nKPX ccaron k -20\r\nKPX ccaron kcommaaccent -20\r\nKPX ccedilla comma -15\r\nKPX ccedilla k -20\r\nKPX ccedilla kcommaaccent -20\r\nKPX colon space -50\r\nKPX comma quotedblright -100\r\nKPX comma quoteright -100\r\nKPX e comma -15\r\nKPX e period -15\r\nKPX e v -30\r\nKPX e w -20\r\nKPX e x -30\r\nKPX e y -20\r\nKPX e yacute -20\r\nKPX e ydieresis -20\r\nKPX eacute comma -15\r\nKPX eacute period -15\r\nKPX eacute v -30\r\nKPX eacute w -20\r\nKPX eacute x -30\r\nKPX eacute y -20\r\nKPX eacute yacute -20\r\nKPX eacute ydieresis -20\r\nKPX ecaron comma -15\r\nKPX ecaron period -15\r\nKPX ecaron v -30\r\nKPX ecaron w -20\r\nKPX ecaron x -30\r\nKPX ecaron y -20\r\nKPX ecaron yacute -20\r\nKPX ecaron ydieresis -20\r\nKPX ecircumflex comma -15\r\nKPX ecircumflex period -15\r\nKPX ecircumflex v -30\r\nKPX ecircumflex w -20\r\nKPX ecircumflex x -30\r\nKPX ecircumflex y -20\r\nKPX ecircumflex yacute -20\r\nKPX ecircumflex ydieresis -20\r\nKPX edieresis comma -15\r\nKPX edieresis period -15\r\nKPX edieresis v -30\r\nKPX edieresis w -20\r\nKPX edieresis x -30\r\nKPX edieresis y -20\r\nKPX edieresis yacute -20\r\nKPX edieresis ydieresis -20\r\nKPX edotaccent comma -15\r\nKPX edotaccent period -15\r\nKPX edotaccent v -30\r\nKPX edotaccent w -20\r\nKPX edotaccent x -30\r\nKPX edotaccent y -20\r\nKPX edotaccent yacute -20\r\nKPX edotaccent ydieresis -20\r\nKPX egrave comma -15\r\nKPX egrave period -15\r\nKPX egrave v -30\r\nKPX egrave w -20\r\nKPX egrave x -30\r\nKPX egrave y -20\r\nKPX egrave yacute -20\r\nKPX egrave ydieresis -20\r\nKPX emacron comma -15\r\nKPX emacron period -15\r\nKPX emacron v -30\r\nKPX emacron w -20\r\nKPX emacron x -30\r\nKPX emacron y -20\r\nKPX emacron yacute -20\r\nKPX emacron ydieresis -20\r\nKPX eogonek comma -15\r\nKPX eogonek period -15\r\nKPX eogonek v -30\r\nKPX eogonek w -20\r\nKPX eogonek x -30\r\nKPX eogonek y -20\r\nKPX eogonek yacute -20\r\nKPX eogonek ydieresis -20\r\nKPX f a -30\r\nKPX f aacute -30\r\nKPX f abreve -30\r\nKPX f acircumflex -30\r\nKPX f adieresis -30\r\nKPX f agrave -30\r\nKPX f amacron -30\r\nKPX f aogonek -30\r\nKPX f aring -30\r\nKPX f atilde -30\r\nKPX f comma -30\r\nKPX f dotlessi -28\r\nKPX f e -30\r\nKPX f eacute -30\r\nKPX f ecaron -30\r\nKPX f ecircumflex -30\r\nKPX f edieresis -30\r\nKPX f edotaccent -30\r\nKPX f egrave -30\r\nKPX f emacron -30\r\nKPX f eogonek -30\r\nKPX f o -30\r\nKPX f oacute -30\r\nKPX f ocircumflex -30\r\nKPX f odieresis -30\r\nKPX f ograve -30\r\nKPX f ohungarumlaut -30\r\nKPX f omacron -30\r\nKPX f oslash -30\r\nKPX f otilde -30\r\nKPX f period -30\r\nKPX f quotedblright 60\r\nKPX f quoteright 50\r\nKPX g r -10\r\nKPX g racute -10\r\nKPX g rcaron -10\r\nKPX g rcommaaccent -10\r\nKPX gbreve r -10\r\nKPX gbreve racute -10\r\nKPX gbreve rcaron -10\r\nKPX gbreve rcommaaccent -10\r\nKPX gcommaaccent r -10\r\nKPX gcommaaccent racute -10\r\nKPX gcommaaccent rcaron -10\r\nKPX gcommaaccent rcommaaccent -10\r\nKPX h y -30\r\nKPX h yacute -30\r\nKPX h ydieresis -30\r\nKPX k e -20\r\nKPX k eacute -20\r\nKPX k ecaron -20\r\nKPX k ecircumflex -20\r\nKPX k edieresis -20\r\nKPX k edotaccent -20\r\nKPX k egrave -20\r\nKPX k emacron -20\r\nKPX k eogonek -20\r\nKPX k o -20\r\nKPX k oacute -20\r\nKPX k ocircumflex -20\r\nKPX k odieresis -20\r\nKPX k ograve -20\r\nKPX k ohungarumlaut -20\r\nKPX k omacron -20\r\nKPX k oslash -20\r\nKPX k otilde -20\r\nKPX kcommaaccent e -20\r\nKPX kcommaaccent eacute -20\r\nKPX kcommaaccent ecaron -20\r\nKPX kcommaaccent ecircumflex -20\r\nKPX kcommaaccent edieresis -20\r\nKPX kcommaaccent edotaccent -20\r\nKPX kcommaaccent egrave -20\r\nKPX kcommaaccent emacron -20\r\nKPX kcommaaccent eogonek -20\r\nKPX kcommaaccent o -20\r\nKPX kcommaaccent oacute -20\r\nKPX kcommaaccent ocircumflex -20\r\nKPX kcommaaccent odieresis -20\r\nKPX kcommaaccent ograve -20\r\nKPX kcommaaccent ohungarumlaut -20\r\nKPX kcommaaccent omacron -20\r\nKPX kcommaaccent oslash -20\r\nKPX kcommaaccent otilde -20\r\nKPX m u -10\r\nKPX m uacute -10\r\nKPX m ucircumflex -10\r\nKPX m udieresis -10\r\nKPX m ugrave -10\r\nKPX m uhungarumlaut -10\r\nKPX m umacron -10\r\nKPX m uogonek -10\r\nKPX m uring -10\r\nKPX m y -15\r\nKPX m yacute -15\r\nKPX m ydieresis -15\r\nKPX n u -10\r\nKPX n uacute -10\r\nKPX n ucircumflex -10\r\nKPX n udieresis -10\r\nKPX n ugrave -10\r\nKPX n uhungarumlaut -10\r\nKPX n umacron -10\r\nKPX n uogonek -10\r\nKPX n uring -10\r\nKPX n v -20\r\nKPX n y -15\r\nKPX n yacute -15\r\nKPX n ydieresis -15\r\nKPX nacute u -10\r\nKPX nacute uacute -10\r\nKPX nacute ucircumflex -10\r\nKPX nacute udieresis -10\r\nKPX nacute ugrave -10\r\nKPX nacute uhungarumlaut -10\r\nKPX nacute umacron -10\r\nKPX nacute uogonek -10\r\nKPX nacute uring -10\r\nKPX nacute v -20\r\nKPX nacute y -15\r\nKPX nacute yacute -15\r\nKPX nacute ydieresis -15\r\nKPX ncaron u -10\r\nKPX ncaron uacute -10\r\nKPX ncaron ucircumflex -10\r\nKPX ncaron udieresis -10\r\nKPX ncaron ugrave -10\r\nKPX ncaron uhungarumlaut -10\r\nKPX ncaron umacron -10\r\nKPX ncaron uogonek -10\r\nKPX ncaron uring -10\r\nKPX ncaron v -20\r\nKPX ncaron y -15\r\nKPX ncaron yacute -15\r\nKPX ncaron ydieresis -15\r\nKPX ncommaaccent u -10\r\nKPX ncommaaccent uacute -10\r\nKPX ncommaaccent ucircumflex -10\r\nKPX ncommaaccent udieresis -10\r\nKPX ncommaaccent ugrave -10\r\nKPX ncommaaccent uhungarumlaut -10\r\nKPX ncommaaccent umacron -10\r\nKPX ncommaaccent uogonek -10\r\nKPX ncommaaccent uring -10\r\nKPX ncommaaccent v -20\r\nKPX ncommaaccent y -15\r\nKPX ncommaaccent yacute -15\r\nKPX ncommaaccent ydieresis -15\r\nKPX ntilde u -10\r\nKPX ntilde uacute -10\r\nKPX ntilde ucircumflex -10\r\nKPX ntilde udieresis -10\r\nKPX ntilde ugrave -10\r\nKPX ntilde uhungarumlaut -10\r\nKPX ntilde umacron -10\r\nKPX ntilde uogonek -10\r\nKPX ntilde uring -10\r\nKPX ntilde v -20\r\nKPX ntilde y -15\r\nKPX ntilde yacute -15\r\nKPX ntilde ydieresis -15\r\nKPX o comma -40\r\nKPX o period -40\r\nKPX o v -15\r\nKPX o w -15\r\nKPX o x -30\r\nKPX o y -30\r\nKPX o yacute -30\r\nKPX o ydieresis -30\r\nKPX oacute comma -40\r\nKPX oacute period -40\r\nKPX oacute v -15\r\nKPX oacute w -15\r\nKPX oacute x -30\r\nKPX oacute y -30\r\nKPX oacute yacute -30\r\nKPX oacute ydieresis -30\r\nKPX ocircumflex comma -40\r\nKPX ocircumflex period -40\r\nKPX ocircumflex v -15\r\nKPX ocircumflex w -15\r\nKPX ocircumflex x -30\r\nKPX ocircumflex y -30\r\nKPX ocircumflex yacute -30\r\nKPX ocircumflex ydieresis -30\r\nKPX odieresis comma -40\r\nKPX odieresis period -40\r\nKPX odieresis v -15\r\nKPX odieresis w -15\r\nKPX odieresis x -30\r\nKPX odieresis y -30\r\nKPX odieresis yacute -30\r\nKPX odieresis ydieresis -30\r\nKPX ograve comma -40\r\nKPX ograve period -40\r\nKPX ograve v -15\r\nKPX ograve w -15\r\nKPX ograve x -30\r\nKPX ograve y -30\r\nKPX ograve yacute -30\r\nKPX ograve ydieresis -30\r\nKPX ohungarumlaut comma -40\r\nKPX ohungarumlaut period -40\r\nKPX ohungarumlaut v -15\r\nKPX ohungarumlaut w -15\r\nKPX ohungarumlaut x -30\r\nKPX ohungarumlaut y -30\r\nKPX ohungarumlaut yacute -30\r\nKPX ohungarumlaut ydieresis -30\r\nKPX omacron comma -40\r\nKPX omacron period -40\r\nKPX omacron v -15\r\nKPX omacron w -15\r\nKPX omacron x -30\r\nKPX omacron y -30\r\nKPX omacron yacute -30\r\nKPX omacron ydieresis -30\r\nKPX oslash a -55\r\nKPX oslash aacute -55\r\nKPX oslash abreve -55\r\nKPX oslash acircumflex -55\r\nKPX oslash adieresis -55\r\nKPX oslash agrave -55\r\nKPX oslash amacron -55\r\nKPX oslash aogonek -55\r\nKPX oslash aring -55\r\nKPX oslash atilde -55\r\nKPX oslash b -55\r\nKPX oslash c -55\r\nKPX oslash cacute -55\r\nKPX oslash ccaron -55\r\nKPX oslash ccedilla -55\r\nKPX oslash comma -95\r\nKPX oslash d -55\r\nKPX oslash dcroat -55\r\nKPX oslash e -55\r\nKPX oslash eacute -55\r\nKPX oslash ecaron -55\r\nKPX oslash ecircumflex -55\r\nKPX oslash edieresis -55\r\nKPX oslash edotaccent -55\r\nKPX oslash egrave -55\r\nKPX oslash emacron -55\r\nKPX oslash eogonek -55\r\nKPX oslash f -55\r\nKPX oslash g -55\r\nKPX oslash gbreve -55\r\nKPX oslash gcommaaccent -55\r\nKPX oslash h -55\r\nKPX oslash i -55\r\nKPX oslash iacute -55\r\nKPX oslash icircumflex -55\r\nKPX oslash idieresis -55\r\nKPX oslash igrave -55\r\nKPX oslash imacron -55\r\nKPX oslash iogonek -55\r\nKPX oslash j -55\r\nKPX oslash k -55\r\nKPX oslash kcommaaccent -55\r\nKPX oslash l -55\r\nKPX oslash lacute -55\r\nKPX oslash lcommaaccent -55\r\nKPX oslash lslash -55\r\nKPX oslash m -55\r\nKPX oslash n -55\r\nKPX oslash nacute -55\r\nKPX oslash ncaron -55\r\nKPX oslash ncommaaccent -55\r\nKPX oslash ntilde -55\r\nKPX oslash o -55\r\nKPX oslash oacute -55\r\nKPX oslash ocircumflex -55\r\nKPX oslash odieresis -55\r\nKPX oslash ograve -55\r\nKPX oslash ohungarumlaut -55\r\nKPX oslash omacron -55\r\nKPX oslash oslash -55\r\nKPX oslash otilde -55\r\nKPX oslash p -55\r\nKPX oslash period -95\r\nKPX oslash q -55\r\nKPX oslash r -55\r\nKPX oslash racute -55\r\nKPX oslash rcaron -55\r\nKPX oslash rcommaaccent -55\r\nKPX oslash s -55\r\nKPX oslash sacute -55\r\nKPX oslash scaron -55\r\nKPX oslash scedilla -55\r\nKPX oslash scommaaccent -55\r\nKPX oslash t -55\r\nKPX oslash tcommaaccent -55\r\nKPX oslash u -55\r\nKPX oslash uacute -55\r\nKPX oslash ucircumflex -55\r\nKPX oslash udieresis -55\r\nKPX oslash ugrave -55\r\nKPX oslash uhungarumlaut -55\r\nKPX oslash umacron -55\r\nKPX oslash uogonek -55\r\nKPX oslash uring -55\r\nKPX oslash v -70\r\nKPX oslash w -70\r\nKPX oslash x -85\r\nKPX oslash y -70\r\nKPX oslash yacute -70\r\nKPX oslash ydieresis -70\r\nKPX oslash z -55\r\nKPX oslash zacute -55\r\nKPX oslash zcaron -55\r\nKPX oslash zdotaccent -55\r\nKPX otilde comma -40\r\nKPX otilde period -40\r\nKPX otilde v -15\r\nKPX otilde w -15\r\nKPX otilde x -30\r\nKPX otilde y -30\r\nKPX otilde yacute -30\r\nKPX otilde ydieresis -30\r\nKPX p comma -35\r\nKPX p period -35\r\nKPX p y -30\r\nKPX p yacute -30\r\nKPX p ydieresis -30\r\nKPX period quotedblright -100\r\nKPX period quoteright -100\r\nKPX period space -60\r\nKPX quotedblright space -40\r\nKPX quoteleft quoteleft -57\r\nKPX quoteright d -50\r\nKPX quoteright dcroat -50\r\nKPX quoteright quoteright -57\r\nKPX quoteright r -50\r\nKPX quoteright racute -50\r\nKPX quoteright rcaron -50\r\nKPX quoteright rcommaaccent -50\r\nKPX quoteright s -50\r\nKPX quoteright sacute -50\r\nKPX quoteright scaron -50\r\nKPX quoteright scedilla -50\r\nKPX quoteright scommaaccent -50\r\nKPX quoteright space -70\r\nKPX r a -10\r\nKPX r aacute -10\r\nKPX r abreve -10\r\nKPX r acircumflex -10\r\nKPX r adieresis -10\r\nKPX r agrave -10\r\nKPX r amacron -10\r\nKPX r aogonek -10\r\nKPX r aring -10\r\nKPX r atilde -10\r\nKPX r colon 30\r\nKPX r comma -50\r\nKPX r i 15\r\nKPX r iacute 15\r\nKPX r icircumflex 15\r\nKPX r idieresis 15\r\nKPX r igrave 15\r\nKPX r imacron 15\r\nKPX r iogonek 15\r\nKPX r k 15\r\nKPX r kcommaaccent 15\r\nKPX r l 15\r\nKPX r lacute 15\r\nKPX r lcommaaccent 15\r\nKPX r lslash 15\r\nKPX r m 25\r\nKPX r n 25\r\nKPX r nacute 25\r\nKPX r ncaron 25\r\nKPX r ncommaaccent 25\r\nKPX r ntilde 25\r\nKPX r p 30\r\nKPX r period -50\r\nKPX r semicolon 30\r\nKPX r t 40\r\nKPX r tcommaaccent 40\r\nKPX r u 15\r\nKPX r uacute 15\r\nKPX r ucircumflex 15\r\nKPX r udieresis 15\r\nKPX r ugrave 15\r\nKPX r uhungarumlaut 15\r\nKPX r umacron 15\r\nKPX r uogonek 15\r\nKPX r uring 15\r\nKPX r v 30\r\nKPX r y 30\r\nKPX r yacute 30\r\nKPX r ydieresis 30\r\nKPX racute a -10\r\nKPX racute aacute -10\r\nKPX racute abreve -10\r\nKPX racute acircumflex -10\r\nKPX racute adieresis -10\r\nKPX racute agrave -10\r\nKPX racute amacron -10\r\nKPX racute aogonek -10\r\nKPX racute aring -10\r\nKPX racute atilde -10\r\nKPX racute colon 30\r\nKPX racute comma -50\r\nKPX racute i 15\r\nKPX racute iacute 15\r\nKPX racute icircumflex 15\r\nKPX racute idieresis 15\r\nKPX racute igrave 15\r\nKPX racute imacron 15\r\nKPX racute iogonek 15\r\nKPX racute k 15\r\nKPX racute kcommaaccent 15\r\nKPX racute l 15\r\nKPX racute lacute 15\r\nKPX racute lcommaaccent 15\r\nKPX racute lslash 15\r\nKPX racute m 25\r\nKPX racute n 25\r\nKPX racute nacute 25\r\nKPX racute ncaron 25\r\nKPX racute ncommaaccent 25\r\nKPX racute ntilde 25\r\nKPX racute p 30\r\nKPX racute period -50\r\nKPX racute semicolon 30\r\nKPX racute t 40\r\nKPX racute tcommaaccent 40\r\nKPX racute u 15\r\nKPX racute uacute 15\r\nKPX racute ucircumflex 15\r\nKPX racute udieresis 15\r\nKPX racute ugrave 15\r\nKPX racute uhungarumlaut 15\r\nKPX racute umacron 15\r\nKPX racute uogonek 15\r\nKPX racute uring 15\r\nKPX racute v 30\r\nKPX racute y 30\r\nKPX racute yacute 30\r\nKPX racute ydieresis 30\r\nKPX rcaron a -10\r\nKPX rcaron aacute -10\r\nKPX rcaron abreve -10\r\nKPX rcaron acircumflex -10\r\nKPX rcaron adieresis -10\r\nKPX rcaron agrave -10\r\nKPX rcaron amacron -10\r\nKPX rcaron aogonek -10\r\nKPX rcaron aring -10\r\nKPX rcaron atilde -10\r\nKPX rcaron colon 30\r\nKPX rcaron comma -50\r\nKPX rcaron i 15\r\nKPX rcaron iacute 15\r\nKPX rcaron icircumflex 15\r\nKPX rcaron idieresis 15\r\nKPX rcaron igrave 15\r\nKPX rcaron imacron 15\r\nKPX rcaron iogonek 15\r\nKPX rcaron k 15\r\nKPX rcaron kcommaaccent 15\r\nKPX rcaron l 15\r\nKPX rcaron lacute 15\r\nKPX rcaron lcommaaccent 15\r\nKPX rcaron lslash 15\r\nKPX rcaron m 25\r\nKPX rcaron n 25\r\nKPX rcaron nacute 25\r\nKPX rcaron ncaron 25\r\nKPX rcaron ncommaaccent 25\r\nKPX rcaron ntilde 25\r\nKPX rcaron p 30\r\nKPX rcaron period -50\r\nKPX rcaron semicolon 30\r\nKPX rcaron t 40\r\nKPX rcaron tcommaaccent 40\r\nKPX rcaron u 15\r\nKPX rcaron uacute 15\r\nKPX rcaron ucircumflex 15\r\nKPX rcaron udieresis 15\r\nKPX rcaron ugrave 15\r\nKPX rcaron uhungarumlaut 15\r\nKPX rcaron umacron 15\r\nKPX rcaron uogonek 15\r\nKPX rcaron uring 15\r\nKPX rcaron v 30\r\nKPX rcaron y 30\r\nKPX rcaron yacute 30\r\nKPX rcaron ydieresis 30\r\nKPX rcommaaccent a -10\r\nKPX rcommaaccent aacute -10\r\nKPX rcommaaccent abreve -10\r\nKPX rcommaaccent acircumflex -10\r\nKPX rcommaaccent adieresis -10\r\nKPX rcommaaccent agrave -10\r\nKPX rcommaaccent amacron -10\r\nKPX rcommaaccent aogonek -10\r\nKPX rcommaaccent aring -10\r\nKPX rcommaaccent atilde -10\r\nKPX rcommaaccent colon 30\r\nKPX rcommaaccent comma -50\r\nKPX rcommaaccent i 15\r\nKPX rcommaaccent iacute 15\r\nKPX rcommaaccent icircumflex 15\r\nKPX rcommaaccent idieresis 15\r\nKPX rcommaaccent igrave 15\r\nKPX rcommaaccent imacron 15\r\nKPX rcommaaccent iogonek 15\r\nKPX rcommaaccent k 15\r\nKPX rcommaaccent kcommaaccent 15\r\nKPX rcommaaccent l 15\r\nKPX rcommaaccent lacute 15\r\nKPX rcommaaccent lcommaaccent 15\r\nKPX rcommaaccent lslash 15\r\nKPX rcommaaccent m 25\r\nKPX rcommaaccent n 25\r\nKPX rcommaaccent nacute 25\r\nKPX rcommaaccent ncaron 25\r\nKPX rcommaaccent ncommaaccent 25\r\nKPX rcommaaccent ntilde 25\r\nKPX rcommaaccent p 30\r\nKPX rcommaaccent period -50\r\nKPX rcommaaccent semicolon 30\r\nKPX rcommaaccent t 40\r\nKPX rcommaaccent tcommaaccent 40\r\nKPX rcommaaccent u 15\r\nKPX rcommaaccent uacute 15\r\nKPX rcommaaccent ucircumflex 15\r\nKPX rcommaaccent udieresis 15\r\nKPX rcommaaccent ugrave 15\r\nKPX rcommaaccent uhungarumlaut 15\r\nKPX rcommaaccent umacron 15\r\nKPX rcommaaccent uogonek 15\r\nKPX rcommaaccent uring 15\r\nKPX rcommaaccent v 30\r\nKPX rcommaaccent y 30\r\nKPX rcommaaccent yacute 30\r\nKPX rcommaaccent ydieresis 30\r\nKPX s comma -15\r\nKPX s period -15\r\nKPX s w -30\r\nKPX sacute comma -15\r\nKPX sacute period -15\r\nKPX sacute w -30\r\nKPX scaron comma -15\r\nKPX scaron period -15\r\nKPX scaron w -30\r\nKPX scedilla comma -15\r\nKPX scedilla period -15\r\nKPX scedilla w -30\r\nKPX scommaaccent comma -15\r\nKPX scommaaccent period -15\r\nKPX scommaaccent w -30\r\nKPX semicolon space -50\r\nKPX space T -50\r\nKPX space Tcaron -50\r\nKPX space Tcommaaccent -50\r\nKPX space V -50\r\nKPX space W -40\r\nKPX space Y -90\r\nKPX space Yacute -90\r\nKPX space Ydieresis -90\r\nKPX space quotedblleft -30\r\nKPX space quoteleft -60\r\nKPX v a -25\r\nKPX v aacute -25\r\nKPX v abreve -25\r\nKPX v acircumflex -25\r\nKPX v adieresis -25\r\nKPX v agrave -25\r\nKPX v amacron -25\r\nKPX v aogonek -25\r\nKPX v aring -25\r\nKPX v atilde -25\r\nKPX v comma -80\r\nKPX v e -25\r\nKPX v eacute -25\r\nKPX v ecaron -25\r\nKPX v ecircumflex -25\r\nKPX v edieresis -25\r\nKPX v edotaccent -25\r\nKPX v egrave -25\r\nKPX v emacron -25\r\nKPX v eogonek -25\r\nKPX v o -25\r\nKPX v oacute -25\r\nKPX v ocircumflex -25\r\nKPX v odieresis -25\r\nKPX v ograve -25\r\nKPX v ohungarumlaut -25\r\nKPX v omacron -25\r\nKPX v oslash -25\r\nKPX v otilde -25\r\nKPX v period -80\r\nKPX w a -15\r\nKPX w aacute -15\r\nKPX w abreve -15\r\nKPX w acircumflex -15\r\nKPX w adieresis -15\r\nKPX w agrave -15\r\nKPX w amacron -15\r\nKPX w aogonek -15\r\nKPX w aring -15\r\nKPX w atilde -15\r\nKPX w comma -60\r\nKPX w e -10\r\nKPX w eacute -10\r\nKPX w ecaron -10\r\nKPX w ecircumflex -10\r\nKPX w edieresis -10\r\nKPX w edotaccent -10\r\nKPX w egrave -10\r\nKPX w emacron -10\r\nKPX w eogonek -10\r\nKPX w o -10\r\nKPX w oacute -10\r\nKPX w ocircumflex -10\r\nKPX w odieresis -10\r\nKPX w ograve -10\r\nKPX w ohungarumlaut -10\r\nKPX w omacron -10\r\nKPX w oslash -10\r\nKPX w otilde -10\r\nKPX w period -60\r\nKPX x e -30\r\nKPX x eacute -30\r\nKPX x ecaron -30\r\nKPX x ecircumflex -30\r\nKPX x edieresis -30\r\nKPX x edotaccent -30\r\nKPX x egrave -30\r\nKPX x emacron -30\r\nKPX x eogonek -30\r\nKPX y a -20\r\nKPX y aacute -20\r\nKPX y abreve -20\r\nKPX y acircumflex -20\r\nKPX y adieresis -20\r\nKPX y agrave -20\r\nKPX y amacron -20\r\nKPX y aogonek -20\r\nKPX y aring -20\r\nKPX y atilde -20\r\nKPX y comma -100\r\nKPX y e -20\r\nKPX y eacute -20\r\nKPX y ecaron -20\r\nKPX y ecircumflex -20\r\nKPX y edieresis -20\r\nKPX y edotaccent -20\r\nKPX y egrave -20\r\nKPX y emacron -20\r\nKPX y eogonek -20\r\nKPX y o -20\r\nKPX y oacute -20\r\nKPX y ocircumflex -20\r\nKPX y odieresis -20\r\nKPX y ograve -20\r\nKPX y ohungarumlaut -20\r\nKPX y omacron -20\r\nKPX y oslash -20\r\nKPX y otilde -20\r\nKPX y period -100\r\nKPX yacute a -20\r\nKPX yacute aacute -20\r\nKPX yacute abreve -20\r\nKPX yacute acircumflex -20\r\nKPX yacute adieresis -20\r\nKPX yacute agrave -20\r\nKPX yacute amacron -20\r\nKPX yacute aogonek -20\r\nKPX yacute aring -20\r\nKPX yacute atilde -20\r\nKPX yacute comma -100\r\nKPX yacute e -20\r\nKPX yacute eacute -20\r\nKPX yacute ecaron -20\r\nKPX yacute ecircumflex -20\r\nKPX yacute edieresis -20\r\nKPX yacute edotaccent -20\r\nKPX yacute egrave -20\r\nKPX yacute emacron -20\r\nKPX yacute eogonek -20\r\nKPX yacute o -20\r\nKPX yacute oacute -20\r\nKPX yacute ocircumflex -20\r\nKPX yacute odieresis -20\r\nKPX yacute ograve -20\r\nKPX yacute ohungarumlaut -20\r\nKPX yacute omacron -20\r\nKPX yacute oslash -20\r\nKPX yacute otilde -20\r\nKPX yacute period -100\r\nKPX ydieresis a -20\r\nKPX ydieresis aacute -20\r\nKPX ydieresis abreve -20\r\nKPX ydieresis acircumflex -20\r\nKPX ydieresis adieresis -20\r\nKPX ydieresis agrave -20\r\nKPX ydieresis amacron -20\r\nKPX ydieresis aogonek -20\r\nKPX ydieresis aring -20\r\nKPX ydieresis atilde -20\r\nKPX ydieresis comma -100\r\nKPX ydieresis e -20\r\nKPX ydieresis eacute -20\r\nKPX ydieresis ecaron -20\r\nKPX ydieresis ecircumflex -20\r\nKPX ydieresis edieresis -20\r\nKPX ydieresis edotaccent -20\r\nKPX ydieresis egrave -20\r\nKPX ydieresis emacron -20\r\nKPX ydieresis eogonek -20\r\nKPX ydieresis o -20\r\nKPX ydieresis oacute -20\r\nKPX ydieresis ocircumflex -20\r\nKPX ydieresis odieresis -20\r\nKPX ydieresis ograve -20\r\nKPX ydieresis ohungarumlaut -20\r\nKPX ydieresis omacron -20\r\nKPX ydieresis oslash -20\r\nKPX ydieresis otilde -20\r\nKPX ydieresis period -100\r\nKPX z e -15\r\nKPX z eacute -15\r\nKPX z ecaron -15\r\nKPX z ecircumflex -15\r\nKPX z edieresis -15\r\nKPX z edotaccent -15\r\nKPX z egrave -15\r\nKPX z emacron -15\r\nKPX z eogonek -15\r\nKPX z o -15\r\nKPX z oacute -15\r\nKPX z ocircumflex -15\r\nKPX z odieresis -15\r\nKPX z ograve -15\r\nKPX z ohungarumlaut -15\r\nKPX z omacron -15\r\nKPX z oslash -15\r\nKPX z otilde -15\r\nKPX zacute e -15\r\nKPX zacute eacute -15\r\nKPX zacute ecaron -15\r\nKPX zacute ecircumflex -15\r\nKPX zacute edieresis -15\r\nKPX zacute edotaccent -15\r\nKPX zacute egrave -15\r\nKPX zacute emacron -15\r\nKPX zacute eogonek -15\r\nKPX zacute o -15\r\nKPX zacute oacute -15\r\nKPX zacute ocircumflex -15\r\nKPX zacute odieresis -15\r\nKPX zacute ograve -15\r\nKPX zacute ohungarumlaut -15\r\nKPX zacute omacron -15\r\nKPX zacute oslash -15\r\nKPX zacute otilde -15\r\nKPX zcaron e -15\r\nKPX zcaron eacute -15\r\nKPX zcaron ecaron -15\r\nKPX zcaron ecircumflex -15\r\nKPX zcaron edieresis -15\r\nKPX zcaron edotaccent -15\r\nKPX zcaron egrave -15\r\nKPX zcaron emacron -15\r\nKPX zcaron eogonek -15\r\nKPX zcaron o -15\r\nKPX zcaron oacute -15\r\nKPX zcaron ocircumflex -15\r\nKPX zcaron odieresis -15\r\nKPX zcaron ograve -15\r\nKPX zcaron ohungarumlaut -15\r\nKPX zcaron omacron -15\r\nKPX zcaron oslash -15\r\nKPX zcaron otilde -15\r\nKPX zdotaccent e -15\r\nKPX zdotaccent eacute -15\r\nKPX zdotaccent ecaron -15\r\nKPX zdotaccent ecircumflex -15\r\nKPX zdotaccent edieresis -15\r\nKPX zdotaccent edotaccent -15\r\nKPX zdotaccent egrave -15\r\nKPX zdotaccent emacron -15\r\nKPX zdotaccent eogonek -15\r\nKPX zdotaccent o -15\r\nKPX zdotaccent oacute -15\r\nKPX zdotaccent ocircumflex -15\r\nKPX zdotaccent odieresis -15\r\nKPX zdotaccent ograve -15\r\nKPX zdotaccent ohungarumlaut -15\r\nKPX zdotaccent omacron -15\r\nKPX zdotaccent oslash -15\r\nKPX zdotaccent otilde -15\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Helvetica-Bold"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:43:52 1997\r\nComment UniqueID 43052\r\nComment VMusage 37169 48194\r\nFontName Helvetica-Bold\r\nFullName Helvetica Bold\r\nFamilyName Helvetica\r\nWeight Bold\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -170 -228 1003 962 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 718\r\nXHeight 532\r\nAscender 718\r\nDescender -207\r\nStdHW 118\r\nStdVW 140\r\nStartCharMetrics 315\r\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 90 0 244 718 ;\r\nC 34 ; WX 474 ; N quotedbl ; B 98 447 376 718 ;\r\nC 35 ; WX 556 ; N numbersign ; B 18 0 538 698 ;\r\nC 36 ; WX 556 ; N dollar ; B 30 -115 523 775 ;\r\nC 37 ; WX 889 ; N percent ; B 28 -19 861 710 ;\r\nC 38 ; WX 722 ; N ampersand ; B 54 -19 701 718 ;\r\nC 39 ; WX 278 ; N quoteright ; B 69 445 209 718 ;\r\nC 40 ; WX 333 ; N parenleft ; B 35 -208 314 734 ;\r\nC 41 ; WX 333 ; N parenright ; B 19 -208 298 734 ;\r\nC 42 ; WX 389 ; N asterisk ; B 27 387 362 718 ;\r\nC 43 ; WX 584 ; N plus ; B 40 0 544 506 ;\r\nC 44 ; WX 278 ; N comma ; B 64 -168 214 146 ;\r\nC 45 ; WX 333 ; N hyphen ; B 27 215 306 345 ;\r\nC 46 ; WX 278 ; N period ; B 64 0 214 146 ;\r\nC 47 ; WX 278 ; N slash ; B -33 -19 311 737 ;\r\nC 48 ; WX 556 ; N zero ; B 32 -19 524 710 ;\r\nC 49 ; WX 556 ; N one ; B 69 0 378 710 ;\r\nC 50 ; WX 556 ; N two ; B 26 0 511 710 ;\r\nC 51 ; WX 556 ; N three ; B 27 -19 516 710 ;\r\nC 52 ; WX 556 ; N four ; B 27 0 526 710 ;\r\nC 53 ; WX 556 ; N five ; B 27 -19 516 698 ;\r\nC 54 ; WX 556 ; N six ; B 31 -19 520 710 ;\r\nC 55 ; WX 556 ; N seven ; B 25 0 528 698 ;\r\nC 56 ; WX 556 ; N eight ; B 32 -19 524 710 ;\r\nC 57 ; WX 556 ; N nine ; B 30 -19 522 710 ;\r\nC 58 ; WX 333 ; N colon ; B 92 0 242 512 ;\r\nC 59 ; WX 333 ; N semicolon ; B 92 -168 242 512 ;\r\nC 60 ; WX 584 ; N less ; B 38 -8 546 514 ;\r\nC 61 ; WX 584 ; N equal ; B 40 87 544 419 ;\r\nC 62 ; WX 584 ; N greater ; B 38 -8 546 514 ;\r\nC 63 ; WX 611 ; N question ; B 60 0 556 727 ;\r\nC 64 ; WX 975 ; N at ; B 118 -19 856 737 ;\r\nC 65 ; WX 722 ; N A ; B 20 0 702 718 ;\r\nC 66 ; WX 722 ; N B ; B 76 0 669 718 ;\r\nC 67 ; WX 722 ; N C ; B 44 -19 684 737 ;\r\nC 68 ; WX 722 ; N D ; B 76 0 685 718 ;\r\nC 69 ; WX 667 ; N E ; B 76 0 621 718 ;\r\nC 70 ; WX 611 ; N F ; B 76 0 587 718 ;\r\nC 71 ; WX 778 ; N G ; B 44 -19 713 737 ;\r\nC 72 ; WX 722 ; N H ; B 71 0 651 718 ;\r\nC 73 ; WX 278 ; N I ; B 64 0 214 718 ;\r\nC 74 ; WX 556 ; N J ; B 22 -18 484 718 ;\r\nC 75 ; WX 722 ; N K ; B 87 0 722 718 ;\r\nC 76 ; WX 611 ; N L ; B 76 0 583 718 ;\r\nC 77 ; WX 833 ; N M ; B 69 0 765 718 ;\r\nC 78 ; WX 722 ; N N ; B 69 0 654 718 ;\r\nC 79 ; WX 778 ; N O ; B 44 -19 734 737 ;\r\nC 80 ; WX 667 ; N P ; B 76 0 627 718 ;\r\nC 81 ; WX 778 ; N Q ; B 44 -52 737 737 ;\r\nC 82 ; WX 722 ; N R ; B 76 0 677 718 ;\r\nC 83 ; WX 667 ; N S ; B 39 -19 629 737 ;\r\nC 84 ; WX 611 ; N T ; B 14 0 598 718 ;\r\nC 85 ; WX 722 ; N U ; B 72 -19 651 718 ;\r\nC 86 ; WX 667 ; N V ; B 19 0 648 718 ;\r\nC 87 ; WX 944 ; N W ; B 16 0 929 718 ;\r\nC 88 ; WX 667 ; N X ; B 14 0 653 718 ;\r\nC 89 ; WX 667 ; N Y ; B 15 0 653 718 ;\r\nC 90 ; WX 611 ; N Z ; B 25 0 586 718 ;\r\nC 91 ; WX 333 ; N bracketleft ; B 63 -196 309 722 ;\r\nC 92 ; WX 278 ; N backslash ; B -33 -19 311 737 ;\r\nC 93 ; WX 333 ; N bracketright ; B 24 -196 270 722 ;\r\nC 94 ; WX 584 ; N asciicircum ; B 62 323 522 698 ;\r\nC 95 ; WX 556 ; N underscore ; B 0 -125 556 -75 ;\r\nC 96 ; WX 278 ; N quoteleft ; B 69 454 209 727 ;\r\nC 97 ; WX 556 ; N a ; B 29 -14 527 546 ;\r\nC 98 ; WX 611 ; N b ; B 61 -14 578 718 ;\r\nC 99 ; WX 556 ; N c ; B 34 -14 524 546 ;\r\nC 100 ; WX 611 ; N d ; B 34 -14 551 718 ;\r\nC 101 ; WX 556 ; N e ; B 23 -14 528 546 ;\r\nC 102 ; WX 333 ; N f ; B 10 0 318 727 ; L i fi ; L l fl ;\r\nC 103 ; WX 611 ; N g ; B 40 -217 553 546 ;\r\nC 104 ; WX 611 ; N h ; B 65 0 546 718 ;\r\nC 105 ; WX 278 ; N i ; B 69 0 209 725 ;\r\nC 106 ; WX 278 ; N j ; B 3 -214 209 725 ;\r\nC 107 ; WX 556 ; N k ; B 69 0 562 718 ;\r\nC 108 ; WX 278 ; N l ; B 69 0 209 718 ;\r\nC 109 ; WX 889 ; N m ; B 64 0 826 546 ;\r\nC 110 ; WX 611 ; N n ; B 65 0 546 546 ;\r\nC 111 ; WX 611 ; N o ; B 34 -14 578 546 ;\r\nC 112 ; WX 611 ; N p ; B 62 -207 578 546 ;\r\nC 113 ; WX 611 ; N q ; B 34 -207 552 546 ;\r\nC 114 ; WX 389 ; N r ; B 64 0 373 546 ;\r\nC 115 ; WX 556 ; N s ; B 30 -14 519 546 ;\r\nC 116 ; WX 333 ; N t ; B 10 -6 309 676 ;\r\nC 117 ; WX 611 ; N u ; B 66 -14 545 532 ;\r\nC 118 ; WX 556 ; N v ; B 13 0 543 532 ;\r\nC 119 ; WX 778 ; N w ; B 10 0 769 532 ;\r\nC 120 ; WX 556 ; N x ; B 15 0 541 532 ;\r\nC 121 ; WX 556 ; N y ; B 10 -214 539 532 ;\r\nC 122 ; WX 500 ; N z ; B 20 0 480 532 ;\r\nC 123 ; WX 389 ; N braceleft ; B 48 -196 365 722 ;\r\nC 124 ; WX 280 ; N bar ; B 84 -225 196 775 ;\r\nC 125 ; WX 389 ; N braceright ; B 24 -196 341 722 ;\r\nC 126 ; WX 584 ; N asciitilde ; B 61 163 523 343 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 90 -186 244 532 ;\r\nC 162 ; WX 556 ; N cent ; B 34 -118 524 628 ;\r\nC 163 ; WX 556 ; N sterling ; B 28 -16 541 718 ;\r\nC 164 ; WX 167 ; N fraction ; B -170 -19 336 710 ;\r\nC 165 ; WX 556 ; N yen ; B -9 0 565 698 ;\r\nC 166 ; WX 556 ; N florin ; B -10 -210 516 737 ;\r\nC 167 ; WX 556 ; N section ; B 34 -184 522 727 ;\r\nC 168 ; WX 556 ; N currency ; B -3 76 559 636 ;\r\nC 169 ; WX 238 ; N quotesingle ; B 70 447 168 718 ;\r\nC 170 ; WX 500 ; N quotedblleft ; B 64 454 436 727 ;\r\nC 171 ; WX 556 ; N guillemotleft ; B 88 76 468 484 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 83 76 250 484 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 83 76 250 484 ;\r\nC 174 ; WX 611 ; N fi ; B 10 0 542 727 ;\r\nC 175 ; WX 611 ; N fl ; B 10 0 542 727 ;\r\nC 177 ; WX 556 ; N endash ; B 0 227 556 333 ;\r\nC 178 ; WX 556 ; N dagger ; B 36 -171 520 718 ;\r\nC 179 ; WX 556 ; N daggerdbl ; B 36 -171 520 718 ;\r\nC 180 ; WX 278 ; N periodcentered ; B 58 172 220 334 ;\r\nC 182 ; WX 556 ; N paragraph ; B -8 -191 539 700 ;\r\nC 183 ; WX 350 ; N bullet ; B 10 194 340 524 ;\r\nC 184 ; WX 278 ; N quotesinglbase ; B 69 -146 209 127 ;\r\nC 185 ; WX 500 ; N quotedblbase ; B 64 -146 436 127 ;\r\nC 186 ; WX 500 ; N quotedblright ; B 64 445 436 718 ;\r\nC 187 ; WX 556 ; N guillemotright ; B 88 76 468 484 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 92 0 908 146 ;\r\nC 189 ; WX 1000 ; N perthousand ; B -3 -19 1003 710 ;\r\nC 191 ; WX 611 ; N questiondown ; B 55 -195 551 532 ;\r\nC 193 ; WX 333 ; N grave ; B -23 604 225 750 ;\r\nC 194 ; WX 333 ; N acute ; B 108 604 356 750 ;\r\nC 195 ; WX 333 ; N circumflex ; B -10 604 343 750 ;\r\nC 196 ; WX 333 ; N tilde ; B -17 610 350 737 ;\r\nC 197 ; WX 333 ; N macron ; B -6 604 339 678 ;\r\nC 198 ; WX 333 ; N breve ; B -2 604 335 750 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 104 614 230 729 ;\r\nC 200 ; WX 333 ; N dieresis ; B 6 614 327 729 ;\r\nC 202 ; WX 333 ; N ring ; B 59 568 275 776 ;\r\nC 203 ; WX 333 ; N cedilla ; B 6 -228 245 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 9 604 486 750 ;\r\nC 206 ; WX 333 ; N ogonek ; B 71 -228 304 0 ;\r\nC 207 ; WX 333 ; N caron ; B -10 604 343 750 ;\r\nC 208 ; WX 1000 ; N emdash ; B 0 227 1000 333 ;\r\nC 225 ; WX 1000 ; N AE ; B 5 0 954 718 ;\r\nC 227 ; WX 370 ; N ordfeminine ; B 22 401 347 737 ;\r\nC 232 ; WX 611 ; N Lslash ; B -20 0 583 718 ;\r\nC 233 ; WX 778 ; N Oslash ; B 33 -27 744 745 ;\r\nC 234 ; WX 1000 ; N OE ; B 37 -19 961 737 ;\r\nC 235 ; WX 365 ; N ordmasculine ; B 6 401 360 737 ;\r\nC 241 ; WX 889 ; N ae ; B 29 -14 858 546 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 69 0 209 532 ;\r\nC 248 ; WX 278 ; N lslash ; B -18 0 296 718 ;\r\nC 249 ; WX 611 ; N oslash ; B 22 -29 589 560 ;\r\nC 250 ; WX 944 ; N oe ; B 34 -14 912 546 ;\r\nC 251 ; WX 611 ; N germandbls ; B 69 -14 579 731 ;\r\nC -1 ; WX 278 ; N Idieresis ; B -21 0 300 915 ;\r\nC -1 ; WX 556 ; N eacute ; B 23 -14 528 750 ;\r\nC -1 ; WX 556 ; N abreve ; B 29 -14 527 750 ;\r\nC -1 ; WX 611 ; N uhungarumlaut ; B 66 -14 625 750 ;\r\nC -1 ; WX 556 ; N ecaron ; B 23 -14 528 750 ;\r\nC -1 ; WX 667 ; N Ydieresis ; B 15 0 653 915 ;\r\nC -1 ; WX 584 ; N divide ; B 40 -42 544 548 ;\r\nC -1 ; WX 667 ; N Yacute ; B 15 0 653 936 ;\r\nC -1 ; WX 722 ; N Acircumflex ; B 20 0 702 936 ;\r\nC -1 ; WX 556 ; N aacute ; B 29 -14 527 750 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 72 -19 651 936 ;\r\nC -1 ; WX 556 ; N yacute ; B 10 -214 539 750 ;\r\nC -1 ; WX 556 ; N scommaaccent ; B 30 -228 519 546 ;\r\nC -1 ; WX 556 ; N ecircumflex ; B 23 -14 528 750 ;\r\nC -1 ; WX 722 ; N Uring ; B 72 -19 651 962 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 72 -19 651 915 ;\r\nC -1 ; WX 556 ; N aogonek ; B 29 -224 545 546 ;\r\nC -1 ; WX 722 ; N Uacute ; B 72 -19 651 936 ;\r\nC -1 ; WX 611 ; N uogonek ; B 66 -228 545 532 ;\r\nC -1 ; WX 667 ; N Edieresis ; B 76 0 621 915 ;\r\nC -1 ; WX 722 ; N Dcroat ; B -5 0 685 718 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 64 -228 199 -50 ;\r\nC -1 ; WX 737 ; N copyright ; B -11 -19 749 737 ;\r\nC -1 ; WX 667 ; N Emacron ; B 76 0 621 864 ;\r\nC -1 ; WX 556 ; N ccaron ; B 34 -14 524 750 ;\r\nC -1 ; WX 556 ; N aring ; B 29 -14 527 776 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 69 -228 654 718 ;\r\nC -1 ; WX 278 ; N lacute ; B 69 0 329 936 ;\r\nC -1 ; WX 556 ; N agrave ; B 29 -14 527 750 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 14 -228 598 718 ;\r\nC -1 ; WX 722 ; N Cacute ; B 44 -19 684 936 ;\r\nC -1 ; WX 556 ; N atilde ; B 29 -14 527 737 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B 76 0 621 915 ;\r\nC -1 ; WX 556 ; N scaron ; B 30 -14 519 750 ;\r\nC -1 ; WX 556 ; N scedilla ; B 30 -228 519 546 ;\r\nC -1 ; WX 278 ; N iacute ; B 69 0 329 750 ;\r\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\r\nC -1 ; WX 722 ; N Rcaron ; B 76 0 677 936 ;\r\nC -1 ; WX 778 ; N Gcommaaccent ; B 44 -228 713 737 ;\r\nC -1 ; WX 611 ; N ucircumflex ; B 66 -14 545 750 ;\r\nC -1 ; WX 556 ; N acircumflex ; B 29 -14 527 750 ;\r\nC -1 ; WX 722 ; N Amacron ; B 20 0 702 864 ;\r\nC -1 ; WX 389 ; N rcaron ; B 18 0 373 750 ;\r\nC -1 ; WX 556 ; N ccedilla ; B 34 -228 524 546 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B 25 0 586 915 ;\r\nC -1 ; WX 667 ; N Thorn ; B 76 0 627 718 ;\r\nC -1 ; WX 778 ; N Omacron ; B 44 -19 734 864 ;\r\nC -1 ; WX 722 ; N Racute ; B 76 0 677 936 ;\r\nC -1 ; WX 667 ; N Sacute ; B 39 -19 629 936 ;\r\nC -1 ; WX 743 ; N dcaron ; B 34 -14 750 718 ;\r\nC -1 ; WX 722 ; N Umacron ; B 72 -19 651 864 ;\r\nC -1 ; WX 611 ; N uring ; B 66 -14 545 776 ;\r\nC -1 ; WX 333 ; N threesuperior ; B 8 271 326 710 ;\r\nC -1 ; WX 778 ; N Ograve ; B 44 -19 734 936 ;\r\nC -1 ; WX 722 ; N Agrave ; B 20 0 702 936 ;\r\nC -1 ; WX 722 ; N Abreve ; B 20 0 702 936 ;\r\nC -1 ; WX 584 ; N multiply ; B 40 1 545 505 ;\r\nC -1 ; WX 611 ; N uacute ; B 66 -14 545 750 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 14 0 598 936 ;\r\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\r\nC -1 ; WX 556 ; N ydieresis ; B 10 -214 539 729 ;\r\nC -1 ; WX 722 ; N Nacute ; B 69 0 654 936 ;\r\nC -1 ; WX 278 ; N icircumflex ; B -37 0 316 750 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B 76 0 621 936 ;\r\nC -1 ; WX 556 ; N adieresis ; B 29 -14 527 729 ;\r\nC -1 ; WX 556 ; N edieresis ; B 23 -14 528 729 ;\r\nC -1 ; WX 556 ; N cacute ; B 34 -14 524 750 ;\r\nC -1 ; WX 611 ; N nacute ; B 65 0 546 750 ;\r\nC -1 ; WX 611 ; N umacron ; B 66 -14 545 678 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 69 0 654 936 ;\r\nC -1 ; WX 278 ; N Iacute ; B 64 0 329 936 ;\r\nC -1 ; WX 584 ; N plusminus ; B 40 0 544 506 ;\r\nC -1 ; WX 280 ; N brokenbar ; B 84 -150 196 700 ;\r\nC -1 ; WX 737 ; N registered ; B -11 -19 748 737 ;\r\nC -1 ; WX 778 ; N Gbreve ; B 44 -19 713 936 ;\r\nC -1 ; WX 278 ; N Idotaccent ; B 64 0 214 915 ;\r\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B 76 0 621 936 ;\r\nC -1 ; WX 389 ; N racute ; B 64 0 384 750 ;\r\nC -1 ; WX 611 ; N omacron ; B 34 -14 578 678 ;\r\nC -1 ; WX 611 ; N Zacute ; B 25 0 586 936 ;\r\nC -1 ; WX 611 ; N Zcaron ; B 25 0 586 936 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\r\nC -1 ; WX 722 ; N Eth ; B -5 0 685 718 ;\r\nC -1 ; WX 722 ; N Ccedilla ; B 44 -228 684 737 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B 69 -228 213 718 ;\r\nC -1 ; WX 389 ; N tcaron ; B 10 -6 421 878 ;\r\nC -1 ; WX 556 ; N eogonek ; B 23 -228 528 546 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 72 -228 651 718 ;\r\nC -1 ; WX 722 ; N Aacute ; B 20 0 702 936 ;\r\nC -1 ; WX 722 ; N Adieresis ; B 20 0 702 915 ;\r\nC -1 ; WX 556 ; N egrave ; B 23 -14 528 750 ;\r\nC -1 ; WX 500 ; N zacute ; B 20 0 480 750 ;\r\nC -1 ; WX 278 ; N iogonek ; B 16 -224 249 725 ;\r\nC -1 ; WX 778 ; N Oacute ; B 44 -19 734 936 ;\r\nC -1 ; WX 611 ; N oacute ; B 34 -14 578 750 ;\r\nC -1 ; WX 556 ; N amacron ; B 29 -14 527 678 ;\r\nC -1 ; WX 556 ; N sacute ; B 30 -14 519 750 ;\r\nC -1 ; WX 278 ; N idieresis ; B -21 0 300 729 ;\r\nC -1 ; WX 778 ; N Ocircumflex ; B 44 -19 734 936 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 72 -19 651 936 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 611 ; N thorn ; B 62 -208 578 718 ;\r\nC -1 ; WX 333 ; N twosuperior ; B 9 283 324 710 ;\r\nC -1 ; WX 778 ; N Odieresis ; B 44 -19 734 915 ;\r\nC -1 ; WX 611 ; N mu ; B 66 -207 545 532 ;\r\nC -1 ; WX 278 ; N igrave ; B -50 0 209 750 ;\r\nC -1 ; WX 611 ; N ohungarumlaut ; B 34 -14 625 750 ;\r\nC -1 ; WX 667 ; N Eogonek ; B 76 -224 639 718 ;\r\nC -1 ; WX 611 ; N dcroat ; B 34 -14 650 718 ;\r\nC -1 ; WX 834 ; N threequarters ; B 16 -19 799 710 ;\r\nC -1 ; WX 667 ; N Scedilla ; B 39 -228 629 737 ;\r\nC -1 ; WX 400 ; N lcaron ; B 69 0 408 718 ;\r\nC -1 ; WX 722 ; N Kcommaaccent ; B 87 -228 722 718 ;\r\nC -1 ; WX 611 ; N Lacute ; B 76 0 583 936 ;\r\nC -1 ; WX 1000 ; N trademark ; B 44 306 956 718 ;\r\nC -1 ; WX 556 ; N edotaccent ; B 23 -14 528 729 ;\r\nC -1 ; WX 278 ; N Igrave ; B -50 0 214 936 ;\r\nC -1 ; WX 278 ; N Imacron ; B -33 0 312 864 ;\r\nC -1 ; WX 611 ; N Lcaron ; B 76 0 583 718 ;\r\nC -1 ; WX 834 ; N onehalf ; B 26 -19 794 710 ;\r\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\r\nC -1 ; WX 611 ; N ocircumflex ; B 34 -14 578 750 ;\r\nC -1 ; WX 611 ; N ntilde ; B 65 0 546 737 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 72 -19 681 936 ;\r\nC -1 ; WX 667 ; N Eacute ; B 76 0 621 936 ;\r\nC -1 ; WX 556 ; N emacron ; B 23 -14 528 678 ;\r\nC -1 ; WX 611 ; N gbreve ; B 40 -217 553 750 ;\r\nC -1 ; WX 834 ; N onequarter ; B 26 -19 766 710 ;\r\nC -1 ; WX 667 ; N Scaron ; B 39 -19 629 936 ;\r\nC -1 ; WX 667 ; N Scommaaccent ; B 39 -228 629 737 ;\r\nC -1 ; WX 778 ; N Ohungarumlaut ; B 44 -19 734 936 ;\r\nC -1 ; WX 400 ; N degree ; B 57 426 343 712 ;\r\nC -1 ; WX 611 ; N ograve ; B 34 -14 578 750 ;\r\nC -1 ; WX 722 ; N Ccaron ; B 44 -19 684 936 ;\r\nC -1 ; WX 611 ; N ugrave ; B 66 -14 545 750 ;\r\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 76 0 685 936 ;\r\nC -1 ; WX 389 ; N rcommaaccent ; B 64 -228 373 546 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 69 0 654 923 ;\r\nC -1 ; WX 611 ; N otilde ; B 34 -14 578 737 ;\r\nC -1 ; WX 722 ; N Rcommaaccent ; B 76 -228 677 718 ;\r\nC -1 ; WX 611 ; N Lcommaaccent ; B 76 -228 583 718 ;\r\nC -1 ; WX 722 ; N Atilde ; B 20 0 702 923 ;\r\nC -1 ; WX 722 ; N Aogonek ; B 20 -224 742 718 ;\r\nC -1 ; WX 722 ; N Aring ; B 20 0 702 962 ;\r\nC -1 ; WX 778 ; N Otilde ; B 44 -19 734 923 ;\r\nC -1 ; WX 500 ; N zdotaccent ; B 20 0 480 729 ;\r\nC -1 ; WX 667 ; N Ecaron ; B 76 0 621 936 ;\r\nC -1 ; WX 278 ; N Iogonek ; B -11 -228 222 718 ;\r\nC -1 ; WX 556 ; N kcommaaccent ; B 69 -228 562 718 ;\r\nC -1 ; WX 584 ; N minus ; B 40 197 544 309 ;\r\nC -1 ; WX 278 ; N Icircumflex ; B -37 0 316 936 ;\r\nC -1 ; WX 611 ; N ncaron ; B 65 0 546 750 ;\r\nC -1 ; WX 333 ; N tcommaaccent ; B 10 -228 309 676 ;\r\nC -1 ; WX 584 ; N logicalnot ; B 40 108 544 419 ;\r\nC -1 ; WX 611 ; N odieresis ; B 34 -14 578 729 ;\r\nC -1 ; WX 611 ; N udieresis ; B 66 -14 545 729 ;\r\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\r\nC -1 ; WX 611 ; N gcommaaccent ; B 40 -217 553 850 ;\r\nC -1 ; WX 611 ; N eth ; B 34 -14 578 737 ;\r\nC -1 ; WX 500 ; N zcaron ; B 20 0 480 750 ;\r\nC -1 ; WX 611 ; N ncommaaccent ; B 65 -228 546 546 ;\r\nC -1 ; WX 333 ; N onesuperior ; B 26 283 237 710 ;\r\nC -1 ; WX 278 ; N imacron ; B -8 0 285 678 ;\r\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2481\r\nKPX A C -40\r\nKPX A Cacute -40\r\nKPX A Ccaron -40\r\nKPX A Ccedilla -40\r\nKPX A G -50\r\nKPX A Gbreve -50\r\nKPX A Gcommaaccent -50\r\nKPX A O -40\r\nKPX A Oacute -40\r\nKPX A Ocircumflex -40\r\nKPX A Odieresis -40\r\nKPX A Ograve -40\r\nKPX A Ohungarumlaut -40\r\nKPX A Omacron -40\r\nKPX A Oslash -40\r\nKPX A Otilde -40\r\nKPX A Q -40\r\nKPX A T -90\r\nKPX A Tcaron -90\r\nKPX A Tcommaaccent -90\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -80\r\nKPX A W -60\r\nKPX A Y -110\r\nKPX A Yacute -110\r\nKPX A Ydieresis -110\r\nKPX A u -30\r\nKPX A uacute -30\r\nKPX A ucircumflex -30\r\nKPX A udieresis -30\r\nKPX A ugrave -30\r\nKPX A uhungarumlaut -30\r\nKPX A umacron -30\r\nKPX A uogonek -30\r\nKPX A uring -30\r\nKPX A v -40\r\nKPX A w -30\r\nKPX A y -30\r\nKPX A yacute -30\r\nKPX A ydieresis -30\r\nKPX Aacute C -40\r\nKPX Aacute Cacute -40\r\nKPX Aacute Ccaron -40\r\nKPX Aacute Ccedilla -40\r\nKPX Aacute G -50\r\nKPX Aacute Gbreve -50\r\nKPX Aacute Gcommaaccent -50\r\nKPX Aacute O -40\r\nKPX Aacute Oacute -40\r\nKPX Aacute Ocircumflex -40\r\nKPX Aacute Odieresis -40\r\nKPX Aacute Ograve -40\r\nKPX Aacute Ohungarumlaut -40\r\nKPX Aacute Omacron -40\r\nKPX Aacute Oslash -40\r\nKPX Aacute Otilde -40\r\nKPX Aacute Q -40\r\nKPX Aacute T -90\r\nKPX Aacute Tcaron -90\r\nKPX Aacute Tcommaaccent -90\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -80\r\nKPX Aacute W -60\r\nKPX Aacute Y -110\r\nKPX Aacute Yacute -110\r\nKPX Aacute Ydieresis -110\r\nKPX Aacute u -30\r\nKPX Aacute uacute -30\r\nKPX Aacute ucircumflex -30\r\nKPX Aacute udieresis -30\r\nKPX Aacute ugrave -30\r\nKPX Aacute uhungarumlaut -30\r\nKPX Aacute umacron -30\r\nKPX Aacute uogonek -30\r\nKPX Aacute uring -30\r\nKPX Aacute v -40\r\nKPX Aacute w -30\r\nKPX Aacute y -30\r\nKPX Aacute yacute -30\r\nKPX Aacute ydieresis -30\r\nKPX Abreve C -40\r\nKPX Abreve Cacute -40\r\nKPX Abreve Ccaron -40\r\nKPX Abreve Ccedilla -40\r\nKPX Abreve G -50\r\nKPX Abreve Gbreve -50\r\nKPX Abreve Gcommaaccent -50\r\nKPX Abreve O -40\r\nKPX Abreve Oacute -40\r\nKPX Abreve Ocircumflex -40\r\nKPX Abreve Odieresis -40\r\nKPX Abreve Ograve -40\r\nKPX Abreve Ohungarumlaut -40\r\nKPX Abreve Omacron -40\r\nKPX Abreve Oslash -40\r\nKPX Abreve Otilde -40\r\nKPX Abreve Q -40\r\nKPX Abreve T -90\r\nKPX Abreve Tcaron -90\r\nKPX Abreve Tcommaaccent -90\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -80\r\nKPX Abreve W -60\r\nKPX Abreve Y -110\r\nKPX Abreve Yacute -110\r\nKPX Abreve Ydieresis -110\r\nKPX Abreve u -30\r\nKPX Abreve uacute -30\r\nKPX Abreve ucircumflex -30\r\nKPX Abreve udieresis -30\r\nKPX Abreve ugrave -30\r\nKPX Abreve uhungarumlaut -30\r\nKPX Abreve umacron -30\r\nKPX Abreve uogonek -30\r\nKPX Abreve uring -30\r\nKPX Abreve v -40\r\nKPX Abreve w -30\r\nKPX Abreve y -30\r\nKPX Abreve yacute -30\r\nKPX Abreve ydieresis -30\r\nKPX Acircumflex C -40\r\nKPX Acircumflex Cacute -40\r\nKPX Acircumflex Ccaron -40\r\nKPX Acircumflex Ccedilla -40\r\nKPX Acircumflex G -50\r\nKPX Acircumflex Gbreve -50\r\nKPX Acircumflex Gcommaaccent -50\r\nKPX Acircumflex O -40\r\nKPX Acircumflex Oacute -40\r\nKPX Acircumflex Ocircumflex -40\r\nKPX Acircumflex Odieresis -40\r\nKPX Acircumflex Ograve -40\r\nKPX Acircumflex Ohungarumlaut -40\r\nKPX Acircumflex Omacron -40\r\nKPX Acircumflex Oslash -40\r\nKPX Acircumflex Otilde -40\r\nKPX Acircumflex Q -40\r\nKPX Acircumflex T -90\r\nKPX Acircumflex Tcaron -90\r\nKPX Acircumflex Tcommaaccent -90\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -80\r\nKPX Acircumflex W -60\r\nKPX Acircumflex Y -110\r\nKPX Acircumflex Yacute -110\r\nKPX Acircumflex Ydieresis -110\r\nKPX Acircumflex u -30\r\nKPX Acircumflex uacute -30\r\nKPX Acircumflex ucircumflex -30\r\nKPX Acircumflex udieresis -30\r\nKPX Acircumflex ugrave -30\r\nKPX Acircumflex uhungarumlaut -30\r\nKPX Acircumflex umacron -30\r\nKPX Acircumflex uogonek -30\r\nKPX Acircumflex uring -30\r\nKPX Acircumflex v -40\r\nKPX Acircumflex w -30\r\nKPX Acircumflex y -30\r\nKPX Acircumflex yacute -30\r\nKPX Acircumflex ydieresis -30\r\nKPX Adieresis C -40\r\nKPX Adieresis Cacute -40\r\nKPX Adieresis Ccaron -40\r\nKPX Adieresis Ccedilla -40\r\nKPX Adieresis G -50\r\nKPX Adieresis Gbreve -50\r\nKPX Adieresis Gcommaaccent -50\r\nKPX Adieresis O -40\r\nKPX Adieresis Oacute -40\r\nKPX Adieresis Ocircumflex -40\r\nKPX Adieresis Odieresis -40\r\nKPX Adieresis Ograve -40\r\nKPX Adieresis Ohungarumlaut -40\r\nKPX Adieresis Omacron -40\r\nKPX Adieresis Oslash -40\r\nKPX Adieresis Otilde -40\r\nKPX Adieresis Q -40\r\nKPX Adieresis T -90\r\nKPX Adieresis Tcaron -90\r\nKPX Adieresis Tcommaaccent -90\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -80\r\nKPX Adieresis W -60\r\nKPX Adieresis Y -110\r\nKPX Adieresis Yacute -110\r\nKPX Adieresis Ydieresis -110\r\nKPX Adieresis u -30\r\nKPX Adieresis uacute -30\r\nKPX Adieresis ucircumflex -30\r\nKPX Adieresis udieresis -30\r\nKPX Adieresis ugrave -30\r\nKPX Adieresis uhungarumlaut -30\r\nKPX Adieresis umacron -30\r\nKPX Adieresis uogonek -30\r\nKPX Adieresis uring -30\r\nKPX Adieresis v -40\r\nKPX Adieresis w -30\r\nKPX Adieresis y -30\r\nKPX Adieresis yacute -30\r\nKPX Adieresis ydieresis -30\r\nKPX Agrave C -40\r\nKPX Agrave Cacute -40\r\nKPX Agrave Ccaron -40\r\nKPX Agrave Ccedilla -40\r\nKPX Agrave G -50\r\nKPX Agrave Gbreve -50\r\nKPX Agrave Gcommaaccent -50\r\nKPX Agrave O -40\r\nKPX Agrave Oacute -40\r\nKPX Agrave Ocircumflex -40\r\nKPX Agrave Odieresis -40\r\nKPX Agrave Ograve -40\r\nKPX Agrave Ohungarumlaut -40\r\nKPX Agrave Omacron -40\r\nKPX Agrave Oslash -40\r\nKPX Agrave Otilde -40\r\nKPX Agrave Q -40\r\nKPX Agrave T -90\r\nKPX Agrave Tcaron -90\r\nKPX Agrave Tcommaaccent -90\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -80\r\nKPX Agrave W -60\r\nKPX Agrave Y -110\r\nKPX Agrave Yacute -110\r\nKPX Agrave Ydieresis -110\r\nKPX Agrave u -30\r\nKPX Agrave uacute -30\r\nKPX Agrave ucircumflex -30\r\nKPX Agrave udieresis -30\r\nKPX Agrave ugrave -30\r\nKPX Agrave uhungarumlaut -30\r\nKPX Agrave umacron -30\r\nKPX Agrave uogonek -30\r\nKPX Agrave uring -30\r\nKPX Agrave v -40\r\nKPX Agrave w -30\r\nKPX Agrave y -30\r\nKPX Agrave yacute -30\r\nKPX Agrave ydieresis -30\r\nKPX Amacron C -40\r\nKPX Amacron Cacute -40\r\nKPX Amacron Ccaron -40\r\nKPX Amacron Ccedilla -40\r\nKPX Amacron G -50\r\nKPX Amacron Gbreve -50\r\nKPX Amacron Gcommaaccent -50\r\nKPX Amacron O -40\r\nKPX Amacron Oacute -40\r\nKPX Amacron Ocircumflex -40\r\nKPX Amacron Odieresis -40\r\nKPX Amacron Ograve -40\r\nKPX Amacron Ohungarumlaut -40\r\nKPX Amacron Omacron -40\r\nKPX Amacron Oslash -40\r\nKPX Amacron Otilde -40\r\nKPX Amacron Q -40\r\nKPX Amacron T -90\r\nKPX Amacron Tcaron -90\r\nKPX Amacron Tcommaaccent -90\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -80\r\nKPX Amacron W -60\r\nKPX Amacron Y -110\r\nKPX Amacron Yacute -110\r\nKPX Amacron Ydieresis -110\r\nKPX Amacron u -30\r\nKPX Amacron uacute -30\r\nKPX Amacron ucircumflex -30\r\nKPX Amacron udieresis -30\r\nKPX Amacron ugrave -30\r\nKPX Amacron uhungarumlaut -30\r\nKPX Amacron umacron -30\r\nKPX Amacron uogonek -30\r\nKPX Amacron uring -30\r\nKPX Amacron v -40\r\nKPX Amacron w -30\r\nKPX Amacron y -30\r\nKPX Amacron yacute -30\r\nKPX Amacron ydieresis -30\r\nKPX Aogonek C -40\r\nKPX Aogonek Cacute -40\r\nKPX Aogonek Ccaron -40\r\nKPX Aogonek Ccedilla -40\r\nKPX Aogonek G -50\r\nKPX Aogonek Gbreve -50\r\nKPX Aogonek Gcommaaccent -50\r\nKPX Aogonek O -40\r\nKPX Aogonek Oacute -40\r\nKPX Aogonek Ocircumflex -40\r\nKPX Aogonek Odieresis -40\r\nKPX Aogonek Ograve -40\r\nKPX Aogonek Ohungarumlaut -40\r\nKPX Aogonek Omacron -40\r\nKPX Aogonek Oslash -40\r\nKPX Aogonek Otilde -40\r\nKPX Aogonek Q -40\r\nKPX Aogonek T -90\r\nKPX Aogonek Tcaron -90\r\nKPX Aogonek Tcommaaccent -90\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -80\r\nKPX Aogonek W -60\r\nKPX Aogonek Y -110\r\nKPX Aogonek Yacute -110\r\nKPX Aogonek Ydieresis -110\r\nKPX Aogonek u -30\r\nKPX Aogonek uacute -30\r\nKPX Aogonek ucircumflex -30\r\nKPX Aogonek udieresis -30\r\nKPX Aogonek ugrave -30\r\nKPX Aogonek uhungarumlaut -30\r\nKPX Aogonek umacron -30\r\nKPX Aogonek uogonek -30\r\nKPX Aogonek uring -30\r\nKPX Aogonek v -40\r\nKPX Aogonek w -30\r\nKPX Aogonek y -30\r\nKPX Aogonek yacute -30\r\nKPX Aogonek ydieresis -30\r\nKPX Aring C -40\r\nKPX Aring Cacute -40\r\nKPX Aring Ccaron -40\r\nKPX Aring Ccedilla -40\r\nKPX Aring G -50\r\nKPX Aring Gbreve -50\r\nKPX Aring Gcommaaccent -50\r\nKPX Aring O -40\r\nKPX Aring Oacute -40\r\nKPX Aring Ocircumflex -40\r\nKPX Aring Odieresis -40\r\nKPX Aring Ograve -40\r\nKPX Aring Ohungarumlaut -40\r\nKPX Aring Omacron -40\r\nKPX Aring Oslash -40\r\nKPX Aring Otilde -40\r\nKPX Aring Q -40\r\nKPX Aring T -90\r\nKPX Aring Tcaron -90\r\nKPX Aring Tcommaaccent -90\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -80\r\nKPX Aring W -60\r\nKPX Aring Y -110\r\nKPX Aring Yacute -110\r\nKPX Aring Ydieresis -110\r\nKPX Aring u -30\r\nKPX Aring uacute -30\r\nKPX Aring ucircumflex -30\r\nKPX Aring udieresis -30\r\nKPX Aring ugrave -30\r\nKPX Aring uhungarumlaut -30\r\nKPX Aring umacron -30\r\nKPX Aring uogonek -30\r\nKPX Aring uring -30\r\nKPX Aring v -40\r\nKPX Aring w -30\r\nKPX Aring y -30\r\nKPX Aring yacute -30\r\nKPX Aring ydieresis -30\r\nKPX Atilde C -40\r\nKPX Atilde Cacute -40\r\nKPX Atilde Ccaron -40\r\nKPX Atilde Ccedilla -40\r\nKPX Atilde G -50\r\nKPX Atilde Gbreve -50\r\nKPX Atilde Gcommaaccent -50\r\nKPX Atilde O -40\r\nKPX Atilde Oacute -40\r\nKPX Atilde Ocircumflex -40\r\nKPX Atilde Odieresis -40\r\nKPX Atilde Ograve -40\r\nKPX Atilde Ohungarumlaut -40\r\nKPX Atilde Omacron -40\r\nKPX Atilde Oslash -40\r\nKPX Atilde Otilde -40\r\nKPX Atilde Q -40\r\nKPX Atilde T -90\r\nKPX Atilde Tcaron -90\r\nKPX Atilde Tcommaaccent -90\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -80\r\nKPX Atilde W -60\r\nKPX Atilde Y -110\r\nKPX Atilde Yacute -110\r\nKPX Atilde Ydieresis -110\r\nKPX Atilde u -30\r\nKPX Atilde uacute -30\r\nKPX Atilde ucircumflex -30\r\nKPX Atilde udieresis -30\r\nKPX Atilde ugrave -30\r\nKPX Atilde uhungarumlaut -30\r\nKPX Atilde umacron -30\r\nKPX Atilde uogonek -30\r\nKPX Atilde uring -30\r\nKPX Atilde v -40\r\nKPX Atilde w -30\r\nKPX Atilde y -30\r\nKPX Atilde yacute -30\r\nKPX Atilde ydieresis -30\r\nKPX B A -30\r\nKPX B Aacute -30\r\nKPX B Abreve -30\r\nKPX B Acircumflex -30\r\nKPX B Adieresis -30\r\nKPX B Agrave -30\r\nKPX B Amacron -30\r\nKPX B Aogonek -30\r\nKPX B Aring -30\r\nKPX B Atilde -30\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -40\r\nKPX D Aacute -40\r\nKPX D Abreve -40\r\nKPX D Acircumflex -40\r\nKPX D Adieresis -40\r\nKPX D Agrave -40\r\nKPX D Amacron -40\r\nKPX D Aogonek -40\r\nKPX D Aring -40\r\nKPX D Atilde -40\r\nKPX D V -40\r\nKPX D W -40\r\nKPX D Y -70\r\nKPX D Yacute -70\r\nKPX D Ydieresis -70\r\nKPX D comma -30\r\nKPX D period -30\r\nKPX Dcaron A -40\r\nKPX Dcaron Aacute -40\r\nKPX Dcaron Abreve -40\r\nKPX Dcaron Acircumflex -40\r\nKPX Dcaron Adieresis -40\r\nKPX Dcaron Agrave -40\r\nKPX Dcaron Amacron -40\r\nKPX Dcaron Aogonek -40\r\nKPX Dcaron Aring -40\r\nKPX Dcaron Atilde -40\r\nKPX Dcaron V -40\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -70\r\nKPX Dcaron Yacute -70\r\nKPX Dcaron Ydieresis -70\r\nKPX Dcaron comma -30\r\nKPX Dcaron period -30\r\nKPX Dcroat A -40\r\nKPX Dcroat Aacute -40\r\nKPX Dcroat Abreve -40\r\nKPX Dcroat Acircumflex -40\r\nKPX Dcroat Adieresis -40\r\nKPX Dcroat Agrave -40\r\nKPX Dcroat Amacron -40\r\nKPX Dcroat Aogonek -40\r\nKPX Dcroat Aring -40\r\nKPX Dcroat Atilde -40\r\nKPX Dcroat V -40\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -70\r\nKPX Dcroat Yacute -70\r\nKPX Dcroat Ydieresis -70\r\nKPX Dcroat comma -30\r\nKPX Dcroat period -30\r\nKPX F A -80\r\nKPX F Aacute -80\r\nKPX F Abreve -80\r\nKPX F Acircumflex -80\r\nKPX F Adieresis -80\r\nKPX F Agrave -80\r\nKPX F Amacron -80\r\nKPX F Aogonek -80\r\nKPX F Aring -80\r\nKPX F Atilde -80\r\nKPX F a -20\r\nKPX F aacute -20\r\nKPX F abreve -20\r\nKPX F acircumflex -20\r\nKPX F adieresis -20\r\nKPX F agrave -20\r\nKPX F amacron -20\r\nKPX F aogonek -20\r\nKPX F aring -20\r\nKPX F atilde -20\r\nKPX F comma -100\r\nKPX F period -100\r\nKPX J A -20\r\nKPX J Aacute -20\r\nKPX J Abreve -20\r\nKPX J Acircumflex -20\r\nKPX J Adieresis -20\r\nKPX J Agrave -20\r\nKPX J Amacron -20\r\nKPX J Aogonek -20\r\nKPX J Aring -20\r\nKPX J Atilde -20\r\nKPX J comma -20\r\nKPX J period -20\r\nKPX J u -20\r\nKPX J uacute -20\r\nKPX J ucircumflex -20\r\nKPX J udieresis -20\r\nKPX J ugrave -20\r\nKPX J uhungarumlaut -20\r\nKPX J umacron -20\r\nKPX J uogonek -20\r\nKPX J uring -20\r\nKPX K O -30\r\nKPX K Oacute -30\r\nKPX K Ocircumflex -30\r\nKPX K Odieresis -30\r\nKPX K Ograve -30\r\nKPX K Ohungarumlaut -30\r\nKPX K Omacron -30\r\nKPX K Oslash -30\r\nKPX K Otilde -30\r\nKPX K e -15\r\nKPX K eacute -15\r\nKPX K ecaron -15\r\nKPX K ecircumflex -15\r\nKPX K edieresis -15\r\nKPX K edotaccent -15\r\nKPX K egrave -15\r\nKPX K emacron -15\r\nKPX K eogonek -15\r\nKPX K o -35\r\nKPX K oacute -35\r\nKPX K ocircumflex -35\r\nKPX K odieresis -35\r\nKPX K ograve -35\r\nKPX K ohungarumlaut -35\r\nKPX K omacron -35\r\nKPX K oslash -35\r\nKPX K otilde -35\r\nKPX K u -30\r\nKPX K uacute -30\r\nKPX K ucircumflex -30\r\nKPX K udieresis -30\r\nKPX K ugrave -30\r\nKPX K uhungarumlaut -30\r\nKPX K umacron -30\r\nKPX K uogonek -30\r\nKPX K uring -30\r\nKPX K y -40\r\nKPX K yacute -40\r\nKPX K ydieresis -40\r\nKPX Kcommaaccent O -30\r\nKPX Kcommaaccent Oacute -30\r\nKPX Kcommaaccent Ocircumflex -30\r\nKPX Kcommaaccent Odieresis -30\r\nKPX Kcommaaccent Ograve -30\r\nKPX Kcommaaccent Ohungarumlaut -30\r\nKPX Kcommaaccent Omacron -30\r\nKPX Kcommaaccent Oslash -30\r\nKPX Kcommaaccent Otilde -30\r\nKPX Kcommaaccent e -15\r\nKPX Kcommaaccent eacute -15\r\nKPX Kcommaaccent ecaron -15\r\nKPX Kcommaaccent ecircumflex -15\r\nKPX Kcommaaccent edieresis -15\r\nKPX Kcommaaccent edotaccent -15\r\nKPX Kcommaaccent egrave -15\r\nKPX Kcommaaccent emacron -15\r\nKPX Kcommaaccent eogonek -15\r\nKPX Kcommaaccent o -35\r\nKPX Kcommaaccent oacute -35\r\nKPX Kcommaaccent ocircumflex -35\r\nKPX Kcommaaccent odieresis -35\r\nKPX Kcommaaccent ograve -35\r\nKPX Kcommaaccent ohungarumlaut -35\r\nKPX Kcommaaccent omacron -35\r\nKPX Kcommaaccent oslash -35\r\nKPX Kcommaaccent otilde -35\r\nKPX Kcommaaccent u -30\r\nKPX Kcommaaccent uacute -30\r\nKPX Kcommaaccent ucircumflex -30\r\nKPX Kcommaaccent udieresis -30\r\nKPX Kcommaaccent ugrave -30\r\nKPX Kcommaaccent uhungarumlaut -30\r\nKPX Kcommaaccent umacron -30\r\nKPX Kcommaaccent uogonek -30\r\nKPX Kcommaaccent uring -30\r\nKPX Kcommaaccent y -40\r\nKPX Kcommaaccent yacute -40\r\nKPX Kcommaaccent ydieresis -40\r\nKPX L T -90\r\nKPX L Tcaron -90\r\nKPX L Tcommaaccent -90\r\nKPX L V -110\r\nKPX L W -80\r\nKPX L Y -120\r\nKPX L Yacute -120\r\nKPX L Ydieresis -120\r\nKPX L quotedblright -140\r\nKPX L quoteright -140\r\nKPX L y -30\r\nKPX L yacute -30\r\nKPX L ydieresis -30\r\nKPX Lacute T -90\r\nKPX Lacute Tcaron -90\r\nKPX Lacute Tcommaaccent -90\r\nKPX Lacute V -110\r\nKPX Lacute W -80\r\nKPX Lacute Y -120\r\nKPX Lacute Yacute -120\r\nKPX Lacute Ydieresis -120\r\nKPX Lacute quotedblright -140\r\nKPX Lacute quoteright -140\r\nKPX Lacute y -30\r\nKPX Lacute yacute -30\r\nKPX Lacute ydieresis -30\r\nKPX Lcommaaccent T -90\r\nKPX Lcommaaccent Tcaron -90\r\nKPX Lcommaaccent Tcommaaccent -90\r\nKPX Lcommaaccent V -110\r\nKPX Lcommaaccent W -80\r\nKPX Lcommaaccent Y -120\r\nKPX Lcommaaccent Yacute -120\r\nKPX Lcommaaccent Ydieresis -120\r\nKPX Lcommaaccent quotedblright -140\r\nKPX Lcommaaccent quoteright -140\r\nKPX Lcommaaccent y -30\r\nKPX Lcommaaccent yacute -30\r\nKPX Lcommaaccent ydieresis -30\r\nKPX Lslash T -90\r\nKPX Lslash Tcaron -90\r\nKPX Lslash Tcommaaccent -90\r\nKPX Lslash V -110\r\nKPX Lslash W -80\r\nKPX Lslash Y -120\r\nKPX Lslash Yacute -120\r\nKPX Lslash Ydieresis -120\r\nKPX Lslash quotedblright -140\r\nKPX Lslash quoteright -140\r\nKPX Lslash y -30\r\nKPX Lslash yacute -30\r\nKPX Lslash ydieresis -30\r\nKPX O A -50\r\nKPX O Aacute -50\r\nKPX O Abreve -50\r\nKPX O Acircumflex -50\r\nKPX O Adieresis -50\r\nKPX O Agrave -50\r\nKPX O Amacron -50\r\nKPX O Aogonek -50\r\nKPX O Aring -50\r\nKPX O Atilde -50\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -50\r\nKPX O X -50\r\nKPX O Y -70\r\nKPX O Yacute -70\r\nKPX O Ydieresis -70\r\nKPX O comma -40\r\nKPX O period -40\r\nKPX Oacute A -50\r\nKPX Oacute Aacute -50\r\nKPX Oacute Abreve -50\r\nKPX Oacute Acircumflex -50\r\nKPX Oacute Adieresis -50\r\nKPX Oacute Agrave -50\r\nKPX Oacute Amacron -50\r\nKPX Oacute Aogonek -50\r\nKPX Oacute Aring -50\r\nKPX Oacute Atilde -50\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -50\r\nKPX Oacute X -50\r\nKPX Oacute Y -70\r\nKPX Oacute Yacute -70\r\nKPX Oacute Ydieresis -70\r\nKPX Oacute comma -40\r\nKPX Oacute period -40\r\nKPX Ocircumflex A -50\r\nKPX Ocircumflex Aacute -50\r\nKPX Ocircumflex Abreve -50\r\nKPX Ocircumflex Acircumflex -50\r\nKPX Ocircumflex Adieresis -50\r\nKPX Ocircumflex Agrave -50\r\nKPX Ocircumflex Amacron -50\r\nKPX Ocircumflex Aogonek -50\r\nKPX Ocircumflex Aring -50\r\nKPX Ocircumflex Atilde -50\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -50\r\nKPX Ocircumflex X -50\r\nKPX Ocircumflex Y -70\r\nKPX Ocircumflex Yacute -70\r\nKPX Ocircumflex Ydieresis -70\r\nKPX Ocircumflex comma -40\r\nKPX Ocircumflex period -40\r\nKPX Odieresis A -50\r\nKPX Odieresis Aacute -50\r\nKPX Odieresis Abreve -50\r\nKPX Odieresis Acircumflex -50\r\nKPX Odieresis Adieresis -50\r\nKPX Odieresis Agrave -50\r\nKPX Odieresis Amacron -50\r\nKPX Odieresis Aogonek -50\r\nKPX Odieresis Aring -50\r\nKPX Odieresis Atilde -50\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -50\r\nKPX Odieresis X -50\r\nKPX Odieresis Y -70\r\nKPX Odieresis Yacute -70\r\nKPX Odieresis Ydieresis -70\r\nKPX Odieresis comma -40\r\nKPX Odieresis period -40\r\nKPX Ograve A -50\r\nKPX Ograve Aacute -50\r\nKPX Ograve Abreve -50\r\nKPX Ograve Acircumflex -50\r\nKPX Ograve Adieresis -50\r\nKPX Ograve Agrave -50\r\nKPX Ograve Amacron -50\r\nKPX Ograve Aogonek -50\r\nKPX Ograve Aring -50\r\nKPX Ograve Atilde -50\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -50\r\nKPX Ograve X -50\r\nKPX Ograve Y -70\r\nKPX Ograve Yacute -70\r\nKPX Ograve Ydieresis -70\r\nKPX Ograve comma -40\r\nKPX Ograve period -40\r\nKPX Ohungarumlaut A -50\r\nKPX Ohungarumlaut Aacute -50\r\nKPX Ohungarumlaut Abreve -50\r\nKPX Ohungarumlaut Acircumflex -50\r\nKPX Ohungarumlaut Adieresis -50\r\nKPX Ohungarumlaut Agrave -50\r\nKPX Ohungarumlaut Amacron -50\r\nKPX Ohungarumlaut Aogonek -50\r\nKPX Ohungarumlaut Aring -50\r\nKPX Ohungarumlaut Atilde -50\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -50\r\nKPX Ohungarumlaut X -50\r\nKPX Ohungarumlaut Y -70\r\nKPX Ohungarumlaut Yacute -70\r\nKPX Ohungarumlaut Ydieresis -70\r\nKPX Ohungarumlaut comma -40\r\nKPX Ohungarumlaut period -40\r\nKPX Omacron A -50\r\nKPX Omacron Aacute -50\r\nKPX Omacron Abreve -50\r\nKPX Omacron Acircumflex -50\r\nKPX Omacron Adieresis -50\r\nKPX Omacron Agrave -50\r\nKPX Omacron Amacron -50\r\nKPX Omacron Aogonek -50\r\nKPX Omacron Aring -50\r\nKPX Omacron Atilde -50\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -50\r\nKPX Omacron X -50\r\nKPX Omacron Y -70\r\nKPX Omacron Yacute -70\r\nKPX Omacron Ydieresis -70\r\nKPX Omacron comma -40\r\nKPX Omacron period -40\r\nKPX Oslash A -50\r\nKPX Oslash Aacute -50\r\nKPX Oslash Abreve -50\r\nKPX Oslash Acircumflex -50\r\nKPX Oslash Adieresis -50\r\nKPX Oslash Agrave -50\r\nKPX Oslash Amacron -50\r\nKPX Oslash Aogonek -50\r\nKPX Oslash Aring -50\r\nKPX Oslash Atilde -50\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -50\r\nKPX Oslash X -50\r\nKPX Oslash Y -70\r\nKPX Oslash Yacute -70\r\nKPX Oslash Ydieresis -70\r\nKPX Oslash comma -40\r\nKPX Oslash period -40\r\nKPX Otilde A -50\r\nKPX Otilde Aacute -50\r\nKPX Otilde Abreve -50\r\nKPX Otilde Acircumflex -50\r\nKPX Otilde Adieresis -50\r\nKPX Otilde Agrave -50\r\nKPX Otilde Amacron -50\r\nKPX Otilde Aogonek -50\r\nKPX Otilde Aring -50\r\nKPX Otilde Atilde -50\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -50\r\nKPX Otilde X -50\r\nKPX Otilde Y -70\r\nKPX Otilde Yacute -70\r\nKPX Otilde Ydieresis -70\r\nKPX Otilde comma -40\r\nKPX Otilde period -40\r\nKPX P A -100\r\nKPX P Aacute -100\r\nKPX P Abreve -100\r\nKPX P Acircumflex -100\r\nKPX P Adieresis -100\r\nKPX P Agrave -100\r\nKPX P Amacron -100\r\nKPX P Aogonek -100\r\nKPX P Aring -100\r\nKPX P Atilde -100\r\nKPX P a -30\r\nKPX P aacute -30\r\nKPX P abreve -30\r\nKPX P acircumflex -30\r\nKPX P adieresis -30\r\nKPX P agrave -30\r\nKPX P amacron -30\r\nKPX P aogonek -30\r\nKPX P aring -30\r\nKPX P atilde -30\r\nKPX P comma -120\r\nKPX P e -30\r\nKPX P eacute -30\r\nKPX P ecaron -30\r\nKPX P ecircumflex -30\r\nKPX P edieresis -30\r\nKPX P edotaccent -30\r\nKPX P egrave -30\r\nKPX P emacron -30\r\nKPX P eogonek -30\r\nKPX P o -40\r\nKPX P oacute -40\r\nKPX P ocircumflex -40\r\nKPX P odieresis -40\r\nKPX P ograve -40\r\nKPX P ohungarumlaut -40\r\nKPX P omacron -40\r\nKPX P oslash -40\r\nKPX P otilde -40\r\nKPX P period -120\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX Q comma 20\r\nKPX Q period 20\r\nKPX R O -20\r\nKPX R Oacute -20\r\nKPX R Ocircumflex -20\r\nKPX R Odieresis -20\r\nKPX R Ograve -20\r\nKPX R Ohungarumlaut -20\r\nKPX R Omacron -20\r\nKPX R Oslash -20\r\nKPX R Otilde -20\r\nKPX R T -20\r\nKPX R Tcaron -20\r\nKPX R Tcommaaccent -20\r\nKPX R U -20\r\nKPX R Uacute -20\r\nKPX R Ucircumflex -20\r\nKPX R Udieresis -20\r\nKPX R Ugrave -20\r\nKPX R Uhungarumlaut -20\r\nKPX R Umacron -20\r\nKPX R Uogonek -20\r\nKPX R Uring -20\r\nKPX R V -50\r\nKPX R W -40\r\nKPX R Y -50\r\nKPX R Yacute -50\r\nKPX R Ydieresis -50\r\nKPX Racute O -20\r\nKPX Racute Oacute -20\r\nKPX Racute Ocircumflex -20\r\nKPX Racute Odieresis -20\r\nKPX Racute Ograve -20\r\nKPX Racute Ohungarumlaut -20\r\nKPX Racute Omacron -20\r\nKPX Racute Oslash -20\r\nKPX Racute Otilde -20\r\nKPX Racute T -20\r\nKPX Racute Tcaron -20\r\nKPX Racute Tcommaaccent -20\r\nKPX Racute U -20\r\nKPX Racute Uacute -20\r\nKPX Racute Ucircumflex -20\r\nKPX Racute Udieresis -20\r\nKPX Racute Ugrave -20\r\nKPX Racute Uhungarumlaut -20\r\nKPX Racute Umacron -20\r\nKPX Racute Uogonek -20\r\nKPX Racute Uring -20\r\nKPX Racute V -50\r\nKPX Racute W -40\r\nKPX Racute Y -50\r\nKPX Racute Yacute -50\r\nKPX Racute Ydieresis -50\r\nKPX Rcaron O -20\r\nKPX Rcaron Oacute -20\r\nKPX Rcaron Ocircumflex -20\r\nKPX Rcaron Odieresis -20\r\nKPX Rcaron Ograve -20\r\nKPX Rcaron Ohungarumlaut -20\r\nKPX Rcaron Omacron -20\r\nKPX Rcaron Oslash -20\r\nKPX Rcaron Otilde -20\r\nKPX Rcaron T -20\r\nKPX Rcaron Tcaron -20\r\nKPX Rcaron Tcommaaccent -20\r\nKPX Rcaron U -20\r\nKPX Rcaron Uacute -20\r\nKPX Rcaron Ucircumflex -20\r\nKPX Rcaron Udieresis -20\r\nKPX Rcaron Ugrave -20\r\nKPX Rcaron Uhungarumlaut -20\r\nKPX Rcaron Umacron -20\r\nKPX Rcaron Uogonek -20\r\nKPX Rcaron Uring -20\r\nKPX Rcaron V -50\r\nKPX Rcaron W -40\r\nKPX Rcaron Y -50\r\nKPX Rcaron Yacute -50\r\nKPX Rcaron Ydieresis -50\r\nKPX Rcommaaccent O -20\r\nKPX Rcommaaccent Oacute -20\r\nKPX Rcommaaccent Ocircumflex -20\r\nKPX Rcommaaccent Odieresis -20\r\nKPX Rcommaaccent Ograve -20\r\nKPX Rcommaaccent Ohungarumlaut -20\r\nKPX Rcommaaccent Omacron -20\r\nKPX Rcommaaccent Oslash -20\r\nKPX Rcommaaccent Otilde -20\r\nKPX Rcommaaccent T -20\r\nKPX Rcommaaccent Tcaron -20\r\nKPX Rcommaaccent Tcommaaccent -20\r\nKPX Rcommaaccent U -20\r\nKPX Rcommaaccent Uacute -20\r\nKPX Rcommaaccent Ucircumflex -20\r\nKPX Rcommaaccent Udieresis -20\r\nKPX Rcommaaccent Ugrave -20\r\nKPX Rcommaaccent Uhungarumlaut -20\r\nKPX Rcommaaccent Umacron -20\r\nKPX Rcommaaccent Uogonek -20\r\nKPX Rcommaaccent Uring -20\r\nKPX Rcommaaccent V -50\r\nKPX Rcommaaccent W -40\r\nKPX Rcommaaccent Y -50\r\nKPX Rcommaaccent Yacute -50\r\nKPX Rcommaaccent Ydieresis -50\r\nKPX T A -90\r\nKPX T Aacute -90\r\nKPX T Abreve -90\r\nKPX T Acircumflex -90\r\nKPX T Adieresis -90\r\nKPX T Agrave -90\r\nKPX T Amacron -90\r\nKPX T Aogonek -90\r\nKPX T Aring -90\r\nKPX T Atilde -90\r\nKPX T O -40\r\nKPX T Oacute -40\r\nKPX T Ocircumflex -40\r\nKPX T Odieresis -40\r\nKPX T Ograve -40\r\nKPX T Ohungarumlaut -40\r\nKPX T Omacron -40\r\nKPX T Oslash -40\r\nKPX T Otilde -40\r\nKPX T a -80\r\nKPX T aacute -80\r\nKPX T abreve -80\r\nKPX T acircumflex -80\r\nKPX T adieresis -80\r\nKPX T agrave -80\r\nKPX T amacron -80\r\nKPX T aogonek -80\r\nKPX T aring -80\r\nKPX T atilde -80\r\nKPX T colon -40\r\nKPX T comma -80\r\nKPX T e -60\r\nKPX T eacute -60\r\nKPX T ecaron -60\r\nKPX T ecircumflex -60\r\nKPX T edieresis -60\r\nKPX T edotaccent -60\r\nKPX T egrave -60\r\nKPX T emacron -60\r\nKPX T eogonek -60\r\nKPX T hyphen -120\r\nKPX T o -80\r\nKPX T oacute -80\r\nKPX T ocircumflex -80\r\nKPX T odieresis -80\r\nKPX T ograve -80\r\nKPX T ohungarumlaut -80\r\nKPX T omacron -80\r\nKPX T oslash -80\r\nKPX T otilde -80\r\nKPX T period -80\r\nKPX T r -80\r\nKPX T racute -80\r\nKPX T rcommaaccent -80\r\nKPX T semicolon -40\r\nKPX T u -90\r\nKPX T uacute -90\r\nKPX T ucircumflex -90\r\nKPX T udieresis -90\r\nKPX T ugrave -90\r\nKPX T uhungarumlaut -90\r\nKPX T umacron -90\r\nKPX T uogonek -90\r\nKPX T uring -90\r\nKPX T w -60\r\nKPX T y -60\r\nKPX T yacute -60\r\nKPX T ydieresis -60\r\nKPX Tcaron A -90\r\nKPX Tcaron Aacute -90\r\nKPX Tcaron Abreve -90\r\nKPX Tcaron Acircumflex -90\r\nKPX Tcaron Adieresis -90\r\nKPX Tcaron Agrave -90\r\nKPX Tcaron Amacron -90\r\nKPX Tcaron Aogonek -90\r\nKPX Tcaron Aring -90\r\nKPX Tcaron Atilde -90\r\nKPX Tcaron O -40\r\nKPX Tcaron Oacute -40\r\nKPX Tcaron Ocircumflex -40\r\nKPX Tcaron Odieresis -40\r\nKPX Tcaron Ograve -40\r\nKPX Tcaron Ohungarumlaut -40\r\nKPX Tcaron Omacron -40\r\nKPX Tcaron Oslash -40\r\nKPX Tcaron Otilde -40\r\nKPX Tcaron a -80\r\nKPX Tcaron aacute -80\r\nKPX Tcaron abreve -80\r\nKPX Tcaron acircumflex -80\r\nKPX Tcaron adieresis -80\r\nKPX Tcaron agrave -80\r\nKPX Tcaron amacron -80\r\nKPX Tcaron aogonek -80\r\nKPX Tcaron aring -80\r\nKPX Tcaron atilde -80\r\nKPX Tcaron colon -40\r\nKPX Tcaron comma -80\r\nKPX Tcaron e -60\r\nKPX Tcaron eacute -60\r\nKPX Tcaron ecaron -60\r\nKPX Tcaron ecircumflex -60\r\nKPX Tcaron edieresis -60\r\nKPX Tcaron edotaccent -60\r\nKPX Tcaron egrave -60\r\nKPX Tcaron emacron -60\r\nKPX Tcaron eogonek -60\r\nKPX Tcaron hyphen -120\r\nKPX Tcaron o -80\r\nKPX Tcaron oacute -80\r\nKPX Tcaron ocircumflex -80\r\nKPX Tcaron odieresis -80\r\nKPX Tcaron ograve -80\r\nKPX Tcaron ohungarumlaut -80\r\nKPX Tcaron omacron -80\r\nKPX Tcaron oslash -80\r\nKPX Tcaron otilde -80\r\nKPX Tcaron period -80\r\nKPX Tcaron r -80\r\nKPX Tcaron racute -80\r\nKPX Tcaron rcommaaccent -80\r\nKPX Tcaron semicolon -40\r\nKPX Tcaron u -90\r\nKPX Tcaron uacute -90\r\nKPX Tcaron ucircumflex -90\r\nKPX Tcaron udieresis -90\r\nKPX Tcaron ugrave -90\r\nKPX Tcaron uhungarumlaut -90\r\nKPX Tcaron umacron -90\r\nKPX Tcaron uogonek -90\r\nKPX Tcaron uring -90\r\nKPX Tcaron w -60\r\nKPX Tcaron y -60\r\nKPX Tcaron yacute -60\r\nKPX Tcaron ydieresis -60\r\nKPX Tcommaaccent A -90\r\nKPX Tcommaaccent Aacute -90\r\nKPX Tcommaaccent Abreve -90\r\nKPX Tcommaaccent Acircumflex -90\r\nKPX Tcommaaccent Adieresis -90\r\nKPX Tcommaaccent Agrave -90\r\nKPX Tcommaaccent Amacron -90\r\nKPX Tcommaaccent Aogonek -90\r\nKPX Tcommaaccent Aring -90\r\nKPX Tcommaaccent Atilde -90\r\nKPX Tcommaaccent O -40\r\nKPX Tcommaaccent Oacute -40\r\nKPX Tcommaaccent Ocircumflex -40\r\nKPX Tcommaaccent Odieresis -40\r\nKPX Tcommaaccent Ograve -40\r\nKPX Tcommaaccent Ohungarumlaut -40\r\nKPX Tcommaaccent Omacron -40\r\nKPX Tcommaaccent Oslash -40\r\nKPX Tcommaaccent Otilde -40\r\nKPX Tcommaaccent a -80\r\nKPX Tcommaaccent aacute -80\r\nKPX Tcommaaccent abreve -80\r\nKPX Tcommaaccent acircumflex -80\r\nKPX Tcommaaccent adieresis -80\r\nKPX Tcommaaccent agrave -80\r\nKPX Tcommaaccent amacron -80\r\nKPX Tcommaaccent aogonek -80\r\nKPX Tcommaaccent aring -80\r\nKPX Tcommaaccent atilde -80\r\nKPX Tcommaaccent colon -40\r\nKPX Tcommaaccent comma -80\r\nKPX Tcommaaccent e -60\r\nKPX Tcommaaccent eacute -60\r\nKPX Tcommaaccent ecaron -60\r\nKPX Tcommaaccent ecircumflex -60\r\nKPX Tcommaaccent edieresis -60\r\nKPX Tcommaaccent edotaccent -60\r\nKPX Tcommaaccent egrave -60\r\nKPX Tcommaaccent emacron -60\r\nKPX Tcommaaccent eogonek -60\r\nKPX Tcommaaccent hyphen -120\r\nKPX Tcommaaccent o -80\r\nKPX Tcommaaccent oacute -80\r\nKPX Tcommaaccent ocircumflex -80\r\nKPX Tcommaaccent odieresis -80\r\nKPX Tcommaaccent ograve -80\r\nKPX Tcommaaccent ohungarumlaut -80\r\nKPX Tcommaaccent omacron -80\r\nKPX Tcommaaccent oslash -80\r\nKPX Tcommaaccent otilde -80\r\nKPX Tcommaaccent period -80\r\nKPX Tcommaaccent r -80\r\nKPX Tcommaaccent racute -80\r\nKPX Tcommaaccent rcommaaccent -80\r\nKPX Tcommaaccent semicolon -40\r\nKPX Tcommaaccent u -90\r\nKPX Tcommaaccent uacute -90\r\nKPX Tcommaaccent ucircumflex -90\r\nKPX Tcommaaccent udieresis -90\r\nKPX Tcommaaccent ugrave -90\r\nKPX Tcommaaccent uhungarumlaut -90\r\nKPX Tcommaaccent umacron -90\r\nKPX Tcommaaccent uogonek -90\r\nKPX Tcommaaccent uring -90\r\nKPX Tcommaaccent w -60\r\nKPX Tcommaaccent y -60\r\nKPX Tcommaaccent yacute -60\r\nKPX Tcommaaccent ydieresis -60\r\nKPX U A -50\r\nKPX U Aacute -50\r\nKPX U Abreve -50\r\nKPX U Acircumflex -50\r\nKPX U Adieresis -50\r\nKPX U Agrave -50\r\nKPX U Amacron -50\r\nKPX U Aogonek -50\r\nKPX U Aring -50\r\nKPX U Atilde -50\r\nKPX U comma -30\r\nKPX U period -30\r\nKPX Uacute A -50\r\nKPX Uacute Aacute -50\r\nKPX Uacute Abreve -50\r\nKPX Uacute Acircumflex -50\r\nKPX Uacute Adieresis -50\r\nKPX Uacute Agrave -50\r\nKPX Uacute Amacron -50\r\nKPX Uacute Aogonek -50\r\nKPX Uacute Aring -50\r\nKPX Uacute Atilde -50\r\nKPX Uacute comma -30\r\nKPX Uacute period -30\r\nKPX Ucircumflex A -50\r\nKPX Ucircumflex Aacute -50\r\nKPX Ucircumflex Abreve -50\r\nKPX Ucircumflex Acircumflex -50\r\nKPX Ucircumflex Adieresis -50\r\nKPX Ucircumflex Agrave -50\r\nKPX Ucircumflex Amacron -50\r\nKPX Ucircumflex Aogonek -50\r\nKPX Ucircumflex Aring -50\r\nKPX Ucircumflex Atilde -50\r\nKPX Ucircumflex comma -30\r\nKPX Ucircumflex period -30\r\nKPX Udieresis A -50\r\nKPX Udieresis Aacute -50\r\nKPX Udieresis Abreve -50\r\nKPX Udieresis Acircumflex -50\r\nKPX Udieresis Adieresis -50\r\nKPX Udieresis Agrave -50\r\nKPX Udieresis Amacron -50\r\nKPX Udieresis Aogonek -50\r\nKPX Udieresis Aring -50\r\nKPX Udieresis Atilde -50\r\nKPX Udieresis comma -30\r\nKPX Udieresis period -30\r\nKPX Ugrave A -50\r\nKPX Ugrave Aacute -50\r\nKPX Ugrave Abreve -50\r\nKPX Ugrave Acircumflex -50\r\nKPX Ugrave Adieresis -50\r\nKPX Ugrave Agrave -50\r\nKPX Ugrave Amacron -50\r\nKPX Ugrave Aogonek -50\r\nKPX Ugrave Aring -50\r\nKPX Ugrave Atilde -50\r\nKPX Ugrave comma -30\r\nKPX Ugrave period -30\r\nKPX Uhungarumlaut A -50\r\nKPX Uhungarumlaut Aacute -50\r\nKPX Uhungarumlaut Abreve -50\r\nKPX Uhungarumlaut Acircumflex -50\r\nKPX Uhungarumlaut Adieresis -50\r\nKPX Uhungarumlaut Agrave -50\r\nKPX Uhungarumlaut Amacron -50\r\nKPX Uhungarumlaut Aogonek -50\r\nKPX Uhungarumlaut Aring -50\r\nKPX Uhungarumlaut Atilde -50\r\nKPX Uhungarumlaut comma -30\r\nKPX Uhungarumlaut period -30\r\nKPX Umacron A -50\r\nKPX Umacron Aacute -50\r\nKPX Umacron Abreve -50\r\nKPX Umacron Acircumflex -50\r\nKPX Umacron Adieresis -50\r\nKPX Umacron Agrave -50\r\nKPX Umacron Amacron -50\r\nKPX Umacron Aogonek -50\r\nKPX Umacron Aring -50\r\nKPX Umacron Atilde -50\r\nKPX Umacron comma -30\r\nKPX Umacron period -30\r\nKPX Uogonek A -50\r\nKPX Uogonek Aacute -50\r\nKPX Uogonek Abreve -50\r\nKPX Uogonek Acircumflex -50\r\nKPX Uogonek Adieresis -50\r\nKPX Uogonek Agrave -50\r\nKPX Uogonek Amacron -50\r\nKPX Uogonek Aogonek -50\r\nKPX Uogonek Aring -50\r\nKPX Uogonek Atilde -50\r\nKPX Uogonek comma -30\r\nKPX Uogonek period -30\r\nKPX Uring A -50\r\nKPX Uring Aacute -50\r\nKPX Uring Abreve -50\r\nKPX Uring Acircumflex -50\r\nKPX Uring Adieresis -50\r\nKPX Uring Agrave -50\r\nKPX Uring Amacron -50\r\nKPX Uring Aogonek -50\r\nKPX Uring Aring -50\r\nKPX Uring Atilde -50\r\nKPX Uring comma -30\r\nKPX Uring period -30\r\nKPX V A -80\r\nKPX V Aacute -80\r\nKPX V Abreve -80\r\nKPX V Acircumflex -80\r\nKPX V Adieresis -80\r\nKPX V Agrave -80\r\nKPX V Amacron -80\r\nKPX V Aogonek -80\r\nKPX V Aring -80\r\nKPX V Atilde -80\r\nKPX V G -50\r\nKPX V Gbreve -50\r\nKPX V Gcommaaccent -50\r\nKPX V O -50\r\nKPX V Oacute -50\r\nKPX V Ocircumflex -50\r\nKPX V Odieresis -50\r\nKPX V Ograve -50\r\nKPX V Ohungarumlaut -50\r\nKPX V Omacron -50\r\nKPX V Oslash -50\r\nKPX V Otilde -50\r\nKPX V a -60\r\nKPX V aacute -60\r\nKPX V abreve -60\r\nKPX V acircumflex -60\r\nKPX V adieresis -60\r\nKPX V agrave -60\r\nKPX V amacron -60\r\nKPX V aogonek -60\r\nKPX V aring -60\r\nKPX V atilde -60\r\nKPX V colon -40\r\nKPX V comma -120\r\nKPX V e -50\r\nKPX V eacute -50\r\nKPX V ecaron -50\r\nKPX V ecircumflex -50\r\nKPX V edieresis -50\r\nKPX V edotaccent -50\r\nKPX V egrave -50\r\nKPX V emacron -50\r\nKPX V eogonek -50\r\nKPX V hyphen -80\r\nKPX V o -90\r\nKPX V oacute -90\r\nKPX V ocircumflex -90\r\nKPX V odieresis -90\r\nKPX V ograve -90\r\nKPX V ohungarumlaut -90\r\nKPX V omacron -90\r\nKPX V oslash -90\r\nKPX V otilde -90\r\nKPX V period -120\r\nKPX V semicolon -40\r\nKPX V u -60\r\nKPX V uacute -60\r\nKPX V ucircumflex -60\r\nKPX V udieresis -60\r\nKPX V ugrave -60\r\nKPX V uhungarumlaut -60\r\nKPX V umacron -60\r\nKPX V uogonek -60\r\nKPX V uring -60\r\nKPX W A -60\r\nKPX W Aacute -60\r\nKPX W Abreve -60\r\nKPX W Acircumflex -60\r\nKPX W Adieresis -60\r\nKPX W Agrave -60\r\nKPX W Amacron -60\r\nKPX W Aogonek -60\r\nKPX W Aring -60\r\nKPX W Atilde -60\r\nKPX W O -20\r\nKPX W Oacute -20\r\nKPX W Ocircumflex -20\r\nKPX W Odieresis -20\r\nKPX W Ograve -20\r\nKPX W Ohungarumlaut -20\r\nKPX W Omacron -20\r\nKPX W Oslash -20\r\nKPX W Otilde -20\r\nKPX W a -40\r\nKPX W aacute -40\r\nKPX W abreve -40\r\nKPX W acircumflex -40\r\nKPX W adieresis -40\r\nKPX W agrave -40\r\nKPX W amacron -40\r\nKPX W aogonek -40\r\nKPX W aring -40\r\nKPX W atilde -40\r\nKPX W colon -10\r\nKPX W comma -80\r\nKPX W e -35\r\nKPX W eacute -35\r\nKPX W ecaron -35\r\nKPX W ecircumflex -35\r\nKPX W edieresis -35\r\nKPX W edotaccent -35\r\nKPX W egrave -35\r\nKPX W emacron -35\r\nKPX W eogonek -35\r\nKPX W hyphen -40\r\nKPX W o -60\r\nKPX W oacute -60\r\nKPX W ocircumflex -60\r\nKPX W odieresis -60\r\nKPX W ograve -60\r\nKPX W ohungarumlaut -60\r\nKPX W omacron -60\r\nKPX W oslash -60\r\nKPX W otilde -60\r\nKPX W period -80\r\nKPX W semicolon -10\r\nKPX W u -45\r\nKPX W uacute -45\r\nKPX W ucircumflex -45\r\nKPX W udieresis -45\r\nKPX W ugrave -45\r\nKPX W uhungarumlaut -45\r\nKPX W umacron -45\r\nKPX W uogonek -45\r\nKPX W uring -45\r\nKPX W y -20\r\nKPX W yacute -20\r\nKPX W ydieresis -20\r\nKPX Y A -110\r\nKPX Y Aacute -110\r\nKPX Y Abreve -110\r\nKPX Y Acircumflex -110\r\nKPX Y Adieresis -110\r\nKPX Y Agrave -110\r\nKPX Y Amacron -110\r\nKPX Y Aogonek -110\r\nKPX Y Aring -110\r\nKPX Y Atilde -110\r\nKPX Y O -70\r\nKPX Y Oacute -70\r\nKPX Y Ocircumflex -70\r\nKPX Y Odieresis -70\r\nKPX Y Ograve -70\r\nKPX Y Ohungarumlaut -70\r\nKPX Y Omacron -70\r\nKPX Y Oslash -70\r\nKPX Y Otilde -70\r\nKPX Y a -90\r\nKPX Y aacute -90\r\nKPX Y abreve -90\r\nKPX Y acircumflex -90\r\nKPX Y adieresis -90\r\nKPX Y agrave -90\r\nKPX Y amacron -90\r\nKPX Y aogonek -90\r\nKPX Y aring -90\r\nKPX Y atilde -90\r\nKPX Y colon -50\r\nKPX Y comma -100\r\nKPX Y e -80\r\nKPX Y eacute -80\r\nKPX Y ecaron -80\r\nKPX Y ecircumflex -80\r\nKPX Y edieresis -80\r\nKPX Y edotaccent -80\r\nKPX Y egrave -80\r\nKPX Y emacron -80\r\nKPX Y eogonek -80\r\nKPX Y o -100\r\nKPX Y oacute -100\r\nKPX Y ocircumflex -100\r\nKPX Y odieresis -100\r\nKPX Y ograve -100\r\nKPX Y ohungarumlaut -100\r\nKPX Y omacron -100\r\nKPX Y oslash -100\r\nKPX Y otilde -100\r\nKPX Y period -100\r\nKPX Y semicolon -50\r\nKPX Y u -100\r\nKPX Y uacute -100\r\nKPX Y ucircumflex -100\r\nKPX Y udieresis -100\r\nKPX Y ugrave -100\r\nKPX Y uhungarumlaut -100\r\nKPX Y umacron -100\r\nKPX Y uogonek -100\r\nKPX Y uring -100\r\nKPX Yacute A -110\r\nKPX Yacute Aacute -110\r\nKPX Yacute Abreve -110\r\nKPX Yacute Acircumflex -110\r\nKPX Yacute Adieresis -110\r\nKPX Yacute Agrave -110\r\nKPX Yacute Amacron -110\r\nKPX Yacute Aogonek -110\r\nKPX Yacute Aring -110\r\nKPX Yacute Atilde -110\r\nKPX Yacute O -70\r\nKPX Yacute Oacute -70\r\nKPX Yacute Ocircumflex -70\r\nKPX Yacute Odieresis -70\r\nKPX Yacute Ograve -70\r\nKPX Yacute Ohungarumlaut -70\r\nKPX Yacute Omacron -70\r\nKPX Yacute Oslash -70\r\nKPX Yacute Otilde -70\r\nKPX Yacute a -90\r\nKPX Yacute aacute -90\r\nKPX Yacute abreve -90\r\nKPX Yacute acircumflex -90\r\nKPX Yacute adieresis -90\r\nKPX Yacute agrave -90\r\nKPX Yacute amacron -90\r\nKPX Yacute aogonek -90\r\nKPX Yacute aring -90\r\nKPX Yacute atilde -90\r\nKPX Yacute colon -50\r\nKPX Yacute comma -100\r\nKPX Yacute e -80\r\nKPX Yacute eacute -80\r\nKPX Yacute ecaron -80\r\nKPX Yacute ecircumflex -80\r\nKPX Yacute edieresis -80\r\nKPX Yacute edotaccent -80\r\nKPX Yacute egrave -80\r\nKPX Yacute emacron -80\r\nKPX Yacute eogonek -80\r\nKPX Yacute o -100\r\nKPX Yacute oacute -100\r\nKPX Yacute ocircumflex -100\r\nKPX Yacute odieresis -100\r\nKPX Yacute ograve -100\r\nKPX Yacute ohungarumlaut -100\r\nKPX Yacute omacron -100\r\nKPX Yacute oslash -100\r\nKPX Yacute otilde -100\r\nKPX Yacute period -100\r\nKPX Yacute semicolon -50\r\nKPX Yacute u -100\r\nKPX Yacute uacute -100\r\nKPX Yacute ucircumflex -100\r\nKPX Yacute udieresis -100\r\nKPX Yacute ugrave -100\r\nKPX Yacute uhungarumlaut -100\r\nKPX Yacute umacron -100\r\nKPX Yacute uogonek -100\r\nKPX Yacute uring -100\r\nKPX Ydieresis A -110\r\nKPX Ydieresis Aacute -110\r\nKPX Ydieresis Abreve -110\r\nKPX Ydieresis Acircumflex -110\r\nKPX Ydieresis Adieresis -110\r\nKPX Ydieresis Agrave -110\r\nKPX Ydieresis Amacron -110\r\nKPX Ydieresis Aogonek -110\r\nKPX Ydieresis Aring -110\r\nKPX Ydieresis Atilde -110\r\nKPX Ydieresis O -70\r\nKPX Ydieresis Oacute -70\r\nKPX Ydieresis Ocircumflex -70\r\nKPX Ydieresis Odieresis -70\r\nKPX Ydieresis Ograve -70\r\nKPX Ydieresis Ohungarumlaut -70\r\nKPX Ydieresis Omacron -70\r\nKPX Ydieresis Oslash -70\r\nKPX Ydieresis Otilde -70\r\nKPX Ydieresis a -90\r\nKPX Ydieresis aacute -90\r\nKPX Ydieresis abreve -90\r\nKPX Ydieresis acircumflex -90\r\nKPX Ydieresis adieresis -90\r\nKPX Ydieresis agrave -90\r\nKPX Ydieresis amacron -90\r\nKPX Ydieresis aogonek -90\r\nKPX Ydieresis aring -90\r\nKPX Ydieresis atilde -90\r\nKPX Ydieresis colon -50\r\nKPX Ydieresis comma -100\r\nKPX Ydieresis e -80\r\nKPX Ydieresis eacute -80\r\nKPX Ydieresis ecaron -80\r\nKPX Ydieresis ecircumflex -80\r\nKPX Ydieresis edieresis -80\r\nKPX Ydieresis edotaccent -80\r\nKPX Ydieresis egrave -80\r\nKPX Ydieresis emacron -80\r\nKPX Ydieresis eogonek -80\r\nKPX Ydieresis o -100\r\nKPX Ydieresis oacute -100\r\nKPX Ydieresis ocircumflex -100\r\nKPX Ydieresis odieresis -100\r\nKPX Ydieresis ograve -100\r\nKPX Ydieresis ohungarumlaut -100\r\nKPX Ydieresis omacron -100\r\nKPX Ydieresis oslash -100\r\nKPX Ydieresis otilde -100\r\nKPX Ydieresis period -100\r\nKPX Ydieresis semicolon -50\r\nKPX Ydieresis u -100\r\nKPX Ydieresis uacute -100\r\nKPX Ydieresis ucircumflex -100\r\nKPX Ydieresis udieresis -100\r\nKPX Ydieresis ugrave -100\r\nKPX Ydieresis uhungarumlaut -100\r\nKPX Ydieresis umacron -100\r\nKPX Ydieresis uogonek -100\r\nKPX Ydieresis uring -100\r\nKPX a g -10\r\nKPX a gbreve -10\r\nKPX a gcommaaccent -10\r\nKPX a v -15\r\nKPX a w -15\r\nKPX a y -20\r\nKPX a yacute -20\r\nKPX a ydieresis -20\r\nKPX aacute g -10\r\nKPX aacute gbreve -10\r\nKPX aacute gcommaaccent -10\r\nKPX aacute v -15\r\nKPX aacute w -15\r\nKPX aacute y -20\r\nKPX aacute yacute -20\r\nKPX aacute ydieresis -20\r\nKPX abreve g -10\r\nKPX abreve gbreve -10\r\nKPX abreve gcommaaccent -10\r\nKPX abreve v -15\r\nKPX abreve w -15\r\nKPX abreve y -20\r\nKPX abreve yacute -20\r\nKPX abreve ydieresis -20\r\nKPX acircumflex g -10\r\nKPX acircumflex gbreve -10\r\nKPX acircumflex gcommaaccent -10\r\nKPX acircumflex v -15\r\nKPX acircumflex w -15\r\nKPX acircumflex y -20\r\nKPX acircumflex yacute -20\r\nKPX acircumflex ydieresis -20\r\nKPX adieresis g -10\r\nKPX adieresis gbreve -10\r\nKPX adieresis gcommaaccent -10\r\nKPX adieresis v -15\r\nKPX adieresis w -15\r\nKPX adieresis y -20\r\nKPX adieresis yacute -20\r\nKPX adieresis ydieresis -20\r\nKPX agrave g -10\r\nKPX agrave gbreve -10\r\nKPX agrave gcommaaccent -10\r\nKPX agrave v -15\r\nKPX agrave w -15\r\nKPX agrave y -20\r\nKPX agrave yacute -20\r\nKPX agrave ydieresis -20\r\nKPX amacron g -10\r\nKPX amacron gbreve -10\r\nKPX amacron gcommaaccent -10\r\nKPX amacron v -15\r\nKPX amacron w -15\r\nKPX amacron y -20\r\nKPX amacron yacute -20\r\nKPX amacron ydieresis -20\r\nKPX aogonek g -10\r\nKPX aogonek gbreve -10\r\nKPX aogonek gcommaaccent -10\r\nKPX aogonek v -15\r\nKPX aogonek w -15\r\nKPX aogonek y -20\r\nKPX aogonek yacute -20\r\nKPX aogonek ydieresis -20\r\nKPX aring g -10\r\nKPX aring gbreve -10\r\nKPX aring gcommaaccent -10\r\nKPX aring v -15\r\nKPX aring w -15\r\nKPX aring y -20\r\nKPX aring yacute -20\r\nKPX aring ydieresis -20\r\nKPX atilde g -10\r\nKPX atilde gbreve -10\r\nKPX atilde gcommaaccent -10\r\nKPX atilde v -15\r\nKPX atilde w -15\r\nKPX atilde y -20\r\nKPX atilde yacute -20\r\nKPX atilde ydieresis -20\r\nKPX b l -10\r\nKPX b lacute -10\r\nKPX b lcommaaccent -10\r\nKPX b lslash -10\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -20\r\nKPX b y -20\r\nKPX b yacute -20\r\nKPX b ydieresis -20\r\nKPX c h -10\r\nKPX c k -20\r\nKPX c kcommaaccent -20\r\nKPX c l -20\r\nKPX c lacute -20\r\nKPX c lcommaaccent -20\r\nKPX c lslash -20\r\nKPX c y -10\r\nKPX c yacute -10\r\nKPX c ydieresis -10\r\nKPX cacute h -10\r\nKPX cacute k -20\r\nKPX cacute kcommaaccent -20\r\nKPX cacute l -20\r\nKPX cacute lacute -20\r\nKPX cacute lcommaaccent -20\r\nKPX cacute lslash -20\r\nKPX cacute y -10\r\nKPX cacute yacute -10\r\nKPX cacute ydieresis -10\r\nKPX ccaron h -10\r\nKPX ccaron k -20\r\nKPX ccaron kcommaaccent -20\r\nKPX ccaron l -20\r\nKPX ccaron lacute -20\r\nKPX ccaron lcommaaccent -20\r\nKPX ccaron lslash -20\r\nKPX ccaron y -10\r\nKPX ccaron yacute -10\r\nKPX ccaron ydieresis -10\r\nKPX ccedilla h -10\r\nKPX ccedilla k -20\r\nKPX ccedilla kcommaaccent -20\r\nKPX ccedilla l -20\r\nKPX ccedilla lacute -20\r\nKPX ccedilla lcommaaccent -20\r\nKPX ccedilla lslash -20\r\nKPX ccedilla y -10\r\nKPX ccedilla yacute -10\r\nKPX ccedilla ydieresis -10\r\nKPX colon space -40\r\nKPX comma quotedblright -120\r\nKPX comma quoteright -120\r\nKPX comma space -40\r\nKPX d d -10\r\nKPX d dcroat -10\r\nKPX d v -15\r\nKPX d w -15\r\nKPX d y -15\r\nKPX d yacute -15\r\nKPX d ydieresis -15\r\nKPX dcroat d -10\r\nKPX dcroat dcroat -10\r\nKPX dcroat v -15\r\nKPX dcroat w -15\r\nKPX dcroat y -15\r\nKPX dcroat yacute -15\r\nKPX dcroat ydieresis -15\r\nKPX e comma 10\r\nKPX e period 20\r\nKPX e v -15\r\nKPX e w -15\r\nKPX e x -15\r\nKPX e y -15\r\nKPX e yacute -15\r\nKPX e ydieresis -15\r\nKPX eacute comma 10\r\nKPX eacute period 20\r\nKPX eacute v -15\r\nKPX eacute w -15\r\nKPX eacute x -15\r\nKPX eacute y -15\r\nKPX eacute yacute -15\r\nKPX eacute ydieresis -15\r\nKPX ecaron comma 10\r\nKPX ecaron period 20\r\nKPX ecaron v -15\r\nKPX ecaron w -15\r\nKPX ecaron x -15\r\nKPX ecaron y -15\r\nKPX ecaron yacute -15\r\nKPX ecaron ydieresis -15\r\nKPX ecircumflex comma 10\r\nKPX ecircumflex period 20\r\nKPX ecircumflex v -15\r\nKPX ecircumflex w -15\r\nKPX ecircumflex x -15\r\nKPX ecircumflex y -15\r\nKPX ecircumflex yacute -15\r\nKPX ecircumflex ydieresis -15\r\nKPX edieresis comma 10\r\nKPX edieresis period 20\r\nKPX edieresis v -15\r\nKPX edieresis w -15\r\nKPX edieresis x -15\r\nKPX edieresis y -15\r\nKPX edieresis yacute -15\r\nKPX edieresis ydieresis -15\r\nKPX edotaccent comma 10\r\nKPX edotaccent period 20\r\nKPX edotaccent v -15\r\nKPX edotaccent w -15\r\nKPX edotaccent x -15\r\nKPX edotaccent y -15\r\nKPX edotaccent yacute -15\r\nKPX edotaccent ydieresis -15\r\nKPX egrave comma 10\r\nKPX egrave period 20\r\nKPX egrave v -15\r\nKPX egrave w -15\r\nKPX egrave x -15\r\nKPX egrave y -15\r\nKPX egrave yacute -15\r\nKPX egrave ydieresis -15\r\nKPX emacron comma 10\r\nKPX emacron period 20\r\nKPX emacron v -15\r\nKPX emacron w -15\r\nKPX emacron x -15\r\nKPX emacron y -15\r\nKPX emacron yacute -15\r\nKPX emacron ydieresis -15\r\nKPX eogonek comma 10\r\nKPX eogonek period 20\r\nKPX eogonek v -15\r\nKPX eogonek w -15\r\nKPX eogonek x -15\r\nKPX eogonek y -15\r\nKPX eogonek yacute -15\r\nKPX eogonek ydieresis -15\r\nKPX f comma -10\r\nKPX f e -10\r\nKPX f eacute -10\r\nKPX f ecaron -10\r\nKPX f ecircumflex -10\r\nKPX f edieresis -10\r\nKPX f edotaccent -10\r\nKPX f egrave -10\r\nKPX f emacron -10\r\nKPX f eogonek -10\r\nKPX f o -20\r\nKPX f oacute -20\r\nKPX f ocircumflex -20\r\nKPX f odieresis -20\r\nKPX f ograve -20\r\nKPX f ohungarumlaut -20\r\nKPX f omacron -20\r\nKPX f oslash -20\r\nKPX f otilde -20\r\nKPX f period -10\r\nKPX f quotedblright 30\r\nKPX f quoteright 30\r\nKPX g e 10\r\nKPX g eacute 10\r\nKPX g ecaron 10\r\nKPX g ecircumflex 10\r\nKPX g edieresis 10\r\nKPX g edotaccent 10\r\nKPX g egrave 10\r\nKPX g emacron 10\r\nKPX g eogonek 10\r\nKPX g g -10\r\nKPX g gbreve -10\r\nKPX g gcommaaccent -10\r\nKPX gbreve e 10\r\nKPX gbreve eacute 10\r\nKPX gbreve ecaron 10\r\nKPX gbreve ecircumflex 10\r\nKPX gbreve edieresis 10\r\nKPX gbreve edotaccent 10\r\nKPX gbreve egrave 10\r\nKPX gbreve emacron 10\r\nKPX gbreve eogonek 10\r\nKPX gbreve g -10\r\nKPX gbreve gbreve -10\r\nKPX gbreve gcommaaccent -10\r\nKPX gcommaaccent e 10\r\nKPX gcommaaccent eacute 10\r\nKPX gcommaaccent ecaron 10\r\nKPX gcommaaccent ecircumflex 10\r\nKPX gcommaaccent edieresis 10\r\nKPX gcommaaccent edotaccent 10\r\nKPX gcommaaccent egrave 10\r\nKPX gcommaaccent emacron 10\r\nKPX gcommaaccent eogonek 10\r\nKPX gcommaaccent g -10\r\nKPX gcommaaccent gbreve -10\r\nKPX gcommaaccent gcommaaccent -10\r\nKPX h y -20\r\nKPX h yacute -20\r\nKPX h ydieresis -20\r\nKPX k o -15\r\nKPX k oacute -15\r\nKPX k ocircumflex -15\r\nKPX k odieresis -15\r\nKPX k ograve -15\r\nKPX k ohungarumlaut -15\r\nKPX k omacron -15\r\nKPX k oslash -15\r\nKPX k otilde -15\r\nKPX kcommaaccent o -15\r\nKPX kcommaaccent oacute -15\r\nKPX kcommaaccent ocircumflex -15\r\nKPX kcommaaccent odieresis -15\r\nKPX kcommaaccent ograve -15\r\nKPX kcommaaccent ohungarumlaut -15\r\nKPX kcommaaccent omacron -15\r\nKPX kcommaaccent oslash -15\r\nKPX kcommaaccent otilde -15\r\nKPX l w -15\r\nKPX l y -15\r\nKPX l yacute -15\r\nKPX l ydieresis -15\r\nKPX lacute w -15\r\nKPX lacute y -15\r\nKPX lacute yacute -15\r\nKPX lacute ydieresis -15\r\nKPX lcommaaccent w -15\r\nKPX lcommaaccent y -15\r\nKPX lcommaaccent yacute -15\r\nKPX lcommaaccent ydieresis -15\r\nKPX lslash w -15\r\nKPX lslash y -15\r\nKPX lslash yacute -15\r\nKPX lslash ydieresis -15\r\nKPX m u -20\r\nKPX m uacute -20\r\nKPX m ucircumflex -20\r\nKPX m udieresis -20\r\nKPX m ugrave -20\r\nKPX m uhungarumlaut -20\r\nKPX m umacron -20\r\nKPX m uogonek -20\r\nKPX m uring -20\r\nKPX m y -30\r\nKPX m yacute -30\r\nKPX m ydieresis -30\r\nKPX n u -10\r\nKPX n uacute -10\r\nKPX n ucircumflex -10\r\nKPX n udieresis -10\r\nKPX n ugrave -10\r\nKPX n uhungarumlaut -10\r\nKPX n umacron -10\r\nKPX n uogonek -10\r\nKPX n uring -10\r\nKPX n v -40\r\nKPX n y -20\r\nKPX n yacute -20\r\nKPX n ydieresis -20\r\nKPX nacute u -10\r\nKPX nacute uacute -10\r\nKPX nacute ucircumflex -10\r\nKPX nacute udieresis -10\r\nKPX nacute ugrave -10\r\nKPX nacute uhungarumlaut -10\r\nKPX nacute umacron -10\r\nKPX nacute uogonek -10\r\nKPX nacute uring -10\r\nKPX nacute v -40\r\nKPX nacute y -20\r\nKPX nacute yacute -20\r\nKPX nacute ydieresis -20\r\nKPX ncaron u -10\r\nKPX ncaron uacute -10\r\nKPX ncaron ucircumflex -10\r\nKPX ncaron udieresis -10\r\nKPX ncaron ugrave -10\r\nKPX ncaron uhungarumlaut -10\r\nKPX ncaron umacron -10\r\nKPX ncaron uogonek -10\r\nKPX ncaron uring -10\r\nKPX ncaron v -40\r\nKPX ncaron y -20\r\nKPX ncaron yacute -20\r\nKPX ncaron ydieresis -20\r\nKPX ncommaaccent u -10\r\nKPX ncommaaccent uacute -10\r\nKPX ncommaaccent ucircumflex -10\r\nKPX ncommaaccent udieresis -10\r\nKPX ncommaaccent ugrave -10\r\nKPX ncommaaccent uhungarumlaut -10\r\nKPX ncommaaccent umacron -10\r\nKPX ncommaaccent uogonek -10\r\nKPX ncommaaccent uring -10\r\nKPX ncommaaccent v -40\r\nKPX ncommaaccent y -20\r\nKPX ncommaaccent yacute -20\r\nKPX ncommaaccent ydieresis -20\r\nKPX ntilde u -10\r\nKPX ntilde uacute -10\r\nKPX ntilde ucircumflex -10\r\nKPX ntilde udieresis -10\r\nKPX ntilde ugrave -10\r\nKPX ntilde uhungarumlaut -10\r\nKPX ntilde umacron -10\r\nKPX ntilde uogonek -10\r\nKPX ntilde uring -10\r\nKPX ntilde v -40\r\nKPX ntilde y -20\r\nKPX ntilde yacute -20\r\nKPX ntilde ydieresis -20\r\nKPX o v -20\r\nKPX o w -15\r\nKPX o x -30\r\nKPX o y -20\r\nKPX o yacute -20\r\nKPX o ydieresis -20\r\nKPX oacute v -20\r\nKPX oacute w -15\r\nKPX oacute x -30\r\nKPX oacute y -20\r\nKPX oacute yacute -20\r\nKPX oacute ydieresis -20\r\nKPX ocircumflex v -20\r\nKPX ocircumflex w -15\r\nKPX ocircumflex x -30\r\nKPX ocircumflex y -20\r\nKPX ocircumflex yacute -20\r\nKPX ocircumflex ydieresis -20\r\nKPX odieresis v -20\r\nKPX odieresis w -15\r\nKPX odieresis x -30\r\nKPX odieresis y -20\r\nKPX odieresis yacute -20\r\nKPX odieresis ydieresis -20\r\nKPX ograve v -20\r\nKPX ograve w -15\r\nKPX ograve x -30\r\nKPX ograve y -20\r\nKPX ograve yacute -20\r\nKPX ograve ydieresis -20\r\nKPX ohungarumlaut v -20\r\nKPX ohungarumlaut w -15\r\nKPX ohungarumlaut x -30\r\nKPX ohungarumlaut y -20\r\nKPX ohungarumlaut yacute -20\r\nKPX ohungarumlaut ydieresis -20\r\nKPX omacron v -20\r\nKPX omacron w -15\r\nKPX omacron x -30\r\nKPX omacron y -20\r\nKPX omacron yacute -20\r\nKPX omacron ydieresis -20\r\nKPX oslash v -20\r\nKPX oslash w -15\r\nKPX oslash x -30\r\nKPX oslash y -20\r\nKPX oslash yacute -20\r\nKPX oslash ydieresis -20\r\nKPX otilde v -20\r\nKPX otilde w -15\r\nKPX otilde x -30\r\nKPX otilde y -20\r\nKPX otilde yacute -20\r\nKPX otilde ydieresis -20\r\nKPX p y -15\r\nKPX p yacute -15\r\nKPX p ydieresis -15\r\nKPX period quotedblright -120\r\nKPX period quoteright -120\r\nKPX period space -40\r\nKPX quotedblright space -80\r\nKPX quoteleft quoteleft -46\r\nKPX quoteright d -80\r\nKPX quoteright dcroat -80\r\nKPX quoteright l -20\r\nKPX quoteright lacute -20\r\nKPX quoteright lcommaaccent -20\r\nKPX quoteright lslash -20\r\nKPX quoteright quoteright -46\r\nKPX quoteright r -40\r\nKPX quoteright racute -40\r\nKPX quoteright rcaron -40\r\nKPX quoteright rcommaaccent -40\r\nKPX quoteright s -60\r\nKPX quoteright sacute -60\r\nKPX quoteright scaron -60\r\nKPX quoteright scedilla -60\r\nKPX quoteright scommaaccent -60\r\nKPX quoteright space -80\r\nKPX quoteright v -20\r\nKPX r c -20\r\nKPX r cacute -20\r\nKPX r ccaron -20\r\nKPX r ccedilla -20\r\nKPX r comma -60\r\nKPX r d -20\r\nKPX r dcroat -20\r\nKPX r g -15\r\nKPX r gbreve -15\r\nKPX r gcommaaccent -15\r\nKPX r hyphen -20\r\nKPX r o -20\r\nKPX r oacute -20\r\nKPX r ocircumflex -20\r\nKPX r odieresis -20\r\nKPX r ograve -20\r\nKPX r ohungarumlaut -20\r\nKPX r omacron -20\r\nKPX r oslash -20\r\nKPX r otilde -20\r\nKPX r period -60\r\nKPX r q -20\r\nKPX r s -15\r\nKPX r sacute -15\r\nKPX r scaron -15\r\nKPX r scedilla -15\r\nKPX r scommaaccent -15\r\nKPX r t 20\r\nKPX r tcommaaccent 20\r\nKPX r v 10\r\nKPX r y 10\r\nKPX r yacute 10\r\nKPX r ydieresis 10\r\nKPX racute c -20\r\nKPX racute cacute -20\r\nKPX racute ccaron -20\r\nKPX racute ccedilla -20\r\nKPX racute comma -60\r\nKPX racute d -20\r\nKPX racute dcroat -20\r\nKPX racute g -15\r\nKPX racute gbreve -15\r\nKPX racute gcommaaccent -15\r\nKPX racute hyphen -20\r\nKPX racute o -20\r\nKPX racute oacute -20\r\nKPX racute ocircumflex -20\r\nKPX racute odieresis -20\r\nKPX racute ograve -20\r\nKPX racute ohungarumlaut -20\r\nKPX racute omacron -20\r\nKPX racute oslash -20\r\nKPX racute otilde -20\r\nKPX racute period -60\r\nKPX racute q -20\r\nKPX racute s -15\r\nKPX racute sacute -15\r\nKPX racute scaron -15\r\nKPX racute scedilla -15\r\nKPX racute scommaaccent -15\r\nKPX racute t 20\r\nKPX racute tcommaaccent 20\r\nKPX racute v 10\r\nKPX racute y 10\r\nKPX racute yacute 10\r\nKPX racute ydieresis 10\r\nKPX rcaron c -20\r\nKPX rcaron cacute -20\r\nKPX rcaron ccaron -20\r\nKPX rcaron ccedilla -20\r\nKPX rcaron comma -60\r\nKPX rcaron d -20\r\nKPX rcaron dcroat -20\r\nKPX rcaron g -15\r\nKPX rcaron gbreve -15\r\nKPX rcaron gcommaaccent -15\r\nKPX rcaron hyphen -20\r\nKPX rcaron o -20\r\nKPX rcaron oacute -20\r\nKPX rcaron ocircumflex -20\r\nKPX rcaron odieresis -20\r\nKPX rcaron ograve -20\r\nKPX rcaron ohungarumlaut -20\r\nKPX rcaron omacron -20\r\nKPX rcaron oslash -20\r\nKPX rcaron otilde -20\r\nKPX rcaron period -60\r\nKPX rcaron q -20\r\nKPX rcaron s -15\r\nKPX rcaron sacute -15\r\nKPX rcaron scaron -15\r\nKPX rcaron scedilla -15\r\nKPX rcaron scommaaccent -15\r\nKPX rcaron t 20\r\nKPX rcaron tcommaaccent 20\r\nKPX rcaron v 10\r\nKPX rcaron y 10\r\nKPX rcaron yacute 10\r\nKPX rcaron ydieresis 10\r\nKPX rcommaaccent c -20\r\nKPX rcommaaccent cacute -20\r\nKPX rcommaaccent ccaron -20\r\nKPX rcommaaccent ccedilla -20\r\nKPX rcommaaccent comma -60\r\nKPX rcommaaccent d -20\r\nKPX rcommaaccent dcroat -20\r\nKPX rcommaaccent g -15\r\nKPX rcommaaccent gbreve -15\r\nKPX rcommaaccent gcommaaccent -15\r\nKPX rcommaaccent hyphen -20\r\nKPX rcommaaccent o -20\r\nKPX rcommaaccent oacute -20\r\nKPX rcommaaccent ocircumflex -20\r\nKPX rcommaaccent odieresis -20\r\nKPX rcommaaccent ograve -20\r\nKPX rcommaaccent ohungarumlaut -20\r\nKPX rcommaaccent omacron -20\r\nKPX rcommaaccent oslash -20\r\nKPX rcommaaccent otilde -20\r\nKPX rcommaaccent period -60\r\nKPX rcommaaccent q -20\r\nKPX rcommaaccent s -15\r\nKPX rcommaaccent sacute -15\r\nKPX rcommaaccent scaron -15\r\nKPX rcommaaccent scedilla -15\r\nKPX rcommaaccent scommaaccent -15\r\nKPX rcommaaccent t 20\r\nKPX rcommaaccent tcommaaccent 20\r\nKPX rcommaaccent v 10\r\nKPX rcommaaccent y 10\r\nKPX rcommaaccent yacute 10\r\nKPX rcommaaccent ydieresis 10\r\nKPX s w -15\r\nKPX sacute w -15\r\nKPX scaron w -15\r\nKPX scedilla w -15\r\nKPX scommaaccent w -15\r\nKPX semicolon space -40\r\nKPX space T -100\r\nKPX space Tcaron -100\r\nKPX space Tcommaaccent -100\r\nKPX space V -80\r\nKPX space W -80\r\nKPX space Y -120\r\nKPX space Yacute -120\r\nKPX space Ydieresis -120\r\nKPX space quotedblleft -80\r\nKPX space quoteleft -60\r\nKPX v a -20\r\nKPX v aacute -20\r\nKPX v abreve -20\r\nKPX v acircumflex -20\r\nKPX v adieresis -20\r\nKPX v agrave -20\r\nKPX v amacron -20\r\nKPX v aogonek -20\r\nKPX v aring -20\r\nKPX v atilde -20\r\nKPX v comma -80\r\nKPX v o -30\r\nKPX v oacute -30\r\nKPX v ocircumflex -30\r\nKPX v odieresis -30\r\nKPX v ograve -30\r\nKPX v ohungarumlaut -30\r\nKPX v omacron -30\r\nKPX v oslash -30\r\nKPX v otilde -30\r\nKPX v period -80\r\nKPX w comma -40\r\nKPX w o -20\r\nKPX w oacute -20\r\nKPX w ocircumflex -20\r\nKPX w odieresis -20\r\nKPX w ograve -20\r\nKPX w ohungarumlaut -20\r\nKPX w omacron -20\r\nKPX w oslash -20\r\nKPX w otilde -20\r\nKPX w period -40\r\nKPX x e -10\r\nKPX x eacute -10\r\nKPX x ecaron -10\r\nKPX x ecircumflex -10\r\nKPX x edieresis -10\r\nKPX x edotaccent -10\r\nKPX x egrave -10\r\nKPX x emacron -10\r\nKPX x eogonek -10\r\nKPX y a -30\r\nKPX y aacute -30\r\nKPX y abreve -30\r\nKPX y acircumflex -30\r\nKPX y adieresis -30\r\nKPX y agrave -30\r\nKPX y amacron -30\r\nKPX y aogonek -30\r\nKPX y aring -30\r\nKPX y atilde -30\r\nKPX y comma -80\r\nKPX y e -10\r\nKPX y eacute -10\r\nKPX y ecaron -10\r\nKPX y ecircumflex -10\r\nKPX y edieresis -10\r\nKPX y edotaccent -10\r\nKPX y egrave -10\r\nKPX y emacron -10\r\nKPX y eogonek -10\r\nKPX y o -25\r\nKPX y oacute -25\r\nKPX y ocircumflex -25\r\nKPX y odieresis -25\r\nKPX y ograve -25\r\nKPX y ohungarumlaut -25\r\nKPX y omacron -25\r\nKPX y oslash -25\r\nKPX y otilde -25\r\nKPX y period -80\r\nKPX yacute a -30\r\nKPX yacute aacute -30\r\nKPX yacute abreve -30\r\nKPX yacute acircumflex -30\r\nKPX yacute adieresis -30\r\nKPX yacute agrave -30\r\nKPX yacute amacron -30\r\nKPX yacute aogonek -30\r\nKPX yacute aring -30\r\nKPX yacute atilde -30\r\nKPX yacute comma -80\r\nKPX yacute e -10\r\nKPX yacute eacute -10\r\nKPX yacute ecaron -10\r\nKPX yacute ecircumflex -10\r\nKPX yacute edieresis -10\r\nKPX yacute edotaccent -10\r\nKPX yacute egrave -10\r\nKPX yacute emacron -10\r\nKPX yacute eogonek -10\r\nKPX yacute o -25\r\nKPX yacute oacute -25\r\nKPX yacute ocircumflex -25\r\nKPX yacute odieresis -25\r\nKPX yacute ograve -25\r\nKPX yacute ohungarumlaut -25\r\nKPX yacute omacron -25\r\nKPX yacute oslash -25\r\nKPX yacute otilde -25\r\nKPX yacute period -80\r\nKPX ydieresis a -30\r\nKPX ydieresis aacute -30\r\nKPX ydieresis abreve -30\r\nKPX ydieresis acircumflex -30\r\nKPX ydieresis adieresis -30\r\nKPX ydieresis agrave -30\r\nKPX ydieresis amacron -30\r\nKPX ydieresis aogonek -30\r\nKPX ydieresis aring -30\r\nKPX ydieresis atilde -30\r\nKPX ydieresis comma -80\r\nKPX ydieresis e -10\r\nKPX ydieresis eacute -10\r\nKPX ydieresis ecaron -10\r\nKPX ydieresis ecircumflex -10\r\nKPX ydieresis edieresis -10\r\nKPX ydieresis edotaccent -10\r\nKPX ydieresis egrave -10\r\nKPX ydieresis emacron -10\r\nKPX ydieresis eogonek -10\r\nKPX ydieresis o -25\r\nKPX ydieresis oacute -25\r\nKPX ydieresis ocircumflex -25\r\nKPX ydieresis odieresis -25\r\nKPX ydieresis ograve -25\r\nKPX ydieresis ohungarumlaut -25\r\nKPX ydieresis omacron -25\r\nKPX ydieresis oslash -25\r\nKPX ydieresis otilde -25\r\nKPX ydieresis period -80\r\nKPX z e 10\r\nKPX z eacute 10\r\nKPX z ecaron 10\r\nKPX z ecircumflex 10\r\nKPX z edieresis 10\r\nKPX z edotaccent 10\r\nKPX z egrave 10\r\nKPX z emacron 10\r\nKPX z eogonek 10\r\nKPX zacute e 10\r\nKPX zacute eacute 10\r\nKPX zacute ecaron 10\r\nKPX zacute ecircumflex 10\r\nKPX zacute edieresis 10\r\nKPX zacute edotaccent 10\r\nKPX zacute egrave 10\r\nKPX zacute emacron 10\r\nKPX zacute eogonek 10\r\nKPX zcaron e 10\r\nKPX zcaron eacute 10\r\nKPX zcaron ecaron 10\r\nKPX zcaron ecircumflex 10\r\nKPX zcaron edieresis 10\r\nKPX zcaron edotaccent 10\r\nKPX zcaron egrave 10\r\nKPX zcaron emacron 10\r\nKPX zcaron eogonek 10\r\nKPX zdotaccent e 10\r\nKPX zdotaccent eacute 10\r\nKPX zdotaccent ecaron 10\r\nKPX zdotaccent ecircumflex 10\r\nKPX zdotaccent edieresis 10\r\nKPX zdotaccent edotaccent 10\r\nKPX zdotaccent egrave 10\r\nKPX zdotaccent emacron 10\r\nKPX zdotaccent eogonek 10\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Helvetica-Oblique"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:44:31 1997\r\nComment UniqueID 43055\r\nComment VMusage 14960 69346\r\nFontName Helvetica-Oblique\r\nFullName Helvetica Oblique\r\nFamilyName Helvetica\r\nWeight Medium\r\nItalicAngle -12\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -170 -225 1116 931 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 718\r\nXHeight 523\r\nAscender 718\r\nDescender -207\r\nStdHW 76\r\nStdVW 88\r\nStartCharMetrics 315\r\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 278 ; N exclam ; B 90 0 340 718 ;\r\nC 34 ; WX 355 ; N quotedbl ; B 168 463 438 718 ;\r\nC 35 ; WX 556 ; N numbersign ; B 73 0 631 688 ;\r\nC 36 ; WX 556 ; N dollar ; B 69 -115 617 775 ;\r\nC 37 ; WX 889 ; N percent ; B 147 -19 889 703 ;\r\nC 38 ; WX 667 ; N ampersand ; B 77 -15 647 718 ;\r\nC 39 ; WX 222 ; N quoteright ; B 151 463 310 718 ;\r\nC 40 ; WX 333 ; N parenleft ; B 108 -207 454 733 ;\r\nC 41 ; WX 333 ; N parenright ; B -9 -207 337 733 ;\r\nC 42 ; WX 389 ; N asterisk ; B 165 431 475 718 ;\r\nC 43 ; WX 584 ; N plus ; B 85 0 606 505 ;\r\nC 44 ; WX 278 ; N comma ; B 56 -147 214 106 ;\r\nC 45 ; WX 333 ; N hyphen ; B 93 232 357 322 ;\r\nC 46 ; WX 278 ; N period ; B 87 0 214 106 ;\r\nC 47 ; WX 278 ; N slash ; B -21 -19 452 737 ;\r\nC 48 ; WX 556 ; N zero ; B 93 -19 608 703 ;\r\nC 49 ; WX 556 ; N one ; B 207 0 508 703 ;\r\nC 50 ; WX 556 ; N two ; B 26 0 617 703 ;\r\nC 51 ; WX 556 ; N three ; B 75 -19 610 703 ;\r\nC 52 ; WX 556 ; N four ; B 61 0 576 703 ;\r\nC 53 ; WX 556 ; N five ; B 68 -19 621 688 ;\r\nC 54 ; WX 556 ; N six ; B 91 -19 615 703 ;\r\nC 55 ; WX 556 ; N seven ; B 137 0 669 688 ;\r\nC 56 ; WX 556 ; N eight ; B 74 -19 607 703 ;\r\nC 57 ; WX 556 ; N nine ; B 82 -19 609 703 ;\r\nC 58 ; WX 278 ; N colon ; B 87 0 301 516 ;\r\nC 59 ; WX 278 ; N semicolon ; B 56 -147 301 516 ;\r\nC 60 ; WX 584 ; N less ; B 94 11 641 495 ;\r\nC 61 ; WX 584 ; N equal ; B 63 115 628 390 ;\r\nC 62 ; WX 584 ; N greater ; B 50 11 597 495 ;\r\nC 63 ; WX 556 ; N question ; B 161 0 610 727 ;\r\nC 64 ; WX 1015 ; N at ; B 215 -19 965 737 ;\r\nC 65 ; WX 667 ; N A ; B 14 0 654 718 ;\r\nC 66 ; WX 667 ; N B ; B 74 0 712 718 ;\r\nC 67 ; WX 722 ; N C ; B 108 -19 782 737 ;\r\nC 68 ; WX 722 ; N D ; B 81 0 764 718 ;\r\nC 69 ; WX 667 ; N E ; B 86 0 762 718 ;\r\nC 70 ; WX 611 ; N F ; B 86 0 736 718 ;\r\nC 71 ; WX 778 ; N G ; B 111 -19 799 737 ;\r\nC 72 ; WX 722 ; N H ; B 77 0 799 718 ;\r\nC 73 ; WX 278 ; N I ; B 91 0 341 718 ;\r\nC 74 ; WX 500 ; N J ; B 47 -19 581 718 ;\r\nC 75 ; WX 667 ; N K ; B 76 0 808 718 ;\r\nC 76 ; WX 556 ; N L ; B 76 0 555 718 ;\r\nC 77 ; WX 833 ; N M ; B 73 0 914 718 ;\r\nC 78 ; WX 722 ; N N ; B 76 0 799 718 ;\r\nC 79 ; WX 778 ; N O ; B 105 -19 826 737 ;\r\nC 80 ; WX 667 ; N P ; B 86 0 737 718 ;\r\nC 81 ; WX 778 ; N Q ; B 105 -56 826 737 ;\r\nC 82 ; WX 722 ; N R ; B 88 0 773 718 ;\r\nC 83 ; WX 667 ; N S ; B 90 -19 713 737 ;\r\nC 84 ; WX 611 ; N T ; B 148 0 750 718 ;\r\nC 85 ; WX 722 ; N U ; B 123 -19 797 718 ;\r\nC 86 ; WX 667 ; N V ; B 173 0 800 718 ;\r\nC 87 ; WX 944 ; N W ; B 169 0 1081 718 ;\r\nC 88 ; WX 667 ; N X ; B 19 0 790 718 ;\r\nC 89 ; WX 667 ; N Y ; B 167 0 806 718 ;\r\nC 90 ; WX 611 ; N Z ; B 23 0 741 718 ;\r\nC 91 ; WX 278 ; N bracketleft ; B 21 -196 403 722 ;\r\nC 92 ; WX 278 ; N backslash ; B 140 -19 291 737 ;\r\nC 93 ; WX 278 ; N bracketright ; B -14 -196 368 722 ;\r\nC 94 ; WX 469 ; N asciicircum ; B 42 264 539 688 ;\r\nC 95 ; WX 556 ; N underscore ; B -27 -125 540 -75 ;\r\nC 96 ; WX 222 ; N quoteleft ; B 165 470 323 725 ;\r\nC 97 ; WX 556 ; N a ; B 61 -15 559 538 ;\r\nC 98 ; WX 556 ; N b ; B 58 -15 584 718 ;\r\nC 99 ; WX 500 ; N c ; B 74 -15 553 538 ;\r\nC 100 ; WX 556 ; N d ; B 84 -15 652 718 ;\r\nC 101 ; WX 556 ; N e ; B 84 -15 578 538 ;\r\nC 102 ; WX 278 ; N f ; B 86 0 416 728 ; L i fi ; L l fl ;\r\nC 103 ; WX 556 ; N g ; B 42 -220 610 538 ;\r\nC 104 ; WX 556 ; N h ; B 65 0 573 718 ;\r\nC 105 ; WX 222 ; N i ; B 67 0 308 718 ;\r\nC 106 ; WX 222 ; N j ; B -60 -210 308 718 ;\r\nC 107 ; WX 500 ; N k ; B 67 0 600 718 ;\r\nC 108 ; WX 222 ; N l ; B 67 0 308 718 ;\r\nC 109 ; WX 833 ; N m ; B 65 0 852 538 ;\r\nC 110 ; WX 556 ; N n ; B 65 0 573 538 ;\r\nC 111 ; WX 556 ; N o ; B 83 -14 585 538 ;\r\nC 112 ; WX 556 ; N p ; B 14 -207 584 538 ;\r\nC 113 ; WX 556 ; N q ; B 84 -207 605 538 ;\r\nC 114 ; WX 333 ; N r ; B 77 0 446 538 ;\r\nC 115 ; WX 500 ; N s ; B 63 -15 529 538 ;\r\nC 116 ; WX 278 ; N t ; B 102 -7 368 669 ;\r\nC 117 ; WX 556 ; N u ; B 94 -15 600 523 ;\r\nC 118 ; WX 500 ; N v ; B 119 0 603 523 ;\r\nC 119 ; WX 722 ; N w ; B 125 0 820 523 ;\r\nC 120 ; WX 500 ; N x ; B 11 0 594 523 ;\r\nC 121 ; WX 500 ; N y ; B 15 -214 600 523 ;\r\nC 122 ; WX 500 ; N z ; B 31 0 571 523 ;\r\nC 123 ; WX 334 ; N braceleft ; B 92 -196 445 722 ;\r\nC 124 ; WX 260 ; N bar ; B 46 -225 332 775 ;\r\nC 125 ; WX 334 ; N braceright ; B 0 -196 354 722 ;\r\nC 126 ; WX 584 ; N asciitilde ; B 111 180 580 326 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 77 -195 326 523 ;\r\nC 162 ; WX 556 ; N cent ; B 95 -115 584 623 ;\r\nC 163 ; WX 556 ; N sterling ; B 49 -16 634 718 ;\r\nC 164 ; WX 167 ; N fraction ; B -170 -19 482 703 ;\r\nC 165 ; WX 556 ; N yen ; B 81 0 699 688 ;\r\nC 166 ; WX 556 ; N florin ; B -52 -207 654 737 ;\r\nC 167 ; WX 556 ; N section ; B 76 -191 584 737 ;\r\nC 168 ; WX 556 ; N currency ; B 60 99 646 603 ;\r\nC 169 ; WX 191 ; N quotesingle ; B 157 463 285 718 ;\r\nC 170 ; WX 333 ; N quotedblleft ; B 138 470 461 725 ;\r\nC 171 ; WX 556 ; N guillemotleft ; B 146 108 554 446 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 137 108 340 446 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 111 108 314 446 ;\r\nC 174 ; WX 500 ; N fi ; B 86 0 587 728 ;\r\nC 175 ; WX 500 ; N fl ; B 86 0 585 728 ;\r\nC 177 ; WX 556 ; N endash ; B 51 240 623 313 ;\r\nC 178 ; WX 556 ; N dagger ; B 135 -159 622 718 ;\r\nC 179 ; WX 556 ; N daggerdbl ; B 52 -159 623 718 ;\r\nC 180 ; WX 278 ; N periodcentered ; B 129 190 257 315 ;\r\nC 182 ; WX 537 ; N paragraph ; B 126 -173 650 718 ;\r\nC 183 ; WX 350 ; N bullet ; B 91 202 413 517 ;\r\nC 184 ; WX 222 ; N quotesinglbase ; B 21 -149 180 106 ;\r\nC 185 ; WX 333 ; N quotedblbase ; B -6 -149 318 106 ;\r\nC 186 ; WX 333 ; N quotedblright ; B 124 463 448 718 ;\r\nC 187 ; WX 556 ; N guillemotright ; B 120 108 528 446 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 115 0 908 106 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 88 -19 1029 703 ;\r\nC 191 ; WX 611 ; N questiondown ; B 85 -201 534 525 ;\r\nC 193 ; WX 333 ; N grave ; B 170 593 337 734 ;\r\nC 194 ; WX 333 ; N acute ; B 248 593 475 734 ;\r\nC 195 ; WX 333 ; N circumflex ; B 147 593 438 734 ;\r\nC 196 ; WX 333 ; N tilde ; B 125 606 490 722 ;\r\nC 197 ; WX 333 ; N macron ; B 143 627 468 684 ;\r\nC 198 ; WX 333 ; N breve ; B 167 595 476 731 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 249 604 362 706 ;\r\nC 200 ; WX 333 ; N dieresis ; B 168 604 443 706 ;\r\nC 202 ; WX 333 ; N ring ; B 214 572 402 756 ;\r\nC 203 ; WX 333 ; N cedilla ; B 2 -225 232 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 157 593 565 734 ;\r\nC 206 ; WX 333 ; N ogonek ; B 43 -225 249 0 ;\r\nC 207 ; WX 333 ; N caron ; B 177 593 468 734 ;\r\nC 208 ; WX 1000 ; N emdash ; B 51 240 1067 313 ;\r\nC 225 ; WX 1000 ; N AE ; B 8 0 1097 718 ;\r\nC 227 ; WX 370 ; N ordfeminine ; B 127 405 449 737 ;\r\nC 232 ; WX 556 ; N Lslash ; B 41 0 555 718 ;\r\nC 233 ; WX 778 ; N Oslash ; B 43 -19 890 737 ;\r\nC 234 ; WX 1000 ; N OE ; B 98 -19 1116 737 ;\r\nC 235 ; WX 365 ; N ordmasculine ; B 141 405 468 737 ;\r\nC 241 ; WX 889 ; N ae ; B 61 -15 909 538 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 95 0 294 523 ;\r\nC 248 ; WX 222 ; N lslash ; B 41 0 347 718 ;\r\nC 249 ; WX 611 ; N oslash ; B 29 -22 647 545 ;\r\nC 250 ; WX 944 ; N oe ; B 83 -15 964 538 ;\r\nC 251 ; WX 611 ; N germandbls ; B 67 -15 658 728 ;\r\nC -1 ; WX 278 ; N Idieresis ; B 91 0 458 901 ;\r\nC -1 ; WX 556 ; N eacute ; B 84 -15 587 734 ;\r\nC -1 ; WX 556 ; N abreve ; B 61 -15 578 731 ;\r\nC -1 ; WX 556 ; N uhungarumlaut ; B 94 -15 677 734 ;\r\nC -1 ; WX 556 ; N ecaron ; B 84 -15 580 734 ;\r\nC -1 ; WX 667 ; N Ydieresis ; B 167 0 806 901 ;\r\nC -1 ; WX 584 ; N divide ; B 85 -19 606 524 ;\r\nC -1 ; WX 667 ; N Yacute ; B 167 0 806 929 ;\r\nC -1 ; WX 667 ; N Acircumflex ; B 14 0 654 929 ;\r\nC -1 ; WX 556 ; N aacute ; B 61 -15 587 734 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 123 -19 797 929 ;\r\nC -1 ; WX 500 ; N yacute ; B 15 -214 600 734 ;\r\nC -1 ; WX 500 ; N scommaaccent ; B 63 -225 529 538 ;\r\nC -1 ; WX 556 ; N ecircumflex ; B 84 -15 578 734 ;\r\nC -1 ; WX 722 ; N Uring ; B 123 -19 797 931 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 123 -19 797 901 ;\r\nC -1 ; WX 556 ; N aogonek ; B 61 -220 559 538 ;\r\nC -1 ; WX 722 ; N Uacute ; B 123 -19 797 929 ;\r\nC -1 ; WX 556 ; N uogonek ; B 94 -225 600 523 ;\r\nC -1 ; WX 667 ; N Edieresis ; B 86 0 762 901 ;\r\nC -1 ; WX 722 ; N Dcroat ; B 69 0 764 718 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 39 -225 172 -40 ;\r\nC -1 ; WX 737 ; N copyright ; B 54 -19 837 737 ;\r\nC -1 ; WX 667 ; N Emacron ; B 86 0 762 879 ;\r\nC -1 ; WX 500 ; N ccaron ; B 74 -15 553 734 ;\r\nC -1 ; WX 556 ; N aring ; B 61 -15 559 756 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 76 -225 799 718 ;\r\nC -1 ; WX 222 ; N lacute ; B 67 0 461 929 ;\r\nC -1 ; WX 556 ; N agrave ; B 61 -15 559 734 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 148 -225 750 718 ;\r\nC -1 ; WX 722 ; N Cacute ; B 108 -19 782 929 ;\r\nC -1 ; WX 556 ; N atilde ; B 61 -15 592 722 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B 86 0 762 901 ;\r\nC -1 ; WX 500 ; N scaron ; B 63 -15 552 734 ;\r\nC -1 ; WX 500 ; N scedilla ; B 63 -225 529 538 ;\r\nC -1 ; WX 278 ; N iacute ; B 95 0 448 734 ;\r\nC -1 ; WX 471 ; N lozenge ; B 88 0 540 728 ;\r\nC -1 ; WX 722 ; N Rcaron ; B 88 0 773 929 ;\r\nC -1 ; WX 778 ; N Gcommaaccent ; B 111 -225 799 737 ;\r\nC -1 ; WX 556 ; N ucircumflex ; B 94 -15 600 734 ;\r\nC -1 ; WX 556 ; N acircumflex ; B 61 -15 559 734 ;\r\nC -1 ; WX 667 ; N Amacron ; B 14 0 677 879 ;\r\nC -1 ; WX 333 ; N rcaron ; B 77 0 508 734 ;\r\nC -1 ; WX 500 ; N ccedilla ; B 74 -225 553 538 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B 23 0 741 901 ;\r\nC -1 ; WX 667 ; N Thorn ; B 86 0 712 718 ;\r\nC -1 ; WX 778 ; N Omacron ; B 105 -19 826 879 ;\r\nC -1 ; WX 722 ; N Racute ; B 88 0 773 929 ;\r\nC -1 ; WX 667 ; N Sacute ; B 90 -19 713 929 ;\r\nC -1 ; WX 643 ; N dcaron ; B 84 -15 808 718 ;\r\nC -1 ; WX 722 ; N Umacron ; B 123 -19 797 879 ;\r\nC -1 ; WX 556 ; N uring ; B 94 -15 600 756 ;\r\nC -1 ; WX 333 ; N threesuperior ; B 90 270 436 703 ;\r\nC -1 ; WX 778 ; N Ograve ; B 105 -19 826 929 ;\r\nC -1 ; WX 667 ; N Agrave ; B 14 0 654 929 ;\r\nC -1 ; WX 667 ; N Abreve ; B 14 0 685 926 ;\r\nC -1 ; WX 584 ; N multiply ; B 50 0 642 506 ;\r\nC -1 ; WX 556 ; N uacute ; B 94 -15 600 734 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 148 0 750 929 ;\r\nC -1 ; WX 476 ; N partialdiff ; B 41 -38 550 714 ;\r\nC -1 ; WX 500 ; N ydieresis ; B 15 -214 600 706 ;\r\nC -1 ; WX 722 ; N Nacute ; B 76 0 799 929 ;\r\nC -1 ; WX 278 ; N icircumflex ; B 95 0 411 734 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B 86 0 762 929 ;\r\nC -1 ; WX 556 ; N adieresis ; B 61 -15 559 706 ;\r\nC -1 ; WX 556 ; N edieresis ; B 84 -15 578 706 ;\r\nC -1 ; WX 500 ; N cacute ; B 74 -15 559 734 ;\r\nC -1 ; WX 556 ; N nacute ; B 65 0 587 734 ;\r\nC -1 ; WX 556 ; N umacron ; B 94 -15 600 684 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 76 0 799 929 ;\r\nC -1 ; WX 278 ; N Iacute ; B 91 0 489 929 ;\r\nC -1 ; WX 584 ; N plusminus ; B 39 0 618 506 ;\r\nC -1 ; WX 260 ; N brokenbar ; B 62 -150 316 700 ;\r\nC -1 ; WX 737 ; N registered ; B 54 -19 837 737 ;\r\nC -1 ; WX 778 ; N Gbreve ; B 111 -19 799 926 ;\r\nC -1 ; WX 278 ; N Idotaccent ; B 91 0 377 901 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 671 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B 86 0 762 929 ;\r\nC -1 ; WX 333 ; N racute ; B 77 0 475 734 ;\r\nC -1 ; WX 556 ; N omacron ; B 83 -14 585 684 ;\r\nC -1 ; WX 611 ; N Zacute ; B 23 0 741 929 ;\r\nC -1 ; WX 611 ; N Zcaron ; B 23 0 741 929 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 620 674 ;\r\nC -1 ; WX 722 ; N Eth ; B 69 0 764 718 ;\r\nC -1 ; WX 722 ; N Ccedilla ; B 108 -225 782 737 ;\r\nC -1 ; WX 222 ; N lcommaaccent ; B 25 -225 308 718 ;\r\nC -1 ; WX 317 ; N tcaron ; B 102 -7 501 808 ;\r\nC -1 ; WX 556 ; N eogonek ; B 84 -225 578 538 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 123 -225 797 718 ;\r\nC -1 ; WX 667 ; N Aacute ; B 14 0 683 929 ;\r\nC -1 ; WX 667 ; N Adieresis ; B 14 0 654 901 ;\r\nC -1 ; WX 556 ; N egrave ; B 84 -15 578 734 ;\r\nC -1 ; WX 500 ; N zacute ; B 31 0 571 734 ;\r\nC -1 ; WX 222 ; N iogonek ; B -61 -225 308 718 ;\r\nC -1 ; WX 778 ; N Oacute ; B 105 -19 826 929 ;\r\nC -1 ; WX 556 ; N oacute ; B 83 -14 587 734 ;\r\nC -1 ; WX 556 ; N amacron ; B 61 -15 580 684 ;\r\nC -1 ; WX 500 ; N sacute ; B 63 -15 559 734 ;\r\nC -1 ; WX 278 ; N idieresis ; B 95 0 416 706 ;\r\nC -1 ; WX 778 ; N Ocircumflex ; B 105 -19 826 929 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 123 -19 797 929 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 556 ; N thorn ; B 14 -207 584 718 ;\r\nC -1 ; WX 333 ; N twosuperior ; B 64 281 449 703 ;\r\nC -1 ; WX 778 ; N Odieresis ; B 105 -19 826 901 ;\r\nC -1 ; WX 556 ; N mu ; B 24 -207 600 523 ;\r\nC -1 ; WX 278 ; N igrave ; B 95 0 310 734 ;\r\nC -1 ; WX 556 ; N ohungarumlaut ; B 83 -14 677 734 ;\r\nC -1 ; WX 667 ; N Eogonek ; B 86 -220 762 718 ;\r\nC -1 ; WX 556 ; N dcroat ; B 84 -15 689 718 ;\r\nC -1 ; WX 834 ; N threequarters ; B 130 -19 861 703 ;\r\nC -1 ; WX 667 ; N Scedilla ; B 90 -225 713 737 ;\r\nC -1 ; WX 299 ; N lcaron ; B 67 0 464 718 ;\r\nC -1 ; WX 667 ; N Kcommaaccent ; B 76 -225 808 718 ;\r\nC -1 ; WX 556 ; N Lacute ; B 76 0 555 929 ;\r\nC -1 ; WX 1000 ; N trademark ; B 186 306 1056 718 ;\r\nC -1 ; WX 556 ; N edotaccent ; B 84 -15 578 706 ;\r\nC -1 ; WX 278 ; N Igrave ; B 91 0 351 929 ;\r\nC -1 ; WX 278 ; N Imacron ; B 91 0 483 879 ;\r\nC -1 ; WX 556 ; N Lcaron ; B 76 0 570 718 ;\r\nC -1 ; WX 834 ; N onehalf ; B 114 -19 839 703 ;\r\nC -1 ; WX 549 ; N lessequal ; B 26 0 666 674 ;\r\nC -1 ; WX 556 ; N ocircumflex ; B 83 -14 585 734 ;\r\nC -1 ; WX 556 ; N ntilde ; B 65 0 592 722 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 123 -19 801 929 ;\r\nC -1 ; WX 667 ; N Eacute ; B 86 0 762 929 ;\r\nC -1 ; WX 556 ; N emacron ; B 84 -15 580 684 ;\r\nC -1 ; WX 556 ; N gbreve ; B 42 -220 610 731 ;\r\nC -1 ; WX 834 ; N onequarter ; B 150 -19 802 703 ;\r\nC -1 ; WX 667 ; N Scaron ; B 90 -19 713 929 ;\r\nC -1 ; WX 667 ; N Scommaaccent ; B 90 -225 713 737 ;\r\nC -1 ; WX 778 ; N Ohungarumlaut ; B 105 -19 829 929 ;\r\nC -1 ; WX 400 ; N degree ; B 169 411 468 703 ;\r\nC -1 ; WX 556 ; N ograve ; B 83 -14 585 734 ;\r\nC -1 ; WX 722 ; N Ccaron ; B 108 -19 782 929 ;\r\nC -1 ; WX 556 ; N ugrave ; B 94 -15 600 734 ;\r\nC -1 ; WX 453 ; N radical ; B 79 -80 617 762 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 81 0 764 929 ;\r\nC -1 ; WX 333 ; N rcommaaccent ; B 30 -225 446 538 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 76 0 799 917 ;\r\nC -1 ; WX 556 ; N otilde ; B 83 -14 602 722 ;\r\nC -1 ; WX 722 ; N Rcommaaccent ; B 88 -225 773 718 ;\r\nC -1 ; WX 556 ; N Lcommaaccent ; B 76 -225 555 718 ;\r\nC -1 ; WX 667 ; N Atilde ; B 14 0 699 917 ;\r\nC -1 ; WX 667 ; N Aogonek ; B 14 -225 654 718 ;\r\nC -1 ; WX 667 ; N Aring ; B 14 0 654 931 ;\r\nC -1 ; WX 778 ; N Otilde ; B 105 -19 826 917 ;\r\nC -1 ; WX 500 ; N zdotaccent ; B 31 0 571 706 ;\r\nC -1 ; WX 667 ; N Ecaron ; B 86 0 762 929 ;\r\nC -1 ; WX 278 ; N Iogonek ; B -33 -225 341 718 ;\r\nC -1 ; WX 500 ; N kcommaaccent ; B 67 -225 600 718 ;\r\nC -1 ; WX 584 ; N minus ; B 85 216 606 289 ;\r\nC -1 ; WX 278 ; N Icircumflex ; B 91 0 452 929 ;\r\nC -1 ; WX 556 ; N ncaron ; B 65 0 580 734 ;\r\nC -1 ; WX 278 ; N tcommaaccent ; B 63 -225 368 669 ;\r\nC -1 ; WX 584 ; N logicalnot ; B 106 108 628 390 ;\r\nC -1 ; WX 556 ; N odieresis ; B 83 -14 585 706 ;\r\nC -1 ; WX 556 ; N udieresis ; B 94 -15 600 706 ;\r\nC -1 ; WX 549 ; N notequal ; B 34 -35 623 551 ;\r\nC -1 ; WX 556 ; N gcommaaccent ; B 42 -220 610 822 ;\r\nC -1 ; WX 556 ; N eth ; B 81 -15 617 737 ;\r\nC -1 ; WX 500 ; N zcaron ; B 31 0 571 734 ;\r\nC -1 ; WX 556 ; N ncommaaccent ; B 65 -225 573 538 ;\r\nC -1 ; WX 333 ; N onesuperior ; B 166 281 371 703 ;\r\nC -1 ; WX 278 ; N imacron ; B 95 0 417 684 ;\r\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2705\r\nKPX A C -30\r\nKPX A Cacute -30\r\nKPX A Ccaron -30\r\nKPX A Ccedilla -30\r\nKPX A G -30\r\nKPX A Gbreve -30\r\nKPX A Gcommaaccent -30\r\nKPX A O -30\r\nKPX A Oacute -30\r\nKPX A Ocircumflex -30\r\nKPX A Odieresis -30\r\nKPX A Ograve -30\r\nKPX A Ohungarumlaut -30\r\nKPX A Omacron -30\r\nKPX A Oslash -30\r\nKPX A Otilde -30\r\nKPX A Q -30\r\nKPX A T -120\r\nKPX A Tcaron -120\r\nKPX A Tcommaaccent -120\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -70\r\nKPX A W -50\r\nKPX A Y -100\r\nKPX A Yacute -100\r\nKPX A Ydieresis -100\r\nKPX A u -30\r\nKPX A uacute -30\r\nKPX A ucircumflex -30\r\nKPX A udieresis -30\r\nKPX A ugrave -30\r\nKPX A uhungarumlaut -30\r\nKPX A umacron -30\r\nKPX A uogonek -30\r\nKPX A uring -30\r\nKPX A v -40\r\nKPX A w -40\r\nKPX A y -40\r\nKPX A yacute -40\r\nKPX A ydieresis -40\r\nKPX Aacute C -30\r\nKPX Aacute Cacute -30\r\nKPX Aacute Ccaron -30\r\nKPX Aacute Ccedilla -30\r\nKPX Aacute G -30\r\nKPX Aacute Gbreve -30\r\nKPX Aacute Gcommaaccent -30\r\nKPX Aacute O -30\r\nKPX Aacute Oacute -30\r\nKPX Aacute Ocircumflex -30\r\nKPX Aacute Odieresis -30\r\nKPX Aacute Ograve -30\r\nKPX Aacute Ohungarumlaut -30\r\nKPX Aacute Omacron -30\r\nKPX Aacute Oslash -30\r\nKPX Aacute Otilde -30\r\nKPX Aacute Q -30\r\nKPX Aacute T -120\r\nKPX Aacute Tcaron -120\r\nKPX Aacute Tcommaaccent -120\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -70\r\nKPX Aacute W -50\r\nKPX Aacute Y -100\r\nKPX Aacute Yacute -100\r\nKPX Aacute Ydieresis -100\r\nKPX Aacute u -30\r\nKPX Aacute uacute -30\r\nKPX Aacute ucircumflex -30\r\nKPX Aacute udieresis -30\r\nKPX Aacute ugrave -30\r\nKPX Aacute uhungarumlaut -30\r\nKPX Aacute umacron -30\r\nKPX Aacute uogonek -30\r\nKPX Aacute uring -30\r\nKPX Aacute v -40\r\nKPX Aacute w -40\r\nKPX Aacute y -40\r\nKPX Aacute yacute -40\r\nKPX Aacute ydieresis -40\r\nKPX Abreve C -30\r\nKPX Abreve Cacute -30\r\nKPX Abreve Ccaron -30\r\nKPX Abreve Ccedilla -30\r\nKPX Abreve G -30\r\nKPX Abreve Gbreve -30\r\nKPX Abreve Gcommaaccent -30\r\nKPX Abreve O -30\r\nKPX Abreve Oacute -30\r\nKPX Abreve Ocircumflex -30\r\nKPX Abreve Odieresis -30\r\nKPX Abreve Ograve -30\r\nKPX Abreve Ohungarumlaut -30\r\nKPX Abreve Omacron -30\r\nKPX Abreve Oslash -30\r\nKPX Abreve Otilde -30\r\nKPX Abreve Q -30\r\nKPX Abreve T -120\r\nKPX Abreve Tcaron -120\r\nKPX Abreve Tcommaaccent -120\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -70\r\nKPX Abreve W -50\r\nKPX Abreve Y -100\r\nKPX Abreve Yacute -100\r\nKPX Abreve Ydieresis -100\r\nKPX Abreve u -30\r\nKPX Abreve uacute -30\r\nKPX Abreve ucircumflex -30\r\nKPX Abreve udieresis -30\r\nKPX Abreve ugrave -30\r\nKPX Abreve uhungarumlaut -30\r\nKPX Abreve umacron -30\r\nKPX Abreve uogonek -30\r\nKPX Abreve uring -30\r\nKPX Abreve v -40\r\nKPX Abreve w -40\r\nKPX Abreve y -40\r\nKPX Abreve yacute -40\r\nKPX Abreve ydieresis -40\r\nKPX Acircumflex C -30\r\nKPX Acircumflex Cacute -30\r\nKPX Acircumflex Ccaron -30\r\nKPX Acircumflex Ccedilla -30\r\nKPX Acircumflex G -30\r\nKPX Acircumflex Gbreve -30\r\nKPX Acircumflex Gcommaaccent -30\r\nKPX Acircumflex O -30\r\nKPX Acircumflex Oacute -30\r\nKPX Acircumflex Ocircumflex -30\r\nKPX Acircumflex Odieresis -30\r\nKPX Acircumflex Ograve -30\r\nKPX Acircumflex Ohungarumlaut -30\r\nKPX Acircumflex Omacron -30\r\nKPX Acircumflex Oslash -30\r\nKPX Acircumflex Otilde -30\r\nKPX Acircumflex Q -30\r\nKPX Acircumflex T -120\r\nKPX Acircumflex Tcaron -120\r\nKPX Acircumflex Tcommaaccent -120\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -70\r\nKPX Acircumflex W -50\r\nKPX Acircumflex Y -100\r\nKPX Acircumflex Yacute -100\r\nKPX Acircumflex Ydieresis -100\r\nKPX Acircumflex u -30\r\nKPX Acircumflex uacute -30\r\nKPX Acircumflex ucircumflex -30\r\nKPX Acircumflex udieresis -30\r\nKPX Acircumflex ugrave -30\r\nKPX Acircumflex uhungarumlaut -30\r\nKPX Acircumflex umacron -30\r\nKPX Acircumflex uogonek -30\r\nKPX Acircumflex uring -30\r\nKPX Acircumflex v -40\r\nKPX Acircumflex w -40\r\nKPX Acircumflex y -40\r\nKPX Acircumflex yacute -40\r\nKPX Acircumflex ydieresis -40\r\nKPX Adieresis C -30\r\nKPX Adieresis Cacute -30\r\nKPX Adieresis Ccaron -30\r\nKPX Adieresis Ccedilla -30\r\nKPX Adieresis G -30\r\nKPX Adieresis Gbreve -30\r\nKPX Adieresis Gcommaaccent -30\r\nKPX Adieresis O -30\r\nKPX Adieresis Oacute -30\r\nKPX Adieresis Ocircumflex -30\r\nKPX Adieresis Odieresis -30\r\nKPX Adieresis Ograve -30\r\nKPX Adieresis Ohungarumlaut -30\r\nKPX Adieresis Omacron -30\r\nKPX Adieresis Oslash -30\r\nKPX Adieresis Otilde -30\r\nKPX Adieresis Q -30\r\nKPX Adieresis T -120\r\nKPX Adieresis Tcaron -120\r\nKPX Adieresis Tcommaaccent -120\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -70\r\nKPX Adieresis W -50\r\nKPX Adieresis Y -100\r\nKPX Adieresis Yacute -100\r\nKPX Adieresis Ydieresis -100\r\nKPX Adieresis u -30\r\nKPX Adieresis uacute -30\r\nKPX Adieresis ucircumflex -30\r\nKPX Adieresis udieresis -30\r\nKPX Adieresis ugrave -30\r\nKPX Adieresis uhungarumlaut -30\r\nKPX Adieresis umacron -30\r\nKPX Adieresis uogonek -30\r\nKPX Adieresis uring -30\r\nKPX Adieresis v -40\r\nKPX Adieresis w -40\r\nKPX Adieresis y -40\r\nKPX Adieresis yacute -40\r\nKPX Adieresis ydieresis -40\r\nKPX Agrave C -30\r\nKPX Agrave Cacute -30\r\nKPX Agrave Ccaron -30\r\nKPX Agrave Ccedilla -30\r\nKPX Agrave G -30\r\nKPX Agrave Gbreve -30\r\nKPX Agrave Gcommaaccent -30\r\nKPX Agrave O -30\r\nKPX Agrave Oacute -30\r\nKPX Agrave Ocircumflex -30\r\nKPX Agrave Odieresis -30\r\nKPX Agrave Ograve -30\r\nKPX Agrave Ohungarumlaut -30\r\nKPX Agrave Omacron -30\r\nKPX Agrave Oslash -30\r\nKPX Agrave Otilde -30\r\nKPX Agrave Q -30\r\nKPX Agrave T -120\r\nKPX Agrave Tcaron -120\r\nKPX Agrave Tcommaaccent -120\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -70\r\nKPX Agrave W -50\r\nKPX Agrave Y -100\r\nKPX Agrave Yacute -100\r\nKPX Agrave Ydieresis -100\r\nKPX Agrave u -30\r\nKPX Agrave uacute -30\r\nKPX Agrave ucircumflex -30\r\nKPX Agrave udieresis -30\r\nKPX Agrave ugrave -30\r\nKPX Agrave uhungarumlaut -30\r\nKPX Agrave umacron -30\r\nKPX Agrave uogonek -30\r\nKPX Agrave uring -30\r\nKPX Agrave v -40\r\nKPX Agrave w -40\r\nKPX Agrave y -40\r\nKPX Agrave yacute -40\r\nKPX Agrave ydieresis -40\r\nKPX Amacron C -30\r\nKPX Amacron Cacute -30\r\nKPX Amacron Ccaron -30\r\nKPX Amacron Ccedilla -30\r\nKPX Amacron G -30\r\nKPX Amacron Gbreve -30\r\nKPX Amacron Gcommaaccent -30\r\nKPX Amacron O -30\r\nKPX Amacron Oacute -30\r\nKPX Amacron Ocircumflex -30\r\nKPX Amacron Odieresis -30\r\nKPX Amacron Ograve -30\r\nKPX Amacron Ohungarumlaut -30\r\nKPX Amacron Omacron -30\r\nKPX Amacron Oslash -30\r\nKPX Amacron Otilde -30\r\nKPX Amacron Q -30\r\nKPX Amacron T -120\r\nKPX Amacron Tcaron -120\r\nKPX Amacron Tcommaaccent -120\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -70\r\nKPX Amacron W -50\r\nKPX Amacron Y -100\r\nKPX Amacron Yacute -100\r\nKPX Amacron Ydieresis -100\r\nKPX Amacron u -30\r\nKPX Amacron uacute -30\r\nKPX Amacron ucircumflex -30\r\nKPX Amacron udieresis -30\r\nKPX Amacron ugrave -30\r\nKPX Amacron uhungarumlaut -30\r\nKPX Amacron umacron -30\r\nKPX Amacron uogonek -30\r\nKPX Amacron uring -30\r\nKPX Amacron v -40\r\nKPX Amacron w -40\r\nKPX Amacron y -40\r\nKPX Amacron yacute -40\r\nKPX Amacron ydieresis -40\r\nKPX Aogonek C -30\r\nKPX Aogonek Cacute -30\r\nKPX Aogonek Ccaron -30\r\nKPX Aogonek Ccedilla -30\r\nKPX Aogonek G -30\r\nKPX Aogonek Gbreve -30\r\nKPX Aogonek Gcommaaccent -30\r\nKPX Aogonek O -30\r\nKPX Aogonek Oacute -30\r\nKPX Aogonek Ocircumflex -30\r\nKPX Aogonek Odieresis -30\r\nKPX Aogonek Ograve -30\r\nKPX Aogonek Ohungarumlaut -30\r\nKPX Aogonek Omacron -30\r\nKPX Aogonek Oslash -30\r\nKPX Aogonek Otilde -30\r\nKPX Aogonek Q -30\r\nKPX Aogonek T -120\r\nKPX Aogonek Tcaron -120\r\nKPX Aogonek Tcommaaccent -120\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -70\r\nKPX Aogonek W -50\r\nKPX Aogonek Y -100\r\nKPX Aogonek Yacute -100\r\nKPX Aogonek Ydieresis -100\r\nKPX Aogonek u -30\r\nKPX Aogonek uacute -30\r\nKPX Aogonek ucircumflex -30\r\nKPX Aogonek udieresis -30\r\nKPX Aogonek ugrave -30\r\nKPX Aogonek uhungarumlaut -30\r\nKPX Aogonek umacron -30\r\nKPX Aogonek uogonek -30\r\nKPX Aogonek uring -30\r\nKPX Aogonek v -40\r\nKPX Aogonek w -40\r\nKPX Aogonek y -40\r\nKPX Aogonek yacute -40\r\nKPX Aogonek ydieresis -40\r\nKPX Aring C -30\r\nKPX Aring Cacute -30\r\nKPX Aring Ccaron -30\r\nKPX Aring Ccedilla -30\r\nKPX Aring G -30\r\nKPX Aring Gbreve -30\r\nKPX Aring Gcommaaccent -30\r\nKPX Aring O -30\r\nKPX Aring Oacute -30\r\nKPX Aring Ocircumflex -30\r\nKPX Aring Odieresis -30\r\nKPX Aring Ograve -30\r\nKPX Aring Ohungarumlaut -30\r\nKPX Aring Omacron -30\r\nKPX Aring Oslash -30\r\nKPX Aring Otilde -30\r\nKPX Aring Q -30\r\nKPX Aring T -120\r\nKPX Aring Tcaron -120\r\nKPX Aring Tcommaaccent -120\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -70\r\nKPX Aring W -50\r\nKPX Aring Y -100\r\nKPX Aring Yacute -100\r\nKPX Aring Ydieresis -100\r\nKPX Aring u -30\r\nKPX Aring uacute -30\r\nKPX Aring ucircumflex -30\r\nKPX Aring udieresis -30\r\nKPX Aring ugrave -30\r\nKPX Aring uhungarumlaut -30\r\nKPX Aring umacron -30\r\nKPX Aring uogonek -30\r\nKPX Aring uring -30\r\nKPX Aring v -40\r\nKPX Aring w -40\r\nKPX Aring y -40\r\nKPX Aring yacute -40\r\nKPX Aring ydieresis -40\r\nKPX Atilde C -30\r\nKPX Atilde Cacute -30\r\nKPX Atilde Ccaron -30\r\nKPX Atilde Ccedilla -30\r\nKPX Atilde G -30\r\nKPX Atilde Gbreve -30\r\nKPX Atilde Gcommaaccent -30\r\nKPX Atilde O -30\r\nKPX Atilde Oacute -30\r\nKPX Atilde Ocircumflex -30\r\nKPX Atilde Odieresis -30\r\nKPX Atilde Ograve -30\r\nKPX Atilde Ohungarumlaut -30\r\nKPX Atilde Omacron -30\r\nKPX Atilde Oslash -30\r\nKPX Atilde Otilde -30\r\nKPX Atilde Q -30\r\nKPX Atilde T -120\r\nKPX Atilde Tcaron -120\r\nKPX Atilde Tcommaaccent -120\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -70\r\nKPX Atilde W -50\r\nKPX Atilde Y -100\r\nKPX Atilde Yacute -100\r\nKPX Atilde Ydieresis -100\r\nKPX Atilde u -30\r\nKPX Atilde uacute -30\r\nKPX Atilde ucircumflex -30\r\nKPX Atilde udieresis -30\r\nKPX Atilde ugrave -30\r\nKPX Atilde uhungarumlaut -30\r\nKPX Atilde umacron -30\r\nKPX Atilde uogonek -30\r\nKPX Atilde uring -30\r\nKPX Atilde v -40\r\nKPX Atilde w -40\r\nKPX Atilde y -40\r\nKPX Atilde yacute -40\r\nKPX Atilde ydieresis -40\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX B comma -20\r\nKPX B period -20\r\nKPX C comma -30\r\nKPX C period -30\r\nKPX Cacute comma -30\r\nKPX Cacute period -30\r\nKPX Ccaron comma -30\r\nKPX Ccaron period -30\r\nKPX Ccedilla comma -30\r\nKPX Ccedilla period -30\r\nKPX D A -40\r\nKPX D Aacute -40\r\nKPX D Abreve -40\r\nKPX D Acircumflex -40\r\nKPX D Adieresis -40\r\nKPX D Agrave -40\r\nKPX D Amacron -40\r\nKPX D Aogonek -40\r\nKPX D Aring -40\r\nKPX D Atilde -40\r\nKPX D V -70\r\nKPX D W -40\r\nKPX D Y -90\r\nKPX D Yacute -90\r\nKPX D Ydieresis -90\r\nKPX D comma -70\r\nKPX D period -70\r\nKPX Dcaron A -40\r\nKPX Dcaron Aacute -40\r\nKPX Dcaron Abreve -40\r\nKPX Dcaron Acircumflex -40\r\nKPX Dcaron Adieresis -40\r\nKPX Dcaron Agrave -40\r\nKPX Dcaron Amacron -40\r\nKPX Dcaron Aogonek -40\r\nKPX Dcaron Aring -40\r\nKPX Dcaron Atilde -40\r\nKPX Dcaron V -70\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -90\r\nKPX Dcaron Yacute -90\r\nKPX Dcaron Ydieresis -90\r\nKPX Dcaron comma -70\r\nKPX Dcaron period -70\r\nKPX Dcroat A -40\r\nKPX Dcroat Aacute -40\r\nKPX Dcroat Abreve -40\r\nKPX Dcroat Acircumflex -40\r\nKPX Dcroat Adieresis -40\r\nKPX Dcroat Agrave -40\r\nKPX Dcroat Amacron -40\r\nKPX Dcroat Aogonek -40\r\nKPX Dcroat Aring -40\r\nKPX Dcroat Atilde -40\r\nKPX Dcroat V -70\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -90\r\nKPX Dcroat Yacute -90\r\nKPX Dcroat Ydieresis -90\r\nKPX Dcroat comma -70\r\nKPX Dcroat period -70\r\nKPX F A -80\r\nKPX F Aacute -80\r\nKPX F Abreve -80\r\nKPX F Acircumflex -80\r\nKPX F Adieresis -80\r\nKPX F Agrave -80\r\nKPX F Amacron -80\r\nKPX F Aogonek -80\r\nKPX F Aring -80\r\nKPX F Atilde -80\r\nKPX F a -50\r\nKPX F aacute -50\r\nKPX F abreve -50\r\nKPX F acircumflex -50\r\nKPX F adieresis -50\r\nKPX F agrave -50\r\nKPX F amacron -50\r\nKPX F aogonek -50\r\nKPX F aring -50\r\nKPX F atilde -50\r\nKPX F comma -150\r\nKPX F e -30\r\nKPX F eacute -30\r\nKPX F ecaron -30\r\nKPX F ecircumflex -30\r\nKPX F edieresis -30\r\nKPX F edotaccent -30\r\nKPX F egrave -30\r\nKPX F emacron -30\r\nKPX F eogonek -30\r\nKPX F o -30\r\nKPX F oacute -30\r\nKPX F ocircumflex -30\r\nKPX F odieresis -30\r\nKPX F ograve -30\r\nKPX F ohungarumlaut -30\r\nKPX F omacron -30\r\nKPX F oslash -30\r\nKPX F otilde -30\r\nKPX F period -150\r\nKPX F r -45\r\nKPX F racute -45\r\nKPX F rcaron -45\r\nKPX F rcommaaccent -45\r\nKPX J A -20\r\nKPX J Aacute -20\r\nKPX J Abreve -20\r\nKPX J Acircumflex -20\r\nKPX J Adieresis -20\r\nKPX J Agrave -20\r\nKPX J Amacron -20\r\nKPX J Aogonek -20\r\nKPX J Aring -20\r\nKPX J Atilde -20\r\nKPX J a -20\r\nKPX J aacute -20\r\nKPX J abreve -20\r\nKPX J acircumflex -20\r\nKPX J adieresis -20\r\nKPX J agrave -20\r\nKPX J amacron -20\r\nKPX J aogonek -20\r\nKPX J aring -20\r\nKPX J atilde -20\r\nKPX J comma -30\r\nKPX J period -30\r\nKPX J u -20\r\nKPX J uacute -20\r\nKPX J ucircumflex -20\r\nKPX J udieresis -20\r\nKPX J ugrave -20\r\nKPX J uhungarumlaut -20\r\nKPX J umacron -20\r\nKPX J uogonek -20\r\nKPX J uring -20\r\nKPX K O -50\r\nKPX K Oacute -50\r\nKPX K Ocircumflex -50\r\nKPX K Odieresis -50\r\nKPX K Ograve -50\r\nKPX K Ohungarumlaut -50\r\nKPX K Omacron -50\r\nKPX K Oslash -50\r\nKPX K Otilde -50\r\nKPX K e -40\r\nKPX K eacute -40\r\nKPX K ecaron -40\r\nKPX K ecircumflex -40\r\nKPX K edieresis -40\r\nKPX K edotaccent -40\r\nKPX K egrave -40\r\nKPX K emacron -40\r\nKPX K eogonek -40\r\nKPX K o -40\r\nKPX K oacute -40\r\nKPX K ocircumflex -40\r\nKPX K odieresis -40\r\nKPX K ograve -40\r\nKPX K ohungarumlaut -40\r\nKPX K omacron -40\r\nKPX K oslash -40\r\nKPX K otilde -40\r\nKPX K u -30\r\nKPX K uacute -30\r\nKPX K ucircumflex -30\r\nKPX K udieresis -30\r\nKPX K ugrave -30\r\nKPX K uhungarumlaut -30\r\nKPX K umacron -30\r\nKPX K uogonek -30\r\nKPX K uring -30\r\nKPX K y -50\r\nKPX K yacute -50\r\nKPX K ydieresis -50\r\nKPX Kcommaaccent O -50\r\nKPX Kcommaaccent Oacute -50\r\nKPX Kcommaaccent Ocircumflex -50\r\nKPX Kcommaaccent Odieresis -50\r\nKPX Kcommaaccent Ograve -50\r\nKPX Kcommaaccent Ohungarumlaut -50\r\nKPX Kcommaaccent Omacron -50\r\nKPX Kcommaaccent Oslash -50\r\nKPX Kcommaaccent Otilde -50\r\nKPX Kcommaaccent e -40\r\nKPX Kcommaaccent eacute -40\r\nKPX Kcommaaccent ecaron -40\r\nKPX Kcommaaccent ecircumflex -40\r\nKPX Kcommaaccent edieresis -40\r\nKPX Kcommaaccent edotaccent -40\r\nKPX Kcommaaccent egrave -40\r\nKPX Kcommaaccent emacron -40\r\nKPX Kcommaaccent eogonek -40\r\nKPX Kcommaaccent o -40\r\nKPX Kcommaaccent oacute -40\r\nKPX Kcommaaccent ocircumflex -40\r\nKPX Kcommaaccent odieresis -40\r\nKPX Kcommaaccent ograve -40\r\nKPX Kcommaaccent ohungarumlaut -40\r\nKPX Kcommaaccent omacron -40\r\nKPX Kcommaaccent oslash -40\r\nKPX Kcommaaccent otilde -40\r\nKPX Kcommaaccent u -30\r\nKPX Kcommaaccent uacute -30\r\nKPX Kcommaaccent ucircumflex -30\r\nKPX Kcommaaccent udieresis -30\r\nKPX Kcommaaccent ugrave -30\r\nKPX Kcommaaccent uhungarumlaut -30\r\nKPX Kcommaaccent umacron -30\r\nKPX Kcommaaccent uogonek -30\r\nKPX Kcommaaccent uring -30\r\nKPX Kcommaaccent y -50\r\nKPX Kcommaaccent yacute -50\r\nKPX Kcommaaccent ydieresis -50\r\nKPX L T -110\r\nKPX L Tcaron -110\r\nKPX L Tcommaaccent -110\r\nKPX L V -110\r\nKPX L W -70\r\nKPX L Y -140\r\nKPX L Yacute -140\r\nKPX L Ydieresis -140\r\nKPX L quotedblright -140\r\nKPX L quoteright -160\r\nKPX L y -30\r\nKPX L yacute -30\r\nKPX L ydieresis -30\r\nKPX Lacute T -110\r\nKPX Lacute Tcaron -110\r\nKPX Lacute Tcommaaccent -110\r\nKPX Lacute V -110\r\nKPX Lacute W -70\r\nKPX Lacute Y -140\r\nKPX Lacute Yacute -140\r\nKPX Lacute Ydieresis -140\r\nKPX Lacute quotedblright -140\r\nKPX Lacute quoteright -160\r\nKPX Lacute y -30\r\nKPX Lacute yacute -30\r\nKPX Lacute ydieresis -30\r\nKPX Lcaron T -110\r\nKPX Lcaron Tcaron -110\r\nKPX Lcaron Tcommaaccent -110\r\nKPX Lcaron V -110\r\nKPX Lcaron W -70\r\nKPX Lcaron Y -140\r\nKPX Lcaron Yacute -140\r\nKPX Lcaron Ydieresis -140\r\nKPX Lcaron quotedblright -140\r\nKPX Lcaron quoteright -160\r\nKPX Lcaron y -30\r\nKPX Lcaron yacute -30\r\nKPX Lcaron ydieresis -30\r\nKPX Lcommaaccent T -110\r\nKPX Lcommaaccent Tcaron -110\r\nKPX Lcommaaccent Tcommaaccent -110\r\nKPX Lcommaaccent V -110\r\nKPX Lcommaaccent W -70\r\nKPX Lcommaaccent Y -140\r\nKPX Lcommaaccent Yacute -140\r\nKPX Lcommaaccent Ydieresis -140\r\nKPX Lcommaaccent quotedblright -140\r\nKPX Lcommaaccent quoteright -160\r\nKPX Lcommaaccent y -30\r\nKPX Lcommaaccent yacute -30\r\nKPX Lcommaaccent ydieresis -30\r\nKPX Lslash T -110\r\nKPX Lslash Tcaron -110\r\nKPX Lslash Tcommaaccent -110\r\nKPX Lslash V -110\r\nKPX Lslash W -70\r\nKPX Lslash Y -140\r\nKPX Lslash Yacute -140\r\nKPX Lslash Ydieresis -140\r\nKPX Lslash quotedblright -140\r\nKPX Lslash quoteright -160\r\nKPX Lslash y -30\r\nKPX Lslash yacute -30\r\nKPX Lslash ydieresis -30\r\nKPX O A -20\r\nKPX O Aacute -20\r\nKPX O Abreve -20\r\nKPX O Acircumflex -20\r\nKPX O Adieresis -20\r\nKPX O Agrave -20\r\nKPX O Amacron -20\r\nKPX O Aogonek -20\r\nKPX O Aring -20\r\nKPX O Atilde -20\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -30\r\nKPX O X -60\r\nKPX O Y -70\r\nKPX O Yacute -70\r\nKPX O Ydieresis -70\r\nKPX O comma -40\r\nKPX O period -40\r\nKPX Oacute A -20\r\nKPX Oacute Aacute -20\r\nKPX Oacute Abreve -20\r\nKPX Oacute Acircumflex -20\r\nKPX Oacute Adieresis -20\r\nKPX Oacute Agrave -20\r\nKPX Oacute Amacron -20\r\nKPX Oacute Aogonek -20\r\nKPX Oacute Aring -20\r\nKPX Oacute Atilde -20\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -30\r\nKPX Oacute X -60\r\nKPX Oacute Y -70\r\nKPX Oacute Yacute -70\r\nKPX Oacute Ydieresis -70\r\nKPX Oacute comma -40\r\nKPX Oacute period -40\r\nKPX Ocircumflex A -20\r\nKPX Ocircumflex Aacute -20\r\nKPX Ocircumflex Abreve -20\r\nKPX Ocircumflex Acircumflex -20\r\nKPX Ocircumflex Adieresis -20\r\nKPX Ocircumflex Agrave -20\r\nKPX Ocircumflex Amacron -20\r\nKPX Ocircumflex Aogonek -20\r\nKPX Ocircumflex Aring -20\r\nKPX Ocircumflex Atilde -20\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -30\r\nKPX Ocircumflex X -60\r\nKPX Ocircumflex Y -70\r\nKPX Ocircumflex Yacute -70\r\nKPX Ocircumflex Ydieresis -70\r\nKPX Ocircumflex comma -40\r\nKPX Ocircumflex period -40\r\nKPX Odieresis A -20\r\nKPX Odieresis Aacute -20\r\nKPX Odieresis Abreve -20\r\nKPX Odieresis Acircumflex -20\r\nKPX Odieresis Adieresis -20\r\nKPX Odieresis Agrave -20\r\nKPX Odieresis Amacron -20\r\nKPX Odieresis Aogonek -20\r\nKPX Odieresis Aring -20\r\nKPX Odieresis Atilde -20\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -30\r\nKPX Odieresis X -60\r\nKPX Odieresis Y -70\r\nKPX Odieresis Yacute -70\r\nKPX Odieresis Ydieresis -70\r\nKPX Odieresis comma -40\r\nKPX Odieresis period -40\r\nKPX Ograve A -20\r\nKPX Ograve Aacute -20\r\nKPX Ograve Abreve -20\r\nKPX Ograve Acircumflex -20\r\nKPX Ograve Adieresis -20\r\nKPX Ograve Agrave -20\r\nKPX Ograve Amacron -20\r\nKPX Ograve Aogonek -20\r\nKPX Ograve Aring -20\r\nKPX Ograve Atilde -20\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -30\r\nKPX Ograve X -60\r\nKPX Ograve Y -70\r\nKPX Ograve Yacute -70\r\nKPX Ograve Ydieresis -70\r\nKPX Ograve comma -40\r\nKPX Ograve period -40\r\nKPX Ohungarumlaut A -20\r\nKPX Ohungarumlaut Aacute -20\r\nKPX Ohungarumlaut Abreve -20\r\nKPX Ohungarumlaut Acircumflex -20\r\nKPX Ohungarumlaut Adieresis -20\r\nKPX Ohungarumlaut Agrave -20\r\nKPX Ohungarumlaut Amacron -20\r\nKPX Ohungarumlaut Aogonek -20\r\nKPX Ohungarumlaut Aring -20\r\nKPX Ohungarumlaut Atilde -20\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -30\r\nKPX Ohungarumlaut X -60\r\nKPX Ohungarumlaut Y -70\r\nKPX Ohungarumlaut Yacute -70\r\nKPX Ohungarumlaut Ydieresis -70\r\nKPX Ohungarumlaut comma -40\r\nKPX Ohungarumlaut period -40\r\nKPX Omacron A -20\r\nKPX Omacron Aacute -20\r\nKPX Omacron Abreve -20\r\nKPX Omacron Acircumflex -20\r\nKPX Omacron Adieresis -20\r\nKPX Omacron Agrave -20\r\nKPX Omacron Amacron -20\r\nKPX Omacron Aogonek -20\r\nKPX Omacron Aring -20\r\nKPX Omacron Atilde -20\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -30\r\nKPX Omacron X -60\r\nKPX Omacron Y -70\r\nKPX Omacron Yacute -70\r\nKPX Omacron Ydieresis -70\r\nKPX Omacron comma -40\r\nKPX Omacron period -40\r\nKPX Oslash A -20\r\nKPX Oslash Aacute -20\r\nKPX Oslash Abreve -20\r\nKPX Oslash Acircumflex -20\r\nKPX Oslash Adieresis -20\r\nKPX Oslash Agrave -20\r\nKPX Oslash Amacron -20\r\nKPX Oslash Aogonek -20\r\nKPX Oslash Aring -20\r\nKPX Oslash Atilde -20\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -30\r\nKPX Oslash X -60\r\nKPX Oslash Y -70\r\nKPX Oslash Yacute -70\r\nKPX Oslash Ydieresis -70\r\nKPX Oslash comma -40\r\nKPX Oslash period -40\r\nKPX Otilde A -20\r\nKPX Otilde Aacute -20\r\nKPX Otilde Abreve -20\r\nKPX Otilde Acircumflex -20\r\nKPX Otilde Adieresis -20\r\nKPX Otilde Agrave -20\r\nKPX Otilde Amacron -20\r\nKPX Otilde Aogonek -20\r\nKPX Otilde Aring -20\r\nKPX Otilde Atilde -20\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -30\r\nKPX Otilde X -60\r\nKPX Otilde Y -70\r\nKPX Otilde Yacute -70\r\nKPX Otilde Ydieresis -70\r\nKPX Otilde comma -40\r\nKPX Otilde period -40\r\nKPX P A -120\r\nKPX P Aacute -120\r\nKPX P Abreve -120\r\nKPX P Acircumflex -120\r\nKPX P Adieresis -120\r\nKPX P Agrave -120\r\nKPX P Amacron -120\r\nKPX P Aogonek -120\r\nKPX P Aring -120\r\nKPX P Atilde -120\r\nKPX P a -40\r\nKPX P aacute -40\r\nKPX P abreve -40\r\nKPX P acircumflex -40\r\nKPX P adieresis -40\r\nKPX P agrave -40\r\nKPX P amacron -40\r\nKPX P aogonek -40\r\nKPX P aring -40\r\nKPX P atilde -40\r\nKPX P comma -180\r\nKPX P e -50\r\nKPX P eacute -50\r\nKPX P ecaron -50\r\nKPX P ecircumflex -50\r\nKPX P edieresis -50\r\nKPX P edotaccent -50\r\nKPX P egrave -50\r\nKPX P emacron -50\r\nKPX P eogonek -50\r\nKPX P o -50\r\nKPX P oacute -50\r\nKPX P ocircumflex -50\r\nKPX P odieresis -50\r\nKPX P ograve -50\r\nKPX P ohungarumlaut -50\r\nKPX P omacron -50\r\nKPX P oslash -50\r\nKPX P otilde -50\r\nKPX P period -180\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX R O -20\r\nKPX R Oacute -20\r\nKPX R Ocircumflex -20\r\nKPX R Odieresis -20\r\nKPX R Ograve -20\r\nKPX R Ohungarumlaut -20\r\nKPX R Omacron -20\r\nKPX R Oslash -20\r\nKPX R Otilde -20\r\nKPX R T -30\r\nKPX R Tcaron -30\r\nKPX R Tcommaaccent -30\r\nKPX R U -40\r\nKPX R Uacute -40\r\nKPX R Ucircumflex -40\r\nKPX R Udieresis -40\r\nKPX R Ugrave -40\r\nKPX R Uhungarumlaut -40\r\nKPX R Umacron -40\r\nKPX R Uogonek -40\r\nKPX R Uring -40\r\nKPX R V -50\r\nKPX R W -30\r\nKPX R Y -50\r\nKPX R Yacute -50\r\nKPX R Ydieresis -50\r\nKPX Racute O -20\r\nKPX Racute Oacute -20\r\nKPX Racute Ocircumflex -20\r\nKPX Racute Odieresis -20\r\nKPX Racute Ograve -20\r\nKPX Racute Ohungarumlaut -20\r\nKPX Racute Omacron -20\r\nKPX Racute Oslash -20\r\nKPX Racute Otilde -20\r\nKPX Racute T -30\r\nKPX Racute Tcaron -30\r\nKPX Racute Tcommaaccent -30\r\nKPX Racute U -40\r\nKPX Racute Uacute -40\r\nKPX Racute Ucircumflex -40\r\nKPX Racute Udieresis -40\r\nKPX Racute Ugrave -40\r\nKPX Racute Uhungarumlaut -40\r\nKPX Racute Umacron -40\r\nKPX Racute Uogonek -40\r\nKPX Racute Uring -40\r\nKPX Racute V -50\r\nKPX Racute W -30\r\nKPX Racute Y -50\r\nKPX Racute Yacute -50\r\nKPX Racute Ydieresis -50\r\nKPX Rcaron O -20\r\nKPX Rcaron Oacute -20\r\nKPX Rcaron Ocircumflex -20\r\nKPX Rcaron Odieresis -20\r\nKPX Rcaron Ograve -20\r\nKPX Rcaron Ohungarumlaut -20\r\nKPX Rcaron Omacron -20\r\nKPX Rcaron Oslash -20\r\nKPX Rcaron Otilde -20\r\nKPX Rcaron T -30\r\nKPX Rcaron Tcaron -30\r\nKPX Rcaron Tcommaaccent -30\r\nKPX Rcaron U -40\r\nKPX Rcaron Uacute -40\r\nKPX Rcaron Ucircumflex -40\r\nKPX Rcaron Udieresis -40\r\nKPX Rcaron Ugrave -40\r\nKPX Rcaron Uhungarumlaut -40\r\nKPX Rcaron Umacron -40\r\nKPX Rcaron Uogonek -40\r\nKPX Rcaron Uring -40\r\nKPX Rcaron V -50\r\nKPX Rcaron W -30\r\nKPX Rcaron Y -50\r\nKPX Rcaron Yacute -50\r\nKPX Rcaron Ydieresis -50\r\nKPX Rcommaaccent O -20\r\nKPX Rcommaaccent Oacute -20\r\nKPX Rcommaaccent Ocircumflex -20\r\nKPX Rcommaaccent Odieresis -20\r\nKPX Rcommaaccent Ograve -20\r\nKPX Rcommaaccent Ohungarumlaut -20\r\nKPX Rcommaaccent Omacron -20\r\nKPX Rcommaaccent Oslash -20\r\nKPX Rcommaaccent Otilde -20\r\nKPX Rcommaaccent T -30\r\nKPX Rcommaaccent Tcaron -30\r\nKPX Rcommaaccent Tcommaaccent -30\r\nKPX Rcommaaccent U -40\r\nKPX Rcommaaccent Uacute -40\r\nKPX Rcommaaccent Ucircumflex -40\r\nKPX Rcommaaccent Udieresis -40\r\nKPX Rcommaaccent Ugrave -40\r\nKPX Rcommaaccent Uhungarumlaut -40\r\nKPX Rcommaaccent Umacron -40\r\nKPX Rcommaaccent Uogonek -40\r\nKPX Rcommaaccent Uring -40\r\nKPX Rcommaaccent V -50\r\nKPX Rcommaaccent W -30\r\nKPX Rcommaaccent Y -50\r\nKPX Rcommaaccent Yacute -50\r\nKPX Rcommaaccent Ydieresis -50\r\nKPX S comma -20\r\nKPX S period -20\r\nKPX Sacute comma -20\r\nKPX Sacute period -20\r\nKPX Scaron comma -20\r\nKPX Scaron period -20\r\nKPX Scedilla comma -20\r\nKPX Scedilla period -20\r\nKPX Scommaaccent comma -20\r\nKPX Scommaaccent period -20\r\nKPX T A -120\r\nKPX T Aacute -120\r\nKPX T Abreve -120\r\nKPX T Acircumflex -120\r\nKPX T Adieresis -120\r\nKPX T Agrave -120\r\nKPX T Amacron -120\r\nKPX T Aogonek -120\r\nKPX T Aring -120\r\nKPX T Atilde -120\r\nKPX T O -40\r\nKPX T Oacute -40\r\nKPX T Ocircumflex -40\r\nKPX T Odieresis -40\r\nKPX T Ograve -40\r\nKPX T Ohungarumlaut -40\r\nKPX T Omacron -40\r\nKPX T Oslash -40\r\nKPX T Otilde -40\r\nKPX T a -120\r\nKPX T aacute -120\r\nKPX T abreve -60\r\nKPX T acircumflex -120\r\nKPX T adieresis -120\r\nKPX T agrave -120\r\nKPX T amacron -60\r\nKPX T aogonek -120\r\nKPX T aring -120\r\nKPX T atilde -60\r\nKPX T colon -20\r\nKPX T comma -120\r\nKPX T e -120\r\nKPX T eacute -120\r\nKPX T ecaron -120\r\nKPX T ecircumflex -120\r\nKPX T edieresis -120\r\nKPX T edotaccent -120\r\nKPX T egrave -60\r\nKPX T emacron -60\r\nKPX T eogonek -120\r\nKPX T hyphen -140\r\nKPX T o -120\r\nKPX T oacute -120\r\nKPX T ocircumflex -120\r\nKPX T odieresis -120\r\nKPX T ograve -120\r\nKPX T ohungarumlaut -120\r\nKPX T omacron -60\r\nKPX T oslash -120\r\nKPX T otilde -60\r\nKPX T period -120\r\nKPX T r -120\r\nKPX T racute -120\r\nKPX T rcaron -120\r\nKPX T rcommaaccent -120\r\nKPX T semicolon -20\r\nKPX T u -120\r\nKPX T uacute -120\r\nKPX T ucircumflex -120\r\nKPX T udieresis -120\r\nKPX T ugrave -120\r\nKPX T uhungarumlaut -120\r\nKPX T umacron -60\r\nKPX T uogonek -120\r\nKPX T uring -120\r\nKPX T w -120\r\nKPX T y -120\r\nKPX T yacute -120\r\nKPX T ydieresis -60\r\nKPX Tcaron A -120\r\nKPX Tcaron Aacute -120\r\nKPX Tcaron Abreve -120\r\nKPX Tcaron Acircumflex -120\r\nKPX Tcaron Adieresis -120\r\nKPX Tcaron Agrave -120\r\nKPX Tcaron Amacron -120\r\nKPX Tcaron Aogonek -120\r\nKPX Tcaron Aring -120\r\nKPX Tcaron Atilde -120\r\nKPX Tcaron O -40\r\nKPX Tcaron Oacute -40\r\nKPX Tcaron Ocircumflex -40\r\nKPX Tcaron Odieresis -40\r\nKPX Tcaron Ograve -40\r\nKPX Tcaron Ohungarumlaut -40\r\nKPX Tcaron Omacron -40\r\nKPX Tcaron Oslash -40\r\nKPX Tcaron Otilde -40\r\nKPX Tcaron a -120\r\nKPX Tcaron aacute -120\r\nKPX Tcaron abreve -60\r\nKPX Tcaron acircumflex -120\r\nKPX Tcaron adieresis -120\r\nKPX Tcaron agrave -120\r\nKPX Tcaron amacron -60\r\nKPX Tcaron aogonek -120\r\nKPX Tcaron aring -120\r\nKPX Tcaron atilde -60\r\nKPX Tcaron colon -20\r\nKPX Tcaron comma -120\r\nKPX Tcaron e -120\r\nKPX Tcaron eacute -120\r\nKPX Tcaron ecaron -120\r\nKPX Tcaron ecircumflex -120\r\nKPX Tcaron edieresis -120\r\nKPX Tcaron edotaccent -120\r\nKPX Tcaron egrave -60\r\nKPX Tcaron emacron -60\r\nKPX Tcaron eogonek -120\r\nKPX Tcaron hyphen -140\r\nKPX Tcaron o -120\r\nKPX Tcaron oacute -120\r\nKPX Tcaron ocircumflex -120\r\nKPX Tcaron odieresis -120\r\nKPX Tcaron ograve -120\r\nKPX Tcaron ohungarumlaut -120\r\nKPX Tcaron omacron -60\r\nKPX Tcaron oslash -120\r\nKPX Tcaron otilde -60\r\nKPX Tcaron period -120\r\nKPX Tcaron r -120\r\nKPX Tcaron racute -120\r\nKPX Tcaron rcaron -120\r\nKPX Tcaron rcommaaccent -120\r\nKPX Tcaron semicolon -20\r\nKPX Tcaron u -120\r\nKPX Tcaron uacute -120\r\nKPX Tcaron ucircumflex -120\r\nKPX Tcaron udieresis -120\r\nKPX Tcaron ugrave -120\r\nKPX Tcaron uhungarumlaut -120\r\nKPX Tcaron umacron -60\r\nKPX Tcaron uogonek -120\r\nKPX Tcaron uring -120\r\nKPX Tcaron w -120\r\nKPX Tcaron y -120\r\nKPX Tcaron yacute -120\r\nKPX Tcaron ydieresis -60\r\nKPX Tcommaaccent A -120\r\nKPX Tcommaaccent Aacute -120\r\nKPX Tcommaaccent Abreve -120\r\nKPX Tcommaaccent Acircumflex -120\r\nKPX Tcommaaccent Adieresis -120\r\nKPX Tcommaaccent Agrave -120\r\nKPX Tcommaaccent Amacron -120\r\nKPX Tcommaaccent Aogonek -120\r\nKPX Tcommaaccent Aring -120\r\nKPX Tcommaaccent Atilde -120\r\nKPX Tcommaaccent O -40\r\nKPX Tcommaaccent Oacute -40\r\nKPX Tcommaaccent Ocircumflex -40\r\nKPX Tcommaaccent Odieresis -40\r\nKPX Tcommaaccent Ograve -40\r\nKPX Tcommaaccent Ohungarumlaut -40\r\nKPX Tcommaaccent Omacron -40\r\nKPX Tcommaaccent Oslash -40\r\nKPX Tcommaaccent Otilde -40\r\nKPX Tcommaaccent a -120\r\nKPX Tcommaaccent aacute -120\r\nKPX Tcommaaccent abreve -60\r\nKPX Tcommaaccent acircumflex -120\r\nKPX Tcommaaccent adieresis -120\r\nKPX Tcommaaccent agrave -120\r\nKPX Tcommaaccent amacron -60\r\nKPX Tcommaaccent aogonek -120\r\nKPX Tcommaaccent aring -120\r\nKPX Tcommaaccent atilde -60\r\nKPX Tcommaaccent colon -20\r\nKPX Tcommaaccent comma -120\r\nKPX Tcommaaccent e -120\r\nKPX Tcommaaccent eacute -120\r\nKPX Tcommaaccent ecaron -120\r\nKPX Tcommaaccent ecircumflex -120\r\nKPX Tcommaaccent edieresis -120\r\nKPX Tcommaaccent edotaccent -120\r\nKPX Tcommaaccent egrave -60\r\nKPX Tcommaaccent emacron -60\r\nKPX Tcommaaccent eogonek -120\r\nKPX Tcommaaccent hyphen -140\r\nKPX Tcommaaccent o -120\r\nKPX Tcommaaccent oacute -120\r\nKPX Tcommaaccent ocircumflex -120\r\nKPX Tcommaaccent odieresis -120\r\nKPX Tcommaaccent ograve -120\r\nKPX Tcommaaccent ohungarumlaut -120\r\nKPX Tcommaaccent omacron -60\r\nKPX Tcommaaccent oslash -120\r\nKPX Tcommaaccent otilde -60\r\nKPX Tcommaaccent period -120\r\nKPX Tcommaaccent r -120\r\nKPX Tcommaaccent racute -120\r\nKPX Tcommaaccent rcaron -120\r\nKPX Tcommaaccent rcommaaccent -120\r\nKPX Tcommaaccent semicolon -20\r\nKPX Tcommaaccent u -120\r\nKPX Tcommaaccent uacute -120\r\nKPX Tcommaaccent ucircumflex -120\r\nKPX Tcommaaccent udieresis -120\r\nKPX Tcommaaccent ugrave -120\r\nKPX Tcommaaccent uhungarumlaut -120\r\nKPX Tcommaaccent umacron -60\r\nKPX Tcommaaccent uogonek -120\r\nKPX Tcommaaccent uring -120\r\nKPX Tcommaaccent w -120\r\nKPX Tcommaaccent y -120\r\nKPX Tcommaaccent yacute -120\r\nKPX Tcommaaccent ydieresis -60\r\nKPX U A -40\r\nKPX U Aacute -40\r\nKPX U Abreve -40\r\nKPX U Acircumflex -40\r\nKPX U Adieresis -40\r\nKPX U Agrave -40\r\nKPX U Amacron -40\r\nKPX U Aogonek -40\r\nKPX U Aring -40\r\nKPX U Atilde -40\r\nKPX U comma -40\r\nKPX U period -40\r\nKPX Uacute A -40\r\nKPX Uacute Aacute -40\r\nKPX Uacute Abreve -40\r\nKPX Uacute Acircumflex -40\r\nKPX Uacute Adieresis -40\r\nKPX Uacute Agrave -40\r\nKPX Uacute Amacron -40\r\nKPX Uacute Aogonek -40\r\nKPX Uacute Aring -40\r\nKPX Uacute Atilde -40\r\nKPX Uacute comma -40\r\nKPX Uacute period -40\r\nKPX Ucircumflex A -40\r\nKPX Ucircumflex Aacute -40\r\nKPX Ucircumflex Abreve -40\r\nKPX Ucircumflex Acircumflex -40\r\nKPX Ucircumflex Adieresis -40\r\nKPX Ucircumflex Agrave -40\r\nKPX Ucircumflex Amacron -40\r\nKPX Ucircumflex Aogonek -40\r\nKPX Ucircumflex Aring -40\r\nKPX Ucircumflex Atilde -40\r\nKPX Ucircumflex comma -40\r\nKPX Ucircumflex period -40\r\nKPX Udieresis A -40\r\nKPX Udieresis Aacute -40\r\nKPX Udieresis Abreve -40\r\nKPX Udieresis Acircumflex -40\r\nKPX Udieresis Adieresis -40\r\nKPX Udieresis Agrave -40\r\nKPX Udieresis Amacron -40\r\nKPX Udieresis Aogonek -40\r\nKPX Udieresis Aring -40\r\nKPX Udieresis Atilde -40\r\nKPX Udieresis comma -40\r\nKPX Udieresis period -40\r\nKPX Ugrave A -40\r\nKPX Ugrave Aacute -40\r\nKPX Ugrave Abreve -40\r\nKPX Ugrave Acircumflex -40\r\nKPX Ugrave Adieresis -40\r\nKPX Ugrave Agrave -40\r\nKPX Ugrave Amacron -40\r\nKPX Ugrave Aogonek -40\r\nKPX Ugrave Aring -40\r\nKPX Ugrave Atilde -40\r\nKPX Ugrave comma -40\r\nKPX Ugrave period -40\r\nKPX Uhungarumlaut A -40\r\nKPX Uhungarumlaut Aacute -40\r\nKPX Uhungarumlaut Abreve -40\r\nKPX Uhungarumlaut Acircumflex -40\r\nKPX Uhungarumlaut Adieresis -40\r\nKPX Uhungarumlaut Agrave -40\r\nKPX Uhungarumlaut Amacron -40\r\nKPX Uhungarumlaut Aogonek -40\r\nKPX Uhungarumlaut Aring -40\r\nKPX Uhungarumlaut Atilde -40\r\nKPX Uhungarumlaut comma -40\r\nKPX Uhungarumlaut period -40\r\nKPX Umacron A -40\r\nKPX Umacron Aacute -40\r\nKPX Umacron Abreve -40\r\nKPX Umacron Acircumflex -40\r\nKPX Umacron Adieresis -40\r\nKPX Umacron Agrave -40\r\nKPX Umacron Amacron -40\r\nKPX Umacron Aogonek -40\r\nKPX Umacron Aring -40\r\nKPX Umacron Atilde -40\r\nKPX Umacron comma -40\r\nKPX Umacron period -40\r\nKPX Uogonek A -40\r\nKPX Uogonek Aacute -40\r\nKPX Uogonek Abreve -40\r\nKPX Uogonek Acircumflex -40\r\nKPX Uogonek Adieresis -40\r\nKPX Uogonek Agrave -40\r\nKPX Uogonek Amacron -40\r\nKPX Uogonek Aogonek -40\r\nKPX Uogonek Aring -40\r\nKPX Uogonek Atilde -40\r\nKPX Uogonek comma -40\r\nKPX Uogonek period -40\r\nKPX Uring A -40\r\nKPX Uring Aacute -40\r\nKPX Uring Abreve -40\r\nKPX Uring Acircumflex -40\r\nKPX Uring Adieresis -40\r\nKPX Uring Agrave -40\r\nKPX Uring Amacron -40\r\nKPX Uring Aogonek -40\r\nKPX Uring Aring -40\r\nKPX Uring Atilde -40\r\nKPX Uring comma -40\r\nKPX Uring period -40\r\nKPX V A -80\r\nKPX V Aacute -80\r\nKPX V Abreve -80\r\nKPX V Acircumflex -80\r\nKPX V Adieresis -80\r\nKPX V Agrave -80\r\nKPX V Amacron -80\r\nKPX V Aogonek -80\r\nKPX V Aring -80\r\nKPX V Atilde -80\r\nKPX V G -40\r\nKPX V Gbreve -40\r\nKPX V Gcommaaccent -40\r\nKPX V O -40\r\nKPX V Oacute -40\r\nKPX V Ocircumflex -40\r\nKPX V Odieresis -40\r\nKPX V Ograve -40\r\nKPX V Ohungarumlaut -40\r\nKPX V Omacron -40\r\nKPX V Oslash -40\r\nKPX V Otilde -40\r\nKPX V a -70\r\nKPX V aacute -70\r\nKPX V abreve -70\r\nKPX V acircumflex -70\r\nKPX V adieresis -70\r\nKPX V agrave -70\r\nKPX V amacron -70\r\nKPX V aogonek -70\r\nKPX V aring -70\r\nKPX V atilde -70\r\nKPX V colon -40\r\nKPX V comma -125\r\nKPX V e -80\r\nKPX V eacute -80\r\nKPX V ecaron -80\r\nKPX V ecircumflex -80\r\nKPX V edieresis -80\r\nKPX V edotaccent -80\r\nKPX V egrave -80\r\nKPX V emacron -80\r\nKPX V eogonek -80\r\nKPX V hyphen -80\r\nKPX V o -80\r\nKPX V oacute -80\r\nKPX V ocircumflex -80\r\nKPX V odieresis -80\r\nKPX V ograve -80\r\nKPX V ohungarumlaut -80\r\nKPX V omacron -80\r\nKPX V oslash -80\r\nKPX V otilde -80\r\nKPX V period -125\r\nKPX V semicolon -40\r\nKPX V u -70\r\nKPX V uacute -70\r\nKPX V ucircumflex -70\r\nKPX V udieresis -70\r\nKPX V ugrave -70\r\nKPX V uhungarumlaut -70\r\nKPX V umacron -70\r\nKPX V uogonek -70\r\nKPX V uring -70\r\nKPX W A -50\r\nKPX W Aacute -50\r\nKPX W Abreve -50\r\nKPX W Acircumflex -50\r\nKPX W Adieresis -50\r\nKPX W Agrave -50\r\nKPX W Amacron -50\r\nKPX W Aogonek -50\r\nKPX W Aring -50\r\nKPX W Atilde -50\r\nKPX W O -20\r\nKPX W Oacute -20\r\nKPX W Ocircumflex -20\r\nKPX W Odieresis -20\r\nKPX W Ograve -20\r\nKPX W Ohungarumlaut -20\r\nKPX W Omacron -20\r\nKPX W Oslash -20\r\nKPX W Otilde -20\r\nKPX W a -40\r\nKPX W aacute -40\r\nKPX W abreve -40\r\nKPX W acircumflex -40\r\nKPX W adieresis -40\r\nKPX W agrave -40\r\nKPX W amacron -40\r\nKPX W aogonek -40\r\nKPX W aring -40\r\nKPX W atilde -40\r\nKPX W comma -80\r\nKPX W e -30\r\nKPX W eacute -30\r\nKPX W ecaron -30\r\nKPX W ecircumflex -30\r\nKPX W edieresis -30\r\nKPX W edotaccent -30\r\nKPX W egrave -30\r\nKPX W emacron -30\r\nKPX W eogonek -30\r\nKPX W hyphen -40\r\nKPX W o -30\r\nKPX W oacute -30\r\nKPX W ocircumflex -30\r\nKPX W odieresis -30\r\nKPX W ograve -30\r\nKPX W ohungarumlaut -30\r\nKPX W omacron -30\r\nKPX W oslash -30\r\nKPX W otilde -30\r\nKPX W period -80\r\nKPX W u -30\r\nKPX W uacute -30\r\nKPX W ucircumflex -30\r\nKPX W udieresis -30\r\nKPX W ugrave -30\r\nKPX W uhungarumlaut -30\r\nKPX W umacron -30\r\nKPX W uogonek -30\r\nKPX W uring -30\r\nKPX W y -20\r\nKPX W yacute -20\r\nKPX W ydieresis -20\r\nKPX Y A -110\r\nKPX Y Aacute -110\r\nKPX Y Abreve -110\r\nKPX Y Acircumflex -110\r\nKPX Y Adieresis -110\r\nKPX Y Agrave -110\r\nKPX Y Amacron -110\r\nKPX Y Aogonek -110\r\nKPX Y Aring -110\r\nKPX Y Atilde -110\r\nKPX Y O -85\r\nKPX Y Oacute -85\r\nKPX Y Ocircumflex -85\r\nKPX Y Odieresis -85\r\nKPX Y Ograve -85\r\nKPX Y Ohungarumlaut -85\r\nKPX Y Omacron -85\r\nKPX Y Oslash -85\r\nKPX Y Otilde -85\r\nKPX Y a -140\r\nKPX Y aacute -140\r\nKPX Y abreve -70\r\nKPX Y acircumflex -140\r\nKPX Y adieresis -140\r\nKPX Y agrave -140\r\nKPX Y amacron -70\r\nKPX Y aogonek -140\r\nKPX Y aring -140\r\nKPX Y atilde -140\r\nKPX Y colon -60\r\nKPX Y comma -140\r\nKPX Y e -140\r\nKPX Y eacute -140\r\nKPX Y ecaron -140\r\nKPX Y ecircumflex -140\r\nKPX Y edieresis -140\r\nKPX Y edotaccent -140\r\nKPX Y egrave -140\r\nKPX Y emacron -70\r\nKPX Y eogonek -140\r\nKPX Y hyphen -140\r\nKPX Y i -20\r\nKPX Y iacute -20\r\nKPX Y iogonek -20\r\nKPX Y o -140\r\nKPX Y oacute -140\r\nKPX Y ocircumflex -140\r\nKPX Y odieresis -140\r\nKPX Y ograve -140\r\nKPX Y ohungarumlaut -140\r\nKPX Y omacron -140\r\nKPX Y oslash -140\r\nKPX Y otilde -140\r\nKPX Y period -140\r\nKPX Y semicolon -60\r\nKPX Y u -110\r\nKPX Y uacute -110\r\nKPX Y ucircumflex -110\r\nKPX Y udieresis -110\r\nKPX Y ugrave -110\r\nKPX Y uhungarumlaut -110\r\nKPX Y umacron -110\r\nKPX Y uogonek -110\r\nKPX Y uring -110\r\nKPX Yacute A -110\r\nKPX Yacute Aacute -110\r\nKPX Yacute Abreve -110\r\nKPX Yacute Acircumflex -110\r\nKPX Yacute Adieresis -110\r\nKPX Yacute Agrave -110\r\nKPX Yacute Amacron -110\r\nKPX Yacute Aogonek -110\r\nKPX Yacute Aring -110\r\nKPX Yacute Atilde -110\r\nKPX Yacute O -85\r\nKPX Yacute Oacute -85\r\nKPX Yacute Ocircumflex -85\r\nKPX Yacute Odieresis -85\r\nKPX Yacute Ograve -85\r\nKPX Yacute Ohungarumlaut -85\r\nKPX Yacute Omacron -85\r\nKPX Yacute Oslash -85\r\nKPX Yacute Otilde -85\r\nKPX Yacute a -140\r\nKPX Yacute aacute -140\r\nKPX Yacute abreve -70\r\nKPX Yacute acircumflex -140\r\nKPX Yacute adieresis -140\r\nKPX Yacute agrave -140\r\nKPX Yacute amacron -70\r\nKPX Yacute aogonek -140\r\nKPX Yacute aring -140\r\nKPX Yacute atilde -70\r\nKPX Yacute colon -60\r\nKPX Yacute comma -140\r\nKPX Yacute e -140\r\nKPX Yacute eacute -140\r\nKPX Yacute ecaron -140\r\nKPX Yacute ecircumflex -140\r\nKPX Yacute edieresis -140\r\nKPX Yacute edotaccent -140\r\nKPX Yacute egrave -140\r\nKPX Yacute emacron -70\r\nKPX Yacute eogonek -140\r\nKPX Yacute hyphen -140\r\nKPX Yacute i -20\r\nKPX Yacute iacute -20\r\nKPX Yacute iogonek -20\r\nKPX Yacute o -140\r\nKPX Yacute oacute -140\r\nKPX Yacute ocircumflex -140\r\nKPX Yacute odieresis -140\r\nKPX Yacute ograve -140\r\nKPX Yacute ohungarumlaut -140\r\nKPX Yacute omacron -70\r\nKPX Yacute oslash -140\r\nKPX Yacute otilde -140\r\nKPX Yacute period -140\r\nKPX Yacute semicolon -60\r\nKPX Yacute u -110\r\nKPX Yacute uacute -110\r\nKPX Yacute ucircumflex -110\r\nKPX Yacute udieresis -110\r\nKPX Yacute ugrave -110\r\nKPX Yacute uhungarumlaut -110\r\nKPX Yacute umacron -110\r\nKPX Yacute uogonek -110\r\nKPX Yacute uring -110\r\nKPX Ydieresis A -110\r\nKPX Ydieresis Aacute -110\r\nKPX Ydieresis Abreve -110\r\nKPX Ydieresis Acircumflex -110\r\nKPX Ydieresis Adieresis -110\r\nKPX Ydieresis Agrave -110\r\nKPX Ydieresis Amacron -110\r\nKPX Ydieresis Aogonek -110\r\nKPX Ydieresis Aring -110\r\nKPX Ydieresis Atilde -110\r\nKPX Ydieresis O -85\r\nKPX Ydieresis Oacute -85\r\nKPX Ydieresis Ocircumflex -85\r\nKPX Ydieresis Odieresis -85\r\nKPX Ydieresis Ograve -85\r\nKPX Ydieresis Ohungarumlaut -85\r\nKPX Ydieresis Omacron -85\r\nKPX Ydieresis Oslash -85\r\nKPX Ydieresis Otilde -85\r\nKPX Ydieresis a -140\r\nKPX Ydieresis aacute -140\r\nKPX Ydieresis abreve -70\r\nKPX Ydieresis acircumflex -140\r\nKPX Ydieresis adieresis -140\r\nKPX Ydieresis agrave -140\r\nKPX Ydieresis amacron -70\r\nKPX Ydieresis aogonek -140\r\nKPX Ydieresis aring -140\r\nKPX Ydieresis atilde -70\r\nKPX Ydieresis colon -60\r\nKPX Ydieresis comma -140\r\nKPX Ydieresis e -140\r\nKPX Ydieresis eacute -140\r\nKPX Ydieresis ecaron -140\r\nKPX Ydieresis ecircumflex -140\r\nKPX Ydieresis edieresis -140\r\nKPX Ydieresis edotaccent -140\r\nKPX Ydieresis egrave -140\r\nKPX Ydieresis emacron -70\r\nKPX Ydieresis eogonek -140\r\nKPX Ydieresis hyphen -140\r\nKPX Ydieresis i -20\r\nKPX Ydieresis iacute -20\r\nKPX Ydieresis iogonek -20\r\nKPX Ydieresis o -140\r\nKPX Ydieresis oacute -140\r\nKPX Ydieresis ocircumflex -140\r\nKPX Ydieresis odieresis -140\r\nKPX Ydieresis ograve -140\r\nKPX Ydieresis ohungarumlaut -140\r\nKPX Ydieresis omacron -140\r\nKPX Ydieresis oslash -140\r\nKPX Ydieresis otilde -140\r\nKPX Ydieresis period -140\r\nKPX Ydieresis semicolon -60\r\nKPX Ydieresis u -110\r\nKPX Ydieresis uacute -110\r\nKPX Ydieresis ucircumflex -110\r\nKPX Ydieresis udieresis -110\r\nKPX Ydieresis ugrave -110\r\nKPX Ydieresis uhungarumlaut -110\r\nKPX Ydieresis umacron -110\r\nKPX Ydieresis uogonek -110\r\nKPX Ydieresis uring -110\r\nKPX a v -20\r\nKPX a w -20\r\nKPX a y -30\r\nKPX a yacute -30\r\nKPX a ydieresis -30\r\nKPX aacute v -20\r\nKPX aacute w -20\r\nKPX aacute y -30\r\nKPX aacute yacute -30\r\nKPX aacute ydieresis -30\r\nKPX abreve v -20\r\nKPX abreve w -20\r\nKPX abreve y -30\r\nKPX abreve yacute -30\r\nKPX abreve ydieresis -30\r\nKPX acircumflex v -20\r\nKPX acircumflex w -20\r\nKPX acircumflex y -30\r\nKPX acircumflex yacute -30\r\nKPX acircumflex ydieresis -30\r\nKPX adieresis v -20\r\nKPX adieresis w -20\r\nKPX adieresis y -30\r\nKPX adieresis yacute -30\r\nKPX adieresis ydieresis -30\r\nKPX agrave v -20\r\nKPX agrave w -20\r\nKPX agrave y -30\r\nKPX agrave yacute -30\r\nKPX agrave ydieresis -30\r\nKPX amacron v -20\r\nKPX amacron w -20\r\nKPX amacron y -30\r\nKPX amacron yacute -30\r\nKPX amacron ydieresis -30\r\nKPX aogonek v -20\r\nKPX aogonek w -20\r\nKPX aogonek y -30\r\nKPX aogonek yacute -30\r\nKPX aogonek ydieresis -30\r\nKPX aring v -20\r\nKPX aring w -20\r\nKPX aring y -30\r\nKPX aring yacute -30\r\nKPX aring ydieresis -30\r\nKPX atilde v -20\r\nKPX atilde w -20\r\nKPX atilde y -30\r\nKPX atilde yacute -30\r\nKPX atilde ydieresis -30\r\nKPX b b -10\r\nKPX b comma -40\r\nKPX b l -20\r\nKPX b lacute -20\r\nKPX b lcommaaccent -20\r\nKPX b lslash -20\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -20\r\nKPX b y -20\r\nKPX b yacute -20\r\nKPX b ydieresis -20\r\nKPX c comma -15\r\nKPX c k -20\r\nKPX c kcommaaccent -20\r\nKPX cacute comma -15\r\nKPX cacute k -20\r\nKPX cacute kcommaaccent -20\r\nKPX ccaron comma -15\r\nKPX ccaron k -20\r\nKPX ccaron kcommaaccent -20\r\nKPX ccedilla comma -15\r\nKPX ccedilla k -20\r\nKPX ccedilla kcommaaccent -20\r\nKPX colon space -50\r\nKPX comma quotedblright -100\r\nKPX comma quoteright -100\r\nKPX e comma -15\r\nKPX e period -15\r\nKPX e v -30\r\nKPX e w -20\r\nKPX e x -30\r\nKPX e y -20\r\nKPX e yacute -20\r\nKPX e ydieresis -20\r\nKPX eacute comma -15\r\nKPX eacute period -15\r\nKPX eacute v -30\r\nKPX eacute w -20\r\nKPX eacute x -30\r\nKPX eacute y -20\r\nKPX eacute yacute -20\r\nKPX eacute ydieresis -20\r\nKPX ecaron comma -15\r\nKPX ecaron period -15\r\nKPX ecaron v -30\r\nKPX ecaron w -20\r\nKPX ecaron x -30\r\nKPX ecaron y -20\r\nKPX ecaron yacute -20\r\nKPX ecaron ydieresis -20\r\nKPX ecircumflex comma -15\r\nKPX ecircumflex period -15\r\nKPX ecircumflex v -30\r\nKPX ecircumflex w -20\r\nKPX ecircumflex x -30\r\nKPX ecircumflex y -20\r\nKPX ecircumflex yacute -20\r\nKPX ecircumflex ydieresis -20\r\nKPX edieresis comma -15\r\nKPX edieresis period -15\r\nKPX edieresis v -30\r\nKPX edieresis w -20\r\nKPX edieresis x -30\r\nKPX edieresis y -20\r\nKPX edieresis yacute -20\r\nKPX edieresis ydieresis -20\r\nKPX edotaccent comma -15\r\nKPX edotaccent period -15\r\nKPX edotaccent v -30\r\nKPX edotaccent w -20\r\nKPX edotaccent x -30\r\nKPX edotaccent y -20\r\nKPX edotaccent yacute -20\r\nKPX edotaccent ydieresis -20\r\nKPX egrave comma -15\r\nKPX egrave period -15\r\nKPX egrave v -30\r\nKPX egrave w -20\r\nKPX egrave x -30\r\nKPX egrave y -20\r\nKPX egrave yacute -20\r\nKPX egrave ydieresis -20\r\nKPX emacron comma -15\r\nKPX emacron period -15\r\nKPX emacron v -30\r\nKPX emacron w -20\r\nKPX emacron x -30\r\nKPX emacron y -20\r\nKPX emacron yacute -20\r\nKPX emacron ydieresis -20\r\nKPX eogonek comma -15\r\nKPX eogonek period -15\r\nKPX eogonek v -30\r\nKPX eogonek w -20\r\nKPX eogonek x -30\r\nKPX eogonek y -20\r\nKPX eogonek yacute -20\r\nKPX eogonek ydieresis -20\r\nKPX f a -30\r\nKPX f aacute -30\r\nKPX f abreve -30\r\nKPX f acircumflex -30\r\nKPX f adieresis -30\r\nKPX f agrave -30\r\nKPX f amacron -30\r\nKPX f aogonek -30\r\nKPX f aring -30\r\nKPX f atilde -30\r\nKPX f comma -30\r\nKPX f dotlessi -28\r\nKPX f e -30\r\nKPX f eacute -30\r\nKPX f ecaron -30\r\nKPX f ecircumflex -30\r\nKPX f edieresis -30\r\nKPX f edotaccent -30\r\nKPX f egrave -30\r\nKPX f emacron -30\r\nKPX f eogonek -30\r\nKPX f o -30\r\nKPX f oacute -30\r\nKPX f ocircumflex -30\r\nKPX f odieresis -30\r\nKPX f ograve -30\r\nKPX f ohungarumlaut -30\r\nKPX f omacron -30\r\nKPX f oslash -30\r\nKPX f otilde -30\r\nKPX f period -30\r\nKPX f quotedblright 60\r\nKPX f quoteright 50\r\nKPX g r -10\r\nKPX g racute -10\r\nKPX g rcaron -10\r\nKPX g rcommaaccent -10\r\nKPX gbreve r -10\r\nKPX gbreve racute -10\r\nKPX gbreve rcaron -10\r\nKPX gbreve rcommaaccent -10\r\nKPX gcommaaccent r -10\r\nKPX gcommaaccent racute -10\r\nKPX gcommaaccent rcaron -10\r\nKPX gcommaaccent rcommaaccent -10\r\nKPX h y -30\r\nKPX h yacute -30\r\nKPX h ydieresis -30\r\nKPX k e -20\r\nKPX k eacute -20\r\nKPX k ecaron -20\r\nKPX k ecircumflex -20\r\nKPX k edieresis -20\r\nKPX k edotaccent -20\r\nKPX k egrave -20\r\nKPX k emacron -20\r\nKPX k eogonek -20\r\nKPX k o -20\r\nKPX k oacute -20\r\nKPX k ocircumflex -20\r\nKPX k odieresis -20\r\nKPX k ograve -20\r\nKPX k ohungarumlaut -20\r\nKPX k omacron -20\r\nKPX k oslash -20\r\nKPX k otilde -20\r\nKPX kcommaaccent e -20\r\nKPX kcommaaccent eacute -20\r\nKPX kcommaaccent ecaron -20\r\nKPX kcommaaccent ecircumflex -20\r\nKPX kcommaaccent edieresis -20\r\nKPX kcommaaccent edotaccent -20\r\nKPX kcommaaccent egrave -20\r\nKPX kcommaaccent emacron -20\r\nKPX kcommaaccent eogonek -20\r\nKPX kcommaaccent o -20\r\nKPX kcommaaccent oacute -20\r\nKPX kcommaaccent ocircumflex -20\r\nKPX kcommaaccent odieresis -20\r\nKPX kcommaaccent ograve -20\r\nKPX kcommaaccent ohungarumlaut -20\r\nKPX kcommaaccent omacron -20\r\nKPX kcommaaccent oslash -20\r\nKPX kcommaaccent otilde -20\r\nKPX m u -10\r\nKPX m uacute -10\r\nKPX m ucircumflex -10\r\nKPX m udieresis -10\r\nKPX m ugrave -10\r\nKPX m uhungarumlaut -10\r\nKPX m umacron -10\r\nKPX m uogonek -10\r\nKPX m uring -10\r\nKPX m y -15\r\nKPX m yacute -15\r\nKPX m ydieresis -15\r\nKPX n u -10\r\nKPX n uacute -10\r\nKPX n ucircumflex -10\r\nKPX n udieresis -10\r\nKPX n ugrave -10\r\nKPX n uhungarumlaut -10\r\nKPX n umacron -10\r\nKPX n uogonek -10\r\nKPX n uring -10\r\nKPX n v -20\r\nKPX n y -15\r\nKPX n yacute -15\r\nKPX n ydieresis -15\r\nKPX nacute u -10\r\nKPX nacute uacute -10\r\nKPX nacute ucircumflex -10\r\nKPX nacute udieresis -10\r\nKPX nacute ugrave -10\r\nKPX nacute uhungarumlaut -10\r\nKPX nacute umacron -10\r\nKPX nacute uogonek -10\r\nKPX nacute uring -10\r\nKPX nacute v -20\r\nKPX nacute y -15\r\nKPX nacute yacute -15\r\nKPX nacute ydieresis -15\r\nKPX ncaron u -10\r\nKPX ncaron uacute -10\r\nKPX ncaron ucircumflex -10\r\nKPX ncaron udieresis -10\r\nKPX ncaron ugrave -10\r\nKPX ncaron uhungarumlaut -10\r\nKPX ncaron umacron -10\r\nKPX ncaron uogonek -10\r\nKPX ncaron uring -10\r\nKPX ncaron v -20\r\nKPX ncaron y -15\r\nKPX ncaron yacute -15\r\nKPX ncaron ydieresis -15\r\nKPX ncommaaccent u -10\r\nKPX ncommaaccent uacute -10\r\nKPX ncommaaccent ucircumflex -10\r\nKPX ncommaaccent udieresis -10\r\nKPX ncommaaccent ugrave -10\r\nKPX ncommaaccent uhungarumlaut -10\r\nKPX ncommaaccent umacron -10\r\nKPX ncommaaccent uogonek -10\r\nKPX ncommaaccent uring -10\r\nKPX ncommaaccent v -20\r\nKPX ncommaaccent y -15\r\nKPX ncommaaccent yacute -15\r\nKPX ncommaaccent ydieresis -15\r\nKPX ntilde u -10\r\nKPX ntilde uacute -10\r\nKPX ntilde ucircumflex -10\r\nKPX ntilde udieresis -10\r\nKPX ntilde ugrave -10\r\nKPX ntilde uhungarumlaut -10\r\nKPX ntilde umacron -10\r\nKPX ntilde uogonek -10\r\nKPX ntilde uring -10\r\nKPX ntilde v -20\r\nKPX ntilde y -15\r\nKPX ntilde yacute -15\r\nKPX ntilde ydieresis -15\r\nKPX o comma -40\r\nKPX o period -40\r\nKPX o v -15\r\nKPX o w -15\r\nKPX o x -30\r\nKPX o y -30\r\nKPX o yacute -30\r\nKPX o ydieresis -30\r\nKPX oacute comma -40\r\nKPX oacute period -40\r\nKPX oacute v -15\r\nKPX oacute w -15\r\nKPX oacute x -30\r\nKPX oacute y -30\r\nKPX oacute yacute -30\r\nKPX oacute ydieresis -30\r\nKPX ocircumflex comma -40\r\nKPX ocircumflex period -40\r\nKPX ocircumflex v -15\r\nKPX ocircumflex w -15\r\nKPX ocircumflex x -30\r\nKPX ocircumflex y -30\r\nKPX ocircumflex yacute -30\r\nKPX ocircumflex ydieresis -30\r\nKPX odieresis comma -40\r\nKPX odieresis period -40\r\nKPX odieresis v -15\r\nKPX odieresis w -15\r\nKPX odieresis x -30\r\nKPX odieresis y -30\r\nKPX odieresis yacute -30\r\nKPX odieresis ydieresis -30\r\nKPX ograve comma -40\r\nKPX ograve period -40\r\nKPX ograve v -15\r\nKPX ograve w -15\r\nKPX ograve x -30\r\nKPX ograve y -30\r\nKPX ograve yacute -30\r\nKPX ograve ydieresis -30\r\nKPX ohungarumlaut comma -40\r\nKPX ohungarumlaut period -40\r\nKPX ohungarumlaut v -15\r\nKPX ohungarumlaut w -15\r\nKPX ohungarumlaut x -30\r\nKPX ohungarumlaut y -30\r\nKPX ohungarumlaut yacute -30\r\nKPX ohungarumlaut ydieresis -30\r\nKPX omacron comma -40\r\nKPX omacron period -40\r\nKPX omacron v -15\r\nKPX omacron w -15\r\nKPX omacron x -30\r\nKPX omacron y -30\r\nKPX omacron yacute -30\r\nKPX omacron ydieresis -30\r\nKPX oslash a -55\r\nKPX oslash aacute -55\r\nKPX oslash abreve -55\r\nKPX oslash acircumflex -55\r\nKPX oslash adieresis -55\r\nKPX oslash agrave -55\r\nKPX oslash amacron -55\r\nKPX oslash aogonek -55\r\nKPX oslash aring -55\r\nKPX oslash atilde -55\r\nKPX oslash b -55\r\nKPX oslash c -55\r\nKPX oslash cacute -55\r\nKPX oslash ccaron -55\r\nKPX oslash ccedilla -55\r\nKPX oslash comma -95\r\nKPX oslash d -55\r\nKPX oslash dcroat -55\r\nKPX oslash e -55\r\nKPX oslash eacute -55\r\nKPX oslash ecaron -55\r\nKPX oslash ecircumflex -55\r\nKPX oslash edieresis -55\r\nKPX oslash edotaccent -55\r\nKPX oslash egrave -55\r\nKPX oslash emacron -55\r\nKPX oslash eogonek -55\r\nKPX oslash f -55\r\nKPX oslash g -55\r\nKPX oslash gbreve -55\r\nKPX oslash gcommaaccent -55\r\nKPX oslash h -55\r\nKPX oslash i -55\r\nKPX oslash iacute -55\r\nKPX oslash icircumflex -55\r\nKPX oslash idieresis -55\r\nKPX oslash igrave -55\r\nKPX oslash imacron -55\r\nKPX oslash iogonek -55\r\nKPX oslash j -55\r\nKPX oslash k -55\r\nKPX oslash kcommaaccent -55\r\nKPX oslash l -55\r\nKPX oslash lacute -55\r\nKPX oslash lcommaaccent -55\r\nKPX oslash lslash -55\r\nKPX oslash m -55\r\nKPX oslash n -55\r\nKPX oslash nacute -55\r\nKPX oslash ncaron -55\r\nKPX oslash ncommaaccent -55\r\nKPX oslash ntilde -55\r\nKPX oslash o -55\r\nKPX oslash oacute -55\r\nKPX oslash ocircumflex -55\r\nKPX oslash odieresis -55\r\nKPX oslash ograve -55\r\nKPX oslash ohungarumlaut -55\r\nKPX oslash omacron -55\r\nKPX oslash oslash -55\r\nKPX oslash otilde -55\r\nKPX oslash p -55\r\nKPX oslash period -95\r\nKPX oslash q -55\r\nKPX oslash r -55\r\nKPX oslash racute -55\r\nKPX oslash rcaron -55\r\nKPX oslash rcommaaccent -55\r\nKPX oslash s -55\r\nKPX oslash sacute -55\r\nKPX oslash scaron -55\r\nKPX oslash scedilla -55\r\nKPX oslash scommaaccent -55\r\nKPX oslash t -55\r\nKPX oslash tcommaaccent -55\r\nKPX oslash u -55\r\nKPX oslash uacute -55\r\nKPX oslash ucircumflex -55\r\nKPX oslash udieresis -55\r\nKPX oslash ugrave -55\r\nKPX oslash uhungarumlaut -55\r\nKPX oslash umacron -55\r\nKPX oslash uogonek -55\r\nKPX oslash uring -55\r\nKPX oslash v -70\r\nKPX oslash w -70\r\nKPX oslash x -85\r\nKPX oslash y -70\r\nKPX oslash yacute -70\r\nKPX oslash ydieresis -70\r\nKPX oslash z -55\r\nKPX oslash zacute -55\r\nKPX oslash zcaron -55\r\nKPX oslash zdotaccent -55\r\nKPX otilde comma -40\r\nKPX otilde period -40\r\nKPX otilde v -15\r\nKPX otilde w -15\r\nKPX otilde x -30\r\nKPX otilde y -30\r\nKPX otilde yacute -30\r\nKPX otilde ydieresis -30\r\nKPX p comma -35\r\nKPX p period -35\r\nKPX p y -30\r\nKPX p yacute -30\r\nKPX p ydieresis -30\r\nKPX period quotedblright -100\r\nKPX period quoteright -100\r\nKPX period space -60\r\nKPX quotedblright space -40\r\nKPX quoteleft quoteleft -57\r\nKPX quoteright d -50\r\nKPX quoteright dcroat -50\r\nKPX quoteright quoteright -57\r\nKPX quoteright r -50\r\nKPX quoteright racute -50\r\nKPX quoteright rcaron -50\r\nKPX quoteright rcommaaccent -50\r\nKPX quoteright s -50\r\nKPX quoteright sacute -50\r\nKPX quoteright scaron -50\r\nKPX quoteright scedilla -50\r\nKPX quoteright scommaaccent -50\r\nKPX quoteright space -70\r\nKPX r a -10\r\nKPX r aacute -10\r\nKPX r abreve -10\r\nKPX r acircumflex -10\r\nKPX r adieresis -10\r\nKPX r agrave -10\r\nKPX r amacron -10\r\nKPX r aogonek -10\r\nKPX r aring -10\r\nKPX r atilde -10\r\nKPX r colon 30\r\nKPX r comma -50\r\nKPX r i 15\r\nKPX r iacute 15\r\nKPX r icircumflex 15\r\nKPX r idieresis 15\r\nKPX r igrave 15\r\nKPX r imacron 15\r\nKPX r iogonek 15\r\nKPX r k 15\r\nKPX r kcommaaccent 15\r\nKPX r l 15\r\nKPX r lacute 15\r\nKPX r lcommaaccent 15\r\nKPX r lslash 15\r\nKPX r m 25\r\nKPX r n 25\r\nKPX r nacute 25\r\nKPX r ncaron 25\r\nKPX r ncommaaccent 25\r\nKPX r ntilde 25\r\nKPX r p 30\r\nKPX r period -50\r\nKPX r semicolon 30\r\nKPX r t 40\r\nKPX r tcommaaccent 40\r\nKPX r u 15\r\nKPX r uacute 15\r\nKPX r ucircumflex 15\r\nKPX r udieresis 15\r\nKPX r ugrave 15\r\nKPX r uhungarumlaut 15\r\nKPX r umacron 15\r\nKPX r uogonek 15\r\nKPX r uring 15\r\nKPX r v 30\r\nKPX r y 30\r\nKPX r yacute 30\r\nKPX r ydieresis 30\r\nKPX racute a -10\r\nKPX racute aacute -10\r\nKPX racute abreve -10\r\nKPX racute acircumflex -10\r\nKPX racute adieresis -10\r\nKPX racute agrave -10\r\nKPX racute amacron -10\r\nKPX racute aogonek -10\r\nKPX racute aring -10\r\nKPX racute atilde -10\r\nKPX racute colon 30\r\nKPX racute comma -50\r\nKPX racute i 15\r\nKPX racute iacute 15\r\nKPX racute icircumflex 15\r\nKPX racute idieresis 15\r\nKPX racute igrave 15\r\nKPX racute imacron 15\r\nKPX racute iogonek 15\r\nKPX racute k 15\r\nKPX racute kcommaaccent 15\r\nKPX racute l 15\r\nKPX racute lacute 15\r\nKPX racute lcommaaccent 15\r\nKPX racute lslash 15\r\nKPX racute m 25\r\nKPX racute n 25\r\nKPX racute nacute 25\r\nKPX racute ncaron 25\r\nKPX racute ncommaaccent 25\r\nKPX racute ntilde 25\r\nKPX racute p 30\r\nKPX racute period -50\r\nKPX racute semicolon 30\r\nKPX racute t 40\r\nKPX racute tcommaaccent 40\r\nKPX racute u 15\r\nKPX racute uacute 15\r\nKPX racute ucircumflex 15\r\nKPX racute udieresis 15\r\nKPX racute ugrave 15\r\nKPX racute uhungarumlaut 15\r\nKPX racute umacron 15\r\nKPX racute uogonek 15\r\nKPX racute uring 15\r\nKPX racute v 30\r\nKPX racute y 30\r\nKPX racute yacute 30\r\nKPX racute ydieresis 30\r\nKPX rcaron a -10\r\nKPX rcaron aacute -10\r\nKPX rcaron abreve -10\r\nKPX rcaron acircumflex -10\r\nKPX rcaron adieresis -10\r\nKPX rcaron agrave -10\r\nKPX rcaron amacron -10\r\nKPX rcaron aogonek -10\r\nKPX rcaron aring -10\r\nKPX rcaron atilde -10\r\nKPX rcaron colon 30\r\nKPX rcaron comma -50\r\nKPX rcaron i 15\r\nKPX rcaron iacute 15\r\nKPX rcaron icircumflex 15\r\nKPX rcaron idieresis 15\r\nKPX rcaron igrave 15\r\nKPX rcaron imacron 15\r\nKPX rcaron iogonek 15\r\nKPX rcaron k 15\r\nKPX rcaron kcommaaccent 15\r\nKPX rcaron l 15\r\nKPX rcaron lacute 15\r\nKPX rcaron lcommaaccent 15\r\nKPX rcaron lslash 15\r\nKPX rcaron m 25\r\nKPX rcaron n 25\r\nKPX rcaron nacute 25\r\nKPX rcaron ncaron 25\r\nKPX rcaron ncommaaccent 25\r\nKPX rcaron ntilde 25\r\nKPX rcaron p 30\r\nKPX rcaron period -50\r\nKPX rcaron semicolon 30\r\nKPX rcaron t 40\r\nKPX rcaron tcommaaccent 40\r\nKPX rcaron u 15\r\nKPX rcaron uacute 15\r\nKPX rcaron ucircumflex 15\r\nKPX rcaron udieresis 15\r\nKPX rcaron ugrave 15\r\nKPX rcaron uhungarumlaut 15\r\nKPX rcaron umacron 15\r\nKPX rcaron uogonek 15\r\nKPX rcaron uring 15\r\nKPX rcaron v 30\r\nKPX rcaron y 30\r\nKPX rcaron yacute 30\r\nKPX rcaron ydieresis 30\r\nKPX rcommaaccent a -10\r\nKPX rcommaaccent aacute -10\r\nKPX rcommaaccent abreve -10\r\nKPX rcommaaccent acircumflex -10\r\nKPX rcommaaccent adieresis -10\r\nKPX rcommaaccent agrave -10\r\nKPX rcommaaccent amacron -10\r\nKPX rcommaaccent aogonek -10\r\nKPX rcommaaccent aring -10\r\nKPX rcommaaccent atilde -10\r\nKPX rcommaaccent colon 30\r\nKPX rcommaaccent comma -50\r\nKPX rcommaaccent i 15\r\nKPX rcommaaccent iacute 15\r\nKPX rcommaaccent icircumflex 15\r\nKPX rcommaaccent idieresis 15\r\nKPX rcommaaccent igrave 15\r\nKPX rcommaaccent imacron 15\r\nKPX rcommaaccent iogonek 15\r\nKPX rcommaaccent k 15\r\nKPX rcommaaccent kcommaaccent 15\r\nKPX rcommaaccent l 15\r\nKPX rcommaaccent lacute 15\r\nKPX rcommaaccent lcommaaccent 15\r\nKPX rcommaaccent lslash 15\r\nKPX rcommaaccent m 25\r\nKPX rcommaaccent n 25\r\nKPX rcommaaccent nacute 25\r\nKPX rcommaaccent ncaron 25\r\nKPX rcommaaccent ncommaaccent 25\r\nKPX rcommaaccent ntilde 25\r\nKPX rcommaaccent p 30\r\nKPX rcommaaccent period -50\r\nKPX rcommaaccent semicolon 30\r\nKPX rcommaaccent t 40\r\nKPX rcommaaccent tcommaaccent 40\r\nKPX rcommaaccent u 15\r\nKPX rcommaaccent uacute 15\r\nKPX rcommaaccent ucircumflex 15\r\nKPX rcommaaccent udieresis 15\r\nKPX rcommaaccent ugrave 15\r\nKPX rcommaaccent uhungarumlaut 15\r\nKPX rcommaaccent umacron 15\r\nKPX rcommaaccent uogonek 15\r\nKPX rcommaaccent uring 15\r\nKPX rcommaaccent v 30\r\nKPX rcommaaccent y 30\r\nKPX rcommaaccent yacute 30\r\nKPX rcommaaccent ydieresis 30\r\nKPX s comma -15\r\nKPX s period -15\r\nKPX s w -30\r\nKPX sacute comma -15\r\nKPX sacute period -15\r\nKPX sacute w -30\r\nKPX scaron comma -15\r\nKPX scaron period -15\r\nKPX scaron w -30\r\nKPX scedilla comma -15\r\nKPX scedilla period -15\r\nKPX scedilla w -30\r\nKPX scommaaccent comma -15\r\nKPX scommaaccent period -15\r\nKPX scommaaccent w -30\r\nKPX semicolon space -50\r\nKPX space T -50\r\nKPX space Tcaron -50\r\nKPX space Tcommaaccent -50\r\nKPX space V -50\r\nKPX space W -40\r\nKPX space Y -90\r\nKPX space Yacute -90\r\nKPX space Ydieresis -90\r\nKPX space quotedblleft -30\r\nKPX space quoteleft -60\r\nKPX v a -25\r\nKPX v aacute -25\r\nKPX v abreve -25\r\nKPX v acircumflex -25\r\nKPX v adieresis -25\r\nKPX v agrave -25\r\nKPX v amacron -25\r\nKPX v aogonek -25\r\nKPX v aring -25\r\nKPX v atilde -25\r\nKPX v comma -80\r\nKPX v e -25\r\nKPX v eacute -25\r\nKPX v ecaron -25\r\nKPX v ecircumflex -25\r\nKPX v edieresis -25\r\nKPX v edotaccent -25\r\nKPX v egrave -25\r\nKPX v emacron -25\r\nKPX v eogonek -25\r\nKPX v o -25\r\nKPX v oacute -25\r\nKPX v ocircumflex -25\r\nKPX v odieresis -25\r\nKPX v ograve -25\r\nKPX v ohungarumlaut -25\r\nKPX v omacron -25\r\nKPX v oslash -25\r\nKPX v otilde -25\r\nKPX v period -80\r\nKPX w a -15\r\nKPX w aacute -15\r\nKPX w abreve -15\r\nKPX w acircumflex -15\r\nKPX w adieresis -15\r\nKPX w agrave -15\r\nKPX w amacron -15\r\nKPX w aogonek -15\r\nKPX w aring -15\r\nKPX w atilde -15\r\nKPX w comma -60\r\nKPX w e -10\r\nKPX w eacute -10\r\nKPX w ecaron -10\r\nKPX w ecircumflex -10\r\nKPX w edieresis -10\r\nKPX w edotaccent -10\r\nKPX w egrave -10\r\nKPX w emacron -10\r\nKPX w eogonek -10\r\nKPX w o -10\r\nKPX w oacute -10\r\nKPX w ocircumflex -10\r\nKPX w odieresis -10\r\nKPX w ograve -10\r\nKPX w ohungarumlaut -10\r\nKPX w omacron -10\r\nKPX w oslash -10\r\nKPX w otilde -10\r\nKPX w period -60\r\nKPX x e -30\r\nKPX x eacute -30\r\nKPX x ecaron -30\r\nKPX x ecircumflex -30\r\nKPX x edieresis -30\r\nKPX x edotaccent -30\r\nKPX x egrave -30\r\nKPX x emacron -30\r\nKPX x eogonek -30\r\nKPX y a -20\r\nKPX y aacute -20\r\nKPX y abreve -20\r\nKPX y acircumflex -20\r\nKPX y adieresis -20\r\nKPX y agrave -20\r\nKPX y amacron -20\r\nKPX y aogonek -20\r\nKPX y aring -20\r\nKPX y atilde -20\r\nKPX y comma -100\r\nKPX y e -20\r\nKPX y eacute -20\r\nKPX y ecaron -20\r\nKPX y ecircumflex -20\r\nKPX y edieresis -20\r\nKPX y edotaccent -20\r\nKPX y egrave -20\r\nKPX y emacron -20\r\nKPX y eogonek -20\r\nKPX y o -20\r\nKPX y oacute -20\r\nKPX y ocircumflex -20\r\nKPX y odieresis -20\r\nKPX y ograve -20\r\nKPX y ohungarumlaut -20\r\nKPX y omacron -20\r\nKPX y oslash -20\r\nKPX y otilde -20\r\nKPX y period -100\r\nKPX yacute a -20\r\nKPX yacute aacute -20\r\nKPX yacute abreve -20\r\nKPX yacute acircumflex -20\r\nKPX yacute adieresis -20\r\nKPX yacute agrave -20\r\nKPX yacute amacron -20\r\nKPX yacute aogonek -20\r\nKPX yacute aring -20\r\nKPX yacute atilde -20\r\nKPX yacute comma -100\r\nKPX yacute e -20\r\nKPX yacute eacute -20\r\nKPX yacute ecaron -20\r\nKPX yacute ecircumflex -20\r\nKPX yacute edieresis -20\r\nKPX yacute edotaccent -20\r\nKPX yacute egrave -20\r\nKPX yacute emacron -20\r\nKPX yacute eogonek -20\r\nKPX yacute o -20\r\nKPX yacute oacute -20\r\nKPX yacute ocircumflex -20\r\nKPX yacute odieresis -20\r\nKPX yacute ograve -20\r\nKPX yacute ohungarumlaut -20\r\nKPX yacute omacron -20\r\nKPX yacute oslash -20\r\nKPX yacute otilde -20\r\nKPX yacute period -100\r\nKPX ydieresis a -20\r\nKPX ydieresis aacute -20\r\nKPX ydieresis abreve -20\r\nKPX ydieresis acircumflex -20\r\nKPX ydieresis adieresis -20\r\nKPX ydieresis agrave -20\r\nKPX ydieresis amacron -20\r\nKPX ydieresis aogonek -20\r\nKPX ydieresis aring -20\r\nKPX ydieresis atilde -20\r\nKPX ydieresis comma -100\r\nKPX ydieresis e -20\r\nKPX ydieresis eacute -20\r\nKPX ydieresis ecaron -20\r\nKPX ydieresis ecircumflex -20\r\nKPX ydieresis edieresis -20\r\nKPX ydieresis edotaccent -20\r\nKPX ydieresis egrave -20\r\nKPX ydieresis emacron -20\r\nKPX ydieresis eogonek -20\r\nKPX ydieresis o -20\r\nKPX ydieresis oacute -20\r\nKPX ydieresis ocircumflex -20\r\nKPX ydieresis odieresis -20\r\nKPX ydieresis ograve -20\r\nKPX ydieresis ohungarumlaut -20\r\nKPX ydieresis omacron -20\r\nKPX ydieresis oslash -20\r\nKPX ydieresis otilde -20\r\nKPX ydieresis period -100\r\nKPX z e -15\r\nKPX z eacute -15\r\nKPX z ecaron -15\r\nKPX z ecircumflex -15\r\nKPX z edieresis -15\r\nKPX z edotaccent -15\r\nKPX z egrave -15\r\nKPX z emacron -15\r\nKPX z eogonek -15\r\nKPX z o -15\r\nKPX z oacute -15\r\nKPX z ocircumflex -15\r\nKPX z odieresis -15\r\nKPX z ograve -15\r\nKPX z ohungarumlaut -15\r\nKPX z omacron -15\r\nKPX z oslash -15\r\nKPX z otilde -15\r\nKPX zacute e -15\r\nKPX zacute eacute -15\r\nKPX zacute ecaron -15\r\nKPX zacute ecircumflex -15\r\nKPX zacute edieresis -15\r\nKPX zacute edotaccent -15\r\nKPX zacute egrave -15\r\nKPX zacute emacron -15\r\nKPX zacute eogonek -15\r\nKPX zacute o -15\r\nKPX zacute oacute -15\r\nKPX zacute ocircumflex -15\r\nKPX zacute odieresis -15\r\nKPX zacute ograve -15\r\nKPX zacute ohungarumlaut -15\r\nKPX zacute omacron -15\r\nKPX zacute oslash -15\r\nKPX zacute otilde -15\r\nKPX zcaron e -15\r\nKPX zcaron eacute -15\r\nKPX zcaron ecaron -15\r\nKPX zcaron ecircumflex -15\r\nKPX zcaron edieresis -15\r\nKPX zcaron edotaccent -15\r\nKPX zcaron egrave -15\r\nKPX zcaron emacron -15\r\nKPX zcaron eogonek -15\r\nKPX zcaron o -15\r\nKPX zcaron oacute -15\r\nKPX zcaron ocircumflex -15\r\nKPX zcaron odieresis -15\r\nKPX zcaron ograve -15\r\nKPX zcaron ohungarumlaut -15\r\nKPX zcaron omacron -15\r\nKPX zcaron oslash -15\r\nKPX zcaron otilde -15\r\nKPX zdotaccent e -15\r\nKPX zdotaccent eacute -15\r\nKPX zdotaccent ecaron -15\r\nKPX zdotaccent ecircumflex -15\r\nKPX zdotaccent edieresis -15\r\nKPX zdotaccent edotaccent -15\r\nKPX zdotaccent egrave -15\r\nKPX zdotaccent emacron -15\r\nKPX zdotaccent eogonek -15\r\nKPX zdotaccent o -15\r\nKPX zdotaccent oacute -15\r\nKPX zdotaccent ocircumflex -15\r\nKPX zdotaccent odieresis -15\r\nKPX zdotaccent ograve -15\r\nKPX zdotaccent ohungarumlaut -15\r\nKPX zdotaccent omacron -15\r\nKPX zdotaccent oslash -15\r\nKPX zdotaccent otilde -15\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Helvetica-BoldOblique"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:45:12 1997\r\nComment UniqueID 43053\r\nComment VMusage 14482 68586\r\nFontName Helvetica-BoldOblique\r\nFullName Helvetica Bold Oblique\r\nFamilyName Helvetica\r\nWeight Bold\r\nItalicAngle -12\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -174 -228 1114 962 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 718\r\nXHeight 532\r\nAscender 718\r\nDescender -207\r\nStdHW 118\r\nStdVW 140\r\nStartCharMetrics 315\r\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 94 0 397 718 ;\r\nC 34 ; WX 474 ; N quotedbl ; B 193 447 529 718 ;\r\nC 35 ; WX 556 ; N numbersign ; B 60 0 644 698 ;\r\nC 36 ; WX 556 ; N dollar ; B 67 -115 622 775 ;\r\nC 37 ; WX 889 ; N percent ; B 136 -19 901 710 ;\r\nC 38 ; WX 722 ; N ampersand ; B 89 -19 732 718 ;\r\nC 39 ; WX 278 ; N quoteright ; B 167 445 362 718 ;\r\nC 40 ; WX 333 ; N parenleft ; B 76 -208 470 734 ;\r\nC 41 ; WX 333 ; N parenright ; B -25 -208 369 734 ;\r\nC 42 ; WX 389 ; N asterisk ; B 146 387 481 718 ;\r\nC 43 ; WX 584 ; N plus ; B 82 0 610 506 ;\r\nC 44 ; WX 278 ; N comma ; B 28 -168 245 146 ;\r\nC 45 ; WX 333 ; N hyphen ; B 73 215 379 345 ;\r\nC 46 ; WX 278 ; N period ; B 64 0 245 146 ;\r\nC 47 ; WX 278 ; N slash ; B -37 -19 468 737 ;\r\nC 48 ; WX 556 ; N zero ; B 86 -19 617 710 ;\r\nC 49 ; WX 556 ; N one ; B 173 0 529 710 ;\r\nC 50 ; WX 556 ; N two ; B 26 0 619 710 ;\r\nC 51 ; WX 556 ; N three ; B 65 -19 608 710 ;\r\nC 52 ; WX 556 ; N four ; B 60 0 598 710 ;\r\nC 53 ; WX 556 ; N five ; B 64 -19 636 698 ;\r\nC 54 ; WX 556 ; N six ; B 85 -19 619 710 ;\r\nC 55 ; WX 556 ; N seven ; B 125 0 676 698 ;\r\nC 56 ; WX 556 ; N eight ; B 69 -19 616 710 ;\r\nC 57 ; WX 556 ; N nine ; B 78 -19 615 710 ;\r\nC 58 ; WX 333 ; N colon ; B 92 0 351 512 ;\r\nC 59 ; WX 333 ; N semicolon ; B 56 -168 351 512 ;\r\nC 60 ; WX 584 ; N less ; B 82 -8 655 514 ;\r\nC 61 ; WX 584 ; N equal ; B 58 87 633 419 ;\r\nC 62 ; WX 584 ; N greater ; B 36 -8 609 514 ;\r\nC 63 ; WX 611 ; N question ; B 165 0 671 727 ;\r\nC 64 ; WX 975 ; N at ; B 186 -19 954 737 ;\r\nC 65 ; WX 722 ; N A ; B 20 0 702 718 ;\r\nC 66 ; WX 722 ; N B ; B 76 0 764 718 ;\r\nC 67 ; WX 722 ; N C ; B 107 -19 789 737 ;\r\nC 68 ; WX 722 ; N D ; B 76 0 777 718 ;\r\nC 69 ; WX 667 ; N E ; B 76 0 757 718 ;\r\nC 70 ; WX 611 ; N F ; B 76 0 740 718 ;\r\nC 71 ; WX 778 ; N G ; B 108 -19 817 737 ;\r\nC 72 ; WX 722 ; N H ; B 71 0 804 718 ;\r\nC 73 ; WX 278 ; N I ; B 64 0 367 718 ;\r\nC 74 ; WX 556 ; N J ; B 60 -18 637 718 ;\r\nC 75 ; WX 722 ; N K ; B 87 0 858 718 ;\r\nC 76 ; WX 611 ; N L ; B 76 0 611 718 ;\r\nC 77 ; WX 833 ; N M ; B 69 0 918 718 ;\r\nC 78 ; WX 722 ; N N ; B 69 0 807 718 ;\r\nC 79 ; WX 778 ; N O ; B 107 -19 823 737 ;\r\nC 80 ; WX 667 ; N P ; B 76 0 738 718 ;\r\nC 81 ; WX 778 ; N Q ; B 107 -52 823 737 ;\r\nC 82 ; WX 722 ; N R ; B 76 0 778 718 ;\r\nC 83 ; WX 667 ; N S ; B 81 -19 718 737 ;\r\nC 84 ; WX 611 ; N T ; B 140 0 751 718 ;\r\nC 85 ; WX 722 ; N U ; B 116 -19 804 718 ;\r\nC 86 ; WX 667 ; N V ; B 172 0 801 718 ;\r\nC 87 ; WX 944 ; N W ; B 169 0 1082 718 ;\r\nC 88 ; WX 667 ; N X ; B 14 0 791 718 ;\r\nC 89 ; WX 667 ; N Y ; B 168 0 806 718 ;\r\nC 90 ; WX 611 ; N Z ; B 25 0 737 718 ;\r\nC 91 ; WX 333 ; N bracketleft ; B 21 -196 462 722 ;\r\nC 92 ; WX 278 ; N backslash ; B 124 -19 307 737 ;\r\nC 93 ; WX 333 ; N bracketright ; B -18 -196 423 722 ;\r\nC 94 ; WX 584 ; N asciicircum ; B 131 323 591 698 ;\r\nC 95 ; WX 556 ; N underscore ; B -27 -125 540 -75 ;\r\nC 96 ; WX 278 ; N quoteleft ; B 165 454 361 727 ;\r\nC 97 ; WX 556 ; N a ; B 55 -14 583 546 ;\r\nC 98 ; WX 611 ; N b ; B 61 -14 645 718 ;\r\nC 99 ; WX 556 ; N c ; B 79 -14 599 546 ;\r\nC 100 ; WX 611 ; N d ; B 82 -14 704 718 ;\r\nC 101 ; WX 556 ; N e ; B 70 -14 593 546 ;\r\nC 102 ; WX 333 ; N f ; B 87 0 469 727 ; L i fi ; L l fl ;\r\nC 103 ; WX 611 ; N g ; B 38 -217 666 546 ;\r\nC 104 ; WX 611 ; N h ; B 65 0 629 718 ;\r\nC 105 ; WX 278 ; N i ; B 69 0 363 725 ;\r\nC 106 ; WX 278 ; N j ; B -42 -214 363 725 ;\r\nC 107 ; WX 556 ; N k ; B 69 0 670 718 ;\r\nC 108 ; WX 278 ; N l ; B 69 0 362 718 ;\r\nC 109 ; WX 889 ; N m ; B 64 0 909 546 ;\r\nC 110 ; WX 611 ; N n ; B 65 0 629 546 ;\r\nC 111 ; WX 611 ; N o ; B 82 -14 643 546 ;\r\nC 112 ; WX 611 ; N p ; B 18 -207 645 546 ;\r\nC 113 ; WX 611 ; N q ; B 80 -207 665 546 ;\r\nC 114 ; WX 389 ; N r ; B 64 0 489 546 ;\r\nC 115 ; WX 556 ; N s ; B 63 -14 584 546 ;\r\nC 116 ; WX 333 ; N t ; B 100 -6 422 676 ;\r\nC 117 ; WX 611 ; N u ; B 98 -14 658 532 ;\r\nC 118 ; WX 556 ; N v ; B 126 0 656 532 ;\r\nC 119 ; WX 778 ; N w ; B 123 0 882 532 ;\r\nC 120 ; WX 556 ; N x ; B 15 0 648 532 ;\r\nC 121 ; WX 556 ; N y ; B 42 -214 652 532 ;\r\nC 122 ; WX 500 ; N z ; B 20 0 583 532 ;\r\nC 123 ; WX 389 ; N braceleft ; B 94 -196 518 722 ;\r\nC 124 ; WX 280 ; N bar ; B 36 -225 361 775 ;\r\nC 125 ; WX 389 ; N braceright ; B -18 -196 407 722 ;\r\nC 126 ; WX 584 ; N asciitilde ; B 115 163 577 343 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 50 -186 353 532 ;\r\nC 162 ; WX 556 ; N cent ; B 79 -118 599 628 ;\r\nC 163 ; WX 556 ; N sterling ; B 50 -16 635 718 ;\r\nC 164 ; WX 167 ; N fraction ; B -174 -19 487 710 ;\r\nC 165 ; WX 556 ; N yen ; B 60 0 713 698 ;\r\nC 166 ; WX 556 ; N florin ; B -50 -210 669 737 ;\r\nC 167 ; WX 556 ; N section ; B 61 -184 598 727 ;\r\nC 168 ; WX 556 ; N currency ; B 27 76 680 636 ;\r\nC 169 ; WX 238 ; N quotesingle ; B 165 447 321 718 ;\r\nC 170 ; WX 500 ; N quotedblleft ; B 160 454 588 727 ;\r\nC 171 ; WX 556 ; N guillemotleft ; B 135 76 571 484 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 130 76 353 484 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 99 76 322 484 ;\r\nC 174 ; WX 611 ; N fi ; B 87 0 696 727 ;\r\nC 175 ; WX 611 ; N fl ; B 87 0 695 727 ;\r\nC 177 ; WX 556 ; N endash ; B 48 227 627 333 ;\r\nC 178 ; WX 556 ; N dagger ; B 118 -171 626 718 ;\r\nC 179 ; WX 556 ; N daggerdbl ; B 46 -171 628 718 ;\r\nC 180 ; WX 278 ; N periodcentered ; B 110 172 276 334 ;\r\nC 182 ; WX 556 ; N paragraph ; B 98 -191 688 700 ;\r\nC 183 ; WX 350 ; N bullet ; B 83 194 420 524 ;\r\nC 184 ; WX 278 ; N quotesinglbase ; B 41 -146 236 127 ;\r\nC 185 ; WX 500 ; N quotedblbase ; B 36 -146 463 127 ;\r\nC 186 ; WX 500 ; N quotedblright ; B 162 445 589 718 ;\r\nC 187 ; WX 556 ; N guillemotright ; B 104 76 540 484 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 92 0 939 146 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 76 -19 1038 710 ;\r\nC 191 ; WX 611 ; N questiondown ; B 53 -195 559 532 ;\r\nC 193 ; WX 333 ; N grave ; B 136 604 353 750 ;\r\nC 194 ; WX 333 ; N acute ; B 236 604 515 750 ;\r\nC 195 ; WX 333 ; N circumflex ; B 118 604 471 750 ;\r\nC 196 ; WX 333 ; N tilde ; B 113 610 507 737 ;\r\nC 197 ; WX 333 ; N macron ; B 122 604 483 678 ;\r\nC 198 ; WX 333 ; N breve ; B 156 604 494 750 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 235 614 385 729 ;\r\nC 200 ; WX 333 ; N dieresis ; B 137 614 482 729 ;\r\nC 202 ; WX 333 ; N ring ; B 200 568 420 776 ;\r\nC 203 ; WX 333 ; N cedilla ; B -37 -228 220 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 137 604 645 750 ;\r\nC 206 ; WX 333 ; N ogonek ; B 41 -228 264 0 ;\r\nC 207 ; WX 333 ; N caron ; B 149 604 502 750 ;\r\nC 208 ; WX 1000 ; N emdash ; B 48 227 1071 333 ;\r\nC 225 ; WX 1000 ; N AE ; B 5 0 1100 718 ;\r\nC 227 ; WX 370 ; N ordfeminine ; B 125 401 465 737 ;\r\nC 232 ; WX 611 ; N Lslash ; B 34 0 611 718 ;\r\nC 233 ; WX 778 ; N Oslash ; B 35 -27 894 745 ;\r\nC 234 ; WX 1000 ; N OE ; B 99 -19 1114 737 ;\r\nC 235 ; WX 365 ; N ordmasculine ; B 123 401 485 737 ;\r\nC 241 ; WX 889 ; N ae ; B 56 -14 923 546 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 69 0 322 532 ;\r\nC 248 ; WX 278 ; N lslash ; B 40 0 407 718 ;\r\nC 249 ; WX 611 ; N oslash ; B 22 -29 701 560 ;\r\nC 250 ; WX 944 ; N oe ; B 82 -14 977 546 ;\r\nC 251 ; WX 611 ; N germandbls ; B 69 -14 657 731 ;\r\nC -1 ; WX 278 ; N Idieresis ; B 64 0 494 915 ;\r\nC -1 ; WX 556 ; N eacute ; B 70 -14 627 750 ;\r\nC -1 ; WX 556 ; N abreve ; B 55 -14 606 750 ;\r\nC -1 ; WX 611 ; N uhungarumlaut ; B 98 -14 784 750 ;\r\nC -1 ; WX 556 ; N ecaron ; B 70 -14 614 750 ;\r\nC -1 ; WX 667 ; N Ydieresis ; B 168 0 806 915 ;\r\nC -1 ; WX 584 ; N divide ; B 82 -42 610 548 ;\r\nC -1 ; WX 667 ; N Yacute ; B 168 0 806 936 ;\r\nC -1 ; WX 722 ; N Acircumflex ; B 20 0 706 936 ;\r\nC -1 ; WX 556 ; N aacute ; B 55 -14 627 750 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 116 -19 804 936 ;\r\nC -1 ; WX 556 ; N yacute ; B 42 -214 652 750 ;\r\nC -1 ; WX 556 ; N scommaaccent ; B 63 -228 584 546 ;\r\nC -1 ; WX 556 ; N ecircumflex ; B 70 -14 593 750 ;\r\nC -1 ; WX 722 ; N Uring ; B 116 -19 804 962 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 116 -19 804 915 ;\r\nC -1 ; WX 556 ; N aogonek ; B 55 -224 583 546 ;\r\nC -1 ; WX 722 ; N Uacute ; B 116 -19 804 936 ;\r\nC -1 ; WX 611 ; N uogonek ; B 98 -228 658 532 ;\r\nC -1 ; WX 667 ; N Edieresis ; B 76 0 757 915 ;\r\nC -1 ; WX 722 ; N Dcroat ; B 62 0 777 718 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 16 -228 188 -50 ;\r\nC -1 ; WX 737 ; N copyright ; B 56 -19 835 737 ;\r\nC -1 ; WX 667 ; N Emacron ; B 76 0 757 864 ;\r\nC -1 ; WX 556 ; N ccaron ; B 79 -14 614 750 ;\r\nC -1 ; WX 556 ; N aring ; B 55 -14 583 776 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 69 -228 807 718 ;\r\nC -1 ; WX 278 ; N lacute ; B 69 0 528 936 ;\r\nC -1 ; WX 556 ; N agrave ; B 55 -14 583 750 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 140 -228 751 718 ;\r\nC -1 ; WX 722 ; N Cacute ; B 107 -19 789 936 ;\r\nC -1 ; WX 556 ; N atilde ; B 55 -14 619 737 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B 76 0 757 915 ;\r\nC -1 ; WX 556 ; N scaron ; B 63 -14 614 750 ;\r\nC -1 ; WX 556 ; N scedilla ; B 63 -228 584 546 ;\r\nC -1 ; WX 278 ; N iacute ; B 69 0 488 750 ;\r\nC -1 ; WX 494 ; N lozenge ; B 90 0 564 745 ;\r\nC -1 ; WX 722 ; N Rcaron ; B 76 0 778 936 ;\r\nC -1 ; WX 778 ; N Gcommaaccent ; B 108 -228 817 737 ;\r\nC -1 ; WX 611 ; N ucircumflex ; B 98 -14 658 750 ;\r\nC -1 ; WX 556 ; N acircumflex ; B 55 -14 583 750 ;\r\nC -1 ; WX 722 ; N Amacron ; B 20 0 718 864 ;\r\nC -1 ; WX 389 ; N rcaron ; B 64 0 530 750 ;\r\nC -1 ; WX 556 ; N ccedilla ; B 79 -228 599 546 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B 25 0 737 915 ;\r\nC -1 ; WX 667 ; N Thorn ; B 76 0 716 718 ;\r\nC -1 ; WX 778 ; N Omacron ; B 107 -19 823 864 ;\r\nC -1 ; WX 722 ; N Racute ; B 76 0 778 936 ;\r\nC -1 ; WX 667 ; N Sacute ; B 81 -19 722 936 ;\r\nC -1 ; WX 743 ; N dcaron ; B 82 -14 903 718 ;\r\nC -1 ; WX 722 ; N Umacron ; B 116 -19 804 864 ;\r\nC -1 ; WX 611 ; N uring ; B 98 -14 658 776 ;\r\nC -1 ; WX 333 ; N threesuperior ; B 91 271 441 710 ;\r\nC -1 ; WX 778 ; N Ograve ; B 107 -19 823 936 ;\r\nC -1 ; WX 722 ; N Agrave ; B 20 0 702 936 ;\r\nC -1 ; WX 722 ; N Abreve ; B 20 0 729 936 ;\r\nC -1 ; WX 584 ; N multiply ; B 57 1 635 505 ;\r\nC -1 ; WX 611 ; N uacute ; B 98 -14 658 750 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 140 0 751 936 ;\r\nC -1 ; WX 494 ; N partialdiff ; B 43 -21 585 750 ;\r\nC -1 ; WX 556 ; N ydieresis ; B 42 -214 652 729 ;\r\nC -1 ; WX 722 ; N Nacute ; B 69 0 807 936 ;\r\nC -1 ; WX 278 ; N icircumflex ; B 69 0 444 750 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B 76 0 757 936 ;\r\nC -1 ; WX 556 ; N adieresis ; B 55 -14 594 729 ;\r\nC -1 ; WX 556 ; N edieresis ; B 70 -14 594 729 ;\r\nC -1 ; WX 556 ; N cacute ; B 79 -14 627 750 ;\r\nC -1 ; WX 611 ; N nacute ; B 65 0 654 750 ;\r\nC -1 ; WX 611 ; N umacron ; B 98 -14 658 678 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 69 0 807 936 ;\r\nC -1 ; WX 278 ; N Iacute ; B 64 0 528 936 ;\r\nC -1 ; WX 584 ; N plusminus ; B 40 0 625 506 ;\r\nC -1 ; WX 280 ; N brokenbar ; B 52 -150 345 700 ;\r\nC -1 ; WX 737 ; N registered ; B 55 -19 834 737 ;\r\nC -1 ; WX 778 ; N Gbreve ; B 108 -19 817 936 ;\r\nC -1 ; WX 278 ; N Idotaccent ; B 64 0 397 915 ;\r\nC -1 ; WX 600 ; N summation ; B 14 -10 670 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B 76 0 757 936 ;\r\nC -1 ; WX 389 ; N racute ; B 64 0 543 750 ;\r\nC -1 ; WX 611 ; N omacron ; B 82 -14 643 678 ;\r\nC -1 ; WX 611 ; N Zacute ; B 25 0 737 936 ;\r\nC -1 ; WX 611 ; N Zcaron ; B 25 0 737 936 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 629 704 ;\r\nC -1 ; WX 722 ; N Eth ; B 62 0 777 718 ;\r\nC -1 ; WX 722 ; N Ccedilla ; B 107 -228 789 737 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B 30 -228 362 718 ;\r\nC -1 ; WX 389 ; N tcaron ; B 100 -6 608 878 ;\r\nC -1 ; WX 556 ; N eogonek ; B 70 -228 593 546 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 116 -228 804 718 ;\r\nC -1 ; WX 722 ; N Aacute ; B 20 0 750 936 ;\r\nC -1 ; WX 722 ; N Adieresis ; B 20 0 716 915 ;\r\nC -1 ; WX 556 ; N egrave ; B 70 -14 593 750 ;\r\nC -1 ; WX 500 ; N zacute ; B 20 0 599 750 ;\r\nC -1 ; WX 278 ; N iogonek ; B -14 -224 363 725 ;\r\nC -1 ; WX 778 ; N Oacute ; B 107 -19 823 936 ;\r\nC -1 ; WX 611 ; N oacute ; B 82 -14 654 750 ;\r\nC -1 ; WX 556 ; N amacron ; B 55 -14 595 678 ;\r\nC -1 ; WX 556 ; N sacute ; B 63 -14 627 750 ;\r\nC -1 ; WX 278 ; N idieresis ; B 69 0 455 729 ;\r\nC -1 ; WX 778 ; N Ocircumflex ; B 107 -19 823 936 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 116 -19 804 936 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 611 ; N thorn ; B 18 -208 645 718 ;\r\nC -1 ; WX 333 ; N twosuperior ; B 69 283 449 710 ;\r\nC -1 ; WX 778 ; N Odieresis ; B 107 -19 823 915 ;\r\nC -1 ; WX 611 ; N mu ; B 22 -207 658 532 ;\r\nC -1 ; WX 278 ; N igrave ; B 69 0 326 750 ;\r\nC -1 ; WX 611 ; N ohungarumlaut ; B 82 -14 784 750 ;\r\nC -1 ; WX 667 ; N Eogonek ; B 76 -224 757 718 ;\r\nC -1 ; WX 611 ; N dcroat ; B 82 -14 789 718 ;\r\nC -1 ; WX 834 ; N threequarters ; B 99 -19 839 710 ;\r\nC -1 ; WX 667 ; N Scedilla ; B 81 -228 718 737 ;\r\nC -1 ; WX 400 ; N lcaron ; B 69 0 561 718 ;\r\nC -1 ; WX 722 ; N Kcommaaccent ; B 87 -228 858 718 ;\r\nC -1 ; WX 611 ; N Lacute ; B 76 0 611 936 ;\r\nC -1 ; WX 1000 ; N trademark ; B 179 306 1109 718 ;\r\nC -1 ; WX 556 ; N edotaccent ; B 70 -14 593 729 ;\r\nC -1 ; WX 278 ; N Igrave ; B 64 0 367 936 ;\r\nC -1 ; WX 278 ; N Imacron ; B 64 0 496 864 ;\r\nC -1 ; WX 611 ; N Lcaron ; B 76 0 643 718 ;\r\nC -1 ; WX 834 ; N onehalf ; B 132 -19 858 710 ;\r\nC -1 ; WX 549 ; N lessequal ; B 29 0 676 704 ;\r\nC -1 ; WX 611 ; N ocircumflex ; B 82 -14 643 750 ;\r\nC -1 ; WX 611 ; N ntilde ; B 65 0 646 737 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 116 -19 880 936 ;\r\nC -1 ; WX 667 ; N Eacute ; B 76 0 757 936 ;\r\nC -1 ; WX 556 ; N emacron ; B 70 -14 595 678 ;\r\nC -1 ; WX 611 ; N gbreve ; B 38 -217 666 750 ;\r\nC -1 ; WX 834 ; N onequarter ; B 132 -19 806 710 ;\r\nC -1 ; WX 667 ; N Scaron ; B 81 -19 718 936 ;\r\nC -1 ; WX 667 ; N Scommaaccent ; B 81 -228 718 737 ;\r\nC -1 ; WX 778 ; N Ohungarumlaut ; B 107 -19 908 936 ;\r\nC -1 ; WX 400 ; N degree ; B 175 426 467 712 ;\r\nC -1 ; WX 611 ; N ograve ; B 82 -14 643 750 ;\r\nC -1 ; WX 722 ; N Ccaron ; B 107 -19 789 936 ;\r\nC -1 ; WX 611 ; N ugrave ; B 98 -14 658 750 ;\r\nC -1 ; WX 549 ; N radical ; B 112 -46 689 850 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 76 0 777 936 ;\r\nC -1 ; WX 389 ; N rcommaaccent ; B 26 -228 489 546 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 69 0 807 923 ;\r\nC -1 ; WX 611 ; N otilde ; B 82 -14 646 737 ;\r\nC -1 ; WX 722 ; N Rcommaaccent ; B 76 -228 778 718 ;\r\nC -1 ; WX 611 ; N Lcommaaccent ; B 76 -228 611 718 ;\r\nC -1 ; WX 722 ; N Atilde ; B 20 0 741 923 ;\r\nC -1 ; WX 722 ; N Aogonek ; B 20 -224 702 718 ;\r\nC -1 ; WX 722 ; N Aring ; B 20 0 702 962 ;\r\nC -1 ; WX 778 ; N Otilde ; B 107 -19 823 923 ;\r\nC -1 ; WX 500 ; N zdotaccent ; B 20 0 583 729 ;\r\nC -1 ; WX 667 ; N Ecaron ; B 76 0 757 936 ;\r\nC -1 ; WX 278 ; N Iogonek ; B -41 -228 367 718 ;\r\nC -1 ; WX 556 ; N kcommaaccent ; B 69 -228 670 718 ;\r\nC -1 ; WX 584 ; N minus ; B 82 197 610 309 ;\r\nC -1 ; WX 278 ; N Icircumflex ; B 64 0 484 936 ;\r\nC -1 ; WX 611 ; N ncaron ; B 65 0 641 750 ;\r\nC -1 ; WX 333 ; N tcommaaccent ; B 58 -228 422 676 ;\r\nC -1 ; WX 584 ; N logicalnot ; B 105 108 633 419 ;\r\nC -1 ; WX 611 ; N odieresis ; B 82 -14 643 729 ;\r\nC -1 ; WX 611 ; N udieresis ; B 98 -14 658 729 ;\r\nC -1 ; WX 549 ; N notequal ; B 32 -49 630 570 ;\r\nC -1 ; WX 611 ; N gcommaaccent ; B 38 -217 666 850 ;\r\nC -1 ; WX 611 ; N eth ; B 82 -14 670 737 ;\r\nC -1 ; WX 500 ; N zcaron ; B 20 0 586 750 ;\r\nC -1 ; WX 611 ; N ncommaaccent ; B 65 -228 629 546 ;\r\nC -1 ; WX 333 ; N onesuperior ; B 148 283 388 710 ;\r\nC -1 ; WX 278 ; N imacron ; B 69 0 429 678 ;\r\nC -1 ; WX 556 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2481\r\nKPX A C -40\r\nKPX A Cacute -40\r\nKPX A Ccaron -40\r\nKPX A Ccedilla -40\r\nKPX A G -50\r\nKPX A Gbreve -50\r\nKPX A Gcommaaccent -50\r\nKPX A O -40\r\nKPX A Oacute -40\r\nKPX A Ocircumflex -40\r\nKPX A Odieresis -40\r\nKPX A Ograve -40\r\nKPX A Ohungarumlaut -40\r\nKPX A Omacron -40\r\nKPX A Oslash -40\r\nKPX A Otilde -40\r\nKPX A Q -40\r\nKPX A T -90\r\nKPX A Tcaron -90\r\nKPX A Tcommaaccent -90\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -80\r\nKPX A W -60\r\nKPX A Y -110\r\nKPX A Yacute -110\r\nKPX A Ydieresis -110\r\nKPX A u -30\r\nKPX A uacute -30\r\nKPX A ucircumflex -30\r\nKPX A udieresis -30\r\nKPX A ugrave -30\r\nKPX A uhungarumlaut -30\r\nKPX A umacron -30\r\nKPX A uogonek -30\r\nKPX A uring -30\r\nKPX A v -40\r\nKPX A w -30\r\nKPX A y -30\r\nKPX A yacute -30\r\nKPX A ydieresis -30\r\nKPX Aacute C -40\r\nKPX Aacute Cacute -40\r\nKPX Aacute Ccaron -40\r\nKPX Aacute Ccedilla -40\r\nKPX Aacute G -50\r\nKPX Aacute Gbreve -50\r\nKPX Aacute Gcommaaccent -50\r\nKPX Aacute O -40\r\nKPX Aacute Oacute -40\r\nKPX Aacute Ocircumflex -40\r\nKPX Aacute Odieresis -40\r\nKPX Aacute Ograve -40\r\nKPX Aacute Ohungarumlaut -40\r\nKPX Aacute Omacron -40\r\nKPX Aacute Oslash -40\r\nKPX Aacute Otilde -40\r\nKPX Aacute Q -40\r\nKPX Aacute T -90\r\nKPX Aacute Tcaron -90\r\nKPX Aacute Tcommaaccent -90\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -80\r\nKPX Aacute W -60\r\nKPX Aacute Y -110\r\nKPX Aacute Yacute -110\r\nKPX Aacute Ydieresis -110\r\nKPX Aacute u -30\r\nKPX Aacute uacute -30\r\nKPX Aacute ucircumflex -30\r\nKPX Aacute udieresis -30\r\nKPX Aacute ugrave -30\r\nKPX Aacute uhungarumlaut -30\r\nKPX Aacute umacron -30\r\nKPX Aacute uogonek -30\r\nKPX Aacute uring -30\r\nKPX Aacute v -40\r\nKPX Aacute w -30\r\nKPX Aacute y -30\r\nKPX Aacute yacute -30\r\nKPX Aacute ydieresis -30\r\nKPX Abreve C -40\r\nKPX Abreve Cacute -40\r\nKPX Abreve Ccaron -40\r\nKPX Abreve Ccedilla -40\r\nKPX Abreve G -50\r\nKPX Abreve Gbreve -50\r\nKPX Abreve Gcommaaccent -50\r\nKPX Abreve O -40\r\nKPX Abreve Oacute -40\r\nKPX Abreve Ocircumflex -40\r\nKPX Abreve Odieresis -40\r\nKPX Abreve Ograve -40\r\nKPX Abreve Ohungarumlaut -40\r\nKPX Abreve Omacron -40\r\nKPX Abreve Oslash -40\r\nKPX Abreve Otilde -40\r\nKPX Abreve Q -40\r\nKPX Abreve T -90\r\nKPX Abreve Tcaron -90\r\nKPX Abreve Tcommaaccent -90\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -80\r\nKPX Abreve W -60\r\nKPX Abreve Y -110\r\nKPX Abreve Yacute -110\r\nKPX Abreve Ydieresis -110\r\nKPX Abreve u -30\r\nKPX Abreve uacute -30\r\nKPX Abreve ucircumflex -30\r\nKPX Abreve udieresis -30\r\nKPX Abreve ugrave -30\r\nKPX Abreve uhungarumlaut -30\r\nKPX Abreve umacron -30\r\nKPX Abreve uogonek -30\r\nKPX Abreve uring -30\r\nKPX Abreve v -40\r\nKPX Abreve w -30\r\nKPX Abreve y -30\r\nKPX Abreve yacute -30\r\nKPX Abreve ydieresis -30\r\nKPX Acircumflex C -40\r\nKPX Acircumflex Cacute -40\r\nKPX Acircumflex Ccaron -40\r\nKPX Acircumflex Ccedilla -40\r\nKPX Acircumflex G -50\r\nKPX Acircumflex Gbreve -50\r\nKPX Acircumflex Gcommaaccent -50\r\nKPX Acircumflex O -40\r\nKPX Acircumflex Oacute -40\r\nKPX Acircumflex Ocircumflex -40\r\nKPX Acircumflex Odieresis -40\r\nKPX Acircumflex Ograve -40\r\nKPX Acircumflex Ohungarumlaut -40\r\nKPX Acircumflex Omacron -40\r\nKPX Acircumflex Oslash -40\r\nKPX Acircumflex Otilde -40\r\nKPX Acircumflex Q -40\r\nKPX Acircumflex T -90\r\nKPX Acircumflex Tcaron -90\r\nKPX Acircumflex Tcommaaccent -90\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -80\r\nKPX Acircumflex W -60\r\nKPX Acircumflex Y -110\r\nKPX Acircumflex Yacute -110\r\nKPX Acircumflex Ydieresis -110\r\nKPX Acircumflex u -30\r\nKPX Acircumflex uacute -30\r\nKPX Acircumflex ucircumflex -30\r\nKPX Acircumflex udieresis -30\r\nKPX Acircumflex ugrave -30\r\nKPX Acircumflex uhungarumlaut -30\r\nKPX Acircumflex umacron -30\r\nKPX Acircumflex uogonek -30\r\nKPX Acircumflex uring -30\r\nKPX Acircumflex v -40\r\nKPX Acircumflex w -30\r\nKPX Acircumflex y -30\r\nKPX Acircumflex yacute -30\r\nKPX Acircumflex ydieresis -30\r\nKPX Adieresis C -40\r\nKPX Adieresis Cacute -40\r\nKPX Adieresis Ccaron -40\r\nKPX Adieresis Ccedilla -40\r\nKPX Adieresis G -50\r\nKPX Adieresis Gbreve -50\r\nKPX Adieresis Gcommaaccent -50\r\nKPX Adieresis O -40\r\nKPX Adieresis Oacute -40\r\nKPX Adieresis Ocircumflex -40\r\nKPX Adieresis Odieresis -40\r\nKPX Adieresis Ograve -40\r\nKPX Adieresis Ohungarumlaut -40\r\nKPX Adieresis Omacron -40\r\nKPX Adieresis Oslash -40\r\nKPX Adieresis Otilde -40\r\nKPX Adieresis Q -40\r\nKPX Adieresis T -90\r\nKPX Adieresis Tcaron -90\r\nKPX Adieresis Tcommaaccent -90\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -80\r\nKPX Adieresis W -60\r\nKPX Adieresis Y -110\r\nKPX Adieresis Yacute -110\r\nKPX Adieresis Ydieresis -110\r\nKPX Adieresis u -30\r\nKPX Adieresis uacute -30\r\nKPX Adieresis ucircumflex -30\r\nKPX Adieresis udieresis -30\r\nKPX Adieresis ugrave -30\r\nKPX Adieresis uhungarumlaut -30\r\nKPX Adieresis umacron -30\r\nKPX Adieresis uogonek -30\r\nKPX Adieresis uring -30\r\nKPX Adieresis v -40\r\nKPX Adieresis w -30\r\nKPX Adieresis y -30\r\nKPX Adieresis yacute -30\r\nKPX Adieresis ydieresis -30\r\nKPX Agrave C -40\r\nKPX Agrave Cacute -40\r\nKPX Agrave Ccaron -40\r\nKPX Agrave Ccedilla -40\r\nKPX Agrave G -50\r\nKPX Agrave Gbreve -50\r\nKPX Agrave Gcommaaccent -50\r\nKPX Agrave O -40\r\nKPX Agrave Oacute -40\r\nKPX Agrave Ocircumflex -40\r\nKPX Agrave Odieresis -40\r\nKPX Agrave Ograve -40\r\nKPX Agrave Ohungarumlaut -40\r\nKPX Agrave Omacron -40\r\nKPX Agrave Oslash -40\r\nKPX Agrave Otilde -40\r\nKPX Agrave Q -40\r\nKPX Agrave T -90\r\nKPX Agrave Tcaron -90\r\nKPX Agrave Tcommaaccent -90\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -80\r\nKPX Agrave W -60\r\nKPX Agrave Y -110\r\nKPX Agrave Yacute -110\r\nKPX Agrave Ydieresis -110\r\nKPX Agrave u -30\r\nKPX Agrave uacute -30\r\nKPX Agrave ucircumflex -30\r\nKPX Agrave udieresis -30\r\nKPX Agrave ugrave -30\r\nKPX Agrave uhungarumlaut -30\r\nKPX Agrave umacron -30\r\nKPX Agrave uogonek -30\r\nKPX Agrave uring -30\r\nKPX Agrave v -40\r\nKPX Agrave w -30\r\nKPX Agrave y -30\r\nKPX Agrave yacute -30\r\nKPX Agrave ydieresis -30\r\nKPX Amacron C -40\r\nKPX Amacron Cacute -40\r\nKPX Amacron Ccaron -40\r\nKPX Amacron Ccedilla -40\r\nKPX Amacron G -50\r\nKPX Amacron Gbreve -50\r\nKPX Amacron Gcommaaccent -50\r\nKPX Amacron O -40\r\nKPX Amacron Oacute -40\r\nKPX Amacron Ocircumflex -40\r\nKPX Amacron Odieresis -40\r\nKPX Amacron Ograve -40\r\nKPX Amacron Ohungarumlaut -40\r\nKPX Amacron Omacron -40\r\nKPX Amacron Oslash -40\r\nKPX Amacron Otilde -40\r\nKPX Amacron Q -40\r\nKPX Amacron T -90\r\nKPX Amacron Tcaron -90\r\nKPX Amacron Tcommaaccent -90\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -80\r\nKPX Amacron W -60\r\nKPX Amacron Y -110\r\nKPX Amacron Yacute -110\r\nKPX Amacron Ydieresis -110\r\nKPX Amacron u -30\r\nKPX Amacron uacute -30\r\nKPX Amacron ucircumflex -30\r\nKPX Amacron udieresis -30\r\nKPX Amacron ugrave -30\r\nKPX Amacron uhungarumlaut -30\r\nKPX Amacron umacron -30\r\nKPX Amacron uogonek -30\r\nKPX Amacron uring -30\r\nKPX Amacron v -40\r\nKPX Amacron w -30\r\nKPX Amacron y -30\r\nKPX Amacron yacute -30\r\nKPX Amacron ydieresis -30\r\nKPX Aogonek C -40\r\nKPX Aogonek Cacute -40\r\nKPX Aogonek Ccaron -40\r\nKPX Aogonek Ccedilla -40\r\nKPX Aogonek G -50\r\nKPX Aogonek Gbreve -50\r\nKPX Aogonek Gcommaaccent -50\r\nKPX Aogonek O -40\r\nKPX Aogonek Oacute -40\r\nKPX Aogonek Ocircumflex -40\r\nKPX Aogonek Odieresis -40\r\nKPX Aogonek Ograve -40\r\nKPX Aogonek Ohungarumlaut -40\r\nKPX Aogonek Omacron -40\r\nKPX Aogonek Oslash -40\r\nKPX Aogonek Otilde -40\r\nKPX Aogonek Q -40\r\nKPX Aogonek T -90\r\nKPX Aogonek Tcaron -90\r\nKPX Aogonek Tcommaaccent -90\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -80\r\nKPX Aogonek W -60\r\nKPX Aogonek Y -110\r\nKPX Aogonek Yacute -110\r\nKPX Aogonek Ydieresis -110\r\nKPX Aogonek u -30\r\nKPX Aogonek uacute -30\r\nKPX Aogonek ucircumflex -30\r\nKPX Aogonek udieresis -30\r\nKPX Aogonek ugrave -30\r\nKPX Aogonek uhungarumlaut -30\r\nKPX Aogonek umacron -30\r\nKPX Aogonek uogonek -30\r\nKPX Aogonek uring -30\r\nKPX Aogonek v -40\r\nKPX Aogonek w -30\r\nKPX Aogonek y -30\r\nKPX Aogonek yacute -30\r\nKPX Aogonek ydieresis -30\r\nKPX Aring C -40\r\nKPX Aring Cacute -40\r\nKPX Aring Ccaron -40\r\nKPX Aring Ccedilla -40\r\nKPX Aring G -50\r\nKPX Aring Gbreve -50\r\nKPX Aring Gcommaaccent -50\r\nKPX Aring O -40\r\nKPX Aring Oacute -40\r\nKPX Aring Ocircumflex -40\r\nKPX Aring Odieresis -40\r\nKPX Aring Ograve -40\r\nKPX Aring Ohungarumlaut -40\r\nKPX Aring Omacron -40\r\nKPX Aring Oslash -40\r\nKPX Aring Otilde -40\r\nKPX Aring Q -40\r\nKPX Aring T -90\r\nKPX Aring Tcaron -90\r\nKPX Aring Tcommaaccent -90\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -80\r\nKPX Aring W -60\r\nKPX Aring Y -110\r\nKPX Aring Yacute -110\r\nKPX Aring Ydieresis -110\r\nKPX Aring u -30\r\nKPX Aring uacute -30\r\nKPX Aring ucircumflex -30\r\nKPX Aring udieresis -30\r\nKPX Aring ugrave -30\r\nKPX Aring uhungarumlaut -30\r\nKPX Aring umacron -30\r\nKPX Aring uogonek -30\r\nKPX Aring uring -30\r\nKPX Aring v -40\r\nKPX Aring w -30\r\nKPX Aring y -30\r\nKPX Aring yacute -30\r\nKPX Aring ydieresis -30\r\nKPX Atilde C -40\r\nKPX Atilde Cacute -40\r\nKPX Atilde Ccaron -40\r\nKPX Atilde Ccedilla -40\r\nKPX Atilde G -50\r\nKPX Atilde Gbreve -50\r\nKPX Atilde Gcommaaccent -50\r\nKPX Atilde O -40\r\nKPX Atilde Oacute -40\r\nKPX Atilde Ocircumflex -40\r\nKPX Atilde Odieresis -40\r\nKPX Atilde Ograve -40\r\nKPX Atilde Ohungarumlaut -40\r\nKPX Atilde Omacron -40\r\nKPX Atilde Oslash -40\r\nKPX Atilde Otilde -40\r\nKPX Atilde Q -40\r\nKPX Atilde T -90\r\nKPX Atilde Tcaron -90\r\nKPX Atilde Tcommaaccent -90\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -80\r\nKPX Atilde W -60\r\nKPX Atilde Y -110\r\nKPX Atilde Yacute -110\r\nKPX Atilde Ydieresis -110\r\nKPX Atilde u -30\r\nKPX Atilde uacute -30\r\nKPX Atilde ucircumflex -30\r\nKPX Atilde udieresis -30\r\nKPX Atilde ugrave -30\r\nKPX Atilde uhungarumlaut -30\r\nKPX Atilde umacron -30\r\nKPX Atilde uogonek -30\r\nKPX Atilde uring -30\r\nKPX Atilde v -40\r\nKPX Atilde w -30\r\nKPX Atilde y -30\r\nKPX Atilde yacute -30\r\nKPX Atilde ydieresis -30\r\nKPX B A -30\r\nKPX B Aacute -30\r\nKPX B Abreve -30\r\nKPX B Acircumflex -30\r\nKPX B Adieresis -30\r\nKPX B Agrave -30\r\nKPX B Amacron -30\r\nKPX B Aogonek -30\r\nKPX B Aring -30\r\nKPX B Atilde -30\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -40\r\nKPX D Aacute -40\r\nKPX D Abreve -40\r\nKPX D Acircumflex -40\r\nKPX D Adieresis -40\r\nKPX D Agrave -40\r\nKPX D Amacron -40\r\nKPX D Aogonek -40\r\nKPX D Aring -40\r\nKPX D Atilde -40\r\nKPX D V -40\r\nKPX D W -40\r\nKPX D Y -70\r\nKPX D Yacute -70\r\nKPX D Ydieresis -70\r\nKPX D comma -30\r\nKPX D period -30\r\nKPX Dcaron A -40\r\nKPX Dcaron Aacute -40\r\nKPX Dcaron Abreve -40\r\nKPX Dcaron Acircumflex -40\r\nKPX Dcaron Adieresis -40\r\nKPX Dcaron Agrave -40\r\nKPX Dcaron Amacron -40\r\nKPX Dcaron Aogonek -40\r\nKPX Dcaron Aring -40\r\nKPX Dcaron Atilde -40\r\nKPX Dcaron V -40\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -70\r\nKPX Dcaron Yacute -70\r\nKPX Dcaron Ydieresis -70\r\nKPX Dcaron comma -30\r\nKPX Dcaron period -30\r\nKPX Dcroat A -40\r\nKPX Dcroat Aacute -40\r\nKPX Dcroat Abreve -40\r\nKPX Dcroat Acircumflex -40\r\nKPX Dcroat Adieresis -40\r\nKPX Dcroat Agrave -40\r\nKPX Dcroat Amacron -40\r\nKPX Dcroat Aogonek -40\r\nKPX Dcroat Aring -40\r\nKPX Dcroat Atilde -40\r\nKPX Dcroat V -40\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -70\r\nKPX Dcroat Yacute -70\r\nKPX Dcroat Ydieresis -70\r\nKPX Dcroat comma -30\r\nKPX Dcroat period -30\r\nKPX F A -80\r\nKPX F Aacute -80\r\nKPX F Abreve -80\r\nKPX F Acircumflex -80\r\nKPX F Adieresis -80\r\nKPX F Agrave -80\r\nKPX F Amacron -80\r\nKPX F Aogonek -80\r\nKPX F Aring -80\r\nKPX F Atilde -80\r\nKPX F a -20\r\nKPX F aacute -20\r\nKPX F abreve -20\r\nKPX F acircumflex -20\r\nKPX F adieresis -20\r\nKPX F agrave -20\r\nKPX F amacron -20\r\nKPX F aogonek -20\r\nKPX F aring -20\r\nKPX F atilde -20\r\nKPX F comma -100\r\nKPX F period -100\r\nKPX J A -20\r\nKPX J Aacute -20\r\nKPX J Abreve -20\r\nKPX J Acircumflex -20\r\nKPX J Adieresis -20\r\nKPX J Agrave -20\r\nKPX J Amacron -20\r\nKPX J Aogonek -20\r\nKPX J Aring -20\r\nKPX J Atilde -20\r\nKPX J comma -20\r\nKPX J period -20\r\nKPX J u -20\r\nKPX J uacute -20\r\nKPX J ucircumflex -20\r\nKPX J udieresis -20\r\nKPX J ugrave -20\r\nKPX J uhungarumlaut -20\r\nKPX J umacron -20\r\nKPX J uogonek -20\r\nKPX J uring -20\r\nKPX K O -30\r\nKPX K Oacute -30\r\nKPX K Ocircumflex -30\r\nKPX K Odieresis -30\r\nKPX K Ograve -30\r\nKPX K Ohungarumlaut -30\r\nKPX K Omacron -30\r\nKPX K Oslash -30\r\nKPX K Otilde -30\r\nKPX K e -15\r\nKPX K eacute -15\r\nKPX K ecaron -15\r\nKPX K ecircumflex -15\r\nKPX K edieresis -15\r\nKPX K edotaccent -15\r\nKPX K egrave -15\r\nKPX K emacron -15\r\nKPX K eogonek -15\r\nKPX K o -35\r\nKPX K oacute -35\r\nKPX K ocircumflex -35\r\nKPX K odieresis -35\r\nKPX K ograve -35\r\nKPX K ohungarumlaut -35\r\nKPX K omacron -35\r\nKPX K oslash -35\r\nKPX K otilde -35\r\nKPX K u -30\r\nKPX K uacute -30\r\nKPX K ucircumflex -30\r\nKPX K udieresis -30\r\nKPX K ugrave -30\r\nKPX K uhungarumlaut -30\r\nKPX K umacron -30\r\nKPX K uogonek -30\r\nKPX K uring -30\r\nKPX K y -40\r\nKPX K yacute -40\r\nKPX K ydieresis -40\r\nKPX Kcommaaccent O -30\r\nKPX Kcommaaccent Oacute -30\r\nKPX Kcommaaccent Ocircumflex -30\r\nKPX Kcommaaccent Odieresis -30\r\nKPX Kcommaaccent Ograve -30\r\nKPX Kcommaaccent Ohungarumlaut -30\r\nKPX Kcommaaccent Omacron -30\r\nKPX Kcommaaccent Oslash -30\r\nKPX Kcommaaccent Otilde -30\r\nKPX Kcommaaccent e -15\r\nKPX Kcommaaccent eacute -15\r\nKPX Kcommaaccent ecaron -15\r\nKPX Kcommaaccent ecircumflex -15\r\nKPX Kcommaaccent edieresis -15\r\nKPX Kcommaaccent edotaccent -15\r\nKPX Kcommaaccent egrave -15\r\nKPX Kcommaaccent emacron -15\r\nKPX Kcommaaccent eogonek -15\r\nKPX Kcommaaccent o -35\r\nKPX Kcommaaccent oacute -35\r\nKPX Kcommaaccent ocircumflex -35\r\nKPX Kcommaaccent odieresis -35\r\nKPX Kcommaaccent ograve -35\r\nKPX Kcommaaccent ohungarumlaut -35\r\nKPX Kcommaaccent omacron -35\r\nKPX Kcommaaccent oslash -35\r\nKPX Kcommaaccent otilde -35\r\nKPX Kcommaaccent u -30\r\nKPX Kcommaaccent uacute -30\r\nKPX Kcommaaccent ucircumflex -30\r\nKPX Kcommaaccent udieresis -30\r\nKPX Kcommaaccent ugrave -30\r\nKPX Kcommaaccent uhungarumlaut -30\r\nKPX Kcommaaccent umacron -30\r\nKPX Kcommaaccent uogonek -30\r\nKPX Kcommaaccent uring -30\r\nKPX Kcommaaccent y -40\r\nKPX Kcommaaccent yacute -40\r\nKPX Kcommaaccent ydieresis -40\r\nKPX L T -90\r\nKPX L Tcaron -90\r\nKPX L Tcommaaccent -90\r\nKPX L V -110\r\nKPX L W -80\r\nKPX L Y -120\r\nKPX L Yacute -120\r\nKPX L Ydieresis -120\r\nKPX L quotedblright -140\r\nKPX L quoteright -140\r\nKPX L y -30\r\nKPX L yacute -30\r\nKPX L ydieresis -30\r\nKPX Lacute T -90\r\nKPX Lacute Tcaron -90\r\nKPX Lacute Tcommaaccent -90\r\nKPX Lacute V -110\r\nKPX Lacute W -80\r\nKPX Lacute Y -120\r\nKPX Lacute Yacute -120\r\nKPX Lacute Ydieresis -120\r\nKPX Lacute quotedblright -140\r\nKPX Lacute quoteright -140\r\nKPX Lacute y -30\r\nKPX Lacute yacute -30\r\nKPX Lacute ydieresis -30\r\nKPX Lcommaaccent T -90\r\nKPX Lcommaaccent Tcaron -90\r\nKPX Lcommaaccent Tcommaaccent -90\r\nKPX Lcommaaccent V -110\r\nKPX Lcommaaccent W -80\r\nKPX Lcommaaccent Y -120\r\nKPX Lcommaaccent Yacute -120\r\nKPX Lcommaaccent Ydieresis -120\r\nKPX Lcommaaccent quotedblright -140\r\nKPX Lcommaaccent quoteright -140\r\nKPX Lcommaaccent y -30\r\nKPX Lcommaaccent yacute -30\r\nKPX Lcommaaccent ydieresis -30\r\nKPX Lslash T -90\r\nKPX Lslash Tcaron -90\r\nKPX Lslash Tcommaaccent -90\r\nKPX Lslash V -110\r\nKPX Lslash W -80\r\nKPX Lslash Y -120\r\nKPX Lslash Yacute -120\r\nKPX Lslash Ydieresis -120\r\nKPX Lslash quotedblright -140\r\nKPX Lslash quoteright -140\r\nKPX Lslash y -30\r\nKPX Lslash yacute -30\r\nKPX Lslash ydieresis -30\r\nKPX O A -50\r\nKPX O Aacute -50\r\nKPX O Abreve -50\r\nKPX O Acircumflex -50\r\nKPX O Adieresis -50\r\nKPX O Agrave -50\r\nKPX O Amacron -50\r\nKPX O Aogonek -50\r\nKPX O Aring -50\r\nKPX O Atilde -50\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -50\r\nKPX O X -50\r\nKPX O Y -70\r\nKPX O Yacute -70\r\nKPX O Ydieresis -70\r\nKPX O comma -40\r\nKPX O period -40\r\nKPX Oacute A -50\r\nKPX Oacute Aacute -50\r\nKPX Oacute Abreve -50\r\nKPX Oacute Acircumflex -50\r\nKPX Oacute Adieresis -50\r\nKPX Oacute Agrave -50\r\nKPX Oacute Amacron -50\r\nKPX Oacute Aogonek -50\r\nKPX Oacute Aring -50\r\nKPX Oacute Atilde -50\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -50\r\nKPX Oacute X -50\r\nKPX Oacute Y -70\r\nKPX Oacute Yacute -70\r\nKPX Oacute Ydieresis -70\r\nKPX Oacute comma -40\r\nKPX Oacute period -40\r\nKPX Ocircumflex A -50\r\nKPX Ocircumflex Aacute -50\r\nKPX Ocircumflex Abreve -50\r\nKPX Ocircumflex Acircumflex -50\r\nKPX Ocircumflex Adieresis -50\r\nKPX Ocircumflex Agrave -50\r\nKPX Ocircumflex Amacron -50\r\nKPX Ocircumflex Aogonek -50\r\nKPX Ocircumflex Aring -50\r\nKPX Ocircumflex Atilde -50\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -50\r\nKPX Ocircumflex X -50\r\nKPX Ocircumflex Y -70\r\nKPX Ocircumflex Yacute -70\r\nKPX Ocircumflex Ydieresis -70\r\nKPX Ocircumflex comma -40\r\nKPX Ocircumflex period -40\r\nKPX Odieresis A -50\r\nKPX Odieresis Aacute -50\r\nKPX Odieresis Abreve -50\r\nKPX Odieresis Acircumflex -50\r\nKPX Odieresis Adieresis -50\r\nKPX Odieresis Agrave -50\r\nKPX Odieresis Amacron -50\r\nKPX Odieresis Aogonek -50\r\nKPX Odieresis Aring -50\r\nKPX Odieresis Atilde -50\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -50\r\nKPX Odieresis X -50\r\nKPX Odieresis Y -70\r\nKPX Odieresis Yacute -70\r\nKPX Odieresis Ydieresis -70\r\nKPX Odieresis comma -40\r\nKPX Odieresis period -40\r\nKPX Ograve A -50\r\nKPX Ograve Aacute -50\r\nKPX Ograve Abreve -50\r\nKPX Ograve Acircumflex -50\r\nKPX Ograve Adieresis -50\r\nKPX Ograve Agrave -50\r\nKPX Ograve Amacron -50\r\nKPX Ograve Aogonek -50\r\nKPX Ograve Aring -50\r\nKPX Ograve Atilde -50\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -50\r\nKPX Ograve X -50\r\nKPX Ograve Y -70\r\nKPX Ograve Yacute -70\r\nKPX Ograve Ydieresis -70\r\nKPX Ograve comma -40\r\nKPX Ograve period -40\r\nKPX Ohungarumlaut A -50\r\nKPX Ohungarumlaut Aacute -50\r\nKPX Ohungarumlaut Abreve -50\r\nKPX Ohungarumlaut Acircumflex -50\r\nKPX Ohungarumlaut Adieresis -50\r\nKPX Ohungarumlaut Agrave -50\r\nKPX Ohungarumlaut Amacron -50\r\nKPX Ohungarumlaut Aogonek -50\r\nKPX Ohungarumlaut Aring -50\r\nKPX Ohungarumlaut Atilde -50\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -50\r\nKPX Ohungarumlaut X -50\r\nKPX Ohungarumlaut Y -70\r\nKPX Ohungarumlaut Yacute -70\r\nKPX Ohungarumlaut Ydieresis -70\r\nKPX Ohungarumlaut comma -40\r\nKPX Ohungarumlaut period -40\r\nKPX Omacron A -50\r\nKPX Omacron Aacute -50\r\nKPX Omacron Abreve -50\r\nKPX Omacron Acircumflex -50\r\nKPX Omacron Adieresis -50\r\nKPX Omacron Agrave -50\r\nKPX Omacron Amacron -50\r\nKPX Omacron Aogonek -50\r\nKPX Omacron Aring -50\r\nKPX Omacron Atilde -50\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -50\r\nKPX Omacron X -50\r\nKPX Omacron Y -70\r\nKPX Omacron Yacute -70\r\nKPX Omacron Ydieresis -70\r\nKPX Omacron comma -40\r\nKPX Omacron period -40\r\nKPX Oslash A -50\r\nKPX Oslash Aacute -50\r\nKPX Oslash Abreve -50\r\nKPX Oslash Acircumflex -50\r\nKPX Oslash Adieresis -50\r\nKPX Oslash Agrave -50\r\nKPX Oslash Amacron -50\r\nKPX Oslash Aogonek -50\r\nKPX Oslash Aring -50\r\nKPX Oslash Atilde -50\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -50\r\nKPX Oslash X -50\r\nKPX Oslash Y -70\r\nKPX Oslash Yacute -70\r\nKPX Oslash Ydieresis -70\r\nKPX Oslash comma -40\r\nKPX Oslash period -40\r\nKPX Otilde A -50\r\nKPX Otilde Aacute -50\r\nKPX Otilde Abreve -50\r\nKPX Otilde Acircumflex -50\r\nKPX Otilde Adieresis -50\r\nKPX Otilde Agrave -50\r\nKPX Otilde Amacron -50\r\nKPX Otilde Aogonek -50\r\nKPX Otilde Aring -50\r\nKPX Otilde Atilde -50\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -50\r\nKPX Otilde X -50\r\nKPX Otilde Y -70\r\nKPX Otilde Yacute -70\r\nKPX Otilde Ydieresis -70\r\nKPX Otilde comma -40\r\nKPX Otilde period -40\r\nKPX P A -100\r\nKPX P Aacute -100\r\nKPX P Abreve -100\r\nKPX P Acircumflex -100\r\nKPX P Adieresis -100\r\nKPX P Agrave -100\r\nKPX P Amacron -100\r\nKPX P Aogonek -100\r\nKPX P Aring -100\r\nKPX P Atilde -100\r\nKPX P a -30\r\nKPX P aacute -30\r\nKPX P abreve -30\r\nKPX P acircumflex -30\r\nKPX P adieresis -30\r\nKPX P agrave -30\r\nKPX P amacron -30\r\nKPX P aogonek -30\r\nKPX P aring -30\r\nKPX P atilde -30\r\nKPX P comma -120\r\nKPX P e -30\r\nKPX P eacute -30\r\nKPX P ecaron -30\r\nKPX P ecircumflex -30\r\nKPX P edieresis -30\r\nKPX P edotaccent -30\r\nKPX P egrave -30\r\nKPX P emacron -30\r\nKPX P eogonek -30\r\nKPX P o -40\r\nKPX P oacute -40\r\nKPX P ocircumflex -40\r\nKPX P odieresis -40\r\nKPX P ograve -40\r\nKPX P ohungarumlaut -40\r\nKPX P omacron -40\r\nKPX P oslash -40\r\nKPX P otilde -40\r\nKPX P period -120\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX Q comma 20\r\nKPX Q period 20\r\nKPX R O -20\r\nKPX R Oacute -20\r\nKPX R Ocircumflex -20\r\nKPX R Odieresis -20\r\nKPX R Ograve -20\r\nKPX R Ohungarumlaut -20\r\nKPX R Omacron -20\r\nKPX R Oslash -20\r\nKPX R Otilde -20\r\nKPX R T -20\r\nKPX R Tcaron -20\r\nKPX R Tcommaaccent -20\r\nKPX R U -20\r\nKPX R Uacute -20\r\nKPX R Ucircumflex -20\r\nKPX R Udieresis -20\r\nKPX R Ugrave -20\r\nKPX R Uhungarumlaut -20\r\nKPX R Umacron -20\r\nKPX R Uogonek -20\r\nKPX R Uring -20\r\nKPX R V -50\r\nKPX R W -40\r\nKPX R Y -50\r\nKPX R Yacute -50\r\nKPX R Ydieresis -50\r\nKPX Racute O -20\r\nKPX Racute Oacute -20\r\nKPX Racute Ocircumflex -20\r\nKPX Racute Odieresis -20\r\nKPX Racute Ograve -20\r\nKPX Racute Ohungarumlaut -20\r\nKPX Racute Omacron -20\r\nKPX Racute Oslash -20\r\nKPX Racute Otilde -20\r\nKPX Racute T -20\r\nKPX Racute Tcaron -20\r\nKPX Racute Tcommaaccent -20\r\nKPX Racute U -20\r\nKPX Racute Uacute -20\r\nKPX Racute Ucircumflex -20\r\nKPX Racute Udieresis -20\r\nKPX Racute Ugrave -20\r\nKPX Racute Uhungarumlaut -20\r\nKPX Racute Umacron -20\r\nKPX Racute Uogonek -20\r\nKPX Racute Uring -20\r\nKPX Racute V -50\r\nKPX Racute W -40\r\nKPX Racute Y -50\r\nKPX Racute Yacute -50\r\nKPX Racute Ydieresis -50\r\nKPX Rcaron O -20\r\nKPX Rcaron Oacute -20\r\nKPX Rcaron Ocircumflex -20\r\nKPX Rcaron Odieresis -20\r\nKPX Rcaron Ograve -20\r\nKPX Rcaron Ohungarumlaut -20\r\nKPX Rcaron Omacron -20\r\nKPX Rcaron Oslash -20\r\nKPX Rcaron Otilde -20\r\nKPX Rcaron T -20\r\nKPX Rcaron Tcaron -20\r\nKPX Rcaron Tcommaaccent -20\r\nKPX Rcaron U -20\r\nKPX Rcaron Uacute -20\r\nKPX Rcaron Ucircumflex -20\r\nKPX Rcaron Udieresis -20\r\nKPX Rcaron Ugrave -20\r\nKPX Rcaron Uhungarumlaut -20\r\nKPX Rcaron Umacron -20\r\nKPX Rcaron Uogonek -20\r\nKPX Rcaron Uring -20\r\nKPX Rcaron V -50\r\nKPX Rcaron W -40\r\nKPX Rcaron Y -50\r\nKPX Rcaron Yacute -50\r\nKPX Rcaron Ydieresis -50\r\nKPX Rcommaaccent O -20\r\nKPX Rcommaaccent Oacute -20\r\nKPX Rcommaaccent Ocircumflex -20\r\nKPX Rcommaaccent Odieresis -20\r\nKPX Rcommaaccent Ograve -20\r\nKPX Rcommaaccent Ohungarumlaut -20\r\nKPX Rcommaaccent Omacron -20\r\nKPX Rcommaaccent Oslash -20\r\nKPX Rcommaaccent Otilde -20\r\nKPX Rcommaaccent T -20\r\nKPX Rcommaaccent Tcaron -20\r\nKPX Rcommaaccent Tcommaaccent -20\r\nKPX Rcommaaccent U -20\r\nKPX Rcommaaccent Uacute -20\r\nKPX Rcommaaccent Ucircumflex -20\r\nKPX Rcommaaccent Udieresis -20\r\nKPX Rcommaaccent Ugrave -20\r\nKPX Rcommaaccent Uhungarumlaut -20\r\nKPX Rcommaaccent Umacron -20\r\nKPX Rcommaaccent Uogonek -20\r\nKPX Rcommaaccent Uring -20\r\nKPX Rcommaaccent V -50\r\nKPX Rcommaaccent W -40\r\nKPX Rcommaaccent Y -50\r\nKPX Rcommaaccent Yacute -50\r\nKPX Rcommaaccent Ydieresis -50\r\nKPX T A -90\r\nKPX T Aacute -90\r\nKPX T Abreve -90\r\nKPX T Acircumflex -90\r\nKPX T Adieresis -90\r\nKPX T Agrave -90\r\nKPX T Amacron -90\r\nKPX T Aogonek -90\r\nKPX T Aring -90\r\nKPX T Atilde -90\r\nKPX T O -40\r\nKPX T Oacute -40\r\nKPX T Ocircumflex -40\r\nKPX T Odieresis -40\r\nKPX T Ograve -40\r\nKPX T Ohungarumlaut -40\r\nKPX T Omacron -40\r\nKPX T Oslash -40\r\nKPX T Otilde -40\r\nKPX T a -80\r\nKPX T aacute -80\r\nKPX T abreve -80\r\nKPX T acircumflex -80\r\nKPX T adieresis -80\r\nKPX T agrave -80\r\nKPX T amacron -80\r\nKPX T aogonek -80\r\nKPX T aring -80\r\nKPX T atilde -80\r\nKPX T colon -40\r\nKPX T comma -80\r\nKPX T e -60\r\nKPX T eacute -60\r\nKPX T ecaron -60\r\nKPX T ecircumflex -60\r\nKPX T edieresis -60\r\nKPX T edotaccent -60\r\nKPX T egrave -60\r\nKPX T emacron -60\r\nKPX T eogonek -60\r\nKPX T hyphen -120\r\nKPX T o -80\r\nKPX T oacute -80\r\nKPX T ocircumflex -80\r\nKPX T odieresis -80\r\nKPX T ograve -80\r\nKPX T ohungarumlaut -80\r\nKPX T omacron -80\r\nKPX T oslash -80\r\nKPX T otilde -80\r\nKPX T period -80\r\nKPX T r -80\r\nKPX T racute -80\r\nKPX T rcommaaccent -80\r\nKPX T semicolon -40\r\nKPX T u -90\r\nKPX T uacute -90\r\nKPX T ucircumflex -90\r\nKPX T udieresis -90\r\nKPX T ugrave -90\r\nKPX T uhungarumlaut -90\r\nKPX T umacron -90\r\nKPX T uogonek -90\r\nKPX T uring -90\r\nKPX T w -60\r\nKPX T y -60\r\nKPX T yacute -60\r\nKPX T ydieresis -60\r\nKPX Tcaron A -90\r\nKPX Tcaron Aacute -90\r\nKPX Tcaron Abreve -90\r\nKPX Tcaron Acircumflex -90\r\nKPX Tcaron Adieresis -90\r\nKPX Tcaron Agrave -90\r\nKPX Tcaron Amacron -90\r\nKPX Tcaron Aogonek -90\r\nKPX Tcaron Aring -90\r\nKPX Tcaron Atilde -90\r\nKPX Tcaron O -40\r\nKPX Tcaron Oacute -40\r\nKPX Tcaron Ocircumflex -40\r\nKPX Tcaron Odieresis -40\r\nKPX Tcaron Ograve -40\r\nKPX Tcaron Ohungarumlaut -40\r\nKPX Tcaron Omacron -40\r\nKPX Tcaron Oslash -40\r\nKPX Tcaron Otilde -40\r\nKPX Tcaron a -80\r\nKPX Tcaron aacute -80\r\nKPX Tcaron abreve -80\r\nKPX Tcaron acircumflex -80\r\nKPX Tcaron adieresis -80\r\nKPX Tcaron agrave -80\r\nKPX Tcaron amacron -80\r\nKPX Tcaron aogonek -80\r\nKPX Tcaron aring -80\r\nKPX Tcaron atilde -80\r\nKPX Tcaron colon -40\r\nKPX Tcaron comma -80\r\nKPX Tcaron e -60\r\nKPX Tcaron eacute -60\r\nKPX Tcaron ecaron -60\r\nKPX Tcaron ecircumflex -60\r\nKPX Tcaron edieresis -60\r\nKPX Tcaron edotaccent -60\r\nKPX Tcaron egrave -60\r\nKPX Tcaron emacron -60\r\nKPX Tcaron eogonek -60\r\nKPX Tcaron hyphen -120\r\nKPX Tcaron o -80\r\nKPX Tcaron oacute -80\r\nKPX Tcaron ocircumflex -80\r\nKPX Tcaron odieresis -80\r\nKPX Tcaron ograve -80\r\nKPX Tcaron ohungarumlaut -80\r\nKPX Tcaron omacron -80\r\nKPX Tcaron oslash -80\r\nKPX Tcaron otilde -80\r\nKPX Tcaron period -80\r\nKPX Tcaron r -80\r\nKPX Tcaron racute -80\r\nKPX Tcaron rcommaaccent -80\r\nKPX Tcaron semicolon -40\r\nKPX Tcaron u -90\r\nKPX Tcaron uacute -90\r\nKPX Tcaron ucircumflex -90\r\nKPX Tcaron udieresis -90\r\nKPX Tcaron ugrave -90\r\nKPX Tcaron uhungarumlaut -90\r\nKPX Tcaron umacron -90\r\nKPX Tcaron uogonek -90\r\nKPX Tcaron uring -90\r\nKPX Tcaron w -60\r\nKPX Tcaron y -60\r\nKPX Tcaron yacute -60\r\nKPX Tcaron ydieresis -60\r\nKPX Tcommaaccent A -90\r\nKPX Tcommaaccent Aacute -90\r\nKPX Tcommaaccent Abreve -90\r\nKPX Tcommaaccent Acircumflex -90\r\nKPX Tcommaaccent Adieresis -90\r\nKPX Tcommaaccent Agrave -90\r\nKPX Tcommaaccent Amacron -90\r\nKPX Tcommaaccent Aogonek -90\r\nKPX Tcommaaccent Aring -90\r\nKPX Tcommaaccent Atilde -90\r\nKPX Tcommaaccent O -40\r\nKPX Tcommaaccent Oacute -40\r\nKPX Tcommaaccent Ocircumflex -40\r\nKPX Tcommaaccent Odieresis -40\r\nKPX Tcommaaccent Ograve -40\r\nKPX Tcommaaccent Ohungarumlaut -40\r\nKPX Tcommaaccent Omacron -40\r\nKPX Tcommaaccent Oslash -40\r\nKPX Tcommaaccent Otilde -40\r\nKPX Tcommaaccent a -80\r\nKPX Tcommaaccent aacute -80\r\nKPX Tcommaaccent abreve -80\r\nKPX Tcommaaccent acircumflex -80\r\nKPX Tcommaaccent adieresis -80\r\nKPX Tcommaaccent agrave -80\r\nKPX Tcommaaccent amacron -80\r\nKPX Tcommaaccent aogonek -80\r\nKPX Tcommaaccent aring -80\r\nKPX Tcommaaccent atilde -80\r\nKPX Tcommaaccent colon -40\r\nKPX Tcommaaccent comma -80\r\nKPX Tcommaaccent e -60\r\nKPX Tcommaaccent eacute -60\r\nKPX Tcommaaccent ecaron -60\r\nKPX Tcommaaccent ecircumflex -60\r\nKPX Tcommaaccent edieresis -60\r\nKPX Tcommaaccent edotaccent -60\r\nKPX Tcommaaccent egrave -60\r\nKPX Tcommaaccent emacron -60\r\nKPX Tcommaaccent eogonek -60\r\nKPX Tcommaaccent hyphen -120\r\nKPX Tcommaaccent o -80\r\nKPX Tcommaaccent oacute -80\r\nKPX Tcommaaccent ocircumflex -80\r\nKPX Tcommaaccent odieresis -80\r\nKPX Tcommaaccent ograve -80\r\nKPX Tcommaaccent ohungarumlaut -80\r\nKPX Tcommaaccent omacron -80\r\nKPX Tcommaaccent oslash -80\r\nKPX Tcommaaccent otilde -80\r\nKPX Tcommaaccent period -80\r\nKPX Tcommaaccent r -80\r\nKPX Tcommaaccent racute -80\r\nKPX Tcommaaccent rcommaaccent -80\r\nKPX Tcommaaccent semicolon -40\r\nKPX Tcommaaccent u -90\r\nKPX Tcommaaccent uacute -90\r\nKPX Tcommaaccent ucircumflex -90\r\nKPX Tcommaaccent udieresis -90\r\nKPX Tcommaaccent ugrave -90\r\nKPX Tcommaaccent uhungarumlaut -90\r\nKPX Tcommaaccent umacron -90\r\nKPX Tcommaaccent uogonek -90\r\nKPX Tcommaaccent uring -90\r\nKPX Tcommaaccent w -60\r\nKPX Tcommaaccent y -60\r\nKPX Tcommaaccent yacute -60\r\nKPX Tcommaaccent ydieresis -60\r\nKPX U A -50\r\nKPX U Aacute -50\r\nKPX U Abreve -50\r\nKPX U Acircumflex -50\r\nKPX U Adieresis -50\r\nKPX U Agrave -50\r\nKPX U Amacron -50\r\nKPX U Aogonek -50\r\nKPX U Aring -50\r\nKPX U Atilde -50\r\nKPX U comma -30\r\nKPX U period -30\r\nKPX Uacute A -50\r\nKPX Uacute Aacute -50\r\nKPX Uacute Abreve -50\r\nKPX Uacute Acircumflex -50\r\nKPX Uacute Adieresis -50\r\nKPX Uacute Agrave -50\r\nKPX Uacute Amacron -50\r\nKPX Uacute Aogonek -50\r\nKPX Uacute Aring -50\r\nKPX Uacute Atilde -50\r\nKPX Uacute comma -30\r\nKPX Uacute period -30\r\nKPX Ucircumflex A -50\r\nKPX Ucircumflex Aacute -50\r\nKPX Ucircumflex Abreve -50\r\nKPX Ucircumflex Acircumflex -50\r\nKPX Ucircumflex Adieresis -50\r\nKPX Ucircumflex Agrave -50\r\nKPX Ucircumflex Amacron -50\r\nKPX Ucircumflex Aogonek -50\r\nKPX Ucircumflex Aring -50\r\nKPX Ucircumflex Atilde -50\r\nKPX Ucircumflex comma -30\r\nKPX Ucircumflex period -30\r\nKPX Udieresis A -50\r\nKPX Udieresis Aacute -50\r\nKPX Udieresis Abreve -50\r\nKPX Udieresis Acircumflex -50\r\nKPX Udieresis Adieresis -50\r\nKPX Udieresis Agrave -50\r\nKPX Udieresis Amacron -50\r\nKPX Udieresis Aogonek -50\r\nKPX Udieresis Aring -50\r\nKPX Udieresis Atilde -50\r\nKPX Udieresis comma -30\r\nKPX Udieresis period -30\r\nKPX Ugrave A -50\r\nKPX Ugrave Aacute -50\r\nKPX Ugrave Abreve -50\r\nKPX Ugrave Acircumflex -50\r\nKPX Ugrave Adieresis -50\r\nKPX Ugrave Agrave -50\r\nKPX Ugrave Amacron -50\r\nKPX Ugrave Aogonek -50\r\nKPX Ugrave Aring -50\r\nKPX Ugrave Atilde -50\r\nKPX Ugrave comma -30\r\nKPX Ugrave period -30\r\nKPX Uhungarumlaut A -50\r\nKPX Uhungarumlaut Aacute -50\r\nKPX Uhungarumlaut Abreve -50\r\nKPX Uhungarumlaut Acircumflex -50\r\nKPX Uhungarumlaut Adieresis -50\r\nKPX Uhungarumlaut Agrave -50\r\nKPX Uhungarumlaut Amacron -50\r\nKPX Uhungarumlaut Aogonek -50\r\nKPX Uhungarumlaut Aring -50\r\nKPX Uhungarumlaut Atilde -50\r\nKPX Uhungarumlaut comma -30\r\nKPX Uhungarumlaut period -30\r\nKPX Umacron A -50\r\nKPX Umacron Aacute -50\r\nKPX Umacron Abreve -50\r\nKPX Umacron Acircumflex -50\r\nKPX Umacron Adieresis -50\r\nKPX Umacron Agrave -50\r\nKPX Umacron Amacron -50\r\nKPX Umacron Aogonek -50\r\nKPX Umacron Aring -50\r\nKPX Umacron Atilde -50\r\nKPX Umacron comma -30\r\nKPX Umacron period -30\r\nKPX Uogonek A -50\r\nKPX Uogonek Aacute -50\r\nKPX Uogonek Abreve -50\r\nKPX Uogonek Acircumflex -50\r\nKPX Uogonek Adieresis -50\r\nKPX Uogonek Agrave -50\r\nKPX Uogonek Amacron -50\r\nKPX Uogonek Aogonek -50\r\nKPX Uogonek Aring -50\r\nKPX Uogonek Atilde -50\r\nKPX Uogonek comma -30\r\nKPX Uogonek period -30\r\nKPX Uring A -50\r\nKPX Uring Aacute -50\r\nKPX Uring Abreve -50\r\nKPX Uring Acircumflex -50\r\nKPX Uring Adieresis -50\r\nKPX Uring Agrave -50\r\nKPX Uring Amacron -50\r\nKPX Uring Aogonek -50\r\nKPX Uring Aring -50\r\nKPX Uring Atilde -50\r\nKPX Uring comma -30\r\nKPX Uring period -30\r\nKPX V A -80\r\nKPX V Aacute -80\r\nKPX V Abreve -80\r\nKPX V Acircumflex -80\r\nKPX V Adieresis -80\r\nKPX V Agrave -80\r\nKPX V Amacron -80\r\nKPX V Aogonek -80\r\nKPX V Aring -80\r\nKPX V Atilde -80\r\nKPX V G -50\r\nKPX V Gbreve -50\r\nKPX V Gcommaaccent -50\r\nKPX V O -50\r\nKPX V Oacute -50\r\nKPX V Ocircumflex -50\r\nKPX V Odieresis -50\r\nKPX V Ograve -50\r\nKPX V Ohungarumlaut -50\r\nKPX V Omacron -50\r\nKPX V Oslash -50\r\nKPX V Otilde -50\r\nKPX V a -60\r\nKPX V aacute -60\r\nKPX V abreve -60\r\nKPX V acircumflex -60\r\nKPX V adieresis -60\r\nKPX V agrave -60\r\nKPX V amacron -60\r\nKPX V aogonek -60\r\nKPX V aring -60\r\nKPX V atilde -60\r\nKPX V colon -40\r\nKPX V comma -120\r\nKPX V e -50\r\nKPX V eacute -50\r\nKPX V ecaron -50\r\nKPX V ecircumflex -50\r\nKPX V edieresis -50\r\nKPX V edotaccent -50\r\nKPX V egrave -50\r\nKPX V emacron -50\r\nKPX V eogonek -50\r\nKPX V hyphen -80\r\nKPX V o -90\r\nKPX V oacute -90\r\nKPX V ocircumflex -90\r\nKPX V odieresis -90\r\nKPX V ograve -90\r\nKPX V ohungarumlaut -90\r\nKPX V omacron -90\r\nKPX V oslash -90\r\nKPX V otilde -90\r\nKPX V period -120\r\nKPX V semicolon -40\r\nKPX V u -60\r\nKPX V uacute -60\r\nKPX V ucircumflex -60\r\nKPX V udieresis -60\r\nKPX V ugrave -60\r\nKPX V uhungarumlaut -60\r\nKPX V umacron -60\r\nKPX V uogonek -60\r\nKPX V uring -60\r\nKPX W A -60\r\nKPX W Aacute -60\r\nKPX W Abreve -60\r\nKPX W Acircumflex -60\r\nKPX W Adieresis -60\r\nKPX W Agrave -60\r\nKPX W Amacron -60\r\nKPX W Aogonek -60\r\nKPX W Aring -60\r\nKPX W Atilde -60\r\nKPX W O -20\r\nKPX W Oacute -20\r\nKPX W Ocircumflex -20\r\nKPX W Odieresis -20\r\nKPX W Ograve -20\r\nKPX W Ohungarumlaut -20\r\nKPX W Omacron -20\r\nKPX W Oslash -20\r\nKPX W Otilde -20\r\nKPX W a -40\r\nKPX W aacute -40\r\nKPX W abreve -40\r\nKPX W acircumflex -40\r\nKPX W adieresis -40\r\nKPX W agrave -40\r\nKPX W amacron -40\r\nKPX W aogonek -40\r\nKPX W aring -40\r\nKPX W atilde -40\r\nKPX W colon -10\r\nKPX W comma -80\r\nKPX W e -35\r\nKPX W eacute -35\r\nKPX W ecaron -35\r\nKPX W ecircumflex -35\r\nKPX W edieresis -35\r\nKPX W edotaccent -35\r\nKPX W egrave -35\r\nKPX W emacron -35\r\nKPX W eogonek -35\r\nKPX W hyphen -40\r\nKPX W o -60\r\nKPX W oacute -60\r\nKPX W ocircumflex -60\r\nKPX W odieresis -60\r\nKPX W ograve -60\r\nKPX W ohungarumlaut -60\r\nKPX W omacron -60\r\nKPX W oslash -60\r\nKPX W otilde -60\r\nKPX W period -80\r\nKPX W semicolon -10\r\nKPX W u -45\r\nKPX W uacute -45\r\nKPX W ucircumflex -45\r\nKPX W udieresis -45\r\nKPX W ugrave -45\r\nKPX W uhungarumlaut -45\r\nKPX W umacron -45\r\nKPX W uogonek -45\r\nKPX W uring -45\r\nKPX W y -20\r\nKPX W yacute -20\r\nKPX W ydieresis -20\r\nKPX Y A -110\r\nKPX Y Aacute -110\r\nKPX Y Abreve -110\r\nKPX Y Acircumflex -110\r\nKPX Y Adieresis -110\r\nKPX Y Agrave -110\r\nKPX Y Amacron -110\r\nKPX Y Aogonek -110\r\nKPX Y Aring -110\r\nKPX Y Atilde -110\r\nKPX Y O -70\r\nKPX Y Oacute -70\r\nKPX Y Ocircumflex -70\r\nKPX Y Odieresis -70\r\nKPX Y Ograve -70\r\nKPX Y Ohungarumlaut -70\r\nKPX Y Omacron -70\r\nKPX Y Oslash -70\r\nKPX Y Otilde -70\r\nKPX Y a -90\r\nKPX Y aacute -90\r\nKPX Y abreve -90\r\nKPX Y acircumflex -90\r\nKPX Y adieresis -90\r\nKPX Y agrave -90\r\nKPX Y amacron -90\r\nKPX Y aogonek -90\r\nKPX Y aring -90\r\nKPX Y atilde -90\r\nKPX Y colon -50\r\nKPX Y comma -100\r\nKPX Y e -80\r\nKPX Y eacute -80\r\nKPX Y ecaron -80\r\nKPX Y ecircumflex -80\r\nKPX Y edieresis -80\r\nKPX Y edotaccent -80\r\nKPX Y egrave -80\r\nKPX Y emacron -80\r\nKPX Y eogonek -80\r\nKPX Y o -100\r\nKPX Y oacute -100\r\nKPX Y ocircumflex -100\r\nKPX Y odieresis -100\r\nKPX Y ograve -100\r\nKPX Y ohungarumlaut -100\r\nKPX Y omacron -100\r\nKPX Y oslash -100\r\nKPX Y otilde -100\r\nKPX Y period -100\r\nKPX Y semicolon -50\r\nKPX Y u -100\r\nKPX Y uacute -100\r\nKPX Y ucircumflex -100\r\nKPX Y udieresis -100\r\nKPX Y ugrave -100\r\nKPX Y uhungarumlaut -100\r\nKPX Y umacron -100\r\nKPX Y uogonek -100\r\nKPX Y uring -100\r\nKPX Yacute A -110\r\nKPX Yacute Aacute -110\r\nKPX Yacute Abreve -110\r\nKPX Yacute Acircumflex -110\r\nKPX Yacute Adieresis -110\r\nKPX Yacute Agrave -110\r\nKPX Yacute Amacron -110\r\nKPX Yacute Aogonek -110\r\nKPX Yacute Aring -110\r\nKPX Yacute Atilde -110\r\nKPX Yacute O -70\r\nKPX Yacute Oacute -70\r\nKPX Yacute Ocircumflex -70\r\nKPX Yacute Odieresis -70\r\nKPX Yacute Ograve -70\r\nKPX Yacute Ohungarumlaut -70\r\nKPX Yacute Omacron -70\r\nKPX Yacute Oslash -70\r\nKPX Yacute Otilde -70\r\nKPX Yacute a -90\r\nKPX Yacute aacute -90\r\nKPX Yacute abreve -90\r\nKPX Yacute acircumflex -90\r\nKPX Yacute adieresis -90\r\nKPX Yacute agrave -90\r\nKPX Yacute amacron -90\r\nKPX Yacute aogonek -90\r\nKPX Yacute aring -90\r\nKPX Yacute atilde -90\r\nKPX Yacute colon -50\r\nKPX Yacute comma -100\r\nKPX Yacute e -80\r\nKPX Yacute eacute -80\r\nKPX Yacute ecaron -80\r\nKPX Yacute ecircumflex -80\r\nKPX Yacute edieresis -80\r\nKPX Yacute edotaccent -80\r\nKPX Yacute egrave -80\r\nKPX Yacute emacron -80\r\nKPX Yacute eogonek -80\r\nKPX Yacute o -100\r\nKPX Yacute oacute -100\r\nKPX Yacute ocircumflex -100\r\nKPX Yacute odieresis -100\r\nKPX Yacute ograve -100\r\nKPX Yacute ohungarumlaut -100\r\nKPX Yacute omacron -100\r\nKPX Yacute oslash -100\r\nKPX Yacute otilde -100\r\nKPX Yacute period -100\r\nKPX Yacute semicolon -50\r\nKPX Yacute u -100\r\nKPX Yacute uacute -100\r\nKPX Yacute ucircumflex -100\r\nKPX Yacute udieresis -100\r\nKPX Yacute ugrave -100\r\nKPX Yacute uhungarumlaut -100\r\nKPX Yacute umacron -100\r\nKPX Yacute uogonek -100\r\nKPX Yacute uring -100\r\nKPX Ydieresis A -110\r\nKPX Ydieresis Aacute -110\r\nKPX Ydieresis Abreve -110\r\nKPX Ydieresis Acircumflex -110\r\nKPX Ydieresis Adieresis -110\r\nKPX Ydieresis Agrave -110\r\nKPX Ydieresis Amacron -110\r\nKPX Ydieresis Aogonek -110\r\nKPX Ydieresis Aring -110\r\nKPX Ydieresis Atilde -110\r\nKPX Ydieresis O -70\r\nKPX Ydieresis Oacute -70\r\nKPX Ydieresis Ocircumflex -70\r\nKPX Ydieresis Odieresis -70\r\nKPX Ydieresis Ograve -70\r\nKPX Ydieresis Ohungarumlaut -70\r\nKPX Ydieresis Omacron -70\r\nKPX Ydieresis Oslash -70\r\nKPX Ydieresis Otilde -70\r\nKPX Ydieresis a -90\r\nKPX Ydieresis aacute -90\r\nKPX Ydieresis abreve -90\r\nKPX Ydieresis acircumflex -90\r\nKPX Ydieresis adieresis -90\r\nKPX Ydieresis agrave -90\r\nKPX Ydieresis amacron -90\r\nKPX Ydieresis aogonek -90\r\nKPX Ydieresis aring -90\r\nKPX Ydieresis atilde -90\r\nKPX Ydieresis colon -50\r\nKPX Ydieresis comma -100\r\nKPX Ydieresis e -80\r\nKPX Ydieresis eacute -80\r\nKPX Ydieresis ecaron -80\r\nKPX Ydieresis ecircumflex -80\r\nKPX Ydieresis edieresis -80\r\nKPX Ydieresis edotaccent -80\r\nKPX Ydieresis egrave -80\r\nKPX Ydieresis emacron -80\r\nKPX Ydieresis eogonek -80\r\nKPX Ydieresis o -100\r\nKPX Ydieresis oacute -100\r\nKPX Ydieresis ocircumflex -100\r\nKPX Ydieresis odieresis -100\r\nKPX Ydieresis ograve -100\r\nKPX Ydieresis ohungarumlaut -100\r\nKPX Ydieresis omacron -100\r\nKPX Ydieresis oslash -100\r\nKPX Ydieresis otilde -100\r\nKPX Ydieresis period -100\r\nKPX Ydieresis semicolon -50\r\nKPX Ydieresis u -100\r\nKPX Ydieresis uacute -100\r\nKPX Ydieresis ucircumflex -100\r\nKPX Ydieresis udieresis -100\r\nKPX Ydieresis ugrave -100\r\nKPX Ydieresis uhungarumlaut -100\r\nKPX Ydieresis umacron -100\r\nKPX Ydieresis uogonek -100\r\nKPX Ydieresis uring -100\r\nKPX a g -10\r\nKPX a gbreve -10\r\nKPX a gcommaaccent -10\r\nKPX a v -15\r\nKPX a w -15\r\nKPX a y -20\r\nKPX a yacute -20\r\nKPX a ydieresis -20\r\nKPX aacute g -10\r\nKPX aacute gbreve -10\r\nKPX aacute gcommaaccent -10\r\nKPX aacute v -15\r\nKPX aacute w -15\r\nKPX aacute y -20\r\nKPX aacute yacute -20\r\nKPX aacute ydieresis -20\r\nKPX abreve g -10\r\nKPX abreve gbreve -10\r\nKPX abreve gcommaaccent -10\r\nKPX abreve v -15\r\nKPX abreve w -15\r\nKPX abreve y -20\r\nKPX abreve yacute -20\r\nKPX abreve ydieresis -20\r\nKPX acircumflex g -10\r\nKPX acircumflex gbreve -10\r\nKPX acircumflex gcommaaccent -10\r\nKPX acircumflex v -15\r\nKPX acircumflex w -15\r\nKPX acircumflex y -20\r\nKPX acircumflex yacute -20\r\nKPX acircumflex ydieresis -20\r\nKPX adieresis g -10\r\nKPX adieresis gbreve -10\r\nKPX adieresis gcommaaccent -10\r\nKPX adieresis v -15\r\nKPX adieresis w -15\r\nKPX adieresis y -20\r\nKPX adieresis yacute -20\r\nKPX adieresis ydieresis -20\r\nKPX agrave g -10\r\nKPX agrave gbreve -10\r\nKPX agrave gcommaaccent -10\r\nKPX agrave v -15\r\nKPX agrave w -15\r\nKPX agrave y -20\r\nKPX agrave yacute -20\r\nKPX agrave ydieresis -20\r\nKPX amacron g -10\r\nKPX amacron gbreve -10\r\nKPX amacron gcommaaccent -10\r\nKPX amacron v -15\r\nKPX amacron w -15\r\nKPX amacron y -20\r\nKPX amacron yacute -20\r\nKPX amacron ydieresis -20\r\nKPX aogonek g -10\r\nKPX aogonek gbreve -10\r\nKPX aogonek gcommaaccent -10\r\nKPX aogonek v -15\r\nKPX aogonek w -15\r\nKPX aogonek y -20\r\nKPX aogonek yacute -20\r\nKPX aogonek ydieresis -20\r\nKPX aring g -10\r\nKPX aring gbreve -10\r\nKPX aring gcommaaccent -10\r\nKPX aring v -15\r\nKPX aring w -15\r\nKPX aring y -20\r\nKPX aring yacute -20\r\nKPX aring ydieresis -20\r\nKPX atilde g -10\r\nKPX atilde gbreve -10\r\nKPX atilde gcommaaccent -10\r\nKPX atilde v -15\r\nKPX atilde w -15\r\nKPX atilde y -20\r\nKPX atilde yacute -20\r\nKPX atilde ydieresis -20\r\nKPX b l -10\r\nKPX b lacute -10\r\nKPX b lcommaaccent -10\r\nKPX b lslash -10\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -20\r\nKPX b y -20\r\nKPX b yacute -20\r\nKPX b ydieresis -20\r\nKPX c h -10\r\nKPX c k -20\r\nKPX c kcommaaccent -20\r\nKPX c l -20\r\nKPX c lacute -20\r\nKPX c lcommaaccent -20\r\nKPX c lslash -20\r\nKPX c y -10\r\nKPX c yacute -10\r\nKPX c ydieresis -10\r\nKPX cacute h -10\r\nKPX cacute k -20\r\nKPX cacute kcommaaccent -20\r\nKPX cacute l -20\r\nKPX cacute lacute -20\r\nKPX cacute lcommaaccent -20\r\nKPX cacute lslash -20\r\nKPX cacute y -10\r\nKPX cacute yacute -10\r\nKPX cacute ydieresis -10\r\nKPX ccaron h -10\r\nKPX ccaron k -20\r\nKPX ccaron kcommaaccent -20\r\nKPX ccaron l -20\r\nKPX ccaron lacute -20\r\nKPX ccaron lcommaaccent -20\r\nKPX ccaron lslash -20\r\nKPX ccaron y -10\r\nKPX ccaron yacute -10\r\nKPX ccaron ydieresis -10\r\nKPX ccedilla h -10\r\nKPX ccedilla k -20\r\nKPX ccedilla kcommaaccent -20\r\nKPX ccedilla l -20\r\nKPX ccedilla lacute -20\r\nKPX ccedilla lcommaaccent -20\r\nKPX ccedilla lslash -20\r\nKPX ccedilla y -10\r\nKPX ccedilla yacute -10\r\nKPX ccedilla ydieresis -10\r\nKPX colon space -40\r\nKPX comma quotedblright -120\r\nKPX comma quoteright -120\r\nKPX comma space -40\r\nKPX d d -10\r\nKPX d dcroat -10\r\nKPX d v -15\r\nKPX d w -15\r\nKPX d y -15\r\nKPX d yacute -15\r\nKPX d ydieresis -15\r\nKPX dcroat d -10\r\nKPX dcroat dcroat -10\r\nKPX dcroat v -15\r\nKPX dcroat w -15\r\nKPX dcroat y -15\r\nKPX dcroat yacute -15\r\nKPX dcroat ydieresis -15\r\nKPX e comma 10\r\nKPX e period 20\r\nKPX e v -15\r\nKPX e w -15\r\nKPX e x -15\r\nKPX e y -15\r\nKPX e yacute -15\r\nKPX e ydieresis -15\r\nKPX eacute comma 10\r\nKPX eacute period 20\r\nKPX eacute v -15\r\nKPX eacute w -15\r\nKPX eacute x -15\r\nKPX eacute y -15\r\nKPX eacute yacute -15\r\nKPX eacute ydieresis -15\r\nKPX ecaron comma 10\r\nKPX ecaron period 20\r\nKPX ecaron v -15\r\nKPX ecaron w -15\r\nKPX ecaron x -15\r\nKPX ecaron y -15\r\nKPX ecaron yacute -15\r\nKPX ecaron ydieresis -15\r\nKPX ecircumflex comma 10\r\nKPX ecircumflex period 20\r\nKPX ecircumflex v -15\r\nKPX ecircumflex w -15\r\nKPX ecircumflex x -15\r\nKPX ecircumflex y -15\r\nKPX ecircumflex yacute -15\r\nKPX ecircumflex ydieresis -15\r\nKPX edieresis comma 10\r\nKPX edieresis period 20\r\nKPX edieresis v -15\r\nKPX edieresis w -15\r\nKPX edieresis x -15\r\nKPX edieresis y -15\r\nKPX edieresis yacute -15\r\nKPX edieresis ydieresis -15\r\nKPX edotaccent comma 10\r\nKPX edotaccent period 20\r\nKPX edotaccent v -15\r\nKPX edotaccent w -15\r\nKPX edotaccent x -15\r\nKPX edotaccent y -15\r\nKPX edotaccent yacute -15\r\nKPX edotaccent ydieresis -15\r\nKPX egrave comma 10\r\nKPX egrave period 20\r\nKPX egrave v -15\r\nKPX egrave w -15\r\nKPX egrave x -15\r\nKPX egrave y -15\r\nKPX egrave yacute -15\r\nKPX egrave ydieresis -15\r\nKPX emacron comma 10\r\nKPX emacron period 20\r\nKPX emacron v -15\r\nKPX emacron w -15\r\nKPX emacron x -15\r\nKPX emacron y -15\r\nKPX emacron yacute -15\r\nKPX emacron ydieresis -15\r\nKPX eogonek comma 10\r\nKPX eogonek period 20\r\nKPX eogonek v -15\r\nKPX eogonek w -15\r\nKPX eogonek x -15\r\nKPX eogonek y -15\r\nKPX eogonek yacute -15\r\nKPX eogonek ydieresis -15\r\nKPX f comma -10\r\nKPX f e -10\r\nKPX f eacute -10\r\nKPX f ecaron -10\r\nKPX f ecircumflex -10\r\nKPX f edieresis -10\r\nKPX f edotaccent -10\r\nKPX f egrave -10\r\nKPX f emacron -10\r\nKPX f eogonek -10\r\nKPX f o -20\r\nKPX f oacute -20\r\nKPX f ocircumflex -20\r\nKPX f odieresis -20\r\nKPX f ograve -20\r\nKPX f ohungarumlaut -20\r\nKPX f omacron -20\r\nKPX f oslash -20\r\nKPX f otilde -20\r\nKPX f period -10\r\nKPX f quotedblright 30\r\nKPX f quoteright 30\r\nKPX g e 10\r\nKPX g eacute 10\r\nKPX g ecaron 10\r\nKPX g ecircumflex 10\r\nKPX g edieresis 10\r\nKPX g edotaccent 10\r\nKPX g egrave 10\r\nKPX g emacron 10\r\nKPX g eogonek 10\r\nKPX g g -10\r\nKPX g gbreve -10\r\nKPX g gcommaaccent -10\r\nKPX gbreve e 10\r\nKPX gbreve eacute 10\r\nKPX gbreve ecaron 10\r\nKPX gbreve ecircumflex 10\r\nKPX gbreve edieresis 10\r\nKPX gbreve edotaccent 10\r\nKPX gbreve egrave 10\r\nKPX gbreve emacron 10\r\nKPX gbreve eogonek 10\r\nKPX gbreve g -10\r\nKPX gbreve gbreve -10\r\nKPX gbreve gcommaaccent -10\r\nKPX gcommaaccent e 10\r\nKPX gcommaaccent eacute 10\r\nKPX gcommaaccent ecaron 10\r\nKPX gcommaaccent ecircumflex 10\r\nKPX gcommaaccent edieresis 10\r\nKPX gcommaaccent edotaccent 10\r\nKPX gcommaaccent egrave 10\r\nKPX gcommaaccent emacron 10\r\nKPX gcommaaccent eogonek 10\r\nKPX gcommaaccent g -10\r\nKPX gcommaaccent gbreve -10\r\nKPX gcommaaccent gcommaaccent -10\r\nKPX h y -20\r\nKPX h yacute -20\r\nKPX h ydieresis -20\r\nKPX k o -15\r\nKPX k oacute -15\r\nKPX k ocircumflex -15\r\nKPX k odieresis -15\r\nKPX k ograve -15\r\nKPX k ohungarumlaut -15\r\nKPX k omacron -15\r\nKPX k oslash -15\r\nKPX k otilde -15\r\nKPX kcommaaccent o -15\r\nKPX kcommaaccent oacute -15\r\nKPX kcommaaccent ocircumflex -15\r\nKPX kcommaaccent odieresis -15\r\nKPX kcommaaccent ograve -15\r\nKPX kcommaaccent ohungarumlaut -15\r\nKPX kcommaaccent omacron -15\r\nKPX kcommaaccent oslash -15\r\nKPX kcommaaccent otilde -15\r\nKPX l w -15\r\nKPX l y -15\r\nKPX l yacute -15\r\nKPX l ydieresis -15\r\nKPX lacute w -15\r\nKPX lacute y -15\r\nKPX lacute yacute -15\r\nKPX lacute ydieresis -15\r\nKPX lcommaaccent w -15\r\nKPX lcommaaccent y -15\r\nKPX lcommaaccent yacute -15\r\nKPX lcommaaccent ydieresis -15\r\nKPX lslash w -15\r\nKPX lslash y -15\r\nKPX lslash yacute -15\r\nKPX lslash ydieresis -15\r\nKPX m u -20\r\nKPX m uacute -20\r\nKPX m ucircumflex -20\r\nKPX m udieresis -20\r\nKPX m ugrave -20\r\nKPX m uhungarumlaut -20\r\nKPX m umacron -20\r\nKPX m uogonek -20\r\nKPX m uring -20\r\nKPX m y -30\r\nKPX m yacute -30\r\nKPX m ydieresis -30\r\nKPX n u -10\r\nKPX n uacute -10\r\nKPX n ucircumflex -10\r\nKPX n udieresis -10\r\nKPX n ugrave -10\r\nKPX n uhungarumlaut -10\r\nKPX n umacron -10\r\nKPX n uogonek -10\r\nKPX n uring -10\r\nKPX n v -40\r\nKPX n y -20\r\nKPX n yacute -20\r\nKPX n ydieresis -20\r\nKPX nacute u -10\r\nKPX nacute uacute -10\r\nKPX nacute ucircumflex -10\r\nKPX nacute udieresis -10\r\nKPX nacute ugrave -10\r\nKPX nacute uhungarumlaut -10\r\nKPX nacute umacron -10\r\nKPX nacute uogonek -10\r\nKPX nacute uring -10\r\nKPX nacute v -40\r\nKPX nacute y -20\r\nKPX nacute yacute -20\r\nKPX nacute ydieresis -20\r\nKPX ncaron u -10\r\nKPX ncaron uacute -10\r\nKPX ncaron ucircumflex -10\r\nKPX ncaron udieresis -10\r\nKPX ncaron ugrave -10\r\nKPX ncaron uhungarumlaut -10\r\nKPX ncaron umacron -10\r\nKPX ncaron uogonek -10\r\nKPX ncaron uring -10\r\nKPX ncaron v -40\r\nKPX ncaron y -20\r\nKPX ncaron yacute -20\r\nKPX ncaron ydieresis -20\r\nKPX ncommaaccent u -10\r\nKPX ncommaaccent uacute -10\r\nKPX ncommaaccent ucircumflex -10\r\nKPX ncommaaccent udieresis -10\r\nKPX ncommaaccent ugrave -10\r\nKPX ncommaaccent uhungarumlaut -10\r\nKPX ncommaaccent umacron -10\r\nKPX ncommaaccent uogonek -10\r\nKPX ncommaaccent uring -10\r\nKPX ncommaaccent v -40\r\nKPX ncommaaccent y -20\r\nKPX ncommaaccent yacute -20\r\nKPX ncommaaccent ydieresis -20\r\nKPX ntilde u -10\r\nKPX ntilde uacute -10\r\nKPX ntilde ucircumflex -10\r\nKPX ntilde udieresis -10\r\nKPX ntilde ugrave -10\r\nKPX ntilde uhungarumlaut -10\r\nKPX ntilde umacron -10\r\nKPX ntilde uogonek -10\r\nKPX ntilde uring -10\r\nKPX ntilde v -40\r\nKPX ntilde y -20\r\nKPX ntilde yacute -20\r\nKPX ntilde ydieresis -20\r\nKPX o v -20\r\nKPX o w -15\r\nKPX o x -30\r\nKPX o y -20\r\nKPX o yacute -20\r\nKPX o ydieresis -20\r\nKPX oacute v -20\r\nKPX oacute w -15\r\nKPX oacute x -30\r\nKPX oacute y -20\r\nKPX oacute yacute -20\r\nKPX oacute ydieresis -20\r\nKPX ocircumflex v -20\r\nKPX ocircumflex w -15\r\nKPX ocircumflex x -30\r\nKPX ocircumflex y -20\r\nKPX ocircumflex yacute -20\r\nKPX ocircumflex ydieresis -20\r\nKPX odieresis v -20\r\nKPX odieresis w -15\r\nKPX odieresis x -30\r\nKPX odieresis y -20\r\nKPX odieresis yacute -20\r\nKPX odieresis ydieresis -20\r\nKPX ograve v -20\r\nKPX ograve w -15\r\nKPX ograve x -30\r\nKPX ograve y -20\r\nKPX ograve yacute -20\r\nKPX ograve ydieresis -20\r\nKPX ohungarumlaut v -20\r\nKPX ohungarumlaut w -15\r\nKPX ohungarumlaut x -30\r\nKPX ohungarumlaut y -20\r\nKPX ohungarumlaut yacute -20\r\nKPX ohungarumlaut ydieresis -20\r\nKPX omacron v -20\r\nKPX omacron w -15\r\nKPX omacron x -30\r\nKPX omacron y -20\r\nKPX omacron yacute -20\r\nKPX omacron ydieresis -20\r\nKPX oslash v -20\r\nKPX oslash w -15\r\nKPX oslash x -30\r\nKPX oslash y -20\r\nKPX oslash yacute -20\r\nKPX oslash ydieresis -20\r\nKPX otilde v -20\r\nKPX otilde w -15\r\nKPX otilde x -30\r\nKPX otilde y -20\r\nKPX otilde yacute -20\r\nKPX otilde ydieresis -20\r\nKPX p y -15\r\nKPX p yacute -15\r\nKPX p ydieresis -15\r\nKPX period quotedblright -120\r\nKPX period quoteright -120\r\nKPX period space -40\r\nKPX quotedblright space -80\r\nKPX quoteleft quoteleft -46\r\nKPX quoteright d -80\r\nKPX quoteright dcroat -80\r\nKPX quoteright l -20\r\nKPX quoteright lacute -20\r\nKPX quoteright lcommaaccent -20\r\nKPX quoteright lslash -20\r\nKPX quoteright quoteright -46\r\nKPX quoteright r -40\r\nKPX quoteright racute -40\r\nKPX quoteright rcaron -40\r\nKPX quoteright rcommaaccent -40\r\nKPX quoteright s -60\r\nKPX quoteright sacute -60\r\nKPX quoteright scaron -60\r\nKPX quoteright scedilla -60\r\nKPX quoteright scommaaccent -60\r\nKPX quoteright space -80\r\nKPX quoteright v -20\r\nKPX r c -20\r\nKPX r cacute -20\r\nKPX r ccaron -20\r\nKPX r ccedilla -20\r\nKPX r comma -60\r\nKPX r d -20\r\nKPX r dcroat -20\r\nKPX r g -15\r\nKPX r gbreve -15\r\nKPX r gcommaaccent -15\r\nKPX r hyphen -20\r\nKPX r o -20\r\nKPX r oacute -20\r\nKPX r ocircumflex -20\r\nKPX r odieresis -20\r\nKPX r ograve -20\r\nKPX r ohungarumlaut -20\r\nKPX r omacron -20\r\nKPX r oslash -20\r\nKPX r otilde -20\r\nKPX r period -60\r\nKPX r q -20\r\nKPX r s -15\r\nKPX r sacute -15\r\nKPX r scaron -15\r\nKPX r scedilla -15\r\nKPX r scommaaccent -15\r\nKPX r t 20\r\nKPX r tcommaaccent 20\r\nKPX r v 10\r\nKPX r y 10\r\nKPX r yacute 10\r\nKPX r ydieresis 10\r\nKPX racute c -20\r\nKPX racute cacute -20\r\nKPX racute ccaron -20\r\nKPX racute ccedilla -20\r\nKPX racute comma -60\r\nKPX racute d -20\r\nKPX racute dcroat -20\r\nKPX racute g -15\r\nKPX racute gbreve -15\r\nKPX racute gcommaaccent -15\r\nKPX racute hyphen -20\r\nKPX racute o -20\r\nKPX racute oacute -20\r\nKPX racute ocircumflex -20\r\nKPX racute odieresis -20\r\nKPX racute ograve -20\r\nKPX racute ohungarumlaut -20\r\nKPX racute omacron -20\r\nKPX racute oslash -20\r\nKPX racute otilde -20\r\nKPX racute period -60\r\nKPX racute q -20\r\nKPX racute s -15\r\nKPX racute sacute -15\r\nKPX racute scaron -15\r\nKPX racute scedilla -15\r\nKPX racute scommaaccent -15\r\nKPX racute t 20\r\nKPX racute tcommaaccent 20\r\nKPX racute v 10\r\nKPX racute y 10\r\nKPX racute yacute 10\r\nKPX racute ydieresis 10\r\nKPX rcaron c -20\r\nKPX rcaron cacute -20\r\nKPX rcaron ccaron -20\r\nKPX rcaron ccedilla -20\r\nKPX rcaron comma -60\r\nKPX rcaron d -20\r\nKPX rcaron dcroat -20\r\nKPX rcaron g -15\r\nKPX rcaron gbreve -15\r\nKPX rcaron gcommaaccent -15\r\nKPX rcaron hyphen -20\r\nKPX rcaron o -20\r\nKPX rcaron oacute -20\r\nKPX rcaron ocircumflex -20\r\nKPX rcaron odieresis -20\r\nKPX rcaron ograve -20\r\nKPX rcaron ohungarumlaut -20\r\nKPX rcaron omacron -20\r\nKPX rcaron oslash -20\r\nKPX rcaron otilde -20\r\nKPX rcaron period -60\r\nKPX rcaron q -20\r\nKPX rcaron s -15\r\nKPX rcaron sacute -15\r\nKPX rcaron scaron -15\r\nKPX rcaron scedilla -15\r\nKPX rcaron scommaaccent -15\r\nKPX rcaron t 20\r\nKPX rcaron tcommaaccent 20\r\nKPX rcaron v 10\r\nKPX rcaron y 10\r\nKPX rcaron yacute 10\r\nKPX rcaron ydieresis 10\r\nKPX rcommaaccent c -20\r\nKPX rcommaaccent cacute -20\r\nKPX rcommaaccent ccaron -20\r\nKPX rcommaaccent ccedilla -20\r\nKPX rcommaaccent comma -60\r\nKPX rcommaaccent d -20\r\nKPX rcommaaccent dcroat -20\r\nKPX rcommaaccent g -15\r\nKPX rcommaaccent gbreve -15\r\nKPX rcommaaccent gcommaaccent -15\r\nKPX rcommaaccent hyphen -20\r\nKPX rcommaaccent o -20\r\nKPX rcommaaccent oacute -20\r\nKPX rcommaaccent ocircumflex -20\r\nKPX rcommaaccent odieresis -20\r\nKPX rcommaaccent ograve -20\r\nKPX rcommaaccent ohungarumlaut -20\r\nKPX rcommaaccent omacron -20\r\nKPX rcommaaccent oslash -20\r\nKPX rcommaaccent otilde -20\r\nKPX rcommaaccent period -60\r\nKPX rcommaaccent q -20\r\nKPX rcommaaccent s -15\r\nKPX rcommaaccent sacute -15\r\nKPX rcommaaccent scaron -15\r\nKPX rcommaaccent scedilla -15\r\nKPX rcommaaccent scommaaccent -15\r\nKPX rcommaaccent t 20\r\nKPX rcommaaccent tcommaaccent 20\r\nKPX rcommaaccent v 10\r\nKPX rcommaaccent y 10\r\nKPX rcommaaccent yacute 10\r\nKPX rcommaaccent ydieresis 10\r\nKPX s w -15\r\nKPX sacute w -15\r\nKPX scaron w -15\r\nKPX scedilla w -15\r\nKPX scommaaccent w -15\r\nKPX semicolon space -40\r\nKPX space T -100\r\nKPX space Tcaron -100\r\nKPX space Tcommaaccent -100\r\nKPX space V -80\r\nKPX space W -80\r\nKPX space Y -120\r\nKPX space Yacute -120\r\nKPX space Ydieresis -120\r\nKPX space quotedblleft -80\r\nKPX space quoteleft -60\r\nKPX v a -20\r\nKPX v aacute -20\r\nKPX v abreve -20\r\nKPX v acircumflex -20\r\nKPX v adieresis -20\r\nKPX v agrave -20\r\nKPX v amacron -20\r\nKPX v aogonek -20\r\nKPX v aring -20\r\nKPX v atilde -20\r\nKPX v comma -80\r\nKPX v o -30\r\nKPX v oacute -30\r\nKPX v ocircumflex -30\r\nKPX v odieresis -30\r\nKPX v ograve -30\r\nKPX v ohungarumlaut -30\r\nKPX v omacron -30\r\nKPX v oslash -30\r\nKPX v otilde -30\r\nKPX v period -80\r\nKPX w comma -40\r\nKPX w o -20\r\nKPX w oacute -20\r\nKPX w ocircumflex -20\r\nKPX w odieresis -20\r\nKPX w ograve -20\r\nKPX w ohungarumlaut -20\r\nKPX w omacron -20\r\nKPX w oslash -20\r\nKPX w otilde -20\r\nKPX w period -40\r\nKPX x e -10\r\nKPX x eacute -10\r\nKPX x ecaron -10\r\nKPX x ecircumflex -10\r\nKPX x edieresis -10\r\nKPX x edotaccent -10\r\nKPX x egrave -10\r\nKPX x emacron -10\r\nKPX x eogonek -10\r\nKPX y a -30\r\nKPX y aacute -30\r\nKPX y abreve -30\r\nKPX y acircumflex -30\r\nKPX y adieresis -30\r\nKPX y agrave -30\r\nKPX y amacron -30\r\nKPX y aogonek -30\r\nKPX y aring -30\r\nKPX y atilde -30\r\nKPX y comma -80\r\nKPX y e -10\r\nKPX y eacute -10\r\nKPX y ecaron -10\r\nKPX y ecircumflex -10\r\nKPX y edieresis -10\r\nKPX y edotaccent -10\r\nKPX y egrave -10\r\nKPX y emacron -10\r\nKPX y eogonek -10\r\nKPX y o -25\r\nKPX y oacute -25\r\nKPX y ocircumflex -25\r\nKPX y odieresis -25\r\nKPX y ograve -25\r\nKPX y ohungarumlaut -25\r\nKPX y omacron -25\r\nKPX y oslash -25\r\nKPX y otilde -25\r\nKPX y period -80\r\nKPX yacute a -30\r\nKPX yacute aacute -30\r\nKPX yacute abreve -30\r\nKPX yacute acircumflex -30\r\nKPX yacute adieresis -30\r\nKPX yacute agrave -30\r\nKPX yacute amacron -30\r\nKPX yacute aogonek -30\r\nKPX yacute aring -30\r\nKPX yacute atilde -30\r\nKPX yacute comma -80\r\nKPX yacute e -10\r\nKPX yacute eacute -10\r\nKPX yacute ecaron -10\r\nKPX yacute ecircumflex -10\r\nKPX yacute edieresis -10\r\nKPX yacute edotaccent -10\r\nKPX yacute egrave -10\r\nKPX yacute emacron -10\r\nKPX yacute eogonek -10\r\nKPX yacute o -25\r\nKPX yacute oacute -25\r\nKPX yacute ocircumflex -25\r\nKPX yacute odieresis -25\r\nKPX yacute ograve -25\r\nKPX yacute ohungarumlaut -25\r\nKPX yacute omacron -25\r\nKPX yacute oslash -25\r\nKPX yacute otilde -25\r\nKPX yacute period -80\r\nKPX ydieresis a -30\r\nKPX ydieresis aacute -30\r\nKPX ydieresis abreve -30\r\nKPX ydieresis acircumflex -30\r\nKPX ydieresis adieresis -30\r\nKPX ydieresis agrave -30\r\nKPX ydieresis amacron -30\r\nKPX ydieresis aogonek -30\r\nKPX ydieresis aring -30\r\nKPX ydieresis atilde -30\r\nKPX ydieresis comma -80\r\nKPX ydieresis e -10\r\nKPX ydieresis eacute -10\r\nKPX ydieresis ecaron -10\r\nKPX ydieresis ecircumflex -10\r\nKPX ydieresis edieresis -10\r\nKPX ydieresis edotaccent -10\r\nKPX ydieresis egrave -10\r\nKPX ydieresis emacron -10\r\nKPX ydieresis eogonek -10\r\nKPX ydieresis o -25\r\nKPX ydieresis oacute -25\r\nKPX ydieresis ocircumflex -25\r\nKPX ydieresis odieresis -25\r\nKPX ydieresis ograve -25\r\nKPX ydieresis ohungarumlaut -25\r\nKPX ydieresis omacron -25\r\nKPX ydieresis oslash -25\r\nKPX ydieresis otilde -25\r\nKPX ydieresis period -80\r\nKPX z e 10\r\nKPX z eacute 10\r\nKPX z ecaron 10\r\nKPX z ecircumflex 10\r\nKPX z edieresis 10\r\nKPX z edotaccent 10\r\nKPX z egrave 10\r\nKPX z emacron 10\r\nKPX z eogonek 10\r\nKPX zacute e 10\r\nKPX zacute eacute 10\r\nKPX zacute ecaron 10\r\nKPX zacute ecircumflex 10\r\nKPX zacute edieresis 10\r\nKPX zacute edotaccent 10\r\nKPX zacute egrave 10\r\nKPX zacute emacron 10\r\nKPX zacute eogonek 10\r\nKPX zcaron e 10\r\nKPX zcaron eacute 10\r\nKPX zcaron ecaron 10\r\nKPX zcaron ecircumflex 10\r\nKPX zcaron edieresis 10\r\nKPX zcaron edotaccent 10\r\nKPX zcaron egrave 10\r\nKPX zcaron emacron 10\r\nKPX zcaron eogonek 10\r\nKPX zdotaccent e 10\r\nKPX zdotaccent eacute 10\r\nKPX zdotaccent ecaron 10\r\nKPX zdotaccent ecircumflex 10\r\nKPX zdotaccent edieresis 10\r\nKPX zdotaccent edotaccent 10\r\nKPX zdotaccent egrave 10\r\nKPX zdotaccent emacron 10\r\nKPX zdotaccent eogonek 10\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Times-Roman"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:49:17 1997\r\nComment UniqueID 43068\r\nComment VMusage 43909 54934\r\nFontName Times-Roman\r\nFullName Times Roman\r\nFamilyName Times\r\nWeight Roman\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -168 -218 1000 898 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 662\r\nXHeight 450\r\nAscender 683\r\nDescender -217\r\nStdHW 28\r\nStdVW 84\r\nStartCharMetrics 315\r\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 130 -9 238 676 ;\r\nC 34 ; WX 408 ; N quotedbl ; B 77 431 331 676 ;\r\nC 35 ; WX 500 ; N numbersign ; B 5 0 496 662 ;\r\nC 36 ; WX 500 ; N dollar ; B 44 -87 457 727 ;\r\nC 37 ; WX 833 ; N percent ; B 61 -13 772 676 ;\r\nC 38 ; WX 778 ; N ampersand ; B 42 -13 750 676 ;\r\nC 39 ; WX 333 ; N quoteright ; B 79 433 218 676 ;\r\nC 40 ; WX 333 ; N parenleft ; B 48 -177 304 676 ;\r\nC 41 ; WX 333 ; N parenright ; B 29 -177 285 676 ;\r\nC 42 ; WX 500 ; N asterisk ; B 69 265 432 676 ;\r\nC 43 ; WX 564 ; N plus ; B 30 0 534 506 ;\r\nC 44 ; WX 250 ; N comma ; B 56 -141 195 102 ;\r\nC 45 ; WX 333 ; N hyphen ; B 39 194 285 257 ;\r\nC 46 ; WX 250 ; N period ; B 70 -11 181 100 ;\r\nC 47 ; WX 278 ; N slash ; B -9 -14 287 676 ;\r\nC 48 ; WX 500 ; N zero ; B 24 -14 476 676 ;\r\nC 49 ; WX 500 ; N one ; B 111 0 394 676 ;\r\nC 50 ; WX 500 ; N two ; B 30 0 475 676 ;\r\nC 51 ; WX 500 ; N three ; B 43 -14 431 676 ;\r\nC 52 ; WX 500 ; N four ; B 12 0 472 676 ;\r\nC 53 ; WX 500 ; N five ; B 32 -14 438 688 ;\r\nC 54 ; WX 500 ; N six ; B 34 -14 468 684 ;\r\nC 55 ; WX 500 ; N seven ; B 20 -8 449 662 ;\r\nC 56 ; WX 500 ; N eight ; B 56 -14 445 676 ;\r\nC 57 ; WX 500 ; N nine ; B 30 -22 459 676 ;\r\nC 58 ; WX 278 ; N colon ; B 81 -11 192 459 ;\r\nC 59 ; WX 278 ; N semicolon ; B 80 -141 219 459 ;\r\nC 60 ; WX 564 ; N less ; B 28 -8 536 514 ;\r\nC 61 ; WX 564 ; N equal ; B 30 120 534 386 ;\r\nC 62 ; WX 564 ; N greater ; B 28 -8 536 514 ;\r\nC 63 ; WX 444 ; N question ; B 68 -8 414 676 ;\r\nC 64 ; WX 921 ; N at ; B 116 -14 809 676 ;\r\nC 65 ; WX 722 ; N A ; B 15 0 706 674 ;\r\nC 66 ; WX 667 ; N B ; B 17 0 593 662 ;\r\nC 67 ; WX 667 ; N C ; B 28 -14 633 676 ;\r\nC 68 ; WX 722 ; N D ; B 16 0 685 662 ;\r\nC 69 ; WX 611 ; N E ; B 12 0 597 662 ;\r\nC 70 ; WX 556 ; N F ; B 12 0 546 662 ;\r\nC 71 ; WX 722 ; N G ; B 32 -14 709 676 ;\r\nC 72 ; WX 722 ; N H ; B 19 0 702 662 ;\r\nC 73 ; WX 333 ; N I ; B 18 0 315 662 ;\r\nC 74 ; WX 389 ; N J ; B 10 -14 370 662 ;\r\nC 75 ; WX 722 ; N K ; B 34 0 723 662 ;\r\nC 76 ; WX 611 ; N L ; B 12 0 598 662 ;\r\nC 77 ; WX 889 ; N M ; B 12 0 863 662 ;\r\nC 78 ; WX 722 ; N N ; B 12 -11 707 662 ;\r\nC 79 ; WX 722 ; N O ; B 34 -14 688 676 ;\r\nC 80 ; WX 556 ; N P ; B 16 0 542 662 ;\r\nC 81 ; WX 722 ; N Q ; B 34 -178 701 676 ;\r\nC 82 ; WX 667 ; N R ; B 17 0 659 662 ;\r\nC 83 ; WX 556 ; N S ; B 42 -14 491 676 ;\r\nC 84 ; WX 611 ; N T ; B 17 0 593 662 ;\r\nC 85 ; WX 722 ; N U ; B 14 -14 705 662 ;\r\nC 86 ; WX 722 ; N V ; B 16 -11 697 662 ;\r\nC 87 ; WX 944 ; N W ; B 5 -11 932 662 ;\r\nC 88 ; WX 722 ; N X ; B 10 0 704 662 ;\r\nC 89 ; WX 722 ; N Y ; B 22 0 703 662 ;\r\nC 90 ; WX 611 ; N Z ; B 9 0 597 662 ;\r\nC 91 ; WX 333 ; N bracketleft ; B 88 -156 299 662 ;\r\nC 92 ; WX 278 ; N backslash ; B -9 -14 287 676 ;\r\nC 93 ; WX 333 ; N bracketright ; B 34 -156 245 662 ;\r\nC 94 ; WX 469 ; N asciicircum ; B 24 297 446 662 ;\r\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\r\nC 96 ; WX 333 ; N quoteleft ; B 115 433 254 676 ;\r\nC 97 ; WX 444 ; N a ; B 37 -10 442 460 ;\r\nC 98 ; WX 500 ; N b ; B 3 -10 468 683 ;\r\nC 99 ; WX 444 ; N c ; B 25 -10 412 460 ;\r\nC 100 ; WX 500 ; N d ; B 27 -10 491 683 ;\r\nC 101 ; WX 444 ; N e ; B 25 -10 424 460 ;\r\nC 102 ; WX 333 ; N f ; B 20 0 383 683 ; L i fi ; L l fl ;\r\nC 103 ; WX 500 ; N g ; B 28 -218 470 460 ;\r\nC 104 ; WX 500 ; N h ; B 9 0 487 683 ;\r\nC 105 ; WX 278 ; N i ; B 16 0 253 683 ;\r\nC 106 ; WX 278 ; N j ; B -70 -218 194 683 ;\r\nC 107 ; WX 500 ; N k ; B 7 0 505 683 ;\r\nC 108 ; WX 278 ; N l ; B 19 0 257 683 ;\r\nC 109 ; WX 778 ; N m ; B 16 0 775 460 ;\r\nC 110 ; WX 500 ; N n ; B 16 0 485 460 ;\r\nC 111 ; WX 500 ; N o ; B 29 -10 470 460 ;\r\nC 112 ; WX 500 ; N p ; B 5 -217 470 460 ;\r\nC 113 ; WX 500 ; N q ; B 24 -217 488 460 ;\r\nC 114 ; WX 333 ; N r ; B 5 0 335 460 ;\r\nC 115 ; WX 389 ; N s ; B 51 -10 348 460 ;\r\nC 116 ; WX 278 ; N t ; B 13 -10 279 579 ;\r\nC 117 ; WX 500 ; N u ; B 9 -10 479 450 ;\r\nC 118 ; WX 500 ; N v ; B 19 -14 477 450 ;\r\nC 119 ; WX 722 ; N w ; B 21 -14 694 450 ;\r\nC 120 ; WX 500 ; N x ; B 17 0 479 450 ;\r\nC 121 ; WX 500 ; N y ; B 14 -218 475 450 ;\r\nC 122 ; WX 444 ; N z ; B 27 0 418 450 ;\r\nC 123 ; WX 480 ; N braceleft ; B 100 -181 350 680 ;\r\nC 124 ; WX 200 ; N bar ; B 67 -218 133 782 ;\r\nC 125 ; WX 480 ; N braceright ; B 130 -181 380 680 ;\r\nC 126 ; WX 541 ; N asciitilde ; B 40 183 502 323 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 97 -218 205 467 ;\r\nC 162 ; WX 500 ; N cent ; B 53 -138 448 579 ;\r\nC 163 ; WX 500 ; N sterling ; B 12 -8 490 676 ;\r\nC 164 ; WX 167 ; N fraction ; B -168 -14 331 676 ;\r\nC 165 ; WX 500 ; N yen ; B -53 0 512 662 ;\r\nC 166 ; WX 500 ; N florin ; B 7 -189 490 676 ;\r\nC 167 ; WX 500 ; N section ; B 70 -148 426 676 ;\r\nC 168 ; WX 500 ; N currency ; B -22 58 522 602 ;\r\nC 169 ; WX 180 ; N quotesingle ; B 48 431 133 676 ;\r\nC 170 ; WX 444 ; N quotedblleft ; B 43 433 414 676 ;\r\nC 171 ; WX 500 ; N guillemotleft ; B 42 33 456 416 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 63 33 285 416 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 48 33 270 416 ;\r\nC 174 ; WX 556 ; N fi ; B 31 0 521 683 ;\r\nC 175 ; WX 556 ; N fl ; B 32 0 521 683 ;\r\nC 177 ; WX 500 ; N endash ; B 0 201 500 250 ;\r\nC 178 ; WX 500 ; N dagger ; B 59 -149 442 676 ;\r\nC 179 ; WX 500 ; N daggerdbl ; B 58 -153 442 676 ;\r\nC 180 ; WX 250 ; N periodcentered ; B 70 199 181 310 ;\r\nC 182 ; WX 453 ; N paragraph ; B -22 -154 450 662 ;\r\nC 183 ; WX 350 ; N bullet ; B 40 196 310 466 ;\r\nC 184 ; WX 333 ; N quotesinglbase ; B 79 -141 218 102 ;\r\nC 185 ; WX 444 ; N quotedblbase ; B 45 -141 416 102 ;\r\nC 186 ; WX 444 ; N quotedblright ; B 30 433 401 676 ;\r\nC 187 ; WX 500 ; N guillemotright ; B 44 33 458 416 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 111 -11 888 100 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 7 -19 994 706 ;\r\nC 191 ; WX 444 ; N questiondown ; B 30 -218 376 466 ;\r\nC 193 ; WX 333 ; N grave ; B 19 507 242 678 ;\r\nC 194 ; WX 333 ; N acute ; B 93 507 317 678 ;\r\nC 195 ; WX 333 ; N circumflex ; B 11 507 322 674 ;\r\nC 196 ; WX 333 ; N tilde ; B 1 532 331 638 ;\r\nC 197 ; WX 333 ; N macron ; B 11 547 322 601 ;\r\nC 198 ; WX 333 ; N breve ; B 26 507 307 664 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 118 581 216 681 ;\r\nC 200 ; WX 333 ; N dieresis ; B 18 581 315 681 ;\r\nC 202 ; WX 333 ; N ring ; B 67 512 266 711 ;\r\nC 203 ; WX 333 ; N cedilla ; B 52 -215 261 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B -3 507 377 678 ;\r\nC 206 ; WX 333 ; N ogonek ; B 62 -165 243 0 ;\r\nC 207 ; WX 333 ; N caron ; B 11 507 322 674 ;\r\nC 208 ; WX 1000 ; N emdash ; B 0 201 1000 250 ;\r\nC 225 ; WX 889 ; N AE ; B 0 0 863 662 ;\r\nC 227 ; WX 276 ; N ordfeminine ; B 4 394 270 676 ;\r\nC 232 ; WX 611 ; N Lslash ; B 12 0 598 662 ;\r\nC 233 ; WX 722 ; N Oslash ; B 34 -80 688 734 ;\r\nC 234 ; WX 889 ; N OE ; B 30 -6 885 668 ;\r\nC 235 ; WX 310 ; N ordmasculine ; B 6 394 304 676 ;\r\nC 241 ; WX 667 ; N ae ; B 38 -10 632 460 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 16 0 253 460 ;\r\nC 248 ; WX 278 ; N lslash ; B 19 0 259 683 ;\r\nC 249 ; WX 500 ; N oslash ; B 29 -112 470 551 ;\r\nC 250 ; WX 722 ; N oe ; B 30 -10 690 460 ;\r\nC 251 ; WX 500 ; N germandbls ; B 12 -9 468 683 ;\r\nC -1 ; WX 333 ; N Idieresis ; B 18 0 315 835 ;\r\nC -1 ; WX 444 ; N eacute ; B 25 -10 424 678 ;\r\nC -1 ; WX 444 ; N abreve ; B 37 -10 442 664 ;\r\nC -1 ; WX 500 ; N uhungarumlaut ; B 9 -10 501 678 ;\r\nC -1 ; WX 444 ; N ecaron ; B 25 -10 424 674 ;\r\nC -1 ; WX 722 ; N Ydieresis ; B 22 0 703 835 ;\r\nC -1 ; WX 564 ; N divide ; B 30 -10 534 516 ;\r\nC -1 ; WX 722 ; N Yacute ; B 22 0 703 890 ;\r\nC -1 ; WX 722 ; N Acircumflex ; B 15 0 706 886 ;\r\nC -1 ; WX 444 ; N aacute ; B 37 -10 442 678 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 14 -14 705 886 ;\r\nC -1 ; WX 500 ; N yacute ; B 14 -218 475 678 ;\r\nC -1 ; WX 389 ; N scommaaccent ; B 51 -218 348 460 ;\r\nC -1 ; WX 444 ; N ecircumflex ; B 25 -10 424 674 ;\r\nC -1 ; WX 722 ; N Uring ; B 14 -14 705 898 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 14 -14 705 835 ;\r\nC -1 ; WX 444 ; N aogonek ; B 37 -165 469 460 ;\r\nC -1 ; WX 722 ; N Uacute ; B 14 -14 705 890 ;\r\nC -1 ; WX 500 ; N uogonek ; B 9 -155 487 450 ;\r\nC -1 ; WX 611 ; N Edieresis ; B 12 0 597 835 ;\r\nC -1 ; WX 722 ; N Dcroat ; B 16 0 685 662 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 59 -218 184 -50 ;\r\nC -1 ; WX 760 ; N copyright ; B 38 -14 722 676 ;\r\nC -1 ; WX 611 ; N Emacron ; B 12 0 597 813 ;\r\nC -1 ; WX 444 ; N ccaron ; B 25 -10 412 674 ;\r\nC -1 ; WX 444 ; N aring ; B 37 -10 442 711 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 12 -198 707 662 ;\r\nC -1 ; WX 278 ; N lacute ; B 19 0 290 890 ;\r\nC -1 ; WX 444 ; N agrave ; B 37 -10 442 678 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 17 -218 593 662 ;\r\nC -1 ; WX 667 ; N Cacute ; B 28 -14 633 890 ;\r\nC -1 ; WX 444 ; N atilde ; B 37 -10 442 638 ;\r\nC -1 ; WX 611 ; N Edotaccent ; B 12 0 597 835 ;\r\nC -1 ; WX 389 ; N scaron ; B 39 -10 350 674 ;\r\nC -1 ; WX 389 ; N scedilla ; B 51 -215 348 460 ;\r\nC -1 ; WX 278 ; N iacute ; B 16 0 290 678 ;\r\nC -1 ; WX 471 ; N lozenge ; B 13 0 459 724 ;\r\nC -1 ; WX 667 ; N Rcaron ; B 17 0 659 886 ;\r\nC -1 ; WX 722 ; N Gcommaaccent ; B 32 -218 709 676 ;\r\nC -1 ; WX 500 ; N ucircumflex ; B 9 -10 479 674 ;\r\nC -1 ; WX 444 ; N acircumflex ; B 37 -10 442 674 ;\r\nC -1 ; WX 722 ; N Amacron ; B 15 0 706 813 ;\r\nC -1 ; WX 333 ; N rcaron ; B 5 0 335 674 ;\r\nC -1 ; WX 444 ; N ccedilla ; B 25 -215 412 460 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B 9 0 597 835 ;\r\nC -1 ; WX 556 ; N Thorn ; B 16 0 542 662 ;\r\nC -1 ; WX 722 ; N Omacron ; B 34 -14 688 813 ;\r\nC -1 ; WX 667 ; N Racute ; B 17 0 659 890 ;\r\nC -1 ; WX 556 ; N Sacute ; B 42 -14 491 890 ;\r\nC -1 ; WX 588 ; N dcaron ; B 27 -10 589 695 ;\r\nC -1 ; WX 722 ; N Umacron ; B 14 -14 705 813 ;\r\nC -1 ; WX 500 ; N uring ; B 9 -10 479 711 ;\r\nC -1 ; WX 300 ; N threesuperior ; B 15 262 291 676 ;\r\nC -1 ; WX 722 ; N Ograve ; B 34 -14 688 890 ;\r\nC -1 ; WX 722 ; N Agrave ; B 15 0 706 890 ;\r\nC -1 ; WX 722 ; N Abreve ; B 15 0 706 876 ;\r\nC -1 ; WX 564 ; N multiply ; B 38 8 527 497 ;\r\nC -1 ; WX 500 ; N uacute ; B 9 -10 479 678 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 17 0 593 886 ;\r\nC -1 ; WX 476 ; N partialdiff ; B 17 -38 459 710 ;\r\nC -1 ; WX 500 ; N ydieresis ; B 14 -218 475 623 ;\r\nC -1 ; WX 722 ; N Nacute ; B 12 -11 707 890 ;\r\nC -1 ; WX 278 ; N icircumflex ; B -16 0 295 674 ;\r\nC -1 ; WX 611 ; N Ecircumflex ; B 12 0 597 886 ;\r\nC -1 ; WX 444 ; N adieresis ; B 37 -10 442 623 ;\r\nC -1 ; WX 444 ; N edieresis ; B 25 -10 424 623 ;\r\nC -1 ; WX 444 ; N cacute ; B 25 -10 413 678 ;\r\nC -1 ; WX 500 ; N nacute ; B 16 0 485 678 ;\r\nC -1 ; WX 500 ; N umacron ; B 9 -10 479 601 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 12 -11 707 886 ;\r\nC -1 ; WX 333 ; N Iacute ; B 18 0 317 890 ;\r\nC -1 ; WX 564 ; N plusminus ; B 30 0 534 506 ;\r\nC -1 ; WX 200 ; N brokenbar ; B 67 -143 133 707 ;\r\nC -1 ; WX 760 ; N registered ; B 38 -14 722 676 ;\r\nC -1 ; WX 722 ; N Gbreve ; B 32 -14 709 876 ;\r\nC -1 ; WX 333 ; N Idotaccent ; B 18 0 315 835 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\r\nC -1 ; WX 611 ; N Egrave ; B 12 0 597 890 ;\r\nC -1 ; WX 333 ; N racute ; B 5 0 335 678 ;\r\nC -1 ; WX 500 ; N omacron ; B 29 -10 470 601 ;\r\nC -1 ; WX 611 ; N Zacute ; B 9 0 597 890 ;\r\nC -1 ; WX 611 ; N Zcaron ; B 9 0 597 886 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 666 ;\r\nC -1 ; WX 722 ; N Eth ; B 16 0 685 662 ;\r\nC -1 ; WX 667 ; N Ccedilla ; B 28 -215 633 676 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B 19 -218 257 683 ;\r\nC -1 ; WX 326 ; N tcaron ; B 13 -10 318 722 ;\r\nC -1 ; WX 444 ; N eogonek ; B 25 -165 424 460 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 14 -165 705 662 ;\r\nC -1 ; WX 722 ; N Aacute ; B 15 0 706 890 ;\r\nC -1 ; WX 722 ; N Adieresis ; B 15 0 706 835 ;\r\nC -1 ; WX 444 ; N egrave ; B 25 -10 424 678 ;\r\nC -1 ; WX 444 ; N zacute ; B 27 0 418 678 ;\r\nC -1 ; WX 278 ; N iogonek ; B 16 -165 265 683 ;\r\nC -1 ; WX 722 ; N Oacute ; B 34 -14 688 890 ;\r\nC -1 ; WX 500 ; N oacute ; B 29 -10 470 678 ;\r\nC -1 ; WX 444 ; N amacron ; B 37 -10 442 601 ;\r\nC -1 ; WX 389 ; N sacute ; B 51 -10 348 678 ;\r\nC -1 ; WX 278 ; N idieresis ; B -9 0 288 623 ;\r\nC -1 ; WX 722 ; N Ocircumflex ; B 34 -14 688 886 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 14 -14 705 890 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 500 ; N thorn ; B 5 -217 470 683 ;\r\nC -1 ; WX 300 ; N twosuperior ; B 1 270 296 676 ;\r\nC -1 ; WX 722 ; N Odieresis ; B 34 -14 688 835 ;\r\nC -1 ; WX 500 ; N mu ; B 36 -218 512 450 ;\r\nC -1 ; WX 278 ; N igrave ; B -8 0 253 678 ;\r\nC -1 ; WX 500 ; N ohungarumlaut ; B 29 -10 491 678 ;\r\nC -1 ; WX 611 ; N Eogonek ; B 12 -165 597 662 ;\r\nC -1 ; WX 500 ; N dcroat ; B 27 -10 500 683 ;\r\nC -1 ; WX 750 ; N threequarters ; B 15 -14 718 676 ;\r\nC -1 ; WX 556 ; N Scedilla ; B 42 -215 491 676 ;\r\nC -1 ; WX 344 ; N lcaron ; B 19 0 347 695 ;\r\nC -1 ; WX 722 ; N Kcommaaccent ; B 34 -198 723 662 ;\r\nC -1 ; WX 611 ; N Lacute ; B 12 0 598 890 ;\r\nC -1 ; WX 980 ; N trademark ; B 30 256 957 662 ;\r\nC -1 ; WX 444 ; N edotaccent ; B 25 -10 424 623 ;\r\nC -1 ; WX 333 ; N Igrave ; B 18 0 315 890 ;\r\nC -1 ; WX 333 ; N Imacron ; B 11 0 322 813 ;\r\nC -1 ; WX 611 ; N Lcaron ; B 12 0 598 676 ;\r\nC -1 ; WX 750 ; N onehalf ; B 31 -14 746 676 ;\r\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 666 ;\r\nC -1 ; WX 500 ; N ocircumflex ; B 29 -10 470 674 ;\r\nC -1 ; WX 500 ; N ntilde ; B 16 0 485 638 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 14 -14 705 890 ;\r\nC -1 ; WX 611 ; N Eacute ; B 12 0 597 890 ;\r\nC -1 ; WX 444 ; N emacron ; B 25 -10 424 601 ;\r\nC -1 ; WX 500 ; N gbreve ; B 28 -218 470 664 ;\r\nC -1 ; WX 750 ; N onequarter ; B 37 -14 718 676 ;\r\nC -1 ; WX 556 ; N Scaron ; B 42 -14 491 886 ;\r\nC -1 ; WX 556 ; N Scommaaccent ; B 42 -218 491 676 ;\r\nC -1 ; WX 722 ; N Ohungarumlaut ; B 34 -14 688 890 ;\r\nC -1 ; WX 400 ; N degree ; B 57 390 343 676 ;\r\nC -1 ; WX 500 ; N ograve ; B 29 -10 470 678 ;\r\nC -1 ; WX 667 ; N Ccaron ; B 28 -14 633 886 ;\r\nC -1 ; WX 500 ; N ugrave ; B 9 -10 479 678 ;\r\nC -1 ; WX 453 ; N radical ; B 2 -60 452 768 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 16 0 685 886 ;\r\nC -1 ; WX 333 ; N rcommaaccent ; B 5 -218 335 460 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 12 -11 707 850 ;\r\nC -1 ; WX 500 ; N otilde ; B 29 -10 470 638 ;\r\nC -1 ; WX 667 ; N Rcommaaccent ; B 17 -198 659 662 ;\r\nC -1 ; WX 611 ; N Lcommaaccent ; B 12 -218 598 662 ;\r\nC -1 ; WX 722 ; N Atilde ; B 15 0 706 850 ;\r\nC -1 ; WX 722 ; N Aogonek ; B 15 -165 738 674 ;\r\nC -1 ; WX 722 ; N Aring ; B 15 0 706 898 ;\r\nC -1 ; WX 722 ; N Otilde ; B 34 -14 688 850 ;\r\nC -1 ; WX 444 ; N zdotaccent ; B 27 0 418 623 ;\r\nC -1 ; WX 611 ; N Ecaron ; B 12 0 597 886 ;\r\nC -1 ; WX 333 ; N Iogonek ; B 18 -165 315 662 ;\r\nC -1 ; WX 500 ; N kcommaaccent ; B 7 -218 505 683 ;\r\nC -1 ; WX 564 ; N minus ; B 30 220 534 286 ;\r\nC -1 ; WX 333 ; N Icircumflex ; B 11 0 322 886 ;\r\nC -1 ; WX 500 ; N ncaron ; B 16 0 485 674 ;\r\nC -1 ; WX 278 ; N tcommaaccent ; B 13 -218 279 579 ;\r\nC -1 ; WX 564 ; N logicalnot ; B 30 108 534 386 ;\r\nC -1 ; WX 500 ; N odieresis ; B 29 -10 470 623 ;\r\nC -1 ; WX 500 ; N udieresis ; B 9 -10 479 623 ;\r\nC -1 ; WX 549 ; N notequal ; B 12 -31 537 547 ;\r\nC -1 ; WX 500 ; N gcommaaccent ; B 28 -218 470 749 ;\r\nC -1 ; WX 500 ; N eth ; B 29 -10 471 686 ;\r\nC -1 ; WX 444 ; N zcaron ; B 27 0 418 674 ;\r\nC -1 ; WX 500 ; N ncommaaccent ; B 16 -218 485 460 ;\r\nC -1 ; WX 300 ; N onesuperior ; B 57 270 248 676 ;\r\nC -1 ; WX 278 ; N imacron ; B 6 0 271 601 ;\r\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2073\r\nKPX A C -40\r\nKPX A Cacute -40\r\nKPX A Ccaron -40\r\nKPX A Ccedilla -40\r\nKPX A G -40\r\nKPX A Gbreve -40\r\nKPX A Gcommaaccent -40\r\nKPX A O -55\r\nKPX A Oacute -55\r\nKPX A Ocircumflex -55\r\nKPX A Odieresis -55\r\nKPX A Ograve -55\r\nKPX A Ohungarumlaut -55\r\nKPX A Omacron -55\r\nKPX A Oslash -55\r\nKPX A Otilde -55\r\nKPX A Q -55\r\nKPX A T -111\r\nKPX A Tcaron -111\r\nKPX A Tcommaaccent -111\r\nKPX A U -55\r\nKPX A Uacute -55\r\nKPX A Ucircumflex -55\r\nKPX A Udieresis -55\r\nKPX A Ugrave -55\r\nKPX A Uhungarumlaut -55\r\nKPX A Umacron -55\r\nKPX A Uogonek -55\r\nKPX A Uring -55\r\nKPX A V -135\r\nKPX A W -90\r\nKPX A Y -105\r\nKPX A Yacute -105\r\nKPX A Ydieresis -105\r\nKPX A quoteright -111\r\nKPX A v -74\r\nKPX A w -92\r\nKPX A y -92\r\nKPX A yacute -92\r\nKPX A ydieresis -92\r\nKPX Aacute C -40\r\nKPX Aacute Cacute -40\r\nKPX Aacute Ccaron -40\r\nKPX Aacute Ccedilla -40\r\nKPX Aacute G -40\r\nKPX Aacute Gbreve -40\r\nKPX Aacute Gcommaaccent -40\r\nKPX Aacute O -55\r\nKPX Aacute Oacute -55\r\nKPX Aacute Ocircumflex -55\r\nKPX Aacute Odieresis -55\r\nKPX Aacute Ograve -55\r\nKPX Aacute Ohungarumlaut -55\r\nKPX Aacute Omacron -55\r\nKPX Aacute Oslash -55\r\nKPX Aacute Otilde -55\r\nKPX Aacute Q -55\r\nKPX Aacute T -111\r\nKPX Aacute Tcaron -111\r\nKPX Aacute Tcommaaccent -111\r\nKPX Aacute U -55\r\nKPX Aacute Uacute -55\r\nKPX Aacute Ucircumflex -55\r\nKPX Aacute Udieresis -55\r\nKPX Aacute Ugrave -55\r\nKPX Aacute Uhungarumlaut -55\r\nKPX Aacute Umacron -55\r\nKPX Aacute Uogonek -55\r\nKPX Aacute Uring -55\r\nKPX Aacute V -135\r\nKPX Aacute W -90\r\nKPX Aacute Y -105\r\nKPX Aacute Yacute -105\r\nKPX Aacute Ydieresis -105\r\nKPX Aacute quoteright -111\r\nKPX Aacute v -74\r\nKPX Aacute w -92\r\nKPX Aacute y -92\r\nKPX Aacute yacute -92\r\nKPX Aacute ydieresis -92\r\nKPX Abreve C -40\r\nKPX Abreve Cacute -40\r\nKPX Abreve Ccaron -40\r\nKPX Abreve Ccedilla -40\r\nKPX Abreve G -40\r\nKPX Abreve Gbreve -40\r\nKPX Abreve Gcommaaccent -40\r\nKPX Abreve O -55\r\nKPX Abreve Oacute -55\r\nKPX Abreve Ocircumflex -55\r\nKPX Abreve Odieresis -55\r\nKPX Abreve Ograve -55\r\nKPX Abreve Ohungarumlaut -55\r\nKPX Abreve Omacron -55\r\nKPX Abreve Oslash -55\r\nKPX Abreve Otilde -55\r\nKPX Abreve Q -55\r\nKPX Abreve T -111\r\nKPX Abreve Tcaron -111\r\nKPX Abreve Tcommaaccent -111\r\nKPX Abreve U -55\r\nKPX Abreve Uacute -55\r\nKPX Abreve Ucircumflex -55\r\nKPX Abreve Udieresis -55\r\nKPX Abreve Ugrave -55\r\nKPX Abreve Uhungarumlaut -55\r\nKPX Abreve Umacron -55\r\nKPX Abreve Uogonek -55\r\nKPX Abreve Uring -55\r\nKPX Abreve V -135\r\nKPX Abreve W -90\r\nKPX Abreve Y -105\r\nKPX Abreve Yacute -105\r\nKPX Abreve Ydieresis -105\r\nKPX Abreve quoteright -111\r\nKPX Abreve v -74\r\nKPX Abreve w -92\r\nKPX Abreve y -92\r\nKPX Abreve yacute -92\r\nKPX Abreve ydieresis -92\r\nKPX Acircumflex C -40\r\nKPX Acircumflex Cacute -40\r\nKPX Acircumflex Ccaron -40\r\nKPX Acircumflex Ccedilla -40\r\nKPX Acircumflex G -40\r\nKPX Acircumflex Gbreve -40\r\nKPX Acircumflex Gcommaaccent -40\r\nKPX Acircumflex O -55\r\nKPX Acircumflex Oacute -55\r\nKPX Acircumflex Ocircumflex -55\r\nKPX Acircumflex Odieresis -55\r\nKPX Acircumflex Ograve -55\r\nKPX Acircumflex Ohungarumlaut -55\r\nKPX Acircumflex Omacron -55\r\nKPX Acircumflex Oslash -55\r\nKPX Acircumflex Otilde -55\r\nKPX Acircumflex Q -55\r\nKPX Acircumflex T -111\r\nKPX Acircumflex Tcaron -111\r\nKPX Acircumflex Tcommaaccent -111\r\nKPX Acircumflex U -55\r\nKPX Acircumflex Uacute -55\r\nKPX Acircumflex Ucircumflex -55\r\nKPX Acircumflex Udieresis -55\r\nKPX Acircumflex Ugrave -55\r\nKPX Acircumflex Uhungarumlaut -55\r\nKPX Acircumflex Umacron -55\r\nKPX Acircumflex Uogonek -55\r\nKPX Acircumflex Uring -55\r\nKPX Acircumflex V -135\r\nKPX Acircumflex W -90\r\nKPX Acircumflex Y -105\r\nKPX Acircumflex Yacute -105\r\nKPX Acircumflex Ydieresis -105\r\nKPX Acircumflex quoteright -111\r\nKPX Acircumflex v -74\r\nKPX Acircumflex w -92\r\nKPX Acircumflex y -92\r\nKPX Acircumflex yacute -92\r\nKPX Acircumflex ydieresis -92\r\nKPX Adieresis C -40\r\nKPX Adieresis Cacute -40\r\nKPX Adieresis Ccaron -40\r\nKPX Adieresis Ccedilla -40\r\nKPX Adieresis G -40\r\nKPX Adieresis Gbreve -40\r\nKPX Adieresis Gcommaaccent -40\r\nKPX Adieresis O -55\r\nKPX Adieresis Oacute -55\r\nKPX Adieresis Ocircumflex -55\r\nKPX Adieresis Odieresis -55\r\nKPX Adieresis Ograve -55\r\nKPX Adieresis Ohungarumlaut -55\r\nKPX Adieresis Omacron -55\r\nKPX Adieresis Oslash -55\r\nKPX Adieresis Otilde -55\r\nKPX Adieresis Q -55\r\nKPX Adieresis T -111\r\nKPX Adieresis Tcaron -111\r\nKPX Adieresis Tcommaaccent -111\r\nKPX Adieresis U -55\r\nKPX Adieresis Uacute -55\r\nKPX Adieresis Ucircumflex -55\r\nKPX Adieresis Udieresis -55\r\nKPX Adieresis Ugrave -55\r\nKPX Adieresis Uhungarumlaut -55\r\nKPX Adieresis Umacron -55\r\nKPX Adieresis Uogonek -55\r\nKPX Adieresis Uring -55\r\nKPX Adieresis V -135\r\nKPX Adieresis W -90\r\nKPX Adieresis Y -105\r\nKPX Adieresis Yacute -105\r\nKPX Adieresis Ydieresis -105\r\nKPX Adieresis quoteright -111\r\nKPX Adieresis v -74\r\nKPX Adieresis w -92\r\nKPX Adieresis y -92\r\nKPX Adieresis yacute -92\r\nKPX Adieresis ydieresis -92\r\nKPX Agrave C -40\r\nKPX Agrave Cacute -40\r\nKPX Agrave Ccaron -40\r\nKPX Agrave Ccedilla -40\r\nKPX Agrave G -40\r\nKPX Agrave Gbreve -40\r\nKPX Agrave Gcommaaccent -40\r\nKPX Agrave O -55\r\nKPX Agrave Oacute -55\r\nKPX Agrave Ocircumflex -55\r\nKPX Agrave Odieresis -55\r\nKPX Agrave Ograve -55\r\nKPX Agrave Ohungarumlaut -55\r\nKPX Agrave Omacron -55\r\nKPX Agrave Oslash -55\r\nKPX Agrave Otilde -55\r\nKPX Agrave Q -55\r\nKPX Agrave T -111\r\nKPX Agrave Tcaron -111\r\nKPX Agrave Tcommaaccent -111\r\nKPX Agrave U -55\r\nKPX Agrave Uacute -55\r\nKPX Agrave Ucircumflex -55\r\nKPX Agrave Udieresis -55\r\nKPX Agrave Ugrave -55\r\nKPX Agrave Uhungarumlaut -55\r\nKPX Agrave Umacron -55\r\nKPX Agrave Uogonek -55\r\nKPX Agrave Uring -55\r\nKPX Agrave V -135\r\nKPX Agrave W -90\r\nKPX Agrave Y -105\r\nKPX Agrave Yacute -105\r\nKPX Agrave Ydieresis -105\r\nKPX Agrave quoteright -111\r\nKPX Agrave v -74\r\nKPX Agrave w -92\r\nKPX Agrave y -92\r\nKPX Agrave yacute -92\r\nKPX Agrave ydieresis -92\r\nKPX Amacron C -40\r\nKPX Amacron Cacute -40\r\nKPX Amacron Ccaron -40\r\nKPX Amacron Ccedilla -40\r\nKPX Amacron G -40\r\nKPX Amacron Gbreve -40\r\nKPX Amacron Gcommaaccent -40\r\nKPX Amacron O -55\r\nKPX Amacron Oacute -55\r\nKPX Amacron Ocircumflex -55\r\nKPX Amacron Odieresis -55\r\nKPX Amacron Ograve -55\r\nKPX Amacron Ohungarumlaut -55\r\nKPX Amacron Omacron -55\r\nKPX Amacron Oslash -55\r\nKPX Amacron Otilde -55\r\nKPX Amacron Q -55\r\nKPX Amacron T -111\r\nKPX Amacron Tcaron -111\r\nKPX Amacron Tcommaaccent -111\r\nKPX Amacron U -55\r\nKPX Amacron Uacute -55\r\nKPX Amacron Ucircumflex -55\r\nKPX Amacron Udieresis -55\r\nKPX Amacron Ugrave -55\r\nKPX Amacron Uhungarumlaut -55\r\nKPX Amacron Umacron -55\r\nKPX Amacron Uogonek -55\r\nKPX Amacron Uring -55\r\nKPX Amacron V -135\r\nKPX Amacron W -90\r\nKPX Amacron Y -105\r\nKPX Amacron Yacute -105\r\nKPX Amacron Ydieresis -105\r\nKPX Amacron quoteright -111\r\nKPX Amacron v -74\r\nKPX Amacron w -92\r\nKPX Amacron y -92\r\nKPX Amacron yacute -92\r\nKPX Amacron ydieresis -92\r\nKPX Aogonek C -40\r\nKPX Aogonek Cacute -40\r\nKPX Aogonek Ccaron -40\r\nKPX Aogonek Ccedilla -40\r\nKPX Aogonek G -40\r\nKPX Aogonek Gbreve -40\r\nKPX Aogonek Gcommaaccent -40\r\nKPX Aogonek O -55\r\nKPX Aogonek Oacute -55\r\nKPX Aogonek Ocircumflex -55\r\nKPX Aogonek Odieresis -55\r\nKPX Aogonek Ograve -55\r\nKPX Aogonek Ohungarumlaut -55\r\nKPX Aogonek Omacron -55\r\nKPX Aogonek Oslash -55\r\nKPX Aogonek Otilde -55\r\nKPX Aogonek Q -55\r\nKPX Aogonek T -111\r\nKPX Aogonek Tcaron -111\r\nKPX Aogonek Tcommaaccent -111\r\nKPX Aogonek U -55\r\nKPX Aogonek Uacute -55\r\nKPX Aogonek Ucircumflex -55\r\nKPX Aogonek Udieresis -55\r\nKPX Aogonek Ugrave -55\r\nKPX Aogonek Uhungarumlaut -55\r\nKPX Aogonek Umacron -55\r\nKPX Aogonek Uogonek -55\r\nKPX Aogonek Uring -55\r\nKPX Aogonek V -135\r\nKPX Aogonek W -90\r\nKPX Aogonek Y -105\r\nKPX Aogonek Yacute -105\r\nKPX Aogonek Ydieresis -105\r\nKPX Aogonek quoteright -111\r\nKPX Aogonek v -74\r\nKPX Aogonek w -52\r\nKPX Aogonek y -52\r\nKPX Aogonek yacute -52\r\nKPX Aogonek ydieresis -52\r\nKPX Aring C -40\r\nKPX Aring Cacute -40\r\nKPX Aring Ccaron -40\r\nKPX Aring Ccedilla -40\r\nKPX Aring G -40\r\nKPX Aring Gbreve -40\r\nKPX Aring Gcommaaccent -40\r\nKPX Aring O -55\r\nKPX Aring Oacute -55\r\nKPX Aring Ocircumflex -55\r\nKPX Aring Odieresis -55\r\nKPX Aring Ograve -55\r\nKPX Aring Ohungarumlaut -55\r\nKPX Aring Omacron -55\r\nKPX Aring Oslash -55\r\nKPX Aring Otilde -55\r\nKPX Aring Q -55\r\nKPX Aring T -111\r\nKPX Aring Tcaron -111\r\nKPX Aring Tcommaaccent -111\r\nKPX Aring U -55\r\nKPX Aring Uacute -55\r\nKPX Aring Ucircumflex -55\r\nKPX Aring Udieresis -55\r\nKPX Aring Ugrave -55\r\nKPX Aring Uhungarumlaut -55\r\nKPX Aring Umacron -55\r\nKPX Aring Uogonek -55\r\nKPX Aring Uring -55\r\nKPX Aring V -135\r\nKPX Aring W -90\r\nKPX Aring Y -105\r\nKPX Aring Yacute -105\r\nKPX Aring Ydieresis -105\r\nKPX Aring quoteright -111\r\nKPX Aring v -74\r\nKPX Aring w -92\r\nKPX Aring y -92\r\nKPX Aring yacute -92\r\nKPX Aring ydieresis -92\r\nKPX Atilde C -40\r\nKPX Atilde Cacute -40\r\nKPX Atilde Ccaron -40\r\nKPX Atilde Ccedilla -40\r\nKPX Atilde G -40\r\nKPX Atilde Gbreve -40\r\nKPX Atilde Gcommaaccent -40\r\nKPX Atilde O -55\r\nKPX Atilde Oacute -55\r\nKPX Atilde Ocircumflex -55\r\nKPX Atilde Odieresis -55\r\nKPX Atilde Ograve -55\r\nKPX Atilde Ohungarumlaut -55\r\nKPX Atilde Omacron -55\r\nKPX Atilde Oslash -55\r\nKPX Atilde Otilde -55\r\nKPX Atilde Q -55\r\nKPX Atilde T -111\r\nKPX Atilde Tcaron -111\r\nKPX Atilde Tcommaaccent -111\r\nKPX Atilde U -55\r\nKPX Atilde Uacute -55\r\nKPX Atilde Ucircumflex -55\r\nKPX Atilde Udieresis -55\r\nKPX Atilde Ugrave -55\r\nKPX Atilde Uhungarumlaut -55\r\nKPX Atilde Umacron -55\r\nKPX Atilde Uogonek -55\r\nKPX Atilde Uring -55\r\nKPX Atilde V -135\r\nKPX Atilde W -90\r\nKPX Atilde Y -105\r\nKPX Atilde Yacute -105\r\nKPX Atilde Ydieresis -105\r\nKPX Atilde quoteright -111\r\nKPX Atilde v -74\r\nKPX Atilde w -92\r\nKPX Atilde y -92\r\nKPX Atilde yacute -92\r\nKPX Atilde ydieresis -92\r\nKPX B A -35\r\nKPX B Aacute -35\r\nKPX B Abreve -35\r\nKPX B Acircumflex -35\r\nKPX B Adieresis -35\r\nKPX B Agrave -35\r\nKPX B Amacron -35\r\nKPX B Aogonek -35\r\nKPX B Aring -35\r\nKPX B Atilde -35\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -40\r\nKPX D Aacute -40\r\nKPX D Abreve -40\r\nKPX D Acircumflex -40\r\nKPX D Adieresis -40\r\nKPX D Agrave -40\r\nKPX D Amacron -40\r\nKPX D Aogonek -40\r\nKPX D Aring -40\r\nKPX D Atilde -40\r\nKPX D V -40\r\nKPX D W -30\r\nKPX D Y -55\r\nKPX D Yacute -55\r\nKPX D Ydieresis -55\r\nKPX Dcaron A -40\r\nKPX Dcaron Aacute -40\r\nKPX Dcaron Abreve -40\r\nKPX Dcaron Acircumflex -40\r\nKPX Dcaron Adieresis -40\r\nKPX Dcaron Agrave -40\r\nKPX Dcaron Amacron -40\r\nKPX Dcaron Aogonek -40\r\nKPX Dcaron Aring -40\r\nKPX Dcaron Atilde -40\r\nKPX Dcaron V -40\r\nKPX Dcaron W -30\r\nKPX Dcaron Y -55\r\nKPX Dcaron Yacute -55\r\nKPX Dcaron Ydieresis -55\r\nKPX Dcroat A -40\r\nKPX Dcroat Aacute -40\r\nKPX Dcroat Abreve -40\r\nKPX Dcroat Acircumflex -40\r\nKPX Dcroat Adieresis -40\r\nKPX Dcroat Agrave -40\r\nKPX Dcroat Amacron -40\r\nKPX Dcroat Aogonek -40\r\nKPX Dcroat Aring -40\r\nKPX Dcroat Atilde -40\r\nKPX Dcroat V -40\r\nKPX Dcroat W -30\r\nKPX Dcroat Y -55\r\nKPX Dcroat Yacute -55\r\nKPX Dcroat Ydieresis -55\r\nKPX F A -74\r\nKPX F Aacute -74\r\nKPX F Abreve -74\r\nKPX F Acircumflex -74\r\nKPX F Adieresis -74\r\nKPX F Agrave -74\r\nKPX F Amacron -74\r\nKPX F Aogonek -74\r\nKPX F Aring -74\r\nKPX F Atilde -74\r\nKPX F a -15\r\nKPX F aacute -15\r\nKPX F abreve -15\r\nKPX F acircumflex -15\r\nKPX F adieresis -15\r\nKPX F agrave -15\r\nKPX F amacron -15\r\nKPX F aogonek -15\r\nKPX F aring -15\r\nKPX F atilde -15\r\nKPX F comma -80\r\nKPX F o -15\r\nKPX F oacute -15\r\nKPX F ocircumflex -15\r\nKPX F odieresis -15\r\nKPX F ograve -15\r\nKPX F ohungarumlaut -15\r\nKPX F omacron -15\r\nKPX F oslash -15\r\nKPX F otilde -15\r\nKPX F period -80\r\nKPX J A -60\r\nKPX J Aacute -60\r\nKPX J Abreve -60\r\nKPX J Acircumflex -60\r\nKPX J Adieresis -60\r\nKPX J Agrave -60\r\nKPX J Amacron -60\r\nKPX J Aogonek -60\r\nKPX J Aring -60\r\nKPX J Atilde -60\r\nKPX K O -30\r\nKPX K Oacute -30\r\nKPX K Ocircumflex -30\r\nKPX K Odieresis -30\r\nKPX K Ograve -30\r\nKPX K Ohungarumlaut -30\r\nKPX K Omacron -30\r\nKPX K Oslash -30\r\nKPX K Otilde -30\r\nKPX K e -25\r\nKPX K eacute -25\r\nKPX K ecaron -25\r\nKPX K ecircumflex -25\r\nKPX K edieresis -25\r\nKPX K edotaccent -25\r\nKPX K egrave -25\r\nKPX K emacron -25\r\nKPX K eogonek -25\r\nKPX K o -35\r\nKPX K oacute -35\r\nKPX K ocircumflex -35\r\nKPX K odieresis -35\r\nKPX K ograve -35\r\nKPX K ohungarumlaut -35\r\nKPX K omacron -35\r\nKPX K oslash -35\r\nKPX K otilde -35\r\nKPX K u -15\r\nKPX K uacute -15\r\nKPX K ucircumflex -15\r\nKPX K udieresis -15\r\nKPX K ugrave -15\r\nKPX K uhungarumlaut -15\r\nKPX K umacron -15\r\nKPX K uogonek -15\r\nKPX K uring -15\r\nKPX K y -25\r\nKPX K yacute -25\r\nKPX K ydieresis -25\r\nKPX Kcommaaccent O -30\r\nKPX Kcommaaccent Oacute -30\r\nKPX Kcommaaccent Ocircumflex -30\r\nKPX Kcommaaccent Odieresis -30\r\nKPX Kcommaaccent Ograve -30\r\nKPX Kcommaaccent Ohungarumlaut -30\r\nKPX Kcommaaccent Omacron -30\r\nKPX Kcommaaccent Oslash -30\r\nKPX Kcommaaccent Otilde -30\r\nKPX Kcommaaccent e -25\r\nKPX Kcommaaccent eacute -25\r\nKPX Kcommaaccent ecaron -25\r\nKPX Kcommaaccent ecircumflex -25\r\nKPX Kcommaaccent edieresis -25\r\nKPX Kcommaaccent edotaccent -25\r\nKPX Kcommaaccent egrave -25\r\nKPX Kcommaaccent emacron -25\r\nKPX Kcommaaccent eogonek -25\r\nKPX Kcommaaccent o -35\r\nKPX Kcommaaccent oacute -35\r\nKPX Kcommaaccent ocircumflex -35\r\nKPX Kcommaaccent odieresis -35\r\nKPX Kcommaaccent ograve -35\r\nKPX Kcommaaccent ohungarumlaut -35\r\nKPX Kcommaaccent omacron -35\r\nKPX Kcommaaccent oslash -35\r\nKPX Kcommaaccent otilde -35\r\nKPX Kcommaaccent u -15\r\nKPX Kcommaaccent uacute -15\r\nKPX Kcommaaccent ucircumflex -15\r\nKPX Kcommaaccent udieresis -15\r\nKPX Kcommaaccent ugrave -15\r\nKPX Kcommaaccent uhungarumlaut -15\r\nKPX Kcommaaccent umacron -15\r\nKPX Kcommaaccent uogonek -15\r\nKPX Kcommaaccent uring -15\r\nKPX Kcommaaccent y -25\r\nKPX Kcommaaccent yacute -25\r\nKPX Kcommaaccent ydieresis -25\r\nKPX L T -92\r\nKPX L Tcaron -92\r\nKPX L Tcommaaccent -92\r\nKPX L V -100\r\nKPX L W -74\r\nKPX L Y -100\r\nKPX L Yacute -100\r\nKPX L Ydieresis -100\r\nKPX L quoteright -92\r\nKPX L y -55\r\nKPX L yacute -55\r\nKPX L ydieresis -55\r\nKPX Lacute T -92\r\nKPX Lacute Tcaron -92\r\nKPX Lacute Tcommaaccent -92\r\nKPX Lacute V -100\r\nKPX Lacute W -74\r\nKPX Lacute Y -100\r\nKPX Lacute Yacute -100\r\nKPX Lacute Ydieresis -100\r\nKPX Lacute quoteright -92\r\nKPX Lacute y -55\r\nKPX Lacute yacute -55\r\nKPX Lacute ydieresis -55\r\nKPX Lcaron quoteright -92\r\nKPX Lcaron y -55\r\nKPX Lcaron yacute -55\r\nKPX Lcaron ydieresis -55\r\nKPX Lcommaaccent T -92\r\nKPX Lcommaaccent Tcaron -92\r\nKPX Lcommaaccent Tcommaaccent -92\r\nKPX Lcommaaccent V -100\r\nKPX Lcommaaccent W -74\r\nKPX Lcommaaccent Y -100\r\nKPX Lcommaaccent Yacute -100\r\nKPX Lcommaaccent Ydieresis -100\r\nKPX Lcommaaccent quoteright -92\r\nKPX Lcommaaccent y -55\r\nKPX Lcommaaccent yacute -55\r\nKPX Lcommaaccent ydieresis -55\r\nKPX Lslash T -92\r\nKPX Lslash Tcaron -92\r\nKPX Lslash Tcommaaccent -92\r\nKPX Lslash V -100\r\nKPX Lslash W -74\r\nKPX Lslash Y -100\r\nKPX Lslash Yacute -100\r\nKPX Lslash Ydieresis -100\r\nKPX Lslash quoteright -92\r\nKPX Lslash y -55\r\nKPX Lslash yacute -55\r\nKPX Lslash ydieresis -55\r\nKPX N A -35\r\nKPX N Aacute -35\r\nKPX N Abreve -35\r\nKPX N Acircumflex -35\r\nKPX N Adieresis -35\r\nKPX N Agrave -35\r\nKPX N Amacron -35\r\nKPX N Aogonek -35\r\nKPX N Aring -35\r\nKPX N Atilde -35\r\nKPX Nacute A -35\r\nKPX Nacute Aacute -35\r\nKPX Nacute Abreve -35\r\nKPX Nacute Acircumflex -35\r\nKPX Nacute Adieresis -35\r\nKPX Nacute Agrave -35\r\nKPX Nacute Amacron -35\r\nKPX Nacute Aogonek -35\r\nKPX Nacute Aring -35\r\nKPX Nacute Atilde -35\r\nKPX Ncaron A -35\r\nKPX Ncaron Aacute -35\r\nKPX Ncaron Abreve -35\r\nKPX Ncaron Acircumflex -35\r\nKPX Ncaron Adieresis -35\r\nKPX Ncaron Agrave -35\r\nKPX Ncaron Amacron -35\r\nKPX Ncaron Aogonek -35\r\nKPX Ncaron Aring -35\r\nKPX Ncaron Atilde -35\r\nKPX Ncommaaccent A -35\r\nKPX Ncommaaccent Aacute -35\r\nKPX Ncommaaccent Abreve -35\r\nKPX Ncommaaccent Acircumflex -35\r\nKPX Ncommaaccent Adieresis -35\r\nKPX Ncommaaccent Agrave -35\r\nKPX Ncommaaccent Amacron -35\r\nKPX Ncommaaccent Aogonek -35\r\nKPX Ncommaaccent Aring -35\r\nKPX Ncommaaccent Atilde -35\r\nKPX Ntilde A -35\r\nKPX Ntilde Aacute -35\r\nKPX Ntilde Abreve -35\r\nKPX Ntilde Acircumflex -35\r\nKPX Ntilde Adieresis -35\r\nKPX Ntilde Agrave -35\r\nKPX Ntilde Amacron -35\r\nKPX Ntilde Aogonek -35\r\nKPX Ntilde Aring -35\r\nKPX Ntilde Atilde -35\r\nKPX O A -35\r\nKPX O Aacute -35\r\nKPX O Abreve -35\r\nKPX O Acircumflex -35\r\nKPX O Adieresis -35\r\nKPX O Agrave -35\r\nKPX O Amacron -35\r\nKPX O Aogonek -35\r\nKPX O Aring -35\r\nKPX O Atilde -35\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -35\r\nKPX O X -40\r\nKPX O Y -50\r\nKPX O Yacute -50\r\nKPX O Ydieresis -50\r\nKPX Oacute A -35\r\nKPX Oacute Aacute -35\r\nKPX Oacute Abreve -35\r\nKPX Oacute Acircumflex -35\r\nKPX Oacute Adieresis -35\r\nKPX Oacute Agrave -35\r\nKPX Oacute Amacron -35\r\nKPX Oacute Aogonek -35\r\nKPX Oacute Aring -35\r\nKPX Oacute Atilde -35\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -35\r\nKPX Oacute X -40\r\nKPX Oacute Y -50\r\nKPX Oacute Yacute -50\r\nKPX Oacute Ydieresis -50\r\nKPX Ocircumflex A -35\r\nKPX Ocircumflex Aacute -35\r\nKPX Ocircumflex Abreve -35\r\nKPX Ocircumflex Acircumflex -35\r\nKPX Ocircumflex Adieresis -35\r\nKPX Ocircumflex Agrave -35\r\nKPX Ocircumflex Amacron -35\r\nKPX Ocircumflex Aogonek -35\r\nKPX Ocircumflex Aring -35\r\nKPX Ocircumflex Atilde -35\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -35\r\nKPX Ocircumflex X -40\r\nKPX Ocircumflex Y -50\r\nKPX Ocircumflex Yacute -50\r\nKPX Ocircumflex Ydieresis -50\r\nKPX Odieresis A -35\r\nKPX Odieresis Aacute -35\r\nKPX Odieresis Abreve -35\r\nKPX Odieresis Acircumflex -35\r\nKPX Odieresis Adieresis -35\r\nKPX Odieresis Agrave -35\r\nKPX Odieresis Amacron -35\r\nKPX Odieresis Aogonek -35\r\nKPX Odieresis Aring -35\r\nKPX Odieresis Atilde -35\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -35\r\nKPX Odieresis X -40\r\nKPX Odieresis Y -50\r\nKPX Odieresis Yacute -50\r\nKPX Odieresis Ydieresis -50\r\nKPX Ograve A -35\r\nKPX Ograve Aacute -35\r\nKPX Ograve Abreve -35\r\nKPX Ograve Acircumflex -35\r\nKPX Ograve Adieresis -35\r\nKPX Ograve Agrave -35\r\nKPX Ograve Amacron -35\r\nKPX Ograve Aogonek -35\r\nKPX Ograve Aring -35\r\nKPX Ograve Atilde -35\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -35\r\nKPX Ograve X -40\r\nKPX Ograve Y -50\r\nKPX Ograve Yacute -50\r\nKPX Ograve Ydieresis -50\r\nKPX Ohungarumlaut A -35\r\nKPX Ohungarumlaut Aacute -35\r\nKPX Ohungarumlaut Abreve -35\r\nKPX Ohungarumlaut Acircumflex -35\r\nKPX Ohungarumlaut Adieresis -35\r\nKPX Ohungarumlaut Agrave -35\r\nKPX Ohungarumlaut Amacron -35\r\nKPX Ohungarumlaut Aogonek -35\r\nKPX Ohungarumlaut Aring -35\r\nKPX Ohungarumlaut Atilde -35\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -35\r\nKPX Ohungarumlaut X -40\r\nKPX Ohungarumlaut Y -50\r\nKPX Ohungarumlaut Yacute -50\r\nKPX Ohungarumlaut Ydieresis -50\r\nKPX Omacron A -35\r\nKPX Omacron Aacute -35\r\nKPX Omacron Abreve -35\r\nKPX Omacron Acircumflex -35\r\nKPX Omacron Adieresis -35\r\nKPX Omacron Agrave -35\r\nKPX Omacron Amacron -35\r\nKPX Omacron Aogonek -35\r\nKPX Omacron Aring -35\r\nKPX Omacron Atilde -35\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -35\r\nKPX Omacron X -40\r\nKPX Omacron Y -50\r\nKPX Omacron Yacute -50\r\nKPX Omacron Ydieresis -50\r\nKPX Oslash A -35\r\nKPX Oslash Aacute -35\r\nKPX Oslash Abreve -35\r\nKPX Oslash Acircumflex -35\r\nKPX Oslash Adieresis -35\r\nKPX Oslash Agrave -35\r\nKPX Oslash Amacron -35\r\nKPX Oslash Aogonek -35\r\nKPX Oslash Aring -35\r\nKPX Oslash Atilde -35\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -35\r\nKPX Oslash X -40\r\nKPX Oslash Y -50\r\nKPX Oslash Yacute -50\r\nKPX Oslash Ydieresis -50\r\nKPX Otilde A -35\r\nKPX Otilde Aacute -35\r\nKPX Otilde Abreve -35\r\nKPX Otilde Acircumflex -35\r\nKPX Otilde Adieresis -35\r\nKPX Otilde Agrave -35\r\nKPX Otilde Amacron -35\r\nKPX Otilde Aogonek -35\r\nKPX Otilde Aring -35\r\nKPX Otilde Atilde -35\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -35\r\nKPX Otilde X -40\r\nKPX Otilde Y -50\r\nKPX Otilde Yacute -50\r\nKPX Otilde Ydieresis -50\r\nKPX P A -92\r\nKPX P Aacute -92\r\nKPX P Abreve -92\r\nKPX P Acircumflex -92\r\nKPX P Adieresis -92\r\nKPX P Agrave -92\r\nKPX P Amacron -92\r\nKPX P Aogonek -92\r\nKPX P Aring -92\r\nKPX P Atilde -92\r\nKPX P a -15\r\nKPX P aacute -15\r\nKPX P abreve -15\r\nKPX P acircumflex -15\r\nKPX P adieresis -15\r\nKPX P agrave -15\r\nKPX P amacron -15\r\nKPX P aogonek -15\r\nKPX P aring -15\r\nKPX P atilde -15\r\nKPX P comma -111\r\nKPX P period -111\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX R O -40\r\nKPX R Oacute -40\r\nKPX R Ocircumflex -40\r\nKPX R Odieresis -40\r\nKPX R Ograve -40\r\nKPX R Ohungarumlaut -40\r\nKPX R Omacron -40\r\nKPX R Oslash -40\r\nKPX R Otilde -40\r\nKPX R T -60\r\nKPX R Tcaron -60\r\nKPX R Tcommaaccent -60\r\nKPX R U -40\r\nKPX R Uacute -40\r\nKPX R Ucircumflex -40\r\nKPX R Udieresis -40\r\nKPX R Ugrave -40\r\nKPX R Uhungarumlaut -40\r\nKPX R Umacron -40\r\nKPX R Uogonek -40\r\nKPX R Uring -40\r\nKPX R V -80\r\nKPX R W -55\r\nKPX R Y -65\r\nKPX R Yacute -65\r\nKPX R Ydieresis -65\r\nKPX Racute O -40\r\nKPX Racute Oacute -40\r\nKPX Racute Ocircumflex -40\r\nKPX Racute Odieresis -40\r\nKPX Racute Ograve -40\r\nKPX Racute Ohungarumlaut -40\r\nKPX Racute Omacron -40\r\nKPX Racute Oslash -40\r\nKPX Racute Otilde -40\r\nKPX Racute T -60\r\nKPX Racute Tcaron -60\r\nKPX Racute Tcommaaccent -60\r\nKPX Racute U -40\r\nKPX Racute Uacute -40\r\nKPX Racute Ucircumflex -40\r\nKPX Racute Udieresis -40\r\nKPX Racute Ugrave -40\r\nKPX Racute Uhungarumlaut -40\r\nKPX Racute Umacron -40\r\nKPX Racute Uogonek -40\r\nKPX Racute Uring -40\r\nKPX Racute V -80\r\nKPX Racute W -55\r\nKPX Racute Y -65\r\nKPX Racute Yacute -65\r\nKPX Racute Ydieresis -65\r\nKPX Rcaron O -40\r\nKPX Rcaron Oacute -40\r\nKPX Rcaron Ocircumflex -40\r\nKPX Rcaron Odieresis -40\r\nKPX Rcaron Ograve -40\r\nKPX Rcaron Ohungarumlaut -40\r\nKPX Rcaron Omacron -40\r\nKPX Rcaron Oslash -40\r\nKPX Rcaron Otilde -40\r\nKPX Rcaron T -60\r\nKPX Rcaron Tcaron -60\r\nKPX Rcaron Tcommaaccent -60\r\nKPX Rcaron U -40\r\nKPX Rcaron Uacute -40\r\nKPX Rcaron Ucircumflex -40\r\nKPX Rcaron Udieresis -40\r\nKPX Rcaron Ugrave -40\r\nKPX Rcaron Uhungarumlaut -40\r\nKPX Rcaron Umacron -40\r\nKPX Rcaron Uogonek -40\r\nKPX Rcaron Uring -40\r\nKPX Rcaron V -80\r\nKPX Rcaron W -55\r\nKPX Rcaron Y -65\r\nKPX Rcaron Yacute -65\r\nKPX Rcaron Ydieresis -65\r\nKPX Rcommaaccent O -40\r\nKPX Rcommaaccent Oacute -40\r\nKPX Rcommaaccent Ocircumflex -40\r\nKPX Rcommaaccent Odieresis -40\r\nKPX Rcommaaccent Ograve -40\r\nKPX Rcommaaccent Ohungarumlaut -40\r\nKPX Rcommaaccent Omacron -40\r\nKPX Rcommaaccent Oslash -40\r\nKPX Rcommaaccent Otilde -40\r\nKPX Rcommaaccent T -60\r\nKPX Rcommaaccent Tcaron -60\r\nKPX Rcommaaccent Tcommaaccent -60\r\nKPX Rcommaaccent U -40\r\nKPX Rcommaaccent Uacute -40\r\nKPX Rcommaaccent Ucircumflex -40\r\nKPX Rcommaaccent Udieresis -40\r\nKPX Rcommaaccent Ugrave -40\r\nKPX Rcommaaccent Uhungarumlaut -40\r\nKPX Rcommaaccent Umacron -40\r\nKPX Rcommaaccent Uogonek -40\r\nKPX Rcommaaccent Uring -40\r\nKPX Rcommaaccent V -80\r\nKPX Rcommaaccent W -55\r\nKPX Rcommaaccent Y -65\r\nKPX Rcommaaccent Yacute -65\r\nKPX Rcommaaccent Ydieresis -65\r\nKPX T A -93\r\nKPX T Aacute -93\r\nKPX T Abreve -93\r\nKPX T Acircumflex -93\r\nKPX T Adieresis -93\r\nKPX T Agrave -93\r\nKPX T Amacron -93\r\nKPX T Aogonek -93\r\nKPX T Aring -93\r\nKPX T Atilde -93\r\nKPX T O -18\r\nKPX T Oacute -18\r\nKPX T Ocircumflex -18\r\nKPX T Odieresis -18\r\nKPX T Ograve -18\r\nKPX T Ohungarumlaut -18\r\nKPX T Omacron -18\r\nKPX T Oslash -18\r\nKPX T Otilde -18\r\nKPX T a -80\r\nKPX T aacute -80\r\nKPX T abreve -80\r\nKPX T acircumflex -80\r\nKPX T adieresis -40\r\nKPX T agrave -40\r\nKPX T amacron -40\r\nKPX T aogonek -80\r\nKPX T aring -80\r\nKPX T atilde -40\r\nKPX T colon -50\r\nKPX T comma -74\r\nKPX T e -70\r\nKPX T eacute -70\r\nKPX T ecaron -70\r\nKPX T ecircumflex -70\r\nKPX T edieresis -30\r\nKPX T edotaccent -70\r\nKPX T egrave -70\r\nKPX T emacron -30\r\nKPX T eogonek -70\r\nKPX T hyphen -92\r\nKPX T i -35\r\nKPX T iacute -35\r\nKPX T iogonek -35\r\nKPX T o -80\r\nKPX T oacute -80\r\nKPX T ocircumflex -80\r\nKPX T odieresis -80\r\nKPX T ograve -80\r\nKPX T ohungarumlaut -80\r\nKPX T omacron -80\r\nKPX T oslash -80\r\nKPX T otilde -80\r\nKPX T period -74\r\nKPX T r -35\r\nKPX T racute -35\r\nKPX T rcaron -35\r\nKPX T rcommaaccent -35\r\nKPX T semicolon -55\r\nKPX T u -45\r\nKPX T uacute -45\r\nKPX T ucircumflex -45\r\nKPX T udieresis -45\r\nKPX T ugrave -45\r\nKPX T uhungarumlaut -45\r\nKPX T umacron -45\r\nKPX T uogonek -45\r\nKPX T uring -45\r\nKPX T w -80\r\nKPX T y -80\r\nKPX T yacute -80\r\nKPX T ydieresis -80\r\nKPX Tcaron A -93\r\nKPX Tcaron Aacute -93\r\nKPX Tcaron Abreve -93\r\nKPX Tcaron Acircumflex -93\r\nKPX Tcaron Adieresis -93\r\nKPX Tcaron Agrave -93\r\nKPX Tcaron Amacron -93\r\nKPX Tcaron Aogonek -93\r\nKPX Tcaron Aring -93\r\nKPX Tcaron Atilde -93\r\nKPX Tcaron O -18\r\nKPX Tcaron Oacute -18\r\nKPX Tcaron Ocircumflex -18\r\nKPX Tcaron Odieresis -18\r\nKPX Tcaron Ograve -18\r\nKPX Tcaron Ohungarumlaut -18\r\nKPX Tcaron Omacron -18\r\nKPX Tcaron Oslash -18\r\nKPX Tcaron Otilde -18\r\nKPX Tcaron a -80\r\nKPX Tcaron aacute -80\r\nKPX Tcaron abreve -80\r\nKPX Tcaron acircumflex -80\r\nKPX Tcaron adieresis -40\r\nKPX Tcaron agrave -40\r\nKPX Tcaron amacron -40\r\nKPX Tcaron aogonek -80\r\nKPX Tcaron aring -80\r\nKPX Tcaron atilde -40\r\nKPX Tcaron colon -50\r\nKPX Tcaron comma -74\r\nKPX Tcaron e -70\r\nKPX Tcaron eacute -70\r\nKPX Tcaron ecaron -70\r\nKPX Tcaron ecircumflex -30\r\nKPX Tcaron edieresis -30\r\nKPX Tcaron edotaccent -70\r\nKPX Tcaron egrave -70\r\nKPX Tcaron emacron -30\r\nKPX Tcaron eogonek -70\r\nKPX Tcaron hyphen -92\r\nKPX Tcaron i -35\r\nKPX Tcaron iacute -35\r\nKPX Tcaron iogonek -35\r\nKPX Tcaron o -80\r\nKPX Tcaron oacute -80\r\nKPX Tcaron ocircumflex -80\r\nKPX Tcaron odieresis -80\r\nKPX Tcaron ograve -80\r\nKPX Tcaron ohungarumlaut -80\r\nKPX Tcaron omacron -80\r\nKPX Tcaron oslash -80\r\nKPX Tcaron otilde -80\r\nKPX Tcaron period -74\r\nKPX Tcaron r -35\r\nKPX Tcaron racute -35\r\nKPX Tcaron rcaron -35\r\nKPX Tcaron rcommaaccent -35\r\nKPX Tcaron semicolon -55\r\nKPX Tcaron u -45\r\nKPX Tcaron uacute -45\r\nKPX Tcaron ucircumflex -45\r\nKPX Tcaron udieresis -45\r\nKPX Tcaron ugrave -45\r\nKPX Tcaron uhungarumlaut -45\r\nKPX Tcaron umacron -45\r\nKPX Tcaron uogonek -45\r\nKPX Tcaron uring -45\r\nKPX Tcaron w -80\r\nKPX Tcaron y -80\r\nKPX Tcaron yacute -80\r\nKPX Tcaron ydieresis -80\r\nKPX Tcommaaccent A -93\r\nKPX Tcommaaccent Aacute -93\r\nKPX Tcommaaccent Abreve -93\r\nKPX Tcommaaccent Acircumflex -93\r\nKPX Tcommaaccent Adieresis -93\r\nKPX Tcommaaccent Agrave -93\r\nKPX Tcommaaccent Amacron -93\r\nKPX Tcommaaccent Aogonek -93\r\nKPX Tcommaaccent Aring -93\r\nKPX Tcommaaccent Atilde -93\r\nKPX Tcommaaccent O -18\r\nKPX Tcommaaccent Oacute -18\r\nKPX Tcommaaccent Ocircumflex -18\r\nKPX Tcommaaccent Odieresis -18\r\nKPX Tcommaaccent Ograve -18\r\nKPX Tcommaaccent Ohungarumlaut -18\r\nKPX Tcommaaccent Omacron -18\r\nKPX Tcommaaccent Oslash -18\r\nKPX Tcommaaccent Otilde -18\r\nKPX Tcommaaccent a -80\r\nKPX Tcommaaccent aacute -80\r\nKPX Tcommaaccent abreve -80\r\nKPX Tcommaaccent acircumflex -80\r\nKPX Tcommaaccent adieresis -40\r\nKPX Tcommaaccent agrave -40\r\nKPX Tcommaaccent amacron -40\r\nKPX Tcommaaccent aogonek -80\r\nKPX Tcommaaccent aring -80\r\nKPX Tcommaaccent atilde -40\r\nKPX Tcommaaccent colon -50\r\nKPX Tcommaaccent comma -74\r\nKPX Tcommaaccent e -70\r\nKPX Tcommaaccent eacute -70\r\nKPX Tcommaaccent ecaron -70\r\nKPX Tcommaaccent ecircumflex -30\r\nKPX Tcommaaccent edieresis -30\r\nKPX Tcommaaccent edotaccent -70\r\nKPX Tcommaaccent egrave -30\r\nKPX Tcommaaccent emacron -70\r\nKPX Tcommaaccent eogonek -70\r\nKPX Tcommaaccent hyphen -92\r\nKPX Tcommaaccent i -35\r\nKPX Tcommaaccent iacute -35\r\nKPX Tcommaaccent iogonek -35\r\nKPX Tcommaaccent o -80\r\nKPX Tcommaaccent oacute -80\r\nKPX Tcommaaccent ocircumflex -80\r\nKPX Tcommaaccent odieresis -80\r\nKPX Tcommaaccent ograve -80\r\nKPX Tcommaaccent ohungarumlaut -80\r\nKPX Tcommaaccent omacron -80\r\nKPX Tcommaaccent oslash -80\r\nKPX Tcommaaccent otilde -80\r\nKPX Tcommaaccent period -74\r\nKPX Tcommaaccent r -35\r\nKPX Tcommaaccent racute -35\r\nKPX Tcommaaccent rcaron -35\r\nKPX Tcommaaccent rcommaaccent -35\r\nKPX Tcommaaccent semicolon -55\r\nKPX Tcommaaccent u -45\r\nKPX Tcommaaccent uacute -45\r\nKPX Tcommaaccent ucircumflex -45\r\nKPX Tcommaaccent udieresis -45\r\nKPX Tcommaaccent ugrave -45\r\nKPX Tcommaaccent uhungarumlaut -45\r\nKPX Tcommaaccent umacron -45\r\nKPX Tcommaaccent uogonek -45\r\nKPX Tcommaaccent uring -45\r\nKPX Tcommaaccent w -80\r\nKPX Tcommaaccent y -80\r\nKPX Tcommaaccent yacute -80\r\nKPX Tcommaaccent ydieresis -80\r\nKPX U A -40\r\nKPX U Aacute -40\r\nKPX U Abreve -40\r\nKPX U Acircumflex -40\r\nKPX U Adieresis -40\r\nKPX U Agrave -40\r\nKPX U Amacron -40\r\nKPX U Aogonek -40\r\nKPX U Aring -40\r\nKPX U Atilde -40\r\nKPX Uacute A -40\r\nKPX Uacute Aacute -40\r\nKPX Uacute Abreve -40\r\nKPX Uacute Acircumflex -40\r\nKPX Uacute Adieresis -40\r\nKPX Uacute Agrave -40\r\nKPX Uacute Amacron -40\r\nKPX Uacute Aogonek -40\r\nKPX Uacute Aring -40\r\nKPX Uacute Atilde -40\r\nKPX Ucircumflex A -40\r\nKPX Ucircumflex Aacute -40\r\nKPX Ucircumflex Abreve -40\r\nKPX Ucircumflex Acircumflex -40\r\nKPX Ucircumflex Adieresis -40\r\nKPX Ucircumflex Agrave -40\r\nKPX Ucircumflex Amacron -40\r\nKPX Ucircumflex Aogonek -40\r\nKPX Ucircumflex Aring -40\r\nKPX Ucircumflex Atilde -40\r\nKPX Udieresis A -40\r\nKPX Udieresis Aacute -40\r\nKPX Udieresis Abreve -40\r\nKPX Udieresis Acircumflex -40\r\nKPX Udieresis Adieresis -40\r\nKPX Udieresis Agrave -40\r\nKPX Udieresis Amacron -40\r\nKPX Udieresis Aogonek -40\r\nKPX Udieresis Aring -40\r\nKPX Udieresis Atilde -40\r\nKPX Ugrave A -40\r\nKPX Ugrave Aacute -40\r\nKPX Ugrave Abreve -40\r\nKPX Ugrave Acircumflex -40\r\nKPX Ugrave Adieresis -40\r\nKPX Ugrave Agrave -40\r\nKPX Ugrave Amacron -40\r\nKPX Ugrave Aogonek -40\r\nKPX Ugrave Aring -40\r\nKPX Ugrave Atilde -40\r\nKPX Uhungarumlaut A -40\r\nKPX Uhungarumlaut Aacute -40\r\nKPX Uhungarumlaut Abreve -40\r\nKPX Uhungarumlaut Acircumflex -40\r\nKPX Uhungarumlaut Adieresis -40\r\nKPX Uhungarumlaut Agrave -40\r\nKPX Uhungarumlaut Amacron -40\r\nKPX Uhungarumlaut Aogonek -40\r\nKPX Uhungarumlaut Aring -40\r\nKPX Uhungarumlaut Atilde -40\r\nKPX Umacron A -40\r\nKPX Umacron Aacute -40\r\nKPX Umacron Abreve -40\r\nKPX Umacron Acircumflex -40\r\nKPX Umacron Adieresis -40\r\nKPX Umacron Agrave -40\r\nKPX Umacron Amacron -40\r\nKPX Umacron Aogonek -40\r\nKPX Umacron Aring -40\r\nKPX Umacron Atilde -40\r\nKPX Uogonek A -40\r\nKPX Uogonek Aacute -40\r\nKPX Uogonek Abreve -40\r\nKPX Uogonek Acircumflex -40\r\nKPX Uogonek Adieresis -40\r\nKPX Uogonek Agrave -40\r\nKPX Uogonek Amacron -40\r\nKPX Uogonek Aogonek -40\r\nKPX Uogonek Aring -40\r\nKPX Uogonek Atilde -40\r\nKPX Uring A -40\r\nKPX Uring Aacute -40\r\nKPX Uring Abreve -40\r\nKPX Uring Acircumflex -40\r\nKPX Uring Adieresis -40\r\nKPX Uring Agrave -40\r\nKPX Uring Amacron -40\r\nKPX Uring Aogonek -40\r\nKPX Uring Aring -40\r\nKPX Uring Atilde -40\r\nKPX V A -135\r\nKPX V Aacute -135\r\nKPX V Abreve -135\r\nKPX V Acircumflex -135\r\nKPX V Adieresis -135\r\nKPX V Agrave -135\r\nKPX V Amacron -135\r\nKPX V Aogonek -135\r\nKPX V Aring -135\r\nKPX V Atilde -135\r\nKPX V G -15\r\nKPX V Gbreve -15\r\nKPX V Gcommaaccent -15\r\nKPX V O -40\r\nKPX V Oacute -40\r\nKPX V Ocircumflex -40\r\nKPX V Odieresis -40\r\nKPX V Ograve -40\r\nKPX V Ohungarumlaut -40\r\nKPX V Omacron -40\r\nKPX V Oslash -40\r\nKPX V Otilde -40\r\nKPX V a -111\r\nKPX V aacute -111\r\nKPX V abreve -111\r\nKPX V acircumflex -71\r\nKPX V adieresis -71\r\nKPX V agrave -71\r\nKPX V amacron -71\r\nKPX V aogonek -111\r\nKPX V aring -111\r\nKPX V atilde -71\r\nKPX V colon -74\r\nKPX V comma -129\r\nKPX V e -111\r\nKPX V eacute -111\r\nKPX V ecaron -71\r\nKPX V ecircumflex -71\r\nKPX V edieresis -71\r\nKPX V edotaccent -111\r\nKPX V egrave -71\r\nKPX V emacron -71\r\nKPX V eogonek -111\r\nKPX V hyphen -100\r\nKPX V i -60\r\nKPX V iacute -60\r\nKPX V icircumflex -20\r\nKPX V idieresis -20\r\nKPX V igrave -20\r\nKPX V imacron -20\r\nKPX V iogonek -60\r\nKPX V o -129\r\nKPX V oacute -129\r\nKPX V ocircumflex -129\r\nKPX V odieresis -89\r\nKPX V ograve -89\r\nKPX V ohungarumlaut -129\r\nKPX V omacron -89\r\nKPX V oslash -129\r\nKPX V otilde -89\r\nKPX V period -129\r\nKPX V semicolon -74\r\nKPX V u -75\r\nKPX V uacute -75\r\nKPX V ucircumflex -75\r\nKPX V udieresis -75\r\nKPX V ugrave -75\r\nKPX V uhungarumlaut -75\r\nKPX V umacron -75\r\nKPX V uogonek -75\r\nKPX V uring -75\r\nKPX W A -120\r\nKPX W Aacute -120\r\nKPX W Abreve -120\r\nKPX W Acircumflex -120\r\nKPX W Adieresis -120\r\nKPX W Agrave -120\r\nKPX W Amacron -120\r\nKPX W Aogonek -120\r\nKPX W Aring -120\r\nKPX W Atilde -120\r\nKPX W O -10\r\nKPX W Oacute -10\r\nKPX W Ocircumflex -10\r\nKPX W Odieresis -10\r\nKPX W Ograve -10\r\nKPX W Ohungarumlaut -10\r\nKPX W Omacron -10\r\nKPX W Oslash -10\r\nKPX W Otilde -10\r\nKPX W a -80\r\nKPX W aacute -80\r\nKPX W abreve -80\r\nKPX W acircumflex -80\r\nKPX W adieresis -80\r\nKPX W agrave -80\r\nKPX W amacron -80\r\nKPX W aogonek -80\r\nKPX W aring -80\r\nKPX W atilde -80\r\nKPX W colon -37\r\nKPX W comma -92\r\nKPX W e -80\r\nKPX W eacute -80\r\nKPX W ecaron -80\r\nKPX W ecircumflex -80\r\nKPX W edieresis -40\r\nKPX W edotaccent -80\r\nKPX W egrave -40\r\nKPX W emacron -40\r\nKPX W eogonek -80\r\nKPX W hyphen -65\r\nKPX W i -40\r\nKPX W iacute -40\r\nKPX W iogonek -40\r\nKPX W o -80\r\nKPX W oacute -80\r\nKPX W ocircumflex -80\r\nKPX W odieresis -80\r\nKPX W ograve -80\r\nKPX W ohungarumlaut -80\r\nKPX W omacron -80\r\nKPX W oslash -80\r\nKPX W otilde -80\r\nKPX W period -92\r\nKPX W semicolon -37\r\nKPX W u -50\r\nKPX W uacute -50\r\nKPX W ucircumflex -50\r\nKPX W udieresis -50\r\nKPX W ugrave -50\r\nKPX W uhungarumlaut -50\r\nKPX W umacron -50\r\nKPX W uogonek -50\r\nKPX W uring -50\r\nKPX W y -73\r\nKPX W yacute -73\r\nKPX W ydieresis -73\r\nKPX Y A -120\r\nKPX Y Aacute -120\r\nKPX Y Abreve -120\r\nKPX Y Acircumflex -120\r\nKPX Y Adieresis -120\r\nKPX Y Agrave -120\r\nKPX Y Amacron -120\r\nKPX Y Aogonek -120\r\nKPX Y Aring -120\r\nKPX Y Atilde -120\r\nKPX Y O -30\r\nKPX Y Oacute -30\r\nKPX Y Ocircumflex -30\r\nKPX Y Odieresis -30\r\nKPX Y Ograve -30\r\nKPX Y Ohungarumlaut -30\r\nKPX Y Omacron -30\r\nKPX Y Oslash -30\r\nKPX Y Otilde -30\r\nKPX Y a -100\r\nKPX Y aacute -100\r\nKPX Y abreve -100\r\nKPX Y acircumflex -100\r\nKPX Y adieresis -60\r\nKPX Y agrave -60\r\nKPX Y amacron -60\r\nKPX Y aogonek -100\r\nKPX Y aring -100\r\nKPX Y atilde -60\r\nKPX Y colon -92\r\nKPX Y comma -129\r\nKPX Y e -100\r\nKPX Y eacute -100\r\nKPX Y ecaron -100\r\nKPX Y ecircumflex -100\r\nKPX Y edieresis -60\r\nKPX Y edotaccent -100\r\nKPX Y egrave -60\r\nKPX Y emacron -60\r\nKPX Y eogonek -100\r\nKPX Y hyphen -111\r\nKPX Y i -55\r\nKPX Y iacute -55\r\nKPX Y iogonek -55\r\nKPX Y o -110\r\nKPX Y oacute -110\r\nKPX Y ocircumflex -110\r\nKPX Y odieresis -70\r\nKPX Y ograve -70\r\nKPX Y ohungarumlaut -110\r\nKPX Y omacron -70\r\nKPX Y oslash -110\r\nKPX Y otilde -70\r\nKPX Y period -129\r\nKPX Y semicolon -92\r\nKPX Y u -111\r\nKPX Y uacute -111\r\nKPX Y ucircumflex -111\r\nKPX Y udieresis -71\r\nKPX Y ugrave -71\r\nKPX Y uhungarumlaut -111\r\nKPX Y umacron -71\r\nKPX Y uogonek -111\r\nKPX Y uring -111\r\nKPX Yacute A -120\r\nKPX Yacute Aacute -120\r\nKPX Yacute Abreve -120\r\nKPX Yacute Acircumflex -120\r\nKPX Yacute Adieresis -120\r\nKPX Yacute Agrave -120\r\nKPX Yacute Amacron -120\r\nKPX Yacute Aogonek -120\r\nKPX Yacute Aring -120\r\nKPX Yacute Atilde -120\r\nKPX Yacute O -30\r\nKPX Yacute Oacute -30\r\nKPX Yacute Ocircumflex -30\r\nKPX Yacute Odieresis -30\r\nKPX Yacute Ograve -30\r\nKPX Yacute Ohungarumlaut -30\r\nKPX Yacute Omacron -30\r\nKPX Yacute Oslash -30\r\nKPX Yacute Otilde -30\r\nKPX Yacute a -100\r\nKPX Yacute aacute -100\r\nKPX Yacute abreve -100\r\nKPX Yacute acircumflex -100\r\nKPX Yacute adieresis -60\r\nKPX Yacute agrave -60\r\nKPX Yacute amacron -60\r\nKPX Yacute aogonek -100\r\nKPX Yacute aring -100\r\nKPX Yacute atilde -60\r\nKPX Yacute colon -92\r\nKPX Yacute comma -129\r\nKPX Yacute e -100\r\nKPX Yacute eacute -100\r\nKPX Yacute ecaron -100\r\nKPX Yacute ecircumflex -100\r\nKPX Yacute edieresis -60\r\nKPX Yacute edotaccent -100\r\nKPX Yacute egrave -60\r\nKPX Yacute emacron -60\r\nKPX Yacute eogonek -100\r\nKPX Yacute hyphen -111\r\nKPX Yacute i -55\r\nKPX Yacute iacute -55\r\nKPX Yacute iogonek -55\r\nKPX Yacute o -110\r\nKPX Yacute oacute -110\r\nKPX Yacute ocircumflex -110\r\nKPX Yacute odieresis -70\r\nKPX Yacute ograve -70\r\nKPX Yacute ohungarumlaut -110\r\nKPX Yacute omacron -70\r\nKPX Yacute oslash -110\r\nKPX Yacute otilde -70\r\nKPX Yacute period -129\r\nKPX Yacute semicolon -92\r\nKPX Yacute u -111\r\nKPX Yacute uacute -111\r\nKPX Yacute ucircumflex -111\r\nKPX Yacute udieresis -71\r\nKPX Yacute ugrave -71\r\nKPX Yacute uhungarumlaut -111\r\nKPX Yacute umacron -71\r\nKPX Yacute uogonek -111\r\nKPX Yacute uring -111\r\nKPX Ydieresis A -120\r\nKPX Ydieresis Aacute -120\r\nKPX Ydieresis Abreve -120\r\nKPX Ydieresis Acircumflex -120\r\nKPX Ydieresis Adieresis -120\r\nKPX Ydieresis Agrave -120\r\nKPX Ydieresis Amacron -120\r\nKPX Ydieresis Aogonek -120\r\nKPX Ydieresis Aring -120\r\nKPX Ydieresis Atilde -120\r\nKPX Ydieresis O -30\r\nKPX Ydieresis Oacute -30\r\nKPX Ydieresis Ocircumflex -30\r\nKPX Ydieresis Odieresis -30\r\nKPX Ydieresis Ograve -30\r\nKPX Ydieresis Ohungarumlaut -30\r\nKPX Ydieresis Omacron -30\r\nKPX Ydieresis Oslash -30\r\nKPX Ydieresis Otilde -30\r\nKPX Ydieresis a -100\r\nKPX Ydieresis aacute -100\r\nKPX Ydieresis abreve -100\r\nKPX Ydieresis acircumflex -100\r\nKPX Ydieresis adieresis -60\r\nKPX Ydieresis agrave -60\r\nKPX Ydieresis amacron -60\r\nKPX Ydieresis aogonek -100\r\nKPX Ydieresis aring -100\r\nKPX Ydieresis atilde -100\r\nKPX Ydieresis colon -92\r\nKPX Ydieresis comma -129\r\nKPX Ydieresis e -100\r\nKPX Ydieresis eacute -100\r\nKPX Ydieresis ecaron -100\r\nKPX Ydieresis ecircumflex -100\r\nKPX Ydieresis edieresis -60\r\nKPX Ydieresis edotaccent -100\r\nKPX Ydieresis egrave -60\r\nKPX Ydieresis emacron -60\r\nKPX Ydieresis eogonek -100\r\nKPX Ydieresis hyphen -111\r\nKPX Ydieresis i -55\r\nKPX Ydieresis iacute -55\r\nKPX Ydieresis iogonek -55\r\nKPX Ydieresis o -110\r\nKPX Ydieresis oacute -110\r\nKPX Ydieresis ocircumflex -110\r\nKPX Ydieresis odieresis -70\r\nKPX Ydieresis ograve -70\r\nKPX Ydieresis ohungarumlaut -110\r\nKPX Ydieresis omacron -70\r\nKPX Ydieresis oslash -110\r\nKPX Ydieresis otilde -70\r\nKPX Ydieresis period -129\r\nKPX Ydieresis semicolon -92\r\nKPX Ydieresis u -111\r\nKPX Ydieresis uacute -111\r\nKPX Ydieresis ucircumflex -111\r\nKPX Ydieresis udieresis -71\r\nKPX Ydieresis ugrave -71\r\nKPX Ydieresis uhungarumlaut -111\r\nKPX Ydieresis umacron -71\r\nKPX Ydieresis uogonek -111\r\nKPX Ydieresis uring -111\r\nKPX a v -20\r\nKPX a w -15\r\nKPX aacute v -20\r\nKPX aacute w -15\r\nKPX abreve v -20\r\nKPX abreve w -15\r\nKPX acircumflex v -20\r\nKPX acircumflex w -15\r\nKPX adieresis v -20\r\nKPX adieresis w -15\r\nKPX agrave v -20\r\nKPX agrave w -15\r\nKPX amacron v -20\r\nKPX amacron w -15\r\nKPX aogonek v -20\r\nKPX aogonek w -15\r\nKPX aring v -20\r\nKPX aring w -15\r\nKPX atilde v -20\r\nKPX atilde w -15\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -15\r\nKPX c y -15\r\nKPX c yacute -15\r\nKPX c ydieresis -15\r\nKPX cacute y -15\r\nKPX cacute yacute -15\r\nKPX cacute ydieresis -15\r\nKPX ccaron y -15\r\nKPX ccaron yacute -15\r\nKPX ccaron ydieresis -15\r\nKPX ccedilla y -15\r\nKPX ccedilla yacute -15\r\nKPX ccedilla ydieresis -15\r\nKPX comma quotedblright -70\r\nKPX comma quoteright -70\r\nKPX e g -15\r\nKPX e gbreve -15\r\nKPX e gcommaaccent -15\r\nKPX e v -25\r\nKPX e w -25\r\nKPX e x -15\r\nKPX e y -15\r\nKPX e yacute -15\r\nKPX e ydieresis -15\r\nKPX eacute g -15\r\nKPX eacute gbreve -15\r\nKPX eacute gcommaaccent -15\r\nKPX eacute v -25\r\nKPX eacute w -25\r\nKPX eacute x -15\r\nKPX eacute y -15\r\nKPX eacute yacute -15\r\nKPX eacute ydieresis -15\r\nKPX ecaron g -15\r\nKPX ecaron gbreve -15\r\nKPX ecaron gcommaaccent -15\r\nKPX ecaron v -25\r\nKPX ecaron w -25\r\nKPX ecaron x -15\r\nKPX ecaron y -15\r\nKPX ecaron yacute -15\r\nKPX ecaron ydieresis -15\r\nKPX ecircumflex g -15\r\nKPX ecircumflex gbreve -15\r\nKPX ecircumflex gcommaaccent -15\r\nKPX ecircumflex v -25\r\nKPX ecircumflex w -25\r\nKPX ecircumflex x -15\r\nKPX ecircumflex y -15\r\nKPX ecircumflex yacute -15\r\nKPX ecircumflex ydieresis -15\r\nKPX edieresis g -15\r\nKPX edieresis gbreve -15\r\nKPX edieresis gcommaaccent -15\r\nKPX edieresis v -25\r\nKPX edieresis w -25\r\nKPX edieresis x -15\r\nKPX edieresis y -15\r\nKPX edieresis yacute -15\r\nKPX edieresis ydieresis -15\r\nKPX edotaccent g -15\r\nKPX edotaccent gbreve -15\r\nKPX edotaccent gcommaaccent -15\r\nKPX edotaccent v -25\r\nKPX edotaccent w -25\r\nKPX edotaccent x -15\r\nKPX edotaccent y -15\r\nKPX edotaccent yacute -15\r\nKPX edotaccent ydieresis -15\r\nKPX egrave g -15\r\nKPX egrave gbreve -15\r\nKPX egrave gcommaaccent -15\r\nKPX egrave v -25\r\nKPX egrave w -25\r\nKPX egrave x -15\r\nKPX egrave y -15\r\nKPX egrave yacute -15\r\nKPX egrave ydieresis -15\r\nKPX emacron g -15\r\nKPX emacron gbreve -15\r\nKPX emacron gcommaaccent -15\r\nKPX emacron v -25\r\nKPX emacron w -25\r\nKPX emacron x -15\r\nKPX emacron y -15\r\nKPX emacron yacute -15\r\nKPX emacron ydieresis -15\r\nKPX eogonek g -15\r\nKPX eogonek gbreve -15\r\nKPX eogonek gcommaaccent -15\r\nKPX eogonek v -25\r\nKPX eogonek w -25\r\nKPX eogonek x -15\r\nKPX eogonek y -15\r\nKPX eogonek yacute -15\r\nKPX eogonek ydieresis -15\r\nKPX f a -10\r\nKPX f aacute -10\r\nKPX f abreve -10\r\nKPX f acircumflex -10\r\nKPX f adieresis -10\r\nKPX f agrave -10\r\nKPX f amacron -10\r\nKPX f aogonek -10\r\nKPX f aring -10\r\nKPX f atilde -10\r\nKPX f dotlessi -50\r\nKPX f f -25\r\nKPX f i -20\r\nKPX f iacute -20\r\nKPX f quoteright 55\r\nKPX g a -5\r\nKPX g aacute -5\r\nKPX g abreve -5\r\nKPX g acircumflex -5\r\nKPX g adieresis -5\r\nKPX g agrave -5\r\nKPX g amacron -5\r\nKPX g aogonek -5\r\nKPX g aring -5\r\nKPX g atilde -5\r\nKPX gbreve a -5\r\nKPX gbreve aacute -5\r\nKPX gbreve abreve -5\r\nKPX gbreve acircumflex -5\r\nKPX gbreve adieresis -5\r\nKPX gbreve agrave -5\r\nKPX gbreve amacron -5\r\nKPX gbreve aogonek -5\r\nKPX gbreve aring -5\r\nKPX gbreve atilde -5\r\nKPX gcommaaccent a -5\r\nKPX gcommaaccent aacute -5\r\nKPX gcommaaccent abreve -5\r\nKPX gcommaaccent acircumflex -5\r\nKPX gcommaaccent adieresis -5\r\nKPX gcommaaccent agrave -5\r\nKPX gcommaaccent amacron -5\r\nKPX gcommaaccent aogonek -5\r\nKPX gcommaaccent aring -5\r\nKPX gcommaaccent atilde -5\r\nKPX h y -5\r\nKPX h yacute -5\r\nKPX h ydieresis -5\r\nKPX i v -25\r\nKPX iacute v -25\r\nKPX icircumflex v -25\r\nKPX idieresis v -25\r\nKPX igrave v -25\r\nKPX imacron v -25\r\nKPX iogonek v -25\r\nKPX k e -10\r\nKPX k eacute -10\r\nKPX k ecaron -10\r\nKPX k ecircumflex -10\r\nKPX k edieresis -10\r\nKPX k edotaccent -10\r\nKPX k egrave -10\r\nKPX k emacron -10\r\nKPX k eogonek -10\r\nKPX k o -10\r\nKPX k oacute -10\r\nKPX k ocircumflex -10\r\nKPX k odieresis -10\r\nKPX k ograve -10\r\nKPX k ohungarumlaut -10\r\nKPX k omacron -10\r\nKPX k oslash -10\r\nKPX k otilde -10\r\nKPX k y -15\r\nKPX k yacute -15\r\nKPX k ydieresis -15\r\nKPX kcommaaccent e -10\r\nKPX kcommaaccent eacute -10\r\nKPX kcommaaccent ecaron -10\r\nKPX kcommaaccent ecircumflex -10\r\nKPX kcommaaccent edieresis -10\r\nKPX kcommaaccent edotaccent -10\r\nKPX kcommaaccent egrave -10\r\nKPX kcommaaccent emacron -10\r\nKPX kcommaaccent eogonek -10\r\nKPX kcommaaccent o -10\r\nKPX kcommaaccent oacute -10\r\nKPX kcommaaccent ocircumflex -10\r\nKPX kcommaaccent odieresis -10\r\nKPX kcommaaccent ograve -10\r\nKPX kcommaaccent ohungarumlaut -10\r\nKPX kcommaaccent omacron -10\r\nKPX kcommaaccent oslash -10\r\nKPX kcommaaccent otilde -10\r\nKPX kcommaaccent y -15\r\nKPX kcommaaccent yacute -15\r\nKPX kcommaaccent ydieresis -15\r\nKPX l w -10\r\nKPX lacute w -10\r\nKPX lcommaaccent w -10\r\nKPX lslash w -10\r\nKPX n v -40\r\nKPX n y -15\r\nKPX n yacute -15\r\nKPX n ydieresis -15\r\nKPX nacute v -40\r\nKPX nacute y -15\r\nKPX nacute yacute -15\r\nKPX nacute ydieresis -15\r\nKPX ncaron v -40\r\nKPX ncaron y -15\r\nKPX ncaron yacute -15\r\nKPX ncaron ydieresis -15\r\nKPX ncommaaccent v -40\r\nKPX ncommaaccent y -15\r\nKPX ncommaaccent yacute -15\r\nKPX ncommaaccent ydieresis -15\r\nKPX ntilde v -40\r\nKPX ntilde y -15\r\nKPX ntilde yacute -15\r\nKPX ntilde ydieresis -15\r\nKPX o v -15\r\nKPX o w -25\r\nKPX o y -10\r\nKPX o yacute -10\r\nKPX o ydieresis -10\r\nKPX oacute v -15\r\nKPX oacute w -25\r\nKPX oacute y -10\r\nKPX oacute yacute -10\r\nKPX oacute ydieresis -10\r\nKPX ocircumflex v -15\r\nKPX ocircumflex w -25\r\nKPX ocircumflex y -10\r\nKPX ocircumflex yacute -10\r\nKPX ocircumflex ydieresis -10\r\nKPX odieresis v -15\r\nKPX odieresis w -25\r\nKPX odieresis y -10\r\nKPX odieresis yacute -10\r\nKPX odieresis ydieresis -10\r\nKPX ograve v -15\r\nKPX ograve w -25\r\nKPX ograve y -10\r\nKPX ograve yacute -10\r\nKPX ograve ydieresis -10\r\nKPX ohungarumlaut v -15\r\nKPX ohungarumlaut w -25\r\nKPX ohungarumlaut y -10\r\nKPX ohungarumlaut yacute -10\r\nKPX ohungarumlaut ydieresis -10\r\nKPX omacron v -15\r\nKPX omacron w -25\r\nKPX omacron y -10\r\nKPX omacron yacute -10\r\nKPX omacron ydieresis -10\r\nKPX oslash v -15\r\nKPX oslash w -25\r\nKPX oslash y -10\r\nKPX oslash yacute -10\r\nKPX oslash ydieresis -10\r\nKPX otilde v -15\r\nKPX otilde w -25\r\nKPX otilde y -10\r\nKPX otilde yacute -10\r\nKPX otilde ydieresis -10\r\nKPX p y -10\r\nKPX p yacute -10\r\nKPX p ydieresis -10\r\nKPX period quotedblright -70\r\nKPX period quoteright -70\r\nKPX quotedblleft A -80\r\nKPX quotedblleft Aacute -80\r\nKPX quotedblleft Abreve -80\r\nKPX quotedblleft Acircumflex -80\r\nKPX quotedblleft Adieresis -80\r\nKPX quotedblleft Agrave -80\r\nKPX quotedblleft Amacron -80\r\nKPX quotedblleft Aogonek -80\r\nKPX quotedblleft Aring -80\r\nKPX quotedblleft Atilde -80\r\nKPX quoteleft A -80\r\nKPX quoteleft Aacute -80\r\nKPX quoteleft Abreve -80\r\nKPX quoteleft Acircumflex -80\r\nKPX quoteleft Adieresis -80\r\nKPX quoteleft Agrave -80\r\nKPX quoteleft Amacron -80\r\nKPX quoteleft Aogonek -80\r\nKPX quoteleft Aring -80\r\nKPX quoteleft Atilde -80\r\nKPX quoteleft quoteleft -74\r\nKPX quoteright d -50\r\nKPX quoteright dcroat -50\r\nKPX quoteright l -10\r\nKPX quoteright lacute -10\r\nKPX quoteright lcommaaccent -10\r\nKPX quoteright lslash -10\r\nKPX quoteright quoteright -74\r\nKPX quoteright r -50\r\nKPX quoteright racute -50\r\nKPX quoteright rcaron -50\r\nKPX quoteright rcommaaccent -50\r\nKPX quoteright s -55\r\nKPX quoteright sacute -55\r\nKPX quoteright scaron -55\r\nKPX quoteright scedilla -55\r\nKPX quoteright scommaaccent -55\r\nKPX quoteright space -74\r\nKPX quoteright t -18\r\nKPX quoteright tcommaaccent -18\r\nKPX quoteright v -50\r\nKPX r comma -40\r\nKPX r g -18\r\nKPX r gbreve -18\r\nKPX r gcommaaccent -18\r\nKPX r hyphen -20\r\nKPX r period -55\r\nKPX racute comma -40\r\nKPX racute g -18\r\nKPX racute gbreve -18\r\nKPX racute gcommaaccent -18\r\nKPX racute hyphen -20\r\nKPX racute period -55\r\nKPX rcaron comma -40\r\nKPX rcaron g -18\r\nKPX rcaron gbreve -18\r\nKPX rcaron gcommaaccent -18\r\nKPX rcaron hyphen -20\r\nKPX rcaron period -55\r\nKPX rcommaaccent comma -40\r\nKPX rcommaaccent g -18\r\nKPX rcommaaccent gbreve -18\r\nKPX rcommaaccent gcommaaccent -18\r\nKPX rcommaaccent hyphen -20\r\nKPX rcommaaccent period -55\r\nKPX space A -55\r\nKPX space Aacute -55\r\nKPX space Abreve -55\r\nKPX space Acircumflex -55\r\nKPX space Adieresis -55\r\nKPX space Agrave -55\r\nKPX space Amacron -55\r\nKPX space Aogonek -55\r\nKPX space Aring -55\r\nKPX space Atilde -55\r\nKPX space T -18\r\nKPX space Tcaron -18\r\nKPX space Tcommaaccent -18\r\nKPX space V -50\r\nKPX space W -30\r\nKPX space Y -90\r\nKPX space Yacute -90\r\nKPX space Ydieresis -90\r\nKPX v a -25\r\nKPX v aacute -25\r\nKPX v abreve -25\r\nKPX v acircumflex -25\r\nKPX v adieresis -25\r\nKPX v agrave -25\r\nKPX v amacron -25\r\nKPX v aogonek -25\r\nKPX v aring -25\r\nKPX v atilde -25\r\nKPX v comma -65\r\nKPX v e -15\r\nKPX v eacute -15\r\nKPX v ecaron -15\r\nKPX v ecircumflex -15\r\nKPX v edieresis -15\r\nKPX v edotaccent -15\r\nKPX v egrave -15\r\nKPX v emacron -15\r\nKPX v eogonek -15\r\nKPX v o -20\r\nKPX v oacute -20\r\nKPX v ocircumflex -20\r\nKPX v odieresis -20\r\nKPX v ograve -20\r\nKPX v ohungarumlaut -20\r\nKPX v omacron -20\r\nKPX v oslash -20\r\nKPX v otilde -20\r\nKPX v period -65\r\nKPX w a -10\r\nKPX w aacute -10\r\nKPX w abreve -10\r\nKPX w acircumflex -10\r\nKPX w adieresis -10\r\nKPX w agrave -10\r\nKPX w amacron -10\r\nKPX w aogonek -10\r\nKPX w aring -10\r\nKPX w atilde -10\r\nKPX w comma -65\r\nKPX w o -10\r\nKPX w oacute -10\r\nKPX w ocircumflex -10\r\nKPX w odieresis -10\r\nKPX w ograve -10\r\nKPX w ohungarumlaut -10\r\nKPX w omacron -10\r\nKPX w oslash -10\r\nKPX w otilde -10\r\nKPX w period -65\r\nKPX x e -15\r\nKPX x eacute -15\r\nKPX x ecaron -15\r\nKPX x ecircumflex -15\r\nKPX x edieresis -15\r\nKPX x edotaccent -15\r\nKPX x egrave -15\r\nKPX x emacron -15\r\nKPX x eogonek -15\r\nKPX y comma -65\r\nKPX y period -65\r\nKPX yacute comma -65\r\nKPX yacute period -65\r\nKPX ydieresis comma -65\r\nKPX ydieresis period -65\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Times-Bold"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:52:56 1997\r\nComment UniqueID 43065\r\nComment VMusage 41636 52661\r\nFontName Times-Bold\r\nFullName Times Bold\r\nFamilyName Times\r\nWeight Bold\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -168 -218 1000 935 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 676\r\nXHeight 461\r\nAscender 683\r\nDescender -217\r\nStdHW 44\r\nStdVW 139\r\nStartCharMetrics 315\r\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 81 -13 251 691 ;\r\nC 34 ; WX 555 ; N quotedbl ; B 83 404 472 691 ;\r\nC 35 ; WX 500 ; N numbersign ; B 4 0 496 700 ;\r\nC 36 ; WX 500 ; N dollar ; B 29 -99 472 750 ;\r\nC 37 ; WX 1000 ; N percent ; B 124 -14 877 692 ;\r\nC 38 ; WX 833 ; N ampersand ; B 62 -16 787 691 ;\r\nC 39 ; WX 333 ; N quoteright ; B 79 356 263 691 ;\r\nC 40 ; WX 333 ; N parenleft ; B 46 -168 306 694 ;\r\nC 41 ; WX 333 ; N parenright ; B 27 -168 287 694 ;\r\nC 42 ; WX 500 ; N asterisk ; B 56 255 447 691 ;\r\nC 43 ; WX 570 ; N plus ; B 33 0 537 506 ;\r\nC 44 ; WX 250 ; N comma ; B 39 -180 223 155 ;\r\nC 45 ; WX 333 ; N hyphen ; B 44 171 287 287 ;\r\nC 46 ; WX 250 ; N period ; B 41 -13 210 156 ;\r\nC 47 ; WX 278 ; N slash ; B -24 -19 302 691 ;\r\nC 48 ; WX 500 ; N zero ; B 24 -13 476 688 ;\r\nC 49 ; WX 500 ; N one ; B 65 0 442 688 ;\r\nC 50 ; WX 500 ; N two ; B 17 0 478 688 ;\r\nC 51 ; WX 500 ; N three ; B 16 -14 468 688 ;\r\nC 52 ; WX 500 ; N four ; B 19 0 475 688 ;\r\nC 53 ; WX 500 ; N five ; B 22 -8 470 676 ;\r\nC 54 ; WX 500 ; N six ; B 28 -13 475 688 ;\r\nC 55 ; WX 500 ; N seven ; B 17 0 477 676 ;\r\nC 56 ; WX 500 ; N eight ; B 28 -13 472 688 ;\r\nC 57 ; WX 500 ; N nine ; B 26 -13 473 688 ;\r\nC 58 ; WX 333 ; N colon ; B 82 -13 251 472 ;\r\nC 59 ; WX 333 ; N semicolon ; B 82 -180 266 472 ;\r\nC 60 ; WX 570 ; N less ; B 31 -8 539 514 ;\r\nC 61 ; WX 570 ; N equal ; B 33 107 537 399 ;\r\nC 62 ; WX 570 ; N greater ; B 31 -8 539 514 ;\r\nC 63 ; WX 500 ; N question ; B 57 -13 445 689 ;\r\nC 64 ; WX 930 ; N at ; B 108 -19 822 691 ;\r\nC 65 ; WX 722 ; N A ; B 9 0 689 690 ;\r\nC 66 ; WX 667 ; N B ; B 16 0 619 676 ;\r\nC 67 ; WX 722 ; N C ; B 49 -19 687 691 ;\r\nC 68 ; WX 722 ; N D ; B 14 0 690 676 ;\r\nC 69 ; WX 667 ; N E ; B 16 0 641 676 ;\r\nC 70 ; WX 611 ; N F ; B 16 0 583 676 ;\r\nC 71 ; WX 778 ; N G ; B 37 -19 755 691 ;\r\nC 72 ; WX 778 ; N H ; B 21 0 759 676 ;\r\nC 73 ; WX 389 ; N I ; B 20 0 370 676 ;\r\nC 74 ; WX 500 ; N J ; B 3 -96 479 676 ;\r\nC 75 ; WX 778 ; N K ; B 30 0 769 676 ;\r\nC 76 ; WX 667 ; N L ; B 19 0 638 676 ;\r\nC 77 ; WX 944 ; N M ; B 14 0 921 676 ;\r\nC 78 ; WX 722 ; N N ; B 16 -18 701 676 ;\r\nC 79 ; WX 778 ; N O ; B 35 -19 743 691 ;\r\nC 80 ; WX 611 ; N P ; B 16 0 600 676 ;\r\nC 81 ; WX 778 ; N Q ; B 35 -176 743 691 ;\r\nC 82 ; WX 722 ; N R ; B 26 0 715 676 ;\r\nC 83 ; WX 556 ; N S ; B 35 -19 513 692 ;\r\nC 84 ; WX 667 ; N T ; B 31 0 636 676 ;\r\nC 85 ; WX 722 ; N U ; B 16 -19 701 676 ;\r\nC 86 ; WX 722 ; N V ; B 16 -18 701 676 ;\r\nC 87 ; WX 1000 ; N W ; B 19 -15 981 676 ;\r\nC 88 ; WX 722 ; N X ; B 16 0 699 676 ;\r\nC 89 ; WX 722 ; N Y ; B 15 0 699 676 ;\r\nC 90 ; WX 667 ; N Z ; B 28 0 634 676 ;\r\nC 91 ; WX 333 ; N bracketleft ; B 67 -149 301 678 ;\r\nC 92 ; WX 278 ; N backslash ; B -25 -19 303 691 ;\r\nC 93 ; WX 333 ; N bracketright ; B 32 -149 266 678 ;\r\nC 94 ; WX 581 ; N asciicircum ; B 73 311 509 676 ;\r\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\r\nC 96 ; WX 333 ; N quoteleft ; B 70 356 254 691 ;\r\nC 97 ; WX 500 ; N a ; B 25 -14 488 473 ;\r\nC 98 ; WX 556 ; N b ; B 17 -14 521 676 ;\r\nC 99 ; WX 444 ; N c ; B 25 -14 430 473 ;\r\nC 100 ; WX 556 ; N d ; B 25 -14 534 676 ;\r\nC 101 ; WX 444 ; N e ; B 25 -14 426 473 ;\r\nC 102 ; WX 333 ; N f ; B 14 0 389 691 ; L i fi ; L l fl ;\r\nC 103 ; WX 500 ; N g ; B 28 -206 483 473 ;\r\nC 104 ; WX 556 ; N h ; B 16 0 534 676 ;\r\nC 105 ; WX 278 ; N i ; B 16 0 255 691 ;\r\nC 106 ; WX 333 ; N j ; B -57 -203 263 691 ;\r\nC 107 ; WX 556 ; N k ; B 22 0 543 676 ;\r\nC 108 ; WX 278 ; N l ; B 16 0 255 676 ;\r\nC 109 ; WX 833 ; N m ; B 16 0 814 473 ;\r\nC 110 ; WX 556 ; N n ; B 21 0 539 473 ;\r\nC 111 ; WX 500 ; N o ; B 25 -14 476 473 ;\r\nC 112 ; WX 556 ; N p ; B 19 -205 524 473 ;\r\nC 113 ; WX 556 ; N q ; B 34 -205 536 473 ;\r\nC 114 ; WX 444 ; N r ; B 29 0 434 473 ;\r\nC 115 ; WX 389 ; N s ; B 25 -14 361 473 ;\r\nC 116 ; WX 333 ; N t ; B 20 -12 332 630 ;\r\nC 117 ; WX 556 ; N u ; B 16 -14 537 461 ;\r\nC 118 ; WX 500 ; N v ; B 21 -14 485 461 ;\r\nC 119 ; WX 722 ; N w ; B 23 -14 707 461 ;\r\nC 120 ; WX 500 ; N x ; B 12 0 484 461 ;\r\nC 121 ; WX 500 ; N y ; B 16 -205 480 461 ;\r\nC 122 ; WX 444 ; N z ; B 21 0 420 461 ;\r\nC 123 ; WX 394 ; N braceleft ; B 22 -175 340 698 ;\r\nC 124 ; WX 220 ; N bar ; B 66 -218 154 782 ;\r\nC 125 ; WX 394 ; N braceright ; B 54 -175 372 698 ;\r\nC 126 ; WX 520 ; N asciitilde ; B 29 173 491 333 ;\r\nC 161 ; WX 333 ; N exclamdown ; B 82 -203 252 501 ;\r\nC 162 ; WX 500 ; N cent ; B 53 -140 458 588 ;\r\nC 163 ; WX 500 ; N sterling ; B 21 -14 477 684 ;\r\nC 164 ; WX 167 ; N fraction ; B -168 -12 329 688 ;\r\nC 165 ; WX 500 ; N yen ; B -64 0 547 676 ;\r\nC 166 ; WX 500 ; N florin ; B 0 -155 498 706 ;\r\nC 167 ; WX 500 ; N section ; B 57 -132 443 691 ;\r\nC 168 ; WX 500 ; N currency ; B -26 61 526 613 ;\r\nC 169 ; WX 278 ; N quotesingle ; B 75 404 204 691 ;\r\nC 170 ; WX 500 ; N quotedblleft ; B 32 356 486 691 ;\r\nC 171 ; WX 500 ; N guillemotleft ; B 23 36 473 415 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 51 36 305 415 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 28 36 282 415 ;\r\nC 174 ; WX 556 ; N fi ; B 14 0 536 691 ;\r\nC 175 ; WX 556 ; N fl ; B 14 0 536 691 ;\r\nC 177 ; WX 500 ; N endash ; B 0 181 500 271 ;\r\nC 178 ; WX 500 ; N dagger ; B 47 -134 453 691 ;\r\nC 179 ; WX 500 ; N daggerdbl ; B 45 -132 456 691 ;\r\nC 180 ; WX 250 ; N periodcentered ; B 41 248 210 417 ;\r\nC 182 ; WX 540 ; N paragraph ; B 0 -186 519 676 ;\r\nC 183 ; WX 350 ; N bullet ; B 35 198 315 478 ;\r\nC 184 ; WX 333 ; N quotesinglbase ; B 79 -180 263 155 ;\r\nC 185 ; WX 500 ; N quotedblbase ; B 14 -180 468 155 ;\r\nC 186 ; WX 500 ; N quotedblright ; B 14 356 468 691 ;\r\nC 187 ; WX 500 ; N guillemotright ; B 27 36 477 415 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 82 -13 917 156 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 7 -29 995 706 ;\r\nC 191 ; WX 500 ; N questiondown ; B 55 -201 443 501 ;\r\nC 193 ; WX 333 ; N grave ; B 8 528 246 713 ;\r\nC 194 ; WX 333 ; N acute ; B 86 528 324 713 ;\r\nC 195 ; WX 333 ; N circumflex ; B -2 528 335 704 ;\r\nC 196 ; WX 333 ; N tilde ; B -16 547 349 674 ;\r\nC 197 ; WX 333 ; N macron ; B 1 565 331 637 ;\r\nC 198 ; WX 333 ; N breve ; B 15 528 318 691 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 103 536 258 691 ;\r\nC 200 ; WX 333 ; N dieresis ; B -2 537 335 667 ;\r\nC 202 ; WX 333 ; N ring ; B 60 527 273 740 ;\r\nC 203 ; WX 333 ; N cedilla ; B 68 -218 294 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B -13 528 425 713 ;\r\nC 206 ; WX 333 ; N ogonek ; B 90 -193 319 24 ;\r\nC 207 ; WX 333 ; N caron ; B -2 528 335 704 ;\r\nC 208 ; WX 1000 ; N emdash ; B 0 181 1000 271 ;\r\nC 225 ; WX 1000 ; N AE ; B 4 0 951 676 ;\r\nC 227 ; WX 300 ; N ordfeminine ; B -1 397 301 688 ;\r\nC 232 ; WX 667 ; N Lslash ; B 19 0 638 676 ;\r\nC 233 ; WX 778 ; N Oslash ; B 35 -74 743 737 ;\r\nC 234 ; WX 1000 ; N OE ; B 22 -5 981 684 ;\r\nC 235 ; WX 330 ; N ordmasculine ; B 18 397 312 688 ;\r\nC 241 ; WX 722 ; N ae ; B 33 -14 693 473 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 16 0 255 461 ;\r\nC 248 ; WX 278 ; N lslash ; B -22 0 303 676 ;\r\nC 249 ; WX 500 ; N oslash ; B 25 -92 476 549 ;\r\nC 250 ; WX 722 ; N oe ; B 22 -14 696 473 ;\r\nC 251 ; WX 556 ; N germandbls ; B 19 -12 517 691 ;\r\nC -1 ; WX 389 ; N Idieresis ; B 20 0 370 877 ;\r\nC -1 ; WX 444 ; N eacute ; B 25 -14 426 713 ;\r\nC -1 ; WX 500 ; N abreve ; B 25 -14 488 691 ;\r\nC -1 ; WX 556 ; N uhungarumlaut ; B 16 -14 557 713 ;\r\nC -1 ; WX 444 ; N ecaron ; B 25 -14 426 704 ;\r\nC -1 ; WX 722 ; N Ydieresis ; B 15 0 699 877 ;\r\nC -1 ; WX 570 ; N divide ; B 33 -31 537 537 ;\r\nC -1 ; WX 722 ; N Yacute ; B 15 0 699 923 ;\r\nC -1 ; WX 722 ; N Acircumflex ; B 9 0 689 914 ;\r\nC -1 ; WX 500 ; N aacute ; B 25 -14 488 713 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 16 -19 701 914 ;\r\nC -1 ; WX 500 ; N yacute ; B 16 -205 480 713 ;\r\nC -1 ; WX 389 ; N scommaaccent ; B 25 -218 361 473 ;\r\nC -1 ; WX 444 ; N ecircumflex ; B 25 -14 426 704 ;\r\nC -1 ; WX 722 ; N Uring ; B 16 -19 701 935 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 16 -19 701 877 ;\r\nC -1 ; WX 500 ; N aogonek ; B 25 -193 504 473 ;\r\nC -1 ; WX 722 ; N Uacute ; B 16 -19 701 923 ;\r\nC -1 ; WX 556 ; N uogonek ; B 16 -193 539 461 ;\r\nC -1 ; WX 667 ; N Edieresis ; B 16 0 641 877 ;\r\nC -1 ; WX 722 ; N Dcroat ; B 6 0 690 676 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 47 -218 203 -50 ;\r\nC -1 ; WX 747 ; N copyright ; B 26 -19 721 691 ;\r\nC -1 ; WX 667 ; N Emacron ; B 16 0 641 847 ;\r\nC -1 ; WX 444 ; N ccaron ; B 25 -14 430 704 ;\r\nC -1 ; WX 500 ; N aring ; B 25 -14 488 740 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B 16 -188 701 676 ;\r\nC -1 ; WX 278 ; N lacute ; B 16 0 297 923 ;\r\nC -1 ; WX 500 ; N agrave ; B 25 -14 488 713 ;\r\nC -1 ; WX 667 ; N Tcommaaccent ; B 31 -218 636 676 ;\r\nC -1 ; WX 722 ; N Cacute ; B 49 -19 687 923 ;\r\nC -1 ; WX 500 ; N atilde ; B 25 -14 488 674 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B 16 0 641 901 ;\r\nC -1 ; WX 389 ; N scaron ; B 25 -14 363 704 ;\r\nC -1 ; WX 389 ; N scedilla ; B 25 -218 361 473 ;\r\nC -1 ; WX 278 ; N iacute ; B 16 0 289 713 ;\r\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\r\nC -1 ; WX 722 ; N Rcaron ; B 26 0 715 914 ;\r\nC -1 ; WX 778 ; N Gcommaaccent ; B 37 -218 755 691 ;\r\nC -1 ; WX 556 ; N ucircumflex ; B 16 -14 537 704 ;\r\nC -1 ; WX 500 ; N acircumflex ; B 25 -14 488 704 ;\r\nC -1 ; WX 722 ; N Amacron ; B 9 0 689 847 ;\r\nC -1 ; WX 444 ; N rcaron ; B 29 0 434 704 ;\r\nC -1 ; WX 444 ; N ccedilla ; B 25 -218 430 473 ;\r\nC -1 ; WX 667 ; N Zdotaccent ; B 28 0 634 901 ;\r\nC -1 ; WX 611 ; N Thorn ; B 16 0 600 676 ;\r\nC -1 ; WX 778 ; N Omacron ; B 35 -19 743 847 ;\r\nC -1 ; WX 722 ; N Racute ; B 26 0 715 923 ;\r\nC -1 ; WX 556 ; N Sacute ; B 35 -19 513 923 ;\r\nC -1 ; WX 672 ; N dcaron ; B 25 -14 681 682 ;\r\nC -1 ; WX 722 ; N Umacron ; B 16 -19 701 847 ;\r\nC -1 ; WX 556 ; N uring ; B 16 -14 537 740 ;\r\nC -1 ; WX 300 ; N threesuperior ; B 3 268 297 688 ;\r\nC -1 ; WX 778 ; N Ograve ; B 35 -19 743 923 ;\r\nC -1 ; WX 722 ; N Agrave ; B 9 0 689 923 ;\r\nC -1 ; WX 722 ; N Abreve ; B 9 0 689 901 ;\r\nC -1 ; WX 570 ; N multiply ; B 48 16 522 490 ;\r\nC -1 ; WX 556 ; N uacute ; B 16 -14 537 713 ;\r\nC -1 ; WX 667 ; N Tcaron ; B 31 0 636 914 ;\r\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\r\nC -1 ; WX 500 ; N ydieresis ; B 16 -205 480 667 ;\r\nC -1 ; WX 722 ; N Nacute ; B 16 -18 701 923 ;\r\nC -1 ; WX 278 ; N icircumflex ; B -37 0 300 704 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B 16 0 641 914 ;\r\nC -1 ; WX 500 ; N adieresis ; B 25 -14 488 667 ;\r\nC -1 ; WX 444 ; N edieresis ; B 25 -14 426 667 ;\r\nC -1 ; WX 444 ; N cacute ; B 25 -14 430 713 ;\r\nC -1 ; WX 556 ; N nacute ; B 21 0 539 713 ;\r\nC -1 ; WX 556 ; N umacron ; B 16 -14 537 637 ;\r\nC -1 ; WX 722 ; N Ncaron ; B 16 -18 701 914 ;\r\nC -1 ; WX 389 ; N Iacute ; B 20 0 370 923 ;\r\nC -1 ; WX 570 ; N plusminus ; B 33 0 537 506 ;\r\nC -1 ; WX 220 ; N brokenbar ; B 66 -143 154 707 ;\r\nC -1 ; WX 747 ; N registered ; B 26 -19 721 691 ;\r\nC -1 ; WX 778 ; N Gbreve ; B 37 -19 755 901 ;\r\nC -1 ; WX 389 ; N Idotaccent ; B 20 0 370 901 ;\r\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B 16 0 641 923 ;\r\nC -1 ; WX 444 ; N racute ; B 29 0 434 713 ;\r\nC -1 ; WX 500 ; N omacron ; B 25 -14 476 637 ;\r\nC -1 ; WX 667 ; N Zacute ; B 28 0 634 923 ;\r\nC -1 ; WX 667 ; N Zcaron ; B 28 0 634 914 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\r\nC -1 ; WX 722 ; N Eth ; B 6 0 690 676 ;\r\nC -1 ; WX 722 ; N Ccedilla ; B 49 -218 687 691 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B 16 -218 255 676 ;\r\nC -1 ; WX 416 ; N tcaron ; B 20 -12 425 815 ;\r\nC -1 ; WX 444 ; N eogonek ; B 25 -193 426 473 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 16 -193 701 676 ;\r\nC -1 ; WX 722 ; N Aacute ; B 9 0 689 923 ;\r\nC -1 ; WX 722 ; N Adieresis ; B 9 0 689 877 ;\r\nC -1 ; WX 444 ; N egrave ; B 25 -14 426 713 ;\r\nC -1 ; WX 444 ; N zacute ; B 21 0 420 713 ;\r\nC -1 ; WX 278 ; N iogonek ; B 16 -193 274 691 ;\r\nC -1 ; WX 778 ; N Oacute ; B 35 -19 743 923 ;\r\nC -1 ; WX 500 ; N oacute ; B 25 -14 476 713 ;\r\nC -1 ; WX 500 ; N amacron ; B 25 -14 488 637 ;\r\nC -1 ; WX 389 ; N sacute ; B 25 -14 361 713 ;\r\nC -1 ; WX 278 ; N idieresis ; B -37 0 300 667 ;\r\nC -1 ; WX 778 ; N Ocircumflex ; B 35 -19 743 914 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 16 -19 701 923 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 556 ; N thorn ; B 19 -205 524 676 ;\r\nC -1 ; WX 300 ; N twosuperior ; B 0 275 300 688 ;\r\nC -1 ; WX 778 ; N Odieresis ; B 35 -19 743 877 ;\r\nC -1 ; WX 556 ; N mu ; B 33 -206 536 461 ;\r\nC -1 ; WX 278 ; N igrave ; B -27 0 255 713 ;\r\nC -1 ; WX 500 ; N ohungarumlaut ; B 25 -14 529 713 ;\r\nC -1 ; WX 667 ; N Eogonek ; B 16 -193 644 676 ;\r\nC -1 ; WX 556 ; N dcroat ; B 25 -14 534 676 ;\r\nC -1 ; WX 750 ; N threequarters ; B 23 -12 733 688 ;\r\nC -1 ; WX 556 ; N Scedilla ; B 35 -218 513 692 ;\r\nC -1 ; WX 394 ; N lcaron ; B 16 0 412 682 ;\r\nC -1 ; WX 778 ; N Kcommaaccent ; B 30 -218 769 676 ;\r\nC -1 ; WX 667 ; N Lacute ; B 19 0 638 923 ;\r\nC -1 ; WX 1000 ; N trademark ; B 24 271 977 676 ;\r\nC -1 ; WX 444 ; N edotaccent ; B 25 -14 426 691 ;\r\nC -1 ; WX 389 ; N Igrave ; B 20 0 370 923 ;\r\nC -1 ; WX 389 ; N Imacron ; B 20 0 370 847 ;\r\nC -1 ; WX 667 ; N Lcaron ; B 19 0 652 682 ;\r\nC -1 ; WX 750 ; N onehalf ; B -7 -12 775 688 ;\r\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\r\nC -1 ; WX 500 ; N ocircumflex ; B 25 -14 476 704 ;\r\nC -1 ; WX 556 ; N ntilde ; B 21 0 539 674 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 16 -19 701 923 ;\r\nC -1 ; WX 667 ; N Eacute ; B 16 0 641 923 ;\r\nC -1 ; WX 444 ; N emacron ; B 25 -14 426 637 ;\r\nC -1 ; WX 500 ; N gbreve ; B 28 -206 483 691 ;\r\nC -1 ; WX 750 ; N onequarter ; B 28 -12 743 688 ;\r\nC -1 ; WX 556 ; N Scaron ; B 35 -19 513 914 ;\r\nC -1 ; WX 556 ; N Scommaaccent ; B 35 -218 513 692 ;\r\nC -1 ; WX 778 ; N Ohungarumlaut ; B 35 -19 743 923 ;\r\nC -1 ; WX 400 ; N degree ; B 57 402 343 688 ;\r\nC -1 ; WX 500 ; N ograve ; B 25 -14 476 713 ;\r\nC -1 ; WX 722 ; N Ccaron ; B 49 -19 687 914 ;\r\nC -1 ; WX 556 ; N ugrave ; B 16 -14 537 713 ;\r\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\r\nC -1 ; WX 722 ; N Dcaron ; B 14 0 690 914 ;\r\nC -1 ; WX 444 ; N rcommaaccent ; B 29 -218 434 473 ;\r\nC -1 ; WX 722 ; N Ntilde ; B 16 -18 701 884 ;\r\nC -1 ; WX 500 ; N otilde ; B 25 -14 476 674 ;\r\nC -1 ; WX 722 ; N Rcommaaccent ; B 26 -218 715 676 ;\r\nC -1 ; WX 667 ; N Lcommaaccent ; B 19 -218 638 676 ;\r\nC -1 ; WX 722 ; N Atilde ; B 9 0 689 884 ;\r\nC -1 ; WX 722 ; N Aogonek ; B 9 -193 699 690 ;\r\nC -1 ; WX 722 ; N Aring ; B 9 0 689 935 ;\r\nC -1 ; WX 778 ; N Otilde ; B 35 -19 743 884 ;\r\nC -1 ; WX 444 ; N zdotaccent ; B 21 0 420 691 ;\r\nC -1 ; WX 667 ; N Ecaron ; B 16 0 641 914 ;\r\nC -1 ; WX 389 ; N Iogonek ; B 20 -193 370 676 ;\r\nC -1 ; WX 556 ; N kcommaaccent ; B 22 -218 543 676 ;\r\nC -1 ; WX 570 ; N minus ; B 33 209 537 297 ;\r\nC -1 ; WX 389 ; N Icircumflex ; B 20 0 370 914 ;\r\nC -1 ; WX 556 ; N ncaron ; B 21 0 539 704 ;\r\nC -1 ; WX 333 ; N tcommaaccent ; B 20 -218 332 630 ;\r\nC -1 ; WX 570 ; N logicalnot ; B 33 108 537 399 ;\r\nC -1 ; WX 500 ; N odieresis ; B 25 -14 476 667 ;\r\nC -1 ; WX 556 ; N udieresis ; B 16 -14 537 667 ;\r\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\r\nC -1 ; WX 500 ; N gcommaaccent ; B 28 -206 483 829 ;\r\nC -1 ; WX 500 ; N eth ; B 25 -14 476 691 ;\r\nC -1 ; WX 444 ; N zcaron ; B 21 0 420 704 ;\r\nC -1 ; WX 556 ; N ncommaaccent ; B 21 -218 539 473 ;\r\nC -1 ; WX 300 ; N onesuperior ; B 28 275 273 688 ;\r\nC -1 ; WX 278 ; N imacron ; B -8 0 272 637 ;\r\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2242\r\nKPX A C -55\r\nKPX A Cacute -55\r\nKPX A Ccaron -55\r\nKPX A Ccedilla -55\r\nKPX A G -55\r\nKPX A Gbreve -55\r\nKPX A Gcommaaccent -55\r\nKPX A O -45\r\nKPX A Oacute -45\r\nKPX A Ocircumflex -45\r\nKPX A Odieresis -45\r\nKPX A Ograve -45\r\nKPX A Ohungarumlaut -45\r\nKPX A Omacron -45\r\nKPX A Oslash -45\r\nKPX A Otilde -45\r\nKPX A Q -45\r\nKPX A T -95\r\nKPX A Tcaron -95\r\nKPX A Tcommaaccent -95\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -145\r\nKPX A W -130\r\nKPX A Y -100\r\nKPX A Yacute -100\r\nKPX A Ydieresis -100\r\nKPX A p -25\r\nKPX A quoteright -74\r\nKPX A u -50\r\nKPX A uacute -50\r\nKPX A ucircumflex -50\r\nKPX A udieresis -50\r\nKPX A ugrave -50\r\nKPX A uhungarumlaut -50\r\nKPX A umacron -50\r\nKPX A uogonek -50\r\nKPX A uring -50\r\nKPX A v -100\r\nKPX A w -90\r\nKPX A y -74\r\nKPX A yacute -74\r\nKPX A ydieresis -74\r\nKPX Aacute C -55\r\nKPX Aacute Cacute -55\r\nKPX Aacute Ccaron -55\r\nKPX Aacute Ccedilla -55\r\nKPX Aacute G -55\r\nKPX Aacute Gbreve -55\r\nKPX Aacute Gcommaaccent -55\r\nKPX Aacute O -45\r\nKPX Aacute Oacute -45\r\nKPX Aacute Ocircumflex -45\r\nKPX Aacute Odieresis -45\r\nKPX Aacute Ograve -45\r\nKPX Aacute Ohungarumlaut -45\r\nKPX Aacute Omacron -45\r\nKPX Aacute Oslash -45\r\nKPX Aacute Otilde -45\r\nKPX Aacute Q -45\r\nKPX Aacute T -95\r\nKPX Aacute Tcaron -95\r\nKPX Aacute Tcommaaccent -95\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -145\r\nKPX Aacute W -130\r\nKPX Aacute Y -100\r\nKPX Aacute Yacute -100\r\nKPX Aacute Ydieresis -100\r\nKPX Aacute p -25\r\nKPX Aacute quoteright -74\r\nKPX Aacute u -50\r\nKPX Aacute uacute -50\r\nKPX Aacute ucircumflex -50\r\nKPX Aacute udieresis -50\r\nKPX Aacute ugrave -50\r\nKPX Aacute uhungarumlaut -50\r\nKPX Aacute umacron -50\r\nKPX Aacute uogonek -50\r\nKPX Aacute uring -50\r\nKPX Aacute v -100\r\nKPX Aacute w -90\r\nKPX Aacute y -74\r\nKPX Aacute yacute -74\r\nKPX Aacute ydieresis -74\r\nKPX Abreve C -55\r\nKPX Abreve Cacute -55\r\nKPX Abreve Ccaron -55\r\nKPX Abreve Ccedilla -55\r\nKPX Abreve G -55\r\nKPX Abreve Gbreve -55\r\nKPX Abreve Gcommaaccent -55\r\nKPX Abreve O -45\r\nKPX Abreve Oacute -45\r\nKPX Abreve Ocircumflex -45\r\nKPX Abreve Odieresis -45\r\nKPX Abreve Ograve -45\r\nKPX Abreve Ohungarumlaut -45\r\nKPX Abreve Omacron -45\r\nKPX Abreve Oslash -45\r\nKPX Abreve Otilde -45\r\nKPX Abreve Q -45\r\nKPX Abreve T -95\r\nKPX Abreve Tcaron -95\r\nKPX Abreve Tcommaaccent -95\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -145\r\nKPX Abreve W -130\r\nKPX Abreve Y -100\r\nKPX Abreve Yacute -100\r\nKPX Abreve Ydieresis -100\r\nKPX Abreve p -25\r\nKPX Abreve quoteright -74\r\nKPX Abreve u -50\r\nKPX Abreve uacute -50\r\nKPX Abreve ucircumflex -50\r\nKPX Abreve udieresis -50\r\nKPX Abreve ugrave -50\r\nKPX Abreve uhungarumlaut -50\r\nKPX Abreve umacron -50\r\nKPX Abreve uogonek -50\r\nKPX Abreve uring -50\r\nKPX Abreve v -100\r\nKPX Abreve w -90\r\nKPX Abreve y -74\r\nKPX Abreve yacute -74\r\nKPX Abreve ydieresis -74\r\nKPX Acircumflex C -55\r\nKPX Acircumflex Cacute -55\r\nKPX Acircumflex Ccaron -55\r\nKPX Acircumflex Ccedilla -55\r\nKPX Acircumflex G -55\r\nKPX Acircumflex Gbreve -55\r\nKPX Acircumflex Gcommaaccent -55\r\nKPX Acircumflex O -45\r\nKPX Acircumflex Oacute -45\r\nKPX Acircumflex Ocircumflex -45\r\nKPX Acircumflex Odieresis -45\r\nKPX Acircumflex Ograve -45\r\nKPX Acircumflex Ohungarumlaut -45\r\nKPX Acircumflex Omacron -45\r\nKPX Acircumflex Oslash -45\r\nKPX Acircumflex Otilde -45\r\nKPX Acircumflex Q -45\r\nKPX Acircumflex T -95\r\nKPX Acircumflex Tcaron -95\r\nKPX Acircumflex Tcommaaccent -95\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -145\r\nKPX Acircumflex W -130\r\nKPX Acircumflex Y -100\r\nKPX Acircumflex Yacute -100\r\nKPX Acircumflex Ydieresis -100\r\nKPX Acircumflex p -25\r\nKPX Acircumflex quoteright -74\r\nKPX Acircumflex u -50\r\nKPX Acircumflex uacute -50\r\nKPX Acircumflex ucircumflex -50\r\nKPX Acircumflex udieresis -50\r\nKPX Acircumflex ugrave -50\r\nKPX Acircumflex uhungarumlaut -50\r\nKPX Acircumflex umacron -50\r\nKPX Acircumflex uogonek -50\r\nKPX Acircumflex uring -50\r\nKPX Acircumflex v -100\r\nKPX Acircumflex w -90\r\nKPX Acircumflex y -74\r\nKPX Acircumflex yacute -74\r\nKPX Acircumflex ydieresis -74\r\nKPX Adieresis C -55\r\nKPX Adieresis Cacute -55\r\nKPX Adieresis Ccaron -55\r\nKPX Adieresis Ccedilla -55\r\nKPX Adieresis G -55\r\nKPX Adieresis Gbreve -55\r\nKPX Adieresis Gcommaaccent -55\r\nKPX Adieresis O -45\r\nKPX Adieresis Oacute -45\r\nKPX Adieresis Ocircumflex -45\r\nKPX Adieresis Odieresis -45\r\nKPX Adieresis Ograve -45\r\nKPX Adieresis Ohungarumlaut -45\r\nKPX Adieresis Omacron -45\r\nKPX Adieresis Oslash -45\r\nKPX Adieresis Otilde -45\r\nKPX Adieresis Q -45\r\nKPX Adieresis T -95\r\nKPX Adieresis Tcaron -95\r\nKPX Adieresis Tcommaaccent -95\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -145\r\nKPX Adieresis W -130\r\nKPX Adieresis Y -100\r\nKPX Adieresis Yacute -100\r\nKPX Adieresis Ydieresis -100\r\nKPX Adieresis p -25\r\nKPX Adieresis quoteright -74\r\nKPX Adieresis u -50\r\nKPX Adieresis uacute -50\r\nKPX Adieresis ucircumflex -50\r\nKPX Adieresis udieresis -50\r\nKPX Adieresis ugrave -50\r\nKPX Adieresis uhungarumlaut -50\r\nKPX Adieresis umacron -50\r\nKPX Adieresis uogonek -50\r\nKPX Adieresis uring -50\r\nKPX Adieresis v -100\r\nKPX Adieresis w -90\r\nKPX Adieresis y -74\r\nKPX Adieresis yacute -74\r\nKPX Adieresis ydieresis -74\r\nKPX Agrave C -55\r\nKPX Agrave Cacute -55\r\nKPX Agrave Ccaron -55\r\nKPX Agrave Ccedilla -55\r\nKPX Agrave G -55\r\nKPX Agrave Gbreve -55\r\nKPX Agrave Gcommaaccent -55\r\nKPX Agrave O -45\r\nKPX Agrave Oacute -45\r\nKPX Agrave Ocircumflex -45\r\nKPX Agrave Odieresis -45\r\nKPX Agrave Ograve -45\r\nKPX Agrave Ohungarumlaut -45\r\nKPX Agrave Omacron -45\r\nKPX Agrave Oslash -45\r\nKPX Agrave Otilde -45\r\nKPX Agrave Q -45\r\nKPX Agrave T -95\r\nKPX Agrave Tcaron -95\r\nKPX Agrave Tcommaaccent -95\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -145\r\nKPX Agrave W -130\r\nKPX Agrave Y -100\r\nKPX Agrave Yacute -100\r\nKPX Agrave Ydieresis -100\r\nKPX Agrave p -25\r\nKPX Agrave quoteright -74\r\nKPX Agrave u -50\r\nKPX Agrave uacute -50\r\nKPX Agrave ucircumflex -50\r\nKPX Agrave udieresis -50\r\nKPX Agrave ugrave -50\r\nKPX Agrave uhungarumlaut -50\r\nKPX Agrave umacron -50\r\nKPX Agrave uogonek -50\r\nKPX Agrave uring -50\r\nKPX Agrave v -100\r\nKPX Agrave w -90\r\nKPX Agrave y -74\r\nKPX Agrave yacute -74\r\nKPX Agrave ydieresis -74\r\nKPX Amacron C -55\r\nKPX Amacron Cacute -55\r\nKPX Amacron Ccaron -55\r\nKPX Amacron Ccedilla -55\r\nKPX Amacron G -55\r\nKPX Amacron Gbreve -55\r\nKPX Amacron Gcommaaccent -55\r\nKPX Amacron O -45\r\nKPX Amacron Oacute -45\r\nKPX Amacron Ocircumflex -45\r\nKPX Amacron Odieresis -45\r\nKPX Amacron Ograve -45\r\nKPX Amacron Ohungarumlaut -45\r\nKPX Amacron Omacron -45\r\nKPX Amacron Oslash -45\r\nKPX Amacron Otilde -45\r\nKPX Amacron Q -45\r\nKPX Amacron T -95\r\nKPX Amacron Tcaron -95\r\nKPX Amacron Tcommaaccent -95\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -145\r\nKPX Amacron W -130\r\nKPX Amacron Y -100\r\nKPX Amacron Yacute -100\r\nKPX Amacron Ydieresis -100\r\nKPX Amacron p -25\r\nKPX Amacron quoteright -74\r\nKPX Amacron u -50\r\nKPX Amacron uacute -50\r\nKPX Amacron ucircumflex -50\r\nKPX Amacron udieresis -50\r\nKPX Amacron ugrave -50\r\nKPX Amacron uhungarumlaut -50\r\nKPX Amacron umacron -50\r\nKPX Amacron uogonek -50\r\nKPX Amacron uring -50\r\nKPX Amacron v -100\r\nKPX Amacron w -90\r\nKPX Amacron y -74\r\nKPX Amacron yacute -74\r\nKPX Amacron ydieresis -74\r\nKPX Aogonek C -55\r\nKPX Aogonek Cacute -55\r\nKPX Aogonek Ccaron -55\r\nKPX Aogonek Ccedilla -55\r\nKPX Aogonek G -55\r\nKPX Aogonek Gbreve -55\r\nKPX Aogonek Gcommaaccent -55\r\nKPX Aogonek O -45\r\nKPX Aogonek Oacute -45\r\nKPX Aogonek Ocircumflex -45\r\nKPX Aogonek Odieresis -45\r\nKPX Aogonek Ograve -45\r\nKPX Aogonek Ohungarumlaut -45\r\nKPX Aogonek Omacron -45\r\nKPX Aogonek Oslash -45\r\nKPX Aogonek Otilde -45\r\nKPX Aogonek Q -45\r\nKPX Aogonek T -95\r\nKPX Aogonek Tcaron -95\r\nKPX Aogonek Tcommaaccent -95\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -145\r\nKPX Aogonek W -130\r\nKPX Aogonek Y -100\r\nKPX Aogonek Yacute -100\r\nKPX Aogonek Ydieresis -100\r\nKPX Aogonek p -25\r\nKPX Aogonek quoteright -74\r\nKPX Aogonek u -50\r\nKPX Aogonek uacute -50\r\nKPX Aogonek ucircumflex -50\r\nKPX Aogonek udieresis -50\r\nKPX Aogonek ugrave -50\r\nKPX Aogonek uhungarumlaut -50\r\nKPX Aogonek umacron -50\r\nKPX Aogonek uogonek -50\r\nKPX Aogonek uring -50\r\nKPX Aogonek v -100\r\nKPX Aogonek w -90\r\nKPX Aogonek y -34\r\nKPX Aogonek yacute -34\r\nKPX Aogonek ydieresis -34\r\nKPX Aring C -55\r\nKPX Aring Cacute -55\r\nKPX Aring Ccaron -55\r\nKPX Aring Ccedilla -55\r\nKPX Aring G -55\r\nKPX Aring Gbreve -55\r\nKPX Aring Gcommaaccent -55\r\nKPX Aring O -45\r\nKPX Aring Oacute -45\r\nKPX Aring Ocircumflex -45\r\nKPX Aring Odieresis -45\r\nKPX Aring Ograve -45\r\nKPX Aring Ohungarumlaut -45\r\nKPX Aring Omacron -45\r\nKPX Aring Oslash -45\r\nKPX Aring Otilde -45\r\nKPX Aring Q -45\r\nKPX Aring T -95\r\nKPX Aring Tcaron -95\r\nKPX Aring Tcommaaccent -95\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -145\r\nKPX Aring W -130\r\nKPX Aring Y -100\r\nKPX Aring Yacute -100\r\nKPX Aring Ydieresis -100\r\nKPX Aring p -25\r\nKPX Aring quoteright -74\r\nKPX Aring u -50\r\nKPX Aring uacute -50\r\nKPX Aring ucircumflex -50\r\nKPX Aring udieresis -50\r\nKPX Aring ugrave -50\r\nKPX Aring uhungarumlaut -50\r\nKPX Aring umacron -50\r\nKPX Aring uogonek -50\r\nKPX Aring uring -50\r\nKPX Aring v -100\r\nKPX Aring w -90\r\nKPX Aring y -74\r\nKPX Aring yacute -74\r\nKPX Aring ydieresis -74\r\nKPX Atilde C -55\r\nKPX Atilde Cacute -55\r\nKPX Atilde Ccaron -55\r\nKPX Atilde Ccedilla -55\r\nKPX Atilde G -55\r\nKPX Atilde Gbreve -55\r\nKPX Atilde Gcommaaccent -55\r\nKPX Atilde O -45\r\nKPX Atilde Oacute -45\r\nKPX Atilde Ocircumflex -45\r\nKPX Atilde Odieresis -45\r\nKPX Atilde Ograve -45\r\nKPX Atilde Ohungarumlaut -45\r\nKPX Atilde Omacron -45\r\nKPX Atilde Oslash -45\r\nKPX Atilde Otilde -45\r\nKPX Atilde Q -45\r\nKPX Atilde T -95\r\nKPX Atilde Tcaron -95\r\nKPX Atilde Tcommaaccent -95\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -145\r\nKPX Atilde W -130\r\nKPX Atilde Y -100\r\nKPX Atilde Yacute -100\r\nKPX Atilde Ydieresis -100\r\nKPX Atilde p -25\r\nKPX Atilde quoteright -74\r\nKPX Atilde u -50\r\nKPX Atilde uacute -50\r\nKPX Atilde ucircumflex -50\r\nKPX Atilde udieresis -50\r\nKPX Atilde ugrave -50\r\nKPX Atilde uhungarumlaut -50\r\nKPX Atilde umacron -50\r\nKPX Atilde uogonek -50\r\nKPX Atilde uring -50\r\nKPX Atilde v -100\r\nKPX Atilde w -90\r\nKPX Atilde y -74\r\nKPX Atilde yacute -74\r\nKPX Atilde ydieresis -74\r\nKPX B A -30\r\nKPX B Aacute -30\r\nKPX B Abreve -30\r\nKPX B Acircumflex -30\r\nKPX B Adieresis -30\r\nKPX B Agrave -30\r\nKPX B Amacron -30\r\nKPX B Aogonek -30\r\nKPX B Aring -30\r\nKPX B Atilde -30\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -35\r\nKPX D Aacute -35\r\nKPX D Abreve -35\r\nKPX D Acircumflex -35\r\nKPX D Adieresis -35\r\nKPX D Agrave -35\r\nKPX D Amacron -35\r\nKPX D Aogonek -35\r\nKPX D Aring -35\r\nKPX D Atilde -35\r\nKPX D V -40\r\nKPX D W -40\r\nKPX D Y -40\r\nKPX D Yacute -40\r\nKPX D Ydieresis -40\r\nKPX D period -20\r\nKPX Dcaron A -35\r\nKPX Dcaron Aacute -35\r\nKPX Dcaron Abreve -35\r\nKPX Dcaron Acircumflex -35\r\nKPX Dcaron Adieresis -35\r\nKPX Dcaron Agrave -35\r\nKPX Dcaron Amacron -35\r\nKPX Dcaron Aogonek -35\r\nKPX Dcaron Aring -35\r\nKPX Dcaron Atilde -35\r\nKPX Dcaron V -40\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -40\r\nKPX Dcaron Yacute -40\r\nKPX Dcaron Ydieresis -40\r\nKPX Dcaron period -20\r\nKPX Dcroat A -35\r\nKPX Dcroat Aacute -35\r\nKPX Dcroat Abreve -35\r\nKPX Dcroat Acircumflex -35\r\nKPX Dcroat Adieresis -35\r\nKPX Dcroat Agrave -35\r\nKPX Dcroat Amacron -35\r\nKPX Dcroat Aogonek -35\r\nKPX Dcroat Aring -35\r\nKPX Dcroat Atilde -35\r\nKPX Dcroat V -40\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -40\r\nKPX Dcroat Yacute -40\r\nKPX Dcroat Ydieresis -40\r\nKPX Dcroat period -20\r\nKPX F A -90\r\nKPX F Aacute -90\r\nKPX F Abreve -90\r\nKPX F Acircumflex -90\r\nKPX F Adieresis -90\r\nKPX F Agrave -90\r\nKPX F Amacron -90\r\nKPX F Aogonek -90\r\nKPX F Aring -90\r\nKPX F Atilde -90\r\nKPX F a -25\r\nKPX F aacute -25\r\nKPX F abreve -25\r\nKPX F acircumflex -25\r\nKPX F adieresis -25\r\nKPX F agrave -25\r\nKPX F amacron -25\r\nKPX F aogonek -25\r\nKPX F aring -25\r\nKPX F atilde -25\r\nKPX F comma -92\r\nKPX F e -25\r\nKPX F eacute -25\r\nKPX F ecaron -25\r\nKPX F ecircumflex -25\r\nKPX F edieresis -25\r\nKPX F edotaccent -25\r\nKPX F egrave -25\r\nKPX F emacron -25\r\nKPX F eogonek -25\r\nKPX F o -25\r\nKPX F oacute -25\r\nKPX F ocircumflex -25\r\nKPX F odieresis -25\r\nKPX F ograve -25\r\nKPX F ohungarumlaut -25\r\nKPX F omacron -25\r\nKPX F oslash -25\r\nKPX F otilde -25\r\nKPX F period -110\r\nKPX J A -30\r\nKPX J Aacute -30\r\nKPX J Abreve -30\r\nKPX J Acircumflex -30\r\nKPX J Adieresis -30\r\nKPX J Agrave -30\r\nKPX J Amacron -30\r\nKPX J Aogonek -30\r\nKPX J Aring -30\r\nKPX J Atilde -30\r\nKPX J a -15\r\nKPX J aacute -15\r\nKPX J abreve -15\r\nKPX J acircumflex -15\r\nKPX J adieresis -15\r\nKPX J agrave -15\r\nKPX J amacron -15\r\nKPX J aogonek -15\r\nKPX J aring -15\r\nKPX J atilde -15\r\nKPX J e -15\r\nKPX J eacute -15\r\nKPX J ecaron -15\r\nKPX J ecircumflex -15\r\nKPX J edieresis -15\r\nKPX J edotaccent -15\r\nKPX J egrave -15\r\nKPX J emacron -15\r\nKPX J eogonek -15\r\nKPX J o -15\r\nKPX J oacute -15\r\nKPX J ocircumflex -15\r\nKPX J odieresis -15\r\nKPX J ograve -15\r\nKPX J ohungarumlaut -15\r\nKPX J omacron -15\r\nKPX J oslash -15\r\nKPX J otilde -15\r\nKPX J period -20\r\nKPX J u -15\r\nKPX J uacute -15\r\nKPX J ucircumflex -15\r\nKPX J udieresis -15\r\nKPX J ugrave -15\r\nKPX J uhungarumlaut -15\r\nKPX J umacron -15\r\nKPX J uogonek -15\r\nKPX J uring -15\r\nKPX K O -30\r\nKPX K Oacute -30\r\nKPX K Ocircumflex -30\r\nKPX K Odieresis -30\r\nKPX K Ograve -30\r\nKPX K Ohungarumlaut -30\r\nKPX K Omacron -30\r\nKPX K Oslash -30\r\nKPX K Otilde -30\r\nKPX K e -25\r\nKPX K eacute -25\r\nKPX K ecaron -25\r\nKPX K ecircumflex -25\r\nKPX K edieresis -25\r\nKPX K edotaccent -25\r\nKPX K egrave -25\r\nKPX K emacron -25\r\nKPX K eogonek -25\r\nKPX K o -25\r\nKPX K oacute -25\r\nKPX K ocircumflex -25\r\nKPX K odieresis -25\r\nKPX K ograve -25\r\nKPX K ohungarumlaut -25\r\nKPX K omacron -25\r\nKPX K oslash -25\r\nKPX K otilde -25\r\nKPX K u -15\r\nKPX K uacute -15\r\nKPX K ucircumflex -15\r\nKPX K udieresis -15\r\nKPX K ugrave -15\r\nKPX K uhungarumlaut -15\r\nKPX K umacron -15\r\nKPX K uogonek -15\r\nKPX K uring -15\r\nKPX K y -45\r\nKPX K yacute -45\r\nKPX K ydieresis -45\r\nKPX Kcommaaccent O -30\r\nKPX Kcommaaccent Oacute -30\r\nKPX Kcommaaccent Ocircumflex -30\r\nKPX Kcommaaccent Odieresis -30\r\nKPX Kcommaaccent Ograve -30\r\nKPX Kcommaaccent Ohungarumlaut -30\r\nKPX Kcommaaccent Omacron -30\r\nKPX Kcommaaccent Oslash -30\r\nKPX Kcommaaccent Otilde -30\r\nKPX Kcommaaccent e -25\r\nKPX Kcommaaccent eacute -25\r\nKPX Kcommaaccent ecaron -25\r\nKPX Kcommaaccent ecircumflex -25\r\nKPX Kcommaaccent edieresis -25\r\nKPX Kcommaaccent edotaccent -25\r\nKPX Kcommaaccent egrave -25\r\nKPX Kcommaaccent emacron -25\r\nKPX Kcommaaccent eogonek -25\r\nKPX Kcommaaccent o -25\r\nKPX Kcommaaccent oacute -25\r\nKPX Kcommaaccent ocircumflex -25\r\nKPX Kcommaaccent odieresis -25\r\nKPX Kcommaaccent ograve -25\r\nKPX Kcommaaccent ohungarumlaut -25\r\nKPX Kcommaaccent omacron -25\r\nKPX Kcommaaccent oslash -25\r\nKPX Kcommaaccent otilde -25\r\nKPX Kcommaaccent u -15\r\nKPX Kcommaaccent uacute -15\r\nKPX Kcommaaccent ucircumflex -15\r\nKPX Kcommaaccent udieresis -15\r\nKPX Kcommaaccent ugrave -15\r\nKPX Kcommaaccent uhungarumlaut -15\r\nKPX Kcommaaccent umacron -15\r\nKPX Kcommaaccent uogonek -15\r\nKPX Kcommaaccent uring -15\r\nKPX Kcommaaccent y -45\r\nKPX Kcommaaccent yacute -45\r\nKPX Kcommaaccent ydieresis -45\r\nKPX L T -92\r\nKPX L Tcaron -92\r\nKPX L Tcommaaccent -92\r\nKPX L V -92\r\nKPX L W -92\r\nKPX L Y -92\r\nKPX L Yacute -92\r\nKPX L Ydieresis -92\r\nKPX L quotedblright -20\r\nKPX L quoteright -110\r\nKPX L y -55\r\nKPX L yacute -55\r\nKPX L ydieresis -55\r\nKPX Lacute T -92\r\nKPX Lacute Tcaron -92\r\nKPX Lacute Tcommaaccent -92\r\nKPX Lacute V -92\r\nKPX Lacute W -92\r\nKPX Lacute Y -92\r\nKPX Lacute Yacute -92\r\nKPX Lacute Ydieresis -92\r\nKPX Lacute quotedblright -20\r\nKPX Lacute quoteright -110\r\nKPX Lacute y -55\r\nKPX Lacute yacute -55\r\nKPX Lacute ydieresis -55\r\nKPX Lcommaaccent T -92\r\nKPX Lcommaaccent Tcaron -92\r\nKPX Lcommaaccent Tcommaaccent -92\r\nKPX Lcommaaccent V -92\r\nKPX Lcommaaccent W -92\r\nKPX Lcommaaccent Y -92\r\nKPX Lcommaaccent Yacute -92\r\nKPX Lcommaaccent Ydieresis -92\r\nKPX Lcommaaccent quotedblright -20\r\nKPX Lcommaaccent quoteright -110\r\nKPX Lcommaaccent y -55\r\nKPX Lcommaaccent yacute -55\r\nKPX Lcommaaccent ydieresis -55\r\nKPX Lslash T -92\r\nKPX Lslash Tcaron -92\r\nKPX Lslash Tcommaaccent -92\r\nKPX Lslash V -92\r\nKPX Lslash W -92\r\nKPX Lslash Y -92\r\nKPX Lslash Yacute -92\r\nKPX Lslash Ydieresis -92\r\nKPX Lslash quotedblright -20\r\nKPX Lslash quoteright -110\r\nKPX Lslash y -55\r\nKPX Lslash yacute -55\r\nKPX Lslash ydieresis -55\r\nKPX N A -20\r\nKPX N Aacute -20\r\nKPX N Abreve -20\r\nKPX N Acircumflex -20\r\nKPX N Adieresis -20\r\nKPX N Agrave -20\r\nKPX N Amacron -20\r\nKPX N Aogonek -20\r\nKPX N Aring -20\r\nKPX N Atilde -20\r\nKPX Nacute A -20\r\nKPX Nacute Aacute -20\r\nKPX Nacute Abreve -20\r\nKPX Nacute Acircumflex -20\r\nKPX Nacute Adieresis -20\r\nKPX Nacute Agrave -20\r\nKPX Nacute Amacron -20\r\nKPX Nacute Aogonek -20\r\nKPX Nacute Aring -20\r\nKPX Nacute Atilde -20\r\nKPX Ncaron A -20\r\nKPX Ncaron Aacute -20\r\nKPX Ncaron Abreve -20\r\nKPX Ncaron Acircumflex -20\r\nKPX Ncaron Adieresis -20\r\nKPX Ncaron Agrave -20\r\nKPX Ncaron Amacron -20\r\nKPX Ncaron Aogonek -20\r\nKPX Ncaron Aring -20\r\nKPX Ncaron Atilde -20\r\nKPX Ncommaaccent A -20\r\nKPX Ncommaaccent Aacute -20\r\nKPX Ncommaaccent Abreve -20\r\nKPX Ncommaaccent Acircumflex -20\r\nKPX Ncommaaccent Adieresis -20\r\nKPX Ncommaaccent Agrave -20\r\nKPX Ncommaaccent Amacron -20\r\nKPX Ncommaaccent Aogonek -20\r\nKPX Ncommaaccent Aring -20\r\nKPX Ncommaaccent Atilde -20\r\nKPX Ntilde A -20\r\nKPX Ntilde Aacute -20\r\nKPX Ntilde Abreve -20\r\nKPX Ntilde Acircumflex -20\r\nKPX Ntilde Adieresis -20\r\nKPX Ntilde Agrave -20\r\nKPX Ntilde Amacron -20\r\nKPX Ntilde Aogonek -20\r\nKPX Ntilde Aring -20\r\nKPX Ntilde Atilde -20\r\nKPX O A -40\r\nKPX O Aacute -40\r\nKPX O Abreve -40\r\nKPX O Acircumflex -40\r\nKPX O Adieresis -40\r\nKPX O Agrave -40\r\nKPX O Amacron -40\r\nKPX O Aogonek -40\r\nKPX O Aring -40\r\nKPX O Atilde -40\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -50\r\nKPX O X -40\r\nKPX O Y -50\r\nKPX O Yacute -50\r\nKPX O Ydieresis -50\r\nKPX Oacute A -40\r\nKPX Oacute Aacute -40\r\nKPX Oacute Abreve -40\r\nKPX Oacute Acircumflex -40\r\nKPX Oacute Adieresis -40\r\nKPX Oacute Agrave -40\r\nKPX Oacute Amacron -40\r\nKPX Oacute Aogonek -40\r\nKPX Oacute Aring -40\r\nKPX Oacute Atilde -40\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -50\r\nKPX Oacute X -40\r\nKPX Oacute Y -50\r\nKPX Oacute Yacute -50\r\nKPX Oacute Ydieresis -50\r\nKPX Ocircumflex A -40\r\nKPX Ocircumflex Aacute -40\r\nKPX Ocircumflex Abreve -40\r\nKPX Ocircumflex Acircumflex -40\r\nKPX Ocircumflex Adieresis -40\r\nKPX Ocircumflex Agrave -40\r\nKPX Ocircumflex Amacron -40\r\nKPX Ocircumflex Aogonek -40\r\nKPX Ocircumflex Aring -40\r\nKPX Ocircumflex Atilde -40\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -50\r\nKPX Ocircumflex X -40\r\nKPX Ocircumflex Y -50\r\nKPX Ocircumflex Yacute -50\r\nKPX Ocircumflex Ydieresis -50\r\nKPX Odieresis A -40\r\nKPX Odieresis Aacute -40\r\nKPX Odieresis Abreve -40\r\nKPX Odieresis Acircumflex -40\r\nKPX Odieresis Adieresis -40\r\nKPX Odieresis Agrave -40\r\nKPX Odieresis Amacron -40\r\nKPX Odieresis Aogonek -40\r\nKPX Odieresis Aring -40\r\nKPX Odieresis Atilde -40\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -50\r\nKPX Odieresis X -40\r\nKPX Odieresis Y -50\r\nKPX Odieresis Yacute -50\r\nKPX Odieresis Ydieresis -50\r\nKPX Ograve A -40\r\nKPX Ograve Aacute -40\r\nKPX Ograve Abreve -40\r\nKPX Ograve Acircumflex -40\r\nKPX Ograve Adieresis -40\r\nKPX Ograve Agrave -40\r\nKPX Ograve Amacron -40\r\nKPX Ograve Aogonek -40\r\nKPX Ograve Aring -40\r\nKPX Ograve Atilde -40\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -50\r\nKPX Ograve X -40\r\nKPX Ograve Y -50\r\nKPX Ograve Yacute -50\r\nKPX Ograve Ydieresis -50\r\nKPX Ohungarumlaut A -40\r\nKPX Ohungarumlaut Aacute -40\r\nKPX Ohungarumlaut Abreve -40\r\nKPX Ohungarumlaut Acircumflex -40\r\nKPX Ohungarumlaut Adieresis -40\r\nKPX Ohungarumlaut Agrave -40\r\nKPX Ohungarumlaut Amacron -40\r\nKPX Ohungarumlaut Aogonek -40\r\nKPX Ohungarumlaut Aring -40\r\nKPX Ohungarumlaut Atilde -40\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -50\r\nKPX Ohungarumlaut X -40\r\nKPX Ohungarumlaut Y -50\r\nKPX Ohungarumlaut Yacute -50\r\nKPX Ohungarumlaut Ydieresis -50\r\nKPX Omacron A -40\r\nKPX Omacron Aacute -40\r\nKPX Omacron Abreve -40\r\nKPX Omacron Acircumflex -40\r\nKPX Omacron Adieresis -40\r\nKPX Omacron Agrave -40\r\nKPX Omacron Amacron -40\r\nKPX Omacron Aogonek -40\r\nKPX Omacron Aring -40\r\nKPX Omacron Atilde -40\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -50\r\nKPX Omacron X -40\r\nKPX Omacron Y -50\r\nKPX Omacron Yacute -50\r\nKPX Omacron Ydieresis -50\r\nKPX Oslash A -40\r\nKPX Oslash Aacute -40\r\nKPX Oslash Abreve -40\r\nKPX Oslash Acircumflex -40\r\nKPX Oslash Adieresis -40\r\nKPX Oslash Agrave -40\r\nKPX Oslash Amacron -40\r\nKPX Oslash Aogonek -40\r\nKPX Oslash Aring -40\r\nKPX Oslash Atilde -40\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -50\r\nKPX Oslash X -40\r\nKPX Oslash Y -50\r\nKPX Oslash Yacute -50\r\nKPX Oslash Ydieresis -50\r\nKPX Otilde A -40\r\nKPX Otilde Aacute -40\r\nKPX Otilde Abreve -40\r\nKPX Otilde Acircumflex -40\r\nKPX Otilde Adieresis -40\r\nKPX Otilde Agrave -40\r\nKPX Otilde Amacron -40\r\nKPX Otilde Aogonek -40\r\nKPX Otilde Aring -40\r\nKPX Otilde Atilde -40\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -50\r\nKPX Otilde X -40\r\nKPX Otilde Y -50\r\nKPX Otilde Yacute -50\r\nKPX Otilde Ydieresis -50\r\nKPX P A -74\r\nKPX P Aacute -74\r\nKPX P Abreve -74\r\nKPX P Acircumflex -74\r\nKPX P Adieresis -74\r\nKPX P Agrave -74\r\nKPX P Amacron -74\r\nKPX P Aogonek -74\r\nKPX P Aring -74\r\nKPX P Atilde -74\r\nKPX P a -10\r\nKPX P aacute -10\r\nKPX P abreve -10\r\nKPX P acircumflex -10\r\nKPX P adieresis -10\r\nKPX P agrave -10\r\nKPX P amacron -10\r\nKPX P aogonek -10\r\nKPX P aring -10\r\nKPX P atilde -10\r\nKPX P comma -92\r\nKPX P e -20\r\nKPX P eacute -20\r\nKPX P ecaron -20\r\nKPX P ecircumflex -20\r\nKPX P edieresis -20\r\nKPX P edotaccent -20\r\nKPX P egrave -20\r\nKPX P emacron -20\r\nKPX P eogonek -20\r\nKPX P o -20\r\nKPX P oacute -20\r\nKPX P ocircumflex -20\r\nKPX P odieresis -20\r\nKPX P ograve -20\r\nKPX P ohungarumlaut -20\r\nKPX P omacron -20\r\nKPX P oslash -20\r\nKPX P otilde -20\r\nKPX P period -110\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX Q period -20\r\nKPX R O -30\r\nKPX R Oacute -30\r\nKPX R Ocircumflex -30\r\nKPX R Odieresis -30\r\nKPX R Ograve -30\r\nKPX R Ohungarumlaut -30\r\nKPX R Omacron -30\r\nKPX R Oslash -30\r\nKPX R Otilde -30\r\nKPX R T -40\r\nKPX R Tcaron -40\r\nKPX R Tcommaaccent -40\r\nKPX R U -30\r\nKPX R Uacute -30\r\nKPX R Ucircumflex -30\r\nKPX R Udieresis -30\r\nKPX R Ugrave -30\r\nKPX R Uhungarumlaut -30\r\nKPX R Umacron -30\r\nKPX R Uogonek -30\r\nKPX R Uring -30\r\nKPX R V -55\r\nKPX R W -35\r\nKPX R Y -35\r\nKPX R Yacute -35\r\nKPX R Ydieresis -35\r\nKPX Racute O -30\r\nKPX Racute Oacute -30\r\nKPX Racute Ocircumflex -30\r\nKPX Racute Odieresis -30\r\nKPX Racute Ograve -30\r\nKPX Racute Ohungarumlaut -30\r\nKPX Racute Omacron -30\r\nKPX Racute Oslash -30\r\nKPX Racute Otilde -30\r\nKPX Racute T -40\r\nKPX Racute Tcaron -40\r\nKPX Racute Tcommaaccent -40\r\nKPX Racute U -30\r\nKPX Racute Uacute -30\r\nKPX Racute Ucircumflex -30\r\nKPX Racute Udieresis -30\r\nKPX Racute Ugrave -30\r\nKPX Racute Uhungarumlaut -30\r\nKPX Racute Umacron -30\r\nKPX Racute Uogonek -30\r\nKPX Racute Uring -30\r\nKPX Racute V -55\r\nKPX Racute W -35\r\nKPX Racute Y -35\r\nKPX Racute Yacute -35\r\nKPX Racute Ydieresis -35\r\nKPX Rcaron O -30\r\nKPX Rcaron Oacute -30\r\nKPX Rcaron Ocircumflex -30\r\nKPX Rcaron Odieresis -30\r\nKPX Rcaron Ograve -30\r\nKPX Rcaron Ohungarumlaut -30\r\nKPX Rcaron Omacron -30\r\nKPX Rcaron Oslash -30\r\nKPX Rcaron Otilde -30\r\nKPX Rcaron T -40\r\nKPX Rcaron Tcaron -40\r\nKPX Rcaron Tcommaaccent -40\r\nKPX Rcaron U -30\r\nKPX Rcaron Uacute -30\r\nKPX Rcaron Ucircumflex -30\r\nKPX Rcaron Udieresis -30\r\nKPX Rcaron Ugrave -30\r\nKPX Rcaron Uhungarumlaut -30\r\nKPX Rcaron Umacron -30\r\nKPX Rcaron Uogonek -30\r\nKPX Rcaron Uring -30\r\nKPX Rcaron V -55\r\nKPX Rcaron W -35\r\nKPX Rcaron Y -35\r\nKPX Rcaron Yacute -35\r\nKPX Rcaron Ydieresis -35\r\nKPX Rcommaaccent O -30\r\nKPX Rcommaaccent Oacute -30\r\nKPX Rcommaaccent Ocircumflex -30\r\nKPX Rcommaaccent Odieresis -30\r\nKPX Rcommaaccent Ograve -30\r\nKPX Rcommaaccent Ohungarumlaut -30\r\nKPX Rcommaaccent Omacron -30\r\nKPX Rcommaaccent Oslash -30\r\nKPX Rcommaaccent Otilde -30\r\nKPX Rcommaaccent T -40\r\nKPX Rcommaaccent Tcaron -40\r\nKPX Rcommaaccent Tcommaaccent -40\r\nKPX Rcommaaccent U -30\r\nKPX Rcommaaccent Uacute -30\r\nKPX Rcommaaccent Ucircumflex -30\r\nKPX Rcommaaccent Udieresis -30\r\nKPX Rcommaaccent Ugrave -30\r\nKPX Rcommaaccent Uhungarumlaut -30\r\nKPX Rcommaaccent Umacron -30\r\nKPX Rcommaaccent Uogonek -30\r\nKPX Rcommaaccent Uring -30\r\nKPX Rcommaaccent V -55\r\nKPX Rcommaaccent W -35\r\nKPX Rcommaaccent Y -35\r\nKPX Rcommaaccent Yacute -35\r\nKPX Rcommaaccent Ydieresis -35\r\nKPX T A -90\r\nKPX T Aacute -90\r\nKPX T Abreve -90\r\nKPX T Acircumflex -90\r\nKPX T Adieresis -90\r\nKPX T Agrave -90\r\nKPX T Amacron -90\r\nKPX T Aogonek -90\r\nKPX T Aring -90\r\nKPX T Atilde -90\r\nKPX T O -18\r\nKPX T Oacute -18\r\nKPX T Ocircumflex -18\r\nKPX T Odieresis -18\r\nKPX T Ograve -18\r\nKPX T Ohungarumlaut -18\r\nKPX T Omacron -18\r\nKPX T Oslash -18\r\nKPX T Otilde -18\r\nKPX T a -92\r\nKPX T aacute -92\r\nKPX T abreve -52\r\nKPX T acircumflex -52\r\nKPX T adieresis -52\r\nKPX T agrave -52\r\nKPX T amacron -52\r\nKPX T aogonek -92\r\nKPX T aring -92\r\nKPX T atilde -52\r\nKPX T colon -74\r\nKPX T comma -74\r\nKPX T e -92\r\nKPX T eacute -92\r\nKPX T ecaron -92\r\nKPX T ecircumflex -92\r\nKPX T edieresis -52\r\nKPX T edotaccent -92\r\nKPX T egrave -52\r\nKPX T emacron -52\r\nKPX T eogonek -92\r\nKPX T hyphen -92\r\nKPX T i -18\r\nKPX T iacute -18\r\nKPX T iogonek -18\r\nKPX T o -92\r\nKPX T oacute -92\r\nKPX T ocircumflex -92\r\nKPX T odieresis -92\r\nKPX T ograve -92\r\nKPX T ohungarumlaut -92\r\nKPX T omacron -92\r\nKPX T oslash -92\r\nKPX T otilde -92\r\nKPX T period -90\r\nKPX T r -74\r\nKPX T racute -74\r\nKPX T rcaron -74\r\nKPX T rcommaaccent -74\r\nKPX T semicolon -74\r\nKPX T u -92\r\nKPX T uacute -92\r\nKPX T ucircumflex -92\r\nKPX T udieresis -92\r\nKPX T ugrave -92\r\nKPX T uhungarumlaut -92\r\nKPX T umacron -92\r\nKPX T uogonek -92\r\nKPX T uring -92\r\nKPX T w -74\r\nKPX T y -34\r\nKPX T yacute -34\r\nKPX T ydieresis -34\r\nKPX Tcaron A -90\r\nKPX Tcaron Aacute -90\r\nKPX Tcaron Abreve -90\r\nKPX Tcaron Acircumflex -90\r\nKPX Tcaron Adieresis -90\r\nKPX Tcaron Agrave -90\r\nKPX Tcaron Amacron -90\r\nKPX Tcaron Aogonek -90\r\nKPX Tcaron Aring -90\r\nKPX Tcaron Atilde -90\r\nKPX Tcaron O -18\r\nKPX Tcaron Oacute -18\r\nKPX Tcaron Ocircumflex -18\r\nKPX Tcaron Odieresis -18\r\nKPX Tcaron Ograve -18\r\nKPX Tcaron Ohungarumlaut -18\r\nKPX Tcaron Omacron -18\r\nKPX Tcaron Oslash -18\r\nKPX Tcaron Otilde -18\r\nKPX Tcaron a -92\r\nKPX Tcaron aacute -92\r\nKPX Tcaron abreve -52\r\nKPX Tcaron acircumflex -52\r\nKPX Tcaron adieresis -52\r\nKPX Tcaron agrave -52\r\nKPX Tcaron amacron -52\r\nKPX Tcaron aogonek -92\r\nKPX Tcaron aring -92\r\nKPX Tcaron atilde -52\r\nKPX Tcaron colon -74\r\nKPX Tcaron comma -74\r\nKPX Tcaron e -92\r\nKPX Tcaron eacute -92\r\nKPX Tcaron ecaron -92\r\nKPX Tcaron ecircumflex -92\r\nKPX Tcaron edieresis -52\r\nKPX Tcaron edotaccent -92\r\nKPX Tcaron egrave -52\r\nKPX Tcaron emacron -52\r\nKPX Tcaron eogonek -92\r\nKPX Tcaron hyphen -92\r\nKPX Tcaron i -18\r\nKPX Tcaron iacute -18\r\nKPX Tcaron iogonek -18\r\nKPX Tcaron o -92\r\nKPX Tcaron oacute -92\r\nKPX Tcaron ocircumflex -92\r\nKPX Tcaron odieresis -92\r\nKPX Tcaron ograve -92\r\nKPX Tcaron ohungarumlaut -92\r\nKPX Tcaron omacron -92\r\nKPX Tcaron oslash -92\r\nKPX Tcaron otilde -92\r\nKPX Tcaron period -90\r\nKPX Tcaron r -74\r\nKPX Tcaron racute -74\r\nKPX Tcaron rcaron -74\r\nKPX Tcaron rcommaaccent -74\r\nKPX Tcaron semicolon -74\r\nKPX Tcaron u -92\r\nKPX Tcaron uacute -92\r\nKPX Tcaron ucircumflex -92\r\nKPX Tcaron udieresis -92\r\nKPX Tcaron ugrave -92\r\nKPX Tcaron uhungarumlaut -92\r\nKPX Tcaron umacron -92\r\nKPX Tcaron uogonek -92\r\nKPX Tcaron uring -92\r\nKPX Tcaron w -74\r\nKPX Tcaron y -34\r\nKPX Tcaron yacute -34\r\nKPX Tcaron ydieresis -34\r\nKPX Tcommaaccent A -90\r\nKPX Tcommaaccent Aacute -90\r\nKPX Tcommaaccent Abreve -90\r\nKPX Tcommaaccent Acircumflex -90\r\nKPX Tcommaaccent Adieresis -90\r\nKPX Tcommaaccent Agrave -90\r\nKPX Tcommaaccent Amacron -90\r\nKPX Tcommaaccent Aogonek -90\r\nKPX Tcommaaccent Aring -90\r\nKPX Tcommaaccent Atilde -90\r\nKPX Tcommaaccent O -18\r\nKPX Tcommaaccent Oacute -18\r\nKPX Tcommaaccent Ocircumflex -18\r\nKPX Tcommaaccent Odieresis -18\r\nKPX Tcommaaccent Ograve -18\r\nKPX Tcommaaccent Ohungarumlaut -18\r\nKPX Tcommaaccent Omacron -18\r\nKPX Tcommaaccent Oslash -18\r\nKPX Tcommaaccent Otilde -18\r\nKPX Tcommaaccent a -92\r\nKPX Tcommaaccent aacute -92\r\nKPX Tcommaaccent abreve -52\r\nKPX Tcommaaccent acircumflex -52\r\nKPX Tcommaaccent adieresis -52\r\nKPX Tcommaaccent agrave -52\r\nKPX Tcommaaccent amacron -52\r\nKPX Tcommaaccent aogonek -92\r\nKPX Tcommaaccent aring -92\r\nKPX Tcommaaccent atilde -52\r\nKPX Tcommaaccent colon -74\r\nKPX Tcommaaccent comma -74\r\nKPX Tcommaaccent e -92\r\nKPX Tcommaaccent eacute -92\r\nKPX Tcommaaccent ecaron -92\r\nKPX Tcommaaccent ecircumflex -92\r\nKPX Tcommaaccent edieresis -52\r\nKPX Tcommaaccent edotaccent -92\r\nKPX Tcommaaccent egrave -52\r\nKPX Tcommaaccent emacron -52\r\nKPX Tcommaaccent eogonek -92\r\nKPX Tcommaaccent hyphen -92\r\nKPX Tcommaaccent i -18\r\nKPX Tcommaaccent iacute -18\r\nKPX Tcommaaccent iogonek -18\r\nKPX Tcommaaccent o -92\r\nKPX Tcommaaccent oacute -92\r\nKPX Tcommaaccent ocircumflex -92\r\nKPX Tcommaaccent odieresis -92\r\nKPX Tcommaaccent ograve -92\r\nKPX Tcommaaccent ohungarumlaut -92\r\nKPX Tcommaaccent omacron -92\r\nKPX Tcommaaccent oslash -92\r\nKPX Tcommaaccent otilde -92\r\nKPX Tcommaaccent period -90\r\nKPX Tcommaaccent r -74\r\nKPX Tcommaaccent racute -74\r\nKPX Tcommaaccent rcaron -74\r\nKPX Tcommaaccent rcommaaccent -74\r\nKPX Tcommaaccent semicolon -74\r\nKPX Tcommaaccent u -92\r\nKPX Tcommaaccent uacute -92\r\nKPX Tcommaaccent ucircumflex -92\r\nKPX Tcommaaccent udieresis -92\r\nKPX Tcommaaccent ugrave -92\r\nKPX Tcommaaccent uhungarumlaut -92\r\nKPX Tcommaaccent umacron -92\r\nKPX Tcommaaccent uogonek -92\r\nKPX Tcommaaccent uring -92\r\nKPX Tcommaaccent w -74\r\nKPX Tcommaaccent y -34\r\nKPX Tcommaaccent yacute -34\r\nKPX Tcommaaccent ydieresis -34\r\nKPX U A -60\r\nKPX U Aacute -60\r\nKPX U Abreve -60\r\nKPX U Acircumflex -60\r\nKPX U Adieresis -60\r\nKPX U Agrave -60\r\nKPX U Amacron -60\r\nKPX U Aogonek -60\r\nKPX U Aring -60\r\nKPX U Atilde -60\r\nKPX U comma -50\r\nKPX U period -50\r\nKPX Uacute A -60\r\nKPX Uacute Aacute -60\r\nKPX Uacute Abreve -60\r\nKPX Uacute Acircumflex -60\r\nKPX Uacute Adieresis -60\r\nKPX Uacute Agrave -60\r\nKPX Uacute Amacron -60\r\nKPX Uacute Aogonek -60\r\nKPX Uacute Aring -60\r\nKPX Uacute Atilde -60\r\nKPX Uacute comma -50\r\nKPX Uacute period -50\r\nKPX Ucircumflex A -60\r\nKPX Ucircumflex Aacute -60\r\nKPX Ucircumflex Abreve -60\r\nKPX Ucircumflex Acircumflex -60\r\nKPX Ucircumflex Adieresis -60\r\nKPX Ucircumflex Agrave -60\r\nKPX Ucircumflex Amacron -60\r\nKPX Ucircumflex Aogonek -60\r\nKPX Ucircumflex Aring -60\r\nKPX Ucircumflex Atilde -60\r\nKPX Ucircumflex comma -50\r\nKPX Ucircumflex period -50\r\nKPX Udieresis A -60\r\nKPX Udieresis Aacute -60\r\nKPX Udieresis Abreve -60\r\nKPX Udieresis Acircumflex -60\r\nKPX Udieresis Adieresis -60\r\nKPX Udieresis Agrave -60\r\nKPX Udieresis Amacron -60\r\nKPX Udieresis Aogonek -60\r\nKPX Udieresis Aring -60\r\nKPX Udieresis Atilde -60\r\nKPX Udieresis comma -50\r\nKPX Udieresis period -50\r\nKPX Ugrave A -60\r\nKPX Ugrave Aacute -60\r\nKPX Ugrave Abreve -60\r\nKPX Ugrave Acircumflex -60\r\nKPX Ugrave Adieresis -60\r\nKPX Ugrave Agrave -60\r\nKPX Ugrave Amacron -60\r\nKPX Ugrave Aogonek -60\r\nKPX Ugrave Aring -60\r\nKPX Ugrave Atilde -60\r\nKPX Ugrave comma -50\r\nKPX Ugrave period -50\r\nKPX Uhungarumlaut A -60\r\nKPX Uhungarumlaut Aacute -60\r\nKPX Uhungarumlaut Abreve -60\r\nKPX Uhungarumlaut Acircumflex -60\r\nKPX Uhungarumlaut Adieresis -60\r\nKPX Uhungarumlaut Agrave -60\r\nKPX Uhungarumlaut Amacron -60\r\nKPX Uhungarumlaut Aogonek -60\r\nKPX Uhungarumlaut Aring -60\r\nKPX Uhungarumlaut Atilde -60\r\nKPX Uhungarumlaut comma -50\r\nKPX Uhungarumlaut period -50\r\nKPX Umacron A -60\r\nKPX Umacron Aacute -60\r\nKPX Umacron Abreve -60\r\nKPX Umacron Acircumflex -60\r\nKPX Umacron Adieresis -60\r\nKPX Umacron Agrave -60\r\nKPX Umacron Amacron -60\r\nKPX Umacron Aogonek -60\r\nKPX Umacron Aring -60\r\nKPX Umacron Atilde -60\r\nKPX Umacron comma -50\r\nKPX Umacron period -50\r\nKPX Uogonek A -60\r\nKPX Uogonek Aacute -60\r\nKPX Uogonek Abreve -60\r\nKPX Uogonek Acircumflex -60\r\nKPX Uogonek Adieresis -60\r\nKPX Uogonek Agrave -60\r\nKPX Uogonek Amacron -60\r\nKPX Uogonek Aogonek -60\r\nKPX Uogonek Aring -60\r\nKPX Uogonek Atilde -60\r\nKPX Uogonek comma -50\r\nKPX Uogonek period -50\r\nKPX Uring A -60\r\nKPX Uring Aacute -60\r\nKPX Uring Abreve -60\r\nKPX Uring Acircumflex -60\r\nKPX Uring Adieresis -60\r\nKPX Uring Agrave -60\r\nKPX Uring Amacron -60\r\nKPX Uring Aogonek -60\r\nKPX Uring Aring -60\r\nKPX Uring Atilde -60\r\nKPX Uring comma -50\r\nKPX Uring period -50\r\nKPX V A -135\r\nKPX V Aacute -135\r\nKPX V Abreve -135\r\nKPX V Acircumflex -135\r\nKPX V Adieresis -135\r\nKPX V Agrave -135\r\nKPX V Amacron -135\r\nKPX V Aogonek -135\r\nKPX V Aring -135\r\nKPX V Atilde -135\r\nKPX V G -30\r\nKPX V Gbreve -30\r\nKPX V Gcommaaccent -30\r\nKPX V O -45\r\nKPX V Oacute -45\r\nKPX V Ocircumflex -45\r\nKPX V Odieresis -45\r\nKPX V Ograve -45\r\nKPX V Ohungarumlaut -45\r\nKPX V Omacron -45\r\nKPX V Oslash -45\r\nKPX V Otilde -45\r\nKPX V a -92\r\nKPX V aacute -92\r\nKPX V abreve -92\r\nKPX V acircumflex -92\r\nKPX V adieresis -92\r\nKPX V agrave -92\r\nKPX V amacron -92\r\nKPX V aogonek -92\r\nKPX V aring -92\r\nKPX V atilde -92\r\nKPX V colon -92\r\nKPX V comma -129\r\nKPX V e -100\r\nKPX V eacute -100\r\nKPX V ecaron -100\r\nKPX V ecircumflex -100\r\nKPX V edieresis -100\r\nKPX V edotaccent -100\r\nKPX V egrave -100\r\nKPX V emacron -100\r\nKPX V eogonek -100\r\nKPX V hyphen -74\r\nKPX V i -37\r\nKPX V iacute -37\r\nKPX V icircumflex -37\r\nKPX V idieresis -37\r\nKPX V igrave -37\r\nKPX V imacron -37\r\nKPX V iogonek -37\r\nKPX V o -100\r\nKPX V oacute -100\r\nKPX V ocircumflex -100\r\nKPX V odieresis -100\r\nKPX V ograve -100\r\nKPX V ohungarumlaut -100\r\nKPX V omacron -100\r\nKPX V oslash -100\r\nKPX V otilde -100\r\nKPX V period -145\r\nKPX V semicolon -92\r\nKPX V u -92\r\nKPX V uacute -92\r\nKPX V ucircumflex -92\r\nKPX V udieresis -92\r\nKPX V ugrave -92\r\nKPX V uhungarumlaut -92\r\nKPX V umacron -92\r\nKPX V uogonek -92\r\nKPX V uring -92\r\nKPX W A -120\r\nKPX W Aacute -120\r\nKPX W Abreve -120\r\nKPX W Acircumflex -120\r\nKPX W Adieresis -120\r\nKPX W Agrave -120\r\nKPX W Amacron -120\r\nKPX W Aogonek -120\r\nKPX W Aring -120\r\nKPX W Atilde -120\r\nKPX W O -10\r\nKPX W Oacute -10\r\nKPX W Ocircumflex -10\r\nKPX W Odieresis -10\r\nKPX W Ograve -10\r\nKPX W Ohungarumlaut -10\r\nKPX W Omacron -10\r\nKPX W Oslash -10\r\nKPX W Otilde -10\r\nKPX W a -65\r\nKPX W aacute -65\r\nKPX W abreve -65\r\nKPX W acircumflex -65\r\nKPX W adieresis -65\r\nKPX W agrave -65\r\nKPX W amacron -65\r\nKPX W aogonek -65\r\nKPX W aring -65\r\nKPX W atilde -65\r\nKPX W colon -55\r\nKPX W comma -92\r\nKPX W e -65\r\nKPX W eacute -65\r\nKPX W ecaron -65\r\nKPX W ecircumflex -65\r\nKPX W edieresis -65\r\nKPX W edotaccent -65\r\nKPX W egrave -65\r\nKPX W emacron -65\r\nKPX W eogonek -65\r\nKPX W hyphen -37\r\nKPX W i -18\r\nKPX W iacute -18\r\nKPX W iogonek -18\r\nKPX W o -75\r\nKPX W oacute -75\r\nKPX W ocircumflex -75\r\nKPX W odieresis -75\r\nKPX W ograve -75\r\nKPX W ohungarumlaut -75\r\nKPX W omacron -75\r\nKPX W oslash -75\r\nKPX W otilde -75\r\nKPX W period -92\r\nKPX W semicolon -55\r\nKPX W u -50\r\nKPX W uacute -50\r\nKPX W ucircumflex -50\r\nKPX W udieresis -50\r\nKPX W ugrave -50\r\nKPX W uhungarumlaut -50\r\nKPX W umacron -50\r\nKPX W uogonek -50\r\nKPX W uring -50\r\nKPX W y -60\r\nKPX W yacute -60\r\nKPX W ydieresis -60\r\nKPX Y A -110\r\nKPX Y Aacute -110\r\nKPX Y Abreve -110\r\nKPX Y Acircumflex -110\r\nKPX Y Adieresis -110\r\nKPX Y Agrave -110\r\nKPX Y Amacron -110\r\nKPX Y Aogonek -110\r\nKPX Y Aring -110\r\nKPX Y Atilde -110\r\nKPX Y O -35\r\nKPX Y Oacute -35\r\nKPX Y Ocircumflex -35\r\nKPX Y Odieresis -35\r\nKPX Y Ograve -35\r\nKPX Y Ohungarumlaut -35\r\nKPX Y Omacron -35\r\nKPX Y Oslash -35\r\nKPX Y Otilde -35\r\nKPX Y a -85\r\nKPX Y aacute -85\r\nKPX Y abreve -85\r\nKPX Y acircumflex -85\r\nKPX Y adieresis -85\r\nKPX Y agrave -85\r\nKPX Y amacron -85\r\nKPX Y aogonek -85\r\nKPX Y aring -85\r\nKPX Y atilde -85\r\nKPX Y colon -92\r\nKPX Y comma -92\r\nKPX Y e -111\r\nKPX Y eacute -111\r\nKPX Y ecaron -111\r\nKPX Y ecircumflex -111\r\nKPX Y edieresis -71\r\nKPX Y edotaccent -111\r\nKPX Y egrave -71\r\nKPX Y emacron -71\r\nKPX Y eogonek -111\r\nKPX Y hyphen -92\r\nKPX Y i -37\r\nKPX Y iacute -37\r\nKPX Y iogonek -37\r\nKPX Y o -111\r\nKPX Y oacute -111\r\nKPX Y ocircumflex -111\r\nKPX Y odieresis -111\r\nKPX Y ograve -111\r\nKPX Y ohungarumlaut -111\r\nKPX Y omacron -111\r\nKPX Y oslash -111\r\nKPX Y otilde -111\r\nKPX Y period -92\r\nKPX Y semicolon -92\r\nKPX Y u -92\r\nKPX Y uacute -92\r\nKPX Y ucircumflex -92\r\nKPX Y udieresis -92\r\nKPX Y ugrave -92\r\nKPX Y uhungarumlaut -92\r\nKPX Y umacron -92\r\nKPX Y uogonek -92\r\nKPX Y uring -92\r\nKPX Yacute A -110\r\nKPX Yacute Aacute -110\r\nKPX Yacute Abreve -110\r\nKPX Yacute Acircumflex -110\r\nKPX Yacute Adieresis -110\r\nKPX Yacute Agrave -110\r\nKPX Yacute Amacron -110\r\nKPX Yacute Aogonek -110\r\nKPX Yacute Aring -110\r\nKPX Yacute Atilde -110\r\nKPX Yacute O -35\r\nKPX Yacute Oacute -35\r\nKPX Yacute Ocircumflex -35\r\nKPX Yacute Odieresis -35\r\nKPX Yacute Ograve -35\r\nKPX Yacute Ohungarumlaut -35\r\nKPX Yacute Omacron -35\r\nKPX Yacute Oslash -35\r\nKPX Yacute Otilde -35\r\nKPX Yacute a -85\r\nKPX Yacute aacute -85\r\nKPX Yacute abreve -85\r\nKPX Yacute acircumflex -85\r\nKPX Yacute adieresis -85\r\nKPX Yacute agrave -85\r\nKPX Yacute amacron -85\r\nKPX Yacute aogonek -85\r\nKPX Yacute aring -85\r\nKPX Yacute atilde -85\r\nKPX Yacute colon -92\r\nKPX Yacute comma -92\r\nKPX Yacute e -111\r\nKPX Yacute eacute -111\r\nKPX Yacute ecaron -111\r\nKPX Yacute ecircumflex -111\r\nKPX Yacute edieresis -71\r\nKPX Yacute edotaccent -111\r\nKPX Yacute egrave -71\r\nKPX Yacute emacron -71\r\nKPX Yacute eogonek -111\r\nKPX Yacute hyphen -92\r\nKPX Yacute i -37\r\nKPX Yacute iacute -37\r\nKPX Yacute iogonek -37\r\nKPX Yacute o -111\r\nKPX Yacute oacute -111\r\nKPX Yacute ocircumflex -111\r\nKPX Yacute odieresis -111\r\nKPX Yacute ograve -111\r\nKPX Yacute ohungarumlaut -111\r\nKPX Yacute omacron -111\r\nKPX Yacute oslash -111\r\nKPX Yacute otilde -111\r\nKPX Yacute period -92\r\nKPX Yacute semicolon -92\r\nKPX Yacute u -92\r\nKPX Yacute uacute -92\r\nKPX Yacute ucircumflex -92\r\nKPX Yacute udieresis -92\r\nKPX Yacute ugrave -92\r\nKPX Yacute uhungarumlaut -92\r\nKPX Yacute umacron -92\r\nKPX Yacute uogonek -92\r\nKPX Yacute uring -92\r\nKPX Ydieresis A -110\r\nKPX Ydieresis Aacute -110\r\nKPX Ydieresis Abreve -110\r\nKPX Ydieresis Acircumflex -110\r\nKPX Ydieresis Adieresis -110\r\nKPX Ydieresis Agrave -110\r\nKPX Ydieresis Amacron -110\r\nKPX Ydieresis Aogonek -110\r\nKPX Ydieresis Aring -110\r\nKPX Ydieresis Atilde -110\r\nKPX Ydieresis O -35\r\nKPX Ydieresis Oacute -35\r\nKPX Ydieresis Ocircumflex -35\r\nKPX Ydieresis Odieresis -35\r\nKPX Ydieresis Ograve -35\r\nKPX Ydieresis Ohungarumlaut -35\r\nKPX Ydieresis Omacron -35\r\nKPX Ydieresis Oslash -35\r\nKPX Ydieresis Otilde -35\r\nKPX Ydieresis a -85\r\nKPX Ydieresis aacute -85\r\nKPX Ydieresis abreve -85\r\nKPX Ydieresis acircumflex -85\r\nKPX Ydieresis adieresis -85\r\nKPX Ydieresis agrave -85\r\nKPX Ydieresis amacron -85\r\nKPX Ydieresis aogonek -85\r\nKPX Ydieresis aring -85\r\nKPX Ydieresis atilde -85\r\nKPX Ydieresis colon -92\r\nKPX Ydieresis comma -92\r\nKPX Ydieresis e -111\r\nKPX Ydieresis eacute -111\r\nKPX Ydieresis ecaron -111\r\nKPX Ydieresis ecircumflex -111\r\nKPX Ydieresis edieresis -71\r\nKPX Ydieresis edotaccent -111\r\nKPX Ydieresis egrave -71\r\nKPX Ydieresis emacron -71\r\nKPX Ydieresis eogonek -111\r\nKPX Ydieresis hyphen -92\r\nKPX Ydieresis i -37\r\nKPX Ydieresis iacute -37\r\nKPX Ydieresis iogonek -37\r\nKPX Ydieresis o -111\r\nKPX Ydieresis oacute -111\r\nKPX Ydieresis ocircumflex -111\r\nKPX Ydieresis odieresis -111\r\nKPX Ydieresis ograve -111\r\nKPX Ydieresis ohungarumlaut -111\r\nKPX Ydieresis omacron -111\r\nKPX Ydieresis oslash -111\r\nKPX Ydieresis otilde -111\r\nKPX Ydieresis period -92\r\nKPX Ydieresis semicolon -92\r\nKPX Ydieresis u -92\r\nKPX Ydieresis uacute -92\r\nKPX Ydieresis ucircumflex -92\r\nKPX Ydieresis udieresis -92\r\nKPX Ydieresis ugrave -92\r\nKPX Ydieresis uhungarumlaut -92\r\nKPX Ydieresis umacron -92\r\nKPX Ydieresis uogonek -92\r\nKPX Ydieresis uring -92\r\nKPX a v -25\r\nKPX aacute v -25\r\nKPX abreve v -25\r\nKPX acircumflex v -25\r\nKPX adieresis v -25\r\nKPX agrave v -25\r\nKPX amacron v -25\r\nKPX aogonek v -25\r\nKPX aring v -25\r\nKPX atilde v -25\r\nKPX b b -10\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX b v -15\r\nKPX comma quotedblright -45\r\nKPX comma quoteright -55\r\nKPX d w -15\r\nKPX dcroat w -15\r\nKPX e v -15\r\nKPX eacute v -15\r\nKPX ecaron v -15\r\nKPX ecircumflex v -15\r\nKPX edieresis v -15\r\nKPX edotaccent v -15\r\nKPX egrave v -15\r\nKPX emacron v -15\r\nKPX eogonek v -15\r\nKPX f comma -15\r\nKPX f dotlessi -35\r\nKPX f i -25\r\nKPX f o -25\r\nKPX f oacute -25\r\nKPX f ocircumflex -25\r\nKPX f odieresis -25\r\nKPX f ograve -25\r\nKPX f ohungarumlaut -25\r\nKPX f omacron -25\r\nKPX f oslash -25\r\nKPX f otilde -25\r\nKPX f period -15\r\nKPX f quotedblright 50\r\nKPX f quoteright 55\r\nKPX g period -15\r\nKPX gbreve period -15\r\nKPX gcommaaccent period -15\r\nKPX h y -15\r\nKPX h yacute -15\r\nKPX h ydieresis -15\r\nKPX i v -10\r\nKPX iacute v -10\r\nKPX icircumflex v -10\r\nKPX idieresis v -10\r\nKPX igrave v -10\r\nKPX imacron v -10\r\nKPX iogonek v -10\r\nKPX k e -10\r\nKPX k eacute -10\r\nKPX k ecaron -10\r\nKPX k ecircumflex -10\r\nKPX k edieresis -10\r\nKPX k edotaccent -10\r\nKPX k egrave -10\r\nKPX k emacron -10\r\nKPX k eogonek -10\r\nKPX k o -15\r\nKPX k oacute -15\r\nKPX k ocircumflex -15\r\nKPX k odieresis -15\r\nKPX k ograve -15\r\nKPX k ohungarumlaut -15\r\nKPX k omacron -15\r\nKPX k oslash -15\r\nKPX k otilde -15\r\nKPX k y -15\r\nKPX k yacute -15\r\nKPX k ydieresis -15\r\nKPX kcommaaccent e -10\r\nKPX kcommaaccent eacute -10\r\nKPX kcommaaccent ecaron -10\r\nKPX kcommaaccent ecircumflex -10\r\nKPX kcommaaccent edieresis -10\r\nKPX kcommaaccent edotaccent -10\r\nKPX kcommaaccent egrave -10\r\nKPX kcommaaccent emacron -10\r\nKPX kcommaaccent eogonek -10\r\nKPX kcommaaccent o -15\r\nKPX kcommaaccent oacute -15\r\nKPX kcommaaccent ocircumflex -15\r\nKPX kcommaaccent odieresis -15\r\nKPX kcommaaccent ograve -15\r\nKPX kcommaaccent ohungarumlaut -15\r\nKPX kcommaaccent omacron -15\r\nKPX kcommaaccent oslash -15\r\nKPX kcommaaccent otilde -15\r\nKPX kcommaaccent y -15\r\nKPX kcommaaccent yacute -15\r\nKPX kcommaaccent ydieresis -15\r\nKPX n v -40\r\nKPX nacute v -40\r\nKPX ncaron v -40\r\nKPX ncommaaccent v -40\r\nKPX ntilde v -40\r\nKPX o v -10\r\nKPX o w -10\r\nKPX oacute v -10\r\nKPX oacute w -10\r\nKPX ocircumflex v -10\r\nKPX ocircumflex w -10\r\nKPX odieresis v -10\r\nKPX odieresis w -10\r\nKPX ograve v -10\r\nKPX ograve w -10\r\nKPX ohungarumlaut v -10\r\nKPX ohungarumlaut w -10\r\nKPX omacron v -10\r\nKPX omacron w -10\r\nKPX oslash v -10\r\nKPX oslash w -10\r\nKPX otilde v -10\r\nKPX otilde w -10\r\nKPX period quotedblright -55\r\nKPX period quoteright -55\r\nKPX quotedblleft A -10\r\nKPX quotedblleft Aacute -10\r\nKPX quotedblleft Abreve -10\r\nKPX quotedblleft Acircumflex -10\r\nKPX quotedblleft Adieresis -10\r\nKPX quotedblleft Agrave -10\r\nKPX quotedblleft Amacron -10\r\nKPX quotedblleft Aogonek -10\r\nKPX quotedblleft Aring -10\r\nKPX quotedblleft Atilde -10\r\nKPX quoteleft A -10\r\nKPX quoteleft Aacute -10\r\nKPX quoteleft Abreve -10\r\nKPX quoteleft Acircumflex -10\r\nKPX quoteleft Adieresis -10\r\nKPX quoteleft Agrave -10\r\nKPX quoteleft Amacron -10\r\nKPX quoteleft Aogonek -10\r\nKPX quoteleft Aring -10\r\nKPX quoteleft Atilde -10\r\nKPX quoteleft quoteleft -63\r\nKPX quoteright d -20\r\nKPX quoteright dcroat -20\r\nKPX quoteright quoteright -63\r\nKPX quoteright r -20\r\nKPX quoteright racute -20\r\nKPX quoteright rcaron -20\r\nKPX quoteright rcommaaccent -20\r\nKPX quoteright s -37\r\nKPX quoteright sacute -37\r\nKPX quoteright scaron -37\r\nKPX quoteright scedilla -37\r\nKPX quoteright scommaaccent -37\r\nKPX quoteright space -74\r\nKPX quoteright v -20\r\nKPX r c -18\r\nKPX r cacute -18\r\nKPX r ccaron -18\r\nKPX r ccedilla -18\r\nKPX r comma -92\r\nKPX r e -18\r\nKPX r eacute -18\r\nKPX r ecaron -18\r\nKPX r ecircumflex -18\r\nKPX r edieresis -18\r\nKPX r edotaccent -18\r\nKPX r egrave -18\r\nKPX r emacron -18\r\nKPX r eogonek -18\r\nKPX r g -10\r\nKPX r gbreve -10\r\nKPX r gcommaaccent -10\r\nKPX r hyphen -37\r\nKPX r n -15\r\nKPX r nacute -15\r\nKPX r ncaron -15\r\nKPX r ncommaaccent -15\r\nKPX r ntilde -15\r\nKPX r o -18\r\nKPX r oacute -18\r\nKPX r ocircumflex -18\r\nKPX r odieresis -18\r\nKPX r ograve -18\r\nKPX r ohungarumlaut -18\r\nKPX r omacron -18\r\nKPX r oslash -18\r\nKPX r otilde -18\r\nKPX r p -10\r\nKPX r period -100\r\nKPX r q -18\r\nKPX r v -10\r\nKPX racute c -18\r\nKPX racute cacute -18\r\nKPX racute ccaron -18\r\nKPX racute ccedilla -18\r\nKPX racute comma -92\r\nKPX racute e -18\r\nKPX racute eacute -18\r\nKPX racute ecaron -18\r\nKPX racute ecircumflex -18\r\nKPX racute edieresis -18\r\nKPX racute edotaccent -18\r\nKPX racute egrave -18\r\nKPX racute emacron -18\r\nKPX racute eogonek -18\r\nKPX racute g -10\r\nKPX racute gbreve -10\r\nKPX racute gcommaaccent -10\r\nKPX racute hyphen -37\r\nKPX racute n -15\r\nKPX racute nacute -15\r\nKPX racute ncaron -15\r\nKPX racute ncommaaccent -15\r\nKPX racute ntilde -15\r\nKPX racute o -18\r\nKPX racute oacute -18\r\nKPX racute ocircumflex -18\r\nKPX racute odieresis -18\r\nKPX racute ograve -18\r\nKPX racute ohungarumlaut -18\r\nKPX racute omacron -18\r\nKPX racute oslash -18\r\nKPX racute otilde -18\r\nKPX racute p -10\r\nKPX racute period -100\r\nKPX racute q -18\r\nKPX racute v -10\r\nKPX rcaron c -18\r\nKPX rcaron cacute -18\r\nKPX rcaron ccaron -18\r\nKPX rcaron ccedilla -18\r\nKPX rcaron comma -92\r\nKPX rcaron e -18\r\nKPX rcaron eacute -18\r\nKPX rcaron ecaron -18\r\nKPX rcaron ecircumflex -18\r\nKPX rcaron edieresis -18\r\nKPX rcaron edotaccent -18\r\nKPX rcaron egrave -18\r\nKPX rcaron emacron -18\r\nKPX rcaron eogonek -18\r\nKPX rcaron g -10\r\nKPX rcaron gbreve -10\r\nKPX rcaron gcommaaccent -10\r\nKPX rcaron hyphen -37\r\nKPX rcaron n -15\r\nKPX rcaron nacute -15\r\nKPX rcaron ncaron -15\r\nKPX rcaron ncommaaccent -15\r\nKPX rcaron ntilde -15\r\nKPX rcaron o -18\r\nKPX rcaron oacute -18\r\nKPX rcaron ocircumflex -18\r\nKPX rcaron odieresis -18\r\nKPX rcaron ograve -18\r\nKPX rcaron ohungarumlaut -18\r\nKPX rcaron omacron -18\r\nKPX rcaron oslash -18\r\nKPX rcaron otilde -18\r\nKPX rcaron p -10\r\nKPX rcaron period -100\r\nKPX rcaron q -18\r\nKPX rcaron v -10\r\nKPX rcommaaccent c -18\r\nKPX rcommaaccent cacute -18\r\nKPX rcommaaccent ccaron -18\r\nKPX rcommaaccent ccedilla -18\r\nKPX rcommaaccent comma -92\r\nKPX rcommaaccent e -18\r\nKPX rcommaaccent eacute -18\r\nKPX rcommaaccent ecaron -18\r\nKPX rcommaaccent ecircumflex -18\r\nKPX rcommaaccent edieresis -18\r\nKPX rcommaaccent edotaccent -18\r\nKPX rcommaaccent egrave -18\r\nKPX rcommaaccent emacron -18\r\nKPX rcommaaccent eogonek -18\r\nKPX rcommaaccent g -10\r\nKPX rcommaaccent gbreve -10\r\nKPX rcommaaccent gcommaaccent -10\r\nKPX rcommaaccent hyphen -37\r\nKPX rcommaaccent n -15\r\nKPX rcommaaccent nacute -15\r\nKPX rcommaaccent ncaron -15\r\nKPX rcommaaccent ncommaaccent -15\r\nKPX rcommaaccent ntilde -15\r\nKPX rcommaaccent o -18\r\nKPX rcommaaccent oacute -18\r\nKPX rcommaaccent ocircumflex -18\r\nKPX rcommaaccent odieresis -18\r\nKPX rcommaaccent ograve -18\r\nKPX rcommaaccent ohungarumlaut -18\r\nKPX rcommaaccent omacron -18\r\nKPX rcommaaccent oslash -18\r\nKPX rcommaaccent otilde -18\r\nKPX rcommaaccent p -10\r\nKPX rcommaaccent period -100\r\nKPX rcommaaccent q -18\r\nKPX rcommaaccent v -10\r\nKPX space A -55\r\nKPX space Aacute -55\r\nKPX space Abreve -55\r\nKPX space Acircumflex -55\r\nKPX space Adieresis -55\r\nKPX space Agrave -55\r\nKPX space Amacron -55\r\nKPX space Aogonek -55\r\nKPX space Aring -55\r\nKPX space Atilde -55\r\nKPX space T -30\r\nKPX space Tcaron -30\r\nKPX space Tcommaaccent -30\r\nKPX space V -45\r\nKPX space W -30\r\nKPX space Y -55\r\nKPX space Yacute -55\r\nKPX space Ydieresis -55\r\nKPX v a -10\r\nKPX v aacute -10\r\nKPX v abreve -10\r\nKPX v acircumflex -10\r\nKPX v adieresis -10\r\nKPX v agrave -10\r\nKPX v amacron -10\r\nKPX v aogonek -10\r\nKPX v aring -10\r\nKPX v atilde -10\r\nKPX v comma -55\r\nKPX v e -10\r\nKPX v eacute -10\r\nKPX v ecaron -10\r\nKPX v ecircumflex -10\r\nKPX v edieresis -10\r\nKPX v edotaccent -10\r\nKPX v egrave -10\r\nKPX v emacron -10\r\nKPX v eogonek -10\r\nKPX v o -10\r\nKPX v oacute -10\r\nKPX v ocircumflex -10\r\nKPX v odieresis -10\r\nKPX v ograve -10\r\nKPX v ohungarumlaut -10\r\nKPX v omacron -10\r\nKPX v oslash -10\r\nKPX v otilde -10\r\nKPX v period -70\r\nKPX w comma -55\r\nKPX w o -10\r\nKPX w oacute -10\r\nKPX w ocircumflex -10\r\nKPX w odieresis -10\r\nKPX w ograve -10\r\nKPX w ohungarumlaut -10\r\nKPX w omacron -10\r\nKPX w oslash -10\r\nKPX w otilde -10\r\nKPX w period -70\r\nKPX y comma -55\r\nKPX y e -10\r\nKPX y eacute -10\r\nKPX y ecaron -10\r\nKPX y ecircumflex -10\r\nKPX y edieresis -10\r\nKPX y edotaccent -10\r\nKPX y egrave -10\r\nKPX y emacron -10\r\nKPX y eogonek -10\r\nKPX y o -25\r\nKPX y oacute -25\r\nKPX y ocircumflex -25\r\nKPX y odieresis -25\r\nKPX y ograve -25\r\nKPX y ohungarumlaut -25\r\nKPX y omacron -25\r\nKPX y oslash -25\r\nKPX y otilde -25\r\nKPX y period -70\r\nKPX yacute comma -55\r\nKPX yacute e -10\r\nKPX yacute eacute -10\r\nKPX yacute ecaron -10\r\nKPX yacute ecircumflex -10\r\nKPX yacute edieresis -10\r\nKPX yacute edotaccent -10\r\nKPX yacute egrave -10\r\nKPX yacute emacron -10\r\nKPX yacute eogonek -10\r\nKPX yacute o -25\r\nKPX yacute oacute -25\r\nKPX yacute ocircumflex -25\r\nKPX yacute odieresis -25\r\nKPX yacute ograve -25\r\nKPX yacute ohungarumlaut -25\r\nKPX yacute omacron -25\r\nKPX yacute oslash -25\r\nKPX yacute otilde -25\r\nKPX yacute period -70\r\nKPX ydieresis comma -55\r\nKPX ydieresis e -10\r\nKPX ydieresis eacute -10\r\nKPX ydieresis ecaron -10\r\nKPX ydieresis ecircumflex -10\r\nKPX ydieresis edieresis -10\r\nKPX ydieresis edotaccent -10\r\nKPX ydieresis egrave -10\r\nKPX ydieresis emacron -10\r\nKPX ydieresis eogonek -10\r\nKPX ydieresis o -25\r\nKPX ydieresis oacute -25\r\nKPX ydieresis ocircumflex -25\r\nKPX ydieresis odieresis -25\r\nKPX ydieresis ograve -25\r\nKPX ydieresis ohungarumlaut -25\r\nKPX ydieresis omacron -25\r\nKPX ydieresis oslash -25\r\nKPX ydieresis otilde -25\r\nKPX ydieresis period -70\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Times-Italic"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 12:56:55 1997\r\nComment UniqueID 43067\r\nComment VMusage 47727 58752\r\nFontName Times-Italic\r\nFullName Times Italic\r\nFamilyName Times\r\nWeight Medium\r\nItalicAngle -15.5\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -169 -217 1010 883 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 653\r\nXHeight 441\r\nAscender 683\r\nDescender -217\r\nStdHW 32\r\nStdVW 76\r\nStartCharMetrics 315\r\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 39 -11 302 667 ;\r\nC 34 ; WX 420 ; N quotedbl ; B 144 421 432 666 ;\r\nC 35 ; WX 500 ; N numbersign ; B 2 0 540 676 ;\r\nC 36 ; WX 500 ; N dollar ; B 31 -89 497 731 ;\r\nC 37 ; WX 833 ; N percent ; B 79 -13 790 676 ;\r\nC 38 ; WX 778 ; N ampersand ; B 76 -18 723 666 ;\r\nC 39 ; WX 333 ; N quoteright ; B 151 436 290 666 ;\r\nC 40 ; WX 333 ; N parenleft ; B 42 -181 315 669 ;\r\nC 41 ; WX 333 ; N parenright ; B 16 -180 289 669 ;\r\nC 42 ; WX 500 ; N asterisk ; B 128 255 492 666 ;\r\nC 43 ; WX 675 ; N plus ; B 86 0 590 506 ;\r\nC 44 ; WX 250 ; N comma ; B -4 -129 135 101 ;\r\nC 45 ; WX 333 ; N hyphen ; B 49 192 282 255 ;\r\nC 46 ; WX 250 ; N period ; B 27 -11 138 100 ;\r\nC 47 ; WX 278 ; N slash ; B -65 -18 386 666 ;\r\nC 48 ; WX 500 ; N zero ; B 32 -7 497 676 ;\r\nC 49 ; WX 500 ; N one ; B 49 0 409 676 ;\r\nC 50 ; WX 500 ; N two ; B 12 0 452 676 ;\r\nC 51 ; WX 500 ; N three ; B 15 -7 465 676 ;\r\nC 52 ; WX 500 ; N four ; B 1 0 479 676 ;\r\nC 53 ; WX 500 ; N five ; B 15 -7 491 666 ;\r\nC 54 ; WX 500 ; N six ; B 30 -7 521 686 ;\r\nC 55 ; WX 500 ; N seven ; B 75 -8 537 666 ;\r\nC 56 ; WX 500 ; N eight ; B 30 -7 493 676 ;\r\nC 57 ; WX 500 ; N nine ; B 23 -17 492 676 ;\r\nC 58 ; WX 333 ; N colon ; B 50 -11 261 441 ;\r\nC 59 ; WX 333 ; N semicolon ; B 27 -129 261 441 ;\r\nC 60 ; WX 675 ; N less ; B 84 -8 592 514 ;\r\nC 61 ; WX 675 ; N equal ; B 86 120 590 386 ;\r\nC 62 ; WX 675 ; N greater ; B 84 -8 592 514 ;\r\nC 63 ; WX 500 ; N question ; B 132 -12 472 664 ;\r\nC 64 ; WX 920 ; N at ; B 118 -18 806 666 ;\r\nC 65 ; WX 611 ; N A ; B -51 0 564 668 ;\r\nC 66 ; WX 611 ; N B ; B -8 0 588 653 ;\r\nC 67 ; WX 667 ; N C ; B 66 -18 689 666 ;\r\nC 68 ; WX 722 ; N D ; B -8 0 700 653 ;\r\nC 69 ; WX 611 ; N E ; B -1 0 634 653 ;\r\nC 70 ; WX 611 ; N F ; B 8 0 645 653 ;\r\nC 71 ; WX 722 ; N G ; B 52 -18 722 666 ;\r\nC 72 ; WX 722 ; N H ; B -8 0 767 653 ;\r\nC 73 ; WX 333 ; N I ; B -8 0 384 653 ;\r\nC 74 ; WX 444 ; N J ; B -6 -18 491 653 ;\r\nC 75 ; WX 667 ; N K ; B 7 0 722 653 ;\r\nC 76 ; WX 556 ; N L ; B -8 0 559 653 ;\r\nC 77 ; WX 833 ; N M ; B -18 0 873 653 ;\r\nC 78 ; WX 667 ; N N ; B -20 -15 727 653 ;\r\nC 79 ; WX 722 ; N O ; B 60 -18 699 666 ;\r\nC 80 ; WX 611 ; N P ; B 0 0 605 653 ;\r\nC 81 ; WX 722 ; N Q ; B 59 -182 699 666 ;\r\nC 82 ; WX 611 ; N R ; B -13 0 588 653 ;\r\nC 83 ; WX 500 ; N S ; B 17 -18 508 667 ;\r\nC 84 ; WX 556 ; N T ; B 59 0 633 653 ;\r\nC 85 ; WX 722 ; N U ; B 102 -18 765 653 ;\r\nC 86 ; WX 611 ; N V ; B 76 -18 688 653 ;\r\nC 87 ; WX 833 ; N W ; B 71 -18 906 653 ;\r\nC 88 ; WX 611 ; N X ; B -29 0 655 653 ;\r\nC 89 ; WX 556 ; N Y ; B 78 0 633 653 ;\r\nC 90 ; WX 556 ; N Z ; B -6 0 606 653 ;\r\nC 91 ; WX 389 ; N bracketleft ; B 21 -153 391 663 ;\r\nC 92 ; WX 278 ; N backslash ; B -41 -18 319 666 ;\r\nC 93 ; WX 389 ; N bracketright ; B 12 -153 382 663 ;\r\nC 94 ; WX 422 ; N asciicircum ; B 0 301 422 666 ;\r\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\r\nC 96 ; WX 333 ; N quoteleft ; B 171 436 310 666 ;\r\nC 97 ; WX 500 ; N a ; B 17 -11 476 441 ;\r\nC 98 ; WX 500 ; N b ; B 23 -11 473 683 ;\r\nC 99 ; WX 444 ; N c ; B 30 -11 425 441 ;\r\nC 100 ; WX 500 ; N d ; B 15 -13 527 683 ;\r\nC 101 ; WX 444 ; N e ; B 31 -11 412 441 ;\r\nC 102 ; WX 278 ; N f ; B -147 -207 424 678 ; L i fi ; L l fl ;\r\nC 103 ; WX 500 ; N g ; B 8 -206 472 441 ;\r\nC 104 ; WX 500 ; N h ; B 19 -9 478 683 ;\r\nC 105 ; WX 278 ; N i ; B 49 -11 264 654 ;\r\nC 106 ; WX 278 ; N j ; B -124 -207 276 654 ;\r\nC 107 ; WX 444 ; N k ; B 14 -11 461 683 ;\r\nC 108 ; WX 278 ; N l ; B 41 -11 279 683 ;\r\nC 109 ; WX 722 ; N m ; B 12 -9 704 441 ;\r\nC 110 ; WX 500 ; N n ; B 14 -9 474 441 ;\r\nC 111 ; WX 500 ; N o ; B 27 -11 468 441 ;\r\nC 112 ; WX 500 ; N p ; B -75 -205 469 441 ;\r\nC 113 ; WX 500 ; N q ; B 25 -209 483 441 ;\r\nC 114 ; WX 389 ; N r ; B 45 0 412 441 ;\r\nC 115 ; WX 389 ; N s ; B 16 -13 366 442 ;\r\nC 116 ; WX 278 ; N t ; B 37 -11 296 546 ;\r\nC 117 ; WX 500 ; N u ; B 42 -11 475 441 ;\r\nC 118 ; WX 444 ; N v ; B 21 -18 426 441 ;\r\nC 119 ; WX 667 ; N w ; B 16 -18 648 441 ;\r\nC 120 ; WX 444 ; N x ; B -27 -11 447 441 ;\r\nC 121 ; WX 444 ; N y ; B -24 -206 426 441 ;\r\nC 122 ; WX 389 ; N z ; B -2 -81 380 428 ;\r\nC 123 ; WX 400 ; N braceleft ; B 51 -177 407 687 ;\r\nC 124 ; WX 275 ; N bar ; B 105 -217 171 783 ;\r\nC 125 ; WX 400 ; N braceright ; B -7 -177 349 687 ;\r\nC 126 ; WX 541 ; N asciitilde ; B 40 183 502 323 ;\r\nC 161 ; WX 389 ; N exclamdown ; B 59 -205 322 473 ;\r\nC 162 ; WX 500 ; N cent ; B 77 -143 472 560 ;\r\nC 163 ; WX 500 ; N sterling ; B 10 -6 517 670 ;\r\nC 164 ; WX 167 ; N fraction ; B -169 -10 337 676 ;\r\nC 165 ; WX 500 ; N yen ; B 27 0 603 653 ;\r\nC 166 ; WX 500 ; N florin ; B 25 -182 507 682 ;\r\nC 167 ; WX 500 ; N section ; B 53 -162 461 666 ;\r\nC 168 ; WX 500 ; N currency ; B -22 53 522 597 ;\r\nC 169 ; WX 214 ; N quotesingle ; B 132 421 241 666 ;\r\nC 170 ; WX 556 ; N quotedblleft ; B 166 436 514 666 ;\r\nC 171 ; WX 500 ; N guillemotleft ; B 53 37 445 403 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 51 37 281 403 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 52 37 282 403 ;\r\nC 174 ; WX 500 ; N fi ; B -141 -207 481 681 ;\r\nC 175 ; WX 500 ; N fl ; B -141 -204 518 682 ;\r\nC 177 ; WX 500 ; N endash ; B -6 197 505 243 ;\r\nC 178 ; WX 500 ; N dagger ; B 101 -159 488 666 ;\r\nC 179 ; WX 500 ; N daggerdbl ; B 22 -143 491 666 ;\r\nC 180 ; WX 250 ; N periodcentered ; B 70 199 181 310 ;\r\nC 182 ; WX 523 ; N paragraph ; B 55 -123 616 653 ;\r\nC 183 ; WX 350 ; N bullet ; B 40 191 310 461 ;\r\nC 184 ; WX 333 ; N quotesinglbase ; B 44 -129 183 101 ;\r\nC 185 ; WX 556 ; N quotedblbase ; B 57 -129 405 101 ;\r\nC 186 ; WX 556 ; N quotedblright ; B 151 436 499 666 ;\r\nC 187 ; WX 500 ; N guillemotright ; B 55 37 447 403 ;\r\nC 188 ; WX 889 ; N ellipsis ; B 57 -11 762 100 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 25 -19 1010 706 ;\r\nC 191 ; WX 500 ; N questiondown ; B 28 -205 368 471 ;\r\nC 193 ; WX 333 ; N grave ; B 121 492 311 664 ;\r\nC 194 ; WX 333 ; N acute ; B 180 494 403 664 ;\r\nC 195 ; WX 333 ; N circumflex ; B 91 492 385 661 ;\r\nC 196 ; WX 333 ; N tilde ; B 100 517 427 624 ;\r\nC 197 ; WX 333 ; N macron ; B 99 532 411 583 ;\r\nC 198 ; WX 333 ; N breve ; B 117 492 418 650 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 207 548 305 646 ;\r\nC 200 ; WX 333 ; N dieresis ; B 107 548 405 646 ;\r\nC 202 ; WX 333 ; N ring ; B 155 492 355 691 ;\r\nC 203 ; WX 333 ; N cedilla ; B -30 -217 182 0 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 93 494 486 664 ;\r\nC 206 ; WX 333 ; N ogonek ; B 20 -169 203 40 ;\r\nC 207 ; WX 333 ; N caron ; B 121 492 426 661 ;\r\nC 208 ; WX 889 ; N emdash ; B -6 197 894 243 ;\r\nC 225 ; WX 889 ; N AE ; B -27 0 911 653 ;\r\nC 227 ; WX 276 ; N ordfeminine ; B 42 406 352 676 ;\r\nC 232 ; WX 556 ; N Lslash ; B -8 0 559 653 ;\r\nC 233 ; WX 722 ; N Oslash ; B 60 -105 699 722 ;\r\nC 234 ; WX 944 ; N OE ; B 49 -8 964 666 ;\r\nC 235 ; WX 310 ; N ordmasculine ; B 67 406 362 676 ;\r\nC 241 ; WX 667 ; N ae ; B 23 -11 640 441 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 49 -11 235 441 ;\r\nC 248 ; WX 278 ; N lslash ; B 41 -11 312 683 ;\r\nC 249 ; WX 500 ; N oslash ; B 28 -135 469 554 ;\r\nC 250 ; WX 667 ; N oe ; B 20 -12 646 441 ;\r\nC 251 ; WX 500 ; N germandbls ; B -168 -207 493 679 ;\r\nC -1 ; WX 333 ; N Idieresis ; B -8 0 435 818 ;\r\nC -1 ; WX 444 ; N eacute ; B 31 -11 459 664 ;\r\nC -1 ; WX 500 ; N abreve ; B 17 -11 502 650 ;\r\nC -1 ; WX 500 ; N uhungarumlaut ; B 42 -11 580 664 ;\r\nC -1 ; WX 444 ; N ecaron ; B 31 -11 482 661 ;\r\nC -1 ; WX 556 ; N Ydieresis ; B 78 0 633 818 ;\r\nC -1 ; WX 675 ; N divide ; B 86 -11 590 517 ;\r\nC -1 ; WX 556 ; N Yacute ; B 78 0 633 876 ;\r\nC -1 ; WX 611 ; N Acircumflex ; B -51 0 564 873 ;\r\nC -1 ; WX 500 ; N aacute ; B 17 -11 487 664 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 102 -18 765 873 ;\r\nC -1 ; WX 444 ; N yacute ; B -24 -206 459 664 ;\r\nC -1 ; WX 389 ; N scommaaccent ; B 16 -217 366 442 ;\r\nC -1 ; WX 444 ; N ecircumflex ; B 31 -11 441 661 ;\r\nC -1 ; WX 722 ; N Uring ; B 102 -18 765 883 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 102 -18 765 818 ;\r\nC -1 ; WX 500 ; N aogonek ; B 17 -169 476 441 ;\r\nC -1 ; WX 722 ; N Uacute ; B 102 -18 765 876 ;\r\nC -1 ; WX 500 ; N uogonek ; B 42 -169 477 441 ;\r\nC -1 ; WX 611 ; N Edieresis ; B -1 0 634 818 ;\r\nC -1 ; WX 722 ; N Dcroat ; B -8 0 700 653 ;\r\nC -1 ; WX 250 ; N commaaccent ; B 8 -217 133 -50 ;\r\nC -1 ; WX 760 ; N copyright ; B 41 -18 719 666 ;\r\nC -1 ; WX 611 ; N Emacron ; B -1 0 634 795 ;\r\nC -1 ; WX 444 ; N ccaron ; B 30 -11 482 661 ;\r\nC -1 ; WX 500 ; N aring ; B 17 -11 476 691 ;\r\nC -1 ; WX 667 ; N Ncommaaccent ; B -20 -187 727 653 ;\r\nC -1 ; WX 278 ; N lacute ; B 41 -11 395 876 ;\r\nC -1 ; WX 500 ; N agrave ; B 17 -11 476 664 ;\r\nC -1 ; WX 556 ; N Tcommaaccent ; B 59 -217 633 653 ;\r\nC -1 ; WX 667 ; N Cacute ; B 66 -18 690 876 ;\r\nC -1 ; WX 500 ; N atilde ; B 17 -11 511 624 ;\r\nC -1 ; WX 611 ; N Edotaccent ; B -1 0 634 818 ;\r\nC -1 ; WX 389 ; N scaron ; B 16 -13 454 661 ;\r\nC -1 ; WX 389 ; N scedilla ; B 16 -217 366 442 ;\r\nC -1 ; WX 278 ; N iacute ; B 49 -11 355 664 ;\r\nC -1 ; WX 471 ; N lozenge ; B 13 0 459 724 ;\r\nC -1 ; WX 611 ; N Rcaron ; B -13 0 588 873 ;\r\nC -1 ; WX 722 ; N Gcommaaccent ; B 52 -217 722 666 ;\r\nC -1 ; WX 500 ; N ucircumflex ; B 42 -11 475 661 ;\r\nC -1 ; WX 500 ; N acircumflex ; B 17 -11 476 661 ;\r\nC -1 ; WX 611 ; N Amacron ; B -51 0 564 795 ;\r\nC -1 ; WX 389 ; N rcaron ; B 45 0 434 661 ;\r\nC -1 ; WX 444 ; N ccedilla ; B 30 -217 425 441 ;\r\nC -1 ; WX 556 ; N Zdotaccent ; B -6 0 606 818 ;\r\nC -1 ; WX 611 ; N Thorn ; B 0 0 569 653 ;\r\nC -1 ; WX 722 ; N Omacron ; B 60 -18 699 795 ;\r\nC -1 ; WX 611 ; N Racute ; B -13 0 588 876 ;\r\nC -1 ; WX 500 ; N Sacute ; B 17 -18 508 876 ;\r\nC -1 ; WX 544 ; N dcaron ; B 15 -13 658 683 ;\r\nC -1 ; WX 722 ; N Umacron ; B 102 -18 765 795 ;\r\nC -1 ; WX 500 ; N uring ; B 42 -11 475 691 ;\r\nC -1 ; WX 300 ; N threesuperior ; B 43 268 339 676 ;\r\nC -1 ; WX 722 ; N Ograve ; B 60 -18 699 876 ;\r\nC -1 ; WX 611 ; N Agrave ; B -51 0 564 876 ;\r\nC -1 ; WX 611 ; N Abreve ; B -51 0 564 862 ;\r\nC -1 ; WX 675 ; N multiply ; B 93 8 582 497 ;\r\nC -1 ; WX 500 ; N uacute ; B 42 -11 477 664 ;\r\nC -1 ; WX 556 ; N Tcaron ; B 59 0 633 873 ;\r\nC -1 ; WX 476 ; N partialdiff ; B 17 -38 459 710 ;\r\nC -1 ; WX 444 ; N ydieresis ; B -24 -206 441 606 ;\r\nC -1 ; WX 667 ; N Nacute ; B -20 -15 727 876 ;\r\nC -1 ; WX 278 ; N icircumflex ; B 33 -11 327 661 ;\r\nC -1 ; WX 611 ; N Ecircumflex ; B -1 0 634 873 ;\r\nC -1 ; WX 500 ; N adieresis ; B 17 -11 489 606 ;\r\nC -1 ; WX 444 ; N edieresis ; B 31 -11 451 606 ;\r\nC -1 ; WX 444 ; N cacute ; B 30 -11 459 664 ;\r\nC -1 ; WX 500 ; N nacute ; B 14 -9 477 664 ;\r\nC -1 ; WX 500 ; N umacron ; B 42 -11 485 583 ;\r\nC -1 ; WX 667 ; N Ncaron ; B -20 -15 727 873 ;\r\nC -1 ; WX 333 ; N Iacute ; B -8 0 433 876 ;\r\nC -1 ; WX 675 ; N plusminus ; B 86 0 590 506 ;\r\nC -1 ; WX 275 ; N brokenbar ; B 105 -142 171 708 ;\r\nC -1 ; WX 760 ; N registered ; B 41 -18 719 666 ;\r\nC -1 ; WX 722 ; N Gbreve ; B 52 -18 722 862 ;\r\nC -1 ; WX 333 ; N Idotaccent ; B -8 0 384 818 ;\r\nC -1 ; WX 600 ; N summation ; B 15 -10 585 706 ;\r\nC -1 ; WX 611 ; N Egrave ; B -1 0 634 876 ;\r\nC -1 ; WX 389 ; N racute ; B 45 0 431 664 ;\r\nC -1 ; WX 500 ; N omacron ; B 27 -11 495 583 ;\r\nC -1 ; WX 556 ; N Zacute ; B -6 0 606 876 ;\r\nC -1 ; WX 556 ; N Zcaron ; B -6 0 606 873 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 658 ;\r\nC -1 ; WX 722 ; N Eth ; B -8 0 700 653 ;\r\nC -1 ; WX 667 ; N Ccedilla ; B 66 -217 689 666 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B 22 -217 279 683 ;\r\nC -1 ; WX 300 ; N tcaron ; B 37 -11 407 681 ;\r\nC -1 ; WX 444 ; N eogonek ; B 31 -169 412 441 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 102 -184 765 653 ;\r\nC -1 ; WX 611 ; N Aacute ; B -51 0 564 876 ;\r\nC -1 ; WX 611 ; N Adieresis ; B -51 0 564 818 ;\r\nC -1 ; WX 444 ; N egrave ; B 31 -11 412 664 ;\r\nC -1 ; WX 389 ; N zacute ; B -2 -81 431 664 ;\r\nC -1 ; WX 278 ; N iogonek ; B 49 -169 264 654 ;\r\nC -1 ; WX 722 ; N Oacute ; B 60 -18 699 876 ;\r\nC -1 ; WX 500 ; N oacute ; B 27 -11 487 664 ;\r\nC -1 ; WX 500 ; N amacron ; B 17 -11 495 583 ;\r\nC -1 ; WX 389 ; N sacute ; B 16 -13 431 664 ;\r\nC -1 ; WX 278 ; N idieresis ; B 49 -11 352 606 ;\r\nC -1 ; WX 722 ; N Ocircumflex ; B 60 -18 699 873 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 102 -18 765 876 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 500 ; N thorn ; B -75 -205 469 683 ;\r\nC -1 ; WX 300 ; N twosuperior ; B 33 271 324 676 ;\r\nC -1 ; WX 722 ; N Odieresis ; B 60 -18 699 818 ;\r\nC -1 ; WX 500 ; N mu ; B -30 -209 497 428 ;\r\nC -1 ; WX 278 ; N igrave ; B 49 -11 284 664 ;\r\nC -1 ; WX 500 ; N ohungarumlaut ; B 27 -11 590 664 ;\r\nC -1 ; WX 611 ; N Eogonek ; B -1 -169 634 653 ;\r\nC -1 ; WX 500 ; N dcroat ; B 15 -13 572 683 ;\r\nC -1 ; WX 750 ; N threequarters ; B 23 -10 736 676 ;\r\nC -1 ; WX 500 ; N Scedilla ; B 17 -217 508 667 ;\r\nC -1 ; WX 300 ; N lcaron ; B 41 -11 407 683 ;\r\nC -1 ; WX 667 ; N Kcommaaccent ; B 7 -217 722 653 ;\r\nC -1 ; WX 556 ; N Lacute ; B -8 0 559 876 ;\r\nC -1 ; WX 980 ; N trademark ; B 30 247 957 653 ;\r\nC -1 ; WX 444 ; N edotaccent ; B 31 -11 412 606 ;\r\nC -1 ; WX 333 ; N Igrave ; B -8 0 384 876 ;\r\nC -1 ; WX 333 ; N Imacron ; B -8 0 441 795 ;\r\nC -1 ; WX 611 ; N Lcaron ; B -8 0 586 653 ;\r\nC -1 ; WX 750 ; N onehalf ; B 34 -10 749 676 ;\r\nC -1 ; WX 549 ; N lessequal ; B 26 0 523 658 ;\r\nC -1 ; WX 500 ; N ocircumflex ; B 27 -11 468 661 ;\r\nC -1 ; WX 500 ; N ntilde ; B 14 -9 476 624 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 102 -18 765 876 ;\r\nC -1 ; WX 611 ; N Eacute ; B -1 0 634 876 ;\r\nC -1 ; WX 444 ; N emacron ; B 31 -11 457 583 ;\r\nC -1 ; WX 500 ; N gbreve ; B 8 -206 487 650 ;\r\nC -1 ; WX 750 ; N onequarter ; B 33 -10 736 676 ;\r\nC -1 ; WX 500 ; N Scaron ; B 17 -18 520 873 ;\r\nC -1 ; WX 500 ; N Scommaaccent ; B 17 -217 508 667 ;\r\nC -1 ; WX 722 ; N Ohungarumlaut ; B 60 -18 699 876 ;\r\nC -1 ; WX 400 ; N degree ; B 101 390 387 676 ;\r\nC -1 ; WX 500 ; N ograve ; B 27 -11 468 664 ;\r\nC -1 ; WX 667 ; N Ccaron ; B 66 -18 689 873 ;\r\nC -1 ; WX 500 ; N ugrave ; B 42 -11 475 664 ;\r\nC -1 ; WX 453 ; N radical ; B 2 -60 452 768 ;\r\nC -1 ; WX 722 ; N Dcaron ; B -8 0 700 873 ;\r\nC -1 ; WX 389 ; N rcommaaccent ; B -3 -217 412 441 ;\r\nC -1 ; WX 667 ; N Ntilde ; B -20 -15 727 836 ;\r\nC -1 ; WX 500 ; N otilde ; B 27 -11 496 624 ;\r\nC -1 ; WX 611 ; N Rcommaaccent ; B -13 -187 588 653 ;\r\nC -1 ; WX 556 ; N Lcommaaccent ; B -8 -217 559 653 ;\r\nC -1 ; WX 611 ; N Atilde ; B -51 0 566 836 ;\r\nC -1 ; WX 611 ; N Aogonek ; B -51 -169 566 668 ;\r\nC -1 ; WX 611 ; N Aring ; B -51 0 564 883 ;\r\nC -1 ; WX 722 ; N Otilde ; B 60 -18 699 836 ;\r\nC -1 ; WX 389 ; N zdotaccent ; B -2 -81 380 606 ;\r\nC -1 ; WX 611 ; N Ecaron ; B -1 0 634 873 ;\r\nC -1 ; WX 333 ; N Iogonek ; B -8 -169 384 653 ;\r\nC -1 ; WX 444 ; N kcommaaccent ; B 14 -187 461 683 ;\r\nC -1 ; WX 675 ; N minus ; B 86 220 590 286 ;\r\nC -1 ; WX 333 ; N Icircumflex ; B -8 0 425 873 ;\r\nC -1 ; WX 500 ; N ncaron ; B 14 -9 510 661 ;\r\nC -1 ; WX 278 ; N tcommaaccent ; B 2 -217 296 546 ;\r\nC -1 ; WX 675 ; N logicalnot ; B 86 108 590 386 ;\r\nC -1 ; WX 500 ; N odieresis ; B 27 -11 489 606 ;\r\nC -1 ; WX 500 ; N udieresis ; B 42 -11 479 606 ;\r\nC -1 ; WX 549 ; N notequal ; B 12 -29 537 541 ;\r\nC -1 ; WX 500 ; N gcommaaccent ; B 8 -206 472 706 ;\r\nC -1 ; WX 500 ; N eth ; B 27 -11 482 683 ;\r\nC -1 ; WX 389 ; N zcaron ; B -2 -81 434 661 ;\r\nC -1 ; WX 500 ; N ncommaaccent ; B 14 -187 474 441 ;\r\nC -1 ; WX 300 ; N onesuperior ; B 43 271 284 676 ;\r\nC -1 ; WX 278 ; N imacron ; B 46 -11 311 583 ;\r\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2321\r\nKPX A C -30\r\nKPX A Cacute -30\r\nKPX A Ccaron -30\r\nKPX A Ccedilla -30\r\nKPX A G -35\r\nKPX A Gbreve -35\r\nKPX A Gcommaaccent -35\r\nKPX A O -40\r\nKPX A Oacute -40\r\nKPX A Ocircumflex -40\r\nKPX A Odieresis -40\r\nKPX A Ograve -40\r\nKPX A Ohungarumlaut -40\r\nKPX A Omacron -40\r\nKPX A Oslash -40\r\nKPX A Otilde -40\r\nKPX A Q -40\r\nKPX A T -37\r\nKPX A Tcaron -37\r\nKPX A Tcommaaccent -37\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -105\r\nKPX A W -95\r\nKPX A Y -55\r\nKPX A Yacute -55\r\nKPX A Ydieresis -55\r\nKPX A quoteright -37\r\nKPX A u -20\r\nKPX A uacute -20\r\nKPX A ucircumflex -20\r\nKPX A udieresis -20\r\nKPX A ugrave -20\r\nKPX A uhungarumlaut -20\r\nKPX A umacron -20\r\nKPX A uogonek -20\r\nKPX A uring -20\r\nKPX A v -55\r\nKPX A w -55\r\nKPX A y -55\r\nKPX A yacute -55\r\nKPX A ydieresis -55\r\nKPX Aacute C -30\r\nKPX Aacute Cacute -30\r\nKPX Aacute Ccaron -30\r\nKPX Aacute Ccedilla -30\r\nKPX Aacute G -35\r\nKPX Aacute Gbreve -35\r\nKPX Aacute Gcommaaccent -35\r\nKPX Aacute O -40\r\nKPX Aacute Oacute -40\r\nKPX Aacute Ocircumflex -40\r\nKPX Aacute Odieresis -40\r\nKPX Aacute Ograve -40\r\nKPX Aacute Ohungarumlaut -40\r\nKPX Aacute Omacron -40\r\nKPX Aacute Oslash -40\r\nKPX Aacute Otilde -40\r\nKPX Aacute Q -40\r\nKPX Aacute T -37\r\nKPX Aacute Tcaron -37\r\nKPX Aacute Tcommaaccent -37\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -105\r\nKPX Aacute W -95\r\nKPX Aacute Y -55\r\nKPX Aacute Yacute -55\r\nKPX Aacute Ydieresis -55\r\nKPX Aacute quoteright -37\r\nKPX Aacute u -20\r\nKPX Aacute uacute -20\r\nKPX Aacute ucircumflex -20\r\nKPX Aacute udieresis -20\r\nKPX Aacute ugrave -20\r\nKPX Aacute uhungarumlaut -20\r\nKPX Aacute umacron -20\r\nKPX Aacute uogonek -20\r\nKPX Aacute uring -20\r\nKPX Aacute v -55\r\nKPX Aacute w -55\r\nKPX Aacute y -55\r\nKPX Aacute yacute -55\r\nKPX Aacute ydieresis -55\r\nKPX Abreve C -30\r\nKPX Abreve Cacute -30\r\nKPX Abreve Ccaron -30\r\nKPX Abreve Ccedilla -30\r\nKPX Abreve G -35\r\nKPX Abreve Gbreve -35\r\nKPX Abreve Gcommaaccent -35\r\nKPX Abreve O -40\r\nKPX Abreve Oacute -40\r\nKPX Abreve Ocircumflex -40\r\nKPX Abreve Odieresis -40\r\nKPX Abreve Ograve -40\r\nKPX Abreve Ohungarumlaut -40\r\nKPX Abreve Omacron -40\r\nKPX Abreve Oslash -40\r\nKPX Abreve Otilde -40\r\nKPX Abreve Q -40\r\nKPX Abreve T -37\r\nKPX Abreve Tcaron -37\r\nKPX Abreve Tcommaaccent -37\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -105\r\nKPX Abreve W -95\r\nKPX Abreve Y -55\r\nKPX Abreve Yacute -55\r\nKPX Abreve Ydieresis -55\r\nKPX Abreve quoteright -37\r\nKPX Abreve u -20\r\nKPX Abreve uacute -20\r\nKPX Abreve ucircumflex -20\r\nKPX Abreve udieresis -20\r\nKPX Abreve ugrave -20\r\nKPX Abreve uhungarumlaut -20\r\nKPX Abreve umacron -20\r\nKPX Abreve uogonek -20\r\nKPX Abreve uring -20\r\nKPX Abreve v -55\r\nKPX Abreve w -55\r\nKPX Abreve y -55\r\nKPX Abreve yacute -55\r\nKPX Abreve ydieresis -55\r\nKPX Acircumflex C -30\r\nKPX Acircumflex Cacute -30\r\nKPX Acircumflex Ccaron -30\r\nKPX Acircumflex Ccedilla -30\r\nKPX Acircumflex G -35\r\nKPX Acircumflex Gbreve -35\r\nKPX Acircumflex Gcommaaccent -35\r\nKPX Acircumflex O -40\r\nKPX Acircumflex Oacute -40\r\nKPX Acircumflex Ocircumflex -40\r\nKPX Acircumflex Odieresis -40\r\nKPX Acircumflex Ograve -40\r\nKPX Acircumflex Ohungarumlaut -40\r\nKPX Acircumflex Omacron -40\r\nKPX Acircumflex Oslash -40\r\nKPX Acircumflex Otilde -40\r\nKPX Acircumflex Q -40\r\nKPX Acircumflex T -37\r\nKPX Acircumflex Tcaron -37\r\nKPX Acircumflex Tcommaaccent -37\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -105\r\nKPX Acircumflex W -95\r\nKPX Acircumflex Y -55\r\nKPX Acircumflex Yacute -55\r\nKPX Acircumflex Ydieresis -55\r\nKPX Acircumflex quoteright -37\r\nKPX Acircumflex u -20\r\nKPX Acircumflex uacute -20\r\nKPX Acircumflex ucircumflex -20\r\nKPX Acircumflex udieresis -20\r\nKPX Acircumflex ugrave -20\r\nKPX Acircumflex uhungarumlaut -20\r\nKPX Acircumflex umacron -20\r\nKPX Acircumflex uogonek -20\r\nKPX Acircumflex uring -20\r\nKPX Acircumflex v -55\r\nKPX Acircumflex w -55\r\nKPX Acircumflex y -55\r\nKPX Acircumflex yacute -55\r\nKPX Acircumflex ydieresis -55\r\nKPX Adieresis C -30\r\nKPX Adieresis Cacute -30\r\nKPX Adieresis Ccaron -30\r\nKPX Adieresis Ccedilla -30\r\nKPX Adieresis G -35\r\nKPX Adieresis Gbreve -35\r\nKPX Adieresis Gcommaaccent -35\r\nKPX Adieresis O -40\r\nKPX Adieresis Oacute -40\r\nKPX Adieresis Ocircumflex -40\r\nKPX Adieresis Odieresis -40\r\nKPX Adieresis Ograve -40\r\nKPX Adieresis Ohungarumlaut -40\r\nKPX Adieresis Omacron -40\r\nKPX Adieresis Oslash -40\r\nKPX Adieresis Otilde -40\r\nKPX Adieresis Q -40\r\nKPX Adieresis T -37\r\nKPX Adieresis Tcaron -37\r\nKPX Adieresis Tcommaaccent -37\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -105\r\nKPX Adieresis W -95\r\nKPX Adieresis Y -55\r\nKPX Adieresis Yacute -55\r\nKPX Adieresis Ydieresis -55\r\nKPX Adieresis quoteright -37\r\nKPX Adieresis u -20\r\nKPX Adieresis uacute -20\r\nKPX Adieresis ucircumflex -20\r\nKPX Adieresis udieresis -20\r\nKPX Adieresis ugrave -20\r\nKPX Adieresis uhungarumlaut -20\r\nKPX Adieresis umacron -20\r\nKPX Adieresis uogonek -20\r\nKPX Adieresis uring -20\r\nKPX Adieresis v -55\r\nKPX Adieresis w -55\r\nKPX Adieresis y -55\r\nKPX Adieresis yacute -55\r\nKPX Adieresis ydieresis -55\r\nKPX Agrave C -30\r\nKPX Agrave Cacute -30\r\nKPX Agrave Ccaron -30\r\nKPX Agrave Ccedilla -30\r\nKPX Agrave G -35\r\nKPX Agrave Gbreve -35\r\nKPX Agrave Gcommaaccent -35\r\nKPX Agrave O -40\r\nKPX Agrave Oacute -40\r\nKPX Agrave Ocircumflex -40\r\nKPX Agrave Odieresis -40\r\nKPX Agrave Ograve -40\r\nKPX Agrave Ohungarumlaut -40\r\nKPX Agrave Omacron -40\r\nKPX Agrave Oslash -40\r\nKPX Agrave Otilde -40\r\nKPX Agrave Q -40\r\nKPX Agrave T -37\r\nKPX Agrave Tcaron -37\r\nKPX Agrave Tcommaaccent -37\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -105\r\nKPX Agrave W -95\r\nKPX Agrave Y -55\r\nKPX Agrave Yacute -55\r\nKPX Agrave Ydieresis -55\r\nKPX Agrave quoteright -37\r\nKPX Agrave u -20\r\nKPX Agrave uacute -20\r\nKPX Agrave ucircumflex -20\r\nKPX Agrave udieresis -20\r\nKPX Agrave ugrave -20\r\nKPX Agrave uhungarumlaut -20\r\nKPX Agrave umacron -20\r\nKPX Agrave uogonek -20\r\nKPX Agrave uring -20\r\nKPX Agrave v -55\r\nKPX Agrave w -55\r\nKPX Agrave y -55\r\nKPX Agrave yacute -55\r\nKPX Agrave ydieresis -55\r\nKPX Amacron C -30\r\nKPX Amacron Cacute -30\r\nKPX Amacron Ccaron -30\r\nKPX Amacron Ccedilla -30\r\nKPX Amacron G -35\r\nKPX Amacron Gbreve -35\r\nKPX Amacron Gcommaaccent -35\r\nKPX Amacron O -40\r\nKPX Amacron Oacute -40\r\nKPX Amacron Ocircumflex -40\r\nKPX Amacron Odieresis -40\r\nKPX Amacron Ograve -40\r\nKPX Amacron Ohungarumlaut -40\r\nKPX Amacron Omacron -40\r\nKPX Amacron Oslash -40\r\nKPX Amacron Otilde -40\r\nKPX Amacron Q -40\r\nKPX Amacron T -37\r\nKPX Amacron Tcaron -37\r\nKPX Amacron Tcommaaccent -37\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -105\r\nKPX Amacron W -95\r\nKPX Amacron Y -55\r\nKPX Amacron Yacute -55\r\nKPX Amacron Ydieresis -55\r\nKPX Amacron quoteright -37\r\nKPX Amacron u -20\r\nKPX Amacron uacute -20\r\nKPX Amacron ucircumflex -20\r\nKPX Amacron udieresis -20\r\nKPX Amacron ugrave -20\r\nKPX Amacron uhungarumlaut -20\r\nKPX Amacron umacron -20\r\nKPX Amacron uogonek -20\r\nKPX Amacron uring -20\r\nKPX Amacron v -55\r\nKPX Amacron w -55\r\nKPX Amacron y -55\r\nKPX Amacron yacute -55\r\nKPX Amacron ydieresis -55\r\nKPX Aogonek C -30\r\nKPX Aogonek Cacute -30\r\nKPX Aogonek Ccaron -30\r\nKPX Aogonek Ccedilla -30\r\nKPX Aogonek G -35\r\nKPX Aogonek Gbreve -35\r\nKPX Aogonek Gcommaaccent -35\r\nKPX Aogonek O -40\r\nKPX Aogonek Oacute -40\r\nKPX Aogonek Ocircumflex -40\r\nKPX Aogonek Odieresis -40\r\nKPX Aogonek Ograve -40\r\nKPX Aogonek Ohungarumlaut -40\r\nKPX Aogonek Omacron -40\r\nKPX Aogonek Oslash -40\r\nKPX Aogonek Otilde -40\r\nKPX Aogonek Q -40\r\nKPX Aogonek T -37\r\nKPX Aogonek Tcaron -37\r\nKPX Aogonek Tcommaaccent -37\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -105\r\nKPX Aogonek W -95\r\nKPX Aogonek Y -55\r\nKPX Aogonek Yacute -55\r\nKPX Aogonek Ydieresis -55\r\nKPX Aogonek quoteright -37\r\nKPX Aogonek u -20\r\nKPX Aogonek uacute -20\r\nKPX Aogonek ucircumflex -20\r\nKPX Aogonek udieresis -20\r\nKPX Aogonek ugrave -20\r\nKPX Aogonek uhungarumlaut -20\r\nKPX Aogonek umacron -20\r\nKPX Aogonek uogonek -20\r\nKPX Aogonek uring -20\r\nKPX Aogonek v -55\r\nKPX Aogonek w -55\r\nKPX Aogonek y -55\r\nKPX Aogonek yacute -55\r\nKPX Aogonek ydieresis -55\r\nKPX Aring C -30\r\nKPX Aring Cacute -30\r\nKPX Aring Ccaron -30\r\nKPX Aring Ccedilla -30\r\nKPX Aring G -35\r\nKPX Aring Gbreve -35\r\nKPX Aring Gcommaaccent -35\r\nKPX Aring O -40\r\nKPX Aring Oacute -40\r\nKPX Aring Ocircumflex -40\r\nKPX Aring Odieresis -40\r\nKPX Aring Ograve -40\r\nKPX Aring Ohungarumlaut -40\r\nKPX Aring Omacron -40\r\nKPX Aring Oslash -40\r\nKPX Aring Otilde -40\r\nKPX Aring Q -40\r\nKPX Aring T -37\r\nKPX Aring Tcaron -37\r\nKPX Aring Tcommaaccent -37\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -105\r\nKPX Aring W -95\r\nKPX Aring Y -55\r\nKPX Aring Yacute -55\r\nKPX Aring Ydieresis -55\r\nKPX Aring quoteright -37\r\nKPX Aring u -20\r\nKPX Aring uacute -20\r\nKPX Aring ucircumflex -20\r\nKPX Aring udieresis -20\r\nKPX Aring ugrave -20\r\nKPX Aring uhungarumlaut -20\r\nKPX Aring umacron -20\r\nKPX Aring uogonek -20\r\nKPX Aring uring -20\r\nKPX Aring v -55\r\nKPX Aring w -55\r\nKPX Aring y -55\r\nKPX Aring yacute -55\r\nKPX Aring ydieresis -55\r\nKPX Atilde C -30\r\nKPX Atilde Cacute -30\r\nKPX Atilde Ccaron -30\r\nKPX Atilde Ccedilla -30\r\nKPX Atilde G -35\r\nKPX Atilde Gbreve -35\r\nKPX Atilde Gcommaaccent -35\r\nKPX Atilde O -40\r\nKPX Atilde Oacute -40\r\nKPX Atilde Ocircumflex -40\r\nKPX Atilde Odieresis -40\r\nKPX Atilde Ograve -40\r\nKPX Atilde Ohungarumlaut -40\r\nKPX Atilde Omacron -40\r\nKPX Atilde Oslash -40\r\nKPX Atilde Otilde -40\r\nKPX Atilde Q -40\r\nKPX Atilde T -37\r\nKPX Atilde Tcaron -37\r\nKPX Atilde Tcommaaccent -37\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -105\r\nKPX Atilde W -95\r\nKPX Atilde Y -55\r\nKPX Atilde Yacute -55\r\nKPX Atilde Ydieresis -55\r\nKPX Atilde quoteright -37\r\nKPX Atilde u -20\r\nKPX Atilde uacute -20\r\nKPX Atilde ucircumflex -20\r\nKPX Atilde udieresis -20\r\nKPX Atilde ugrave -20\r\nKPX Atilde uhungarumlaut -20\r\nKPX Atilde umacron -20\r\nKPX Atilde uogonek -20\r\nKPX Atilde uring -20\r\nKPX Atilde v -55\r\nKPX Atilde w -55\r\nKPX Atilde y -55\r\nKPX Atilde yacute -55\r\nKPX Atilde ydieresis -55\r\nKPX B A -25\r\nKPX B Aacute -25\r\nKPX B Abreve -25\r\nKPX B Acircumflex -25\r\nKPX B Adieresis -25\r\nKPX B Agrave -25\r\nKPX B Amacron -25\r\nKPX B Aogonek -25\r\nKPX B Aring -25\r\nKPX B Atilde -25\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -35\r\nKPX D Aacute -35\r\nKPX D Abreve -35\r\nKPX D Acircumflex -35\r\nKPX D Adieresis -35\r\nKPX D Agrave -35\r\nKPX D Amacron -35\r\nKPX D Aogonek -35\r\nKPX D Aring -35\r\nKPX D Atilde -35\r\nKPX D V -40\r\nKPX D W -40\r\nKPX D Y -40\r\nKPX D Yacute -40\r\nKPX D Ydieresis -40\r\nKPX Dcaron A -35\r\nKPX Dcaron Aacute -35\r\nKPX Dcaron Abreve -35\r\nKPX Dcaron Acircumflex -35\r\nKPX Dcaron Adieresis -35\r\nKPX Dcaron Agrave -35\r\nKPX Dcaron Amacron -35\r\nKPX Dcaron Aogonek -35\r\nKPX Dcaron Aring -35\r\nKPX Dcaron Atilde -35\r\nKPX Dcaron V -40\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -40\r\nKPX Dcaron Yacute -40\r\nKPX Dcaron Ydieresis -40\r\nKPX Dcroat A -35\r\nKPX Dcroat Aacute -35\r\nKPX Dcroat Abreve -35\r\nKPX Dcroat Acircumflex -35\r\nKPX Dcroat Adieresis -35\r\nKPX Dcroat Agrave -35\r\nKPX Dcroat Amacron -35\r\nKPX Dcroat Aogonek -35\r\nKPX Dcroat Aring -35\r\nKPX Dcroat Atilde -35\r\nKPX Dcroat V -40\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -40\r\nKPX Dcroat Yacute -40\r\nKPX Dcroat Ydieresis -40\r\nKPX F A -115\r\nKPX F Aacute -115\r\nKPX F Abreve -115\r\nKPX F Acircumflex -115\r\nKPX F Adieresis -115\r\nKPX F Agrave -115\r\nKPX F Amacron -115\r\nKPX F Aogonek -115\r\nKPX F Aring -115\r\nKPX F Atilde -115\r\nKPX F a -75\r\nKPX F aacute -75\r\nKPX F abreve -75\r\nKPX F acircumflex -75\r\nKPX F adieresis -75\r\nKPX F agrave -75\r\nKPX F amacron -75\r\nKPX F aogonek -75\r\nKPX F aring -75\r\nKPX F atilde -75\r\nKPX F comma -135\r\nKPX F e -75\r\nKPX F eacute -75\r\nKPX F ecaron -75\r\nKPX F ecircumflex -75\r\nKPX F edieresis -75\r\nKPX F edotaccent -75\r\nKPX F egrave -75\r\nKPX F emacron -75\r\nKPX F eogonek -75\r\nKPX F i -45\r\nKPX F iacute -45\r\nKPX F icircumflex -45\r\nKPX F idieresis -45\r\nKPX F igrave -45\r\nKPX F imacron -45\r\nKPX F iogonek -45\r\nKPX F o -105\r\nKPX F oacute -105\r\nKPX F ocircumflex -105\r\nKPX F odieresis -105\r\nKPX F ograve -105\r\nKPX F ohungarumlaut -105\r\nKPX F omacron -105\r\nKPX F oslash -105\r\nKPX F otilde -105\r\nKPX F period -135\r\nKPX F r -55\r\nKPX F racute -55\r\nKPX F rcaron -55\r\nKPX F rcommaaccent -55\r\nKPX J A -40\r\nKPX J Aacute -40\r\nKPX J Abreve -40\r\nKPX J Acircumflex -40\r\nKPX J Adieresis -40\r\nKPX J Agrave -40\r\nKPX J Amacron -40\r\nKPX J Aogonek -40\r\nKPX J Aring -40\r\nKPX J Atilde -40\r\nKPX J a -35\r\nKPX J aacute -35\r\nKPX J abreve -35\r\nKPX J acircumflex -35\r\nKPX J adieresis -35\r\nKPX J agrave -35\r\nKPX J amacron -35\r\nKPX J aogonek -35\r\nKPX J aring -35\r\nKPX J atilde -35\r\nKPX J comma -25\r\nKPX J e -25\r\nKPX J eacute -25\r\nKPX J ecaron -25\r\nKPX J ecircumflex -25\r\nKPX J edieresis -25\r\nKPX J edotaccent -25\r\nKPX J egrave -25\r\nKPX J emacron -25\r\nKPX J eogonek -25\r\nKPX J o -25\r\nKPX J oacute -25\r\nKPX J ocircumflex -25\r\nKPX J odieresis -25\r\nKPX J ograve -25\r\nKPX J ohungarumlaut -25\r\nKPX J omacron -25\r\nKPX J oslash -25\r\nKPX J otilde -25\r\nKPX J period -25\r\nKPX J u -35\r\nKPX J uacute -35\r\nKPX J ucircumflex -35\r\nKPX J udieresis -35\r\nKPX J ugrave -35\r\nKPX J uhungarumlaut -35\r\nKPX J umacron -35\r\nKPX J uogonek -35\r\nKPX J uring -35\r\nKPX K O -50\r\nKPX K Oacute -50\r\nKPX K Ocircumflex -50\r\nKPX K Odieresis -50\r\nKPX K Ograve -50\r\nKPX K Ohungarumlaut -50\r\nKPX K Omacron -50\r\nKPX K Oslash -50\r\nKPX K Otilde -50\r\nKPX K e -35\r\nKPX K eacute -35\r\nKPX K ecaron -35\r\nKPX K ecircumflex -35\r\nKPX K edieresis -35\r\nKPX K edotaccent -35\r\nKPX K egrave -35\r\nKPX K emacron -35\r\nKPX K eogonek -35\r\nKPX K o -40\r\nKPX K oacute -40\r\nKPX K ocircumflex -40\r\nKPX K odieresis -40\r\nKPX K ograve -40\r\nKPX K ohungarumlaut -40\r\nKPX K omacron -40\r\nKPX K oslash -40\r\nKPX K otilde -40\r\nKPX K u -40\r\nKPX K uacute -40\r\nKPX K ucircumflex -40\r\nKPX K udieresis -40\r\nKPX K ugrave -40\r\nKPX K uhungarumlaut -40\r\nKPX K umacron -40\r\nKPX K uogonek -40\r\nKPX K uring -40\r\nKPX K y -40\r\nKPX K yacute -40\r\nKPX K ydieresis -40\r\nKPX Kcommaaccent O -50\r\nKPX Kcommaaccent Oacute -50\r\nKPX Kcommaaccent Ocircumflex -50\r\nKPX Kcommaaccent Odieresis -50\r\nKPX Kcommaaccent Ograve -50\r\nKPX Kcommaaccent Ohungarumlaut -50\r\nKPX Kcommaaccent Omacron -50\r\nKPX Kcommaaccent Oslash -50\r\nKPX Kcommaaccent Otilde -50\r\nKPX Kcommaaccent e -35\r\nKPX Kcommaaccent eacute -35\r\nKPX Kcommaaccent ecaron -35\r\nKPX Kcommaaccent ecircumflex -35\r\nKPX Kcommaaccent edieresis -35\r\nKPX Kcommaaccent edotaccent -35\r\nKPX Kcommaaccent egrave -35\r\nKPX Kcommaaccent emacron -35\r\nKPX Kcommaaccent eogonek -35\r\nKPX Kcommaaccent o -40\r\nKPX Kcommaaccent oacute -40\r\nKPX Kcommaaccent ocircumflex -40\r\nKPX Kcommaaccent odieresis -40\r\nKPX Kcommaaccent ograve -40\r\nKPX Kcommaaccent ohungarumlaut -40\r\nKPX Kcommaaccent omacron -40\r\nKPX Kcommaaccent oslash -40\r\nKPX Kcommaaccent otilde -40\r\nKPX Kcommaaccent u -40\r\nKPX Kcommaaccent uacute -40\r\nKPX Kcommaaccent ucircumflex -40\r\nKPX Kcommaaccent udieresis -40\r\nKPX Kcommaaccent ugrave -40\r\nKPX Kcommaaccent uhungarumlaut -40\r\nKPX Kcommaaccent umacron -40\r\nKPX Kcommaaccent uogonek -40\r\nKPX Kcommaaccent uring -40\r\nKPX Kcommaaccent y -40\r\nKPX Kcommaaccent yacute -40\r\nKPX Kcommaaccent ydieresis -40\r\nKPX L T -20\r\nKPX L Tcaron -20\r\nKPX L Tcommaaccent -20\r\nKPX L V -55\r\nKPX L W -55\r\nKPX L Y -20\r\nKPX L Yacute -20\r\nKPX L Ydieresis -20\r\nKPX L quoteright -37\r\nKPX L y -30\r\nKPX L yacute -30\r\nKPX L ydieresis -30\r\nKPX Lacute T -20\r\nKPX Lacute Tcaron -20\r\nKPX Lacute Tcommaaccent -20\r\nKPX Lacute V -55\r\nKPX Lacute W -55\r\nKPX Lacute Y -20\r\nKPX Lacute Yacute -20\r\nKPX Lacute Ydieresis -20\r\nKPX Lacute quoteright -37\r\nKPX Lacute y -30\r\nKPX Lacute yacute -30\r\nKPX Lacute ydieresis -30\r\nKPX Lcommaaccent T -20\r\nKPX Lcommaaccent Tcaron -20\r\nKPX Lcommaaccent Tcommaaccent -20\r\nKPX Lcommaaccent V -55\r\nKPX Lcommaaccent W -55\r\nKPX Lcommaaccent Y -20\r\nKPX Lcommaaccent Yacute -20\r\nKPX Lcommaaccent Ydieresis -20\r\nKPX Lcommaaccent quoteright -37\r\nKPX Lcommaaccent y -30\r\nKPX Lcommaaccent yacute -30\r\nKPX Lcommaaccent ydieresis -30\r\nKPX Lslash T -20\r\nKPX Lslash Tcaron -20\r\nKPX Lslash Tcommaaccent -20\r\nKPX Lslash V -55\r\nKPX Lslash W -55\r\nKPX Lslash Y -20\r\nKPX Lslash Yacute -20\r\nKPX Lslash Ydieresis -20\r\nKPX Lslash quoteright -37\r\nKPX Lslash y -30\r\nKPX Lslash yacute -30\r\nKPX Lslash ydieresis -30\r\nKPX N A -27\r\nKPX N Aacute -27\r\nKPX N Abreve -27\r\nKPX N Acircumflex -27\r\nKPX N Adieresis -27\r\nKPX N Agrave -27\r\nKPX N Amacron -27\r\nKPX N Aogonek -27\r\nKPX N Aring -27\r\nKPX N Atilde -27\r\nKPX Nacute A -27\r\nKPX Nacute Aacute -27\r\nKPX Nacute Abreve -27\r\nKPX Nacute Acircumflex -27\r\nKPX Nacute Adieresis -27\r\nKPX Nacute Agrave -27\r\nKPX Nacute Amacron -27\r\nKPX Nacute Aogonek -27\r\nKPX Nacute Aring -27\r\nKPX Nacute Atilde -27\r\nKPX Ncaron A -27\r\nKPX Ncaron Aacute -27\r\nKPX Ncaron Abreve -27\r\nKPX Ncaron Acircumflex -27\r\nKPX Ncaron Adieresis -27\r\nKPX Ncaron Agrave -27\r\nKPX Ncaron Amacron -27\r\nKPX Ncaron Aogonek -27\r\nKPX Ncaron Aring -27\r\nKPX Ncaron Atilde -27\r\nKPX Ncommaaccent A -27\r\nKPX Ncommaaccent Aacute -27\r\nKPX Ncommaaccent Abreve -27\r\nKPX Ncommaaccent Acircumflex -27\r\nKPX Ncommaaccent Adieresis -27\r\nKPX Ncommaaccent Agrave -27\r\nKPX Ncommaaccent Amacron -27\r\nKPX Ncommaaccent Aogonek -27\r\nKPX Ncommaaccent Aring -27\r\nKPX Ncommaaccent Atilde -27\r\nKPX Ntilde A -27\r\nKPX Ntilde Aacute -27\r\nKPX Ntilde Abreve -27\r\nKPX Ntilde Acircumflex -27\r\nKPX Ntilde Adieresis -27\r\nKPX Ntilde Agrave -27\r\nKPX Ntilde Amacron -27\r\nKPX Ntilde Aogonek -27\r\nKPX Ntilde Aring -27\r\nKPX Ntilde Atilde -27\r\nKPX O A -55\r\nKPX O Aacute -55\r\nKPX O Abreve -55\r\nKPX O Acircumflex -55\r\nKPX O Adieresis -55\r\nKPX O Agrave -55\r\nKPX O Amacron -55\r\nKPX O Aogonek -55\r\nKPX O Aring -55\r\nKPX O Atilde -55\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -50\r\nKPX O X -40\r\nKPX O Y -50\r\nKPX O Yacute -50\r\nKPX O Ydieresis -50\r\nKPX Oacute A -55\r\nKPX Oacute Aacute -55\r\nKPX Oacute Abreve -55\r\nKPX Oacute Acircumflex -55\r\nKPX Oacute Adieresis -55\r\nKPX Oacute Agrave -55\r\nKPX Oacute Amacron -55\r\nKPX Oacute Aogonek -55\r\nKPX Oacute Aring -55\r\nKPX Oacute Atilde -55\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -50\r\nKPX Oacute X -40\r\nKPX Oacute Y -50\r\nKPX Oacute Yacute -50\r\nKPX Oacute Ydieresis -50\r\nKPX Ocircumflex A -55\r\nKPX Ocircumflex Aacute -55\r\nKPX Ocircumflex Abreve -55\r\nKPX Ocircumflex Acircumflex -55\r\nKPX Ocircumflex Adieresis -55\r\nKPX Ocircumflex Agrave -55\r\nKPX Ocircumflex Amacron -55\r\nKPX Ocircumflex Aogonek -55\r\nKPX Ocircumflex Aring -55\r\nKPX Ocircumflex Atilde -55\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -50\r\nKPX Ocircumflex X -40\r\nKPX Ocircumflex Y -50\r\nKPX Ocircumflex Yacute -50\r\nKPX Ocircumflex Ydieresis -50\r\nKPX Odieresis A -55\r\nKPX Odieresis Aacute -55\r\nKPX Odieresis Abreve -55\r\nKPX Odieresis Acircumflex -55\r\nKPX Odieresis Adieresis -55\r\nKPX Odieresis Agrave -55\r\nKPX Odieresis Amacron -55\r\nKPX Odieresis Aogonek -55\r\nKPX Odieresis Aring -55\r\nKPX Odieresis Atilde -55\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -50\r\nKPX Odieresis X -40\r\nKPX Odieresis Y -50\r\nKPX Odieresis Yacute -50\r\nKPX Odieresis Ydieresis -50\r\nKPX Ograve A -55\r\nKPX Ograve Aacute -55\r\nKPX Ograve Abreve -55\r\nKPX Ograve Acircumflex -55\r\nKPX Ograve Adieresis -55\r\nKPX Ograve Agrave -55\r\nKPX Ograve Amacron -55\r\nKPX Ograve Aogonek -55\r\nKPX Ograve Aring -55\r\nKPX Ograve Atilde -55\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -50\r\nKPX Ograve X -40\r\nKPX Ograve Y -50\r\nKPX Ograve Yacute -50\r\nKPX Ograve Ydieresis -50\r\nKPX Ohungarumlaut A -55\r\nKPX Ohungarumlaut Aacute -55\r\nKPX Ohungarumlaut Abreve -55\r\nKPX Ohungarumlaut Acircumflex -55\r\nKPX Ohungarumlaut Adieresis -55\r\nKPX Ohungarumlaut Agrave -55\r\nKPX Ohungarumlaut Amacron -55\r\nKPX Ohungarumlaut Aogonek -55\r\nKPX Ohungarumlaut Aring -55\r\nKPX Ohungarumlaut Atilde -55\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -50\r\nKPX Ohungarumlaut X -40\r\nKPX Ohungarumlaut Y -50\r\nKPX Ohungarumlaut Yacute -50\r\nKPX Ohungarumlaut Ydieresis -50\r\nKPX Omacron A -55\r\nKPX Omacron Aacute -55\r\nKPX Omacron Abreve -55\r\nKPX Omacron Acircumflex -55\r\nKPX Omacron Adieresis -55\r\nKPX Omacron Agrave -55\r\nKPX Omacron Amacron -55\r\nKPX Omacron Aogonek -55\r\nKPX Omacron Aring -55\r\nKPX Omacron Atilde -55\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -50\r\nKPX Omacron X -40\r\nKPX Omacron Y -50\r\nKPX Omacron Yacute -50\r\nKPX Omacron Ydieresis -50\r\nKPX Oslash A -55\r\nKPX Oslash Aacute -55\r\nKPX Oslash Abreve -55\r\nKPX Oslash Acircumflex -55\r\nKPX Oslash Adieresis -55\r\nKPX Oslash Agrave -55\r\nKPX Oslash Amacron -55\r\nKPX Oslash Aogonek -55\r\nKPX Oslash Aring -55\r\nKPX Oslash Atilde -55\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -50\r\nKPX Oslash X -40\r\nKPX Oslash Y -50\r\nKPX Oslash Yacute -50\r\nKPX Oslash Ydieresis -50\r\nKPX Otilde A -55\r\nKPX Otilde Aacute -55\r\nKPX Otilde Abreve -55\r\nKPX Otilde Acircumflex -55\r\nKPX Otilde Adieresis -55\r\nKPX Otilde Agrave -55\r\nKPX Otilde Amacron -55\r\nKPX Otilde Aogonek -55\r\nKPX Otilde Aring -55\r\nKPX Otilde Atilde -55\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -50\r\nKPX Otilde X -40\r\nKPX Otilde Y -50\r\nKPX Otilde Yacute -50\r\nKPX Otilde Ydieresis -50\r\nKPX P A -90\r\nKPX P Aacute -90\r\nKPX P Abreve -90\r\nKPX P Acircumflex -90\r\nKPX P Adieresis -90\r\nKPX P Agrave -90\r\nKPX P Amacron -90\r\nKPX P Aogonek -90\r\nKPX P Aring -90\r\nKPX P Atilde -90\r\nKPX P a -80\r\nKPX P aacute -80\r\nKPX P abreve -80\r\nKPX P acircumflex -80\r\nKPX P adieresis -80\r\nKPX P agrave -80\r\nKPX P amacron -80\r\nKPX P aogonek -80\r\nKPX P aring -80\r\nKPX P atilde -80\r\nKPX P comma -135\r\nKPX P e -80\r\nKPX P eacute -80\r\nKPX P ecaron -80\r\nKPX P ecircumflex -80\r\nKPX P edieresis -80\r\nKPX P edotaccent -80\r\nKPX P egrave -80\r\nKPX P emacron -80\r\nKPX P eogonek -80\r\nKPX P o -80\r\nKPX P oacute -80\r\nKPX P ocircumflex -80\r\nKPX P odieresis -80\r\nKPX P ograve -80\r\nKPX P ohungarumlaut -80\r\nKPX P omacron -80\r\nKPX P oslash -80\r\nKPX P otilde -80\r\nKPX P period -135\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX R O -40\r\nKPX R Oacute -40\r\nKPX R Ocircumflex -40\r\nKPX R Odieresis -40\r\nKPX R Ograve -40\r\nKPX R Ohungarumlaut -40\r\nKPX R Omacron -40\r\nKPX R Oslash -40\r\nKPX R Otilde -40\r\nKPX R U -40\r\nKPX R Uacute -40\r\nKPX R Ucircumflex -40\r\nKPX R Udieresis -40\r\nKPX R Ugrave -40\r\nKPX R Uhungarumlaut -40\r\nKPX R Umacron -40\r\nKPX R Uogonek -40\r\nKPX R Uring -40\r\nKPX R V -18\r\nKPX R W -18\r\nKPX R Y -18\r\nKPX R Yacute -18\r\nKPX R Ydieresis -18\r\nKPX Racute O -40\r\nKPX Racute Oacute -40\r\nKPX Racute Ocircumflex -40\r\nKPX Racute Odieresis -40\r\nKPX Racute Ograve -40\r\nKPX Racute Ohungarumlaut -40\r\nKPX Racute Omacron -40\r\nKPX Racute Oslash -40\r\nKPX Racute Otilde -40\r\nKPX Racute U -40\r\nKPX Racute Uacute -40\r\nKPX Racute Ucircumflex -40\r\nKPX Racute Udieresis -40\r\nKPX Racute Ugrave -40\r\nKPX Racute Uhungarumlaut -40\r\nKPX Racute Umacron -40\r\nKPX Racute Uogonek -40\r\nKPX Racute Uring -40\r\nKPX Racute V -18\r\nKPX Racute W -18\r\nKPX Racute Y -18\r\nKPX Racute Yacute -18\r\nKPX Racute Ydieresis -18\r\nKPX Rcaron O -40\r\nKPX Rcaron Oacute -40\r\nKPX Rcaron Ocircumflex -40\r\nKPX Rcaron Odieresis -40\r\nKPX Rcaron Ograve -40\r\nKPX Rcaron Ohungarumlaut -40\r\nKPX Rcaron Omacron -40\r\nKPX Rcaron Oslash -40\r\nKPX Rcaron Otilde -40\r\nKPX Rcaron U -40\r\nKPX Rcaron Uacute -40\r\nKPX Rcaron Ucircumflex -40\r\nKPX Rcaron Udieresis -40\r\nKPX Rcaron Ugrave -40\r\nKPX Rcaron Uhungarumlaut -40\r\nKPX Rcaron Umacron -40\r\nKPX Rcaron Uogonek -40\r\nKPX Rcaron Uring -40\r\nKPX Rcaron V -18\r\nKPX Rcaron W -18\r\nKPX Rcaron Y -18\r\nKPX Rcaron Yacute -18\r\nKPX Rcaron Ydieresis -18\r\nKPX Rcommaaccent O -40\r\nKPX Rcommaaccent Oacute -40\r\nKPX Rcommaaccent Ocircumflex -40\r\nKPX Rcommaaccent Odieresis -40\r\nKPX Rcommaaccent Ograve -40\r\nKPX Rcommaaccent Ohungarumlaut -40\r\nKPX Rcommaaccent Omacron -40\r\nKPX Rcommaaccent Oslash -40\r\nKPX Rcommaaccent Otilde -40\r\nKPX Rcommaaccent U -40\r\nKPX Rcommaaccent Uacute -40\r\nKPX Rcommaaccent Ucircumflex -40\r\nKPX Rcommaaccent Udieresis -40\r\nKPX Rcommaaccent Ugrave -40\r\nKPX Rcommaaccent Uhungarumlaut -40\r\nKPX Rcommaaccent Umacron -40\r\nKPX Rcommaaccent Uogonek -40\r\nKPX Rcommaaccent Uring -40\r\nKPX Rcommaaccent V -18\r\nKPX Rcommaaccent W -18\r\nKPX Rcommaaccent Y -18\r\nKPX Rcommaaccent Yacute -18\r\nKPX Rcommaaccent Ydieresis -18\r\nKPX T A -50\r\nKPX T Aacute -50\r\nKPX T Abreve -50\r\nKPX T Acircumflex -50\r\nKPX T Adieresis -50\r\nKPX T Agrave -50\r\nKPX T Amacron -50\r\nKPX T Aogonek -50\r\nKPX T Aring -50\r\nKPX T Atilde -50\r\nKPX T O -18\r\nKPX T Oacute -18\r\nKPX T Ocircumflex -18\r\nKPX T Odieresis -18\r\nKPX T Ograve -18\r\nKPX T Ohungarumlaut -18\r\nKPX T Omacron -18\r\nKPX T Oslash -18\r\nKPX T Otilde -18\r\nKPX T a -92\r\nKPX T aacute -92\r\nKPX T abreve -92\r\nKPX T acircumflex -92\r\nKPX T adieresis -92\r\nKPX T agrave -92\r\nKPX T amacron -92\r\nKPX T aogonek -92\r\nKPX T aring -92\r\nKPX T atilde -92\r\nKPX T colon -55\r\nKPX T comma -74\r\nKPX T e -92\r\nKPX T eacute -92\r\nKPX T ecaron -92\r\nKPX T ecircumflex -52\r\nKPX T edieresis -52\r\nKPX T edotaccent -92\r\nKPX T egrave -52\r\nKPX T emacron -52\r\nKPX T eogonek -92\r\nKPX T hyphen -74\r\nKPX T i -55\r\nKPX T iacute -55\r\nKPX T iogonek -55\r\nKPX T o -92\r\nKPX T oacute -92\r\nKPX T ocircumflex -92\r\nKPX T odieresis -92\r\nKPX T ograve -92\r\nKPX T ohungarumlaut -92\r\nKPX T omacron -92\r\nKPX T oslash -92\r\nKPX T otilde -92\r\nKPX T period -74\r\nKPX T r -55\r\nKPX T racute -55\r\nKPX T rcaron -55\r\nKPX T rcommaaccent -55\r\nKPX T semicolon -65\r\nKPX T u -55\r\nKPX T uacute -55\r\nKPX T ucircumflex -55\r\nKPX T udieresis -55\r\nKPX T ugrave -55\r\nKPX T uhungarumlaut -55\r\nKPX T umacron -55\r\nKPX T uogonek -55\r\nKPX T uring -55\r\nKPX T w -74\r\nKPX T y -74\r\nKPX T yacute -74\r\nKPX T ydieresis -34\r\nKPX Tcaron A -50\r\nKPX Tcaron Aacute -50\r\nKPX Tcaron Abreve -50\r\nKPX Tcaron Acircumflex -50\r\nKPX Tcaron Adieresis -50\r\nKPX Tcaron Agrave -50\r\nKPX Tcaron Amacron -50\r\nKPX Tcaron Aogonek -50\r\nKPX Tcaron Aring -50\r\nKPX Tcaron Atilde -50\r\nKPX Tcaron O -18\r\nKPX Tcaron Oacute -18\r\nKPX Tcaron Ocircumflex -18\r\nKPX Tcaron Odieresis -18\r\nKPX Tcaron Ograve -18\r\nKPX Tcaron Ohungarumlaut -18\r\nKPX Tcaron Omacron -18\r\nKPX Tcaron Oslash -18\r\nKPX Tcaron Otilde -18\r\nKPX Tcaron a -92\r\nKPX Tcaron aacute -92\r\nKPX Tcaron abreve -92\r\nKPX Tcaron acircumflex -92\r\nKPX Tcaron adieresis -92\r\nKPX Tcaron agrave -92\r\nKPX Tcaron amacron -92\r\nKPX Tcaron aogonek -92\r\nKPX Tcaron aring -92\r\nKPX Tcaron atilde -92\r\nKPX Tcaron colon -55\r\nKPX Tcaron comma -74\r\nKPX Tcaron e -92\r\nKPX Tcaron eacute -92\r\nKPX Tcaron ecaron -92\r\nKPX Tcaron ecircumflex -52\r\nKPX Tcaron edieresis -52\r\nKPX Tcaron edotaccent -92\r\nKPX Tcaron egrave -52\r\nKPX Tcaron emacron -52\r\nKPX Tcaron eogonek -92\r\nKPX Tcaron hyphen -74\r\nKPX Tcaron i -55\r\nKPX Tcaron iacute -55\r\nKPX Tcaron iogonek -55\r\nKPX Tcaron o -92\r\nKPX Tcaron oacute -92\r\nKPX Tcaron ocircumflex -92\r\nKPX Tcaron odieresis -92\r\nKPX Tcaron ograve -92\r\nKPX Tcaron ohungarumlaut -92\r\nKPX Tcaron omacron -92\r\nKPX Tcaron oslash -92\r\nKPX Tcaron otilde -92\r\nKPX Tcaron period -74\r\nKPX Tcaron r -55\r\nKPX Tcaron racute -55\r\nKPX Tcaron rcaron -55\r\nKPX Tcaron rcommaaccent -55\r\nKPX Tcaron semicolon -65\r\nKPX Tcaron u -55\r\nKPX Tcaron uacute -55\r\nKPX Tcaron ucircumflex -55\r\nKPX Tcaron udieresis -55\r\nKPX Tcaron ugrave -55\r\nKPX Tcaron uhungarumlaut -55\r\nKPX Tcaron umacron -55\r\nKPX Tcaron uogonek -55\r\nKPX Tcaron uring -55\r\nKPX Tcaron w -74\r\nKPX Tcaron y -74\r\nKPX Tcaron yacute -74\r\nKPX Tcaron ydieresis -34\r\nKPX Tcommaaccent A -50\r\nKPX Tcommaaccent Aacute -50\r\nKPX Tcommaaccent Abreve -50\r\nKPX Tcommaaccent Acircumflex -50\r\nKPX Tcommaaccent Adieresis -50\r\nKPX Tcommaaccent Agrave -50\r\nKPX Tcommaaccent Amacron -50\r\nKPX Tcommaaccent Aogonek -50\r\nKPX Tcommaaccent Aring -50\r\nKPX Tcommaaccent Atilde -50\r\nKPX Tcommaaccent O -18\r\nKPX Tcommaaccent Oacute -18\r\nKPX Tcommaaccent Ocircumflex -18\r\nKPX Tcommaaccent Odieresis -18\r\nKPX Tcommaaccent Ograve -18\r\nKPX Tcommaaccent Ohungarumlaut -18\r\nKPX Tcommaaccent Omacron -18\r\nKPX Tcommaaccent Oslash -18\r\nKPX Tcommaaccent Otilde -18\r\nKPX Tcommaaccent a -92\r\nKPX Tcommaaccent aacute -92\r\nKPX Tcommaaccent abreve -92\r\nKPX Tcommaaccent acircumflex -92\r\nKPX Tcommaaccent adieresis -92\r\nKPX Tcommaaccent agrave -92\r\nKPX Tcommaaccent amacron -92\r\nKPX Tcommaaccent aogonek -92\r\nKPX Tcommaaccent aring -92\r\nKPX Tcommaaccent atilde -92\r\nKPX Tcommaaccent colon -55\r\nKPX Tcommaaccent comma -74\r\nKPX Tcommaaccent e -92\r\nKPX Tcommaaccent eacute -92\r\nKPX Tcommaaccent ecaron -92\r\nKPX Tcommaaccent ecircumflex -52\r\nKPX Tcommaaccent edieresis -52\r\nKPX Tcommaaccent edotaccent -92\r\nKPX Tcommaaccent egrave -52\r\nKPX Tcommaaccent emacron -52\r\nKPX Tcommaaccent eogonek -92\r\nKPX Tcommaaccent hyphen -74\r\nKPX Tcommaaccent i -55\r\nKPX Tcommaaccent iacute -55\r\nKPX Tcommaaccent iogonek -55\r\nKPX Tcommaaccent o -92\r\nKPX Tcommaaccent oacute -92\r\nKPX Tcommaaccent ocircumflex -92\r\nKPX Tcommaaccent odieresis -92\r\nKPX Tcommaaccent ograve -92\r\nKPX Tcommaaccent ohungarumlaut -92\r\nKPX Tcommaaccent omacron -92\r\nKPX Tcommaaccent oslash -92\r\nKPX Tcommaaccent otilde -92\r\nKPX Tcommaaccent period -74\r\nKPX Tcommaaccent r -55\r\nKPX Tcommaaccent racute -55\r\nKPX Tcommaaccent rcaron -55\r\nKPX Tcommaaccent rcommaaccent -55\r\nKPX Tcommaaccent semicolon -65\r\nKPX Tcommaaccent u -55\r\nKPX Tcommaaccent uacute -55\r\nKPX Tcommaaccent ucircumflex -55\r\nKPX Tcommaaccent udieresis -55\r\nKPX Tcommaaccent ugrave -55\r\nKPX Tcommaaccent uhungarumlaut -55\r\nKPX Tcommaaccent umacron -55\r\nKPX Tcommaaccent uogonek -55\r\nKPX Tcommaaccent uring -55\r\nKPX Tcommaaccent w -74\r\nKPX Tcommaaccent y -74\r\nKPX Tcommaaccent yacute -74\r\nKPX Tcommaaccent ydieresis -34\r\nKPX U A -40\r\nKPX U Aacute -40\r\nKPX U Abreve -40\r\nKPX U Acircumflex -40\r\nKPX U Adieresis -40\r\nKPX U Agrave -40\r\nKPX U Amacron -40\r\nKPX U Aogonek -40\r\nKPX U Aring -40\r\nKPX U Atilde -40\r\nKPX U comma -25\r\nKPX U period -25\r\nKPX Uacute A -40\r\nKPX Uacute Aacute -40\r\nKPX Uacute Abreve -40\r\nKPX Uacute Acircumflex -40\r\nKPX Uacute Adieresis -40\r\nKPX Uacute Agrave -40\r\nKPX Uacute Amacron -40\r\nKPX Uacute Aogonek -40\r\nKPX Uacute Aring -40\r\nKPX Uacute Atilde -40\r\nKPX Uacute comma -25\r\nKPX Uacute period -25\r\nKPX Ucircumflex A -40\r\nKPX Ucircumflex Aacute -40\r\nKPX Ucircumflex Abreve -40\r\nKPX Ucircumflex Acircumflex -40\r\nKPX Ucircumflex Adieresis -40\r\nKPX Ucircumflex Agrave -40\r\nKPX Ucircumflex Amacron -40\r\nKPX Ucircumflex Aogonek -40\r\nKPX Ucircumflex Aring -40\r\nKPX Ucircumflex Atilde -40\r\nKPX Ucircumflex comma -25\r\nKPX Ucircumflex period -25\r\nKPX Udieresis A -40\r\nKPX Udieresis Aacute -40\r\nKPX Udieresis Abreve -40\r\nKPX Udieresis Acircumflex -40\r\nKPX Udieresis Adieresis -40\r\nKPX Udieresis Agrave -40\r\nKPX Udieresis Amacron -40\r\nKPX Udieresis Aogonek -40\r\nKPX Udieresis Aring -40\r\nKPX Udieresis Atilde -40\r\nKPX Udieresis comma -25\r\nKPX Udieresis period -25\r\nKPX Ugrave A -40\r\nKPX Ugrave Aacute -40\r\nKPX Ugrave Abreve -40\r\nKPX Ugrave Acircumflex -40\r\nKPX Ugrave Adieresis -40\r\nKPX Ugrave Agrave -40\r\nKPX Ugrave Amacron -40\r\nKPX Ugrave Aogonek -40\r\nKPX Ugrave Aring -40\r\nKPX Ugrave Atilde -40\r\nKPX Ugrave comma -25\r\nKPX Ugrave period -25\r\nKPX Uhungarumlaut A -40\r\nKPX Uhungarumlaut Aacute -40\r\nKPX Uhungarumlaut Abreve -40\r\nKPX Uhungarumlaut Acircumflex -40\r\nKPX Uhungarumlaut Adieresis -40\r\nKPX Uhungarumlaut Agrave -40\r\nKPX Uhungarumlaut Amacron -40\r\nKPX Uhungarumlaut Aogonek -40\r\nKPX Uhungarumlaut Aring -40\r\nKPX Uhungarumlaut Atilde -40\r\nKPX Uhungarumlaut comma -25\r\nKPX Uhungarumlaut period -25\r\nKPX Umacron A -40\r\nKPX Umacron Aacute -40\r\nKPX Umacron Abreve -40\r\nKPX Umacron Acircumflex -40\r\nKPX Umacron Adieresis -40\r\nKPX Umacron Agrave -40\r\nKPX Umacron Amacron -40\r\nKPX Umacron Aogonek -40\r\nKPX Umacron Aring -40\r\nKPX Umacron Atilde -40\r\nKPX Umacron comma -25\r\nKPX Umacron period -25\r\nKPX Uogonek A -40\r\nKPX Uogonek Aacute -40\r\nKPX Uogonek Abreve -40\r\nKPX Uogonek Acircumflex -40\r\nKPX Uogonek Adieresis -40\r\nKPX Uogonek Agrave -40\r\nKPX Uogonek Amacron -40\r\nKPX Uogonek Aogonek -40\r\nKPX Uogonek Aring -40\r\nKPX Uogonek Atilde -40\r\nKPX Uogonek comma -25\r\nKPX Uogonek period -25\r\nKPX Uring A -40\r\nKPX Uring Aacute -40\r\nKPX Uring Abreve -40\r\nKPX Uring Acircumflex -40\r\nKPX Uring Adieresis -40\r\nKPX Uring Agrave -40\r\nKPX Uring Amacron -40\r\nKPX Uring Aogonek -40\r\nKPX Uring Aring -40\r\nKPX Uring Atilde -40\r\nKPX Uring comma -25\r\nKPX Uring period -25\r\nKPX V A -60\r\nKPX V Aacute -60\r\nKPX V Abreve -60\r\nKPX V Acircumflex -60\r\nKPX V Adieresis -60\r\nKPX V Agrave -60\r\nKPX V Amacron -60\r\nKPX V Aogonek -60\r\nKPX V Aring -60\r\nKPX V Atilde -60\r\nKPX V O -30\r\nKPX V Oacute -30\r\nKPX V Ocircumflex -30\r\nKPX V Odieresis -30\r\nKPX V Ograve -30\r\nKPX V Ohungarumlaut -30\r\nKPX V Omacron -30\r\nKPX V Oslash -30\r\nKPX V Otilde -30\r\nKPX V a -111\r\nKPX V aacute -111\r\nKPX V abreve -111\r\nKPX V acircumflex -111\r\nKPX V adieresis -111\r\nKPX V agrave -111\r\nKPX V amacron -111\r\nKPX V aogonek -111\r\nKPX V aring -111\r\nKPX V atilde -111\r\nKPX V colon -65\r\nKPX V comma -129\r\nKPX V e -111\r\nKPX V eacute -111\r\nKPX V ecaron -111\r\nKPX V ecircumflex -111\r\nKPX V edieresis -71\r\nKPX V edotaccent -111\r\nKPX V egrave -71\r\nKPX V emacron -71\r\nKPX V eogonek -111\r\nKPX V hyphen -55\r\nKPX V i -74\r\nKPX V iacute -74\r\nKPX V icircumflex -34\r\nKPX V idieresis -34\r\nKPX V igrave -34\r\nKPX V imacron -34\r\nKPX V iogonek -74\r\nKPX V o -111\r\nKPX V oacute -111\r\nKPX V ocircumflex -111\r\nKPX V odieresis -111\r\nKPX V ograve -111\r\nKPX V ohungarumlaut -111\r\nKPX V omacron -111\r\nKPX V oslash -111\r\nKPX V otilde -111\r\nKPX V period -129\r\nKPX V semicolon -74\r\nKPX V u -74\r\nKPX V uacute -74\r\nKPX V ucircumflex -74\r\nKPX V udieresis -74\r\nKPX V ugrave -74\r\nKPX V uhungarumlaut -74\r\nKPX V umacron -74\r\nKPX V uogonek -74\r\nKPX V uring -74\r\nKPX W A -60\r\nKPX W Aacute -60\r\nKPX W Abreve -60\r\nKPX W Acircumflex -60\r\nKPX W Adieresis -60\r\nKPX W Agrave -60\r\nKPX W Amacron -60\r\nKPX W Aogonek -60\r\nKPX W Aring -60\r\nKPX W Atilde -60\r\nKPX W O -25\r\nKPX W Oacute -25\r\nKPX W Ocircumflex -25\r\nKPX W Odieresis -25\r\nKPX W Ograve -25\r\nKPX W Ohungarumlaut -25\r\nKPX W Omacron -25\r\nKPX W Oslash -25\r\nKPX W Otilde -25\r\nKPX W a -92\r\nKPX W aacute -92\r\nKPX W abreve -92\r\nKPX W acircumflex -92\r\nKPX W adieresis -92\r\nKPX W agrave -92\r\nKPX W amacron -92\r\nKPX W aogonek -92\r\nKPX W aring -92\r\nKPX W atilde -92\r\nKPX W colon -65\r\nKPX W comma -92\r\nKPX W e -92\r\nKPX W eacute -92\r\nKPX W ecaron -92\r\nKPX W ecircumflex -92\r\nKPX W edieresis -52\r\nKPX W edotaccent -92\r\nKPX W egrave -52\r\nKPX W emacron -52\r\nKPX W eogonek -92\r\nKPX W hyphen -37\r\nKPX W i -55\r\nKPX W iacute -55\r\nKPX W iogonek -55\r\nKPX W o -92\r\nKPX W oacute -92\r\nKPX W ocircumflex -92\r\nKPX W odieresis -92\r\nKPX W ograve -92\r\nKPX W ohungarumlaut -92\r\nKPX W omacron -92\r\nKPX W oslash -92\r\nKPX W otilde -92\r\nKPX W period -92\r\nKPX W semicolon -65\r\nKPX W u -55\r\nKPX W uacute -55\r\nKPX W ucircumflex -55\r\nKPX W udieresis -55\r\nKPX W ugrave -55\r\nKPX W uhungarumlaut -55\r\nKPX W umacron -55\r\nKPX W uogonek -55\r\nKPX W uring -55\r\nKPX W y -70\r\nKPX W yacute -70\r\nKPX W ydieresis -70\r\nKPX Y A -50\r\nKPX Y Aacute -50\r\nKPX Y Abreve -50\r\nKPX Y Acircumflex -50\r\nKPX Y Adieresis -50\r\nKPX Y Agrave -50\r\nKPX Y Amacron -50\r\nKPX Y Aogonek -50\r\nKPX Y Aring -50\r\nKPX Y Atilde -50\r\nKPX Y O -15\r\nKPX Y Oacute -15\r\nKPX Y Ocircumflex -15\r\nKPX Y Odieresis -15\r\nKPX Y Ograve -15\r\nKPX Y Ohungarumlaut -15\r\nKPX Y Omacron -15\r\nKPX Y Oslash -15\r\nKPX Y Otilde -15\r\nKPX Y a -92\r\nKPX Y aacute -92\r\nKPX Y abreve -92\r\nKPX Y acircumflex -92\r\nKPX Y adieresis -92\r\nKPX Y agrave -92\r\nKPX Y amacron -92\r\nKPX Y aogonek -92\r\nKPX Y aring -92\r\nKPX Y atilde -92\r\nKPX Y colon -65\r\nKPX Y comma -92\r\nKPX Y e -92\r\nKPX Y eacute -92\r\nKPX Y ecaron -92\r\nKPX Y ecircumflex -92\r\nKPX Y edieresis -52\r\nKPX Y edotaccent -92\r\nKPX Y egrave -52\r\nKPX Y emacron -52\r\nKPX Y eogonek -92\r\nKPX Y hyphen -74\r\nKPX Y i -74\r\nKPX Y iacute -74\r\nKPX Y icircumflex -34\r\nKPX Y idieresis -34\r\nKPX Y igrave -34\r\nKPX Y imacron -34\r\nKPX Y iogonek -74\r\nKPX Y o -92\r\nKPX Y oacute -92\r\nKPX Y ocircumflex -92\r\nKPX Y odieresis -92\r\nKPX Y ograve -92\r\nKPX Y ohungarumlaut -92\r\nKPX Y omacron -92\r\nKPX Y oslash -92\r\nKPX Y otilde -92\r\nKPX Y period -92\r\nKPX Y semicolon -65\r\nKPX Y u -92\r\nKPX Y uacute -92\r\nKPX Y ucircumflex -92\r\nKPX Y udieresis -92\r\nKPX Y ugrave -92\r\nKPX Y uhungarumlaut -92\r\nKPX Y umacron -92\r\nKPX Y uogonek -92\r\nKPX Y uring -92\r\nKPX Yacute A -50\r\nKPX Yacute Aacute -50\r\nKPX Yacute Abreve -50\r\nKPX Yacute Acircumflex -50\r\nKPX Yacute Adieresis -50\r\nKPX Yacute Agrave -50\r\nKPX Yacute Amacron -50\r\nKPX Yacute Aogonek -50\r\nKPX Yacute Aring -50\r\nKPX Yacute Atilde -50\r\nKPX Yacute O -15\r\nKPX Yacute Oacute -15\r\nKPX Yacute Ocircumflex -15\r\nKPX Yacute Odieresis -15\r\nKPX Yacute Ograve -15\r\nKPX Yacute Ohungarumlaut -15\r\nKPX Yacute Omacron -15\r\nKPX Yacute Oslash -15\r\nKPX Yacute Otilde -15\r\nKPX Yacute a -92\r\nKPX Yacute aacute -92\r\nKPX Yacute abreve -92\r\nKPX Yacute acircumflex -92\r\nKPX Yacute adieresis -92\r\nKPX Yacute agrave -92\r\nKPX Yacute amacron -92\r\nKPX Yacute aogonek -92\r\nKPX Yacute aring -92\r\nKPX Yacute atilde -92\r\nKPX Yacute colon -65\r\nKPX Yacute comma -92\r\nKPX Yacute e -92\r\nKPX Yacute eacute -92\r\nKPX Yacute ecaron -92\r\nKPX Yacute ecircumflex -92\r\nKPX Yacute edieresis -52\r\nKPX Yacute edotaccent -92\r\nKPX Yacute egrave -52\r\nKPX Yacute emacron -52\r\nKPX Yacute eogonek -92\r\nKPX Yacute hyphen -74\r\nKPX Yacute i -74\r\nKPX Yacute iacute -74\r\nKPX Yacute icircumflex -34\r\nKPX Yacute idieresis -34\r\nKPX Yacute igrave -34\r\nKPX Yacute imacron -34\r\nKPX Yacute iogonek -74\r\nKPX Yacute o -92\r\nKPX Yacute oacute -92\r\nKPX Yacute ocircumflex -92\r\nKPX Yacute odieresis -92\r\nKPX Yacute ograve -92\r\nKPX Yacute ohungarumlaut -92\r\nKPX Yacute omacron -92\r\nKPX Yacute oslash -92\r\nKPX Yacute otilde -92\r\nKPX Yacute period -92\r\nKPX Yacute semicolon -65\r\nKPX Yacute u -92\r\nKPX Yacute uacute -92\r\nKPX Yacute ucircumflex -92\r\nKPX Yacute udieresis -92\r\nKPX Yacute ugrave -92\r\nKPX Yacute uhungarumlaut -92\r\nKPX Yacute umacron -92\r\nKPX Yacute uogonek -92\r\nKPX Yacute uring -92\r\nKPX Ydieresis A -50\r\nKPX Ydieresis Aacute -50\r\nKPX Ydieresis Abreve -50\r\nKPX Ydieresis Acircumflex -50\r\nKPX Ydieresis Adieresis -50\r\nKPX Ydieresis Agrave -50\r\nKPX Ydieresis Amacron -50\r\nKPX Ydieresis Aogonek -50\r\nKPX Ydieresis Aring -50\r\nKPX Ydieresis Atilde -50\r\nKPX Ydieresis O -15\r\nKPX Ydieresis Oacute -15\r\nKPX Ydieresis Ocircumflex -15\r\nKPX Ydieresis Odieresis -15\r\nKPX Ydieresis Ograve -15\r\nKPX Ydieresis Ohungarumlaut -15\r\nKPX Ydieresis Omacron -15\r\nKPX Ydieresis Oslash -15\r\nKPX Ydieresis Otilde -15\r\nKPX Ydieresis a -92\r\nKPX Ydieresis aacute -92\r\nKPX Ydieresis abreve -92\r\nKPX Ydieresis acircumflex -92\r\nKPX Ydieresis adieresis -92\r\nKPX Ydieresis agrave -92\r\nKPX Ydieresis amacron -92\r\nKPX Ydieresis aogonek -92\r\nKPX Ydieresis aring -92\r\nKPX Ydieresis atilde -92\r\nKPX Ydieresis colon -65\r\nKPX Ydieresis comma -92\r\nKPX Ydieresis e -92\r\nKPX Ydieresis eacute -92\r\nKPX Ydieresis ecaron -92\r\nKPX Ydieresis ecircumflex -92\r\nKPX Ydieresis edieresis -52\r\nKPX Ydieresis edotaccent -92\r\nKPX Ydieresis egrave -52\r\nKPX Ydieresis emacron -52\r\nKPX Ydieresis eogonek -92\r\nKPX Ydieresis hyphen -74\r\nKPX Ydieresis i -74\r\nKPX Ydieresis iacute -74\r\nKPX Ydieresis icircumflex -34\r\nKPX Ydieresis idieresis -34\r\nKPX Ydieresis igrave -34\r\nKPX Ydieresis imacron -34\r\nKPX Ydieresis iogonek -74\r\nKPX Ydieresis o -92\r\nKPX Ydieresis oacute -92\r\nKPX Ydieresis ocircumflex -92\r\nKPX Ydieresis odieresis -92\r\nKPX Ydieresis ograve -92\r\nKPX Ydieresis ohungarumlaut -92\r\nKPX Ydieresis omacron -92\r\nKPX Ydieresis oslash -92\r\nKPX Ydieresis otilde -92\r\nKPX Ydieresis period -92\r\nKPX Ydieresis semicolon -65\r\nKPX Ydieresis u -92\r\nKPX Ydieresis uacute -92\r\nKPX Ydieresis ucircumflex -92\r\nKPX Ydieresis udieresis -92\r\nKPX Ydieresis ugrave -92\r\nKPX Ydieresis uhungarumlaut -92\r\nKPX Ydieresis umacron -92\r\nKPX Ydieresis uogonek -92\r\nKPX Ydieresis uring -92\r\nKPX a g -10\r\nKPX a gbreve -10\r\nKPX a gcommaaccent -10\r\nKPX aacute g -10\r\nKPX aacute gbreve -10\r\nKPX aacute gcommaaccent -10\r\nKPX abreve g -10\r\nKPX abreve gbreve -10\r\nKPX abreve gcommaaccent -10\r\nKPX acircumflex g -10\r\nKPX acircumflex gbreve -10\r\nKPX acircumflex gcommaaccent -10\r\nKPX adieresis g -10\r\nKPX adieresis gbreve -10\r\nKPX adieresis gcommaaccent -10\r\nKPX agrave g -10\r\nKPX agrave gbreve -10\r\nKPX agrave gcommaaccent -10\r\nKPX amacron g -10\r\nKPX amacron gbreve -10\r\nKPX amacron gcommaaccent -10\r\nKPX aogonek g -10\r\nKPX aogonek gbreve -10\r\nKPX aogonek gcommaaccent -10\r\nKPX aring g -10\r\nKPX aring gbreve -10\r\nKPX aring gcommaaccent -10\r\nKPX atilde g -10\r\nKPX atilde gbreve -10\r\nKPX atilde gcommaaccent -10\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX c h -15\r\nKPX c k -20\r\nKPX c kcommaaccent -20\r\nKPX cacute h -15\r\nKPX cacute k -20\r\nKPX cacute kcommaaccent -20\r\nKPX ccaron h -15\r\nKPX ccaron k -20\r\nKPX ccaron kcommaaccent -20\r\nKPX ccedilla h -15\r\nKPX ccedilla k -20\r\nKPX ccedilla kcommaaccent -20\r\nKPX comma quotedblright -140\r\nKPX comma quoteright -140\r\nKPX e comma -10\r\nKPX e g -40\r\nKPX e gbreve -40\r\nKPX e gcommaaccent -40\r\nKPX e period -15\r\nKPX e v -15\r\nKPX e w -15\r\nKPX e x -20\r\nKPX e y -30\r\nKPX e yacute -30\r\nKPX e ydieresis -30\r\nKPX eacute comma -10\r\nKPX eacute g -40\r\nKPX eacute gbreve -40\r\nKPX eacute gcommaaccent -40\r\nKPX eacute period -15\r\nKPX eacute v -15\r\nKPX eacute w -15\r\nKPX eacute x -20\r\nKPX eacute y -30\r\nKPX eacute yacute -30\r\nKPX eacute ydieresis -30\r\nKPX ecaron comma -10\r\nKPX ecaron g -40\r\nKPX ecaron gbreve -40\r\nKPX ecaron gcommaaccent -40\r\nKPX ecaron period -15\r\nKPX ecaron v -15\r\nKPX ecaron w -15\r\nKPX ecaron x -20\r\nKPX ecaron y -30\r\nKPX ecaron yacute -30\r\nKPX ecaron ydieresis -30\r\nKPX ecircumflex comma -10\r\nKPX ecircumflex g -40\r\nKPX ecircumflex gbreve -40\r\nKPX ecircumflex gcommaaccent -40\r\nKPX ecircumflex period -15\r\nKPX ecircumflex v -15\r\nKPX ecircumflex w -15\r\nKPX ecircumflex x -20\r\nKPX ecircumflex y -30\r\nKPX ecircumflex yacute -30\r\nKPX ecircumflex ydieresis -30\r\nKPX edieresis comma -10\r\nKPX edieresis g -40\r\nKPX edieresis gbreve -40\r\nKPX edieresis gcommaaccent -40\r\nKPX edieresis period -15\r\nKPX edieresis v -15\r\nKPX edieresis w -15\r\nKPX edieresis x -20\r\nKPX edieresis y -30\r\nKPX edieresis yacute -30\r\nKPX edieresis ydieresis -30\r\nKPX edotaccent comma -10\r\nKPX edotaccent g -40\r\nKPX edotaccent gbreve -40\r\nKPX edotaccent gcommaaccent -40\r\nKPX edotaccent period -15\r\nKPX edotaccent v -15\r\nKPX edotaccent w -15\r\nKPX edotaccent x -20\r\nKPX edotaccent y -30\r\nKPX edotaccent yacute -30\r\nKPX edotaccent ydieresis -30\r\nKPX egrave comma -10\r\nKPX egrave g -40\r\nKPX egrave gbreve -40\r\nKPX egrave gcommaaccent -40\r\nKPX egrave period -15\r\nKPX egrave v -15\r\nKPX egrave w -15\r\nKPX egrave x -20\r\nKPX egrave y -30\r\nKPX egrave yacute -30\r\nKPX egrave ydieresis -30\r\nKPX emacron comma -10\r\nKPX emacron g -40\r\nKPX emacron gbreve -40\r\nKPX emacron gcommaaccent -40\r\nKPX emacron period -15\r\nKPX emacron v -15\r\nKPX emacron w -15\r\nKPX emacron x -20\r\nKPX emacron y -30\r\nKPX emacron yacute -30\r\nKPX emacron ydieresis -30\r\nKPX eogonek comma -10\r\nKPX eogonek g -40\r\nKPX eogonek gbreve -40\r\nKPX eogonek gcommaaccent -40\r\nKPX eogonek period -15\r\nKPX eogonek v -15\r\nKPX eogonek w -15\r\nKPX eogonek x -20\r\nKPX eogonek y -30\r\nKPX eogonek yacute -30\r\nKPX eogonek ydieresis -30\r\nKPX f comma -10\r\nKPX f dotlessi -60\r\nKPX f f -18\r\nKPX f i -20\r\nKPX f iogonek -20\r\nKPX f period -15\r\nKPX f quoteright 92\r\nKPX g comma -10\r\nKPX g e -10\r\nKPX g eacute -10\r\nKPX g ecaron -10\r\nKPX g ecircumflex -10\r\nKPX g edieresis -10\r\nKPX g edotaccent -10\r\nKPX g egrave -10\r\nKPX g emacron -10\r\nKPX g eogonek -10\r\nKPX g g -10\r\nKPX g gbreve -10\r\nKPX g gcommaaccent -10\r\nKPX g period -15\r\nKPX gbreve comma -10\r\nKPX gbreve e -10\r\nKPX gbreve eacute -10\r\nKPX gbreve ecaron -10\r\nKPX gbreve ecircumflex -10\r\nKPX gbreve edieresis -10\r\nKPX gbreve edotaccent -10\r\nKPX gbreve egrave -10\r\nKPX gbreve emacron -10\r\nKPX gbreve eogonek -10\r\nKPX gbreve g -10\r\nKPX gbreve gbreve -10\r\nKPX gbreve gcommaaccent -10\r\nKPX gbreve period -15\r\nKPX gcommaaccent comma -10\r\nKPX gcommaaccent e -10\r\nKPX gcommaaccent eacute -10\r\nKPX gcommaaccent ecaron -10\r\nKPX gcommaaccent ecircumflex -10\r\nKPX gcommaaccent edieresis -10\r\nKPX gcommaaccent edotaccent -10\r\nKPX gcommaaccent egrave -10\r\nKPX gcommaaccent emacron -10\r\nKPX gcommaaccent eogonek -10\r\nKPX gcommaaccent g -10\r\nKPX gcommaaccent gbreve -10\r\nKPX gcommaaccent gcommaaccent -10\r\nKPX gcommaaccent period -15\r\nKPX k e -10\r\nKPX k eacute -10\r\nKPX k ecaron -10\r\nKPX k ecircumflex -10\r\nKPX k edieresis -10\r\nKPX k edotaccent -10\r\nKPX k egrave -10\r\nKPX k emacron -10\r\nKPX k eogonek -10\r\nKPX k o -10\r\nKPX k oacute -10\r\nKPX k ocircumflex -10\r\nKPX k odieresis -10\r\nKPX k ograve -10\r\nKPX k ohungarumlaut -10\r\nKPX k omacron -10\r\nKPX k oslash -10\r\nKPX k otilde -10\r\nKPX k y -10\r\nKPX k yacute -10\r\nKPX k ydieresis -10\r\nKPX kcommaaccent e -10\r\nKPX kcommaaccent eacute -10\r\nKPX kcommaaccent ecaron -10\r\nKPX kcommaaccent ecircumflex -10\r\nKPX kcommaaccent edieresis -10\r\nKPX kcommaaccent edotaccent -10\r\nKPX kcommaaccent egrave -10\r\nKPX kcommaaccent emacron -10\r\nKPX kcommaaccent eogonek -10\r\nKPX kcommaaccent o -10\r\nKPX kcommaaccent oacute -10\r\nKPX kcommaaccent ocircumflex -10\r\nKPX kcommaaccent odieresis -10\r\nKPX kcommaaccent ograve -10\r\nKPX kcommaaccent ohungarumlaut -10\r\nKPX kcommaaccent omacron -10\r\nKPX kcommaaccent oslash -10\r\nKPX kcommaaccent otilde -10\r\nKPX kcommaaccent y -10\r\nKPX kcommaaccent yacute -10\r\nKPX kcommaaccent ydieresis -10\r\nKPX n v -40\r\nKPX nacute v -40\r\nKPX ncaron v -40\r\nKPX ncommaaccent v -40\r\nKPX ntilde v -40\r\nKPX o g -10\r\nKPX o gbreve -10\r\nKPX o gcommaaccent -10\r\nKPX o v -10\r\nKPX oacute g -10\r\nKPX oacute gbreve -10\r\nKPX oacute gcommaaccent -10\r\nKPX oacute v -10\r\nKPX ocircumflex g -10\r\nKPX ocircumflex gbreve -10\r\nKPX ocircumflex gcommaaccent -10\r\nKPX ocircumflex v -10\r\nKPX odieresis g -10\r\nKPX odieresis gbreve -10\r\nKPX odieresis gcommaaccent -10\r\nKPX odieresis v -10\r\nKPX ograve g -10\r\nKPX ograve gbreve -10\r\nKPX ograve gcommaaccent -10\r\nKPX ograve v -10\r\nKPX ohungarumlaut g -10\r\nKPX ohungarumlaut gbreve -10\r\nKPX ohungarumlaut gcommaaccent -10\r\nKPX ohungarumlaut v -10\r\nKPX omacron g -10\r\nKPX omacron gbreve -10\r\nKPX omacron gcommaaccent -10\r\nKPX omacron v -10\r\nKPX oslash g -10\r\nKPX oslash gbreve -10\r\nKPX oslash gcommaaccent -10\r\nKPX oslash v -10\r\nKPX otilde g -10\r\nKPX otilde gbreve -10\r\nKPX otilde gcommaaccent -10\r\nKPX otilde v -10\r\nKPX period quotedblright -140\r\nKPX period quoteright -140\r\nKPX quoteleft quoteleft -111\r\nKPX quoteright d -25\r\nKPX quoteright dcroat -25\r\nKPX quoteright quoteright -111\r\nKPX quoteright r -25\r\nKPX quoteright racute -25\r\nKPX quoteright rcaron -25\r\nKPX quoteright rcommaaccent -25\r\nKPX quoteright s -40\r\nKPX quoteright sacute -40\r\nKPX quoteright scaron -40\r\nKPX quoteright scedilla -40\r\nKPX quoteright scommaaccent -40\r\nKPX quoteright space -111\r\nKPX quoteright t -30\r\nKPX quoteright tcommaaccent -30\r\nKPX quoteright v -10\r\nKPX r a -15\r\nKPX r aacute -15\r\nKPX r abreve -15\r\nKPX r acircumflex -15\r\nKPX r adieresis -15\r\nKPX r agrave -15\r\nKPX r amacron -15\r\nKPX r aogonek -15\r\nKPX r aring -15\r\nKPX r atilde -15\r\nKPX r c -37\r\nKPX r cacute -37\r\nKPX r ccaron -37\r\nKPX r ccedilla -37\r\nKPX r comma -111\r\nKPX r d -37\r\nKPX r dcroat -37\r\nKPX r e -37\r\nKPX r eacute -37\r\nKPX r ecaron -37\r\nKPX r ecircumflex -37\r\nKPX r edieresis -37\r\nKPX r edotaccent -37\r\nKPX r egrave -37\r\nKPX r emacron -37\r\nKPX r eogonek -37\r\nKPX r g -37\r\nKPX r gbreve -37\r\nKPX r gcommaaccent -37\r\nKPX r hyphen -20\r\nKPX r o -45\r\nKPX r oacute -45\r\nKPX r ocircumflex -45\r\nKPX r odieresis -45\r\nKPX r ograve -45\r\nKPX r ohungarumlaut -45\r\nKPX r omacron -45\r\nKPX r oslash -45\r\nKPX r otilde -45\r\nKPX r period -111\r\nKPX r q -37\r\nKPX r s -10\r\nKPX r sacute -10\r\nKPX r scaron -10\r\nKPX r scedilla -10\r\nKPX r scommaaccent -10\r\nKPX racute a -15\r\nKPX racute aacute -15\r\nKPX racute abreve -15\r\nKPX racute acircumflex -15\r\nKPX racute adieresis -15\r\nKPX racute agrave -15\r\nKPX racute amacron -15\r\nKPX racute aogonek -15\r\nKPX racute aring -15\r\nKPX racute atilde -15\r\nKPX racute c -37\r\nKPX racute cacute -37\r\nKPX racute ccaron -37\r\nKPX racute ccedilla -37\r\nKPX racute comma -111\r\nKPX racute d -37\r\nKPX racute dcroat -37\r\nKPX racute e -37\r\nKPX racute eacute -37\r\nKPX racute ecaron -37\r\nKPX racute ecircumflex -37\r\nKPX racute edieresis -37\r\nKPX racute edotaccent -37\r\nKPX racute egrave -37\r\nKPX racute emacron -37\r\nKPX racute eogonek -37\r\nKPX racute g -37\r\nKPX racute gbreve -37\r\nKPX racute gcommaaccent -37\r\nKPX racute hyphen -20\r\nKPX racute o -45\r\nKPX racute oacute -45\r\nKPX racute ocircumflex -45\r\nKPX racute odieresis -45\r\nKPX racute ograve -45\r\nKPX racute ohungarumlaut -45\r\nKPX racute omacron -45\r\nKPX racute oslash -45\r\nKPX racute otilde -45\r\nKPX racute period -111\r\nKPX racute q -37\r\nKPX racute s -10\r\nKPX racute sacute -10\r\nKPX racute scaron -10\r\nKPX racute scedilla -10\r\nKPX racute scommaaccent -10\r\nKPX rcaron a -15\r\nKPX rcaron aacute -15\r\nKPX rcaron abreve -15\r\nKPX rcaron acircumflex -15\r\nKPX rcaron adieresis -15\r\nKPX rcaron agrave -15\r\nKPX rcaron amacron -15\r\nKPX rcaron aogonek -15\r\nKPX rcaron aring -15\r\nKPX rcaron atilde -15\r\nKPX rcaron c -37\r\nKPX rcaron cacute -37\r\nKPX rcaron ccaron -37\r\nKPX rcaron ccedilla -37\r\nKPX rcaron comma -111\r\nKPX rcaron d -37\r\nKPX rcaron dcroat -37\r\nKPX rcaron e -37\r\nKPX rcaron eacute -37\r\nKPX rcaron ecaron -37\r\nKPX rcaron ecircumflex -37\r\nKPX rcaron edieresis -37\r\nKPX rcaron edotaccent -37\r\nKPX rcaron egrave -37\r\nKPX rcaron emacron -37\r\nKPX rcaron eogonek -37\r\nKPX rcaron g -37\r\nKPX rcaron gbreve -37\r\nKPX rcaron gcommaaccent -37\r\nKPX rcaron hyphen -20\r\nKPX rcaron o -45\r\nKPX rcaron oacute -45\r\nKPX rcaron ocircumflex -45\r\nKPX rcaron odieresis -45\r\nKPX rcaron ograve -45\r\nKPX rcaron ohungarumlaut -45\r\nKPX rcaron omacron -45\r\nKPX rcaron oslash -45\r\nKPX rcaron otilde -45\r\nKPX rcaron period -111\r\nKPX rcaron q -37\r\nKPX rcaron s -10\r\nKPX rcaron sacute -10\r\nKPX rcaron scaron -10\r\nKPX rcaron scedilla -10\r\nKPX rcaron scommaaccent -10\r\nKPX rcommaaccent a -15\r\nKPX rcommaaccent aacute -15\r\nKPX rcommaaccent abreve -15\r\nKPX rcommaaccent acircumflex -15\r\nKPX rcommaaccent adieresis -15\r\nKPX rcommaaccent agrave -15\r\nKPX rcommaaccent amacron -15\r\nKPX rcommaaccent aogonek -15\r\nKPX rcommaaccent aring -15\r\nKPX rcommaaccent atilde -15\r\nKPX rcommaaccent c -37\r\nKPX rcommaaccent cacute -37\r\nKPX rcommaaccent ccaron -37\r\nKPX rcommaaccent ccedilla -37\r\nKPX rcommaaccent comma -111\r\nKPX rcommaaccent d -37\r\nKPX rcommaaccent dcroat -37\r\nKPX rcommaaccent e -37\r\nKPX rcommaaccent eacute -37\r\nKPX rcommaaccent ecaron -37\r\nKPX rcommaaccent ecircumflex -37\r\nKPX rcommaaccent edieresis -37\r\nKPX rcommaaccent edotaccent -37\r\nKPX rcommaaccent egrave -37\r\nKPX rcommaaccent emacron -37\r\nKPX rcommaaccent eogonek -37\r\nKPX rcommaaccent g -37\r\nKPX rcommaaccent gbreve -37\r\nKPX rcommaaccent gcommaaccent -37\r\nKPX rcommaaccent hyphen -20\r\nKPX rcommaaccent o -45\r\nKPX rcommaaccent oacute -45\r\nKPX rcommaaccent ocircumflex -45\r\nKPX rcommaaccent odieresis -45\r\nKPX rcommaaccent ograve -45\r\nKPX rcommaaccent ohungarumlaut -45\r\nKPX rcommaaccent omacron -45\r\nKPX rcommaaccent oslash -45\r\nKPX rcommaaccent otilde -45\r\nKPX rcommaaccent period -111\r\nKPX rcommaaccent q -37\r\nKPX rcommaaccent s -10\r\nKPX rcommaaccent sacute -10\r\nKPX rcommaaccent scaron -10\r\nKPX rcommaaccent scedilla -10\r\nKPX rcommaaccent scommaaccent -10\r\nKPX space A -18\r\nKPX space Aacute -18\r\nKPX space Abreve -18\r\nKPX space Acircumflex -18\r\nKPX space Adieresis -18\r\nKPX space Agrave -18\r\nKPX space Amacron -18\r\nKPX space Aogonek -18\r\nKPX space Aring -18\r\nKPX space Atilde -18\r\nKPX space T -18\r\nKPX space Tcaron -18\r\nKPX space Tcommaaccent -18\r\nKPX space V -35\r\nKPX space W -40\r\nKPX space Y -75\r\nKPX space Yacute -75\r\nKPX space Ydieresis -75\r\nKPX v comma -74\r\nKPX v period -74\r\nKPX w comma -74\r\nKPX w period -74\r\nKPX y comma -55\r\nKPX y period -55\r\nKPX yacute comma -55\r\nKPX yacute period -55\r\nKPX ydieresis comma -55\r\nKPX ydieresis period -55\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  "Times-BoldItalic"() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.\r\nComment Creation Date: Thu May  1 13:04:06 1997\r\nComment UniqueID 43066\r\nComment VMusage 45874 56899\r\nFontName Times-BoldItalic\r\nFullName Times Bold Italic\r\nFamilyName Times\r\nWeight Bold\r\nItalicAngle -15\r\nIsFixedPitch false\r\nCharacterSet ExtendedRoman\r\nFontBBox -200 -218 996 921 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.\r\nEncodingScheme AdobeStandardEncoding\r\nCapHeight 669\r\nXHeight 462\r\nAscender 683\r\nDescender -217\r\nStdHW 42\r\nStdVW 121\r\nStartCharMetrics 315\r\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 389 ; N exclam ; B 67 -13 370 684 ;\r\nC 34 ; WX 555 ; N quotedbl ; B 136 398 536 685 ;\r\nC 35 ; WX 500 ; N numbersign ; B -33 0 533 700 ;\r\nC 36 ; WX 500 ; N dollar ; B -20 -100 497 733 ;\r\nC 37 ; WX 833 ; N percent ; B 39 -10 793 692 ;\r\nC 38 ; WX 778 ; N ampersand ; B 5 -19 699 682 ;\r\nC 39 ; WX 333 ; N quoteright ; B 98 369 302 685 ;\r\nC 40 ; WX 333 ; N parenleft ; B 28 -179 344 685 ;\r\nC 41 ; WX 333 ; N parenright ; B -44 -179 271 685 ;\r\nC 42 ; WX 500 ; N asterisk ; B 65 249 456 685 ;\r\nC 43 ; WX 570 ; N plus ; B 33 0 537 506 ;\r\nC 44 ; WX 250 ; N comma ; B -60 -182 144 134 ;\r\nC 45 ; WX 333 ; N hyphen ; B 2 166 271 282 ;\r\nC 46 ; WX 250 ; N period ; B -9 -13 139 135 ;\r\nC 47 ; WX 278 ; N slash ; B -64 -18 342 685 ;\r\nC 48 ; WX 500 ; N zero ; B 17 -14 477 683 ;\r\nC 49 ; WX 500 ; N one ; B 5 0 419 683 ;\r\nC 50 ; WX 500 ; N two ; B -27 0 446 683 ;\r\nC 51 ; WX 500 ; N three ; B -15 -13 450 683 ;\r\nC 52 ; WX 500 ; N four ; B -15 0 503 683 ;\r\nC 53 ; WX 500 ; N five ; B -11 -13 487 669 ;\r\nC 54 ; WX 500 ; N six ; B 23 -15 509 679 ;\r\nC 55 ; WX 500 ; N seven ; B 52 0 525 669 ;\r\nC 56 ; WX 500 ; N eight ; B 3 -13 476 683 ;\r\nC 57 ; WX 500 ; N nine ; B -12 -10 475 683 ;\r\nC 58 ; WX 333 ; N colon ; B 23 -13 264 459 ;\r\nC 59 ; WX 333 ; N semicolon ; B -25 -183 264 459 ;\r\nC 60 ; WX 570 ; N less ; B 31 -8 539 514 ;\r\nC 61 ; WX 570 ; N equal ; B 33 107 537 399 ;\r\nC 62 ; WX 570 ; N greater ; B 31 -8 539 514 ;\r\nC 63 ; WX 500 ; N question ; B 79 -13 470 684 ;\r\nC 64 ; WX 832 ; N at ; B 63 -18 770 685 ;\r\nC 65 ; WX 667 ; N A ; B -67 0 593 683 ;\r\nC 66 ; WX 667 ; N B ; B -24 0 624 669 ;\r\nC 67 ; WX 667 ; N C ; B 32 -18 677 685 ;\r\nC 68 ; WX 722 ; N D ; B -46 0 685 669 ;\r\nC 69 ; WX 667 ; N E ; B -27 0 653 669 ;\r\nC 70 ; WX 667 ; N F ; B -13 0 660 669 ;\r\nC 71 ; WX 722 ; N G ; B 21 -18 706 685 ;\r\nC 72 ; WX 778 ; N H ; B -24 0 799 669 ;\r\nC 73 ; WX 389 ; N I ; B -32 0 406 669 ;\r\nC 74 ; WX 500 ; N J ; B -46 -99 524 669 ;\r\nC 75 ; WX 667 ; N K ; B -21 0 702 669 ;\r\nC 76 ; WX 611 ; N L ; B -22 0 590 669 ;\r\nC 77 ; WX 889 ; N M ; B -29 -12 917 669 ;\r\nC 78 ; WX 722 ; N N ; B -27 -15 748 669 ;\r\nC 79 ; WX 722 ; N O ; B 27 -18 691 685 ;\r\nC 80 ; WX 611 ; N P ; B -27 0 613 669 ;\r\nC 81 ; WX 722 ; N Q ; B 27 -208 691 685 ;\r\nC 82 ; WX 667 ; N R ; B -29 0 623 669 ;\r\nC 83 ; WX 556 ; N S ; B 2 -18 526 685 ;\r\nC 84 ; WX 611 ; N T ; B 50 0 650 669 ;\r\nC 85 ; WX 722 ; N U ; B 67 -18 744 669 ;\r\nC 86 ; WX 667 ; N V ; B 65 -18 715 669 ;\r\nC 87 ; WX 889 ; N W ; B 65 -18 940 669 ;\r\nC 88 ; WX 667 ; N X ; B -24 0 694 669 ;\r\nC 89 ; WX 611 ; N Y ; B 73 0 659 669 ;\r\nC 90 ; WX 611 ; N Z ; B -11 0 590 669 ;\r\nC 91 ; WX 333 ; N bracketleft ; B -37 -159 362 674 ;\r\nC 92 ; WX 278 ; N backslash ; B -1 -18 279 685 ;\r\nC 93 ; WX 333 ; N bracketright ; B -56 -157 343 674 ;\r\nC 94 ; WX 570 ; N asciicircum ; B 67 304 503 669 ;\r\nC 95 ; WX 500 ; N underscore ; B 0 -125 500 -75 ;\r\nC 96 ; WX 333 ; N quoteleft ; B 128 369 332 685 ;\r\nC 97 ; WX 500 ; N a ; B -21 -14 455 462 ;\r\nC 98 ; WX 500 ; N b ; B -14 -13 444 699 ;\r\nC 99 ; WX 444 ; N c ; B -5 -13 392 462 ;\r\nC 100 ; WX 500 ; N d ; B -21 -13 517 699 ;\r\nC 101 ; WX 444 ; N e ; B 5 -13 398 462 ;\r\nC 102 ; WX 333 ; N f ; B -169 -205 446 698 ; L i fi ; L l fl ;\r\nC 103 ; WX 500 ; N g ; B -52 -203 478 462 ;\r\nC 104 ; WX 556 ; N h ; B -13 -9 498 699 ;\r\nC 105 ; WX 278 ; N i ; B 2 -9 263 684 ;\r\nC 106 ; WX 278 ; N j ; B -189 -207 279 684 ;\r\nC 107 ; WX 500 ; N k ; B -23 -8 483 699 ;\r\nC 108 ; WX 278 ; N l ; B 2 -9 290 699 ;\r\nC 109 ; WX 778 ; N m ; B -14 -9 722 462 ;\r\nC 110 ; WX 556 ; N n ; B -6 -9 493 462 ;\r\nC 111 ; WX 500 ; N o ; B -3 -13 441 462 ;\r\nC 112 ; WX 500 ; N p ; B -120 -205 446 462 ;\r\nC 113 ; WX 500 ; N q ; B 1 -205 471 462 ;\r\nC 114 ; WX 389 ; N r ; B -21 0 389 462 ;\r\nC 115 ; WX 389 ; N s ; B -19 -13 333 462 ;\r\nC 116 ; WX 278 ; N t ; B -11 -9 281 594 ;\r\nC 117 ; WX 556 ; N u ; B 15 -9 492 462 ;\r\nC 118 ; WX 444 ; N v ; B 16 -13 401 462 ;\r\nC 119 ; WX 667 ; N w ; B 16 -13 614 462 ;\r\nC 120 ; WX 500 ; N x ; B -46 -13 469 462 ;\r\nC 121 ; WX 444 ; N y ; B -94 -205 392 462 ;\r\nC 122 ; WX 389 ; N z ; B -43 -78 368 449 ;\r\nC 123 ; WX 348 ; N braceleft ; B 5 -187 436 686 ;\r\nC 124 ; WX 220 ; N bar ; B 66 -218 154 782 ;\r\nC 125 ; WX 348 ; N braceright ; B -129 -187 302 686 ;\r\nC 126 ; WX 570 ; N asciitilde ; B 54 173 516 333 ;\r\nC 161 ; WX 389 ; N exclamdown ; B 19 -205 322 492 ;\r\nC 162 ; WX 500 ; N cent ; B 42 -143 439 576 ;\r\nC 163 ; WX 500 ; N sterling ; B -32 -12 510 683 ;\r\nC 164 ; WX 167 ; N fraction ; B -169 -14 324 683 ;\r\nC 165 ; WX 500 ; N yen ; B 33 0 628 669 ;\r\nC 166 ; WX 500 ; N florin ; B -87 -156 537 707 ;\r\nC 167 ; WX 500 ; N section ; B 36 -143 459 685 ;\r\nC 168 ; WX 500 ; N currency ; B -26 34 526 586 ;\r\nC 169 ; WX 278 ; N quotesingle ; B 128 398 268 685 ;\r\nC 170 ; WX 500 ; N quotedblleft ; B 53 369 513 685 ;\r\nC 171 ; WX 500 ; N guillemotleft ; B 12 32 468 415 ;\r\nC 172 ; WX 333 ; N guilsinglleft ; B 32 32 303 415 ;\r\nC 173 ; WX 333 ; N guilsinglright ; B 10 32 281 415 ;\r\nC 174 ; WX 556 ; N fi ; B -188 -205 514 703 ;\r\nC 175 ; WX 556 ; N fl ; B -186 -205 553 704 ;\r\nC 177 ; WX 500 ; N endash ; B -40 178 477 269 ;\r\nC 178 ; WX 500 ; N dagger ; B 91 -145 494 685 ;\r\nC 179 ; WX 500 ; N daggerdbl ; B 10 -139 493 685 ;\r\nC 180 ; WX 250 ; N periodcentered ; B 51 257 199 405 ;\r\nC 182 ; WX 500 ; N paragraph ; B -57 -193 562 669 ;\r\nC 183 ; WX 350 ; N bullet ; B 0 175 350 525 ;\r\nC 184 ; WX 333 ; N quotesinglbase ; B -5 -182 199 134 ;\r\nC 185 ; WX 500 ; N quotedblbase ; B -57 -182 403 134 ;\r\nC 186 ; WX 500 ; N quotedblright ; B 53 369 513 685 ;\r\nC 187 ; WX 500 ; N guillemotright ; B 12 32 468 415 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 40 -13 852 135 ;\r\nC 189 ; WX 1000 ; N perthousand ; B 7 -29 996 706 ;\r\nC 191 ; WX 500 ; N questiondown ; B 30 -205 421 492 ;\r\nC 193 ; WX 333 ; N grave ; B 85 516 297 697 ;\r\nC 194 ; WX 333 ; N acute ; B 139 516 379 697 ;\r\nC 195 ; WX 333 ; N circumflex ; B 40 516 367 690 ;\r\nC 196 ; WX 333 ; N tilde ; B 48 536 407 655 ;\r\nC 197 ; WX 333 ; N macron ; B 51 553 393 623 ;\r\nC 198 ; WX 333 ; N breve ; B 71 516 387 678 ;\r\nC 199 ; WX 333 ; N dotaccent ; B 163 550 298 684 ;\r\nC 200 ; WX 333 ; N dieresis ; B 55 550 402 684 ;\r\nC 202 ; WX 333 ; N ring ; B 127 516 340 729 ;\r\nC 203 ; WX 333 ; N cedilla ; B -80 -218 156 5 ;\r\nC 205 ; WX 333 ; N hungarumlaut ; B 69 516 498 697 ;\r\nC 206 ; WX 333 ; N ogonek ; B 15 -183 244 34 ;\r\nC 207 ; WX 333 ; N caron ; B 79 516 411 690 ;\r\nC 208 ; WX 1000 ; N emdash ; B -40 178 977 269 ;\r\nC 225 ; WX 944 ; N AE ; B -64 0 918 669 ;\r\nC 227 ; WX 266 ; N ordfeminine ; B 16 399 330 685 ;\r\nC 232 ; WX 611 ; N Lslash ; B -22 0 590 669 ;\r\nC 233 ; WX 722 ; N Oslash ; B 27 -125 691 764 ;\r\nC 234 ; WX 944 ; N OE ; B 23 -8 946 677 ;\r\nC 235 ; WX 300 ; N ordmasculine ; B 56 400 347 685 ;\r\nC 241 ; WX 722 ; N ae ; B -5 -13 673 462 ;\r\nC 245 ; WX 278 ; N dotlessi ; B 2 -9 238 462 ;\r\nC 248 ; WX 278 ; N lslash ; B -7 -9 307 699 ;\r\nC 249 ; WX 500 ; N oslash ; B -3 -119 441 560 ;\r\nC 250 ; WX 722 ; N oe ; B 6 -13 674 462 ;\r\nC 251 ; WX 500 ; N germandbls ; B -200 -200 473 705 ;\r\nC -1 ; WX 389 ; N Idieresis ; B -32 0 450 862 ;\r\nC -1 ; WX 444 ; N eacute ; B 5 -13 435 697 ;\r\nC -1 ; WX 500 ; N abreve ; B -21 -14 471 678 ;\r\nC -1 ; WX 556 ; N uhungarumlaut ; B 15 -9 610 697 ;\r\nC -1 ; WX 444 ; N ecaron ; B 5 -13 467 690 ;\r\nC -1 ; WX 611 ; N Ydieresis ; B 73 0 659 862 ;\r\nC -1 ; WX 570 ; N divide ; B 33 -29 537 535 ;\r\nC -1 ; WX 611 ; N Yacute ; B 73 0 659 904 ;\r\nC -1 ; WX 667 ; N Acircumflex ; B -67 0 593 897 ;\r\nC -1 ; WX 500 ; N aacute ; B -21 -14 463 697 ;\r\nC -1 ; WX 722 ; N Ucircumflex ; B 67 -18 744 897 ;\r\nC -1 ; WX 444 ; N yacute ; B -94 -205 435 697 ;\r\nC -1 ; WX 389 ; N scommaaccent ; B -19 -218 333 462 ;\r\nC -1 ; WX 444 ; N ecircumflex ; B 5 -13 423 690 ;\r\nC -1 ; WX 722 ; N Uring ; B 67 -18 744 921 ;\r\nC -1 ; WX 722 ; N Udieresis ; B 67 -18 744 862 ;\r\nC -1 ; WX 500 ; N aogonek ; B -21 -183 455 462 ;\r\nC -1 ; WX 722 ; N Uacute ; B 67 -18 744 904 ;\r\nC -1 ; WX 556 ; N uogonek ; B 15 -183 492 462 ;\r\nC -1 ; WX 667 ; N Edieresis ; B -27 0 653 862 ;\r\nC -1 ; WX 722 ; N Dcroat ; B -31 0 700 669 ;\r\nC -1 ; WX 250 ; N commaaccent ; B -36 -218 131 -50 ;\r\nC -1 ; WX 747 ; N copyright ; B 30 -18 718 685 ;\r\nC -1 ; WX 667 ; N Emacron ; B -27 0 653 830 ;\r\nC -1 ; WX 444 ; N ccaron ; B -5 -13 467 690 ;\r\nC -1 ; WX 500 ; N aring ; B -21 -14 455 729 ;\r\nC -1 ; WX 722 ; N Ncommaaccent ; B -27 -218 748 669 ;\r\nC -1 ; WX 278 ; N lacute ; B 2 -9 392 904 ;\r\nC -1 ; WX 500 ; N agrave ; B -21 -14 455 697 ;\r\nC -1 ; WX 611 ; N Tcommaaccent ; B 50 -218 650 669 ;\r\nC -1 ; WX 667 ; N Cacute ; B 32 -18 677 904 ;\r\nC -1 ; WX 500 ; N atilde ; B -21 -14 491 655 ;\r\nC -1 ; WX 667 ; N Edotaccent ; B -27 0 653 862 ;\r\nC -1 ; WX 389 ; N scaron ; B -19 -13 424 690 ;\r\nC -1 ; WX 389 ; N scedilla ; B -19 -218 333 462 ;\r\nC -1 ; WX 278 ; N iacute ; B 2 -9 352 697 ;\r\nC -1 ; WX 494 ; N lozenge ; B 10 0 484 745 ;\r\nC -1 ; WX 667 ; N Rcaron ; B -29 0 623 897 ;\r\nC -1 ; WX 722 ; N Gcommaaccent ; B 21 -218 706 685 ;\r\nC -1 ; WX 556 ; N ucircumflex ; B 15 -9 492 690 ;\r\nC -1 ; WX 500 ; N acircumflex ; B -21 -14 455 690 ;\r\nC -1 ; WX 667 ; N Amacron ; B -67 0 593 830 ;\r\nC -1 ; WX 389 ; N rcaron ; B -21 0 424 690 ;\r\nC -1 ; WX 444 ; N ccedilla ; B -5 -218 392 462 ;\r\nC -1 ; WX 611 ; N Zdotaccent ; B -11 0 590 862 ;\r\nC -1 ; WX 611 ; N Thorn ; B -27 0 573 669 ;\r\nC -1 ; WX 722 ; N Omacron ; B 27 -18 691 830 ;\r\nC -1 ; WX 667 ; N Racute ; B -29 0 623 904 ;\r\nC -1 ; WX 556 ; N Sacute ; B 2 -18 531 904 ;\r\nC -1 ; WX 608 ; N dcaron ; B -21 -13 675 708 ;\r\nC -1 ; WX 722 ; N Umacron ; B 67 -18 744 830 ;\r\nC -1 ; WX 556 ; N uring ; B 15 -9 492 729 ;\r\nC -1 ; WX 300 ; N threesuperior ; B 17 265 321 683 ;\r\nC -1 ; WX 722 ; N Ograve ; B 27 -18 691 904 ;\r\nC -1 ; WX 667 ; N Agrave ; B -67 0 593 904 ;\r\nC -1 ; WX 667 ; N Abreve ; B -67 0 593 885 ;\r\nC -1 ; WX 570 ; N multiply ; B 48 16 522 490 ;\r\nC -1 ; WX 556 ; N uacute ; B 15 -9 492 697 ;\r\nC -1 ; WX 611 ; N Tcaron ; B 50 0 650 897 ;\r\nC -1 ; WX 494 ; N partialdiff ; B 11 -21 494 750 ;\r\nC -1 ; WX 444 ; N ydieresis ; B -94 -205 443 655 ;\r\nC -1 ; WX 722 ; N Nacute ; B -27 -15 748 904 ;\r\nC -1 ; WX 278 ; N icircumflex ; B -3 -9 324 690 ;\r\nC -1 ; WX 667 ; N Ecircumflex ; B -27 0 653 897 ;\r\nC -1 ; WX 500 ; N adieresis ; B -21 -14 476 655 ;\r\nC -1 ; WX 444 ; N edieresis ; B 5 -13 448 655 ;\r\nC -1 ; WX 444 ; N cacute ; B -5 -13 435 697 ;\r\nC -1 ; WX 556 ; N nacute ; B -6 -9 493 697 ;\r\nC -1 ; WX 556 ; N umacron ; B 15 -9 492 623 ;\r\nC -1 ; WX 722 ; N Ncaron ; B -27 -15 748 897 ;\r\nC -1 ; WX 389 ; N Iacute ; B -32 0 432 904 ;\r\nC -1 ; WX 570 ; N plusminus ; B 33 0 537 506 ;\r\nC -1 ; WX 220 ; N brokenbar ; B 66 -143 154 707 ;\r\nC -1 ; WX 747 ; N registered ; B 30 -18 718 685 ;\r\nC -1 ; WX 722 ; N Gbreve ; B 21 -18 706 885 ;\r\nC -1 ; WX 389 ; N Idotaccent ; B -32 0 406 862 ;\r\nC -1 ; WX 600 ; N summation ; B 14 -10 585 706 ;\r\nC -1 ; WX 667 ; N Egrave ; B -27 0 653 904 ;\r\nC -1 ; WX 389 ; N racute ; B -21 0 407 697 ;\r\nC -1 ; WX 500 ; N omacron ; B -3 -13 462 623 ;\r\nC -1 ; WX 611 ; N Zacute ; B -11 0 590 904 ;\r\nC -1 ; WX 611 ; N Zcaron ; B -11 0 590 897 ;\r\nC -1 ; WX 549 ; N greaterequal ; B 26 0 523 704 ;\r\nC -1 ; WX 722 ; N Eth ; B -31 0 700 669 ;\r\nC -1 ; WX 667 ; N Ccedilla ; B 32 -218 677 685 ;\r\nC -1 ; WX 278 ; N lcommaaccent ; B -42 -218 290 699 ;\r\nC -1 ; WX 366 ; N tcaron ; B -11 -9 434 754 ;\r\nC -1 ; WX 444 ; N eogonek ; B 5 -183 398 462 ;\r\nC -1 ; WX 722 ; N Uogonek ; B 67 -183 744 669 ;\r\nC -1 ; WX 667 ; N Aacute ; B -67 0 593 904 ;\r\nC -1 ; WX 667 ; N Adieresis ; B -67 0 593 862 ;\r\nC -1 ; WX 444 ; N egrave ; B 5 -13 398 697 ;\r\nC -1 ; WX 389 ; N zacute ; B -43 -78 407 697 ;\r\nC -1 ; WX 278 ; N iogonek ; B -20 -183 263 684 ;\r\nC -1 ; WX 722 ; N Oacute ; B 27 -18 691 904 ;\r\nC -1 ; WX 500 ; N oacute ; B -3 -13 463 697 ;\r\nC -1 ; WX 500 ; N amacron ; B -21 -14 467 623 ;\r\nC -1 ; WX 389 ; N sacute ; B -19 -13 407 697 ;\r\nC -1 ; WX 278 ; N idieresis ; B 2 -9 364 655 ;\r\nC -1 ; WX 722 ; N Ocircumflex ; B 27 -18 691 897 ;\r\nC -1 ; WX 722 ; N Ugrave ; B 67 -18 744 904 ;\r\nC -1 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC -1 ; WX 500 ; N thorn ; B -120 -205 446 699 ;\r\nC -1 ; WX 300 ; N twosuperior ; B 2 274 313 683 ;\r\nC -1 ; WX 722 ; N Odieresis ; B 27 -18 691 862 ;\r\nC -1 ; WX 576 ; N mu ; B -60 -207 516 449 ;\r\nC -1 ; WX 278 ; N igrave ; B 2 -9 259 697 ;\r\nC -1 ; WX 500 ; N ohungarumlaut ; B -3 -13 582 697 ;\r\nC -1 ; WX 667 ; N Eogonek ; B -27 -183 653 669 ;\r\nC -1 ; WX 500 ; N dcroat ; B -21 -13 552 699 ;\r\nC -1 ; WX 750 ; N threequarters ; B 7 -14 726 683 ;\r\nC -1 ; WX 556 ; N Scedilla ; B 2 -218 526 685 ;\r\nC -1 ; WX 382 ; N lcaron ; B 2 -9 448 708 ;\r\nC -1 ; WX 667 ; N Kcommaaccent ; B -21 -218 702 669 ;\r\nC -1 ; WX 611 ; N Lacute ; B -22 0 590 904 ;\r\nC -1 ; WX 1000 ; N trademark ; B 32 263 968 669 ;\r\nC -1 ; WX 444 ; N edotaccent ; B 5 -13 398 655 ;\r\nC -1 ; WX 389 ; N Igrave ; B -32 0 406 904 ;\r\nC -1 ; WX 389 ; N Imacron ; B -32 0 461 830 ;\r\nC -1 ; WX 611 ; N Lcaron ; B -22 0 671 718 ;\r\nC -1 ; WX 750 ; N onehalf ; B -9 -14 723 683 ;\r\nC -1 ; WX 549 ; N lessequal ; B 29 0 526 704 ;\r\nC -1 ; WX 500 ; N ocircumflex ; B -3 -13 451 690 ;\r\nC -1 ; WX 556 ; N ntilde ; B -6 -9 504 655 ;\r\nC -1 ; WX 722 ; N Uhungarumlaut ; B 67 -18 744 904 ;\r\nC -1 ; WX 667 ; N Eacute ; B -27 0 653 904 ;\r\nC -1 ; WX 444 ; N emacron ; B 5 -13 439 623 ;\r\nC -1 ; WX 500 ; N gbreve ; B -52 -203 478 678 ;\r\nC -1 ; WX 750 ; N onequarter ; B 7 -14 721 683 ;\r\nC -1 ; WX 556 ; N Scaron ; B 2 -18 553 897 ;\r\nC -1 ; WX 556 ; N Scommaaccent ; B 2 -218 526 685 ;\r\nC -1 ; WX 722 ; N Ohungarumlaut ; B 27 -18 723 904 ;\r\nC -1 ; WX 400 ; N degree ; B 83 397 369 683 ;\r\nC -1 ; WX 500 ; N ograve ; B -3 -13 441 697 ;\r\nC -1 ; WX 667 ; N Ccaron ; B 32 -18 677 897 ;\r\nC -1 ; WX 556 ; N ugrave ; B 15 -9 492 697 ;\r\nC -1 ; WX 549 ; N radical ; B 10 -46 512 850 ;\r\nC -1 ; WX 722 ; N Dcaron ; B -46 0 685 897 ;\r\nC -1 ; WX 389 ; N rcommaaccent ; B -67 -218 389 462 ;\r\nC -1 ; WX 722 ; N Ntilde ; B -27 -15 748 862 ;\r\nC -1 ; WX 500 ; N otilde ; B -3 -13 491 655 ;\r\nC -1 ; WX 667 ; N Rcommaaccent ; B -29 -218 623 669 ;\r\nC -1 ; WX 611 ; N Lcommaaccent ; B -22 -218 590 669 ;\r\nC -1 ; WX 667 ; N Atilde ; B -67 0 593 862 ;\r\nC -1 ; WX 667 ; N Aogonek ; B -67 -183 604 683 ;\r\nC -1 ; WX 667 ; N Aring ; B -67 0 593 921 ;\r\nC -1 ; WX 722 ; N Otilde ; B 27 -18 691 862 ;\r\nC -1 ; WX 389 ; N zdotaccent ; B -43 -78 368 655 ;\r\nC -1 ; WX 667 ; N Ecaron ; B -27 0 653 897 ;\r\nC -1 ; WX 389 ; N Iogonek ; B -32 -183 406 669 ;\r\nC -1 ; WX 500 ; N kcommaaccent ; B -23 -218 483 699 ;\r\nC -1 ; WX 606 ; N minus ; B 51 209 555 297 ;\r\nC -1 ; WX 389 ; N Icircumflex ; B -32 0 450 897 ;\r\nC -1 ; WX 556 ; N ncaron ; B -6 -9 523 690 ;\r\nC -1 ; WX 278 ; N tcommaaccent ; B -62 -218 281 594 ;\r\nC -1 ; WX 606 ; N logicalnot ; B 51 108 555 399 ;\r\nC -1 ; WX 500 ; N odieresis ; B -3 -13 471 655 ;\r\nC -1 ; WX 556 ; N udieresis ; B 15 -9 499 655 ;\r\nC -1 ; WX 549 ; N notequal ; B 15 -49 540 570 ;\r\nC -1 ; WX 500 ; N gcommaaccent ; B -52 -203 478 767 ;\r\nC -1 ; WX 500 ; N eth ; B -3 -13 454 699 ;\r\nC -1 ; WX 389 ; N zcaron ; B -43 -78 424 690 ;\r\nC -1 ; WX 556 ; N ncommaaccent ; B -6 -218 493 462 ;\r\nC -1 ; WX 300 ; N onesuperior ; B 30 274 301 683 ;\r\nC -1 ; WX 278 ; N imacron ; B 2 -9 294 623 ;\r\nC -1 ; WX 500 ; N Euro ; B 0 0 0 0 ;\r\nEndCharMetrics\r\nStartKernData\r\nStartKernPairs 2038\r\nKPX A C -65\r\nKPX A Cacute -65\r\nKPX A Ccaron -65\r\nKPX A Ccedilla -65\r\nKPX A G -60\r\nKPX A Gbreve -60\r\nKPX A Gcommaaccent -60\r\nKPX A O -50\r\nKPX A Oacute -50\r\nKPX A Ocircumflex -50\r\nKPX A Odieresis -50\r\nKPX A Ograve -50\r\nKPX A Ohungarumlaut -50\r\nKPX A Omacron -50\r\nKPX A Oslash -50\r\nKPX A Otilde -50\r\nKPX A Q -55\r\nKPX A T -55\r\nKPX A Tcaron -55\r\nKPX A Tcommaaccent -55\r\nKPX A U -50\r\nKPX A Uacute -50\r\nKPX A Ucircumflex -50\r\nKPX A Udieresis -50\r\nKPX A Ugrave -50\r\nKPX A Uhungarumlaut -50\r\nKPX A Umacron -50\r\nKPX A Uogonek -50\r\nKPX A Uring -50\r\nKPX A V -95\r\nKPX A W -100\r\nKPX A Y -70\r\nKPX A Yacute -70\r\nKPX A Ydieresis -70\r\nKPX A quoteright -74\r\nKPX A u -30\r\nKPX A uacute -30\r\nKPX A ucircumflex -30\r\nKPX A udieresis -30\r\nKPX A ugrave -30\r\nKPX A uhungarumlaut -30\r\nKPX A umacron -30\r\nKPX A uogonek -30\r\nKPX A uring -30\r\nKPX A v -74\r\nKPX A w -74\r\nKPX A y -74\r\nKPX A yacute -74\r\nKPX A ydieresis -74\r\nKPX Aacute C -65\r\nKPX Aacute Cacute -65\r\nKPX Aacute Ccaron -65\r\nKPX Aacute Ccedilla -65\r\nKPX Aacute G -60\r\nKPX Aacute Gbreve -60\r\nKPX Aacute Gcommaaccent -60\r\nKPX Aacute O -50\r\nKPX Aacute Oacute -50\r\nKPX Aacute Ocircumflex -50\r\nKPX Aacute Odieresis -50\r\nKPX Aacute Ograve -50\r\nKPX Aacute Ohungarumlaut -50\r\nKPX Aacute Omacron -50\r\nKPX Aacute Oslash -50\r\nKPX Aacute Otilde -50\r\nKPX Aacute Q -55\r\nKPX Aacute T -55\r\nKPX Aacute Tcaron -55\r\nKPX Aacute Tcommaaccent -55\r\nKPX Aacute U -50\r\nKPX Aacute Uacute -50\r\nKPX Aacute Ucircumflex -50\r\nKPX Aacute Udieresis -50\r\nKPX Aacute Ugrave -50\r\nKPX Aacute Uhungarumlaut -50\r\nKPX Aacute Umacron -50\r\nKPX Aacute Uogonek -50\r\nKPX Aacute Uring -50\r\nKPX Aacute V -95\r\nKPX Aacute W -100\r\nKPX Aacute Y -70\r\nKPX Aacute Yacute -70\r\nKPX Aacute Ydieresis -70\r\nKPX Aacute quoteright -74\r\nKPX Aacute u -30\r\nKPX Aacute uacute -30\r\nKPX Aacute ucircumflex -30\r\nKPX Aacute udieresis -30\r\nKPX Aacute ugrave -30\r\nKPX Aacute uhungarumlaut -30\r\nKPX Aacute umacron -30\r\nKPX Aacute uogonek -30\r\nKPX Aacute uring -30\r\nKPX Aacute v -74\r\nKPX Aacute w -74\r\nKPX Aacute y -74\r\nKPX Aacute yacute -74\r\nKPX Aacute ydieresis -74\r\nKPX Abreve C -65\r\nKPX Abreve Cacute -65\r\nKPX Abreve Ccaron -65\r\nKPX Abreve Ccedilla -65\r\nKPX Abreve G -60\r\nKPX Abreve Gbreve -60\r\nKPX Abreve Gcommaaccent -60\r\nKPX Abreve O -50\r\nKPX Abreve Oacute -50\r\nKPX Abreve Ocircumflex -50\r\nKPX Abreve Odieresis -50\r\nKPX Abreve Ograve -50\r\nKPX Abreve Ohungarumlaut -50\r\nKPX Abreve Omacron -50\r\nKPX Abreve Oslash -50\r\nKPX Abreve Otilde -50\r\nKPX Abreve Q -55\r\nKPX Abreve T -55\r\nKPX Abreve Tcaron -55\r\nKPX Abreve Tcommaaccent -55\r\nKPX Abreve U -50\r\nKPX Abreve Uacute -50\r\nKPX Abreve Ucircumflex -50\r\nKPX Abreve Udieresis -50\r\nKPX Abreve Ugrave -50\r\nKPX Abreve Uhungarumlaut -50\r\nKPX Abreve Umacron -50\r\nKPX Abreve Uogonek -50\r\nKPX Abreve Uring -50\r\nKPX Abreve V -95\r\nKPX Abreve W -100\r\nKPX Abreve Y -70\r\nKPX Abreve Yacute -70\r\nKPX Abreve Ydieresis -70\r\nKPX Abreve quoteright -74\r\nKPX Abreve u -30\r\nKPX Abreve uacute -30\r\nKPX Abreve ucircumflex -30\r\nKPX Abreve udieresis -30\r\nKPX Abreve ugrave -30\r\nKPX Abreve uhungarumlaut -30\r\nKPX Abreve umacron -30\r\nKPX Abreve uogonek -30\r\nKPX Abreve uring -30\r\nKPX Abreve v -74\r\nKPX Abreve w -74\r\nKPX Abreve y -74\r\nKPX Abreve yacute -74\r\nKPX Abreve ydieresis -74\r\nKPX Acircumflex C -65\r\nKPX Acircumflex Cacute -65\r\nKPX Acircumflex Ccaron -65\r\nKPX Acircumflex Ccedilla -65\r\nKPX Acircumflex G -60\r\nKPX Acircumflex Gbreve -60\r\nKPX Acircumflex Gcommaaccent -60\r\nKPX Acircumflex O -50\r\nKPX Acircumflex Oacute -50\r\nKPX Acircumflex Ocircumflex -50\r\nKPX Acircumflex Odieresis -50\r\nKPX Acircumflex Ograve -50\r\nKPX Acircumflex Ohungarumlaut -50\r\nKPX Acircumflex Omacron -50\r\nKPX Acircumflex Oslash -50\r\nKPX Acircumflex Otilde -50\r\nKPX Acircumflex Q -55\r\nKPX Acircumflex T -55\r\nKPX Acircumflex Tcaron -55\r\nKPX Acircumflex Tcommaaccent -55\r\nKPX Acircumflex U -50\r\nKPX Acircumflex Uacute -50\r\nKPX Acircumflex Ucircumflex -50\r\nKPX Acircumflex Udieresis -50\r\nKPX Acircumflex Ugrave -50\r\nKPX Acircumflex Uhungarumlaut -50\r\nKPX Acircumflex Umacron -50\r\nKPX Acircumflex Uogonek -50\r\nKPX Acircumflex Uring -50\r\nKPX Acircumflex V -95\r\nKPX Acircumflex W -100\r\nKPX Acircumflex Y -70\r\nKPX Acircumflex Yacute -70\r\nKPX Acircumflex Ydieresis -70\r\nKPX Acircumflex quoteright -74\r\nKPX Acircumflex u -30\r\nKPX Acircumflex uacute -30\r\nKPX Acircumflex ucircumflex -30\r\nKPX Acircumflex udieresis -30\r\nKPX Acircumflex ugrave -30\r\nKPX Acircumflex uhungarumlaut -30\r\nKPX Acircumflex umacron -30\r\nKPX Acircumflex uogonek -30\r\nKPX Acircumflex uring -30\r\nKPX Acircumflex v -74\r\nKPX Acircumflex w -74\r\nKPX Acircumflex y -74\r\nKPX Acircumflex yacute -74\r\nKPX Acircumflex ydieresis -74\r\nKPX Adieresis C -65\r\nKPX Adieresis Cacute -65\r\nKPX Adieresis Ccaron -65\r\nKPX Adieresis Ccedilla -65\r\nKPX Adieresis G -60\r\nKPX Adieresis Gbreve -60\r\nKPX Adieresis Gcommaaccent -60\r\nKPX Adieresis O -50\r\nKPX Adieresis Oacute -50\r\nKPX Adieresis Ocircumflex -50\r\nKPX Adieresis Odieresis -50\r\nKPX Adieresis Ograve -50\r\nKPX Adieresis Ohungarumlaut -50\r\nKPX Adieresis Omacron -50\r\nKPX Adieresis Oslash -50\r\nKPX Adieresis Otilde -50\r\nKPX Adieresis Q -55\r\nKPX Adieresis T -55\r\nKPX Adieresis Tcaron -55\r\nKPX Adieresis Tcommaaccent -55\r\nKPX Adieresis U -50\r\nKPX Adieresis Uacute -50\r\nKPX Adieresis Ucircumflex -50\r\nKPX Adieresis Udieresis -50\r\nKPX Adieresis Ugrave -50\r\nKPX Adieresis Uhungarumlaut -50\r\nKPX Adieresis Umacron -50\r\nKPX Adieresis Uogonek -50\r\nKPX Adieresis Uring -50\r\nKPX Adieresis V -95\r\nKPX Adieresis W -100\r\nKPX Adieresis Y -70\r\nKPX Adieresis Yacute -70\r\nKPX Adieresis Ydieresis -70\r\nKPX Adieresis quoteright -74\r\nKPX Adieresis u -30\r\nKPX Adieresis uacute -30\r\nKPX Adieresis ucircumflex -30\r\nKPX Adieresis udieresis -30\r\nKPX Adieresis ugrave -30\r\nKPX Adieresis uhungarumlaut -30\r\nKPX Adieresis umacron -30\r\nKPX Adieresis uogonek -30\r\nKPX Adieresis uring -30\r\nKPX Adieresis v -74\r\nKPX Adieresis w -74\r\nKPX Adieresis y -74\r\nKPX Adieresis yacute -74\r\nKPX Adieresis ydieresis -74\r\nKPX Agrave C -65\r\nKPX Agrave Cacute -65\r\nKPX Agrave Ccaron -65\r\nKPX Agrave Ccedilla -65\r\nKPX Agrave G -60\r\nKPX Agrave Gbreve -60\r\nKPX Agrave Gcommaaccent -60\r\nKPX Agrave O -50\r\nKPX Agrave Oacute -50\r\nKPX Agrave Ocircumflex -50\r\nKPX Agrave Odieresis -50\r\nKPX Agrave Ograve -50\r\nKPX Agrave Ohungarumlaut -50\r\nKPX Agrave Omacron -50\r\nKPX Agrave Oslash -50\r\nKPX Agrave Otilde -50\r\nKPX Agrave Q -55\r\nKPX Agrave T -55\r\nKPX Agrave Tcaron -55\r\nKPX Agrave Tcommaaccent -55\r\nKPX Agrave U -50\r\nKPX Agrave Uacute -50\r\nKPX Agrave Ucircumflex -50\r\nKPX Agrave Udieresis -50\r\nKPX Agrave Ugrave -50\r\nKPX Agrave Uhungarumlaut -50\r\nKPX Agrave Umacron -50\r\nKPX Agrave Uogonek -50\r\nKPX Agrave Uring -50\r\nKPX Agrave V -95\r\nKPX Agrave W -100\r\nKPX Agrave Y -70\r\nKPX Agrave Yacute -70\r\nKPX Agrave Ydieresis -70\r\nKPX Agrave quoteright -74\r\nKPX Agrave u -30\r\nKPX Agrave uacute -30\r\nKPX Agrave ucircumflex -30\r\nKPX Agrave udieresis -30\r\nKPX Agrave ugrave -30\r\nKPX Agrave uhungarumlaut -30\r\nKPX Agrave umacron -30\r\nKPX Agrave uogonek -30\r\nKPX Agrave uring -30\r\nKPX Agrave v -74\r\nKPX Agrave w -74\r\nKPX Agrave y -74\r\nKPX Agrave yacute -74\r\nKPX Agrave ydieresis -74\r\nKPX Amacron C -65\r\nKPX Amacron Cacute -65\r\nKPX Amacron Ccaron -65\r\nKPX Amacron Ccedilla -65\r\nKPX Amacron G -60\r\nKPX Amacron Gbreve -60\r\nKPX Amacron Gcommaaccent -60\r\nKPX Amacron O -50\r\nKPX Amacron Oacute -50\r\nKPX Amacron Ocircumflex -50\r\nKPX Amacron Odieresis -50\r\nKPX Amacron Ograve -50\r\nKPX Amacron Ohungarumlaut -50\r\nKPX Amacron Omacron -50\r\nKPX Amacron Oslash -50\r\nKPX Amacron Otilde -50\r\nKPX Amacron Q -55\r\nKPX Amacron T -55\r\nKPX Amacron Tcaron -55\r\nKPX Amacron Tcommaaccent -55\r\nKPX Amacron U -50\r\nKPX Amacron Uacute -50\r\nKPX Amacron Ucircumflex -50\r\nKPX Amacron Udieresis -50\r\nKPX Amacron Ugrave -50\r\nKPX Amacron Uhungarumlaut -50\r\nKPX Amacron Umacron -50\r\nKPX Amacron Uogonek -50\r\nKPX Amacron Uring -50\r\nKPX Amacron V -95\r\nKPX Amacron W -100\r\nKPX Amacron Y -70\r\nKPX Amacron Yacute -70\r\nKPX Amacron Ydieresis -70\r\nKPX Amacron quoteright -74\r\nKPX Amacron u -30\r\nKPX Amacron uacute -30\r\nKPX Amacron ucircumflex -30\r\nKPX Amacron udieresis -30\r\nKPX Amacron ugrave -30\r\nKPX Amacron uhungarumlaut -30\r\nKPX Amacron umacron -30\r\nKPX Amacron uogonek -30\r\nKPX Amacron uring -30\r\nKPX Amacron v -74\r\nKPX Amacron w -74\r\nKPX Amacron y -74\r\nKPX Amacron yacute -74\r\nKPX Amacron ydieresis -74\r\nKPX Aogonek C -65\r\nKPX Aogonek Cacute -65\r\nKPX Aogonek Ccaron -65\r\nKPX Aogonek Ccedilla -65\r\nKPX Aogonek G -60\r\nKPX Aogonek Gbreve -60\r\nKPX Aogonek Gcommaaccent -60\r\nKPX Aogonek O -50\r\nKPX Aogonek Oacute -50\r\nKPX Aogonek Ocircumflex -50\r\nKPX Aogonek Odieresis -50\r\nKPX Aogonek Ograve -50\r\nKPX Aogonek Ohungarumlaut -50\r\nKPX Aogonek Omacron -50\r\nKPX Aogonek Oslash -50\r\nKPX Aogonek Otilde -50\r\nKPX Aogonek Q -55\r\nKPX Aogonek T -55\r\nKPX Aogonek Tcaron -55\r\nKPX Aogonek Tcommaaccent -55\r\nKPX Aogonek U -50\r\nKPX Aogonek Uacute -50\r\nKPX Aogonek Ucircumflex -50\r\nKPX Aogonek Udieresis -50\r\nKPX Aogonek Ugrave -50\r\nKPX Aogonek Uhungarumlaut -50\r\nKPX Aogonek Umacron -50\r\nKPX Aogonek Uogonek -50\r\nKPX Aogonek Uring -50\r\nKPX Aogonek V -95\r\nKPX Aogonek W -100\r\nKPX Aogonek Y -70\r\nKPX Aogonek Yacute -70\r\nKPX Aogonek Ydieresis -70\r\nKPX Aogonek quoteright -74\r\nKPX Aogonek u -30\r\nKPX Aogonek uacute -30\r\nKPX Aogonek ucircumflex -30\r\nKPX Aogonek udieresis -30\r\nKPX Aogonek ugrave -30\r\nKPX Aogonek uhungarumlaut -30\r\nKPX Aogonek umacron -30\r\nKPX Aogonek uogonek -30\r\nKPX Aogonek uring -30\r\nKPX Aogonek v -74\r\nKPX Aogonek w -74\r\nKPX Aogonek y -34\r\nKPX Aogonek yacute -34\r\nKPX Aogonek ydieresis -34\r\nKPX Aring C -65\r\nKPX Aring Cacute -65\r\nKPX Aring Ccaron -65\r\nKPX Aring Ccedilla -65\r\nKPX Aring G -60\r\nKPX Aring Gbreve -60\r\nKPX Aring Gcommaaccent -60\r\nKPX Aring O -50\r\nKPX Aring Oacute -50\r\nKPX Aring Ocircumflex -50\r\nKPX Aring Odieresis -50\r\nKPX Aring Ograve -50\r\nKPX Aring Ohungarumlaut -50\r\nKPX Aring Omacron -50\r\nKPX Aring Oslash -50\r\nKPX Aring Otilde -50\r\nKPX Aring Q -55\r\nKPX Aring T -55\r\nKPX Aring Tcaron -55\r\nKPX Aring Tcommaaccent -55\r\nKPX Aring U -50\r\nKPX Aring Uacute -50\r\nKPX Aring Ucircumflex -50\r\nKPX Aring Udieresis -50\r\nKPX Aring Ugrave -50\r\nKPX Aring Uhungarumlaut -50\r\nKPX Aring Umacron -50\r\nKPX Aring Uogonek -50\r\nKPX Aring Uring -50\r\nKPX Aring V -95\r\nKPX Aring W -100\r\nKPX Aring Y -70\r\nKPX Aring Yacute -70\r\nKPX Aring Ydieresis -70\r\nKPX Aring quoteright -74\r\nKPX Aring u -30\r\nKPX Aring uacute -30\r\nKPX Aring ucircumflex -30\r\nKPX Aring udieresis -30\r\nKPX Aring ugrave -30\r\nKPX Aring uhungarumlaut -30\r\nKPX Aring umacron -30\r\nKPX Aring uogonek -30\r\nKPX Aring uring -30\r\nKPX Aring v -74\r\nKPX Aring w -74\r\nKPX Aring y -74\r\nKPX Aring yacute -74\r\nKPX Aring ydieresis -74\r\nKPX Atilde C -65\r\nKPX Atilde Cacute -65\r\nKPX Atilde Ccaron -65\r\nKPX Atilde Ccedilla -65\r\nKPX Atilde G -60\r\nKPX Atilde Gbreve -60\r\nKPX Atilde Gcommaaccent -60\r\nKPX Atilde O -50\r\nKPX Atilde Oacute -50\r\nKPX Atilde Ocircumflex -50\r\nKPX Atilde Odieresis -50\r\nKPX Atilde Ograve -50\r\nKPX Atilde Ohungarumlaut -50\r\nKPX Atilde Omacron -50\r\nKPX Atilde Oslash -50\r\nKPX Atilde Otilde -50\r\nKPX Atilde Q -55\r\nKPX Atilde T -55\r\nKPX Atilde Tcaron -55\r\nKPX Atilde Tcommaaccent -55\r\nKPX Atilde U -50\r\nKPX Atilde Uacute -50\r\nKPX Atilde Ucircumflex -50\r\nKPX Atilde Udieresis -50\r\nKPX Atilde Ugrave -50\r\nKPX Atilde Uhungarumlaut -50\r\nKPX Atilde Umacron -50\r\nKPX Atilde Uogonek -50\r\nKPX Atilde Uring -50\r\nKPX Atilde V -95\r\nKPX Atilde W -100\r\nKPX Atilde Y -70\r\nKPX Atilde Yacute -70\r\nKPX Atilde Ydieresis -70\r\nKPX Atilde quoteright -74\r\nKPX Atilde u -30\r\nKPX Atilde uacute -30\r\nKPX Atilde ucircumflex -30\r\nKPX Atilde udieresis -30\r\nKPX Atilde ugrave -30\r\nKPX Atilde uhungarumlaut -30\r\nKPX Atilde umacron -30\r\nKPX Atilde uogonek -30\r\nKPX Atilde uring -30\r\nKPX Atilde v -74\r\nKPX Atilde w -74\r\nKPX Atilde y -74\r\nKPX Atilde yacute -74\r\nKPX Atilde ydieresis -74\r\nKPX B A -25\r\nKPX B Aacute -25\r\nKPX B Abreve -25\r\nKPX B Acircumflex -25\r\nKPX B Adieresis -25\r\nKPX B Agrave -25\r\nKPX B Amacron -25\r\nKPX B Aogonek -25\r\nKPX B Aring -25\r\nKPX B Atilde -25\r\nKPX B U -10\r\nKPX B Uacute -10\r\nKPX B Ucircumflex -10\r\nKPX B Udieresis -10\r\nKPX B Ugrave -10\r\nKPX B Uhungarumlaut -10\r\nKPX B Umacron -10\r\nKPX B Uogonek -10\r\nKPX B Uring -10\r\nKPX D A -25\r\nKPX D Aacute -25\r\nKPX D Abreve -25\r\nKPX D Acircumflex -25\r\nKPX D Adieresis -25\r\nKPX D Agrave -25\r\nKPX D Amacron -25\r\nKPX D Aogonek -25\r\nKPX D Aring -25\r\nKPX D Atilde -25\r\nKPX D V -50\r\nKPX D W -40\r\nKPX D Y -50\r\nKPX D Yacute -50\r\nKPX D Ydieresis -50\r\nKPX Dcaron A -25\r\nKPX Dcaron Aacute -25\r\nKPX Dcaron Abreve -25\r\nKPX Dcaron Acircumflex -25\r\nKPX Dcaron Adieresis -25\r\nKPX Dcaron Agrave -25\r\nKPX Dcaron Amacron -25\r\nKPX Dcaron Aogonek -25\r\nKPX Dcaron Aring -25\r\nKPX Dcaron Atilde -25\r\nKPX Dcaron V -50\r\nKPX Dcaron W -40\r\nKPX Dcaron Y -50\r\nKPX Dcaron Yacute -50\r\nKPX Dcaron Ydieresis -50\r\nKPX Dcroat A -25\r\nKPX Dcroat Aacute -25\r\nKPX Dcroat Abreve -25\r\nKPX Dcroat Acircumflex -25\r\nKPX Dcroat Adieresis -25\r\nKPX Dcroat Agrave -25\r\nKPX Dcroat Amacron -25\r\nKPX Dcroat Aogonek -25\r\nKPX Dcroat Aring -25\r\nKPX Dcroat Atilde -25\r\nKPX Dcroat V -50\r\nKPX Dcroat W -40\r\nKPX Dcroat Y -50\r\nKPX Dcroat Yacute -50\r\nKPX Dcroat Ydieresis -50\r\nKPX F A -100\r\nKPX F Aacute -100\r\nKPX F Abreve -100\r\nKPX F Acircumflex -100\r\nKPX F Adieresis -100\r\nKPX F Agrave -100\r\nKPX F Amacron -100\r\nKPX F Aogonek -100\r\nKPX F Aring -100\r\nKPX F Atilde -100\r\nKPX F a -95\r\nKPX F aacute -95\r\nKPX F abreve -95\r\nKPX F acircumflex -95\r\nKPX F adieresis -95\r\nKPX F agrave -95\r\nKPX F amacron -95\r\nKPX F aogonek -95\r\nKPX F aring -95\r\nKPX F atilde -95\r\nKPX F comma -129\r\nKPX F e -100\r\nKPX F eacute -100\r\nKPX F ecaron -100\r\nKPX F ecircumflex -100\r\nKPX F edieresis -100\r\nKPX F edotaccent -100\r\nKPX F egrave -100\r\nKPX F emacron -100\r\nKPX F eogonek -100\r\nKPX F i -40\r\nKPX F iacute -40\r\nKPX F icircumflex -40\r\nKPX F idieresis -40\r\nKPX F igrave -40\r\nKPX F imacron -40\r\nKPX F iogonek -40\r\nKPX F o -70\r\nKPX F oacute -70\r\nKPX F ocircumflex -70\r\nKPX F odieresis -70\r\nKPX F ograve -70\r\nKPX F ohungarumlaut -70\r\nKPX F omacron -70\r\nKPX F oslash -70\r\nKPX F otilde -70\r\nKPX F period -129\r\nKPX F r -50\r\nKPX F racute -50\r\nKPX F rcaron -50\r\nKPX F rcommaaccent -50\r\nKPX J A -25\r\nKPX J Aacute -25\r\nKPX J Abreve -25\r\nKPX J Acircumflex -25\r\nKPX J Adieresis -25\r\nKPX J Agrave -25\r\nKPX J Amacron -25\r\nKPX J Aogonek -25\r\nKPX J Aring -25\r\nKPX J Atilde -25\r\nKPX J a -40\r\nKPX J aacute -40\r\nKPX J abreve -40\r\nKPX J acircumflex -40\r\nKPX J adieresis -40\r\nKPX J agrave -40\r\nKPX J amacron -40\r\nKPX J aogonek -40\r\nKPX J aring -40\r\nKPX J atilde -40\r\nKPX J comma -10\r\nKPX J e -40\r\nKPX J eacute -40\r\nKPX J ecaron -40\r\nKPX J ecircumflex -40\r\nKPX J edieresis -40\r\nKPX J edotaccent -40\r\nKPX J egrave -40\r\nKPX J emacron -40\r\nKPX J eogonek -40\r\nKPX J o -40\r\nKPX J oacute -40\r\nKPX J ocircumflex -40\r\nKPX J odieresis -40\r\nKPX J ograve -40\r\nKPX J ohungarumlaut -40\r\nKPX J omacron -40\r\nKPX J oslash -40\r\nKPX J otilde -40\r\nKPX J period -10\r\nKPX J u -40\r\nKPX J uacute -40\r\nKPX J ucircumflex -40\r\nKPX J udieresis -40\r\nKPX J ugrave -40\r\nKPX J uhungarumlaut -40\r\nKPX J umacron -40\r\nKPX J uogonek -40\r\nKPX J uring -40\r\nKPX K O -30\r\nKPX K Oacute -30\r\nKPX K Ocircumflex -30\r\nKPX K Odieresis -30\r\nKPX K Ograve -30\r\nKPX K Ohungarumlaut -30\r\nKPX K Omacron -30\r\nKPX K Oslash -30\r\nKPX K Otilde -30\r\nKPX K e -25\r\nKPX K eacute -25\r\nKPX K ecaron -25\r\nKPX K ecircumflex -25\r\nKPX K edieresis -25\r\nKPX K edotaccent -25\r\nKPX K egrave -25\r\nKPX K emacron -25\r\nKPX K eogonek -25\r\nKPX K o -25\r\nKPX K oacute -25\r\nKPX K ocircumflex -25\r\nKPX K odieresis -25\r\nKPX K ograve -25\r\nKPX K ohungarumlaut -25\r\nKPX K omacron -25\r\nKPX K oslash -25\r\nKPX K otilde -25\r\nKPX K u -20\r\nKPX K uacute -20\r\nKPX K ucircumflex -20\r\nKPX K udieresis -20\r\nKPX K ugrave -20\r\nKPX K uhungarumlaut -20\r\nKPX K umacron -20\r\nKPX K uogonek -20\r\nKPX K uring -20\r\nKPX K y -20\r\nKPX K yacute -20\r\nKPX K ydieresis -20\r\nKPX Kcommaaccent O -30\r\nKPX Kcommaaccent Oacute -30\r\nKPX Kcommaaccent Ocircumflex -30\r\nKPX Kcommaaccent Odieresis -30\r\nKPX Kcommaaccent Ograve -30\r\nKPX Kcommaaccent Ohungarumlaut -30\r\nKPX Kcommaaccent Omacron -30\r\nKPX Kcommaaccent Oslash -30\r\nKPX Kcommaaccent Otilde -30\r\nKPX Kcommaaccent e -25\r\nKPX Kcommaaccent eacute -25\r\nKPX Kcommaaccent ecaron -25\r\nKPX Kcommaaccent ecircumflex -25\r\nKPX Kcommaaccent edieresis -25\r\nKPX Kcommaaccent edotaccent -25\r\nKPX Kcommaaccent egrave -25\r\nKPX Kcommaaccent emacron -25\r\nKPX Kcommaaccent eogonek -25\r\nKPX Kcommaaccent o -25\r\nKPX Kcommaaccent oacute -25\r\nKPX Kcommaaccent ocircumflex -25\r\nKPX Kcommaaccent odieresis -25\r\nKPX Kcommaaccent ograve -25\r\nKPX Kcommaaccent ohungarumlaut -25\r\nKPX Kcommaaccent omacron -25\r\nKPX Kcommaaccent oslash -25\r\nKPX Kcommaaccent otilde -25\r\nKPX Kcommaaccent u -20\r\nKPX Kcommaaccent uacute -20\r\nKPX Kcommaaccent ucircumflex -20\r\nKPX Kcommaaccent udieresis -20\r\nKPX Kcommaaccent ugrave -20\r\nKPX Kcommaaccent uhungarumlaut -20\r\nKPX Kcommaaccent umacron -20\r\nKPX Kcommaaccent uogonek -20\r\nKPX Kcommaaccent uring -20\r\nKPX Kcommaaccent y -20\r\nKPX Kcommaaccent yacute -20\r\nKPX Kcommaaccent ydieresis -20\r\nKPX L T -18\r\nKPX L Tcaron -18\r\nKPX L Tcommaaccent -18\r\nKPX L V -37\r\nKPX L W -37\r\nKPX L Y -37\r\nKPX L Yacute -37\r\nKPX L Ydieresis -37\r\nKPX L quoteright -55\r\nKPX L y -37\r\nKPX L yacute -37\r\nKPX L ydieresis -37\r\nKPX Lacute T -18\r\nKPX Lacute Tcaron -18\r\nKPX Lacute Tcommaaccent -18\r\nKPX Lacute V -37\r\nKPX Lacute W -37\r\nKPX Lacute Y -37\r\nKPX Lacute Yacute -37\r\nKPX Lacute Ydieresis -37\r\nKPX Lacute quoteright -55\r\nKPX Lacute y -37\r\nKPX Lacute yacute -37\r\nKPX Lacute ydieresis -37\r\nKPX Lcommaaccent T -18\r\nKPX Lcommaaccent Tcaron -18\r\nKPX Lcommaaccent Tcommaaccent -18\r\nKPX Lcommaaccent V -37\r\nKPX Lcommaaccent W -37\r\nKPX Lcommaaccent Y -37\r\nKPX Lcommaaccent Yacute -37\r\nKPX Lcommaaccent Ydieresis -37\r\nKPX Lcommaaccent quoteright -55\r\nKPX Lcommaaccent y -37\r\nKPX Lcommaaccent yacute -37\r\nKPX Lcommaaccent ydieresis -37\r\nKPX Lslash T -18\r\nKPX Lslash Tcaron -18\r\nKPX Lslash Tcommaaccent -18\r\nKPX Lslash V -37\r\nKPX Lslash W -37\r\nKPX Lslash Y -37\r\nKPX Lslash Yacute -37\r\nKPX Lslash Ydieresis -37\r\nKPX Lslash quoteright -55\r\nKPX Lslash y -37\r\nKPX Lslash yacute -37\r\nKPX Lslash ydieresis -37\r\nKPX N A -30\r\nKPX N Aacute -30\r\nKPX N Abreve -30\r\nKPX N Acircumflex -30\r\nKPX N Adieresis -30\r\nKPX N Agrave -30\r\nKPX N Amacron -30\r\nKPX N Aogonek -30\r\nKPX N Aring -30\r\nKPX N Atilde -30\r\nKPX Nacute A -30\r\nKPX Nacute Aacute -30\r\nKPX Nacute Abreve -30\r\nKPX Nacute Acircumflex -30\r\nKPX Nacute Adieresis -30\r\nKPX Nacute Agrave -30\r\nKPX Nacute Amacron -30\r\nKPX Nacute Aogonek -30\r\nKPX Nacute Aring -30\r\nKPX Nacute Atilde -30\r\nKPX Ncaron A -30\r\nKPX Ncaron Aacute -30\r\nKPX Ncaron Abreve -30\r\nKPX Ncaron Acircumflex -30\r\nKPX Ncaron Adieresis -30\r\nKPX Ncaron Agrave -30\r\nKPX Ncaron Amacron -30\r\nKPX Ncaron Aogonek -30\r\nKPX Ncaron Aring -30\r\nKPX Ncaron Atilde -30\r\nKPX Ncommaaccent A -30\r\nKPX Ncommaaccent Aacute -30\r\nKPX Ncommaaccent Abreve -30\r\nKPX Ncommaaccent Acircumflex -30\r\nKPX Ncommaaccent Adieresis -30\r\nKPX Ncommaaccent Agrave -30\r\nKPX Ncommaaccent Amacron -30\r\nKPX Ncommaaccent Aogonek -30\r\nKPX Ncommaaccent Aring -30\r\nKPX Ncommaaccent Atilde -30\r\nKPX Ntilde A -30\r\nKPX Ntilde Aacute -30\r\nKPX Ntilde Abreve -30\r\nKPX Ntilde Acircumflex -30\r\nKPX Ntilde Adieresis -30\r\nKPX Ntilde Agrave -30\r\nKPX Ntilde Amacron -30\r\nKPX Ntilde Aogonek -30\r\nKPX Ntilde Aring -30\r\nKPX Ntilde Atilde -30\r\nKPX O A -40\r\nKPX O Aacute -40\r\nKPX O Abreve -40\r\nKPX O Acircumflex -40\r\nKPX O Adieresis -40\r\nKPX O Agrave -40\r\nKPX O Amacron -40\r\nKPX O Aogonek -40\r\nKPX O Aring -40\r\nKPX O Atilde -40\r\nKPX O T -40\r\nKPX O Tcaron -40\r\nKPX O Tcommaaccent -40\r\nKPX O V -50\r\nKPX O W -50\r\nKPX O X -40\r\nKPX O Y -50\r\nKPX O Yacute -50\r\nKPX O Ydieresis -50\r\nKPX Oacute A -40\r\nKPX Oacute Aacute -40\r\nKPX Oacute Abreve -40\r\nKPX Oacute Acircumflex -40\r\nKPX Oacute Adieresis -40\r\nKPX Oacute Agrave -40\r\nKPX Oacute Amacron -40\r\nKPX Oacute Aogonek -40\r\nKPX Oacute Aring -40\r\nKPX Oacute Atilde -40\r\nKPX Oacute T -40\r\nKPX Oacute Tcaron -40\r\nKPX Oacute Tcommaaccent -40\r\nKPX Oacute V -50\r\nKPX Oacute W -50\r\nKPX Oacute X -40\r\nKPX Oacute Y -50\r\nKPX Oacute Yacute -50\r\nKPX Oacute Ydieresis -50\r\nKPX Ocircumflex A -40\r\nKPX Ocircumflex Aacute -40\r\nKPX Ocircumflex Abreve -40\r\nKPX Ocircumflex Acircumflex -40\r\nKPX Ocircumflex Adieresis -40\r\nKPX Ocircumflex Agrave -40\r\nKPX Ocircumflex Amacron -40\r\nKPX Ocircumflex Aogonek -40\r\nKPX Ocircumflex Aring -40\r\nKPX Ocircumflex Atilde -40\r\nKPX Ocircumflex T -40\r\nKPX Ocircumflex Tcaron -40\r\nKPX Ocircumflex Tcommaaccent -40\r\nKPX Ocircumflex V -50\r\nKPX Ocircumflex W -50\r\nKPX Ocircumflex X -40\r\nKPX Ocircumflex Y -50\r\nKPX Ocircumflex Yacute -50\r\nKPX Ocircumflex Ydieresis -50\r\nKPX Odieresis A -40\r\nKPX Odieresis Aacute -40\r\nKPX Odieresis Abreve -40\r\nKPX Odieresis Acircumflex -40\r\nKPX Odieresis Adieresis -40\r\nKPX Odieresis Agrave -40\r\nKPX Odieresis Amacron -40\r\nKPX Odieresis Aogonek -40\r\nKPX Odieresis Aring -40\r\nKPX Odieresis Atilde -40\r\nKPX Odieresis T -40\r\nKPX Odieresis Tcaron -40\r\nKPX Odieresis Tcommaaccent -40\r\nKPX Odieresis V -50\r\nKPX Odieresis W -50\r\nKPX Odieresis X -40\r\nKPX Odieresis Y -50\r\nKPX Odieresis Yacute -50\r\nKPX Odieresis Ydieresis -50\r\nKPX Ograve A -40\r\nKPX Ograve Aacute -40\r\nKPX Ograve Abreve -40\r\nKPX Ograve Acircumflex -40\r\nKPX Ograve Adieresis -40\r\nKPX Ograve Agrave -40\r\nKPX Ograve Amacron -40\r\nKPX Ograve Aogonek -40\r\nKPX Ograve Aring -40\r\nKPX Ograve Atilde -40\r\nKPX Ograve T -40\r\nKPX Ograve Tcaron -40\r\nKPX Ograve Tcommaaccent -40\r\nKPX Ograve V -50\r\nKPX Ograve W -50\r\nKPX Ograve X -40\r\nKPX Ograve Y -50\r\nKPX Ograve Yacute -50\r\nKPX Ograve Ydieresis -50\r\nKPX Ohungarumlaut A -40\r\nKPX Ohungarumlaut Aacute -40\r\nKPX Ohungarumlaut Abreve -40\r\nKPX Ohungarumlaut Acircumflex -40\r\nKPX Ohungarumlaut Adieresis -40\r\nKPX Ohungarumlaut Agrave -40\r\nKPX Ohungarumlaut Amacron -40\r\nKPX Ohungarumlaut Aogonek -40\r\nKPX Ohungarumlaut Aring -40\r\nKPX Ohungarumlaut Atilde -40\r\nKPX Ohungarumlaut T -40\r\nKPX Ohungarumlaut Tcaron -40\r\nKPX Ohungarumlaut Tcommaaccent -40\r\nKPX Ohungarumlaut V -50\r\nKPX Ohungarumlaut W -50\r\nKPX Ohungarumlaut X -40\r\nKPX Ohungarumlaut Y -50\r\nKPX Ohungarumlaut Yacute -50\r\nKPX Ohungarumlaut Ydieresis -50\r\nKPX Omacron A -40\r\nKPX Omacron Aacute -40\r\nKPX Omacron Abreve -40\r\nKPX Omacron Acircumflex -40\r\nKPX Omacron Adieresis -40\r\nKPX Omacron Agrave -40\r\nKPX Omacron Amacron -40\r\nKPX Omacron Aogonek -40\r\nKPX Omacron Aring -40\r\nKPX Omacron Atilde -40\r\nKPX Omacron T -40\r\nKPX Omacron Tcaron -40\r\nKPX Omacron Tcommaaccent -40\r\nKPX Omacron V -50\r\nKPX Omacron W -50\r\nKPX Omacron X -40\r\nKPX Omacron Y -50\r\nKPX Omacron Yacute -50\r\nKPX Omacron Ydieresis -50\r\nKPX Oslash A -40\r\nKPX Oslash Aacute -40\r\nKPX Oslash Abreve -40\r\nKPX Oslash Acircumflex -40\r\nKPX Oslash Adieresis -40\r\nKPX Oslash Agrave -40\r\nKPX Oslash Amacron -40\r\nKPX Oslash Aogonek -40\r\nKPX Oslash Aring -40\r\nKPX Oslash Atilde -40\r\nKPX Oslash T -40\r\nKPX Oslash Tcaron -40\r\nKPX Oslash Tcommaaccent -40\r\nKPX Oslash V -50\r\nKPX Oslash W -50\r\nKPX Oslash X -40\r\nKPX Oslash Y -50\r\nKPX Oslash Yacute -50\r\nKPX Oslash Ydieresis -50\r\nKPX Otilde A -40\r\nKPX Otilde Aacute -40\r\nKPX Otilde Abreve -40\r\nKPX Otilde Acircumflex -40\r\nKPX Otilde Adieresis -40\r\nKPX Otilde Agrave -40\r\nKPX Otilde Amacron -40\r\nKPX Otilde Aogonek -40\r\nKPX Otilde Aring -40\r\nKPX Otilde Atilde -40\r\nKPX Otilde T -40\r\nKPX Otilde Tcaron -40\r\nKPX Otilde Tcommaaccent -40\r\nKPX Otilde V -50\r\nKPX Otilde W -50\r\nKPX Otilde X -40\r\nKPX Otilde Y -50\r\nKPX Otilde Yacute -50\r\nKPX Otilde Ydieresis -50\r\nKPX P A -85\r\nKPX P Aacute -85\r\nKPX P Abreve -85\r\nKPX P Acircumflex -85\r\nKPX P Adieresis -85\r\nKPX P Agrave -85\r\nKPX P Amacron -85\r\nKPX P Aogonek -85\r\nKPX P Aring -85\r\nKPX P Atilde -85\r\nKPX P a -40\r\nKPX P aacute -40\r\nKPX P abreve -40\r\nKPX P acircumflex -40\r\nKPX P adieresis -40\r\nKPX P agrave -40\r\nKPX P amacron -40\r\nKPX P aogonek -40\r\nKPX P aring -40\r\nKPX P atilde -40\r\nKPX P comma -129\r\nKPX P e -50\r\nKPX P eacute -50\r\nKPX P ecaron -50\r\nKPX P ecircumflex -50\r\nKPX P edieresis -50\r\nKPX P edotaccent -50\r\nKPX P egrave -50\r\nKPX P emacron -50\r\nKPX P eogonek -50\r\nKPX P o -55\r\nKPX P oacute -55\r\nKPX P ocircumflex -55\r\nKPX P odieresis -55\r\nKPX P ograve -55\r\nKPX P ohungarumlaut -55\r\nKPX P omacron -55\r\nKPX P oslash -55\r\nKPX P otilde -55\r\nKPX P period -129\r\nKPX Q U -10\r\nKPX Q Uacute -10\r\nKPX Q Ucircumflex -10\r\nKPX Q Udieresis -10\r\nKPX Q Ugrave -10\r\nKPX Q Uhungarumlaut -10\r\nKPX Q Umacron -10\r\nKPX Q Uogonek -10\r\nKPX Q Uring -10\r\nKPX R O -40\r\nKPX R Oacute -40\r\nKPX R Ocircumflex -40\r\nKPX R Odieresis -40\r\nKPX R Ograve -40\r\nKPX R Ohungarumlaut -40\r\nKPX R Omacron -40\r\nKPX R Oslash -40\r\nKPX R Otilde -40\r\nKPX R T -30\r\nKPX R Tcaron -30\r\nKPX R Tcommaaccent -30\r\nKPX R U -40\r\nKPX R Uacute -40\r\nKPX R Ucircumflex -40\r\nKPX R Udieresis -40\r\nKPX R Ugrave -40\r\nKPX R Uhungarumlaut -40\r\nKPX R Umacron -40\r\nKPX R Uogonek -40\r\nKPX R Uring -40\r\nKPX R V -18\r\nKPX R W -18\r\nKPX R Y -18\r\nKPX R Yacute -18\r\nKPX R Ydieresis -18\r\nKPX Racute O -40\r\nKPX Racute Oacute -40\r\nKPX Racute Ocircumflex -40\r\nKPX Racute Odieresis -40\r\nKPX Racute Ograve -40\r\nKPX Racute Ohungarumlaut -40\r\nKPX Racute Omacron -40\r\nKPX Racute Oslash -40\r\nKPX Racute Otilde -40\r\nKPX Racute T -30\r\nKPX Racute Tcaron -30\r\nKPX Racute Tcommaaccent -30\r\nKPX Racute U -40\r\nKPX Racute Uacute -40\r\nKPX Racute Ucircumflex -40\r\nKPX Racute Udieresis -40\r\nKPX Racute Ugrave -40\r\nKPX Racute Uhungarumlaut -40\r\nKPX Racute Umacron -40\r\nKPX Racute Uogonek -40\r\nKPX Racute Uring -40\r\nKPX Racute V -18\r\nKPX Racute W -18\r\nKPX Racute Y -18\r\nKPX Racute Yacute -18\r\nKPX Racute Ydieresis -18\r\nKPX Rcaron O -40\r\nKPX Rcaron Oacute -40\r\nKPX Rcaron Ocircumflex -40\r\nKPX Rcaron Odieresis -40\r\nKPX Rcaron Ograve -40\r\nKPX Rcaron Ohungarumlaut -40\r\nKPX Rcaron Omacron -40\r\nKPX Rcaron Oslash -40\r\nKPX Rcaron Otilde -40\r\nKPX Rcaron T -30\r\nKPX Rcaron Tcaron -30\r\nKPX Rcaron Tcommaaccent -30\r\nKPX Rcaron U -40\r\nKPX Rcaron Uacute -40\r\nKPX Rcaron Ucircumflex -40\r\nKPX Rcaron Udieresis -40\r\nKPX Rcaron Ugrave -40\r\nKPX Rcaron Uhungarumlaut -40\r\nKPX Rcaron Umacron -40\r\nKPX Rcaron Uogonek -40\r\nKPX Rcaron Uring -40\r\nKPX Rcaron V -18\r\nKPX Rcaron W -18\r\nKPX Rcaron Y -18\r\nKPX Rcaron Yacute -18\r\nKPX Rcaron Ydieresis -18\r\nKPX Rcommaaccent O -40\r\nKPX Rcommaaccent Oacute -40\r\nKPX Rcommaaccent Ocircumflex -40\r\nKPX Rcommaaccent Odieresis -40\r\nKPX Rcommaaccent Ograve -40\r\nKPX Rcommaaccent Ohungarumlaut -40\r\nKPX Rcommaaccent Omacron -40\r\nKPX Rcommaaccent Oslash -40\r\nKPX Rcommaaccent Otilde -40\r\nKPX Rcommaaccent T -30\r\nKPX Rcommaaccent Tcaron -30\r\nKPX Rcommaaccent Tcommaaccent -30\r\nKPX Rcommaaccent U -40\r\nKPX Rcommaaccent Uacute -40\r\nKPX Rcommaaccent Ucircumflex -40\r\nKPX Rcommaaccent Udieresis -40\r\nKPX Rcommaaccent Ugrave -40\r\nKPX Rcommaaccent Uhungarumlaut -40\r\nKPX Rcommaaccent Umacron -40\r\nKPX Rcommaaccent Uogonek -40\r\nKPX Rcommaaccent Uring -40\r\nKPX Rcommaaccent V -18\r\nKPX Rcommaaccent W -18\r\nKPX Rcommaaccent Y -18\r\nKPX Rcommaaccent Yacute -18\r\nKPX Rcommaaccent Ydieresis -18\r\nKPX T A -55\r\nKPX T Aacute -55\r\nKPX T Abreve -55\r\nKPX T Acircumflex -55\r\nKPX T Adieresis -55\r\nKPX T Agrave -55\r\nKPX T Amacron -55\r\nKPX T Aogonek -55\r\nKPX T Aring -55\r\nKPX T Atilde -55\r\nKPX T O -18\r\nKPX T Oacute -18\r\nKPX T Ocircumflex -18\r\nKPX T Odieresis -18\r\nKPX T Ograve -18\r\nKPX T Ohungarumlaut -18\r\nKPX T Omacron -18\r\nKPX T Oslash -18\r\nKPX T Otilde -18\r\nKPX T a -92\r\nKPX T aacute -92\r\nKPX T abreve -92\r\nKPX T acircumflex -92\r\nKPX T adieresis -92\r\nKPX T agrave -92\r\nKPX T amacron -92\r\nKPX T aogonek -92\r\nKPX T aring -92\r\nKPX T atilde -92\r\nKPX T colon -74\r\nKPX T comma -92\r\nKPX T e -92\r\nKPX T eacute -92\r\nKPX T ecaron -92\r\nKPX T ecircumflex -92\r\nKPX T edieresis -52\r\nKPX T edotaccent -92\r\nKPX T egrave -52\r\nKPX T emacron -52\r\nKPX T eogonek -92\r\nKPX T hyphen -92\r\nKPX T i -37\r\nKPX T iacute -37\r\nKPX T iogonek -37\r\nKPX T o -95\r\nKPX T oacute -95\r\nKPX T ocircumflex -95\r\nKPX T odieresis -95\r\nKPX T ograve -95\r\nKPX T ohungarumlaut -95\r\nKPX T omacron -95\r\nKPX T oslash -95\r\nKPX T otilde -95\r\nKPX T period -92\r\nKPX T r -37\r\nKPX T racute -37\r\nKPX T rcaron -37\r\nKPX T rcommaaccent -37\r\nKPX T semicolon -74\r\nKPX T u -37\r\nKPX T uacute -37\r\nKPX T ucircumflex -37\r\nKPX T udieresis -37\r\nKPX T ugrave -37\r\nKPX T uhungarumlaut -37\r\nKPX T umacron -37\r\nKPX T uogonek -37\r\nKPX T uring -37\r\nKPX T w -37\r\nKPX T y -37\r\nKPX T yacute -37\r\nKPX T ydieresis -37\r\nKPX Tcaron A -55\r\nKPX Tcaron Aacute -55\r\nKPX Tcaron Abreve -55\r\nKPX Tcaron Acircumflex -55\r\nKPX Tcaron Adieresis -55\r\nKPX Tcaron Agrave -55\r\nKPX Tcaron Amacron -55\r\nKPX Tcaron Aogonek -55\r\nKPX Tcaron Aring -55\r\nKPX Tcaron Atilde -55\r\nKPX Tcaron O -18\r\nKPX Tcaron Oacute -18\r\nKPX Tcaron Ocircumflex -18\r\nKPX Tcaron Odieresis -18\r\nKPX Tcaron Ograve -18\r\nKPX Tcaron Ohungarumlaut -18\r\nKPX Tcaron Omacron -18\r\nKPX Tcaron Oslash -18\r\nKPX Tcaron Otilde -18\r\nKPX Tcaron a -92\r\nKPX Tcaron aacute -92\r\nKPX Tcaron abreve -92\r\nKPX Tcaron acircumflex -92\r\nKPX Tcaron adieresis -92\r\nKPX Tcaron agrave -92\r\nKPX Tcaron amacron -92\r\nKPX Tcaron aogonek -92\r\nKPX Tcaron aring -92\r\nKPX Tcaron atilde -92\r\nKPX Tcaron colon -74\r\nKPX Tcaron comma -92\r\nKPX Tcaron e -92\r\nKPX Tcaron eacute -92\r\nKPX Tcaron ecaron -92\r\nKPX Tcaron ecircumflex -92\r\nKPX Tcaron edieresis -52\r\nKPX Tcaron edotaccent -92\r\nKPX Tcaron egrave -52\r\nKPX Tcaron emacron -52\r\nKPX Tcaron eogonek -92\r\nKPX Tcaron hyphen -92\r\nKPX Tcaron i -37\r\nKPX Tcaron iacute -37\r\nKPX Tcaron iogonek -37\r\nKPX Tcaron o -95\r\nKPX Tcaron oacute -95\r\nKPX Tcaron ocircumflex -95\r\nKPX Tcaron odieresis -95\r\nKPX Tcaron ograve -95\r\nKPX Tcaron ohungarumlaut -95\r\nKPX Tcaron omacron -95\r\nKPX Tcaron oslash -95\r\nKPX Tcaron otilde -95\r\nKPX Tcaron period -92\r\nKPX Tcaron r -37\r\nKPX Tcaron racute -37\r\nKPX Tcaron rcaron -37\r\nKPX Tcaron rcommaaccent -37\r\nKPX Tcaron semicolon -74\r\nKPX Tcaron u -37\r\nKPX Tcaron uacute -37\r\nKPX Tcaron ucircumflex -37\r\nKPX Tcaron udieresis -37\r\nKPX Tcaron ugrave -37\r\nKPX Tcaron uhungarumlaut -37\r\nKPX Tcaron umacron -37\r\nKPX Tcaron uogonek -37\r\nKPX Tcaron uring -37\r\nKPX Tcaron w -37\r\nKPX Tcaron y -37\r\nKPX Tcaron yacute -37\r\nKPX Tcaron ydieresis -37\r\nKPX Tcommaaccent A -55\r\nKPX Tcommaaccent Aacute -55\r\nKPX Tcommaaccent Abreve -55\r\nKPX Tcommaaccent Acircumflex -55\r\nKPX Tcommaaccent Adieresis -55\r\nKPX Tcommaaccent Agrave -55\r\nKPX Tcommaaccent Amacron -55\r\nKPX Tcommaaccent Aogonek -55\r\nKPX Tcommaaccent Aring -55\r\nKPX Tcommaaccent Atilde -55\r\nKPX Tcommaaccent O -18\r\nKPX Tcommaaccent Oacute -18\r\nKPX Tcommaaccent Ocircumflex -18\r\nKPX Tcommaaccent Odieresis -18\r\nKPX Tcommaaccent Ograve -18\r\nKPX Tcommaaccent Ohungarumlaut -18\r\nKPX Tcommaaccent Omacron -18\r\nKPX Tcommaaccent Oslash -18\r\nKPX Tcommaaccent Otilde -18\r\nKPX Tcommaaccent a -92\r\nKPX Tcommaaccent aacute -92\r\nKPX Tcommaaccent abreve -92\r\nKPX Tcommaaccent acircumflex -92\r\nKPX Tcommaaccent adieresis -92\r\nKPX Tcommaaccent agrave -92\r\nKPX Tcommaaccent amacron -92\r\nKPX Tcommaaccent aogonek -92\r\nKPX Tcommaaccent aring -92\r\nKPX Tcommaaccent atilde -92\r\nKPX Tcommaaccent colon -74\r\nKPX Tcommaaccent comma -92\r\nKPX Tcommaaccent e -92\r\nKPX Tcommaaccent eacute -92\r\nKPX Tcommaaccent ecaron -92\r\nKPX Tcommaaccent ecircumflex -92\r\nKPX Tcommaaccent edieresis -52\r\nKPX Tcommaaccent edotaccent -92\r\nKPX Tcommaaccent egrave -52\r\nKPX Tcommaaccent emacron -52\r\nKPX Tcommaaccent eogonek -92\r\nKPX Tcommaaccent hyphen -92\r\nKPX Tcommaaccent i -37\r\nKPX Tcommaaccent iacute -37\r\nKPX Tcommaaccent iogonek -37\r\nKPX Tcommaaccent o -95\r\nKPX Tcommaaccent oacute -95\r\nKPX Tcommaaccent ocircumflex -95\r\nKPX Tcommaaccent odieresis -95\r\nKPX Tcommaaccent ograve -95\r\nKPX Tcommaaccent ohungarumlaut -95\r\nKPX Tcommaaccent omacron -95\r\nKPX Tcommaaccent oslash -95\r\nKPX Tcommaaccent otilde -95\r\nKPX Tcommaaccent period -92\r\nKPX Tcommaaccent r -37\r\nKPX Tcommaaccent racute -37\r\nKPX Tcommaaccent rcaron -37\r\nKPX Tcommaaccent rcommaaccent -37\r\nKPX Tcommaaccent semicolon -74\r\nKPX Tcommaaccent u -37\r\nKPX Tcommaaccent uacute -37\r\nKPX Tcommaaccent ucircumflex -37\r\nKPX Tcommaaccent udieresis -37\r\nKPX Tcommaaccent ugrave -37\r\nKPX Tcommaaccent uhungarumlaut -37\r\nKPX Tcommaaccent umacron -37\r\nKPX Tcommaaccent uogonek -37\r\nKPX Tcommaaccent uring -37\r\nKPX Tcommaaccent w -37\r\nKPX Tcommaaccent y -37\r\nKPX Tcommaaccent yacute -37\r\nKPX Tcommaaccent ydieresis -37\r\nKPX U A -45\r\nKPX U Aacute -45\r\nKPX U Abreve -45\r\nKPX U Acircumflex -45\r\nKPX U Adieresis -45\r\nKPX U Agrave -45\r\nKPX U Amacron -45\r\nKPX U Aogonek -45\r\nKPX U Aring -45\r\nKPX U Atilde -45\r\nKPX Uacute A -45\r\nKPX Uacute Aacute -45\r\nKPX Uacute Abreve -45\r\nKPX Uacute Acircumflex -45\r\nKPX Uacute Adieresis -45\r\nKPX Uacute Agrave -45\r\nKPX Uacute Amacron -45\r\nKPX Uacute Aogonek -45\r\nKPX Uacute Aring -45\r\nKPX Uacute Atilde -45\r\nKPX Ucircumflex A -45\r\nKPX Ucircumflex Aacute -45\r\nKPX Ucircumflex Abreve -45\r\nKPX Ucircumflex Acircumflex -45\r\nKPX Ucircumflex Adieresis -45\r\nKPX Ucircumflex Agrave -45\r\nKPX Ucircumflex Amacron -45\r\nKPX Ucircumflex Aogonek -45\r\nKPX Ucircumflex Aring -45\r\nKPX Ucircumflex Atilde -45\r\nKPX Udieresis A -45\r\nKPX Udieresis Aacute -45\r\nKPX Udieresis Abreve -45\r\nKPX Udieresis Acircumflex -45\r\nKPX Udieresis Adieresis -45\r\nKPX Udieresis Agrave -45\r\nKPX Udieresis Amacron -45\r\nKPX Udieresis Aogonek -45\r\nKPX Udieresis Aring -45\r\nKPX Udieresis Atilde -45\r\nKPX Ugrave A -45\r\nKPX Ugrave Aacute -45\r\nKPX Ugrave Abreve -45\r\nKPX Ugrave Acircumflex -45\r\nKPX Ugrave Adieresis -45\r\nKPX Ugrave Agrave -45\r\nKPX Ugrave Amacron -45\r\nKPX Ugrave Aogonek -45\r\nKPX Ugrave Aring -45\r\nKPX Ugrave Atilde -45\r\nKPX Uhungarumlaut A -45\r\nKPX Uhungarumlaut Aacute -45\r\nKPX Uhungarumlaut Abreve -45\r\nKPX Uhungarumlaut Acircumflex -45\r\nKPX Uhungarumlaut Adieresis -45\r\nKPX Uhungarumlaut Agrave -45\r\nKPX Uhungarumlaut Amacron -45\r\nKPX Uhungarumlaut Aogonek -45\r\nKPX Uhungarumlaut Aring -45\r\nKPX Uhungarumlaut Atilde -45\r\nKPX Umacron A -45\r\nKPX Umacron Aacute -45\r\nKPX Umacron Abreve -45\r\nKPX Umacron Acircumflex -45\r\nKPX Umacron Adieresis -45\r\nKPX Umacron Agrave -45\r\nKPX Umacron Amacron -45\r\nKPX Umacron Aogonek -45\r\nKPX Umacron Aring -45\r\nKPX Umacron Atilde -45\r\nKPX Uogonek A -45\r\nKPX Uogonek Aacute -45\r\nKPX Uogonek Abreve -45\r\nKPX Uogonek Acircumflex -45\r\nKPX Uogonek Adieresis -45\r\nKPX Uogonek Agrave -45\r\nKPX Uogonek Amacron -45\r\nKPX Uogonek Aogonek -45\r\nKPX Uogonek Aring -45\r\nKPX Uogonek Atilde -45\r\nKPX Uring A -45\r\nKPX Uring Aacute -45\r\nKPX Uring Abreve -45\r\nKPX Uring Acircumflex -45\r\nKPX Uring Adieresis -45\r\nKPX Uring Agrave -45\r\nKPX Uring Amacron -45\r\nKPX Uring Aogonek -45\r\nKPX Uring Aring -45\r\nKPX Uring Atilde -45\r\nKPX V A -85\r\nKPX V Aacute -85\r\nKPX V Abreve -85\r\nKPX V Acircumflex -85\r\nKPX V Adieresis -85\r\nKPX V Agrave -85\r\nKPX V Amacron -85\r\nKPX V Aogonek -85\r\nKPX V Aring -85\r\nKPX V Atilde -85\r\nKPX V G -10\r\nKPX V Gbreve -10\r\nKPX V Gcommaaccent -10\r\nKPX V O -30\r\nKPX V Oacute -30\r\nKPX V Ocircumflex -30\r\nKPX V Odieresis -30\r\nKPX V Ograve -30\r\nKPX V Ohungarumlaut -30\r\nKPX V Omacron -30\r\nKPX V Oslash -30\r\nKPX V Otilde -30\r\nKPX V a -111\r\nKPX V aacute -111\r\nKPX V abreve -111\r\nKPX V acircumflex -111\r\nKPX V adieresis -111\r\nKPX V agrave -111\r\nKPX V amacron -111\r\nKPX V aogonek -111\r\nKPX V aring -111\r\nKPX V atilde -111\r\nKPX V colon -74\r\nKPX V comma -129\r\nKPX V e -111\r\nKPX V eacute -111\r\nKPX V ecaron -111\r\nKPX V ecircumflex -111\r\nKPX V edieresis -71\r\nKPX V edotaccent -111\r\nKPX V egrave -71\r\nKPX V emacron -71\r\nKPX V eogonek -111\r\nKPX V hyphen -70\r\nKPX V i -55\r\nKPX V iacute -55\r\nKPX V iogonek -55\r\nKPX V o -111\r\nKPX V oacute -111\r\nKPX V ocircumflex -111\r\nKPX V odieresis -111\r\nKPX V ograve -111\r\nKPX V ohungarumlaut -111\r\nKPX V omacron -111\r\nKPX V oslash -111\r\nKPX V otilde -111\r\nKPX V period -129\r\nKPX V semicolon -74\r\nKPX V u -55\r\nKPX V uacute -55\r\nKPX V ucircumflex -55\r\nKPX V udieresis -55\r\nKPX V ugrave -55\r\nKPX V uhungarumlaut -55\r\nKPX V umacron -55\r\nKPX V uogonek -55\r\nKPX V uring -55\r\nKPX W A -74\r\nKPX W Aacute -74\r\nKPX W Abreve -74\r\nKPX W Acircumflex -74\r\nKPX W Adieresis -74\r\nKPX W Agrave -74\r\nKPX W Amacron -74\r\nKPX W Aogonek -74\r\nKPX W Aring -74\r\nKPX W Atilde -74\r\nKPX W O -15\r\nKPX W Oacute -15\r\nKPX W Ocircumflex -15\r\nKPX W Odieresis -15\r\nKPX W Ograve -15\r\nKPX W Ohungarumlaut -15\r\nKPX W Omacron -15\r\nKPX W Oslash -15\r\nKPX W Otilde -15\r\nKPX W a -85\r\nKPX W aacute -85\r\nKPX W abreve -85\r\nKPX W acircumflex -85\r\nKPX W adieresis -85\r\nKPX W agrave -85\r\nKPX W amacron -85\r\nKPX W aogonek -85\r\nKPX W aring -85\r\nKPX W atilde -85\r\nKPX W colon -55\r\nKPX W comma -74\r\nKPX W e -90\r\nKPX W eacute -90\r\nKPX W ecaron -90\r\nKPX W ecircumflex -90\r\nKPX W edieresis -50\r\nKPX W edotaccent -90\r\nKPX W egrave -50\r\nKPX W emacron -50\r\nKPX W eogonek -90\r\nKPX W hyphen -50\r\nKPX W i -37\r\nKPX W iacute -37\r\nKPX W iogonek -37\r\nKPX W o -80\r\nKPX W oacute -80\r\nKPX W ocircumflex -80\r\nKPX W odieresis -80\r\nKPX W ograve -80\r\nKPX W ohungarumlaut -80\r\nKPX W omacron -80\r\nKPX W oslash -80\r\nKPX W otilde -80\r\nKPX W period -74\r\nKPX W semicolon -55\r\nKPX W u -55\r\nKPX W uacute -55\r\nKPX W ucircumflex -55\r\nKPX W udieresis -55\r\nKPX W ugrave -55\r\nKPX W uhungarumlaut -55\r\nKPX W umacron -55\r\nKPX W uogonek -55\r\nKPX W uring -55\r\nKPX W y -55\r\nKPX W yacute -55\r\nKPX W ydieresis -55\r\nKPX Y A -74\r\nKPX Y Aacute -74\r\nKPX Y Abreve -74\r\nKPX Y Acircumflex -74\r\nKPX Y Adieresis -74\r\nKPX Y Agrave -74\r\nKPX Y Amacron -74\r\nKPX Y Aogonek -74\r\nKPX Y Aring -74\r\nKPX Y Atilde -74\r\nKPX Y O -25\r\nKPX Y Oacute -25\r\nKPX Y Ocircumflex -25\r\nKPX Y Odieresis -25\r\nKPX Y Ograve -25\r\nKPX Y Ohungarumlaut -25\r\nKPX Y Omacron -25\r\nKPX Y Oslash -25\r\nKPX Y Otilde -25\r\nKPX Y a -92\r\nKPX Y aacute -92\r\nKPX Y abreve -92\r\nKPX Y acircumflex -92\r\nKPX Y adieresis -92\r\nKPX Y agrave -92\r\nKPX Y amacron -92\r\nKPX Y aogonek -92\r\nKPX Y aring -92\r\nKPX Y atilde -92\r\nKPX Y colon -92\r\nKPX Y comma -92\r\nKPX Y e -111\r\nKPX Y eacute -111\r\nKPX Y ecaron -111\r\nKPX Y ecircumflex -71\r\nKPX Y edieresis -71\r\nKPX Y edotaccent -111\r\nKPX Y egrave -71\r\nKPX Y emacron -71\r\nKPX Y eogonek -111\r\nKPX Y hyphen -92\r\nKPX Y i -55\r\nKPX Y iacute -55\r\nKPX Y iogonek -55\r\nKPX Y o -111\r\nKPX Y oacute -111\r\nKPX Y ocircumflex -111\r\nKPX Y odieresis -111\r\nKPX Y ograve -111\r\nKPX Y ohungarumlaut -111\r\nKPX Y omacron -111\r\nKPX Y oslash -111\r\nKPX Y otilde -111\r\nKPX Y period -74\r\nKPX Y semicolon -92\r\nKPX Y u -92\r\nKPX Y uacute -92\r\nKPX Y ucircumflex -92\r\nKPX Y udieresis -92\r\nKPX Y ugrave -92\r\nKPX Y uhungarumlaut -92\r\nKPX Y umacron -92\r\nKPX Y uogonek -92\r\nKPX Y uring -92\r\nKPX Yacute A -74\r\nKPX Yacute Aacute -74\r\nKPX Yacute Abreve -74\r\nKPX Yacute Acircumflex -74\r\nKPX Yacute Adieresis -74\r\nKPX Yacute Agrave -74\r\nKPX Yacute Amacron -74\r\nKPX Yacute Aogonek -74\r\nKPX Yacute Aring -74\r\nKPX Yacute Atilde -74\r\nKPX Yacute O -25\r\nKPX Yacute Oacute -25\r\nKPX Yacute Ocircumflex -25\r\nKPX Yacute Odieresis -25\r\nKPX Yacute Ograve -25\r\nKPX Yacute Ohungarumlaut -25\r\nKPX Yacute Omacron -25\r\nKPX Yacute Oslash -25\r\nKPX Yacute Otilde -25\r\nKPX Yacute a -92\r\nKPX Yacute aacute -92\r\nKPX Yacute abreve -92\r\nKPX Yacute acircumflex -92\r\nKPX Yacute adieresis -92\r\nKPX Yacute agrave -92\r\nKPX Yacute amacron -92\r\nKPX Yacute aogonek -92\r\nKPX Yacute aring -92\r\nKPX Yacute atilde -92\r\nKPX Yacute colon -92\r\nKPX Yacute comma -92\r\nKPX Yacute e -111\r\nKPX Yacute eacute -111\r\nKPX Yacute ecaron -111\r\nKPX Yacute ecircumflex -71\r\nKPX Yacute edieresis -71\r\nKPX Yacute edotaccent -111\r\nKPX Yacute egrave -71\r\nKPX Yacute emacron -71\r\nKPX Yacute eogonek -111\r\nKPX Yacute hyphen -92\r\nKPX Yacute i -55\r\nKPX Yacute iacute -55\r\nKPX Yacute iogonek -55\r\nKPX Yacute o -111\r\nKPX Yacute oacute -111\r\nKPX Yacute ocircumflex -111\r\nKPX Yacute odieresis -111\r\nKPX Yacute ograve -111\r\nKPX Yacute ohungarumlaut -111\r\nKPX Yacute omacron -111\r\nKPX Yacute oslash -111\r\nKPX Yacute otilde -111\r\nKPX Yacute period -74\r\nKPX Yacute semicolon -92\r\nKPX Yacute u -92\r\nKPX Yacute uacute -92\r\nKPX Yacute ucircumflex -92\r\nKPX Yacute udieresis -92\r\nKPX Yacute ugrave -92\r\nKPX Yacute uhungarumlaut -92\r\nKPX Yacute umacron -92\r\nKPX Yacute uogonek -92\r\nKPX Yacute uring -92\r\nKPX Ydieresis A -74\r\nKPX Ydieresis Aacute -74\r\nKPX Ydieresis Abreve -74\r\nKPX Ydieresis Acircumflex -74\r\nKPX Ydieresis Adieresis -74\r\nKPX Ydieresis Agrave -74\r\nKPX Ydieresis Amacron -74\r\nKPX Ydieresis Aogonek -74\r\nKPX Ydieresis Aring -74\r\nKPX Ydieresis Atilde -74\r\nKPX Ydieresis O -25\r\nKPX Ydieresis Oacute -25\r\nKPX Ydieresis Ocircumflex -25\r\nKPX Ydieresis Odieresis -25\r\nKPX Ydieresis Ograve -25\r\nKPX Ydieresis Ohungarumlaut -25\r\nKPX Ydieresis Omacron -25\r\nKPX Ydieresis Oslash -25\r\nKPX Ydieresis Otilde -25\r\nKPX Ydieresis a -92\r\nKPX Ydieresis aacute -92\r\nKPX Ydieresis abreve -92\r\nKPX Ydieresis acircumflex -92\r\nKPX Ydieresis adieresis -92\r\nKPX Ydieresis agrave -92\r\nKPX Ydieresis amacron -92\r\nKPX Ydieresis aogonek -92\r\nKPX Ydieresis aring -92\r\nKPX Ydieresis atilde -92\r\nKPX Ydieresis colon -92\r\nKPX Ydieresis comma -92\r\nKPX Ydieresis e -111\r\nKPX Ydieresis eacute -111\r\nKPX Ydieresis ecaron -111\r\nKPX Ydieresis ecircumflex -71\r\nKPX Ydieresis edieresis -71\r\nKPX Ydieresis edotaccent -111\r\nKPX Ydieresis egrave -71\r\nKPX Ydieresis emacron -71\r\nKPX Ydieresis eogonek -111\r\nKPX Ydieresis hyphen -92\r\nKPX Ydieresis i -55\r\nKPX Ydieresis iacute -55\r\nKPX Ydieresis iogonek -55\r\nKPX Ydieresis o -111\r\nKPX Ydieresis oacute -111\r\nKPX Ydieresis ocircumflex -111\r\nKPX Ydieresis odieresis -111\r\nKPX Ydieresis ograve -111\r\nKPX Ydieresis ohungarumlaut -111\r\nKPX Ydieresis omacron -111\r\nKPX Ydieresis oslash -111\r\nKPX Ydieresis otilde -111\r\nKPX Ydieresis period -74\r\nKPX Ydieresis semicolon -92\r\nKPX Ydieresis u -92\r\nKPX Ydieresis uacute -92\r\nKPX Ydieresis ucircumflex -92\r\nKPX Ydieresis udieresis -92\r\nKPX Ydieresis ugrave -92\r\nKPX Ydieresis uhungarumlaut -92\r\nKPX Ydieresis umacron -92\r\nKPX Ydieresis uogonek -92\r\nKPX Ydieresis uring -92\r\nKPX b b -10\r\nKPX b period -40\r\nKPX b u -20\r\nKPX b uacute -20\r\nKPX b ucircumflex -20\r\nKPX b udieresis -20\r\nKPX b ugrave -20\r\nKPX b uhungarumlaut -20\r\nKPX b umacron -20\r\nKPX b uogonek -20\r\nKPX b uring -20\r\nKPX c h -10\r\nKPX c k -10\r\nKPX c kcommaaccent -10\r\nKPX cacute h -10\r\nKPX cacute k -10\r\nKPX cacute kcommaaccent -10\r\nKPX ccaron h -10\r\nKPX ccaron k -10\r\nKPX ccaron kcommaaccent -10\r\nKPX ccedilla h -10\r\nKPX ccedilla k -10\r\nKPX ccedilla kcommaaccent -10\r\nKPX comma quotedblright -95\r\nKPX comma quoteright -95\r\nKPX e b -10\r\nKPX eacute b -10\r\nKPX ecaron b -10\r\nKPX ecircumflex b -10\r\nKPX edieresis b -10\r\nKPX edotaccent b -10\r\nKPX egrave b -10\r\nKPX emacron b -10\r\nKPX eogonek b -10\r\nKPX f comma -10\r\nKPX f dotlessi -30\r\nKPX f e -10\r\nKPX f eacute -10\r\nKPX f edotaccent -10\r\nKPX f eogonek -10\r\nKPX f f -18\r\nKPX f o -10\r\nKPX f oacute -10\r\nKPX f ocircumflex -10\r\nKPX f ograve -10\r\nKPX f ohungarumlaut -10\r\nKPX f oslash -10\r\nKPX f otilde -10\r\nKPX f period -10\r\nKPX f quoteright 55\r\nKPX k e -30\r\nKPX k eacute -30\r\nKPX k ecaron -30\r\nKPX k ecircumflex -30\r\nKPX k edieresis -30\r\nKPX k edotaccent -30\r\nKPX k egrave -30\r\nKPX k emacron -30\r\nKPX k eogonek -30\r\nKPX k o -10\r\nKPX k oacute -10\r\nKPX k ocircumflex -10\r\nKPX k odieresis -10\r\nKPX k ograve -10\r\nKPX k ohungarumlaut -10\r\nKPX k omacron -10\r\nKPX k oslash -10\r\nKPX k otilde -10\r\nKPX kcommaaccent e -30\r\nKPX kcommaaccent eacute -30\r\nKPX kcommaaccent ecaron -30\r\nKPX kcommaaccent ecircumflex -30\r\nKPX kcommaaccent edieresis -30\r\nKPX kcommaaccent edotaccent -30\r\nKPX kcommaaccent egrave -30\r\nKPX kcommaaccent emacron -30\r\nKPX kcommaaccent eogonek -30\r\nKPX kcommaaccent o -10\r\nKPX kcommaaccent oacute -10\r\nKPX kcommaaccent ocircumflex -10\r\nKPX kcommaaccent odieresis -10\r\nKPX kcommaaccent ograve -10\r\nKPX kcommaaccent ohungarumlaut -10\r\nKPX kcommaaccent omacron -10\r\nKPX kcommaaccent oslash -10\r\nKPX kcommaaccent otilde -10\r\nKPX n v -40\r\nKPX nacute v -40\r\nKPX ncaron v -40\r\nKPX ncommaaccent v -40\r\nKPX ntilde v -40\r\nKPX o v -15\r\nKPX o w -25\r\nKPX o x -10\r\nKPX o y -10\r\nKPX o yacute -10\r\nKPX o ydieresis -10\r\nKPX oacute v -15\r\nKPX oacute w -25\r\nKPX oacute x -10\r\nKPX oacute y -10\r\nKPX oacute yacute -10\r\nKPX oacute ydieresis -10\r\nKPX ocircumflex v -15\r\nKPX ocircumflex w -25\r\nKPX ocircumflex x -10\r\nKPX ocircumflex y -10\r\nKPX ocircumflex yacute -10\r\nKPX ocircumflex ydieresis -10\r\nKPX odieresis v -15\r\nKPX odieresis w -25\r\nKPX odieresis x -10\r\nKPX odieresis y -10\r\nKPX odieresis yacute -10\r\nKPX odieresis ydieresis -10\r\nKPX ograve v -15\r\nKPX ograve w -25\r\nKPX ograve x -10\r\nKPX ograve y -10\r\nKPX ograve yacute -10\r\nKPX ograve ydieresis -10\r\nKPX ohungarumlaut v -15\r\nKPX ohungarumlaut w -25\r\nKPX ohungarumlaut x -10\r\nKPX ohungarumlaut y -10\r\nKPX ohungarumlaut yacute -10\r\nKPX ohungarumlaut ydieresis -10\r\nKPX omacron v -15\r\nKPX omacron w -25\r\nKPX omacron x -10\r\nKPX omacron y -10\r\nKPX omacron yacute -10\r\nKPX omacron ydieresis -10\r\nKPX oslash v -15\r\nKPX oslash w -25\r\nKPX oslash x -10\r\nKPX oslash y -10\r\nKPX oslash yacute -10\r\nKPX oslash ydieresis -10\r\nKPX otilde v -15\r\nKPX otilde w -25\r\nKPX otilde x -10\r\nKPX otilde y -10\r\nKPX otilde yacute -10\r\nKPX otilde ydieresis -10\r\nKPX period quotedblright -95\r\nKPX period quoteright -95\r\nKPX quoteleft quoteleft -74\r\nKPX quoteright d -15\r\nKPX quoteright dcroat -15\r\nKPX quoteright quoteright -74\r\nKPX quoteright r -15\r\nKPX quoteright racute -15\r\nKPX quoteright rcaron -15\r\nKPX quoteright rcommaaccent -15\r\nKPX quoteright s -74\r\nKPX quoteright sacute -74\r\nKPX quoteright scaron -74\r\nKPX quoteright scedilla -74\r\nKPX quoteright scommaaccent -74\r\nKPX quoteright space -74\r\nKPX quoteright t -37\r\nKPX quoteright tcommaaccent -37\r\nKPX quoteright v -15\r\nKPX r comma -65\r\nKPX r period -65\r\nKPX racute comma -65\r\nKPX racute period -65\r\nKPX rcaron comma -65\r\nKPX rcaron period -65\r\nKPX rcommaaccent comma -65\r\nKPX rcommaaccent period -65\r\nKPX space A -37\r\nKPX space Aacute -37\r\nKPX space Abreve -37\r\nKPX space Acircumflex -37\r\nKPX space Adieresis -37\r\nKPX space Agrave -37\r\nKPX space Amacron -37\r\nKPX space Aogonek -37\r\nKPX space Aring -37\r\nKPX space Atilde -37\r\nKPX space V -70\r\nKPX space W -70\r\nKPX space Y -70\r\nKPX space Yacute -70\r\nKPX space Ydieresis -70\r\nKPX v comma -37\r\nKPX v e -15\r\nKPX v eacute -15\r\nKPX v ecaron -15\r\nKPX v ecircumflex -15\r\nKPX v edieresis -15\r\nKPX v edotaccent -15\r\nKPX v egrave -15\r\nKPX v emacron -15\r\nKPX v eogonek -15\r\nKPX v o -15\r\nKPX v oacute -15\r\nKPX v ocircumflex -15\r\nKPX v odieresis -15\r\nKPX v ograve -15\r\nKPX v ohungarumlaut -15\r\nKPX v omacron -15\r\nKPX v oslash -15\r\nKPX v otilde -15\r\nKPX v period -37\r\nKPX w a -10\r\nKPX w aacute -10\r\nKPX w abreve -10\r\nKPX w acircumflex -10\r\nKPX w adieresis -10\r\nKPX w agrave -10\r\nKPX w amacron -10\r\nKPX w aogonek -10\r\nKPX w aring -10\r\nKPX w atilde -10\r\nKPX w comma -37\r\nKPX w e -10\r\nKPX w eacute -10\r\nKPX w ecaron -10\r\nKPX w ecircumflex -10\r\nKPX w edieresis -10\r\nKPX w edotaccent -10\r\nKPX w egrave -10\r\nKPX w emacron -10\r\nKPX w eogonek -10\r\nKPX w o -15\r\nKPX w oacute -15\r\nKPX w ocircumflex -15\r\nKPX w odieresis -15\r\nKPX w ograve -15\r\nKPX w ohungarumlaut -15\r\nKPX w omacron -15\r\nKPX w oslash -15\r\nKPX w otilde -15\r\nKPX w period -37\r\nKPX x e -10\r\nKPX x eacute -10\r\nKPX x ecaron -10\r\nKPX x ecircumflex -10\r\nKPX x edieresis -10\r\nKPX x edotaccent -10\r\nKPX x egrave -10\r\nKPX x emacron -10\r\nKPX x eogonek -10\r\nKPX y comma -37\r\nKPX y period -37\r\nKPX yacute comma -37\r\nKPX yacute period -37\r\nKPX ydieresis comma -37\r\nKPX ydieresis period -37\r\nEndKernPairs\r\nEndKernData\r\nEndFontMetrics\r\n";
                  },
  
                  Symbol() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated. All rights reserved.\r\nComment Creation Date: Thu May  1 15:12:25 1997\r\nComment UniqueID 43064\r\nComment VMusage 30820 39997\r\nFontName Symbol\r\nFullName Symbol\r\nFamilyName Symbol\r\nWeight Medium\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet Special\r\nFontBBox -180 -293 1090 1010 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 001.008\r\nNotice Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated. All rights reserved.\r\nEncodingScheme FontSpecific\r\nStdHW 92\r\nStdVW 85\r\nStartCharMetrics 190\r\nC 32 ; WX 250 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 333 ; N exclam ; B 128 -17 240 672 ;\r\nC 34 ; WX 713 ; N universal ; B 31 0 681 705 ;\r\nC 35 ; WX 500 ; N numbersign ; B 20 -16 481 673 ;\r\nC 36 ; WX 549 ; N existential ; B 25 0 478 707 ;\r\nC 37 ; WX 833 ; N percent ; B 63 -36 771 655 ;\r\nC 38 ; WX 778 ; N ampersand ; B 41 -18 750 661 ;\r\nC 39 ; WX 439 ; N suchthat ; B 48 -17 414 500 ;\r\nC 40 ; WX 333 ; N parenleft ; B 53 -191 300 673 ;\r\nC 41 ; WX 333 ; N parenright ; B 30 -191 277 673 ;\r\nC 42 ; WX 500 ; N asteriskmath ; B 65 134 427 551 ;\r\nC 43 ; WX 549 ; N plus ; B 10 0 539 533 ;\r\nC 44 ; WX 250 ; N comma ; B 56 -152 194 104 ;\r\nC 45 ; WX 549 ; N minus ; B 11 233 535 288 ;\r\nC 46 ; WX 250 ; N period ; B 69 -17 181 95 ;\r\nC 47 ; WX 278 ; N slash ; B 0 -18 254 646 ;\r\nC 48 ; WX 500 ; N zero ; B 24 -14 476 685 ;\r\nC 49 ; WX 500 ; N one ; B 117 0 390 673 ;\r\nC 50 ; WX 500 ; N two ; B 25 0 475 685 ;\r\nC 51 ; WX 500 ; N three ; B 43 -14 435 685 ;\r\nC 52 ; WX 500 ; N four ; B 15 0 469 685 ;\r\nC 53 ; WX 500 ; N five ; B 32 -14 445 690 ;\r\nC 54 ; WX 500 ; N six ; B 34 -14 468 685 ;\r\nC 55 ; WX 500 ; N seven ; B 24 -16 448 673 ;\r\nC 56 ; WX 500 ; N eight ; B 56 -14 445 685 ;\r\nC 57 ; WX 500 ; N nine ; B 30 -18 459 685 ;\r\nC 58 ; WX 278 ; N colon ; B 81 -17 193 460 ;\r\nC 59 ; WX 278 ; N semicolon ; B 83 -152 221 460 ;\r\nC 60 ; WX 549 ; N less ; B 26 0 523 522 ;\r\nC 61 ; WX 549 ; N equal ; B 11 141 537 390 ;\r\nC 62 ; WX 549 ; N greater ; B 26 0 523 522 ;\r\nC 63 ; WX 444 ; N question ; B 70 -17 412 686 ;\r\nC 64 ; WX 549 ; N congruent ; B 11 0 537 475 ;\r\nC 65 ; WX 722 ; N Alpha ; B 4 0 684 673 ;\r\nC 66 ; WX 667 ; N Beta ; B 29 0 592 673 ;\r\nC 67 ; WX 722 ; N Chi ; B -9 0 704 673 ;\r\nC 68 ; WX 612 ; N Delta ; B 6 0 608 688 ;\r\nC 69 ; WX 611 ; N Epsilon ; B 32 0 617 673 ;\r\nC 70 ; WX 763 ; N Phi ; B 26 0 741 673 ;\r\nC 71 ; WX 603 ; N Gamma ; B 24 0 609 673 ;\r\nC 72 ; WX 722 ; N Eta ; B 39 0 729 673 ;\r\nC 73 ; WX 333 ; N Iota ; B 32 0 316 673 ;\r\nC 74 ; WX 631 ; N theta1 ; B 18 -18 623 689 ;\r\nC 75 ; WX 722 ; N Kappa ; B 35 0 722 673 ;\r\nC 76 ; WX 686 ; N Lambda ; B 6 0 680 688 ;\r\nC 77 ; WX 889 ; N Mu ; B 28 0 887 673 ;\r\nC 78 ; WX 722 ; N Nu ; B 29 -8 720 673 ;\r\nC 79 ; WX 722 ; N Omicron ; B 41 -17 715 685 ;\r\nC 80 ; WX 768 ; N Pi ; B 25 0 745 673 ;\r\nC 81 ; WX 741 ; N Theta ; B 41 -17 715 685 ;\r\nC 82 ; WX 556 ; N Rho ; B 28 0 563 673 ;\r\nC 83 ; WX 592 ; N Sigma ; B 5 0 589 673 ;\r\nC 84 ; WX 611 ; N Tau ; B 33 0 607 673 ;\r\nC 85 ; WX 690 ; N Upsilon ; B -8 0 694 673 ;\r\nC 86 ; WX 439 ; N sigma1 ; B 40 -233 436 500 ;\r\nC 87 ; WX 768 ; N Omega ; B 34 0 736 688 ;\r\nC 88 ; WX 645 ; N Xi ; B 40 0 599 673 ;\r\nC 89 ; WX 795 ; N Psi ; B 15 0 781 684 ;\r\nC 90 ; WX 611 ; N Zeta ; B 44 0 636 673 ;\r\nC 91 ; WX 333 ; N bracketleft ; B 86 -155 299 674 ;\r\nC 92 ; WX 863 ; N therefore ; B 163 0 701 487 ;\r\nC 93 ; WX 333 ; N bracketright ; B 33 -155 246 674 ;\r\nC 94 ; WX 658 ; N perpendicular ; B 15 0 652 674 ;\r\nC 95 ; WX 500 ; N underscore ; B -2 -125 502 -75 ;\r\nC 96 ; WX 500 ; N radicalex ; B 480 881 1090 917 ;\r\nC 97 ; WX 631 ; N alpha ; B 41 -18 622 500 ;\r\nC 98 ; WX 549 ; N beta ; B 61 -223 515 741 ;\r\nC 99 ; WX 549 ; N chi ; B 12 -231 522 499 ;\r\nC 100 ; WX 494 ; N delta ; B 40 -19 481 740 ;\r\nC 101 ; WX 439 ; N epsilon ; B 22 -19 427 502 ;\r\nC 102 ; WX 521 ; N phi ; B 28 -224 492 673 ;\r\nC 103 ; WX 411 ; N gamma ; B 5 -225 484 499 ;\r\nC 104 ; WX 603 ; N eta ; B 0 -202 527 514 ;\r\nC 105 ; WX 329 ; N iota ; B 0 -17 301 503 ;\r\nC 106 ; WX 603 ; N phi1 ; B 36 -224 587 499 ;\r\nC 107 ; WX 549 ; N kappa ; B 33 0 558 501 ;\r\nC 108 ; WX 549 ; N lambda ; B 24 -17 548 739 ;\r\nC 109 ; WX 576 ; N mu ; B 33 -223 567 500 ;\r\nC 110 ; WX 521 ; N nu ; B -9 -16 475 507 ;\r\nC 111 ; WX 549 ; N omicron ; B 35 -19 501 499 ;\r\nC 112 ; WX 549 ; N pi ; B 10 -19 530 487 ;\r\nC 113 ; WX 521 ; N theta ; B 43 -17 485 690 ;\r\nC 114 ; WX 549 ; N rho ; B 50 -230 490 499 ;\r\nC 115 ; WX 603 ; N sigma ; B 30 -21 588 500 ;\r\nC 116 ; WX 439 ; N tau ; B 10 -19 418 500 ;\r\nC 117 ; WX 576 ; N upsilon ; B 7 -18 535 507 ;\r\nC 118 ; WX 713 ; N omega1 ; B 12 -18 671 583 ;\r\nC 119 ; WX 686 ; N omega ; B 42 -17 684 500 ;\r\nC 120 ; WX 493 ; N xi ; B 27 -224 469 766 ;\r\nC 121 ; WX 686 ; N psi ; B 12 -228 701 500 ;\r\nC 122 ; WX 494 ; N zeta ; B 60 -225 467 756 ;\r\nC 123 ; WX 480 ; N braceleft ; B 58 -183 397 673 ;\r\nC 124 ; WX 200 ; N bar ; B 65 -293 135 707 ;\r\nC 125 ; WX 480 ; N braceright ; B 79 -183 418 673 ;\r\nC 126 ; WX 549 ; N similar ; B 17 203 529 307 ;\r\nC 160 ; WX 750 ; N Euro ; B 20 -12 714 685 ;\r\nC 161 ; WX 620 ; N Upsilon1 ; B -2 0 610 685 ;\r\nC 162 ; WX 247 ; N minute ; B 27 459 228 735 ;\r\nC 163 ; WX 549 ; N lessequal ; B 29 0 526 639 ;\r\nC 164 ; WX 167 ; N fraction ; B -180 -12 340 677 ;\r\nC 165 ; WX 713 ; N infinity ; B 26 124 688 404 ;\r\nC 166 ; WX 500 ; N florin ; B 2 -193 494 686 ;\r\nC 167 ; WX 753 ; N club ; B 86 -26 660 533 ;\r\nC 168 ; WX 753 ; N diamond ; B 142 -36 600 550 ;\r\nC 169 ; WX 753 ; N heart ; B 117 -33 631 532 ;\r\nC 170 ; WX 753 ; N spade ; B 113 -36 629 548 ;\r\nC 171 ; WX 1042 ; N arrowboth ; B 24 -15 1024 511 ;\r\nC 172 ; WX 987 ; N arrowleft ; B 32 -15 942 511 ;\r\nC 173 ; WX 603 ; N arrowup ; B 45 0 571 910 ;\r\nC 174 ; WX 987 ; N arrowright ; B 49 -15 959 511 ;\r\nC 175 ; WX 603 ; N arrowdown ; B 45 -22 571 888 ;\r\nC 176 ; WX 400 ; N degree ; B 50 385 350 685 ;\r\nC 177 ; WX 549 ; N plusminus ; B 10 0 539 645 ;\r\nC 178 ; WX 411 ; N second ; B 20 459 413 737 ;\r\nC 179 ; WX 549 ; N greaterequal ; B 29 0 526 639 ;\r\nC 180 ; WX 549 ; N multiply ; B 17 8 533 524 ;\r\nC 181 ; WX 713 ; N proportional ; B 27 123 639 404 ;\r\nC 182 ; WX 494 ; N partialdiff ; B 26 -20 462 746 ;\r\nC 183 ; WX 460 ; N bullet ; B 50 113 410 473 ;\r\nC 184 ; WX 549 ; N divide ; B 10 71 536 456 ;\r\nC 185 ; WX 549 ; N notequal ; B 15 -25 540 549 ;\r\nC 186 ; WX 549 ; N equivalence ; B 14 82 538 443 ;\r\nC 187 ; WX 549 ; N approxequal ; B 14 135 527 394 ;\r\nC 188 ; WX 1000 ; N ellipsis ; B 111 -17 889 95 ;\r\nC 189 ; WX 603 ; N arrowvertex ; B 280 -120 336 1010 ;\r\nC 190 ; WX 1000 ; N arrowhorizex ; B -60 220 1050 276 ;\r\nC 191 ; WX 658 ; N carriagereturn ; B 15 -16 602 629 ;\r\nC 192 ; WX 823 ; N aleph ; B 175 -18 661 658 ;\r\nC 193 ; WX 686 ; N Ifraktur ; B 10 -53 578 740 ;\r\nC 194 ; WX 795 ; N Rfraktur ; B 26 -15 759 734 ;\r\nC 195 ; WX 987 ; N weierstrass ; B 159 -211 870 573 ;\r\nC 196 ; WX 768 ; N circlemultiply ; B 43 -17 733 673 ;\r\nC 197 ; WX 768 ; N circleplus ; B 43 -15 733 675 ;\r\nC 198 ; WX 823 ; N emptyset ; B 39 -24 781 719 ;\r\nC 199 ; WX 768 ; N intersection ; B 40 0 732 509 ;\r\nC 200 ; WX 768 ; N union ; B 40 -17 732 492 ;\r\nC 201 ; WX 713 ; N propersuperset ; B 20 0 673 470 ;\r\nC 202 ; WX 713 ; N reflexsuperset ; B 20 -125 673 470 ;\r\nC 203 ; WX 713 ; N notsubset ; B 36 -70 690 540 ;\r\nC 204 ; WX 713 ; N propersubset ; B 37 0 690 470 ;\r\nC 205 ; WX 713 ; N reflexsubset ; B 37 -125 690 470 ;\r\nC 206 ; WX 713 ; N element ; B 45 0 505 468 ;\r\nC 207 ; WX 713 ; N notelement ; B 45 -58 505 555 ;\r\nC 208 ; WX 768 ; N angle ; B 26 0 738 673 ;\r\nC 209 ; WX 713 ; N gradient ; B 36 -19 681 718 ;\r\nC 210 ; WX 790 ; N registerserif ; B 50 -17 740 673 ;\r\nC 211 ; WX 790 ; N copyrightserif ; B 51 -15 741 675 ;\r\nC 212 ; WX 890 ; N trademarkserif ; B 18 293 855 673 ;\r\nC 213 ; WX 823 ; N product ; B 25 -101 803 751 ;\r\nC 214 ; WX 549 ; N radical ; B 10 -38 515 917 ;\r\nC 215 ; WX 250 ; N dotmath ; B 69 210 169 310 ;\r\nC 216 ; WX 713 ; N logicalnot ; B 15 0 680 288 ;\r\nC 217 ; WX 603 ; N logicaland ; B 23 0 583 454 ;\r\nC 218 ; WX 603 ; N logicalor ; B 30 0 578 477 ;\r\nC 219 ; WX 1042 ; N arrowdblboth ; B 27 -20 1023 510 ;\r\nC 220 ; WX 987 ; N arrowdblleft ; B 30 -15 939 513 ;\r\nC 221 ; WX 603 ; N arrowdblup ; B 39 2 567 911 ;\r\nC 222 ; WX 987 ; N arrowdblright ; B 45 -20 954 508 ;\r\nC 223 ; WX 603 ; N arrowdbldown ; B 44 -19 572 890 ;\r\nC 224 ; WX 494 ; N lozenge ; B 18 0 466 745 ;\r\nC 225 ; WX 329 ; N angleleft ; B 25 -198 306 746 ;\r\nC 226 ; WX 790 ; N registersans ; B 50 -20 740 670 ;\r\nC 227 ; WX 790 ; N copyrightsans ; B 49 -15 739 675 ;\r\nC 228 ; WX 786 ; N trademarksans ; B 5 293 725 673 ;\r\nC 229 ; WX 713 ; N summation ; B 14 -108 695 752 ;\r\nC 230 ; WX 384 ; N parenlefttp ; B 24 -293 436 926 ;\r\nC 231 ; WX 384 ; N parenleftex ; B 24 -85 108 925 ;\r\nC 232 ; WX 384 ; N parenleftbt ; B 24 -293 436 926 ;\r\nC 233 ; WX 384 ; N bracketlefttp ; B 0 -80 349 926 ;\r\nC 234 ; WX 384 ; N bracketleftex ; B 0 -79 77 925 ;\r\nC 235 ; WX 384 ; N bracketleftbt ; B 0 -80 349 926 ;\r\nC 236 ; WX 494 ; N bracelefttp ; B 209 -85 445 925 ;\r\nC 237 ; WX 494 ; N braceleftmid ; B 20 -85 284 935 ;\r\nC 238 ; WX 494 ; N braceleftbt ; B 209 -75 445 935 ;\r\nC 239 ; WX 494 ; N braceex ; B 209 -85 284 935 ;\r\nC 241 ; WX 329 ; N angleright ; B 21 -198 302 746 ;\r\nC 242 ; WX 274 ; N integral ; B 2 -107 291 916 ;\r\nC 243 ; WX 686 ; N integraltp ; B 308 -88 675 920 ;\r\nC 244 ; WX 686 ; N integralex ; B 308 -88 378 975 ;\r\nC 245 ; WX 686 ; N integralbt ; B 11 -87 378 921 ;\r\nC 246 ; WX 384 ; N parenrighttp ; B 54 -293 466 926 ;\r\nC 247 ; WX 384 ; N parenrightex ; B 382 -85 466 925 ;\r\nC 248 ; WX 384 ; N parenrightbt ; B 54 -293 466 926 ;\r\nC 249 ; WX 384 ; N bracketrighttp ; B 22 -80 371 926 ;\r\nC 250 ; WX 384 ; N bracketrightex ; B 294 -79 371 925 ;\r\nC 251 ; WX 384 ; N bracketrightbt ; B 22 -80 371 926 ;\r\nC 252 ; WX 494 ; N bracerighttp ; B 48 -85 284 925 ;\r\nC 253 ; WX 494 ; N bracerightmid ; B 209 -85 473 935 ;\r\nC 254 ; WX 494 ; N bracerightbt ; B 48 -75 284 935 ;\r\nC -1 ; WX 790 ; N apple ; B 56 -3 733 808 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
  
                  ZapfDingbats() {
                    return "StartFontMetrics 4.1\r\nComment Copyright (c) 1985, 1987, 1988, 1989, 1997 Adobe Systems Incorporated. All Rights Reserved.\r\nComment Creation Date: Thu May  1 15:14:13 1997\r\nComment UniqueID 43082\r\nComment VMusage 45775 55535\r\nFontName ZapfDingbats\r\nFullName ITC Zapf Dingbats\r\nFamilyName ZapfDingbats\r\nWeight Medium\r\nItalicAngle 0\r\nIsFixedPitch false\r\nCharacterSet Special\r\nFontBBox -1 -143 981 820 \r\nUnderlinePosition -100\r\nUnderlineThickness 50\r\nVersion 002.000\r\nNotice Copyright (c) 1985, 1987, 1988, 1989, 1997 Adobe Systems Incorporated. All Rights Reserved.ITC Zapf Dingbats is a registered trademark of International Typeface Corporation.\r\nEncodingScheme FontSpecific\r\nStdHW 28\r\nStdVW 90\r\nStartCharMetrics 202\r\nC 32 ; WX 278 ; N space ; B 0 0 0 0 ;\r\nC 33 ; WX 974 ; N a1 ; B 35 72 939 621 ;\r\nC 34 ; WX 961 ; N a2 ; B 35 81 927 611 ;\r\nC 35 ; WX 974 ; N a202 ; B 35 72 939 621 ;\r\nC 36 ; WX 980 ; N a3 ; B 35 0 945 692 ;\r\nC 37 ; WX 719 ; N a4 ; B 34 139 685 566 ;\r\nC 38 ; WX 789 ; N a5 ; B 35 -14 755 705 ;\r\nC 39 ; WX 790 ; N a119 ; B 35 -14 755 705 ;\r\nC 40 ; WX 791 ; N a118 ; B 35 -13 761 705 ;\r\nC 41 ; WX 690 ; N a117 ; B 34 138 655 553 ;\r\nC 42 ; WX 960 ; N a11 ; B 35 123 925 568 ;\r\nC 43 ; WX 939 ; N a12 ; B 35 134 904 559 ;\r\nC 44 ; WX 549 ; N a13 ; B 29 -11 516 705 ;\r\nC 45 ; WX 855 ; N a14 ; B 34 59 820 632 ;\r\nC 46 ; WX 911 ; N a15 ; B 35 50 876 642 ;\r\nC 47 ; WX 933 ; N a16 ; B 35 139 899 550 ;\r\nC 48 ; WX 911 ; N a105 ; B 35 50 876 642 ;\r\nC 49 ; WX 945 ; N a17 ; B 35 139 909 553 ;\r\nC 50 ; WX 974 ; N a18 ; B 35 104 938 587 ;\r\nC 51 ; WX 755 ; N a19 ; B 34 -13 721 705 ;\r\nC 52 ; WX 846 ; N a20 ; B 36 -14 811 705 ;\r\nC 53 ; WX 762 ; N a21 ; B 35 0 727 692 ;\r\nC 54 ; WX 761 ; N a22 ; B 35 0 727 692 ;\r\nC 55 ; WX 571 ; N a23 ; B -1 -68 571 661 ;\r\nC 56 ; WX 677 ; N a24 ; B 36 -13 642 705 ;\r\nC 57 ; WX 763 ; N a25 ; B 35 0 728 692 ;\r\nC 58 ; WX 760 ; N a26 ; B 35 0 726 692 ;\r\nC 59 ; WX 759 ; N a27 ; B 35 0 725 692 ;\r\nC 60 ; WX 754 ; N a28 ; B 35 0 720 692 ;\r\nC 61 ; WX 494 ; N a6 ; B 35 0 460 692 ;\r\nC 62 ; WX 552 ; N a7 ; B 35 0 517 692 ;\r\nC 63 ; WX 537 ; N a8 ; B 35 0 503 692 ;\r\nC 64 ; WX 577 ; N a9 ; B 35 96 542 596 ;\r\nC 65 ; WX 692 ; N a10 ; B 35 -14 657 705 ;\r\nC 66 ; WX 786 ; N a29 ; B 35 -14 751 705 ;\r\nC 67 ; WX 788 ; N a30 ; B 35 -14 752 705 ;\r\nC 68 ; WX 788 ; N a31 ; B 35 -14 753 705 ;\r\nC 69 ; WX 790 ; N a32 ; B 35 -14 756 705 ;\r\nC 70 ; WX 793 ; N a33 ; B 35 -13 759 705 ;\r\nC 71 ; WX 794 ; N a34 ; B 35 -13 759 705 ;\r\nC 72 ; WX 816 ; N a35 ; B 35 -14 782 705 ;\r\nC 73 ; WX 823 ; N a36 ; B 35 -14 787 705 ;\r\nC 74 ; WX 789 ; N a37 ; B 35 -14 754 705 ;\r\nC 75 ; WX 841 ; N a38 ; B 35 -14 807 705 ;\r\nC 76 ; WX 823 ; N a39 ; B 35 -14 789 705 ;\r\nC 77 ; WX 833 ; N a40 ; B 35 -14 798 705 ;\r\nC 78 ; WX 816 ; N a41 ; B 35 -13 782 705 ;\r\nC 79 ; WX 831 ; N a42 ; B 35 -14 796 705 ;\r\nC 80 ; WX 923 ; N a43 ; B 35 -14 888 705 ;\r\nC 81 ; WX 744 ; N a44 ; B 35 0 710 692 ;\r\nC 82 ; WX 723 ; N a45 ; B 35 0 688 692 ;\r\nC 83 ; WX 749 ; N a46 ; B 35 0 714 692 ;\r\nC 84 ; WX 790 ; N a47 ; B 34 -14 756 705 ;\r\nC 85 ; WX 792 ; N a48 ; B 35 -14 758 705 ;\r\nC 86 ; WX 695 ; N a49 ; B 35 -14 661 706 ;\r\nC 87 ; WX 776 ; N a50 ; B 35 -6 741 699 ;\r\nC 88 ; WX 768 ; N a51 ; B 35 -7 734 699 ;\r\nC 89 ; WX 792 ; N a52 ; B 35 -14 757 705 ;\r\nC 90 ; WX 759 ; N a53 ; B 35 0 725 692 ;\r\nC 91 ; WX 707 ; N a54 ; B 35 -13 672 704 ;\r\nC 92 ; WX 708 ; N a55 ; B 35 -14 672 705 ;\r\nC 93 ; WX 682 ; N a56 ; B 35 -14 647 705 ;\r\nC 94 ; WX 701 ; N a57 ; B 35 -14 666 705 ;\r\nC 95 ; WX 826 ; N a58 ; B 35 -14 791 705 ;\r\nC 96 ; WX 815 ; N a59 ; B 35 -14 780 705 ;\r\nC 97 ; WX 789 ; N a60 ; B 35 -14 754 705 ;\r\nC 98 ; WX 789 ; N a61 ; B 35 -14 754 705 ;\r\nC 99 ; WX 707 ; N a62 ; B 34 -14 673 705 ;\r\nC 100 ; WX 687 ; N a63 ; B 36 0 651 692 ;\r\nC 101 ; WX 696 ; N a64 ; B 35 0 661 691 ;\r\nC 102 ; WX 689 ; N a65 ; B 35 0 655 692 ;\r\nC 103 ; WX 786 ; N a66 ; B 34 -14 751 705 ;\r\nC 104 ; WX 787 ; N a67 ; B 35 -14 752 705 ;\r\nC 105 ; WX 713 ; N a68 ; B 35 -14 678 705 ;\r\nC 106 ; WX 791 ; N a69 ; B 35 -14 756 705 ;\r\nC 107 ; WX 785 ; N a70 ; B 36 -14 751 705 ;\r\nC 108 ; WX 791 ; N a71 ; B 35 -14 757 705 ;\r\nC 109 ; WX 873 ; N a72 ; B 35 -14 838 705 ;\r\nC 110 ; WX 761 ; N a73 ; B 35 0 726 692 ;\r\nC 111 ; WX 762 ; N a74 ; B 35 0 727 692 ;\r\nC 112 ; WX 762 ; N a203 ; B 35 0 727 692 ;\r\nC 113 ; WX 759 ; N a75 ; B 35 0 725 692 ;\r\nC 114 ; WX 759 ; N a204 ; B 35 0 725 692 ;\r\nC 115 ; WX 892 ; N a76 ; B 35 0 858 705 ;\r\nC 116 ; WX 892 ; N a77 ; B 35 -14 858 692 ;\r\nC 117 ; WX 788 ; N a78 ; B 35 -14 754 705 ;\r\nC 118 ; WX 784 ; N a79 ; B 35 -14 749 705 ;\r\nC 119 ; WX 438 ; N a81 ; B 35 -14 403 705 ;\r\nC 120 ; WX 138 ; N a82 ; B 35 0 104 692 ;\r\nC 121 ; WX 277 ; N a83 ; B 35 0 242 692 ;\r\nC 122 ; WX 415 ; N a84 ; B 35 0 380 692 ;\r\nC 123 ; WX 392 ; N a97 ; B 35 263 357 705 ;\r\nC 124 ; WX 392 ; N a98 ; B 34 263 357 705 ;\r\nC 125 ; WX 668 ; N a99 ; B 35 263 633 705 ;\r\nC 126 ; WX 668 ; N a100 ; B 36 263 634 705 ;\r\nC 128 ; WX 390 ; N a89 ; B 35 -14 356 705 ;\r\nC 129 ; WX 390 ; N a90 ; B 35 -14 355 705 ;\r\nC 130 ; WX 317 ; N a93 ; B 35 0 283 692 ;\r\nC 131 ; WX 317 ; N a94 ; B 35 0 283 692 ;\r\nC 132 ; WX 276 ; N a91 ; B 35 0 242 692 ;\r\nC 133 ; WX 276 ; N a92 ; B 35 0 242 692 ;\r\nC 134 ; WX 509 ; N a205 ; B 35 0 475 692 ;\r\nC 135 ; WX 509 ; N a85 ; B 35 0 475 692 ;\r\nC 136 ; WX 410 ; N a206 ; B 35 0 375 692 ;\r\nC 137 ; WX 410 ; N a86 ; B 35 0 375 692 ;\r\nC 138 ; WX 234 ; N a87 ; B 35 -14 199 705 ;\r\nC 139 ; WX 234 ; N a88 ; B 35 -14 199 705 ;\r\nC 140 ; WX 334 ; N a95 ; B 35 0 299 692 ;\r\nC 141 ; WX 334 ; N a96 ; B 35 0 299 692 ;\r\nC 161 ; WX 732 ; N a101 ; B 35 -143 697 806 ;\r\nC 162 ; WX 544 ; N a102 ; B 56 -14 488 706 ;\r\nC 163 ; WX 544 ; N a103 ; B 34 -14 508 705 ;\r\nC 164 ; WX 910 ; N a104 ; B 35 40 875 651 ;\r\nC 165 ; WX 667 ; N a106 ; B 35 -14 633 705 ;\r\nC 166 ; WX 760 ; N a107 ; B 35 -14 726 705 ;\r\nC 167 ; WX 760 ; N a108 ; B 0 121 758 569 ;\r\nC 168 ; WX 776 ; N a112 ; B 35 0 741 705 ;\r\nC 169 ; WX 595 ; N a111 ; B 34 -14 560 705 ;\r\nC 170 ; WX 694 ; N a110 ; B 35 -14 659 705 ;\r\nC 171 ; WX 626 ; N a109 ; B 34 0 591 705 ;\r\nC 172 ; WX 788 ; N a120 ; B 35 -14 754 705 ;\r\nC 173 ; WX 788 ; N a121 ; B 35 -14 754 705 ;\r\nC 174 ; WX 788 ; N a122 ; B 35 -14 754 705 ;\r\nC 175 ; WX 788 ; N a123 ; B 35 -14 754 705 ;\r\nC 176 ; WX 788 ; N a124 ; B 35 -14 754 705 ;\r\nC 177 ; WX 788 ; N a125 ; B 35 -14 754 705 ;\r\nC 178 ; WX 788 ; N a126 ; B 35 -14 754 705 ;\r\nC 179 ; WX 788 ; N a127 ; B 35 -14 754 705 ;\r\nC 180 ; WX 788 ; N a128 ; B 35 -14 754 705 ;\r\nC 181 ; WX 788 ; N a129 ; B 35 -14 754 705 ;\r\nC 182 ; WX 788 ; N a130 ; B 35 -14 754 705 ;\r\nC 183 ; WX 788 ; N a131 ; B 35 -14 754 705 ;\r\nC 184 ; WX 788 ; N a132 ; B 35 -14 754 705 ;\r\nC 185 ; WX 788 ; N a133 ; B 35 -14 754 705 ;\r\nC 186 ; WX 788 ; N a134 ; B 35 -14 754 705 ;\r\nC 187 ; WX 788 ; N a135 ; B 35 -14 754 705 ;\r\nC 188 ; WX 788 ; N a136 ; B 35 -14 754 705 ;\r\nC 189 ; WX 788 ; N a137 ; B 35 -14 754 705 ;\r\nC 190 ; WX 788 ; N a138 ; B 35 -14 754 705 ;\r\nC 191 ; WX 788 ; N a139 ; B 35 -14 754 705 ;\r\nC 192 ; WX 788 ; N a140 ; B 35 -14 754 705 ;\r\nC 193 ; WX 788 ; N a141 ; B 35 -14 754 705 ;\r\nC 194 ; WX 788 ; N a142 ; B 35 -14 754 705 ;\r\nC 195 ; WX 788 ; N a143 ; B 35 -14 754 705 ;\r\nC 196 ; WX 788 ; N a144 ; B 35 -14 754 705 ;\r\nC 197 ; WX 788 ; N a145 ; B 35 -14 754 705 ;\r\nC 198 ; WX 788 ; N a146 ; B 35 -14 754 705 ;\r\nC 199 ; WX 788 ; N a147 ; B 35 -14 754 705 ;\r\nC 200 ; WX 788 ; N a148 ; B 35 -14 754 705 ;\r\nC 201 ; WX 788 ; N a149 ; B 35 -14 754 705 ;\r\nC 202 ; WX 788 ; N a150 ; B 35 -14 754 705 ;\r\nC 203 ; WX 788 ; N a151 ; B 35 -14 754 705 ;\r\nC 204 ; WX 788 ; N a152 ; B 35 -14 754 705 ;\r\nC 205 ; WX 788 ; N a153 ; B 35 -14 754 705 ;\r\nC 206 ; WX 788 ; N a154 ; B 35 -14 754 705 ;\r\nC 207 ; WX 788 ; N a155 ; B 35 -14 754 705 ;\r\nC 208 ; WX 788 ; N a156 ; B 35 -14 754 705 ;\r\nC 209 ; WX 788 ; N a157 ; B 35 -14 754 705 ;\r\nC 210 ; WX 788 ; N a158 ; B 35 -14 754 705 ;\r\nC 211 ; WX 788 ; N a159 ; B 35 -14 754 705 ;\r\nC 212 ; WX 894 ; N a160 ; B 35 58 860 634 ;\r\nC 213 ; WX 838 ; N a161 ; B 35 152 803 540 ;\r\nC 214 ; WX 1016 ; N a163 ; B 34 152 981 540 ;\r\nC 215 ; WX 458 ; N a164 ; B 35 -127 422 820 ;\r\nC 216 ; WX 748 ; N a196 ; B 35 94 698 597 ;\r\nC 217 ; WX 924 ; N a165 ; B 35 140 890 552 ;\r\nC 218 ; WX 748 ; N a192 ; B 35 94 698 597 ;\r\nC 219 ; WX 918 ; N a166 ; B 35 166 884 526 ;\r\nC 220 ; WX 927 ; N a167 ; B 35 32 892 660 ;\r\nC 221 ; WX 928 ; N a168 ; B 35 129 891 562 ;\r\nC 222 ; WX 928 ; N a169 ; B 35 128 893 563 ;\r\nC 223 ; WX 834 ; N a170 ; B 35 155 799 537 ;\r\nC 224 ; WX 873 ; N a171 ; B 35 93 838 599 ;\r\nC 225 ; WX 828 ; N a172 ; B 35 104 791 588 ;\r\nC 226 ; WX 924 ; N a173 ; B 35 98 889 594 ;\r\nC 227 ; WX 924 ; N a162 ; B 35 98 889 594 ;\r\nC 228 ; WX 917 ; N a174 ; B 35 0 882 692 ;\r\nC 229 ; WX 930 ; N a175 ; B 35 84 896 608 ;\r\nC 230 ; WX 931 ; N a176 ; B 35 84 896 608 ;\r\nC 231 ; WX 463 ; N a177 ; B 35 -99 429 791 ;\r\nC 232 ; WX 883 ; N a178 ; B 35 71 848 623 ;\r\nC 233 ; WX 836 ; N a179 ; B 35 44 802 648 ;\r\nC 234 ; WX 836 ; N a193 ; B 35 44 802 648 ;\r\nC 235 ; WX 867 ; N a180 ; B 35 101 832 591 ;\r\nC 236 ; WX 867 ; N a199 ; B 35 101 832 591 ;\r\nC 237 ; WX 696 ; N a181 ; B 35 44 661 648 ;\r\nC 238 ; WX 696 ; N a200 ; B 35 44 661 648 ;\r\nC 239 ; WX 874 ; N a182 ; B 35 77 840 619 ;\r\nC 241 ; WX 874 ; N a201 ; B 35 73 840 615 ;\r\nC 242 ; WX 760 ; N a183 ; B 35 0 725 692 ;\r\nC 243 ; WX 946 ; N a184 ; B 35 160 911 533 ;\r\nC 244 ; WX 771 ; N a197 ; B 34 37 736 655 ;\r\nC 245 ; WX 865 ; N a185 ; B 35 207 830 481 ;\r\nC 246 ; WX 771 ; N a194 ; B 34 37 736 655 ;\r\nC 247 ; WX 888 ; N a198 ; B 34 -19 853 712 ;\r\nC 248 ; WX 967 ; N a186 ; B 35 124 932 568 ;\r\nC 249 ; WX 888 ; N a195 ; B 34 -19 853 712 ;\r\nC 250 ; WX 831 ; N a187 ; B 35 113 796 579 ;\r\nC 251 ; WX 873 ; N a188 ; B 36 118 838 578 ;\r\nC 252 ; WX 927 ; N a189 ; B 35 150 891 542 ;\r\nC 253 ; WX 970 ; N a190 ; B 35 76 931 616 ;\r\nC 254 ; WX 918 ; N a191 ; B 34 99 884 593 ;\r\nEndCharMetrics\r\nEndFontMetrics\r\n";
                  },
                };
  
                class StandardFont extends PDFFont {
                  constructor(document, name, id) {
                    super();
                    this.document = document;
                    this.name = name;
                    this.id = id;
                    this.font = new AFMFont(STANDARD_FONTS[this.name]());
                    ({
                      ascender: this.ascender,
                      descender: this.descender,
                      bbox: this.bbox,
                      lineGap: this.lineGap,
                      xHeight: this.xHeight,
                      capHeight: this.capHeight,
                    } = this.font);
                  }
  
                  embed() {
                    this.dictionary.data = {
                      Type: "Font",
                      BaseFont: this.name,
                      Subtype: "Type1",
                      Encoding: "WinAnsiEncoding",
                    };
                    return this.dictionary.end();
                  }
  
                  encode(text) {
                    const encoded = this.font.encodeText(text);
                    const glyphs = this.font.glyphsForString(`${text}`);
                    const advances = this.font.advancesForGlyphs(glyphs);
                    const positions = [];
  
                    for (let i = 0; i < glyphs.length; i++) {
                      const glyph = glyphs[i];
                      positions.push({
                        xAdvance: advances[i],
                        yAdvance: 0,
                        xOffset: 0,
                        yOffset: 0,
                        advanceWidth: this.font.widthOfGlyph(glyph),
                      });
                    }
  
                    return [encoded, positions];
                  }
  
                  widthOfString(string, size) {
                    const glyphs = this.font.glyphsForString(`${string}`);
                    const advances = this.font.advancesForGlyphs(glyphs);
                    let width = 0;
  
                    for (let advance of advances) {
                      width += advance;
                    }
  
                    const scale = size / 1000;
                    return width * scale;
                  }
  
                  static isStandardFont(name) {
                    return name in STANDARD_FONTS;
                  }
                }
  
                const toHex = function (num) {
                  return `0000${num.toString(16)}`.slice(-4);
                };
  
                class EmbeddedFont extends PDFFont {
                  constructor(document, font, id) {
                    super();
                    this.document = document;
                    this.font = font;
                    this.id = id;
                    this.subset = this.font.createSubset();
                    this.unicode = [[0]];
                    this.widths = [this.font.getGlyph(0).advanceWidth];
                    this.name = this.font.postscriptName;
                    this.scale = 1000 / this.font.unitsPerEm;
                    this.ascender = this.font.ascent * this.scale;
                    this.descender = this.font.descent * this.scale;
                    this.xHeight = this.font.xHeight * this.scale;
                    this.capHeight = this.font.capHeight * this.scale;
                    this.lineGap = this.font.lineGap * this.scale;
                    this.bbox = this.font.bbox;
  
                    if (document.options.fontLayoutCache !== false) {
                      this.layoutCache = Object.create(null);
                    }
                  }
  
                  layoutRun(text, features) {
                    const run = this.font.layout(text, features); // Normalize position values
  
                    for (let i = 0; i < run.positions.length; i++) {
                      const position = run.positions[i];
  
                      for (let key in position) {
                        position[key] *= this.scale;
                      }
  
                      position.advanceWidth =
                        run.glyphs[i].advanceWidth * this.scale;
                    }
  
                    return run;
                  }
  
                  layoutCached(text) {
                    if (!this.layoutCache) {
                      return this.layoutRun(text);
                    }
  
                    let cached;
  
                    if ((cached = this.layoutCache[text])) {
                      return cached;
                    }
  
                    const run = this.layoutRun(text);
                    this.layoutCache[text] = run;
                    return run;
                  }
  
                  layout(text, features, onlyWidth) {
                    // Skip the cache if any user defined features are applied
                    if (features) {
                      return this.layoutRun(text, features);
                    }
  
                    let glyphs = onlyWidth ? null : [];
                    let positions = onlyWidth ? null : [];
                    let advanceWidth = 0; // Split the string by words to increase cache efficiency.
                    // For this purpose, spaces and tabs are a good enough delimeter.
  
                    let last = 0;
                    let index = 0;
  
                    while (index <= text.length) {
                      var needle;
  
                      if (
                        (index === text.length && last < index) ||
                        ((needle = text.charAt(index)),
                        [" ", "\t"].includes(needle))
                      ) {
                        const run = this.layoutCached(text.slice(last, ++index));
  
                        if (!onlyWidth) {
                          glyphs = glyphs.concat(run.glyphs);
                          positions = positions.concat(run.positions);
                        }
  
                        advanceWidth += run.advanceWidth;
                        last = index;
                      } else {
                        index++;
                      }
                    }
  
                    return {
                      glyphs,
                      positions,
                      advanceWidth,
                    };
                  }
  
                  encode(text, features) {
                    const { glyphs, positions } = this.layout(text, features);
                    const res = [];
  
                    for (let i = 0; i < glyphs.length; i++) {
                      const glyph = glyphs[i];
                      const gid = this.subset.includeGlyph(glyph.id);
                      res.push(`0000${gid.toString(16)}`.slice(-4));
  
                      if (this.widths[gid] == null) {
                        this.widths[gid] = glyph.advanceWidth * this.scale;
                      }
  
                      if (this.unicode[gid] == null) {
                        this.unicode[gid] = glyph.codePoints;
                      }
                    }
  
                    return [res, positions];
                  }
  
                  widthOfString(string, size, features) {
                    const width = this.layout(
                      string,
                      features,
                      true
                    ).advanceWidth;
                    const scale = size / 1000;
                    return width * scale;
                  }
  
                  embed() {
                    const isCFF = this.subset.cff != null;
                    const fontFile = this.document.ref();
  
                    if (isCFF) {
                      fontFile.data.Subtype = "CIDFontType0C";
                    }
  
                    this.subset
                      .encodeStream()
                      .on("data", (data) => fontFile.write(data))
                      .on("end", () => fontFile.end());
                    const familyClass =
                      ((this.font["OS/2"] != null
                        ? this.font["OS/2"].sFamilyClass
                        : undefined) || 0) >> 8;
                    let flags = 0;
  
                    if (this.font.post.isFixedPitch) {
                      flags |= 1 << 0;
                    }
  
                    if (1 <= familyClass && familyClass <= 7) {
                      flags |= 1 << 1;
                    }
  
                    flags |= 1 << 2; // assume the font uses non-latin characters
  
                    if (familyClass === 10) {
                      flags |= 1 << 3;
                    }
  
                    if (this.font.head.macStyle.italic) {
                      flags |= 1 << 6;
                    } // generate a tag (6 uppercase letters. 17 is the char code offset from '0' to 'A'. 73 will map to 'Z')
  
                    const tag = [1, 2, 3, 4, 5, 6]
                      .map((i) =>
                        String.fromCharCode((this.id.charCodeAt(i) || 73) + 17)
                      )
                      .join("");
                    const name = tag + "+" + this.font.postscriptName;
                    const { bbox } = this.font;
                    const descriptor = this.document.ref({
                      Type: "FontDescriptor",
                      FontName: name,
                      Flags: flags,
                      FontBBox: [
                        bbox.minX * this.scale,
                        bbox.minY * this.scale,
                        bbox.maxX * this.scale,
                        bbox.maxY * this.scale,
                      ],
                      ItalicAngle: this.font.italicAngle,
                      Ascent: this.ascender,
                      Descent: this.descender,
                      CapHeight:
                        (this.font.capHeight || this.font.ascent) * this.scale,
                      XHeight: (this.font.xHeight || 0) * this.scale,
                      StemV: 0,
                    }); // not sure how to calculate this
  
                    if (isCFF) {
                      descriptor.data.FontFile3 = fontFile;
                    } else {
                      descriptor.data.FontFile2 = fontFile;
                    }
  
                    descriptor.end();
                    const descendantFontData = {
                      Type: "Font",
                      Subtype: "CIDFontType0",
                      BaseFont: name,
                      CIDSystemInfo: {
                        Registry: new String("Adobe"),
                        Ordering: new String("Identity"),
                        Supplement: 0,
                      },
                      FontDescriptor: descriptor,
                      W: [0, this.widths],
                    };
  
                    if (!isCFF) {
                      descendantFontData.Subtype = "CIDFontType2";
                      descendantFontData.CIDToGIDMap = "Identity";
                    }
  
                    const descendantFont = this.document.ref(descendantFontData);
                    descendantFont.end();
                    this.dictionary.data = {
                      Type: "Font",
                      Subtype: "Type0",
                      BaseFont: name,
                      Encoding: "Identity-H",
                      DescendantFonts: [descendantFont],
                      ToUnicode: this.toUnicodeCmap(),
                    };
                    return this.dictionary.end();
                  } // Maps the glyph ids encoded in the PDF back to unicode strings
                  // Because of ligature substitutions and the like, there may be one or more
                  // unicode characters represented by each glyph.
  
                  toUnicodeCmap() {
                    const cmap = this.document.ref();
                    const entries = [];
  
                    for (let codePoints of this.unicode) {
                      const encoded = []; // encode codePoints to utf16
  
                      for (let value of codePoints) {
                        if (value > 0xffff) {
                          value -= 0x10000;
                          encoded.push(toHex(((value >>> 10) & 0x3ff) | 0xd800));
                          value = 0xdc00 | (value & 0x3ff);
                        }
  
                        encoded.push(toHex(value));
                      }
  
                      entries.push(`<${encoded.join(" ")}>`);
                    }
  
                    cmap.end(`\
  /CIDInit /ProcSet findresource begin
  12 dict begin
  begincmap
  /CIDSystemInfo <<
    /Registry (Adobe)
    /Ordering (UCS)
    /Supplement 0
  >> def
  /CMapName /Adobe-Identity-UCS def
  /CMapType 2 def
  1 begincodespacerange
  <0000><ffff>
  endcodespacerange
  1 beginbfrange
  <0000> <${toHex(entries.length - 1)}> [${entries.join(" ")}]
  endbfrange
  endcmap
  CMapName currentdict /CMap defineresource pop
  end
  end\
  `);
                    return cmap;
                  }
                }
  
                class PDFFontFactory {
                  static open(document, src, family, id) {
                    let font;
  
                    if (typeof src === "string") {
                      if (StandardFont.isStandardFont(src)) {
                        return new StandardFont(document, src, id);
                      }
  
                      src = fs.readFileSync(src);
                    }
  
                    if (Buffer.isBuffer(src)) {
                      font = fontkit.create(src, family);
                    } else if (src instanceof Uint8Array) {
                      font = fontkit.create(Buffer.from(src), family);
                    } else if (src instanceof ArrayBuffer) {
                      font = fontkit.create(
                        Buffer.from(new Uint8Array(src)),
                        family
                      );
                    }
  
                    if (font == null) {
                      throw new Error(
                        "Not a supported font format or standard PDF font."
                      );
                    }
  
                    return new EmbeddedFont(document, font, id);
                  }
                }
  
                var FontsMixin = {
                  initFonts(defaultFont = "Helvetica") {
                    // Lookup table for embedded fonts
                    this._fontFamilies = {};
                    this._fontCount = 0; // Font state
  
                    this._defaultFont = "Helvetica";
                    this._fontSize = 12;
                    this._font = null;
                    this._registeredFonts = {}; // Set the default font
  
                    if (defaultFont) {
                      this.font(defaultFont);
                    }
                  },
  
                  font(src, family, size) {
                    let executed = false;
                    if (
                      src === "Helvetica" ||
                      src === "Times-Roman" ||
                      src === "Courier"
                    ) {
                      let cacheKey, font;
                      if (typeof family === "number") {
                        size = family;
                        family = null;
                      } // check registered fonts if src is a string
                      if (typeof src === "string" && this._registeredFonts[src]) {
                        cacheKey = src;
                        ({ src, family } = this._registeredFonts[src]);
                      } else {
                        cacheKey = family || src;
                        if (typeof cacheKey !== "string") {
                          cacheKey = null;
                        }
                      }
                      if (size != null) {
                        this.fontSize(size);
                      } // fast path: check if the font is already in the PDF
                      if ((font = this._fontFamilies[cacheKey])) {
                        this._font = font;
                        return this;
                      } // load the font
                      const id = `F${++this._fontCount}`;
                      this._font = PDFFontFactory.open(this, src, family, id); // check for existing font familes with the same name already in the PDF
                      // useful if the font was passed as a buffer
                      if ((font = this._fontFamilies[this._font.name])) {
                        this._font = font;
                        return this;
                      } // save the font for reuse later
                      if (cacheKey) {
                        this._fontFamilies[cacheKey] = this._font;
                      }
                      if (this._font.name) {
                        this._fontFamilies[this._font.name] = this._font;
                      }
                      return this;
                    } else {
                      if (!executed) {
                        executed = true;
                        this.font(this._defaultFont);
                      }
                    }
                  },
  
                  fontSize(_fontSize) {
                    this._fontSize = _fontSize;
                    return this;
                  },
  
                  currentLineHeight(includeGap) {
                    if (includeGap == null) {
                      includeGap = false;
                    }
  
                    return this._font.lineHeight(this._fontSize, includeGap);
                  },
  
                  registerFont(name, src, family) {
                    this._registeredFonts[name] = {
                      src,
                      family,
                    };
                    return this;
                  },
                };
  
                class LineWrapper extends events.EventEmitter {
                  constructor(document, options) {
                    super();
                    this.document = document;
                    this.indent = options.indent || 0;
                    this.characterSpacing = options.characterSpacing || 0;
                    this.wordSpacing = options.wordSpacing === 0;
                    this.columns = options.columns || 1;
                    this.columnGap =
                      options.columnGap != null ? options.columnGap : 18; // 1/4 inch
  
                    this.lineWidth =
                      (options.width - this.columnGap * (this.columns - 1)) /
                      this.columns;
                    this.spaceLeft = this.lineWidth;
                    this.startX = this.document.x;
                    this.startY = this.document.y;
                    this.column = 1;
                    this.ellipsis = options.ellipsis;
                    this.continuedX = 0;
                    this.features = options.features; // calculate the maximum Y position the text can appear at
  
                    if (options.height != null) {
                      this.height = options.height;
                      this.maxY = this.startY + options.height;
                    } else {
                      this.maxY = this.document.page.maxY();
                    } // handle paragraph indents
  
                    this.on("firstLine", (options) => {
                      // if this is the first line of the text segment, and
                      // we're continuing where we left off, indent that much
                      // otherwise use the user specified indent option
                      const indent = this.continuedX || this.indent;
                      this.document.x += indent;
                      this.lineWidth -= indent;
                      return this.once("line", () => {
                        this.document.x -= indent;
                        this.lineWidth += indent;
  
                        if (options.continued && !this.continuedX) {
                          this.continuedX = this.indent;
                        }
  
                        if (!options.continued) {
                          return (this.continuedX = 0);
                        }
                      });
                    }); // handle left aligning last lines of paragraphs
  
                    this.on("lastLine", (options) => {
                      const { align } = options;
  
                      if (align === "justify") {
                        options.align = "left";
                      }
  
                      this.lastLine = true;
                      return this.once("line", () => {
                        this.document.y += options.paragraphGap || 0;
                        options.align = align;
                        return (this.lastLine = false);
                      });
                    });
                  }
  
                  wordWidth(word) {
                    return (
                      this.document.widthOfString(word, this) +
                      this.characterSpacing +
                      this.wordSpacing
                    );
                  }
  
                  eachWord(text, fn) {
                    // setup a unicode line breaker
                    let bk;
                    const breaker = new LineBreaker(text);
                    let last = null;
                    const wordWidths = Object.create(null);
  
                    while ((bk = breaker.nextBreak())) {
                      var shouldContinue;
                      let word = text.slice(
                        (last != null ? last.position : undefined) || 0,
                        bk.position
                      );
                      let w =
                        wordWidths[word] != null
                          ? wordWidths[word]
                          : (wordWidths[word] = this.wordWidth(word)); // if the word is longer than the whole line, chop it up
                      // TODO: break by grapheme clusters, not JS string characters
  
                      if (w > this.lineWidth + this.continuedX) {
                        // make some fake break objects
                        let lbk = last;
                        const fbk = {};
  
                        while (word.length) {
                          // fit as much of the word as possible into the space we have
                          var l, mightGrow;
  
                          if (w > this.spaceLeft) {
                            // start our check at the end of our available space - this method is faster than a loop of each character and it resolves
                            // an issue with long loops when processing massive words, such as a huge number of spaces
                            l = Math.ceil(this.spaceLeft / (w / word.length));
                            w = this.wordWidth(word.slice(0, l));
                            mightGrow = w <= this.spaceLeft && l < word.length;
                          } else {
                            l = word.length;
                          }
  
                          let mustShrink = w > this.spaceLeft && l > 0; // shrink or grow word as necessary after our near-guess above
  
                          while (mustShrink || mightGrow) {
                            if (mustShrink) {
                              w = this.wordWidth(word.slice(0, --l));
                              mustShrink = w > this.spaceLeft && l > 0;
                            } else {
                              w = this.wordWidth(word.slice(0, ++l));
                              mustShrink = w > this.spaceLeft && l > 0;
                              mightGrow = w <= this.spaceLeft && l < word.length;
                            }
                          } // check for the edge case where a single character cannot fit into a line.
  
                          if (l === 0 && this.spaceLeft === this.lineWidth) {
                            l = 1;
                          } // send a required break unless this is the last piece and a linebreak is not specified
  
                          fbk.required = bk.required || l < word.length;
                          shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
                          lbk = {
                            required: false,
                          }; // get the remaining piece of the word
  
                          word = word.slice(l);
                          w = this.wordWidth(word);
  
                          if (shouldContinue === false) {
                            break;
                          }
                        }
                      } else {
                        // otherwise just emit the break as it was given to us
                        shouldContinue = fn(word, w, bk, last);
                      }
  
                      if (shouldContinue === false) {
                        break;
                      }
  
                      last = bk;
                    }
                  }
  
                  wrap(text, options) {
                    // override options from previous continued fragments
                    if (options.indent != null) {
                      this.indent = options.indent;
                    }
  
                    if (options.characterSpacing != null) {
                      this.characterSpacing = options.characterSpacing;
                    }
  
                    if (options.wordSpacing != null) {
                      this.wordSpacing = options.wordSpacing;
                    }
  
                    if (options.ellipsis != null) {
                      this.ellipsis = options.ellipsis;
                    } // make sure we're actually on the page
                    // and that the first line of is never by
                    // itself at the bottom of a page (orphans)
  
                    const nextY =
                      this.document.y + this.document.currentLineHeight(true);
  
                    if (this.document.y > this.maxY || nextY > this.maxY) {
                      this.nextSection();
                    }
  
                    let buffer = "";
                    let textWidth = 0;
                    let wc = 0;
                    let lc = 0;
                    let { y } = this.document; // used to reset Y pos if options.continued (below)
  
                    const emitLine = () => {
                      options.textWidth = textWidth + this.wordSpacing * (wc - 1);
                      options.wordCount = wc;
                      options.lineWidth = this.lineWidth;
                      ({ y } = this.document);
                      this.emit("line", buffer, options, this);
                      return lc++;
                    };
  
                    this.emit("sectionStart", options, this);
                    this.eachWord(text, (word, w, bk, last) => {
                      if (last == null || last.required) {
                        this.emit("firstLine", options, this);
                        this.spaceLeft = this.lineWidth;
                      }
  
                      if (w <= this.spaceLeft) {
                        buffer += word;
                        textWidth += w;
                        wc++;
                      }
  
                      if (bk.required || w > this.spaceLeft) {
                        // if the user specified a max height and an ellipsis, and is about to pass the
                        // max height and max columns after the next line, append the ellipsis
                        const lh = this.document.currentLineHeight(true);
  
                        if (
                          this.height != null &&
                          this.ellipsis &&
                          this.document.y + lh * 2 > this.maxY &&
                          this.column >= this.columns
                        ) {
                          if (this.ellipsis === true) {
                            this.ellipsis = "…";
                          } // map default ellipsis character
  
                          buffer = buffer.replace(/\s+$/, "");
                          textWidth = this.wordWidth(buffer + this.ellipsis); // remove characters from the buffer until the ellipsis fits
                          // to avoid infinite loop need to stop while-loop if buffer is empty string
  
                          while (buffer && textWidth > this.lineWidth) {
                            buffer = buffer.slice(0, -1).replace(/\s+$/, "");
                            textWidth = this.wordWidth(buffer + this.ellipsis);
                          } // need to add ellipsis only if there is enough space for it
  
                          if (textWidth <= this.lineWidth) {
                            buffer = buffer + this.ellipsis;
                          }
  
                          textWidth = this.wordWidth(buffer);
                        }
  
                        if (bk.required) {
                          if (w > this.spaceLeft) {
                            emitLine();
                            buffer = word;
                            textWidth = w;
                            wc = 1;
                          }
  
                          this.emit("lastLine", options, this);
                        }
  
                        emitLine(); // if we've reached the edge of the page,
                        // continue on a new page or column
  
                        if (this.document.y + lh > this.maxY) {
                          const shouldContinue = this.nextSection(); // stop if we reached the maximum height
  
                          if (!shouldContinue) {
                            wc = 0;
                            buffer = "";
                            return false;
                          }
                        } // reset the space left and buffer
  
                        if (bk.required) {
                          this.spaceLeft = this.lineWidth;
                          buffer = "";
                          textWidth = 0;
                          return (wc = 0);
                        } else {
                          // reset the space left and buffer
                          this.spaceLeft = this.lineWidth - w;
                          buffer = word;
                          textWidth = w;
                          return (wc = 1);
                        }
                      } else {
                        return (this.spaceLeft -= w);
                      }
                    });
  
                    if (wc > 0) {
                      this.emit("lastLine", options, this);
                      emitLine();
                    }
  
                    this.emit("sectionEnd", options, this); // if the wrap is set to be continued, save the X position
                    // to start the first line of the next segment at, and reset
                    // the y position
  
                    if (options.continued === true) {
                      if (lc > 1) {
                        this.continuedX = 0;
                      }
  
                      this.continuedX += options.textWidth || 0;
                      return (this.document.y = y);
                    } else {
                      return (this.document.x = this.startX);
                    }
                  }
  
                  nextSection(options) {
                    this.emit("sectionEnd", options, this);
  
                    if (++this.column > this.columns) {
                      // if a max height was specified by the user, we're done.
                      // otherwise, the default is to make a new page at the bottom.
                      if (this.height != null) {
                        return false;
                      }
  
                      this.document.continueOnNewPage();
                      this.column = 1;
                      this.startY = this.document.page.margins.top;
                      this.maxY = this.document.page.maxY();
                      this.document.x = this.startX;
  
                      if (this.document._fillColor) {
                        this.document.fillColor(...this.document._fillColor);
                      }
  
                      this.emit("pageBreak", options, this);
                    } else {
                      this.document.x += this.lineWidth + this.columnGap;
                      this.document.y = this.startY;
                      this.emit("columnBreak", options, this);
                    }
  
                    this.emit("sectionStart", options, this);
                    return true;
                  }
                }
  
                const { number: number$2 } = PDFObject;
                var TextMixin = {
                  initText() {
                    this._line = this._line.bind(this); // Current coordinates
  
                    this.x = 0;
                    this.y = 0;
                    return (this._lineGap = 0);
                  },
  
                  lineGap(_lineGap) {
                    this._lineGap = _lineGap;
                    return this;
                  },
  
                  moveDown(lines) {
                    if (lines == null) {
                      lines = 1;
                    }
  
                    this.y +=
                      this.currentLineHeight(true) * lines + this._lineGap;
                    return this;
                  },
  
                  moveUp(lines) {
                    if (lines == null) {
                      lines = 1;
                    }
  
                    this.y -=
                      this.currentLineHeight(true) * lines + this._lineGap;
                    return this;
                  },
  
                  _text(text, x, y, options, lineCallback) {
                    options = this._initOptions(x, y, options); // Convert text to a string
  
                    text = text == null ? "" : `${text}`; // if the wordSpacing option is specified, remove multiple consecutive spaces
  
                    if (options.wordSpacing) {
                      text = text.replace(/\s{2,}/g, " ");
                    }
  
                    const addStructure = () => {
                      if (options.structParent) {
                        options.structParent.add(
                          this.struct(options.structType || "P", [
                            this.markStructureContent(options.structType || "P"),
                          ])
                        );
                      }
                    }; // word wrapping
  
                    if (options.width) {
                      let wrapper = this._wrapper;
  
                      if (!wrapper) {
                        wrapper = new LineWrapper(this, options);
                        wrapper.on("line", lineCallback);
                        wrapper.on("firstLine", addStructure);
                      }
  
                      this._wrapper = options.continued ? wrapper : null;
                      this._textOptions = options.continued ? options : null;
                      wrapper.wrap(text, options); // render paragraphs as single lines
                    } else {
                      for (let line of text.split("\n")) {
                        addStructure();
                        lineCallback(line, options);
                      }
                    }
  
                    return this;
                  },
  
                  text(text, x, y, options) {
                    return this._text(text, x, y, options, this._line);
                  },
  
                  widthOfString(string, options = {}) {
                    return (
                      this._font.widthOfString(
                        string,
                        this._fontSize,
                        options.features
                      ) +
                      (options.characterSpacing || 0) * (string.length - 1)
                    );
                  },
  
                  heightOfString(text, options) {
                    const { x, y } = this;
                    options = this._initOptions(options);
                    options.height = Infinity; // don't break pages
  
                    const lineGap = options.lineGap || this._lineGap || 0;
  
                    this._text(text, this.x, this.y, options, () => {
                      return (this.y += this.currentLineHeight(true) + lineGap);
                    });
  
                    const height = this.y - y;
                    this.x = x;
                    this.y = y;
                    return height;
                  },
  
                  list(list, x, y, options, wrapper) {
                    options = this._initOptions(x, y, options);
                    const listType = options.listType || "bullet";
                    const unit = Math.round(
                      (this._font.ascender / 1000) * this._fontSize
                    );
                    const midLine = unit / 2;
                    const r = options.bulletRadius || unit / 3;
                    const indent =
                      options.textIndent ||
                      (listType === "bullet" ? r * 5 : unit * 2);
                    const itemIndent =
                      options.bulletIndent ||
                      (listType === "bullet" ? r * 8 : unit * 2);
                    let level = 1;
                    const items = [];
                    const levels = [];
                    const numbers = [];
  
                    var flatten = function (list) {
                      let n = 1;
  
                      for (let i = 0; i < list.length; i++) {
                        const item = list[i];
  
                        if (Array.isArray(item)) {
                          level++;
                          flatten(item);
                          level--;
                        } else {
                          items.push(item);
                          levels.push(level);
  
                          if (listType !== "bullet") {
                            numbers.push(n++);
                          }
                        }
                      }
                    };
  
                    flatten(list);
  
                    const label = function (n) {
                      switch (listType) {
                        case "numbered":
                          return `${n}.`;
  
                        case "lettered":
                          var letter = String.fromCharCode(((n - 1) % 26) + 65);
                          var times = Math.floor((n - 1) / 26 + 1);
                          var text = Array(times + 1).join(letter);
                          return `${text}.`;
                      }
                    };
  
                    wrapper = new LineWrapper(this, options);
                    wrapper.on("line", this._line);
                    level = 1;
                    let i = 0;
                    wrapper.on("firstLine", () => {
                      let item, itemType, labelType, bodyType;
  
                      if (options.structParent) {
                        if (options.structTypes) {
                          [itemType, labelType, bodyType] = options.structTypes;
                        } else {
                          [itemType, labelType, bodyType] = [
                            "LI",
                            "Lbl",
                            "LBody",
                          ];
                        }
                      }
  
                      if (itemType) {
                        item = this.struct(itemType);
                        options.structParent.add(item);
                      } else if (options.structParent) {
                        item = options.structParent;
                      }
  
                      let l;
  
                      if ((l = levels[i++]) !== level) {
                        const diff = itemIndent * (l - level);
                        this.x += diff;
                        wrapper.lineWidth -= diff;
                        level = l;
                      }
  
                      if (item && (labelType || bodyType)) {
                        item.add(
                          this.struct(labelType || bodyType, [
                            this.markStructureContent(labelType || bodyType),
                          ])
                        );
                      }
  
                      switch (listType) {
                        case "bullet":
                          this.circle(this.x - indent + r, this.y + midLine, r);
                          this.fill();
                          break;
  
                        case "numbered":
                        case "lettered":
                          var text = label(numbers[i - 1]);
  
                          this._fragment(text, this.x - indent, this.y, options);
  
                          break;
                      }
  
                      if (item && labelType && bodyType) {
                        item.add(
                          this.struct(bodyType, [
                            this.markStructureContent(bodyType),
                          ])
                        );
                      }
  
                      if (item && item !== options.structParent) {
                        item.end();
                      }
                    });
                    wrapper.on("sectionStart", () => {
                      const pos = indent + itemIndent * (level - 1);
                      this.x += pos;
                      return (wrapper.lineWidth -= pos);
                    });
                    wrapper.on("sectionEnd", () => {
                      const pos = indent + itemIndent * (level - 1);
                      this.x -= pos;
                      return (wrapper.lineWidth += pos);
                    });
                    wrapper.wrap(items.join("\n"), options);
                    return this;
                  },
  
                  _initOptions(x = {}, y, options = {}) {
                    if (typeof x === "object") {
                      options = x;
                      x = null;
                    } // clone options object
  
                    const result = Object.assign({}, options); // extend options with previous values for continued text
  
                    if (this._textOptions) {
                      for (let key in this._textOptions) {
                        const val = this._textOptions[key];
  
                        if (key !== "continued") {
                          if (result[key] === undefined) {
                            result[key] = val;
                          }
                        }
                      }
                    } // Update the current position
  
                    if (x != null) {
                      this.x = x;
                    }
  
                    if (y != null) {
                      this.y = y;
                    } // wrap to margins if no x or y position passed
  
                    if (result.lineBreak !== false) {
                      if (result.width == null) {
                        result.width =
                          this.page.width - this.x - this.page.margins.right;
                      }
  
                      result.width = Math.max(result.width, 0);
                    }
  
                    if (!result.columns) {
                      result.columns = 0;
                    }
  
                    if (result.columnGap == null) {
                      result.columnGap = 18;
                    } // 1/4 inch
  
                    return result;
                  },
  
                  _line(text, options = {}, wrapper) {
                    this._fragment(text, this.x, this.y, options);
  
                    const lineGap = options.lineGap || this._lineGap || 0;
  
                    if (!wrapper) {
                      return (this.x += this.widthOfString(text));
                    } else {
                      return (this.y += this.currentLineHeight(true) + lineGap);
                    }
                  },
  
                  _fragment(text, x, y, options) {
                    let dy, encoded, i, positions, textWidth, words;
                    text = `${text}`.replace(/\n/g, "");
  
                    if (text.length === 0) {
                      return;
                    } // handle options
  
                    const align = options.align || "left";
                    let wordSpacing = options.wordSpacing || 0;
                    const characterSpacing = options.characterSpacing || 0; // text alignments
  
                    if (options.width) {
                      switch (align) {
                        case "right":
                          textWidth = this.widthOfString(
                            text.replace(/\s+$/, ""),
                            options
                          );
                          x += options.lineWidth - textWidth;
                          break;
  
                        case "center":
                          x += options.lineWidth / 2 - options.textWidth / 2;
                          break;
  
                        case "justify":
                          // calculate the word spacing value
                          words = text.trim().split(/\s+/);
                          textWidth = this.widthOfString(
                            text.replace(/\s+/g, ""),
                            options
                          );
                          var spaceWidth =
                            this.widthOfString(" ") + characterSpacing;
                          wordSpacing = Math.max(
                            0,
                            (options.lineWidth - textWidth) /
                              Math.max(1, words.length - 1) -
                              spaceWidth
                          );
                          break;
                      }
                    } // text baseline alignments based on http://wiki.apache.org/xmlgraphics-fop/LineLayout/AlignmentHandling
  
                    if (typeof options.baseline === "number") {
                      dy = -options.baseline;
                    } else {
                      switch (options.baseline) {
                        case "svg-middle":
                          dy = 0.5 * this._font.xHeight;
                          break;
  
                        case "middle":
                        case "svg-central":
                          dy = 0.5 * (this._font.descender + this._font.ascender);
                          break;
  
                        case "bottom":
                        case "ideographic":
                          dy = this._font.descender;
                          break;
  
                        case "alphabetic":
                          dy = 0;
                          break;
  
                        case "mathematical":
                          dy = 0.5 * this._font.ascender;
                          break;
  
                        case "hanging":
                          dy = 0.8 * this._font.ascender;
                          break;
  
                        case "top":
                          dy = this._font.ascender;
                          break;
  
                        default:
                          dy = this._font.ascender;
                      }
  
                      dy = (dy / 1000) * this._fontSize;
                    } // calculate the actual rendered width of the string after word and character spacing
  
                    const renderedWidth =
                      options.textWidth +
                      wordSpacing * (options.wordCount - 1) +
                      characterSpacing * (text.length - 1); // create link annotations if the link option is given
  
                    if (options.link != null) {
                      this.link(
                        x,
                        y,
                        renderedWidth,
                        this.currentLineHeight(),
                        options.link
                      );
                    }
  
                    if (options.goTo != null) {
                      this.goTo(
                        x,
                        y,
                        renderedWidth,
                        this.currentLineHeight(),
                        options.goTo
                      );
                    }
  
                    if (options.destination != null) {
                      this.addNamedDestination(
                        options.destination,
                        "XYZ",
                        x,
                        y,
                        null
                      );
                    } // create underline
  
                    if (options.underline) {
                      this.save();
  
                      if (!options.stroke) {
                        this.strokeColor(...(this._fillColor || []));
                      }
  
                      const lineWidth =
                        this._fontSize < 10
                          ? 0.5
                          : Math.floor(this._fontSize / 10);
                      this.lineWidth(lineWidth);
                      let lineY = y + this.currentLineHeight() - lineWidth;
                      this.moveTo(x, lineY);
                      this.lineTo(x + renderedWidth, lineY);
                      this.stroke();
                      this.restore();
                    } // create strikethrough line
  
                    if (options.strike) {
                      this.save();
  
                      if (!options.stroke) {
                        this.strokeColor(...(this._fillColor || []));
                      }
  
                      const lineWidth =
                        this._fontSize < 10
                          ? 0.5
                          : Math.floor(this._fontSize / 10);
                      this.lineWidth(lineWidth);
                      let lineY = y + this.currentLineHeight() / 2;
                      this.moveTo(x, lineY);
                      this.lineTo(x + renderedWidth, lineY);
                      this.stroke();
                      this.restore();
                    }
  
                    this.save(); // oblique (angle in degrees or boolean)
  
                    if (options.oblique) {
                      let skew;
  
                      if (typeof options.oblique === "number") {
                        skew = -Math.tan((options.oblique * Math.PI) / 180);
                      } else {
                        skew = -0.25;
                      }
  
                      this.transform(1, 0, 0, 1, x, y);
                      this.transform(1, 0, skew, 1, -skew * dy, 0);
                      this.transform(1, 0, 0, 1, -x, -y);
                    } // flip coordinate system
  
                    this.transform(1, 0, 0, -1, 0, this.page.height);
                    y = this.page.height - y - dy; // add current font to page if necessary
  
                    if (this.page.fonts[this._font.id] == null) {
                      this.page.fonts[this._font.id] = this._font.ref();
                    } // begin the text object
  
                    this.addContent("BT"); // text position
  
                    this.addContent(`1 0 0 1 ${number$2(x)} ${number$2(y)} Tm`); // font and font size
  
                    this.addContent(
                      `/${this._font.id} ${number$2(this._fontSize)} Tf`
                    ); // rendering mode
  
                    const mode =
                      options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
  
                    if (mode) {
                      this.addContent(`${mode} Tr`);
                    } // Character spacing
  
                    if (characterSpacing) {
                      this.addContent(`${number$2(characterSpacing)} Tc`);
                    } // Add the actual text
                    // If we have a word spacing value, we need to encode each word separately
                    // since the normal Tw operator only works on character code 32, which isn't
                    // used for embedded fonts.
  
                    if (wordSpacing) {
                      words = text.trim().split(/\s+/);
                      wordSpacing += this.widthOfString(" ") + characterSpacing;
                      wordSpacing *= 1000 / this._fontSize;
                      encoded = [];
                      positions = [];
  
                      for (let word of words) {
                        const [encodedWord, positionsWord] = this._font.encode(
                          word,
                          options.features
                        );
  
                        encoded = encoded.concat(encodedWord);
                        positions = positions.concat(positionsWord); // add the word spacing to the end of the word
                        // clone object because of cache
  
                        const space = {};
                        const object = positions[positions.length - 1];
  
                        for (let key in object) {
                          const val = object[key];
                          space[key] = val;
                        }
  
                        space.xAdvance += wordSpacing;
                        positions[positions.length - 1] = space;
                      }
                    } else {
                      [encoded, positions] = this._font.encode(
                        text,
                        options.features
                      );
                    }
  
                    const scale = this._fontSize / 1000;
                    const commands = [];
                    let last = 0;
                    let hadOffset = false; // Adds a segment of text to the TJ command buffer
  
                    const addSegment = (cur) => {
                      if (last < cur) {
                        const hex = encoded.slice(last, cur).join("");
                        const advance =
                          positions[cur - 1].xAdvance -
                          positions[cur - 1].advanceWidth;
                        commands.push(`<${hex}> ${number$2(-advance)}`);
                      }
  
                      return (last = cur);
                    }; // Flushes the current TJ commands to the output stream
  
                    const flush = (i) => {
                      addSegment(i);
  
                      if (commands.length > 0) {
                        this.addContent(`[${commands.join(" ")}] TJ`);
                        return (commands.length = 0);
                      }
                    };
  
                    for (i = 0; i < positions.length; i++) {
                      // If we have an x or y offset, we have to break out of the current TJ command
                      // so we can move the text position.
                      const pos = positions[i];
  
                      if (pos.xOffset || pos.yOffset) {
                        // Flush the current buffer
                        flush(i); // Move the text position and flush just the current character
  
                        this.addContent(
                          `1 0 0 1 ${number$2(
                            x + pos.xOffset * scale
                          )} ${number$2(y + pos.yOffset * scale)} Tm`
                        );
                        flush(i + 1);
                        hadOffset = true;
                      } else {
                        // If the last character had an offset, reset the text position
                        if (hadOffset) {
                          this.addContent(
                            `1 0 0 1 ${number$2(x)} ${number$2(y)} Tm`
                          );
                          hadOffset = false;
                        } // Group segments that don't have any advance adjustments
  
                        if (pos.xAdvance - pos.advanceWidth !== 0) {
                          addSegment(i + 1);
                        }
                      }
  
                      x += pos.xAdvance * scale;
                    } // Flush any remaining commands
  
                    flush(i); // end the text object
  
                    this.addContent("ET"); // restore flipped coordinate system
  
                    return this.restore();
                  },
                };
  
                const MARKERS = [
                  0xffc0, 0xffc1, 0xffc2, 0xffc3, 0xffc5, 0xffc6, 0xffc7, 0xffc8,
                  0xffc9, 0xffca, 0xffcb, 0xffcc, 0xffcd, 0xffce, 0xffcf,
                ];
                const COLOR_SPACE_MAP = {
                  1: "DeviceGray",
                  3: "DeviceRGB",
                  4: "DeviceCMYK",
                };
  
                class JPEG {
                  constructor(data, label) {
                    let marker;
                    this.data = data;
                    this.label = label;
  
                    if (this.data.readUInt16BE(0) !== 0xffd8) {
                      throw "SOI not found in JPEG";
                    }
  
                    let pos = 2;
  
                    while (pos < this.data.length) {
                      marker = this.data.readUInt16BE(pos);
                      pos += 2;
  
                      if (MARKERS.includes(marker)) {
                        break;
                      }
  
                      pos += this.data.readUInt16BE(pos);
                    }
  
                    if (!MARKERS.includes(marker)) {
                      throw "Invalid JPEG.";
                    }
  
                    pos += 2;
                    this.bits = this.data[pos++];
                    this.height = this.data.readUInt16BE(pos);
                    pos += 2;
                    this.width = this.data.readUInt16BE(pos);
                    pos += 2;
                    const channels = this.data[pos++];
                    this.colorSpace = COLOR_SPACE_MAP[channels];
                    this.obj = null;
                  }
  
                  embed(document) {
                    if (this.obj) {
                      return;
                    }
  
                    this.obj = document.ref({
                      Type: "XObject",
                      Subtype: "Image",
                      BitsPerComponent: this.bits,
                      Width: this.width,
                      Height: this.height,
                      ColorSpace: this.colorSpace,
                      Filter: "DCTDecode",
                    }); // add extra decode params for CMYK images. By swapping the
                    // min and max values from the default, we invert the colors. See
                    // section 4.8.4 of the spec.
  
                    if (this.colorSpace === "DeviceCMYK") {
                      this.obj.data["Decode"] = [
                        1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0,
                      ];
                    }
  
                    this.obj.end(this.data); // free memory
  
                    return (this.data = null);
                  }
                }
  
                class PNGImage {
                  constructor(data, label) {
                    this.label = label;
                    this.image = new PNG(data);
                    this.width = this.image.width;
                    this.height = this.image.height;
                    this.imgData = this.image.imgData;
                    this.obj = null;
                  }
  
                  embed(document) {
                    let dataDecoded = false;
                    this.document = document;
  
                    if (this.obj) {
                      return;
                    }
  
                    const hasAlphaChannel = this.image.hasAlphaChannel;
                    const isInterlaced = this.image.interlaceMethod === 1;
                    this.obj = this.document.ref({
                      Type: "XObject",
                      Subtype: "Image",
                      BitsPerComponent: hasAlphaChannel ? 8 : this.image.bits,
                      Width: this.width,
                      Height: this.height,
                      Filter: "FlateDecode",
                    });
  
                    if (!hasAlphaChannel) {
                      const params = this.document.ref({
                        Predictor: isInterlaced ? 1 : 15,
                        Colors: this.image.colors,
                        BitsPerComponent: this.image.bits,
                        Columns: this.width,
                      });
                      this.obj.data["DecodeParms"] = params;
                      params.end();
                    }
  
                    if (this.image.palette.length === 0) {
                      this.obj.data["ColorSpace"] = this.image.colorSpace;
                    } else {
                      // embed the color palette in the PDF as an object stream
                      const palette = this.document.ref();
                      palette.end(Buffer.from(this.image.palette)); // build the color space array for the image
  
                      this.obj.data["ColorSpace"] = [
                        "Indexed",
                        "DeviceRGB",
                        this.image.palette.length / 3 - 1,
                        palette,
                      ];
                    } // For PNG color types 0, 2 and 3, the transparency data is stored in
                    // a dedicated PNG chunk.
  
                    if (this.image.transparency.grayscale != null) {
                      // Use Color Key Masking (spec section 4.8.5)
                      // An array with N elements, where N is two times the number of color components.
                      const val = this.image.transparency.grayscale;
                      this.obj.data["Mask"] = [val, val];
                    } else if (this.image.transparency.rgb) {
                      // Use Color Key Masking (spec section 4.8.5)
                      // An array with N elements, where N is two times the number of color components.
                      const { rgb } = this.image.transparency;
                      const mask = [];
  
                      for (let x of rgb) {
                        mask.push(x, x);
                      }
  
                      this.obj.data["Mask"] = mask;
                    } else if (this.image.transparency.indexed) {
                      // Create a transparency SMask for the image based on the data
                      // in the PLTE and tRNS sections. See below for details on SMasks.
                      dataDecoded = true;
                      return this.loadIndexedAlphaChannel();
                    } else if (hasAlphaChannel) {
                      // For PNG color types 4 and 6, the transparency data is stored as a alpha
                      // channel mixed in with the main image data. Separate this data out into an
                      // SMask object and store it separately in the PDF.
                      dataDecoded = true;
                      return this.splitAlphaChannel();
                    }
  
                    if (isInterlaced && !dataDecoded) {
                      return this.decodeData();
                    }
  
                    this.finalize();
                  }
  
                  finalize() {
                    if (this.alphaChannel) {
                      const sMask = this.document.ref({
                        Type: "XObject",
                        Subtype: "Image",
                        Height: this.height,
                        Width: this.width,
                        BitsPerComponent: 8,
                        Filter: "FlateDecode",
                        ColorSpace: "DeviceGray",
                        Decode: [0, 1],
                      });
                      sMask.end(this.alphaChannel);
                      this.obj.data["SMask"] = sMask;
                    } // add the actual image data
  
                    this.obj.end(this.imgData); // free memory
  
                    this.image = null;
                    return (this.imgData = null);
                  }
  
                  splitAlphaChannel() {
                    return this.image.decodePixels((pixels) => {
                      let a, p;
                      const colorCount = this.image.colors;
                      const pixelCount = this.width * this.height;
                      const imgData = Buffer.alloc(pixelCount * colorCount);
                      const alphaChannel = Buffer.alloc(pixelCount);
                      let i = (p = a = 0);
                      const len = pixels.length; // For 16bit images copy only most significant byte (MSB) - PNG data is always stored in network byte order (MSB first)
  
                      const skipByteCount = this.image.bits === 16 ? 1 : 0;
  
                      while (i < len) {
                        for (
                          let colorIndex = 0;
                          colorIndex < colorCount;
                          colorIndex++
                        ) {
                          imgData[p++] = pixels[i++];
                          i += skipByteCount;
                        }
  
                        alphaChannel[a++] = pixels[i++];
                        i += skipByteCount;
                      }
  
                      this.imgData = zlib.deflateSync(imgData);
                      this.alphaChannel = zlib.deflateSync(alphaChannel);
                      return this.finalize();
                    });
                  }
  
                  loadIndexedAlphaChannel() {
                    const transparency = this.image.transparency.indexed;
                    return this.image.decodePixels((pixels) => {
                      const alphaChannel = Buffer.alloc(this.width * this.height);
                      let i = 0;
  
                      for (let j = 0, end = pixels.length; j < end; j++) {
                        alphaChannel[i++] = transparency[pixels[j]];
                      }
  
                      this.alphaChannel = zlib.deflateSync(alphaChannel);
                      return this.finalize();
                    });
                  }
  
                  decodeData() {
                    this.image.decodePixels((pixels) => {
                      this.imgData = zlib.deflateSync(pixels);
                      this.finalize();
                    });
                  }
                }
  
                /*
  PDFImage - embeds images in PDF documents
  By Devon Govett
  */
  
                class PDFImage {
                  static open(src, label) {
                    let data;
  
                    if (Buffer.isBuffer(src)) {
                      data = src;
                    } else if (src instanceof ArrayBuffer) {
                      data = Buffer.from(new Uint8Array(src));
                    } else {
                      let match;
  
                      if ((match = /^data:.+;base64,(.*)$/.exec(src))) {
                        data = Buffer.from(match[1], "base64");
                      } else {
                        data = fs.readFileSync(src);
  
                        if (!data) {
                          return;
                        }
                      }
                    }
  
                    if (data[0] === 0xff && data[1] === 0xd8) {
                      return new JPEG(data, label);
                    } else if (
                      data[0] === 0x89 &&
                      data.toString("ascii", 1, 4) === "PNG"
                    ) {
                      return new PNGImage(data, label);
                    } else {
                      throw new Error("Unknown image format.");
                    }
                  }
                }
  
                var ImagesMixin = {
                  initImages() {
                    this._imageRegistry = {};
                    return (this._imageCount = 0);
                  },
  
                  image(src, x, y, options = {}) {
                    let bh, bp, bw, image, ip, left, left1;
  
                    if (typeof x === "object") {
                      options = x;
                      x = null;
                    }
  
                    x =
                      (left = x != null ? x : options.x) != null ? left : this.x;
                    y =
                      (left1 = y != null ? y : options.y) != null
                        ? left1
                        : this.y;
  
                    if (typeof src === "string") {
                      image = this._imageRegistry[src];
                    }
  
                    if (!image) {
                      if (src.width && src.height) {
                        image = src;
                      } else {
                        image = this.openImage(src);
                      }
                    }
  
                    if (!image.obj) {
                      image.embed(this);
                    }
  
                    if (this.page.xobjects[image.label] == null) {
                      this.page.xobjects[image.label] = image.obj;
                    }
  
                    let w = options.width || image.width;
                    let h = options.height || image.height;
  
                    if (options.width && !options.height) {
                      const wp = w / image.width;
                      w = image.width * wp;
                      h = image.height * wp;
                    } else if (options.height && !options.width) {
                      const hp = h / image.height;
                      w = image.width * hp;
                      h = image.height * hp;
                    } else if (options.scale) {
                      w = image.width * options.scale;
                      h = image.height * options.scale;
                    } else if (options.fit) {
                      [bw, bh] = options.fit;
                      bp = bw / bh;
                      ip = image.width / image.height;
  
                      if (ip > bp) {
                        w = bw;
                        h = bw / ip;
                      } else {
                        h = bh;
                        w = bh * ip;
                      }
                    } else if (options.cover) {
                      [bw, bh] = options.cover;
                      bp = bw / bh;
                      ip = image.width / image.height;
  
                      if (ip > bp) {
                        h = bh;
                        w = bh * ip;
                      } else {
                        w = bw;
                        h = bw / ip;
                      }
                    }
  
                    if (options.fit || options.cover) {
                      if (options.align === "center") {
                        x = x + bw / 2 - w / 2;
                      } else if (options.align === "right") {
                        x = x + bw - w;
                      }
  
                      if (options.valign === "center") {
                        y = y + bh / 2 - h / 2;
                      } else if (options.valign === "bottom") {
                        y = y + bh - h;
                      }
                    } // create link annotations if the link option is given
  
                    if (options.link != null) {
                      this.link(x, y, w, h, options.link);
                    }
  
                    if (options.goTo != null) {
                      this.goTo(x, y, w, h, options.goTo);
                    }
  
                    if (options.destination != null) {
                      this.addNamedDestination(
                        options.destination,
                        "XYZ",
                        x,
                        y,
                        null
                      );
                    } // Set the current y position to below the image if it is in the document flow
  
                    if (this.y === y) {
                      this.y += h;
                    }
  
                    this.save();
                    this.transform(w, 0, 0, -h, x, y + h);
                    this.addContent(`/${image.label} Do`);
                    this.restore();
                    return this;
                  },
  
                  openImage(src) {
                    let image;
  
                    if (typeof src === "string") {
                      image = this._imageRegistry[src];
                    }
  
                    if (!image) {
                      image = PDFImage.open(src, `I${++this._imageCount}`);
  
                      if (typeof src === "string") {
                        this._imageRegistry[src] = image;
                      }
                    }
  
                    return image;
                  },
                };
  
                var AnnotationsMixin = {
                  annotate(x, y, w, h, options) {
                    options.Type = "Annot";
                    options.Rect = this._convertRect(x, y, w, h);
                    options.Border = [0, 0, 0];
  
                    if (
                      options.Subtype === "Link" &&
                      typeof options.F === "undefined"
                    ) {
                      options.F = 1 << 2; // Print Annotation Flag
                    }
  
                    if (options.Subtype !== "Link") {
                      if (options.C == null) {
                        options.C = this._normalizeColor(
                          options.color || [0, 0, 0]
                        );
                      }
                    } // convert colors
  
                    delete options.color;
  
                    if (typeof options.Dest === "string") {
                      options.Dest = new String(options.Dest);
                    } // Capitalize keys
  
                    for (let key in options) {
                      const val = options[key];
                      options[key[0].toUpperCase() + key.slice(1)] = val;
                    }
  
                    const ref = this.ref(options);
                    this.page.annotations.push(ref);
                    ref.end();
                    return this;
                  },
  
                  note(x, y, w, h, contents, options = {}) {
                    options.Subtype = "Text";
                    options.Contents = new String(contents);
                    options.Name = "Comment";
  
                    if (options.color == null) {
                      options.color = [243, 223, 92];
                    }
  
                    return this.annotate(x, y, w, h, options);
                  },
  
                  goTo(x, y, w, h, name, options = {}) {
                    options.Subtype = "Link";
                    options.A = this.ref({
                      S: "GoTo",
                      D: new String(name),
                    });
                    options.A.end();
                    return this.annotate(x, y, w, h, options);
                  },
  
                  link(x, y, w, h, url, options = {}) {
                    options.Subtype = "Link";
  
                    if (typeof url === "number") {
                      // Link to a page in the document (the page must already exist)
                      const pages = this._root.data.Pages.data;
  
                      if (url >= 0 && url < pages.Kids.length) {
                        options.A = this.ref({
                          S: "GoTo",
                          D: [pages.Kids[url], "XYZ", null, null, null],
                        });
                        options.A.end();
                      } else {
                        throw new Error(`The document has no page ${url}`);
                      }
                    } else {
                      // Link to an external url
                      options.A = this.ref({
                        S: "URI",
                        URI: new String(url),
                      });
                      options.A.end();
                    }
  
                    return this.annotate(x, y, w, h, options);
                  },
  
                  _markup(x, y, w, h, options = {}) {
                    const [x1, y1, x2, y2] = this._convertRect(x, y, w, h);
  
                    options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
                    options.Contents = new String();
                    return this.annotate(x, y, w, h, options);
                  },
  
                  highlight(x, y, w, h, options = {}) {
                    options.Subtype = "Highlight";
  
                    if (options.color == null) {
                      options.color = [241, 238, 148];
                    }
  
                    return this._markup(x, y, w, h, options);
                  },
  
                  underline(x, y, w, h, options = {}) {
                    options.Subtype = "Underline";
                    return this._markup(x, y, w, h, options);
                  },
  
                  strike(x, y, w, h, options = {}) {
                    options.Subtype = "StrikeOut";
                    return this._markup(x, y, w, h, options);
                  },
  
                  lineAnnotation(x1, y1, x2, y2, options = {}) {
                    options.Subtype = "Line";
                    options.Contents = new String();
                    options.L = [
                      x1,
                      this.page.height - y1,
                      x2,
                      this.page.height - y2,
                    ];
                    return this.annotate(x1, y1, x2, y2, options);
                  },
  
                  rectAnnotation(x, y, w, h, options = {}) {
                    options.Subtype = "Square";
                    options.Contents = new String();
                    return this.annotate(x, y, w, h, options);
                  },
  
                  ellipseAnnotation(x, y, w, h, options = {}) {
                    options.Subtype = "Circle";
                    options.Contents = new String();
                    return this.annotate(x, y, w, h, options);
                  },
  
                  textAnnotation(x, y, w, h, text, options = {}) {
                    options.Subtype = "FreeText";
                    options.Contents = new String(text);
                    options.DA = new String();
                    return this.annotate(x, y, w, h, options);
                  },
  
                  fileAnnotation(x, y, w, h, file = {}, options = {}) {
                    // create hidden file
                    const filespec = this.file(
                      file.src,
                      Object.assign(
                        {
                          hidden: true,
                        },
                        file
                      )
                    );
                    options.Subtype = "FileAttachment";
                    options.FS = filespec; // add description from filespec unless description (Contents) has already been set
  
                    if (options.Contents) {
                      options.Contents = new String(options.Contents);
                    } else if (filespec.data.Desc) {
                      options.Contents = filespec.data.Desc;
                    }
  
                    return this.annotate(x, y, w, h, options);
                  },
  
                  _convertRect(x1, y1, w, h) {
                    // flip y1 and y2
                    let y2 = y1;
                    y1 += h; // make x2
  
                    let x2 = x1 + w; // apply current transformation matrix to points
  
                    const [m0, m1, m2, m3, m4, m5] = this._ctm;
                    x1 = m0 * x1 + m2 * y1 + m4;
                    y1 = m1 * x1 + m3 * y1 + m5;
                    x2 = m0 * x2 + m2 * y2 + m4;
                    y2 = m1 * x2 + m3 * y2 + m5;
                    return [x1, y1, x2, y2];
                  },
                };
  
                class PDFOutline {
                  constructor(
                    document,
                    parent,
                    title,
                    dest,
                    options = {
                      expanded: false,
                    }
                  ) {
                    this.document = document;
                    this.options = options;
                    this.outlineData = {};
  
                    if (dest !== null) {
                      this.outlineData["Dest"] = [dest.dictionary, "Fit"];
                    }
  
                    if (parent !== null) {
                      this.outlineData["Parent"] = parent;
                    }
  
                    if (title !== null) {
                      this.outlineData["Title"] = new String(title);
                    }
  
                    this.dictionary = this.document.ref(this.outlineData);
                    this.children = [];
                  }
  
                  addItem(
                    title,
                    options = {
                      expanded: false,
                    }
                  ) {
                    const result = new PDFOutline(
                      this.document,
                      this.dictionary,
                      title,
                      this.document.page,
                      options
                    );
                    this.children.push(result);
                    return result;
                  }
  
                  endOutline() {
                    if (this.children.length > 0) {
                      if (this.options.expanded) {
                        this.outlineData.Count = this.children.length;
                      }
  
                      const first = this.children[0],
                        last = this.children[this.children.length - 1];
                      this.outlineData.First = first.dictionary;
                      this.outlineData.Last = last.dictionary;
  
                      for (let i = 0, len = this.children.length; i < len; i++) {
                        const child = this.children[i];
  
                        if (i > 0) {
                          child.outlineData.Prev =
                            this.children[i - 1].dictionary;
                        }
  
                        if (i < this.children.length - 1) {
                          child.outlineData.Next =
                            this.children[i + 1].dictionary;
                        }
  
                        child.endOutline();
                      }
                    }
  
                    return this.dictionary.end();
                  }
                }
  
                var OutlineMixin = {
                  initOutline() {
                    return (this.outline = new PDFOutline(
                      this,
                      null,
                      null,
                      null
                    ));
                  },
  
                  endOutline() {
                    this.outline.endOutline();
  
                    if (this.outline.children.length > 0) {
                      this._root.data.Outlines = this.outline.dictionary;
                      return (this._root.data.PageMode = "UseOutlines");
                    }
                  },
                };
  
                function ownKeys(object, enumerableOnly) {
                  var keys = Object.keys(object);
  
                  if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
  
                    if (enumerableOnly) {
                      symbols = symbols.filter(function (sym) {
                        return Object.getOwnPropertyDescriptor(
                          object,
                          sym
                        ).enumerable;
                      });
                    }
  
                    keys.push.apply(keys, symbols);
                  }
  
                  return keys;
                }
  
                function _objectSpread2(target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i] != null ? arguments[i] : {};
  
                    if (i % 2) {
                      ownKeys(Object(source), true).forEach(function (key) {
                        _defineProperty(target, key, source[key]);
                      });
                    } else if (Object.getOwnPropertyDescriptors) {
                      Object.defineProperties(
                        target,
                        Object.getOwnPropertyDescriptors(source)
                      );
                    } else {
                      ownKeys(Object(source)).forEach(function (key) {
                        Object.defineProperty(
                          target,
                          key,
                          Object.getOwnPropertyDescriptor(source, key)
                        );
                      });
                    }
                  }
  
                  return target;
                }
  
                function _defineProperty(obj, key, value) {
                  if (key in obj) {
                    Object.defineProperty(obj, key, {
                      value: value,
                      enumerable: true,
                      configurable: true,
                      writable: true,
                    });
                  } else {
                    obj[key] = value;
                  }
  
                  return obj;
                }
  
                /*
  PDFStructureContent - a reference to a marked structure content
  By Ben Schmidt
  */
                class PDFStructureContent {
                  constructor(pageRef, mcid) {
                    this.refs = [
                      {
                        pageRef,
                        mcid,
                      },
                    ];
                  }
  
                  push(structContent) {
                    structContent.refs.forEach((ref) => this.refs.push(ref));
                  }
                }
  
                /*
  PDFStructureElement - represents an element in the PDF logical structure tree
  By Ben Schmidt
  */
  
                class PDFStructureElement {
                  constructor(document, type, options = {}, children = null) {
                    this.document = document;
                    this._attached = false;
                    this._ended = false;
                    this._flushed = false;
                    this.dictionary = document.ref({
                      // Type: "StructElem",
                      S: type,
                    });
                    const data = this.dictionary.data;
  
                    if (Array.isArray(options) || this._isValidChild(options)) {
                      children = options;
                      options = {};
                    }
  
                    if (typeof options.title !== "undefined") {
                      data.T = new String(options.title);
                    }
  
                    if (typeof options.lang !== "undefined") {
                      data.Lang = new String(options.lang);
                    }
  
                    if (typeof options.alt !== "undefined") {
                      data.Alt = new String(options.alt);
                    }
  
                    if (typeof options.expanded !== "undefined") {
                      data.E = new String(options.expanded);
                    }
  
                    if (typeof options.actual !== "undefined") {
                      data.ActualText = new String(options.actual);
                    }
  
                    this._children = [];
  
                    if (children) {
                      if (!Array.isArray(children)) {
                        children = [children];
                      }
  
                      children.forEach((child) => this.add(child));
                      this.end();
                    }
                  }
  
                  add(child) {
                    if (this._ended) {
                      throw new Error(
                        `Cannot add child to already-ended structure element`
                      );
                    }
  
                    if (!this._isValidChild(child)) {
                      throw new Error(`Invalid structure element child`);
                    }
  
                    if (child instanceof PDFStructureElement) {
                      child.setParent(this.dictionary);
  
                      if (this._attached) {
                        child.setAttached();
                      }
                    }
  
                    if (child instanceof PDFStructureContent) {
                      this._addContentToParentTree(child);
                    }
  
                    if (typeof child === "function" && this._attached) {
                      // _contentForClosure() adds the content to the parent tree
                      child = this._contentForClosure(child);
                    }
  
                    this._children.push(child);
  
                    return this;
                  }
  
                  _addContentToParentTree(content) {
                    content.refs.forEach(({ pageRef, mcid }) => {
                      const pageStructParents = this.document
                        .getStructParentTree()
                        .get(pageRef.data.StructParents);
                      pageStructParents[mcid] = this.dictionary;
                    });
                  }
  
                  setParent(parentRef) {
                    if (this.dictionary.data.P) {
                      throw new Error(
                        `Structure element added to more than one parent`
                      );
                    }
  
                    this.dictionary.data.P = parentRef;
  
                    this._flush();
                  }
  
                  setAttached() {
                    if (this._attached) {
                      return;
                    }
  
                    this._children.forEach((child, index) => {
                      if (child instanceof PDFStructureElement) {
                        child.setAttached();
                      }
  
                      if (typeof child === "function") {
                        this._children[index] = this._contentForClosure(child);
                      }
                    });
  
                    this._attached = true;
  
                    this._flush();
                  }
  
                  end() {
                    if (this._ended) {
                      return;
                    }
  
                    this._children
                      .filter((child) => child instanceof PDFStructureElement)
                      .forEach((child) => child.end());
  
                    this._ended = true;
  
                    this._flush();
                  }
  
                  _isValidChild(child) {
                    return (
                      child instanceof PDFStructureElement ||
                      child instanceof PDFStructureContent ||
                      typeof child === "function"
                    );
                  }
  
                  _contentForClosure(closure) {
                    const content = this.document.markStructureContent(
                      this.dictionary.data.S
                    );
                    closure();
                    this.document.endMarkedContent();
  
                    this._addContentToParentTree(content);
  
                    return content;
                  }
  
                  _isFlushable() {
                    if (!this.dictionary.data.P || !this._ended) {
                      return false;
                    }
  
                    return this._children.every((child) => {
                      if (typeof child === "function") {
                        return false;
                      }
  
                      if (child instanceof PDFStructureElement) {
                        return child._isFlushable();
                      }
  
                      return true;
                    });
                  }
  
                  _flush() {
                    if (this._flushed || !this._isFlushable()) {
                      return;
                    }
  
                    this.dictionary.data.K = [];
  
                    this._children.forEach((child) => this._flushChild(child));
  
                    this.dictionary.end(); // free memory used by children; the dictionary itself may still be
                    // referenced by a parent structure element or root, but we can
                    // at least trim the tree here
  
                    this._children = [];
                    this.dictionary.data.K = null;
                    this._flushed = true;
                  }
  
                  _flushChild(child) {
                    if (child instanceof PDFStructureElement) {
                      this.dictionary.data.K.push(child.dictionary);
                    }
  
                    if (child instanceof PDFStructureContent) {
                      child.refs.forEach(({ pageRef, mcid }) => {
                        if (!this.dictionary.data.Pg) {
                          this.dictionary.data.Pg = pageRef;
                        }
  
                        if (this.dictionary.data.Pg === pageRef) {
                          this.dictionary.data.K.push(mcid);
                        } else {
                          this.dictionary.data.K.push({
                            Type: "MCR",
                            Pg: pageRef,
                            MCID: mcid,
                          });
                        }
                      });
                    }
                  }
                }
  
                /*
  PDFNumberTree - represents a number tree object
  */
  
                class PDFNumberTree extends PDFTree {
                  _compareKeys(a, b) {
                    return parseInt(a) - parseInt(b);
                  }
  
                  _keysName() {
                    return "Nums";
                  }
  
                  _dataForKey(k) {
                    return parseInt(k);
                  }
                }
  
                var MarkingsMixin = {
                  initMarkings(options) {
                    this.structChildren = [];
  
                    if (options.tagged) {
                      this.getMarkInfoDictionary().data.Marked = true;
                      this.getStructTreeRoot();
                    }
                  },
  
                  markContent(tag, options = null) {
                    if (tag === "Artifact" || (options && options.mcid)) {
                      let toClose = 0;
                      this.page.markings.forEach((marking) => {
                        if (
                          toClose ||
                          marking.structContent ||
                          marking.tag === "Artifact"
                        ) {
                          toClose++;
                        }
                      });
  
                      while (toClose--) {
                        this.endMarkedContent();
                      }
                    }
  
                    if (!options) {
                      this.page.markings.push({
                        tag,
                      });
                      this.addContent(`/${tag} BMC`);
                      return this;
                    }
  
                    this.page.markings.push({
                      tag,
                      options,
                    });
                    const dictionary = {};
  
                    if (typeof options.mcid !== "undefined") {
                      dictionary.MCID = options.mcid;
                    }
  
                    if (tag === "Artifact") {
                      if (typeof options.type === "string") {
                        dictionary.Type = options.type;
                      }
  
                      if (Array.isArray(options.bbox)) {
                        dictionary.BBox = [
                          options.bbox[0],
                          this.page.height - options.bbox[3],
                          options.bbox[2],
                          this.page.height - options.bbox[1],
                        ];
                      }
  
                      if (
                        Array.isArray(options.attached) &&
                        options.attached.every((val) => typeof val === "string")
                      ) {
                        dictionary.Attached = options.attached;
                      }
                    }
  
                    if (tag === "Span") {
                      if (options.lang) {
                        dictionary.Lang = new String(options.lang);
                      }
  
                      if (options.alt) {
                        dictionary.Alt = new String(options.alt);
                      }
  
                      if (options.expanded) {
                        dictionary.E = new String(options.expanded);
                      }
  
                      if (options.actual) {
                        dictionary.ActualText = new String(options.actual);
                      }
                    }
  
                    this.addContent(
                      `/${tag} ${PDFObject.convert(dictionary)} BDC`
                    );
                    return this;
                  },
  
                  markStructureContent(tag, options = {}) {
                    const pageStructParents = this.getStructParentTree().get(
                      this.page.structParentTreeKey
                    );
                    const mcid = pageStructParents.length;
                    pageStructParents.push(null);
                    this.markContent(
                      tag,
                      _objectSpread2(
                        _objectSpread2({}, options),
                        {},
                        {
                          mcid,
                        }
                      )
                    );
                    const structContent = new PDFStructureContent(
                      this.page.dictionary,
                      mcid
                    );
                    this.page.markings.slice(-1)[0].structContent = structContent;
                    return structContent;
                  },
  
                  endMarkedContent() {
                    this.page.markings.pop();
                    this.addContent("EMC");
                    return this;
                  },
  
                  struct(type, options = {}, children = null) {
                    return new PDFStructureElement(this, type, options, children);
                  },
  
                  addStructure(structElem) {
                    const structTreeRoot = this.getStructTreeRoot();
                    structElem.setParent(structTreeRoot);
                    structElem.setAttached();
                    this.structChildren.push(structElem);
  
                    if (!structTreeRoot.data.K) {
                      structTreeRoot.data.K = [];
                    }
  
                    structTreeRoot.data.K.push(structElem.dictionary);
                    return this;
                  },
  
                  initPageMarkings(pageMarkings) {
                    pageMarkings.forEach((marking) => {
                      if (marking.structContent) {
                        const structContent = marking.structContent;
                        const newStructContent = this.markStructureContent(
                          marking.tag,
                          marking.options
                        );
                        structContent.push(newStructContent);
                        this.page.markings.slice(-1)[0].structContent =
                          structContent;
                      } else {
                        this.markContent(marking.tag, marking.options);
                      }
                    });
                  },
  
                  endPageMarkings(page) {
                    const pageMarkings = page.markings;
                    pageMarkings.forEach(() => page.write("EMC"));
                    page.markings = [];
                    return pageMarkings;
                  },
  
                  getMarkInfoDictionary() {
                    if (!this._root.data.MarkInfo) {
                      this._root.data.MarkInfo = this.ref({});
                    }
  
                    return this._root.data.MarkInfo;
                  },
  
                  getStructTreeRoot() {
                    if (!this._root.data.StructTreeRoot) {
                      this._root.data.StructTreeRoot = this.ref({
                        Type: "StructTreeRoot",
                        ParentTree: new PDFNumberTree(),
                        ParentTreeNextKey: 0,
                      });
                    }
  
                    return this._root.data.StructTreeRoot;
                  },
  
                  getStructParentTree() {
                    return this.getStructTreeRoot().data.ParentTree;
                  },
  
                  createStructParentTreeNextKey() {
                    // initialise the MarkInfo dictionary
                    this.getMarkInfoDictionary();
                    const structTreeRoot = this.getStructTreeRoot();
                    const key = structTreeRoot.data.ParentTreeNextKey++;
                    structTreeRoot.data.ParentTree.add(key, []);
                    return key;
                  },
  
                  endMarkings() {
                    const structTreeRoot = this._root.data.StructTreeRoot;
  
                    if (structTreeRoot) {
                      structTreeRoot.end();
                      this.structChildren.forEach((structElem) =>
                        structElem.end()
                      );
                    }
  
                    if (this._root.data.MarkInfo) {
                      this._root.data.MarkInfo.end();
                    }
                  },
                };
  
                const FIELD_FLAGS = {
                  readOnly: 1,
                  required: 2,
                  noExport: 4,
                  multiline: 0x1000,
                  password: 0x2000,
                  toggleToOffButton: 0x4000,
                  radioButton: 0x8000,
                  pushButton: 0x10000,
                  combo: 0x20000,
                  edit: 0x40000,
                  sort: 0x80000,
                  multiSelect: 0x200000,
                  noSpell: 0x400000,
                };
                const FIELD_JUSTIFY = {
                  left: 0,
                  center: 1,
                  right: 2,
                };
                const VALUE_MAP = {
                  value: "V",
                  defaultValue: "DV",
                };
                const FORMAT_SPECIAL = {
                  zip: "0",
                  zipPlus4: "1",
                  zip4: "1",
                  phone: "2",
                  ssn: "3",
                };
                const FORMAT_DEFAULT = {
                  number: {
                    nDec: 0,
                    sepComma: false,
                    negStyle: "MinusBlack",
                    currency: "",
                    currencyPrepend: true,
                  },
                  percent: {
                    nDec: 0,
                    sepComma: false,
                  },
                };
                var AcroFormMixin = {
                  /**
                   * Must call if adding AcroForms to a document. Must also call font() before
                   * this method to set the default font.
                   */
                  initForm() {
                    if (!this._font) {
                      throw new Error(
                        "Must set a font before calling initForm method"
                      );
                    }
  
                    this._acroform = {
                      fonts: {},
                      defaultFont: this._font.name,
                    };
                    this._acroform.fonts[this._font.id] = this._font.ref();
                    let data = {
                      Fields: [],
                      NeedAppearances: true,
                      DA: new String(`/${this._font.id} 0 Tf 0 g`),
                      DR: {
                        Font: {},
                      },
                    };
                    data.DR.Font[this._font.id] = this._font.ref();
                    const AcroForm = this.ref(data);
                    this._root.data.AcroForm = AcroForm;
                    return this;
                  },
  
                  /**
                   * Called automatically by document.js
                   */
                  endAcroForm() {
                    if (this._root.data.AcroForm) {
                      if (
                        !Object.keys(this._acroform.fonts).length &&
                        !this._acroform.defaultFont
                      ) {
                        throw new Error("No fonts specified for PDF form");
                      }
  
                      let fontDict = this._root.data.AcroForm.data.DR.Font;
                      Object.keys(this._acroform.fonts).forEach((name) => {
                        fontDict[name] = this._acroform.fonts[name];
                      });
  
                      this._root.data.AcroForm.data.Fields.forEach((fieldRef) => {
                        this._endChild(fieldRef);
                      });
  
                      this._root.data.AcroForm.end();
                    }
  
                    return this;
                  },
  
                  _endChild(ref) {
                    if (Array.isArray(ref.data.Kids)) {
                      ref.data.Kids.forEach((childRef) => {
                        this._endChild(childRef);
                      });
                      ref.end();
                    }
  
                    return this;
                  },
  
                  /**
                   * Creates and adds a form field to the document. Form fields are intermediate
                   * nodes in a PDF form that are used to specify form name heirarchy and form
                   * value defaults.
                   * @param {string} name - field name (T attribute in field dictionary)
                   * @param {object} options  - other attributes to include in field dictionary
                   */
                  formField(name, options = {}) {
                    let fieldDict = this._fieldDict(name, null, options);
  
                    let fieldRef = this.ref(fieldDict);
  
                    this._addToParent(fieldRef);
  
                    return fieldRef;
                  },
  
                  /**
                   * Creates and adds a Form Annotation to the document. Form annotations are
                   * called Widget annotations internally within a PDF file.
                   * @param {string} name - form field name (T attribute of widget annotation
                   * dictionary)
                   * @param {number} x
                   * @param {number} y
                   * @param {number} w
                   * @param {number} h
                   * @param {object} options
                   */
                  formAnnotation(name, type, x, y, w, h, options = {}) {
                    let fieldDict = this._fieldDict(name, type, options);
  
                    fieldDict.Subtype = "Widget";
  
                    if (fieldDict.F === undefined) {
                      fieldDict.F = 4; // print the annotation
                    } // Add Field annot to page, and get it's ref
  
                    this.annotate(x, y, w, h, fieldDict);
                    let annotRef =
                      this.page.annotations[this.page.annotations.length - 1];
                    return this._addToParent(annotRef);
                  },
  
                  formText(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(name, "text", x, y, w, h, options);
                  },
  
                  formPushButton(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(
                      name,
                      "pushButton",
                      x,
                      y,
                      w,
                      h,
                      options
                    );
                  },
  
                  formCombo(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(
                      name,
                      "combo",
                      x,
                      y,
                      w,
                      h,
                      options
                    );
                  },
  
                  formList(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(name, "list", x, y, w, h, options);
                  },
  
                  formRadioButton(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(
                      name,
                      "radioButton",
                      x,
                      y,
                      w,
                      h,
                      options
                    );
                  },
  
                  formCheckbox(name, x, y, w, h, options = {}) {
                    return this.formAnnotation(
                      name,
                      "checkbox",
                      x,
                      y,
                      w,
                      h,
                      options
                    );
                  },
  
                  _addToParent(fieldRef) {
                    let parent = fieldRef.data.Parent;
  
                    if (parent) {
                      if (!parent.data.Kids) {
                        parent.data.Kids = [];
                      }
  
                      parent.data.Kids.push(fieldRef);
                    } else {
                      this._root.data.AcroForm.data.Fields.push(fieldRef);
                    }
  
                    return this;
                  },
  
                  _fieldDict(name, type, options = {}) {
                    if (!this._acroform) {
                      throw new Error(
                        "Call document.initForms() method before adding form elements to document"
                      );
                    }
  
                    let opts = Object.assign({}, options);
  
                    if (type !== null) {
                      opts = this._resolveType(type, options);
                    }
  
                    opts = this._resolveFlags(opts);
                    opts = this._resolveJustify(opts);
                    opts = this._resolveFont(opts);
                    opts = this._resolveStrings(opts);
                    opts = this._resolveColors(opts);
                    opts = this._resolveFormat(opts);
                    opts.T = new String(name);
  
                    if (opts.parent) {
                      opts.Parent = opts.parent;
                      delete opts.parent;
                    }
  
                    return opts;
                  },
  
                  _resolveType(type, opts) {
                    if (type === "text") {
                      opts.FT = "Tx";
                    } else if (type === "pushButton") {
                      opts.FT = "Btn";
                      opts.pushButton = true;
                    } else if (type === "radioButton") {
                      opts.FT = "Btn";
                      opts.radioButton = true;
                    } else if (type === "checkbox") {
                      opts.FT = "Btn";
                    } else if (type === "combo") {
                      opts.FT = "Ch";
                      opts.combo = true;
                    } else if (type === "list") {
                      opts.FT = "Ch";
                    } else {
                      throw new Error(`Invalid form annotation type '${type}'`);
                    }
  
                    return opts;
                  },
  
                  _resolveFormat(opts) {
                    const f = opts.format;
  
                    if (f && f.type) {
                      let fnKeystroke;
                      let fnFormat;
                      let params = "";
  
                      if (FORMAT_SPECIAL[f.type] !== undefined) {
                        fnKeystroke = `AFSpecial_Keystroke`;
                        fnFormat = `AFSpecial_Format`;
                        params = FORMAT_SPECIAL[f.type];
                      } else {
                        let format =
                          f.type.charAt(0).toUpperCase() + f.type.slice(1);
                        fnKeystroke = `AF${format}_Keystroke`;
                        fnFormat = `AF${format}_Format`;
  
                        if (f.type === "date") {
                          fnKeystroke += "Ex";
                          params = String(f.param);
                        } else if (f.type === "time") {
                          params = String(f.param);
                        } else if (f.type === "number") {
                          let p = Object.assign({}, FORMAT_DEFAULT.number, f);
                          params = String(
                            [
                              String(p.nDec),
                              p.sepComma ? "0" : "1",
                              '"' + p.negStyle + '"',
                              "null",
                              '"' + p.currency + '"',
                              String(p.currencyPrepend),
                            ].join(",")
                          );
                        } else if (f.type === "percent") {
                          let p = Object.assign({}, FORMAT_DEFAULT.percent, f);
                          params = String(
                            [String(p.nDec), p.sepComma ? "0" : "1"].join(",")
                          );
                        }
                      }
  
                      opts.AA = opts.AA ? opts.AA : {};
                      opts.AA.K = {
                        S: "JavaScript",
                        JS: new String(`${fnKeystroke}(${params});`),
                      };
                      opts.AA.F = {
                        S: "JavaScript",
                        JS: new String(`${fnFormat}(${params});`),
                      };
                    }
  
                    delete opts.format;
                    return opts;
                  },
  
                  _resolveColors(opts) {
                    let color = this._normalizeColor(opts.backgroundColor);
  
                    if (color) {
                      if (!opts.MK) {
                        opts.MK = {};
                      }
  
                      opts.MK.BG = color;
                    }
  
                    color = this._normalizeColor(opts.borderColor);
  
                    if (color) {
                      if (!opts.MK) {
                        opts.MK = {};
                      }
  
                      opts.MK.BC = color;
                    }
  
                    delete opts.backgroundColor;
                    delete opts.borderColor;
                    return opts;
                  },
  
                  _resolveFlags(options) {
                    let result = 0;
                    Object.keys(options).forEach((key) => {
                      if (FIELD_FLAGS[key]) {
                        result |= FIELD_FLAGS[key];
                        delete options[key];
                      }
                    });
  
                    if (result !== 0) {
                      options.Ff = options.Ff ? options.Ff : 0;
                      options.Ff |= result;
                    }
  
                    return options;
                  },
  
                  _resolveJustify(options) {
                    let result = 0;
  
                    if (options.align !== undefined) {
                      if (typeof FIELD_JUSTIFY[options.align] === "number") {
                        result = FIELD_JUSTIFY[options.align];
                      }
  
                      delete options.align;
                    }
  
                    if (result !== 0) {
                      options.Q = result; // default
                    }
  
                    return options;
                  },
  
                  _resolveFont(options) {
                    // add current font to document-level AcroForm dict if necessary
                    if (this._acroform.fonts[this._font.id] === null) {
                      this._acroform.fonts[this._font.id] = this._font.ref();
                    } // add current font to field's resource dict (RD) if not the default acroform font
  
                    if (this._acroform.defaultFont !== this._font.name) {
                      options.DR = {
                        Font: {},
                      }; // Get the fontSize option. If not set use auto sizing
  
                      const fontSize = options.fontSize || 0;
                      options.DR.Font[this._font.id] = this._font.ref();
                      options.DA = new String(
                        `/${this._font.id} ${fontSize} Tf 0 g`
                      );
                    }
  
                    return options;
                  },
  
                  _resolveStrings(options) {
                    let select = [];
  
                    function appendChoices(a) {
                      if (Array.isArray(a)) {
                        for (let idx = 0; idx < a.length; idx++) {
                          if (typeof a[idx] === "string") {
                            select.push(new String(a[idx]));
                          } else {
                            select.push(a[idx]);
                          }
                        }
                      }
                    }
  
                    appendChoices(options.Opt);
  
                    if (options.select) {
                      appendChoices(options.select);
                      delete options.select;
                    }
  
                    if (select.length) {
                      options.Opt = select;
                    }
  
                    Object.keys(VALUE_MAP).forEach((key) => {
                      if (options[key] !== undefined) {
                        options[VALUE_MAP[key]] = options[key];
                        delete options[key];
                      }
                    });
                    ["V", "DV"].forEach((key) => {
                      if (typeof options[key] === "string") {
                        options[key] = new String(options[key]);
                      }
                    });
  
                    if (options.MK && options.MK.CA) {
                      options.MK.CA = new String(options.MK.CA);
                    }
  
                    if (options.label) {
                      options.MK = options.MK ? options.MK : {};
                      options.MK.CA = new String(options.label);
                      delete options.label;
                    }
  
                    return options;
                  },
                };
  
                var AttachmentsMixin = {
                  /**
                   * Embed contents of `src` in PDF
                   * @param {Buffer | ArrayBuffer | string} src input Buffer, ArrayBuffer, base64 encoded string or path to file
                   * @param {object} options
                   *  * options.name: filename to be shown in PDF, will use `src` if none set
                   *  * options.type: filetype to be shown in PDF
                   *  * options.description: description to be shown in PDF
                   *  * options.hidden: if true, do not add attachment to EmbeddedFiles dictionary. Useful for file attachment annotations
                   *  * options.creationDate: override creation date
                   *  * options.modifiedDate: override modified date
                   * @returns filespec reference
                   */
                  file(src, options = {}) {
                    options.name = options.name || src;
                    const refBody = {
                      Type: "EmbeddedFile",
                      Params: {},
                    };
                    let data;
  
                    if (!src) {
                      throw new Error("No src specified");
                    }
  
                    if (Buffer.isBuffer(src)) {
                      data = src;
                    } else if (src instanceof ArrayBuffer) {
                      data = Buffer.from(new Uint8Array(src));
                    } else {
                      let match;
  
                      if ((match = /^data:(.*);base64,(.*)$/.exec(src))) {
                        if (match[1]) {
                          refBody.Subtype = match[1].replace("/", "#2F");
                        }
  
                        data = Buffer.from(match[2], "base64");
                      } else {
                        data = fs.readFileSync(src);
  
                        if (!data) {
                          throw new Error(
                            `Could not read contents of file at filepath ${src}`
                          );
                        } // update CreationDate and ModDate
  
                        const { birthtime, ctime } = fs.statSync(src);
                        refBody.Params.CreationDate = birthtime;
                        refBody.Params.ModDate = ctime;
                      }
                    } // override creation date and modified date
  
                    if (options.creationDate instanceof Date) {
                      refBody.Params.CreationDate = options.creationDate;
                    }
  
                    if (options.modifiedDate instanceof Date) {
                      refBody.Params.ModDate = options.modifiedDate;
                    } // add optional subtype
  
                    if (options.type) {
                      refBody.Subtype = options.type.replace("/", "#2F");
                    } // add checksum and size information
  
                    const checksum = CryptoJS.MD5(
                      CryptoJS.lib.WordArray.create(new Uint8Array(data))
                    );
                    refBody.Params.CheckSum = new String(checksum);
                    refBody.Params.Size = data.byteLength; // save some space when embedding the same file again
                    // if a file with the same name and metadata exists, reuse its reference
  
                    let ref;
                    if (!this._fileRegistry) this._fileRegistry = {};
                    let file = this._fileRegistry[options.name];
  
                    if (file && isEqual(refBody, file)) {
                      ref = file.ref;
                    } else {
                      ref = this.ref(refBody);
                      ref.end(data);
                      this._fileRegistry[options.name] = _objectSpread2(
                        _objectSpread2({}, refBody),
                        {},
                        {
                          ref,
                        }
                      );
                    } // add filespec for embedded file
  
                    const fileSpecBody = {
                      Type: "Filespec",
                      F: new String(options.name),
                      EF: {
                        F: ref,
                      },
                      UF: new String(options.name),
                    };
  
                    if (options.description) {
                      fileSpecBody.Desc = new String(options.description);
                    }
  
                    const filespec = this.ref(fileSpecBody);
                    filespec.end();
  
                    if (!options.hidden) {
                      this.addNamedEmbeddedFile(options.name, filespec);
                    }
  
                    return filespec;
                  },
                };
                /** check two embedded file metadata objects for equality */
  
                function isEqual(a, b) {
                  return (
                    a.Subtype === b.Subtype &&
                    a.Params.CheckSum.toString() ===
                      b.Params.CheckSum.toString() &&
                    a.Params.Size === b.Params.Size &&
                    a.Params.CreationDate === b.Params.CreationDate &&
                    a.Params.ModDate === b.Params.ModDate
                  );
                }
  
                /*
  PDFDocument - represents an entire PDF document
  By Devon Govett
  */
  
                class PDFDocument extends stream.Readable {
                  constructor(options = {}) {
                    super(options);
                    this.options = options; // PDF version
  
                    switch (options.pdfVersion) {
                      case "1.4":
                        this.version = 1.4;
                        break;
  
                      case "1.5":
                        this.version = 1.5;
                        break;
  
                      case "1.6":
                        this.version = 1.6;
                        break;
  
                      case "1.7":
                      case "1.7ext3":
                        this.version = 1.7;
                        break;
  
                      default:
                        this.version = 1.3;
                        break;
                    } // Whether streams should be compressed
  
                    this.compress =
                      this.options.compress != null
                        ? this.options.compress
                        : true;
                    this._pageBuffer = [];
                    this._pageBufferStart = 0; // The PDF object store
  
                    this._offsets = [];
                    this._waiting = 0;
                    this._ended = false;
                    this._offset = 0;
                    const Pages = this.ref({
                      Type: "Pages",
                      Count: 0,
                      Kids: [],
                    });
                    const Names = this.ref({
                      Dests: new PDFNameTree(),
                    });
                    this._root = this.ref({
                      Type: "Catalog",
                      Pages,
                      Names,
                    });
  
                    if (this.options.lang) {
                      this._root.data.Lang = new String(this.options.lang);
                    } // The current page
  
                    this.page = null; // Initialize mixins
  
                    this.initColor();
                    this.initVector();
                    this.initFonts(options.font);
                    this.initText();
                    this.initImages();
                    this.initOutline();
                    this.initMarkings(options); // Initialize the metadata
  
                    this.info = {
                      Producer: "PDFKit",
                      Creator: "PDFKit",
                      CreationDate: new Date(),
                    };
  
                    if (this.options.info) {
                      for (let key in this.options.info) {
                        const val = this.options.info[key];
                        this.info[key] = val;
                      }
                    }
  
                    if (this.options.displayTitle) {
                      this._root.data.ViewerPreferences = this.ref({
                        DisplayDocTitle: true,
                      });
                    } // Generate file ID
  
                    this._id = PDFSecurity.generateFileID(this.info); // Initialize security settings
  
                    this._security = PDFSecurity.create(this, options); // Write the header
                    // PDF version
  
                    this._write(`%PDF-${this.version}`); // 4 binary chars, as recommended by the spec
  
                    this._write("%\xFF\xFF\xFF\xFF"); // Add the first page
  
                    if (this.options.autoFirstPage !== false) {
                      this.addPage();
                    }
                  }
  
                  addPage(options) {
                    if (options == null) {
                      ({ options } = this);
                    } // end the current page if needed
  
                    if (!this.options.bufferPages) {
                      this.flushPages();
                    } // create a page object
  
                    this.page = new PDFPage(this, options);
  
                    this._pageBuffer.push(this.page); // add the page to the object store
  
                    const pages = this._root.data.Pages.data;
                    pages.Kids.push(this.page.dictionary);
                    pages.Count++; // reset x and y coordinates
  
                    this.x = this.page.margins.left;
                    this.y = this.page.margins.top; // flip PDF coordinate system so that the origin is in
                    // the top left rather than the bottom left
  
                    this._ctm = [1, 0, 0, 1, 0, 0];
                    this.transform(1, 0, 0, -1, 0, this.page.height);
                    this.emit("pageAdded");
                    return this;
                  }
  
                  continueOnNewPage(options) {
                    const pageMarkings = this.endPageMarkings(this.page);
                    this.addPage(options);
                    this.initPageMarkings(pageMarkings);
                    return this;
                  }
  
                  bufferedPageRange() {
                    return {
                      start: this._pageBufferStart,
                      count: this._pageBuffer.length,
                    };
                  }
  
                  switchToPage(n) {
                    let page;
  
                    if (!(page = this._pageBuffer[n - this._pageBufferStart])) {
                      throw new Error(
                        `switchToPage(${n}) out of bounds, current buffer covers pages ${
                          this._pageBufferStart
                        } to ${
                          this._pageBufferStart + this._pageBuffer.length - 1
                        }`
                      );
                    }
  
                    return (this.page = page);
                  }
  
                  flushPages() {
                    // this local variable exists so we're future-proof against
                    // reentrant calls to flushPages.
                    const pages = this._pageBuffer;
                    this._pageBuffer = [];
                    this._pageBufferStart += pages.length;
  
                    for (let page of pages) {
                      this.endPageMarkings(page);
                      page.end();
                    }
                  }
  
                  addNamedDestination(name, ...args) {
                    if (args.length === 0) {
                      args = ["XYZ", null, null, null];
                    }
  
                    if (args[0] === "XYZ" && args[2] !== null) {
                      args[2] = this.page.height - args[2];
                    }
  
                    args.unshift(this.page.dictionary);
  
                    this._root.data.Names.data.Dests.add(name, args);
                  }
  
                  addNamedEmbeddedFile(name, ref) {
                    if (!this._root.data.Names.data.EmbeddedFiles) {
                      // disabling /Limits for this tree fixes attachments not showing in Adobe Reader
                      this._root.data.Names.data.EmbeddedFiles = new PDFNameTree({
                        limits: false,
                      });
                    } // add filespec to EmbeddedFiles
  
                    this._root.data.Names.data.EmbeddedFiles.add(name, ref);
                  }
  
                  addNamedJavaScript(name, js) {
                    if (!this._root.data.Names.data.JavaScript) {
                      this._root.data.Names.data.JavaScript = new PDFNameTree();
                    }
  
                    let data = {
                      JS: new String(js),
                      S: "JavaScript",
                    };
  
                    this._root.data.Names.data.JavaScript.add(name, data);
                  }
  
                  ref(data) {
                    const ref = new PDFReference(
                      this,
                      this._offsets.length + 1,
                      data
                    );
  
                    this._offsets.push(null); // placeholder for this object's offset once it is finalized
  
                    this._waiting++;
                    return ref;
                  }
  
                  _read() {} // do nothing, but this method is required by node
  
                  _write(data) {
                    if (!Buffer.isBuffer(data)) {
                      data = Buffer.from(data + "\n", "binary");
                    }
  
                    this.push(data);
                    return (this._offset += data.length);
                  }
  
                  addContent(data) {
                    this.page.write(data);
                    return this;
                  }
  
                  _refEnd(ref) {
                    this._offsets[ref.id - 1] = ref.offset;
  
                    if (--this._waiting === 0 && this._ended) {
                      this._finalize();
  
                      return (this._ended = false);
                    }
                  }
  
                  write(filename, fn) {
                    // print a deprecation warning with a stacktrace
                    const err = new Error(`\
  PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. \
  Please pipe the document into a Node stream.\
  `);
                    console.warn(err.stack);
                    this.pipe(fs.createWriteStream(filename));
                    this.end();
                    return this.once("end", fn);
                  }
  
                  end() {
                    this.flushPages();
                    this._info = this.ref();
  
                    for (let key in this.info) {
                      let val = this.info[key];
  
                      if (typeof val === "string") {
                        val = new String(val);
                      }
  
                      let entry = this.ref(val);
                      entry.end();
                      this._info.data[key] = entry;
                    }
  
                    this._info.end();
  
                    for (let name in this._fontFamilies) {
                      const font = this._fontFamilies[name];
                      font.finalize();
                    }
  
                    this.endOutline();
                    this.endMarkings();
  
                    this._root.end();
  
                    this._root.data.Pages.end();
  
                    this._root.data.Names.end();
  
                    this.endAcroForm();
  
                    if (this._root.data.ViewerPreferences) {
                      this._root.data.ViewerPreferences.end();
                    }
  
                    if (this._security) {
                      this._security.end();
                    }
  
                    if (this._waiting === 0) {
                      return this._finalize();
                    } else {
                      return (this._ended = true);
                    }
                  }
  
                  _finalize() {
                    // generate xref
                    const xRefOffset = this._offset;
  
                    this._write("xref");
  
                    this._write(`0 ${this._offsets.length + 1}`);
  
                    this._write("0000000000 65535 f ");
  
                    for (let offset of this._offsets) {
                      offset = `0000000000${offset}`.slice(-10);
  
                      this._write(offset + " 00000 n ");
                    } // trailer
  
                    const trailer = {
                      Size: this._offsets.length + 1,
                      Root: this._root,
                      Info: this._info,
                      ID: [this._id, this._id],
                    };
  
                    if (this._security) {
                      trailer.Encrypt = this._security.dictionary;
                    }
  
                    this._write("trailer");
  
                    this._write(PDFObject.convert(trailer));
  
                    this._write("startxref");
  
                    this._write(`${xRefOffset}`);
  
                    this._write("%%EOF"); // end the stream
  
                    return this.push(null);
                  }
  
                  toString() {
                    return "[object PDFDocument]";
                  }
                }
  
                const mixin = (methods) => {
                  Object.assign(PDFDocument.prototype, methods);
                };
  
                mixin(ColorMixin);
                mixin(VectorMixin);
                mixin(FontsMixin);
                mixin(TextMixin);
                mixin(ImagesMixin);
                mixin(AnnotationsMixin);
                mixin(OutlineMixin);
                mixin(MarkingsMixin);
                mixin(AcroFormMixin);
                mixin(AttachmentsMixin);
                PDFDocument.LineWrapper = LineWrapper;
  
                module.exports = PDFDocument;
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          {
            buffer: 55,
            "crypto-js": 202,
            events: 231,
            fontkit: 232,
            fs: 54,
            linebreak: 249,
            "png-js": 259,
            stream: 297,
            zlib: 42,
          },
        ],
        2: [
          function (require, module, exports) {
            (function (global) {
              (function () {
                "use strict";
  
                var objectAssign = require("object-assign");
  
                // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
                // original notice:
  
                /*!
                 * The buffer module from node.js, for the browser.
                 *
                 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
                 * @license  MIT
                 */
                function compare(a, b) {
                  if (a === b) {
                    return 0;
                  }
  
                  var x = a.length;
                  var y = b.length;
  
                  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
                    if (a[i] !== b[i]) {
                      x = a[i];
                      y = b[i];
                      break;
                    }
                  }
  
                  if (x < y) {
                    return -1;
                  }
                  if (y < x) {
                    return 1;
                  }
                  return 0;
                }
                function isBuffer(b) {
                  if (
                    global.Buffer &&
                    typeof global.Buffer.isBuffer === "function"
                  ) {
                    return global.Buffer.isBuffer(b);
                  }
                  return !!(b != null && b._isBuffer);
                }
  
                // based on node assert, original notice:
                // NB: The URL to the CommonJS spec is kept just for tradition.
                //     node-assert has evolved a lot since then, both in API and behavior.
  
                // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
                //
                // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
                //
                // Originally from narwhal.js (http://narwhaljs.org)
                // Copyright (c) 2009 Thomas Robinson <280north.com>
                //
                // Permission is hereby granted, free of charge, to any person obtaining a copy
                // of this software and associated documentation files (the 'Software'), to
                // deal in the Software without restriction, including without limitation the
                // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
                // sell copies of the Software, and to permit persons to whom the Software is
                // furnished to do so, subject to the following conditions:
                //
                // The above copyright notice and this permission notice shall be included in
                // all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
                // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  
                var util = require("util/");
                var hasOwn = Object.prototype.hasOwnProperty;
                var pSlice = Array.prototype.slice;
                var functionsHaveNames = (function () {
                  return function foo() {}.name === "foo";
                })();
                function pToString(obj) {
                  return Object.prototype.toString.call(obj);
                }
                function isView(arrbuf) {
                  if (isBuffer(arrbuf)) {
                    return false;
                  }
                  if (typeof global.ArrayBuffer !== "function") {
                    return false;
                  }
                  if (typeof ArrayBuffer.isView === "function") {
                    return ArrayBuffer.isView(arrbuf);
                  }
                  if (!arrbuf) {
                    return false;
                  }
                  if (arrbuf instanceof DataView) {
                    return true;
                  }
                  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
                    return true;
                  }
                  return false;
                }
                // 1. The assert module provides functions that throw
                // AssertionError's when particular conditions are not met. The
                // assert module must conform to the following interface.
  
                var assert = (module.exports = ok);
  
                // 2. The AssertionError is defined in assert.
                // new assert.AssertionError({ message: message,
                //                             actual: actual,
                //                             expected: expected })
  
                var regex = /\s*function\s+([^\(\s]*)\s*/;
                // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
                function getName(func) {
                  if (!util.isFunction(func)) {
                    return;
                  }
                  if (functionsHaveNames) {
                    return func.name;
                  }
                  var str = func.toString();
                  var match = str.match(regex);
                  return match && match[1];
                }
                assert.AssertionError = function AssertionError(options) {
                  this.name = "AssertionError";
                  this.actual = options.actual;
                  this.expected = options.expected;
                  this.operator = options.operator;
                  if (options.message) {
                    this.message = options.message;
                    this.generatedMessage = false;
                  } else {
                    this.message = getMessage(this);
                    this.generatedMessage = true;
                  }
                  var stackStartFunction = options.stackStartFunction || fail;
                  if (Error.captureStackTrace) {
                    Error.captureStackTrace(this, stackStartFunction);
                  } else {
                    // non v8 browsers so we can have a stacktrace
                    var err = new Error();
                    if (err.stack) {
                      var out = err.stack;
  
                      // try to strip useless frames
                      var fn_name = getName(stackStartFunction);
                      var idx = out.indexOf("\n" + fn_name);
                      if (idx >= 0) {
                        // once we have located the function frame
                        // we need to strip out everything before it (and its line)
                        var next_line = out.indexOf("\n", idx + 1);
                        out = out.substring(next_line + 1);
                      }
  
                      this.stack = out;
                    }
                  }
                };
  
                // assert.AssertionError instanceof Error
                util.inherits(assert.AssertionError, Error);
  
                function truncate(s, n) {
                  if (typeof s === "string") {
                    return s.length < n ? s : s.slice(0, n);
                  } else {
                    return s;
                  }
                }
                function inspect(something) {
                  if (functionsHaveNames || !util.isFunction(something)) {
                    return util.inspect(something);
                  }
                  var rawname = getName(something);
                  var name = rawname ? ": " + rawname : "";
                  return "[Function" + name + "]";
                }
                function getMessage(self) {
                  return (
                    truncate(inspect(self.actual), 128) +
                    " " +
                    self.operator +
                    " " +
                    truncate(inspect(self.expected), 128)
                  );
                }
  
                // At present only the three keys mentioned above are used and
                // understood by the spec. Implementations or sub modules can pass
                // other keys to the AssertionError's constructor - they will be
                // ignored.
  
                // 3. All of the following functions must throw an AssertionError
                // when a corresponding condition is not met, with a message that
                // may be undefined if not provided.  All assertion methods provide
                // both the actual and expected values to the assertion error for
                // display purposes.
  
                function fail(
                  actual,
                  expected,
                  message,
                  operator,
                  stackStartFunction
                ) {
                  throw new assert.AssertionError({
                    message: message,
                    actual: actual,
                    expected: expected,
                    operator: operator,
                    stackStartFunction: stackStartFunction,
                  });
                }
  
                // EXTENSION! allows for well behaved errors defined elsewhere.
                assert.fail = fail;
  
                // 4. Pure assertion tests whether a value is truthy, as determined
                // by !!guard.
                // assert.ok(guard, message_opt);
                // This statement is equivalent to assert.equal(true, !!guard,
                // message_opt);. To test strictly for the value true, use
                // assert.strictEqual(true, guard, message_opt);.
  
                function ok(value, message) {
                  if (!value) fail(value, true, message, "==", assert.ok);
                }
                assert.ok = ok;
  
                // 5. The equality assertion tests shallow, coercive equality with
                // ==.
                // assert.equal(actual, expected, message_opt);
  
                assert.equal = function equal(actual, expected, message) {
                  if (actual != expected)
                    fail(actual, expected, message, "==", assert.equal);
                };
  
                // 6. The non-equality assertion tests for whether two objects are not equal
                // with != assert.notEqual(actual, expected, message_opt);
  
                assert.notEqual = function notEqual(actual, expected, message) {
                  if (actual == expected) {
                    fail(actual, expected, message, "!=", assert.notEqual);
                  }
                };
  
                // 7. The equivalence assertion tests a deep equality relation.
                // assert.deepEqual(actual, expected, message_opt);
  
                assert.deepEqual = function deepEqual(actual, expected, message) {
                  if (!_deepEqual(actual, expected, false)) {
                    fail(
                      actual,
                      expected,
                      message,
                      "deepEqual",
                      assert.deepEqual
                    );
                  }
                };
  
                assert.deepStrictEqual = function deepStrictEqual(
                  actual,
                  expected,
                  message
                ) {
                  if (!_deepEqual(actual, expected, true)) {
                    fail(
                      actual,
                      expected,
                      message,
                      "deepStrictEqual",
                      assert.deepStrictEqual
                    );
                  }
                };
  
                function _deepEqual(actual, expected, strict, memos) {
                  // 7.1. All identical values are equivalent, as determined by ===.
                  if (actual === expected) {
                    return true;
                  } else if (isBuffer(actual) && isBuffer(expected)) {
                    return compare(actual, expected) === 0;
  
                    // 7.2. If the expected value is a Date object, the actual value is
                    // equivalent if it is also a Date object that refers to the same time.
                  } else if (util.isDate(actual) && util.isDate(expected)) {
                    return actual.getTime() === expected.getTime();
  
                    // 7.3 If the expected value is a RegExp object, the actual value is
                    // equivalent if it is also a RegExp object with the same source and
                    // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
                  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
                    return (
                      actual.source === expected.source &&
                      actual.global === expected.global &&
                      actual.multiline === expected.multiline &&
                      actual.lastIndex === expected.lastIndex &&
                      actual.ignoreCase === expected.ignoreCase
                    );
  
                    // 7.4. Other pairs that do not both pass typeof value == 'object',
                    // equivalence is determined by ==.
                  } else if (
                    (actual === null || typeof actual !== "object") &&
                    (expected === null || typeof expected !== "object")
                  ) {
                    return strict ? actual === expected : actual == expected;
  
                    // If both values are instances of typed arrays, wrap their underlying
                    // ArrayBuffers in a Buffer each to increase performance
                    // This optimization requires the arrays to have the same type as checked by
                    // Object.prototype.toString (aka pToString). Never perform binary
                    // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
                    // bit patterns are not identical.
                  } else if (
                    isView(actual) &&
                    isView(expected) &&
                    pToString(actual) === pToString(expected) &&
                    !(
                      actual instanceof Float32Array ||
                      actual instanceof Float64Array
                    )
                  ) {
                    return (
                      compare(
                        new Uint8Array(actual.buffer),
                        new Uint8Array(expected.buffer)
                      ) === 0
                    );
  
                    // 7.5 For all other Object pairs, including Array objects, equivalence is
                    // determined by having the same number of owned properties (as verified
                    // with Object.prototype.hasOwnProperty.call), the same set of keys
                    // (although not necessarily the same order), equivalent values for every
                    // corresponding key, and an identical 'prototype' property. Note: this
                    // accounts for both named and indexed properties on Arrays.
                  } else if (isBuffer(actual) !== isBuffer(expected)) {
                    return false;
                  } else {
                    memos = memos || { actual: [], expected: [] };
  
                    var actualIndex = memos.actual.indexOf(actual);
                    if (actualIndex !== -1) {
                      if (actualIndex === memos.expected.indexOf(expected)) {
                        return true;
                      }
                    }
  
                    memos.actual.push(actual);
                    memos.expected.push(expected);
  
                    return objEquiv(actual, expected, strict, memos);
                  }
                }
  
                function isArguments(object) {
                  return (
                    Object.prototype.toString.call(object) == "[object Arguments]"
                  );
                }
  
                function objEquiv(a, b, strict, actualVisitedObjects) {
                  if (
                    a === null ||
                    a === undefined ||
                    b === null ||
                    b === undefined
                  )
                    return false;
                  // if one is a primitive, the other must be same
                  if (util.isPrimitive(a) || util.isPrimitive(b)) return a === b;
                  if (
                    strict &&
                    Object.getPrototypeOf(a) !== Object.getPrototypeOf(b)
                  )
                    return false;
                  var aIsArgs = isArguments(a);
                  var bIsArgs = isArguments(b);
                  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
                    return false;
                  if (aIsArgs) {
                    a = pSlice.call(a);
                    b = pSlice.call(b);
                    return _deepEqual(a, b, strict);
                  }
                  var ka = objectKeys(a);
                  var kb = objectKeys(b);
                  var key, i;
                  // having the same number of owned properties (keys incorporates
                  // hasOwnProperty)
                  if (ka.length !== kb.length) return false;
                  //the same set of keys (although not necessarily the same order),
                  ka.sort();
                  kb.sort();
                  //~~~cheap key test
                  for (i = ka.length - 1; i >= 0; i--) {
                    if (ka[i] !== kb[i]) return false;
                  }
                  //equivalent values for every corresponding key, and
                  //~~~possibly expensive deep test
                  for (i = ka.length - 1; i >= 0; i--) {
                    key = ka[i];
                    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
                      return false;
                  }
                  return true;
                }
  
                // 8. The non-equivalence assertion tests for any deep inequality.
                // assert.notDeepEqual(actual, expected, message_opt);
  
                assert.notDeepEqual = function notDeepEqual(
                  actual,
                  expected,
                  message
                ) {
                  if (_deepEqual(actual, expected, false)) {
                    fail(
                      actual,
                      expected,
                      message,
                      "notDeepEqual",
                      assert.notDeepEqual
                    );
                  }
                };
  
                assert.notDeepStrictEqual = notDeepStrictEqual;
                function notDeepStrictEqual(actual, expected, message) {
                  if (_deepEqual(actual, expected, true)) {
                    fail(
                      actual,
                      expected,
                      message,
                      "notDeepStrictEqual",
                      notDeepStrictEqual
                    );
                  }
                }
  
                // 9. The strict equality assertion tests strict equality, as determined by ===.
                // assert.strictEqual(actual, expected, message_opt);
  
                assert.strictEqual = function strictEqual(
                  actual,
                  expected,
                  message
                ) {
                  if (actual !== expected) {
                    fail(actual, expected, message, "===", assert.strictEqual);
                  }
                };
  
                // 10. The strict non-equality assertion tests for strict inequality, as
                // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
  
                assert.notStrictEqual = function notStrictEqual(
                  actual,
                  expected,
                  message
                ) {
                  if (actual === expected) {
                    fail(actual, expected, message, "!==", assert.notStrictEqual);
                  }
                };
  
                function expectedException(actual, expected) {
                  if (!actual || !expected) {
                    return false;
                  }
  
                  if (
                    Object.prototype.toString.call(expected) == "[object RegExp]"
                  ) {
                    return expected.test(actual);
                  }
  
                  try {
                    if (actual instanceof expected) {
                      return true;
                    }
                  } catch (e) {
                    // Ignore.  The instanceof check doesn't work for arrow functions.
                  }
  
                  if (Error.isPrototypeOf(expected)) {
                    return false;
                  }
  
                  return expected.call({}, actual) === true;
                }
  
                function _tryBlock(block) {
                  var error;
                  try {
                    block();
                  } catch (e) {
                    error = e;
                  }
                  return error;
                }
  
                function _throws(shouldThrow, block, expected, message) {
                  var actual;
  
                  if (typeof block !== "function") {
                    throw new TypeError('"block" argument must be a function');
                  }
  
                  if (typeof expected === "string") {
                    message = expected;
                    expected = null;
                  }
  
                  actual = _tryBlock(block);
  
                  message =
                    (expected && expected.name
                      ? " (" + expected.name + ")."
                      : ".") + (message ? " " + message : ".");
  
                  if (shouldThrow && !actual) {
                    fail(
                      actual,
                      expected,
                      "Missing expected exception" + message
                    );
                  }
  
                  var userProvidedMessage = typeof message === "string";
                  var isUnwantedException = !shouldThrow && util.isError(actual);
                  var isUnexpectedException = !shouldThrow && actual && !expected;
  
                  if (
                    (isUnwantedException &&
                      userProvidedMessage &&
                      expectedException(actual, expected)) ||
                    isUnexpectedException
                  ) {
                    fail(actual, expected, "Got unwanted exception" + message);
                  }
  
                  if (
                    (shouldThrow &&
                      actual &&
                      expected &&
                      !expectedException(actual, expected)) ||
                    (!shouldThrow && actual)
                  ) {
                    throw actual;
                  }
                }
  
                // 11. Expected to throw an error:
                // assert.throws(block, Error_opt, message_opt);
  
                assert.throws = function (
                  block,
                  /*optional*/ error,
                  /*optional*/ message
                ) {
                  _throws(true, block, error, message);
                };
  
                // EXTENSION! This is annoying to write outside this module.
                assert.doesNotThrow = function (
                  block,
                  /*optional*/ error,
                  /*optional*/ message
                ) {
                  _throws(false, block, error, message);
                };
  
                assert.ifError = function (err) {
                  if (err) throw err;
                };
  
                // Expose a strict only variant of assert
                function strict(value, message) {
                  if (!value) fail(value, true, message, "==", strict);
                }
                assert.strict = objectAssign(strict, assert, {
                  equal: assert.strictEqual,
                  deepEqual: assert.deepStrictEqual,
                  notEqual: assert.notStrictEqual,
                  notDeepEqual: assert.notDeepStrictEqual,
                });
                assert.strict.strict = assert.strict;
  
                var objectKeys =
                  Object.keys ||
                  function (obj) {
                    var keys = [];
                    for (var key in obj) {
                      if (hasOwn.call(obj, key)) keys.push(key);
                    }
                    return keys;
                  };
              }.call(this));
            }.call(
              this,
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {}
            ));
          },
          { "object-assign": 251, "util/": 5 },
        ],
        3: [
          function (require, module, exports) {
            if (typeof Object.create === "function") {
              // implementation from standard node.js 'util' module
              module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                ctor.prototype = Object.create(superCtor.prototype, {
                  constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true,
                  },
                });
              };
            } else {
              // old school shim for old browsers
              module.exports = function inherits(ctor, superCtor) {
                ctor.super_ = superCtor;
                var TempCtor = function () {};
                TempCtor.prototype = superCtor.prototype;
                ctor.prototype = new TempCtor();
                ctor.prototype.constructor = ctor;
              };
            }
          },
          {},
        ],
        4: [
          function (require, module, exports) {
            module.exports = function isBuffer(arg) {
              return (
                arg &&
                typeof arg === "object" &&
                typeof arg.copy === "function" &&
                typeof arg.fill === "function" &&
                typeof arg.readUInt8 === "function"
              );
            };
          },
          {},
        ],
        5: [
          function (require, module, exports) {
            (function (process, global) {
              (function () {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
                var formatRegExp = /%[sdj%]/g;
                exports.format = function (f) {
                  if (!isString(f)) {
                    var objects = [];
                    for (var i = 0; i < arguments.length; i++) {
                      objects.push(inspect(arguments[i]));
                    }
                    return objects.join(" ");
                  }
  
                  var i = 1;
                  var args = arguments;
                  var len = args.length;
                  var str = String(f).replace(formatRegExp, function (x) {
                    if (x === "%%") return "%";
                    if (i >= len) return x;
                    switch (x) {
                      case "%s":
                        return String(args[i++]);
                      case "%d":
                        return Number(args[i++]);
                      case "%j":
                        try {
                          return JSON.stringify(args[i++]);
                        } catch (_) {
                          return "[Circular]";
                        }
                      default:
                        return x;
                    }
                  });
                  for (var x = args[i]; i < len; x = args[++i]) {
                    if (isNull(x) || !isObject(x)) {
                      str += " " + x;
                    } else {
                      str += " " + inspect(x);
                    }
                  }
                  return str;
                };
  
                // Mark that a method should not be used.
                // Returns a modified function which warns once by default.
                // If --no-deprecation is set, then it is a no-op.
                exports.deprecate = function (fn, msg) {
                  // Allow for deprecating things in the process of starting up.
                  if (isUndefined(global.process)) {
                    return function () {
                      return exports.deprecate(fn, msg).apply(this, arguments);
                    };
                  }
  
                  if (process.noDeprecation === true) {
                    return fn;
                  }
  
                  var warned = false;
                  function deprecated() {
                    if (!warned) {
                      if (process.throwDeprecation) {
                        throw new Error(msg);
                      } else if (process.traceDeprecation) {
                        console.trace(msg);
                      } else {
                        console.error(msg);
                      }
                      warned = true;
                    }
                    return fn.apply(this, arguments);
                  }
  
                  return deprecated;
                };
  
                var debugs = {};
                var debugEnviron;
                exports.debuglog = function (set) {
                  if (isUndefined(debugEnviron))
                    debugEnviron = process.env.NODE_DEBUG || "";
                  set = set.toUpperCase();
                  if (!debugs[set]) {
                    if (new RegExp("\\b" + set + "\\b", "i").test(debugEnviron)) {
                      var pid = process.pid;
                      debugs[set] = function () {
                        var msg = exports.format.apply(exports, arguments);
                        console.error("%s %d: %s", set, pid, msg);
                      };
                    } else {
                      debugs[set] = function () {};
                    }
                  }
                  return debugs[set];
                };
  
                /**
                 * Echos the value of a value. Trys to print the value out
                 * in the best way possible given the different types.
                 *
                 * @param {Object} obj The object to print out.
                 * @param {Object} opts Optional options object that alters the output.
                 */
                /* legacy: obj, showHidden, depth, colors*/
                function inspect(obj, opts) {
                  // default options
                  var ctx = {
                    seen: [],
                    stylize: stylizeNoColor,
                  };
                  // legacy...
                  if (arguments.length >= 3) ctx.depth = arguments[2];
                  if (arguments.length >= 4) ctx.colors = arguments[3];
                  if (isBoolean(opts)) {
                    // legacy...
                    ctx.showHidden = opts;
                  } else if (opts) {
                    // got an "options" object
                    exports._extend(ctx, opts);
                  }
                  // set default options
                  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
                  if (isUndefined(ctx.depth)) ctx.depth = 2;
                  if (isUndefined(ctx.colors)) ctx.colors = false;
                  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
                  if (ctx.colors) ctx.stylize = stylizeWithColor;
                  return formatValue(ctx, obj, ctx.depth);
                }
                exports.inspect = inspect;
  
                // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
                inspect.colors = {
                  bold: [1, 22],
                  italic: [3, 23],
                  underline: [4, 24],
                  inverse: [7, 27],
                  white: [37, 39],
                  grey: [90, 39],
                  black: [30, 39],
                  blue: [34, 39],
                  cyan: [36, 39],
                  green: [32, 39],
                  magenta: [35, 39],
                  red: [31, 39],
                  yellow: [33, 39],
                };
  
                // Don't use 'blue' not visible on cmd.exe
                inspect.styles = {
                  special: "cyan",
                  number: "yellow",
                  boolean: "yellow",
                  undefined: "grey",
                  null: "bold",
                  string: "green",
                  date: "magenta",
                  // "name": intentionally not styling
                  regexp: "red",
                };
  
                function stylizeWithColor(str, styleType) {
                  var style = inspect.styles[styleType];
  
                  if (style) {
                    return (
                      "\u001b[" +
                      inspect.colors[style][0] +
                      "m" +
                      str +
                      "\u001b[" +
                      inspect.colors[style][1] +
                      "m"
                    );
                  } else {
                    return str;
                  }
                }
  
                function stylizeNoColor(str, styleType) {
                  return str;
                }
  
                function arrayToHash(array) {
                  var hash = {};
  
                  array.forEach(function (val, idx) {
                    hash[val] = true;
                  });
  
                  return hash;
                }
  
                function formatValue(ctx, value, recurseTimes) {
                  // Provide a hook for user-specified inspect functions.
                  // Check that value is an object with an inspect function on it
                  if (
                    ctx.customInspect &&
                    value &&
                    isFunction(value.inspect) &&
                    // Filter out the util module, it's inspect function is special
                    value.inspect !== exports.inspect &&
                    // Also filter out any prototype objects using the circular check.
                    !(value.constructor && value.constructor.prototype === value)
                  ) {
                    var ret = value.inspect(recurseTimes, ctx);
                    if (!isString(ret)) {
                      ret = formatValue(ctx, ret, recurseTimes);
                    }
                    return ret;
                  }
  
                  // Primitive types cannot have properties
                  var primitive = formatPrimitive(ctx, value);
                  if (primitive) {
                    return primitive;
                  }
  
                  // Look up the keys of the object.
                  var keys = Object.keys(value);
                  var visibleKeys = arrayToHash(keys);
  
                  if (ctx.showHidden) {
                    keys = Object.getOwnPropertyNames(value);
                  }
  
                  // IE doesn't make error fields non-enumerable
                  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
                  if (
                    isError(value) &&
                    (keys.indexOf("message") >= 0 ||
                      keys.indexOf("description") >= 0)
                  ) {
                    return formatError(value);
                  }
  
                  // Some type of object without properties can be shortcutted.
                  if (keys.length === 0) {
                    if (isFunction(value)) {
                      var name = value.name ? ": " + value.name : "";
                      return ctx.stylize("[Function" + name + "]", "special");
                    }
                    if (isRegExp(value)) {
                      return ctx.stylize(
                        RegExp.prototype.toString.call(value),
                        "regexp"
                      );
                    }
                    if (isDate(value)) {
                      return ctx.stylize(
                        Date.prototype.toString.call(value),
                        "date"
                      );
                    }
                    if (isError(value)) {
                      return formatError(value);
                    }
                  }
  
                  var base = "",
                    array = false,
                    braces = ["{", "}"];
  
                  // Make Array say that they are Array
                  if (isArray(value)) {
                    array = true;
                    braces = ["[", "]"];
                  }
  
                  // Make functions say that they are functions
                  if (isFunction(value)) {
                    var n = value.name ? ": " + value.name : "";
                    base = " [Function" + n + "]";
                  }
  
                  // Make RegExps say that they are RegExps
                  if (isRegExp(value)) {
                    base = " " + RegExp.prototype.toString.call(value);
                  }
  
                  // Make dates with properties first say the date
                  if (isDate(value)) {
                    base = " " + Date.prototype.toUTCString.call(value);
                  }
  
                  // Make error with message first say the error
                  if (isError(value)) {
                    base = " " + formatError(value);
                  }
  
                  if (keys.length === 0 && (!array || value.length == 0)) {
                    return braces[0] + base + braces[1];
                  }
  
                  if (recurseTimes < 0) {
                    if (isRegExp(value)) {
                      return ctx.stylize(
                        RegExp.prototype.toString.call(value),
                        "regexp"
                      );
                    } else {
                      return ctx.stylize("[Object]", "special");
                    }
                  }
  
                  ctx.seen.push(value);
  
                  var output;
                  if (array) {
                    output = formatArray(
                      ctx,
                      value,
                      recurseTimes,
                      visibleKeys,
                      keys
                    );
                  } else {
                    output = keys.map(function (key) {
                      return formatProperty(
                        ctx,
                        value,
                        recurseTimes,
                        visibleKeys,
                        key,
                        array
                      );
                    });
                  }
  
                  ctx.seen.pop();
  
                  return reduceToSingleString(output, base, braces);
                }
  
                function formatPrimitive(ctx, value) {
                  if (isUndefined(value))
                    return ctx.stylize("undefined", "undefined");
                  if (isString(value)) {
                    var simple =
                      "'" +
                      JSON.stringify(value)
                        .replace(/^"|"$/g, "")
                        .replace(/'/g, "\\'")
                        .replace(/\\"/g, '"') +
                      "'";
                    return ctx.stylize(simple, "string");
                  }
                  if (isNumber(value)) return ctx.stylize("" + value, "number");
                  if (isBoolean(value)) return ctx.stylize("" + value, "boolean");
                  // For some reason typeof null is "object", so special case here.
                  if (isNull(value)) return ctx.stylize("null", "null");
                }
  
                function formatError(value) {
                  return "[" + Error.prototype.toString.call(value) + "]";
                }
  
                function formatArray(
                  ctx,
                  value,
                  recurseTimes,
                  visibleKeys,
                  keys
                ) {
                  var output = [];
                  for (var i = 0, l = value.length; i < l; ++i) {
                    if (hasOwnProperty(value, String(i))) {
                      output.push(
                        formatProperty(
                          ctx,
                          value,
                          recurseTimes,
                          visibleKeys,
                          String(i),
                          true
                        )
                      );
                    } else {
                      output.push("");
                    }
                  }
                  keys.forEach(function (key) {
                    if (!key.match(/^\d+$/)) {
                      output.push(
                        formatProperty(
                          ctx,
                          value,
                          recurseTimes,
                          visibleKeys,
                          key,
                          true
                        )
                      );
                    }
                  });
                  return output;
                }
  
                function formatProperty(
                  ctx,
                  value,
                  recurseTimes,
                  visibleKeys,
                  key,
                  array
                ) {
                  var name, str, desc;
                  desc = Object.getOwnPropertyDescriptor(value, key) || {
                    value: value[key],
                  };
                  if (desc.get) {
                    if (desc.set) {
                      str = ctx.stylize("[Getter/Setter]", "special");
                    } else {
                      str = ctx.stylize("[Getter]", "special");
                    }
                  } else {
                    if (desc.set) {
                      str = ctx.stylize("[Setter]", "special");
                    }
                  }
                  if (!hasOwnProperty(visibleKeys, key)) {
                    name = "[" + key + "]";
                  }
                  if (!str) {
                    if (ctx.seen.indexOf(desc.value) < 0) {
                      if (isNull(recurseTimes)) {
                        str = formatValue(ctx, desc.value, null);
                      } else {
                        str = formatValue(ctx, desc.value, recurseTimes - 1);
                      }
                      if (str.indexOf("\n") > -1) {
                        if (array) {
                          str = str
                            .split("\n")
                            .map(function (line) {
                              return "  " + line;
                            })
                            .join("\n")
                            .substr(2);
                        } else {
                          str =
                            "\n" +
                            str
                              .split("\n")
                              .map(function (line) {
                                return "   " + line;
                              })
                              .join("\n");
                        }
                      }
                    } else {
                      str = ctx.stylize("[Circular]", "special");
                    }
                  }
                  if (isUndefined(name)) {
                    if (array && key.match(/^\d+$/)) {
                      return str;
                    }
                    name = JSON.stringify("" + key);
                    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                      name = name.substr(1, name.length - 2);
                      name = ctx.stylize(name, "name");
                    } else {
                      name = name
                        .replace(/'/g, "\\'")
                        .replace(/\\"/g, '"')
                        .replace(/(^"|"$)/g, "'");
                      name = ctx.stylize(name, "string");
                    }
                  }
  
                  return name + ": " + str;
                }
  
                function reduceToSingleString(output, base, braces) {
                  var numLinesEst = 0;
                  var length = output.reduce(function (prev, cur) {
                    numLinesEst++;
                    if (cur.indexOf("\n") >= 0) numLinesEst++;
                    return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
                  }, 0);
  
                  if (length > 60) {
                    return (
                      braces[0] +
                      (base === "" ? "" : base + "\n ") +
                      " " +
                      output.join(",\n  ") +
                      " " +
                      braces[1]
                    );
                  }
  
                  return (
                    braces[0] + base + " " + output.join(", ") + " " + braces[1]
                  );
                }
  
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
                function isArray(ar) {
                  return Array.isArray(ar);
                }
                exports.isArray = isArray;
  
                function isBoolean(arg) {
                  return typeof arg === "boolean";
                }
                exports.isBoolean = isBoolean;
  
                function isNull(arg) {
                  return arg === null;
                }
                exports.isNull = isNull;
  
                function isNullOrUndefined(arg) {
                  return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
  
                function isNumber(arg) {
                  return typeof arg === "number";
                }
                exports.isNumber = isNumber;
  
                function isString(arg) {
                  return typeof arg === "string";
                }
                exports.isString = isString;
  
                function isSymbol(arg) {
                  return typeof arg === "symbol";
                }
                exports.isSymbol = isSymbol;
  
                function isUndefined(arg) {
                  return arg === void 0;
                }
                exports.isUndefined = isUndefined;
  
                function isRegExp(re) {
                  return isObject(re) && objectToString(re) === "[object RegExp]";
                }
                exports.isRegExp = isRegExp;
  
                function isObject(arg) {
                  return typeof arg === "object" && arg !== null;
                }
                exports.isObject = isObject;
  
                function isDate(d) {
                  return isObject(d) && objectToString(d) === "[object Date]";
                }
                exports.isDate = isDate;
  
                function isError(e) {
                  return (
                    isObject(e) &&
                    (objectToString(e) === "[object Error]" || e instanceof Error)
                  );
                }
                exports.isError = isError;
  
                function isFunction(arg) {
                  return typeof arg === "function";
                }
                exports.isFunction = isFunction;
  
                function isPrimitive(arg) {
                  return (
                    arg === null ||
                    typeof arg === "boolean" ||
                    typeof arg === "number" ||
                    typeof arg === "string" ||
                    typeof arg === "symbol" || // ES6 symbol
                    typeof arg === "undefined"
                  );
                }
                exports.isPrimitive = isPrimitive;
  
                exports.isBuffer = require("./support/isBuffer");
  
                function objectToString(o) {
                  return Object.prototype.toString.call(o);
                }
  
                function pad(n) {
                  return n < 10 ? "0" + n.toString(10) : n.toString(10);
                }
  
                var months = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sep",
                  "Oct",
                  "Nov",
                  "Dec",
                ];
  
                // 26 Feb 16:19:34
                function timestamp() {
                  var d = new Date();
                  var time = [
                    pad(d.getHours()),
                    pad(d.getMinutes()),
                    pad(d.getSeconds()),
                  ].join(":");
                  return [d.getDate(), months[d.getMonth()], time].join(" ");
                }
  
                // log is just a thin wrapper to console.log that prepends a timestamp
                exports.log = function () {
                  console.log(
                    "%s - %s",
                    timestamp(),
                    exports.format.apply(exports, arguments)
                  );
                };
  
                /**
                 * Inherit the prototype methods from one constructor into another.
                 *
                 * The Function.prototype.inherits from lang.js rewritten as a standalone
                 * function (not on Function.prototype). NOTE: If this file is to be loaded
                 * during bootstrapping this function needs to be rewritten using some native
                 * functions as prototype setup using normal JavaScript does not work as
                 * expected during bootstrapping (see mirror.js in r114903).
                 *
                 * @param {function} ctor Constructor function which needs to inherit the
                 *     prototype.
                 * @param {function} superCtor Constructor function to inherit prototype from.
                 */
                exports.inherits = require("inherits");
  
                exports._extend = function (origin, add) {
                  // Don't do anything if add isn't an object
                  if (!add || !isObject(add)) return origin;
  
                  var keys = Object.keys(add);
                  var i = keys.length;
                  while (i--) {
                    origin[keys[i]] = add[keys[i]];
                  }
                  return origin;
                };
  
                function hasOwnProperty(obj, prop) {
                  return Object.prototype.hasOwnProperty.call(obj, prop);
                }
              }.call(this));
            }.call(
              this,
              require("_process"),
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {}
            ));
          },
          { "./support/isBuffer": 4, _process: 261, inherits: 3 },
        ],
        6: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/array/from"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/array/from": 60 },
        ],
        7: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/get-iterator"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/get-iterator": 61 },
        ],
        8: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/map"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/map": 62 },
        ],
        9: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/number/epsilon"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/number/epsilon": 63 },
        ],
        10: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/assign"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/assign": 64 },
        ],
        11: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/create"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/create": 65 },
        ],
        12: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/define-properties"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/define-properties": 66 },
        ],
        13: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/define-property"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/define-property": 67 },
        ],
        14: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/freeze"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/freeze": 68 },
        ],
        15: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/get-own-property-descriptor"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/get-own-property-descriptor": 69 },
        ],
        16: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/keys"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/keys": 70 },
        ],
        17: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/object/set-prototype-of"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/object/set-prototype-of": 71 },
        ],
        18: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/promise"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/promise": 72 },
        ],
        19: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/set"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/set": 73 },
        ],
        20: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/string/from-code-point"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/string/from-code-point": 74 },
        ],
        21: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/symbol"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/symbol": 75 },
        ],
        22: [
          function (require, module, exports) {
            module.exports = {
              default: require("core-js/library/fn/symbol/iterator"),
              __esModule: true,
            };
          },
          { "core-js/library/fn/symbol/iterator": 76 },
        ],
        23: [
          function (require, module, exports) {
            "use strict";
  
            exports.__esModule = true;
  
            exports.default = function (instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
              }
            };
          },
          {},
        ],
        24: [
          function (require, module, exports) {
            "use strict";
  
            exports.__esModule = true;
  
            var _defineProperty = require("../core-js/object/define-property");
  
            var _defineProperty2 = _interopRequireDefault(_defineProperty);
  
            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : { default: obj };
            }
  
            exports.default = (function () {
              function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  (0, _defineProperty2.default)(
                    target,
                    descriptor.key,
                    descriptor
                  );
                }
              }
  
              return function (Constructor, protoProps, staticProps) {
                if (protoProps)
                  defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
              };
            })();
          },
          { "../core-js/object/define-property": 13 },
        ],
        25: [
          function (require, module, exports) {
            "use strict";
  
            exports.__esModule = true;
  
            var _setPrototypeOf = require("../core-js/object/set-prototype-of");
  
            var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
  
            var _create = require("../core-js/object/create");
  
            var _create2 = _interopRequireDefault(_create);
  
            var _typeof2 = require("../helpers/typeof");
  
            var _typeof3 = _interopRequireDefault(_typeof2);
  
            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : { default: obj };
            }
  
            exports.default = function (subClass, superClass) {
              if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError(
                  "Super expression must either be null or a function, not " +
                    (typeof superClass === "undefined"
                      ? "undefined"
                      : (0, _typeof3.default)(superClass))
                );
              }
  
              subClass.prototype = (0, _create2.default)(
                superClass && superClass.prototype,
                {
                  constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true,
                  },
                }
              );
              if (superClass)
                _setPrototypeOf2.default
                  ? (0, _setPrototypeOf2.default)(subClass, superClass)
                  : (subClass.__proto__ = superClass);
            };
          },
          {
            "../core-js/object/create": 11,
            "../core-js/object/set-prototype-of": 17,
            "../helpers/typeof": 27,
          },
        ],
        26: [
          function (require, module, exports) {
            "use strict";
  
            exports.__esModule = true;
  
            var _typeof2 = require("../helpers/typeof");
  
            var _typeof3 = _interopRequireDefault(_typeof2);
  
            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : { default: obj };
            }
  
            exports.default = function (self, call) {
              if (!self) {
                throw new ReferenceError(
                  "this hasn't been initialised - super() hasn't been called"
                );
              }
  
              return call &&
                ((typeof call === "undefined"
                  ? "undefined"
                  : (0, _typeof3.default)(call)) === "object" ||
                  typeof call === "function")
                ? call
                : self;
            };
          },
          { "../helpers/typeof": 27 },
        ],
        27: [
          function (require, module, exports) {
            "use strict";
  
            exports.__esModule = true;
  
            var _iterator = require("../core-js/symbol/iterator");
  
            var _iterator2 = _interopRequireDefault(_iterator);
  
            var _symbol = require("../core-js/symbol");
  
            var _symbol2 = _interopRequireDefault(_symbol);
  
            var _typeof =
              typeof _symbol2.default === "function" &&
              typeof _iterator2.default === "symbol"
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      typeof _symbol2.default === "function" &&
                      obj.constructor === _symbol2.default &&
                      obj !== _symbol2.default.prototype
                      ? "symbol"
                      : typeof obj;
                  };
  
            function _interopRequireDefault(obj) {
              return obj && obj.__esModule ? obj : { default: obj };
            }
  
            exports.default =
              typeof _symbol2.default === "function" &&
              _typeof(_iterator2.default) === "symbol"
                ? function (obj) {
                    return typeof obj === "undefined"
                      ? "undefined"
                      : _typeof(obj);
                  }
                : function (obj) {
                    return obj &&
                      typeof _symbol2.default === "function" &&
                      obj.constructor === _symbol2.default &&
                      obj !== _symbol2.default.prototype
                      ? "symbol"
                      : typeof obj === "undefined"
                      ? "undefined"
                      : _typeof(obj);
                  };
          },
          { "../core-js/symbol": 21, "../core-js/symbol/iterator": 22 },
        ],
        28: [
          function (require, module, exports) {
            "use strict";
  
            exports.byteLength = byteLength;
            exports.toByteArray = toByteArray;
            exports.fromByteArray = fromByteArray;
  
            var lookup = [];
            var revLookup = [];
            var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
  
            var code =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (var i = 0, len = code.length; i < len; ++i) {
              lookup[i] = code[i];
              revLookup[code.charCodeAt(i)] = i;
            }
  
            // Support decoding URL-safe base64 strings, as Node.js does.
            // See: https://en.wikipedia.org/wiki/Base64#URL_applications
            revLookup["-".charCodeAt(0)] = 62;
            revLookup["_".charCodeAt(0)] = 63;
  
            function getLens(b64) {
              var len = b64.length;
  
              if (len % 4 > 0) {
                throw new Error("Invalid string. Length must be a multiple of 4");
              }
  
              // Trim off extra bytes after placeholder bytes are found
              // See: https://github.com/beatgammit/base64-js/issues/42
              var validLen = b64.indexOf("=");
              if (validLen === -1) validLen = len;
  
              var placeHoldersLen = validLen === len ? 0 : 4 - (validLen % 4);
  
              return [validLen, placeHoldersLen];
            }
  
            // base64 is 4/3 + up to two characters of the original data
            function byteLength(b64) {
              var lens = getLens(b64);
              var validLen = lens[0];
              var placeHoldersLen = lens[1];
              return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
            }
  
            function _byteLength(b64, validLen, placeHoldersLen) {
              return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
            }
  
            function toByteArray(b64) {
              var tmp;
              var lens = getLens(b64);
              var validLen = lens[0];
              var placeHoldersLen = lens[1];
  
              var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  
              var curByte = 0;
  
              // if there are placeholders, only get up to the last complete 4 chars
              var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  
              for (var i = 0; i < len; i += 4) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 18) |
                  (revLookup[b64.charCodeAt(i + 1)] << 12) |
                  (revLookup[b64.charCodeAt(i + 2)] << 6) |
                  revLookup[b64.charCodeAt(i + 3)];
                arr[curByte++] = (tmp >> 16) & 0xff;
                arr[curByte++] = (tmp >> 8) & 0xff;
                arr[curByte++] = tmp & 0xff;
              }
  
              if (placeHoldersLen === 2) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 2) |
                  (revLookup[b64.charCodeAt(i + 1)] >> 4);
                arr[curByte++] = tmp & 0xff;
              }
  
              if (placeHoldersLen === 1) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 10) |
                  (revLookup[b64.charCodeAt(i + 1)] << 4) |
                  (revLookup[b64.charCodeAt(i + 2)] >> 2);
                arr[curByte++] = (tmp >> 8) & 0xff;
                arr[curByte++] = tmp & 0xff;
              }
  
              return arr;
            }
  
            function tripletToBase64(num) {
              return (
                lookup[(num >> 18) & 0x3f] +
                lookup[(num >> 12) & 0x3f] +
                lookup[(num >> 6) & 0x3f] +
                lookup[num & 0x3f]
              );
            }
  
            function encodeChunk(uint8, start, end) {
              var tmp;
              var output = [];
              for (var i = start; i < end; i += 3) {
                tmp =
                  ((uint8[i] << 16) & 0xff0000) +
                  ((uint8[i + 1] << 8) & 0xff00) +
                  (uint8[i + 2] & 0xff);
                output.push(tripletToBase64(tmp));
              }
              return output.join("");
            }
  
            function fromByteArray(uint8) {
              var tmp;
              var len = uint8.length;
              var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
              var parts = [];
              var maxChunkLength = 16383; // must be multiple of 3
  
              // go through the array every three bytes, we'll deal with trailing stuff later
              for (
                var i = 0, len2 = len - extraBytes;
                i < len2;
                i += maxChunkLength
              ) {
                parts.push(
                  encodeChunk(
                    uint8,
                    i,
                    i + maxChunkLength > len2 ? len2 : i + maxChunkLength
                  )
                );
              }
  
              // pad the end with zeros, but make sure to not forget the extra bytes
              if (extraBytes === 1) {
                tmp = uint8[len - 1];
                parts.push(lookup[tmp >> 2] + lookup[(tmp << 4) & 0x3f] + "==");
              } else if (extraBytes === 2) {
                tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                parts.push(
                  lookup[tmp >> 10] +
                    lookup[(tmp >> 4) & 0x3f] +
                    lookup[(tmp << 2) & 0x3f] +
                    "="
                );
              }
  
              return parts.join("");
            }
          },
          {},
        ],
        29: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Bit reading helpers
  */
  
            var BROTLI_READ_SIZE = 4096;
            var BROTLI_IBUF_SIZE = 2 * BROTLI_READ_SIZE + 32;
            var BROTLI_IBUF_MASK = 2 * BROTLI_READ_SIZE - 1;
  
            var kBitMask = new Uint32Array([
              0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191,
              16383, 32767, 65535, 131071, 262143, 524287, 1048575, 2097151,
              4194303, 8388607, 16777215,
            ]);
  
            /* Input byte buffer, consist of a ringbuffer and a "slack" region where */
            /* bytes from the start of the ringbuffer are copied. */
            function BrotliBitReader(input) {
              this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
              this.input_ = input; /* input callback */
  
              this.reset();
            }
  
            BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
            BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;
  
            BrotliBitReader.prototype.reset = function () {
              this.buf_ptr_ = 0; /* next input will write here */
              this.val_ = 0; /* pre-fetched bits */
              this.pos_ = 0; /* byte position in stream */
              this.bit_pos_ = 0; /* current bit-reading position in val_ */
              this.bit_end_pos_ = 0; /* bit-reading end position from LSB of val_ */
              this.eos_ = 0; /* input stream is finished */
  
              this.readMoreInput();
              for (var i = 0; i < 4; i++) {
                this.val_ |= this.buf_[this.pos_] << (8 * i);
                ++this.pos_;
              }
  
              return this.bit_end_pos_ > 0;
            };
  
            /* Fills up the input ringbuffer by calling the input callback.
  
     Does nothing if there are at least 32 bytes present after current position.
  
     Returns 0 if either:
      - the input callback returned an error, or
      - there is no more input and the position is past the end of the stream.
  
     After encountering the end of the input stream, 32 additional zero bytes are
     copied to the ringbuffer, therefore it is safe to call this function after
     every 32 bytes of input is read.
  */
            BrotliBitReader.prototype.readMoreInput = function () {
              if (this.bit_end_pos_ > 256) {
                return;
              } else if (this.eos_) {
                if (this.bit_pos_ > this.bit_end_pos_)
                  throw new Error(
                    "Unexpected end of input " +
                      this.bit_pos_ +
                      " " +
                      this.bit_end_pos_
                  );
              } else {
                var dst = this.buf_ptr_;
                var bytes_read = this.input_.read(
                  this.buf_,
                  dst,
                  BROTLI_READ_SIZE
                );
                if (bytes_read < 0) {
                  throw new Error("Unexpected end of input");
                }
  
                if (bytes_read < BROTLI_READ_SIZE) {
                  this.eos_ = 1;
                  /* Store 32 bytes of zero after the stream end. */
                  for (var p = 0; p < 32; p++)
                    this.buf_[dst + bytes_read + p] = 0;
                }
  
                if (dst === 0) {
                  /* Copy the head of the ringbuffer to the slack region. */
                  for (var p = 0; p < 32; p++)
                    this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
  
                  this.buf_ptr_ = BROTLI_READ_SIZE;
                } else {
                  this.buf_ptr_ = 0;
                }
  
                this.bit_end_pos_ += bytes_read << 3;
              }
            };
  
            /* Guarantees that there are at least 24 bits in the buffer. */
            BrotliBitReader.prototype.fillBitWindow = function () {
              while (this.bit_pos_ >= 8) {
                this.val_ >>>= 8;
                this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
                ++this.pos_;
                this.bit_pos_ = (this.bit_pos_ - 8) >>> 0;
                this.bit_end_pos_ = (this.bit_end_pos_ - 8) >>> 0;
              }
            };
  
            /* Reads the specified number of bits from Read Buffer. */
            BrotliBitReader.prototype.readBits = function (n_bits) {
              if (32 - this.bit_pos_ < n_bits) {
                this.fillBitWindow();
              }
  
              var val = (this.val_ >>> this.bit_pos_) & kBitMask[n_bits];
              this.bit_pos_ += n_bits;
              return val;
            };
  
            module.exports = BrotliBitReader;
          },
          {},
        ],
        30: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Lookup table to map the previous two bytes to a context id.
  
     There are four different context modeling modes defined here:
       CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
       CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
       CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
       CONTEXT_SIGNED: second-order context model tuned for signed integers.
  
     The context id for the UTF8 context model is calculated as follows. If p1
     and p2 are the previous two bytes, we calcualte the context as
  
       context = kContextLookup[p1] | kContextLookup[p2 + 256].
  
     If the previous two bytes are ASCII characters (i.e. < 128), this will be
     equivalent to
  
       context = 4 * context1(p1) + context2(p2),
  
     where context1 is based on the previous byte in the following way:
  
       0  : non-ASCII control
       1  : \t, \n, \r
       2  : space
       3  : other punctuation
       4  : " '
       5  : %
       6  : ( < [ {
       7  : ) > ] }
       8  : , ; :
       9  : .
       10 : =
       11 : number
       12 : upper-case vowel
       13 : upper-case consonant
       14 : lower-case vowel
       15 : lower-case consonant
  
     and context2 is based on the second last byte:
  
       0 : control, space
       1 : punctuation
       2 : upper-case letter, number
       3 : lower-case letter
  
     If the last byte is ASCII, and the second last byte is not (in a valid UTF8
     stream it will be a continuation byte, value between 128 and 191), the
     context is the same as if the second last byte was an ASCII control or space.
  
     If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
     be a continuation byte and the context id is 2 or 3 depending on the LSB of
     the last byte and to a lesser extent on the second last byte if it is ASCII.
  
     If the last byte is a UTF8 continuation byte, the second last byte can be:
       - continuation byte: the next byte is probably ASCII or lead byte (assuming
         4-byte UTF8 characters are rare) and the context id is 0 or 1.
       - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
       - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3
  
     The possible value combinations of the previous two bytes, the range of
     context ids and the type of the next byte is summarized in the table below:
  
     |--------\-----------------------------------------------------------------|
     |         \                         Last byte                              |
     | Second   \---------------------------------------------------------------|
     | last byte \    ASCII            |   cont. byte        |   lead byte      |
     |            \   (0-127)          |   (128-191)         |   (192-)         |
     |=============|===================|=====================|==================|
     |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
     |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
     |-------------|-------------------|---------------------|------------------|
     |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
     |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
     |-------------|-------------------|---------------------|------------------|
     |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
     |  (192-207)  |                   |  context: 0 - 1     |                  |
     |-------------|-------------------|---------------------|------------------|
     |  lead byte  | not valid         |  next: cont.        |  not valid       |
     |  (208-)     |                   |  context: 2 - 3     |                  |
     |-------------|-------------------|---------------------|------------------|
  
     The context id for the signed context mode is calculated as:
  
       context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].
  
     For any context modeling modes, the context ids can be calculated by |-ing
     together two lookups from one table using context model dependent offsets:
  
       context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].
  
     where offset1 and offset2 are dependent on the context mode.
  */
  
            var CONTEXT_LSB6 = 0;
            var CONTEXT_MSB6 = 1;
            var CONTEXT_UTF8 = 2;
            var CONTEXT_SIGNED = 3;
  
            /* Common context lookup table for all context modes. */
            exports.lookup = new Uint8Array([
              /* CONTEXT_UTF8, last byte. */
              /* ASCII range. */
              0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 8, 12, 16, 12, 12, 20, 12, 16, 24, 28,
              12, 12, 32, 12, 36, 12, 44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32,
              32, 24, 40, 28, 12, 12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52,
              52, 52, 52, 48, 52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12,
              28, 12, 12, 12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60,
              60, 56, 60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12,
              0, /* UTF8 continuation byte range. */
              0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0,
              1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
              0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
              /* UTF8 lead byte range. */
              2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2,
              3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
              2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
              /* CONTEXT_UTF8 second last byte. */
              /* ASCII range. */
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
              1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2,
              2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1,
              1, 1, 1, 1, 1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
              3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
              /* UTF8 continuation byte range. */
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, /* UTF8 lead byte range. */
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2,
              2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
              2, 2, /* CONTEXT_SIGNED, second last byte. */
              0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2,
              2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
              2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3,
              3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
              3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
              3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
              4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
              4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
              4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
              6, 6, 7,
              /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
              0,
              8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 16, 16, 16, 16, 16, 16,
              16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
              16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
              16, 16, 16, 16, 16, 16, 16, 16, 24, 24, 24, 24, 24, 24, 24, 24, 24,
              24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
              24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
              24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
              24, 24, 24, 24, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
              32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
              32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
              32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
              40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
              40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
              40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 48, 48, 48,
              48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
              /* CONTEXT_LSB6, last byte. */
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35,
              36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52,
              53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 0, 1, 2, 3, 4, 5, 6, 7,
              8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
              25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
              42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58,
              59, 60, 61, 62, 63, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
              14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
              31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
              48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 0,
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
              37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
              54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
              /* CONTEXT_MSB6, last byte. */
              0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5,
              5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 9, 10, 10, 10, 10,
              11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15,
              15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19,
              19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23,
              23, 24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
              28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31, 32,
              32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35, 36, 36,
              36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39, 40, 40, 40,
              40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43, 44, 44, 44, 44,
              45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47, 48, 48, 48, 48, 49,
              49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51, 52, 52, 52, 52, 53, 53,
              53, 53, 54, 54, 54, 54, 55, 55, 55, 55, 56, 56, 56, 56, 57, 57, 57,
              57, 58, 58, 58, 58, 59, 59, 59, 59, 60, 60, 60, 60, 61, 61, 61, 61,
              62, 62, 62, 62, 63, 63, 63, 63,
              /* CONTEXT_{M,L}SB6, second last byte, */
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0,
            ]);
  
            exports.lookupOffsets = new Uint16Array([
              /* CONTEXT_LSB6 */
              1024, 1536, /* CONTEXT_MSB6 */
              1280, 1536, /* CONTEXT_UTF8 */
              0, 256, /* CONTEXT_SIGNED */
              768, 512,
            ]);
          },
          {},
        ],
        31: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  */
  
            var BrotliInput = require("./streams").BrotliInput;
            var BrotliOutput = require("./streams").BrotliOutput;
            var BrotliBitReader = require("./bit_reader");
            var BrotliDictionary = require("./dictionary");
            var HuffmanCode = require("./huffman").HuffmanCode;
            var BrotliBuildHuffmanTable =
              require("./huffman").BrotliBuildHuffmanTable;
            var Context = require("./context");
            var Prefix = require("./prefix");
            var Transform = require("./transform");
  
            var kDefaultCodeLength = 8;
            var kCodeLengthRepeatCode = 16;
            var kNumLiteralCodes = 256;
            var kNumInsertAndCopyCodes = 704;
            var kNumBlockLengthCodes = 26;
            var kLiteralContextBits = 6;
            var kDistanceContextBits = 2;
  
            var HUFFMAN_TABLE_BITS = 8;
            var HUFFMAN_TABLE_MASK = 0xff;
            /* Maximum possible Huffman table size for an alphabet size of 704, max code
             * length 15 and root table bits 8. */
            var HUFFMAN_MAX_TABLE_SIZE = 1080;
  
            var CODE_LENGTH_CODES = 18;
            var kCodeLengthCodeOrder = new Uint8Array([
              1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
            ]);
  
            var NUM_DISTANCE_SHORT_CODES = 16;
            var kDistanceShortCodeIndexOffset = new Uint8Array([
              3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2,
            ]);
  
            var kDistanceShortCodeValueOffset = new Int8Array([
              0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3,
            ]);
  
            var kMaxHuffmanTableSize = new Uint16Array([
              256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758,
              790, 822, 854, 886, 920, 952, 984, 1016, 1048, 1080,
            ]);
  
            function DecodeWindowBits(br) {
              var n;
              if (br.readBits(1) === 0) {
                return 16;
              }
  
              n = br.readBits(3);
              if (n > 0) {
                return 17 + n;
              }
  
              n = br.readBits(3);
              if (n > 0) {
                return 8 + n;
              }
  
              return 17;
            }
  
            /* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
            function DecodeVarLenUint8(br) {
              if (br.readBits(1)) {
                var nbits = br.readBits(3);
                if (nbits === 0) {
                  return 1;
                } else {
                  return br.readBits(nbits) + (1 << nbits);
                }
              }
              return 0;
            }
  
            function MetaBlockLength() {
              this.meta_block_length = 0;
              this.input_end = 0;
              this.is_uncompressed = 0;
              this.is_metadata = false;
            }
  
            function DecodeMetaBlockLength(br) {
              var out = new MetaBlockLength();
              var size_nibbles;
              var size_bytes;
              var i;
  
              out.input_end = br.readBits(1);
              if (out.input_end && br.readBits(1)) {
                return out;
              }
  
              size_nibbles = br.readBits(2) + 4;
              if (size_nibbles === 7) {
                out.is_metadata = true;
  
                if (br.readBits(1) !== 0) throw new Error("Invalid reserved bit");
  
                size_bytes = br.readBits(2);
                if (size_bytes === 0) return out;
  
                for (i = 0; i < size_bytes; i++) {
                  var next_byte = br.readBits(8);
                  if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
                    throw new Error("Invalid size byte");
  
                  out.meta_block_length |= next_byte << (i * 8);
                }
              } else {
                for (i = 0; i < size_nibbles; ++i) {
                  var next_nibble = br.readBits(4);
                  if (
                    i + 1 === size_nibbles &&
                    size_nibbles > 4 &&
                    next_nibble === 0
                  )
                    throw new Error("Invalid size nibble");
  
                  out.meta_block_length |= next_nibble << (i * 4);
                }
              }
  
              ++out.meta_block_length;
  
              if (!out.input_end && !out.is_metadata) {
                out.is_uncompressed = br.readBits(1);
              }
  
              return out;
            }
  
            /* Decodes the next Huffman code from bit-stream. */
            function ReadSymbol(table, index, br) {
              var start_index = index;
  
              var nbits;
              br.fillBitWindow();
              index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
              nbits = table[index].bits - HUFFMAN_TABLE_BITS;
              if (nbits > 0) {
                br.bit_pos_ += HUFFMAN_TABLE_BITS;
                index += table[index].value;
                index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
              }
              br.bit_pos_ += table[index].bits;
              return table[index].value;
            }
  
            function ReadHuffmanCodeLengths(
              code_length_code_lengths,
              num_symbols,
              code_lengths,
              br
            ) {
              var symbol = 0;
              var prev_code_len = kDefaultCodeLength;
              var repeat = 0;
              var repeat_code_len = 0;
              var space = 32768;
  
              var table = [];
              for (var i = 0; i < 32; i++) table.push(new HuffmanCode(0, 0));
  
              BrotliBuildHuffmanTable(
                table,
                0,
                5,
                code_length_code_lengths,
                CODE_LENGTH_CODES
              );
  
              while (symbol < num_symbols && space > 0) {
                var p = 0;
                var code_len;
  
                br.readMoreInput();
                br.fillBitWindow();
                p += (br.val_ >>> br.bit_pos_) & 31;
                br.bit_pos_ += table[p].bits;
                code_len = table[p].value & 0xff;
                if (code_len < kCodeLengthRepeatCode) {
                  repeat = 0;
                  code_lengths[symbol++] = code_len;
                  if (code_len !== 0) {
                    prev_code_len = code_len;
                    space -= 32768 >> code_len;
                  }
                } else {
                  var extra_bits = code_len - 14;
                  var old_repeat;
                  var repeat_delta;
                  var new_len = 0;
                  if (code_len === kCodeLengthRepeatCode) {
                    new_len = prev_code_len;
                  }
                  if (repeat_code_len !== new_len) {
                    repeat = 0;
                    repeat_code_len = new_len;
                  }
                  old_repeat = repeat;
                  if (repeat > 0) {
                    repeat -= 2;
                    repeat <<= extra_bits;
                  }
                  repeat += br.readBits(extra_bits) + 3;
                  repeat_delta = repeat - old_repeat;
                  if (symbol + repeat_delta > num_symbols) {
                    throw new Error(
                      "[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols"
                    );
                  }
  
                  for (var x = 0; x < repeat_delta; x++)
                    code_lengths[symbol + x] = repeat_code_len;
  
                  symbol += repeat_delta;
  
                  if (repeat_code_len !== 0) {
                    space -= repeat_delta << (15 - repeat_code_len);
                  }
                }
              }
              if (space !== 0) {
                throw new Error("[ReadHuffmanCodeLengths] space = " + space);
              }
  
              for (; symbol < num_symbols; symbol++) code_lengths[symbol] = 0;
            }
  
            function ReadHuffmanCode(alphabet_size, tables, table, br) {
              var table_size = 0;
              var simple_code_or_skip;
              var code_lengths = new Uint8Array(alphabet_size);
  
              br.readMoreInput();
  
              /* simple_code_or_skip is used as follows:
       1 for simple code;
       0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
              simple_code_or_skip = br.readBits(2);
              if (simple_code_or_skip === 1) {
                /* Read symbols, codes & code lengths directly. */
                var i;
                var max_bits_counter = alphabet_size - 1;
                var max_bits = 0;
                var symbols = new Int32Array(4);
                var num_symbols = br.readBits(2) + 1;
                while (max_bits_counter) {
                  max_bits_counter >>= 1;
                  ++max_bits;
                }
  
                for (i = 0; i < num_symbols; ++i) {
                  symbols[i] = br.readBits(max_bits) % alphabet_size;
                  code_lengths[symbols[i]] = 2;
                }
                code_lengths[symbols[0]] = 1;
                switch (num_symbols) {
                  case 1:
                    break;
                  case 3:
                    if (
                      symbols[0] === symbols[1] ||
                      symbols[0] === symbols[2] ||
                      symbols[1] === symbols[2]
                    ) {
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    }
                    break;
                  case 2:
                    if (symbols[0] === symbols[1]) {
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    }
  
                    code_lengths[symbols[1]] = 1;
                    break;
                  case 4:
                    if (
                      symbols[0] === symbols[1] ||
                      symbols[0] === symbols[2] ||
                      symbols[0] === symbols[3] ||
                      symbols[1] === symbols[2] ||
                      symbols[1] === symbols[3] ||
                      symbols[2] === symbols[3]
                    ) {
                      throw new Error("[ReadHuffmanCode] invalid symbols");
                    }
  
                    if (br.readBits(1)) {
                      code_lengths[symbols[2]] = 3;
                      code_lengths[symbols[3]] = 3;
                    } else {
                      code_lengths[symbols[0]] = 2;
                    }
                    break;
                }
              } else {
                /* Decode Huffman-coded code lengths. */
                var i;
                var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
                var space = 32;
                var num_codes = 0;
                /* Static Huffman code for the code length code lengths */
                var huff = [
                  new HuffmanCode(2, 0),
                  new HuffmanCode(2, 4),
                  new HuffmanCode(2, 3),
                  new HuffmanCode(3, 2),
                  new HuffmanCode(2, 0),
                  new HuffmanCode(2, 4),
                  new HuffmanCode(2, 3),
                  new HuffmanCode(4, 1),
                  new HuffmanCode(2, 0),
                  new HuffmanCode(2, 4),
                  new HuffmanCode(2, 3),
                  new HuffmanCode(3, 2),
                  new HuffmanCode(2, 0),
                  new HuffmanCode(2, 4),
                  new HuffmanCode(2, 3),
                  new HuffmanCode(4, 5),
                ];
                for (
                  i = simple_code_or_skip;
                  i < CODE_LENGTH_CODES && space > 0;
                  ++i
                ) {
                  var code_len_idx = kCodeLengthCodeOrder[i];
                  var p = 0;
                  var v;
                  br.fillBitWindow();
                  p += (br.val_ >>> br.bit_pos_) & 15;
                  br.bit_pos_ += huff[p].bits;
                  v = huff[p].value;
                  code_length_code_lengths[code_len_idx] = v;
                  if (v !== 0) {
                    space -= 32 >> v;
                    ++num_codes;
                  }
                }
  
                if (!(num_codes === 1 || space === 0))
                  throw new Error("[ReadHuffmanCode] invalid num_codes or space");
  
                ReadHuffmanCodeLengths(
                  code_length_code_lengths,
                  alphabet_size,
                  code_lengths,
                  br
                );
              }
  
              table_size = BrotliBuildHuffmanTable(
                tables,
                table,
                HUFFMAN_TABLE_BITS,
                code_lengths,
                alphabet_size
              );
  
              if (table_size === 0) {
                throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
              }
  
              return table_size;
            }
  
            function ReadBlockLength(table, index, br) {
              var code;
              var nbits;
              code = ReadSymbol(table, index, br);
              nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
              return (
                Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits)
              );
            }
  
            function TranslateShortCodes(code, ringbuffer, index) {
              var val;
              if (code < NUM_DISTANCE_SHORT_CODES) {
                index += kDistanceShortCodeIndexOffset[code];
                index &= 3;
                val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
              } else {
                val = code - NUM_DISTANCE_SHORT_CODES + 1;
              }
              return val;
            }
  
            function MoveToFront(v, index) {
              var value = v[index];
              var i = index;
              for (; i; --i) v[i] = v[i - 1];
              v[0] = value;
            }
  
            function InverseMoveToFrontTransform(v, v_len) {
              var mtf = new Uint8Array(256);
              var i;
              for (i = 0; i < 256; ++i) {
                mtf[i] = i;
              }
              for (i = 0; i < v_len; ++i) {
                var index = v[i];
                v[i] = mtf[index];
                if (index) MoveToFront(mtf, index);
              }
            }
  
            /* Contains a collection of huffman trees with the same alphabet size. */
            function HuffmanTreeGroup(alphabet_size, num_htrees) {
              this.alphabet_size = alphabet_size;
              this.num_htrees = num_htrees;
              this.codes = new Array(
                num_htrees +
                  num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]
              );
              this.htrees = new Uint32Array(num_htrees);
            }
  
            HuffmanTreeGroup.prototype.decode = function (br) {
              var i;
              var table_size;
              var next = 0;
              for (i = 0; i < this.num_htrees; ++i) {
                this.htrees[i] = next;
                table_size = ReadHuffmanCode(
                  this.alphabet_size,
                  this.codes,
                  next,
                  br
                );
                next += table_size;
              }
            };
  
            function DecodeContextMap(context_map_size, br) {
              var out = { num_htrees: null, context_map: null };
              var use_rle_for_zeros;
              var max_run_length_prefix = 0;
              var table;
              var i;
  
              br.readMoreInput();
              var num_htrees = (out.num_htrees = DecodeVarLenUint8(br) + 1);
  
              var context_map = (out.context_map = new Uint8Array(
                context_map_size
              ));
              if (num_htrees <= 1) {
                return out;
              }
  
              use_rle_for_zeros = br.readBits(1);
              if (use_rle_for_zeros) {
                max_run_length_prefix = br.readBits(4) + 1;
              }
  
              table = [];
              for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
                table[i] = new HuffmanCode(0, 0);
              }
  
              ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
  
              for (i = 0; i < context_map_size; ) {
                var code;
  
                br.readMoreInput();
                code = ReadSymbol(table, 0, br);
                if (code === 0) {
                  context_map[i] = 0;
                  ++i;
                } else if (code <= max_run_length_prefix) {
                  var reps = 1 + (1 << code) + br.readBits(code);
                  while (--reps) {
                    if (i >= context_map_size) {
                      throw new Error("[DecodeContextMap] i >= context_map_size");
                    }
                    context_map[i] = 0;
                    ++i;
                  }
                } else {
                  context_map[i] = code - max_run_length_prefix;
                  ++i;
                }
              }
              if (br.readBits(1)) {
                InverseMoveToFrontTransform(context_map, context_map_size);
              }
  
              return out;
            }
  
            function DecodeBlockType(
              max_block_type,
              trees,
              tree_type,
              block_types,
              ringbuffers,
              indexes,
              br
            ) {
              var ringbuffer = tree_type * 2;
              var index = tree_type;
              var type_code = ReadSymbol(
                trees,
                tree_type * HUFFMAN_MAX_TABLE_SIZE,
                br
              );
              var block_type;
              if (type_code === 0) {
                block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
              } else if (type_code === 1) {
                block_type =
                  ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
              } else {
                block_type = type_code - 2;
              }
              if (block_type >= max_block_type) {
                block_type -= max_block_type;
              }
              block_types[tree_type] = block_type;
              ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
              ++indexes[index];
            }
  
            function CopyUncompressedBlockToOutput(
              output,
              len,
              pos,
              ringbuffer,
              ringbuffer_mask,
              br
            ) {
              var rb_size = ringbuffer_mask + 1;
              var rb_pos = pos & ringbuffer_mask;
              var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
              var nbytes;
  
              /* For short lengths copy byte-by-byte */
              if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
                while (len-- > 0) {
                  br.readMoreInput();
                  ringbuffer[rb_pos++] = br.readBits(8);
                  if (rb_pos === rb_size) {
                    output.write(ringbuffer, rb_size);
                    rb_pos = 0;
                  }
                }
                return;
              }
  
              if (br.bit_end_pos_ < 32) {
                throw new Error(
                  "[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32"
                );
              }
  
              /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
              while (br.bit_pos_ < 32) {
                ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
                br.bit_pos_ += 8;
                ++rb_pos;
                --len;
              }
  
              /* Copy remaining bytes from br.buf_ to ringbuffer. */
              nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
              if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
                var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
                for (var x = 0; x < tail; x++)
                  ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
  
                nbytes -= tail;
                rb_pos += tail;
                len -= tail;
                br_pos = 0;
              }
  
              for (var x = 0; x < nbytes; x++)
                ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
  
              rb_pos += nbytes;
              len -= nbytes;
  
              /* If we wrote past the logical end of the ringbuffer, copy the tail of the
       ringbuffer to its beginning and flush the ringbuffer to the output. */
              if (rb_pos >= rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos -= rb_size;
                for (var x = 0; x < rb_pos; x++)
                  ringbuffer[x] = ringbuffer[rb_size + x];
              }
  
              /* If we have more to copy than the remaining size of the ringbuffer, then we
       first fill the ringbuffer from the input and then flush the ringbuffer to
       the output */
              while (rb_pos + len >= rb_size) {
                nbytes = rb_size - rb_pos;
                if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
                  throw new Error(
                    "[CopyUncompressedBlockToOutput] not enough bytes"
                  );
                }
                output.write(ringbuffer, rb_size);
                len -= nbytes;
                rb_pos = 0;
              }
  
              /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
       flushed to the output at a later time. */
              if (br.input_.read(ringbuffer, rb_pos, len) < len) {
                throw new Error(
                  "[CopyUncompressedBlockToOutput] not enough bytes"
                );
              }
  
              /* Restore the state of the bit reader. */
              br.reset();
            }
  
            /* Advances the bit reader position to the next byte boundary and verifies
     that any skipped bits are set to zero. */
            function JumpToByteBoundary(br) {
              var new_bit_pos = (br.bit_pos_ + 7) & ~7;
              var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
              return pad_bits == 0;
            }
  
            function BrotliDecompressedSize(buffer) {
              var input = new BrotliInput(buffer);
              var br = new BrotliBitReader(input);
              DecodeWindowBits(br);
              var out = DecodeMetaBlockLength(br);
              return out.meta_block_length;
            }
  
            exports.BrotliDecompressedSize = BrotliDecompressedSize;
  
            function BrotliDecompressBuffer(buffer, output_size) {
              var input = new BrotliInput(buffer);
  
              if (output_size == null) {
                output_size = BrotliDecompressedSize(buffer);
              }
  
              var output_buffer = new Uint8Array(output_size);
              var output = new BrotliOutput(output_buffer);
  
              BrotliDecompress(input, output);
  
              if (output.pos < output.buffer.length) {
                output.buffer = output.buffer.subarray(0, output.pos);
              }
  
              return output.buffer;
            }
  
            exports.BrotliDecompressBuffer = BrotliDecompressBuffer;
  
            function BrotliDecompress(input, output) {
              var i;
              var pos = 0;
              var input_end = 0;
              var window_bits = 0;
              var max_backward_distance;
              var max_distance = 0;
              var ringbuffer_size;
              var ringbuffer_mask;
              var ringbuffer;
              var ringbuffer_end;
              /* This ring buffer holds a few past copy distances that will be used by */
              /* some special distance codes. */
              var dist_rb = [16, 15, 11, 4];
              var dist_rb_idx = 0;
              /* The previous 2 bytes used for context. */
              var prev_byte1 = 0;
              var prev_byte2 = 0;
              var hgroup = [
                new HuffmanTreeGroup(0, 0),
                new HuffmanTreeGroup(0, 0),
                new HuffmanTreeGroup(0, 0),
              ];
              var block_type_trees;
              var block_len_trees;
              var br;
  
              /* We need the slack region for the following reasons:
         - always doing two 8-byte copies for fast backward copying
         - transforms
         - flushing the input ringbuffer when decoding uncompressed blocks */
              var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;
  
              br = new BrotliBitReader(input);
  
              /* Decode window size. */
              window_bits = DecodeWindowBits(br);
              max_backward_distance = (1 << window_bits) - 16;
  
              ringbuffer_size = 1 << window_bits;
              ringbuffer_mask = ringbuffer_size - 1;
              ringbuffer = new Uint8Array(
                ringbuffer_size +
                  kRingBufferWriteAheadSlack +
                  BrotliDictionary.maxDictionaryWordLength
              );
              ringbuffer_end = ringbuffer_size;
  
              block_type_trees = [];
              block_len_trees = [];
              for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
                block_type_trees[x] = new HuffmanCode(0, 0);
                block_len_trees[x] = new HuffmanCode(0, 0);
              }
  
              while (!input_end) {
                var meta_block_remaining_len = 0;
                var is_uncompressed;
                var block_length = [1 << 28, 1 << 28, 1 << 28];
                var block_type = [0];
                var num_block_types = [1, 1, 1];
                var block_type_rb = [0, 1, 0, 1, 0, 1];
                var block_type_rb_index = [0];
                var distance_postfix_bits;
                var num_direct_distance_codes;
                var distance_postfix_mask;
                var num_distance_codes;
                var context_map = null;
                var context_modes = null;
                var num_literal_htrees;
                var dist_context_map = null;
                var num_dist_htrees;
                var context_offset = 0;
                var context_map_slice = null;
                var literal_htree_index = 0;
                var dist_context_offset = 0;
                var dist_context_map_slice = null;
                var dist_htree_index = 0;
                var context_lookup_offset1 = 0;
                var context_lookup_offset2 = 0;
                var context_mode;
                var htree_command;
  
                for (i = 0; i < 3; ++i) {
                  hgroup[i].codes = null;
                  hgroup[i].htrees = null;
                }
  
                br.readMoreInput();
  
                var _out = DecodeMetaBlockLength(br);
                meta_block_remaining_len = _out.meta_block_length;
                if (pos + meta_block_remaining_len > output.buffer.length) {
                  /* We need to grow the output buffer to fit the additional data. */
                  var tmp = new Uint8Array(pos + meta_block_remaining_len);
                  tmp.set(output.buffer);
                  output.buffer = tmp;
                }
                input_end = _out.input_end;
                is_uncompressed = _out.is_uncompressed;
  
                if (_out.is_metadata) {
                  JumpToByteBoundary(br);
  
                  for (
                    ;
                    meta_block_remaining_len > 0;
                    --meta_block_remaining_len
                  ) {
                    br.readMoreInput();
                    /* Read one byte and ignore it. */
                    br.readBits(8);
                  }
  
                  continue;
                }
  
                if (meta_block_remaining_len === 0) {
                  continue;
                }
  
                if (is_uncompressed) {
                  br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
                  CopyUncompressedBlockToOutput(
                    output,
                    meta_block_remaining_len,
                    pos,
                    ringbuffer,
                    ringbuffer_mask,
                    br
                  );
                  pos += meta_block_remaining_len;
                  continue;
                }
  
                for (i = 0; i < 3; ++i) {
                  num_block_types[i] = DecodeVarLenUint8(br) + 1;
                  if (num_block_types[i] >= 2) {
                    ReadHuffmanCode(
                      num_block_types[i] + 2,
                      block_type_trees,
                      i * HUFFMAN_MAX_TABLE_SIZE,
                      br
                    );
                    ReadHuffmanCode(
                      kNumBlockLengthCodes,
                      block_len_trees,
                      i * HUFFMAN_MAX_TABLE_SIZE,
                      br
                    );
                    block_length[i] = ReadBlockLength(
                      block_len_trees,
                      i * HUFFMAN_MAX_TABLE_SIZE,
                      br
                    );
                    block_type_rb_index[i] = 1;
                  }
                }
  
                br.readMoreInput();
  
                distance_postfix_bits = br.readBits(2);
                num_direct_distance_codes =
                  NUM_DISTANCE_SHORT_CODES +
                  (br.readBits(4) << distance_postfix_bits);
                distance_postfix_mask = (1 << distance_postfix_bits) - 1;
                num_distance_codes =
                  num_direct_distance_codes + (48 << distance_postfix_bits);
                context_modes = new Uint8Array(num_block_types[0]);
  
                for (i = 0; i < num_block_types[0]; ++i) {
                  br.readMoreInput();
                  context_modes[i] = br.readBits(2) << 1;
                }
  
                var _o1 = DecodeContextMap(
                  num_block_types[0] << kLiteralContextBits,
                  br
                );
                num_literal_htrees = _o1.num_htrees;
                context_map = _o1.context_map;
  
                var _o2 = DecodeContextMap(
                  num_block_types[2] << kDistanceContextBits,
                  br
                );
                num_dist_htrees = _o2.num_htrees;
                dist_context_map = _o2.context_map;
  
                hgroup[0] = new HuffmanTreeGroup(
                  kNumLiteralCodes,
                  num_literal_htrees
                );
                hgroup[1] = new HuffmanTreeGroup(
                  kNumInsertAndCopyCodes,
                  num_block_types[1]
                );
                hgroup[2] = new HuffmanTreeGroup(
                  num_distance_codes,
                  num_dist_htrees
                );
  
                for (i = 0; i < 3; ++i) {
                  hgroup[i].decode(br);
                }
  
                context_map_slice = 0;
                dist_context_map_slice = 0;
                context_mode = context_modes[block_type[0]];
                context_lookup_offset1 = Context.lookupOffsets[context_mode];
                context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
                htree_command = hgroup[1].htrees[0];
  
                while (meta_block_remaining_len > 0) {
                  var cmd_code;
                  var range_idx;
                  var insert_code;
                  var copy_code;
                  var insert_length;
                  var copy_length;
                  var distance_code;
                  var distance;
                  var context;
                  var j;
                  var copy_dst;
  
                  br.readMoreInput();
  
                  if (block_length[1] === 0) {
                    DecodeBlockType(
                      num_block_types[1],
                      block_type_trees,
                      1,
                      block_type,
                      block_type_rb,
                      block_type_rb_index,
                      br
                    );
                    block_length[1] = ReadBlockLength(
                      block_len_trees,
                      HUFFMAN_MAX_TABLE_SIZE,
                      br
                    );
                    htree_command = hgroup[1].htrees[block_type[1]];
                  }
                  --block_length[1];
                  cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
                  range_idx = cmd_code >> 6;
                  if (range_idx >= 2) {
                    range_idx -= 2;
                    distance_code = -1;
                  } else {
                    distance_code = 0;
                  }
                  insert_code =
                    Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
                  copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
                  insert_length =
                    Prefix.kInsertLengthPrefixCode[insert_code].offset +
                    br.readBits(
                      Prefix.kInsertLengthPrefixCode[insert_code].nbits
                    );
                  copy_length =
                    Prefix.kCopyLengthPrefixCode[copy_code].offset +
                    br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
                  prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
                  prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
                  for (j = 0; j < insert_length; ++j) {
                    br.readMoreInput();
  
                    if (block_length[0] === 0) {
                      DecodeBlockType(
                        num_block_types[0],
                        block_type_trees,
                        0,
                        block_type,
                        block_type_rb,
                        block_type_rb_index,
                        br
                      );
                      block_length[0] = ReadBlockLength(block_len_trees, 0, br);
                      context_offset = block_type[0] << kLiteralContextBits;
                      context_map_slice = context_offset;
                      context_mode = context_modes[block_type[0]];
                      context_lookup_offset1 =
                        Context.lookupOffsets[context_mode];
                      context_lookup_offset2 =
                        Context.lookupOffsets[context_mode + 1];
                    }
                    context =
                      Context.lookup[context_lookup_offset1 + prev_byte1] |
                      Context.lookup[context_lookup_offset2 + prev_byte2];
                    literal_htree_index =
                      context_map[context_map_slice + context];
                    --block_length[0];
                    prev_byte2 = prev_byte1;
                    prev_byte1 = ReadSymbol(
                      hgroup[0].codes,
                      hgroup[0].htrees[literal_htree_index],
                      br
                    );
                    ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) {
                      output.write(ringbuffer, ringbuffer_size);
                    }
                    ++pos;
                  }
                  meta_block_remaining_len -= insert_length;
                  if (meta_block_remaining_len <= 0) break;
  
                  if (distance_code < 0) {
                    var context;
  
                    br.readMoreInput();
                    if (block_length[2] === 0) {
                      DecodeBlockType(
                        num_block_types[2],
                        block_type_trees,
                        2,
                        block_type,
                        block_type_rb,
                        block_type_rb_index,
                        br
                      );
                      block_length[2] = ReadBlockLength(
                        block_len_trees,
                        2 * HUFFMAN_MAX_TABLE_SIZE,
                        br
                      );
                      dist_context_offset = block_type[2] << kDistanceContextBits;
                      dist_context_map_slice = dist_context_offset;
                    }
                    --block_length[2];
                    context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                    dist_htree_index =
                      dist_context_map[dist_context_map_slice + context];
                    distance_code = ReadSymbol(
                      hgroup[2].codes,
                      hgroup[2].htrees[dist_htree_index],
                      br
                    );
                    if (distance_code >= num_direct_distance_codes) {
                      var nbits;
                      var postfix;
                      var offset;
                      distance_code -= num_direct_distance_codes;
                      postfix = distance_code & distance_postfix_mask;
                      distance_code >>= distance_postfix_bits;
                      nbits = (distance_code >> 1) + 1;
                      offset = ((2 + (distance_code & 1)) << nbits) - 4;
                      distance_code =
                        num_direct_distance_codes +
                        ((offset + br.readBits(nbits)) << distance_postfix_bits) +
                        postfix;
                    }
                  }
  
                  /* Convert the distance code to the actual distance by possibly looking */
                  /* up past distnaces from the ringbuffer. */
                  distance = TranslateShortCodes(
                    distance_code,
                    dist_rb,
                    dist_rb_idx
                  );
                  if (distance < 0) {
                    throw new Error("[BrotliDecompress] invalid distance");
                  }
  
                  if (
                    pos < max_backward_distance &&
                    max_distance !== max_backward_distance
                  ) {
                    max_distance = pos;
                  } else {
                    max_distance = max_backward_distance;
                  }
  
                  copy_dst = pos & ringbuffer_mask;
  
                  if (distance > max_distance) {
                    if (
                      copy_length >= BrotliDictionary.minDictionaryWordLength &&
                      copy_length <= BrotliDictionary.maxDictionaryWordLength
                    ) {
                      var offset = BrotliDictionary.offsetsByLength[copy_length];
                      var word_id = distance - max_distance - 1;
                      var shift = BrotliDictionary.sizeBitsByLength[copy_length];
                      var mask = (1 << shift) - 1;
                      var word_idx = word_id & mask;
                      var transform_idx = word_id >> shift;
                      offset += word_idx * copy_length;
                      if (transform_idx < Transform.kNumTransforms) {
                        var len = Transform.transformDictionaryWord(
                          ringbuffer,
                          copy_dst,
                          offset,
                          copy_length,
                          transform_idx
                        );
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                          output.write(ringbuffer, ringbuffer_size);
  
                          for (var _x = 0; _x < copy_dst - ringbuffer_end; _x++)
                            ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                      } else {
                        throw new Error(
                          "Invalid backward reference. pos: " +
                            pos +
                            " distance: " +
                            distance +
                            " len: " +
                            copy_length +
                            " bytes left: " +
                            meta_block_remaining_len
                        );
                      }
                    } else {
                      throw new Error(
                        "Invalid backward reference. pos: " +
                          pos +
                          " distance: " +
                          distance +
                          " len: " +
                          copy_length +
                          " bytes left: " +
                          meta_block_remaining_len
                      );
                    }
                  } else {
                    if (distance_code > 0) {
                      dist_rb[dist_rb_idx & 3] = distance;
                      ++dist_rb_idx;
                    }
  
                    if (copy_length > meta_block_remaining_len) {
                      throw new Error(
                        "Invalid backward reference. pos: " +
                          pos +
                          " distance: " +
                          distance +
                          " len: " +
                          copy_length +
                          " bytes left: " +
                          meta_block_remaining_len
                      );
                    }
  
                    for (j = 0; j < copy_length; ++j) {
                      ringbuffer[pos & ringbuffer_mask] =
                        ringbuffer[(pos - distance) & ringbuffer_mask];
                      if ((pos & ringbuffer_mask) === ringbuffer_mask) {
                        output.write(ringbuffer, ringbuffer_size);
                      }
                      ++pos;
                      --meta_block_remaining_len;
                    }
                  }
  
                  /* When we get here, we must have inserted at least one literal and */
                  /* made a copy of at least length two, therefore accessing the last 2 */
                  /* bytes is valid. */
                  prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
                  prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
                }
  
                /* Protect pos from overflow, wrap it around at every GB of input data */
                pos &= 0x3fffffff;
              }
  
              output.write(ringbuffer, pos & ringbuffer_mask);
            }
  
            exports.BrotliDecompress = BrotliDecompress;
  
            BrotliDictionary.init();
          },
          {
            "./bit_reader": 29,
            "./context": 30,
            "./dictionary": 34,
            "./huffman": 35,
            "./prefix": 36,
            "./streams": 37,
            "./transform": 38,
          },
        ],
        32: [
          function (require, module, exports) {
            var base64 = require("base64-js");
            var fs = require("fs");
  
            /**
             * The normal dictionary-data.js is quite large, which makes it
             * unsuitable for browser usage. In order to make it smaller,
             * we read dictionary.bin, which is a compressed version of
             * the dictionary, and on initial load, Brotli decompresses
             * it's own dictionary. 😜
             */
            exports.init = function () {
              var BrotliDecompressBuffer =
                require("./decode").BrotliDecompressBuffer;
              var compressed = base64.toByteArray(require("./dictionary.bin.js"));
              return BrotliDecompressBuffer(compressed);
            };
          },
          { "./decode": 31, "./dictionary.bin.js": 33, "base64-js": 28, fs: 54 },
        ],
        33: [
          function (require, module, exports) {
            module.exports =
              "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";
          },
          {},
        ],
        34: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Collection of static dictionary words.
  */
  
            var data = require("./dictionary-data");
            exports.init = function () {
              exports.dictionary = data.init();
            };
  
            exports.offsetsByLength = new Uint32Array([
              0, 0, 0, 0, 0, 4096, 9216, 21504, 35840, 44032, 53248, 63488, 74752,
              87040, 93696, 100864, 104704, 106752, 108928, 113536, 115968,
              118528, 119872, 121280, 122016,
            ]);
  
            exports.sizeBitsByLength = new Uint8Array([
              0, 0, 0, 0, 10, 10, 11, 11, 10, 10, 10, 10, 10, 9, 9, 8, 7, 7, 8, 7,
              7, 6, 6, 5, 5,
            ]);
  
            exports.minDictionaryWordLength = 4;
            exports.maxDictionaryWordLength = 24;
          },
          { "./dictionary-data": 32 },
        ],
        35: [
          function (require, module, exports) {
            function HuffmanCode(bits, value) {
              this.bits = bits; /* number of bits used for this symbol */
              this.value = value; /* symbol value or table offset */
            }
  
            exports.HuffmanCode = HuffmanCode;
  
            var MAX_LENGTH = 15;
  
            /* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
     bit-wise reversal of the len least significant bits of key. */
            function GetNextKey(key, len) {
              var step = 1 << (len - 1);
              while (key & step) {
                step >>= 1;
              }
              return (key & (step - 1)) + step;
            }
  
            /* Stores code in table[0], table[step], table[2*step], ..., table[end] */
            /* Assumes that end is an integer multiple of step */
            function ReplicateValue(table, i, step, end, code) {
              do {
                end -= step;
                table[i + end] = new HuffmanCode(code.bits, code.value);
              } while (end > 0);
            }
  
            /* Returns the table width of the next 2nd level table. count is the histogram
     of bit lengths for the remaining symbols, len is the code length of the next
     processed symbol */
            function NextTableBitSize(count, len, root_bits) {
              var left = 1 << (len - root_bits);
              while (len < MAX_LENGTH) {
                left -= count[len];
                if (left <= 0) break;
                ++len;
                left <<= 1;
              }
              return len - root_bits;
            }
  
            exports.BrotliBuildHuffmanTable = function (
              root_table,
              table,
              root_bits,
              code_lengths,
              code_lengths_size
            ) {
              var start_table = table;
              var code; /* current table entry */
              var len; /* current code length */
              var symbol; /* symbol index in original or sorted table */
              var key; /* reversed prefix code */
              var step; /* step size to replicate values in current table */
              var low; /* low bits for current root entry */
              var mask; /* mask for low bits */
              var table_bits; /* key length of current table */
              var table_size; /* size of current table */
              var total_size; /* sum of root table size and 2nd level table sizes */
              var sorted; /* symbols sorted by code length */
              var count = new Int32Array(
                MAX_LENGTH + 1
              ); /* number of codes of each length */
              var offset = new Int32Array(
                MAX_LENGTH + 1
              ); /* offsets in sorted table for each length */
  
              sorted = new Int32Array(code_lengths_size);
  
              /* build histogram of code lengths */
              for (symbol = 0; symbol < code_lengths_size; symbol++) {
                count[code_lengths[symbol]]++;
              }
  
              /* generate offsets into sorted symbol table by code length */
              offset[1] = 0;
              for (len = 1; len < MAX_LENGTH; len++) {
                offset[len + 1] = offset[len] + count[len];
              }
  
              /* sort symbols by length, by symbol order within each length */
              for (symbol = 0; symbol < code_lengths_size; symbol++) {
                if (code_lengths[symbol] !== 0) {
                  sorted[offset[code_lengths[symbol]]++] = symbol;
                }
              }
  
              table_bits = root_bits;
              table_size = 1 << table_bits;
              total_size = table_size;
  
              /* special case code with only one value */
              if (offset[MAX_LENGTH] === 1) {
                for (key = 0; key < total_size; ++key) {
                  root_table[table + key] = new HuffmanCode(
                    0,
                    sorted[0] & 0xffff
                  );
                }
  
                return total_size;
              }
  
              /* fill in root table */
              key = 0;
              symbol = 0;
              for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
                for (; count[len] > 0; --count[len]) {
                  code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
                  ReplicateValue(root_table, table + key, step, table_size, code);
                  key = GetNextKey(key, len);
                }
              }
  
              /* fill in 2nd level tables and add pointers to root table */
              mask = total_size - 1;
              low = -1;
              for (
                len = root_bits + 1, step = 2;
                len <= MAX_LENGTH;
                ++len, step <<= 1
              ) {
                for (; count[len] > 0; --count[len]) {
                  if ((key & mask) !== low) {
                    table += table_size;
                    table_bits = NextTableBitSize(count, len, root_bits);
                    table_size = 1 << table_bits;
                    total_size += table_size;
                    low = key & mask;
                    root_table[start_table + low] = new HuffmanCode(
                      (table_bits + root_bits) & 0xff,
                      (table - start_table - low) & 0xffff
                    );
                  }
                  code = new HuffmanCode(
                    (len - root_bits) & 0xff,
                    sorted[symbol++] & 0xffff
                  );
                  ReplicateValue(
                    root_table,
                    table + (key >> root_bits),
                    step,
                    table_size,
                    code
                  );
                  key = GetNextKey(key, len);
                }
              }
  
              return total_size;
            };
          },
          {},
        ],
        36: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Lookup tables to map prefix codes to value ranges. This is used during
     decoding of the block lengths, literal insertion lengths and copy lengths.
  */
  
            /* Represents the range of values belonging to a prefix code: */
            /* [offset, offset + 2^nbits) */
            function PrefixCodeRange(offset, nbits) {
              this.offset = offset;
              this.nbits = nbits;
            }
  
            exports.kBlockLengthPrefixCode = [
              new PrefixCodeRange(1, 2),
              new PrefixCodeRange(5, 2),
              new PrefixCodeRange(9, 2),
              new PrefixCodeRange(13, 2),
              new PrefixCodeRange(17, 3),
              new PrefixCodeRange(25, 3),
              new PrefixCodeRange(33, 3),
              new PrefixCodeRange(41, 3),
              new PrefixCodeRange(49, 4),
              new PrefixCodeRange(65, 4),
              new PrefixCodeRange(81, 4),
              new PrefixCodeRange(97, 4),
              new PrefixCodeRange(113, 5),
              new PrefixCodeRange(145, 5),
              new PrefixCodeRange(177, 5),
              new PrefixCodeRange(209, 5),
              new PrefixCodeRange(241, 6),
              new PrefixCodeRange(305, 6),
              new PrefixCodeRange(369, 7),
              new PrefixCodeRange(497, 8),
              new PrefixCodeRange(753, 9),
              new PrefixCodeRange(1265, 10),
              new PrefixCodeRange(2289, 11),
              new PrefixCodeRange(4337, 12),
              new PrefixCodeRange(8433, 13),
              new PrefixCodeRange(16625, 24),
            ];
  
            exports.kInsertLengthPrefixCode = [
              new PrefixCodeRange(0, 0),
              new PrefixCodeRange(1, 0),
              new PrefixCodeRange(2, 0),
              new PrefixCodeRange(3, 0),
              new PrefixCodeRange(4, 0),
              new PrefixCodeRange(5, 0),
              new PrefixCodeRange(6, 1),
              new PrefixCodeRange(8, 1),
              new PrefixCodeRange(10, 2),
              new PrefixCodeRange(14, 2),
              new PrefixCodeRange(18, 3),
              new PrefixCodeRange(26, 3),
              new PrefixCodeRange(34, 4),
              new PrefixCodeRange(50, 4),
              new PrefixCodeRange(66, 5),
              new PrefixCodeRange(98, 5),
              new PrefixCodeRange(130, 6),
              new PrefixCodeRange(194, 7),
              new PrefixCodeRange(322, 8),
              new PrefixCodeRange(578, 9),
              new PrefixCodeRange(1090, 10),
              new PrefixCodeRange(2114, 12),
              new PrefixCodeRange(6210, 14),
              new PrefixCodeRange(22594, 24),
            ];
  
            exports.kCopyLengthPrefixCode = [
              new PrefixCodeRange(2, 0),
              new PrefixCodeRange(3, 0),
              new PrefixCodeRange(4, 0),
              new PrefixCodeRange(5, 0),
              new PrefixCodeRange(6, 0),
              new PrefixCodeRange(7, 0),
              new PrefixCodeRange(8, 0),
              new PrefixCodeRange(9, 0),
              new PrefixCodeRange(10, 1),
              new PrefixCodeRange(12, 1),
              new PrefixCodeRange(14, 2),
              new PrefixCodeRange(18, 2),
              new PrefixCodeRange(22, 3),
              new PrefixCodeRange(30, 3),
              new PrefixCodeRange(38, 4),
              new PrefixCodeRange(54, 4),
              new PrefixCodeRange(70, 5),
              new PrefixCodeRange(102, 5),
              new PrefixCodeRange(134, 6),
              new PrefixCodeRange(198, 7),
              new PrefixCodeRange(326, 8),
              new PrefixCodeRange(582, 9),
              new PrefixCodeRange(1094, 10),
              new PrefixCodeRange(2118, 24),
            ];
  
            exports.kInsertRangeLut = [0, 0, 8, 8, 0, 16, 8, 16, 16];
  
            exports.kCopyRangeLut = [0, 8, 0, 8, 16, 0, 16, 8, 16];
          },
          {},
        ],
        37: [
          function (require, module, exports) {
            function BrotliInput(buffer) {
              this.buffer = buffer;
              this.pos = 0;
            }
  
            BrotliInput.prototype.read = function (buf, i, count) {
              if (this.pos + count > this.buffer.length) {
                count = this.buffer.length - this.pos;
              }
  
              for (var p = 0; p < count; p++)
                buf[i + p] = this.buffer[this.pos + p];
  
              this.pos += count;
              return count;
            };
  
            exports.BrotliInput = BrotliInput;
  
            function BrotliOutput(buf) {
              this.buffer = buf;
              this.pos = 0;
            }
  
            BrotliOutput.prototype.write = function (buf, count) {
              if (this.pos + count > this.buffer.length)
                throw new Error("Output buffer is not large enough");
  
              this.buffer.set(buf.subarray(0, count), this.pos);
              this.pos += count;
              return count;
            };
  
            exports.BrotliOutput = BrotliOutput;
          },
          {},
        ],
        38: [
          function (require, module, exports) {
            /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Transformations on dictionary words.
  */
  
            var BrotliDictionary = require("./dictionary");
  
            var kIdentity = 0;
            var kOmitLast1 = 1;
            var kOmitLast2 = 2;
            var kOmitLast3 = 3;
            var kOmitLast4 = 4;
            var kOmitLast5 = 5;
            var kOmitLast6 = 6;
            var kOmitLast7 = 7;
            var kOmitLast8 = 8;
            var kOmitLast9 = 9;
            var kUppercaseFirst = 10;
            var kUppercaseAll = 11;
            var kOmitFirst1 = 12;
            var kOmitFirst2 = 13;
            var kOmitFirst3 = 14;
            var kOmitFirst4 = 15;
            var kOmitFirst5 = 16;
            var kOmitFirst6 = 17;
            var kOmitFirst7 = 18;
            var kOmitFirst8 = 19;
            var kOmitFirst9 = 20;
  
            function Transform(prefix, transform, suffix) {
              this.prefix = new Uint8Array(prefix.length);
              this.transform = transform;
              this.suffix = new Uint8Array(suffix.length);
  
              for (var i = 0; i < prefix.length; i++)
                this.prefix[i] = prefix.charCodeAt(i);
  
              for (var i = 0; i < suffix.length; i++)
                this.suffix[i] = suffix.charCodeAt(i);
            }
  
            var kTransforms = [
              new Transform("", kIdentity, ""),
              new Transform("", kIdentity, " "),
              new Transform(" ", kIdentity, " "),
              new Transform("", kOmitFirst1, ""),
              new Transform("", kUppercaseFirst, " "),
              new Transform("", kIdentity, " the "),
              new Transform(" ", kIdentity, ""),
              new Transform("s ", kIdentity, " "),
              new Transform("", kIdentity, " of "),
              new Transform("", kUppercaseFirst, ""),
              new Transform("", kIdentity, " and "),
              new Transform("", kOmitFirst2, ""),
              new Transform("", kOmitLast1, ""),
              new Transform(", ", kIdentity, " "),
              new Transform("", kIdentity, ", "),
              new Transform(" ", kUppercaseFirst, " "),
              new Transform("", kIdentity, " in "),
              new Transform("", kIdentity, " to "),
              new Transform("e ", kIdentity, " "),
              new Transform("", kIdentity, '"'),
              new Transform("", kIdentity, "."),
              new Transform("", kIdentity, '">'),
              new Transform("", kIdentity, "\n"),
              new Transform("", kOmitLast3, ""),
              new Transform("", kIdentity, "]"),
              new Transform("", kIdentity, " for "),
              new Transform("", kOmitFirst3, ""),
              new Transform("", kOmitLast2, ""),
              new Transform("", kIdentity, " a "),
              new Transform("", kIdentity, " that "),
              new Transform(" ", kUppercaseFirst, ""),
              new Transform("", kIdentity, ". "),
              new Transform(".", kIdentity, ""),
              new Transform(" ", kIdentity, ", "),
              new Transform("", kOmitFirst4, ""),
              new Transform("", kIdentity, " with "),
              new Transform("", kIdentity, "'"),
              new Transform("", kIdentity, " from "),
              new Transform("", kIdentity, " by "),
              new Transform("", kOmitFirst5, ""),
              new Transform("", kOmitFirst6, ""),
              new Transform(" the ", kIdentity, ""),
              new Transform("", kOmitLast4, ""),
              new Transform("", kIdentity, ". The "),
              new Transform("", kUppercaseAll, ""),
              new Transform("", kIdentity, " on "),
              new Transform("", kIdentity, " as "),
              new Transform("", kIdentity, " is "),
              new Transform("", kOmitLast7, ""),
              new Transform("", kOmitLast1, "ing "),
              new Transform("", kIdentity, "\n\t"),
              new Transform("", kIdentity, ":"),
              new Transform(" ", kIdentity, ". "),
              new Transform("", kIdentity, "ed "),
              new Transform("", kOmitFirst9, ""),
              new Transform("", kOmitFirst7, ""),
              new Transform("", kOmitLast6, ""),
              new Transform("", kIdentity, "("),
              new Transform("", kUppercaseFirst, ", "),
              new Transform("", kOmitLast8, ""),
              new Transform("", kIdentity, " at "),
              new Transform("", kIdentity, "ly "),
              new Transform(" the ", kIdentity, " of "),
              new Transform("", kOmitLast5, ""),
              new Transform("", kOmitLast9, ""),
              new Transform(" ", kUppercaseFirst, ", "),
              new Transform("", kUppercaseFirst, '"'),
              new Transform(".", kIdentity, "("),
              new Transform("", kUppercaseAll, " "),
              new Transform("", kUppercaseFirst, '">'),
              new Transform("", kIdentity, '="'),
              new Transform(" ", kIdentity, "."),
              new Transform(".com/", kIdentity, ""),
              new Transform(" the ", kIdentity, " of the "),
              new Transform("", kUppercaseFirst, "'"),
              new Transform("", kIdentity, ". This "),
              new Transform("", kIdentity, ","),
              new Transform(".", kIdentity, " "),
              new Transform("", kUppercaseFirst, "("),
              new Transform("", kUppercaseFirst, "."),
              new Transform("", kIdentity, " not "),
              new Transform(" ", kIdentity, '="'),
              new Transform("", kIdentity, "er "),
              new Transform(" ", kUppercaseAll, " "),
              new Transform("", kIdentity, "al "),
              new Transform(" ", kUppercaseAll, ""),
              new Transform("", kIdentity, "='"),
              new Transform("", kUppercaseAll, '"'),
              new Transform("", kUppercaseFirst, ". "),
              new Transform(" ", kIdentity, "("),
              new Transform("", kIdentity, "ful "),
              new Transform(" ", kUppercaseFirst, ". "),
              new Transform("", kIdentity, "ive "),
              new Transform("", kIdentity, "less "),
              new Transform("", kUppercaseAll, "'"),
              new Transform("", kIdentity, "est "),
              new Transform(" ", kUppercaseFirst, "."),
              new Transform("", kUppercaseAll, '">'),
              new Transform(" ", kIdentity, "='"),
              new Transform("", kUppercaseFirst, ","),
              new Transform("", kIdentity, "ize "),
              new Transform("", kUppercaseAll, "."),
              new Transform("\xc2\xa0", kIdentity, ""),
              new Transform(" ", kIdentity, ","),
              new Transform("", kUppercaseFirst, '="'),
              new Transform("", kUppercaseAll, '="'),
              new Transform("", kIdentity, "ous "),
              new Transform("", kUppercaseAll, ", "),
              new Transform("", kUppercaseFirst, "='"),
              new Transform(" ", kUppercaseFirst, ","),
              new Transform(" ", kUppercaseAll, '="'),
              new Transform(" ", kUppercaseAll, ", "),
              new Transform("", kUppercaseAll, ","),
              new Transform("", kUppercaseAll, "("),
              new Transform("", kUppercaseAll, ". "),
              new Transform(" ", kUppercaseAll, "."),
              new Transform("", kUppercaseAll, "='"),
              new Transform(" ", kUppercaseAll, ". "),
              new Transform(" ", kUppercaseFirst, '="'),
              new Transform(" ", kUppercaseAll, "='"),
              new Transform(" ", kUppercaseFirst, "='"),
            ];
  
            exports.kTransforms = kTransforms;
            exports.kNumTransforms = kTransforms.length;
  
            function ToUpperCase(p, i) {
              if (p[i] < 0xc0) {
                if (p[i] >= 97 && p[i] <= 122) {
                  p[i] ^= 32;
                }
                return 1;
              }
  
              /* An overly simplified uppercasing model for utf-8. */
              if (p[i] < 0xe0) {
                p[i + 1] ^= 32;
                return 2;
              }
  
              /* An arbitrary transform for three byte characters. */
              p[i + 2] ^= 5;
              return 3;
            }
  
            exports.transformDictionaryWord = function (
              dst,
              idx,
              word,
              len,
              transform
            ) {
              var prefix = kTransforms[transform].prefix;
              var suffix = kTransforms[transform].suffix;
              var t = kTransforms[transform].transform;
              var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
              var i = 0;
              var start_idx = idx;
              var uppercase;
  
              if (skip > len) {
                skip = len;
              }
  
              var prefix_pos = 0;
              while (prefix_pos < prefix.length) {
                dst[idx++] = prefix[prefix_pos++];
              }
  
              word += skip;
              len -= skip;
  
              if (t <= kOmitLast9) {
                len -= t;
              }
  
              for (i = 0; i < len; i++) {
                dst[idx++] = BrotliDictionary.dictionary[word + i];
              }
  
              uppercase = idx - len;
  
              if (t === kUppercaseFirst) {
                ToUpperCase(dst, uppercase);
              } else if (t === kUppercaseAll) {
                while (len > 0) {
                  var step = ToUpperCase(dst, uppercase);
                  uppercase += step;
                  len -= step;
                }
              }
  
              var suffix_pos = 0;
              while (suffix_pos < suffix.length) {
                dst[idx++] = suffix[suffix_pos++];
              }
  
              return idx - start_idx;
            };
          },
          { "./dictionary": 34 },
        ],
        39: [
          function (require, module, exports) {
            module.exports = require("./dec/decode").BrotliDecompressBuffer;
          },
          { "./dec/decode": 31 },
        ],
        40: [function (require, module, exports) {}, {}],
        41: [
          function (require, module, exports) {
            (function (process, Buffer) {
              (function () {
                "use strict";
                /* eslint camelcase: "off" */
  
                var assert = require("assert");
  
                var Zstream = require("pako/lib/zlib/zstream");
                var zlib_deflate = require("pako/lib/zlib/deflate.js");
                var zlib_inflate = require("pako/lib/zlib/inflate.js");
                var constants = require("pako/lib/zlib/constants");
  
                for (var key in constants) {
                  exports[key] = constants[key];
                }
  
                // zlib modes
                exports.NONE = 0;
                exports.DEFLATE = 1;
                exports.INFLATE = 2;
                exports.GZIP = 3;
                exports.GUNZIP = 4;
                exports.DEFLATERAW = 5;
                exports.INFLATERAW = 6;
                exports.UNZIP = 7;
  
                var GZIP_HEADER_ID1 = 0x1f;
                var GZIP_HEADER_ID2 = 0x8b;
  
                /**
                 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
                 */
                function Zlib(mode) {
                  if (
                    typeof mode !== "number" ||
                    mode < exports.DEFLATE ||
                    mode > exports.UNZIP
                  ) {
                    throw new TypeError("Bad argument");
                  }
  
                  this.dictionary = null;
                  this.err = 0;
                  this.flush = 0;
                  this.init_done = false;
                  this.level = 0;
                  this.memLevel = 0;
                  this.mode = mode;
                  this.strategy = 0;
                  this.windowBits = 0;
                  this.write_in_progress = false;
                  this.pending_close = false;
                  this.gzip_id_bytes_read = 0;
                }
  
                Zlib.prototype.close = function () {
                  if (this.write_in_progress) {
                    this.pending_close = true;
                    return;
                  }
  
                  this.pending_close = false;
  
                  assert(this.init_done, "close before init");
                  assert(this.mode <= exports.UNZIP);
  
                  if (
                    this.mode === exports.DEFLATE ||
                    this.mode === exports.GZIP ||
                    this.mode === exports.DEFLATERAW
                  ) {
                    zlib_deflate.deflateEnd(this.strm);
                  } else if (
                    this.mode === exports.INFLATE ||
                    this.mode === exports.GUNZIP ||
                    this.mode === exports.INFLATERAW ||
                    this.mode === exports.UNZIP
                  ) {
                    zlib_inflate.inflateEnd(this.strm);
                  }
  
                  this.mode = exports.NONE;
  
                  this.dictionary = null;
                };
  
                Zlib.prototype.write = function (
                  flush,
                  input,
                  in_off,
                  in_len,
                  out,
                  out_off,
                  out_len
                ) {
                  return this._write(
                    true,
                    flush,
                    input,
                    in_off,
                    in_len,
                    out,
                    out_off,
                    out_len
                  );
                };
  
                Zlib.prototype.writeSync = function (
                  flush,
                  input,
                  in_off,
                  in_len,
                  out,
                  out_off,
                  out_len
                ) {
                  return this._write(
                    false,
                    flush,
                    input,
                    in_off,
                    in_len,
                    out,
                    out_off,
                    out_len
                  );
                };
  
                Zlib.prototype._write = function (
                  async,
                  flush,
                  input,
                  in_off,
                  in_len,
                  out,
                  out_off,
                  out_len
                ) {
                  assert.equal(arguments.length, 8);
  
                  assert(this.init_done, "write before init");
                  assert(this.mode !== exports.NONE, "already finalized");
                  assert.equal(
                    false,
                    this.write_in_progress,
                    "write already in progress"
                  );
                  assert.equal(false, this.pending_close, "close is pending");
  
                  this.write_in_progress = true;
  
                  assert.equal(
                    false,
                    flush === undefined,
                    "must provide flush value"
                  );
  
                  this.write_in_progress = true;
  
                  if (
                    flush !== exports.Z_NO_FLUSH &&
                    flush !== exports.Z_PARTIAL_FLUSH &&
                    flush !== exports.Z_SYNC_FLUSH &&
                    flush !== exports.Z_FULL_FLUSH &&
                    flush !== exports.Z_FINISH &&
                    flush !== exports.Z_BLOCK
                  ) {
                    throw new Error("Invalid flush value");
                  }
  
                  if (input == null) {
                    input = Buffer.alloc(0);
                    in_len = 0;
                    in_off = 0;
                  }
  
                  this.strm.avail_in = in_len;
                  this.strm.input = input;
                  this.strm.next_in = in_off;
                  this.strm.avail_out = out_len;
                  this.strm.output = out;
                  this.strm.next_out = out_off;
                  this.flush = flush;
  
                  if (!async) {
                    // sync version
                    this._process();
  
                    if (this._checkError()) {
                      return this._afterSync();
                    }
                    return;
                  }
  
                  // async version
                  var self = this;
                  process.nextTick(function () {
                    self._process();
                    self._after();
                  });
  
                  return this;
                };
  
                Zlib.prototype._afterSync = function () {
                  var avail_out = this.strm.avail_out;
                  var avail_in = this.strm.avail_in;
  
                  this.write_in_progress = false;
  
                  return [avail_in, avail_out];
                };
  
                Zlib.prototype._process = function () {
                  var next_expected_header_byte = null;
  
                  // If the avail_out is left at 0, then it means that it ran out
                  // of room.  If there was avail_out left over, then it means
                  // that all of the input was consumed.
                  switch (this.mode) {
                    case exports.DEFLATE:
                    case exports.GZIP:
                    case exports.DEFLATERAW:
                      this.err = zlib_deflate.deflate(this.strm, this.flush);
                      break;
                    case exports.UNZIP:
                      if (this.strm.avail_in > 0) {
                        next_expected_header_byte = this.strm.next_in;
                      }
  
                      switch (this.gzip_id_bytes_read) {
                        case 0:
                          if (next_expected_header_byte === null) {
                            break;
                          }
  
                          if (
                            this.strm.input[next_expected_header_byte] ===
                            GZIP_HEADER_ID1
                          ) {
                            this.gzip_id_bytes_read = 1;
                            next_expected_header_byte++;
  
                            if (this.strm.avail_in === 1) {
                              // The only available byte was already read.
                              break;
                            }
                          } else {
                            this.mode = exports.INFLATE;
                            break;
                          }
  
                        // fallthrough
                        case 1:
                          if (next_expected_header_byte === null) {
                            break;
                          }
  
                          if (
                            this.strm.input[next_expected_header_byte] ===
                            GZIP_HEADER_ID2
                          ) {
                            this.gzip_id_bytes_read = 2;
                            this.mode = exports.GUNZIP;
                          } else {
                            // There is no actual difference between INFLATE and INFLATERAW
                            // (after initialization).
                            this.mode = exports.INFLATE;
                          }
  
                          break;
                        default:
                          throw new Error(
                            "invalid number of gzip magic number bytes read"
                          );
                      }
  
                    // fallthrough
                    case exports.INFLATE:
                    case exports.GUNZIP:
                    case exports.INFLATERAW:
                      this.err = zlib_inflate.inflate(
                        this.strm,
                        this.flush
  
                        // If data was encoded with dictionary
                      );
                      if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                        // Load it
                        this.err = zlib_inflate.inflateSetDictionary(
                          this.strm,
                          this.dictionary
                        );
                        if (this.err === exports.Z_OK) {
                          // And try to decode again
                          this.err = zlib_inflate.inflate(this.strm, this.flush);
                        } else if (this.err === exports.Z_DATA_ERROR) {
                          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                          // Make it possible for After() to tell a bad dictionary from bad
                          // input.
                          this.err = exports.Z_NEED_DICT;
                        }
                      }
                      while (
                        this.strm.avail_in > 0 &&
                        this.mode === exports.GUNZIP &&
                        this.err === exports.Z_STREAM_END &&
                        this.strm.next_in[0] !== 0x00
                      ) {
                        // Bytes remain in input buffer. Perhaps this is another compressed
                        // member in the same archive, or just trailing garbage.
                        // Trailing zero bytes are okay, though, since they are frequently
                        // used for padding.
  
                        this.reset();
                        this.err = zlib_inflate.inflate(this.strm, this.flush);
                      }
                      break;
                    default:
                      throw new Error("Unknown mode " + this.mode);
                  }
                };
  
                Zlib.prototype._checkError = function () {
                  // Acceptable error states depend on the type of zlib stream.
                  switch (this.err) {
                    case exports.Z_OK:
                    case exports.Z_BUF_ERROR:
                      if (
                        this.strm.avail_out !== 0 &&
                        this.flush === exports.Z_FINISH
                      ) {
                        this._error("unexpected end of file");
                        return false;
                      }
                      break;
                    case exports.Z_STREAM_END:
                      // normal statuses, not fatal
                      break;
                    case exports.Z_NEED_DICT:
                      if (this.dictionary == null) {
                        this._error("Missing dictionary");
                      } else {
                        this._error("Bad dictionary");
                      }
                      return false;
                    default:
                      // something else.
                      this._error("Zlib error");
                      return false;
                  }
  
                  return true;
                };
  
                Zlib.prototype._after = function () {
                  if (!this._checkError()) {
                    return;
                  }
  
                  var avail_out = this.strm.avail_out;
                  var avail_in = this.strm.avail_in;
  
                  this.write_in_progress = false;
  
                  // call the write() cb
                  this.callback(avail_in, avail_out);
  
                  if (this.pending_close) {
                    this.close();
                  }
                };
  
                Zlib.prototype._error = function (message) {
                  if (this.strm.msg) {
                    message = this.strm.msg;
                  }
                  this.onerror(
                    message,
                    this.err
  
                    // no hope of rescue.
                  );
                  this.write_in_progress = false;
                  if (this.pending_close) {
                    this.close();
                  }
                };
  
                Zlib.prototype.init = function (
                  windowBits,
                  level,
                  memLevel,
                  strategy,
                  dictionary
                ) {
                  assert(
                    arguments.length === 4 || arguments.length === 5,
                    "init(windowBits, level, memLevel, strategy, [dictionary])"
                  );
  
                  assert(
                    windowBits >= 8 && windowBits <= 15,
                    "invalid windowBits"
                  );
                  assert(level >= -1 && level <= 9, "invalid compression level");
  
                  assert(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
  
                  assert(
                    strategy === exports.Z_FILTERED ||
                      strategy === exports.Z_HUFFMAN_ONLY ||
                      strategy === exports.Z_RLE ||
                      strategy === exports.Z_FIXED ||
                      strategy === exports.Z_DEFAULT_STRATEGY,
                    "invalid strategy"
                  );
  
                  this._init(level, windowBits, memLevel, strategy, dictionary);
                  this._setDictionary();
                };
  
                Zlib.prototype.params = function () {
                  throw new Error("deflateParams Not supported");
                };
  
                Zlib.prototype.reset = function () {
                  this._reset();
                  this._setDictionary();
                };
  
                Zlib.prototype._init = function (
                  level,
                  windowBits,
                  memLevel,
                  strategy,
                  dictionary
                ) {
                  this.level = level;
                  this.windowBits = windowBits;
                  this.memLevel = memLevel;
                  this.strategy = strategy;
  
                  this.flush = exports.Z_NO_FLUSH;
  
                  this.err = exports.Z_OK;
  
                  if (
                    this.mode === exports.GZIP ||
                    this.mode === exports.GUNZIP
                  ) {
                    this.windowBits += 16;
                  }
  
                  if (this.mode === exports.UNZIP) {
                    this.windowBits += 32;
                  }
  
                  if (
                    this.mode === exports.DEFLATERAW ||
                    this.mode === exports.INFLATERAW
                  ) {
                    this.windowBits = -1 * this.windowBits;
                  }
  
                  this.strm = new Zstream();
  
                  switch (this.mode) {
                    case exports.DEFLATE:
                    case exports.GZIP:
                    case exports.DEFLATERAW:
                      this.err = zlib_deflate.deflateInit2(
                        this.strm,
                        this.level,
                        exports.Z_DEFLATED,
                        this.windowBits,
                        this.memLevel,
                        this.strategy
                      );
                      break;
                    case exports.INFLATE:
                    case exports.GUNZIP:
                    case exports.INFLATERAW:
                    case exports.UNZIP:
                      this.err = zlib_inflate.inflateInit2(
                        this.strm,
                        this.windowBits
                      );
                      break;
                    default:
                      throw new Error("Unknown mode " + this.mode);
                  }
  
                  if (this.err !== exports.Z_OK) {
                    this._error("Init error");
                  }
  
                  this.dictionary = dictionary;
  
                  this.write_in_progress = false;
                  this.init_done = true;
                };
  
                Zlib.prototype._setDictionary = function () {
                  if (this.dictionary == null) {
                    return;
                  }
  
                  this.err = exports.Z_OK;
  
                  switch (this.mode) {
                    case exports.DEFLATE:
                    case exports.DEFLATERAW:
                      this.err = zlib_deflate.deflateSetDictionary(
                        this.strm,
                        this.dictionary
                      );
                      break;
                    default:
                      break;
                  }
  
                  if (this.err !== exports.Z_OK) {
                    this._error("Failed to set dictionary");
                  }
                };
  
                Zlib.prototype._reset = function () {
                  this.err = exports.Z_OK;
  
                  switch (this.mode) {
                    case exports.DEFLATE:
                    case exports.DEFLATERAW:
                    case exports.GZIP:
                      this.err = zlib_deflate.deflateReset(this.strm);
                      break;
                    case exports.INFLATE:
                    case exports.INFLATERAW:
                    case exports.GUNZIP:
                      this.err = zlib_inflate.inflateReset(this.strm);
                      break;
                    default:
                      break;
                  }
  
                  if (this.err !== exports.Z_OK) {
                    this._error("Failed to reset stream");
                  }
                };
  
                exports.Zlib = Zlib;
              }.call(this));
            }.call(this, require("_process"), require("buffer").Buffer));
          },
          {
            _process: 261,
            assert: 2,
            buffer: 55,
            "pako/lib/zlib/constants": 45,
            "pako/lib/zlib/deflate.js": 47,
            "pako/lib/zlib/inflate.js": 49,
            "pako/lib/zlib/zstream": 53,
          },
        ],
        42: [
          function (require, module, exports) {
            (function (process) {
              (function () {
                "use strict";
  
                var Buffer = require("buffer").Buffer;
                var Transform = require("stream").Transform;
                var binding = require("./binding");
                var util = require("util");
                var assert = require("assert").ok;
                var kMaxLength = require("buffer").kMaxLength;
                var kRangeErrorMessage =
                  "Cannot create final Buffer. It would be larger " +
                  "than 0x" +
                  kMaxLength.toString(16) +
                  " bytes";
  
                // zlib doesn't provide these, so kludge them in following the same
                // const naming scheme zlib uses.
                binding.Z_MIN_WINDOWBITS = 8;
                binding.Z_MAX_WINDOWBITS = 15;
                binding.Z_DEFAULT_WINDOWBITS = 15;
  
                // fewer than 64 bytes per chunk is stupid.
                // technically it could work with as few as 8, but even 64 bytes
                // is absurdly low.  Usually a MB or more is best.
                binding.Z_MIN_CHUNK = 64;
                binding.Z_MAX_CHUNK = Infinity;
                binding.Z_DEFAULT_CHUNK = 16 * 1024;
  
                binding.Z_MIN_MEMLEVEL = 1;
                binding.Z_MAX_MEMLEVEL = 9;
                binding.Z_DEFAULT_MEMLEVEL = 8;
  
                binding.Z_MIN_LEVEL = -1;
                binding.Z_MAX_LEVEL = 9;
                binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
  
                // expose all the zlib constants
                var bkeys = Object.keys(binding);
                for (var bk = 0; bk < bkeys.length; bk++) {
                  var bkey = bkeys[bk];
                  if (bkey.match(/^Z/)) {
                    Object.defineProperty(exports, bkey, {
                      enumerable: true,
                      value: binding[bkey],
                      writable: false,
                    });
                  }
                }
  
                // translation table for return codes.
                var codes = {
                  Z_OK: binding.Z_OK,
                  Z_STREAM_END: binding.Z_STREAM_END,
                  Z_NEED_DICT: binding.Z_NEED_DICT,
                  Z_ERRNO: binding.Z_ERRNO,
                  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
                  Z_DATA_ERROR: binding.Z_DATA_ERROR,
                  Z_MEM_ERROR: binding.Z_MEM_ERROR,
                  Z_BUF_ERROR: binding.Z_BUF_ERROR,
                  Z_VERSION_ERROR: binding.Z_VERSION_ERROR,
                };
  
                var ckeys = Object.keys(codes);
                for (var ck = 0; ck < ckeys.length; ck++) {
                  var ckey = ckeys[ck];
                  codes[codes[ckey]] = ckey;
                }
  
                Object.defineProperty(exports, "codes", {
                  enumerable: true,
                  value: Object.freeze(codes),
                  writable: false,
                });
  
                exports.Deflate = Deflate;
                exports.Inflate = Inflate;
                exports.Gzip = Gzip;
                exports.Gunzip = Gunzip;
                exports.DeflateRaw = DeflateRaw;
                exports.InflateRaw = InflateRaw;
                exports.Unzip = Unzip;
  
                exports.createDeflate = function (o) {
                  return new Deflate(o);
                };
  
                exports.createInflate = function (o) {
                  return new Inflate(o);
                };
  
                exports.createDeflateRaw = function (o) {
                  return new DeflateRaw(o);
                };
  
                exports.createInflateRaw = function (o) {
                  return new InflateRaw(o);
                };
  
                exports.createGzip = function (o) {
                  return new Gzip(o);
                };
  
                exports.createGunzip = function (o) {
                  return new Gunzip(o);
                };
  
                exports.createUnzip = function (o) {
                  return new Unzip(o);
                };
  
                // Convenience methods.
                // compress/decompress a string or buffer in one step.
                exports.deflate = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new Deflate(opts), buffer, callback);
                };
  
                exports.deflateSync = function (buffer, opts) {
                  return zlibBufferSync(new Deflate(opts), buffer);
                };
  
                exports.gzip = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new Gzip(opts), buffer, callback);
                };
  
                exports.gzipSync = function (buffer, opts) {
                  return zlibBufferSync(new Gzip(opts), buffer);
                };
  
                exports.deflateRaw = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
                };
  
                exports.deflateRawSync = function (buffer, opts) {
                  return zlibBufferSync(new DeflateRaw(opts), buffer);
                };
  
                exports.unzip = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new Unzip(opts), buffer, callback);
                };
  
                exports.unzipSync = function (buffer, opts) {
                  return zlibBufferSync(new Unzip(opts), buffer);
                };
  
                exports.inflate = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new Inflate(opts), buffer, callback);
                };
  
                exports.inflateSync = function (buffer, opts) {
                  return zlibBufferSync(new Inflate(opts), buffer);
                };
  
                exports.gunzip = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new Gunzip(opts), buffer, callback);
                };
  
                exports.gunzipSync = function (buffer, opts) {
                  return zlibBufferSync(new Gunzip(opts), buffer);
                };
  
                exports.inflateRaw = function (buffer, opts, callback) {
                  if (typeof opts === "function") {
                    callback = opts;
                    opts = {};
                  }
                  return zlibBuffer(new InflateRaw(opts), buffer, callback);
                };
  
                exports.inflateRawSync = function (buffer, opts) {
                  return zlibBufferSync(new InflateRaw(opts), buffer);
                };
  
                function zlibBuffer(engine, buffer, callback) {
                  var buffers = [];
                  var nread = 0;
  
                  engine.on("error", onError);
                  engine.on("end", onEnd);
  
                  engine.end(buffer);
                  flow();
  
                  function flow() {
                    var chunk;
                    while (null !== (chunk = engine.read())) {
                      buffers.push(chunk);
                      nread += chunk.length;
                    }
                    engine.once("readable", flow);
                  }
  
                  function onError(err) {
                    engine.removeListener("end", onEnd);
                    engine.removeListener("readable", flow);
                    callback(err);
                  }
  
                  function onEnd() {
                    var buf;
                    var err = null;
  
                    if (nread >= kMaxLength) {
                      err = new RangeError(kRangeErrorMessage);
                    } else {
                      buf = Buffer.concat(buffers, nread);
                    }
  
                    buffers = [];
                    engine.close();
                    callback(err, buf);
                  }
                }
  
                function zlibBufferSync(engine, buffer) {
                  if (typeof buffer === "string") buffer = Buffer.from(buffer);
  
                  if (!Buffer.isBuffer(buffer))
                    throw new TypeError("Not a string or buffer");
  
                  var flushFlag = engine._finishFlushFlag;
  
                  return engine._processChunk(buffer, flushFlag);
                }
  
                // generic zlib
                // minimal 2-byte header
                function Deflate(opts) {
                  if (!(this instanceof Deflate)) return new Deflate(opts);
                  Zlib.call(this, opts, binding.DEFLATE);
                }
  
                function Inflate(opts) {
                  if (!(this instanceof Inflate)) return new Inflate(opts);
                  Zlib.call(this, opts, binding.INFLATE);
                }
  
                // gzip - bigger header, same deflate compression
                function Gzip(opts) {
                  if (!(this instanceof Gzip)) return new Gzip(opts);
                  Zlib.call(this, opts, binding.GZIP);
                }
  
                function Gunzip(opts) {
                  if (!(this instanceof Gunzip)) return new Gunzip(opts);
                  Zlib.call(this, opts, binding.GUNZIP);
                }
  
                // raw - no header
                function DeflateRaw(opts) {
                  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
                  Zlib.call(this, opts, binding.DEFLATERAW);
                }
  
                function InflateRaw(opts) {
                  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
                  Zlib.call(this, opts, binding.INFLATERAW);
                }
  
                // auto-detect header.
                function Unzip(opts) {
                  if (!(this instanceof Unzip)) return new Unzip(opts);
                  Zlib.call(this, opts, binding.UNZIP);
                }
  
                function isValidFlushFlag(flag) {
                  return (
                    flag === binding.Z_NO_FLUSH ||
                    flag === binding.Z_PARTIAL_FLUSH ||
                    flag === binding.Z_SYNC_FLUSH ||
                    flag === binding.Z_FULL_FLUSH ||
                    flag === binding.Z_FINISH ||
                    flag === binding.Z_BLOCK
                  );
                }
  
                // the Zlib class they all inherit from
                // This thing manages the queue of requests, and returns
                // true or false if there is anything in the queue when
                // you call the .write() method.
  
                function Zlib(opts, mode) {
                  var _this = this;
  
                  this._opts = opts = opts || {};
                  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
  
                  Transform.call(this, opts);
  
                  if (opts.flush && !isValidFlushFlag(opts.flush)) {
                    throw new Error("Invalid flush flag: " + opts.flush);
                  }
                  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
                    throw new Error("Invalid flush flag: " + opts.finishFlush);
                  }
  
                  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
                  this._finishFlushFlag =
                    typeof opts.finishFlush !== "undefined"
                      ? opts.finishFlush
                      : binding.Z_FINISH;
  
                  if (opts.chunkSize) {
                    if (
                      opts.chunkSize < exports.Z_MIN_CHUNK ||
                      opts.chunkSize > exports.Z_MAX_CHUNK
                    ) {
                      throw new Error("Invalid chunk size: " + opts.chunkSize);
                    }
                  }
  
                  if (opts.windowBits) {
                    if (
                      opts.windowBits < exports.Z_MIN_WINDOWBITS ||
                      opts.windowBits > exports.Z_MAX_WINDOWBITS
                    ) {
                      throw new Error("Invalid windowBits: " + opts.windowBits);
                    }
                  }
  
                  if (opts.level) {
                    if (
                      opts.level < exports.Z_MIN_LEVEL ||
                      opts.level > exports.Z_MAX_LEVEL
                    ) {
                      throw new Error("Invalid compression level: " + opts.level);
                    }
                  }
  
                  if (opts.memLevel) {
                    if (
                      opts.memLevel < exports.Z_MIN_MEMLEVEL ||
                      opts.memLevel > exports.Z_MAX_MEMLEVEL
                    ) {
                      throw new Error("Invalid memLevel: " + opts.memLevel);
                    }
                  }
  
                  if (opts.strategy) {
                    if (
                      opts.strategy != exports.Z_FILTERED &&
                      opts.strategy != exports.Z_HUFFMAN_ONLY &&
                      opts.strategy != exports.Z_RLE &&
                      opts.strategy != exports.Z_FIXED &&
                      opts.strategy != exports.Z_DEFAULT_STRATEGY
                    ) {
                      throw new Error("Invalid strategy: " + opts.strategy);
                    }
                  }
  
                  if (opts.dictionary) {
                    if (!Buffer.isBuffer(opts.dictionary)) {
                      throw new Error(
                        "Invalid dictionary: it should be a Buffer instance"
                      );
                    }
                  }
  
                  this._handle = new binding.Zlib(mode);
  
                  var self = this;
                  this._hadError = false;
                  this._handle.onerror = function (message, errno) {
                    // there is no way to cleanly recover.
                    // continuing only obscures problems.
                    _close(self);
                    self._hadError = true;
  
                    var error = new Error(message);
                    error.errno = errno;
                    error.code = exports.codes[errno];
                    self.emit("error", error);
                  };
  
                  var level = exports.Z_DEFAULT_COMPRESSION;
                  if (typeof opts.level === "number") level = opts.level;
  
                  var strategy = exports.Z_DEFAULT_STRATEGY;
                  if (typeof opts.strategy === "number") strategy = opts.strategy;
  
                  this._handle.init(
                    opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
                    level,
                    opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
                    strategy,
                    opts.dictionary
                  );
  
                  this._buffer = Buffer.allocUnsafe(this._chunkSize);
                  this._offset = 0;
                  this._level = level;
                  this._strategy = strategy;
  
                  this.once("end", this.close);
  
                  Object.defineProperty(this, "_closed", {
                    get: function () {
                      return !_this._handle;
                    },
                    configurable: true,
                    enumerable: true,
                  });
                }
  
                util.inherits(Zlib, Transform);
  
                Zlib.prototype.params = function (level, strategy, callback) {
                  if (
                    level < exports.Z_MIN_LEVEL ||
                    level > exports.Z_MAX_LEVEL
                  ) {
                    throw new RangeError("Invalid compression level: " + level);
                  }
                  if (
                    strategy != exports.Z_FILTERED &&
                    strategy != exports.Z_HUFFMAN_ONLY &&
                    strategy != exports.Z_RLE &&
                    strategy != exports.Z_FIXED &&
                    strategy != exports.Z_DEFAULT_STRATEGY
                  ) {
                    throw new TypeError("Invalid strategy: " + strategy);
                  }
  
                  if (this._level !== level || this._strategy !== strategy) {
                    var self = this;
                    this.flush(binding.Z_SYNC_FLUSH, function () {
                      assert(self._handle, "zlib binding closed");
                      self._handle.params(level, strategy);
                      if (!self._hadError) {
                        self._level = level;
                        self._strategy = strategy;
                        if (callback) callback();
                      }
                    });
                  } else {
                    process.nextTick(callback);
                  }
                };
  
                Zlib.prototype.reset = function () {
                  assert(this._handle, "zlib binding closed");
                  return this._handle.reset();
                };
  
                // This is the _flush function called by the transform class,
                // internally, when the last chunk has been written.
                Zlib.prototype._flush = function (callback) {
                  this._transform(Buffer.alloc(0), "", callback);
                };
  
                Zlib.prototype.flush = function (kind, callback) {
                  var _this2 = this;
  
                  var ws = this._writableState;
  
                  if (
                    typeof kind === "function" ||
                    (kind === undefined && !callback)
                  ) {
                    callback = kind;
                    kind = binding.Z_FULL_FLUSH;
                  }
  
                  if (ws.ended) {
                    if (callback) process.nextTick(callback);
                  } else if (ws.ending) {
                    if (callback) this.once("end", callback);
                  } else if (ws.needDrain) {
                    if (callback) {
                      this.once("drain", function () {
                        return _this2.flush(kind, callback);
                      });
                    }
                  } else {
                    this._flushFlag = kind;
                    this.write(Buffer.alloc(0), "", callback);
                  }
                };
  
                Zlib.prototype.close = function (callback) {
                  _close(this, callback);
                  process.nextTick(emitCloseNT, this);
                };
  
                function _close(engine, callback) {
                  if (callback) process.nextTick(callback);
  
                  // Caller may invoke .close after a zlib error (which will null _handle).
                  if (!engine._handle) return;
  
                  engine._handle.close();
                  engine._handle = null;
                }
  
                function emitCloseNT(self) {
                  self.emit("close");
                }
  
                Zlib.prototype._transform = function (chunk, encoding, cb) {
                  var flushFlag;
                  var ws = this._writableState;
                  var ending = ws.ending || ws.ended;
                  var last = ending && (!chunk || ws.length === chunk.length);
  
                  if (chunk !== null && !Buffer.isBuffer(chunk))
                    return cb(new Error("invalid input"));
  
                  if (!this._handle) return cb(new Error("zlib binding closed"));
  
                  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
                  // (or whatever flag was provided using opts.finishFlush).
                  // If it's explicitly flushing at some other time, then we use
                  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
                  // goodness.
                  if (last) flushFlag = this._finishFlushFlag;
                  else {
                    flushFlag = this._flushFlag;
                    // once we've flushed the last of the queue, stop flushing and
                    // go back to the normal behavior.
                    if (chunk.length >= ws.length) {
                      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
                    }
                  }
  
                  this._processChunk(chunk, flushFlag, cb);
                };
  
                Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
                  var availInBefore = chunk && chunk.length;
                  var availOutBefore = this._chunkSize - this._offset;
                  var inOff = 0;
  
                  var self = this;
  
                  var async = typeof cb === "function";
  
                  if (!async) {
                    var buffers = [];
                    var nread = 0;
  
                    var error;
                    this.on("error", function (er) {
                      error = er;
                    });
  
                    assert(this._handle, "zlib binding closed");
                    do {
                      var res = this._handle.writeSync(
                        flushFlag,
                        chunk, // in
                        inOff, // in_off
                        availInBefore, // in_len
                        this._buffer, // out
                        this._offset, //out_off
                        availOutBefore
                      ); // out_len
                    } while (!this._hadError && callback(res[0], res[1]));
  
                    if (this._hadError) {
                      throw error;
                    }
  
                    if (nread >= kMaxLength) {
                      _close(this);
                      throw new RangeError(kRangeErrorMessage);
                    }
  
                    var buf = Buffer.concat(buffers, nread);
                    _close(this);
  
                    return buf;
                  }
  
                  assert(this._handle, "zlib binding closed");
                  var req = this._handle.write(
                    flushFlag,
                    chunk, // in
                    inOff, // in_off
                    availInBefore, // in_len
                    this._buffer, // out
                    this._offset, //out_off
                    availOutBefore
                  ); // out_len
  
                  req.buffer = chunk;
                  req.callback = callback;
  
                  function callback(availInAfter, availOutAfter) {
                    // When the callback is used in an async write, the callback's
                    // context is the `req` object that was created. The req object
                    // is === this._handle, and that's why it's important to null
                    // out the values after they are done being used. `this._handle`
                    // can stay in memory longer than the callback and buffer are needed.
                    if (this) {
                      this.buffer = null;
                      this.callback = null;
                    }
  
                    if (self._hadError) return;
  
                    var have = availOutBefore - availOutAfter;
                    assert(have >= 0, "have should not go down");
  
                    if (have > 0) {
                      var out = self._buffer.slice(
                        self._offset,
                        self._offset + have
                      );
                      self._offset += have;
                      // serve some output to the consumer.
                      if (async) {
                        self.push(out);
                      } else {
                        buffers.push(out);
                        nread += out.length;
                      }
                    }
  
                    // exhausted the output buffer, or used all the input create a new one.
                    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
                      availOutBefore = self._chunkSize;
                      self._offset = 0;
                      self._buffer = Buffer.allocUnsafe(self._chunkSize);
                    }
  
                    if (availOutAfter === 0) {
                      // Not actually done.  Need to reprocess.
                      // Also, update the availInBefore to the availInAfter value,
                      // so that if we have to hit it a third (fourth, etc.) time,
                      // it'll have the correct byte counts.
                      inOff += availInBefore - availInAfter;
                      availInBefore = availInAfter;
  
                      if (!async) return true;
  
                      var newReq = self._handle.write(
                        flushFlag,
                        chunk,
                        inOff,
                        availInBefore,
                        self._buffer,
                        self._offset,
                        self._chunkSize
                      );
                      newReq.callback = callback; // this same function
                      newReq.buffer = chunk;
                      return;
                    }
  
                    if (!async) return false;
  
                    // finished with the chunk.
                    cb();
                  }
                };
  
                util.inherits(Deflate, Zlib);
                util.inherits(Inflate, Zlib);
                util.inherits(Gzip, Zlib);
                util.inherits(Gunzip, Zlib);
                util.inherits(DeflateRaw, Zlib);
                util.inherits(InflateRaw, Zlib);
                util.inherits(Unzip, Zlib);
              }.call(this));
            }.call(this, require("_process")));
          },
          {
            "./binding": 41,
            _process: 261,
            assert: 2,
            buffer: 55,
            stream: 297,
            util: 307,
          },
        ],
        43: [
          function (require, module, exports) {
            "use strict";
  
            var TYPED_OK =
              typeof Uint8Array !== "undefined" &&
              typeof Uint16Array !== "undefined" &&
              typeof Int32Array !== "undefined";
  
            function _has(obj, key) {
              return Object.prototype.hasOwnProperty.call(obj, key);
            }
  
            exports.assign = function (obj /*from1, from2, from3, ...*/) {
              var sources = Array.prototype.slice.call(arguments, 1);
              while (sources.length) {
                var source = sources.shift();
                if (!source) {
                  continue;
                }
  
                if (typeof source !== "object") {
                  throw new TypeError(source + "must be non-object");
                }
  
                for (var p in source) {
                  if (_has(source, p)) {
                    obj[p] = source[p];
                  }
                }
              }
  
              return obj;
            };
  
            // reduce buffer size, avoiding mem copy
            exports.shrinkBuf = function (buf, size) {
              if (buf.length === size) {
                return buf;
              }
              if (buf.subarray) {
                return buf.subarray(0, size);
              }
              buf.length = size;
              return buf;
            };
  
            var fnTyped = {
              arraySet: function (dest, src, src_offs, len, dest_offs) {
                if (src.subarray && dest.subarray) {
                  dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
                  return;
                }
                // Fallback to ordinary array
                for (var i = 0; i < len; i++) {
                  dest[dest_offs + i] = src[src_offs + i];
                }
              },
              // Join array of chunks to single array.
              flattenChunks: function (chunks) {
                var i, l, len, pos, chunk, result;
  
                // calculate data length
                len = 0;
                for (i = 0, l = chunks.length; i < l; i++) {
                  len += chunks[i].length;
                }
  
                // join chunks
                result = new Uint8Array(len);
                pos = 0;
                for (i = 0, l = chunks.length; i < l; i++) {
                  chunk = chunks[i];
                  result.set(chunk, pos);
                  pos += chunk.length;
                }
  
                return result;
              },
            };
  
            var fnUntyped = {
              arraySet: function (dest, src, src_offs, len, dest_offs) {
                for (var i = 0; i < len; i++) {
                  dest[dest_offs + i] = src[src_offs + i];
                }
              },
              // Join array of chunks to single array.
              flattenChunks: function (chunks) {
                return [].concat.apply([], chunks);
              },
            };
  
            // Enable/Disable typed arrays use, for testing
            //
            exports.setTyped = function (on) {
              if (on) {
                exports.Buf8 = Uint8Array;
                exports.Buf16 = Uint16Array;
                exports.Buf32 = Int32Array;
                exports.assign(exports, fnTyped);
              } else {
                exports.Buf8 = Array;
                exports.Buf16 = Array;
                exports.Buf32 = Array;
                exports.assign(exports, fnUntyped);
              }
            };
  
            exports.setTyped(TYPED_OK);
          },
          {},
        ],
        44: [
          function (require, module, exports) {
            "use strict";
  
            // Note: adler32 takes 12% for level 0 and 2% for level 6.
            // It isn't worth it to make additional optimizations as in original.
            // Small size is preferable.
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            function adler32(adler, buf, len, pos) {
              var s1 = (adler & 0xffff) | 0,
                s2 = ((adler >>> 16) & 0xffff) | 0,
                n = 0;
  
              while (len !== 0) {
                // Set limit ~ twice less than 5552, to keep
                // s2 in 31-bits, because we force signed ints.
                // in other case %= will fail.
                n = len > 2000 ? 2000 : len;
                len -= n;
  
                do {
                  s1 = (s1 + buf[pos++]) | 0;
                  s2 = (s2 + s1) | 0;
                } while (--n);
  
                s1 %= 65521;
                s2 %= 65521;
              }
  
              return s1 | (s2 << 16) | 0;
            }
  
            module.exports = adler32;
          },
          {},
        ],
        45: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            module.exports = {
              /* Allowed flush values; see deflate() and inflate() below for details */
              Z_NO_FLUSH: 0,
              Z_PARTIAL_FLUSH: 1,
              Z_SYNC_FLUSH: 2,
              Z_FULL_FLUSH: 3,
              Z_FINISH: 4,
              Z_BLOCK: 5,
              Z_TREES: 6,
  
              /* Return codes for the compression/decompression functions. Negative values
               * are errors, positive values are used for special but normal events.
               */
              Z_OK: 0,
              Z_STREAM_END: 1,
              Z_NEED_DICT: 2,
              Z_ERRNO: -1,
              Z_STREAM_ERROR: -2,
              Z_DATA_ERROR: -3,
              //Z_MEM_ERROR:     -4,
              Z_BUF_ERROR: -5,
              //Z_VERSION_ERROR: -6,
  
              /* compression levels */
              Z_NO_COMPRESSION: 0,
              Z_BEST_SPEED: 1,
              Z_BEST_COMPRESSION: 9,
              Z_DEFAULT_COMPRESSION: -1,
  
              Z_FILTERED: 1,
              Z_HUFFMAN_ONLY: 2,
              Z_RLE: 3,
              Z_FIXED: 4,
              Z_DEFAULT_STRATEGY: 0,
  
              /* Possible values of the data_type field (though see inflate()) */
              Z_BINARY: 0,
              Z_TEXT: 1,
              //Z_ASCII:                1, // = Z_TEXT (deprecated)
              Z_UNKNOWN: 2,
  
              /* The deflate compression method */
              Z_DEFLATED: 8,
              //Z_NULL:                 null // Use -1 or null inline, depending on var type
            };
          },
          {},
        ],
        46: [
          function (require, module, exports) {
            "use strict";
  
            // Note: we can't get significant speed boost here.
            // So write code to minimize size - no pregenerated tables
            // and array tools dependencies.
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            // Use ordinary array, since untyped makes no boost here
            function makeTable() {
              var c,
                table = [];
  
              for (var n = 0; n < 256; n++) {
                c = n;
                for (var k = 0; k < 8; k++) {
                  c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
                }
                table[n] = c;
              }
  
              return table;
            }
  
            // Create table on load. Just 255 signed longs. Not a problem.
            var crcTable = makeTable();
  
            function crc32(crc, buf, len, pos) {
              var t = crcTable,
                end = pos + len;
  
              crc ^= -1;
  
              for (var i = pos; i < end; i++) {
                crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xff];
              }
  
              return crc ^ -1; // >>> 0;
            }
  
            module.exports = crc32;
          },
          {},
        ],
        47: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            var utils = require("../utils/common");
            var trees = require("./trees");
            var adler32 = require("./adler32");
            var crc32 = require("./crc32");
            var msg = require("./messages");
  
            /* Public constants ==========================================================*/
            /* ===========================================================================*/
  
            /* Allowed flush values; see deflate() and inflate() below for details */
            var Z_NO_FLUSH = 0;
            var Z_PARTIAL_FLUSH = 1;
            //var Z_SYNC_FLUSH    = 2;
            var Z_FULL_FLUSH = 3;
            var Z_FINISH = 4;
            var Z_BLOCK = 5;
            //var Z_TREES         = 6;
  
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            var Z_OK = 0;
            var Z_STREAM_END = 1;
            //var Z_NEED_DICT     = 2;
            //var Z_ERRNO         = -1;
            var Z_STREAM_ERROR = -2;
            var Z_DATA_ERROR = -3;
            //var Z_MEM_ERROR     = -4;
            var Z_BUF_ERROR = -5;
            //var Z_VERSION_ERROR = -6;
  
            /* compression levels */
            //var Z_NO_COMPRESSION      = 0;
            //var Z_BEST_SPEED          = 1;
            //var Z_BEST_COMPRESSION    = 9;
            var Z_DEFAULT_COMPRESSION = -1;
  
            var Z_FILTERED = 1;
            var Z_HUFFMAN_ONLY = 2;
            var Z_RLE = 3;
            var Z_FIXED = 4;
            var Z_DEFAULT_STRATEGY = 0;
  
            /* Possible values of the data_type field (though see inflate()) */
            //var Z_BINARY              = 0;
            //var Z_TEXT                = 1;
            //var Z_ASCII               = 1; // = Z_TEXT
            var Z_UNKNOWN = 2;
  
            /* The deflate compression method */
            var Z_DEFLATED = 8;
  
            /*============================================================================*/
  
            var MAX_MEM_LEVEL = 9;
            /* Maximum value for memLevel in deflateInit2 */
            var MAX_WBITS = 15;
            /* 32K LZ77 window */
            var DEF_MEM_LEVEL = 8;
  
            var LENGTH_CODES = 29;
            /* number of length codes, not counting the special END_BLOCK code */
            var LITERALS = 256;
            /* number of literal bytes 0..255 */
            var L_CODES = LITERALS + 1 + LENGTH_CODES;
            /* number of Literal or Length codes, including the END_BLOCK code */
            var D_CODES = 30;
            /* number of distance codes */
            var BL_CODES = 19;
            /* number of codes used to transfer the bit lengths */
            var HEAP_SIZE = 2 * L_CODES + 1;
            /* maximum heap size */
            var MAX_BITS = 15;
            /* All codes must not exceed MAX_BITS bits */
  
            var MIN_MATCH = 3;
            var MAX_MATCH = 258;
            var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
  
            var PRESET_DICT = 0x20;
  
            var INIT_STATE = 42;
            var EXTRA_STATE = 69;
            var NAME_STATE = 73;
            var COMMENT_STATE = 91;
            var HCRC_STATE = 103;
            var BUSY_STATE = 113;
            var FINISH_STATE = 666;
  
            var BS_NEED_MORE = 1; /* block not completed, need more input or more output */
            var BS_BLOCK_DONE = 2; /* block flush performed */
            var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
            var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */
  
            var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
  
            function err(strm, errorCode) {
              strm.msg = msg[errorCode];
              return errorCode;
            }
  
            function rank(f) {
              return (f << 1) - (f > 4 ? 9 : 0);
            }
  
            function zero(buf) {
              var len = buf.length;
              while (--len >= 0) {
                buf[len] = 0;
              }
            }
  
            /* =========================================================================
             * Flush as much pending output as possible. All deflate() output goes
             * through this function so some applications may wish to modify it
             * to avoid allocating a large strm->output buffer and copying into it.
             * (See also read_buf()).
             */
            function flush_pending(strm) {
              var s = strm.state;
  
              //_tr_flush_bits(s);
              var len = s.pending;
              if (len > strm.avail_out) {
                len = strm.avail_out;
              }
              if (len === 0) {
                return;
              }
  
              utils.arraySet(
                strm.output,
                s.pending_buf,
                s.pending_out,
                len,
                strm.next_out
              );
              strm.next_out += len;
              s.pending_out += len;
              strm.total_out += len;
              strm.avail_out -= len;
              s.pending -= len;
              if (s.pending === 0) {
                s.pending_out = 0;
              }
            }
  
            function flush_block_only(s, last) {
              trees._tr_flush_block(
                s,
                s.block_start >= 0 ? s.block_start : -1,
                s.strstart - s.block_start,
                last
              );
              s.block_start = s.strstart;
              flush_pending(s.strm);
            }
  
            function put_byte(s, b) {
              s.pending_buf[s.pending++] = b;
            }
  
            /* =========================================================================
             * Put a short in the pending buffer. The 16-bit value is put in MSB order.
             * IN assertion: the stream state is correct and there is enough room in
             * pending_buf.
             */
            function putShortMSB(s, b) {
              //  put_byte(s, (Byte)(b >> 8));
              //  put_byte(s, (Byte)(b & 0xff));
              s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
              s.pending_buf[s.pending++] = b & 0xff;
            }
  
            /* ===========================================================================
             * Read a new buffer from the current input stream, update the adler32
             * and total number of bytes read.  All deflate() input goes through
             * this function so some applications may wish to modify it to avoid
             * allocating a large strm->input buffer and copying from it.
             * (See also flush_pending()).
             */
            function read_buf(strm, buf, start, size) {
              var len = strm.avail_in;
  
              if (len > size) {
                len = size;
              }
              if (len === 0) {
                return 0;
              }
  
              strm.avail_in -= len;
  
              // zmemcpy(buf, strm->next_in, len);
              utils.arraySet(buf, strm.input, strm.next_in, len, start);
              if (strm.state.wrap === 1) {
                strm.adler = adler32(strm.adler, buf, len, start);
              } else if (strm.state.wrap === 2) {
                strm.adler = crc32(strm.adler, buf, len, start);
              }
  
              strm.next_in += len;
              strm.total_in += len;
  
              return len;
            }
  
            /* ===========================================================================
             * Set match_start to the longest match starting at the given string and
             * return its length. Matches shorter or equal to prev_length are discarded,
             * in which case the result is equal to prev_length and match_start is
             * garbage.
             * IN assertions: cur_match is the head of the hash chain for the current
             *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
             * OUT assertion: the match length is not greater than s->lookahead.
             */
            function longest_match(s, cur_match) {
              var chain_length = s.max_chain_length; /* max hash chain length */
              var scan = s.strstart; /* current string */
              var match; /* matched string */
              var len; /* length of current match */
              var best_len = s.prev_length; /* best match length so far */
              var nice_match = s.nice_match; /* stop if match long enough */
              var limit =
                s.strstart > s.w_size - MIN_LOOKAHEAD
                  ? s.strstart - (s.w_size - MIN_LOOKAHEAD)
                  : 0; /*NIL*/
  
              var _win = s.window; // shortcut
  
              var wmask = s.w_mask;
              var prev = s.prev;
  
              /* Stop when cur_match becomes <= limit. To simplify the code,
               * we prevent matches with the string of window index 0.
               */
  
              var strend = s.strstart + MAX_MATCH;
              var scan_end1 = _win[scan + best_len - 1];
              var scan_end = _win[scan + best_len];
  
              /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
               * It is easy to get rid of this optimization if necessary.
               */
              // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
  
              /* Do not waste too much time if we already have a good match: */
              if (s.prev_length >= s.good_match) {
                chain_length >>= 2;
              }
              /* Do not look for matches beyond the end of the input. This is necessary
               * to make deflate deterministic.
               */
              if (nice_match > s.lookahead) {
                nice_match = s.lookahead;
              }
  
              // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
  
              do {
                // Assert(cur_match < s->strstart, "no future");
                match = cur_match;
  
                /* Skip to next match if the match length cannot increase
                 * or if the match length is less than 2.  Note that the checks below
                 * for insufficient lookahead only occur occasionally for performance
                 * reasons.  Therefore uninitialized memory will be accessed, and
                 * conditional jumps will be made that depend on those values.
                 * However the length of the match is limited to the lookahead, so
                 * the output of deflate is not affected by the uninitialized values.
                 */
  
                if (
                  _win[match + best_len] !== scan_end ||
                  _win[match + best_len - 1] !== scan_end1 ||
                  _win[match] !== _win[scan] ||
                  _win[++match] !== _win[scan + 1]
                ) {
                  continue;
                }
  
                /* The check at best_len-1 can be removed because it will be made
                 * again later. (This heuristic is not always a win.)
                 * It is not necessary to compare scan[2] and match[2] since they
                 * are always equal when the other bytes match, given that
                 * the hash keys are equal and that HASH_BITS >= 8.
                 */
                scan += 2;
                match++;
                // Assert(*scan == *match, "match[2]?");
  
                /* We check for insufficient lookahead only every 8th comparison;
                 * the 256th check will be made at strstart+258.
                 */
                do {
                  /*jshint noempty:false*/
                } while (
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  _win[++scan] === _win[++match] &&
                  scan < strend
                );
  
                // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
  
                len = MAX_MATCH - (strend - scan);
                scan = strend - MAX_MATCH;
  
                if (len > best_len) {
                  s.match_start = cur_match;
                  best_len = len;
                  if (len >= nice_match) {
                    break;
                  }
                  scan_end1 = _win[scan + best_len - 1];
                  scan_end = _win[scan + best_len];
                }
              } while (
                (cur_match = prev[cur_match & wmask]) > limit &&
                --chain_length !== 0
              );
  
              if (best_len <= s.lookahead) {
                return best_len;
              }
              return s.lookahead;
            }
  
            /* ===========================================================================
             * Fill the window when the lookahead becomes insufficient.
             * Updates strstart and lookahead.
             *
             * IN assertion: lookahead < MIN_LOOKAHEAD
             * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
             *    At least one byte has been read, or avail_in == 0; reads are
             *    performed for at least two bytes (required for the zip translate_eol
             *    option -- not supported here).
             */
            function fill_window(s) {
              var _w_size = s.w_size;
              var p, n, m, more, str;
  
              //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
  
              do {
                more = s.window_size - s.lookahead - s.strstart;
  
                // JS ints have 32 bit, block below not needed
                /* Deal with !@#$% 64K limit: */
                //if (sizeof(int) <= 2) {
                //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
                //        more = wsize;
                //
                //  } else if (more == (unsigned)(-1)) {
                //        /* Very unlikely, but possible on 16 bit machine if
                //         * strstart == 0 && lookahead == 1 (input done a byte at time)
                //         */
                //        more--;
                //    }
                //}
  
                /* If the window is almost full and there is insufficient lookahead,
                 * move the upper half to the lower one to make room in the upper half.
                 */
                if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
                  utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
                  s.match_start -= _w_size;
                  s.strstart -= _w_size;
                  /* we now have strstart >= MAX_DIST */
                  s.block_start -= _w_size;
  
                  /* Slide the hash table (could be avoided with 32 bit values
         at the expense of memory usage). We slide even when level == 0
         to keep the hash table consistent if we switch back to level > 0
         later. (Using level 0 permanently is not an optimal usage of
         zlib, so we don't care about this pathological case.)
         */
  
                  n = s.hash_size;
                  p = n;
                  do {
                    m = s.head[--p];
                    s.head[p] = m >= _w_size ? m - _w_size : 0;
                  } while (--n);
  
                  n = _w_size;
                  p = n;
                  do {
                    m = s.prev[--p];
                    s.prev[p] = m >= _w_size ? m - _w_size : 0;
                    /* If n is not on any hash chain, prev[n] is garbage but
                     * its value will never be used.
                     */
                  } while (--n);
  
                  more += _w_size;
                }
                if (s.strm.avail_in === 0) {
                  break;
                }
  
                /* If there was no sliding:
                 *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
                 *    more == window_size - lookahead - strstart
                 * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
                 * => more >= window_size - 2*WSIZE + 2
                 * In the BIG_MEM or MMAP case (not yet supported),
                 *   window_size == input_size + MIN_LOOKAHEAD  &&
                 *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
                 * Otherwise, window_size == 2*WSIZE so more >= 2.
                 * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
                 */
                //Assert(more >= 2, "more < 2");
                n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
                s.lookahead += n;
  
                /* Initialize the hash value now that we have some input: */
                if (s.lookahead + s.insert >= MIN_MATCH) {
                  str = s.strstart - s.insert;
                  s.ins_h = s.window[str];
  
                  /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
                  s.ins_h =
                    ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
                  //#if MIN_MATCH != 3
                  //        Call update_hash() MIN_MATCH-3 more times
                  //#endif
                  while (s.insert) {
                    /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                    s.ins_h =
                      ((s.ins_h << s.hash_shift) ^
                        s.window[str + MIN_MATCH - 1]) &
                      s.hash_mask;
  
                    s.prev[str & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = str;
                    str++;
                    s.insert--;
                    if (s.lookahead + s.insert < MIN_MATCH) {
                      break;
                    }
                  }
                }
                /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
                 * but this is not important since only literal bytes will be emitted.
                 */
              } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
  
              /* If the WIN_INIT bytes after the end of the current data have never been
               * written, then zero those bytes in order to avoid memory check reports of
               * the use of uninitialized (or uninitialised as Julian writes) bytes by
               * the longest match routines.  Update the high water mark for the next
               * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
               * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
               */
              //  if (s.high_water < s.window_size) {
              //    var curr = s.strstart + s.lookahead;
              //    var init = 0;
              //
              //    if (s.high_water < curr) {
              //      /* Previous high water mark below current data -- zero WIN_INIT
              //       * bytes or up to end of window, whichever is less.
              //       */
              //      init = s.window_size - curr;
              //      if (init > WIN_INIT)
              //        init = WIN_INIT;
              //      zmemzero(s->window + curr, (unsigned)init);
              //      s->high_water = curr + init;
              //    }
              //    else if (s->high_water < (ulg)curr + WIN_INIT) {
              //      /* High water mark at or above current data, but below current data
              //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
              //       * to end of window, whichever is less.
              //       */
              //      init = (ulg)curr + WIN_INIT - s->high_water;
              //      if (init > s->window_size - s->high_water)
              //        init = s->window_size - s->high_water;
              //      zmemzero(s->window + s->high_water, (unsigned)init);
              //      s->high_water += init;
              //    }
              //  }
              //
              //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
              //    "not enough room for search");
            }
  
            /* ===========================================================================
             * Copy without compression as much as possible from the input stream, return
             * the current block state.
             * This function does not insert new strings in the dictionary since
             * uncompressible data is probably not useful. This function is used
             * only for the level=0 compression option.
             * NOTE: this function should be optimized to avoid extra copying from
             * window to pending_buf.
             */
            function deflate_stored(s, flush) {
              /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
               * to pending_buf_size, and each stored block has a 5 byte header:
               */
              var max_block_size = 0xffff;
  
              if (max_block_size > s.pending_buf_size - 5) {
                max_block_size = s.pending_buf_size - 5;
              }
  
              /* Copy as much as possible from input to output: */
              for (;;) {
                /* Fill the window as much as possible: */
                if (s.lookahead <= 1) {
                  //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
                  //  s->block_start >= (long)s->w_size, "slide too late");
                  //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
                  //        s.block_start >= s.w_size)) {
                  //        throw  new Error("slide too late");
                  //      }
  
                  fill_window(s);
                  if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
                    return BS_NEED_MORE;
                  }
  
                  if (s.lookahead === 0) {
                    break;
                  }
                  /* flush the current block */
                }
                //Assert(s->block_start >= 0L, "block gone");
                //    if (s.block_start < 0) throw new Error("block gone");
  
                s.strstart += s.lookahead;
                s.lookahead = 0;
  
                /* Emit a stored block if pending_buf will be full: */
                var max_start = s.block_start + max_block_size;
  
                if (s.strstart === 0 || s.strstart >= max_start) {
                  /* strstart == 0 is possible when wraparound on 16-bit machine */
                  s.lookahead = s.strstart - max_start;
                  s.strstart = max_start;
                  /*** FLUSH_BLOCK(s, 0); ***/
                  flush_block_only(s, false);
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                  /***/
                }
                /* Flush if we may have to slide, otherwise block_start may become
                 * negative and the data will be gone:
                 */
                if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
                  /*** FLUSH_BLOCK(s, 0); ***/
                  flush_block_only(s, false);
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                  /***/
                }
              }
  
              s.insert = 0;
  
              if (flush === Z_FINISH) {
                /*** FLUSH_BLOCK(s, 1); ***/
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                  return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
              }
  
              if (s.strstart > s.block_start) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
  
              return BS_NEED_MORE;
            }
  
            /* ===========================================================================
             * Compress as much as possible from the input stream, return the current
             * block state.
             * This function does not perform lazy evaluation of matches and inserts
             * new strings in the dictionary only for unmatched strings or for short
             * matches. It is used only for the fast compression options.
             */
            function deflate_fast(s, flush) {
              var hash_head; /* head of the hash chain */
              var bflush; /* set if current block must be flushed */
  
              for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                  fill_window(s);
                  if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                    return BS_NEED_MORE;
                  }
                  if (s.lookahead === 0) {
                    break; /* flush the current block */
                  }
                }
  
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0 /*NIL*/;
                if (s.lookahead >= MIN_MATCH) {
                  /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                  s.ins_h =
                    ((s.ins_h << s.hash_shift) ^
                      s.window[s.strstart + MIN_MATCH - 1]) &
                    s.hash_mask;
                  hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                  s.head[s.ins_h] = s.strstart;
                  /***/
                }
  
                /* Find the longest match, discarding those <= prev_length.
                 * At this point we have always match_length < MIN_MATCH
                 */
                if (
                  hash_head !== 0 /*NIL*/ &&
                  s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD
                ) {
                  /* To simplify the code, we prevent matches with the string
                   * of window index 0 (in particular we have to avoid a match
                   * of the string with itself at the start of the input file).
                   */
                  s.match_length = longest_match(s, hash_head);
                  /* longest_match() sets match_start */
                }
                if (s.match_length >= MIN_MATCH) {
                  // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
  
                  /*** _tr_tally_dist(s, s.strstart - s.match_start,
                       s.match_length - MIN_MATCH, bflush); ***/
                  bflush = trees._tr_tally(
                    s,
                    s.strstart - s.match_start,
                    s.match_length - MIN_MATCH
                  );
  
                  s.lookahead -= s.match_length;
  
                  /* Insert new strings in the hash table only if the match length
                   * is not too large. This saves time but degrades compression.
                   */
                  if (
                    s.match_length <= s.max_lazy_match /*max_insert_length*/ &&
                    s.lookahead >= MIN_MATCH
                  ) {
                    s.match_length--; /* string at strstart already in table */
                    do {
                      s.strstart++;
                      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                      s.ins_h =
                        ((s.ins_h << s.hash_shift) ^
                          s.window[s.strstart + MIN_MATCH - 1]) &
                        s.hash_mask;
                      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                      s.head[s.ins_h] = s.strstart;
                      /***/
                      /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                       * always MIN_MATCH bytes ahead.
                       */
                    } while (--s.match_length !== 0);
                    s.strstart++;
                  } else {
                    s.strstart += s.match_length;
                    s.match_length = 0;
                    s.ins_h = s.window[s.strstart];
                    /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
                    s.ins_h =
                      ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) &
                      s.hash_mask;
  
                    //#if MIN_MATCH != 3
                    //                Call UPDATE_HASH() MIN_MATCH-3 more times
                    //#endif
                    /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
                     * matter since it will be recomputed at next deflate call.
                     */
                  }
                } else {
                  /* No match, output a literal byte */
                  //Tracevv((stderr,"%c", s.window[s.strstart]));
                  /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
                  bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
  
                  s.lookahead--;
                  s.strstart++;
                }
                if (bflush) {
                  /*** FLUSH_BLOCK(s, 0); ***/
                  flush_block_only(s, false);
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                  /***/
                }
              }
              s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
              if (flush === Z_FINISH) {
                /*** FLUSH_BLOCK(s, 1); ***/
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                  return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
              }
              if (s.last_lit) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
              return BS_BLOCK_DONE;
            }
  
            /* ===========================================================================
             * Same as above, but achieves better compression. We use a lazy
             * evaluation for matches: a match is finally adopted only if there is
             * no better match at the next window position.
             */
            function deflate_slow(s, flush) {
              var hash_head; /* head of hash chain */
              var bflush; /* set if current block must be flushed */
  
              var max_insert;
  
              /* Process the input block. */
              for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the next match, plus MIN_MATCH bytes to insert the
                 * string following the next match.
                 */
                if (s.lookahead < MIN_LOOKAHEAD) {
                  fill_window(s);
                  if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
                    return BS_NEED_MORE;
                  }
                  if (s.lookahead === 0) {
                    break;
                  } /* flush the current block */
                }
  
                /* Insert the string window[strstart .. strstart+2] in the
                 * dictionary, and set hash_head to the head of the hash chain:
                 */
                hash_head = 0 /*NIL*/;
                if (s.lookahead >= MIN_MATCH) {
                  /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                  s.ins_h =
                    ((s.ins_h << s.hash_shift) ^
                      s.window[s.strstart + MIN_MATCH - 1]) &
                    s.hash_mask;
                  hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                  s.head[s.ins_h] = s.strstart;
                  /***/
                }
  
                /* Find the longest match, discarding those <= prev_length.
                 */
                s.prev_length = s.match_length;
                s.prev_match = s.match_start;
                s.match_length = MIN_MATCH - 1;
  
                if (
                  hash_head !== 0 /*NIL*/ &&
                  s.prev_length < s.max_lazy_match &&
                  s.strstart - hash_head <=
                    s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/
                ) {
                  /* To simplify the code, we prevent matches with the string
                   * of window index 0 (in particular we have to avoid a match
                   * of the string with itself at the start of the input file).
                   */
                  s.match_length = longest_match(s, hash_head);
                  /* longest_match() sets match_start */
  
                  if (
                    s.match_length <= 5 &&
                    (s.strategy === Z_FILTERED ||
                      (s.match_length === MIN_MATCH &&
                        s.strstart - s.match_start > 4096) /*TOO_FAR*/)
                  ) {
                    /* If prev_match is also MIN_MATCH, match_start is garbage
                     * but we will ignore the current match anyway.
                     */
                    s.match_length = MIN_MATCH - 1;
                  }
                }
                /* If there was a match at the previous step and the current
                 * match is not better, output the previous match:
                 */
                if (
                  s.prev_length >= MIN_MATCH &&
                  s.match_length <= s.prev_length
                ) {
                  max_insert = s.strstart + s.lookahead - MIN_MATCH;
                  /* Do not insert strings in hash table beyond this. */
  
                  //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
  
                  /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                       s.prev_length - MIN_MATCH, bflush);***/
                  bflush = trees._tr_tally(
                    s,
                    s.strstart - 1 - s.prev_match,
                    s.prev_length - MIN_MATCH
                  );
                  /* Insert in hash table all strings up to the end of the match.
                   * strstart-1 and strstart are already inserted. If there is not
                   * enough lookahead, the last two strings are not inserted in
                   * the hash table.
                   */
                  s.lookahead -= s.prev_length - 1;
                  s.prev_length -= 2;
                  do {
                    if (++s.strstart <= max_insert) {
                      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                      s.ins_h =
                        ((s.ins_h << s.hash_shift) ^
                          s.window[s.strstart + MIN_MATCH - 1]) &
                        s.hash_mask;
                      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                      s.head[s.ins_h] = s.strstart;
                      /***/
                    }
                  } while (--s.prev_length !== 0);
                  s.match_available = 0;
                  s.match_length = MIN_MATCH - 1;
                  s.strstart++;
  
                  if (bflush) {
                    /*** FLUSH_BLOCK(s, 0); ***/
                    flush_block_only(s, false);
                    if (s.strm.avail_out === 0) {
                      return BS_NEED_MORE;
                    }
                    /***/
                  }
                } else if (s.match_available) {
                  /* If there was no match at the previous position, output a
                   * single literal. If there was a match but the current match
                   * is longer, truncate the previous match to a single literal.
                   */
                  //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                  /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
                  bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
  
                  if (bflush) {
                    /*** FLUSH_BLOCK_ONLY(s, 0) ***/
                    flush_block_only(s, false);
                    /***/
                  }
                  s.strstart++;
                  s.lookahead--;
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                } else {
                  /* There is no previous match to compare with, wait for
                   * the next step to decide.
                   */
                  s.match_available = 1;
                  s.strstart++;
                  s.lookahead--;
                }
              }
              //Assert (flush != Z_NO_FLUSH, "no flush?");
              if (s.match_available) {
                //Tracevv((stderr,"%c", s->window[s->strstart-1]));
                /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
                bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
  
                s.match_available = 0;
              }
              s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
              if (flush === Z_FINISH) {
                /*** FLUSH_BLOCK(s, 1); ***/
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                  return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
              }
              if (s.last_lit) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
  
              return BS_BLOCK_DONE;
            }
  
            /* ===========================================================================
             * For Z_RLE, simply look for runs of bytes, generate matches only of distance
             * one.  Do not maintain a hash table.  (It will be regenerated if this run of
             * deflate switches away from Z_RLE.)
             */
            function deflate_rle(s, flush) {
              var bflush; /* set if current block must be flushed */
              var prev; /* byte at distance one to match */
              var scan, strend; /* scan goes up to strend for length of run */
  
              var _win = s.window;
  
              for (;;) {
                /* Make sure that we always have enough lookahead, except
                 * at the end of the input file. We need MAX_MATCH bytes
                 * for the longest run, plus one for the unrolled loop.
                 */
                if (s.lookahead <= MAX_MATCH) {
                  fill_window(s);
                  if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
                    return BS_NEED_MORE;
                  }
                  if (s.lookahead === 0) {
                    break;
                  } /* flush the current block */
                }
  
                /* See how many times the previous byte repeats */
                s.match_length = 0;
                if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
                  scan = s.strstart - 1;
                  prev = _win[scan];
                  if (
                    prev === _win[++scan] &&
                    prev === _win[++scan] &&
                    prev === _win[++scan]
                  ) {
                    strend = s.strstart + MAX_MATCH;
                    do {
                      /*jshint noempty:false*/
                    } while (
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      prev === _win[++scan] &&
                      scan < strend
                    );
                    s.match_length = MAX_MATCH - (strend - scan);
                    if (s.match_length > s.lookahead) {
                      s.match_length = s.lookahead;
                    }
                  }
                  //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
                }
  
                /* Emit match if have run of MIN_MATCH or longer, else emit literal */
                if (s.match_length >= MIN_MATCH) {
                  //check_match(s, s.strstart, s.strstart - 1, s.match_length);
  
                  /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
                  bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
  
                  s.lookahead -= s.match_length;
                  s.strstart += s.match_length;
                  s.match_length = 0;
                } else {
                  /* No match, output a literal byte */
                  //Tracevv((stderr,"%c", s->window[s->strstart]));
                  /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
                  bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
  
                  s.lookahead--;
                  s.strstart++;
                }
                if (bflush) {
                  /*** FLUSH_BLOCK(s, 0); ***/
                  flush_block_only(s, false);
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                  /***/
                }
              }
              s.insert = 0;
              if (flush === Z_FINISH) {
                /*** FLUSH_BLOCK(s, 1); ***/
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                  return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
              }
              if (s.last_lit) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
              return BS_BLOCK_DONE;
            }
  
            /* ===========================================================================
             * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
             * (It will be regenerated if this run of deflate switches away from Huffman.)
             */
            function deflate_huff(s, flush) {
              var bflush; /* set if current block must be flushed */
  
              for (;;) {
                /* Make sure that we have a literal to write. */
                if (s.lookahead === 0) {
                  fill_window(s);
                  if (s.lookahead === 0) {
                    if (flush === Z_NO_FLUSH) {
                      return BS_NEED_MORE;
                    }
                    break; /* flush the current block */
                  }
                }
  
                /* Output a literal byte */
                s.match_length = 0;
                //Tracevv((stderr,"%c", s->window[s->strstart]));
                /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
                bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
                s.lookahead--;
                s.strstart++;
                if (bflush) {
                  /*** FLUSH_BLOCK(s, 0); ***/
                  flush_block_only(s, false);
                  if (s.strm.avail_out === 0) {
                    return BS_NEED_MORE;
                  }
                  /***/
                }
              }
              s.insert = 0;
              if (flush === Z_FINISH) {
                /*** FLUSH_BLOCK(s, 1); ***/
                flush_block_only(s, true);
                if (s.strm.avail_out === 0) {
                  return BS_FINISH_STARTED;
                }
                /***/
                return BS_FINISH_DONE;
              }
              if (s.last_lit) {
                /*** FLUSH_BLOCK(s, 0); ***/
                flush_block_only(s, false);
                if (s.strm.avail_out === 0) {
                  return BS_NEED_MORE;
                }
                /***/
              }
              return BS_BLOCK_DONE;
            }
  
            /* Values for max_lazy_match, good_match and max_chain_length, depending on
             * the desired pack level (0..9). The values given below have been tuned to
             * exclude worst case performance for pathological files. Better values may be
             * found for specific files.
             */
            function Config(good_length, max_lazy, nice_length, max_chain, func) {
              this.good_length = good_length;
              this.max_lazy = max_lazy;
              this.nice_length = nice_length;
              this.max_chain = max_chain;
              this.func = func;
            }
  
            var configuration_table;
  
            configuration_table = [
              /*      good lazy nice chain */
              new Config(0, 0, 0, 0, deflate_stored) /* 0 store only */,
              new Config(
                4,
                4,
                8,
                4,
                deflate_fast
              ) /* 1 max speed, no lazy matches */,
              new Config(4, 5, 16, 8, deflate_fast) /* 2 */,
              new Config(4, 6, 32, 32, deflate_fast) /* 3 */,
  
              new Config(4, 4, 16, 16, deflate_slow) /* 4 lazy matches */,
              new Config(8, 16, 32, 32, deflate_slow) /* 5 */,
              new Config(8, 16, 128, 128, deflate_slow) /* 6 */,
              new Config(8, 32, 128, 256, deflate_slow) /* 7 */,
              new Config(32, 128, 258, 1024, deflate_slow) /* 8 */,
              new Config(
                32,
                258,
                258,
                4096,
                deflate_slow
              ) /* 9 max compression */,
            ];
  
            /* ===========================================================================
             * Initialize the "longest match" routines for a new zlib stream
             */
            function lm_init(s) {
              s.window_size = 2 * s.w_size;
  
              /*** CLEAR_HASH(s); ***/
              zero(s.head); // Fill with NIL (= 0);
  
              /* Set the default configuration parameters:
               */
              s.max_lazy_match = configuration_table[s.level].max_lazy;
              s.good_match = configuration_table[s.level].good_length;
              s.nice_match = configuration_table[s.level].nice_length;
              s.max_chain_length = configuration_table[s.level].max_chain;
  
              s.strstart = 0;
              s.block_start = 0;
              s.lookahead = 0;
              s.insert = 0;
              s.match_length = s.prev_length = MIN_MATCH - 1;
              s.match_available = 0;
              s.ins_h = 0;
            }
  
            function DeflateState() {
              this.strm = null; /* pointer back to this zlib stream */
              this.status = 0; /* as the name implies */
              this.pending_buf = null; /* output still pending */
              this.pending_buf_size = 0; /* size of pending_buf */
              this.pending_out = 0; /* next pending byte to output to the stream */
              this.pending = 0; /* nb of bytes in the pending buffer */
              this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
              this.gzhead = null; /* gzip header information to write */
              this.gzindex = 0; /* where in extra, name, or comment */
              this.method = Z_DEFLATED; /* can only be DEFLATED */
              this.last_flush =
                -1; /* value of flush param for previous deflate call */
  
              this.w_size = 0; /* LZ77 window size (32K by default) */
              this.w_bits = 0; /* log2(w_size)  (8..16) */
              this.w_mask = 0; /* w_size - 1 */
  
              this.window = null;
              /* Sliding window. Input bytes are read into the second half of the window,
               * and move to the first half later to keep a dictionary of at least wSize
               * bytes. With this organization, matches are limited to a distance of
               * wSize-MAX_MATCH bytes, but this ensures that IO is always
               * performed with a length multiple of the block size.
               */
  
              this.window_size = 0;
              /* Actual size of window: 2*wSize, except when the user input buffer
               * is directly used as sliding window.
               */
  
              this.prev = null;
              /* Link to older string with same hash index. To limit the size of this
               * array to 64K, this link is maintained only for the last 32K strings.
               * An index in this array is thus a window index modulo 32K.
               */
  
              this.head = null; /* Heads of the hash chains or NIL. */
  
              this.ins_h = 0; /* hash index of string to be inserted */
              this.hash_size = 0; /* number of elements in hash table */
              this.hash_bits = 0; /* log2(hash_size) */
              this.hash_mask = 0; /* hash_size-1 */
  
              this.hash_shift = 0;
              /* Number of bits by which ins_h must be shifted at each input
               * step. It must be such that after MIN_MATCH steps, the oldest
               * byte no longer takes part in the hash key, that is:
               *   hash_shift * MIN_MATCH >= hash_bits
               */
  
              this.block_start = 0;
              /* Window position at the beginning of the current output block. Gets
               * negative when the window is moved backwards.
               */
  
              this.match_length = 0; /* length of best match */
              this.prev_match = 0; /* previous match */
              this.match_available = 0; /* set if previous match exists */
              this.strstart = 0; /* start of string to insert */
              this.match_start = 0; /* start of matching string */
              this.lookahead = 0; /* number of valid bytes ahead in window */
  
              this.prev_length = 0;
              /* Length of the best match at previous step. Matches not greater than this
               * are discarded. This is used in the lazy match evaluation.
               */
  
              this.max_chain_length = 0;
              /* To speed up deflation, hash chains are never searched beyond this
               * length.  A higher limit improves compression ratio but degrades the
               * speed.
               */
  
              this.max_lazy_match = 0;
              /* Attempt to find a better match only when the current match is strictly
               * smaller than this value. This mechanism is used only for compression
               * levels >= 4.
               */
              // That's alias to max_lazy_match, don't use directly
              //this.max_insert_length = 0;
              /* Insert new strings in the hash table only if the match length is not
               * greater than this length. This saves time but degrades compression.
               * max_insert_length is used only for compression levels <= 3.
               */
  
              this.level = 0; /* compression level (1..9) */
              this.strategy = 0; /* favor or force Huffman coding*/
  
              this.good_match = 0;
              /* Use a faster search when the previous match is longer than this */
  
              this.nice_match = 0; /* Stop searching when current match exceeds this */
  
              /* used by trees.c: */
  
              /* Didn't use ct_data typedef below to suppress compiler warning */
  
              // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
              // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
              // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
  
              // Use flat array of DOUBLE size, with interleaved fata,
              // because JS does not support effective
              this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
              this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
              this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
              zero(this.dyn_ltree);
              zero(this.dyn_dtree);
              zero(this.bl_tree);
  
              this.l_desc = null; /* desc. for literal tree */
              this.d_desc = null; /* desc. for distance tree */
              this.bl_desc = null; /* desc. for bit length tree */
  
              //ush bl_count[MAX_BITS+1];
              this.bl_count = new utils.Buf16(MAX_BITS + 1);
              /* number of codes at each bit length for an optimal tree */
  
              //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
              this.heap = new utils.Buf16(
                2 * L_CODES + 1
              ); /* heap used to build the Huffman trees */
              zero(this.heap);
  
              this.heap_len = 0; /* number of elements in the heap */
              this.heap_max = 0; /* element of largest frequency */
              /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
               * The same heap array is used to build all trees.
               */
  
              this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
              zero(this.depth);
              /* Depth of each subtree used as tie breaker for trees of equal frequency
               */
  
              this.l_buf = 0; /* buffer index for literals or lengths */
  
              this.lit_bufsize = 0;
              /* Size of match buffer for literals/lengths.  There are 4 reasons for
               * limiting lit_bufsize to 64K:
               *   - frequencies can be kept in 16 bit counters
               *   - if compression is not successful for the first block, all input
               *     data is still in the window so we can still emit a stored block even
               *     when input comes from standard input.  (This can also be done for
               *     all blocks if lit_bufsize is not greater than 32K.)
               *   - if compression is not successful for a file smaller than 64K, we can
               *     even emit a stored file instead of a stored block (saving 5 bytes).
               *     This is applicable only for zip (not gzip or zlib).
               *   - creating new Huffman trees less frequently may not provide fast
               *     adaptation to changes in the input data statistics. (Take for
               *     example a binary file with poorly compressible code followed by
               *     a highly compressible string table.) Smaller buffer sizes give
               *     fast adaptation but have of course the overhead of transmitting
               *     trees more frequently.
               *   - I can't count above 4
               */
  
              this.last_lit = 0; /* running index in l_buf */
  
              this.d_buf = 0;
              /* Buffer index for distances. To simplify the code, d_buf and l_buf have
               * the same number of elements. To use different lengths, an extra flag
               * array would be necessary.
               */
  
              this.opt_len = 0; /* bit length of current block with optimal trees */
              this.static_len = 0; /* bit length of current block with static trees */
              this.matches = 0; /* number of string matches in current block */
              this.insert = 0; /* bytes at end of window left to insert */
  
              this.bi_buf = 0;
              /* Output buffer. bits are inserted starting at the bottom (least
               * significant bits).
               */
              this.bi_valid = 0;
              /* Number of valid bits in bi_buf.  All bits above the last valid bit
               * are always zero.
               */
  
              // Used for window memory init. We safely ignore it for JS. That makes
              // sense only for pointers and memory check tools.
              //this.high_water = 0;
              /* High water mark offset in window for initialized bytes -- bytes above
               * this are set to zero in order to avoid memory check warnings when
               * longest match routines access bytes past the input.  This is then
               * updated to the new high water mark.
               */
            }
  
            function deflateResetKeep(strm) {
              var s;
  
              if (!strm || !strm.state) {
                return err(strm, Z_STREAM_ERROR);
              }
  
              strm.total_in = strm.total_out = 0;
              strm.data_type = Z_UNKNOWN;
  
              s = strm.state;
              s.pending = 0;
              s.pending_out = 0;
  
              if (s.wrap < 0) {
                s.wrap = -s.wrap;
                /* was made negative by deflate(..., Z_FINISH); */
              }
              s.status = s.wrap ? INIT_STATE : BUSY_STATE;
              strm.adler =
                s.wrap === 2
                  ? 0 // crc32(0, Z_NULL, 0)
                  : 1; // adler32(0, Z_NULL, 0)
              s.last_flush = Z_NO_FLUSH;
              trees._tr_init(s);
              return Z_OK;
            }
  
            function deflateReset(strm) {
              var ret = deflateResetKeep(strm);
              if (ret === Z_OK) {
                lm_init(strm.state);
              }
              return ret;
            }
  
            function deflateSetHeader(strm, head) {
              if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
              }
              if (strm.state.wrap !== 2) {
                return Z_STREAM_ERROR;
              }
              strm.state.gzhead = head;
              return Z_OK;
            }
  
            function deflateInit2(
              strm,
              level,
              method,
              windowBits,
              memLevel,
              strategy
            ) {
              if (!strm) {
                // === Z_NULL
                return Z_STREAM_ERROR;
              }
              var wrap = 1;
  
              if (level === Z_DEFAULT_COMPRESSION) {
                level = 6;
              }
  
              if (windowBits < 0) {
                /* suppress zlib wrapper */
                wrap = 0;
                windowBits = -windowBits;
              } else if (windowBits > 15) {
                wrap = 2; /* write gzip wrapper instead */
                windowBits -= 16;
              }
  
              if (
                memLevel < 1 ||
                memLevel > MAX_MEM_LEVEL ||
                method !== Z_DEFLATED ||
                windowBits < 8 ||
                windowBits > 15 ||
                level < 0 ||
                level > 9 ||
                strategy < 0 ||
                strategy > Z_FIXED
              ) {
                return err(strm, Z_STREAM_ERROR);
              }
  
              if (windowBits === 8) {
                windowBits = 9;
              }
              /* until 256-byte window bug fixed */
  
              var s = new DeflateState();
  
              strm.state = s;
              s.strm = strm;
  
              s.wrap = wrap;
              s.gzhead = null;
              s.w_bits = windowBits;
              s.w_size = 1 << s.w_bits;
              s.w_mask = s.w_size - 1;
  
              s.hash_bits = memLevel + 7;
              s.hash_size = 1 << s.hash_bits;
              s.hash_mask = s.hash_size - 1;
              s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
  
              s.window = new utils.Buf8(s.w_size * 2);
              s.head = new utils.Buf16(s.hash_size);
              s.prev = new utils.Buf16(s.w_size);
  
              // Don't need mem init magic for JS.
              //s.high_water = 0;  /* nothing written to s->window yet */
  
              s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
  
              s.pending_buf_size = s.lit_bufsize * 4;
  
              //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
              //s->pending_buf = (uchf *) overlay;
              s.pending_buf = new utils.Buf8(s.pending_buf_size);
  
              // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
              //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
              s.d_buf = 1 * s.lit_bufsize;
  
              //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
              s.l_buf = (1 + 2) * s.lit_bufsize;
  
              s.level = level;
              s.strategy = strategy;
              s.method = method;
  
              return deflateReset(strm);
            }
  
            function deflateInit(strm, level) {
              return deflateInit2(
                strm,
                level,
                Z_DEFLATED,
                MAX_WBITS,
                DEF_MEM_LEVEL,
                Z_DEFAULT_STRATEGY
              );
            }
  
            function deflate(strm, flush) {
              var old_flush, s;
              var beg, val; // for gzip header write only
  
              if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
                return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
              }
  
              s = strm.state;
  
              if (
                !strm.output ||
                (!strm.input && strm.avail_in !== 0) ||
                (s.status === FINISH_STATE && flush !== Z_FINISH)
              ) {
                return err(
                  strm,
                  strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR
                );
              }
  
              s.strm = strm; /* just in case */
              old_flush = s.last_flush;
              s.last_flush = flush;
  
              /* Write the header */
              if (s.status === INIT_STATE) {
                if (s.wrap === 2) {
                  // GZIP header
                  strm.adler = 0; //crc32(0L, Z_NULL, 0);
                  put_byte(s, 31);
                  put_byte(s, 139);
                  put_byte(s, 8);
                  if (!s.gzhead) {
                    // s->gzhead == Z_NULL
                    put_byte(s, 0);
                    put_byte(s, 0);
                    put_byte(s, 0);
                    put_byte(s, 0);
                    put_byte(s, 0);
                    put_byte(
                      s,
                      s.level === 9
                        ? 2
                        : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                        ? 4
                        : 0
                    );
                    put_byte(s, OS_CODE);
                    s.status = BUSY_STATE;
                  } else {
                    put_byte(
                      s,
                      (s.gzhead.text ? 1 : 0) +
                        (s.gzhead.hcrc ? 2 : 0) +
                        (!s.gzhead.extra ? 0 : 4) +
                        (!s.gzhead.name ? 0 : 8) +
                        (!s.gzhead.comment ? 0 : 16)
                    );
                    put_byte(s, s.gzhead.time & 0xff);
                    put_byte(s, (s.gzhead.time >> 8) & 0xff);
                    put_byte(s, (s.gzhead.time >> 16) & 0xff);
                    put_byte(s, (s.gzhead.time >> 24) & 0xff);
                    put_byte(
                      s,
                      s.level === 9
                        ? 2
                        : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2
                        ? 4
                        : 0
                    );
                    put_byte(s, s.gzhead.os & 0xff);
                    if (s.gzhead.extra && s.gzhead.extra.length) {
                      put_byte(s, s.gzhead.extra.length & 0xff);
                      put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
                    }
                    if (s.gzhead.hcrc) {
                      strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                    }
                    s.gzindex = 0;
                    s.status = EXTRA_STATE;
                  }
                } // DEFLATE header
                else {
                  var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
                  var level_flags = -1;
  
                  if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                    level_flags = 0;
                  } else if (s.level < 6) {
                    level_flags = 1;
                  } else if (s.level === 6) {
                    level_flags = 2;
                  } else {
                    level_flags = 3;
                  }
                  header |= level_flags << 6;
                  if (s.strstart !== 0) {
                    header |= PRESET_DICT;
                  }
                  header += 31 - (header % 31);
  
                  s.status = BUSY_STATE;
                  putShortMSB(s, header);
  
                  /* Save the adler32 of the preset dictionary: */
                  if (s.strstart !== 0) {
                    putShortMSB(s, strm.adler >>> 16);
                    putShortMSB(s, strm.adler & 0xffff);
                  }
                  strm.adler = 1; // adler32(0L, Z_NULL, 0);
                }
              }
  
              //#ifdef GZIP
              if (s.status === EXTRA_STATE) {
                if (s.gzhead.extra /* != Z_NULL*/) {
                  beg = s.pending; /* start of bytes to update crc */
  
                  while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
                    if (s.pending === s.pending_buf_size) {
                      if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32(
                          strm.adler,
                          s.pending_buf,
                          s.pending - beg,
                          beg
                        );
                      }
                      flush_pending(strm);
                      beg = s.pending;
                      if (s.pending === s.pending_buf_size) {
                        break;
                      }
                    }
                    put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                    s.gzindex++;
                  }
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(
                      strm.adler,
                      s.pending_buf,
                      s.pending - beg,
                      beg
                    );
                  }
                  if (s.gzindex === s.gzhead.extra.length) {
                    s.gzindex = 0;
                    s.status = NAME_STATE;
                  }
                } else {
                  s.status = NAME_STATE;
                }
              }
              if (s.status === NAME_STATE) {
                if (s.gzhead.name /* != Z_NULL*/) {
                  beg = s.pending; /* start of bytes to update crc */
                  //int val;
  
                  do {
                    if (s.pending === s.pending_buf_size) {
                      if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32(
                          strm.adler,
                          s.pending_buf,
                          s.pending - beg,
                          beg
                        );
                      }
                      flush_pending(strm);
                      beg = s.pending;
                      if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                      }
                    }
                    // JS specific: little magic to add zero terminator to end of string
                    if (s.gzindex < s.gzhead.name.length) {
                      val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                    } else {
                      val = 0;
                    }
                    put_byte(s, val);
                  } while (val !== 0);
  
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(
                      strm.adler,
                      s.pending_buf,
                      s.pending - beg,
                      beg
                    );
                  }
                  if (val === 0) {
                    s.gzindex = 0;
                    s.status = COMMENT_STATE;
                  }
                } else {
                  s.status = COMMENT_STATE;
                }
              }
              if (s.status === COMMENT_STATE) {
                if (s.gzhead.comment /* != Z_NULL*/) {
                  beg = s.pending; /* start of bytes to update crc */
                  //int val;
  
                  do {
                    if (s.pending === s.pending_buf_size) {
                      if (s.gzhead.hcrc && s.pending > beg) {
                        strm.adler = crc32(
                          strm.adler,
                          s.pending_buf,
                          s.pending - beg,
                          beg
                        );
                      }
                      flush_pending(strm);
                      beg = s.pending;
                      if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                      }
                    }
                    // JS specific: little magic to add zero terminator to end of string
                    if (s.gzindex < s.gzhead.comment.length) {
                      val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                    } else {
                      val = 0;
                    }
                    put_byte(s, val);
                  } while (val !== 0);
  
                  if (s.gzhead.hcrc && s.pending > beg) {
                    strm.adler = crc32(
                      strm.adler,
                      s.pending_buf,
                      s.pending - beg,
                      beg
                    );
                  }
                  if (val === 0) {
                    s.status = HCRC_STATE;
                  }
                } else {
                  s.status = HCRC_STATE;
                }
              }
              if (s.status === HCRC_STATE) {
                if (s.gzhead.hcrc) {
                  if (s.pending + 2 > s.pending_buf_size) {
                    flush_pending(strm);
                  }
                  if (s.pending + 2 <= s.pending_buf_size) {
                    put_byte(s, strm.adler & 0xff);
                    put_byte(s, (strm.adler >> 8) & 0xff);
                    strm.adler = 0; //crc32(0L, Z_NULL, 0);
                    s.status = BUSY_STATE;
                  }
                } else {
                  s.status = BUSY_STATE;
                }
              }
              //#endif
  
              /* Flush as much pending output as possible */
              if (s.pending !== 0) {
                flush_pending(strm);
                if (strm.avail_out === 0) {
                  /* Since avail_out is 0, deflate will be called again with
                   * more output space, but possibly with both pending and
                   * avail_in equal to zero. There won't be anything to do,
                   * but this is not an error situation so make sure we
                   * return OK instead of BUF_ERROR at next call of deflate:
                   */
                  s.last_flush = -1;
                  return Z_OK;
                }
  
                /* Make sure there is something to do and avoid duplicate consecutive
                 * flushes. For repeated and useless calls with Z_FINISH, we keep
                 * returning Z_STREAM_END instead of Z_BUF_ERROR.
                 */
              } else if (
                strm.avail_in === 0 &&
                rank(flush) <= rank(old_flush) &&
                flush !== Z_FINISH
              ) {
                return err(strm, Z_BUF_ERROR);
              }
  
              /* User must not provide more input after the first FINISH: */
              if (s.status === FINISH_STATE && strm.avail_in !== 0) {
                return err(strm, Z_BUF_ERROR);
              }
  
              /* Start a new block or continue the current one.
               */
              if (
                strm.avail_in !== 0 ||
                s.lookahead !== 0 ||
                (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)
              ) {
                var bstate =
                  s.strategy === Z_HUFFMAN_ONLY
                    ? deflate_huff(s, flush)
                    : s.strategy === Z_RLE
                    ? deflate_rle(s, flush)
                    : configuration_table[s.level].func(s, flush);
  
                if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
                  s.status = FINISH_STATE;
                }
                if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
                  if (strm.avail_out === 0) {
                    s.last_flush = -1;
                    /* avoid BUF_ERROR next call, see above */
                  }
                  return Z_OK;
                  /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
                   * of deflate should use the same flush parameter to make sure
                   * that the flush is complete. So we don't have to output an
                   * empty block here, this will be done at next call. This also
                   * ensures that for a very small output buffer, we emit at most
                   * one empty block.
                   */
                }
                if (bstate === BS_BLOCK_DONE) {
                  if (flush === Z_PARTIAL_FLUSH) {
                    trees._tr_align(s);
                  } else if (flush !== Z_BLOCK) {
                    /* FULL_FLUSH or SYNC_FLUSH */
  
                    trees._tr_stored_block(s, 0, 0, false);
                    /* For a full flush, this empty block will be recognized
                     * as a special marker by inflate_sync().
                     */
                    if (flush === Z_FULL_FLUSH) {
                      /*** CLEAR_HASH(s); ***/ /* forget history */
                      zero(s.head); // Fill with NIL (= 0);
  
                      if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                      }
                    }
                  }
                  flush_pending(strm);
                  if (strm.avail_out === 0) {
                    s.last_flush =
                      -1; /* avoid BUF_ERROR at next call, see above */
                    return Z_OK;
                  }
                }
              }
              //Assert(strm->avail_out > 0, "bug2");
              //if (strm.avail_out <= 0) { throw new Error("bug2");}
  
              if (flush !== Z_FINISH) {
                return Z_OK;
              }
              if (s.wrap <= 0) {
                return Z_STREAM_END;
              }
  
              /* Write the trailer */
              if (s.wrap === 2) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, (strm.adler >> 8) & 0xff);
                put_byte(s, (strm.adler >> 16) & 0xff);
                put_byte(s, (strm.adler >> 24) & 0xff);
                put_byte(s, strm.total_in & 0xff);
                put_byte(s, (strm.total_in >> 8) & 0xff);
                put_byte(s, (strm.total_in >> 16) & 0xff);
                put_byte(s, (strm.total_in >> 24) & 0xff);
              } else {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }
  
              flush_pending(strm);
              /* If avail_out is zero, the application will call deflate again
               * to flush the rest.
               */
              if (s.wrap > 0) {
                s.wrap = -s.wrap;
              }
              /* write the trailer only once! */
              return s.pending !== 0 ? Z_OK : Z_STREAM_END;
            }
  
            function deflateEnd(strm) {
              var status;
  
              if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
                return Z_STREAM_ERROR;
              }
  
              status = strm.state.status;
              if (
                status !== INIT_STATE &&
                status !== EXTRA_STATE &&
                status !== NAME_STATE &&
                status !== COMMENT_STATE &&
                status !== HCRC_STATE &&
                status !== BUSY_STATE &&
                status !== FINISH_STATE
              ) {
                return err(strm, Z_STREAM_ERROR);
              }
  
              strm.state = null;
  
              return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
            }
  
            /* =========================================================================
             * Initializes the compression dictionary from the given byte
             * sequence without producing any compressed output.
             */
            function deflateSetDictionary(strm, dictionary) {
              var dictLength = dictionary.length;
  
              var s;
              var str, n;
              var wrap;
              var avail;
              var next;
              var input;
              var tmpDict;
  
              if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
                return Z_STREAM_ERROR;
              }
  
              s = strm.state;
              wrap = s.wrap;
  
              if (
                wrap === 2 ||
                (wrap === 1 && s.status !== INIT_STATE) ||
                s.lookahead
              ) {
                return Z_STREAM_ERROR;
              }
  
              /* when using zlib wrappers, compute Adler-32 for provided dictionary */
              if (wrap === 1) {
                /* adler32(strm->adler, dictionary, dictLength); */
                strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
              }
  
              s.wrap = 0; /* avoid computing Adler-32 in read_buf */
  
              /* if dictionary would fill window, just replace the history */
              if (dictLength >= s.w_size) {
                if (wrap === 0) {
                  /* already empty otherwise */
                  /*** CLEAR_HASH(s); ***/
                  zero(s.head); // Fill with NIL (= 0);
                  s.strstart = 0;
                  s.block_start = 0;
                  s.insert = 0;
                }
                /* use the tail */
                // dictionary = dictionary.slice(dictLength - s.w_size);
                tmpDict = new utils.Buf8(s.w_size);
                utils.arraySet(
                  tmpDict,
                  dictionary,
                  dictLength - s.w_size,
                  s.w_size,
                  0
                );
                dictionary = tmpDict;
                dictLength = s.w_size;
              }
              /* insert dictionary into window and hash */
              avail = strm.avail_in;
              next = strm.next_in;
              input = strm.input;
              strm.avail_in = dictLength;
              strm.next_in = 0;
              strm.input = dictionary;
              fill_window(s);
              while (s.lookahead >= MIN_MATCH) {
                str = s.strstart;
                n = s.lookahead - (MIN_MATCH - 1);
                do {
                  /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
                  s.ins_h =
                    ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) &
                    s.hash_mask;
  
                  s.prev[str & s.w_mask] = s.head[s.ins_h];
  
                  s.head[s.ins_h] = str;
                  str++;
                } while (--n);
                s.strstart = str;
                s.lookahead = MIN_MATCH - 1;
                fill_window(s);
              }
              s.strstart += s.lookahead;
              s.block_start = s.strstart;
              s.insert = s.lookahead;
              s.lookahead = 0;
              s.match_length = s.prev_length = MIN_MATCH - 1;
              s.match_available = 0;
              strm.next_in = next;
              strm.input = input;
              strm.avail_in = avail;
              s.wrap = wrap;
              return Z_OK;
            }
  
            exports.deflateInit = deflateInit;
            exports.deflateInit2 = deflateInit2;
            exports.deflateReset = deflateReset;
            exports.deflateResetKeep = deflateResetKeep;
            exports.deflateSetHeader = deflateSetHeader;
            exports.deflate = deflate;
            exports.deflateEnd = deflateEnd;
            exports.deflateSetDictionary = deflateSetDictionary;
            exports.deflateInfo = "pako deflate (from Nodeca project)";
  
            /* Not implemented
  exports.deflateBound = deflateBound;
  exports.deflateCopy = deflateCopy;
  exports.deflateParams = deflateParams;
  exports.deflatePending = deflatePending;
  exports.deflatePrime = deflatePrime;
  exports.deflateTune = deflateTune;
  */
          },
          {
            "../utils/common": 43,
            "./adler32": 44,
            "./crc32": 46,
            "./messages": 51,
            "./trees": 52,
          },
        ],
        48: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            // See state defs from inflate.js
            var BAD = 30; /* got a data error -- remain here until reset */
            var TYPE = 12; /* i: waiting for type bits, including last-flag bit */
  
            /*
     Decode literal, length, and distance codes and write out the resulting
     literal and match bytes until either not enough input or output is
     available, an end-of-block is encountered, or a data error is encountered.
     When large enough input and output buffers are supplied to inflate(), for
     example, a 16K input buffer and a 64K output buffer, more than 95% of the
     inflate execution time is spent in this routine.
  
     Entry assumptions:
  
          state.mode === LEN
          strm.avail_in >= 6
          strm.avail_out >= 258
          start >= strm.avail_out
          state.bits < 8
  
     On return, state.mode is one of:
  
          LEN -- ran out of enough output space or enough available input
          TYPE -- reached end of block code, inflate() to interpret next block
          BAD -- error in block data
  
     Notes:
  
      - The maximum input bits used by a length/distance pair is 15 bits for the
        length code, 5 bits for the length extra, 15 bits for the distance code,
        and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
        Therefore if strm.avail_in >= 6, then there is enough input to avoid
        checking for available input while decoding.
  
      - The maximum bytes that a single length/distance pair can output is 258
        bytes, which is the maximum length that can be coded.  inflate_fast()
        requires strm.avail_out >= 258 for each loop to avoid checking for
        output space.
   */
            module.exports = function inflate_fast(strm, start) {
              var state;
              var _in; /* local strm.input */
              var last; /* have enough input while in < last */
              var _out; /* local strm.output */
              var beg; /* inflate()'s initial strm.output */
              var end; /* while out < end, enough space available */
              //#ifdef INFLATE_STRICT
              var dmax; /* maximum distance from zlib header */
              //#endif
              var wsize; /* window size or zero if not using window */
              var whave; /* valid bytes in the window */
              var wnext; /* window write index */
              // Use `s_window` instead `window`, avoid conflict with instrumentation tools
              var s_window; /* allocated sliding window, if wsize != 0 */
              var hold; /* local strm.hold */
              var bits; /* local strm.bits */
              var lcode; /* local strm.lencode */
              var dcode; /* local strm.distcode */
              var lmask; /* mask for first level of length codes */
              var dmask; /* mask for first level of distance codes */
              var here; /* retrieved table entry */
              var op; /* code bits, operation, extra bits, or */
              /*  window position, window bytes to copy */
              var len; /* match length, unused bytes */
              var dist; /* match distance */
              var from; /* where to copy match from */
              var from_source;
  
              var input, output; // JS specific, because we have no pointers
  
              /* copy state to local variables */
              state = strm.state;
              //here = state.here;
              _in = strm.next_in;
              input = strm.input;
              last = _in + (strm.avail_in - 5);
              _out = strm.next_out;
              output = strm.output;
              beg = _out - (start - strm.avail_out);
              end = _out + (strm.avail_out - 257);
              //#ifdef INFLATE_STRICT
              dmax = state.dmax;
              //#endif
              wsize = state.wsize;
              whave = state.whave;
              wnext = state.wnext;
              s_window = state.window;
              hold = state.hold;
              bits = state.bits;
              lcode = state.lencode;
              dcode = state.distcode;
              lmask = (1 << state.lenbits) - 1;
              dmask = (1 << state.distbits) - 1;
  
              /* decode literals and length/distances until end-of-block or not enough
       input data or output space */
  
              top: do {
                if (bits < 15) {
                  hold += input[_in++] << bits;
                  bits += 8;
                  hold += input[_in++] << bits;
                  bits += 8;
                }
  
                here = lcode[hold & lmask];
  
                dolen: for (;;) {
                  // Goto emulation
                  op = here >>> 24 /*here.bits*/;
                  hold >>>= op;
                  bits -= op;
                  op = (here >>> 16) & 0xff /*here.op*/;
                  if (op === 0) {
                    /* literal */
                    //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                    //        "inflate:         literal '%c'\n" :
                    //        "inflate:         literal 0x%02x\n", here.val));
                    output[_out++] = here & 0xffff /*here.val*/;
                  } else if (op & 16) {
                    /* length base */
                    len = here & 0xffff /*here.val*/;
                    op &= 15; /* number of extra bits */
                    if (op) {
                      if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                      }
                      len += hold & ((1 << op) - 1);
                      hold >>>= op;
                      bits -= op;
                    }
                    //Tracevv((stderr, "inflate:         length %u\n", len));
                    if (bits < 15) {
                      hold += input[_in++] << bits;
                      bits += 8;
                      hold += input[_in++] << bits;
                      bits += 8;
                    }
                    here = dcode[hold & dmask];
  
                    dodist: for (;;) {
                      // goto emulation
                      op = here >>> 24 /*here.bits*/;
                      hold >>>= op;
                      bits -= op;
                      op = (here >>> 16) & 0xff /*here.op*/;
  
                      if (op & 16) {
                        /* distance base */
                        dist = here & 0xffff /*here.val*/;
                        op &= 15; /* number of extra bits */
                        if (bits < op) {
                          hold += input[_in++] << bits;
                          bits += 8;
                          if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                          }
                        }
                        dist += hold & ((1 << op) - 1);
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                          strm.msg = "invalid distance too far back";
                          state.mode = BAD;
                          break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */
                        if (dist > op) {
                          /* see if copy from window */
                          op = dist - op; /* distance back in window */
                          if (op > whave) {
                            if (state.sane) {
                              strm.msg = "invalid distance too far back";
                              state.mode = BAD;
                              break top;
                            }
  
                            // (!) This block is disabled in zlib defaults,
                            // don't enable it for binary compatibility
                            //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                            //                if (len <= op - whave) {
                            //                  do {
                            //                    output[_out++] = 0;
                            //                  } while (--len);
                            //                  continue top;
                            //                }
                            //                len -= op - whave;
                            //                do {
                            //                  output[_out++] = 0;
                            //                } while (--op > whave);
                            //                if (op === 0) {
                            //                  from = _out - dist;
                            //                  do {
                            //                    output[_out++] = output[from++];
                            //                  } while (--len);
                            //                  continue top;
                            //                }
                            //#endif
                          }
                          from = 0; // window index
                          from_source = s_window;
                          if (wnext === 0) {
                            /* very common case */
                            from += wsize - op;
                            if (op < len) {
                              /* some from window */
                              len -= op;
                              do {
                                output[_out++] = s_window[from++];
                              } while (--op);
                              from = _out - dist; /* rest from output */
                              from_source = output;
                            }
                          } else if (wnext < op) {
                            /* wrap around window */
                            from += wsize + wnext - op;
                            op -= wnext;
                            if (op < len) {
                              /* some from end of window */
                              len -= op;
                              do {
                                output[_out++] = s_window[from++];
                              } while (--op);
                              from = 0;
                              if (wnext < len) {
                                /* some from start of window */
                                op = wnext;
                                len -= op;
                                do {
                                  output[_out++] = s_window[from++];
                                } while (--op);
                                from = _out - dist; /* rest from output */
                                from_source = output;
                              }
                            }
                          } else {
                            /* contiguous in window */
                            from += wnext - op;
                            if (op < len) {
                              /* some from window */
                              len -= op;
                              do {
                                output[_out++] = s_window[from++];
                              } while (--op);
                              from = _out - dist; /* rest from output */
                              from_source = output;
                            }
                          }
                          while (len > 2) {
                            output[_out++] = from_source[from++];
                            output[_out++] = from_source[from++];
                            output[_out++] = from_source[from++];
                            len -= 3;
                          }
                          if (len) {
                            output[_out++] = from_source[from++];
                            if (len > 1) {
                              output[_out++] = from_source[from++];
                            }
                          }
                        } else {
                          from = _out - dist; /* copy direct from output */
                          do {
                            /* minimum length is three */
                            output[_out++] = output[from++];
                            output[_out++] = output[from++];
                            output[_out++] = output[from++];
                            len -= 3;
                          } while (len > 2);
                          if (len) {
                            output[_out++] = output[from++];
                            if (len > 1) {
                              output[_out++] = output[from++];
                            }
                          }
                        }
                      } else if ((op & 64) === 0) {
                        /* 2nd level distance code */
                        here =
                          dcode[
                            (here & 0xffff) /*here.val*/ +
                              (hold & ((1 << op) - 1))
                          ];
                        continue dodist;
                      } else {
                        strm.msg = "invalid distance code";
                        state.mode = BAD;
                        break top;
                      }
  
                      break; // need to emulate goto via "continue"
                    }
                  } else if ((op & 64) === 0) {
                    /* 2nd level length code */
                    here =
                      lcode[
                        (here & 0xffff) /*here.val*/ + (hold & ((1 << op) - 1))
                      ];
                    continue dolen;
                  } else if (op & 32) {
                    /* end-of-block */
                    //Tracevv((stderr, "inflate:         end of block\n"));
                    state.mode = TYPE;
                    break top;
                  } else {
                    strm.msg = "invalid literal/length code";
                    state.mode = BAD;
                    break top;
                  }
  
                  break; // need to emulate goto via "continue"
                }
              } while (_in < last && _out < end);
  
              /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
              len = bits >> 3;
              _in -= len;
              bits -= len << 3;
              hold &= (1 << bits) - 1;
  
              /* update state and return */
              strm.next_in = _in;
              strm.next_out = _out;
              strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
              strm.avail_out =
                _out < end ? 257 + (end - _out) : 257 - (_out - end);
              state.hold = hold;
              state.bits = bits;
              return;
            };
          },
          {},
        ],
        49: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            var utils = require("../utils/common");
            var adler32 = require("./adler32");
            var crc32 = require("./crc32");
            var inflate_fast = require("./inffast");
            var inflate_table = require("./inftrees");
  
            var CODES = 0;
            var LENS = 1;
            var DISTS = 2;
  
            /* Public constants ==========================================================*/
            /* ===========================================================================*/
  
            /* Allowed flush values; see deflate() and inflate() below for details */
            //var Z_NO_FLUSH      = 0;
            //var Z_PARTIAL_FLUSH = 1;
            //var Z_SYNC_FLUSH    = 2;
            //var Z_FULL_FLUSH    = 3;
            var Z_FINISH = 4;
            var Z_BLOCK = 5;
            var Z_TREES = 6;
  
            /* Return codes for the compression/decompression functions. Negative values
             * are errors, positive values are used for special but normal events.
             */
            var Z_OK = 0;
            var Z_STREAM_END = 1;
            var Z_NEED_DICT = 2;
            //var Z_ERRNO         = -1;
            var Z_STREAM_ERROR = -2;
            var Z_DATA_ERROR = -3;
            var Z_MEM_ERROR = -4;
            var Z_BUF_ERROR = -5;
            //var Z_VERSION_ERROR = -6;
  
            /* The deflate compression method */
            var Z_DEFLATED = 8;
  
            /* STATES ====================================================================*/
            /* ===========================================================================*/
  
            var HEAD = 1; /* i: waiting for magic header */
            var FLAGS = 2; /* i: waiting for method and flags (gzip) */
            var TIME = 3; /* i: waiting for modification time (gzip) */
            var OS = 4; /* i: waiting for extra flags and operating system (gzip) */
            var EXLEN = 5; /* i: waiting for extra length (gzip) */
            var EXTRA = 6; /* i: waiting for extra bytes (gzip) */
            var NAME = 7; /* i: waiting for end of file name (gzip) */
            var COMMENT = 8; /* i: waiting for end of comment (gzip) */
            var HCRC = 9; /* i: waiting for header crc (gzip) */
            var DICTID = 10; /* i: waiting for dictionary check value */
            var DICT = 11; /* waiting for inflateSetDictionary() call */
            var TYPE = 12; /* i: waiting for type bits, including last-flag bit */
            var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */
            var STORED = 14; /* i: waiting for stored size (length and complement) */
            var COPY_ = 15; /* i/o: same as COPY below, but only first time in */
            var COPY = 16; /* i/o: waiting for input or output to copy stored block */
            var TABLE = 17; /* i: waiting for dynamic block table lengths */
            var LENLENS = 18; /* i: waiting for code length code lengths */
            var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */
            var LEN_ = 20; /* i: same as LEN below, but only first time in */
            var LEN = 21; /* i: waiting for length/lit/eob code */
            var LENEXT = 22; /* i: waiting for length extra bits */
            var DIST = 23; /* i: waiting for distance code */
            var DISTEXT = 24; /* i: waiting for distance extra bits */
            var MATCH = 25; /* o: waiting for output space to copy string */
            var LIT = 26; /* o: waiting for output space to write literal */
            var CHECK = 27; /* i: waiting for 32-bit check value */
            var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */
            var DONE = 29; /* finished check, done -- remain here until reset */
            var BAD = 30; /* got a data error -- remain here until reset */
            var MEM = 31; /* got an inflate() memory error -- remain here until reset */
            var SYNC = 32; /* looking for synchronization bytes to restart inflate() */
  
            /* ===========================================================================*/
  
            var ENOUGH_LENS = 852;
            var ENOUGH_DISTS = 592;
            //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
  
            var MAX_WBITS = 15;
            /* 32K LZ77 window */
            var DEF_WBITS = MAX_WBITS;
  
            function zswap32(q) {
              return (
                ((q >>> 24) & 0xff) +
                ((q >>> 8) & 0xff00) +
                ((q & 0xff00) << 8) +
                ((q & 0xff) << 24)
              );
            }
  
            function InflateState() {
              this.mode = 0; /* current inflate mode */
              this.last = false; /* true if processing last block */
              this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
              this.havedict = false; /* true if dictionary provided */
              this.flags = 0; /* gzip header method and flags (0 if zlib) */
              this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
              this.check = 0; /* protected copy of check value */
              this.total = 0; /* protected copy of output count */
              // TODO: may be {}
              this.head = null; /* where to save gzip header information */
  
              /* sliding window */
              this.wbits = 0; /* log base 2 of requested window size */
              this.wsize = 0; /* window size or zero if not using window */
              this.whave = 0; /* valid bytes in the window */
              this.wnext = 0; /* window write index */
              this.window = null; /* allocated sliding window, if needed */
  
              /* bit accumulator */
              this.hold = 0; /* input bit accumulator */
              this.bits = 0; /* number of bits in "in" */
  
              /* for string and stored block copying */
              this.length = 0; /* literal or length of data to copy */
              this.offset = 0; /* distance back to copy string from */
  
              /* for table and code decoding */
              this.extra = 0; /* extra bits needed */
  
              /* fixed and dynamic code tables */
              this.lencode = null; /* starting table for length/literal codes */
              this.distcode = null; /* starting table for distance codes */
              this.lenbits = 0; /* index bits for lencode */
              this.distbits = 0; /* index bits for distcode */
  
              /* dynamic table building */
              this.ncode = 0; /* number of code length code lengths */
              this.nlen = 0; /* number of length code lengths */
              this.ndist = 0; /* number of distance code lengths */
              this.have = 0; /* number of code lengths in lens[] */
              this.next = null; /* next available space in codes[] */
  
              this.lens = new utils.Buf16(
                320
              ); /* temporary storage for code lengths */
              this.work = new utils.Buf16(
                288
              ); /* work area for code table building */
  
              /*
     because we don't have pointers in js, we use lencode and distcode directly
     as buffers so we don't need codes
    */
              //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
              this.lendyn =
                null; /* dynamic table for length/literal codes (JS specific) */
              this.distdyn =
                null; /* dynamic table for distance codes (JS specific) */
              this.sane = 0; /* if false, allow invalid distance too far */
              this.back = 0; /* bits back of last unprocessed length/lit */
              this.was = 0; /* initial length of match */
            }
  
            function inflateResetKeep(strm) {
              var state;
  
              if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
              }
              state = strm.state;
              strm.total_in = strm.total_out = state.total = 0;
              strm.msg = ""; /*Z_NULL*/
              if (state.wrap) {
                /* to support ill-conceived Java test suite */
                strm.adler = state.wrap & 1;
              }
              state.mode = HEAD;
              state.last = 0;
              state.havedict = 0;
              state.dmax = 32768;
              state.head = null /*Z_NULL*/;
              state.hold = 0;
              state.bits = 0;
              //state.lencode = state.distcode = state.next = state.codes;
              state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
              state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
  
              state.sane = 1;
              state.back = -1;
              //Tracev((stderr, "inflate: reset\n"));
              return Z_OK;
            }
  
            function inflateReset(strm) {
              var state;
  
              if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
              }
              state = strm.state;
              state.wsize = 0;
              state.whave = 0;
              state.wnext = 0;
              return inflateResetKeep(strm);
            }
  
            function inflateReset2(strm, windowBits) {
              var wrap;
              var state;
  
              /* get the state */
              if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
              }
              state = strm.state;
  
              /* extract wrap request from windowBits parameter */
              if (windowBits < 0) {
                wrap = 0;
                windowBits = -windowBits;
              } else {
                wrap = (windowBits >> 4) + 1;
                if (windowBits < 48) {
                  windowBits &= 15;
                }
              }
  
              /* set number of window bits, free window if different */
              if (windowBits && (windowBits < 8 || windowBits > 15)) {
                return Z_STREAM_ERROR;
              }
              if (state.window !== null && state.wbits !== windowBits) {
                state.window = null;
              }
  
              /* update state and reset the rest of it */
              state.wrap = wrap;
              state.wbits = windowBits;
              return inflateReset(strm);
            }
  
            function inflateInit2(strm, windowBits) {
              var ret;
              var state;
  
              if (!strm) {
                return Z_STREAM_ERROR;
              }
              //strm.msg = Z_NULL;                 /* in case we return an error */
  
              state = new InflateState();
  
              //if (state === Z_NULL) return Z_MEM_ERROR;
              //Tracev((stderr, "inflate: allocated\n"));
              strm.state = state;
              state.window = null /*Z_NULL*/;
              ret = inflateReset2(strm, windowBits);
              if (ret !== Z_OK) {
                strm.state = null /*Z_NULL*/;
              }
              return ret;
            }
  
            function inflateInit(strm) {
              return inflateInit2(strm, DEF_WBITS);
            }
  
            /*
   Return state with length and distance decoding tables and index sizes set to
   fixed code decoding.  Normally this returns fixed tables from inffixed.h.
   If BUILDFIXED is defined, then instead this routine builds the tables the
   first time it's called, and returns those tables the first time and
   thereafter.  This reduces the size of the code by about 2K bytes, in
   exchange for a little execution time.  However, BUILDFIXED should not be
   used for threaded applications, since the rewriting of the tables and virgin
   may not be thread-safe.
   */
            var virgin = true;
  
            var lenfix, distfix; // We have no pointers in JS, so keep tables separate
  
            function fixedtables(state) {
              /* build fixed huffman tables if first call (may not be thread safe) */
              if (virgin) {
                var sym;
  
                lenfix = new utils.Buf32(512);
                distfix = new utils.Buf32(32);
  
                /* literal/length table */
                sym = 0;
                while (sym < 144) {
                  state.lens[sym++] = 8;
                }
                while (sym < 256) {
                  state.lens[sym++] = 9;
                }
                while (sym < 280) {
                  state.lens[sym++] = 7;
                }
                while (sym < 288) {
                  state.lens[sym++] = 8;
                }
  
                inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
                  bits: 9,
                });
  
                /* distance table */
                sym = 0;
                while (sym < 32) {
                  state.lens[sym++] = 5;
                }
  
                inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
                  bits: 5,
                });
  
                /* do this just once */
                virgin = false;
              }
  
              state.lencode = lenfix;
              state.lenbits = 9;
              state.distcode = distfix;
              state.distbits = 5;
            }
  
            /*
   Update the window with the last wsize (normally 32K) bytes written before
   returning.  If window does not exist yet, create it.  This is only called
   when a window is already in use, or when output has been written during this
   inflate call, but the end of the deflate stream has not been reached yet.
   It is also called to create a window for dictionary data when a dictionary
   is loaded.
  
   Providing output buffers larger than 32K to inflate() should provide a speed
   advantage, since only the last 32K of output is copied to the sliding window
   upon return from inflate(), and since all distances after the first 32K of
   output will fall in the output data, making match copies simpler and faster.
   The advantage may be dependent on the size of the processor's data caches.
   */
            function updatewindow(strm, src, end, copy) {
              var dist;
              var state = strm.state;
  
              /* if it hasn't been done already, allocate space for the window */
              if (state.window === null) {
                state.wsize = 1 << state.wbits;
                state.wnext = 0;
                state.whave = 0;
  
                state.window = new utils.Buf8(state.wsize);
              }
  
              /* copy state->wsize or less output bytes into the circular window */
              if (copy >= state.wsize) {
                utils.arraySet(
                  state.window,
                  src,
                  end - state.wsize,
                  state.wsize,
                  0
                );
                state.wnext = 0;
                state.whave = state.wsize;
              } else {
                dist = state.wsize - state.wnext;
                if (dist > copy) {
                  dist = copy;
                }
                //zmemcpy(state->window + state->wnext, end - copy, dist);
                utils.arraySet(state.window, src, end - copy, dist, state.wnext);
                copy -= dist;
                if (copy) {
                  //zmemcpy(state->window, end - copy, copy);
                  utils.arraySet(state.window, src, end - copy, copy, 0);
                  state.wnext = copy;
                  state.whave = state.wsize;
                } else {
                  state.wnext += dist;
                  if (state.wnext === state.wsize) {
                    state.wnext = 0;
                  }
                  if (state.whave < state.wsize) {
                    state.whave += dist;
                  }
                }
              }
              return 0;
            }
  
            function inflate(strm, flush) {
              var state;
              var input, output; // input/output buffers
              var next; /* next input INDEX */
              var put; /* next output INDEX */
              var have, left; /* available input and output */
              var hold; /* bit buffer */
              var bits; /* bits in bit buffer */
              var _in, _out; /* save starting available input and output */
              var copy; /* number of stored or match bytes to copy */
              var from; /* where to copy match bytes from */
              var from_source;
              var here = 0; /* current decoding table entry */
              var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
              //var last;                   /* parent table entry */
              var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
              var len; /* length to copy for repeats, bits to drop */
              var ret; /* return code */
              var hbuf = new utils.Buf8(
                4
              ); /* buffer for gzip header crc calculation */
              var opts;
  
              var n; // temporary var for NEED_BITS
  
              var order =
                /* permutation of code lengths */
                [
                  16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1,
                  15,
                ];
  
              if (
                !strm ||
                !strm.state ||
                !strm.output ||
                (!strm.input && strm.avail_in !== 0)
              ) {
                return Z_STREAM_ERROR;
              }
  
              state = strm.state;
              if (state.mode === TYPE) {
                state.mode = TYPEDO;
              } /* skip check */
  
              //--- LOAD() ---
              put = strm.next_out;
              output = strm.output;
              left = strm.avail_out;
              next = strm.next_in;
              input = strm.input;
              have = strm.avail_in;
              hold = state.hold;
              bits = state.bits;
              //---
  
              _in = have;
              _out = left;
              ret = Z_OK;
  
              // goto emulation
              inf_leave: for (;;) {
                switch (state.mode) {
                  case HEAD:
                    if (state.wrap === 0) {
                      state.mode = TYPEDO;
                      break;
                    }
                    //=== NEEDBITS(16);
                    while (bits < 16) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    if (state.wrap & 2 && hold === 0x8b1f) {
                      /* gzip header */
                      state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
                      //=== CRC2(state.check, hold);
                      hbuf[0] = hold & 0xff;
                      hbuf[1] = (hold >>> 8) & 0xff;
                      state.check = crc32(state.check, hbuf, 2, 0);
                      //===//
  
                      //=== INITBITS();
                      hold = 0;
                      bits = 0;
                      //===//
                      state.mode = FLAGS;
                      break;
                    }
                    state.flags = 0; /* expect zlib header */
                    if (state.head) {
                      state.head.done = false;
                    }
                    if (
                      !(state.wrap & 1) /* check if zlib header allowed */ ||
                      (((hold & 0xff) /*BITS(8)*/ << 8) + (hold >> 8)) % 31
                    ) {
                      strm.msg = "incorrect header check";
                      state.mode = BAD;
                      break;
                    }
                    if ((hold & 0x0f) /*BITS(4)*/ !== Z_DEFLATED) {
                      strm.msg = "unknown compression method";
                      state.mode = BAD;
                      break;
                    }
                    //--- DROPBITS(4) ---//
                    hold >>>= 4;
                    bits -= 4;
                    //---//
                    len = (hold & 0x0f) /*BITS(4)*/ + 8;
                    if (state.wbits === 0) {
                      state.wbits = len;
                    } else if (len > state.wbits) {
                      strm.msg = "invalid window size";
                      state.mode = BAD;
                      break;
                    }
                    state.dmax = 1 << len;
                    //Tracev((stderr, "inflate:   zlib header ok\n"));
                    strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
                    state.mode = hold & 0x200 ? DICTID : TYPE;
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    break;
                  case FLAGS:
                    //=== NEEDBITS(16); */
                    while (bits < 16) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    state.flags = hold;
                    if ((state.flags & 0xff) !== Z_DEFLATED) {
                      strm.msg = "unknown compression method";
                      state.mode = BAD;
                      break;
                    }
                    if (state.flags & 0xe000) {
                      strm.msg = "unknown header flags set";
                      state.mode = BAD;
                      break;
                    }
                    if (state.head) {
                      state.head.text = (hold >> 8) & 1;
                    }
                    if (state.flags & 0x0200) {
                      //=== CRC2(state.check, hold);
                      hbuf[0] = hold & 0xff;
                      hbuf[1] = (hold >>> 8) & 0xff;
                      state.check = crc32(state.check, hbuf, 2, 0);
                      //===//
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = TIME;
                  /* falls through */
                  case TIME:
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    if (state.head) {
                      state.head.time = hold;
                    }
                    if (state.flags & 0x0200) {
                      //=== CRC4(state.check, hold)
                      hbuf[0] = hold & 0xff;
                      hbuf[1] = (hold >>> 8) & 0xff;
                      hbuf[2] = (hold >>> 16) & 0xff;
                      hbuf[3] = (hold >>> 24) & 0xff;
                      state.check = crc32(state.check, hbuf, 4, 0);
                      //===
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = OS;
                  /* falls through */
                  case OS:
                    //=== NEEDBITS(16); */
                    while (bits < 16) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    if (state.head) {
                      state.head.xflags = hold & 0xff;
                      state.head.os = hold >> 8;
                    }
                    if (state.flags & 0x0200) {
                      //=== CRC2(state.check, hold);
                      hbuf[0] = hold & 0xff;
                      hbuf[1] = (hold >>> 8) & 0xff;
                      state.check = crc32(state.check, hbuf, 2, 0);
                      //===//
                    }
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = EXLEN;
                  /* falls through */
                  case EXLEN:
                    if (state.flags & 0x0400) {
                      //=== NEEDBITS(16); */
                      while (bits < 16) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      state.length = hold;
                      if (state.head) {
                        state.head.extra_len = hold;
                      }
                      if (state.flags & 0x0200) {
                        //=== CRC2(state.check, hold);
                        hbuf[0] = hold & 0xff;
                        hbuf[1] = (hold >>> 8) & 0xff;
                        state.check = crc32(state.check, hbuf, 2, 0);
                        //===//
                      }
                      //=== INITBITS();
                      hold = 0;
                      bits = 0;
                      //===//
                    } else if (state.head) {
                      state.head.extra = null /*Z_NULL*/;
                    }
                    state.mode = EXTRA;
                  /* falls through */
                  case EXTRA:
                    if (state.flags & 0x0400) {
                      copy = state.length;
                      if (copy > have) {
                        copy = have;
                      }
                      if (copy) {
                        if (state.head) {
                          len = state.head.extra_len - state.length;
                          if (!state.head.extra) {
                            // Use untyped array for more convenient processing later
                            state.head.extra = new Array(state.head.extra_len);
                          }
                          utils.arraySet(
                            state.head.extra,
                            input,
                            next,
                            // extra field is limited to 65536 bytes
                            // - no need for additional size check
                            copy,
                            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                            len
                          );
                          //zmemcpy(state.head.extra + len, next,
                          //        len + copy > state.head.extra_max ?
                          //        state.head.extra_max - len : copy);
                        }
                        if (state.flags & 0x0200) {
                          state.check = crc32(state.check, input, copy, next);
                        }
                        have -= copy;
                        next += copy;
                        state.length -= copy;
                      }
                      if (state.length) {
                        break inf_leave;
                      }
                    }
                    state.length = 0;
                    state.mode = NAME;
                  /* falls through */
                  case NAME:
                    if (state.flags & 0x0800) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      copy = 0;
                      do {
                        // TODO: 2 or 1 bytes?
                        len = input[next + copy++];
                        /* use constant limit because in js we should not preallocate memory */
                        if (
                          state.head &&
                          len &&
                          state.length < 65536 /*state.head.name_max*/
                        ) {
                          state.head.name += String.fromCharCode(len);
                        }
                      } while (len && copy < have);
  
                      if (state.flags & 0x0200) {
                        state.check = crc32(state.check, input, copy, next);
                      }
                      have -= copy;
                      next += copy;
                      if (len) {
                        break inf_leave;
                      }
                    } else if (state.head) {
                      state.head.name = null;
                    }
                    state.length = 0;
                    state.mode = COMMENT;
                  /* falls through */
                  case COMMENT:
                    if (state.flags & 0x1000) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      copy = 0;
                      do {
                        len = input[next + copy++];
                        /* use constant limit because in js we should not preallocate memory */
                        if (
                          state.head &&
                          len &&
                          state.length < 65536 /*state.head.comm_max*/
                        ) {
                          state.head.comment += String.fromCharCode(len);
                        }
                      } while (len && copy < have);
                      if (state.flags & 0x0200) {
                        state.check = crc32(state.check, input, copy, next);
                      }
                      have -= copy;
                      next += copy;
                      if (len) {
                        break inf_leave;
                      }
                    } else if (state.head) {
                      state.head.comment = null;
                    }
                    state.mode = HCRC;
                  /* falls through */
                  case HCRC:
                    if (state.flags & 0x0200) {
                      //=== NEEDBITS(16); */
                      while (bits < 16) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      if (hold !== (state.check & 0xffff)) {
                        strm.msg = "header crc mismatch";
                        state.mode = BAD;
                        break;
                      }
                      //=== INITBITS();
                      hold = 0;
                      bits = 0;
                      //===//
                    }
                    if (state.head) {
                      state.head.hcrc = (state.flags >> 9) & 1;
                      state.head.done = true;
                    }
                    strm.adler = state.check = 0;
                    state.mode = TYPE;
                    break;
                  case DICTID:
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    strm.adler = state.check = zswap32(hold);
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = DICT;
                  /* falls through */
                  case DICT:
                    if (state.havedict === 0) {
                      //--- RESTORE() ---
                      strm.next_out = put;
                      strm.avail_out = left;
                      strm.next_in = next;
                      strm.avail_in = have;
                      state.hold = hold;
                      state.bits = bits;
                      //---
                      return Z_NEED_DICT;
                    }
                    strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
                    state.mode = TYPE;
                  /* falls through */
                  case TYPE:
                    if (flush === Z_BLOCK || flush === Z_TREES) {
                      break inf_leave;
                    }
                  /* falls through */
                  case TYPEDO:
                    if (state.last) {
                      //--- BYTEBITS() ---//
                      hold >>>= bits & 7;
                      bits -= bits & 7;
                      //---//
                      state.mode = CHECK;
                      break;
                    }
                    //=== NEEDBITS(3); */
                    while (bits < 3) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    state.last = hold & 0x01 /*BITS(1)*/;
                    //--- DROPBITS(1) ---//
                    hold >>>= 1;
                    bits -= 1;
                    //---//
  
                    switch (hold & 0x03 /*BITS(2)*/) {
                      case 0 /* stored block */:
                        //Tracev((stderr, "inflate:     stored block%s\n",
                        //        state.last ? " (last)" : ""));
                        state.mode = STORED;
                        break;
                      case 1 /* fixed block */:
                        fixedtables(state);
                        //Tracev((stderr, "inflate:     fixed codes block%s\n",
                        //        state.last ? " (last)" : ""));
                        state.mode = LEN_; /* decode codes */
                        if (flush === Z_TREES) {
                          //--- DROPBITS(2) ---//
                          hold >>>= 2;
                          bits -= 2;
                          //---//
                          break inf_leave;
                        }
                        break;
                      case 2 /* dynamic block */:
                        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                        //        state.last ? " (last)" : ""));
                        state.mode = TABLE;
                        break;
                      case 3:
                        strm.msg = "invalid block type";
                        state.mode = BAD;
                    }
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                    break;
                  case STORED:
                    //--- BYTEBITS() ---// /* go to byte boundary */
                    hold >>>= bits & 7;
                    bits -= bits & 7;
                    //---//
                    //=== NEEDBITS(32); */
                    while (bits < 32) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
                      strm.msg = "invalid stored block lengths";
                      state.mode = BAD;
                      break;
                    }
                    state.length = hold & 0xffff;
                    //Tracev((stderr, "inflate:       stored length %u\n",
                    //        state.length));
                    //=== INITBITS();
                    hold = 0;
                    bits = 0;
                    //===//
                    state.mode = COPY_;
                    if (flush === Z_TREES) {
                      break inf_leave;
                    }
                  /* falls through */
                  case COPY_:
                    state.mode = COPY;
                  /* falls through */
                  case COPY:
                    copy = state.length;
                    if (copy) {
                      if (copy > have) {
                        copy = have;
                      }
                      if (copy > left) {
                        copy = left;
                      }
                      if (copy === 0) {
                        break inf_leave;
                      }
                      //--- zmemcpy(put, next, copy); ---
                      utils.arraySet(output, input, next, copy, put);
                      //---//
                      have -= copy;
                      next += copy;
                      left -= copy;
                      put += copy;
                      state.length -= copy;
                      break;
                    }
                    //Tracev((stderr, "inflate:       stored end\n"));
                    state.mode = TYPE;
                    break;
                  case TABLE:
                    //=== NEEDBITS(14); */
                    while (bits < 14) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    state.nlen = (hold & 0x1f) /*BITS(5)*/ + 257;
                    //--- DROPBITS(5) ---//
                    hold >>>= 5;
                    bits -= 5;
                    //---//
                    state.ndist = (hold & 0x1f) /*BITS(5)*/ + 1;
                    //--- DROPBITS(5) ---//
                    hold >>>= 5;
                    bits -= 5;
                    //---//
                    state.ncode = (hold & 0x0f) /*BITS(4)*/ + 4;
                    //--- DROPBITS(4) ---//
                    hold >>>= 4;
                    bits -= 4;
                    //---//
                    //#ifndef PKZIP_BUG_WORKAROUND
                    if (state.nlen > 286 || state.ndist > 30) {
                      strm.msg = "too many length or distance symbols";
                      state.mode = BAD;
                      break;
                    }
                    //#endif
                    //Tracev((stderr, "inflate:       table sizes ok\n"));
                    state.have = 0;
                    state.mode = LENLENS;
                  /* falls through */
                  case LENLENS:
                    while (state.have < state.ncode) {
                      //=== NEEDBITS(3);
                      while (bits < 3) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                      //--- DROPBITS(3) ---//
                      hold >>>= 3;
                      bits -= 3;
                      //---//
                    }
                    while (state.have < 19) {
                      state.lens[order[state.have++]] = 0;
                    }
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    //state.next = state.codes;
                    //state.lencode = state.next;
                    // Switch to use dynamic table
                    state.lencode = state.lendyn;
                    state.lenbits = 7;
  
                    opts = { bits: state.lenbits };
                    ret = inflate_table(
                      CODES,
                      state.lens,
                      0,
                      19,
                      state.lencode,
                      0,
                      state.work,
                      opts
                    );
                    state.lenbits = opts.bits;
  
                    if (ret) {
                      strm.msg = "invalid code lengths set";
                      state.mode = BAD;
                      break;
                    }
                    //Tracev((stderr, "inflate:       code lengths ok\n"));
                    state.have = 0;
                    state.mode = CODELENS;
                  /* falls through */
                  case CODELENS:
                    while (state.have < state.nlen + state.ndist) {
                      for (;;) {
                        here =
                          state.lencode[
                            hold & ((1 << state.lenbits) - 1)
                          ]; /*BITS(state.lenbits)*/
                        here_bits = here >>> 24;
                        here_op = (here >>> 16) & 0xff;
                        here_val = here & 0xffff;
  
                        if (here_bits <= bits) {
                          break;
                        }
                        //--- PULLBYTE() ---//
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                        //---//
                      }
                      if (here_val < 16) {
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        state.lens[state.have++] = here_val;
                      } else {
                        if (here_val === 16) {
                          //=== NEEDBITS(here.bits + 2);
                          n = here_bits + 2;
                          while (bits < n) {
                            if (have === 0) {
                              break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                          }
                          //===//
                          //--- DROPBITS(here.bits) ---//
                          hold >>>= here_bits;
                          bits -= here_bits;
                          //---//
                          if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = BAD;
                            break;
                          }
                          len = state.lens[state.have - 1];
                          copy = 3 + (hold & 0x03); //BITS(2);
                          //--- DROPBITS(2) ---//
                          hold >>>= 2;
                          bits -= 2;
                          //---//
                        } else if (here_val === 17) {
                          //=== NEEDBITS(here.bits + 3);
                          n = here_bits + 3;
                          while (bits < n) {
                            if (have === 0) {
                              break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                          }
                          //===//
                          //--- DROPBITS(here.bits) ---//
                          hold >>>= here_bits;
                          bits -= here_bits;
                          //---//
                          len = 0;
                          copy = 3 + (hold & 0x07); //BITS(3);
                          //--- DROPBITS(3) ---//
                          hold >>>= 3;
                          bits -= 3;
                          //---//
                        } else {
                          //=== NEEDBITS(here.bits + 7);
                          n = here_bits + 7;
                          while (bits < n) {
                            if (have === 0) {
                              break inf_leave;
                            }
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                          }
                          //===//
                          //--- DROPBITS(here.bits) ---//
                          hold >>>= here_bits;
                          bits -= here_bits;
                          //---//
                          len = 0;
                          copy = 11 + (hold & 0x7f); //BITS(7);
                          //--- DROPBITS(7) ---//
                          hold >>>= 7;
                          bits -= 7;
                          //---//
                        }
                        if (state.have + copy > state.nlen + state.ndist) {
                          strm.msg = "invalid bit length repeat";
                          state.mode = BAD;
                          break;
                        }
                        while (copy--) {
                          state.lens[state.have++] = len;
                        }
                      }
                    }
  
                    /* handle error breaks in while */
                    if (state.mode === BAD) {
                      break;
                    }
  
                    /* check for end-of-block code (better have one) */
                    if (state.lens[256] === 0) {
                      strm.msg = "invalid code -- missing end-of-block";
                      state.mode = BAD;
                      break;
                    }
  
                    /* build code tables -- note: do not change the lenbits or distbits
             values here (9 and 6) without reading the comments in inftrees.h
             concerning the ENOUGH constants, which depend on those values */
                    state.lenbits = 9;
  
                    opts = { bits: state.lenbits };
                    ret = inflate_table(
                      LENS,
                      state.lens,
                      0,
                      state.nlen,
                      state.lencode,
                      0,
                      state.work,
                      opts
                    );
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    // state.next_index = opts.table_index;
                    state.lenbits = opts.bits;
                    // state.lencode = state.next;
  
                    if (ret) {
                      strm.msg = "invalid literal/lengths set";
                      state.mode = BAD;
                      break;
                    }
  
                    state.distbits = 6;
                    //state.distcode.copy(state.codes);
                    // Switch to use dynamic table
                    state.distcode = state.distdyn;
                    opts = { bits: state.distbits };
                    ret = inflate_table(
                      DISTS,
                      state.lens,
                      state.nlen,
                      state.ndist,
                      state.distcode,
                      0,
                      state.work,
                      opts
                    );
                    // We have separate tables & no pointers. 2 commented lines below not needed.
                    // state.next_index = opts.table_index;
                    state.distbits = opts.bits;
                    // state.distcode = state.next;
  
                    if (ret) {
                      strm.msg = "invalid distances set";
                      state.mode = BAD;
                      break;
                    }
                    //Tracev((stderr, 'inflate:       codes ok\n'));
                    state.mode = LEN_;
                    if (flush === Z_TREES) {
                      break inf_leave;
                    }
                  /* falls through */
                  case LEN_:
                    state.mode = LEN;
                  /* falls through */
                  case LEN:
                    if (have >= 6 && left >= 258) {
                      //--- RESTORE() ---
                      strm.next_out = put;
                      strm.avail_out = left;
                      strm.next_in = next;
                      strm.avail_in = have;
                      state.hold = hold;
                      state.bits = bits;
                      //---
                      inflate_fast(strm, _out);
                      //--- LOAD() ---
                      put = strm.next_out;
                      output = strm.output;
                      left = strm.avail_out;
                      next = strm.next_in;
                      input = strm.input;
                      have = strm.avail_in;
                      hold = state.hold;
                      bits = state.bits;
                      //---
  
                      if (state.mode === TYPE) {
                        state.back = -1;
                      }
                      break;
                    }
                    state.back = 0;
                    for (;;) {
                      here =
                        state.lencode[
                          hold & ((1 << state.lenbits) - 1)
                        ]; /*BITS(state.lenbits)*/
                      here_bits = here >>> 24;
                      here_op = (here >>> 16) & 0xff;
                      here_val = here & 0xffff;
  
                      if (here_bits <= bits) {
                        break;
                      }
                      //--- PULLBYTE() ---//
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                      //---//
                    }
                    if (here_op && (here_op & 0xf0) === 0) {
                      last_bits = here_bits;
                      last_op = here_op;
                      last_val = here_val;
                      for (;;) {
                        here =
                          state.lencode[
                            last_val +
                              ((hold &
                                ((1 << (last_bits + last_op)) -
                                  1)) /*BITS(last.bits + last.op)*/ >>
                                last_bits)
                          ];
                        here_bits = here >>> 24;
                        here_op = (here >>> 16) & 0xff;
                        here_val = here & 0xffff;
  
                        if (last_bits + here_bits <= bits) {
                          break;
                        }
                        //--- PULLBYTE() ---//
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                        //---//
                      }
                      //--- DROPBITS(last.bits) ---//
                      hold >>>= last_bits;
                      bits -= last_bits;
                      //---//
                      state.back += last_bits;
                    }
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.back += here_bits;
                    state.length = here_val;
                    if (here_op === 0) {
                      //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                      //        "inflate:         literal '%c'\n" :
                      //        "inflate:         literal 0x%02x\n", here.val));
                      state.mode = LIT;
                      break;
                    }
                    if (here_op & 32) {
                      //Tracevv((stderr, "inflate:         end of block\n"));
                      state.back = -1;
                      state.mode = TYPE;
                      break;
                    }
                    if (here_op & 64) {
                      strm.msg = "invalid literal/length code";
                      state.mode = BAD;
                      break;
                    }
                    state.extra = here_op & 15;
                    state.mode = LENEXT;
                  /* falls through */
                  case LENEXT:
                    if (state.extra) {
                      //=== NEEDBITS(state.extra);
                      n = state.extra;
                      while (bits < n) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      state.length +=
                        hold & ((1 << state.extra) - 1) /*BITS(state.extra)*/;
                      //--- DROPBITS(state.extra) ---//
                      hold >>>= state.extra;
                      bits -= state.extra;
                      //---//
                      state.back += state.extra;
                    }
                    //Tracevv((stderr, "inflate:         length %u\n", state.length));
                    state.was = state.length;
                    state.mode = DIST;
                  /* falls through */
                  case DIST:
                    for (;;) {
                      here =
                        state.distcode[
                          hold & ((1 << state.distbits) - 1)
                        ]; /*BITS(state.distbits)*/
                      here_bits = here >>> 24;
                      here_op = (here >>> 16) & 0xff;
                      here_val = here & 0xffff;
  
                      if (here_bits <= bits) {
                        break;
                      }
                      //--- PULLBYTE() ---//
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                      //---//
                    }
                    if ((here_op & 0xf0) === 0) {
                      last_bits = here_bits;
                      last_op = here_op;
                      last_val = here_val;
                      for (;;) {
                        here =
                          state.distcode[
                            last_val +
                              ((hold &
                                ((1 << (last_bits + last_op)) -
                                  1)) /*BITS(last.bits + last.op)*/ >>
                                last_bits)
                          ];
                        here_bits = here >>> 24;
                        here_op = (here >>> 16) & 0xff;
                        here_val = here & 0xffff;
  
                        if (last_bits + here_bits <= bits) {
                          break;
                        }
                        //--- PULLBYTE() ---//
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                        //---//
                      }
                      //--- DROPBITS(last.bits) ---//
                      hold >>>= last_bits;
                      bits -= last_bits;
                      //---//
                      state.back += last_bits;
                    }
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.back += here_bits;
                    if (here_op & 64) {
                      strm.msg = "invalid distance code";
                      state.mode = BAD;
                      break;
                    }
                    state.offset = here_val;
                    state.extra = here_op & 15;
                    state.mode = DISTEXT;
                  /* falls through */
                  case DISTEXT:
                    if (state.extra) {
                      //=== NEEDBITS(state.extra);
                      n = state.extra;
                      while (bits < n) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      state.offset +=
                        hold & ((1 << state.extra) - 1) /*BITS(state.extra)*/;
                      //--- DROPBITS(state.extra) ---//
                      hold >>>= state.extra;
                      bits -= state.extra;
                      //---//
                      state.back += state.extra;
                    }
                    //#ifdef INFLATE_STRICT
                    if (state.offset > state.dmax) {
                      strm.msg = "invalid distance too far back";
                      state.mode = BAD;
                      break;
                    }
                    //#endif
                    //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
                    state.mode = MATCH;
                  /* falls through */
                  case MATCH:
                    if (left === 0) {
                      break inf_leave;
                    }
                    copy = _out - left;
                    if (state.offset > copy) {
                      /* copy from window */
                      copy = state.offset - copy;
                      if (copy > state.whave) {
                        if (state.sane) {
                          strm.msg = "invalid distance too far back";
                          state.mode = BAD;
                          break;
                        }
                        // (!) This block is disabled in zlib defaults,
                        // don't enable it for binary compatibility
                        //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                        //          Trace((stderr, "inflate.c too far\n"));
                        //          copy -= state.whave;
                        //          if (copy > state.length) { copy = state.length; }
                        //          if (copy > left) { copy = left; }
                        //          left -= copy;
                        //          state.length -= copy;
                        //          do {
                        //            output[put++] = 0;
                        //          } while (--copy);
                        //          if (state.length === 0) { state.mode = LEN; }
                        //          break;
                        //#endif
                      }
                      if (copy > state.wnext) {
                        copy -= state.wnext;
                        from = state.wsize - copy;
                      } else {
                        from = state.wnext - copy;
                      }
                      if (copy > state.length) {
                        copy = state.length;
                      }
                      from_source = state.window;
                    } else {
                      /* copy from output */
                      from_source = output;
                      from = put - state.offset;
                      copy = state.length;
                    }
                    if (copy > left) {
                      copy = left;
                    }
                    left -= copy;
                    state.length -= copy;
                    do {
                      output[put++] = from_source[from++];
                    } while (--copy);
                    if (state.length === 0) {
                      state.mode = LEN;
                    }
                    break;
                  case LIT:
                    if (left === 0) {
                      break inf_leave;
                    }
                    output[put++] = state.length;
                    left--;
                    state.mode = LEN;
                    break;
                  case CHECK:
                    if (state.wrap) {
                      //=== NEEDBITS(32);
                      while (bits < 32) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        // Use '|' instead of '+' to make sure that result is signed
                        hold |= input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      _out -= left;
                      strm.total_out += _out;
                      state.total += _out;
                      if (_out) {
                        strm.adler = state.check =
                          /*UPDATE(state.check, put - _out, _out);*/
                          state.flags
                            ? crc32(state.check, output, _out, put - _out)
                            : adler32(state.check, output, _out, put - _out);
                      }
                      _out = left;
                      // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                      if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                        strm.msg = "incorrect data check";
                        state.mode = BAD;
                        break;
                      }
                      //=== INITBITS();
                      hold = 0;
                      bits = 0;
                      //===//
                      //Tracev((stderr, "inflate:   check matches trailer\n"));
                    }
                    state.mode = LENGTH;
                  /* falls through */
                  case LENGTH:
                    if (state.wrap && state.flags) {
                      //=== NEEDBITS(32);
                      while (bits < 32) {
                        if (have === 0) {
                          break inf_leave;
                        }
                        have--;
                        hold += input[next++] << bits;
                        bits += 8;
                      }
                      //===//
                      if (hold !== (state.total & 0xffffffff)) {
                        strm.msg = "incorrect length check";
                        state.mode = BAD;
                        break;
                      }
                      //=== INITBITS();
                      hold = 0;
                      bits = 0;
                      //===//
                      //Tracev((stderr, "inflate:   length matches trailer\n"));
                    }
                    state.mode = DONE;
                  /* falls through */
                  case DONE:
                    ret = Z_STREAM_END;
                    break inf_leave;
                  case BAD:
                    ret = Z_DATA_ERROR;
                    break inf_leave;
                  case MEM:
                    return Z_MEM_ERROR;
                  case SYNC:
                  /* falls through */
                  default:
                    return Z_STREAM_ERROR;
                }
              }
  
              // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
  
              /*
       Return from inflate(), updating the total counts and the check value.
       If there was no progress during the inflate() call, return a buffer
       error.  Call updatewindow() to create and/or update the window state.
       Note: a memory error from inflate() is non-recoverable.
     */
  
              //--- RESTORE() ---
              strm.next_out = put;
              strm.avail_out = left;
              strm.next_in = next;
              strm.avail_in = have;
              state.hold = hold;
              state.bits = bits;
              //---
  
              if (
                state.wsize ||
                (_out !== strm.avail_out &&
                  state.mode < BAD &&
                  (state.mode < CHECK || flush !== Z_FINISH))
              ) {
                if (
                  updatewindow(
                    strm,
                    strm.output,
                    strm.next_out,
                    _out - strm.avail_out
                  )
                ) {
                  state.mode = MEM;
                  return Z_MEM_ERROR;
                }
              }
              _in -= strm.avail_in;
              _out -= strm.avail_out;
              strm.total_in += _in;
              strm.total_out += _out;
              state.total += _out;
              if (state.wrap && _out) {
                strm.adler = state.check =
                  /*UPDATE(state.check, strm.next_out - _out, _out);*/
                  state.flags
                    ? crc32(state.check, output, _out, strm.next_out - _out)
                    : adler32(state.check, output, _out, strm.next_out - _out);
              }
              strm.data_type =
                state.bits +
                (state.last ? 64 : 0) +
                (state.mode === TYPE ? 128 : 0) +
                (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
              if (
                ((_in === 0 && _out === 0) || flush === Z_FINISH) &&
                ret === Z_OK
              ) {
                ret = Z_BUF_ERROR;
              }
              return ret;
            }
  
            function inflateEnd(strm) {
              if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
                return Z_STREAM_ERROR;
              }
  
              var state = strm.state;
              if (state.window) {
                state.window = null;
              }
              strm.state = null;
              return Z_OK;
            }
  
            function inflateGetHeader(strm, head) {
              var state;
  
              /* check state */
              if (!strm || !strm.state) {
                return Z_STREAM_ERROR;
              }
              state = strm.state;
              if ((state.wrap & 2) === 0) {
                return Z_STREAM_ERROR;
              }
  
              /* save header structure */
              state.head = head;
              head.done = false;
              return Z_OK;
            }
  
            function inflateSetDictionary(strm, dictionary) {
              var dictLength = dictionary.length;
  
              var state;
              var dictid;
              var ret;
  
              /* check state */
              if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) {
                return Z_STREAM_ERROR;
              }
              state = strm.state;
  
              if (state.wrap !== 0 && state.mode !== DICT) {
                return Z_STREAM_ERROR;
              }
  
              /* check for correct dictionary identifier */
              if (state.mode === DICT) {
                dictid = 1; /* adler32(0, null, 0)*/
                /* dictid = adler32(dictid, dictionary, dictLength); */
                dictid = adler32(dictid, dictionary, dictLength, 0);
                if (dictid !== state.check) {
                  return Z_DATA_ERROR;
                }
              }
              /* copy dictionary to window using updatewindow(), which will amend the
     existing dictionary if appropriate */
              ret = updatewindow(strm, dictionary, dictLength, dictLength);
              if (ret) {
                state.mode = MEM;
                return Z_MEM_ERROR;
              }
              state.havedict = 1;
              // Tracev((stderr, "inflate:   dictionary set\n"));
              return Z_OK;
            }
  
            exports.inflateReset = inflateReset;
            exports.inflateReset2 = inflateReset2;
            exports.inflateResetKeep = inflateResetKeep;
            exports.inflateInit = inflateInit;
            exports.inflateInit2 = inflateInit2;
            exports.inflate = inflate;
            exports.inflateEnd = inflateEnd;
            exports.inflateGetHeader = inflateGetHeader;
            exports.inflateSetDictionary = inflateSetDictionary;
            exports.inflateInfo = "pako inflate (from Nodeca project)";
  
            /* Not implemented
  exports.inflateCopy = inflateCopy;
  exports.inflateGetDictionary = inflateGetDictionary;
  exports.inflateMark = inflateMark;
  exports.inflatePrime = inflatePrime;
  exports.inflateSync = inflateSync;
  exports.inflateSyncPoint = inflateSyncPoint;
  exports.inflateUndermine = inflateUndermine;
  */
          },
          {
            "../utils/common": 43,
            "./adler32": 44,
            "./crc32": 46,
            "./inffast": 48,
            "./inftrees": 50,
          },
        ],
        50: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            var utils = require("../utils/common");
  
            var MAXBITS = 15;
            var ENOUGH_LENS = 852;
            var ENOUGH_DISTS = 592;
            //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
  
            var CODES = 0;
            var LENS = 1;
            var DISTS = 2;
  
            var lbase = [
              /* Length codes 257..285 base */ 3, 4, 5, 6, 7, 8, 9, 10, 11, 13,
              15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163,
              195, 227, 258, 0, 0,
            ];
  
            var lext = [
              /* Length codes 257..285 extra */ 16, 16, 16, 16, 16, 16, 16, 16,
              17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21,
              21, 21, 21, 16, 72, 78,
            ];
  
            var dbase = [
              /* Distance codes 0..29 base */ 1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33,
              49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073,
              4097, 6145, 8193, 12289, 16385, 24577, 0, 0,
            ];
  
            var dext = [
              /* Distance codes 0..29 extra */ 16, 16, 16, 16, 17, 17, 18, 18, 19,
              19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
              28, 28, 29, 29, 64, 64,
            ];
  
            module.exports = function inflate_table(
              type,
              lens,
              lens_index,
              codes,
              table,
              table_index,
              work,
              opts
            ) {
              var bits = opts.bits;
              //here = opts.here; /* table entry for duplication */
  
              var len = 0; /* a code's length in bits */
              var sym = 0; /* index of code symbols */
              var min = 0,
                max = 0; /* minimum and maximum code lengths */
              var root = 0; /* number of index bits for root table */
              var curr = 0; /* number of index bits for current table */
              var drop = 0; /* code bits to drop for sub-table */
              var left = 0; /* number of prefix codes available */
              var used = 0; /* code entries in table used */
              var huff = 0; /* Huffman code */
              var incr; /* for incrementing code, index */
              var fill; /* index for replicating entries */
              var low; /* low bits for current root entry */
              var mask; /* mask for low root bits */
              var next; /* next available space in table */
              var base = null; /* base value table to use */
              var base_index = 0;
              //  var shoextra;    /* extra bits table to use */
              var end; /* use base and extra for symbol > end */
              var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
              var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
              var extra = null;
              var extra_index = 0;
  
              var here_bits, here_op, here_val;
  
              /*
     Process a set of code lengths to create a canonical Huffman code.  The
     code lengths are lens[0..codes-1].  Each length corresponds to the
     symbols 0..codes-1.  The Huffman code is generated by first sorting the
     symbols by length from short to long, and retaining the symbol order
     for codes with equal lengths.  Then the code starts with all zero bits
     for the first code of the shortest length, and the codes are integer
     increments for the same length, and zeros are appended as the length
     increases.  For the deflate format, these bits are stored backwards
     from their more natural integer increment ordering, and so when the
     decoding tables are built in the large loop below, the integer codes
     are incremented backwards.
  
     This routine assumes, but does not check, that all of the entries in
     lens[] are in the range 0..MAXBITS.  The caller must assure this.
     1..MAXBITS is interpreted as that code length.  zero means that that
     symbol does not occur in this code.
  
     The codes are sorted by computing a count of codes for each length,
     creating from that a table of starting indices for each length in the
     sorted table, and then entering the symbols in order in the sorted
     table.  The sorted table is work[], with that space being provided by
     the caller.
  
     The length counts are used for other purposes as well, i.e. finding
     the minimum and maximum length codes, determining if there are any
     codes at all, checking for a valid set of lengths, and looking ahead
     at length counts to determine sub-table sizes when building the
     decoding tables.
     */
  
              /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
              for (len = 0; len <= MAXBITS; len++) {
                count[len] = 0;
              }
              for (sym = 0; sym < codes; sym++) {
                count[lens[lens_index + sym]]++;
              }
  
              /* bound code lengths, force root to be within code lengths */
              root = bits;
              for (max = MAXBITS; max >= 1; max--) {
                if (count[max] !== 0) {
                  break;
                }
              }
              if (root > max) {
                root = max;
              }
              if (max === 0) {
                /* no symbols to code at all */
                //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
                //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
                //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
                table[table_index++] = (1 << 24) | (64 << 16) | 0;
  
                //table.op[opts.table_index] = 64;
                //table.bits[opts.table_index] = 1;
                //table.val[opts.table_index++] = 0;
                table[table_index++] = (1 << 24) | (64 << 16) | 0;
  
                opts.bits = 1;
                return 0; /* no symbols, but wait for decoding to report error */
              }
              for (min = 1; min < max; min++) {
                if (count[min] !== 0) {
                  break;
                }
              }
              if (root < min) {
                root = min;
              }
  
              /* check for an over-subscribed or incomplete set of lengths */
              left = 1;
              for (len = 1; len <= MAXBITS; len++) {
                left <<= 1;
                left -= count[len];
                if (left < 0) {
                  return -1;
                } /* over-subscribed */
              }
              if (left > 0 && (type === CODES || max !== 1)) {
                return -1; /* incomplete set */
              }
  
              /* generate offsets into symbol table for each length for sorting */
              offs[1] = 0;
              for (len = 1; len < MAXBITS; len++) {
                offs[len + 1] = offs[len] + count[len];
              }
  
              /* sort symbols by length, by symbol order within each length */
              for (sym = 0; sym < codes; sym++) {
                if (lens[lens_index + sym] !== 0) {
                  work[offs[lens[lens_index + sym]]++] = sym;
                }
              }
  
              /*
     Create and fill in decoding tables.  In this loop, the table being
     filled is at next and has curr index bits.  The code being used is huff
     with length len.  That code is converted to an index by dropping drop
     bits off of the bottom.  For codes where len is less than drop + curr,
     those top drop + curr - len bits are incremented through all values to
     fill the table with replicated entries.
  
     root is the number of index bits for the root table.  When len exceeds
     root, sub-tables are created pointed to by the root entry with an index
     of the low root bits of huff.  This is saved in low to check for when a
     new sub-table should be started.  drop is zero when the root table is
     being filled, and drop is root when sub-tables are being filled.
  
     When a new sub-table is needed, it is necessary to look ahead in the
     code lengths to determine what size sub-table is needed.  The length
     counts are used for this, and so count[] is decremented as codes are
     entered in the tables.
  
     used keeps track of how many table entries have been allocated from the
     provided *table space.  It is checked for LENS and DIST tables against
     the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
     the initial root table size constants.  See the comments in inftrees.h
     for more information.
  
     sym increments through all symbols, and the loop terminates when
     all codes of length max, i.e. all codes, have been processed.  This
     routine permits incomplete codes, so another loop after this one fills
     in the rest of the decoding tables with invalid code markers.
     */
  
              /* set up for code type */
              // poor man optimization - use if-else instead of switch,
              // to avoid deopts in old v8
              if (type === CODES) {
                base = extra = work; /* dummy value--not used */
                end = 19;
              } else if (type === LENS) {
                base = lbase;
                base_index -= 257;
                extra = lext;
                extra_index -= 257;
                end = 256;
              } else {
                /* DISTS */
                base = dbase;
                extra = dext;
                end = -1;
              }
  
              /* initialize opts for loop */
              huff = 0; /* starting code */
              sym = 0; /* starting code symbol */
              len = min; /* starting code length */
              next = table_index; /* current table to fill in */
              curr = root; /* current table index bits */
              drop = 0; /* current bits to drop from code for index */
              low = -1; /* trigger new sub-table when len > root */
              used = 1 << root; /* use root table entries */
              mask = used - 1; /* mask for comparing low */
  
              /* check available table space */
              if (
                (type === LENS && used > ENOUGH_LENS) ||
                (type === DISTS && used > ENOUGH_DISTS)
              ) {
                return 1;
              }
  
              /* process all codes and make table entries */
              for (;;) {
                /* create table entry */
                here_bits = len - drop;
                if (work[sym] < end) {
                  here_op = 0;
                  here_val = work[sym];
                } else if (work[sym] > end) {
                  here_op = extra[extra_index + work[sym]];
                  here_val = base[base_index + work[sym]];
                } else {
                  here_op = 32 + 64; /* end of block */
                  here_val = 0;
                }
  
                /* replicate for those indices with low len bits equal to huff */
                incr = 1 << (len - drop);
                fill = 1 << curr;
                min = fill; /* save offset to next table */
                do {
                  fill -= incr;
                  table[next + (huff >> drop) + fill] =
                    (here_bits << 24) | (here_op << 16) | here_val | 0;
                } while (fill !== 0);
  
                /* backwards increment the len-bit code huff */
                incr = 1 << (len - 1);
                while (huff & incr) {
                  incr >>= 1;
                }
                if (incr !== 0) {
                  huff &= incr - 1;
                  huff += incr;
                } else {
                  huff = 0;
                }
  
                /* go to next symbol, update count, len */
                sym++;
                if (--count[len] === 0) {
                  if (len === max) {
                    break;
                  }
                  len = lens[lens_index + work[sym]];
                }
  
                /* create new sub-table if needed */
                if (len > root && (huff & mask) !== low) {
                  /* if first time, transition to sub-tables */
                  if (drop === 0) {
                    drop = root;
                  }
  
                  /* increment past last table */
                  next += min; /* here min is 1 << curr */
  
                  /* determine length of next table */
                  curr = len - drop;
                  left = 1 << curr;
                  while (curr + drop < max) {
                    left -= count[curr + drop];
                    if (left <= 0) {
                      break;
                    }
                    curr++;
                    left <<= 1;
                  }
  
                  /* check for enough space */
                  used += 1 << curr;
                  if (
                    (type === LENS && used > ENOUGH_LENS) ||
                    (type === DISTS && used > ENOUGH_DISTS)
                  ) {
                    return 1;
                  }
  
                  /* point entry in root table to sub-table */
                  low = huff & mask;
                  /*table.op[low] = curr;
        table.bits[low] = root;
        table.val[low] = next - opts.table_index;*/
                  table[low] =
                    (root << 24) | (curr << 16) | (next - table_index) | 0;
                }
              }
  
              /* fill in remaining table entry if code is incomplete (guaranteed to have
     at most one remaining entry, since if the code is incomplete, the
     maximum code length that was allowed to get this far is one bit) */
              if (huff !== 0) {
                //table.op[next + huff] = 64;            /* invalid code marker */
                //table.bits[next + huff] = len - drop;
                //table.val[next + huff] = 0;
                table[next + huff] = ((len - drop) << 24) | (64 << 16) | 0;
              }
  
              /* set return parameters */
              //opts.table_index += used;
              opts.bits = root;
              return 0;
            };
          },
          { "../utils/common": 43 },
        ],
        51: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            module.exports = {
              2: "need dictionary" /* Z_NEED_DICT       2  */,
              1: "stream end" /* Z_STREAM_END      1  */,
              0: "" /* Z_OK              0  */,
              "-1": "file error" /* Z_ERRNO         (-1) */,
              "-2": "stream error" /* Z_STREAM_ERROR  (-2) */,
              "-3": "data error" /* Z_DATA_ERROR    (-3) */,
              "-4": "insufficient memory" /* Z_MEM_ERROR     (-4) */,
              "-5": "buffer error" /* Z_BUF_ERROR     (-5) */,
              "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */,
            };
          },
          {},
        ],
        52: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            /* eslint-disable space-unary-ops */
  
            var utils = require("../utils/common");
  
            /* Public constants ==========================================================*/
            /* ===========================================================================*/
  
            //var Z_FILTERED          = 1;
            //var Z_HUFFMAN_ONLY      = 2;
            //var Z_RLE               = 3;
            var Z_FIXED = 4;
            //var Z_DEFAULT_STRATEGY  = 0;
  
            /* Possible values of the data_type field (though see inflate()) */
            var Z_BINARY = 0;
            var Z_TEXT = 1;
            //var Z_ASCII             = 1; // = Z_TEXT
            var Z_UNKNOWN = 2;
  
            /*============================================================================*/
  
            function zero(buf) {
              var len = buf.length;
              while (--len >= 0) {
                buf[len] = 0;
              }
            }
  
            // From zutil.h
  
            var STORED_BLOCK = 0;
            var STATIC_TREES = 1;
            var DYN_TREES = 2;
            /* The three kinds of block type */
  
            var MIN_MATCH = 3;
            var MAX_MATCH = 258;
            /* The minimum and maximum match lengths */
  
            // From deflate.h
            /* ===========================================================================
             * Internal compression state.
             */
  
            var LENGTH_CODES = 29;
            /* number of length codes, not counting the special END_BLOCK code */
  
            var LITERALS = 256;
            /* number of literal bytes 0..255 */
  
            var L_CODES = LITERALS + 1 + LENGTH_CODES;
            /* number of Literal or Length codes, including the END_BLOCK code */
  
            var D_CODES = 30;
            /* number of distance codes */
  
            var BL_CODES = 19;
            /* number of codes used to transfer the bit lengths */
  
            var HEAP_SIZE = 2 * L_CODES + 1;
            /* maximum heap size */
  
            var MAX_BITS = 15;
            /* All codes must not exceed MAX_BITS bits */
  
            var Buf_size = 16;
            /* size of bit buffer in bi_buf */
  
            /* ===========================================================================
             * Constants
             */
  
            var MAX_BL_BITS = 7;
            /* Bit length codes must not exceed MAX_BL_BITS bits */
  
            var END_BLOCK = 256;
            /* end of block literal code */
  
            var REP_3_6 = 16;
            /* repeat previous bit length 3-6 times (2 bits of repeat count) */
  
            var REPZ_3_10 = 17;
            /* repeat a zero length 3-10 times  (3 bits of repeat count) */
  
            var REPZ_11_138 = 18;
            /* repeat a zero length 11-138 times  (7 bits of repeat count) */
  
            /* eslint-disable comma-spacing,array-bracket-spacing */
            var extra_lbits =
              /* extra bits for each length code */
              [
                0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4,
                4, 4, 5, 5, 5, 5, 0,
              ];
  
            var extra_dbits =
              /* extra bits for each distance code */
              [
                0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9,
                10, 10, 11, 11, 12, 12, 13, 13,
              ];
  
            var extra_blbits =
              /* extra bits for each bit length code */
              [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
  
            var bl_order = [
              16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
            ];
            /* eslint-enable comma-spacing,array-bracket-spacing */
  
            /* The lengths of the bit length codes are sent in order of decreasing
             * probability, to avoid transmitting the lengths for unused bit length codes.
             */
  
            /* ===========================================================================
             * Local data. These are initialized only once.
             */
  
            // We pre-fill arrays with 0 to avoid uninitialized gaps
  
            var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
  
            // !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
            var static_ltree = new Array((L_CODES + 2) * 2);
            zero(static_ltree);
            /* The static literal tree. Since the bit lengths are imposed, there is no
             * need for the L_CODES extra codes used during heap construction. However
             * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
             * below).
             */
  
            var static_dtree = new Array(D_CODES * 2);
            zero(static_dtree);
            /* The static distance tree. (Actually a trivial tree since all codes use
             * 5 bits.)
             */
  
            var _dist_code = new Array(DIST_CODE_LEN);
            zero(_dist_code);
            /* Distance codes. The first 256 values correspond to the distances
             * 3 .. 258, the last 256 values correspond to the top 8 bits of
             * the 15 bit distances.
             */
  
            var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
            zero(_length_code);
            /* length code for each normalized match length (0 == MIN_MATCH) */
  
            var base_length = new Array(LENGTH_CODES);
            zero(base_length);
            /* First normalized length for each code (0 = MIN_MATCH) */
  
            var base_dist = new Array(D_CODES);
            zero(base_dist);
            /* First normalized distance for each code (0 = distance of 1) */
  
            function StaticTreeDesc(
              static_tree,
              extra_bits,
              extra_base,
              elems,
              max_length
            ) {
              this.static_tree = static_tree; /* static tree or NULL */
              this.extra_bits = extra_bits; /* extra bits for each code or NULL */
              this.extra_base = extra_base; /* base index for extra_bits */
              this.elems = elems; /* max number of elements in the tree */
              this.max_length = max_length; /* max bit length for the codes */
  
              // show if `static_tree` has data or dummy - needed for monomorphic objects
              this.has_stree = static_tree && static_tree.length;
            }
  
            var static_l_desc;
            var static_d_desc;
            var static_bl_desc;
  
            function TreeDesc(dyn_tree, stat_desc) {
              this.dyn_tree = dyn_tree; /* the dynamic tree */
              this.max_code = 0; /* largest code with non zero frequency */
              this.stat_desc = stat_desc; /* the corresponding static tree */
            }
  
            function d_code(dist) {
              return dist < 256
                ? _dist_code[dist]
                : _dist_code[256 + (dist >>> 7)];
            }
  
            /* ===========================================================================
             * Output a short LSB first on the stream.
             * IN assertion: there is enough room in pendingBuf.
             */
            function put_short(s, w) {
              //    put_byte(s, (uch)((w) & 0xff));
              //    put_byte(s, (uch)((ush)(w) >> 8));
              s.pending_buf[s.pending++] = w & 0xff;
              s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
            }
  
            /* ===========================================================================
             * Send a value on a given number of bits.
             * IN assertion: length <= 16 and value fits in length bits.
             */
            function send_bits(s, value, length) {
              if (s.bi_valid > Buf_size - length) {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                put_short(s, s.bi_buf);
                s.bi_buf = value >> (Buf_size - s.bi_valid);
                s.bi_valid += length - Buf_size;
              } else {
                s.bi_buf |= (value << s.bi_valid) & 0xffff;
                s.bi_valid += length;
              }
            }
  
            function send_code(s, c, tree) {
              send_bits(s, tree[c * 2] /*.Code*/, tree[c * 2 + 1] /*.Len*/);
            }
  
            /* ===========================================================================
             * Reverse the first len bits of a code, using straightforward code (a faster
             * method would use a table)
             * IN assertion: 1 <= len <= 15
             */
            function bi_reverse(code, len) {
              var res = 0;
              do {
                res |= code & 1;
                code >>>= 1;
                res <<= 1;
              } while (--len > 0);
              return res >>> 1;
            }
  
            /* ===========================================================================
             * Flush the bit buffer, keeping at most 7 bits in it.
             */
            function bi_flush(s) {
              if (s.bi_valid === 16) {
                put_short(s, s.bi_buf);
                s.bi_buf = 0;
                s.bi_valid = 0;
              } else if (s.bi_valid >= 8) {
                s.pending_buf[s.pending++] = s.bi_buf & 0xff;
                s.bi_buf >>= 8;
                s.bi_valid -= 8;
              }
            }
  
            /* ===========================================================================
             * Compute the optimal bit lengths for a tree and update the total bit length
             * for the current block.
             * IN assertion: the fields freq and dad are set, heap[heap_max] and
             *    above are the tree nodes sorted by increasing frequency.
             * OUT assertions: the field len is set to the optimal bit length, the
             *     array bl_count contains the frequencies for each bit length.
             *     The length opt_len is updated; static_len is also updated if stree is
             *     not null.
             */
            function gen_bitlen(s, desc) {
              //    deflate_state *s;
              //    tree_desc *desc;    /* the tree descriptor */
              var tree = desc.dyn_tree;
              var max_code = desc.max_code;
              var stree = desc.stat_desc.static_tree;
              var has_stree = desc.stat_desc.has_stree;
              var extra = desc.stat_desc.extra_bits;
              var base = desc.stat_desc.extra_base;
              var max_length = desc.stat_desc.max_length;
              var h; /* heap index */
              var n, m; /* iterate over the tree elements */
              var bits; /* bit length */
              var xbits; /* extra bits */
              var f; /* frequency */
              var overflow = 0; /* number of elements with bit length too large */
  
              for (bits = 0; bits <= MAX_BITS; bits++) {
                s.bl_count[bits] = 0;
              }
  
              /* In a first pass, compute the optimal bit lengths (which may
               * overflow in the case of the bit length tree).
               */
              tree[
                s.heap[s.heap_max] * 2 + 1
              ] /*.Len*/ = 0; /* root of the heap */
  
              for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
                n = s.heap[h];
                bits = tree[tree[n * 2 + 1] /*.Dad*/ * 2 + 1] /*.Len*/ + 1;
                if (bits > max_length) {
                  bits = max_length;
                  overflow++;
                }
                tree[n * 2 + 1] /*.Len*/ = bits;
                /* We overwrite tree[n].Dad which is no longer needed */
  
                if (n > max_code) {
                  continue;
                } /* not a leaf node */
  
                s.bl_count[bits]++;
                xbits = 0;
                if (n >= base) {
                  xbits = extra[n - base];
                }
                f = tree[n * 2] /*.Freq*/;
                s.opt_len += f * (bits + xbits);
                if (has_stree) {
                  s.static_len += f * (stree[n * 2 + 1] /*.Len*/ + xbits);
                }
              }
              if (overflow === 0) {
                return;
              }
  
              // Trace((stderr,"\nbit length overflow\n"));
              /* This happens for example on obj2 and pic of the Calgary corpus */
  
              /* Find the first bit length which could increase: */
              do {
                bits = max_length - 1;
                while (s.bl_count[bits] === 0) {
                  bits--;
                }
                s.bl_count[bits]--; /* move one leaf down the tree */
                s.bl_count[
                  bits + 1
                ] += 2; /* move one overflow item as its brother */
                s.bl_count[max_length]--;
                /* The brother of the overflow item also moves one step up,
                 * but this does not affect bl_count[max_length]
                 */
                overflow -= 2;
              } while (overflow > 0);
  
              /* Now recompute all bit lengths, scanning in increasing frequency.
               * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
               * lengths instead of fixing only the wrong ones. This idea is taken
               * from 'ar' written by Haruhiko Okumura.)
               */
              for (bits = max_length; bits !== 0; bits--) {
                n = s.bl_count[bits];
                while (n !== 0) {
                  m = s.heap[--h];
                  if (m > max_code) {
                    continue;
                  }
                  if (tree[m * 2 + 1] /*.Len*/ !== bits) {
                    // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                    s.opt_len +=
                      (bits - tree[m * 2 + 1]) /*.Len*/ * tree[m * 2] /*.Freq*/;
                    tree[m * 2 + 1] /*.Len*/ = bits;
                  }
                  n--;
                }
              }
            }
  
            /* ===========================================================================
             * Generate the codes for a given tree and bit counts (which need not be
             * optimal).
             * IN assertion: the array bl_count contains the bit length statistics for
             * the given tree and the field len is set for all tree elements.
             * OUT assertion: the field code is set for all tree elements of non
             *     zero code length.
             */
            function gen_codes(tree, max_code, bl_count) {
              //    ct_data *tree;             /* the tree to decorate */
              //    int max_code;              /* largest code with non zero frequency */
              //    ushf *bl_count;            /* number of codes at each bit length */
              var next_code = new Array(
                MAX_BITS + 1
              ); /* next code value for each bit length */
              var code = 0; /* running code value */
              var bits; /* bit index */
              var n; /* code index */
  
              /* The distribution counts are first used to generate the code values
               * without bit reversal.
               */
              for (bits = 1; bits <= MAX_BITS; bits++) {
                next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
              }
              /* Check that the bit counts in bl_count are consistent. The last code
               * must be all ones.
               */
              //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
              //        "inconsistent bit counts");
              //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
  
              for (n = 0; n <= max_code; n++) {
                var len = tree[n * 2 + 1]; /*.Len*/
                if (len === 0) {
                  continue;
                }
                /* Now reverse the bits */
                tree[n * 2] /*.Code*/ = bi_reverse(next_code[len]++, len);
  
                //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
                //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
              }
            }
  
            /* ===========================================================================
             * Initialize the various 'constant' tables.
             */
            function tr_static_init() {
              var n; /* iterates over tree elements */
              var bits; /* bit counter */
              var length; /* length value */
              var code; /* code value */
              var dist; /* distance index */
              var bl_count = new Array(MAX_BITS + 1);
              /* number of codes at each bit length for an optimal tree */
  
              // do check in _tr_init()
              //if (static_init_done) return;
  
              /* For some embedded targets, global variables are not initialized: */
              /*#ifdef NO_INIT_GLOBAL_POINTERS
    static_l_desc.static_tree = static_ltree;
    static_l_desc.extra_bits = extra_lbits;
    static_d_desc.static_tree = static_dtree;
    static_d_desc.extra_bits = extra_dbits;
    static_bl_desc.extra_bits = extra_blbits;
  #endif*/
  
              /* Initialize the mapping length (0..255) -> length code (0..28) */
              length = 0;
              for (code = 0; code < LENGTH_CODES - 1; code++) {
                base_length[code] = length;
                for (n = 0; n < 1 << extra_lbits[code]; n++) {
                  _length_code[length++] = code;
                }
              }
              //Assert (length == 256, "tr_static_init: length != 256");
              /* Note that the length 255 (match length 258) can be represented
               * in two different ways: code 284 + 5 bits or code 285, so we
               * overwrite length_code[255] to use the best encoding:
               */
              _length_code[length - 1] = code;
  
              /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
              dist = 0;
              for (code = 0; code < 16; code++) {
                base_dist[code] = dist;
                for (n = 0; n < 1 << extra_dbits[code]; n++) {
                  _dist_code[dist++] = code;
                }
              }
              //Assert (dist == 256, "tr_static_init: dist != 256");
              dist >>= 7; /* from now on, all distances are divided by 128 */
              for (; code < D_CODES; code++) {
                base_dist[code] = dist << 7;
                for (n = 0; n < 1 << (extra_dbits[code] - 7); n++) {
                  _dist_code[256 + dist++] = code;
                }
              }
              //Assert (dist == 256, "tr_static_init: 256+dist != 512");
  
              /* Construct the codes of the static literal tree */
              for (bits = 0; bits <= MAX_BITS; bits++) {
                bl_count[bits] = 0;
              }
  
              n = 0;
              while (n <= 143) {
                static_ltree[n * 2 + 1] /*.Len*/ = 8;
                n++;
                bl_count[8]++;
              }
              while (n <= 255) {
                static_ltree[n * 2 + 1] /*.Len*/ = 9;
                n++;
                bl_count[9]++;
              }
              while (n <= 279) {
                static_ltree[n * 2 + 1] /*.Len*/ = 7;
                n++;
                bl_count[7]++;
              }
              while (n <= 287) {
                static_ltree[n * 2 + 1] /*.Len*/ = 8;
                n++;
                bl_count[8]++;
              }
              /* Codes 286 and 287 do not exist, but we must include them in the
               * tree construction to get a canonical Huffman tree (longest code
               * all ones)
               */
              gen_codes(static_ltree, L_CODES + 1, bl_count);
  
              /* The static distance tree is trivial: */
              for (n = 0; n < D_CODES; n++) {
                static_dtree[n * 2 + 1] /*.Len*/ = 5;
                static_dtree[n * 2] /*.Code*/ = bi_reverse(n, 5);
              }
  
              // Now data ready and we can init static trees
              static_l_desc = new StaticTreeDesc(
                static_ltree,
                extra_lbits,
                LITERALS + 1,
                L_CODES,
                MAX_BITS
              );
              static_d_desc = new StaticTreeDesc(
                static_dtree,
                extra_dbits,
                0,
                D_CODES,
                MAX_BITS
              );
              static_bl_desc = new StaticTreeDesc(
                new Array(0),
                extra_blbits,
                0,
                BL_CODES,
                MAX_BL_BITS
              );
  
              //static_init_done = true;
            }
  
            /* ===========================================================================
             * Initialize a new block.
             */
            function init_block(s) {
              var n; /* iterates over tree elements */
  
              /* Initialize the trees. */
              for (n = 0; n < L_CODES; n++) {
                s.dyn_ltree[n * 2] /*.Freq*/ = 0;
              }
              for (n = 0; n < D_CODES; n++) {
                s.dyn_dtree[n * 2] /*.Freq*/ = 0;
              }
              for (n = 0; n < BL_CODES; n++) {
                s.bl_tree[n * 2] /*.Freq*/ = 0;
              }
  
              s.dyn_ltree[END_BLOCK * 2] /*.Freq*/ = 1;
              s.opt_len = s.static_len = 0;
              s.last_lit = s.matches = 0;
            }
  
            /* ===========================================================================
             * Flush the bit buffer and align the output on a byte boundary
             */
            function bi_windup(s) {
              if (s.bi_valid > 8) {
                put_short(s, s.bi_buf);
              } else if (s.bi_valid > 0) {
                //put_byte(s, (Byte)s->bi_buf);
                s.pending_buf[s.pending++] = s.bi_buf;
              }
              s.bi_buf = 0;
              s.bi_valid = 0;
            }
  
            /* ===========================================================================
             * Copy a stored block, storing first the length and its
             * one's complement if requested.
             */
            function copy_block(s, buf, len, header) {
              //DeflateState *s;
              //charf    *buf;    /* the input data */
              //unsigned len;     /* its length */
              //int      header;  /* true if block header must be written */
              bi_windup(s); /* align on byte boundary */
  
              if (header) {
                put_short(s, len);
                put_short(s, ~len);
              }
              //  while (len--) {
              //    put_byte(s, *buf++);
              //  }
              utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
              s.pending += len;
            }
  
            /* ===========================================================================
             * Compares to subtrees, using the tree depth as tie breaker when
             * the subtrees have equal frequency. This minimizes the worst case length.
             */
            function smaller(tree, n, m, depth) {
              var _n2 = n * 2;
              var _m2 = m * 2;
              return (
                tree[_n2] /*.Freq*/ < tree[_m2] /*.Freq*/ ||
                (tree[_n2] /*.Freq*/ === tree[_m2] /*.Freq*/ &&
                  depth[n] <= depth[m])
              );
            }
  
            /* ===========================================================================
             * Restore the heap property by moving down the tree starting at node k,
             * exchanging a node with the smallest of its two sons if necessary, stopping
             * when the heap property is re-established (each father smaller than its
             * two sons).
             */
            function pqdownheap(s, tree, k) {
              //    deflate_state *s;
              //    ct_data *tree;  /* the tree to restore */
              //    int k;               /* node to move down */
              var v = s.heap[k];
              var j = k << 1; /* left son of k */
              while (j <= s.heap_len) {
                /* Set j to the smallest of the two sons: */
                if (
                  j < s.heap_len &&
                  smaller(tree, s.heap[j + 1], s.heap[j], s.depth)
                ) {
                  j++;
                }
                /* Exit if v is smaller than both sons */
                if (smaller(tree, v, s.heap[j], s.depth)) {
                  break;
                }
  
                /* Exchange v with the smallest son */
                s.heap[k] = s.heap[j];
                k = j;
  
                /* And continue down the tree, setting j to the left son of k */
                j <<= 1;
              }
              s.heap[k] = v;
            }
  
            // inlined manually
            // var SMALLEST = 1;
  
            /* ===========================================================================
             * Send the block data compressed using the given Huffman trees
             */
            function compress_block(s, ltree, dtree) {
              //    deflate_state *s;
              //    const ct_data *ltree; /* literal tree */
              //    const ct_data *dtree; /* distance tree */
              var dist; /* distance of matched string */
              var lc; /* match length or unmatched char (if dist == 0) */
              var lx = 0; /* running index in l_buf */
              var code; /* the code to send */
              var extra; /* number of extra bits to send */
  
              if (s.last_lit !== 0) {
                do {
                  dist =
                    (s.pending_buf[s.d_buf + lx * 2] << 8) |
                    s.pending_buf[s.d_buf + lx * 2 + 1];
                  lc = s.pending_buf[s.l_buf + lx];
                  lx++;
  
                  if (dist === 0) {
                    send_code(s, lc, ltree); /* send a literal byte */
                    //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
                  } else {
                    /* Here, lc is the match length - MIN_MATCH */
                    code = _length_code[lc];
                    send_code(
                      s,
                      code + LITERALS + 1,
                      ltree
                    ); /* send the length code */
                    extra = extra_lbits[code];
                    if (extra !== 0) {
                      lc -= base_length[code];
                      send_bits(s, lc, extra); /* send the extra length bits */
                    }
                    dist--; /* dist is now the match distance - 1 */
                    code = d_code(dist);
                    //Assert (code < D_CODES, "bad d_code");
  
                    send_code(s, code, dtree); /* send the distance code */
                    extra = extra_dbits[code];
                    if (extra !== 0) {
                      dist -= base_dist[code];
                      send_bits(
                        s,
                        dist,
                        extra
                      ); /* send the extra distance bits */
                    }
                  } /* literal or match pair ? */
  
                  /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
                  //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
                  //       "pendingBuf overflow");
                } while (lx < s.last_lit);
              }
  
              send_code(s, END_BLOCK, ltree);
            }
  
            /* ===========================================================================
             * Construct one Huffman tree and assigns the code bit strings and lengths.
             * Update the total bit length for the current block.
             * IN assertion: the field freq is set for all tree elements.
             * OUT assertions: the fields len and code are set to the optimal bit length
             *     and corresponding code. The length opt_len is updated; static_len is
             *     also updated if stree is not null. The field max_code is set.
             */
            function build_tree(s, desc) {
              //    deflate_state *s;
              //    tree_desc *desc; /* the tree descriptor */
              var tree = desc.dyn_tree;
              var stree = desc.stat_desc.static_tree;
              var has_stree = desc.stat_desc.has_stree;
              var elems = desc.stat_desc.elems;
              var n, m; /* iterate over heap elements */
              var max_code = -1; /* largest code with non zero frequency */
              var node; /* new node being created */
  
              /* Construct the initial heap, with least frequent element in
               * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
               * heap[0] is not used.
               */
              s.heap_len = 0;
              s.heap_max = HEAP_SIZE;
  
              for (n = 0; n < elems; n++) {
                if (tree[n * 2] /*.Freq*/ !== 0) {
                  s.heap[++s.heap_len] = max_code = n;
                  s.depth[n] = 0;
                } else {
                  tree[n * 2 + 1] /*.Len*/ = 0;
                }
              }
  
              /* The pkzip format requires that at least one distance code exists,
               * and that at least one bit should be sent even if there is only one
               * possible code. So to avoid special checks later on we force at least
               * two codes of non zero frequency.
               */
              while (s.heap_len < 2) {
                node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
                tree[node * 2] /*.Freq*/ = 1;
                s.depth[node] = 0;
                s.opt_len--;
  
                if (has_stree) {
                  s.static_len -= stree[node * 2 + 1] /*.Len*/;
                }
                /* node is 0 or 1 so it does not have extra bits */
              }
              desc.max_code = max_code;
  
              /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
               * establish sub-heaps of increasing lengths:
               */
              for (n = s.heap_len >> 1 /*int /2*/; n >= 1; n--) {
                pqdownheap(s, tree, n);
              }
  
              /* Construct the Huffman tree by repeatedly combining the least two
               * frequent nodes.
               */
              node = elems; /* next internal node of the tree */
              do {
                //pqremove(s, tree, n);  /* n = node of least frequency */
                /*** pqremove ***/
                n = s.heap[1 /*SMALLEST*/];
                s.heap[1 /*SMALLEST*/] = s.heap[s.heap_len--];
                pqdownheap(s, tree, 1 /*SMALLEST*/);
                /***/
  
                m = s.heap[1 /*SMALLEST*/]; /* m = node of next least frequency */
  
                s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
                s.heap[--s.heap_max] = m;
  
                /* Create a new node father of n and m */
                tree[node * 2] /*.Freq*/ =
                  tree[n * 2] /*.Freq*/ + tree[m * 2] /*.Freq*/;
                s.depth[node] =
                  (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
                tree[n * 2 + 1] /*.Dad*/ = tree[m * 2 + 1] /*.Dad*/ = node;
  
                /* and insert the new node in the heap */
                s.heap[1 /*SMALLEST*/] = node++;
                pqdownheap(s, tree, 1 /*SMALLEST*/);
              } while (s.heap_len >= 2);
  
              s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/];
  
              /* At this point, the fields freq and dad are set. We can now
               * generate the bit lengths.
               */
              gen_bitlen(s, desc);
  
              /* The field len is now set, we can generate the bit codes */
              gen_codes(tree, max_code, s.bl_count);
            }
  
            /* ===========================================================================
             * Scan a literal or distance tree to determine the frequencies of the codes
             * in the bit length tree.
             */
            function scan_tree(s, tree, max_code) {
              //    deflate_state *s;
              //    ct_data *tree;   /* the tree to be scanned */
              //    int max_code;    /* and its largest code of non zero frequency */
              var n; /* iterates over all tree elements */
              var prevlen = -1; /* last emitted length */
              var curlen; /* length of current code */
  
              var nextlen = tree[0 * 2 + 1]; /*.Len*/ /* length of next code */
  
              var count = 0; /* repeat count of the current code */
              var max_count = 7; /* max repeat count */
              var min_count = 4; /* min repeat count */
  
              if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
              }
              tree[(max_code + 1) * 2 + 1] /*.Len*/ = 0xffff; /* guard */
  
              for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;
  
                if (++count < max_count && curlen === nextlen) {
                  continue;
                } else if (count < min_count) {
                  s.bl_tree[curlen * 2] /*.Freq*/ += count;
                } else if (curlen !== 0) {
                  if (curlen !== prevlen) {
                    s.bl_tree[curlen * 2] /*.Freq*/++;
                  }
                  s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
                } else if (count <= 10) {
                  s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
                } else {
                  s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
                }
  
                count = 0;
                prevlen = curlen;
  
                if (nextlen === 0) {
                  max_count = 138;
                  min_count = 3;
                } else if (curlen === nextlen) {
                  max_count = 6;
                  min_count = 3;
                } else {
                  max_count = 7;
                  min_count = 4;
                }
              }
            }
  
            /* ===========================================================================
             * Send a literal or distance tree in compressed form, using the codes in
             * bl_tree.
             */
            function send_tree(s, tree, max_code) {
              //    deflate_state *s;
              //    ct_data *tree; /* the tree to be scanned */
              //    int max_code;       /* and its largest code of non zero frequency */
              var n; /* iterates over all tree elements */
              var prevlen = -1; /* last emitted length */
              var curlen; /* length of current code */
  
              var nextlen = tree[0 * 2 + 1]; /*.Len*/ /* length of next code */
  
              var count = 0; /* repeat count of the current code */
              var max_count = 7; /* max repeat count */
              var min_count = 4; /* min repeat count */
  
              /* tree[max_code+1].Len = -1; */ /* guard already set */
              if (nextlen === 0) {
                max_count = 138;
                min_count = 3;
              }
  
              for (n = 0; n <= max_code; n++) {
                curlen = nextlen;
                nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;
  
                if (++count < max_count && curlen === nextlen) {
                  continue;
                } else if (count < min_count) {
                  do {
                    send_code(s, curlen, s.bl_tree);
                  } while (--count !== 0);
                } else if (curlen !== 0) {
                  if (curlen !== prevlen) {
                    send_code(s, curlen, s.bl_tree);
                    count--;
                  }
                  //Assert(count >= 3 && count <= 6, " 3_6?");
                  send_code(s, REP_3_6, s.bl_tree);
                  send_bits(s, count - 3, 2);
                } else if (count <= 10) {
                  send_code(s, REPZ_3_10, s.bl_tree);
                  send_bits(s, count - 3, 3);
                } else {
                  send_code(s, REPZ_11_138, s.bl_tree);
                  send_bits(s, count - 11, 7);
                }
  
                count = 0;
                prevlen = curlen;
                if (nextlen === 0) {
                  max_count = 138;
                  min_count = 3;
                } else if (curlen === nextlen) {
                  max_count = 6;
                  min_count = 3;
                } else {
                  max_count = 7;
                  min_count = 4;
                }
              }
            }
  
            /* ===========================================================================
             * Construct the Huffman tree for the bit lengths and return the index in
             * bl_order of the last bit length code to send.
             */
            function build_bl_tree(s) {
              var max_blindex; /* index of last bit length code of non zero freq */
  
              /* Determine the bit length frequencies for literal and distance trees */
              scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
              scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
  
              /* Build the bit length tree: */
              build_tree(s, s.bl_desc);
              /* opt_len now includes the length of the tree representations, except
               * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
               */
  
              /* Determine the number of bit length codes to send. The pkzip format
               * requires that at least 4 bit length codes be sent. (appnote.txt says
               * 3 but the actual value used is 4.)
               */
              for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
                if (s.bl_tree[bl_order[max_blindex] * 2 + 1] /*.Len*/ !== 0) {
                  break;
                }
              }
              /* Update opt_len to include the bit length tree and counts */
              s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
              //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
              //        s->opt_len, s->static_len));
  
              return max_blindex;
            }
  
            /* ===========================================================================
             * Send the header for a block using dynamic Huffman trees: the counts, the
             * lengths of the bit length codes, the literal tree and the distance tree.
             * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
             */
            function send_all_trees(s, lcodes, dcodes, blcodes) {
              //    deflate_state *s;
              //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
              var rank; /* index in bl_order */
  
              //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
              //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
              //        "too many codes");
              //Tracev((stderr, "\nbl counts: "));
              send_bits(
                s,
                lcodes - 257,
                5
              ); /* not +255 as stated in appnote.txt */
              send_bits(s, dcodes - 1, 5);
              send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
              for (rank = 0; rank < blcodes; rank++) {
                //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
                send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1] /*.Len*/, 3);
              }
              //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
  
              send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
              //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
  
              send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
              //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
            }
  
            /* ===========================================================================
             * Check if the data type is TEXT or BINARY, using the following algorithm:
             * - TEXT if the two conditions below are satisfied:
             *    a) There are no non-portable control characters belonging to the
             *       "black list" (0..6, 14..25, 28..31).
             *    b) There is at least one printable character belonging to the
             *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
             * - BINARY otherwise.
             * - The following partially-portable control characters form a
             *   "gray list" that is ignored in this detection algorithm:
             *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
             * IN assertion: the fields Freq of dyn_ltree are set.
             */
            function detect_data_type(s) {
              /* black_mask is the bit mask of black-listed bytes
               * set bits 0..6, 14..25, and 28..31
               * 0xf3ffc07f = binary 11110011111111111100000001111111
               */
              var black_mask = 0xf3ffc07f;
              var n;
  
              /* Check for non-textual ("black-listed") bytes. */
              for (n = 0; n <= 31; n++, black_mask >>>= 1) {
                if (black_mask & 1 && s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
                  return Z_BINARY;
                }
              }
  
              /* Check for textual ("white-listed") bytes. */
              if (
                s.dyn_ltree[9 * 2] /*.Freq*/ !== 0 ||
                s.dyn_ltree[10 * 2] /*.Freq*/ !== 0 ||
                s.dyn_ltree[13 * 2] /*.Freq*/ !== 0
              ) {
                return Z_TEXT;
              }
              for (n = 32; n < LITERALS; n++) {
                if (s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
                  return Z_TEXT;
                }
              }
  
              /* There are no "black-listed" or "white-listed" bytes:
               * this stream either is empty or has tolerated ("gray-listed") bytes only.
               */
              return Z_BINARY;
            }
  
            var static_init_done = false;
  
            /* ===========================================================================
             * Initialize the tree data structures for a new zlib stream.
             */
            function _tr_init(s) {
              if (!static_init_done) {
                tr_static_init();
                static_init_done = true;
              }
  
              s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
              s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
              s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
  
              s.bi_buf = 0;
              s.bi_valid = 0;
  
              /* Initialize the first block of the first file: */
              init_block(s);
            }
  
            /* ===========================================================================
             * Send a stored block
             */
            function _tr_stored_block(s, buf, stored_len, last) {
              //DeflateState *s;
              //charf *buf;       /* input block */
              //ulg stored_len;   /* length of input block */
              //int last;         /* one if this is the last block for a file */
              send_bits(
                s,
                (STORED_BLOCK << 1) + (last ? 1 : 0),
                3
              ); /* send block type */
              copy_block(s, buf, stored_len, true); /* with header */
            }
  
            /* ===========================================================================
             * Send one empty static block to give enough lookahead for inflate.
             * This takes 10 bits, of which 7 may remain in the bit buffer.
             */
            function _tr_align(s) {
              send_bits(s, STATIC_TREES << 1, 3);
              send_code(s, END_BLOCK, static_ltree);
              bi_flush(s);
            }
  
            /* ===========================================================================
             * Determine the best encoding for the current block: dynamic trees, static
             * trees or store, and output the encoded block to the zip file.
             */
            function _tr_flush_block(s, buf, stored_len, last) {
              //DeflateState *s;
              //charf *buf;       /* input block, or NULL if too old */
              //ulg stored_len;   /* length of input block */
              //int last;         /* one if this is the last block for a file */
              var opt_lenb, static_lenb; /* opt_len and static_len in bytes */
              var max_blindex = 0; /* index of last bit length code of non zero freq */
  
              /* Build the Huffman trees unless a stored block is forced */
              if (s.level > 0) {
                /* Check if the file is binary or text */
                if (s.strm.data_type === Z_UNKNOWN) {
                  s.strm.data_type = detect_data_type(s);
                }
  
                /* Construct the literal and distance trees */
                build_tree(s, s.l_desc);
                // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
  
                build_tree(s, s.d_desc);
                // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
                //        s->static_len));
                /* At this point, opt_len and static_len are the total bit lengths of
                 * the compressed block data, excluding the tree representations.
                 */
  
                /* Build the bit length tree for the above two trees, and get the index
                 * in bl_order of the last bit length code to send.
                 */
                max_blindex = build_bl_tree(s);
  
                /* Determine the best encoding. Compute the block lengths in bytes. */
                opt_lenb = (s.opt_len + 3 + 7) >>> 3;
                static_lenb = (s.static_len + 3 + 7) >>> 3;
  
                // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
                //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
                //        s->last_lit));
  
                if (static_lenb <= opt_lenb) {
                  opt_lenb = static_lenb;
                }
              } else {
                // Assert(buf != (char*)0, "lost buf");
                opt_lenb = static_lenb =
                  stored_len + 5; /* force a stored block */
              }
  
              if (stored_len + 4 <= opt_lenb && buf !== -1) {
                /* 4: two words for the lengths */
  
                /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
                 * Otherwise we can't have processed more than WSIZE input bytes since
                 * the last block flush, because compression would have been
                 * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
                 * transform a block into a stored block.
                 */
                _tr_stored_block(s, buf, stored_len, last);
              } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
                send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
                compress_block(s, static_ltree, static_dtree);
              } else {
                send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
                send_all_trees(
                  s,
                  s.l_desc.max_code + 1,
                  s.d_desc.max_code + 1,
                  max_blindex + 1
                );
                compress_block(s, s.dyn_ltree, s.dyn_dtree);
              }
              // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
              /* The above check is made mod 2^32, for files larger than 512 MB
               * and uLong implemented on 32 bits.
               */
              init_block(s);
  
              if (last) {
                bi_windup(s);
              }
              // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
              //       s->compressed_len-7*last));
            }
  
            /* ===========================================================================
             * Save the match info and tally the frequency counts. Return true if
             * the current block must be flushed.
             */
            function _tr_tally(s, dist, lc) {
              //    deflate_state *s;
              //    unsigned dist;  /* distance of matched string */
              //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
              //var out_length, in_length, dcode;
  
              s.pending_buf[s.d_buf + s.last_lit * 2] = (dist >>> 8) & 0xff;
              s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
  
              s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
              s.last_lit++;
  
              if (dist === 0) {
                /* lc is the unmatched char */
                s.dyn_ltree[lc * 2] /*.Freq*/++;
              } else {
                s.matches++;
                /* Here, lc is the match length - MIN_MATCH */
                dist--; /* dist = match distance - 1 */
                //Assert((ush)dist < (ush)MAX_DIST(s) &&
                //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
                //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
  
                s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
                s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
              }
  
              // (!) This block is disabled in zlib defaults,
              // don't enable it for binary compatibility
  
              //#ifdef TRUNCATE_BLOCK
              //  /* Try to guess if it is profitable to stop the current block here */
              //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
              //    /* Compute an upper bound for the compressed length */
              //    out_length = s.last_lit*8;
              //    in_length = s.strstart - s.block_start;
              //
              //    for (dcode = 0; dcode < D_CODES; dcode++) {
              //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
              //    }
              //    out_length >>>= 3;
              //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
              //    //       s->last_lit, in_length, out_length,
              //    //       100L - out_length*100L/in_length));
              //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
              //      return true;
              //    }
              //  }
              //#endif
  
              return s.last_lit === s.lit_bufsize - 1;
              /* We avoid equality with lit_bufsize because of wraparound at 64K
               * on 16 bit machines and because stored blocks are restricted to
               * 64K-1 bytes.
               */
            }
  
            exports._tr_init = _tr_init;
            exports._tr_stored_block = _tr_stored_block;
            exports._tr_flush_block = _tr_flush_block;
            exports._tr_tally = _tr_tally;
            exports._tr_align = _tr_align;
          },
          { "../utils/common": 43 },
        ],
        53: [
          function (require, module, exports) {
            "use strict";
  
            // (C) 1995-2013 Jean-loup Gailly and Mark Adler
            // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
            //
            // This software is provided 'as-is', without any express or implied
            // warranty. In no event will the authors be held liable for any damages
            // arising from the use of this software.
            //
            // Permission is granted to anyone to use this software for any purpose,
            // including commercial applications, and to alter it and redistribute it
            // freely, subject to the following restrictions:
            //
            // 1. The origin of this software must not be misrepresented; you must not
            //   claim that you wrote the original software. If you use this software
            //   in a product, an acknowledgment in the product documentation would be
            //   appreciated but is not required.
            // 2. Altered source versions must be plainly marked as such, and must not be
            //   misrepresented as being the original software.
            // 3. This notice may not be removed or altered from any source distribution.
  
            function ZStream() {
              /* next input byte */
              this.input = null; // JS specific, because we have no pointers
              this.next_in = 0;
              /* number of bytes available at input */
              this.avail_in = 0;
              /* total number of input bytes read so far */
              this.total_in = 0;
              /* next output byte should be put there */
              this.output = null; // JS specific, because we have no pointers
              this.next_out = 0;
              /* remaining free space at output */
              this.avail_out = 0;
              /* total number of bytes output so far */
              this.total_out = 0;
              /* last error message, NULL if no error */
              this.msg = "" /*Z_NULL*/;
              /* not visible by applications */
              this.state = null;
              /* best guess about the data type: binary or text */
              this.data_type = 2 /*Z_UNKNOWN*/;
              /* adler32 value of the uncompressed data */
              this.adler = 0;
            }
  
            module.exports = ZStream;
          },
          {},
        ],
        54: [
          function (require, module, exports) {
            arguments[4][40][0].apply(exports, arguments);
          },
          { dup: 40 },
        ],
        55: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                /*!
                 * The buffer module from node.js, for the browser.
                 *
                 * @author   Feross Aboukhadijeh <https://feross.org>
                 * @license  MIT
                 */
                /* eslint-disable no-proto */
  
                "use strict";
  
                var base64 = require("base64-js");
                var ieee754 = require("ieee754");
                var customInspectSymbol =
                  typeof Symbol === "function" &&
                  typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
                    ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
                    : null;
  
                exports.Buffer = Buffer;
                exports.SlowBuffer = SlowBuffer;
                exports.INSPECT_MAX_BYTES = 50;
  
                var K_MAX_LENGTH = 0x7fffffff;
                exports.kMaxLength = K_MAX_LENGTH;
  
                /**
                 * If `Buffer.TYPED_ARRAY_SUPPORT`:
                 *   === true    Use Uint8Array implementation (fastest)
                 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
                 *               implementation (most compatible, even IE6)
                 *
                 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
                 * Opera 11.6+, iOS 4.2+.
                 *
                 * We report that the browser does not support typed arrays if the are not subclassable
                 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
                 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
                 * for __proto__ and has a buggy typed array implementation.
                 */
                Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
  
                if (
                  !Buffer.TYPED_ARRAY_SUPPORT &&
                  typeof console !== "undefined" &&
                  typeof console.error === "function"
                ) {
                  console.error(
                    "This browser lacks typed array (Uint8Array) support which is required by " +
                      "`buffer` v5.x. Use `buffer` v4.x if you require old browser support."
                  );
                }
  
                function typedArraySupport() {
                  // Can typed array instances can be augmented?
                  try {
                    var arr = new Uint8Array(1);
                    var proto = {
                      foo: function () {
                        return 42;
                      },
                    };
                    Object.setPrototypeOf(proto, Uint8Array.prototype);
                    Object.setPrototypeOf(arr, proto);
                    return arr.foo() === 42;
                  } catch (e) {
                    return false;
                  }
                }
  
                Object.defineProperty(Buffer.prototype, "parent", {
                  enumerable: true,
                  get: function () {
                    if (!Buffer.isBuffer(this)) return undefined;
                    return this.buffer;
                  },
                });
  
                Object.defineProperty(Buffer.prototype, "offset", {
                  enumerable: true,
                  get: function () {
                    if (!Buffer.isBuffer(this)) return undefined;
                    return this.byteOffset;
                  },
                });
  
                function createBuffer(length) {
                  if (length > K_MAX_LENGTH) {
                    throw new RangeError(
                      'The value "' + length + '" is invalid for option "size"'
                    );
                  }
                  // Return an augmented `Uint8Array` instance
                  var buf = new Uint8Array(length);
                  Object.setPrototypeOf(buf, Buffer.prototype);
                  return buf;
                }
  
                /**
                 * The Buffer constructor returns instances of `Uint8Array` that have their
                 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
                 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
                 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
                 * returns a single octet.
                 *
                 * The `Uint8Array` prototype remains unmodified.
                 */
  
                function Buffer(arg, encodingOrOffset, length) {
                  // Common case.
                  if (typeof arg === "number") {
                    if (typeof encodingOrOffset === "string") {
                      throw new TypeError(
                        'The "string" argument must be of type string. Received type number'
                      );
                    }
                    return allocUnsafe(arg);
                  }
                  return from(arg, encodingOrOffset, length);
                }
  
                Buffer.poolSize = 8192; // not used by this implementation
  
                function from(value, encodingOrOffset, length) {
                  if (typeof value === "string") {
                    return fromString(value, encodingOrOffset);
                  }
  
                  if (ArrayBuffer.isView(value)) {
                    return fromArrayView(value);
                  }
  
                  if (value == null) {
                    throw new TypeError(
                      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, " +
                        "or Array-like Object. Received type " +
                        typeof value
                    );
                  }
  
                  if (
                    isInstance(value, ArrayBuffer) ||
                    (value && isInstance(value.buffer, ArrayBuffer))
                  ) {
                    return fromArrayBuffer(value, encodingOrOffset, length);
                  }
  
                  if (
                    typeof SharedArrayBuffer !== "undefined" &&
                    (isInstance(value, SharedArrayBuffer) ||
                      (value && isInstance(value.buffer, SharedArrayBuffer)))
                  ) {
                    return fromArrayBuffer(value, encodingOrOffset, length);
                  }
  
                  if (typeof value === "number") {
                    throw new TypeError(
                      'The "value" argument must not be of type number. Received type number'
                    );
                  }
  
                  var valueOf = value.valueOf && value.valueOf();
                  if (valueOf != null && valueOf !== value) {
                    return Buffer.from(valueOf, encodingOrOffset, length);
                  }
  
                  var b = fromObject(value);
                  if (b) return b;
  
                  if (
                    typeof Symbol !== "undefined" &&
                    Symbol.toPrimitive != null &&
                    typeof value[Symbol.toPrimitive] === "function"
                  ) {
                    return Buffer.from(
                      value[Symbol.toPrimitive]("string"),
                      encodingOrOffset,
                      length
                    );
                  }
  
                  throw new TypeError(
                    "The first argument must be one of type string, Buffer, ArrayBuffer, Array, " +
                      "or Array-like Object. Received type " +
                      typeof value
                  );
                }
  
                /**
                 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
                 * if value is a number.
                 * Buffer.from(str[, encoding])
                 * Buffer.from(array)
                 * Buffer.from(buffer)
                 * Buffer.from(arrayBuffer[, byteOffset[, length]])
                 **/
                Buffer.from = function (value, encodingOrOffset, length) {
                  return from(value, encodingOrOffset, length);
                };
  
                // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
                // https://github.com/feross/buffer/pull/148
                Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
                Object.setPrototypeOf(Buffer, Uint8Array);
  
                function assertSize(size) {
                  if (typeof size !== "number") {
                    throw new TypeError('"size" argument must be of type number');
                  } else if (size < 0) {
                    throw new RangeError(
                      'The value "' + size + '" is invalid for option "size"'
                    );
                  }
                }
  
                function alloc(size, fill, encoding) {
                  assertSize(size);
                  if (size <= 0) {
                    return createBuffer(size);
                  }
                  if (fill !== undefined) {
                    // Only pay attention to encoding if it's a string. This
                    // prevents accidentally sending in a number that would
                    // be interpreted as a start offset.
                    return typeof encoding === "string"
                      ? createBuffer(size).fill(fill, encoding)
                      : createBuffer(size).fill(fill);
                  }
                  return createBuffer(size);
                }
  
                /**
                 * Creates a new filled Buffer instance.
                 * alloc(size[, fill[, encoding]])
                 **/
                Buffer.alloc = function (size, fill, encoding) {
                  return alloc(size, fill, encoding);
                };
  
                function allocUnsafe(size) {
                  assertSize(size);
                  return createBuffer(size < 0 ? 0 : checked(size) | 0);
                }
  
                /**
                 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
                 * */
                Buffer.allocUnsafe = function (size) {
                  return allocUnsafe(size);
                };
                /**
                 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
                 */
                Buffer.allocUnsafeSlow = function (size) {
                  return allocUnsafe(size);
                };
  
                function fromString(string, encoding) {
                  if (typeof encoding !== "string" || encoding === "") {
                    encoding = "utf8";
                  }
  
                  if (!Buffer.isEncoding(encoding)) {
                    throw new TypeError("Unknown encoding: " + encoding);
                  }
  
                  var length = byteLength(string, encoding) | 0;
                  var buf = createBuffer(length);
  
                  var actual = buf.write(string, encoding);
  
                  if (actual !== length) {
                    // Writing a hex string, for example, that contains invalid characters will
                    // cause everything after the first invalid character to be ignored. (e.g.
                    // 'abxxcd' will be treated as 'ab')
                    buf = buf.slice(0, actual);
                  }
  
                  return buf;
                }
  
                function fromArrayLike(array) {
                  var length = array.length < 0 ? 0 : checked(array.length) | 0;
                  var buf = createBuffer(length);
                  for (var i = 0; i < length; i += 1) {
                    buf[i] = array[i] & 255;
                  }
                  return buf;
                }
  
                function fromArrayView(arrayView) {
                  if (isInstance(arrayView, Uint8Array)) {
                    var copy = new Uint8Array(arrayView);
                    return fromArrayBuffer(
                      copy.buffer,
                      copy.byteOffset,
                      copy.byteLength
                    );
                  }
                  return fromArrayLike(arrayView);
                }
  
                function fromArrayBuffer(array, byteOffset, length) {
                  if (byteOffset < 0 || array.byteLength < byteOffset) {
                    throw new RangeError('"offset" is outside of buffer bounds');
                  }
  
                  if (array.byteLength < byteOffset + (length || 0)) {
                    throw new RangeError('"length" is outside of buffer bounds');
                  }
  
                  var buf;
                  if (byteOffset === undefined && length === undefined) {
                    buf = new Uint8Array(array);
                  } else if (length === undefined) {
                    buf = new Uint8Array(array, byteOffset);
                  } else {
                    buf = new Uint8Array(array, byteOffset, length);
                  }
  
                  // Return an augmented `Uint8Array` instance
                  Object.setPrototypeOf(buf, Buffer.prototype);
  
                  return buf;
                }
  
                function fromObject(obj) {
                  if (Buffer.isBuffer(obj)) {
                    var len = checked(obj.length) | 0;
                    var buf = createBuffer(len);
  
                    if (buf.length === 0) {
                      return buf;
                    }
  
                    obj.copy(buf, 0, 0, len);
                    return buf;
                  }
  
                  if (obj.length !== undefined) {
                    if (
                      typeof obj.length !== "number" ||
                      numberIsNaN(obj.length)
                    ) {
                      return createBuffer(0);
                    }
                    return fromArrayLike(obj);
                  }
  
                  if (obj.type === "Buffer" && Array.isArray(obj.data)) {
                    return fromArrayLike(obj.data);
                  }
                }
  
                function checked(length) {
                  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
                  // length is NaN (which is otherwise coerced to zero.)
                  if (length >= K_MAX_LENGTH) {
                    throw new RangeError(
                      "Attempt to allocate Buffer larger than maximum " +
                        "size: 0x" +
                        K_MAX_LENGTH.toString(16) +
                        " bytes"
                    );
                  }
                  return length | 0;
                }
  
                function SlowBuffer(length) {
                  if (+length != length) {
                    // eslint-disable-line eqeqeq
                    length = 0;
                  }
                  return Buffer.alloc(+length);
                }
  
                Buffer.isBuffer = function isBuffer(b) {
                  return (
                    b != null && b._isBuffer === true && b !== Buffer.prototype
                  ); // so Buffer.isBuffer(Buffer.prototype) will be false
                };
  
                Buffer.compare = function compare(a, b) {
                  if (isInstance(a, Uint8Array))
                    a = Buffer.from(a, a.offset, a.byteLength);
                  if (isInstance(b, Uint8Array))
                    b = Buffer.from(b, b.offset, b.byteLength);
                  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
                    throw new TypeError(
                      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                    );
                  }
  
                  if (a === b) return 0;
  
                  var x = a.length;
                  var y = b.length;
  
                  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
                    if (a[i] !== b[i]) {
                      x = a[i];
                      y = b[i];
                      break;
                    }
                  }
  
                  if (x < y) return -1;
                  if (y < x) return 1;
                  return 0;
                };
  
                Buffer.isEncoding = function isEncoding(encoding) {
                  switch (String(encoding).toLowerCase()) {
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "latin1":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                      return true;
                    default:
                      return false;
                  }
                };
  
                Buffer.concat = function concat(list, length) {
                  if (!Array.isArray(list)) {
                    throw new TypeError(
                      '"list" argument must be an Array of Buffers'
                    );
                  }
  
                  if (list.length === 0) {
                    return Buffer.alloc(0);
                  }
  
                  var i;
                  if (length === undefined) {
                    length = 0;
                    for (i = 0; i < list.length; ++i) {
                      length += list[i].length;
                    }
                  }
  
                  var buffer = Buffer.allocUnsafe(length);
                  var pos = 0;
                  for (i = 0; i < list.length; ++i) {
                    var buf = list[i];
                    if (isInstance(buf, Uint8Array)) {
                      if (pos + buf.length > buffer.length) {
                        Buffer.from(buf).copy(buffer, pos);
                      } else {
                        Uint8Array.prototype.set.call(buffer, buf, pos);
                      }
                    } else if (!Buffer.isBuffer(buf)) {
                      throw new TypeError(
                        '"list" argument must be an Array of Buffers'
                      );
                    } else {
                      buf.copy(buffer, pos);
                    }
                    pos += buf.length;
                  }
                  return buffer;
                };
  
                function byteLength(string, encoding) {
                  if (Buffer.isBuffer(string)) {
                    return string.length;
                  }
                  if (
                    ArrayBuffer.isView(string) ||
                    isInstance(string, ArrayBuffer)
                  ) {
                    return string.byteLength;
                  }
                  if (typeof string !== "string") {
                    throw new TypeError(
                      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
                        "Received type " +
                        typeof string
                    );
                  }
  
                  var len = string.length;
                  var mustMatch = arguments.length > 2 && arguments[2] === true;
                  if (!mustMatch && len === 0) return 0;
  
                  // Use a for loop to avoid recursion
                  var loweredCase = false;
                  for (;;) {
                    switch (encoding) {
                      case "ascii":
                      case "latin1":
                      case "binary":
                        return len;
                      case "utf8":
                      case "utf-8":
                        return utf8ToBytes(string).length;
                      case "ucs2":
                      case "ucs-2":
                      case "utf16le":
                      case "utf-16le":
                        return len * 2;
                      case "hex":
                        return len >>> 1;
                      case "base64":
                        return base64ToBytes(string).length;
                      default:
                        if (loweredCase) {
                          return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                        }
                        encoding = ("" + encoding).toLowerCase();
                        loweredCase = true;
                    }
                  }
                }
                Buffer.byteLength = byteLength;
  
                function slowToString(encoding, start, end) {
                  var loweredCase = false;
  
                  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
                  // property of a typed array.
  
                  // This behaves neither like String nor Uint8Array in that we set start/end
                  // to their upper/lower bounds if the value passed is out of range.
                  // undefined is handled specially as per ECMA-262 6th Edition,
                  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
                  if (start === undefined || start < 0) {
                    start = 0;
                  }
                  // Return early if start > this.length. Done here to prevent potential uint32
                  // coercion fail below.
                  if (start > this.length) {
                    return "";
                  }
  
                  if (end === undefined || end > this.length) {
                    end = this.length;
                  }
  
                  if (end <= 0) {
                    return "";
                  }
  
                  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
                  end >>>= 0;
                  start >>>= 0;
  
                  if (end <= start) {
                    return "";
                  }
  
                  if (!encoding) encoding = "utf8";
  
                  while (true) {
                    switch (encoding) {
                      case "hex":
                        return hexSlice(this, start, end);
  
                      case "utf8":
                      case "utf-8":
                        return utf8Slice(this, start, end);
  
                      case "ascii":
                        return asciiSlice(this, start, end);
  
                      case "latin1":
                      case "binary":
                        return latin1Slice(this, start, end);
  
                      case "base64":
                        return base64Slice(this, start, end);
  
                      case "ucs2":
                      case "ucs-2":
                      case "utf16le":
                      case "utf-16le":
                        return utf16leSlice(this, start, end);
  
                      default:
                        if (loweredCase)
                          throw new TypeError("Unknown encoding: " + encoding);
                        encoding = (encoding + "").toLowerCase();
                        loweredCase = true;
                    }
                  }
                }
  
                // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
                // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
                // reliably in a browserify context because there could be multiple different
                // copies of the 'buffer' package in use. This method works even for Buffer
                // instances that were created from another copy of the `buffer` package.
                // See: https://github.com/feross/buffer/issues/154
                Buffer.prototype._isBuffer = true;
  
                function swap(b, n, m) {
                  var i = b[n];
                  b[n] = b[m];
                  b[m] = i;
                }
  
                Buffer.prototype.swap16 = function swap16() {
                  var len = this.length;
                  if (len % 2 !== 0) {
                    throw new RangeError(
                      "Buffer size must be a multiple of 16-bits"
                    );
                  }
                  for (var i = 0; i < len; i += 2) {
                    swap(this, i, i + 1);
                  }
                  return this;
                };
  
                Buffer.prototype.swap32 = function swap32() {
                  var len = this.length;
                  if (len % 4 !== 0) {
                    throw new RangeError(
                      "Buffer size must be a multiple of 32-bits"
                    );
                  }
                  for (var i = 0; i < len; i += 4) {
                    swap(this, i, i + 3);
                    swap(this, i + 1, i + 2);
                  }
                  return this;
                };
  
                Buffer.prototype.swap64 = function swap64() {
                  var len = this.length;
                  if (len % 8 !== 0) {
                    throw new RangeError(
                      "Buffer size must be a multiple of 64-bits"
                    );
                  }
                  for (var i = 0; i < len; i += 8) {
                    swap(this, i, i + 7);
                    swap(this, i + 1, i + 6);
                    swap(this, i + 2, i + 5);
                    swap(this, i + 3, i + 4);
                  }
                  return this;
                };
  
                Buffer.prototype.toString = function toString() {
                  var length = this.length;
                  if (length === 0) return "";
                  if (arguments.length === 0) return utf8Slice(this, 0, length);
                  return slowToString.apply(this, arguments);
                };
  
                Buffer.prototype.toLocaleString = Buffer.prototype.toString;
  
                Buffer.prototype.equals = function equals(b) {
                  if (!Buffer.isBuffer(b))
                    throw new TypeError("Argument must be a Buffer");
                  if (this === b) return true;
                  return Buffer.compare(this, b) === 0;
                };
  
                Buffer.prototype.inspect = function inspect() {
                  var str = "";
                  var max = exports.INSPECT_MAX_BYTES;
                  str = this.toString("hex", 0, max)
                    .replace(/(.{2})/g, "$1 ")
                    .trim();
                  if (this.length > max) str += " ... ";
                  return "<Buffer " + str + ">";
                };
                if (customInspectSymbol) {
                  Buffer.prototype[customInspectSymbol] =
                    Buffer.prototype.inspect;
                }
  
                Buffer.prototype.compare = function compare(
                  target,
                  start,
                  end,
                  thisStart,
                  thisEnd
                ) {
                  if (isInstance(target, Uint8Array)) {
                    target = Buffer.from(
                      target,
                      target.offset,
                      target.byteLength
                    );
                  }
                  if (!Buffer.isBuffer(target)) {
                    throw new TypeError(
                      'The "target" argument must be one of type Buffer or Uint8Array. ' +
                        "Received type " +
                        typeof target
                    );
                  }
  
                  if (start === undefined) {
                    start = 0;
                  }
                  if (end === undefined) {
                    end = target ? target.length : 0;
                  }
                  if (thisStart === undefined) {
                    thisStart = 0;
                  }
                  if (thisEnd === undefined) {
                    thisEnd = this.length;
                  }
  
                  if (
                    start < 0 ||
                    end > target.length ||
                    thisStart < 0 ||
                    thisEnd > this.length
                  ) {
                    throw new RangeError("out of range index");
                  }
  
                  if (thisStart >= thisEnd && start >= end) {
                    return 0;
                  }
                  if (thisStart >= thisEnd) {
                    return -1;
                  }
                  if (start >= end) {
                    return 1;
                  }
  
                  start >>>= 0;
                  end >>>= 0;
                  thisStart >>>= 0;
                  thisEnd >>>= 0;
  
                  if (this === target) return 0;
  
                  var x = thisEnd - thisStart;
                  var y = end - start;
                  var len = Math.min(x, y);
  
                  var thisCopy = this.slice(thisStart, thisEnd);
                  var targetCopy = target.slice(start, end);
  
                  for (var i = 0; i < len; ++i) {
                    if (thisCopy[i] !== targetCopy[i]) {
                      x = thisCopy[i];
                      y = targetCopy[i];
                      break;
                    }
                  }
  
                  if (x < y) return -1;
                  if (y < x) return 1;
                  return 0;
                };
  
                // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
                // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
                //
                // Arguments:
                // - buffer - a Buffer to search
                // - val - a string, Buffer, or number
                // - byteOffset - an index into `buffer`; will be clamped to an int32
                // - encoding - an optional encoding, relevant is val is a string
                // - dir - true for indexOf, false for lastIndexOf
                function bidirectionalIndexOf(
                  buffer,
                  val,
                  byteOffset,
                  encoding,
                  dir
                ) {
                  // Empty buffer means no match
                  if (buffer.length === 0) return -1;
  
                  // Normalize byteOffset
                  if (typeof byteOffset === "string") {
                    encoding = byteOffset;
                    byteOffset = 0;
                  } else if (byteOffset > 0x7fffffff) {
                    byteOffset = 0x7fffffff;
                  } else if (byteOffset < -0x80000000) {
                    byteOffset = -0x80000000;
                  }
                  byteOffset = +byteOffset; // Coerce to Number.
                  if (numberIsNaN(byteOffset)) {
                    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
                    byteOffset = dir ? 0 : buffer.length - 1;
                  }
  
                  // Normalize byteOffset: negative offsets start from the end of the buffer
                  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
                  if (byteOffset >= buffer.length) {
                    if (dir) return -1;
                    else byteOffset = buffer.length - 1;
                  } else if (byteOffset < 0) {
                    if (dir) byteOffset = 0;
                    else return -1;
                  }
  
                  // Normalize val
                  if (typeof val === "string") {
                    val = Buffer.from(val, encoding);
                  }
  
                  // Finally, search either indexOf (if dir is true) or lastIndexOf
                  if (Buffer.isBuffer(val)) {
                    // Special case: looking for empty string/buffer always fails
                    if (val.length === 0) {
                      return -1;
                    }
                    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
                  } else if (typeof val === "number") {
                    val = val & 0xff; // Search for a byte value [0-255]
                    if (typeof Uint8Array.prototype.indexOf === "function") {
                      if (dir) {
                        return Uint8Array.prototype.indexOf.call(
                          buffer,
                          val,
                          byteOffset
                        );
                      } else {
                        return Uint8Array.prototype.lastIndexOf.call(
                          buffer,
                          val,
                          byteOffset
                        );
                      }
                    }
                    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
                  }
  
                  throw new TypeError("val must be string, number or Buffer");
                }
  
                function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
                  var indexSize = 1;
                  var arrLength = arr.length;
                  var valLength = val.length;
  
                  if (encoding !== undefined) {
                    encoding = String(encoding).toLowerCase();
                    if (
                      encoding === "ucs2" ||
                      encoding === "ucs-2" ||
                      encoding === "utf16le" ||
                      encoding === "utf-16le"
                    ) {
                      if (arr.length < 2 || val.length < 2) {
                        return -1;
                      }
                      indexSize = 2;
                      arrLength /= 2;
                      valLength /= 2;
                      byteOffset /= 2;
                    }
                  }
  
                  function read(buf, i) {
                    if (indexSize === 1) {
                      return buf[i];
                    } else {
                      return buf.readUInt16BE(i * indexSize);
                    }
                  }
  
                  var i;
                  if (dir) {
                    var foundIndex = -1;
                    for (i = byteOffset; i < arrLength; i++) {
                      if (
                        read(arr, i) ===
                        read(val, foundIndex === -1 ? 0 : i - foundIndex)
                      ) {
                        if (foundIndex === -1) foundIndex = i;
                        if (i - foundIndex + 1 === valLength)
                          return foundIndex * indexSize;
                      } else {
                        if (foundIndex !== -1) i -= i - foundIndex;
                        foundIndex = -1;
                      }
                    }
                  } else {
                    if (byteOffset + valLength > arrLength)
                      byteOffset = arrLength - valLength;
                    for (i = byteOffset; i >= 0; i--) {
                      var found = true;
                      for (var j = 0; j < valLength; j++) {
                        if (read(arr, i + j) !== read(val, j)) {
                          found = false;
                          break;
                        }
                      }
                      if (found) return i;
                    }
                  }
  
                  return -1;
                }
  
                Buffer.prototype.includes = function includes(
                  val,
                  byteOffset,
                  encoding
                ) {
                  return this.indexOf(val, byteOffset, encoding) !== -1;
                };
  
                Buffer.prototype.indexOf = function indexOf(
                  val,
                  byteOffset,
                  encoding
                ) {
                  return bidirectionalIndexOf(
                    this,
                    val,
                    byteOffset,
                    encoding,
                    true
                  );
                };
  
                Buffer.prototype.lastIndexOf = function lastIndexOf(
                  val,
                  byteOffset,
                  encoding
                ) {
                  return bidirectionalIndexOf(
                    this,
                    val,
                    byteOffset,
                    encoding,
                    false
                  );
                };
  
                function hexWrite(buf, string, offset, length) {
                  offset = Number(offset) || 0;
                  var remaining = buf.length - offset;
                  if (!length) {
                    length = remaining;
                  } else {
                    length = Number(length);
                    if (length > remaining) {
                      length = remaining;
                    }
                  }
  
                  var strLen = string.length;
  
                  if (length > strLen / 2) {
                    length = strLen / 2;
                  }
                  for (var i = 0; i < length; ++i) {
                    var parsed = parseInt(string.substr(i * 2, 2), 16);
                    if (numberIsNaN(parsed)) return i;
                    buf[offset + i] = parsed;
                  }
                  return i;
                }
  
                function utf8Write(buf, string, offset, length) {
                  return blitBuffer(
                    utf8ToBytes(string, buf.length - offset),
                    buf,
                    offset,
                    length
                  );
                }
  
                function asciiWrite(buf, string, offset, length) {
                  return blitBuffer(asciiToBytes(string), buf, offset, length);
                }
  
                function base64Write(buf, string, offset, length) {
                  return blitBuffer(base64ToBytes(string), buf, offset, length);
                }
  
                function ucs2Write(buf, string, offset, length) {
                  return blitBuffer(
                    utf16leToBytes(string, buf.length - offset),
                    buf,
                    offset,
                    length
                  );
                }
  
                Buffer.prototype.write = function write(
                  string,
                  offset,
                  length,
                  encoding
                ) {
                  // Buffer#write(string)
                  if (offset === undefined) {
                    encoding = "utf8";
                    length = this.length;
                    offset = 0;
                    // Buffer#write(string, encoding)
                  } else if (length === undefined && typeof offset === "string") {
                    encoding = offset;
                    length = this.length;
                    offset = 0;
                    // Buffer#write(string, offset[, length][, encoding])
                  } else if (isFinite(offset)) {
                    offset = offset >>> 0;
                    if (isFinite(length)) {
                      length = length >>> 0;
                      if (encoding === undefined) encoding = "utf8";
                    } else {
                      encoding = length;
                      length = undefined;
                    }
                  } else {
                    throw new Error(
                      "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                    );
                  }
  
                  var remaining = this.length - offset;
                  if (length === undefined || length > remaining)
                    length = remaining;
  
                  if (
                    (string.length > 0 && (length < 0 || offset < 0)) ||
                    offset > this.length
                  ) {
                    throw new RangeError(
                      "Attempt to write outside buffer bounds"
                    );
                  }
  
                  if (!encoding) encoding = "utf8";
  
                  var loweredCase = false;
                  for (;;) {
                    switch (encoding) {
                      case "hex":
                        return hexWrite(this, string, offset, length);
  
                      case "utf8":
                      case "utf-8":
                        return utf8Write(this, string, offset, length);
  
                      case "ascii":
                      case "latin1":
                      case "binary":
                        return asciiWrite(this, string, offset, length);
  
                      case "base64":
                        // Warning: maxLength not taken into account in base64Write
                        return base64Write(this, string, offset, length);
  
                      case "ucs2":
                      case "ucs-2":
                      case "utf16le":
                      case "utf-16le":
                        return ucs2Write(this, string, offset, length);
  
                      default:
                        if (loweredCase)
                          throw new TypeError("Unknown encoding: " + encoding);
                        encoding = ("" + encoding).toLowerCase();
                        loweredCase = true;
                    }
                  }
                };
  
                Buffer.prototype.toJSON = function toJSON() {
                  return {
                    type: "Buffer",
                    data: Array.prototype.slice.call(this._arr || this, 0),
                  };
                };
  
                function base64Slice(buf, start, end) {
                  if (start === 0 && end === buf.length) {
                    return base64.fromByteArray(buf);
                  } else {
                    return base64.fromByteArray(buf.slice(start, end));
                  }
                }
  
                function utf8Slice(buf, start, end) {
                  end = Math.min(buf.length, end);
                  var res = [];
  
                  var i = start;
                  while (i < end) {
                    var firstByte = buf[i];
                    var codePoint = null;
                    var bytesPerSequence =
                      firstByte > 0xef
                        ? 4
                        : firstByte > 0xdf
                        ? 3
                        : firstByte > 0xbf
                        ? 2
                        : 1;
  
                    if (i + bytesPerSequence <= end) {
                      var secondByte, thirdByte, fourthByte, tempCodePoint;
  
                      switch (bytesPerSequence) {
                        case 1:
                          if (firstByte < 0x80) {
                            codePoint = firstByte;
                          }
                          break;
                        case 2:
                          secondByte = buf[i + 1];
                          if ((secondByte & 0xc0) === 0x80) {
                            tempCodePoint =
                              ((firstByte & 0x1f) << 0x6) | (secondByte & 0x3f);
                            if (tempCodePoint > 0x7f) {
                              codePoint = tempCodePoint;
                            }
                          }
                          break;
                        case 3:
                          secondByte = buf[i + 1];
                          thirdByte = buf[i + 2];
                          if (
                            (secondByte & 0xc0) === 0x80 &&
                            (thirdByte & 0xc0) === 0x80
                          ) {
                            tempCodePoint =
                              ((firstByte & 0xf) << 0xc) |
                              ((secondByte & 0x3f) << 0x6) |
                              (thirdByte & 0x3f);
                            if (
                              tempCodePoint > 0x7ff &&
                              (tempCodePoint < 0xd800 || tempCodePoint > 0xdfff)
                            ) {
                              codePoint = tempCodePoint;
                            }
                          }
                          break;
                        case 4:
                          secondByte = buf[i + 1];
                          thirdByte = buf[i + 2];
                          fourthByte = buf[i + 3];
                          if (
                            (secondByte & 0xc0) === 0x80 &&
                            (thirdByte & 0xc0) === 0x80 &&
                            (fourthByte & 0xc0) === 0x80
                          ) {
                            tempCodePoint =
                              ((firstByte & 0xf) << 0x12) |
                              ((secondByte & 0x3f) << 0xc) |
                              ((thirdByte & 0x3f) << 0x6) |
                              (fourthByte & 0x3f);
                            if (
                              tempCodePoint > 0xffff &&
                              tempCodePoint < 0x110000
                            ) {
                              codePoint = tempCodePoint;
                            }
                          }
                      }
                    }
  
                    if (codePoint === null) {
                      // we did not generate a valid codePoint so insert a
                      // replacement char (U+FFFD) and advance only 1 byte
                      codePoint = 0xfffd;
                      bytesPerSequence = 1;
                    } else if (codePoint > 0xffff) {
                      // encode to utf16 (surrogate pair dance)
                      codePoint -= 0x10000;
                      res.push(((codePoint >>> 10) & 0x3ff) | 0xd800);
                      codePoint = 0xdc00 | (codePoint & 0x3ff);
                    }
  
                    res.push(codePoint);
                    i += bytesPerSequence;
                  }
  
                  return decodeCodePointsArray(res);
                }
  
                // Based on http://stackoverflow.com/a/22747272/680742, the browser with
                // the lowest limit is Chrome, with 0x10000 args.
                // We go 1 magnitude less, for safety
                var MAX_ARGUMENTS_LENGTH = 0x1000;
  
                function decodeCodePointsArray(codePoints) {
                  var len = codePoints.length;
                  if (len <= MAX_ARGUMENTS_LENGTH) {
                    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
                  }
  
                  // Decode in chunks to avoid "call stack size exceeded".
                  var res = "";
                  var i = 0;
                  while (i < len) {
                    res += String.fromCharCode.apply(
                      String,
                      codePoints.slice(i, (i += MAX_ARGUMENTS_LENGTH))
                    );
                  }
                  return res;
                }
  
                function asciiSlice(buf, start, end) {
                  var ret = "";
                  end = Math.min(buf.length, end);
  
                  for (var i = start; i < end; ++i) {
                    ret += String.fromCharCode(buf[i] & 0x7f);
                  }
                  return ret;
                }
  
                function latin1Slice(buf, start, end) {
                  var ret = "";
                  end = Math.min(buf.length, end);
  
                  for (var i = start; i < end; ++i) {
                    ret += String.fromCharCode(buf[i]);
                  }
                  return ret;
                }
  
                function hexSlice(buf, start, end) {
                  var len = buf.length;
  
                  if (!start || start < 0) start = 0;
                  if (!end || end < 0 || end > len) end = len;
  
                  var out = "";
                  for (var i = start; i < end; ++i) {
                    out += hexSliceLookupTable[buf[i]];
                  }
                  return out;
                }
  
                function utf16leSlice(buf, start, end) {
                  var bytes = buf.slice(start, end);
                  var res = "";
                  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
                  for (var i = 0; i < bytes.length - 1; i += 2) {
                    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
                  }
                  return res;
                }
  
                Buffer.prototype.slice = function slice(start, end) {
                  var len = this.length;
                  start = ~~start;
                  end = end === undefined ? len : ~~end;
  
                  if (start < 0) {
                    start += len;
                    if (start < 0) start = 0;
                  } else if (start > len) {
                    start = len;
                  }
  
                  if (end < 0) {
                    end += len;
                    if (end < 0) end = 0;
                  } else if (end > len) {
                    end = len;
                  }
  
                  if (end < start) end = start;
  
                  var newBuf = this.subarray(start, end);
                  // Return an augmented `Uint8Array` instance
                  Object.setPrototypeOf(newBuf, Buffer.prototype);
  
                  return newBuf;
                };
  
                /*
                 * Need to make sure that buffer isn't trying to write out of bounds.
                 */
                function checkOffset(offset, ext, length) {
                  if (offset % 1 !== 0 || offset < 0)
                    throw new RangeError("offset is not uint");
                  if (offset + ext > length)
                    throw new RangeError("Trying to access beyond buffer length");
                }
  
                Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE =
                  function readUIntLE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) checkOffset(offset, byteLength, this.length);
  
                    var val = this[offset];
                    var mul = 1;
                    var i = 0;
                    while (++i < byteLength && (mul *= 0x100)) {
                      val += this[offset + i] * mul;
                    }
  
                    return val;
                  };
  
                Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE =
                  function readUIntBE(offset, byteLength, noAssert) {
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                      checkOffset(offset, byteLength, this.length);
                    }
  
                    var val = this[offset + --byteLength];
                    var mul = 1;
                    while (byteLength > 0 && (mul *= 0x100)) {
                      val += this[offset + --byteLength] * mul;
                    }
  
                    return val;
                  };
  
                Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 =
                  function readUInt8(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 1, this.length);
                    return this[offset];
                  };
  
                Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE =
                  function readUInt16LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return this[offset] | (this[offset + 1] << 8);
                  };
  
                Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE =
                  function readUInt16BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 2, this.length);
                    return (this[offset] << 8) | this[offset + 1];
                  };
  
                Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE =
                  function readUInt32LE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
  
                    return (
                      (this[offset] |
                        (this[offset + 1] << 8) |
                        (this[offset + 2] << 16)) +
                      this[offset + 3] * 0x1000000
                    );
                  };
  
                Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE =
                  function readUInt32BE(offset, noAssert) {
                    offset = offset >>> 0;
                    if (!noAssert) checkOffset(offset, 4, this.length);
  
                    return (
                      this[offset] * 0x1000000 +
                      ((this[offset + 1] << 16) |
                        (this[offset + 2] << 8) |
                        this[offset + 3])
                    );
                  };
  
                Buffer.prototype.readIntLE = function readIntLE(
                  offset,
                  byteLength,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  byteLength = byteLength >>> 0;
                  if (!noAssert) checkOffset(offset, byteLength, this.length);
  
                  var val = this[offset];
                  var mul = 1;
                  var i = 0;
                  while (++i < byteLength && (mul *= 0x100)) {
                    val += this[offset + i] * mul;
                  }
                  mul *= 0x80;
  
                  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  
                  return val;
                };
  
                Buffer.prototype.readIntBE = function readIntBE(
                  offset,
                  byteLength,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  byteLength = byteLength >>> 0;
                  if (!noAssert) checkOffset(offset, byteLength, this.length);
  
                  var i = byteLength;
                  var mul = 1;
                  var val = this[offset + --i];
                  while (i > 0 && (mul *= 0x100)) {
                    val += this[offset + --i] * mul;
                  }
                  mul *= 0x80;
  
                  if (val >= mul) val -= Math.pow(2, 8 * byteLength);
  
                  return val;
                };
  
                Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 1, this.length);
                  if (!(this[offset] & 0x80)) return this[offset];
                  return (0xff - this[offset] + 1) * -1;
                };
  
                Buffer.prototype.readInt16LE = function readInt16LE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 2, this.length);
                  var val = this[offset] | (this[offset + 1] << 8);
                  return val & 0x8000 ? val | 0xffff0000 : val;
                };
  
                Buffer.prototype.readInt16BE = function readInt16BE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 2, this.length);
                  var val = this[offset + 1] | (this[offset] << 8);
                  return val & 0x8000 ? val | 0xffff0000 : val;
                };
  
                Buffer.prototype.readInt32LE = function readInt32LE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 4, this.length);
  
                  return (
                    this[offset] |
                    (this[offset + 1] << 8) |
                    (this[offset + 2] << 16) |
                    (this[offset + 3] << 24)
                  );
                };
  
                Buffer.prototype.readInt32BE = function readInt32BE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 4, this.length);
  
                  return (
                    (this[offset] << 24) |
                    (this[offset + 1] << 16) |
                    (this[offset + 2] << 8) |
                    this[offset + 3]
                  );
                };
  
                Buffer.prototype.readFloatLE = function readFloatLE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 4, this.length);
                  return ieee754.read(this, offset, true, 23, 4);
                };
  
                Buffer.prototype.readFloatBE = function readFloatBE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 4, this.length);
                  return ieee754.read(this, offset, false, 23, 4);
                };
  
                Buffer.prototype.readDoubleLE = function readDoubleLE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 8, this.length);
                  return ieee754.read(this, offset, true, 52, 8);
                };
  
                Buffer.prototype.readDoubleBE = function readDoubleBE(
                  offset,
                  noAssert
                ) {
                  offset = offset >>> 0;
                  if (!noAssert) checkOffset(offset, 8, this.length);
                  return ieee754.read(this, offset, false, 52, 8);
                };
  
                function checkInt(buf, value, offset, ext, max, min) {
                  if (!Buffer.isBuffer(buf))
                    throw new TypeError(
                      '"buffer" argument must be a Buffer instance'
                    );
                  if (value > max || value < min)
                    throw new RangeError('"value" argument is out of bounds');
                  if (offset + ext > buf.length)
                    throw new RangeError("Index out of range");
                }
  
                Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE =
                  function writeUIntLE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                      checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
  
                    var mul = 1;
                    var i = 0;
                    this[offset] = value & 0xff;
                    while (++i < byteLength && (mul *= 0x100)) {
                      this[offset + i] = (value / mul) & 0xff;
                    }
  
                    return offset + byteLength;
                  };
  
                Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE =
                  function writeUIntBE(value, offset, byteLength, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    byteLength = byteLength >>> 0;
                    if (!noAssert) {
                      var maxBytes = Math.pow(2, 8 * byteLength) - 1;
                      checkInt(this, value, offset, byteLength, maxBytes, 0);
                    }
  
                    var i = byteLength - 1;
                    var mul = 1;
                    this[offset + i] = value & 0xff;
                    while (--i >= 0 && (mul *= 0x100)) {
                      this[offset + i] = (value / mul) & 0xff;
                    }
  
                    return offset + byteLength;
                  };
  
                Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 =
                  function writeUInt8(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
                    this[offset] = value & 0xff;
                    return offset + 1;
                  };
  
                Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE =
                  function writeUInt16LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value & 0xff;
                    this[offset + 1] = value >>> 8;
                    return offset + 2;
                  };
  
                Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE =
                  function writeUInt16BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
                    this[offset] = value >>> 8;
                    this[offset + 1] = value & 0xff;
                    return offset + 2;
                  };
  
                Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE =
                  function writeUInt32LE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert)
                      checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset + 3] = value >>> 24;
                    this[offset + 2] = value >>> 16;
                    this[offset + 1] = value >>> 8;
                    this[offset] = value & 0xff;
                    return offset + 4;
                  };
  
                Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE =
                  function writeUInt32BE(value, offset, noAssert) {
                    value = +value;
                    offset = offset >>> 0;
                    if (!noAssert)
                      checkInt(this, value, offset, 4, 0xffffffff, 0);
                    this[offset] = value >>> 24;
                    this[offset + 1] = value >>> 16;
                    this[offset + 2] = value >>> 8;
                    this[offset + 3] = value & 0xff;
                    return offset + 4;
                  };
  
                Buffer.prototype.writeIntLE = function writeIntLE(
                  value,
                  offset,
                  byteLength,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert) {
                    var limit = Math.pow(2, 8 * byteLength - 1);
  
                    checkInt(this, value, offset, byteLength, limit - 1, -limit);
                  }
  
                  var i = 0;
                  var mul = 1;
                  var sub = 0;
                  this[offset] = value & 0xff;
                  while (++i < byteLength && (mul *= 0x100)) {
                    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                      sub = 1;
                    }
                    this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
                  }
  
                  return offset + byteLength;
                };
  
                Buffer.prototype.writeIntBE = function writeIntBE(
                  value,
                  offset,
                  byteLength,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert) {
                    var limit = Math.pow(2, 8 * byteLength - 1);
  
                    checkInt(this, value, offset, byteLength, limit - 1, -limit);
                  }
  
                  var i = byteLength - 1;
                  var mul = 1;
                  var sub = 0;
                  this[offset + i] = value & 0xff;
                  while (--i >= 0 && (mul *= 0x100)) {
                    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                      sub = 1;
                    }
                    this[offset + i] = (((value / mul) >> 0) - sub) & 0xff;
                  }
  
                  return offset + byteLength;
                };
  
                Buffer.prototype.writeInt8 = function writeInt8(
                  value,
                  offset,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
                  if (value < 0) value = 0xff + value + 1;
                  this[offset] = value & 0xff;
                  return offset + 1;
                };
  
                Buffer.prototype.writeInt16LE = function writeInt16LE(
                  value,
                  offset,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert)
                    checkInt(this, value, offset, 2, 0x7fff, -0x8000);
                  this[offset] = value & 0xff;
                  this[offset + 1] = value >>> 8;
                  return offset + 2;
                };
  
                Buffer.prototype.writeInt16BE = function writeInt16BE(
                  value,
                  offset,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert)
                    checkInt(this, value, offset, 2, 0x7fff, -0x8000);
                  this[offset] = value >>> 8;
                  this[offset + 1] = value & 0xff;
                  return offset + 2;
                };
  
                Buffer.prototype.writeInt32LE = function writeInt32LE(
                  value,
                  offset,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert)
                    checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
                  this[offset] = value & 0xff;
                  this[offset + 1] = value >>> 8;
                  this[offset + 2] = value >>> 16;
                  this[offset + 3] = value >>> 24;
                  return offset + 4;
                };
  
                Buffer.prototype.writeInt32BE = function writeInt32BE(
                  value,
                  offset,
                  noAssert
                ) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert)
                    checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
                  if (value < 0) value = 0xffffffff + value + 1;
                  this[offset] = value >>> 24;
                  this[offset + 1] = value >>> 16;
                  this[offset + 2] = value >>> 8;
                  this[offset + 3] = value & 0xff;
                  return offset + 4;
                };
  
                function checkIEEE754(buf, value, offset, ext, max, min) {
                  if (offset + ext > buf.length)
                    throw new RangeError("Index out of range");
                  if (offset < 0) throw new RangeError("Index out of range");
                }
  
                function writeFloat(buf, value, offset, littleEndian, noAssert) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert) {
                    checkIEEE754(
                      buf,
                      value,
                      offset,
                      4,
                      3.4028234663852886e38,
                      -3.4028234663852886e38
                    );
                  }
                  ieee754.write(buf, value, offset, littleEndian, 23, 4);
                  return offset + 4;
                }
  
                Buffer.prototype.writeFloatLE = function writeFloatLE(
                  value,
                  offset,
                  noAssert
                ) {
                  return writeFloat(this, value, offset, true, noAssert);
                };
  
                Buffer.prototype.writeFloatBE = function writeFloatBE(
                  value,
                  offset,
                  noAssert
                ) {
                  return writeFloat(this, value, offset, false, noAssert);
                };
  
                function writeDouble(buf, value, offset, littleEndian, noAssert) {
                  value = +value;
                  offset = offset >>> 0;
                  if (!noAssert) {
                    checkIEEE754(
                      buf,
                      value,
                      offset,
                      8,
                      1.7976931348623157e308,
                      -1.7976931348623157e308
                    );
                  }
                  ieee754.write(buf, value, offset, littleEndian, 52, 8);
                  return offset + 8;
                }
  
                Buffer.prototype.writeDoubleLE = function writeDoubleLE(
                  value,
                  offset,
                  noAssert
                ) {
                  return writeDouble(this, value, offset, true, noAssert);
                };
  
                Buffer.prototype.writeDoubleBE = function writeDoubleBE(
                  value,
                  offset,
                  noAssert
                ) {
                  return writeDouble(this, value, offset, false, noAssert);
                };
  
                // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
                Buffer.prototype.copy = function copy(
                  target,
                  targetStart,
                  start,
                  end
                ) {
                  if (!Buffer.isBuffer(target))
                    throw new TypeError("argument should be a Buffer");
                  if (!start) start = 0;
                  if (!end && end !== 0) end = this.length;
                  if (targetStart >= target.length) targetStart = target.length;
                  if (!targetStart) targetStart = 0;
                  if (end > 0 && end < start) end = start;
  
                  // Copy 0 bytes; we're done
                  if (end === start) return 0;
                  if (target.length === 0 || this.length === 0) return 0;
  
                  // Fatal error conditions
                  if (targetStart < 0) {
                    throw new RangeError("targetStart out of bounds");
                  }
                  if (start < 0 || start >= this.length)
                    throw new RangeError("Index out of range");
                  if (end < 0) throw new RangeError("sourceEnd out of bounds");
  
                  // Are we oob?
                  if (end > this.length) end = this.length;
                  if (target.length - targetStart < end - start) {
                    end = target.length - targetStart + start;
                  }
  
                  var len = end - start;
  
                  if (
                    this === target &&
                    typeof Uint8Array.prototype.copyWithin === "function"
                  ) {
                    // Use built-in when available, missing from IE11
                    this.copyWithin(targetStart, start, end);
                  } else {
                    Uint8Array.prototype.set.call(
                      target,
                      this.subarray(start, end),
                      targetStart
                    );
                  }
  
                  return len;
                };
  
                // Usage:
                //    buffer.fill(number[, offset[, end]])
                //    buffer.fill(buffer[, offset[, end]])
                //    buffer.fill(string[, offset[, end]][, encoding])
                Buffer.prototype.fill = function fill(val, start, end, encoding) {
                  // Handle string cases:
                  if (typeof val === "string") {
                    if (typeof start === "string") {
                      encoding = start;
                      start = 0;
                      end = this.length;
                    } else if (typeof end === "string") {
                      encoding = end;
                      end = this.length;
                    }
                    if (encoding !== undefined && typeof encoding !== "string") {
                      throw new TypeError("encoding must be a string");
                    }
                    if (
                      typeof encoding === "string" &&
                      !Buffer.isEncoding(encoding)
                    ) {
                      throw new TypeError("Unknown encoding: " + encoding);
                    }
                    if (val.length === 1) {
                      var code = val.charCodeAt(0);
                      if (
                        (encoding === "utf8" && code < 128) ||
                        encoding === "latin1"
                      ) {
                        // Fast path: If `val` fits into a single byte, use that numeric value.
                        val = code;
                      }
                    }
                  } else if (typeof val === "number") {
                    val = val & 255;
                  } else if (typeof val === "boolean") {
                    val = Number(val);
                  }
  
                  // Invalid ranges are not set to a default, so can range check early.
                  if (start < 0 || this.length < start || this.length < end) {
                    throw new RangeError("Out of range index");
                  }
  
                  if (end <= start) {
                    return this;
                  }
  
                  start = start >>> 0;
                  end = end === undefined ? this.length : end >>> 0;
  
                  if (!val) val = 0;
  
                  var i;
                  if (typeof val === "number") {
                    for (i = start; i < end; ++i) {
                      this[i] = val;
                    }
                  } else {
                    var bytes = Buffer.isBuffer(val)
                      ? val
                      : Buffer.from(val, encoding);
                    var len = bytes.length;
                    if (len === 0) {
                      throw new TypeError(
                        'The value "' + val + '" is invalid for argument "value"'
                      );
                    }
                    for (i = 0; i < end - start; ++i) {
                      this[i + start] = bytes[i % len];
                    }
                  }
  
                  return this;
                };
  
                // HELPER FUNCTIONS
                // ================
  
                var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  
                function base64clean(str) {
                  // Node takes equal signs as end of the Base64 encoding
                  str = str.split("=")[0];
                  // Node strips out invalid characters like \n and \t from the string, base64-js does not
                  str = str.trim().replace(INVALID_BASE64_RE, "");
                  // Node converts strings with length < 2 to ''
                  if (str.length < 2) return "";
                  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
                  while (str.length % 4 !== 0) {
                    str = str + "=";
                  }
                  return str;
                }
  
                function utf8ToBytes(string, units) {
                  units = units || Infinity;
                  var codePoint;
                  var length = string.length;
                  var leadSurrogate = null;
                  var bytes = [];
  
                  for (var i = 0; i < length; ++i) {
                    codePoint = string.charCodeAt(i);
  
                    // is surrogate component
                    if (codePoint > 0xd7ff && codePoint < 0xe000) {
                      // last char was a lead
                      if (!leadSurrogate) {
                        // no lead yet
                        if (codePoint > 0xdbff) {
                          // unexpected trail
                          if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                          continue;
                        } else if (i + 1 === length) {
                          // unpaired lead
                          if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                          continue;
                        }
  
                        // valid lead
                        leadSurrogate = codePoint;
  
                        continue;
                      }
  
                      // 2 leads in a row
                      if (codePoint < 0xdc00) {
                        if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                        leadSurrogate = codePoint;
                        continue;
                      }
  
                      // valid surrogate pair
                      codePoint =
                        (((leadSurrogate - 0xd800) << 10) |
                          (codePoint - 0xdc00)) +
                        0x10000;
                    } else if (leadSurrogate) {
                      // valid bmp char, but last char was a lead
                      if ((units -= 3) > -1) bytes.push(0xef, 0xbf, 0xbd);
                    }
  
                    leadSurrogate = null;
  
                    // encode utf8
                    if (codePoint < 0x80) {
                      if ((units -= 1) < 0) break;
                      bytes.push(codePoint);
                    } else if (codePoint < 0x800) {
                      if ((units -= 2) < 0) break;
                      bytes.push(
                        (codePoint >> 0x6) | 0xc0,
                        (codePoint & 0x3f) | 0x80
                      );
                    } else if (codePoint < 0x10000) {
                      if ((units -= 3) < 0) break;
                      bytes.push(
                        (codePoint >> 0xc) | 0xe0,
                        ((codePoint >> 0x6) & 0x3f) | 0x80,
                        (codePoint & 0x3f) | 0x80
                      );
                    } else if (codePoint < 0x110000) {
                      if ((units -= 4) < 0) break;
                      bytes.push(
                        (codePoint >> 0x12) | 0xf0,
                        ((codePoint >> 0xc) & 0x3f) | 0x80,
                        ((codePoint >> 0x6) & 0x3f) | 0x80,
                        (codePoint & 0x3f) | 0x80
                      );
                    } else {
                      throw new Error("Invalid code point");
                    }
                  }
  
                  return bytes;
                }
  
                function asciiToBytes(str) {
                  var byteArray = [];
                  for (var i = 0; i < str.length; ++i) {
                    // Node's code seems to be doing this and not & 0x7F..
                    byteArray.push(str.charCodeAt(i) & 0xff);
                  }
                  return byteArray;
                }
  
                function utf16leToBytes(str, units) {
                  var c, hi, lo;
                  var byteArray = [];
                  for (var i = 0; i < str.length; ++i) {
                    if ((units -= 2) < 0) break;
  
                    c = str.charCodeAt(i);
                    hi = c >> 8;
                    lo = c % 256;
                    byteArray.push(lo);
                    byteArray.push(hi);
                  }
  
                  return byteArray;
                }
  
                function base64ToBytes(str) {
                  return base64.toByteArray(base64clean(str));
                }
  
                function blitBuffer(src, dst, offset, length) {
                  for (var i = 0; i < length; ++i) {
                    if (i + offset >= dst.length || i >= src.length) break;
                    dst[i + offset] = src[i];
                  }
                  return i;
                }
  
                // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
                // the `instanceof` check but they should be treated as of that type.
                // See: https://github.com/feross/buffer/issues/166
                function isInstance(obj, type) {
                  return (
                    obj instanceof type ||
                    (obj != null &&
                      obj.constructor != null &&
                      obj.constructor.name != null &&
                      obj.constructor.name === type.name)
                  );
                }
                function numberIsNaN(obj) {
                  // For IE11 support
                  return obj !== obj; // eslint-disable-line no-self-compare
                }
  
                // Create lookup table for `toString('hex')`
                // See: https://github.com/feross/buffer/issues/219
                var hexSliceLookupTable = (function () {
                  var alphabet = "0123456789abcdef";
                  var table = new Array(256);
                  for (var i = 0; i < 16; ++i) {
                    var i16 = i * 16;
                    for (var j = 0; j < 16; ++j) {
                      table[i16 + j] = alphabet[i] + alphabet[j];
                    }
                  }
                  return table;
                })();
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { "base64-js": 56, buffer: 55, ieee754: 239 },
        ],
        56: [
          function (require, module, exports) {
            "use strict";
  
            exports.byteLength = byteLength;
            exports.toByteArray = toByteArray;
            exports.fromByteArray = fromByteArray;
  
            var lookup = [];
            var revLookup = [];
            var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
  
            var code =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for (var i = 0, len = code.length; i < len; ++i) {
              lookup[i] = code[i];
              revLookup[code.charCodeAt(i)] = i;
            }
  
            // Support decoding URL-safe base64 strings, as Node.js does.
            // See: https://en.wikipedia.org/wiki/Base64#URL_applications
            revLookup["-".charCodeAt(0)] = 62;
            revLookup["_".charCodeAt(0)] = 63;
  
            function getLens(b64) {
              var len = b64.length;
  
              if (len % 4 > 0) {
                throw new Error("Invalid string. Length must be a multiple of 4");
              }
  
              // Trim off extra bytes after placeholder bytes are found
              // See: https://github.com/beatgammit/base64-js/issues/42
              var validLen = b64.indexOf("=");
              if (validLen === -1) validLen = len;
  
              var placeHoldersLen = validLen === len ? 0 : 4 - (validLen % 4);
  
              return [validLen, placeHoldersLen];
            }
  
            // base64 is 4/3 + up to two characters of the original data
            function byteLength(b64) {
              var lens = getLens(b64);
              var validLen = lens[0];
              var placeHoldersLen = lens[1];
              return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
            }
  
            function _byteLength(b64, validLen, placeHoldersLen) {
              return ((validLen + placeHoldersLen) * 3) / 4 - placeHoldersLen;
            }
  
            function toByteArray(b64) {
              var tmp;
              var lens = getLens(b64);
              var validLen = lens[0];
              var placeHoldersLen = lens[1];
  
              var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  
              var curByte = 0;
  
              // if there are placeholders, only get up to the last complete 4 chars
              var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  
              var i;
              for (i = 0; i < len; i += 4) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 18) |
                  (revLookup[b64.charCodeAt(i + 1)] << 12) |
                  (revLookup[b64.charCodeAt(i + 2)] << 6) |
                  revLookup[b64.charCodeAt(i + 3)];
                arr[curByte++] = (tmp >> 16) & 0xff;
                arr[curByte++] = (tmp >> 8) & 0xff;
                arr[curByte++] = tmp & 0xff;
              }
  
              if (placeHoldersLen === 2) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 2) |
                  (revLookup[b64.charCodeAt(i + 1)] >> 4);
                arr[curByte++] = tmp & 0xff;
              }
  
              if (placeHoldersLen === 1) {
                tmp =
                  (revLookup[b64.charCodeAt(i)] << 10) |
                  (revLookup[b64.charCodeAt(i + 1)] << 4) |
                  (revLookup[b64.charCodeAt(i + 2)] >> 2);
                arr[curByte++] = (tmp >> 8) & 0xff;
                arr[curByte++] = tmp & 0xff;
              }
  
              return arr;
            }
  
            function tripletToBase64(num) {
              return (
                lookup[(num >> 18) & 0x3f] +
                lookup[(num >> 12) & 0x3f] +
                lookup[(num >> 6) & 0x3f] +
                lookup[num & 0x3f]
              );
            }
  
            function encodeChunk(uint8, start, end) {
              var tmp;
              var output = [];
              for (var i = start; i < end; i += 3) {
                tmp =
                  ((uint8[i] << 16) & 0xff0000) +
                  ((uint8[i + 1] << 8) & 0xff00) +
                  (uint8[i + 2] & 0xff);
                output.push(tripletToBase64(tmp));
              }
              return output.join("");
            }
  
            function fromByteArray(uint8) {
              var tmp;
              var len = uint8.length;
              var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
              var parts = [];
              var maxChunkLength = 16383; // must be multiple of 3
  
              // go through the array every three bytes, we'll deal with trailing stuff later
              for (
                var i = 0, len2 = len - extraBytes;
                i < len2;
                i += maxChunkLength
              ) {
                parts.push(
                  encodeChunk(
                    uint8,
                    i,
                    i + maxChunkLength > len2 ? len2 : i + maxChunkLength
                  )
                );
              }
  
              // pad the end with zeros, but make sure to not forget the extra bytes
              if (extraBytes === 1) {
                tmp = uint8[len - 1];
                parts.push(lookup[tmp >> 2] + lookup[(tmp << 4) & 0x3f] + "==");
              } else if (extraBytes === 2) {
                tmp = (uint8[len - 2] << 8) + uint8[len - 1];
                parts.push(
                  lookup[tmp >> 10] +
                    lookup[(tmp >> 4) & 0x3f] +
                    lookup[(tmp << 2) & 0x3f] +
                    "="
                );
              }
  
              return parts.join("");
            }
          },
          {},
        ],
        57: [
          function (require, module, exports) {
            "use strict";
  
            var GetIntrinsic = require("get-intrinsic");
  
            var callBind = require("./");
  
            var $indexOf = callBind(GetIntrinsic("String.prototype.indexOf"));
  
            module.exports = function callBoundIntrinsic(name, allowMissing) {
              var intrinsic = GetIntrinsic(name, !!allowMissing);
              if (
                typeof intrinsic === "function" &&
                $indexOf(name, ".prototype.") > -1
              ) {
                return callBind(intrinsic);
              }
              return intrinsic;
            };
          },
          { "./": 58, "get-intrinsic": 235 },
        ],
        58: [
          function (require, module, exports) {
            "use strict";
  
            var bind = require("function-bind");
            var GetIntrinsic = require("get-intrinsic");
  
            var $apply = GetIntrinsic("%Function.prototype.apply%");
            var $call = GetIntrinsic("%Function.prototype.call%");
            var $reflectApply =
              GetIntrinsic("%Reflect.apply%", true) || bind.call($call, $apply);
  
            var $gOPD = GetIntrinsic("%Object.getOwnPropertyDescriptor%", true);
            var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
            var $max = GetIntrinsic("%Math.max%");
  
            if ($defineProperty) {
              try {
                $defineProperty({}, "a", { value: 1 });
              } catch (e) {
                // IE 8 has a broken defineProperty
                $defineProperty = null;
              }
            }
  
            module.exports = function callBind(originalFunction) {
              var func = $reflectApply(bind, $call, arguments);
              if ($gOPD && $defineProperty) {
                var desc = $gOPD(func, "length");
                if (desc.configurable) {
                  // original length, plus the receiver, minus any additional arguments (after the receiver)
                  $defineProperty(func, "length", {
                    value:
                      1 +
                      $max(0, originalFunction.length - (arguments.length - 1)),
                  });
                }
              }
              return func;
            };
  
            var applyBind = function applyBind() {
              return $reflectApply(bind, $apply, arguments);
            };
  
            if ($defineProperty) {
              $defineProperty(module.exports, "apply", { value: applyBind });
            } else {
              module.exports.apply = applyBind;
            }
          },
          { "function-bind": 234, "get-intrinsic": 235 },
        ],
        59: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                var clone = (function () {
                  "use strict";
  
                  /**
                   * Clones (copies) an Object using deep copying.
                   *
                   * This function supports circular references by default, but if you are certain
                   * there are no circular references in your object, you can save some CPU time
                   * by calling clone(obj, false).
                   *
                   * Caution: if `circular` is false and `parent` contains circular references,
                   * your program may enter an infinite loop and crash.
                   *
                   * @param `parent` - the object to be cloned
                   * @param `circular` - set to true if the object to be cloned may contain
                   *    circular references. (optional - true by default)
                   * @param `depth` - set to a number if the object is only to be cloned to
                   *    a particular depth. (optional - defaults to Infinity)
                   * @param `prototype` - sets the prototype to be used when cloning an object.
                   *    (optional - defaults to parent prototype).
                   */
                  function clone(parent, circular, depth, prototype) {
                    var filter;
                    if (typeof circular === "object") {
                      depth = circular.depth;
                      prototype = circular.prototype;
                      filter = circular.filter;
                      circular = circular.circular;
                    }
                    // maintain two arrays for circular references, where corresponding parents
                    // and children have the same index
                    var allParents = [];
                    var allChildren = [];
  
                    var useBuffer = typeof Buffer != "undefined";
  
                    if (typeof circular == "undefined") circular = true;
  
                    if (typeof depth == "undefined") depth = Infinity;
  
                    // recurse this function so we don't reset allParents and allChildren
                    function _clone(parent, depth) {
                      // cloning null always returns null
                      if (parent === null) return null;
  
                      if (depth == 0) return parent;
  
                      var child;
                      var proto;
                      if (typeof parent != "object") {
                        return parent;
                      }
  
                      if (clone.__isArray(parent)) {
                        child = [];
                      } else if (clone.__isRegExp(parent)) {
                        child = new RegExp(
                          parent.source,
                          __getRegExpFlags(parent)
                        );
                        if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                      } else if (clone.__isDate(parent)) {
                        child = new Date(parent.getTime());
                      } else if (useBuffer && Buffer.isBuffer(parent)) {
                        if (Buffer.allocUnsafe) {
                          // Node.js >= 4.5.0
                          child = Buffer.allocUnsafe(parent.length);
                        } else {
                          // Older Node.js versions
                          child = new Buffer(parent.length);
                        }
                        parent.copy(child);
                        return child;
                      } else {
                        if (typeof prototype == "undefined") {
                          proto = Object.getPrototypeOf(parent);
                          child = Object.create(proto);
                        } else {
                          child = Object.create(prototype);
                          proto = prototype;
                        }
                      }
  
                      if (circular) {
                        var index = allParents.indexOf(parent);
  
                        if (index != -1) {
                          return allChildren[index];
                        }
                        allParents.push(parent);
                        allChildren.push(child);
                      }
  
                      for (var i in parent) {
                        var attrs;
                        if (proto) {
                          attrs = Object.getOwnPropertyDescriptor(proto, i);
                        }
  
                        if (attrs && attrs.set == null) {
                          continue;
                        }
                        child[i] = _clone(parent[i], depth - 1);
                      }
  
                      return child;
                    }
  
                    return _clone(parent, depth);
                  }
  
                  /**
                   * Simple flat clone using prototype, accepts only objects, usefull for property
                   * override on FLAT configuration object (no nested props).
                   *
                   * USE WITH CAUTION! This may not behave as you wish if you do not know how this
                   * works.
                   */
                  clone.clonePrototype = function clonePrototype(parent) {
                    if (parent === null) return null;
  
                    var c = function () {};
                    c.prototype = parent;
                    return new c();
                  };
  
                  // private utility functions
  
                  function __objToStr(o) {
                    return Object.prototype.toString.call(o);
                  }
                  clone.__objToStr = __objToStr;
  
                  function __isDate(o) {
                    return (
                      typeof o === "object" && __objToStr(o) === "[object Date]"
                    );
                  }
                  clone.__isDate = __isDate;
  
                  function __isArray(o) {
                    return (
                      typeof o === "object" && __objToStr(o) === "[object Array]"
                    );
                  }
                  clone.__isArray = __isArray;
  
                  function __isRegExp(o) {
                    return (
                      typeof o === "object" && __objToStr(o) === "[object RegExp]"
                    );
                  }
                  clone.__isRegExp = __isRegExp;
  
                  function __getRegExpFlags(re) {
                    var flags = "";
                    if (re.global) flags += "g";
                    if (re.ignoreCase) flags += "i";
                    if (re.multiline) flags += "m";
                    return flags;
                  }
                  clone.__getRegExpFlags = __getRegExpFlags;
  
                  return clone;
                })();
  
                if (typeof module === "object" && module.exports) {
                  module.exports = clone;
                }
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { buffer: 55 },
        ],
        60: [
          function (require, module, exports) {
            require("../../modules/es6.string.iterator");
            require("../../modules/es6.array.from");
            module.exports = require("../../modules/_core").Array.from;
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.array.from": 164,
            "../../modules/es6.string.iterator": 180,
          },
        ],
        61: [
          function (require, module, exports) {
            require("../modules/web.dom.iterable");
            require("../modules/es6.string.iterator");
            module.exports = require("../modules/core.get-iterator");
          },
          {
            "../modules/core.get-iterator": 163,
            "../modules/es6.string.iterator": 180,
            "../modules/web.dom.iterable": 192,
          },
        ],
        62: [
          function (require, module, exports) {
            require("../modules/es6.object.to-string");
            require("../modules/es6.string.iterator");
            require("../modules/web.dom.iterable");
            require("../modules/es6.map");
            require("../modules/es7.map.to-json");
            require("../modules/es7.map.of");
            require("../modules/es7.map.from");
            module.exports = require("../modules/_core").Map;
          },
          {
            "../modules/_core": 91,
            "../modules/es6.map": 166,
            "../modules/es6.object.to-string": 176,
            "../modules/es6.string.iterator": 180,
            "../modules/es7.map.from": 182,
            "../modules/es7.map.of": 183,
            "../modules/es7.map.to-json": 184,
            "../modules/web.dom.iterable": 192,
          },
        ],
        63: [
          function (require, module, exports) {
            require("../../modules/es6.number.epsilon");
            module.exports = Math.pow(2, -52);
          },
          { "../../modules/es6.number.epsilon": 167 },
        ],
        64: [
          function (require, module, exports) {
            require("../../modules/es6.object.assign");
            module.exports = require("../../modules/_core").Object.assign;
          },
          { "../../modules/_core": 91, "../../modules/es6.object.assign": 168 },
        ],
        65: [
          function (require, module, exports) {
            require("../../modules/es6.object.create");
            var $Object = require("../../modules/_core").Object;
            module.exports = function create(P, D) {
              return $Object.create(P, D);
            };
          },
          { "../../modules/_core": 91, "../../modules/es6.object.create": 169 },
        ],
        66: [
          function (require, module, exports) {
            require("../../modules/es6.object.define-properties");
            var $Object = require("../../modules/_core").Object;
            module.exports = function defineProperties(T, D) {
              return $Object.defineProperties(T, D);
            };
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.object.define-properties": 170,
          },
        ],
        67: [
          function (require, module, exports) {
            require("../../modules/es6.object.define-property");
            var $Object = require("../../modules/_core").Object;
            module.exports = function defineProperty(it, key, desc) {
              return $Object.defineProperty(it, key, desc);
            };
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.object.define-property": 171,
          },
        ],
        68: [
          function (require, module, exports) {
            require("../../modules/es6.object.freeze");
            module.exports = require("../../modules/_core").Object.freeze;
          },
          { "../../modules/_core": 91, "../../modules/es6.object.freeze": 172 },
        ],
        69: [
          function (require, module, exports) {
            require("../../modules/es6.object.get-own-property-descriptor");
            var $Object = require("../../modules/_core").Object;
            module.exports = function getOwnPropertyDescriptor(it, key) {
              return $Object.getOwnPropertyDescriptor(it, key);
            };
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.object.get-own-property-descriptor": 173,
          },
        ],
        70: [
          function (require, module, exports) {
            require("../../modules/es6.object.keys");
            module.exports = require("../../modules/_core").Object.keys;
          },
          { "../../modules/_core": 91, "../../modules/es6.object.keys": 174 },
        ],
        71: [
          function (require, module, exports) {
            require("../../modules/es6.object.set-prototype-of");
            module.exports = require("../../modules/_core").Object.setPrototypeOf;
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.object.set-prototype-of": 175,
          },
        ],
        72: [
          function (require, module, exports) {
            require("../modules/es6.object.to-string");
            require("../modules/es6.string.iterator");
            require("../modules/web.dom.iterable");
            require("../modules/es6.promise");
            require("../modules/es7.promise.finally");
            require("../modules/es7.promise.try");
            module.exports = require("../modules/_core").Promise;
          },
          {
            "../modules/_core": 91,
            "../modules/es6.object.to-string": 176,
            "../modules/es6.promise": 177,
            "../modules/es6.string.iterator": 180,
            "../modules/es7.promise.finally": 185,
            "../modules/es7.promise.try": 186,
            "../modules/web.dom.iterable": 192,
          },
        ],
        73: [
          function (require, module, exports) {
            require("../modules/es6.object.to-string");
            require("../modules/es6.string.iterator");
            require("../modules/web.dom.iterable");
            require("../modules/es6.set");
            require("../modules/es7.set.to-json");
            require("../modules/es7.set.of");
            require("../modules/es7.set.from");
            module.exports = require("../modules/_core").Set;
          },
          {
            "../modules/_core": 91,
            "../modules/es6.object.to-string": 176,
            "../modules/es6.set": 178,
            "../modules/es6.string.iterator": 180,
            "../modules/es7.set.from": 187,
            "../modules/es7.set.of": 188,
            "../modules/es7.set.to-json": 189,
            "../modules/web.dom.iterable": 192,
          },
        ],
        74: [
          function (require, module, exports) {
            require("../../modules/es6.string.from-code-point");
            module.exports = require("../../modules/_core").String.fromCodePoint;
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.string.from-code-point": 179,
          },
        ],
        75: [
          function (require, module, exports) {
            require("../../modules/es6.symbol");
            require("../../modules/es6.object.to-string");
            require("../../modules/es7.symbol.async-iterator");
            require("../../modules/es7.symbol.observable");
            module.exports = require("../../modules/_core").Symbol;
          },
          {
            "../../modules/_core": 91,
            "../../modules/es6.object.to-string": 176,
            "../../modules/es6.symbol": 181,
            "../../modules/es7.symbol.async-iterator": 190,
            "../../modules/es7.symbol.observable": 191,
          },
        ],
        76: [
          function (require, module, exports) {
            require("../../modules/es6.string.iterator");
            require("../../modules/web.dom.iterable");
            module.exports = require("../../modules/_wks-ext").f("iterator");
          },
          {
            "../../modules/_wks-ext": 160,
            "../../modules/es6.string.iterator": 180,
            "../../modules/web.dom.iterable": 192,
          },
        ],
        77: [
          function (require, module, exports) {
            module.exports = function (it) {
              if (typeof it != "function")
                throw TypeError(it + " is not a function!");
              return it;
            };
          },
          {},
        ],
        78: [
          function (require, module, exports) {
            module.exports = function () {
              /* empty */
            };
          },
          {},
        ],
        79: [
          function (require, module, exports) {
            module.exports = function (it, Constructor, name, forbiddenField) {
              if (
                !(it instanceof Constructor) ||
                (forbiddenField !== undefined && forbiddenField in it)
              ) {
                throw TypeError(name + ": incorrect invocation!");
              }
              return it;
            };
          },
          {},
        ],
        80: [
          function (require, module, exports) {
            var isObject = require("./_is-object");
            module.exports = function (it) {
              if (!isObject(it)) throw TypeError(it + " is not an object!");
              return it;
            };
          },
          { "./_is-object": 111 },
        ],
        81: [
          function (require, module, exports) {
            var forOf = require("./_for-of");
  
            module.exports = function (iter, ITERATOR) {
              var result = [];
              forOf(iter, false, result.push, result, ITERATOR);
              return result;
            };
          },
          { "./_for-of": 101 },
        ],
        82: [
          function (require, module, exports) {
            // false -> Array#indexOf
            // true  -> Array#includes
            var toIObject = require("./_to-iobject");
            var toLength = require("./_to-length");
            var toAbsoluteIndex = require("./_to-absolute-index");
            module.exports = function (IS_INCLUDES) {
              return function ($this, el, fromIndex) {
                var O = toIObject($this);
                var length = toLength(O.length);
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare
                if (IS_INCLUDES && el != el)
                  while (length > index) {
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare
                    if (value != value) return true;
                    // Array#indexOf ignores holes, Array#includes - not
                  }
                else
                  for (; length > index; index++)
                    if (IS_INCLUDES || index in O) {
                      if (O[index] === el) return IS_INCLUDES || index || 0;
                    }
                return !IS_INCLUDES && -1;
              };
            };
          },
          {
            "./_to-absolute-index": 150,
            "./_to-iobject": 152,
            "./_to-length": 153,
          },
        ],
        83: [
          function (require, module, exports) {
            // 0 -> Array#forEach
            // 1 -> Array#map
            // 2 -> Array#filter
            // 3 -> Array#some
            // 4 -> Array#every
            // 5 -> Array#find
            // 6 -> Array#findIndex
            var ctx = require("./_ctx");
            var IObject = require("./_iobject");
            var toObject = require("./_to-object");
            var toLength = require("./_to-length");
            var asc = require("./_array-species-create");
            module.exports = function (TYPE, $create) {
              var IS_MAP = TYPE == 1;
              var IS_FILTER = TYPE == 2;
              var IS_SOME = TYPE == 3;
              var IS_EVERY = TYPE == 4;
              var IS_FIND_INDEX = TYPE == 6;
              var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
              var create = $create || asc;
              return function ($this, callbackfn, that) {
                var O = toObject($this);
                var self = IObject(O);
                var f = ctx(callbackfn, that, 3);
                var length = toLength(self.length);
                var index = 0;
                var result = IS_MAP
                  ? create($this, length)
                  : IS_FILTER
                  ? create($this, 0)
                  : undefined;
                var val, res;
                for (; length > index; index++)
                  if (NO_HOLES || index in self) {
                    val = self[index];
                    res = f(val, index, O);
                    if (TYPE) {
                      if (IS_MAP) result[index] = res; // map
                      else if (res)
                        switch (TYPE) {
                          case 3:
                            return true; // some
                          case 5:
                            return val; // find
                          case 6:
                            return index; // findIndex
                          case 2:
                            result.push(val); // filter
                        }
                      else if (IS_EVERY) return false; // every
                    }
                  }
                return IS_FIND_INDEX
                  ? -1
                  : IS_SOME || IS_EVERY
                  ? IS_EVERY
                  : result;
              };
            };
          },
          {
            "./_array-species-create": 85,
            "./_ctx": 93,
            "./_iobject": 108,
            "./_to-length": 153,
            "./_to-object": 154,
          },
        ],
        84: [
          function (require, module, exports) {
            var isObject = require("./_is-object");
            var isArray = require("./_is-array");
            var SPECIES = require("./_wks")("species");
  
            module.exports = function (original) {
              var C;
              if (isArray(original)) {
                C = original.constructor;
                // cross-realm fallback
                if (
                  typeof C == "function" &&
                  (C === Array || isArray(C.prototype))
                )
                  C = undefined;
                if (isObject(C)) {
                  C = C[SPECIES];
                  if (C === null) C = undefined;
                }
              }
              return C === undefined ? Array : C;
            };
          },
          { "./_is-array": 110, "./_is-object": 111, "./_wks": 161 },
        ],
        85: [
          function (require, module, exports) {
            // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
            var speciesConstructor = require("./_array-species-constructor");
  
            module.exports = function (original, length) {
              return new (speciesConstructor(original))(length);
            };
          },
          { "./_array-species-constructor": 84 },
        ],
        86: [
          function (require, module, exports) {
            // getting tag from 19.1.3.6 Object.prototype.toString()
            var cof = require("./_cof");
            var TAG = require("./_wks")("toStringTag");
            // ES3 wrong here
            var ARG =
              cof(
                (function () {
                  return arguments;
                })()
              ) == "Arguments";
  
            // fallback for IE11 Script Access Denied error
            var tryGet = function (it, key) {
              try {
                return it[key];
              } catch (e) {
                /* empty */
              }
            };
  
            module.exports = function (it) {
              var O, T, B;
              return it === undefined
                ? "Undefined"
                : it === null
                ? "Null"
                : // @@toStringTag case
                typeof (T = tryGet((O = Object(it)), TAG)) == "string"
                ? T
                : // builtinTag case
                ARG
                ? cof(O)
                : // ES3 arguments fallback
                (B = cof(O)) == "Object" && typeof O.callee == "function"
                ? "Arguments"
                : B;
            };
          },
          { "./_cof": 87, "./_wks": 161 },
        ],
        87: [
          function (require, module, exports) {
            var toString = {}.toString;
  
            module.exports = function (it) {
              return toString.call(it).slice(8, -1);
            };
          },
          {},
        ],
        88: [
          function (require, module, exports) {
            "use strict";
            var dP = require("./_object-dp").f;
            var create = require("./_object-create");
            var redefineAll = require("./_redefine-all");
            var ctx = require("./_ctx");
            var anInstance = require("./_an-instance");
            var forOf = require("./_for-of");
            var $iterDefine = require("./_iter-define");
            var step = require("./_iter-step");
            var setSpecies = require("./_set-species");
            var DESCRIPTORS = require("./_descriptors");
            var fastKey = require("./_meta").fastKey;
            var validate = require("./_validate-collection");
            var SIZE = DESCRIPTORS ? "_s" : "size";
  
            var getEntry = function (that, key) {
              // fast case
              var index = fastKey(key);
              var entry;
              if (index !== "F") return that._i[index];
              // frozen object case
              for (entry = that._f; entry; entry = entry.n) {
                if (entry.k == key) return entry;
              }
            };
  
            module.exports = {
              getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
                var C = wrapper(function (that, iterable) {
                  anInstance(that, C, NAME, "_i");
                  that._t = NAME; // collection type
                  that._i = create(null); // index
                  that._f = undefined; // first entry
                  that._l = undefined; // last entry
                  that[SIZE] = 0; // size
                  if (iterable != undefined)
                    forOf(iterable, IS_MAP, that[ADDER], that);
                });
                redefineAll(C.prototype, {
                  // 23.1.3.1 Map.prototype.clear()
                  // 23.2.3.2 Set.prototype.clear()
                  clear: function clear() {
                    for (
                      var that = validate(this, NAME),
                        data = that._i,
                        entry = that._f;
                      entry;
                      entry = entry.n
                    ) {
                      entry.r = true;
                      if (entry.p) entry.p = entry.p.n = undefined;
                      delete data[entry.i];
                    }
                    that._f = that._l = undefined;
                    that[SIZE] = 0;
                  },
                  // 23.1.3.3 Map.prototype.delete(key)
                  // 23.2.3.4 Set.prototype.delete(value)
                  delete: function (key) {
                    var that = validate(this, NAME);
                    var entry = getEntry(that, key);
                    if (entry) {
                      var next = entry.n;
                      var prev = entry.p;
                      delete that._i[entry.i];
                      entry.r = true;
                      if (prev) prev.n = next;
                      if (next) next.p = prev;
                      if (that._f == entry) that._f = next;
                      if (that._l == entry) that._l = prev;
                      that[SIZE]--;
                    }
                    return !!entry;
                  },
                  // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                  // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                  forEach: function forEach(callbackfn /* , that = undefined */) {
                    validate(this, NAME);
                    var f = ctx(
                      callbackfn,
                      arguments.length > 1 ? arguments[1] : undefined,
                      3
                    );
                    var entry;
                    while ((entry = entry ? entry.n : this._f)) {
                      f(entry.v, entry.k, this);
                      // revert to the last existing entry
                      while (entry && entry.r) entry = entry.p;
                    }
                  },
                  // 23.1.3.7 Map.prototype.has(key)
                  // 23.2.3.7 Set.prototype.has(value)
                  has: function has(key) {
                    return !!getEntry(validate(this, NAME), key);
                  },
                });
                if (DESCRIPTORS)
                  dP(C.prototype, "size", {
                    get: function () {
                      return validate(this, NAME)[SIZE];
                    },
                  });
                return C;
              },
              def: function (that, key, value) {
                var entry = getEntry(that, key);
                var prev, index;
                // change existing entry
                if (entry) {
                  entry.v = value;
                  // create new entry
                } else {
                  that._l = entry = {
                    i: (index = fastKey(key, true)), // <- index
                    k: key, // <- key
                    v: value, // <- value
                    p: (prev = that._l), // <- previous entry
                    n: undefined, // <- next entry
                    r: false, // <- removed
                  };
                  if (!that._f) that._f = entry;
                  if (prev) prev.n = entry;
                  that[SIZE]++;
                  // add to index
                  if (index !== "F") that._i[index] = entry;
                }
                return that;
              },
              getEntry: getEntry,
              setStrong: function (C, NAME, IS_MAP) {
                // add .keys, .values, .entries, [@@iterator]
                // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
                $iterDefine(
                  C,
                  NAME,
                  function (iterated, kind) {
                    this._t = validate(iterated, NAME); // target
                    this._k = kind; // kind
                    this._l = undefined; // previous
                  },
                  function () {
                    var that = this;
                    var kind = that._k;
                    var entry = that._l;
                    // revert to the last existing entry
                    while (entry && entry.r) entry = entry.p;
                    // get next entry
                    if (
                      !that._t ||
                      !(that._l = entry = entry ? entry.n : that._t._f)
                    ) {
                      // or finish the iteration
                      that._t = undefined;
                      return step(1);
                    }
                    // return step by kind
                    if (kind == "keys") return step(0, entry.k);
                    if (kind == "values") return step(0, entry.v);
                    return step(0, [entry.k, entry.v]);
                  },
                  IS_MAP ? "entries" : "values",
                  !IS_MAP,
                  true
                );
  
                // add [@@species], 23.1.2.2, 23.2.2.2
                setSpecies(NAME);
              },
            };
          },
          {
            "./_an-instance": 79,
            "./_ctx": 93,
            "./_descriptors": 95,
            "./_for-of": 101,
            "./_iter-define": 114,
            "./_iter-step": 116,
            "./_meta": 119,
            "./_object-create": 123,
            "./_object-dp": 124,
            "./_redefine-all": 138,
            "./_set-species": 143,
            "./_validate-collection": 158,
          },
        ],
        89: [
          function (require, module, exports) {
            // https://github.com/DavidBruant/Map-Set.prototype.toJSON
            var classof = require("./_classof");
            var from = require("./_array-from-iterable");
            module.exports = function (NAME) {
              return function toJSON() {
                if (classof(this) != NAME)
                  throw TypeError(NAME + "#toJSON isn't generic");
                return from(this);
              };
            };
          },
          { "./_array-from-iterable": 81, "./_classof": 86 },
        ],
        90: [
          function (require, module, exports) {
            "use strict";
            var global = require("./_global");
            var $export = require("./_export");
            var meta = require("./_meta");
            var fails = require("./_fails");
            var hide = require("./_hide");
            var redefineAll = require("./_redefine-all");
            var forOf = require("./_for-of");
            var anInstance = require("./_an-instance");
            var isObject = require("./_is-object");
            var setToStringTag = require("./_set-to-string-tag");
            var dP = require("./_object-dp").f;
            var each = require("./_array-methods")(0);
            var DESCRIPTORS = require("./_descriptors");
  
            module.exports = function (
              NAME,
              wrapper,
              methods,
              common,
              IS_MAP,
              IS_WEAK
            ) {
              var Base = global[NAME];
              var C = Base;
              var ADDER = IS_MAP ? "set" : "add";
              var proto = C && C.prototype;
              var O = {};
              if (
                !DESCRIPTORS ||
                typeof C != "function" ||
                !(
                  IS_WEAK ||
                  (proto.forEach &&
                    !fails(function () {
                      new C().entries().next();
                    }))
                )
              ) {
                // create collection constructor
                C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
                redefineAll(C.prototype, methods);
                meta.NEED = true;
              } else {
                C = wrapper(function (target, iterable) {
                  anInstance(target, C, NAME, "_c");
                  target._c = new Base();
                  if (iterable != undefined)
                    forOf(iterable, IS_MAP, target[ADDER], target);
                });
                each(
                  "add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(
                    ","
                  ),
                  function (KEY) {
                    var IS_ADDER = KEY == "add" || KEY == "set";
                    if (KEY in proto && !(IS_WEAK && KEY == "clear"))
                      hide(C.prototype, KEY, function (a, b) {
                        anInstance(this, C, KEY);
                        if (!IS_ADDER && IS_WEAK && !isObject(a))
                          return KEY == "get" ? undefined : false;
                        var result = this._c[KEY](a === 0 ? 0 : a, b);
                        return IS_ADDER ? this : result;
                      });
                  }
                );
                IS_WEAK ||
                  dP(C.prototype, "size", {
                    get: function () {
                      return this._c.size;
                    },
                  });
              }
  
              setToStringTag(C, NAME);
  
              O[NAME] = C;
              $export($export.G + $export.W + $export.F, O);
  
              if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
  
              return C;
            };
          },
          {
            "./_an-instance": 79,
            "./_array-methods": 83,
            "./_descriptors": 95,
            "./_export": 99,
            "./_fails": 100,
            "./_for-of": 101,
            "./_global": 102,
            "./_hide": 104,
            "./_is-object": 111,
            "./_meta": 119,
            "./_object-dp": 124,
            "./_redefine-all": 138,
            "./_set-to-string-tag": 144,
          },
        ],
        91: [
          function (require, module, exports) {
            var core = (module.exports = { version: "2.6.12" });
            if (typeof __e == "number") __e = core; // eslint-disable-line no-undef
          },
          {},
        ],
        92: [
          function (require, module, exports) {
            "use strict";
            var $defineProperty = require("./_object-dp");
            var createDesc = require("./_property-desc");
  
            module.exports = function (object, index, value) {
              if (index in object)
                $defineProperty.f(object, index, createDesc(0, value));
              else object[index] = value;
            };
          },
          { "./_object-dp": 124, "./_property-desc": 137 },
        ],
        93: [
          function (require, module, exports) {
            // optional / simple context binding
            var aFunction = require("./_a-function");
            module.exports = function (fn, that, length) {
              aFunction(fn);
              if (that === undefined) return fn;
              switch (length) {
                case 1:
                  return function (a) {
                    return fn.call(that, a);
                  };
                case 2:
                  return function (a, b) {
                    return fn.call(that, a, b);
                  };
                case 3:
                  return function (a, b, c) {
                    return fn.call(that, a, b, c);
                  };
              }
              return function (/* ...args */) {
                return fn.apply(that, arguments);
              };
            };
          },
          { "./_a-function": 77 },
        ],
        94: [
          function (require, module, exports) {
            // 7.2.1 RequireObjectCoercible(argument)
            module.exports = function (it) {
              if (it == undefined) throw TypeError("Can't call method on  " + it);
              return it;
            };
          },
          {},
        ],
        95: [
          function (require, module, exports) {
            // Thank's IE8 for his funny defineProperty
            module.exports = !require("./_fails")(function () {
              return (
                Object.defineProperty({}, "a", {
                  get: function () {
                    return 7;
                  },
                }).a != 7
              );
            });
          },
          { "./_fails": 100 },
        ],
        96: [
          function (require, module, exports) {
            var isObject = require("./_is-object");
            var document = require("./_global").document;
            // typeof document.createElement is 'object' in old IE
            var is = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
              return is ? document.createElement(it) : {};
            };
          },
          { "./_global": 102, "./_is-object": 111 },
        ],
        97: [
          function (require, module, exports) {
            // IE 8- don't enum bug keys
            module.exports =
              "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                ","
              );
          },
          {},
        ],
        98: [
          function (require, module, exports) {
            // all enumerable object keys, includes symbols
            var getKeys = require("./_object-keys");
            var gOPS = require("./_object-gops");
            var pIE = require("./_object-pie");
            module.exports = function (it) {
              var result = getKeys(it);
              var getSymbols = gOPS.f;
              if (getSymbols) {
                var symbols = getSymbols(it);
                var isEnum = pIE.f;
                var i = 0;
                var key;
                while (symbols.length > i)
                  if (isEnum.call(it, (key = symbols[i++]))) result.push(key);
              }
              return result;
            };
          },
          { "./_object-gops": 129, "./_object-keys": 132, "./_object-pie": 133 },
        ],
        99: [
          function (require, module, exports) {
            var global = require("./_global");
            var core = require("./_core");
            var ctx = require("./_ctx");
            var hide = require("./_hide");
            var has = require("./_has");
            var PROTOTYPE = "prototype";
  
            var $export = function (type, name, source) {
              var IS_FORCED = type & $export.F;
              var IS_GLOBAL = type & $export.G;
              var IS_STATIC = type & $export.S;
              var IS_PROTO = type & $export.P;
              var IS_BIND = type & $export.B;
              var IS_WRAP = type & $export.W;
              var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
              var expProto = exports[PROTOTYPE];
              var target = IS_GLOBAL
                ? global
                : IS_STATIC
                ? global[name]
                : (global[name] || {})[PROTOTYPE];
              var key, own, out;
              if (IS_GLOBAL) source = name;
              for (key in source) {
                // contains in native
                own = !IS_FORCED && target && target[key] !== undefined;
                if (own && has(exports, key)) continue;
                // export native or passed
                out = own ? target[key] : source[key];
                // prevent global pollution for namespaces
                exports[key] =
                  IS_GLOBAL && typeof target[key] != "function"
                    ? source[key]
                    : // bind timers to global for call from export context
                    IS_BIND && own
                    ? ctx(out, global)
                    : // wrap global constructors for prevent change them in library
                    IS_WRAP && target[key] == out
                    ? (function (C) {
                        var F = function (a, b, c) {
                          if (this instanceof C) {
                            switch (arguments.length) {
                              case 0:
                                return new C();
                              case 1:
                                return new C(a);
                              case 2:
                                return new C(a, b);
                            }
                            return new C(a, b, c);
                          }
                          return C.apply(this, arguments);
                        };
                        F[PROTOTYPE] = C[PROTOTYPE];
                        return F;
                        // make static versions for prototype methods
                      })(out)
                    : IS_PROTO && typeof out == "function"
                    ? ctx(Function.call, out)
                    : out;
                // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                if (IS_PROTO) {
                  (exports.virtual || (exports.virtual = {}))[key] = out;
                  // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                  if (type & $export.R && expProto && !expProto[key])
                    hide(expProto, key, out);
                }
              }
            };
            // type bitmap
            $export.F = 1; // forced
            $export.G = 2; // global
            $export.S = 4; // static
            $export.P = 8; // proto
            $export.B = 16; // bind
            $export.W = 32; // wrap
            $export.U = 64; // safe
            $export.R = 128; // real proto method for `library`
            module.exports = $export;
          },
          {
            "./_core": 91,
            "./_ctx": 93,
            "./_global": 102,
            "./_has": 103,
            "./_hide": 104,
          },
        ],
        100: [
          function (require, module, exports) {
            module.exports = function (exec) {
              try {
                return !!exec();
              } catch (e) {
                return true;
              }
            };
          },
          {},
        ],
        101: [
          function (require, module, exports) {
            var ctx = require("./_ctx");
            var call = require("./_iter-call");
            var isArrayIter = require("./_is-array-iter");
            var anObject = require("./_an-object");
            var toLength = require("./_to-length");
            var getIterFn = require("./core.get-iterator-method");
            var BREAK = {};
            var RETURN = {};
            var exports = (module.exports = function (
              iterable,
              entries,
              fn,
              that,
              ITERATOR
            ) {
              var iterFn = ITERATOR
                ? function () {
                    return iterable;
                  }
                : getIterFn(iterable);
              var f = ctx(fn, that, entries ? 2 : 1);
              var index = 0;
              var length, step, iterator, result;
              if (typeof iterFn != "function")
                throw TypeError(iterable + " is not iterable!");
              // fast case for arrays with default iterator
              if (isArrayIter(iterFn))
                for (
                  length = toLength(iterable.length);
                  length > index;
                  index++
                ) {
                  result = entries
                    ? f(anObject((step = iterable[index]))[0], step[1])
                    : f(iterable[index]);
                  if (result === BREAK || result === RETURN) return result;
                }
              else
                for (
                  iterator = iterFn.call(iterable);
                  !(step = iterator.next()).done;
  
                ) {
                  result = call(iterator, f, step.value, entries);
                  if (result === BREAK || result === RETURN) return result;
                }
            });
            exports.BREAK = BREAK;
            exports.RETURN = RETURN;
          },
          {
            "./_an-object": 80,
            "./_ctx": 93,
            "./_is-array-iter": 109,
            "./_iter-call": 112,
            "./_to-length": 153,
            "./core.get-iterator-method": 162,
          },
        ],
        102: [
          function (require, module, exports) {
            // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = (module.exports =
              typeof window != "undefined" && window.Math == Math
                ? window
                : typeof self != "undefined" && self.Math == Math
                ? self
                : // eslint-disable-next-line no-new-func
                  Function("return this")());
            if (typeof __g == "number") __g = global; // eslint-disable-line no-undef
          },
          {},
        ],
        103: [
          function (require, module, exports) {
            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
              return hasOwnProperty.call(it, key);
            };
          },
          {},
        ],
        104: [
          function (require, module, exports) {
            var dP = require("./_object-dp");
            var createDesc = require("./_property-desc");
            module.exports = require("./_descriptors")
              ? function (object, key, value) {
                  return dP.f(object, key, createDesc(1, value));
                }
              : function (object, key, value) {
                  object[key] = value;
                  return object;
                };
          },
          { "./_descriptors": 95, "./_object-dp": 124, "./_property-desc": 137 },
        ],
        105: [
          function (require, module, exports) {
            var document = require("./_global").document;
            module.exports = document && document.documentElement;
          },
          { "./_global": 102 },
        ],
        106: [
          function (require, module, exports) {
            module.exports =
              !require("./_descriptors") &&
              !require("./_fails")(function () {
                return (
                  Object.defineProperty(require("./_dom-create")("div"), "a", {
                    get: function () {
                      return 7;
                    },
                  }).a != 7
                );
              });
          },
          { "./_descriptors": 95, "./_dom-create": 96, "./_fails": 100 },
        ],
        107: [
          function (require, module, exports) {
            // fast apply, http://jsperf.lnkit.com/fast-apply/5
            module.exports = function (fn, args, that) {
              var un = that === undefined;
              switch (args.length) {
                case 0:
                  return un ? fn() : fn.call(that);
                case 1:
                  return un ? fn(args[0]) : fn.call(that, args[0]);
                case 2:
                  return un
                    ? fn(args[0], args[1])
                    : fn.call(that, args[0], args[1]);
                case 3:
                  return un
                    ? fn(args[0], args[1], args[2])
                    : fn.call(that, args[0], args[1], args[2]);
                case 4:
                  return un
                    ? fn(args[0], args[1], args[2], args[3])
                    : fn.call(that, args[0], args[1], args[2], args[3]);
              }
              return fn.apply(that, args);
            };
          },
          {},
        ],
        108: [
          function (require, module, exports) {
            // fallback for non-array-like ES3 and non-enumerable old V8 strings
            var cof = require("./_cof");
            // eslint-disable-next-line no-prototype-builtins
            module.exports = Object("z").propertyIsEnumerable(0)
              ? Object
              : function (it) {
                  return cof(it) == "String" ? it.split("") : Object(it);
                };
          },
          { "./_cof": 87 },
        ],
        109: [
          function (require, module, exports) {
            // check on default Array iterator
            var Iterators = require("./_iterators");
            var ITERATOR = require("./_wks")("iterator");
            var ArrayProto = Array.prototype;
  
            module.exports = function (it) {
              return (
                it !== undefined &&
                (Iterators.Array === it || ArrayProto[ITERATOR] === it)
              );
            };
          },
          { "./_iterators": 117, "./_wks": 161 },
        ],
        110: [
          function (require, module, exports) {
            // 7.2.2 IsArray(argument)
            var cof = require("./_cof");
            module.exports =
              Array.isArray ||
              function isArray(arg) {
                return cof(arg) == "Array";
              };
          },
          { "./_cof": 87 },
        ],
        111: [
          function (require, module, exports) {
            module.exports = function (it) {
              return typeof it === "object"
                ? it !== null
                : typeof it === "function";
            };
          },
          {},
        ],
        112: [
          function (require, module, exports) {
            // call something on iterator step with safe closing on error
            var anObject = require("./_an-object");
            module.exports = function (iterator, fn, value, entries) {
              try {
                return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                // 7.4.6 IteratorClose(iterator, completion)
              } catch (e) {
                var ret = iterator["return"];
                if (ret !== undefined) anObject(ret.call(iterator));
                throw e;
              }
            };
          },
          { "./_an-object": 80 },
        ],
        113: [
          function (require, module, exports) {
            "use strict";
            var create = require("./_object-create");
            var descriptor = require("./_property-desc");
            var setToStringTag = require("./_set-to-string-tag");
            var IteratorPrototype = {};
  
            // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            require("./_hide")(
              IteratorPrototype,
              require("./_wks")("iterator"),
              function () {
                return this;
              }
            );
  
            module.exports = function (Constructor, NAME, next) {
              Constructor.prototype = create(IteratorPrototype, {
                next: descriptor(1, next),
              });
              setToStringTag(Constructor, NAME + " Iterator");
            };
          },
          {
            "./_hide": 104,
            "./_object-create": 123,
            "./_property-desc": 137,
            "./_set-to-string-tag": 144,
            "./_wks": 161,
          },
        ],
        114: [
          function (require, module, exports) {
            "use strict";
            var LIBRARY = require("./_library");
            var $export = require("./_export");
            var redefine = require("./_redefine");
            var hide = require("./_hide");
            var Iterators = require("./_iterators");
            var $iterCreate = require("./_iter-create");
            var setToStringTag = require("./_set-to-string-tag");
            var getPrototypeOf = require("./_object-gpo");
            var ITERATOR = require("./_wks")("iterator");
            var BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
            var FF_ITERATOR = "@@iterator";
            var KEYS = "keys";
            var VALUES = "values";
  
            var returnThis = function () {
              return this;
            };
  
            module.exports = function (
              Base,
              NAME,
              Constructor,
              next,
              DEFAULT,
              IS_SET,
              FORCED
            ) {
              $iterCreate(Constructor, NAME, next);
              var getMethod = function (kind) {
                if (!BUGGY && kind in proto) return proto[kind];
                switch (kind) {
                  case KEYS:
                    return function keys() {
                      return new Constructor(this, kind);
                    };
                  case VALUES:
                    return function values() {
                      return new Constructor(this, kind);
                    };
                }
                return function entries() {
                  return new Constructor(this, kind);
                };
              };
              var TAG = NAME + " Iterator";
              var DEF_VALUES = DEFAULT == VALUES;
              var VALUES_BUG = false;
              var proto = Base.prototype;
              var $native =
                proto[ITERATOR] ||
                proto[FF_ITERATOR] ||
                (DEFAULT && proto[DEFAULT]);
              var $default = $native || getMethod(DEFAULT);
              var $entries = DEFAULT
                ? !DEF_VALUES
                  ? $default
                  : getMethod("entries")
                : undefined;
              var $anyNative =
                NAME == "Array" ? proto.entries || $native : $native;
              var methods, key, IteratorPrototype;
              // Fix native
              if ($anyNative) {
                IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                if (
                  IteratorPrototype !== Object.prototype &&
                  IteratorPrototype.next
                ) {
                  // Set @@toStringTag to native iterators
                  setToStringTag(IteratorPrototype, TAG, true);
                  // fix for some old engines
                  if (
                    !LIBRARY &&
                    typeof IteratorPrototype[ITERATOR] != "function"
                  )
                    hide(IteratorPrototype, ITERATOR, returnThis);
                }
              }
              // fix Array#{values, @@iterator}.name in V8 / FF
              if (DEF_VALUES && $native && $native.name !== VALUES) {
                VALUES_BUG = true;
                $default = function values() {
                  return $native.call(this);
                };
              }
              // Define iterator
              if (
                (!LIBRARY || FORCED) &&
                (BUGGY || VALUES_BUG || !proto[ITERATOR])
              ) {
                hide(proto, ITERATOR, $default);
              }
              // Plug for library
              Iterators[NAME] = $default;
              Iterators[TAG] = returnThis;
              if (DEFAULT) {
                methods = {
                  values: DEF_VALUES ? $default : getMethod(VALUES),
                  keys: IS_SET ? $default : getMethod(KEYS),
                  entries: $entries,
                };
                if (FORCED)
                  for (key in methods) {
                    if (!(key in proto)) redefine(proto, key, methods[key]);
                  }
                else
                  $export(
                    $export.P + $export.F * (BUGGY || VALUES_BUG),
                    NAME,
                    methods
                  );
              }
              return methods;
            };
          },
          {
            "./_export": 99,
            "./_hide": 104,
            "./_iter-create": 113,
            "./_iterators": 117,
            "./_library": 118,
            "./_object-gpo": 130,
            "./_redefine": 139,
            "./_set-to-string-tag": 144,
            "./_wks": 161,
          },
        ],
        115: [
          function (require, module, exports) {
            var ITERATOR = require("./_wks")("iterator");
            var SAFE_CLOSING = false;
  
            try {
              var riter = [7][ITERATOR]();
              riter["return"] = function () {
                SAFE_CLOSING = true;
              };
              // eslint-disable-next-line no-throw-literal
              Array.from(riter, function () {
                throw 2;
              });
            } catch (e) {
              /* empty */
            }
  
            module.exports = function (exec, skipClosing) {
              if (!skipClosing && !SAFE_CLOSING) return false;
              var safe = false;
              try {
                var arr = [7];
                var iter = arr[ITERATOR]();
                iter.next = function () {
                  return { done: (safe = true) };
                };
                arr[ITERATOR] = function () {
                  return iter;
                };
                exec(arr);
              } catch (e) {
                /* empty */
              }
              return safe;
            };
          },
          { "./_wks": 161 },
        ],
        116: [
          function (require, module, exports) {
            module.exports = function (done, value) {
              return { value: value, done: !!done };
            };
          },
          {},
        ],
        117: [
          function (require, module, exports) {
            module.exports = {};
          },
          {},
        ],
        118: [
          function (require, module, exports) {
            module.exports = true;
          },
          {},
        ],
        119: [
          function (require, module, exports) {
            var META = require("./_uid")("meta");
            var isObject = require("./_is-object");
            var has = require("./_has");
            var setDesc = require("./_object-dp").f;
            var id = 0;
            var isExtensible =
              Object.isExtensible ||
              function () {
                return true;
              };
            var FREEZE = !require("./_fails")(function () {
              return isExtensible(Object.preventExtensions({}));
            });
            var setMeta = function (it) {
              setDesc(it, META, {
                value: {
                  i: "O" + ++id, // object ID
                  w: {}, // weak collections IDs
                },
              });
            };
            var fastKey = function (it, create) {
              // return primitive with prefix
              if (!isObject(it))
                return typeof it == "symbol"
                  ? it
                  : (typeof it == "string" ? "S" : "P") + it;
              if (!has(it, META)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return "F";
                // not necessary to add metadata
                if (!create) return "E";
                // add missing metadata
                setMeta(it);
                // return object ID
              }
              return it[META].i;
            };
            var getWeak = function (it, create) {
              if (!has(it, META)) {
                // can't set metadata to uncaught frozen object
                if (!isExtensible(it)) return true;
                // not necessary to add metadata
                if (!create) return false;
                // add missing metadata
                setMeta(it);
                // return hash weak collections IDs
              }
              return it[META].w;
            };
            // add metadata on freeze-family methods calling
            var onFreeze = function (it) {
              if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META))
                setMeta(it);
              return it;
            };
            var meta = (module.exports = {
              KEY: META,
              NEED: false,
              fastKey: fastKey,
              getWeak: getWeak,
              onFreeze: onFreeze,
            });
          },
          {
            "./_fails": 100,
            "./_has": 103,
            "./_is-object": 111,
            "./_object-dp": 124,
            "./_uid": 156,
          },
        ],
        120: [
          function (require, module, exports) {
            var global = require("./_global");
            var macrotask = require("./_task").set;
            var Observer =
              global.MutationObserver || global.WebKitMutationObserver;
            var process = global.process;
            var Promise = global.Promise;
            var isNode = require("./_cof")(process) == "process";
  
            module.exports = function () {
              var head, last, notify;
  
              var flush = function () {
                var parent, fn;
                if (isNode && (parent = process.domain)) parent.exit();
                while (head) {
                  fn = head.fn;
                  head = head.next;
                  try {
                    fn();
                  } catch (e) {
                    if (head) notify();
                    else last = undefined;
                    throw e;
                  }
                }
                last = undefined;
                if (parent) parent.enter();
              };
  
              // Node.js
              if (isNode) {
                notify = function () {
                  process.nextTick(flush);
                };
                // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
              } else if (
                Observer &&
                !(global.navigator && global.navigator.standalone)
              ) {
                var toggle = true;
                var node = document.createTextNode("");
                new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
                notify = function () {
                  node.data = toggle = !toggle;
                };
                // environments with maybe non-completely correct, but existent Promise
              } else if (Promise && Promise.resolve) {
                // Promise.resolve without an argument throws an error in LG WebOS 2
                var promise = Promise.resolve(undefined);
                notify = function () {
                  promise.then(flush);
                };
                // for other environments - macrotask based on:
                // - setImmediate
                // - MessageChannel
                // - window.postMessag
                // - onreadystatechange
                // - setTimeout
              } else {
                notify = function () {
                  // strange IE + webpack dev server bug - use .call(global)
                  macrotask.call(global, flush);
                };
              }
  
              return function (fn) {
                var task = { fn: fn, next: undefined };
                if (last) last.next = task;
                if (!head) {
                  head = task;
                  notify();
                }
                last = task;
              };
            };
          },
          { "./_cof": 87, "./_global": 102, "./_task": 149 },
        ],
        121: [
          function (require, module, exports) {
            "use strict";
            // 25.4.1.5 NewPromiseCapability(C)
            var aFunction = require("./_a-function");
  
            function PromiseCapability(C) {
              var resolve, reject;
              this.promise = new C(function ($$resolve, $$reject) {
                if (resolve !== undefined || reject !== undefined)
                  throw TypeError("Bad Promise constructor");
                resolve = $$resolve;
                reject = $$reject;
              });
              this.resolve = aFunction(resolve);
              this.reject = aFunction(reject);
            }
  
            module.exports.f = function (C) {
              return new PromiseCapability(C);
            };
          },
          { "./_a-function": 77 },
        ],
        122: [
          function (require, module, exports) {
            "use strict";
            // 19.1.2.1 Object.assign(target, source, ...)
            var DESCRIPTORS = require("./_descriptors");
            var getKeys = require("./_object-keys");
            var gOPS = require("./_object-gops");
            var pIE = require("./_object-pie");
            var toObject = require("./_to-object");
            var IObject = require("./_iobject");
            var $assign = Object.assign;
  
            // should work with symbols and should have deterministic property order (V8 bug)
            module.exports =
              !$assign ||
              require("./_fails")(function () {
                var A = {};
                var B = {};
                // eslint-disable-next-line no-undef
                var S = Symbol();
                var K = "abcdefghijklmnopqrst";
                A[S] = 7;
                K.split("").forEach(function (k) {
                  B[k] = k;
                });
                return (
                  $assign({}, A)[S] != 7 ||
                  Object.keys($assign({}, B)).join("") != K
                );
              })
                ? function assign(target, source) {
                    // eslint-disable-line no-unused-vars
                    var T = toObject(target);
                    var aLen = arguments.length;
                    var index = 1;
                    var getSymbols = gOPS.f;
                    var isEnum = pIE.f;
                    while (aLen > index) {
                      var S = IObject(arguments[index++]);
                      var keys = getSymbols
                        ? getKeys(S).concat(getSymbols(S))
                        : getKeys(S);
                      var length = keys.length;
                      var j = 0;
                      var key;
                      while (length > j) {
                        key = keys[j++];
                        if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
                      }
                    }
                    return T;
                  }
                : $assign;
          },
          {
            "./_descriptors": 95,
            "./_fails": 100,
            "./_iobject": 108,
            "./_object-gops": 129,
            "./_object-keys": 132,
            "./_object-pie": 133,
            "./_to-object": 154,
          },
        ],
        123: [
          function (require, module, exports) {
            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            var anObject = require("./_an-object");
            var dPs = require("./_object-dps");
            var enumBugKeys = require("./_enum-bug-keys");
            var IE_PROTO = require("./_shared-key")("IE_PROTO");
            var Empty = function () {
              /* empty */
            };
            var PROTOTYPE = "prototype";
  
            // Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function () {
              // Thrash, waste and sodomy: IE GC bug
              var iframe = require("./_dom-create")("iframe");
              var i = enumBugKeys.length;
              var lt = "<";
              var gt = ">";
              var iframeDocument;
              iframe.style.display = "none";
              require("./_html").appendChild(iframe);
              iframe.src = "javascript:"; // eslint-disable-line no-script-url
              // createDict = iframe.contentWindow.Object;
              // html.removeChild(iframe);
              iframeDocument = iframe.contentWindow.document;
              iframeDocument.open();
              iframeDocument.write(
                lt + "script" + gt + "document.F=Object" + lt + "/script" + gt
              );
              iframeDocument.close();
              createDict = iframeDocument.F;
              while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
              return createDict();
            };
  
            module.exports =
              Object.create ||
              function create(O, Properties) {
                var result;
                if (O !== null) {
                  Empty[PROTOTYPE] = anObject(O);
                  result = new Empty();
                  Empty[PROTOTYPE] = null;
                  // add "__proto__" for Object.getPrototypeOf polyfill
                  result[IE_PROTO] = O;
                } else result = createDict();
                return Properties === undefined
                  ? result
                  : dPs(result, Properties);
              };
          },
          {
            "./_an-object": 80,
            "./_dom-create": 96,
            "./_enum-bug-keys": 97,
            "./_html": 105,
            "./_object-dps": 125,
            "./_shared-key": 145,
          },
        ],
        124: [
          function (require, module, exports) {
            var anObject = require("./_an-object");
            var IE8_DOM_DEFINE = require("./_ie8-dom-define");
            var toPrimitive = require("./_to-primitive");
            var dP = Object.defineProperty;
  
            exports.f = require("./_descriptors")
              ? Object.defineProperty
              : function defineProperty(O, P, Attributes) {
                  anObject(O);
                  P = toPrimitive(P, true);
                  anObject(Attributes);
                  if (IE8_DOM_DEFINE)
                    try {
                      return dP(O, P, Attributes);
                    } catch (e) {
                      /* empty */
                    }
                  if ("get" in Attributes || "set" in Attributes)
                    throw TypeError("Accessors not supported!");
                  if ("value" in Attributes) O[P] = Attributes.value;
                  return O;
                };
          },
          {
            "./_an-object": 80,
            "./_descriptors": 95,
            "./_ie8-dom-define": 106,
            "./_to-primitive": 155,
          },
        ],
        125: [
          function (require, module, exports) {
            var dP = require("./_object-dp");
            var anObject = require("./_an-object");
            var getKeys = require("./_object-keys");
  
            module.exports = require("./_descriptors")
              ? Object.defineProperties
              : function defineProperties(O, Properties) {
                  anObject(O);
                  var keys = getKeys(Properties);
                  var length = keys.length;
                  var i = 0;
                  var P;
                  while (length > i) dP.f(O, (P = keys[i++]), Properties[P]);
                  return O;
                };
          },
          {
            "./_an-object": 80,
            "./_descriptors": 95,
            "./_object-dp": 124,
            "./_object-keys": 132,
          },
        ],
        126: [
          function (require, module, exports) {
            var pIE = require("./_object-pie");
            var createDesc = require("./_property-desc");
            var toIObject = require("./_to-iobject");
            var toPrimitive = require("./_to-primitive");
            var has = require("./_has");
            var IE8_DOM_DEFINE = require("./_ie8-dom-define");
            var gOPD = Object.getOwnPropertyDescriptor;
  
            exports.f = require("./_descriptors")
              ? gOPD
              : function getOwnPropertyDescriptor(O, P) {
                  O = toIObject(O);
                  P = toPrimitive(P, true);
                  if (IE8_DOM_DEFINE)
                    try {
                      return gOPD(O, P);
                    } catch (e) {
                      /* empty */
                    }
                  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
                };
          },
          {
            "./_descriptors": 95,
            "./_has": 103,
            "./_ie8-dom-define": 106,
            "./_object-pie": 133,
            "./_property-desc": 137,
            "./_to-iobject": 152,
            "./_to-primitive": 155,
          },
        ],
        127: [
          function (require, module, exports) {
            // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            var toIObject = require("./_to-iobject");
            var gOPN = require("./_object-gopn").f;
            var toString = {}.toString;
  
            var windowNames =
              typeof window == "object" && window && Object.getOwnPropertyNames
                ? Object.getOwnPropertyNames(window)
                : [];
  
            var getWindowNames = function (it) {
              try {
                return gOPN(it);
              } catch (e) {
                return windowNames.slice();
              }
            };
  
            module.exports.f = function getOwnPropertyNames(it) {
              return windowNames && toString.call(it) == "[object Window]"
                ? getWindowNames(it)
                : gOPN(toIObject(it));
            };
          },
          { "./_object-gopn": 128, "./_to-iobject": 152 },
        ],
        128: [
          function (require, module, exports) {
            // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var $keys = require("./_object-keys-internal");
            var hiddenKeys = require("./_enum-bug-keys").concat(
              "length",
              "prototype"
            );
  
            exports.f =
              Object.getOwnPropertyNames ||
              function getOwnPropertyNames(O) {
                return $keys(O, hiddenKeys);
              };
          },
          { "./_enum-bug-keys": 97, "./_object-keys-internal": 131 },
        ],
        129: [
          function (require, module, exports) {
            exports.f = Object.getOwnPropertySymbols;
          },
          {},
        ],
        130: [
          function (require, module, exports) {
            // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            var has = require("./_has");
            var toObject = require("./_to-object");
            var IE_PROTO = require("./_shared-key")("IE_PROTO");
            var ObjectProto = Object.prototype;
  
            module.exports =
              Object.getPrototypeOf ||
              function (O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (
                  typeof O.constructor == "function" &&
                  O instanceof O.constructor
                ) {
                  return O.constructor.prototype;
                }
                return O instanceof Object ? ObjectProto : null;
              };
          },
          { "./_has": 103, "./_shared-key": 145, "./_to-object": 154 },
        ],
        131: [
          function (require, module, exports) {
            var has = require("./_has");
            var toIObject = require("./_to-iobject");
            var arrayIndexOf = require("./_array-includes")(false);
            var IE_PROTO = require("./_shared-key")("IE_PROTO");
  
            module.exports = function (object, names) {
              var O = toIObject(object);
              var i = 0;
              var result = [];
              var key;
              for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
              // Don't enum bug & hidden keys
              while (names.length > i)
                if (has(O, (key = names[i++]))) {
                  ~arrayIndexOf(result, key) || result.push(key);
                }
              return result;
            };
          },
          {
            "./_array-includes": 82,
            "./_has": 103,
            "./_shared-key": 145,
            "./_to-iobject": 152,
          },
        ],
        132: [
          function (require, module, exports) {
            // 19.1.2.14 / 15.2.3.14 Object.keys(O)
            var $keys = require("./_object-keys-internal");
            var enumBugKeys = require("./_enum-bug-keys");
  
            module.exports =
              Object.keys ||
              function keys(O) {
                return $keys(O, enumBugKeys);
              };
          },
          { "./_enum-bug-keys": 97, "./_object-keys-internal": 131 },
        ],
        133: [
          function (require, module, exports) {
            exports.f = {}.propertyIsEnumerable;
          },
          {},
        ],
        134: [
          function (require, module, exports) {
            // most Object methods by ES6 should accept primitives
            var $export = require("./_export");
            var core = require("./_core");
            var fails = require("./_fails");
            module.exports = function (KEY, exec) {
              var fn = (core.Object || {})[KEY] || Object[KEY];
              var exp = {};
              exp[KEY] = exec(fn);
              $export(
                $export.S +
                  $export.F *
                    fails(function () {
                      fn(1);
                    }),
                "Object",
                exp
              );
            };
          },
          { "./_core": 91, "./_export": 99, "./_fails": 100 },
        ],
        135: [
          function (require, module, exports) {
            module.exports = function (exec) {
              try {
                return { e: false, v: exec() };
              } catch (e) {
                return { e: true, v: e };
              }
            };
          },
          {},
        ],
        136: [
          function (require, module, exports) {
            var anObject = require("./_an-object");
            var isObject = require("./_is-object");
            var newPromiseCapability = require("./_new-promise-capability");
  
            module.exports = function (C, x) {
              anObject(C);
              if (isObject(x) && x.constructor === C) return x;
              var promiseCapability = newPromiseCapability.f(C);
              var resolve = promiseCapability.resolve;
              resolve(x);
              return promiseCapability.promise;
            };
          },
          {
            "./_an-object": 80,
            "./_is-object": 111,
            "./_new-promise-capability": 121,
          },
        ],
        137: [
          function (require, module, exports) {
            module.exports = function (bitmap, value) {
              return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value,
              };
            };
          },
          {},
        ],
        138: [
          function (require, module, exports) {
            var hide = require("./_hide");
            module.exports = function (target, src, safe) {
              for (var key in src) {
                if (safe && target[key]) target[key] = src[key];
                else hide(target, key, src[key]);
              }
              return target;
            };
          },
          { "./_hide": 104 },
        ],
        139: [
          function (require, module, exports) {
            module.exports = require("./_hide");
          },
          { "./_hide": 104 },
        ],
        140: [
          function (require, module, exports) {
            "use strict";
            // https://tc39.github.io/proposal-setmap-offrom/
            var $export = require("./_export");
            var aFunction = require("./_a-function");
            var ctx = require("./_ctx");
            var forOf = require("./_for-of");
  
            module.exports = function (COLLECTION) {
              $export($export.S, COLLECTION, {
                from: function from(source /* , mapFn, thisArg */) {
                  var mapFn = arguments[1];
                  var mapping, A, n, cb;
                  aFunction(this);
                  mapping = mapFn !== undefined;
                  if (mapping) aFunction(mapFn);
                  if (source == undefined) return new this();
                  A = [];
                  if (mapping) {
                    n = 0;
                    cb = ctx(mapFn, arguments[2], 2);
                    forOf(source, false, function (nextItem) {
                      A.push(cb(nextItem, n++));
                    });
                  } else {
                    forOf(source, false, A.push, A);
                  }
                  return new this(A);
                },
              });
            };
          },
          {
            "./_a-function": 77,
            "./_ctx": 93,
            "./_export": 99,
            "./_for-of": 101,
          },
        ],
        141: [
          function (require, module, exports) {
            "use strict";
            // https://tc39.github.io/proposal-setmap-offrom/
            var $export = require("./_export");
  
            module.exports = function (COLLECTION) {
              $export($export.S, COLLECTION, {
                of: function of() {
                  var length = arguments.length;
                  var A = new Array(length);
                  while (length--) A[length] = arguments[length];
                  return new this(A);
                },
              });
            };
          },
          { "./_export": 99 },
        ],
        142: [
          function (require, module, exports) {
            // Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */
            var isObject = require("./_is-object");
            var anObject = require("./_an-object");
            var check = function (O, proto) {
              anObject(O);
              if (!isObject(proto) && proto !== null)
                throw TypeError(proto + ": can't set as prototype!");
            };
            module.exports = {
              set:
                Object.setPrototypeOf ||
                ("__proto__" in {} // eslint-disable-line
                  ? (function (test, buggy, set) {
                      try {
                        set = require("./_ctx")(
                          Function.call,
                          require("./_object-gopd").f(
                            Object.prototype,
                            "__proto__"
                          ).set,
                          2
                        );
                        set(test, []);
                        buggy = !(test instanceof Array);
                      } catch (e) {
                        buggy = true;
                      }
                      return function setPrototypeOf(O, proto) {
                        check(O, proto);
                        if (buggy) O.__proto__ = proto;
                        else set(O, proto);
                        return O;
                      };
                    })({}, false)
                  : undefined),
              check: check,
            };
          },
          {
            "./_an-object": 80,
            "./_ctx": 93,
            "./_is-object": 111,
            "./_object-gopd": 126,
          },
        ],
        143: [
          function (require, module, exports) {
            "use strict";
            var global = require("./_global");
            var core = require("./_core");
            var dP = require("./_object-dp");
            var DESCRIPTORS = require("./_descriptors");
            var SPECIES = require("./_wks")("species");
  
            module.exports = function (KEY) {
              var C = typeof core[KEY] == "function" ? core[KEY] : global[KEY];
              if (DESCRIPTORS && C && !C[SPECIES])
                dP.f(C, SPECIES, {
                  configurable: true,
                  get: function () {
                    return this;
                  },
                });
            };
          },
          {
            "./_core": 91,
            "./_descriptors": 95,
            "./_global": 102,
            "./_object-dp": 124,
            "./_wks": 161,
          },
        ],
        144: [
          function (require, module, exports) {
            var def = require("./_object-dp").f;
            var has = require("./_has");
            var TAG = require("./_wks")("toStringTag");
  
            module.exports = function (it, tag, stat) {
              if (it && !has((it = stat ? it : it.prototype), TAG))
                def(it, TAG, { configurable: true, value: tag });
            };
          },
          { "./_has": 103, "./_object-dp": 124, "./_wks": 161 },
        ],
        145: [
          function (require, module, exports) {
            var shared = require("./_shared")("keys");
            var uid = require("./_uid");
            module.exports = function (key) {
              return shared[key] || (shared[key] = uid(key));
            };
          },
          { "./_shared": 146, "./_uid": 156 },
        ],
        146: [
          function (require, module, exports) {
            var core = require("./_core");
            var global = require("./_global");
            var SHARED = "__core-js_shared__";
            var store = global[SHARED] || (global[SHARED] = {});
  
            (module.exports = function (key, value) {
              return (
                store[key] || (store[key] = value !== undefined ? value : {})
              );
            })("versions", []).push({
              version: core.version,
              mode: require("./_library") ? "pure" : "global",
              copyright: "© 2020 Denis Pushkarev (zloirock.ru)",
            });
          },
          { "./_core": 91, "./_global": 102, "./_library": 118 },
        ],
        147: [
          function (require, module, exports) {
            // 7.3.20 SpeciesConstructor(O, defaultConstructor)
            var anObject = require("./_an-object");
            var aFunction = require("./_a-function");
            var SPECIES = require("./_wks")("species");
            module.exports = function (O, D) {
              var C = anObject(O).constructor;
              var S;
              return C === undefined || (S = anObject(C)[SPECIES]) == undefined
                ? D
                : aFunction(S);
            };
          },
          { "./_a-function": 77, "./_an-object": 80, "./_wks": 161 },
        ],
        148: [
          function (require, module, exports) {
            var toInteger = require("./_to-integer");
            var defined = require("./_defined");
            // true  -> String#at
            // false -> String#codePointAt
            module.exports = function (TO_STRING) {
              return function (that, pos) {
                var s = String(defined(that));
                var i = toInteger(pos);
                var l = s.length;
                var a, b;
                if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
                a = s.charCodeAt(i);
                return a < 0xd800 ||
                  a > 0xdbff ||
                  i + 1 === l ||
                  (b = s.charCodeAt(i + 1)) < 0xdc00 ||
                  b > 0xdfff
                  ? TO_STRING
                    ? s.charAt(i)
                    : a
                  : TO_STRING
                  ? s.slice(i, i + 2)
                  : ((a - 0xd800) << 10) + (b - 0xdc00) + 0x10000;
              };
            };
          },
          { "./_defined": 94, "./_to-integer": 151 },
        ],
        149: [
          function (require, module, exports) {
            var ctx = require("./_ctx");
            var invoke = require("./_invoke");
            var html = require("./_html");
            var cel = require("./_dom-create");
            var global = require("./_global");
            var process = global.process;
            var setTask = global.setImmediate;
            var clearTask = global.clearImmediate;
            var MessageChannel = global.MessageChannel;
            var Dispatch = global.Dispatch;
            var counter = 0;
            var queue = {};
            var ONREADYSTATECHANGE = "onreadystatechange";
            var defer, channel, port;
            var run = function () {
              var id = +this;
              // eslint-disable-next-line no-prototype-builtins
              if (queue.hasOwnProperty(id)) {
                var fn = queue[id];
                delete queue[id];
                fn();
              }
            };
            var listener = function (event) {
              run.call(event.data);
            };
            // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
            if (!setTask || !clearTask) {
              setTask = function setImmediate(fn) {
                var args = [];
                var i = 1;
                while (arguments.length > i) args.push(arguments[i++]);
                queue[++counter] = function () {
                  // eslint-disable-next-line no-new-func
                  invoke(typeof fn == "function" ? fn : Function(fn), args);
                };
                defer(counter);
                return counter;
              };
              clearTask = function clearImmediate(id) {
                delete queue[id];
              };
              // Node.js 0.8-
              if (require("./_cof")(process) == "process") {
                defer = function (id) {
                  process.nextTick(ctx(run, id, 1));
                };
                // Sphere (JS game engine) Dispatch API
              } else if (Dispatch && Dispatch.now) {
                defer = function (id) {
                  Dispatch.now(ctx(run, id, 1));
                };
                // Browsers with MessageChannel, includes WebWorkers
              } else if (MessageChannel) {
                channel = new MessageChannel();
                port = channel.port2;
                channel.port1.onmessage = listener;
                defer = ctx(port.postMessage, port, 1);
                // Browsers with postMessage, skip WebWorkers
                // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
              } else if (
                global.addEventListener &&
                typeof postMessage == "function" &&
                !global.importScripts
              ) {
                defer = function (id) {
                  global.postMessage(id + "", "*");
                };
                global.addEventListener("message", listener, false);
                // IE8-
              } else if (ONREADYSTATECHANGE in cel("script")) {
                defer = function (id) {
                  html.appendChild(cel("script"))[ONREADYSTATECHANGE] =
                    function () {
                      html.removeChild(this);
                      run.call(id);
                    };
                };
                // Rest old browsers
              } else {
                defer = function (id) {
                  setTimeout(ctx(run, id, 1), 0);
                };
              }
            }
            module.exports = {
              set: setTask,
              clear: clearTask,
            };
          },
          {
            "./_cof": 87,
            "./_ctx": 93,
            "./_dom-create": 96,
            "./_global": 102,
            "./_html": 105,
            "./_invoke": 107,
          },
        ],
        150: [
          function (require, module, exports) {
            var toInteger = require("./_to-integer");
            var max = Math.max;
            var min = Math.min;
            module.exports = function (index, length) {
              index = toInteger(index);
              return index < 0 ? max(index + length, 0) : min(index, length);
            };
          },
          { "./_to-integer": 151 },
        ],
        151: [
          function (require, module, exports) {
            // 7.1.4 ToInteger
            var ceil = Math.ceil;
            var floor = Math.floor;
            module.exports = function (it) {
              return isNaN((it = +it)) ? 0 : (it > 0 ? floor : ceil)(it);
            };
          },
          {},
        ],
        152: [
          function (require, module, exports) {
            // to indexed object, toObject with fallback for non-array-like ES3 strings
            var IObject = require("./_iobject");
            var defined = require("./_defined");
            module.exports = function (it) {
              return IObject(defined(it));
            };
          },
          { "./_defined": 94, "./_iobject": 108 },
        ],
        153: [
          function (require, module, exports) {
            // 7.1.15 ToLength
            var toInteger = require("./_to-integer");
            var min = Math.min;
            module.exports = function (it) {
              return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
            };
          },
          { "./_to-integer": 151 },
        ],
        154: [
          function (require, module, exports) {
            // 7.1.13 ToObject(argument)
            var defined = require("./_defined");
            module.exports = function (it) {
              return Object(defined(it));
            };
          },
          { "./_defined": 94 },
        ],
        155: [
          function (require, module, exports) {
            // 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = require("./_is-object");
            // instead of the ES6 spec version, we didn't implement @@toPrimitive case
            // and the second argument - flag - preferred type is a string
            module.exports = function (it, S) {
              if (!isObject(it)) return it;
              var fn, val;
              if (
                S &&
                typeof (fn = it.toString) == "function" &&
                !isObject((val = fn.call(it)))
              )
                return val;
              if (
                typeof (fn = it.valueOf) == "function" &&
                !isObject((val = fn.call(it)))
              )
                return val;
              if (
                !S &&
                typeof (fn = it.toString) == "function" &&
                !isObject((val = fn.call(it)))
              )
                return val;
              throw TypeError("Can't convert object to primitive value");
            };
          },
          { "./_is-object": 111 },
        ],
        156: [
          function (require, module, exports) {
            var id = 0;
            var px = Math.random();
            module.exports = function (key) {
              return "Symbol(".concat(
                key === undefined ? "" : key,
                ")_",
                (++id + px).toString(36)
              );
            };
          },
          {},
        ],
        157: [
          function (require, module, exports) {
            var global = require("./_global");
            var navigator = global.navigator;
  
            module.exports = (navigator && navigator.userAgent) || "";
          },
          { "./_global": 102 },
        ],
        158: [
          function (require, module, exports) {
            var isObject = require("./_is-object");
            module.exports = function (it, TYPE) {
              if (!isObject(it) || it._t !== TYPE)
                throw TypeError("Incompatible receiver, " + TYPE + " required!");
              return it;
            };
          },
          { "./_is-object": 111 },
        ],
        159: [
          function (require, module, exports) {
            var global = require("./_global");
            var core = require("./_core");
            var LIBRARY = require("./_library");
            var wksExt = require("./_wks-ext");
            var defineProperty = require("./_object-dp").f;
            module.exports = function (name) {
              var $Symbol =
                core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
              if (name.charAt(0) != "_" && !(name in $Symbol))
                defineProperty($Symbol, name, { value: wksExt.f(name) });
            };
          },
          {
            "./_core": 91,
            "./_global": 102,
            "./_library": 118,
            "./_object-dp": 124,
            "./_wks-ext": 160,
          },
        ],
        160: [
          function (require, module, exports) {
            exports.f = require("./_wks");
          },
          { "./_wks": 161 },
        ],
        161: [
          function (require, module, exports) {
            var store = require("./_shared")("wks");
            var uid = require("./_uid");
            var Symbol = require("./_global").Symbol;
            var USE_SYMBOL = typeof Symbol == "function";
  
            var $exports = (module.exports = function (name) {
              return (
                store[name] ||
                (store[name] =
                  (USE_SYMBOL && Symbol[name]) ||
                  (USE_SYMBOL ? Symbol : uid)("Symbol." + name))
              );
            });
  
            $exports.store = store;
          },
          { "./_global": 102, "./_shared": 146, "./_uid": 156 },
        ],
        162: [
          function (require, module, exports) {
            var classof = require("./_classof");
            var ITERATOR = require("./_wks")("iterator");
            var Iterators = require("./_iterators");
            module.exports = require("./_core").getIteratorMethod = function (
              it
            ) {
              if (it != undefined)
                return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
            };
          },
          { "./_classof": 86, "./_core": 91, "./_iterators": 117, "./_wks": 161 },
        ],
        163: [
          function (require, module, exports) {
            var anObject = require("./_an-object");
            var get = require("./core.get-iterator-method");
            module.exports = require("./_core").getIterator = function (it) {
              var iterFn = get(it);
              if (typeof iterFn != "function")
                throw TypeError(it + " is not iterable!");
              return anObject(iterFn.call(it));
            };
          },
          {
            "./_an-object": 80,
            "./_core": 91,
            "./core.get-iterator-method": 162,
          },
        ],
        164: [
          function (require, module, exports) {
            "use strict";
            var ctx = require("./_ctx");
            var $export = require("./_export");
            var toObject = require("./_to-object");
            var call = require("./_iter-call");
            var isArrayIter = require("./_is-array-iter");
            var toLength = require("./_to-length");
            var createProperty = require("./_create-property");
            var getIterFn = require("./core.get-iterator-method");
  
            $export(
              $export.S +
                $export.F *
                  !require("./_iter-detect")(function (iter) {
                    Array.from(iter);
                  }),
              "Array",
              {
                // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
                from: function from(
                  arrayLike /* , mapfn = undefined, thisArg = undefined */
                ) {
                  var O = toObject(arrayLike);
                  var C = typeof this == "function" ? this : Array;
                  var aLen = arguments.length;
                  var mapfn = aLen > 1 ? arguments[1] : undefined;
                  var mapping = mapfn !== undefined;
                  var index = 0;
                  var iterFn = getIterFn(O);
                  var length, result, step, iterator;
                  if (mapping)
                    mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
                  // if object isn't iterable or it's array with default iterator - use simple case
                  if (
                    iterFn != undefined &&
                    !(C == Array && isArrayIter(iterFn))
                  ) {
                    for (
                      iterator = iterFn.call(O), result = new C();
                      !(step = iterator.next()).done;
                      index++
                    ) {
                      createProperty(
                        result,
                        index,
                        mapping
                          ? call(iterator, mapfn, [step.value, index], true)
                          : step.value
                      );
                    }
                  } else {
                    length = toLength(O.length);
                    for (result = new C(length); length > index; index++) {
                      createProperty(
                        result,
                        index,
                        mapping ? mapfn(O[index], index) : O[index]
                      );
                    }
                  }
                  result.length = index;
                  return result;
                },
              }
            );
          },
          {
            "./_create-property": 92,
            "./_ctx": 93,
            "./_export": 99,
            "./_is-array-iter": 109,
            "./_iter-call": 112,
            "./_iter-detect": 115,
            "./_to-length": 153,
            "./_to-object": 154,
            "./core.get-iterator-method": 162,
          },
        ],
        165: [
          function (require, module, exports) {
            "use strict";
            var addToUnscopables = require("./_add-to-unscopables");
            var step = require("./_iter-step");
            var Iterators = require("./_iterators");
            var toIObject = require("./_to-iobject");
  
            // 22.1.3.4 Array.prototype.entries()
            // 22.1.3.13 Array.prototype.keys()
            // 22.1.3.29 Array.prototype.values()
            // 22.1.3.30 Array.prototype[@@iterator]()
            module.exports = require("./_iter-define")(
              Array,
              "Array",
              function (iterated, kind) {
                this._t = toIObject(iterated); // target
                this._i = 0; // next index
                this._k = kind; // kind
                // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
              },
              function () {
                var O = this._t;
                var kind = this._k;
                var index = this._i++;
                if (!O || index >= O.length) {
                  this._t = undefined;
                  return step(1);
                }
                if (kind == "keys") return step(0, index);
                if (kind == "values") return step(0, O[index]);
                return step(0, [index, O[index]]);
              },
              "values"
            );
  
            // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
            Iterators.Arguments = Iterators.Array;
  
            addToUnscopables("keys");
            addToUnscopables("values");
            addToUnscopables("entries");
          },
          {
            "./_add-to-unscopables": 78,
            "./_iter-define": 114,
            "./_iter-step": 116,
            "./_iterators": 117,
            "./_to-iobject": 152,
          },
        ],
        166: [
          function (require, module, exports) {
            "use strict";
            var strong = require("./_collection-strong");
            var validate = require("./_validate-collection");
            var MAP = "Map";
  
            // 23.1 Map Objects
            module.exports = require("./_collection")(
              MAP,
              function (get) {
                return function Map() {
                  return get(
                    this,
                    arguments.length > 0 ? arguments[0] : undefined
                  );
                };
              },
              {
                // 23.1.3.6 Map.prototype.get(key)
                get: function get(key) {
                  var entry = strong.getEntry(validate(this, MAP), key);
                  return entry && entry.v;
                },
                // 23.1.3.9 Map.prototype.set(key, value)
                set: function set(key, value) {
                  return strong.def(
                    validate(this, MAP),
                    key === 0 ? 0 : key,
                    value
                  );
                },
              },
              strong,
              true
            );
          },
          {
            "./_collection": 90,
            "./_collection-strong": 88,
            "./_validate-collection": 158,
          },
        ],
        167: [
          function (require, module, exports) {
            // 20.1.2.1 Number.EPSILON
            var $export = require("./_export");
  
            $export($export.S, "Number", { EPSILON: Math.pow(2, -52) });
          },
          { "./_export": 99 },
        ],
        168: [
          function (require, module, exports) {
            // 19.1.3.1 Object.assign(target, source)
            var $export = require("./_export");
  
            $export($export.S + $export.F, "Object", {
              assign: require("./_object-assign"),
            });
          },
          { "./_export": 99, "./_object-assign": 122 },
        ],
        169: [
          function (require, module, exports) {
            var $export = require("./_export");
            // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            $export($export.S, "Object", { create: require("./_object-create") });
          },
          { "./_export": 99, "./_object-create": 123 },
        ],
        170: [
          function (require, module, exports) {
            var $export = require("./_export");
            // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
            $export(
              $export.S + $export.F * !require("./_descriptors"),
              "Object",
              { defineProperties: require("./_object-dps") }
            );
          },
          { "./_descriptors": 95, "./_export": 99, "./_object-dps": 125 },
        ],
        171: [
          function (require, module, exports) {
            var $export = require("./_export");
            // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
            $export(
              $export.S + $export.F * !require("./_descriptors"),
              "Object",
              { defineProperty: require("./_object-dp").f }
            );
          },
          { "./_descriptors": 95, "./_export": 99, "./_object-dp": 124 },
        ],
        172: [
          function (require, module, exports) {
            // 19.1.2.5 Object.freeze(O)
            var isObject = require("./_is-object");
            var meta = require("./_meta").onFreeze;
  
            require("./_object-sap")("freeze", function ($freeze) {
              return function freeze(it) {
                return $freeze && isObject(it) ? $freeze(meta(it)) : it;
              };
            });
          },
          { "./_is-object": 111, "./_meta": 119, "./_object-sap": 134 },
        ],
        173: [
          function (require, module, exports) {
            // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
            var toIObject = require("./_to-iobject");
            var $getOwnPropertyDescriptor = require("./_object-gopd").f;
  
            require("./_object-sap")("getOwnPropertyDescriptor", function () {
              return function getOwnPropertyDescriptor(it, key) {
                return $getOwnPropertyDescriptor(toIObject(it), key);
              };
            });
          },
          { "./_object-gopd": 126, "./_object-sap": 134, "./_to-iobject": 152 },
        ],
        174: [
          function (require, module, exports) {
            // 19.1.2.14 Object.keys(O)
            var toObject = require("./_to-object");
            var $keys = require("./_object-keys");
  
            require("./_object-sap")("keys", function () {
              return function keys(it) {
                return $keys(toObject(it));
              };
            });
          },
          { "./_object-keys": 132, "./_object-sap": 134, "./_to-object": 154 },
        ],
        175: [
          function (require, module, exports) {
            // 19.1.3.19 Object.setPrototypeOf(O, proto)
            var $export = require("./_export");
            $export($export.S, "Object", {
              setPrototypeOf: require("./_set-proto").set,
            });
          },
          { "./_export": 99, "./_set-proto": 142 },
        ],
        176: [
          function (require, module, exports) {
            arguments[4][40][0].apply(exports, arguments);
          },
          { dup: 40 },
        ],
        177: [
          function (require, module, exports) {
            "use strict";
            var LIBRARY = require("./_library");
            var global = require("./_global");
            var ctx = require("./_ctx");
            var classof = require("./_classof");
            var $export = require("./_export");
            var isObject = require("./_is-object");
            var aFunction = require("./_a-function");
            var anInstance = require("./_an-instance");
            var forOf = require("./_for-of");
            var speciesConstructor = require("./_species-constructor");
            var task = require("./_task").set;
            var microtask = require("./_microtask")();
            var newPromiseCapabilityModule = require("./_new-promise-capability");
            var perform = require("./_perform");
            var userAgent = require("./_user-agent");
            var promiseResolve = require("./_promise-resolve");
            var PROMISE = "Promise";
            var TypeError = global.TypeError;
            var process = global.process;
            var versions = process && process.versions;
            var v8 = (versions && versions.v8) || "";
            var $Promise = global[PROMISE];
            var isNode = classof(process) == "process";
            var empty = function () {
              /* empty */
            };
            var Internal,
              newGenericPromiseCapability,
              OwnPromiseCapability,
              Wrapper;
            var newPromiseCapability = (newGenericPromiseCapability =
              newPromiseCapabilityModule.f);
  
            var USE_NATIVE = !!(function () {
              try {
                // correct subclassing with @@species support
                var promise = $Promise.resolve(1);
                var FakePromise = ((promise.constructor = {})[
                  require("./_wks")("species")
                ] = function (exec) {
                  exec(empty, empty);
                });
                // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                return (
                  (isNode || typeof PromiseRejectionEvent == "function") &&
                  promise.then(empty) instanceof FakePromise &&
                  // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
                  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
                  // we can't detect it synchronously, so just check versions
                  v8.indexOf("6.6") !== 0 &&
                  userAgent.indexOf("Chrome/66") === -1
                );
              } catch (e) {
                /* empty */
              }
            })();
  
            // helpers
            var isThenable = function (it) {
              var then;
              return isObject(it) && typeof (then = it.then) == "function"
                ? then
                : false;
            };
            var notify = function (promise, isReject) {
              if (promise._n) return;
              promise._n = true;
              var chain = promise._c;
              microtask(function () {
                var value = promise._v;
                var ok = promise._s == 1;
                var i = 0;
                var run = function (reaction) {
                  var handler = ok ? reaction.ok : reaction.fail;
                  var resolve = reaction.resolve;
                  var reject = reaction.reject;
                  var domain = reaction.domain;
                  var result, then, exited;
                  try {
                    if (handler) {
                      if (!ok) {
                        if (promise._h == 2) onHandleUnhandled(promise);
                        promise._h = 1;
                      }
                      if (handler === true) result = value;
                      else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                          domain.exit();
                          exited = true;
                        }
                      }
                      if (result === reaction.promise) {
                        reject(TypeError("Promise-chain cycle"));
                      } else if ((then = isThenable(result))) {
                        then.call(result, resolve, reject);
                      } else resolve(result);
                    } else reject(value);
                  } catch (e) {
                    if (domain && !exited) domain.exit();
                    reject(e);
                  }
                };
                while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
                promise._c = [];
                promise._n = false;
                if (isReject && !promise._h) onUnhandled(promise);
              });
            };
            var onUnhandled = function (promise) {
              task.call(global, function () {
                var value = promise._v;
                var unhandled = isUnhandled(promise);
                var result, handler, console;
                if (unhandled) {
                  result = perform(function () {
                    if (isNode) {
                      process.emit("unhandledRejection", value, promise);
                    } else if ((handler = global.onunhandledrejection)) {
                      handler({ promise: promise, reason: value });
                    } else if ((console = global.console) && console.error) {
                      console.error("Unhandled promise rejection", value);
                    }
                  });
                  // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                  promise._h = isNode || isUnhandled(promise) ? 2 : 1;
                }
                promise._a = undefined;
                if (unhandled && result.e) throw result.v;
              });
            };
            var isUnhandled = function (promise) {
              return promise._h !== 1 && (promise._a || promise._c).length === 0;
            };
            var onHandleUnhandled = function (promise) {
              task.call(global, function () {
                var handler;
                if (isNode) {
                  process.emit("rejectionHandled", promise);
                } else if ((handler = global.onrejectionhandled)) {
                  handler({ promise: promise, reason: promise._v });
                }
              });
            };
            var $reject = function (value) {
              var promise = this;
              if (promise._d) return;
              promise._d = true;
              promise = promise._w || promise; // unwrap
              promise._v = value;
              promise._s = 2;
              if (!promise._a) promise._a = promise._c.slice();
              notify(promise, true);
            };
            var $resolve = function (value) {
              var promise = this;
              var then;
              if (promise._d) return;
              promise._d = true;
              promise = promise._w || promise; // unwrap
              try {
                if (promise === value)
                  throw TypeError("Promise can't be resolved itself");
                if ((then = isThenable(value))) {
                  microtask(function () {
                    var wrapper = { _w: promise, _d: false }; // wrap
                    try {
                      then.call(
                        value,
                        ctx($resolve, wrapper, 1),
                        ctx($reject, wrapper, 1)
                      );
                    } catch (e) {
                      $reject.call(wrapper, e);
                    }
                  });
                } else {
                  promise._v = value;
                  promise._s = 1;
                  notify(promise, false);
                }
              } catch (e) {
                $reject.call({ _w: promise, _d: false }, e); // wrap
              }
            };
  
            // constructor polyfill
            if (!USE_NATIVE) {
              // 25.4.3.1 Promise(executor)
              $Promise = function Promise(executor) {
                anInstance(this, $Promise, PROMISE, "_h");
                aFunction(executor);
                Internal.call(this);
                try {
                  executor(ctx($resolve, this, 1), ctx($reject, this, 1));
                } catch (err) {
                  $reject.call(this, err);
                }
              };
              // eslint-disable-next-line no-unused-vars
              Internal = function Promise(executor) {
                this._c = []; // <- awaiting reactions
                this._a = undefined; // <- checked in isUnhandled reactions
                this._s = 0; // <- state
                this._d = false; // <- done
                this._v = undefined; // <- value
                this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
                this._n = false; // <- notify
              };
              Internal.prototype = require("./_redefine-all")(
                $Promise.prototype,
                {
                  // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
                  then: function then(onFulfilled, onRejected) {
                    var reaction = newPromiseCapability(
                      speciesConstructor(this, $Promise)
                    );
                    reaction.ok =
                      typeof onFulfilled == "function" ? onFulfilled : true;
                    reaction.fail = typeof onRejected == "function" && onRejected;
                    reaction.domain = isNode ? process.domain : undefined;
                    this._c.push(reaction);
                    if (this._a) this._a.push(reaction);
                    if (this._s) notify(this, false);
                    return reaction.promise;
                  },
                  // 25.4.5.1 Promise.prototype.catch(onRejected)
                  catch: function (onRejected) {
                    return this.then(undefined, onRejected);
                  },
                }
              );
              OwnPromiseCapability = function () {
                var promise = new Internal();
                this.promise = promise;
                this.resolve = ctx($resolve, promise, 1);
                this.reject = ctx($reject, promise, 1);
              };
              newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
                return C === $Promise || C === Wrapper
                  ? new OwnPromiseCapability(C)
                  : newGenericPromiseCapability(C);
              };
            }
  
            $export($export.G + $export.W + $export.F * !USE_NATIVE, {
              Promise: $Promise,
            });
            require("./_set-to-string-tag")($Promise, PROMISE);
            require("./_set-species")(PROMISE);
            Wrapper = require("./_core")[PROMISE];
  
            // statics
            $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
              // 25.4.4.5 Promise.reject(r)
              reject: function reject(r) {
                var capability = newPromiseCapability(this);
                var $$reject = capability.reject;
                $$reject(r);
                return capability.promise;
              },
            });
            $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
              // 25.4.4.6 Promise.resolve(x)
              resolve: function resolve(x) {
                return promiseResolve(
                  LIBRARY && this === Wrapper ? $Promise : this,
                  x
                );
              },
            });
            $export(
              $export.S +
                $export.F *
                  !(
                    USE_NATIVE &&
                    require("./_iter-detect")(function (iter) {
                      $Promise.all(iter)["catch"](empty);
                    })
                  ),
              PROMISE,
              {
                // 25.4.4.1 Promise.all(iterable)
                all: function all(iterable) {
                  var C = this;
                  var capability = newPromiseCapability(C);
                  var resolve = capability.resolve;
                  var reject = capability.reject;
                  var result = perform(function () {
                    var values = [];
                    var index = 0;
                    var remaining = 1;
                    forOf(iterable, false, function (promise) {
                      var $index = index++;
                      var alreadyCalled = false;
                      values.push(undefined);
                      remaining++;
                      C.resolve(promise).then(function (value) {
                        if (alreadyCalled) return;
                        alreadyCalled = true;
                        values[$index] = value;
                        --remaining || resolve(values);
                      }, reject);
                    });
                    --remaining || resolve(values);
                  });
                  if (result.e) reject(result.v);
                  return capability.promise;
                },
                // 25.4.4.4 Promise.race(iterable)
                race: function race(iterable) {
                  var C = this;
                  var capability = newPromiseCapability(C);
                  var reject = capability.reject;
                  var result = perform(function () {
                    forOf(iterable, false, function (promise) {
                      C.resolve(promise).then(capability.resolve, reject);
                    });
                  });
                  if (result.e) reject(result.v);
                  return capability.promise;
                },
              }
            );
          },
          {
            "./_a-function": 77,
            "./_an-instance": 79,
            "./_classof": 86,
            "./_core": 91,
            "./_ctx": 93,
            "./_export": 99,
            "./_for-of": 101,
            "./_global": 102,
            "./_is-object": 111,
            "./_iter-detect": 115,
            "./_library": 118,
            "./_microtask": 120,
            "./_new-promise-capability": 121,
            "./_perform": 135,
            "./_promise-resolve": 136,
            "./_redefine-all": 138,
            "./_set-species": 143,
            "./_set-to-string-tag": 144,
            "./_species-constructor": 147,
            "./_task": 149,
            "./_user-agent": 157,
            "./_wks": 161,
          },
        ],
        178: [
          function (require, module, exports) {
            "use strict";
            var strong = require("./_collection-strong");
            var validate = require("./_validate-collection");
            var SET = "Set";
  
            // 23.2 Set Objects
            module.exports = require("./_collection")(
              SET,
              function (get) {
                return function Set() {
                  return get(
                    this,
                    arguments.length > 0 ? arguments[0] : undefined
                  );
                };
              },
              {
                // 23.2.3.1 Set.prototype.add(value)
                add: function add(value) {
                  return strong.def(
                    validate(this, SET),
                    (value = value === 0 ? 0 : value),
                    value
                  );
                },
              },
              strong
            );
          },
          {
            "./_collection": 90,
            "./_collection-strong": 88,
            "./_validate-collection": 158,
          },
        ],
        179: [
          function (require, module, exports) {
            var $export = require("./_export");
            var toAbsoluteIndex = require("./_to-absolute-index");
            var fromCharCode = String.fromCharCode;
            var $fromCodePoint = String.fromCodePoint;
  
            // length should be 1, old FF problem
            $export(
              $export.S +
                $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1),
              "String",
              {
                // 21.1.2.2 String.fromCodePoint(...codePoints)
                fromCodePoint: function fromCodePoint(x) {
                  // eslint-disable-line no-unused-vars
                  var res = [];
                  var aLen = arguments.length;
                  var i = 0;
                  var code;
                  while (aLen > i) {
                    code = +arguments[i++];
                    if (toAbsoluteIndex(code, 0x10ffff) !== code)
                      throw RangeError(code + " is not a valid code point");
                    res.push(
                      code < 0x10000
                        ? fromCharCode(code)
                        : fromCharCode(
                            ((code -= 0x10000) >> 10) + 0xd800,
                            (code % 0x400) + 0xdc00
                          )
                    );
                  }
                  return res.join("");
                },
              }
            );
          },
          { "./_export": 99, "./_to-absolute-index": 150 },
        ],
        180: [
          function (require, module, exports) {
            "use strict";
            var $at = require("./_string-at")(true);
  
            // 21.1.3.27 String.prototype[@@iterator]()
            require("./_iter-define")(
              String,
              "String",
              function (iterated) {
                this._t = String(iterated); // target
                this._i = 0; // next index
                // 21.1.5.2.1 %StringIteratorPrototype%.next()
              },
              function () {
                var O = this._t;
                var index = this._i;
                var point;
                if (index >= O.length) return { value: undefined, done: true };
                point = $at(O, index);
                this._i += point.length;
                return { value: point, done: false };
              }
            );
          },
          { "./_iter-define": 114, "./_string-at": 148 },
        ],
        181: [
          function (require, module, exports) {
            "use strict";
            // ECMAScript 6 symbols shim
            var global = require("./_global");
            var has = require("./_has");
            var DESCRIPTORS = require("./_descriptors");
            var $export = require("./_export");
            var redefine = require("./_redefine");
            var META = require("./_meta").KEY;
            var $fails = require("./_fails");
            var shared = require("./_shared");
            var setToStringTag = require("./_set-to-string-tag");
            var uid = require("./_uid");
            var wks = require("./_wks");
            var wksExt = require("./_wks-ext");
            var wksDefine = require("./_wks-define");
            var enumKeys = require("./_enum-keys");
            var isArray = require("./_is-array");
            var anObject = require("./_an-object");
            var isObject = require("./_is-object");
            var toObject = require("./_to-object");
            var toIObject = require("./_to-iobject");
            var toPrimitive = require("./_to-primitive");
            var createDesc = require("./_property-desc");
            var _create = require("./_object-create");
            var gOPNExt = require("./_object-gopn-ext");
            var $GOPD = require("./_object-gopd");
            var $GOPS = require("./_object-gops");
            var $DP = require("./_object-dp");
            var $keys = require("./_object-keys");
            var gOPD = $GOPD.f;
            var dP = $DP.f;
            var gOPN = gOPNExt.f;
            var $Symbol = global.Symbol;
            var $JSON = global.JSON;
            var _stringify = $JSON && $JSON.stringify;
            var PROTOTYPE = "prototype";
            var HIDDEN = wks("_hidden");
            var TO_PRIMITIVE = wks("toPrimitive");
            var isEnum = {}.propertyIsEnumerable;
            var SymbolRegistry = shared("symbol-registry");
            var AllSymbols = shared("symbols");
            var OPSymbols = shared("op-symbols");
            var ObjectProto = Object[PROTOTYPE];
            var USE_NATIVE = typeof $Symbol == "function" && !!$GOPS.f;
            var QObject = global.QObject;
            // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var setter =
              !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
  
            // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDesc =
              DESCRIPTORS &&
              $fails(function () {
                return (
                  _create(
                    dP({}, "a", {
                      get: function () {
                        return dP(this, "a", { value: 7 }).a;
                      },
                    })
                  ).a != 7
                );
              })
                ? function (it, key, D) {
                    var protoDesc = gOPD(ObjectProto, key);
                    if (protoDesc) delete ObjectProto[key];
                    dP(it, key, D);
                    if (protoDesc && it !== ObjectProto)
                      dP(ObjectProto, key, protoDesc);
                  }
                : dP;
  
            var wrap = function (tag) {
              var sym = (AllSymbols[tag] = _create($Symbol[PROTOTYPE]));
              sym._k = tag;
              return sym;
            };
  
            var isSymbol =
              USE_NATIVE && typeof $Symbol.iterator == "symbol"
                ? function (it) {
                    return typeof it == "symbol";
                  }
                : function (it) {
                    return it instanceof $Symbol;
                  };
  
            var $defineProperty = function defineProperty(it, key, D) {
              if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
              anObject(it);
              key = toPrimitive(key, true);
              anObject(D);
              if (has(AllSymbols, key)) {
                if (!D.enumerable) {
                  if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                  it[HIDDEN][key] = true;
                } else {
                  if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                  D = _create(D, { enumerable: createDesc(0, false) });
                }
                return setSymbolDesc(it, key, D);
              }
              return dP(it, key, D);
            };
            var $defineProperties = function defineProperties(it, P) {
              anObject(it);
              var keys = enumKeys((P = toIObject(P)));
              var i = 0;
              var l = keys.length;
              var key;
              while (l > i) $defineProperty(it, (key = keys[i++]), P[key]);
              return it;
            };
            var $create = function create(it, P) {
              return P === undefined
                ? _create(it)
                : $defineProperties(_create(it), P);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(key) {
              var E = isEnum.call(this, (key = toPrimitive(key, true)));
              if (
                this === ObjectProto &&
                has(AllSymbols, key) &&
                !has(OPSymbols, key)
              )
                return false;
              return E ||
                !has(this, key) ||
                !has(AllSymbols, key) ||
                (has(this, HIDDEN) && this[HIDDEN][key])
                ? E
                : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(
              it,
              key
            ) {
              it = toIObject(it);
              key = toPrimitive(key, true);
              if (
                it === ObjectProto &&
                has(AllSymbols, key) &&
                !has(OPSymbols, key)
              )
                return;
              var D = gOPD(it, key);
              if (
                D &&
                has(AllSymbols, key) &&
                !(has(it, HIDDEN) && it[HIDDEN][key])
              )
                D.enumerable = true;
              return D;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(it) {
              var names = gOPN(toIObject(it));
              var result = [];
              var i = 0;
              var key;
              while (names.length > i) {
                if (
                  !has(AllSymbols, (key = names[i++])) &&
                  key != HIDDEN &&
                  key != META
                )
                  result.push(key);
              }
              return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
              var IS_OP = it === ObjectProto;
              var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
              var result = [];
              var i = 0;
              var key;
              while (names.length > i) {
                if (
                  has(AllSymbols, (key = names[i++])) &&
                  (IS_OP ? has(ObjectProto, key) : true)
                )
                  result.push(AllSymbols[key]);
              }
              return result;
            };
  
            // 19.4.1.1 Symbol([description])
            if (!USE_NATIVE) {
              $Symbol = function Symbol() {
                if (this instanceof $Symbol)
                  throw TypeError("Symbol is not a constructor!");
                var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                var $set = function (value) {
                  if (this === ObjectProto) $set.call(OPSymbols, value);
                  if (has(this, HIDDEN) && has(this[HIDDEN], tag))
                    this[HIDDEN][tag] = false;
                  setSymbolDesc(this, tag, createDesc(1, value));
                };
                if (DESCRIPTORS && setter)
                  setSymbolDesc(ObjectProto, tag, {
                    configurable: true,
                    set: $set,
                  });
                return wrap(tag);
              };
              redefine($Symbol[PROTOTYPE], "toString", function toString() {
                return this._k;
              });
  
              $GOPD.f = $getOwnPropertyDescriptor;
              $DP.f = $defineProperty;
              require("./_object-gopn").f = gOPNExt.f = $getOwnPropertyNames;
              require("./_object-pie").f = $propertyIsEnumerable;
              $GOPS.f = $getOwnPropertySymbols;
  
              if (DESCRIPTORS && !require("./_library")) {
                redefine(
                  ObjectProto,
                  "propertyIsEnumerable",
                  $propertyIsEnumerable,
                  true
                );
              }
  
              wksExt.f = function (name) {
                return wrap(wks(name));
              };
            }
  
            $export($export.G + $export.W + $export.F * !USE_NATIVE, {
              Symbol: $Symbol,
            });
  
            for (
              var es6Symbols =
                  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
                  "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(
                    ","
                  ),
                j = 0;
              es6Symbols.length > j;
  
            )
              wks(es6Symbols[j++]);
  
            for (
              var wellKnownSymbols = $keys(wks.store), k = 0;
              wellKnownSymbols.length > k;
  
            )
              wksDefine(wellKnownSymbols[k++]);
  
            $export($export.S + $export.F * !USE_NATIVE, "Symbol", {
              // 19.4.2.1 Symbol.for(key)
              for: function (key) {
                return has(SymbolRegistry, (key += ""))
                  ? SymbolRegistry[key]
                  : (SymbolRegistry[key] = $Symbol(key));
              },
              // 19.4.2.5 Symbol.keyFor(sym)
              keyFor: function keyFor(sym) {
                if (!isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
                for (var key in SymbolRegistry)
                  if (SymbolRegistry[key] === sym) return key;
              },
              useSetter: function () {
                setter = true;
              },
              useSimple: function () {
                setter = false;
              },
            });
  
            $export($export.S + $export.F * !USE_NATIVE, "Object", {
              // 19.1.2.2 Object.create(O [, Properties])
              create: $create,
              // 19.1.2.4 Object.defineProperty(O, P, Attributes)
              defineProperty: $defineProperty,
              // 19.1.2.3 Object.defineProperties(O, Properties)
              defineProperties: $defineProperties,
              // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
              getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
              // 19.1.2.7 Object.getOwnPropertyNames(O)
              getOwnPropertyNames: $getOwnPropertyNames,
              // 19.1.2.8 Object.getOwnPropertySymbols(O)
              getOwnPropertySymbols: $getOwnPropertySymbols,
            });
  
            // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
            // https://bugs.chromium.org/p/v8/issues/detail?id=3443
            var FAILS_ON_PRIMITIVES = $fails(function () {
              $GOPS.f(1);
            });
  
            $export($export.S + $export.F * FAILS_ON_PRIMITIVES, "Object", {
              getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                return $GOPS.f(toObject(it));
              },
            });
  
            // 24.3.2 JSON.stringify(value [, replacer [, space]])
            $JSON &&
              $export(
                $export.S +
                  $export.F *
                    (!USE_NATIVE ||
                      $fails(function () {
                        var S = $Symbol();
                        // MS Edge converts symbol values to JSON as {}
                        // WebKit converts symbol values to JSON as null
                        // V8 throws on boxed symbols
                        return (
                          _stringify([S]) != "[null]" ||
                          _stringify({ a: S }) != "{}" ||
                          _stringify(Object(S)) != "{}"
                        );
                      })),
                "JSON",
                {
                  stringify: function stringify(it) {
                    var args = [it];
                    var i = 1;
                    var replacer, $replacer;
                    while (arguments.length > i) args.push(arguments[i++]);
                    $replacer = replacer = args[1];
                    if ((!isObject(replacer) && it === undefined) || isSymbol(it))
                      return; // IE8 returns string on undefined
                    if (!isArray(replacer))
                      replacer = function (key, value) {
                        if (typeof $replacer == "function")
                          value = $replacer.call(this, key, value);
                        if (!isSymbol(value)) return value;
                      };
                    args[1] = replacer;
                    return _stringify.apply($JSON, args);
                  },
                }
              );
  
            // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
            $Symbol[PROTOTYPE][TO_PRIMITIVE] ||
              require("./_hide")(
                $Symbol[PROTOTYPE],
                TO_PRIMITIVE,
                $Symbol[PROTOTYPE].valueOf
              );
            // 19.4.3.5 Symbol.prototype[@@toStringTag]
            setToStringTag($Symbol, "Symbol");
            // 20.2.1.9 Math[@@toStringTag]
            setToStringTag(Math, "Math", true);
            // 24.3.3 JSON[@@toStringTag]
            setToStringTag(global.JSON, "JSON", true);
          },
          {
            "./_an-object": 80,
            "./_descriptors": 95,
            "./_enum-keys": 98,
            "./_export": 99,
            "./_fails": 100,
            "./_global": 102,
            "./_has": 103,
            "./_hide": 104,
            "./_is-array": 110,
            "./_is-object": 111,
            "./_library": 118,
            "./_meta": 119,
            "./_object-create": 123,
            "./_object-dp": 124,
            "./_object-gopd": 126,
            "./_object-gopn": 128,
            "./_object-gopn-ext": 127,
            "./_object-gops": 129,
            "./_object-keys": 132,
            "./_object-pie": 133,
            "./_property-desc": 137,
            "./_redefine": 139,
            "./_set-to-string-tag": 144,
            "./_shared": 146,
            "./_to-iobject": 152,
            "./_to-object": 154,
            "./_to-primitive": 155,
            "./_uid": 156,
            "./_wks": 161,
            "./_wks-define": 159,
            "./_wks-ext": 160,
          },
        ],
        182: [
          function (require, module, exports) {
            // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
            require("./_set-collection-from")("Map");
          },
          { "./_set-collection-from": 140 },
        ],
        183: [
          function (require, module, exports) {
            // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
            require("./_set-collection-of")("Map");
          },
          { "./_set-collection-of": 141 },
        ],
        184: [
          function (require, module, exports) {
            // https://github.com/DavidBruant/Map-Set.prototype.toJSON
            var $export = require("./_export");
  
            $export($export.P + $export.R, "Map", {
              toJSON: require("./_collection-to-json")("Map"),
            });
          },
          { "./_collection-to-json": 89, "./_export": 99 },
        ],
        185: [
          function (require, module, exports) {
            // https://github.com/tc39/proposal-promise-finally
            "use strict";
            var $export = require("./_export");
            var core = require("./_core");
            var global = require("./_global");
            var speciesConstructor = require("./_species-constructor");
            var promiseResolve = require("./_promise-resolve");
  
            $export($export.P + $export.R, "Promise", {
              finally: function (onFinally) {
                var C = speciesConstructor(this, core.Promise || global.Promise);
                var isFunction = typeof onFinally == "function";
                return this.then(
                  isFunction
                    ? function (x) {
                        return promiseResolve(C, onFinally()).then(function () {
                          return x;
                        });
                      }
                    : onFinally,
                  isFunction
                    ? function (e) {
                        return promiseResolve(C, onFinally()).then(function () {
                          throw e;
                        });
                      }
                    : onFinally
                );
              },
            });
          },
          {
            "./_core": 91,
            "./_export": 99,
            "./_global": 102,
            "./_promise-resolve": 136,
            "./_species-constructor": 147,
          },
        ],
        186: [
          function (require, module, exports) {
            "use strict";
            // https://github.com/tc39/proposal-promise-try
            var $export = require("./_export");
            var newPromiseCapability = require("./_new-promise-capability");
            var perform = require("./_perform");
  
            $export($export.S, "Promise", {
              try: function (callbackfn) {
                var promiseCapability = newPromiseCapability.f(this);
                var result = perform(callbackfn);
                (result.e ? promiseCapability.reject : promiseCapability.resolve)(
                  result.v
                );
                return promiseCapability.promise;
              },
            });
          },
          {
            "./_export": 99,
            "./_new-promise-capability": 121,
            "./_perform": 135,
          },
        ],
        187: [
          function (require, module, exports) {
            // https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
            require("./_set-collection-from")("Set");
          },
          { "./_set-collection-from": 140 },
        ],
        188: [
          function (require, module, exports) {
            // https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
            require("./_set-collection-of")("Set");
          },
          { "./_set-collection-of": 141 },
        ],
        189: [
          function (require, module, exports) {
            // https://github.com/DavidBruant/Map-Set.prototype.toJSON
            var $export = require("./_export");
  
            $export($export.P + $export.R, "Set", {
              toJSON: require("./_collection-to-json")("Set"),
            });
          },
          { "./_collection-to-json": 89, "./_export": 99 },
        ],
        190: [
          function (require, module, exports) {
            require("./_wks-define")("asyncIterator");
          },
          { "./_wks-define": 159 },
        ],
        191: [
          function (require, module, exports) {
            require("./_wks-define")("observable");
          },
          { "./_wks-define": 159 },
        ],
        192: [
          function (require, module, exports) {
            require("./es6.array.iterator");
            var global = require("./_global");
            var hide = require("./_hide");
            var Iterators = require("./_iterators");
            var TO_STRING_TAG = require("./_wks")("toStringTag");
  
            var DOMIterables = (
              "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList," +
              "DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement," +
              "MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList," +
              "SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList," +
              "TextTrackList,TouchList"
            ).split(",");
  
            for (var i = 0; i < DOMIterables.length; i++) {
              var NAME = DOMIterables[i];
              var Collection = global[NAME];
              var proto = Collection && Collection.prototype;
              if (proto && !proto[TO_STRING_TAG])
                hide(proto, TO_STRING_TAG, NAME);
              Iterators[NAME] = Iterators.Array;
            }
          },
          {
            "./_global": 102,
            "./_hide": 104,
            "./_iterators": 117,
            "./_wks": 161,
            "./es6.array.iterator": 165,
          },
        ],
        193: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
                // NOTE: These type checking functions intentionally don't use `instanceof`
                // because it is fragile and can be easily faked with `Object.create()`.
  
                function isArray(arg) {
                  if (Array.isArray) {
                    return Array.isArray(arg);
                  }
                  return objectToString(arg) === "[object Array]";
                }
                exports.isArray = isArray;
  
                function isBoolean(arg) {
                  return typeof arg === "boolean";
                }
                exports.isBoolean = isBoolean;
  
                function isNull(arg) {
                  return arg === null;
                }
                exports.isNull = isNull;
  
                function isNullOrUndefined(arg) {
                  return arg == null;
                }
                exports.isNullOrUndefined = isNullOrUndefined;
  
                function isNumber(arg) {
                  return typeof arg === "number";
                }
                exports.isNumber = isNumber;
  
                function isString(arg) {
                  return typeof arg === "string";
                }
                exports.isString = isString;
  
                function isSymbol(arg) {
                  return typeof arg === "symbol";
                }
                exports.isSymbol = isSymbol;
  
                function isUndefined(arg) {
                  return arg === void 0;
                }
                exports.isUndefined = isUndefined;
  
                function isRegExp(re) {
                  return objectToString(re) === "[object RegExp]";
                }
                exports.isRegExp = isRegExp;
  
                function isObject(arg) {
                  return typeof arg === "object" && arg !== null;
                }
                exports.isObject = isObject;
  
                function isDate(d) {
                  return objectToString(d) === "[object Date]";
                }
                exports.isDate = isDate;
  
                function isError(e) {
                  return (
                    objectToString(e) === "[object Error]" || e instanceof Error
                  );
                }
                exports.isError = isError;
  
                function isFunction(arg) {
                  return typeof arg === "function";
                }
                exports.isFunction = isFunction;
  
                function isPrimitive(arg) {
                  return (
                    arg === null ||
                    typeof arg === "boolean" ||
                    typeof arg === "number" ||
                    typeof arg === "string" ||
                    typeof arg === "symbol" || // ES6 symbol
                    typeof arg === "undefined"
                  );
                }
                exports.isPrimitive = isPrimitive;
  
                exports.isBuffer = Buffer.isBuffer;
  
                function objectToString(o) {
                  return Object.prototype.toString.call(o);
                }
              }.call(this));
            }.call(this, { isBuffer: require("../../is-buffer/index.js") }));
          },
          { "../../is-buffer/index.js": 242 },
        ],
        194: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./evpkdf"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./enc-base64",
                  "./md5",
                  "./evpkdf",
                  "./cipher-core",
                ], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var BlockCipher = C_lib.BlockCipher;
                var C_algo = C.algo;
  
                // Lookup tables
                var SBOX = [];
                var INV_SBOX = [];
                var SUB_MIX_0 = [];
                var SUB_MIX_1 = [];
                var SUB_MIX_2 = [];
                var SUB_MIX_3 = [];
                var INV_SUB_MIX_0 = [];
                var INV_SUB_MIX_1 = [];
                var INV_SUB_MIX_2 = [];
                var INV_SUB_MIX_3 = [];
  
                // Compute lookup tables
                (function () {
                  // Compute double table
                  var d = [];
                  for (var i = 0; i < 256; i++) {
                    if (i < 128) {
                      d[i] = i << 1;
                    } else {
                      d[i] = (i << 1) ^ 0x11b;
                    }
                  }
  
                  // Walk GF(2^8)
                  var x = 0;
                  var xi = 0;
                  for (var i = 0; i < 256; i++) {
                    // Compute sbox
                    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
                    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
                    SBOX[x] = sx;
                    INV_SBOX[sx] = x;
  
                    // Compute multiplication
                    var x2 = d[x];
                    var x4 = d[x2];
                    var x8 = d[x4];
  
                    // Compute sub bytes, mix columns tables
                    var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
                    SUB_MIX_0[x] = (t << 24) | (t >>> 8);
                    SUB_MIX_1[x] = (t << 16) | (t >>> 16);
                    SUB_MIX_2[x] = (t << 8) | (t >>> 24);
                    SUB_MIX_3[x] = t;
  
                    // Compute inv sub bytes, inv mix columns tables
                    var t =
                      (x8 * 0x1010101) ^
                      (x4 * 0x10001) ^
                      (x2 * 0x101) ^
                      (x * 0x1010100);
                    INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
                    INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
                    INV_SUB_MIX_2[sx] = (t << 8) | (t >>> 24);
                    INV_SUB_MIX_3[sx] = t;
  
                    // Compute next counter
                    if (!x) {
                      x = xi = 1;
                    } else {
                      x = x2 ^ d[d[d[x8 ^ x2]]];
                      xi ^= d[d[xi]];
                    }
                  }
                })();
  
                // Precomputed Rcon lookup
                var RCON = [
                  0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b,
                  0x36,
                ];
  
                /**
                 * AES block cipher algorithm.
                 */
                var AES = (C_algo.AES = BlockCipher.extend({
                  _doReset: function () {
                    var t;
  
                    // Skip reset of nRounds has been set before and key did not change
                    if (this._nRounds && this._keyPriorReset === this._key) {
                      return;
                    }
  
                    // Shortcuts
                    var key = (this._keyPriorReset = this._key);
                    var keyWords = key.words;
                    var keySize = key.sigBytes / 4;
  
                    // Compute number of rounds
                    var nRounds = (this._nRounds = keySize + 6);
  
                    // Compute number of key schedule rows
                    var ksRows = (nRounds + 1) * 4;
  
                    // Compute key schedule
                    var keySchedule = (this._keySchedule = []);
                    for (var ksRow = 0; ksRow < ksRows; ksRow++) {
                      if (ksRow < keySize) {
                        keySchedule[ksRow] = keyWords[ksRow];
                      } else {
                        t = keySchedule[ksRow - 1];
  
                        if (!(ksRow % keySize)) {
                          // Rot word
                          t = (t << 8) | (t >>> 24);
  
                          // Sub word
                          t =
                            (SBOX[t >>> 24] << 24) |
                            (SBOX[(t >>> 16) & 0xff] << 16) |
                            (SBOX[(t >>> 8) & 0xff] << 8) |
                            SBOX[t & 0xff];
  
                          // Mix Rcon
                          t ^= RCON[(ksRow / keySize) | 0] << 24;
                        } else if (keySize > 6 && ksRow % keySize == 4) {
                          // Sub word
                          t =
                            (SBOX[t >>> 24] << 24) |
                            (SBOX[(t >>> 16) & 0xff] << 16) |
                            (SBOX[(t >>> 8) & 0xff] << 8) |
                            SBOX[t & 0xff];
                        }
  
                        keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                      }
                    }
  
                    // Compute inv key schedule
                    var invKeySchedule = (this._invKeySchedule = []);
                    for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
                      var ksRow = ksRows - invKsRow;
  
                      if (invKsRow % 4) {
                        var t = keySchedule[ksRow];
                      } else {
                        var t = keySchedule[ksRow - 4];
                      }
  
                      if (invKsRow < 4 || ksRow <= 4) {
                        invKeySchedule[invKsRow] = t;
                      } else {
                        invKeySchedule[invKsRow] =
                          INV_SUB_MIX_0[SBOX[t >>> 24]] ^
                          INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
                          INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^
                          INV_SUB_MIX_3[SBOX[t & 0xff]];
                      }
                    }
                  },
  
                  encryptBlock: function (M, offset) {
                    this._doCryptBlock(
                      M,
                      offset,
                      this._keySchedule,
                      SUB_MIX_0,
                      SUB_MIX_1,
                      SUB_MIX_2,
                      SUB_MIX_3,
                      SBOX
                    );
                  },
  
                  decryptBlock: function (M, offset) {
                    // Swap 2nd and 4th rows
                    var t = M[offset + 1];
                    M[offset + 1] = M[offset + 3];
                    M[offset + 3] = t;
  
                    this._doCryptBlock(
                      M,
                      offset,
                      this._invKeySchedule,
                      INV_SUB_MIX_0,
                      INV_SUB_MIX_1,
                      INV_SUB_MIX_2,
                      INV_SUB_MIX_3,
                      INV_SBOX
                    );
  
                    // Inv swap 2nd and 4th rows
                    var t = M[offset + 1];
                    M[offset + 1] = M[offset + 3];
                    M[offset + 3] = t;
                  },
  
                  _doCryptBlock: function (
                    M,
                    offset,
                    keySchedule,
                    SUB_MIX_0,
                    SUB_MIX_1,
                    SUB_MIX_2,
                    SUB_MIX_3,
                    SBOX
                  ) {
                    // Shortcut
                    var nRounds = this._nRounds;
  
                    // Get input, add round key
                    var s0 = M[offset] ^ keySchedule[0];
                    var s1 = M[offset + 1] ^ keySchedule[1];
                    var s2 = M[offset + 2] ^ keySchedule[2];
                    var s3 = M[offset + 3] ^ keySchedule[3];
  
                    // Key schedule row counter
                    var ksRow = 4;
  
                    // Rounds
                    for (var round = 1; round < nRounds; round++) {
                      // Shift rows, sub bytes, mix columns, add round key
                      var t0 =
                        SUB_MIX_0[s0 >>> 24] ^
                        SUB_MIX_1[(s1 >>> 16) & 0xff] ^
                        SUB_MIX_2[(s2 >>> 8) & 0xff] ^
                        SUB_MIX_3[s3 & 0xff] ^
                        keySchedule[ksRow++];
                      var t1 =
                        SUB_MIX_0[s1 >>> 24] ^
                        SUB_MIX_1[(s2 >>> 16) & 0xff] ^
                        SUB_MIX_2[(s3 >>> 8) & 0xff] ^
                        SUB_MIX_3[s0 & 0xff] ^
                        keySchedule[ksRow++];
                      var t2 =
                        SUB_MIX_0[s2 >>> 24] ^
                        SUB_MIX_1[(s3 >>> 16) & 0xff] ^
                        SUB_MIX_2[(s0 >>> 8) & 0xff] ^
                        SUB_MIX_3[s1 & 0xff] ^
                        keySchedule[ksRow++];
                      var t3 =
                        SUB_MIX_0[s3 >>> 24] ^
                        SUB_MIX_1[(s0 >>> 16) & 0xff] ^
                        SUB_MIX_2[(s1 >>> 8) & 0xff] ^
                        SUB_MIX_3[s2 & 0xff] ^
                        keySchedule[ksRow++];
  
                      // Update state
                      s0 = t0;
                      s1 = t1;
                      s2 = t2;
                      s3 = t3;
                    }
  
                    // Shift rows, sub bytes, add round key
                    var t0 =
                      ((SBOX[s0 >>> 24] << 24) |
                        (SBOX[(s1 >>> 16) & 0xff] << 16) |
                        (SBOX[(s2 >>> 8) & 0xff] << 8) |
                        SBOX[s3 & 0xff]) ^
                      keySchedule[ksRow++];
                    var t1 =
                      ((SBOX[s1 >>> 24] << 24) |
                        (SBOX[(s2 >>> 16) & 0xff] << 16) |
                        (SBOX[(s3 >>> 8) & 0xff] << 8) |
                        SBOX[s0 & 0xff]) ^
                      keySchedule[ksRow++];
                    var t2 =
                      ((SBOX[s2 >>> 24] << 24) |
                        (SBOX[(s3 >>> 16) & 0xff] << 16) |
                        (SBOX[(s0 >>> 8) & 0xff] << 8) |
                        SBOX[s1 & 0xff]) ^
                      keySchedule[ksRow++];
                    var t3 =
                      ((SBOX[s3 >>> 24] << 24) |
                        (SBOX[(s0 >>> 16) & 0xff] << 16) |
                        (SBOX[(s1 >>> 8) & 0xff] << 8) |
                        SBOX[s2 & 0xff]) ^
                      keySchedule[ksRow++];
  
                    // Set output
                    M[offset] = t0;
                    M[offset + 1] = t1;
                    M[offset + 2] = t2;
                    M[offset + 3] = t3;
                  },
  
                  keySize: 256 / 32,
                }));
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
                 */
                C.AES = BlockCipher._createHelper(AES);
              })();
  
              return CryptoJS.AES;
            });
          },
          {
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./evpkdf": 199,
            "./md5": 204,
          },
        ],
        195: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./evpkdf")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./evpkdf"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Cipher core components.
               */
              CryptoJS.lib.Cipher ||
                (function (undefined) {
                  // Shortcuts
                  var C = CryptoJS;
                  var C_lib = C.lib;
                  var Base = C_lib.Base;
                  var WordArray = C_lib.WordArray;
                  var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
                  var C_enc = C.enc;
                  var Utf8 = C_enc.Utf8;
                  var Base64 = C_enc.Base64;
                  var C_algo = C.algo;
                  var EvpKDF = C_algo.EvpKDF;
  
                  /**
                   * Abstract base cipher template.
                   *
                   * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
                   * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
                   * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
                   * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
                   */
                  var Cipher = (C_lib.Cipher = BufferedBlockAlgorithm.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {WordArray} iv The IV to use for this operation.
                     */
                    cfg: Base.extend(),
  
                    /**
                     * Creates this cipher in encryption mode.
                     *
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {Cipher} A cipher instance.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
                     */
                    createEncryptor: function (key, cfg) {
                      return this.create(this._ENC_XFORM_MODE, key, cfg);
                    },
  
                    /**
                     * Creates this cipher in decryption mode.
                     *
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @return {Cipher} A cipher instance.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
                     */
                    createDecryptor: function (key, cfg) {
                      return this.create(this._DEC_XFORM_MODE, key, cfg);
                    },
  
                    /**
                     * Initializes a newly created cipher.
                     *
                     * @param {number} xformMode Either the encryption or decryption transormation mode constant.
                     * @param {WordArray} key The key.
                     * @param {Object} cfg (Optional) The configuration options to use for this operation.
                     *
                     * @example
                     *
                     *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
                     */
                    init: function (xformMode, key, cfg) {
                      // Apply config defaults
                      this.cfg = this.cfg.extend(cfg);
  
                      // Store transform mode and key
                      this._xformMode = xformMode;
                      this._key = key;
  
                      // Set initial values
                      this.reset();
                    },
  
                    /**
                     * Resets this cipher to its initial state.
                     *
                     * @example
                     *
                     *     cipher.reset();
                     */
                    reset: function () {
                      // Reset data buffer
                      BufferedBlockAlgorithm.reset.call(this);
  
                      // Perform concrete-cipher logic
                      this._doReset();
                    },
  
                    /**
                     * Adds data to be encrypted or decrypted.
                     *
                     * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
                     *
                     * @return {WordArray} The data after processing.
                     *
                     * @example
                     *
                     *     var encrypted = cipher.process('data');
                     *     var encrypted = cipher.process(wordArray);
                     */
                    process: function (dataUpdate) {
                      // Append
                      this._append(dataUpdate);
  
                      // Process available blocks
                      return this._process();
                    },
  
                    /**
                     * Finalizes the encryption or decryption process.
                     * Note that the finalize operation is effectively a destructive, read-once operation.
                     *
                     * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
                     *
                     * @return {WordArray} The data after final processing.
                     *
                     * @example
                     *
                     *     var encrypted = cipher.finalize();
                     *     var encrypted = cipher.finalize('data');
                     *     var encrypted = cipher.finalize(wordArray);
                     */
                    finalize: function (dataUpdate) {
                      // Final data update
                      if (dataUpdate) {
                        this._append(dataUpdate);
                      }
  
                      // Perform concrete-cipher logic
                      var finalProcessedData = this._doFinalize();
  
                      return finalProcessedData;
                    },
  
                    keySize: 128 / 32,
  
                    ivSize: 128 / 32,
  
                    _ENC_XFORM_MODE: 1,
  
                    _DEC_XFORM_MODE: 2,
  
                    /**
                     * Creates shortcut functions to a cipher's object interface.
                     *
                     * @param {Cipher} cipher The cipher to create a helper for.
                     *
                     * @return {Object} An object with encrypt and decrypt shortcut functions.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
                     */
                    _createHelper: (function () {
                      function selectCipherStrategy(key) {
                        if (typeof key == "string") {
                          return PasswordBasedCipher;
                        } else {
                          return SerializableCipher;
                        }
                      }
  
                      return function (cipher) {
                        return {
                          encrypt: function (message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(
                              cipher,
                              message,
                              key,
                              cfg
                            );
                          },
  
                          decrypt: function (ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(
                              cipher,
                              ciphertext,
                              key,
                              cfg
                            );
                          },
                        };
                      };
                    })(),
                  }));
  
                  /**
                   * Abstract base stream cipher template.
                   *
                   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
                   */
                  var StreamCipher = (C_lib.StreamCipher = Cipher.extend({
                    _doFinalize: function () {
                      // Process partial blocks
                      var finalProcessedBlocks = this._process(!!"flush");
  
                      return finalProcessedBlocks;
                    },
  
                    blockSize: 1,
                  }));
  
                  /**
                   * Mode namespace.
                   */
                  var C_mode = (C.mode = {});
  
                  /**
                   * Abstract base block cipher mode template.
                   */
                  var BlockCipherMode = (C_lib.BlockCipherMode = Base.extend({
                    /**
                     * Creates this mode for encryption.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
                     */
                    createEncryptor: function (cipher, iv) {
                      return this.Encryptor.create(cipher, iv);
                    },
  
                    /**
                     * Creates this mode for decryption.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
                     */
                    createDecryptor: function (cipher, iv) {
                      return this.Decryptor.create(cipher, iv);
                    },
  
                    /**
                     * Initializes a newly created mode.
                     *
                     * @param {Cipher} cipher A block cipher instance.
                     * @param {Array} iv The IV words.
                     *
                     * @example
                     *
                     *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
                     */
                    init: function (cipher, iv) {
                      this._cipher = cipher;
                      this._iv = iv;
                    },
                  }));
  
                  /**
                   * Cipher Block Chaining mode.
                   */
                  var CBC = (C_mode.CBC = (function () {
                    /**
                     * Abstract base CBC mode.
                     */
                    var CBC = BlockCipherMode.extend();
  
                    /**
                     * CBC encryptor.
                     */
                    CBC.Encryptor = CBC.extend({
                      /**
                       * Processes the data block at offset.
                       *
                       * @param {Array} words The data words to operate on.
                       * @param {number} offset The offset where the block starts.
                       *
                       * @example
                       *
                       *     mode.processBlock(data.words, offset);
                       */
                      processBlock: function (words, offset) {
                        // Shortcuts
                        var cipher = this._cipher;
                        var blockSize = cipher.blockSize;
  
                        // XOR and encrypt
                        xorBlock.call(this, words, offset, blockSize);
                        cipher.encryptBlock(words, offset);
  
                        // Remember this block to use with next block
                        this._prevBlock = words.slice(offset, offset + blockSize);
                      },
                    });
  
                    /**
                     * CBC decryptor.
                     */
                    CBC.Decryptor = CBC.extend({
                      /**
                       * Processes the data block at offset.
                       *
                       * @param {Array} words The data words to operate on.
                       * @param {number} offset The offset where the block starts.
                       *
                       * @example
                       *
                       *     mode.processBlock(data.words, offset);
                       */
                      processBlock: function (words, offset) {
                        // Shortcuts
                        var cipher = this._cipher;
                        var blockSize = cipher.blockSize;
  
                        // Remember this block to use with next block
                        var thisBlock = words.slice(offset, offset + blockSize);
  
                        // Decrypt and XOR
                        cipher.decryptBlock(words, offset);
                        xorBlock.call(this, words, offset, blockSize);
  
                        // This block becomes the previous block
                        this._prevBlock = thisBlock;
                      },
                    });
  
                    function xorBlock(words, offset, blockSize) {
                      var block;
  
                      // Shortcut
                      var iv = this._iv;
  
                      // Choose mixing block
                      if (iv) {
                        block = iv;
  
                        // Remove IV for subsequent blocks
                        this._iv = undefined;
                      } else {
                        block = this._prevBlock;
                      }
  
                      // XOR blocks
                      for (var i = 0; i < blockSize; i++) {
                        words[offset + i] ^= block[i];
                      }
                    }
  
                    return CBC;
                  })());
  
                  /**
                   * Padding namespace.
                   */
                  var C_pad = (C.pad = {});
  
                  /**
                   * PKCS #5/7 padding strategy.
                   */
                  var Pkcs7 = (C_pad.Pkcs7 = {
                    /**
                     * Pads data using the algorithm defined in PKCS #5/7.
                     *
                     * @param {WordArray} data The data to pad.
                     * @param {number} blockSize The multiple that the data should be padded to.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
                     */
                    pad: function (data, blockSize) {
                      // Shortcut
                      var blockSizeBytes = blockSize * 4;
  
                      // Count padding bytes
                      var nPaddingBytes =
                        blockSizeBytes - (data.sigBytes % blockSizeBytes);
  
                      // Create padding word
                      var paddingWord =
                        (nPaddingBytes << 24) |
                        (nPaddingBytes << 16) |
                        (nPaddingBytes << 8) |
                        nPaddingBytes;
  
                      // Create padding
                      var paddingWords = [];
                      for (var i = 0; i < nPaddingBytes; i += 4) {
                        paddingWords.push(paddingWord);
                      }
                      var padding = WordArray.create(paddingWords, nPaddingBytes);
  
                      // Add padding
                      data.concat(padding);
                    },
  
                    /**
                     * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
                     *
                     * @param {WordArray} data The data to unpad.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     CryptoJS.pad.Pkcs7.unpad(wordArray);
                     */
                    unpad: function (data) {
                      // Get number of padding bytes from last byte
                      var nPaddingBytes =
                        data.words[(data.sigBytes - 1) >>> 2] & 0xff;
  
                      // Remove padding
                      data.sigBytes -= nPaddingBytes;
                    },
                  });
  
                  /**
                   * Abstract base block cipher template.
                   *
                   * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
                   */
                  var BlockCipher = (C_lib.BlockCipher = Cipher.extend({
                    /**
                     * Configuration options.
                     *
                     * @property {Mode} mode The block mode to use. Default: CBC
                     * @property {Padding} padding The padding strategy to use. Default: Pkcs7
                     */
                    cfg: Cipher.cfg.extend({
                      mode: CBC,
                      padding: Pkcs7,
                    }),
  
                    reset: function () {
                      var modeCreator;
  
                      // Reset cipher
                      Cipher.reset.call(this);
  
                      // Shortcuts
                      var cfg = this.cfg;
                      var iv = cfg.iv;
                      var mode = cfg.mode;
  
                      // Reset block mode
                      if (this._xformMode == this._ENC_XFORM_MODE) {
                        modeCreator = mode.createEncryptor;
                      } /* if (this._xformMode == this._DEC_XFORM_MODE) */ else {
                        modeCreator = mode.createDecryptor;
                        // Keep at least one block in the buffer for unpadding
                        this._minBufferSize = 1;
                      }
  
                      if (this._mode && this._mode.__creator == modeCreator) {
                        this._mode.init(this, iv && iv.words);
                      } else {
                        this._mode = modeCreator.call(mode, this, iv && iv.words);
                        this._mode.__creator = modeCreator;
                      }
                    },
  
                    _doProcessBlock: function (words, offset) {
                      this._mode.processBlock(words, offset);
                    },
  
                    _doFinalize: function () {
                      var finalProcessedBlocks;
  
                      // Shortcut
                      var padding = this.cfg.padding;
  
                      // Finalize
                      if (this._xformMode == this._ENC_XFORM_MODE) {
                        // Pad data
                        padding.pad(this._data, this.blockSize);
  
                        // Process final blocks
                        finalProcessedBlocks = this._process(!!"flush");
                      } /* if (this._xformMode == this._DEC_XFORM_MODE) */ else {
                        // Process final blocks
                        finalProcessedBlocks = this._process(!!"flush");
  
                        // Unpad data
                        padding.unpad(finalProcessedBlocks);
                      }
  
                      return finalProcessedBlocks;
                    },
  
                    blockSize: 128 / 32,
                  }));
  
                  /**
                   * A collection of cipher parameters.
                   *
                   * @property {WordArray} ciphertext The raw ciphertext.
                   * @property {WordArray} key The key to this ciphertext.
                   * @property {WordArray} iv The IV used in the ciphering operation.
                   * @property {WordArray} salt The salt used with a key derivation function.
                   * @property {Cipher} algorithm The cipher algorithm.
                   * @property {Mode} mode The block mode used in the ciphering operation.
                   * @property {Padding} padding The padding scheme used in the ciphering operation.
                   * @property {number} blockSize The block size of the cipher.
                   * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
                   */
                  var CipherParams = (C_lib.CipherParams = Base.extend({
                    /**
                     * Initializes a newly created cipher params object.
                     *
                     * @param {Object} cipherParams An object with any of the possible cipher parameters.
                     *
                     * @example
                     *
                     *     var cipherParams = CryptoJS.lib.CipherParams.create({
                     *         ciphertext: ciphertextWordArray,
                     *         key: keyWordArray,
                     *         iv: ivWordArray,
                     *         salt: saltWordArray,
                     *         algorithm: CryptoJS.algo.AES,
                     *         mode: CryptoJS.mode.CBC,
                     *         padding: CryptoJS.pad.PKCS7,
                     *         blockSize: 4,
                     *         formatter: CryptoJS.format.OpenSSL
                     *     });
                     */
                    init: function (cipherParams) {
                      this.mixIn(cipherParams);
                    },
  
                    /**
                     * Converts this cipher params object to a string.
                     *
                     * @param {Format} formatter (Optional) The formatting strategy to use.
                     *
                     * @return {string} The stringified cipher params.
                     *
                     * @throws Error If neither the formatter nor the default formatter is set.
                     *
                     * @example
                     *
                     *     var string = cipherParams + '';
                     *     var string = cipherParams.toString();
                     *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
                     */
                    toString: function (formatter) {
                      return (formatter || this.formatter).stringify(this);
                    },
                  }));
  
                  /**
                   * Format namespace.
                   */
                  var C_format = (C.format = {});
  
                  /**
                   * OpenSSL formatting strategy.
                   */
                  var OpenSSLFormatter = (C_format.OpenSSL = {
                    /**
                     * Converts a cipher params object to an OpenSSL-compatible string.
                     *
                     * @param {CipherParams} cipherParams The cipher params object.
                     *
                     * @return {string} The OpenSSL-compatible string.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
                     */
                    stringify: function (cipherParams) {
                      var wordArray;
  
                      // Shortcuts
                      var ciphertext = cipherParams.ciphertext;
                      var salt = cipherParams.salt;
  
                      // Format
                      if (salt) {
                        wordArray = WordArray.create([0x53616c74, 0x65645f5f])
                          .concat(salt)
                          .concat(ciphertext);
                      } else {
                        wordArray = ciphertext;
                      }
  
                      return wordArray.toString(Base64);
                    },
  
                    /**
                     * Converts an OpenSSL-compatible string to a cipher params object.
                     *
                     * @param {string} openSSLStr The OpenSSL-compatible string.
                     *
                     * @return {CipherParams} The cipher params object.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
                     */
                    parse: function (openSSLStr) {
                      var salt;
  
                      // Parse base64
                      var ciphertext = Base64.parse(openSSLStr);
  
                      // Shortcut
                      var ciphertextWords = ciphertext.words;
  
                      // Test for salt
                      if (
                        ciphertextWords[0] == 0x53616c74 &&
                        ciphertextWords[1] == 0x65645f5f
                      ) {
                        // Extract salt
                        salt = WordArray.create(ciphertextWords.slice(2, 4));
  
                        // Remove salt from ciphertext
                        ciphertextWords.splice(0, 4);
                        ciphertext.sigBytes -= 16;
                      }
  
                      return CipherParams.create({
                        ciphertext: ciphertext,
                        salt: salt,
                      });
                    },
                  });
  
                  /**
                   * A cipher wrapper that returns ciphertext as a serializable cipher params object.
                   */
                  var SerializableCipher = (C_lib.SerializableCipher =
                    Base.extend({
                      /**
                       * Configuration options.
                       *
                       * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
                       */
                      cfg: Base.extend({
                        format: OpenSSLFormatter,
                      }),
  
                      /**
                       * Encrypts a message.
                       *
                       * @param {Cipher} cipher The cipher algorithm to use.
                       * @param {WordArray|string} message The message to encrypt.
                       * @param {WordArray} key The key.
                       * @param {Object} cfg (Optional) The configuration options to use for this operation.
                       *
                       * @return {CipherParams} A cipher params object.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
                       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
                       *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                       */
                      encrypt: function (cipher, message, key, cfg) {
                        // Apply config defaults
                        cfg = this.cfg.extend(cfg);
  
                        // Encrypt
                        var encryptor = cipher.createEncryptor(key, cfg);
                        var ciphertext = encryptor.finalize(message);
  
                        // Shortcut
                        var cipherCfg = encryptor.cfg;
  
                        // Create and return serializable cipher params
                        return CipherParams.create({
                          ciphertext: ciphertext,
                          key: key,
                          iv: cipherCfg.iv,
                          algorithm: cipher,
                          mode: cipherCfg.mode,
                          padding: cipherCfg.padding,
                          blockSize: cipher.blockSize,
                          formatter: cfg.format,
                        });
                      },
  
                      /**
                       * Decrypts serialized ciphertext.
                       *
                       * @param {Cipher} cipher The cipher algorithm to use.
                       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                       * @param {WordArray} key The key.
                       * @param {Object} cfg (Optional) The configuration options to use for this operation.
                       *
                       * @return {WordArray} The plaintext.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                       *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
                       */
                      decrypt: function (cipher, ciphertext, key, cfg) {
                        // Apply config defaults
                        cfg = this.cfg.extend(cfg);
  
                        // Convert string to CipherParams
                        ciphertext = this._parse(ciphertext, cfg.format);
  
                        // Decrypt
                        var plaintext = cipher
                          .createDecryptor(key, cfg)
                          .finalize(ciphertext.ciphertext);
  
                        return plaintext;
                      },
  
                      /**
                       * Converts serialized ciphertext to CipherParams,
                       * else assumed CipherParams already and returns ciphertext unchanged.
                       *
                       * @param {CipherParams|string} ciphertext The ciphertext.
                       * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
                       *
                       * @return {CipherParams} The unserialized ciphertext.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
                       */
                      _parse: function (ciphertext, format) {
                        if (typeof ciphertext == "string") {
                          return format.parse(ciphertext, this);
                        } else {
                          return ciphertext;
                        }
                      },
                    }));
  
                  /**
                   * Key derivation function namespace.
                   */
                  var C_kdf = (C.kdf = {});
  
                  /**
                   * OpenSSL key derivation function.
                   */
                  var OpenSSLKdf = (C_kdf.OpenSSL = {
                    /**
                     * Derives a key and IV from a password.
                     *
                     * @param {string} password The password to derive from.
                     * @param {number} keySize The size in words of the key to generate.
                     * @param {number} ivSize The size in words of the IV to generate.
                     * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
                     *
                     * @return {CipherParams} A cipher params object with the key, IV, and salt.
                     *
                     * @static
                     *
                     * @example
                     *
                     *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
                     *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
                     */
                    execute: function (password, keySize, ivSize, salt) {
                      // Generate random salt
                      if (!salt) {
                        salt = WordArray.random(64 / 8);
                      }
  
                      // Derive key and IV
                      var key = EvpKDF.create({
                        keySize: keySize + ivSize,
                      }).compute(password, salt);
  
                      // Separate key and IV
                      var iv = WordArray.create(
                        key.words.slice(keySize),
                        ivSize * 4
                      );
                      key.sigBytes = keySize * 4;
  
                      // Return params
                      return CipherParams.create({
                        key: key,
                        iv: iv,
                        salt: salt,
                      });
                    },
                  });
  
                  /**
                   * A serializable cipher wrapper that derives the key from a password,
                   * and returns ciphertext as a serializable cipher params object.
                   */
                  var PasswordBasedCipher = (C_lib.PasswordBasedCipher =
                    SerializableCipher.extend({
                      /**
                       * Configuration options.
                       *
                       * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
                       */
                      cfg: SerializableCipher.cfg.extend({
                        kdf: OpenSSLKdf,
                      }),
  
                      /**
                       * Encrypts a message using a password.
                       *
                       * @param {Cipher} cipher The cipher algorithm to use.
                       * @param {WordArray|string} message The message to encrypt.
                       * @param {string} password The password.
                       * @param {Object} cfg (Optional) The configuration options to use for this operation.
                       *
                       * @return {CipherParams} A cipher params object.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
                       *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
                       */
                      encrypt: function (cipher, message, password, cfg) {
                        // Apply config defaults
                        cfg = this.cfg.extend(cfg);
  
                        // Derive key and other params
                        var derivedParams = cfg.kdf.execute(
                          password,
                          cipher.keySize,
                          cipher.ivSize
                        );
  
                        // Add IV to config
                        cfg.iv = derivedParams.iv;
  
                        // Encrypt
                        var ciphertext = SerializableCipher.encrypt.call(
                          this,
                          cipher,
                          message,
                          derivedParams.key,
                          cfg
                        );
  
                        // Mix in derived params
                        ciphertext.mixIn(derivedParams);
  
                        return ciphertext;
                      },
  
                      /**
                       * Decrypts serialized ciphertext using a password.
                       *
                       * @param {Cipher} cipher The cipher algorithm to use.
                       * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
                       * @param {string} password The password.
                       * @param {Object} cfg (Optional) The configuration options to use for this operation.
                       *
                       * @return {WordArray} The plaintext.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
                       *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
                       */
                      decrypt: function (cipher, ciphertext, password, cfg) {
                        // Apply config defaults
                        cfg = this.cfg.extend(cfg);
  
                        // Convert string to CipherParams
                        ciphertext = this._parse(ciphertext, cfg.format);
  
                        // Derive key and other params
                        var derivedParams = cfg.kdf.execute(
                          password,
                          cipher.keySize,
                          cipher.ivSize,
                          ciphertext.salt
                        );
  
                        // Add IV to config
                        cfg.iv = derivedParams.iv;
  
                        // Decrypt
                        var plaintext = SerializableCipher.decrypt.call(
                          this,
                          cipher,
                          ciphertext,
                          derivedParams.key,
                          cfg
                        );
  
                        return plaintext;
                      },
                    }));
                })();
            });
          },
          { "./core": 196, "./evpkdf": 199 },
        ],
        196: [
          function (require, module, exports) {
            (function (global) {
              (function () {
                (function (root, factory) {
                  if (typeof exports === "object") {
                    // CommonJS
                    module.exports = exports = factory();
                  } else if (typeof define === "function" && define.amd) {
                    // AMD
                    define([], factory);
                  } else {
                    // Global (browser)
                    root.CryptoJS = factory();
                  }
                })(this, function () {
                  /*globals window, global, require*/
  
                  /**
                   * CryptoJS core components.
                   */
                  var CryptoJS =
                    CryptoJS ||
                    (function (Math, undefined) {
                      var crypto;
  
                      // Native crypto from window (Browser)
                      if (typeof window !== "undefined" && window.crypto) {
                        crypto = window.crypto;
                      }
  
                      // Native (experimental IE 11) crypto from window (Browser)
                      if (
                        !crypto &&
                        typeof window !== "undefined" &&
                        window.msCrypto
                      ) {
                        crypto = window.msCrypto;
                      }
  
                      // Native crypto from global (NodeJS)
                      if (
                        !crypto &&
                        typeof global !== "undefined" &&
                        global.crypto
                      ) {
                        crypto = global.crypto;
                      }
  
                      // Native crypto import via require (NodeJS)
                      if (!crypto && typeof require === "function") {
                        try {
                          crypto = require("crypto");
                        } catch (err) {}
                      }
  
                      /*
                       * Cryptographically secure pseudorandom number generator
                       *
                       * As Math.random() is cryptographically not safe to use
                       */
                      var cryptoSecureRandomInt = function () {
                        if (crypto) {
                          // Use getRandomValues method (Browser)
                          if (typeof crypto.getRandomValues === "function") {
                            try {
                              return crypto.getRandomValues(
                                new Uint32Array(1)
                              )[0];
                            } catch (err) {}
                          }
  
                          // Use randomBytes method (NodeJS)
                          if (typeof crypto.randomBytes === "function") {
                            try {
                              return crypto.randomBytes(4).readInt32LE();
                            } catch (err) {}
                          }
                        }
  
                        throw new Error(
                          "Native crypto module could not be used to get secure random number."
                        );
                      };
  
                      /*
           * Local polyfill of Object.create
  
           */
                      var create =
                        Object.create ||
                        (function () {
                          function F() {}
  
                          return function (obj) {
                            var subtype;
  
                            F.prototype = obj;
  
                            subtype = new F();
  
                            F.prototype = null;
  
                            return subtype;
                          };
                        })();
  
                      /**
                       * CryptoJS namespace.
                       */
                      var C = {};
  
                      /**
                       * Library namespace.
                       */
                      var C_lib = (C.lib = {});
  
                      /**
                       * Base object for prototypal inheritance.
                       */
                      var Base = (C_lib.Base = (function () {
                        return {
                          /**
                           * Creates a new object that inherits from this object.
                           *
                           * @param {Object} overrides Properties to copy into the new object.
                           *
                           * @return {Object} The new object.
                           *
                           * @static
                           *
                           * @example
                           *
                           *     var MyType = CryptoJS.lib.Base.extend({
                           *         field: 'value',
                           *
                           *         method: function () {
                           *         }
                           *     });
                           */
                          extend: function (overrides) {
                            // Spawn
                            var subtype = create(this);
  
                            // Augment
                            if (overrides) {
                              subtype.mixIn(overrides);
                            }
  
                            // Create default initializer
                            if (
                              !subtype.hasOwnProperty("init") ||
                              this.init === subtype.init
                            ) {
                              subtype.init = function () {
                                subtype.$super.init.apply(this, arguments);
                              };
                            }
  
                            // Initializer's prototype is the subtype object
                            subtype.init.prototype = subtype;
  
                            // Reference supertype
                            subtype.$super = this;
  
                            return subtype;
                          },
  
                          /**
                           * Extends this object and runs the init method.
                           * Arguments to create() will be passed to init().
                           *
                           * @return {Object} The new object.
                           *
                           * @static
                           *
                           * @example
                           *
                           *     var instance = MyType.create();
                           */
                          create: function () {
                            var instance = this.extend();
                            instance.init.apply(instance, arguments);
  
                            return instance;
                          },
  
                          /**
                           * Initializes a newly created object.
                           * Override this method to add some logic when your objects are created.
                           *
                           * @example
                           *
                           *     var MyType = CryptoJS.lib.Base.extend({
                           *         init: function () {
                           *             // ...
                           *         }
                           *     });
                           */
                          init: function () {},
  
                          /**
                           * Copies properties into this object.
                           *
                           * @param {Object} properties The properties to mix in.
                           *
                           * @example
                           *
                           *     MyType.mixIn({
                           *         field: 'value'
                           *     });
                           */
                          mixIn: function (properties) {
                            for (var propertyName in properties) {
                              if (properties.hasOwnProperty(propertyName)) {
                                this[propertyName] = properties[propertyName];
                              }
                            }
  
                            // IE won't copy toString using the loop above
                            if (properties.hasOwnProperty("toString")) {
                              this.toString = properties.toString;
                            }
                          },
  
                          /**
                           * Creates a copy of this object.
                           *
                           * @return {Object} The clone.
                           *
                           * @example
                           *
                           *     var clone = instance.clone();
                           */
                          clone: function () {
                            return this.init.prototype.extend(this);
                          },
                        };
                      })());
  
                      /**
                       * An array of 32-bit words.
                       *
                       * @property {Array} words The array of 32-bit words.
                       * @property {number} sigBytes The number of significant bytes in this word array.
                       */
                      var WordArray = (C_lib.WordArray = Base.extend({
                        /**
                         * Initializes a newly created word array.
                         *
                         * @param {Array} words (Optional) An array of 32-bit words.
                         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.lib.WordArray.create();
                         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
                         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
                         */
                        init: function (words, sigBytes) {
                          words = this.words = words || [];
  
                          if (sigBytes != undefined) {
                            this.sigBytes = sigBytes;
                          } else {
                            this.sigBytes = words.length * 4;
                          }
                        },
  
                        /**
                         * Converts this word array to a string.
                         *
                         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
                         *
                         * @return {string} The stringified word array.
                         *
                         * @example
                         *
                         *     var string = wordArray + '';
                         *     var string = wordArray.toString();
                         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
                         */
                        toString: function (encoder) {
                          return (encoder || Hex).stringify(this);
                        },
  
                        /**
                         * Concatenates a word array to this word array.
                         *
                         * @param {WordArray} wordArray The word array to append.
                         *
                         * @return {WordArray} This word array.
                         *
                         * @example
                         *
                         *     wordArray1.concat(wordArray2);
                         */
                        concat: function (wordArray) {
                          // Shortcuts
                          var thisWords = this.words;
                          var thatWords = wordArray.words;
                          var thisSigBytes = this.sigBytes;
                          var thatSigBytes = wordArray.sigBytes;
  
                          // Clamp excess bits
                          this.clamp();
  
                          // Concat
                          if (thisSigBytes % 4) {
                            // Copy one byte at a time
                            for (var i = 0; i < thatSigBytes; i++) {
                              var thatByte =
                                (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) &
                                0xff;
                              thisWords[(thisSigBytes + i) >>> 2] |=
                                thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
                            }
                          } else {
                            // Copy one word at a time
                            for (var i = 0; i < thatSigBytes; i += 4) {
                              thisWords[(thisSigBytes + i) >>> 2] =
                                thatWords[i >>> 2];
                            }
                          }
                          this.sigBytes += thatSigBytes;
  
                          // Chainable
                          return this;
                        },
  
                        /**
                         * Removes insignificant bits.
                         *
                         * @example
                         *
                         *     wordArray.clamp();
                         */
                        clamp: function () {
                          // Shortcuts
                          var words = this.words;
                          var sigBytes = this.sigBytes;
  
                          // Clamp
                          words[sigBytes >>> 2] &=
                            0xffffffff << (32 - (sigBytes % 4) * 8);
                          words.length = Math.ceil(sigBytes / 4);
                        },
  
                        /**
                         * Creates a copy of this word array.
                         *
                         * @return {WordArray} The clone.
                         *
                         * @example
                         *
                         *     var clone = wordArray.clone();
                         */
                        clone: function () {
                          var clone = Base.clone.call(this);
                          clone.words = this.words.slice(0);
  
                          return clone;
                        },
  
                        /**
                         * Creates a word array filled with random bytes.
                         *
                         * @param {number} nBytes The number of random bytes to generate.
                         *
                         * @return {WordArray} The random word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.lib.WordArray.random(16);
                         */
                        random: function (nBytes) {
                          var words = [];
  
                          for (var i = 0; i < nBytes; i += 4) {
                            words.push(cryptoSecureRandomInt());
                          }
  
                          return new WordArray.init(words, nBytes);
                        },
                      }));
  
                      /**
                       * Encoder namespace.
                       */
                      var C_enc = (C.enc = {});
  
                      /**
                       * Hex encoding strategy.
                       */
                      var Hex = (C_enc.Hex = {
                        /**
                         * Converts a word array to a hex string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The hex string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                          // Shortcuts
                          var words = wordArray.words;
                          var sigBytes = wordArray.sigBytes;
  
                          // Convert
                          var hexChars = [];
                          for (var i = 0; i < sigBytes; i++) {
                            var bite =
                              (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                            hexChars.push((bite >>> 4).toString(16));
                            hexChars.push((bite & 0x0f).toString(16));
                          }
  
                          return hexChars.join("");
                        },
  
                        /**
                         * Converts a hex string to a word array.
                         *
                         * @param {string} hexStr The hex string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
                         */
                        parse: function (hexStr) {
                          // Shortcut
                          var hexStrLength = hexStr.length;
  
                          // Convert
                          var words = [];
                          for (var i = 0; i < hexStrLength; i += 2) {
                            words[i >>> 3] |=
                              parseInt(hexStr.substr(i, 2), 16) <<
                              (24 - (i % 8) * 4);
                          }
  
                          return new WordArray.init(words, hexStrLength / 2);
                        },
                      });
  
                      /**
                       * Latin1 encoding strategy.
                       */
                      var Latin1 = (C_enc.Latin1 = {
                        /**
                         * Converts a word array to a Latin1 string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The Latin1 string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                          // Shortcuts
                          var words = wordArray.words;
                          var sigBytes = wordArray.sigBytes;
  
                          // Convert
                          var latin1Chars = [];
                          for (var i = 0; i < sigBytes; i++) {
                            var bite =
                              (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                            latin1Chars.push(String.fromCharCode(bite));
                          }
  
                          return latin1Chars.join("");
                        },
  
                        /**
                         * Converts a Latin1 string to a word array.
                         *
                         * @param {string} latin1Str The Latin1 string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
                         */
                        parse: function (latin1Str) {
                          // Shortcut
                          var latin1StrLength = latin1Str.length;
  
                          // Convert
                          var words = [];
                          for (var i = 0; i < latin1StrLength; i++) {
                            words[i >>> 2] |=
                              (latin1Str.charCodeAt(i) & 0xff) <<
                              (24 - (i % 4) * 8);
                          }
  
                          return new WordArray.init(words, latin1StrLength);
                        },
                      });
  
                      /**
                       * UTF-8 encoding strategy.
                       */
                      var Utf8 = (C_enc.Utf8 = {
                        /**
                         * Converts a word array to a UTF-8 string.
                         *
                         * @param {WordArray} wordArray The word array.
                         *
                         * @return {string} The UTF-8 string.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
                         */
                        stringify: function (wordArray) {
                          try {
                            return decodeURIComponent(
                              escape(Latin1.stringify(wordArray))
                            );
                          } catch (e) {
                            throw new Error("Malformed UTF-8 data");
                          }
                        },
  
                        /**
                         * Converts a UTF-8 string to a word array.
                         *
                         * @param {string} utf8Str The UTF-8 string.
                         *
                         * @return {WordArray} The word array.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
                         */
                        parse: function (utf8Str) {
                          return Latin1.parse(
                            unescape(encodeURIComponent(utf8Str))
                          );
                        },
                      });
  
                      /**
                       * Abstract buffered block algorithm template.
                       *
                       * The property blockSize must be implemented in a concrete subtype.
                       *
                       * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
                       */
                      var BufferedBlockAlgorithm = (C_lib.BufferedBlockAlgorithm =
                        Base.extend({
                          /**
                           * Resets this block algorithm's data buffer to its initial state.
                           *
                           * @example
                           *
                           *     bufferedBlockAlgorithm.reset();
                           */
                          reset: function () {
                            // Initial values
                            this._data = new WordArray.init();
                            this._nDataBytes = 0;
                          },
  
                          /**
                           * Adds new data to this block algorithm's buffer.
                           *
                           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
                           *
                           * @example
                           *
                           *     bufferedBlockAlgorithm._append('data');
                           *     bufferedBlockAlgorithm._append(wordArray);
                           */
                          _append: function (data) {
                            // Convert string to WordArray, else assume WordArray already
                            if (typeof data == "string") {
                              data = Utf8.parse(data);
                            }
  
                            // Append
                            this._data.concat(data);
                            this._nDataBytes += data.sigBytes;
                          },
  
                          /**
                           * Processes available data blocks.
                           *
                           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
                           *
                           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
                           *
                           * @return {WordArray} The processed data.
                           *
                           * @example
                           *
                           *     var processedData = bufferedBlockAlgorithm._process();
                           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
                           */
                          _process: function (doFlush) {
                            var processedWords;
  
                            // Shortcuts
                            var data = this._data;
                            var dataWords = data.words;
                            var dataSigBytes = data.sigBytes;
                            var blockSize = this.blockSize;
                            var blockSizeBytes = blockSize * 4;
  
                            // Count blocks ready
                            var nBlocksReady = dataSigBytes / blockSizeBytes;
                            if (doFlush) {
                              // Round up to include partial blocks
                              nBlocksReady = Math.ceil(nBlocksReady);
                            } else {
                              // Round down to include only full blocks,
                              // less the number of blocks that must remain in the buffer
                              nBlocksReady = Math.max(
                                (nBlocksReady | 0) - this._minBufferSize,
                                0
                              );
                            }
  
                            // Count words ready
                            var nWordsReady = nBlocksReady * blockSize;
  
                            // Count bytes ready
                            var nBytesReady = Math.min(
                              nWordsReady * 4,
                              dataSigBytes
                            );
  
                            // Process blocks
                            if (nWordsReady) {
                              for (
                                var offset = 0;
                                offset < nWordsReady;
                                offset += blockSize
                              ) {
                                // Perform concrete-algorithm logic
                                this._doProcessBlock(dataWords, offset);
                              }
  
                              // Remove processed words
                              processedWords = dataWords.splice(0, nWordsReady);
                              data.sigBytes -= nBytesReady;
                            }
  
                            // Return processed words
                            return new WordArray.init(
                              processedWords,
                              nBytesReady
                            );
                          },
  
                          /**
                           * Creates a copy of this object.
                           *
                           * @return {Object} The clone.
                           *
                           * @example
                           *
                           *     var clone = bufferedBlockAlgorithm.clone();
                           */
                          clone: function () {
                            var clone = Base.clone.call(this);
                            clone._data = this._data.clone();
  
                            return clone;
                          },
  
                          _minBufferSize: 0,
                        }));
  
                      /**
                       * Abstract hasher template.
                       *
                       * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
                       */
                      var Hasher = (C_lib.Hasher = BufferedBlockAlgorithm.extend({
                        /**
                         * Configuration options.
                         */
                        cfg: Base.extend(),
  
                        /**
                         * Initializes a newly created hasher.
                         *
                         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
                         *
                         * @example
                         *
                         *     var hasher = CryptoJS.algo.SHA256.create();
                         */
                        init: function (cfg) {
                          // Apply config defaults
                          this.cfg = this.cfg.extend(cfg);
  
                          // Set initial values
                          this.reset();
                        },
  
                        /**
                         * Resets this hasher to its initial state.
                         *
                         * @example
                         *
                         *     hasher.reset();
                         */
                        reset: function () {
                          // Reset data buffer
                          BufferedBlockAlgorithm.reset.call(this);
  
                          // Perform concrete-hasher logic
                          this._doReset();
                        },
  
                        /**
                         * Updates this hasher with a message.
                         *
                         * @param {WordArray|string} messageUpdate The message to append.
                         *
                         * @return {Hasher} This hasher.
                         *
                         * @example
                         *
                         *     hasher.update('message');
                         *     hasher.update(wordArray);
                         */
                        update: function (messageUpdate) {
                          // Append
                          this._append(messageUpdate);
  
                          // Update the hash
                          this._process();
  
                          // Chainable
                          return this;
                        },
  
                        /**
                         * Finalizes the hash computation.
                         * Note that the finalize operation is effectively a destructive, read-once operation.
                         *
                         * @param {WordArray|string} messageUpdate (Optional) A final message update.
                         *
                         * @return {WordArray} The hash.
                         *
                         * @example
                         *
                         *     var hash = hasher.finalize();
                         *     var hash = hasher.finalize('message');
                         *     var hash = hasher.finalize(wordArray);
                         */
                        finalize: function (messageUpdate) {
                          // Final message update
                          if (messageUpdate) {
                            this._append(messageUpdate);
                          }
  
                          // Perform concrete-hasher logic
                          var hash = this._doFinalize();
  
                          return hash;
                        },
  
                        blockSize: 512 / 32,
  
                        /**
                         * Creates a shortcut function to a hasher's object interface.
                         *
                         * @param {Hasher} hasher The hasher to create a helper for.
                         *
                         * @return {Function} The shortcut function.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
                         */
                        _createHelper: function (hasher) {
                          return function (message, cfg) {
                            return new hasher.init(cfg).finalize(message);
                          };
                        },
  
                        /**
                         * Creates a shortcut function to the HMAC's object interface.
                         *
                         * @param {Hasher} hasher The hasher to use in this HMAC helper.
                         *
                         * @return {Function} The shortcut function.
                         *
                         * @static
                         *
                         * @example
                         *
                         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
                         */
                        _createHmacHelper: function (hasher) {
                          return function (message, key) {
                            return new C_algo.HMAC.init(hasher, key).finalize(
                              message
                            );
                          };
                        },
                      }));
  
                      /**
                       * Algorithm namespace.
                       */
                      var C_algo = (C.algo = {});
  
                      return C;
                    })(Math);
  
                  return CryptoJS;
                });
              }.call(this));
            }.call(
              this,
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {}
            ));
          },
          { crypto: 54 },
        ],
        197: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var C_enc = C.enc;
  
                /**
                 * Base64 encoding strategy.
                 */
                var Base64 = (C_enc.Base64 = {
                  /**
                   * Converts a word array to a Base64 string.
                   *
                   * @param {WordArray} wordArray The word array.
                   *
                   * @return {string} The Base64 string.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
                   */
                  stringify: function (wordArray) {
                    // Shortcuts
                    var words = wordArray.words;
                    var sigBytes = wordArray.sigBytes;
                    var map = this._map;
  
                    // Clamp excess bits
                    wordArray.clamp();
  
                    // Convert
                    var base64Chars = [];
                    for (var i = 0; i < sigBytes; i += 3) {
                      var byte1 = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
                      var byte2 =
                        (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) &
                        0xff;
                      var byte3 =
                        (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) &
                        0xff;
  
                      var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
  
                      for (var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++) {
                        base64Chars.push(
                          map.charAt((triplet >>> (6 * (3 - j))) & 0x3f)
                        );
                      }
                    }
  
                    // Add padding
                    var paddingChar = map.charAt(64);
                    if (paddingChar) {
                      while (base64Chars.length % 4) {
                        base64Chars.push(paddingChar);
                      }
                    }
  
                    return base64Chars.join("");
                  },
  
                  /**
                   * Converts a Base64 string to a word array.
                   *
                   * @param {string} base64Str The Base64 string.
                   *
                   * @return {WordArray} The word array.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
                   */
                  parse: function (base64Str) {
                    // Shortcuts
                    var base64StrLength = base64Str.length;
                    var map = this._map;
                    var reverseMap = this._reverseMap;
  
                    if (!reverseMap) {
                      reverseMap = this._reverseMap = [];
                      for (var j = 0; j < map.length; j++) {
                        reverseMap[map.charCodeAt(j)] = j;
                      }
                    }
  
                    // Ignore padding
                    var paddingChar = map.charAt(64);
                    if (paddingChar) {
                      var paddingIndex = base64Str.indexOf(paddingChar);
                      if (paddingIndex !== -1) {
                        base64StrLength = paddingIndex;
                      }
                    }
  
                    // Convert
                    return parseLoop(base64Str, base64StrLength, reverseMap);
                  },
  
                  _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                });
  
                function parseLoop(base64Str, base64StrLength, reverseMap) {
                  var words = [];
                  var nBytes = 0;
                  for (var i = 0; i < base64StrLength; i++) {
                    if (i % 4) {
                      var bits1 =
                        reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
                      var bits2 =
                        reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
                      var bitsCombined = bits1 | bits2;
                      words[nBytes >>> 2] |=
                        bitsCombined << (24 - (nBytes % 4) * 8);
                      nBytes++;
                    }
                  }
                  return WordArray.create(words, nBytes);
                }
              })();
  
              return CryptoJS.enc.Base64;
            });
          },
          { "./core": 196 },
        ],
        198: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var C_enc = C.enc;
  
                /**
                 * UTF-16 BE encoding strategy.
                 */
                var Utf16BE =
                  (C_enc.Utf16 =
                  C_enc.Utf16BE =
                    {
                      /**
                       * Converts a word array to a UTF-16 BE string.
                       *
                       * @param {WordArray} wordArray The word array.
                       *
                       * @return {string} The UTF-16 BE string.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
                       */
                      stringify: function (wordArray) {
                        // Shortcuts
                        var words = wordArray.words;
                        var sigBytes = wordArray.sigBytes;
  
                        // Convert
                        var utf16Chars = [];
                        for (var i = 0; i < sigBytes; i += 2) {
                          var codePoint =
                            (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
                          utf16Chars.push(String.fromCharCode(codePoint));
                        }
  
                        return utf16Chars.join("");
                      },
  
                      /**
                       * Converts a UTF-16 BE string to a word array.
                       *
                       * @param {string} utf16Str The UTF-16 BE string.
                       *
                       * @return {WordArray} The word array.
                       *
                       * @static
                       *
                       * @example
                       *
                       *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
                       */
                      parse: function (utf16Str) {
                        // Shortcut
                        var utf16StrLength = utf16Str.length;
  
                        // Convert
                        var words = [];
                        for (var i = 0; i < utf16StrLength; i++) {
                          words[i >>> 1] |=
                            utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
                        }
  
                        return WordArray.create(words, utf16StrLength * 2);
                      },
                    });
  
                /**
                 * UTF-16 LE encoding strategy.
                 */
                C_enc.Utf16LE = {
                  /**
                   * Converts a word array to a UTF-16 LE string.
                   *
                   * @param {WordArray} wordArray The word array.
                   *
                   * @return {string} The UTF-16 LE string.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
                   */
                  stringify: function (wordArray) {
                    // Shortcuts
                    var words = wordArray.words;
                    var sigBytes = wordArray.sigBytes;
  
                    // Convert
                    var utf16Chars = [];
                    for (var i = 0; i < sigBytes; i += 2) {
                      var codePoint = swapEndian(
                        (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff
                      );
                      utf16Chars.push(String.fromCharCode(codePoint));
                    }
  
                    return utf16Chars.join("");
                  },
  
                  /**
                   * Converts a UTF-16 LE string to a word array.
                   *
                   * @param {string} utf16Str The UTF-16 LE string.
                   *
                   * @return {WordArray} The word array.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
                   */
                  parse: function (utf16Str) {
                    // Shortcut
                    var utf16StrLength = utf16Str.length;
  
                    // Convert
                    var words = [];
                    for (var i = 0; i < utf16StrLength; i++) {
                      words[i >>> 1] |= swapEndian(
                        utf16Str.charCodeAt(i) << (16 - (i % 2) * 16)
                      );
                    }
  
                    return WordArray.create(words, utf16StrLength * 2);
                  },
                };
  
                function swapEndian(word) {
                  return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
                }
              })();
  
              return CryptoJS.enc.Utf16;
            });
          },
          { "./core": 196 },
        ],
        199: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./sha1"),
                  require("./hmac")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./sha1", "./hmac"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var Base = C_lib.Base;
                var WordArray = C_lib.WordArray;
                var C_algo = C.algo;
                var MD5 = C_algo.MD5;
  
                /**
                 * This key derivation function is meant to conform with EVP_BytesToKey.
                 * www.openssl.org/docs/crypto/EVP_BytesToKey.html
                 */
                var EvpKDF = (C_algo.EvpKDF = Base.extend({
                  /**
                   * Configuration options.
                   *
                   * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                   * @property {Hasher} hasher The hash algorithm to use. Default: MD5
                   * @property {number} iterations The number of iterations to perform. Default: 1
                   */
                  cfg: Base.extend({
                    keySize: 128 / 32,
                    hasher: MD5,
                    iterations: 1,
                  }),
  
                  /**
                   * Initializes a newly created key derivation function.
                   *
                   * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                   *
                   * @example
                   *
                   *     var kdf = CryptoJS.algo.EvpKDF.create();
                   *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
                   *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
                   */
                  init: function (cfg) {
                    this.cfg = this.cfg.extend(cfg);
                  },
  
                  /**
                   * Derives a key from a password.
                   *
                   * @param {WordArray|string} password The password.
                   * @param {WordArray|string} salt A salt.
                   *
                   * @return {WordArray} The derived key.
                   *
                   * @example
                   *
                   *     var key = kdf.compute(password, salt);
                   */
                  compute: function (password, salt) {
                    var block;
  
                    // Shortcut
                    var cfg = this.cfg;
  
                    // Init hasher
                    var hasher = cfg.hasher.create();
  
                    // Initial values
                    var derivedKey = WordArray.create();
  
                    // Shortcuts
                    var derivedKeyWords = derivedKey.words;
                    var keySize = cfg.keySize;
                    var iterations = cfg.iterations;
  
                    // Generate key
                    while (derivedKeyWords.length < keySize) {
                      if (block) {
                        hasher.update(block);
                      }
                      block = hasher.update(password).finalize(salt);
                      hasher.reset();
  
                      // Iterations
                      for (var i = 1; i < iterations; i++) {
                        block = hasher.finalize(block);
                        hasher.reset();
                      }
  
                      derivedKey.concat(block);
                    }
                    derivedKey.sigBytes = keySize * 4;
  
                    return derivedKey;
                  },
                }));
  
                /**
                 * Derives a key from a password.
                 *
                 * @param {WordArray|string} password The password.
                 * @param {WordArray|string} salt A salt.
                 * @param {Object} cfg (Optional) The configuration options to use for this computation.
                 *
                 * @return {WordArray} The derived key.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var key = CryptoJS.EvpKDF(password, salt);
                 *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
                 *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
                 */
                C.EvpKDF = function (password, salt, cfg) {
                  return EvpKDF.create(cfg).compute(password, salt);
                };
              })();
  
              return CryptoJS.EvpKDF;
            });
          },
          { "./core": 196, "./hmac": 201, "./sha1": 220 },
        ],
        200: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function (undefined) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var CipherParams = C_lib.CipherParams;
                var C_enc = C.enc;
                var Hex = C_enc.Hex;
                var C_format = C.format;
  
                var HexFormatter = (C_format.Hex = {
                  /**
                   * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
                   *
                   * @param {CipherParams} cipherParams The cipher params object.
                   *
                   * @return {string} The hexadecimally encoded string.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
                   */
                  stringify: function (cipherParams) {
                    return cipherParams.ciphertext.toString(Hex);
                  },
  
                  /**
                   * Converts a hexadecimally encoded ciphertext string to a cipher params object.
                   *
                   * @param {string} input The hexadecimally encoded string.
                   *
                   * @return {CipherParams} The cipher params object.
                   *
                   * @static
                   *
                   * @example
                   *
                   *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
                   */
                  parse: function (input) {
                    var ciphertext = Hex.parse(input);
                    return CipherParams.create({ ciphertext: ciphertext });
                  },
                });
              })();
  
              return CryptoJS.format.Hex;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        201: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var Base = C_lib.Base;
                var C_enc = C.enc;
                var Utf8 = C_enc.Utf8;
                var C_algo = C.algo;
  
                /**
                 * HMAC algorithm.
                 */
                var HMAC = (C_algo.HMAC = Base.extend({
                  /**
                   * Initializes a newly created HMAC.
                   *
                   * @param {Hasher} hasher The hash algorithm to use.
                   * @param {WordArray|string} key The secret key.
                   *
                   * @example
                   *
                   *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
                   */
                  init: function (hasher, key) {
                    // Init hasher
                    hasher = this._hasher = new hasher.init();
  
                    // Convert string to WordArray, else assume WordArray already
                    if (typeof key == "string") {
                      key = Utf8.parse(key);
                    }
  
                    // Shortcuts
                    var hasherBlockSize = hasher.blockSize;
                    var hasherBlockSizeBytes = hasherBlockSize * 4;
  
                    // Allow arbitrary length keys
                    if (key.sigBytes > hasherBlockSizeBytes) {
                      key = hasher.finalize(key);
                    }
  
                    // Clamp excess bits
                    key.clamp();
  
                    // Clone key for inner and outer pads
                    var oKey = (this._oKey = key.clone());
                    var iKey = (this._iKey = key.clone());
  
                    // Shortcuts
                    var oKeyWords = oKey.words;
                    var iKeyWords = iKey.words;
  
                    // XOR keys with pad constants
                    for (var i = 0; i < hasherBlockSize; i++) {
                      oKeyWords[i] ^= 0x5c5c5c5c;
                      iKeyWords[i] ^= 0x36363636;
                    }
                    oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
  
                    // Set initial values
                    this.reset();
                  },
  
                  /**
                   * Resets this HMAC to its initial state.
                   *
                   * @example
                   *
                   *     hmacHasher.reset();
                   */
                  reset: function () {
                    // Shortcut
                    var hasher = this._hasher;
  
                    // Reset
                    hasher.reset();
                    hasher.update(this._iKey);
                  },
  
                  /**
                   * Updates this HMAC with a message.
                   *
                   * @param {WordArray|string} messageUpdate The message to append.
                   *
                   * @return {HMAC} This HMAC instance.
                   *
                   * @example
                   *
                   *     hmacHasher.update('message');
                   *     hmacHasher.update(wordArray);
                   */
                  update: function (messageUpdate) {
                    this._hasher.update(messageUpdate);
  
                    // Chainable
                    return this;
                  },
  
                  /**
                   * Finalizes the HMAC computation.
                   * Note that the finalize operation is effectively a destructive, read-once operation.
                   *
                   * @param {WordArray|string} messageUpdate (Optional) A final message update.
                   *
                   * @return {WordArray} The HMAC.
                   *
                   * @example
                   *
                   *     var hmac = hmacHasher.finalize();
                   *     var hmac = hmacHasher.finalize('message');
                   *     var hmac = hmacHasher.finalize(wordArray);
                   */
                  finalize: function (messageUpdate) {
                    // Shortcut
                    var hasher = this._hasher;
  
                    // Compute HMAC
                    var innerHash = hasher.finalize(messageUpdate);
                    hasher.reset();
                    var hmac = hasher.finalize(
                      this._oKey.clone().concat(innerHash)
                    );
  
                    return hmac;
                  },
                }));
              })();
            });
          },
          { "./core": 196 },
        ],
        202: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./x64-core"),
                  require("./lib-typedarrays"),
                  require("./enc-utf16"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./sha1"),
                  require("./sha256"),
                  require("./sha224"),
                  require("./sha512"),
                  require("./sha384"),
                  require("./sha3"),
                  require("./ripemd160"),
                  require("./hmac"),
                  require("./pbkdf2"),
                  require("./evpkdf"),
                  require("./cipher-core"),
                  require("./mode-cfb"),
                  require("./mode-ctr"),
                  require("./mode-ctr-gladman"),
                  require("./mode-ofb"),
                  require("./mode-ecb"),
                  require("./pad-ansix923"),
                  require("./pad-iso10126"),
                  require("./pad-iso97971"),
                  require("./pad-zeropadding"),
                  require("./pad-nopadding"),
                  require("./format-hex"),
                  require("./aes"),
                  require("./tripledes"),
                  require("./rc4"),
                  require("./rabbit"),
                  require("./rabbit-legacy")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./x64-core",
                  "./lib-typedarrays",
                  "./enc-utf16",
                  "./enc-base64",
                  "./md5",
                  "./sha1",
                  "./sha256",
                  "./sha224",
                  "./sha512",
                  "./sha384",
                  "./sha3",
                  "./ripemd160",
                  "./hmac",
                  "./pbkdf2",
                  "./evpkdf",
                  "./cipher-core",
                  "./mode-cfb",
                  "./mode-ctr",
                  "./mode-ctr-gladman",
                  "./mode-ofb",
                  "./mode-ecb",
                  "./pad-ansix923",
                  "./pad-iso10126",
                  "./pad-iso97971",
                  "./pad-zeropadding",
                  "./pad-nopadding",
                  "./format-hex",
                  "./aes",
                  "./tripledes",
                  "./rc4",
                  "./rabbit",
                  "./rabbit-legacy",
                ], factory);
              } else {
                // Global (browser)
                root.CryptoJS = factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              return CryptoJS;
            });
          },
          {
            "./aes": 194,
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./enc-utf16": 198,
            "./evpkdf": 199,
            "./format-hex": 200,
            "./hmac": 201,
            "./lib-typedarrays": 203,
            "./md5": 204,
            "./mode-cfb": 205,
            "./mode-ctr": 207,
            "./mode-ctr-gladman": 206,
            "./mode-ecb": 208,
            "./mode-ofb": 209,
            "./pad-ansix923": 210,
            "./pad-iso10126": 211,
            "./pad-iso97971": 212,
            "./pad-nopadding": 213,
            "./pad-zeropadding": 214,
            "./pbkdf2": 215,
            "./rabbit": 217,
            "./rabbit-legacy": 216,
            "./rc4": 218,
            "./ripemd160": 219,
            "./sha1": 220,
            "./sha224": 221,
            "./sha256": 222,
            "./sha3": 223,
            "./sha384": 224,
            "./sha512": 225,
            "./tripledes": 226,
            "./x64-core": 227,
          },
        ],
        203: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Check if typed arrays are supported
                if (typeof ArrayBuffer != "function") {
                  return;
                }
  
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
  
                // Reference original init
                var superInit = WordArray.init;
  
                // Augment WordArray.init to handle typed arrays
                var subInit = (WordArray.init = function (typedArray) {
                  // Convert buffers to uint8
                  if (typedArray instanceof ArrayBuffer) {
                    typedArray = new Uint8Array(typedArray);
                  }
  
                  // Convert other array views to uint8
                  if (
                    typedArray instanceof Int8Array ||
                    (typeof Uint8ClampedArray !== "undefined" &&
                      typedArray instanceof Uint8ClampedArray) ||
                    typedArray instanceof Int16Array ||
                    typedArray instanceof Uint16Array ||
                    typedArray instanceof Int32Array ||
                    typedArray instanceof Uint32Array ||
                    typedArray instanceof Float32Array ||
                    typedArray instanceof Float64Array
                  ) {
                    typedArray = new Uint8Array(
                      typedArray.buffer,
                      typedArray.byteOffset,
                      typedArray.byteLength
                    );
                  }
  
                  // Handle Uint8Array
                  if (typedArray instanceof Uint8Array) {
                    // Shortcut
                    var typedArrayByteLength = typedArray.byteLength;
  
                    // Extract bytes
                    var words = [];
                    for (var i = 0; i < typedArrayByteLength; i++) {
                      words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
                    }
  
                    // Initialize this word array
                    superInit.call(this, words, typedArrayByteLength);
                  } else {
                    // Else call normal init
                    superInit.apply(this, arguments);
                  }
                });
  
                subInit.prototype = WordArray;
              })();
  
              return CryptoJS.lib.WordArray;
            });
          },
          { "./core": 196 },
        ],
        204: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function (Math) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var Hasher = C_lib.Hasher;
                var C_algo = C.algo;
  
                // Constants table
                var T = [];
  
                // Compute constants
                (function () {
                  for (var i = 0; i < 64; i++) {
                    T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
                  }
                })();
  
                /**
                 * MD5 hash algorithm.
                 */
                var MD5 = (C_algo.MD5 = Hasher.extend({
                  _doReset: function () {
                    this._hash = new WordArray.init([
                      0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476,
                    ]);
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Swap endian
                    for (var i = 0; i < 16; i++) {
                      // Shortcuts
                      var offset_i = offset + i;
                      var M_offset_i = M[offset_i];
  
                      M[offset_i] =
                        (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
                        (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00);
                    }
  
                    // Shortcuts
                    var H = this._hash.words;
  
                    var M_offset_0 = M[offset + 0];
                    var M_offset_1 = M[offset + 1];
                    var M_offset_2 = M[offset + 2];
                    var M_offset_3 = M[offset + 3];
                    var M_offset_4 = M[offset + 4];
                    var M_offset_5 = M[offset + 5];
                    var M_offset_6 = M[offset + 6];
                    var M_offset_7 = M[offset + 7];
                    var M_offset_8 = M[offset + 8];
                    var M_offset_9 = M[offset + 9];
                    var M_offset_10 = M[offset + 10];
                    var M_offset_11 = M[offset + 11];
                    var M_offset_12 = M[offset + 12];
                    var M_offset_13 = M[offset + 13];
                    var M_offset_14 = M[offset + 14];
                    var M_offset_15 = M[offset + 15];
  
                    // Working varialbes
                    var a = H[0];
                    var b = H[1];
                    var c = H[2];
                    var d = H[3];
  
                    // Computation
                    a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                    d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                    c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                    b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                    a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                    d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                    c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                    b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                    a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                    d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                    c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                    b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                    a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                    d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                    c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                    b = FF(b, c, d, a, M_offset_15, 22, T[15]);
  
                    a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                    d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                    c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                    b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                    a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                    d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                    c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                    b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                    a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                    d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                    c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                    b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                    a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                    d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                    c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                    b = GG(b, c, d, a, M_offset_12, 20, T[31]);
  
                    a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                    d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                    c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                    b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                    a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                    d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                    c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                    b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                    a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                    d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                    c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                    b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                    a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                    d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                    c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                    b = HH(b, c, d, a, M_offset_2, 23, T[47]);
  
                    a = II(a, b, c, d, M_offset_0, 6, T[48]);
                    d = II(d, a, b, c, M_offset_7, 10, T[49]);
                    c = II(c, d, a, b, M_offset_14, 15, T[50]);
                    b = II(b, c, d, a, M_offset_5, 21, T[51]);
                    a = II(a, b, c, d, M_offset_12, 6, T[52]);
                    d = II(d, a, b, c, M_offset_3, 10, T[53]);
                    c = II(c, d, a, b, M_offset_10, 15, T[54]);
                    b = II(b, c, d, a, M_offset_1, 21, T[55]);
                    a = II(a, b, c, d, M_offset_8, 6, T[56]);
                    d = II(d, a, b, c, M_offset_15, 10, T[57]);
                    c = II(c, d, a, b, M_offset_6, 15, T[58]);
                    b = II(b, c, d, a, M_offset_13, 21, T[59]);
                    a = II(a, b, c, d, M_offset_4, 6, T[60]);
                    d = II(d, a, b, c, M_offset_11, 10, T[61]);
                    c = II(c, d, a, b, M_offset_2, 15, T[62]);
                    b = II(b, c, d, a, M_offset_9, 21, T[63]);
  
                    // Intermediate hash value
                    H[0] = (H[0] + a) | 0;
                    H[1] = (H[1] + b) | 0;
                    H[2] = (H[2] + c) | 0;
                    H[3] = (H[3] + d) | 0;
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
  
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - (nBitsLeft % 32));
  
                    var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
                    var nBitsTotalL = nBitsTotal;
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] =
                      (((nBitsTotalH << 8) | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
                      (((nBitsTotalH << 24) | (nBitsTotalH >>> 8)) & 0xff00ff00);
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] =
                      (((nBitsTotalL << 8) | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
                      (((nBitsTotalL << 24) | (nBitsTotalL >>> 8)) & 0xff00ff00);
  
                    data.sigBytes = (dataWords.length + 1) * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Shortcuts
                    var hash = this._hash;
                    var H = hash.words;
  
                    // Swap endian
                    for (var i = 0; i < 4; i++) {
                      // Shortcut
                      var H_i = H[i];
  
                      H[i] =
                        (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
                        (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00);
                    }
  
                    // Return final computed hash
                    return hash;
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
                    clone._hash = this._hash.clone();
  
                    return clone;
                  },
                }));
  
                function FF(a, b, c, d, x, s, t) {
                  var n = a + ((b & c) | (~b & d)) + x + t;
                  return ((n << s) | (n >>> (32 - s))) + b;
                }
  
                function GG(a, b, c, d, x, s, t) {
                  var n = a + ((b & d) | (c & ~d)) + x + t;
                  return ((n << s) | (n >>> (32 - s))) + b;
                }
  
                function HH(a, b, c, d, x, s, t) {
                  var n = a + (b ^ c ^ d) + x + t;
                  return ((n << s) | (n >>> (32 - s))) + b;
                }
  
                function II(a, b, c, d, x, s, t) {
                  var n = a + (c ^ (b | ~d)) + x + t;
                  return ((n << s) | (n >>> (32 - s))) + b;
                }
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.MD5('message');
                 *     var hash = CryptoJS.MD5(wordArray);
                 */
                C.MD5 = Hasher._createHelper(MD5);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacMD5(message, key);
                 */
                C.HmacMD5 = Hasher._createHmacHelper(MD5);
              })(Math);
  
              return CryptoJS.MD5;
            });
          },
          { "./core": 196 },
        ],
        205: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Cipher Feedback block mode.
               */
              CryptoJS.mode.CFB = (function () {
                var CFB = CryptoJS.lib.BlockCipherMode.extend();
  
                CFB.Encryptor = CFB.extend({
                  processBlock: function (words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
  
                    generateKeystreamAndEncrypt.call(
                      this,
                      words,
                      offset,
                      blockSize,
                      cipher
                    );
  
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                  },
                });
  
                CFB.Decryptor = CFB.extend({
                  processBlock: function (words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
  
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
  
                    generateKeystreamAndEncrypt.call(
                      this,
                      words,
                      offset,
                      blockSize,
                      cipher
                    );
  
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                  },
                });
  
                function generateKeystreamAndEncrypt(
                  words,
                  offset,
                  blockSize,
                  cipher
                ) {
                  var keystream;
  
                  // Shortcut
                  var iv = this._iv;
  
                  // Generate keystream
                  if (iv) {
                    keystream = iv.slice(0);
  
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                  } else {
                    keystream = this._prevBlock;
                  }
                  cipher.encryptBlock(keystream, 0);
  
                  // Encrypt
                  for (var i = 0; i < blockSize; i++) {
                    words[offset + i] ^= keystream[i];
                  }
                }
  
                return CFB;
              })();
  
              return CryptoJS.mode.CFB;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        206: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /** @preserve
               * Counter block mode compatible with  Dr Brian Gladman fileenc.c
               * derived from CryptoJS.mode.CTR
               * Jan Hruby jhruby.web@gmail.com
               */
              CryptoJS.mode.CTRGladman = (function () {
                var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
  
                function incWord(word) {
                  if (((word >> 24) & 0xff) === 0xff) {
                    //overflow
                    var b1 = (word >> 16) & 0xff;
                    var b2 = (word >> 8) & 0xff;
                    var b3 = word & 0xff;
  
                    if (b1 === 0xff) {
                      // overflow b1
                      b1 = 0;
                      if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) {
                          b3 = 0;
                        } else {
                          ++b3;
                        }
                      } else {
                        ++b2;
                      }
                    } else {
                      ++b1;
                    }
  
                    word = 0;
                    word += b1 << 16;
                    word += b2 << 8;
                    word += b3;
                  } else {
                    word += 0x01 << 24;
                  }
                  return word;
                }
  
                function incCounter(counter) {
                  if ((counter[0] = incWord(counter[0])) === 0) {
                    // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
                    counter[1] = incWord(counter[1]);
                  }
                  return counter;
                }
  
                var Encryptor = (CTRGladman.Encryptor = CTRGladman.extend({
                  processBlock: function (words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    var iv = this._iv;
                    var counter = this._counter;
  
                    // Generate keystream
                    if (iv) {
                      counter = this._counter = iv.slice(0);
  
                      // Remove IV for subsequent blocks
                      this._iv = undefined;
                    }
  
                    incCounter(counter);
  
                    var keystream = counter.slice(0);
                    cipher.encryptBlock(keystream, 0);
  
                    // Encrypt
                    for (var i = 0; i < blockSize; i++) {
                      words[offset + i] ^= keystream[i];
                    }
                  },
                }));
  
                CTRGladman.Decryptor = Encryptor;
  
                return CTRGladman;
              })();
  
              return CryptoJS.mode.CTRGladman;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        207: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Counter block mode.
               */
              CryptoJS.mode.CTR = (function () {
                var CTR = CryptoJS.lib.BlockCipherMode.extend();
  
                var Encryptor = (CTR.Encryptor = CTR.extend({
                  processBlock: function (words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    var iv = this._iv;
                    var counter = this._counter;
  
                    // Generate keystream
                    if (iv) {
                      counter = this._counter = iv.slice(0);
  
                      // Remove IV for subsequent blocks
                      this._iv = undefined;
                    }
                    var keystream = counter.slice(0);
                    cipher.encryptBlock(keystream, 0);
  
                    // Increment counter
                    counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0;
  
                    // Encrypt
                    for (var i = 0; i < blockSize; i++) {
                      words[offset + i] ^= keystream[i];
                    }
                  },
                }));
  
                CTR.Decryptor = Encryptor;
  
                return CTR;
              })();
  
              return CryptoJS.mode.CTR;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        208: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Electronic Codebook block mode.
               */
              CryptoJS.mode.ECB = (function () {
                var ECB = CryptoJS.lib.BlockCipherMode.extend();
  
                ECB.Encryptor = ECB.extend({
                  processBlock: function (words, offset) {
                    this._cipher.encryptBlock(words, offset);
                  },
                });
  
                ECB.Decryptor = ECB.extend({
                  processBlock: function (words, offset) {
                    this._cipher.decryptBlock(words, offset);
                  },
                });
  
                return ECB;
              })();
  
              return CryptoJS.mode.ECB;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        209: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Output Feedback block mode.
               */
              CryptoJS.mode.OFB = (function () {
                var OFB = CryptoJS.lib.BlockCipherMode.extend();
  
                var Encryptor = (OFB.Encryptor = OFB.extend({
                  processBlock: function (words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    var iv = this._iv;
                    var keystream = this._keystream;
  
                    // Generate keystream
                    if (iv) {
                      keystream = this._keystream = iv.slice(0);
  
                      // Remove IV for subsequent blocks
                      this._iv = undefined;
                    }
                    cipher.encryptBlock(keystream, 0);
  
                    // Encrypt
                    for (var i = 0; i < blockSize; i++) {
                      words[offset + i] ^= keystream[i];
                    }
                  },
                }));
  
                OFB.Decryptor = Encryptor;
  
                return OFB;
              })();
  
              return CryptoJS.mode.OFB;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        210: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * ANSI X.923 padding strategy.
               */
              CryptoJS.pad.AnsiX923 = {
                pad: function (data, blockSize) {
                  // Shortcuts
                  var dataSigBytes = data.sigBytes;
                  var blockSizeBytes = blockSize * 4;
  
                  // Count padding bytes
                  var nPaddingBytes =
                    blockSizeBytes - (dataSigBytes % blockSizeBytes);
  
                  // Compute last byte position
                  var lastBytePos = dataSigBytes + nPaddingBytes - 1;
  
                  // Pad
                  data.clamp();
                  data.words[lastBytePos >>> 2] |=
                    nPaddingBytes << (24 - (lastBytePos % 4) * 8);
                  data.sigBytes += nPaddingBytes;
                },
  
                unpad: function (data) {
                  // Get number of padding bytes from last byte
                  var nPaddingBytes =
                    data.words[(data.sigBytes - 1) >>> 2] & 0xff;
  
                  // Remove padding
                  data.sigBytes -= nPaddingBytes;
                },
              };
  
              return CryptoJS.pad.Ansix923;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        211: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * ISO 10126 padding strategy.
               */
              CryptoJS.pad.Iso10126 = {
                pad: function (data, blockSize) {
                  // Shortcut
                  var blockSizeBytes = blockSize * 4;
  
                  // Count padding bytes
                  var nPaddingBytes =
                    blockSizeBytes - (data.sigBytes % blockSizeBytes);
  
                  // Pad
                  data
                    .concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1))
                    .concat(
                      CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1)
                    );
                },
  
                unpad: function (data) {
                  // Get number of padding bytes from last byte
                  var nPaddingBytes =
                    data.words[(data.sigBytes - 1) >>> 2] & 0xff;
  
                  // Remove padding
                  data.sigBytes -= nPaddingBytes;
                },
              };
  
              return CryptoJS.pad.Iso10126;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        212: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * ISO/IEC 9797-1 Padding Method 2.
               */
              CryptoJS.pad.Iso97971 = {
                pad: function (data, blockSize) {
                  // Add 0x80 byte
                  data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
  
                  // Zero pad the rest
                  CryptoJS.pad.ZeroPadding.pad(data, blockSize);
                },
  
                unpad: function (data) {
                  // Remove zero padding
                  CryptoJS.pad.ZeroPadding.unpad(data);
  
                  // Remove one more byte -- the 0x80 byte
                  data.sigBytes--;
                },
              };
  
              return CryptoJS.pad.Iso97971;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        213: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * A noop padding strategy.
               */
              CryptoJS.pad.NoPadding = {
                pad: function () {},
  
                unpad: function () {},
              };
  
              return CryptoJS.pad.NoPadding;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        214: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./cipher-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /**
               * Zero padding strategy.
               */
              CryptoJS.pad.ZeroPadding = {
                pad: function (data, blockSize) {
                  // Shortcut
                  var blockSizeBytes = blockSize * 4;
  
                  // Pad
                  data.clamp();
                  data.sigBytes +=
                    blockSizeBytes -
                    (data.sigBytes % blockSizeBytes || blockSizeBytes);
                },
  
                unpad: function (data) {
                  // Shortcut
                  var dataWords = data.words;
  
                  // Unpad
                  var i = data.sigBytes - 1;
                  for (var i = data.sigBytes - 1; i >= 0; i--) {
                    if ((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff) {
                      data.sigBytes = i + 1;
                      break;
                    }
                  }
                },
              };
  
              return CryptoJS.pad.ZeroPadding;
            });
          },
          { "./cipher-core": 195, "./core": 196 },
        ],
        215: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./sha1"),
                  require("./hmac")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./sha1", "./hmac"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var Base = C_lib.Base;
                var WordArray = C_lib.WordArray;
                var C_algo = C.algo;
                var SHA1 = C_algo.SHA1;
                var HMAC = C_algo.HMAC;
  
                /**
                 * Password-Based Key Derivation Function 2 algorithm.
                 */
                var PBKDF2 = (C_algo.PBKDF2 = Base.extend({
                  /**
                   * Configuration options.
                   *
                   * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
                   * @property {Hasher} hasher The hasher to use. Default: SHA1
                   * @property {number} iterations The number of iterations to perform. Default: 1
                   */
                  cfg: Base.extend({
                    keySize: 128 / 32,
                    hasher: SHA1,
                    iterations: 1,
                  }),
  
                  /**
                   * Initializes a newly created key derivation function.
                   *
                   * @param {Object} cfg (Optional) The configuration options to use for the derivation.
                   *
                   * @example
                   *
                   *     var kdf = CryptoJS.algo.PBKDF2.create();
                   *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
                   *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
                   */
                  init: function (cfg) {
                    this.cfg = this.cfg.extend(cfg);
                  },
  
                  /**
                   * Computes the Password-Based Key Derivation Function 2.
                   *
                   * @param {WordArray|string} password The password.
                   * @param {WordArray|string} salt A salt.
                   *
                   * @return {WordArray} The derived key.
                   *
                   * @example
                   *
                   *     var key = kdf.compute(password, salt);
                   */
                  compute: function (password, salt) {
                    // Shortcut
                    var cfg = this.cfg;
  
                    // Init HMAC
                    var hmac = HMAC.create(cfg.hasher, password);
  
                    // Initial values
                    var derivedKey = WordArray.create();
                    var blockIndex = WordArray.create([0x00000001]);
  
                    // Shortcuts
                    var derivedKeyWords = derivedKey.words;
                    var blockIndexWords = blockIndex.words;
                    var keySize = cfg.keySize;
                    var iterations = cfg.iterations;
  
                    // Generate key
                    while (derivedKeyWords.length < keySize) {
                      var block = hmac.update(salt).finalize(blockIndex);
                      hmac.reset();
  
                      // Shortcuts
                      var blockWords = block.words;
                      var blockWordsLength = blockWords.length;
  
                      // Iterations
                      var intermediate = block;
                      for (var i = 1; i < iterations; i++) {
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
  
                        // Shortcut
                        var intermediateWords = intermediate.words;
  
                        // XOR intermediate with block
                        for (var j = 0; j < blockWordsLength; j++) {
                          blockWords[j] ^= intermediateWords[j];
                        }
                      }
  
                      derivedKey.concat(block);
                      blockIndexWords[0]++;
                    }
                    derivedKey.sigBytes = keySize * 4;
  
                    return derivedKey;
                  },
                }));
  
                /**
                 * Computes the Password-Based Key Derivation Function 2.
                 *
                 * @param {WordArray|string} password The password.
                 * @param {WordArray|string} salt A salt.
                 * @param {Object} cfg (Optional) The configuration options to use for this computation.
                 *
                 * @return {WordArray} The derived key.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var key = CryptoJS.PBKDF2(password, salt);
                 *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
                 *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
                 */
                C.PBKDF2 = function (password, salt, cfg) {
                  return PBKDF2.create(cfg).compute(password, salt);
                };
              })();
  
              return CryptoJS.PBKDF2;
            });
          },
          { "./core": 196, "./hmac": 201, "./sha1": 220 },
        ],
        216: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./evpkdf"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./enc-base64",
                  "./md5",
                  "./evpkdf",
                  "./cipher-core",
                ], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var StreamCipher = C_lib.StreamCipher;
                var C_algo = C.algo;
  
                // Reusable objects
                var S = [];
                var C_ = [];
                var G = [];
  
                /**
                 * Rabbit stream cipher algorithm.
                 *
                 * This is a legacy version that neglected to convert the key to little-endian.
                 * This error doesn't affect the cipher's security,
                 * but it does affect its compatibility with other implementations.
                 */
                var RabbitLegacy = (C_algo.RabbitLegacy = StreamCipher.extend({
                  _doReset: function () {
                    // Shortcuts
                    var K = this._key.words;
                    var iv = this.cfg.iv;
  
                    // Generate initial state values
                    var X = (this._X = [
                      K[0],
                      (K[3] << 16) | (K[2] >>> 16),
                      K[1],
                      (K[0] << 16) | (K[3] >>> 16),
                      K[2],
                      (K[1] << 16) | (K[0] >>> 16),
                      K[3],
                      (K[2] << 16) | (K[1] >>> 16),
                    ]);
  
                    // Generate initial counter values
                    var C = (this._C = [
                      (K[2] << 16) | (K[2] >>> 16),
                      (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
                      (K[3] << 16) | (K[3] >>> 16),
                      (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
                      (K[0] << 16) | (K[0] >>> 16),
                      (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
                      (K[1] << 16) | (K[1] >>> 16),
                      (K[3] & 0xffff0000) | (K[0] & 0x0000ffff),
                    ]);
  
                    // Carry bit
                    this._b = 0;
  
                    // Iterate the system four times
                    for (var i = 0; i < 4; i++) {
                      nextState.call(this);
                    }
  
                    // Modify the counters
                    for (var i = 0; i < 8; i++) {
                      C[i] ^= X[(i + 4) & 7];
                    }
  
                    // IV setup
                    if (iv) {
                      // Shortcuts
                      var IV = iv.words;
                      var IV_0 = IV[0];
                      var IV_1 = IV[1];
  
                      // Generate four subvectors
                      var i0 =
                        (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) |
                        (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
                      var i2 =
                        (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) |
                        (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
                      var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
                      var i3 = (i2 << 16) | (i0 & 0x0000ffff);
  
                      // Modify counter values
                      C[0] ^= i0;
                      C[1] ^= i1;
                      C[2] ^= i2;
                      C[3] ^= i3;
                      C[4] ^= i0;
                      C[5] ^= i1;
                      C[6] ^= i2;
                      C[7] ^= i3;
  
                      // Iterate the system four times
                      for (var i = 0; i < 4; i++) {
                        nextState.call(this);
                      }
                    }
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcut
                    var X = this._X;
  
                    // Iterate the system
                    nextState.call(this);
  
                    // Generate four keystream words
                    S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
                    S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
                    S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
                    S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
  
                    for (var i = 0; i < 4; i++) {
                      // Swap endian
                      S[i] =
                        (((S[i] << 8) | (S[i] >>> 24)) & 0x00ff00ff) |
                        (((S[i] << 24) | (S[i] >>> 8)) & 0xff00ff00);
  
                      // Encrypt
                      M[offset + i] ^= S[i];
                    }
                  },
  
                  blockSize: 128 / 32,
  
                  ivSize: 64 / 32,
                }));
  
                function nextState() {
                  // Shortcuts
                  var X = this._X;
                  var C = this._C;
  
                  // Save old counter values
                  for (var i = 0; i < 8; i++) {
                    C_[i] = C[i];
                  }
  
                  // Calculate new counter values
                  C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
                  C[1] =
                    (C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0)) | 0;
                  C[2] =
                    (C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0)) | 0;
                  C[3] =
                    (C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0)) | 0;
                  C[4] =
                    (C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0)) | 0;
                  C[5] =
                    (C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0)) | 0;
                  C[6] =
                    (C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0)) | 0;
                  C[7] =
                    (C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0)) | 0;
                  this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
  
                  // Calculate the g-values
                  for (var i = 0; i < 8; i++) {
                    var gx = X[i] + C[i];
  
                    // Construct high and low argument for squaring
                    var ga = gx & 0xffff;
                    var gb = gx >>> 16;
  
                    // Calculate high and low result of squaring
                    var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
                    var gl =
                      (((gx & 0xffff0000) * gx) | 0) +
                      (((gx & 0x0000ffff) * gx) | 0);
  
                    // High XOR low
                    G[i] = gh ^ gl;
                  }
  
                  // Calculate new state values
                  X[0] =
                    (G[0] +
                      ((G[7] << 16) | (G[7] >>> 16)) +
                      ((G[6] << 16) | (G[6] >>> 16))) |
                    0;
                  X[1] = (G[1] + ((G[0] << 8) | (G[0] >>> 24)) + G[7]) | 0;
                  X[2] =
                    (G[2] +
                      ((G[1] << 16) | (G[1] >>> 16)) +
                      ((G[0] << 16) | (G[0] >>> 16))) |
                    0;
                  X[3] = (G[3] + ((G[2] << 8) | (G[2] >>> 24)) + G[1]) | 0;
                  X[4] =
                    (G[4] +
                      ((G[3] << 16) | (G[3] >>> 16)) +
                      ((G[2] << 16) | (G[2] >>> 16))) |
                    0;
                  X[5] = (G[5] + ((G[4] << 8) | (G[4] >>> 24)) + G[3]) | 0;
                  X[6] =
                    (G[6] +
                      ((G[5] << 16) | (G[5] >>> 16)) +
                      ((G[4] << 16) | (G[4] >>> 16))) |
                    0;
                  X[7] = (G[7] + ((G[6] << 8) | (G[6] >>> 24)) + G[5]) | 0;
                }
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
                 */
                C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
              })();
  
              return CryptoJS.RabbitLegacy;
            });
          },
          {
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./evpkdf": 199,
            "./md5": 204,
          },
        ],
        217: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./evpkdf"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./enc-base64",
                  "./md5",
                  "./evpkdf",
                  "./cipher-core",
                ], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var StreamCipher = C_lib.StreamCipher;
                var C_algo = C.algo;
  
                // Reusable objects
                var S = [];
                var C_ = [];
                var G = [];
  
                /**
                 * Rabbit stream cipher algorithm
                 */
                var Rabbit = (C_algo.Rabbit = StreamCipher.extend({
                  _doReset: function () {
                    // Shortcuts
                    var K = this._key.words;
                    var iv = this.cfg.iv;
  
                    // Swap endian
                    for (var i = 0; i < 4; i++) {
                      K[i] =
                        (((K[i] << 8) | (K[i] >>> 24)) & 0x00ff00ff) |
                        (((K[i] << 24) | (K[i] >>> 8)) & 0xff00ff00);
                    }
  
                    // Generate initial state values
                    var X = (this._X = [
                      K[0],
                      (K[3] << 16) | (K[2] >>> 16),
                      K[1],
                      (K[0] << 16) | (K[3] >>> 16),
                      K[2],
                      (K[1] << 16) | (K[0] >>> 16),
                      K[3],
                      (K[2] << 16) | (K[1] >>> 16),
                    ]);
  
                    // Generate initial counter values
                    var C = (this._C = [
                      (K[2] << 16) | (K[2] >>> 16),
                      (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
                      (K[3] << 16) | (K[3] >>> 16),
                      (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
                      (K[0] << 16) | (K[0] >>> 16),
                      (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
                      (K[1] << 16) | (K[1] >>> 16),
                      (K[3] & 0xffff0000) | (K[0] & 0x0000ffff),
                    ]);
  
                    // Carry bit
                    this._b = 0;
  
                    // Iterate the system four times
                    for (var i = 0; i < 4; i++) {
                      nextState.call(this);
                    }
  
                    // Modify the counters
                    for (var i = 0; i < 8; i++) {
                      C[i] ^= X[(i + 4) & 7];
                    }
  
                    // IV setup
                    if (iv) {
                      // Shortcuts
                      var IV = iv.words;
                      var IV_0 = IV[0];
                      var IV_1 = IV[1];
  
                      // Generate four subvectors
                      var i0 =
                        (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) |
                        (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
                      var i2 =
                        (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) |
                        (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
                      var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
                      var i3 = (i2 << 16) | (i0 & 0x0000ffff);
  
                      // Modify counter values
                      C[0] ^= i0;
                      C[1] ^= i1;
                      C[2] ^= i2;
                      C[3] ^= i3;
                      C[4] ^= i0;
                      C[5] ^= i1;
                      C[6] ^= i2;
                      C[7] ^= i3;
  
                      // Iterate the system four times
                      for (var i = 0; i < 4; i++) {
                        nextState.call(this);
                      }
                    }
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcut
                    var X = this._X;
  
                    // Iterate the system
                    nextState.call(this);
  
                    // Generate four keystream words
                    S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
                    S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
                    S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
                    S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
  
                    for (var i = 0; i < 4; i++) {
                      // Swap endian
                      S[i] =
                        (((S[i] << 8) | (S[i] >>> 24)) & 0x00ff00ff) |
                        (((S[i] << 24) | (S[i] >>> 8)) & 0xff00ff00);
  
                      // Encrypt
                      M[offset + i] ^= S[i];
                    }
                  },
  
                  blockSize: 128 / 32,
  
                  ivSize: 64 / 32,
                }));
  
                function nextState() {
                  // Shortcuts
                  var X = this._X;
                  var C = this._C;
  
                  // Save old counter values
                  for (var i = 0; i < 8; i++) {
                    C_[i] = C[i];
                  }
  
                  // Calculate new counter values
                  C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
                  C[1] =
                    (C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0)) | 0;
                  C[2] =
                    (C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0)) | 0;
                  C[3] =
                    (C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0)) | 0;
                  C[4] =
                    (C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0)) | 0;
                  C[5] =
                    (C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0)) | 0;
                  C[6] =
                    (C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0)) | 0;
                  C[7] =
                    (C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0)) | 0;
                  this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
  
                  // Calculate the g-values
                  for (var i = 0; i < 8; i++) {
                    var gx = X[i] + C[i];
  
                    // Construct high and low argument for squaring
                    var ga = gx & 0xffff;
                    var gb = gx >>> 16;
  
                    // Calculate high and low result of squaring
                    var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
                    var gl =
                      (((gx & 0xffff0000) * gx) | 0) +
                      (((gx & 0x0000ffff) * gx) | 0);
  
                    // High XOR low
                    G[i] = gh ^ gl;
                  }
  
                  // Calculate new state values
                  X[0] =
                    (G[0] +
                      ((G[7] << 16) | (G[7] >>> 16)) +
                      ((G[6] << 16) | (G[6] >>> 16))) |
                    0;
                  X[1] = (G[1] + ((G[0] << 8) | (G[0] >>> 24)) + G[7]) | 0;
                  X[2] =
                    (G[2] +
                      ((G[1] << 16) | (G[1] >>> 16)) +
                      ((G[0] << 16) | (G[0] >>> 16))) |
                    0;
                  X[3] = (G[3] + ((G[2] << 8) | (G[2] >>> 24)) + G[1]) | 0;
                  X[4] =
                    (G[4] +
                      ((G[3] << 16) | (G[3] >>> 16)) +
                      ((G[2] << 16) | (G[2] >>> 16))) |
                    0;
                  X[5] = (G[5] + ((G[4] << 8) | (G[4] >>> 24)) + G[3]) | 0;
                  X[6] =
                    (G[6] +
                      ((G[5] << 16) | (G[5] >>> 16)) +
                      ((G[4] << 16) | (G[4] >>> 16))) |
                    0;
                  X[7] = (G[7] + ((G[6] << 8) | (G[6] >>> 24)) + G[5]) | 0;
                }
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
                 */
                C.Rabbit = StreamCipher._createHelper(Rabbit);
              })();
  
              return CryptoJS.Rabbit;
            });
          },
          {
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./evpkdf": 199,
            "./md5": 204,
          },
        ],
        218: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./evpkdf"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./enc-base64",
                  "./md5",
                  "./evpkdf",
                  "./cipher-core",
                ], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var StreamCipher = C_lib.StreamCipher;
                var C_algo = C.algo;
  
                /**
                 * RC4 stream cipher algorithm.
                 */
                var RC4 = (C_algo.RC4 = StreamCipher.extend({
                  _doReset: function () {
                    // Shortcuts
                    var key = this._key;
                    var keyWords = key.words;
                    var keySigBytes = key.sigBytes;
  
                    // Init sbox
                    var S = (this._S = []);
                    for (var i = 0; i < 256; i++) {
                      S[i] = i;
                    }
  
                    // Key setup
                    for (var i = 0, j = 0; i < 256; i++) {
                      var keyByteIndex = i % keySigBytes;
                      var keyByte =
                        (keyWords[keyByteIndex >>> 2] >>>
                          (24 - (keyByteIndex % 4) * 8)) &
                        0xff;
  
                      j = (j + S[i] + keyByte) % 256;
  
                      // Swap
                      var t = S[i];
                      S[i] = S[j];
                      S[j] = t;
                    }
  
                    // Counters
                    this._i = this._j = 0;
                  },
  
                  _doProcessBlock: function (M, offset) {
                    M[offset] ^= generateKeystreamWord.call(this);
                  },
  
                  keySize: 256 / 32,
  
                  ivSize: 0,
                }));
  
                function generateKeystreamWord() {
                  // Shortcuts
                  var S = this._S;
                  var i = this._i;
                  var j = this._j;
  
                  // Generate keystream word
                  var keystreamWord = 0;
                  for (var n = 0; n < 4; n++) {
                    i = (i + 1) % 256;
                    j = (j + S[i]) % 256;
  
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
  
                    keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
                  }
  
                  // Update counters
                  this._i = i;
                  this._j = j;
  
                  return keystreamWord;
                }
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
                 */
                C.RC4 = StreamCipher._createHelper(RC4);
  
                /**
                 * Modified RC4 stream cipher algorithm.
                 */
                var RC4Drop = (C_algo.RC4Drop = RC4.extend({
                  /**
                   * Configuration options.
                   *
                   * @property {number} drop The number of keystream words to drop. Default 192
                   */
                  cfg: RC4.cfg.extend({
                    drop: 192,
                  }),
  
                  _doReset: function () {
                    RC4._doReset.call(this);
  
                    // Drop
                    for (var i = this.cfg.drop; i > 0; i--) {
                      generateKeystreamWord.call(this);
                    }
                  },
                }));
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
                 */
                C.RC4Drop = StreamCipher._createHelper(RC4Drop);
              })();
  
              return CryptoJS.RC4;
            });
          },
          {
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./evpkdf": 199,
            "./md5": 204,
          },
        ],
        219: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              /** @preserve
      (c) 2012 by Cédric Mesnil. All rights reserved.
  
      Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
  
          - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
          - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
  
      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      */
  
              (function (Math) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var Hasher = C_lib.Hasher;
                var C_algo = C.algo;
  
                // Constants table
                var _zl = WordArray.create([
                  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13,
                  1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15,
                  8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13,
                  3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8,
                  11, 6, 15, 13,
                ]);
                var _zr = WordArray.create([
                  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3,
                  7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14,
                  6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5,
                  12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13,
                  14, 0, 3, 9, 11,
                ]);
                var _sl = WordArray.create([
                  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8,
                  13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12, 11, 13, 6, 7, 14,
                  9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14, 15, 9,
                  8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12,
                  13, 14, 11, 8, 5, 6,
                ]);
                var _sr = WordArray.create([
                  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13,
                  15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11,
                  8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14,
                  6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8,
                  13, 6, 5, 15, 13, 11, 11,
                ]);
  
                var _hl = WordArray.create([
                  0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e,
                ]);
                var _hr = WordArray.create([
                  0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000,
                ]);
  
                /**
                 * RIPEMD160 hash algorithm.
                 */
                var RIPEMD160 = (C_algo.RIPEMD160 = Hasher.extend({
                  _doReset: function () {
                    this._hash = WordArray.create([
                      0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0,
                    ]);
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Swap endian
                    for (var i = 0; i < 16; i++) {
                      // Shortcuts
                      var offset_i = offset + i;
                      var M_offset_i = M[offset_i];
  
                      // Swap
                      M[offset_i] =
                        (((M_offset_i << 8) | (M_offset_i >>> 24)) & 0x00ff00ff) |
                        (((M_offset_i << 24) | (M_offset_i >>> 8)) & 0xff00ff00);
                    }
                    // Shortcut
                    var H = this._hash.words;
                    var hl = _hl.words;
                    var hr = _hr.words;
                    var zl = _zl.words;
                    var zr = _zr.words;
                    var sl = _sl.words;
                    var sr = _sr.words;
  
                    // Working variables
                    var al, bl, cl, dl, el;
                    var ar, br, cr, dr, er;
  
                    ar = al = H[0];
                    br = bl = H[1];
                    cr = cl = H[2];
                    dr = dl = H[3];
                    er = el = H[4];
                    // Computation
                    var t;
                    for (var i = 0; i < 80; i += 1) {
                      t = (al + M[offset + zl[i]]) | 0;
                      if (i < 16) {
                        t += f1(bl, cl, dl) + hl[0];
                      } else if (i < 32) {
                        t += f2(bl, cl, dl) + hl[1];
                      } else if (i < 48) {
                        t += f3(bl, cl, dl) + hl[2];
                      } else if (i < 64) {
                        t += f4(bl, cl, dl) + hl[3];
                      } else {
                        // if (i<80) {
                        t += f5(bl, cl, dl) + hl[4];
                      }
                      t = t | 0;
                      t = rotl(t, sl[i]);
                      t = (t + el) | 0;
                      al = el;
                      el = dl;
                      dl = rotl(cl, 10);
                      cl = bl;
                      bl = t;
  
                      t = (ar + M[offset + zr[i]]) | 0;
                      if (i < 16) {
                        t += f5(br, cr, dr) + hr[0];
                      } else if (i < 32) {
                        t += f4(br, cr, dr) + hr[1];
                      } else if (i < 48) {
                        t += f3(br, cr, dr) + hr[2];
                      } else if (i < 64) {
                        t += f2(br, cr, dr) + hr[3];
                      } else {
                        // if (i<80) {
                        t += f1(br, cr, dr) + hr[4];
                      }
                      t = t | 0;
                      t = rotl(t, sr[i]);
                      t = (t + er) | 0;
                      ar = er;
                      er = dr;
                      dr = rotl(cr, 10);
                      cr = br;
                      br = t;
                    }
                    // Intermediate hash value
                    t = (H[1] + cl + dr) | 0;
                    H[1] = (H[2] + dl + er) | 0;
                    H[2] = (H[3] + el + ar) | 0;
                    H[3] = (H[4] + al + br) | 0;
                    H[4] = (H[0] + bl + cr) | 0;
                    H[0] = t;
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
  
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - (nBitsLeft % 32));
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] =
                      (((nBitsTotal << 8) | (nBitsTotal >>> 24)) & 0x00ff00ff) |
                      (((nBitsTotal << 24) | (nBitsTotal >>> 8)) & 0xff00ff00);
                    data.sigBytes = (dataWords.length + 1) * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Shortcuts
                    var hash = this._hash;
                    var H = hash.words;
  
                    // Swap endian
                    for (var i = 0; i < 5; i++) {
                      // Shortcut
                      var H_i = H[i];
  
                      // Swap
                      H[i] =
                        (((H_i << 8) | (H_i >>> 24)) & 0x00ff00ff) |
                        (((H_i << 24) | (H_i >>> 8)) & 0xff00ff00);
                    }
  
                    // Return final computed hash
                    return hash;
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
                    clone._hash = this._hash.clone();
  
                    return clone;
                  },
                }));
  
                function f1(x, y, z) {
                  return x ^ y ^ z;
                }
  
                function f2(x, y, z) {
                  return (x & y) | (~x & z);
                }
  
                function f3(x, y, z) {
                  return (x | ~y) ^ z;
                }
  
                function f4(x, y, z) {
                  return (x & z) | (y & ~z);
                }
  
                function f5(x, y, z) {
                  return x ^ (y | ~z);
                }
  
                function rotl(x, n) {
                  return (x << n) | (x >>> (32 - n));
                }
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.RIPEMD160('message');
                 *     var hash = CryptoJS.RIPEMD160(wordArray);
                 */
                C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
                 */
                C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
              })(Math);
  
              return CryptoJS.RIPEMD160;
            });
          },
          { "./core": 196 },
        ],
        220: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var Hasher = C_lib.Hasher;
                var C_algo = C.algo;
  
                // Reusable object
                var W = [];
  
                /**
                 * SHA-1 hash algorithm.
                 */
                var SHA1 = (C_algo.SHA1 = Hasher.extend({
                  _doReset: function () {
                    this._hash = new WordArray.init([
                      0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0,
                    ]);
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcut
                    var H = this._hash.words;
  
                    // Working variables
                    var a = H[0];
                    var b = H[1];
                    var c = H[2];
                    var d = H[3];
                    var e = H[4];
  
                    // Computation
                    for (var i = 0; i < 80; i++) {
                      if (i < 16) {
                        W[i] = M[offset + i] | 0;
                      } else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = (n << 1) | (n >>> 31);
                      }
  
                      var t = ((a << 5) | (a >>> 27)) + e + W[i];
                      if (i < 20) {
                        t += ((b & c) | (~b & d)) + 0x5a827999;
                      } else if (i < 40) {
                        t += (b ^ c ^ d) + 0x6ed9eba1;
                      } else if (i < 60) {
                        t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
                      } /* if (i < 80) */ else {
                        t += (b ^ c ^ d) - 0x359d3e2a;
                      }
  
                      e = d;
                      d = c;
                      c = (b << 30) | (b >>> 2);
                      b = a;
                      a = t;
                    }
  
                    // Intermediate hash value
                    H[0] = (H[0] + a) | 0;
                    H[1] = (H[1] + b) | 0;
                    H[2] = (H[2] + c) | 0;
                    H[3] = (H[3] + d) | 0;
                    H[4] = (H[4] + e) | 0;
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
  
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - (nBitsLeft % 32));
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(
                      nBitsTotal / 0x100000000
                    );
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
                    data.sigBytes = dataWords.length * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Return final computed hash
                    return this._hash;
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
                    clone._hash = this._hash.clone();
  
                    return clone;
                  },
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA1('message');
                 *     var hash = CryptoJS.SHA1(wordArray);
                 */
                C.SHA1 = Hasher._createHelper(SHA1);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA1(message, key);
                 */
                C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
              })();
  
              return CryptoJS.SHA1;
            });
          },
          { "./core": 196 },
        ],
        221: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./sha256")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./sha256"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var C_algo = C.algo;
                var SHA256 = C_algo.SHA256;
  
                /**
                 * SHA-224 hash algorithm.
                 */
                var SHA224 = (C_algo.SHA224 = SHA256.extend({
                  _doReset: function () {
                    this._hash = new WordArray.init([
                      0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939, 0xffc00b31,
                      0x68581511, 0x64f98fa7, 0xbefa4fa4,
                    ]);
                  },
  
                  _doFinalize: function () {
                    var hash = SHA256._doFinalize.call(this);
  
                    hash.sigBytes -= 4;
  
                    return hash;
                  },
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA224('message');
                 *     var hash = CryptoJS.SHA224(wordArray);
                 */
                C.SHA224 = SHA256._createHelper(SHA224);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA224(message, key);
                 */
                C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
              })();
  
              return CryptoJS.SHA224;
            });
          },
          { "./core": 196, "./sha256": 222 },
        ],
        222: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function (Math) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var Hasher = C_lib.Hasher;
                var C_algo = C.algo;
  
                // Initialization and round constants tables
                var H = [];
                var K = [];
  
                // Compute constants
                (function () {
                  function isPrime(n) {
                    var sqrtN = Math.sqrt(n);
                    for (var factor = 2; factor <= sqrtN; factor++) {
                      if (!(n % factor)) {
                        return false;
                      }
                    }
  
                    return true;
                  }
  
                  function getFractionalBits(n) {
                    return ((n - (n | 0)) * 0x100000000) | 0;
                  }
  
                  var n = 2;
                  var nPrime = 0;
                  while (nPrime < 64) {
                    if (isPrime(n)) {
                      if (nPrime < 8) {
                        H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
                      }
                      K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
  
                      nPrime++;
                    }
  
                    n++;
                  }
                })();
  
                // Reusable object
                var W = [];
  
                /**
                 * SHA-256 hash algorithm.
                 */
                var SHA256 = (C_algo.SHA256 = Hasher.extend({
                  _doReset: function () {
                    this._hash = new WordArray.init(H.slice(0));
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcut
                    var H = this._hash.words;
  
                    // Working variables
                    var a = H[0];
                    var b = H[1];
                    var c = H[2];
                    var d = H[3];
                    var e = H[4];
                    var f = H[5];
                    var g = H[6];
                    var h = H[7];
  
                    // Computation
                    for (var i = 0; i < 64; i++) {
                      if (i < 16) {
                        W[i] = M[offset + i] | 0;
                      } else {
                        var gamma0x = W[i - 15];
                        var gamma0 =
                          ((gamma0x << 25) | (gamma0x >>> 7)) ^
                          ((gamma0x << 14) | (gamma0x >>> 18)) ^
                          (gamma0x >>> 3);
  
                        var gamma1x = W[i - 2];
                        var gamma1 =
                          ((gamma1x << 15) | (gamma1x >>> 17)) ^
                          ((gamma1x << 13) | (gamma1x >>> 19)) ^
                          (gamma1x >>> 10);
  
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                      }
  
                      var ch = (e & f) ^ (~e & g);
                      var maj = (a & b) ^ (a & c) ^ (b & c);
  
                      var sigma0 =
                        ((a << 30) | (a >>> 2)) ^
                        ((a << 19) | (a >>> 13)) ^
                        ((a << 10) | (a >>> 22));
                      var sigma1 =
                        ((e << 26) | (e >>> 6)) ^
                        ((e << 21) | (e >>> 11)) ^
                        ((e << 7) | (e >>> 25));
  
                      var t1 = h + sigma1 + ch + K[i] + W[i];
                      var t2 = sigma0 + maj;
  
                      h = g;
                      g = f;
                      f = e;
                      e = (d + t1) | 0;
                      d = c;
                      c = b;
                      b = a;
                      a = (t1 + t2) | 0;
                    }
  
                    // Intermediate hash value
                    H[0] = (H[0] + a) | 0;
                    H[1] = (H[1] + b) | 0;
                    H[2] = (H[2] + c) | 0;
                    H[3] = (H[3] + d) | 0;
                    H[4] = (H[4] + e) | 0;
                    H[5] = (H[5] + f) | 0;
                    H[6] = (H[6] + g) | 0;
                    H[7] = (H[7] + h) | 0;
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
  
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - (nBitsLeft % 32));
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(
                      nBitsTotal / 0x100000000
                    );
                    dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
                    data.sigBytes = dataWords.length * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Return final computed hash
                    return this._hash;
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
                    clone._hash = this._hash.clone();
  
                    return clone;
                  },
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA256('message');
                 *     var hash = CryptoJS.SHA256(wordArray);
                 */
                C.SHA256 = Hasher._createHelper(SHA256);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA256(message, key);
                 */
                C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
              })(Math);
  
              return CryptoJS.SHA256;
            });
          },
          { "./core": 196 },
        ],
        223: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./x64-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./x64-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function (Math) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var Hasher = C_lib.Hasher;
                var C_x64 = C.x64;
                var X64Word = C_x64.Word;
                var C_algo = C.algo;
  
                // Constants tables
                var RHO_OFFSETS = [];
                var PI_INDEXES = [];
                var ROUND_CONSTANTS = [];
  
                // Compute Constants
                (function () {
                  // Compute rho offset constants
                  var x = 1,
                    y = 0;
                  for (var t = 0; t < 24; t++) {
                    RHO_OFFSETS[x + 5 * y] = (((t + 1) * (t + 2)) / 2) % 64;
  
                    var newX = y % 5;
                    var newY = (2 * x + 3 * y) % 5;
                    x = newX;
                    y = newY;
                  }
  
                  // Compute pi index constants
                  for (var x = 0; x < 5; x++) {
                    for (var y = 0; y < 5; y++) {
                      PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
                    }
                  }
  
                  // Compute round constants
                  var LFSR = 0x01;
                  for (var i = 0; i < 24; i++) {
                    var roundConstantMsw = 0;
                    var roundConstantLsw = 0;
  
                    for (var j = 0; j < 7; j++) {
                      if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) {
                          roundConstantLsw ^= 1 << bitPosition;
                        } /* if (bitPosition >= 32) */ else {
                          roundConstantMsw ^= 1 << (bitPosition - 32);
                        }
                      }
  
                      // Compute next LFSR
                      if (LFSR & 0x80) {
                        // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                        LFSR = (LFSR << 1) ^ 0x71;
                      } else {
                        LFSR <<= 1;
                      }
                    }
  
                    ROUND_CONSTANTS[i] = X64Word.create(
                      roundConstantMsw,
                      roundConstantLsw
                    );
                  }
                })();
  
                // Reusable objects for temporary values
                var T = [];
                (function () {
                  for (var i = 0; i < 25; i++) {
                    T[i] = X64Word.create();
                  }
                })();
  
                /**
                 * SHA-3 hash algorithm.
                 */
                var SHA3 = (C_algo.SHA3 = Hasher.extend({
                  /**
                   * Configuration options.
                   *
                   * @property {number} outputLength
                   *   The desired number of bits in the output hash.
                   *   Only values permitted are: 224, 256, 384, 512.
                   *   Default: 512
                   */
                  cfg: Hasher.cfg.extend({
                    outputLength: 512,
                  }),
  
                  _doReset: function () {
                    var state = (this._state = []);
                    for (var i = 0; i < 25; i++) {
                      state[i] = new X64Word.init();
                    }
  
                    this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcuts
                    var state = this._state;
                    var nBlockSizeLanes = this.blockSize / 2;
  
                    // Absorb
                    for (var i = 0; i < nBlockSizeLanes; i++) {
                      // Shortcuts
                      var M2i = M[offset + 2 * i];
                      var M2i1 = M[offset + 2 * i + 1];
  
                      // Swap endian
                      M2i =
                        (((M2i << 8) | (M2i >>> 24)) & 0x00ff00ff) |
                        (((M2i << 24) | (M2i >>> 8)) & 0xff00ff00);
                      M2i1 =
                        (((M2i1 << 8) | (M2i1 >>> 24)) & 0x00ff00ff) |
                        (((M2i1 << 24) | (M2i1 >>> 8)) & 0xff00ff00);
  
                      // Absorb message into state
                      var lane = state[i];
                      lane.high ^= M2i1;
                      lane.low ^= M2i;
                    }
  
                    // Rounds
                    for (var round = 0; round < 24; round++) {
                      // Theta
                      for (var x = 0; x < 5; x++) {
                        // Mix column lanes
                        var tMsw = 0,
                          tLsw = 0;
                        for (var y = 0; y < 5; y++) {
                          var lane = state[x + 5 * y];
                          tMsw ^= lane.high;
                          tLsw ^= lane.low;
                        }
  
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                      }
                      for (var x = 0; x < 5; x++) {
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
  
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
                        var tLsw = Tx4.low ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
                        for (var y = 0; y < 5; y++) {
                          var lane = state[x + 5 * y];
                          lane.high ^= tMsw;
                          lane.low ^= tLsw;
                        }
                      }
  
                      // Rho Pi
                      for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
                        var tMsw;
                        var tLsw;
  
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
  
                        // Rotate lanes
                        if (rhoOffset < 32) {
                          tMsw =
                            (laneMsw << rhoOffset) |
                            (laneLsw >>> (32 - rhoOffset));
                          tLsw =
                            (laneLsw << rhoOffset) |
                            (laneMsw >>> (32 - rhoOffset));
                        } /* if (rhoOffset >= 32) */ else {
                          tMsw =
                            (laneLsw << (rhoOffset - 32)) |
                            (laneMsw >>> (64 - rhoOffset));
                          tLsw =
                            (laneMsw << (rhoOffset - 32)) |
                            (laneLsw >>> (64 - rhoOffset));
                        }
  
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                      }
  
                      // Rho pi at x = y = 0
                      var T0 = T[0];
                      var state0 = state[0];
                      T0.high = state0.high;
                      T0.low = state0.low;
  
                      // Chi
                      for (var x = 0; x < 5; x++) {
                        for (var y = 0; y < 5; y++) {
                          // Shortcuts
                          var laneIndex = x + 5 * y;
                          var lane = state[laneIndex];
                          var TLane = T[laneIndex];
                          var Tx1Lane = T[((x + 1) % 5) + 5 * y];
                          var Tx2Lane = T[((x + 2) % 5) + 5 * y];
  
                          // Mix rows
                          lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
                          lane.low = TLane.low ^ (~Tx1Lane.low & Tx2Lane.low);
                        }
                      }
  
                      // Iota
                      var lane = state[0];
                      var roundConstant = ROUND_CONSTANTS[round];
                      lane.high ^= roundConstant.high;
                      lane.low ^= roundConstant.low;
                    }
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
                    var blockSizeBits = this.blockSize * 32;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - (nBitsLeft % 32));
                    dataWords[
                      ((Math.ceil((nBitsLeft + 1) / blockSizeBits) *
                        blockSizeBits) >>>
                        5) -
                        1
                    ] |= 0x80;
                    data.sigBytes = dataWords.length * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Shortcuts
                    var state = this._state;
                    var outputLengthBytes = this.cfg.outputLength / 8;
                    var outputLengthLanes = outputLengthBytes / 8;
  
                    // Squeeze
                    var hashWords = [];
                    for (var i = 0; i < outputLengthLanes; i++) {
                      // Shortcuts
                      var lane = state[i];
                      var laneMsw = lane.high;
                      var laneLsw = lane.low;
  
                      // Swap endian
                      laneMsw =
                        (((laneMsw << 8) | (laneMsw >>> 24)) & 0x00ff00ff) |
                        (((laneMsw << 24) | (laneMsw >>> 8)) & 0xff00ff00);
                      laneLsw =
                        (((laneLsw << 8) | (laneLsw >>> 24)) & 0x00ff00ff) |
                        (((laneLsw << 24) | (laneLsw >>> 8)) & 0xff00ff00);
  
                      // Squeeze state to retrieve hash
                      hashWords.push(laneLsw);
                      hashWords.push(laneMsw);
                    }
  
                    // Return final computed hash
                    return new WordArray.init(hashWords, outputLengthBytes);
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
  
                    var state = (clone._state = this._state.slice(0));
                    for (var i = 0; i < 25; i++) {
                      state[i] = state[i].clone();
                    }
  
                    return clone;
                  },
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA3('message');
                 *     var hash = CryptoJS.SHA3(wordArray);
                 */
                C.SHA3 = Hasher._createHelper(SHA3);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA3(message, key);
                 */
                C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
              })(Math);
  
              return CryptoJS.SHA3;
            });
          },
          { "./core": 196, "./x64-core": 227 },
        ],
        224: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./x64-core"),
                  require("./sha512")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./x64-core", "./sha512"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_x64 = C.x64;
                var X64Word = C_x64.Word;
                var X64WordArray = C_x64.WordArray;
                var C_algo = C.algo;
                var SHA512 = C_algo.SHA512;
  
                /**
                 * SHA-384 hash algorithm.
                 */
                var SHA384 = (C_algo.SHA384 = SHA512.extend({
                  _doReset: function () {
                    this._hash = new X64WordArray.init([
                      new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                      new X64Word.init(0x629a292a, 0x367cd507),
                      new X64Word.init(0x9159015a, 0x3070dd17),
                      new X64Word.init(0x152fecd8, 0xf70e5939),
                      new X64Word.init(0x67332667, 0xffc00b31),
                      new X64Word.init(0x8eb44a87, 0x68581511),
                      new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                      new X64Word.init(0x47b5481d, 0xbefa4fa4),
                    ]);
                  },
  
                  _doFinalize: function () {
                    var hash = SHA512._doFinalize.call(this);
  
                    hash.sigBytes -= 16;
  
                    return hash;
                  },
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA384('message');
                 *     var hash = CryptoJS.SHA384(wordArray);
                 */
                C.SHA384 = SHA512._createHelper(SHA384);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA384(message, key);
                 */
                C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
              })();
  
              return CryptoJS.SHA384;
            });
          },
          { "./core": 196, "./sha512": 225, "./x64-core": 227 },
        ],
        225: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./x64-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core", "./x64-core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var Hasher = C_lib.Hasher;
                var C_x64 = C.x64;
                var X64Word = C_x64.Word;
                var X64WordArray = C_x64.WordArray;
                var C_algo = C.algo;
  
                function X64Word_create() {
                  return X64Word.create.apply(X64Word, arguments);
                }
  
                // Constants
                var K = [
                  X64Word_create(0x428a2f98, 0xd728ae22),
                  X64Word_create(0x71374491, 0x23ef65cd),
                  X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
                  X64Word_create(0xe9b5dba5, 0x8189dbbc),
                  X64Word_create(0x3956c25b, 0xf348b538),
                  X64Word_create(0x59f111f1, 0xb605d019),
                  X64Word_create(0x923f82a4, 0xaf194f9b),
                  X64Word_create(0xab1c5ed5, 0xda6d8118),
                  X64Word_create(0xd807aa98, 0xa3030242),
                  X64Word_create(0x12835b01, 0x45706fbe),
                  X64Word_create(0x243185be, 0x4ee4b28c),
                  X64Word_create(0x550c7dc3, 0xd5ffb4e2),
                  X64Word_create(0x72be5d74, 0xf27b896f),
                  X64Word_create(0x80deb1fe, 0x3b1696b1),
                  X64Word_create(0x9bdc06a7, 0x25c71235),
                  X64Word_create(0xc19bf174, 0xcf692694),
                  X64Word_create(0xe49b69c1, 0x9ef14ad2),
                  X64Word_create(0xefbe4786, 0x384f25e3),
                  X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
                  X64Word_create(0x240ca1cc, 0x77ac9c65),
                  X64Word_create(0x2de92c6f, 0x592b0275),
                  X64Word_create(0x4a7484aa, 0x6ea6e483),
                  X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
                  X64Word_create(0x76f988da, 0x831153b5),
                  X64Word_create(0x983e5152, 0xee66dfab),
                  X64Word_create(0xa831c66d, 0x2db43210),
                  X64Word_create(0xb00327c8, 0x98fb213f),
                  X64Word_create(0xbf597fc7, 0xbeef0ee4),
                  X64Word_create(0xc6e00bf3, 0x3da88fc2),
                  X64Word_create(0xd5a79147, 0x930aa725),
                  X64Word_create(0x06ca6351, 0xe003826f),
                  X64Word_create(0x14292967, 0x0a0e6e70),
                  X64Word_create(0x27b70a85, 0x46d22ffc),
                  X64Word_create(0x2e1b2138, 0x5c26c926),
                  X64Word_create(0x4d2c6dfc, 0x5ac42aed),
                  X64Word_create(0x53380d13, 0x9d95b3df),
                  X64Word_create(0x650a7354, 0x8baf63de),
                  X64Word_create(0x766a0abb, 0x3c77b2a8),
                  X64Word_create(0x81c2c92e, 0x47edaee6),
                  X64Word_create(0x92722c85, 0x1482353b),
                  X64Word_create(0xa2bfe8a1, 0x4cf10364),
                  X64Word_create(0xa81a664b, 0xbc423001),
                  X64Word_create(0xc24b8b70, 0xd0f89791),
                  X64Word_create(0xc76c51a3, 0x0654be30),
                  X64Word_create(0xd192e819, 0xd6ef5218),
                  X64Word_create(0xd6990624, 0x5565a910),
                  X64Word_create(0xf40e3585, 0x5771202a),
                  X64Word_create(0x106aa070, 0x32bbd1b8),
                  X64Word_create(0x19a4c116, 0xb8d2d0c8),
                  X64Word_create(0x1e376c08, 0x5141ab53),
                  X64Word_create(0x2748774c, 0xdf8eeb99),
                  X64Word_create(0x34b0bcb5, 0xe19b48a8),
                  X64Word_create(0x391c0cb3, 0xc5c95a63),
                  X64Word_create(0x4ed8aa4a, 0xe3418acb),
                  X64Word_create(0x5b9cca4f, 0x7763e373),
                  X64Word_create(0x682e6ff3, 0xd6b2b8a3),
                  X64Word_create(0x748f82ee, 0x5defb2fc),
                  X64Word_create(0x78a5636f, 0x43172f60),
                  X64Word_create(0x84c87814, 0xa1f0ab72),
                  X64Word_create(0x8cc70208, 0x1a6439ec),
                  X64Word_create(0x90befffa, 0x23631e28),
                  X64Word_create(0xa4506ceb, 0xde82bde9),
                  X64Word_create(0xbef9a3f7, 0xb2c67915),
                  X64Word_create(0xc67178f2, 0xe372532b),
                  X64Word_create(0xca273ece, 0xea26619c),
                  X64Word_create(0xd186b8c7, 0x21c0c207),
                  X64Word_create(0xeada7dd6, 0xcde0eb1e),
                  X64Word_create(0xf57d4f7f, 0xee6ed178),
                  X64Word_create(0x06f067aa, 0x72176fba),
                  X64Word_create(0x0a637dc5, 0xa2c898a6),
                  X64Word_create(0x113f9804, 0xbef90dae),
                  X64Word_create(0x1b710b35, 0x131c471b),
                  X64Word_create(0x28db77f5, 0x23047d84),
                  X64Word_create(0x32caab7b, 0x40c72493),
                  X64Word_create(0x3c9ebe0a, 0x15c9bebc),
                  X64Word_create(0x431d67c4, 0x9c100d4c),
                  X64Word_create(0x4cc5d4be, 0xcb3e42b6),
                  X64Word_create(0x597f299c, 0xfc657e2a),
                  X64Word_create(0x5fcb6fab, 0x3ad6faec),
                  X64Word_create(0x6c44198c, 0x4a475817),
                ];
  
                // Reusable objects
                var W = [];
                (function () {
                  for (var i = 0; i < 80; i++) {
                    W[i] = X64Word_create();
                  }
                })();
  
                /**
                 * SHA-512 hash algorithm.
                 */
                var SHA512 = (C_algo.SHA512 = Hasher.extend({
                  _doReset: function () {
                    this._hash = new X64WordArray.init([
                      new X64Word.init(0x6a09e667, 0xf3bcc908),
                      new X64Word.init(0xbb67ae85, 0x84caa73b),
                      new X64Word.init(0x3c6ef372, 0xfe94f82b),
                      new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                      new X64Word.init(0x510e527f, 0xade682d1),
                      new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                      new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                      new X64Word.init(0x5be0cd19, 0x137e2179),
                    ]);
                  },
  
                  _doProcessBlock: function (M, offset) {
                    // Shortcuts
                    var H = this._hash.words;
  
                    var H0 = H[0];
                    var H1 = H[1];
                    var H2 = H[2];
                    var H3 = H[3];
                    var H4 = H[4];
                    var H5 = H[5];
                    var H6 = H[6];
                    var H7 = H[7];
  
                    var H0h = H0.high;
                    var H0l = H0.low;
                    var H1h = H1.high;
                    var H1l = H1.low;
                    var H2h = H2.high;
                    var H2l = H2.low;
                    var H3h = H3.high;
                    var H3l = H3.low;
                    var H4h = H4.high;
                    var H4l = H4.low;
                    var H5h = H5.high;
                    var H5l = H5.low;
                    var H6h = H6.high;
                    var H6l = H6.low;
                    var H7h = H7.high;
                    var H7l = H7.low;
  
                    // Working variables
                    var ah = H0h;
                    var al = H0l;
                    var bh = H1h;
                    var bl = H1l;
                    var ch = H2h;
                    var cl = H2l;
                    var dh = H3h;
                    var dl = H3l;
                    var eh = H4h;
                    var el = H4l;
                    var fh = H5h;
                    var fl = H5l;
                    var gh = H6h;
                    var gl = H6l;
                    var hh = H7h;
                    var hl = H7l;
  
                    // Rounds
                    for (var i = 0; i < 80; i++) {
                      var Wil;
                      var Wih;
  
                      // Shortcut
                      var Wi = W[i];
  
                      // Extend message
                      if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                      } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h =
                          ((gamma0xh >>> 1) | (gamma0xl << 31)) ^
                          ((gamma0xh >>> 8) | (gamma0xl << 24)) ^
                          (gamma0xh >>> 7);
                        var gamma0l =
                          ((gamma0xl >>> 1) | (gamma0xh << 31)) ^
                          ((gamma0xl >>> 8) | (gamma0xh << 24)) ^
                          ((gamma0xl >>> 7) | (gamma0xh << 25));
  
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h =
                          ((gamma1xh >>> 19) | (gamma1xl << 13)) ^
                          ((gamma1xh << 3) | (gamma1xl >>> 29)) ^
                          (gamma1xh >>> 6);
                        var gamma1l =
                          ((gamma1xl >>> 19) | (gamma1xh << 13)) ^
                          ((gamma1xl << 3) | (gamma1xh >>> 29)) ^
                          ((gamma1xl >>> 6) | (gamma1xh << 26));
  
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
  
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
  
                        Wil = gamma0l + Wi7l;
                        Wih =
                          gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
  
                        Wi.high = Wih;
                        Wi.low = Wil;
                      }
  
                      var chh = (eh & fh) ^ (~eh & gh);
                      var chl = (el & fl) ^ (~el & gl);
                      var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
                      var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
  
                      var sigma0h =
                        ((ah >>> 28) | (al << 4)) ^
                        ((ah << 30) | (al >>> 2)) ^
                        ((ah << 25) | (al >>> 7));
                      var sigma0l =
                        ((al >>> 28) | (ah << 4)) ^
                        ((al << 30) | (ah >>> 2)) ^
                        ((al << 25) | (ah >>> 7));
                      var sigma1h =
                        ((eh >>> 14) | (el << 18)) ^
                        ((eh >>> 18) | (el << 14)) ^
                        ((eh << 23) | (el >>> 9));
                      var sigma1l =
                        ((el >>> 14) | (eh << 18)) ^
                        ((el >>> 18) | (eh << 14)) ^
                        ((el << 23) | (eh >>> 9));
  
                      // t1 = h + sigma1 + ch + K[i] + W[i]
                      var Ki = K[i];
                      var Kih = Ki.high;
                      var Kil = Ki.low;
  
                      var t1l = hl + sigma1l;
                      var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                      var t1l = t1l + chl;
                      var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                      var t1l = t1l + Kil;
                      var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                      var t1l = t1l + Wil;
                      var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
  
                      // t2 = sigma0 + maj
                      var t2l = sigma0l + majl;
                      var t2h =
                        sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
  
                      // Update working variables
                      hh = gh;
                      hl = gl;
                      gh = fh;
                      gl = fl;
                      fh = eh;
                      fl = el;
                      el = (dl + t1l) | 0;
                      eh = (dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0)) | 0;
                      dh = ch;
                      dl = cl;
                      ch = bh;
                      cl = bl;
                      bh = ah;
                      bl = al;
                      al = (t1l + t2l) | 0;
                      ah = (t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0)) | 0;
                    }
  
                    // Intermediate hash value
                    H0l = H0.low = H0l + al;
                    H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                    H1l = H1.low = H1l + bl;
                    H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                    H2l = H2.low = H2l + cl;
                    H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                    H3l = H3.low = H3l + dl;
                    H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                    H4l = H4.low = H4l + el;
                    H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                    H5l = H5.low = H5l + fl;
                    H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                    H6l = H6.low = H6l + gl;
                    H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                    H7l = H7.low = H7l + hl;
                    H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
                  },
  
                  _doFinalize: function () {
                    // Shortcuts
                    var data = this._data;
                    var dataWords = data.words;
  
                    var nBitsTotal = this._nDataBytes * 8;
                    var nBitsLeft = data.sigBytes * 8;
  
                    // Add padding
                    dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - (nBitsLeft % 32));
                    dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] =
                      Math.floor(nBitsTotal / 0x100000000);
                    dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] =
                      nBitsTotal;
                    data.sigBytes = dataWords.length * 4;
  
                    // Hash final blocks
                    this._process();
  
                    // Convert hash to 32-bit word array before returning
                    var hash = this._hash.toX32();
  
                    // Return final computed hash
                    return hash;
                  },
  
                  clone: function () {
                    var clone = Hasher.clone.call(this);
                    clone._hash = this._hash.clone();
  
                    return clone;
                  },
  
                  blockSize: 1024 / 32,
                }));
  
                /**
                 * Shortcut function to the hasher's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 *
                 * @return {WordArray} The hash.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hash = CryptoJS.SHA512('message');
                 *     var hash = CryptoJS.SHA512(wordArray);
                 */
                C.SHA512 = Hasher._createHelper(SHA512);
  
                /**
                 * Shortcut function to the HMAC's object interface.
                 *
                 * @param {WordArray|string} message The message to hash.
                 * @param {WordArray|string} key The secret key.
                 *
                 * @return {WordArray} The HMAC.
                 *
                 * @static
                 *
                 * @example
                 *
                 *     var hmac = CryptoJS.HmacSHA512(message, key);
                 */
                C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
              })();
  
              return CryptoJS.SHA512;
            });
          },
          { "./core": 196, "./x64-core": 227 },
        ],
        226: [
          function (require, module, exports) {
            (function (root, factory, undef) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(
                  require("./core"),
                  require("./enc-base64"),
                  require("./md5"),
                  require("./evpkdf"),
                  require("./cipher-core")
                );
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define([
                  "./core",
                  "./enc-base64",
                  "./md5",
                  "./evpkdf",
                  "./cipher-core",
                ], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function () {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var WordArray = C_lib.WordArray;
                var BlockCipher = C_lib.BlockCipher;
                var C_algo = C.algo;
  
                // Permuted Choice 1 constants
                var PC1 = [
                  57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59,
                  51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31,
                  23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29,
                  21, 13, 5, 28, 20, 12, 4,
                ];
  
                // Permuted Choice 2 constants
                var PC2 = [
                  14, 17, 11, 24, 1, 5, 3, 28, 15, 6, 21, 10, 23, 19, 12, 4, 26,
                  8, 16, 7, 27, 20, 13, 2, 41, 52, 31, 37, 47, 55, 30, 40, 51, 45,
                  33, 48, 44, 49, 39, 56, 34, 53, 46, 42, 50, 36, 29, 32,
                ];
  
                // Cumulative bit shift constants
                var BIT_SHIFTS = [
                  1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28,
                ];
  
                // SBOXes and round permutation constants
                var SBOX_P = [
                  {
                    0x0: 0x808200,
                    0x10000000: 0x8000,
                    0x20000000: 0x808002,
                    0x30000000: 0x2,
                    0x40000000: 0x200,
                    0x50000000: 0x808202,
                    0x60000000: 0x800202,
                    0x70000000: 0x800000,
                    0x80000000: 0x202,
                    0x90000000: 0x800200,
                    0xa0000000: 0x8200,
                    0xb0000000: 0x808000,
                    0xc0000000: 0x8002,
                    0xd0000000: 0x800002,
                    0xe0000000: 0x0,
                    0xf0000000: 0x8202,
                    0x8000000: 0x0,
                    0x18000000: 0x808202,
                    0x28000000: 0x8202,
                    0x38000000: 0x8000,
                    0x48000000: 0x808200,
                    0x58000000: 0x200,
                    0x68000000: 0x808002,
                    0x78000000: 0x2,
                    0x88000000: 0x800200,
                    0x98000000: 0x8200,
                    0xa8000000: 0x808000,
                    0xb8000000: 0x800202,
                    0xc8000000: 0x800002,
                    0xd8000000: 0x8002,
                    0xe8000000: 0x202,
                    0xf8000000: 0x800000,
                    0x1: 0x8000,
                    0x10000001: 0x2,
                    0x20000001: 0x808200,
                    0x30000001: 0x800000,
                    0x40000001: 0x808002,
                    0x50000001: 0x8200,
                    0x60000001: 0x200,
                    0x70000001: 0x800202,
                    0x80000001: 0x808202,
                    0x90000001: 0x808000,
                    0xa0000001: 0x800002,
                    0xb0000001: 0x8202,
                    0xc0000001: 0x202,
                    0xd0000001: 0x800200,
                    0xe0000001: 0x8002,
                    0xf0000001: 0x0,
                    0x8000001: 0x808202,
                    0x18000001: 0x808000,
                    0x28000001: 0x800000,
                    0x38000001: 0x200,
                    0x48000001: 0x8000,
                    0x58000001: 0x800002,
                    0x68000001: 0x2,
                    0x78000001: 0x8202,
                    0x88000001: 0x8002,
                    0x98000001: 0x800202,
                    0xa8000001: 0x202,
                    0xb8000001: 0x808200,
                    0xc8000001: 0x800200,
                    0xd8000001: 0x0,
                    0xe8000001: 0x8200,
                    0xf8000001: 0x808002,
                  },
                  {
                    0x0: 0x40084010,
                    0x1000000: 0x4000,
                    0x2000000: 0x80000,
                    0x3000000: 0x40080010,
                    0x4000000: 0x40000010,
                    0x5000000: 0x40084000,
                    0x6000000: 0x40004000,
                    0x7000000: 0x10,
                    0x8000000: 0x84000,
                    0x9000000: 0x40004010,
                    0xa000000: 0x40000000,
                    0xb000000: 0x84010,
                    0xc000000: 0x80010,
                    0xd000000: 0x0,
                    0xe000000: 0x4010,
                    0xf000000: 0x40080000,
                    0x800000: 0x40004000,
                    0x1800000: 0x84010,
                    0x2800000: 0x10,
                    0x3800000: 0x40004010,
                    0x4800000: 0x40084010,
                    0x5800000: 0x40000000,
                    0x6800000: 0x80000,
                    0x7800000: 0x40080010,
                    0x8800000: 0x80010,
                    0x9800000: 0x0,
                    0xa800000: 0x4000,
                    0xb800000: 0x40080000,
                    0xc800000: 0x40000010,
                    0xd800000: 0x84000,
                    0xe800000: 0x40084000,
                    0xf800000: 0x4010,
                    0x10000000: 0x0,
                    0x11000000: 0x40080010,
                    0x12000000: 0x40004010,
                    0x13000000: 0x40084000,
                    0x14000000: 0x40080000,
                    0x15000000: 0x10,
                    0x16000000: 0x84010,
                    0x17000000: 0x4000,
                    0x18000000: 0x4010,
                    0x19000000: 0x80000,
                    0x1a000000: 0x80010,
                    0x1b000000: 0x40000010,
                    0x1c000000: 0x84000,
                    0x1d000000: 0x40004000,
                    0x1e000000: 0x40000000,
                    0x1f000000: 0x40084010,
                    0x10800000: 0x84010,
                    0x11800000: 0x80000,
                    0x12800000: 0x40080000,
                    0x13800000: 0x4000,
                    0x14800000: 0x40004000,
                    0x15800000: 0x40084010,
                    0x16800000: 0x10,
                    0x17800000: 0x40000000,
                    0x18800000: 0x40084000,
                    0x19800000: 0x40000010,
                    0x1a800000: 0x40004010,
                    0x1b800000: 0x80010,
                    0x1c800000: 0x0,
                    0x1d800000: 0x4010,
                    0x1e800000: 0x40080010,
                    0x1f800000: 0x84000,
                  },
                  {
                    0x0: 0x104,
                    0x100000: 0x0,
                    0x200000: 0x4000100,
                    0x300000: 0x10104,
                    0x400000: 0x10004,
                    0x500000: 0x4000004,
                    0x600000: 0x4010104,
                    0x700000: 0x4010000,
                    0x800000: 0x4000000,
                    0x900000: 0x4010100,
                    0xa00000: 0x10100,
                    0xb00000: 0x4010004,
                    0xc00000: 0x4000104,
                    0xd00000: 0x10000,
                    0xe00000: 0x4,
                    0xf00000: 0x100,
                    0x80000: 0x4010100,
                    0x180000: 0x4010004,
                    0x280000: 0x0,
                    0x380000: 0x4000100,
                    0x480000: 0x4000004,
                    0x580000: 0x10000,
                    0x680000: 0x10004,
                    0x780000: 0x104,
                    0x880000: 0x4,
                    0x980000: 0x100,
                    0xa80000: 0x4010000,
                    0xb80000: 0x10104,
                    0xc80000: 0x10100,
                    0xd80000: 0x4000104,
                    0xe80000: 0x4010104,
                    0xf80000: 0x4000000,
                    0x1000000: 0x4010100,
                    0x1100000: 0x10004,
                    0x1200000: 0x10000,
                    0x1300000: 0x4000100,
                    0x1400000: 0x100,
                    0x1500000: 0x4010104,
                    0x1600000: 0x4000004,
                    0x1700000: 0x0,
                    0x1800000: 0x4000104,
                    0x1900000: 0x4000000,
                    0x1a00000: 0x4,
                    0x1b00000: 0x10100,
                    0x1c00000: 0x4010000,
                    0x1d00000: 0x104,
                    0x1e00000: 0x10104,
                    0x1f00000: 0x4010004,
                    0x1080000: 0x4000000,
                    0x1180000: 0x104,
                    0x1280000: 0x4010100,
                    0x1380000: 0x0,
                    0x1480000: 0x10004,
                    0x1580000: 0x4000100,
                    0x1680000: 0x100,
                    0x1780000: 0x4010004,
                    0x1880000: 0x10000,
                    0x1980000: 0x4010104,
                    0x1a80000: 0x10104,
                    0x1b80000: 0x4000004,
                    0x1c80000: 0x4000104,
                    0x1d80000: 0x4010000,
                    0x1e80000: 0x4,
                    0x1f80000: 0x10100,
                  },
                  {
                    0x0: 0x80401000,
                    0x10000: 0x80001040,
                    0x20000: 0x401040,
                    0x30000: 0x80400000,
                    0x40000: 0x0,
                    0x50000: 0x401000,
                    0x60000: 0x80000040,
                    0x70000: 0x400040,
                    0x80000: 0x80000000,
                    0x90000: 0x400000,
                    0xa0000: 0x40,
                    0xb0000: 0x80001000,
                    0xc0000: 0x80400040,
                    0xd0000: 0x1040,
                    0xe0000: 0x1000,
                    0xf0000: 0x80401040,
                    0x8000: 0x80001040,
                    0x18000: 0x40,
                    0x28000: 0x80400040,
                    0x38000: 0x80001000,
                    0x48000: 0x401000,
                    0x58000: 0x80401040,
                    0x68000: 0x0,
                    0x78000: 0x80400000,
                    0x88000: 0x1000,
                    0x98000: 0x80401000,
                    0xa8000: 0x400000,
                    0xb8000: 0x1040,
                    0xc8000: 0x80000000,
                    0xd8000: 0x400040,
                    0xe8000: 0x401040,
                    0xf8000: 0x80000040,
                    0x100000: 0x400040,
                    0x110000: 0x401000,
                    0x120000: 0x80000040,
                    0x130000: 0x0,
                    0x140000: 0x1040,
                    0x150000: 0x80400040,
                    0x160000: 0x80401000,
                    0x170000: 0x80001040,
                    0x180000: 0x80401040,
                    0x190000: 0x80000000,
                    0x1a0000: 0x80400000,
                    0x1b0000: 0x401040,
                    0x1c0000: 0x80001000,
                    0x1d0000: 0x400000,
                    0x1e0000: 0x40,
                    0x1f0000: 0x1000,
                    0x108000: 0x80400000,
                    0x118000: 0x80401040,
                    0x128000: 0x0,
                    0x138000: 0x401000,
                    0x148000: 0x400040,
                    0x158000: 0x80000000,
                    0x168000: 0x80001040,
                    0x178000: 0x40,
                    0x188000: 0x80000040,
                    0x198000: 0x1000,
                    0x1a8000: 0x80001000,
                    0x1b8000: 0x80400040,
                    0x1c8000: 0x1040,
                    0x1d8000: 0x80401000,
                    0x1e8000: 0x400000,
                    0x1f8000: 0x401040,
                  },
                  {
                    0x0: 0x80,
                    0x1000: 0x1040000,
                    0x2000: 0x40000,
                    0x3000: 0x20000000,
                    0x4000: 0x20040080,
                    0x5000: 0x1000080,
                    0x6000: 0x21000080,
                    0x7000: 0x40080,
                    0x8000: 0x1000000,
                    0x9000: 0x20040000,
                    0xa000: 0x20000080,
                    0xb000: 0x21040080,
                    0xc000: 0x21040000,
                    0xd000: 0x0,
                    0xe000: 0x1040080,
                    0xf000: 0x21000000,
                    0x800: 0x1040080,
                    0x1800: 0x21000080,
                    0x2800: 0x80,
                    0x3800: 0x1040000,
                    0x4800: 0x40000,
                    0x5800: 0x20040080,
                    0x6800: 0x21040000,
                    0x7800: 0x20000000,
                    0x8800: 0x20040000,
                    0x9800: 0x0,
                    0xa800: 0x21040080,
                    0xb800: 0x1000080,
                    0xc800: 0x20000080,
                    0xd800: 0x21000000,
                    0xe800: 0x1000000,
                    0xf800: 0x40080,
                    0x10000: 0x40000,
                    0x11000: 0x80,
                    0x12000: 0x20000000,
                    0x13000: 0x21000080,
                    0x14000: 0x1000080,
                    0x15000: 0x21040000,
                    0x16000: 0x20040080,
                    0x17000: 0x1000000,
                    0x18000: 0x21040080,
                    0x19000: 0x21000000,
                    0x1a000: 0x1040000,
                    0x1b000: 0x20040000,
                    0x1c000: 0x40080,
                    0x1d000: 0x20000080,
                    0x1e000: 0x0,
                    0x1f000: 0x1040080,
                    0x10800: 0x21000080,
                    0x11800: 0x1000000,
                    0x12800: 0x1040000,
                    0x13800: 0x20040080,
                    0x14800: 0x20000000,
                    0x15800: 0x1040080,
                    0x16800: 0x80,
                    0x17800: 0x21040000,
                    0x18800: 0x40080,
                    0x19800: 0x21040080,
                    0x1a800: 0x0,
                    0x1b800: 0x21000000,
                    0x1c800: 0x1000080,
                    0x1d800: 0x40000,
                    0x1e800: 0x20040000,
                    0x1f800: 0x20000080,
                  },
                  {
                    0x0: 0x10000008,
                    0x100: 0x2000,
                    0x200: 0x10200000,
                    0x300: 0x10202008,
                    0x400: 0x10002000,
                    0x500: 0x200000,
                    0x600: 0x200008,
                    0x700: 0x10000000,
                    0x800: 0x0,
                    0x900: 0x10002008,
                    0xa00: 0x202000,
                    0xb00: 0x8,
                    0xc00: 0x10200008,
                    0xd00: 0x202008,
                    0xe00: 0x2008,
                    0xf00: 0x10202000,
                    0x80: 0x10200000,
                    0x180: 0x10202008,
                    0x280: 0x8,
                    0x380: 0x200000,
                    0x480: 0x202008,
                    0x580: 0x10000008,
                    0x680: 0x10002000,
                    0x780: 0x2008,
                    0x880: 0x200008,
                    0x980: 0x2000,
                    0xa80: 0x10002008,
                    0xb80: 0x10200008,
                    0xc80: 0x0,
                    0xd80: 0x10202000,
                    0xe80: 0x202000,
                    0xf80: 0x10000000,
                    0x1000: 0x10002000,
                    0x1100: 0x10200008,
                    0x1200: 0x10202008,
                    0x1300: 0x2008,
                    0x1400: 0x200000,
                    0x1500: 0x10000000,
                    0x1600: 0x10000008,
                    0x1700: 0x202000,
                    0x1800: 0x202008,
                    0x1900: 0x0,
                    0x1a00: 0x8,
                    0x1b00: 0x10200000,
                    0x1c00: 0x2000,
                    0x1d00: 0x10002008,
                    0x1e00: 0x10202000,
                    0x1f00: 0x200008,
                    0x1080: 0x8,
                    0x1180: 0x202000,
                    0x1280: 0x200000,
                    0x1380: 0x10000008,
                    0x1480: 0x10002000,
                    0x1580: 0x2008,
                    0x1680: 0x10202008,
                    0x1780: 0x10200000,
                    0x1880: 0x10202000,
                    0x1980: 0x10200008,
                    0x1a80: 0x2000,
                    0x1b80: 0x202008,
                    0x1c80: 0x200008,
                    0x1d80: 0x0,
                    0x1e80: 0x10000000,
                    0x1f80: 0x10002008,
                  },
                  {
                    0x0: 0x100000,
                    0x10: 0x2000401,
                    0x20: 0x400,
                    0x30: 0x100401,
                    0x40: 0x2100401,
                    0x50: 0x0,
                    0x60: 0x1,
                    0x70: 0x2100001,
                    0x80: 0x2000400,
                    0x90: 0x100001,
                    0xa0: 0x2000001,
                    0xb0: 0x2100400,
                    0xc0: 0x2100000,
                    0xd0: 0x401,
                    0xe0: 0x100400,
                    0xf0: 0x2000000,
                    0x8: 0x2100001,
                    0x18: 0x0,
                    0x28: 0x2000401,
                    0x38: 0x2100400,
                    0x48: 0x100000,
                    0x58: 0x2000001,
                    0x68: 0x2000000,
                    0x78: 0x401,
                    0x88: 0x100401,
                    0x98: 0x2000400,
                    0xa8: 0x2100000,
                    0xb8: 0x100001,
                    0xc8: 0x400,
                    0xd8: 0x2100401,
                    0xe8: 0x1,
                    0xf8: 0x100400,
                    0x100: 0x2000000,
                    0x110: 0x100000,
                    0x120: 0x2000401,
                    0x130: 0x2100001,
                    0x140: 0x100001,
                    0x150: 0x2000400,
                    0x160: 0x2100400,
                    0x170: 0x100401,
                    0x180: 0x401,
                    0x190: 0x2100401,
                    0x1a0: 0x100400,
                    0x1b0: 0x1,
                    0x1c0: 0x0,
                    0x1d0: 0x2100000,
                    0x1e0: 0x2000001,
                    0x1f0: 0x400,
                    0x108: 0x100400,
                    0x118: 0x2000401,
                    0x128: 0x2100001,
                    0x138: 0x1,
                    0x148: 0x2000000,
                    0x158: 0x100000,
                    0x168: 0x401,
                    0x178: 0x2100400,
                    0x188: 0x2000001,
                    0x198: 0x2100000,
                    0x1a8: 0x0,
                    0x1b8: 0x2100401,
                    0x1c8: 0x100401,
                    0x1d8: 0x400,
                    0x1e8: 0x2000400,
                    0x1f8: 0x100001,
                  },
                  {
                    0x0: 0x8000820,
                    0x1: 0x20000,
                    0x2: 0x8000000,
                    0x3: 0x20,
                    0x4: 0x20020,
                    0x5: 0x8020820,
                    0x6: 0x8020800,
                    0x7: 0x800,
                    0x8: 0x8020000,
                    0x9: 0x8000800,
                    0xa: 0x20800,
                    0xb: 0x8020020,
                    0xc: 0x820,
                    0xd: 0x0,
                    0xe: 0x8000020,
                    0xf: 0x20820,
                    0x80000000: 0x800,
                    0x80000001: 0x8020820,
                    0x80000002: 0x8000820,
                    0x80000003: 0x8000000,
                    0x80000004: 0x8020000,
                    0x80000005: 0x20800,
                    0x80000006: 0x20820,
                    0x80000007: 0x20,
                    0x80000008: 0x8000020,
                    0x80000009: 0x820,
                    0x8000000a: 0x20020,
                    0x8000000b: 0x8020800,
                    0x8000000c: 0x0,
                    0x8000000d: 0x8020020,
                    0x8000000e: 0x8000800,
                    0x8000000f: 0x20000,
                    0x10: 0x20820,
                    0x11: 0x8020800,
                    0x12: 0x20,
                    0x13: 0x800,
                    0x14: 0x8000800,
                    0x15: 0x8000020,
                    0x16: 0x8020020,
                    0x17: 0x20000,
                    0x18: 0x0,
                    0x19: 0x20020,
                    0x1a: 0x8020000,
                    0x1b: 0x8000820,
                    0x1c: 0x8020820,
                    0x1d: 0x20800,
                    0x1e: 0x820,
                    0x1f: 0x8000000,
                    0x80000010: 0x20000,
                    0x80000011: 0x800,
                    0x80000012: 0x8020020,
                    0x80000013: 0x20820,
                    0x80000014: 0x20,
                    0x80000015: 0x8020000,
                    0x80000016: 0x8000000,
                    0x80000017: 0x8000820,
                    0x80000018: 0x8020820,
                    0x80000019: 0x8000020,
                    0x8000001a: 0x8000800,
                    0x8000001b: 0x0,
                    0x8000001c: 0x20800,
                    0x8000001d: 0x820,
                    0x8000001e: 0x20020,
                    0x8000001f: 0x8020800,
                  },
                ];
  
                // Masks that select the SBOX input
                var SBOX_MASK = [
                  0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000, 0x0001f800,
                  0x00001f80, 0x000001f8, 0x8000001f,
                ];
  
                /**
                 * DES block cipher algorithm.
                 */
                var DES = (C_algo.DES = BlockCipher.extend({
                  _doReset: function () {
                    // Shortcuts
                    var key = this._key;
                    var keyWords = key.words;
  
                    // Select 56 bits according to PC1
                    var keyBits = [];
                    for (var i = 0; i < 56; i++) {
                      var keyBitPos = PC1[i] - 1;
                      keyBits[i] =
                        (keyWords[keyBitPos >>> 5] >>> (31 - (keyBitPos % 32))) &
                        1;
                    }
  
                    // Assemble 16 subkeys
                    var subKeys = (this._subKeys = []);
                    for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
                      // Create subkey
                      var subKey = (subKeys[nSubKey] = []);
  
                      // Shortcut
                      var bitShift = BIT_SHIFTS[nSubKey];
  
                      // Select 48 bits according to PC2
                      for (var i = 0; i < 24; i++) {
                        // Select from the left 28 key bits
                        subKey[(i / 6) | 0] |=
                          keyBits[(PC2[i] - 1 + bitShift) % 28] << (31 - (i % 6));
  
                        // Select from the right 28 key bits
                        subKey[4 + ((i / 6) | 0)] |=
                          keyBits[28 + ((PC2[i + 24] - 1 + bitShift) % 28)] <<
                          (31 - (i % 6));
                      }
  
                      // Since each subkey is applied to an expanded 32-bit input,
                      // the subkey can be broken into 8 values scaled to 32-bits,
                      // which allows the key to be used without expansion
                      subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
                      for (var i = 1; i < 7; i++) {
                        subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
                      }
                      subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
                    }
  
                    // Compute inverse subkeys
                    var invSubKeys = (this._invSubKeys = []);
                    for (var i = 0; i < 16; i++) {
                      invSubKeys[i] = subKeys[15 - i];
                    }
                  },
  
                  encryptBlock: function (M, offset) {
                    this._doCryptBlock(M, offset, this._subKeys);
                  },
  
                  decryptBlock: function (M, offset) {
                    this._doCryptBlock(M, offset, this._invSubKeys);
                  },
  
                  _doCryptBlock: function (M, offset, subKeys) {
                    // Get input
                    this._lBlock = M[offset];
                    this._rBlock = M[offset + 1];
  
                    // Initial permutation
                    exchangeLR.call(this, 4, 0x0f0f0f0f);
                    exchangeLR.call(this, 16, 0x0000ffff);
                    exchangeRL.call(this, 2, 0x33333333);
                    exchangeRL.call(this, 8, 0x00ff00ff);
                    exchangeLR.call(this, 1, 0x55555555);
  
                    // Rounds
                    for (var round = 0; round < 16; round++) {
                      // Shortcuts
                      var subKey = subKeys[round];
                      var lBlock = this._lBlock;
                      var rBlock = this._rBlock;
  
                      // Feistel function
                      var f = 0;
                      for (var i = 0; i < 8; i++) {
                        f |=
                          SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                      }
                      this._lBlock = rBlock;
                      this._rBlock = lBlock ^ f;
                    }
  
                    // Undo swap from last round
                    var t = this._lBlock;
                    this._lBlock = this._rBlock;
                    this._rBlock = t;
  
                    // Final permutation
                    exchangeLR.call(this, 1, 0x55555555);
                    exchangeRL.call(this, 8, 0x00ff00ff);
                    exchangeRL.call(this, 2, 0x33333333);
                    exchangeLR.call(this, 16, 0x0000ffff);
                    exchangeLR.call(this, 4, 0x0f0f0f0f);
  
                    // Set output
                    M[offset] = this._lBlock;
                    M[offset + 1] = this._rBlock;
                  },
  
                  keySize: 64 / 32,
  
                  ivSize: 64 / 32,
  
                  blockSize: 64 / 32,
                }));
  
                // Swap bits across the left and right words
                function exchangeLR(offset, mask) {
                  var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
                  this._rBlock ^= t;
                  this._lBlock ^= t << offset;
                }
  
                function exchangeRL(offset, mask) {
                  var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
                  this._lBlock ^= t;
                  this._rBlock ^= t << offset;
                }
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
                 */
                C.DES = BlockCipher._createHelper(DES);
  
                /**
                 * Triple-DES block cipher algorithm.
                 */
                var TripleDES = (C_algo.TripleDES = BlockCipher.extend({
                  _doReset: function () {
                    // Shortcuts
                    var key = this._key;
                    var keyWords = key.words;
                    // Make sure the key length is valid (64, 128 or >= 192 bit)
                    if (
                      keyWords.length !== 2 &&
                      keyWords.length !== 4 &&
                      keyWords.length < 6
                    ) {
                      throw new Error(
                        "Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192."
                      );
                    }
  
                    // Extend the key according to the keying options defined in 3DES standard
                    var key1 = keyWords.slice(0, 2);
                    var key2 =
                      keyWords.length < 4
                        ? keyWords.slice(0, 2)
                        : keyWords.slice(2, 4);
                    var key3 =
                      keyWords.length < 6
                        ? keyWords.slice(0, 2)
                        : keyWords.slice(4, 6);
  
                    // Create DES instances
                    this._des1 = DES.createEncryptor(WordArray.create(key1));
                    this._des2 = DES.createEncryptor(WordArray.create(key2));
                    this._des3 = DES.createEncryptor(WordArray.create(key3));
                  },
  
                  encryptBlock: function (M, offset) {
                    this._des1.encryptBlock(M, offset);
                    this._des2.decryptBlock(M, offset);
                    this._des3.encryptBlock(M, offset);
                  },
  
                  decryptBlock: function (M, offset) {
                    this._des3.decryptBlock(M, offset);
                    this._des2.encryptBlock(M, offset);
                    this._des1.decryptBlock(M, offset);
                  },
  
                  keySize: 192 / 32,
  
                  ivSize: 64 / 32,
  
                  blockSize: 64 / 32,
                }));
  
                /**
                 * Shortcut functions to the cipher's object interface.
                 *
                 * @example
                 *
                 *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
                 *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
                 */
                C.TripleDES = BlockCipher._createHelper(TripleDES);
              })();
  
              return CryptoJS.TripleDES;
            });
          },
          {
            "./cipher-core": 195,
            "./core": 196,
            "./enc-base64": 197,
            "./evpkdf": 199,
            "./md5": 204,
          },
        ],
        227: [
          function (require, module, exports) {
            (function (root, factory) {
              if (typeof exports === "object") {
                // CommonJS
                module.exports = exports = factory(require("./core"));
              } else if (typeof define === "function" && define.amd) {
                // AMD
                define(["./core"], factory);
              } else {
                // Global (browser)
                factory(root.CryptoJS);
              }
            })(this, function (CryptoJS) {
              (function (undefined) {
                // Shortcuts
                var C = CryptoJS;
                var C_lib = C.lib;
                var Base = C_lib.Base;
                var X32WordArray = C_lib.WordArray;
  
                /**
                 * x64 namespace.
                 */
                var C_x64 = (C.x64 = {});
  
                /**
                 * A 64-bit word.
                 */
                var X64Word = (C_x64.Word = Base.extend({
                  /**
                   * Initializes a newly created 64-bit word.
                   *
                   * @param {number} high The high 32 bits.
                   * @param {number} low The low 32 bits.
                   *
                   * @example
                   *
                   *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
                   */
                  init: function (high, low) {
                    this.high = high;
                    this.low = low;
                  },
  
                  /**
                   * Bitwise NOTs this word.
                   *
                   * @return {X64Word} A new x64-Word object after negating.
                   *
                   * @example
                   *
                   *     var negated = x64Word.not();
                   */
                  // not: function () {
                  // var high = ~this.high;
                  // var low = ~this.low;
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Bitwise ANDs this word with the passed word.
                   *
                   * @param {X64Word} word The x64-Word to AND with this word.
                   *
                   * @return {X64Word} A new x64-Word object after ANDing.
                   *
                   * @example
                   *
                   *     var anded = x64Word.and(anotherX64Word);
                   */
                  // and: function (word) {
                  // var high = this.high & word.high;
                  // var low = this.low & word.low;
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Bitwise ORs this word with the passed word.
                   *
                   * @param {X64Word} word The x64-Word to OR with this word.
                   *
                   * @return {X64Word} A new x64-Word object after ORing.
                   *
                   * @example
                   *
                   *     var ored = x64Word.or(anotherX64Word);
                   */
                  // or: function (word) {
                  // var high = this.high | word.high;
                  // var low = this.low | word.low;
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Bitwise XORs this word with the passed word.
                   *
                   * @param {X64Word} word The x64-Word to XOR with this word.
                   *
                   * @return {X64Word} A new x64-Word object after XORing.
                   *
                   * @example
                   *
                   *     var xored = x64Word.xor(anotherX64Word);
                   */
                  // xor: function (word) {
                  // var high = this.high ^ word.high;
                  // var low = this.low ^ word.low;
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Shifts this word n bits to the left.
                   *
                   * @param {number} n The number of bits to shift.
                   *
                   * @return {X64Word} A new x64-Word object after shifting.
                   *
                   * @example
                   *
                   *     var shifted = x64Word.shiftL(25);
                   */
                  // shiftL: function (n) {
                  // if (n < 32) {
                  // var high = (this.high << n) | (this.low >>> (32 - n));
                  // var low = this.low << n;
                  // } else {
                  // var high = this.low << (n - 32);
                  // var low = 0;
                  // }
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Shifts this word n bits to the right.
                   *
                   * @param {number} n The number of bits to shift.
                   *
                   * @return {X64Word} A new x64-Word object after shifting.
                   *
                   * @example
                   *
                   *     var shifted = x64Word.shiftR(7);
                   */
                  // shiftR: function (n) {
                  // if (n < 32) {
                  // var low = (this.low >>> n) | (this.high << (32 - n));
                  // var high = this.high >>> n;
                  // } else {
                  // var low = this.high >>> (n - 32);
                  // var high = 0;
                  // }
  
                  // return X64Word.create(high, low);
                  // },
  
                  /**
                   * Rotates this word n bits to the left.
                   *
                   * @param {number} n The number of bits to rotate.
                   *
                   * @return {X64Word} A new x64-Word object after rotating.
                   *
                   * @example
                   *
                   *     var rotated = x64Word.rotL(25);
                   */
                  // rotL: function (n) {
                  // return this.shiftL(n).or(this.shiftR(64 - n));
                  // },
  
                  /**
                   * Rotates this word n bits to the right.
                   *
                   * @param {number} n The number of bits to rotate.
                   *
                   * @return {X64Word} A new x64-Word object after rotating.
                   *
                   * @example
                   *
                   *     var rotated = x64Word.rotR(7);
                   */
                  // rotR: function (n) {
                  // return this.shiftR(n).or(this.shiftL(64 - n));
                  // },
  
                  /**
                   * Adds this word with the passed word.
                   *
                   * @param {X64Word} word The x64-Word to add with this word.
                   *
                   * @return {X64Word} A new x64-Word object after adding.
                   *
                   * @example
                   *
                   *     var added = x64Word.add(anotherX64Word);
                   */
                  // add: function (word) {
                  // var low = (this.low + word.low) | 0;
                  // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
                  // var high = (this.high + word.high + carry) | 0;
  
                  // return X64Word.create(high, low);
                  // }
                }));
  
                /**
                 * An array of 64-bit words.
                 *
                 * @property {Array} words The array of CryptoJS.x64.Word objects.
                 * @property {number} sigBytes The number of significant bytes in this word array.
                 */
                var X64WordArray = (C_x64.WordArray = Base.extend({
                  /**
                   * Initializes a newly created word array.
                   *
                   * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
                   * @param {number} sigBytes (Optional) The number of significant bytes in the words.
                   *
                   * @example
                   *
                   *     var wordArray = CryptoJS.x64.WordArray.create();
                   *
                   *     var wordArray = CryptoJS.x64.WordArray.create([
                   *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
                   *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
                   *     ]);
                   *
                   *     var wordArray = CryptoJS.x64.WordArray.create([
                   *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
                   *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
                   *     ], 10);
                   */
                  init: function (words, sigBytes) {
                    words = this.words = words || [];
  
                    if (sigBytes != undefined) {
                      this.sigBytes = sigBytes;
                    } else {
                      this.sigBytes = words.length * 8;
                    }
                  },
  
                  /**
                   * Converts this 64-bit word array to a 32-bit word array.
                   *
                   * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
                   *
                   * @example
                   *
                   *     var x32WordArray = x64WordArray.toX32();
                   */
                  toX32: function () {
                    // Shortcuts
                    var x64Words = this.words;
                    var x64WordsLength = x64Words.length;
  
                    // Convert
                    var x32Words = [];
                    for (var i = 0; i < x64WordsLength; i++) {
                      var x64Word = x64Words[i];
                      x32Words.push(x64Word.high);
                      x32Words.push(x64Word.low);
                    }
  
                    return X32WordArray.create(x32Words, this.sigBytes);
                  },
  
                  /**
                   * Creates a copy of this word array.
                   *
                   * @return {X64WordArray} The clone.
                   *
                   * @example
                   *
                   *     var clone = x64WordArray.clone();
                   */
                  clone: function () {
                    var clone = Base.clone.call(this);
  
                    // Clone "words" array
                    var words = (clone.words = this.words.slice(0));
  
                    // Clone each X64Word object
                    var wordsLength = words.length;
                    for (var i = 0; i < wordsLength; i++) {
                      words[i] = words[i].clone();
                    }
  
                    return clone;
                  },
                }));
              })();
  
              return CryptoJS;
            });
          },
          { "./core": 196 },
        ],
        228: [
          function (require, module, exports) {
            var objectKeys = require("object-keys");
            var isArguments = require("is-arguments");
            var is = require("object-is");
            var isRegex = require("is-regex");
            var flags = require("regexp.prototype.flags");
            var isDate = require("is-date-object");
  
            var getTime = Date.prototype.getTime;
  
            function deepEqual(actual, expected, options) {
              var opts = options || {};
  
              // 7.1. All identical values are equivalent, as determined by ===.
              if (opts.strict ? is(actual, expected) : actual === expected) {
                return true;
              }
  
              // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
              if (
                !actual ||
                !expected ||
                (typeof actual !== "object" && typeof expected !== "object")
              ) {
                return opts.strict ? is(actual, expected) : actual == expected;
              }
  
              /*
               * 7.4. For all other Object pairs, including Array objects, equivalence is
               * determined by having the same number of owned properties (as verified
               * with Object.prototype.hasOwnProperty.call), the same set of keys
               * (although not necessarily the same order), equivalent values for every
               * corresponding key, and an identical 'prototype' property. Note: this
               * accounts for both named and indexed properties on Arrays.
               */
              // eslint-disable-next-line no-use-before-define
              return objEquiv(actual, expected, opts);
            }
  
            function isUndefinedOrNull(value) {
              return value === null || value === undefined;
            }
  
            function isBuffer(x) {
              if (!x || typeof x !== "object" || typeof x.length !== "number") {
                return false;
              }
              if (typeof x.copy !== "function" || typeof x.slice !== "function") {
                return false;
              }
              if (x.length > 0 && typeof x[0] !== "number") {
                return false;
              }
              return true;
            }
  
            function objEquiv(a, b, opts) {
              /* eslint max-statements: [2, 50] */
              var i, key;
              if (typeof a !== typeof b) {
                return false;
              }
              if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) {
                return false;
              }
  
              // an identical 'prototype' property.
              if (a.prototype !== b.prototype) {
                return false;
              }
  
              if (isArguments(a) !== isArguments(b)) {
                return false;
              }
  
              var aIsRegex = isRegex(a);
              var bIsRegex = isRegex(b);
              if (aIsRegex !== bIsRegex) {
                return false;
              }
              if (aIsRegex || bIsRegex) {
                return a.source === b.source && flags(a) === flags(b);
              }
  
              if (isDate(a) && isDate(b)) {
                return getTime.call(a) === getTime.call(b);
              }
  
              var aIsBuffer = isBuffer(a);
              var bIsBuffer = isBuffer(b);
              if (aIsBuffer !== bIsBuffer) {
                return false;
              }
              if (aIsBuffer || bIsBuffer) {
                // && would work too, because both are true or both false here
                if (a.length !== b.length) {
                  return false;
                }
                for (i = 0; i < a.length; i++) {
                  if (a[i] !== b[i]) {
                    return false;
                  }
                }
                return true;
              }
  
              if (typeof a !== typeof b) {
                return false;
              }
  
              try {
                var ka = objectKeys(a);
                var kb = objectKeys(b);
              } catch (e) {
                // happens when one is a string literal and the other isn't
                return false;
              }
              // having the same number of owned properties (keys incorporates hasOwnProperty)
              if (ka.length !== kb.length) {
                return false;
              }
  
              // the same set of keys (although not necessarily the same order),
              ka.sort();
              kb.sort();
              // ~~~cheap key test
              for (i = ka.length - 1; i >= 0; i--) {
                if (ka[i] != kb[i]) {
                  return false;
                }
              }
              // equivalent values for every corresponding key, and ~~~possibly expensive deep test
              for (i = ka.length - 1; i >= 0; i--) {
                key = ka[i];
                if (!deepEqual(a[key], b[key], opts)) {
                  return false;
                }
              }
  
              return true;
            }
  
            module.exports = deepEqual;
          },
          {
            "is-arguments": 241,
            "is-date-object": 243,
            "is-regex": 244,
            "object-is": 253,
            "object-keys": 257,
            "regexp.prototype.flags": 276,
          },
        ],
        229: [
          function (require, module, exports) {
            "use strict";
  
            var keys = require("object-keys");
            var hasSymbols =
              typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
  
            var toStr = Object.prototype.toString;
            var concat = Array.prototype.concat;
            var origDefineProperty = Object.defineProperty;
  
            var isFunction = function (fn) {
              return (
                typeof fn === "function" && toStr.call(fn) === "[object Function]"
              );
            };
  
            var arePropertyDescriptorsSupported = function () {
              var obj = {};
              try {
                origDefineProperty(obj, "x", { enumerable: false, value: obj });
                // eslint-disable-next-line no-unused-vars, no-restricted-syntax
                for (var _ in obj) {
                  // jscs:ignore disallowUnusedVariables
                  return false;
                }
                return obj.x === obj;
              } catch (e) {
                /* this is IE 8. */
                return false;
              }
            };
            var supportsDescriptors =
              origDefineProperty && arePropertyDescriptorsSupported();
  
            var defineProperty = function (object, name, value, predicate) {
              if (name in object && (!isFunction(predicate) || !predicate())) {
                return;
              }
              if (supportsDescriptors) {
                origDefineProperty(object, name, {
                  configurable: true,
                  enumerable: false,
                  value: value,
                  writable: true,
                });
              } else {
                object[name] = value;
              }
            };
  
            var defineProperties = function (object, map) {
              var predicates = arguments.length > 2 ? arguments[2] : {};
              var props = keys(map);
              if (hasSymbols) {
                props = concat.call(props, Object.getOwnPropertySymbols(map));
              }
              for (var i = 0; i < props.length; i += 1) {
                defineProperty(
                  object,
                  props[i],
                  map[props[i]],
                  predicates[props[i]]
                );
              }
            };
  
            defineProperties.supportsDescriptors = !!supportsDescriptors;
  
            module.exports = defineProperties;
          },
          { "object-keys": 257 },
        ],
        230: [
          function (require, module, exports) {
            "use strict";
  
            var INITIAL_STATE = 1;
            var FAIL_STATE = 0;
            /**
             * A StateMachine represents a deterministic finite automaton.
             * It can perform matches over a sequence of values, similar to a regular expression.
             */
  
            class StateMachine {
              constructor(dfa) {
                this.stateTable = dfa.stateTable;
                this.accepting = dfa.accepting;
                this.tags = dfa.tags;
              }
              /**
               * Returns an iterable object that yields pattern matches over the input sequence.
               * Matches are of the form [startIndex, endIndex, tags].
               */
  
              match(str) {
                var self = this;
                return {
                  *[Symbol.iterator]() {
                    var state = INITIAL_STATE;
                    var startRun = null;
                    var lastAccepting = null;
                    var lastState = null;
  
                    for (var p = 0; p < str.length; p++) {
                      var c = str[p];
                      lastState = state;
                      state = self.stateTable[state][c];
  
                      if (state === FAIL_STATE) {
                        // yield the last match if any
                        if (
                          startRun != null &&
                          lastAccepting != null &&
                          lastAccepting >= startRun
                        ) {
                          yield [startRun, lastAccepting, self.tags[lastState]];
                        } // reset the state as if we started over from the initial state
  
                        state = self.stateTable[INITIAL_STATE][c];
                        startRun = null;
                      } // start a run if not in the failure state
  
                      if (state !== FAIL_STATE && startRun == null) {
                        startRun = p;
                      } // if accepting, mark the potential match end
  
                      if (self.accepting[state]) {
                        lastAccepting = p;
                      } // reset the state to the initial state if we get into the failure state
  
                      if (state === FAIL_STATE) {
                        state = INITIAL_STATE;
                      }
                    } // yield the last match if any
  
                    if (
                      startRun != null &&
                      lastAccepting != null &&
                      lastAccepting >= startRun
                    ) {
                      yield [startRun, lastAccepting, self.tags[state]];
                    }
                  },
                };
              }
              /**
               * For each match over the input sequence, action functions matching
               * the tag definitions in the input pattern are called with the startIndex,
               * endIndex, and sub-match sequence.
               */
  
              apply(str, actions) {
                for (var [start, end, tags] of this.match(str)) {
                  for (var tag of tags) {
                    if (typeof actions[tag] === "function") {
                      actions[tag](start, end, str.slice(start, end + 1));
                    }
                  }
                }
              }
            }
  
            module.exports = StateMachine;
          },
          {},
        ],
        231: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            var objectCreate = Object.create || objectCreatePolyfill;
            var objectKeys = Object.keys || objectKeysPolyfill;
            var bind = Function.prototype.bind || functionBindPolyfill;
  
            function EventEmitter() {
              if (
                !this._events ||
                !Object.prototype.hasOwnProperty.call(this, "_events")
              ) {
                this._events = objectCreate(null);
                this._eventsCount = 0;
              }
  
              this._maxListeners = this._maxListeners || undefined;
            }
            module.exports = EventEmitter;
  
            // Backwards-compat with node 0.10.x
            EventEmitter.EventEmitter = EventEmitter;
  
            EventEmitter.prototype._events = undefined;
            EventEmitter.prototype._maxListeners = undefined;
  
            // By default EventEmitters will print a warning if more than 10 listeners are
            // added to it. This is a useful default which helps finding memory leaks.
            var defaultMaxListeners = 10;
  
            var hasDefineProperty;
            try {
              var o = {};
              if (Object.defineProperty)
                Object.defineProperty(o, "x", { value: 0 });
              hasDefineProperty = o.x === 0;
            } catch (err) {
              hasDefineProperty = false;
            }
            if (hasDefineProperty) {
              Object.defineProperty(EventEmitter, "defaultMaxListeners", {
                enumerable: true,
                get: function () {
                  return defaultMaxListeners;
                },
                set: function (arg) {
                  // check whether the input is a positive number (whose value is zero or
                  // greater and not a NaN).
                  if (typeof arg !== "number" || arg < 0 || arg !== arg)
                    throw new TypeError(
                      '"defaultMaxListeners" must be a positive number'
                    );
                  defaultMaxListeners = arg;
                },
              });
            } else {
              EventEmitter.defaultMaxListeners = defaultMaxListeners;
            }
  
            // Obviously not all Emitters should be limited to 10. This function allows
            // that to be increased. Set to zero for unlimited.
            EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
              if (typeof n !== "number" || n < 0 || isNaN(n))
                throw new TypeError('"n" argument must be a positive number');
              this._maxListeners = n;
              return this;
            };
  
            function $getMaxListeners(that) {
              if (that._maxListeners === undefined)
                return EventEmitter.defaultMaxListeners;
              return that._maxListeners;
            }
  
            EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
              return $getMaxListeners(this);
            };
  
            // These standalone emit* functions are used to optimize calling of event
            // handlers for fast cases because emit() itself often has a variable number of
            // arguments and can be deoptimized because of that. These functions always have
            // the same number of arguments and thus do not get deoptimized, so the code
            // inside them can execute faster.
            function emitNone(handler, isFn, self) {
              if (isFn) handler.call(self);
              else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for (var i = 0; i < len; ++i) listeners[i].call(self);
              }
            }
            function emitOne(handler, isFn, self, arg1) {
              if (isFn) handler.call(self, arg1);
              else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for (var i = 0; i < len; ++i) listeners[i].call(self, arg1);
              }
            }
            function emitTwo(handler, isFn, self, arg1, arg2) {
              if (isFn) handler.call(self, arg1, arg2);
              else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for (var i = 0; i < len; ++i) listeners[i].call(self, arg1, arg2);
              }
            }
            function emitThree(handler, isFn, self, arg1, arg2, arg3) {
              if (isFn) handler.call(self, arg1, arg2, arg3);
              else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for (var i = 0; i < len; ++i)
                  listeners[i].call(self, arg1, arg2, arg3);
              }
            }
  
            function emitMany(handler, isFn, self, args) {
              if (isFn) handler.apply(self, args);
              else {
                var len = handler.length;
                var listeners = arrayClone(handler, len);
                for (var i = 0; i < len; ++i) listeners[i].apply(self, args);
              }
            }
  
            EventEmitter.prototype.emit = function emit(type) {
              var er, handler, len, args, i, events;
              var doError = type === "error";
  
              events = this._events;
              if (events) doError = doError && events.error == null;
              else if (!doError) return false;
  
              // If there is no 'error' event listener then throw.
              if (doError) {
                if (arguments.length > 1) er = arguments[1];
                if (er instanceof Error) {
                  throw er; // Unhandled 'error' event
                } else {
                  // At least give some kind of context to the user
                  var err = new Error('Unhandled "error" event. (' + er + ")");
                  err.context = er;
                  throw err;
                }
                return false;
              }
  
              handler = events[type];
  
              if (!handler) return false;
  
              var isFn = typeof handler === "function";
              len = arguments.length;
              switch (len) {
                // fast cases
                case 1:
                  emitNone(handler, isFn, this);
                  break;
                case 2:
                  emitOne(handler, isFn, this, arguments[1]);
                  break;
                case 3:
                  emitTwo(handler, isFn, this, arguments[1], arguments[2]);
                  break;
                case 4:
                  emitThree(
                    handler,
                    isFn,
                    this,
                    arguments[1],
                    arguments[2],
                    arguments[3]
                  );
                  break;
                // slower
                default:
                  args = new Array(len - 1);
                  for (i = 1; i < len; i++) args[i - 1] = arguments[i];
                  emitMany(handler, isFn, this, args);
              }
  
              return true;
            };
  
            function _addListener(target, type, listener, prepend) {
              var m;
              var events;
              var existing;
  
              if (typeof listener !== "function")
                throw new TypeError('"listener" argument must be a function');
  
              events = target._events;
              if (!events) {
                events = target._events = objectCreate(null);
                target._eventsCount = 0;
              } else {
                // To avoid recursion in the case that type === "newListener"! Before
                // adding it to the listeners, first emit "newListener".
                if (events.newListener) {
                  target.emit(
                    "newListener",
                    type,
                    listener.listener ? listener.listener : listener
                  );
  
                  // Re-assign `events` because a newListener handler could have caused the
                  // this._events to be assigned to a new object
                  events = target._events;
                }
                existing = events[type];
              }
  
              if (!existing) {
                // Optimize the case of one listener. Don't need the extra array object.
                existing = events[type] = listener;
                ++target._eventsCount;
              } else {
                if (typeof existing === "function") {
                  // Adding the second element, need to change to array.
                  existing = events[type] = prepend
                    ? [listener, existing]
                    : [existing, listener];
                } else {
                  // If we've already got an array, just append.
                  if (prepend) {
                    existing.unshift(listener);
                  } else {
                    existing.push(listener);
                  }
                }
  
                // Check for listener leak
                if (!existing.warned) {
                  m = $getMaxListeners(target);
                  if (m && m > 0 && existing.length > m) {
                    existing.warned = true;
                    var w = new Error(
                      "Possible EventEmitter memory leak detected. " +
                        existing.length +
                        ' "' +
                        String(type) +
                        '" listeners ' +
                        "added. Use emitter.setMaxListeners() to " +
                        "increase limit."
                    );
                    w.name = "MaxListenersExceededWarning";
                    w.emitter = target;
                    w.type = type;
                    w.count = existing.length;
                    if (typeof console === "object" && console.warn) {
                      console.warn("%s: %s", w.name, w.message);
                    }
                  }
                }
              }
  
              return target;
            }
  
            EventEmitter.prototype.addListener = function addListener(
              type,
              listener
            ) {
              return _addListener(this, type, listener, false);
            };
  
            EventEmitter.prototype.on = EventEmitter.prototype.addListener;
  
            EventEmitter.prototype.prependListener = function prependListener(
              type,
              listener
            ) {
              return _addListener(this, type, listener, true);
            };
  
            function onceWrapper() {
              if (!this.fired) {
                this.target.removeListener(this.type, this.wrapFn);
                this.fired = true;
                switch (arguments.length) {
                  case 0:
                    return this.listener.call(this.target);
                  case 1:
                    return this.listener.call(this.target, arguments[0]);
                  case 2:
                    return this.listener.call(
                      this.target,
                      arguments[0],
                      arguments[1]
                    );
                  case 3:
                    return this.listener.call(
                      this.target,
                      arguments[0],
                      arguments[1],
                      arguments[2]
                    );
                  default:
                    var args = new Array(arguments.length);
                    for (var i = 0; i < args.length; ++i) args[i] = arguments[i];
                    this.listener.apply(this.target, args);
                }
              }
            }
  
            function _onceWrap(target, type, listener) {
              var state = {
                fired: false,
                wrapFn: undefined,
                target: target,
                type: type,
                listener: listener,
              };
              var wrapped = bind.call(onceWrapper, state);
              wrapped.listener = listener;
              state.wrapFn = wrapped;
              return wrapped;
            }
  
            EventEmitter.prototype.once = function once(type, listener) {
              if (typeof listener !== "function")
                throw new TypeError('"listener" argument must be a function');
              this.on(type, _onceWrap(this, type, listener));
              return this;
            };
  
            EventEmitter.prototype.prependOnceListener =
              function prependOnceListener(type, listener) {
                if (typeof listener !== "function")
                  throw new TypeError('"listener" argument must be a function');
                this.prependListener(type, _onceWrap(this, type, listener));
                return this;
              };
  
            // Emits a 'removeListener' event if and only if the listener was removed.
            EventEmitter.prototype.removeListener = function removeListener(
              type,
              listener
            ) {
              var list, events, position, i, originalListener;
  
              if (typeof listener !== "function")
                throw new TypeError('"listener" argument must be a function');
  
              events = this._events;
              if (!events) return this;
  
              list = events[type];
              if (!list) return this;
  
              if (list === listener || list.listener === listener) {
                if (--this._eventsCount === 0) this._events = objectCreate(null);
                else {
                  delete events[type];
                  if (events.removeListener)
                    this.emit("removeListener", type, list.listener || listener);
                }
              } else if (typeof list !== "function") {
                position = -1;
  
                for (i = list.length - 1; i >= 0; i--) {
                  if (list[i] === listener || list[i].listener === listener) {
                    originalListener = list[i].listener;
                    position = i;
                    break;
                  }
                }
  
                if (position < 0) return this;
  
                if (position === 0) list.shift();
                else spliceOne(list, position);
  
                if (list.length === 1) events[type] = list[0];
  
                if (events.removeListener)
                  this.emit("removeListener", type, originalListener || listener);
              }
  
              return this;
            };
  
            EventEmitter.prototype.removeAllListeners =
              function removeAllListeners(type) {
                var listeners, events, i;
  
                events = this._events;
                if (!events) return this;
  
                // not listening for removeListener, no need to emit
                if (!events.removeListener) {
                  if (arguments.length === 0) {
                    this._events = objectCreate(null);
                    this._eventsCount = 0;
                  } else if (events[type]) {
                    if (--this._eventsCount === 0)
                      this._events = objectCreate(null);
                    else delete events[type];
                  }
                  return this;
                }
  
                // emit removeListener for all listeners on all events
                if (arguments.length === 0) {
                  var keys = objectKeys(events);
                  var key;
                  for (i = 0; i < keys.length; ++i) {
                    key = keys[i];
                    if (key === "removeListener") continue;
                    this.removeAllListeners(key);
                  }
                  this.removeAllListeners("removeListener");
                  this._events = objectCreate(null);
                  this._eventsCount = 0;
                  return this;
                }
  
                listeners = events[type];
  
                if (typeof listeners === "function") {
                  this.removeListener(type, listeners);
                } else if (listeners) {
                  // LIFO order
                  for (i = listeners.length - 1; i >= 0; i--) {
                    this.removeListener(type, listeners[i]);
                  }
                }
  
                return this;
              };
  
            function _listeners(target, type, unwrap) {
              var events = target._events;
  
              if (!events) return [];
  
              var evlistener = events[type];
              if (!evlistener) return [];
  
              if (typeof evlistener === "function")
                return unwrap
                  ? [evlistener.listener || evlistener]
                  : [evlistener];
  
              return unwrap
                ? unwrapListeners(evlistener)
                : arrayClone(evlistener, evlistener.length);
            }
  
            EventEmitter.prototype.listeners = function listeners(type) {
              return _listeners(this, type, true);
            };
  
            EventEmitter.prototype.rawListeners = function rawListeners(type) {
              return _listeners(this, type, false);
            };
  
            EventEmitter.listenerCount = function (emitter, type) {
              if (typeof emitter.listenerCount === "function") {
                return emitter.listenerCount(type);
              } else {
                return listenerCount.call(emitter, type);
              }
            };
  
            EventEmitter.prototype.listenerCount = listenerCount;
            function listenerCount(type) {
              var events = this._events;
  
              if (events) {
                var evlistener = events[type];
  
                if (typeof evlistener === "function") {
                  return 1;
                } else if (evlistener) {
                  return evlistener.length;
                }
              }
  
              return 0;
            }
  
            EventEmitter.prototype.eventNames = function eventNames() {
              return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
            };
  
            // About 1.5x faster than the two-arg version of Array#splice().
            function spliceOne(list, index) {
              for (
                var i = index, k = i + 1, n = list.length;
                k < n;
                i += 1, k += 1
              )
                list[i] = list[k];
              list.pop();
            }
  
            function arrayClone(arr, n) {
              var copy = new Array(n);
              for (var i = 0; i < n; ++i) copy[i] = arr[i];
              return copy;
            }
  
            function unwrapListeners(arr) {
              var ret = new Array(arr.length);
              for (var i = 0; i < ret.length; ++i) {
                ret[i] = arr[i].listener || arr[i];
              }
              return ret;
            }
  
            function objectCreatePolyfill(proto) {
              var F = function () {};
              F.prototype = proto;
              return new F();
            }
            function objectKeysPolyfill(obj) {
              var keys = [];
              for (var k in obj)
                if (Object.prototype.hasOwnProperty.call(obj, k)) {
                  keys.push(k);
                }
              return k;
            }
            function functionBindPolyfill(context) {
              var fn = this;
              return function () {
                return fn.apply(context, arguments);
              };
            }
          },
          {},
        ],
        232: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                "use strict";
                function _interopDefault(ex) {
                  return ex && typeof ex === "object" && "default" in ex
                    ? ex["default"]
                    : ex;
                }
                var r = _interopDefault(require("restructure"));
                var _Object$getOwnPropertyDescriptor = _interopDefault(
                  require("babel-runtime/core-js/object/get-own-property-descriptor")
                );
                var _getIterator = _interopDefault(
                  require("babel-runtime/core-js/get-iterator")
                );
                var _Object$freeze = _interopDefault(
                  require("babel-runtime/core-js/object/freeze")
                );
                var _typeof = _interopDefault(
                  require("babel-runtime/helpers/typeof")
                );
                var _Object$keys = _interopDefault(
                  require("babel-runtime/core-js/object/keys")
                );
                var _Object$defineProperty = _interopDefault(
                  require("babel-runtime/core-js/object/define-property")
                );
                var _classCallCheck = _interopDefault(
                  require("babel-runtime/helpers/classCallCheck")
                );
                var _createClass = _interopDefault(
                  require("babel-runtime/helpers/createClass")
                );
                var _Map = _interopDefault(require("babel-runtime/core-js/map"));
                var _possibleConstructorReturn = _interopDefault(
                  require("babel-runtime/helpers/possibleConstructorReturn")
                );
                var _inherits = _interopDefault(
                  require("babel-runtime/helpers/inherits")
                );
                var restructure_src_utils = require("restructure/src/utils");
                var _Object$defineProperties = _interopDefault(
                  require("babel-runtime/core-js/object/define-properties")
                );
                var isEqual = _interopDefault(require("deep-equal"));
                var _Object$assign = _interopDefault(
                  require("babel-runtime/core-js/object/assign")
                );
                var _String$fromCodePoint = _interopDefault(
                  require("babel-runtime/core-js/string/from-code-point")
                );
                var _Array$from = _interopDefault(
                  require("babel-runtime/core-js/array/from")
                );
                var _Set = _interopDefault(require("babel-runtime/core-js/set"));
                var unicode = _interopDefault(require("unicode-properties"));
                var UnicodeTrie = _interopDefault(require("unicode-trie"));
                var StateMachine = _interopDefault(require("dfa"));
                var _Number$EPSILON = _interopDefault(
                  require("babel-runtime/core-js/number/epsilon")
                );
                var cloneDeep = _interopDefault(require("clone"));
                var _Promise = _interopDefault(
                  require("babel-runtime/core-js/promise")
                );
                var inflate = _interopDefault(require("tiny-inflate"));
                var brotli = _interopDefault(require("brotli/decompress"));
                var fs = require("fs");
                var fontkit = {};
                fontkit.logErrors = false;
                var formats = [];
                fontkit.registerFormat = function (format) {
                  formats.push(format);
                };
                fontkit.openSync = function (filename, postscriptName) {
                  var buffer = fs.readFileSync(filename);
                  return fontkit.create(buffer, postscriptName);
                };
                fontkit.open = function (filename, postscriptName, callback) {
                  if (typeof postscriptName === "function") {
                    callback = postscriptName;
                    postscriptName = null;
                  }
                  fs.readFile(filename, function (err, buffer) {
                    if (err) {
                      return callback(err);
                    }
                    try {
                      var font = fontkit.create(buffer, postscriptName);
                    } catch (e) {
                      return callback(e);
                    }
                    return callback(null, font);
                  });
                  return;
                };
                fontkit.create = function (buffer, postscriptName) {
                  for (var i = 0; i < formats.length; i++) {
                    var format = formats[i];
                    if (format.probe(buffer)) {
                      var font = new format(new r.DecodeStream(buffer));
                      if (postscriptName) {
                        return font.getFont(postscriptName);
                      }
                      return font;
                    }
                  }
                  throw new Error("Unknown font format");
                };
                fontkit.defaultLanguage = "en";
                fontkit.setDefaultLanguage = function () {
                  var lang =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : "en";
                  fontkit.defaultLanguage = lang;
                };
                function cache(target, key, descriptor) {
                  if (descriptor.get) {
                    var get = descriptor.get;
                    descriptor.get = function () {
                      var value = get.call(this);
                      _Object$defineProperty(this, key, { value: value });
                      return value;
                    };
                  } else if (typeof descriptor.value === "function") {
                    var fn = descriptor.value;
                    return {
                      get: function get() {
                        var cache = new _Map();
                        function memoized() {
                          for (
                            var _len = arguments.length,
                              args = Array(_len),
                              _key = 0;
                            _key < _len;
                            _key++
                          ) {
                            args[_key] = arguments[_key];
                          }
                          var key = args.length > 0 ? args[0] : "value";
                          if (cache.has(key)) {
                            return cache.get(key);
                          }
                          var result = fn.apply(this, args);
                          cache.set(key, result);
                          return result;
                        }
                        _Object$defineProperty(this, key, { value: memoized });
                        return memoized;
                      },
                    };
                  }
                }
                var SubHeader = new r.Struct({
                  firstCode: r.uint16,
                  entryCount: r.uint16,
                  idDelta: r.int16,
                  idRangeOffset: r.uint16,
                });
                var CmapGroup = new r.Struct({
                  startCharCode: r.uint32,
                  endCharCode: r.uint32,
                  glyphID: r.uint32,
                });
                var UnicodeValueRange = new r.Struct({
                  startUnicodeValue: r.uint24,
                  additionalCount: r.uint8,
                });
                var UVSMapping = new r.Struct({
                  unicodeValue: r.uint24,
                  glyphID: r.uint16,
                });
                var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
                var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);
                var VarSelectorRecord = new r.Struct({
                  varSelector: r.uint24,
                  defaultUVS: new r.Pointer(r.uint32, DefaultUVS, {
                    type: "parent",
                  }),
                  nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, {
                    type: "parent",
                  }),
                });
                var CmapSubtable = new r.VersionedStruct(r.uint16, {
                  0: {
                    length: r.uint16,
                    language: r.uint16,
                    codeMap: new r.LazyArray(r.uint8, 256),
                  },
                  2: {
                    length: r.uint16,
                    language: r.uint16,
                    subHeaderKeys: new r.Array(r.uint16, 256),
                    subHeaderCount: function subHeaderCount(t) {
                      return Math.max.apply(Math, t.subHeaderKeys);
                    },
                    subHeaders: new r.LazyArray(SubHeader, "subHeaderCount"),
                    glyphIndexArray: new r.LazyArray(r.uint16, "subHeaderCount"),
                  },
                  4: {
                    length: r.uint16,
                    language: r.uint16,
                    segCountX2: r.uint16,
                    segCount: function segCount(t) {
                      return t.segCountX2 >> 1;
                    },
                    searchRange: r.uint16,
                    entrySelector: r.uint16,
                    rangeShift: r.uint16,
                    endCode: new r.LazyArray(r.uint16, "segCount"),
                    reservedPad: new r.Reserved(r.uint16),
                    startCode: new r.LazyArray(r.uint16, "segCount"),
                    idDelta: new r.LazyArray(r.int16, "segCount"),
                    idRangeOffset: new r.LazyArray(r.uint16, "segCount"),
                    glyphIndexArray: new r.LazyArray(r.uint16, function (t) {
                      return (t.length - t._currentOffset) / 2;
                    }),
                  },
                  6: {
                    length: r.uint16,
                    language: r.uint16,
                    firstCode: r.uint16,
                    entryCount: r.uint16,
                    glyphIndices: new r.LazyArray(r.uint16, "entryCount"),
                  },
                  8: {
                    reserved: new r.Reserved(r.uint16),
                    length: r.uint32,
                    language: r.uint16,
                    is32: new r.LazyArray(r.uint8, 8192),
                    nGroups: r.uint32,
                    groups: new r.LazyArray(CmapGroup, "nGroups"),
                  },
                  10: {
                    reserved: new r.Reserved(r.uint16),
                    length: r.uint32,
                    language: r.uint32,
                    firstCode: r.uint32,
                    entryCount: r.uint32,
                    glyphIndices: new r.LazyArray(r.uint16, "numChars"),
                  },
                  12: {
                    reserved: new r.Reserved(r.uint16),
                    length: r.uint32,
                    language: r.uint32,
                    nGroups: r.uint32,
                    groups: new r.LazyArray(CmapGroup, "nGroups"),
                  },
                  13: {
                    reserved: new r.Reserved(r.uint16),
                    length: r.uint32,
                    language: r.uint32,
                    nGroups: r.uint32,
                    groups: new r.LazyArray(CmapGroup, "nGroups"),
                  },
                  14: {
                    length: r.uint32,
                    numRecords: r.uint32,
                    varSelectors: new r.LazyArray(
                      VarSelectorRecord,
                      "numRecords"
                    ),
                  },
                });
                var CmapEntry = new r.Struct({
                  platformID: r.uint16,
                  encodingID: r.uint16,
                  table: new r.Pointer(r.uint32, CmapSubtable, {
                    type: "parent",
                    lazy: true,
                  }),
                });
                var cmap = new r.Struct({
                  version: r.uint16,
                  numSubtables: r.uint16,
                  tables: new r.Array(CmapEntry, "numSubtables"),
                });
                var head = new r.Struct({
                  version: r.int32,
                  revision: r.int32,
                  checkSumAdjustment: r.uint32,
                  magicNumber: r.uint32,
                  flags: r.uint16,
                  unitsPerEm: r.uint16,
                  created: new r.Array(r.int32, 2),
                  modified: new r.Array(r.int32, 2),
                  xMin: r.int16,
                  yMin: r.int16,
                  xMax: r.int16,
                  yMax: r.int16,
                  macStyle: new r.Bitfield(r.uint16, [
                    "bold",
                    "italic",
                    "underline",
                    "outline",
                    "shadow",
                    "condensed",
                    "extended",
                  ]),
                  lowestRecPPEM: r.uint16,
                  fontDirectionHint: r.int16,
                  indexToLocFormat: r.int16,
                  glyphDataFormat: r.int16,
                });
                var hhea = new r.Struct({
                  version: r.int32,
                  ascent: r.int16,
                  descent: r.int16,
                  lineGap: r.int16,
                  advanceWidthMax: r.uint16,
                  minLeftSideBearing: r.int16,
                  minRightSideBearing: r.int16,
                  xMaxExtent: r.int16,
                  caretSlopeRise: r.int16,
                  caretSlopeRun: r.int16,
                  caretOffset: r.int16,
                  reserved: new r.Reserved(r.int16, 4),
                  metricDataFormat: r.int16,
                  numberOfMetrics: r.uint16,
                });
                var HmtxEntry = new r.Struct({
                  advance: r.uint16,
                  bearing: r.int16,
                });
                var hmtx = new r.Struct({
                  metrics: new r.LazyArray(HmtxEntry, function (t) {
                    return t.parent.hhea.numberOfMetrics;
                  }),
                  bearings: new r.LazyArray(r.int16, function (t) {
                    return (
                      t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics
                    );
                  }),
                });
                var maxp = new r.Struct({
                  version: r.int32,
                  numGlyphs: r.uint16,
                  maxPoints: r.uint16,
                  maxContours: r.uint16,
                  maxComponentPoints: r.uint16,
                  maxComponentContours: r.uint16,
                  maxZones: r.uint16,
                  maxTwilightPoints: r.uint16,
                  maxStorage: r.uint16,
                  maxFunctionDefs: r.uint16,
                  maxInstructionDefs: r.uint16,
                  maxStackElements: r.uint16,
                  maxSizeOfInstructions: r.uint16,
                  maxComponentElements: r.uint16,
                  maxComponentDepth: r.uint16,
                });
                function getEncoding(platformID, encodingID) {
                  var languageID =
                    arguments.length > 2 && arguments[2] !== undefined
                      ? arguments[2]
                      : 0;
                  if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
                    return MAC_LANGUAGE_ENCODINGS[languageID];
                  }
                  return ENCODINGS[platformID][encodingID];
                }
                var ENCODINGS = [
                  [
                    "utf16be",
                    "utf16be",
                    "utf16be",
                    "utf16be",
                    "utf16be",
                    "utf16be",
                  ],
                  [
                    "macroman",
                    "shift-jis",
                    "big5",
                    "euc-kr",
                    "iso-8859-6",
                    "iso-8859-8",
                    "macgreek",
                    "maccyrillic",
                    "symbol",
                    "Devanagari",
                    "Gurmukhi",
                    "Gujarati",
                    "Oriya",
                    "Bengali",
                    "Tamil",
                    "Telugu",
                    "Kannada",
                    "Malayalam",
                    "Sinhalese",
                    "Burmese",
                    "Khmer",
                    "macthai",
                    "Laotian",
                    "Georgian",
                    "Armenian",
                    "gb-2312-80",
                    "Tibetan",
                    "Mongolian",
                    "Geez",
                    "maccenteuro",
                    "Vietnamese",
                    "Sindhi",
                  ],
                  ["ascii"],
                  [
                    "symbol",
                    "utf16be",
                    "shift-jis",
                    "gb18030",
                    "big5",
                    "wansung",
                    "johab",
                    null,
                    null,
                    null,
                    "utf16be",
                  ],
                ];
                var MAC_LANGUAGE_ENCODINGS = {
                  15: "maciceland",
                  17: "macturkish",
                  18: "maccroatian",
                  24: "maccenteuro",
                  25: "maccenteuro",
                  26: "maccenteuro",
                  27: "maccenteuro",
                  28: "maccenteuro",
                  30: "maciceland",
                  37: "macromania",
                  38: "maccenteuro",
                  39: "maccenteuro",
                  40: "maccenteuro",
                  143: "macinuit",
                  146: "macgaelic",
                };
                var LANGUAGES = [
                  [],
                  {
                    0: "en",
                    30: "fo",
                    60: "ks",
                    90: "rw",
                    1: "fr",
                    31: "fa",
                    61: "ku",
                    91: "rn",
                    2: "de",
                    32: "ru",
                    62: "sd",
                    92: "ny",
                    3: "it",
                    33: "zh",
                    63: "bo",
                    93: "mg",
                    4: "nl",
                    34: "nl-BE",
                    64: "ne",
                    94: "eo",
                    5: "sv",
                    35: "ga",
                    65: "sa",
                    128: "cy",
                    6: "es",
                    36: "sq",
                    66: "mr",
                    129: "eu",
                    7: "da",
                    37: "ro",
                    67: "bn",
                    130: "ca",
                    8: "pt",
                    38: "cz",
                    68: "as",
                    131: "la",
                    9: "no",
                    39: "sk",
                    69: "gu",
                    132: "qu",
                    10: "he",
                    40: "si",
                    70: "pa",
                    133: "gn",
                    11: "ja",
                    41: "yi",
                    71: "or",
                    134: "ay",
                    12: "ar",
                    42: "sr",
                    72: "ml",
                    135: "tt",
                    13: "fi",
                    43: "mk",
                    73: "kn",
                    136: "ug",
                    14: "el",
                    44: "bg",
                    74: "ta",
                    137: "dz",
                    15: "is",
                    45: "uk",
                    75: "te",
                    138: "jv",
                    16: "mt",
                    46: "be",
                    76: "si",
                    139: "su",
                    17: "tr",
                    47: "uz",
                    77: "my",
                    140: "gl",
                    18: "hr",
                    48: "kk",
                    78: "km",
                    141: "af",
                    19: "zh-Hant",
                    49: "az-Cyrl",
                    79: "lo",
                    142: "br",
                    20: "ur",
                    50: "az-Arab",
                    80: "vi",
                    143: "iu",
                    21: "hi",
                    51: "hy",
                    81: "id",
                    144: "gd",
                    22: "th",
                    52: "ka",
                    82: "tl",
                    145: "gv",
                    23: "ko",
                    53: "mo",
                    83: "ms",
                    146: "ga",
                    24: "lt",
                    54: "ky",
                    84: "ms-Arab",
                    147: "to",
                    25: "pl",
                    55: "tg",
                    85: "am",
                    148: "el-polyton",
                    26: "hu",
                    56: "tk",
                    86: "ti",
                    149: "kl",
                    27: "es",
                    57: "mn-CN",
                    87: "om",
                    150: "az",
                    28: "lv",
                    58: "mn",
                    88: "so",
                    151: "nn",
                    29: "se",
                    59: "ps",
                    89: "sw",
                  },
                  [],
                  {
                    1078: "af",
                    16393: "en-IN",
                    1159: "rw",
                    1074: "tn",
                    1052: "sq",
                    6153: "en-IE",
                    1089: "sw",
                    1115: "si",
                    1156: "gsw",
                    8201: "en-JM",
                    1111: "kok",
                    1051: "sk",
                    1118: "am",
                    17417: "en-MY",
                    1042: "ko",
                    1060: "sl",
                    5121: "ar-DZ",
                    5129: "en-NZ",
                    1088: "ky",
                    11274: "es-AR",
                    15361: "ar-BH",
                    13321: "en-PH",
                    1108: "lo",
                    16394: "es-BO",
                    3073: "ar",
                    18441: "en-SG",
                    1062: "lv",
                    13322: "es-CL",
                    2049: "ar-IQ",
                    7177: "en-ZA",
                    1063: "lt",
                    9226: "es-CO",
                    11265: "ar-JO",
                    11273: "en-TT",
                    2094: "dsb",
                    5130: "es-CR",
                    13313: "ar-KW",
                    2057: "en-GB",
                    1134: "lb",
                    7178: "es-DO",
                    12289: "ar-LB",
                    1033: "en",
                    1071: "mk",
                    12298: "es-EC",
                    4097: "ar-LY",
                    12297: "en-ZW",
                    2110: "ms-BN",
                    17418: "es-SV",
                    6145: "ary",
                    1061: "et",
                    1086: "ms",
                    4106: "es-GT",
                    8193: "ar-OM",
                    1080: "fo",
                    1100: "ml",
                    18442: "es-HN",
                    16385: "ar-QA",
                    1124: "fil",
                    1082: "mt",
                    2058: "es-MX",
                    1025: "ar-SA",
                    1035: "fi",
                    1153: "mi",
                    19466: "es-NI",
                    10241: "ar-SY",
                    2060: "fr-BE",
                    1146: "arn",
                    6154: "es-PA",
                    7169: "aeb",
                    3084: "fr-CA",
                    1102: "mr",
                    15370: "es-PY",
                    14337: "ar-AE",
                    1036: "fr",
                    1148: "moh",
                    10250: "es-PE",
                    9217: "ar-YE",
                    5132: "fr-LU",
                    1104: "mn",
                    20490: "es-PR",
                    1067: "hy",
                    6156: "fr-MC",
                    2128: "mn-CN",
                    3082: "es",
                    1101: "as",
                    4108: "fr-CH",
                    1121: "ne",
                    1034: "es",
                    2092: "az-Cyrl",
                    1122: "fy",
                    1044: "nb",
                    21514: "es-US",
                    1068: "az",
                    1110: "gl",
                    2068: "nn",
                    14346: "es-UY",
                    1133: "ba",
                    1079: "ka",
                    1154: "oc",
                    8202: "es-VE",
                    1069: "eu",
                    3079: "de-AT",
                    1096: "or",
                    2077: "sv-FI",
                    1059: "be",
                    1031: "de",
                    1123: "ps",
                    1053: "sv",
                    2117: "bn",
                    5127: "de-LI",
                    1045: "pl",
                    1114: "syr",
                    1093: "bn-IN",
                    4103: "de-LU",
                    1046: "pt",
                    1064: "tg",
                    8218: "bs-Cyrl",
                    2055: "de-CH",
                    2070: "pt-PT",
                    2143: "tzm",
                    5146: "bs",
                    1032: "el",
                    1094: "pa",
                    1097: "ta",
                    1150: "br",
                    1135: "kl",
                    1131: "qu-BO",
                    1092: "tt",
                    1026: "bg",
                    1095: "gu",
                    2155: "qu-EC",
                    1098: "te",
                    1027: "ca",
                    1128: "ha",
                    3179: "qu",
                    1054: "th",
                    3076: "zh-HK",
                    1037: "he",
                    1048: "ro",
                    1105: "bo",
                    5124: "zh-MO",
                    1081: "hi",
                    1047: "rm",
                    1055: "tr",
                    2052: "zh",
                    1038: "hu",
                    1049: "ru",
                    1090: "tk",
                    4100: "zh-SG",
                    1039: "is",
                    9275: "smn",
                    1152: "ug",
                    1028: "zh-TW",
                    1136: "ig",
                    4155: "smj-NO",
                    1058: "uk",
                    1155: "co",
                    1057: "id",
                    5179: "smj",
                    1070: "hsb",
                    1050: "hr",
                    1117: "iu",
                    3131: "se-FI",
                    1056: "ur",
                    4122: "hr-BA",
                    2141: "iu-Latn",
                    1083: "se",
                    2115: "uz-Cyrl",
                    1029: "cs",
                    2108: "ga",
                    2107: "se-SE",
                    1091: "uz",
                    1030: "da",
                    1076: "xh",
                    8251: "sms",
                    1066: "vi",
                    1164: "prs",
                    1077: "zu",
                    6203: "sma-NO",
                    1106: "cy",
                    1125: "dv",
                    1040: "it",
                    7227: "sms",
                    1160: "wo",
                    2067: "nl-BE",
                    2064: "it-CH",
                    1103: "sa",
                    1157: "sah",
                    1043: "nl",
                    1041: "ja",
                    7194: "sr-Cyrl-BA",
                    1144: "ii",
                    3081: "en-AU",
                    1099: "kn",
                    3098: "sr",
                    1130: "yo",
                    10249: "en-BZ",
                    1087: "kk",
                    6170: "sr-Latn-BA",
                    4105: "en-CA",
                    1107: "km",
                    2074: "sr-Latn",
                    9225: "en-029",
                    1158: "quc",
                    1132: "nso",
                  },
                ];
                var NameRecord = new r.Struct({
                  platformID: r.uint16,
                  encodingID: r.uint16,
                  languageID: r.uint16,
                  nameID: r.uint16,
                  length: r.uint16,
                  string: new r.Pointer(
                    r.uint16,
                    new r.String("length", function (t) {
                      return getEncoding(
                        t.platformID,
                        t.encodingID,
                        t.languageID
                      );
                    }),
                    {
                      type: "parent",
                      relativeTo: "parent.stringOffset",
                      allowNull: false,
                    }
                  ),
                });
                var LangTagRecord = new r.Struct({
                  length: r.uint16,
                  tag: new r.Pointer(
                    r.uint16,
                    new r.String("length", "utf16be"),
                    {
                      type: "parent",
                      relativeTo: "stringOffset",
                    }
                  ),
                });
                var NameTable = new r.VersionedStruct(r.uint16, {
                  0: {
                    count: r.uint16,
                    stringOffset: r.uint16,
                    records: new r.Array(NameRecord, "count"),
                  },
                  1: {
                    count: r.uint16,
                    stringOffset: r.uint16,
                    records: new r.Array(NameRecord, "count"),
                    langTagCount: r.uint16,
                    langTags: new r.Array(LangTagRecord, "langTagCount"),
                  },
                });
                var NAMES = [
                  "copyright",
                  "fontFamily",
                  "fontSubfamily",
                  "uniqueSubfamily",
                  "fullName",
                  "version",
                  "postscriptName",
                  "trademark",
                  "manufacturer",
                  "designer",
                  "description",
                  "vendorURL",
                  "designerURL",
                  "license",
                  "licenseURL",
                  null,
                  "preferredFamily",
                  "preferredSubfamily",
                  "compatibleFull",
                  "sampleText",
                  "postscriptCIDFontName",
                  "wwsFamilyName",
                  "wwsSubfamilyName",
                ];
                NameTable.process = function (stream) {
                  var records = {};
                  for (
                    var _iterator = this.records,
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var record = _ref;
                    var language =
                      LANGUAGES[record.platformID][record.languageID];
                    if (
                      language == null &&
                      this.langTags != null &&
                      record.languageID >= 32768
                    ) {
                      language = this.langTags[record.languageID - 32768].tag;
                    }
                    if (language == null) {
                      language = record.platformID + "-" + record.languageID;
                    }
                    var key =
                      record.nameID >= 256
                        ? "fontFeatures"
                        : NAMES[record.nameID] || record.nameID;
                    if (records[key] == null) {
                      records[key] = {};
                    }
                    var obj = records[key];
                    if (record.nameID >= 256) {
                      obj = obj[record.nameID] || (obj[record.nameID] = {});
                    }
                    if (
                      typeof record.string === "string" ||
                      typeof obj[language] !== "string"
                    ) {
                      obj[language] = record.string;
                    }
                  }
                  this.records = records;
                };
                NameTable.preEncode = function () {
                  if (Array.isArray(this.records)) return;
                  this.version = 0;
                  var records = [];
                  for (var key in this.records) {
                    var val = this.records[key];
                    if (key === "fontFeatures") continue;
                    records.push({
                      platformID: 3,
                      encodingID: 1,
                      languageID: 1033,
                      nameID: NAMES.indexOf(key),
                      length: Buffer.byteLength(val.en, "utf16le"),
                      string: val.en,
                    });
                    if (key === "postscriptName") {
                      records.push({
                        platformID: 1,
                        encodingID: 0,
                        languageID: 0,
                        nameID: NAMES.indexOf(key),
                        length: val.en.length,
                        string: val.en,
                      });
                    }
                  }
                  this.records = records;
                  this.count = records.length;
                  this.stringOffset = NameTable.size(this, null, false);
                };
                var OS2 = new r.VersionedStruct(r.uint16, {
                  header: {
                    xAvgCharWidth: r.int16,
                    usWeightClass: r.uint16,
                    usWidthClass: r.uint16,
                    fsType: new r.Bitfield(r.uint16, [
                      null,
                      "noEmbedding",
                      "viewOnly",
                      "editable",
                      null,
                      null,
                      null,
                      null,
                      "noSubsetting",
                      "bitmapOnly",
                    ]),
                    ySubscriptXSize: r.int16,
                    ySubscriptYSize: r.int16,
                    ySubscriptXOffset: r.int16,
                    ySubscriptYOffset: r.int16,
                    ySuperscriptXSize: r.int16,
                    ySuperscriptYSize: r.int16,
                    ySuperscriptXOffset: r.int16,
                    ySuperscriptYOffset: r.int16,
                    yStrikeoutSize: r.int16,
                    yStrikeoutPosition: r.int16,
                    sFamilyClass: r.int16,
                    panose: new r.Array(r.uint8, 10),
                    ulCharRange: new r.Array(r.uint32, 4),
                    vendorID: new r.String(4),
                    fsSelection: new r.Bitfield(r.uint16, [
                      "italic",
                      "underscore",
                      "negative",
                      "outlined",
                      "strikeout",
                      "bold",
                      "regular",
                      "useTypoMetrics",
                      "wws",
                      "oblique",
                    ]),
                    usFirstCharIndex: r.uint16,
                    usLastCharIndex: r.uint16,
                  },
                  0: {},
                  1: {
                    typoAscender: r.int16,
                    typoDescender: r.int16,
                    typoLineGap: r.int16,
                    winAscent: r.uint16,
                    winDescent: r.uint16,
                    codePageRange: new r.Array(r.uint32, 2),
                  },
                  2: {
                    typoAscender: r.int16,
                    typoDescender: r.int16,
                    typoLineGap: r.int16,
                    winAscent: r.uint16,
                    winDescent: r.uint16,
                    codePageRange: new r.Array(r.uint32, 2),
                    xHeight: r.int16,
                    capHeight: r.int16,
                    defaultChar: r.uint16,
                    breakChar: r.uint16,
                    maxContent: r.uint16,
                  },
                  5: {
                    typoAscender: r.int16,
                    typoDescender: r.int16,
                    typoLineGap: r.int16,
                    winAscent: r.uint16,
                    winDescent: r.uint16,
                    codePageRange: new r.Array(r.uint32, 2),
                    xHeight: r.int16,
                    capHeight: r.int16,
                    defaultChar: r.uint16,
                    breakChar: r.uint16,
                    maxContent: r.uint16,
                    usLowerOpticalPointSize: r.uint16,
                    usUpperOpticalPointSize: r.uint16,
                  },
                });
                var versions = OS2.versions;
                versions[3] = versions[4] = versions[2];
                var post = new r.VersionedStruct(r.fixed32, {
                  header: {
                    italicAngle: r.fixed32,
                    underlinePosition: r.int16,
                    underlineThickness: r.int16,
                    isFixedPitch: r.uint32,
                    minMemType42: r.uint32,
                    maxMemType42: r.uint32,
                    minMemType1: r.uint32,
                    maxMemType1: r.uint32,
                  },
                  1: {},
                  2: {
                    numberOfGlyphs: r.uint16,
                    glyphNameIndex: new r.Array(r.uint16, "numberOfGlyphs"),
                    names: new r.Array(new r.String(r.uint8)),
                  },
                  2.5: {
                    numberOfGlyphs: r.uint16,
                    offsets: new r.Array(r.uint8, "numberOfGlyphs"),
                  },
                  3: {},
                  4: {
                    map: new r.Array(r.uint32, function (t) {
                      return t.parent.maxp.numGlyphs;
                    }),
                  },
                });
                var cvt = new r.Struct({ controlValues: new r.Array(r.int16) });
                var fpgm = new r.Struct({ instructions: new r.Array(r.uint8) });
                var loca = new r.VersionedStruct("head.indexToLocFormat", {
                  0: { offsets: new r.Array(r.uint16) },
                  1: { offsets: new r.Array(r.uint32) },
                });
                loca.process = function () {
                  if (this.version === 0) {
                    for (var i = 0; i < this.offsets.length; i++) {
                      this.offsets[i] <<= 1;
                    }
                  }
                };
                loca.preEncode = function () {
                  if (this.version === 0) {
                    for (var i = 0; i < this.offsets.length; i++) {
                      this.offsets[i] >>>= 1;
                    }
                  }
                };
                var prep = new r.Struct({
                  controlValueProgram: new r.Array(r.uint8),
                });
                var glyf = new r.Array(new r.Buffer());
                var CFFIndex = (function () {
                  function CFFIndex(type) {
                    _classCallCheck(this, CFFIndex);
                    this.type = type;
                  }
                  CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
                    while (ctx && !ctx.hdrSize) {
                      ctx = ctx.parent;
                    }
                    return ctx ? ctx.version : -1;
                  };
                  CFFIndex.prototype.decode = function decode(stream, parent) {
                    var version = this.getCFFVersion(parent);
                    var count =
                      version >= 2
                        ? stream.readUInt32BE()
                        : stream.readUInt16BE();
                    if (count === 0) {
                      return [];
                    }
                    var offSize = stream.readUInt8();
                    var offsetType = void 0;
                    if (offSize === 1) {
                      offsetType = r.uint8;
                    } else if (offSize === 2) {
                      offsetType = r.uint16;
                    } else if (offSize === 3) {
                      offsetType = r.uint24;
                    } else if (offSize === 4) {
                      offsetType = r.uint32;
                    } else {
                      throw new Error(
                        "Bad offset size in CFFIndex: " +
                          offSize +
                          " " +
                          stream.pos
                      );
                    }
                    var ret = [];
                    var startPos = stream.pos + (count + 1) * offSize - 1;
                    var start = offsetType.decode(stream);
                    for (var i = 0; i < count; i++) {
                      var end = offsetType.decode(stream);
                      if (this.type != null) {
                        var pos = stream.pos;
                        stream.pos = startPos + start;
                        parent.length = end - start;
                        ret.push(this.type.decode(stream, parent));
                        stream.pos = pos;
                      } else {
                        ret.push({
                          offset: startPos + start,
                          length: end - start,
                        });
                      }
                      start = end;
                    }
                    stream.pos = startPos + start;
                    return ret;
                  };
                  CFFIndex.prototype.size = function size(arr, parent) {
                    var size = 2;
                    if (arr.length === 0) {
                      return size;
                    }
                    var type = this.type || new r.Buffer();
                    var offset = 1;
                    for (var i = 0; i < arr.length; i++) {
                      var item = arr[i];
                      offset += type.size(item, parent);
                    }
                    var offsetType = void 0;
                    if (offset <= 255) {
                      offsetType = r.uint8;
                    } else if (offset <= 65535) {
                      offsetType = r.uint16;
                    } else if (offset <= 16777215) {
                      offsetType = r.uint24;
                    } else if (offset <= 4294967295) {
                      offsetType = r.uint32;
                    } else {
                      throw new Error("Bad offset in CFFIndex");
                    }
                    size += 1 + offsetType.size() * (arr.length + 1);
                    size += offset - 1;
                    return size;
                  };
                  CFFIndex.prototype.encode = function encode(
                    stream,
                    arr,
                    parent
                  ) {
                    stream.writeUInt16BE(arr.length);
                    if (arr.length === 0) {
                      return;
                    }
                    var type = this.type || new r.Buffer();
                    var sizes = [];
                    var offset = 1;
                    for (
                      var _iterator = arr,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var item = _ref;
                      var s = type.size(item, parent);
                      sizes.push(s);
                      offset += s;
                    }
                    var offsetType = void 0;
                    if (offset <= 255) {
                      offsetType = r.uint8;
                    } else if (offset <= 65535) {
                      offsetType = r.uint16;
                    } else if (offset <= 16777215) {
                      offsetType = r.uint24;
                    } else if (offset <= 4294967295) {
                      offsetType = r.uint32;
                    } else {
                      throw new Error("Bad offset in CFFIndex");
                    }
                    stream.writeUInt8(offsetType.size());
                    offset = 1;
                    offsetType.encode(stream, offset);
                    for (
                      var _iterator2 = sizes,
                        _isArray2 = Array.isArray(_iterator2),
                        _i2 = 0,
                        _iterator2 = _isArray2
                          ? _iterator2
                          : _getIterator(_iterator2);
                      ;
  
                    ) {
                      var _ref2;
                      if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                      } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                      }
                      var size = _ref2;
                      offset += size;
                      offsetType.encode(stream, offset);
                    }
                    for (
                      var _iterator3 = arr,
                        _isArray3 = Array.isArray(_iterator3),
                        _i3 = 0,
                        _iterator3 = _isArray3
                          ? _iterator3
                          : _getIterator(_iterator3);
                      ;
  
                    ) {
                      var _ref3;
                      if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i3++];
                      } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref3 = _i3.value;
                      }
                      var _item = _ref3;
                      type.encode(stream, _item, parent);
                    }
                    return;
                  };
                  return CFFIndex;
                })();
                var FLOAT_EOF = 15;
                var FLOAT_LOOKUP = [
                  "0",
                  "1",
                  "2",
                  "3",
                  "4",
                  "5",
                  "6",
                  "7",
                  "8",
                  "9",
                  ".",
                  "E",
                  "E-",
                  null,
                  "-",
                ];
                var FLOAT_ENCODE_LOOKUP = {
                  ".": 10,
                  E: 11,
                  "E-": 12,
                  "-": 14,
                };
                var CFFOperand = (function () {
                  function CFFOperand() {
                    _classCallCheck(this, CFFOperand);
                  }
                  CFFOperand.decode = function decode(stream, value) {
                    if (32 <= value && value <= 246) {
                      return value - 139;
                    }
                    if (247 <= value && value <= 250) {
                      return (value - 247) * 256 + stream.readUInt8() + 108;
                    }
                    if (251 <= value && value <= 254) {
                      return -(value - 251) * 256 - stream.readUInt8() - 108;
                    }
                    if (value === 28) {
                      return stream.readInt16BE();
                    }
                    if (value === 29) {
                      return stream.readInt32BE();
                    }
                    if (value === 30) {
                      var str = "";
                      while (true) {
                        var b = stream.readUInt8();
                        var n1 = b >> 4;
                        if (n1 === FLOAT_EOF) {
                          break;
                        }
                        str += FLOAT_LOOKUP[n1];
                        var n2 = b & 15;
                        if (n2 === FLOAT_EOF) {
                          break;
                        }
                        str += FLOAT_LOOKUP[n2];
                      }
                      return parseFloat(str);
                    }
                    return null;
                  };
                  CFFOperand.size = function size(value) {
                    if (value.forceLarge) {
                      value = 32768;
                    }
                    if ((value | 0) !== value) {
                      var str = "" + value;
                      return 1 + Math.ceil((str.length + 1) / 2);
                    } else if (-107 <= value && value <= 107) {
                      return 1;
                    } else if (
                      (108 <= value && value <= 1131) ||
                      (-1131 <= value && value <= -108)
                    ) {
                      return 2;
                    } else if (-32768 <= value && value <= 32767) {
                      return 3;
                    } else {
                      return 5;
                    }
                  };
                  CFFOperand.encode = function encode(stream, value) {
                    var val = Number(value);
                    if (value.forceLarge) {
                      stream.writeUInt8(29);
                      return stream.writeInt32BE(val);
                    } else if ((val | 0) !== val) {
                      stream.writeUInt8(30);
                      var str = "" + val;
                      for (var i = 0; i < str.length; i += 2) {
                        var c1 = str[i];
                        var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
                        if (i === str.length - 1) {
                          var n2 = FLOAT_EOF;
                        } else {
                          var c2 = str[i + 1];
                          var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                        }
                        stream.writeUInt8((n1 << 4) | (n2 & 15));
                      }
                      if (n2 !== FLOAT_EOF) {
                        return stream.writeUInt8(FLOAT_EOF << 4);
                      }
                    } else if (-107 <= val && val <= 107) {
                      return stream.writeUInt8(val + 139);
                    } else if (108 <= val && val <= 1131) {
                      val -= 108;
                      stream.writeUInt8((val >> 8) + 247);
                      return stream.writeUInt8(val & 255);
                    } else if (-1131 <= val && val <= -108) {
                      val = -val - 108;
                      stream.writeUInt8((val >> 8) + 251);
                      return stream.writeUInt8(val & 255);
                    } else if (-32768 <= val && val <= 32767) {
                      stream.writeUInt8(28);
                      return stream.writeInt16BE(val);
                    } else {
                      stream.writeUInt8(29);
                      return stream.writeInt32BE(val);
                    }
                  };
                  return CFFOperand;
                })();
                var CFFDict = (function () {
                  function CFFDict() {
                    var ops =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : [];
                    _classCallCheck(this, CFFDict);
                    this.ops = ops;
                    this.fields = {};
                    for (
                      var _iterator = ops,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var field = _ref;
                      var key = Array.isArray(field[0])
                        ? (field[0][0] << 8) | field[0][1]
                        : field[0];
                      this.fields[key] = field;
                    }
                  }
                  CFFDict.prototype.decodeOperands = function decodeOperands(
                    type,
                    stream,
                    ret,
                    operands
                  ) {
                    var _this = this;
                    if (Array.isArray(type)) {
                      return operands.map(function (op, i) {
                        return _this.decodeOperands(type[i], stream, ret, [op]);
                      });
                    } else if (type.decode != null) {
                      return type.decode(stream, ret, operands);
                    } else {
                      switch (type) {
                        case "number":
                        case "offset":
                        case "sid":
                          return operands[0];
                        case "boolean":
                          return !!operands[0];
                        default:
                          return operands;
                      }
                    }
                  };
                  CFFDict.prototype.encodeOperands = function encodeOperands(
                    type,
                    stream,
                    ctx,
                    operands
                  ) {
                    var _this2 = this;
                    if (Array.isArray(type)) {
                      return operands.map(function (op, i) {
                        return _this2.encodeOperands(type[i], stream, ctx, op)[0];
                      });
                    } else if (type.encode != null) {
                      return type.encode(stream, operands, ctx);
                    } else if (typeof operands === "number") {
                      return [operands];
                    } else if (typeof operands === "boolean") {
                      return [+operands];
                    } else if (Array.isArray(operands)) {
                      return operands;
                    } else {
                      return [operands];
                    }
                  };
                  CFFDict.prototype.decode = function decode(stream, parent) {
                    var end = stream.pos + parent.length;
                    var ret = {};
                    var operands = [];
                    _Object$defineProperties(ret, {
                      parent: { value: parent },
                      _startOffset: { value: stream.pos },
                    });
                    for (var key in this.fields) {
                      var field = this.fields[key];
                      ret[field[1]] = field[3];
                    }
                    while (stream.pos < end) {
                      var b = stream.readUInt8();
                      if (b < 28) {
                        if (b === 12) {
                          b = (b << 8) | stream.readUInt8();
                        }
                        var _field = this.fields[b];
                        if (!_field) {
                          throw new Error("Unknown operator " + b);
                        }
                        var val = this.decodeOperands(
                          _field[2],
                          stream,
                          ret,
                          operands
                        );
                        if (val != null) {
                          if (
                            val instanceof
                            restructure_src_utils.PropertyDescriptor
                          ) {
                            _Object$defineProperty(ret, _field[1], val);
                          } else {
                            ret[_field[1]] = val;
                          }
                        }
                        operands = [];
                      } else {
                        operands.push(CFFOperand.decode(stream, b));
                      }
                    }
                    return ret;
                  };
                  CFFDict.prototype.size = function size(dict, parent) {
                    var includePointers =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : true;
                    var ctx = {
                      parent: parent,
                      val: dict,
                      pointerSize: 0,
                      startOffset: parent.startOffset || 0,
                    };
                    var len = 0;
                    for (var k in this.fields) {
                      var field = this.fields[k];
                      var val = dict[field[1]];
                      if (val == null || isEqual(val, field[3])) {
                        continue;
                      }
                      var operands = this.encodeOperands(
                        field[2],
                        null,
                        ctx,
                        val
                      );
                      for (
                        var _iterator2 = operands,
                          _isArray2 = Array.isArray(_iterator2),
                          _i2 = 0,
                          _iterator2 = _isArray2
                            ? _iterator2
                            : _getIterator(_iterator2);
                        ;
  
                      ) {
                        var _ref2;
                        if (_isArray2) {
                          if (_i2 >= _iterator2.length) break;
                          _ref2 = _iterator2[_i2++];
                        } else {
                          _i2 = _iterator2.next();
                          if (_i2.done) break;
                          _ref2 = _i2.value;
                        }
                        var op = _ref2;
                        len += CFFOperand.size(op);
                      }
                      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
                      len += key.length;
                    }
                    if (includePointers) {
                      len += ctx.pointerSize;
                    }
                    return len;
                  };
                  CFFDict.prototype.encode = function encode(
                    stream,
                    dict,
                    parent
                  ) {
                    var ctx = {
                      pointers: [],
                      startOffset: stream.pos,
                      parent: parent,
                      val: dict,
                      pointerSize: 0,
                    };
                    ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
                    for (
                      var _iterator3 = this.ops,
                        _isArray3 = Array.isArray(_iterator3),
                        _i3 = 0,
                        _iterator3 = _isArray3
                          ? _iterator3
                          : _getIterator(_iterator3);
                      ;
  
                    ) {
                      var _ref3;
                      if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i3++];
                      } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref3 = _i3.value;
                      }
                      var field = _ref3;
                      var val = dict[field[1]];
                      if (val == null || isEqual(val, field[3])) {
                        continue;
                      }
                      var operands = this.encodeOperands(
                        field[2],
                        stream,
                        ctx,
                        val
                      );
                      for (
                        var _iterator4 = operands,
                          _isArray4 = Array.isArray(_iterator4),
                          _i4 = 0,
                          _iterator4 = _isArray4
                            ? _iterator4
                            : _getIterator(_iterator4);
                        ;
  
                      ) {
                        var _ref4;
                        if (_isArray4) {
                          if (_i4 >= _iterator4.length) break;
                          _ref4 = _iterator4[_i4++];
                        } else {
                          _i4 = _iterator4.next();
                          if (_i4.done) break;
                          _ref4 = _i4.value;
                        }
                        var op = _ref4;
                        CFFOperand.encode(stream, op);
                      }
                      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
                      for (
                        var _iterator5 = key,
                          _isArray5 = Array.isArray(_iterator5),
                          _i5 = 0,
                          _iterator5 = _isArray5
                            ? _iterator5
                            : _getIterator(_iterator5);
                        ;
  
                      ) {
                        var _ref5;
                        if (_isArray5) {
                          if (_i5 >= _iterator5.length) break;
                          _ref5 = _iterator5[_i5++];
                        } else {
                          _i5 = _iterator5.next();
                          if (_i5.done) break;
                          _ref5 = _i5.value;
                        }
                        var _op = _ref5;
                        stream.writeUInt8(_op);
                      }
                    }
                    var i = 0;
                    while (i < ctx.pointers.length) {
                      var ptr = ctx.pointers[i++];
                      ptr.type.encode(stream, ptr.val, ptr.parent);
                    }
                    return;
                  };
                  return CFFDict;
                })();
                var CFFPointer = (function (_r$Pointer) {
                  _inherits(CFFPointer, _r$Pointer);
                  function CFFPointer(type) {
                    var options =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : {};
                    _classCallCheck(this, CFFPointer);
                    if (options.type == null) {
                      options.type = "global";
                    }
                    return _possibleConstructorReturn(
                      this,
                      _r$Pointer.call(this, null, type, options)
                    );
                  }
                  CFFPointer.prototype.decode = function decode(
                    stream,
                    parent,
                    operands
                  ) {
                    this.offsetType = {
                      decode: function decode() {
                        return operands[0];
                      },
                    };
                    return _r$Pointer.prototype.decode.call(
                      this,
                      stream,
                      parent,
                      operands
                    );
                  };
                  CFFPointer.prototype.encode = function encode(
                    stream,
                    value,
                    ctx
                  ) {
                    if (!stream) {
                      this.offsetType = {
                        size: function size() {
                          return 0;
                        },
                      };
                      this.size(value, ctx);
                      return [new Ptr(0)];
                    }
                    var ptr = null;
                    this.offsetType = {
                      encode: function encode(stream, val) {
                        return (ptr = val);
                      },
                    };
                    _r$Pointer.prototype.encode.call(this, stream, value, ctx);
                    return [new Ptr(ptr)];
                  };
                  return CFFPointer;
                })(r.Pointer);
                var Ptr = (function () {
                  function Ptr(val) {
                    _classCallCheck(this, Ptr);
                    this.val = val;
                    this.forceLarge = true;
                  }
                  Ptr.prototype.valueOf = function valueOf() {
                    return this.val;
                  };
                  return Ptr;
                })();
                var CFFBlendOp = (function () {
                  function CFFBlendOp() {
                    _classCallCheck(this, CFFBlendOp);
                  }
                  CFFBlendOp.decode = function decode(stream, parent, operands) {
                    var numBlends = operands.pop();
                    while (operands.length > numBlends) {
                      operands.pop();
                    }
                  };
                  return CFFBlendOp;
                })();
                var CFFPrivateDict = new CFFDict([
                  [6, "BlueValues", "delta", null],
                  [7, "OtherBlues", "delta", null],
                  [8, "FamilyBlues", "delta", null],
                  [9, "FamilyOtherBlues", "delta", null],
                  [[12, 9], "BlueScale", "number", 0.039625],
                  [[12, 10], "BlueShift", "number", 7],
                  [[12, 11], "BlueFuzz", "number", 1],
                  [10, "StdHW", "number", null],
                  [11, "StdVW", "number", null],
                  [[12, 12], "StemSnapH", "delta", null],
                  [[12, 13], "StemSnapV", "delta", null],
                  [[12, 14], "ForceBold", "boolean", false],
                  [[12, 17], "LanguageGroup", "number", 0],
                  [[12, 18], "ExpansionFactor", "number", 0.06],
                  [[12, 19], "initialRandomSeed", "number", 0],
                  [20, "defaultWidthX", "number", 0],
                  [21, "nominalWidthX", "number", 0],
                  [22, "vsindex", "number", 0],
                  [23, "blend", CFFBlendOp, null],
                  [
                    19,
                    "Subrs",
                    new CFFPointer(new CFFIndex(), { type: "local" }),
                    null,
                  ],
                ]);
                var standardStrings = [
                  ".notdef",
                  "space",
                  "exclam",
                  "quotedbl",
                  "numbersign",
                  "dollar",
                  "percent",
                  "ampersand",
                  "quoteright",
                  "parenleft",
                  "parenright",
                  "asterisk",
                  "plus",
                  "comma",
                  "hyphen",
                  "period",
                  "slash",
                  "zero",
                  "one",
                  "two",
                  "three",
                  "four",
                  "five",
                  "six",
                  "seven",
                  "eight",
                  "nine",
                  "colon",
                  "semicolon",
                  "less",
                  "equal",
                  "greater",
                  "question",
                  "at",
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                  "M",
                  "N",
                  "O",
                  "P",
                  "Q",
                  "R",
                  "S",
                  "T",
                  "U",
                  "V",
                  "W",
                  "X",
                  "Y",
                  "Z",
                  "bracketleft",
                  "backslash",
                  "bracketright",
                  "asciicircum",
                  "underscore",
                  "quoteleft",
                  "a",
                  "b",
                  "c",
                  "d",
                  "e",
                  "f",
                  "g",
                  "h",
                  "i",
                  "j",
                  "k",
                  "l",
                  "m",
                  "n",
                  "o",
                  "p",
                  "q",
                  "r",
                  "s",
                  "t",
                  "u",
                  "v",
                  "w",
                  "x",
                  "y",
                  "z",
                  "braceleft",
                  "bar",
                  "braceright",
                  "asciitilde",
                  "exclamdown",
                  "cent",
                  "sterling",
                  "fraction",
                  "yen",
                  "florin",
                  "section",
                  "currency",
                  "quotesingle",
                  "quotedblleft",
                  "guillemotleft",
                  "guilsinglleft",
                  "guilsinglright",
                  "fi",
                  "fl",
                  "endash",
                  "dagger",
                  "daggerdbl",
                  "periodcentered",
                  "paragraph",
                  "bullet",
                  "quotesinglbase",
                  "quotedblbase",
                  "quotedblright",
                  "guillemotright",
                  "ellipsis",
                  "perthousand",
                  "questiondown",
                  "grave",
                  "acute",
                  "circumflex",
                  "tilde",
                  "macron",
                  "breve",
                  "dotaccent",
                  "dieresis",
                  "ring",
                  "cedilla",
                  "hungarumlaut",
                  "ogonek",
                  "caron",
                  "emdash",
                  "AE",
                  "ordfeminine",
                  "Lslash",
                  "Oslash",
                  "OE",
                  "ordmasculine",
                  "ae",
                  "dotlessi",
                  "lslash",
                  "oslash",
                  "oe",
                  "germandbls",
                  "onesuperior",
                  "logicalnot",
                  "mu",
                  "trademark",
                  "Eth",
                  "onehalf",
                  "plusminus",
                  "Thorn",
                  "onequarter",
                  "divide",
                  "brokenbar",
                  "degree",
                  "thorn",
                  "threequarters",
                  "twosuperior",
                  "registered",
                  "minus",
                  "eth",
                  "multiply",
                  "threesuperior",
                  "copyright",
                  "Aacute",
                  "Acircumflex",
                  "Adieresis",
                  "Agrave",
                  "Aring",
                  "Atilde",
                  "Ccedilla",
                  "Eacute",
                  "Ecircumflex",
                  "Edieresis",
                  "Egrave",
                  "Iacute",
                  "Icircumflex",
                  "Idieresis",
                  "Igrave",
                  "Ntilde",
                  "Oacute",
                  "Ocircumflex",
                  "Odieresis",
                  "Ograve",
                  "Otilde",
                  "Scaron",
                  "Uacute",
                  "Ucircumflex",
                  "Udieresis",
                  "Ugrave",
                  "Yacute",
                  "Ydieresis",
                  "Zcaron",
                  "aacute",
                  "acircumflex",
                  "adieresis",
                  "agrave",
                  "aring",
                  "atilde",
                  "ccedilla",
                  "eacute",
                  "ecircumflex",
                  "edieresis",
                  "egrave",
                  "iacute",
                  "icircumflex",
                  "idieresis",
                  "igrave",
                  "ntilde",
                  "oacute",
                  "ocircumflex",
                  "odieresis",
                  "ograve",
                  "otilde",
                  "scaron",
                  "uacute",
                  "ucircumflex",
                  "udieresis",
                  "ugrave",
                  "yacute",
                  "ydieresis",
                  "zcaron",
                  "exclamsmall",
                  "Hungarumlautsmall",
                  "dollaroldstyle",
                  "dollarsuperior",
                  "ampersandsmall",
                  "Acutesmall",
                  "parenleftsuperior",
                  "parenrightsuperior",
                  "twodotenleader",
                  "onedotenleader",
                  "zerooldstyle",
                  "oneoldstyle",
                  "twooldstyle",
                  "threeoldstyle",
                  "fouroldstyle",
                  "fiveoldstyle",
                  "sixoldstyle",
                  "sevenoldstyle",
                  "eightoldstyle",
                  "nineoldstyle",
                  "commasuperior",
                  "threequartersemdash",
                  "periodsuperior",
                  "questionsmall",
                  "asuperior",
                  "bsuperior",
                  "centsuperior",
                  "dsuperior",
                  "esuperior",
                  "isuperior",
                  "lsuperior",
                  "msuperior",
                  "nsuperior",
                  "osuperior",
                  "rsuperior",
                  "ssuperior",
                  "tsuperior",
                  "ff",
                  "ffi",
                  "ffl",
                  "parenleftinferior",
                  "parenrightinferior",
                  "Circumflexsmall",
                  "hyphensuperior",
                  "Gravesmall",
                  "Asmall",
                  "Bsmall",
                  "Csmall",
                  "Dsmall",
                  "Esmall",
                  "Fsmall",
                  "Gsmall",
                  "Hsmall",
                  "Ismall",
                  "Jsmall",
                  "Ksmall",
                  "Lsmall",
                  "Msmall",
                  "Nsmall",
                  "Osmall",
                  "Psmall",
                  "Qsmall",
                  "Rsmall",
                  "Ssmall",
                  "Tsmall",
                  "Usmall",
                  "Vsmall",
                  "Wsmall",
                  "Xsmall",
                  "Ysmall",
                  "Zsmall",
                  "colonmonetary",
                  "onefitted",
                  "rupiah",
                  "Tildesmall",
                  "exclamdownsmall",
                  "centoldstyle",
                  "Lslashsmall",
                  "Scaronsmall",
                  "Zcaronsmall",
                  "Dieresissmall",
                  "Brevesmall",
                  "Caronsmall",
                  "Dotaccentsmall",
                  "Macronsmall",
                  "figuredash",
                  "hypheninferior",
                  "Ogoneksmall",
                  "Ringsmall",
                  "Cedillasmall",
                  "questiondownsmall",
                  "oneeighth",
                  "threeeighths",
                  "fiveeighths",
                  "seveneighths",
                  "onethird",
                  "twothirds",
                  "zerosuperior",
                  "foursuperior",
                  "fivesuperior",
                  "sixsuperior",
                  "sevensuperior",
                  "eightsuperior",
                  "ninesuperior",
                  "zeroinferior",
                  "oneinferior",
                  "twoinferior",
                  "threeinferior",
                  "fourinferior",
                  "fiveinferior",
                  "sixinferior",
                  "seveninferior",
                  "eightinferior",
                  "nineinferior",
                  "centinferior",
                  "dollarinferior",
                  "periodinferior",
                  "commainferior",
                  "Agravesmall",
                  "Aacutesmall",
                  "Acircumflexsmall",
                  "Atildesmall",
                  "Adieresissmall",
                  "Aringsmall",
                  "AEsmall",
                  "Ccedillasmall",
                  "Egravesmall",
                  "Eacutesmall",
                  "Ecircumflexsmall",
                  "Edieresissmall",
                  "Igravesmall",
                  "Iacutesmall",
                  "Icircumflexsmall",
                  "Idieresissmall",
                  "Ethsmall",
                  "Ntildesmall",
                  "Ogravesmall",
                  "Oacutesmall",
                  "Ocircumflexsmall",
                  "Otildesmall",
                  "Odieresissmall",
                  "OEsmall",
                  "Oslashsmall",
                  "Ugravesmall",
                  "Uacutesmall",
                  "Ucircumflexsmall",
                  "Udieresissmall",
                  "Yacutesmall",
                  "Thornsmall",
                  "Ydieresissmall",
                  "001.000",
                  "001.001",
                  "001.002",
                  "001.003",
                  "Black",
                  "Bold",
                  "Book",
                  "Light",
                  "Medium",
                  "Regular",
                  "Roman",
                  "Semibold",
                ];
                var StandardEncoding = [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "space",
                  "exclam",
                  "quotedbl",
                  "numbersign",
                  "dollar",
                  "percent",
                  "ampersand",
                  "quoteright",
                  "parenleft",
                  "parenright",
                  "asterisk",
                  "plus",
                  "comma",
                  "hyphen",
                  "period",
                  "slash",
                  "zero",
                  "one",
                  "two",
                  "three",
                  "four",
                  "five",
                  "six",
                  "seven",
                  "eight",
                  "nine",
                  "colon",
                  "semicolon",
                  "less",
                  "equal",
                  "greater",
                  "question",
                  "at",
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                  "M",
                  "N",
                  "O",
                  "P",
                  "Q",
                  "R",
                  "S",
                  "T",
                  "U",
                  "V",
                  "W",
                  "X",
                  "Y",
                  "Z",
                  "bracketleft",
                  "backslash",
                  "bracketright",
                  "asciicircum",
                  "underscore",
                  "quoteleft",
                  "a",
                  "b",
                  "c",
                  "d",
                  "e",
                  "f",
                  "g",
                  "h",
                  "i",
                  "j",
                  "k",
                  "l",
                  "m",
                  "n",
                  "o",
                  "p",
                  "q",
                  "r",
                  "s",
                  "t",
                  "u",
                  "v",
                  "w",
                  "x",
                  "y",
                  "z",
                  "braceleft",
                  "bar",
                  "braceright",
                  "asciitilde",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "exclamdown",
                  "cent",
                  "sterling",
                  "fraction",
                  "yen",
                  "florin",
                  "section",
                  "currency",
                  "quotesingle",
                  "quotedblleft",
                  "guillemotleft",
                  "guilsinglleft",
                  "guilsinglright",
                  "fi",
                  "fl",
                  "",
                  "endash",
                  "dagger",
                  "daggerdbl",
                  "periodcentered",
                  "",
                  "paragraph",
                  "bullet",
                  "quotesinglbase",
                  "quotedblbase",
                  "quotedblright",
                  "guillemotright",
                  "ellipsis",
                  "perthousand",
                  "",
                  "questiondown",
                  "",
                  "grave",
                  "acute",
                  "circumflex",
                  "tilde",
                  "macron",
                  "breve",
                  "dotaccent",
                  "dieresis",
                  "",
                  "ring",
                  "cedilla",
                  "",
                  "hungarumlaut",
                  "ogonek",
                  "caron",
                  "emdash",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "AE",
                  "",
                  "ordfeminine",
                  "",
                  "",
                  "",
                  "",
                  "Lslash",
                  "Oslash",
                  "OE",
                  "ordmasculine",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "ae",
                  "",
                  "",
                  "",
                  "dotlessi",
                  "",
                  "",
                  "lslash",
                  "oslash",
                  "oe",
                  "germandbls",
                ];
                var ExpertEncoding = [
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "space",
                  "exclamsmall",
                  "Hungarumlautsmall",
                  "",
                  "dollaroldstyle",
                  "dollarsuperior",
                  "ampersandsmall",
                  "Acutesmall",
                  "parenleftsuperior",
                  "parenrightsuperior",
                  "twodotenleader",
                  "onedotenleader",
                  "comma",
                  "hyphen",
                  "period",
                  "fraction",
                  "zerooldstyle",
                  "oneoldstyle",
                  "twooldstyle",
                  "threeoldstyle",
                  "fouroldstyle",
                  "fiveoldstyle",
                  "sixoldstyle",
                  "sevenoldstyle",
                  "eightoldstyle",
                  "nineoldstyle",
                  "colon",
                  "semicolon",
                  "commasuperior",
                  "threequartersemdash",
                  "periodsuperior",
                  "questionsmall",
                  "",
                  "asuperior",
                  "bsuperior",
                  "centsuperior",
                  "dsuperior",
                  "esuperior",
                  "",
                  "",
                  "isuperior",
                  "",
                  "",
                  "lsuperior",
                  "msuperior",
                  "nsuperior",
                  "osuperior",
                  "",
                  "",
                  "rsuperior",
                  "ssuperior",
                  "tsuperior",
                  "",
                  "ff",
                  "fi",
                  "fl",
                  "ffi",
                  "ffl",
                  "parenleftinferior",
                  "",
                  "parenrightinferior",
                  "Circumflexsmall",
                  "hyphensuperior",
                  "Gravesmall",
                  "Asmall",
                  "Bsmall",
                  "Csmall",
                  "Dsmall",
                  "Esmall",
                  "Fsmall",
                  "Gsmall",
                  "Hsmall",
                  "Ismall",
                  "Jsmall",
                  "Ksmall",
                  "Lsmall",
                  "Msmall",
                  "Nsmall",
                  "Osmall",
                  "Psmall",
                  "Qsmall",
                  "Rsmall",
                  "Ssmall",
                  "Tsmall",
                  "Usmall",
                  "Vsmall",
                  "Wsmall",
                  "Xsmall",
                  "Ysmall",
                  "Zsmall",
                  "colonmonetary",
                  "onefitted",
                  "rupiah",
                  "Tildesmall",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "exclamdownsmall",
                  "centoldstyle",
                  "Lslashsmall",
                  "",
                  "",
                  "Scaronsmall",
                  "Zcaronsmall",
                  "Dieresissmall",
                  "Brevesmall",
                  "Caronsmall",
                  "",
                  "Dotaccentsmall",
                  "",
                  "",
                  "Macronsmall",
                  "",
                  "",
                  "figuredash",
                  "hypheninferior",
                  "",
                  "",
                  "Ogoneksmall",
                  "Ringsmall",
                  "Cedillasmall",
                  "",
                  "",
                  "",
                  "onequarter",
                  "onehalf",
                  "threequarters",
                  "questiondownsmall",
                  "oneeighth",
                  "threeeighths",
                  "fiveeighths",
                  "seveneighths",
                  "onethird",
                  "twothirds",
                  "",
                  "",
                  "zerosuperior",
                  "onesuperior",
                  "twosuperior",
                  "threesuperior",
                  "foursuperior",
                  "fivesuperior",
                  "sixsuperior",
                  "sevensuperior",
                  "eightsuperior",
                  "ninesuperior",
                  "zeroinferior",
                  "oneinferior",
                  "twoinferior",
                  "threeinferior",
                  "fourinferior",
                  "fiveinferior",
                  "sixinferior",
                  "seveninferior",
                  "eightinferior",
                  "nineinferior",
                  "centinferior",
                  "dollarinferior",
                  "periodinferior",
                  "commainferior",
                  "Agravesmall",
                  "Aacutesmall",
                  "Acircumflexsmall",
                  "Atildesmall",
                  "Adieresissmall",
                  "Aringsmall",
                  "AEsmall",
                  "Ccedillasmall",
                  "Egravesmall",
                  "Eacutesmall",
                  "Ecircumflexsmall",
                  "Edieresissmall",
                  "Igravesmall",
                  "Iacutesmall",
                  "Icircumflexsmall",
                  "Idieresissmall",
                  "Ethsmall",
                  "Ntildesmall",
                  "Ogravesmall",
                  "Oacutesmall",
                  "Ocircumflexsmall",
                  "Otildesmall",
                  "Odieresissmall",
                  "OEsmall",
                  "Oslashsmall",
                  "Ugravesmall",
                  "Uacutesmall",
                  "Ucircumflexsmall",
                  "Udieresissmall",
                  "Yacutesmall",
                  "Thornsmall",
                  "Ydieresissmall",
                ];
                var ISOAdobeCharset = [
                  ".notdef",
                  "space",
                  "exclam",
                  "quotedbl",
                  "numbersign",
                  "dollar",
                  "percent",
                  "ampersand",
                  "quoteright",
                  "parenleft",
                  "parenright",
                  "asterisk",
                  "plus",
                  "comma",
                  "hyphen",
                  "period",
                  "slash",
                  "zero",
                  "one",
                  "two",
                  "three",
                  "four",
                  "five",
                  "six",
                  "seven",
                  "eight",
                  "nine",
                  "colon",
                  "semicolon",
                  "less",
                  "equal",
                  "greater",
                  "question",
                  "at",
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                  "M",
                  "N",
                  "O",
                  "P",
                  "Q",
                  "R",
                  "S",
                  "T",
                  "U",
                  "V",
                  "W",
                  "X",
                  "Y",
                  "Z",
                  "bracketleft",
                  "backslash",
                  "bracketright",
                  "asciicircum",
                  "underscore",
                  "quoteleft",
                  "a",
                  "b",
                  "c",
                  "d",
                  "e",
                  "f",
                  "g",
                  "h",
                  "i",
                  "j",
                  "k",
                  "l",
                  "m",
                  "n",
                  "o",
                  "p",
                  "q",
                  "r",
                  "s",
                  "t",
                  "u",
                  "v",
                  "w",
                  "x",
                  "y",
                  "z",
                  "braceleft",
                  "bar",
                  "braceright",
                  "asciitilde",
                  "exclamdown",
                  "cent",
                  "sterling",
                  "fraction",
                  "yen",
                  "florin",
                  "section",
                  "currency",
                  "quotesingle",
                  "quotedblleft",
                  "guillemotleft",
                  "guilsinglleft",
                  "guilsinglright",
                  "fi",
                  "fl",
                  "endash",
                  "dagger",
                  "daggerdbl",
                  "periodcentered",
                  "paragraph",
                  "bullet",
                  "quotesinglbase",
                  "quotedblbase",
                  "quotedblright",
                  "guillemotright",
                  "ellipsis",
                  "perthousand",
                  "questiondown",
                  "grave",
                  "acute",
                  "circumflex",
                  "tilde",
                  "macron",
                  "breve",
                  "dotaccent",
                  "dieresis",
                  "ring",
                  "cedilla",
                  "hungarumlaut",
                  "ogonek",
                  "caron",
                  "emdash",
                  "AE",
                  "ordfeminine",
                  "Lslash",
                  "Oslash",
                  "OE",
                  "ordmasculine",
                  "ae",
                  "dotlessi",
                  "lslash",
                  "oslash",
                  "oe",
                  "germandbls",
                  "onesuperior",
                  "logicalnot",
                  "mu",
                  "trademark",
                  "Eth",
                  "onehalf",
                  "plusminus",
                  "Thorn",
                  "onequarter",
                  "divide",
                  "brokenbar",
                  "degree",
                  "thorn",
                  "threequarters",
                  "twosuperior",
                  "registered",
                  "minus",
                  "eth",
                  "multiply",
                  "threesuperior",
                  "copyright",
                  "Aacute",
                  "Acircumflex",
                  "Adieresis",
                  "Agrave",
                  "Aring",
                  "Atilde",
                  "Ccedilla",
                  "Eacute",
                  "Ecircumflex",
                  "Edieresis",
                  "Egrave",
                  "Iacute",
                  "Icircumflex",
                  "Idieresis",
                  "Igrave",
                  "Ntilde",
                  "Oacute",
                  "Ocircumflex",
                  "Odieresis",
                  "Ograve",
                  "Otilde",
                  "Scaron",
                  "Uacute",
                  "Ucircumflex",
                  "Udieresis",
                  "Ugrave",
                  "Yacute",
                  "Ydieresis",
                  "Zcaron",
                  "aacute",
                  "acircumflex",
                  "adieresis",
                  "agrave",
                  "aring",
                  "atilde",
                  "ccedilla",
                  "eacute",
                  "ecircumflex",
                  "edieresis",
                  "egrave",
                  "iacute",
                  "icircumflex",
                  "idieresis",
                  "igrave",
                  "ntilde",
                  "oacute",
                  "ocircumflex",
                  "odieresis",
                  "ograve",
                  "otilde",
                  "scaron",
                  "uacute",
                  "ucircumflex",
                  "udieresis",
                  "ugrave",
                  "yacute",
                  "ydieresis",
                  "zcaron",
                ];
                var ExpertCharset = [
                  ".notdef",
                  "space",
                  "exclamsmall",
                  "Hungarumlautsmall",
                  "dollaroldstyle",
                  "dollarsuperior",
                  "ampersandsmall",
                  "Acutesmall",
                  "parenleftsuperior",
                  "parenrightsuperior",
                  "twodotenleader",
                  "onedotenleader",
                  "comma",
                  "hyphen",
                  "period",
                  "fraction",
                  "zerooldstyle",
                  "oneoldstyle",
                  "twooldstyle",
                  "threeoldstyle",
                  "fouroldstyle",
                  "fiveoldstyle",
                  "sixoldstyle",
                  "sevenoldstyle",
                  "eightoldstyle",
                  "nineoldstyle",
                  "colon",
                  "semicolon",
                  "commasuperior",
                  "threequartersemdash",
                  "periodsuperior",
                  "questionsmall",
                  "asuperior",
                  "bsuperior",
                  "centsuperior",
                  "dsuperior",
                  "esuperior",
                  "isuperior",
                  "lsuperior",
                  "msuperior",
                  "nsuperior",
                  "osuperior",
                  "rsuperior",
                  "ssuperior",
                  "tsuperior",
                  "ff",
                  "fi",
                  "fl",
                  "ffi",
                  "ffl",
                  "parenleftinferior",
                  "parenrightinferior",
                  "Circumflexsmall",
                  "hyphensuperior",
                  "Gravesmall",
                  "Asmall",
                  "Bsmall",
                  "Csmall",
                  "Dsmall",
                  "Esmall",
                  "Fsmall",
                  "Gsmall",
                  "Hsmall",
                  "Ismall",
                  "Jsmall",
                  "Ksmall",
                  "Lsmall",
                  "Msmall",
                  "Nsmall",
                  "Osmall",
                  "Psmall",
                  "Qsmall",
                  "Rsmall",
                  "Ssmall",
                  "Tsmall",
                  "Usmall",
                  "Vsmall",
                  "Wsmall",
                  "Xsmall",
                  "Ysmall",
                  "Zsmall",
                  "colonmonetary",
                  "onefitted",
                  "rupiah",
                  "Tildesmall",
                  "exclamdownsmall",
                  "centoldstyle",
                  "Lslashsmall",
                  "Scaronsmall",
                  "Zcaronsmall",
                  "Dieresissmall",
                  "Brevesmall",
                  "Caronsmall",
                  "Dotaccentsmall",
                  "Macronsmall",
                  "figuredash",
                  "hypheninferior",
                  "Ogoneksmall",
                  "Ringsmall",
                  "Cedillasmall",
                  "onequarter",
                  "onehalf",
                  "threequarters",
                  "questiondownsmall",
                  "oneeighth",
                  "threeeighths",
                  "fiveeighths",
                  "seveneighths",
                  "onethird",
                  "twothirds",
                  "zerosuperior",
                  "onesuperior",
                  "twosuperior",
                  "threesuperior",
                  "foursuperior",
                  "fivesuperior",
                  "sixsuperior",
                  "sevensuperior",
                  "eightsuperior",
                  "ninesuperior",
                  "zeroinferior",
                  "oneinferior",
                  "twoinferior",
                  "threeinferior",
                  "fourinferior",
                  "fiveinferior",
                  "sixinferior",
                  "seveninferior",
                  "eightinferior",
                  "nineinferior",
                  "centinferior",
                  "dollarinferior",
                  "periodinferior",
                  "commainferior",
                  "Agravesmall",
                  "Aacutesmall",
                  "Acircumflexsmall",
                  "Atildesmall",
                  "Adieresissmall",
                  "Aringsmall",
                  "AEsmall",
                  "Ccedillasmall",
                  "Egravesmall",
                  "Eacutesmall",
                  "Ecircumflexsmall",
                  "Edieresissmall",
                  "Igravesmall",
                  "Iacutesmall",
                  "Icircumflexsmall",
                  "Idieresissmall",
                  "Ethsmall",
                  "Ntildesmall",
                  "Ogravesmall",
                  "Oacutesmall",
                  "Ocircumflexsmall",
                  "Otildesmall",
                  "Odieresissmall",
                  "OEsmall",
                  "Oslashsmall",
                  "Ugravesmall",
                  "Uacutesmall",
                  "Ucircumflexsmall",
                  "Udieresissmall",
                  "Yacutesmall",
                  "Thornsmall",
                  "Ydieresissmall",
                ];
                var ExpertSubsetCharset = [
                  ".notdef",
                  "space",
                  "dollaroldstyle",
                  "dollarsuperior",
                  "parenleftsuperior",
                  "parenrightsuperior",
                  "twodotenleader",
                  "onedotenleader",
                  "comma",
                  "hyphen",
                  "period",
                  "fraction",
                  "zerooldstyle",
                  "oneoldstyle",
                  "twooldstyle",
                  "threeoldstyle",
                  "fouroldstyle",
                  "fiveoldstyle",
                  "sixoldstyle",
                  "sevenoldstyle",
                  "eightoldstyle",
                  "nineoldstyle",
                  "colon",
                  "semicolon",
                  "commasuperior",
                  "threequartersemdash",
                  "periodsuperior",
                  "asuperior",
                  "bsuperior",
                  "centsuperior",
                  "dsuperior",
                  "esuperior",
                  "isuperior",
                  "lsuperior",
                  "msuperior",
                  "nsuperior",
                  "osuperior",
                  "rsuperior",
                  "ssuperior",
                  "tsuperior",
                  "ff",
                  "fi",
                  "fl",
                  "ffi",
                  "ffl",
                  "parenleftinferior",
                  "parenrightinferior",
                  "hyphensuperior",
                  "colonmonetary",
                  "onefitted",
                  "rupiah",
                  "centoldstyle",
                  "figuredash",
                  "hypheninferior",
                  "onequarter",
                  "onehalf",
                  "threequarters",
                  "oneeighth",
                  "threeeighths",
                  "fiveeighths",
                  "seveneighths",
                  "onethird",
                  "twothirds",
                  "zerosuperior",
                  "onesuperior",
                  "twosuperior",
                  "threesuperior",
                  "foursuperior",
                  "fivesuperior",
                  "sixsuperior",
                  "sevensuperior",
                  "eightsuperior",
                  "ninesuperior",
                  "zeroinferior",
                  "oneinferior",
                  "twoinferior",
                  "threeinferior",
                  "fourinferior",
                  "fiveinferior",
                  "sixinferior",
                  "seveninferior",
                  "eightinferior",
                  "nineinferior",
                  "centinferior",
                  "dollarinferior",
                  "periodinferior",
                  "commainferior",
                ];
                var LangSysTable = new r.Struct({
                  reserved: new r.Reserved(r.uint16),
                  reqFeatureIndex: r.uint16,
                  featureCount: r.uint16,
                  featureIndexes: new r.Array(r.uint16, "featureCount"),
                });
                var LangSysRecord = new r.Struct({
                  tag: new r.String(4),
                  langSys: new r.Pointer(r.uint16, LangSysTable, {
                    type: "parent",
                  }),
                });
                var Script = new r.Struct({
                  defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
                  count: r.uint16,
                  langSysRecords: new r.Array(LangSysRecord, "count"),
                });
                var ScriptRecord = new r.Struct({
                  tag: new r.String(4),
                  script: new r.Pointer(r.uint16, Script, { type: "parent" }),
                });
                var ScriptList = new r.Array(ScriptRecord, r.uint16);
                var Feature = new r.Struct({
                  featureParams: r.uint16,
                  lookupCount: r.uint16,
                  lookupListIndexes: new r.Array(r.uint16, "lookupCount"),
                });
                var FeatureRecord = new r.Struct({
                  tag: new r.String(4),
                  feature: new r.Pointer(r.uint16, Feature, { type: "parent" }),
                });
                var FeatureList = new r.Array(FeatureRecord, r.uint16);
                var LookupFlags = new r.Struct({
                  markAttachmentType: r.uint8,
                  flags: new r.Bitfield(r.uint8, [
                    "rightToLeft",
                    "ignoreBaseGlyphs",
                    "ignoreLigatures",
                    "ignoreMarks",
                    "useMarkFilteringSet",
                  ]),
                });
                function LookupList(SubTable) {
                  var Lookup = new r.Struct({
                    lookupType: r.uint16,
                    flags: LookupFlags,
                    subTableCount: r.uint16,
                    subTables: new r.Array(
                      new r.Pointer(r.uint16, SubTable),
                      "subTableCount"
                    ),
                    markFilteringSet: new r.Optional(r.uint16, function (t) {
                      return t.flags.flags.useMarkFilteringSet;
                    }),
                  });
                  return new r.LazyArray(
                    new r.Pointer(r.uint16, Lookup),
                    r.uint16
                  );
                }
                var RangeRecord = new r.Struct({
                  start: r.uint16,
                  end: r.uint16,
                  startCoverageIndex: r.uint16,
                });
                var Coverage = new r.VersionedStruct(r.uint16, {
                  1: {
                    glyphCount: r.uint16,
                    glyphs: new r.Array(r.uint16, "glyphCount"),
                  },
                  2: {
                    rangeCount: r.uint16,
                    rangeRecords: new r.Array(RangeRecord, "rangeCount"),
                  },
                });
                var ClassRangeRecord = new r.Struct({
                  start: r.uint16,
                  end: r.uint16,
                  class: r.uint16,
                });
                var ClassDef = new r.VersionedStruct(r.uint16, {
                  1: {
                    startGlyph: r.uint16,
                    glyphCount: r.uint16,
                    classValueArray: new r.Array(r.uint16, "glyphCount"),
                  },
                  2: {
                    classRangeCount: r.uint16,
                    classRangeRecord: new r.Array(
                      ClassRangeRecord,
                      "classRangeCount"
                    ),
                  },
                });
                var Device = new r.Struct({
                  a: r.uint16,
                  b: r.uint16,
                  deltaFormat: r.uint16,
                });
                var LookupRecord = new r.Struct({
                  sequenceIndex: r.uint16,
                  lookupListIndex: r.uint16,
                });
                var Rule = new r.Struct({
                  glyphCount: r.uint16,
                  lookupCount: r.uint16,
                  input: new r.Array(r.uint16, function (t) {
                    return t.glyphCount - 1;
                  }),
                  lookupRecords: new r.Array(LookupRecord, "lookupCount"),
                });
                var RuleSet = new r.Array(
                  new r.Pointer(r.uint16, Rule),
                  r.uint16
                );
                var ClassRule = new r.Struct({
                  glyphCount: r.uint16,
                  lookupCount: r.uint16,
                  classes: new r.Array(r.uint16, function (t) {
                    return t.glyphCount - 1;
                  }),
                  lookupRecords: new r.Array(LookupRecord, "lookupCount"),
                });
                var ClassSet = new r.Array(
                  new r.Pointer(r.uint16, ClassRule),
                  r.uint16
                );
                var Context = new r.VersionedStruct(r.uint16, {
                  1: {
                    coverage: new r.Pointer(r.uint16, Coverage),
                    ruleSetCount: r.uint16,
                    ruleSets: new r.Array(
                      new r.Pointer(r.uint16, RuleSet),
                      "ruleSetCount"
                    ),
                  },
                  2: {
                    coverage: new r.Pointer(r.uint16, Coverage),
                    classDef: new r.Pointer(r.uint16, ClassDef),
                    classSetCnt: r.uint16,
                    classSet: new r.Array(
                      new r.Pointer(r.uint16, ClassSet),
                      "classSetCnt"
                    ),
                  },
                  3: {
                    glyphCount: r.uint16,
                    lookupCount: r.uint16,
                    coverages: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "glyphCount"
                    ),
                    lookupRecords: new r.Array(LookupRecord, "lookupCount"),
                  },
                });
                var ChainRule = new r.Struct({
                  backtrackGlyphCount: r.uint16,
                  backtrack: new r.Array(r.uint16, "backtrackGlyphCount"),
                  inputGlyphCount: r.uint16,
                  input: new r.Array(r.uint16, function (t) {
                    return t.inputGlyphCount - 1;
                  }),
                  lookaheadGlyphCount: r.uint16,
                  lookahead: new r.Array(r.uint16, "lookaheadGlyphCount"),
                  lookupCount: r.uint16,
                  lookupRecords: new r.Array(LookupRecord, "lookupCount"),
                });
                var ChainRuleSet = new r.Array(
                  new r.Pointer(r.uint16, ChainRule),
                  r.uint16
                );
                var ChainingContext = new r.VersionedStruct(r.uint16, {
                  1: {
                    coverage: new r.Pointer(r.uint16, Coverage),
                    chainCount: r.uint16,
                    chainRuleSets: new r.Array(
                      new r.Pointer(r.uint16, ChainRuleSet),
                      "chainCount"
                    ),
                  },
                  2: {
                    coverage: new r.Pointer(r.uint16, Coverage),
                    backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
                    inputClassDef: new r.Pointer(r.uint16, ClassDef),
                    lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
                    chainCount: r.uint16,
                    chainClassSet: new r.Array(
                      new r.Pointer(r.uint16, ChainRuleSet),
                      "chainCount"
                    ),
                  },
                  3: {
                    backtrackGlyphCount: r.uint16,
                    backtrackCoverage: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "backtrackGlyphCount"
                    ),
                    inputGlyphCount: r.uint16,
                    inputCoverage: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "inputGlyphCount"
                    ),
                    lookaheadGlyphCount: r.uint16,
                    lookaheadCoverage: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "lookaheadGlyphCount"
                    ),
                    lookupCount: r.uint16,
                    lookupRecords: new r.Array(LookupRecord, "lookupCount"),
                  },
                });
                var _;
                var F2DOT14 = new r.Fixed(16, "BE", 14);
                var RegionAxisCoordinates = new r.Struct({
                  startCoord: F2DOT14,
                  peakCoord: F2DOT14,
                  endCoord: F2DOT14,
                });
                var VariationRegionList = new r.Struct({
                  axisCount: r.uint16,
                  regionCount: r.uint16,
                  variationRegions: new r.Array(
                    new r.Array(RegionAxisCoordinates, "axisCount"),
                    "regionCount"
                  ),
                });
                var DeltaSet = new r.Struct({
                  shortDeltas: new r.Array(r.int16, function (t) {
                    return t.parent.shortDeltaCount;
                  }),
                  regionDeltas: new r.Array(r.int8, function (t) {
                    return t.parent.regionIndexCount - t.parent.shortDeltaCount;
                  }),
                  deltas: function deltas(t) {
                    return t.shortDeltas.concat(t.regionDeltas);
                  },
                });
                var ItemVariationData = new r.Struct({
                  itemCount: r.uint16,
                  shortDeltaCount: r.uint16,
                  regionIndexCount: r.uint16,
                  regionIndexes: new r.Array(r.uint16, "regionIndexCount"),
                  deltaSets: new r.Array(DeltaSet, "itemCount"),
                });
                var ItemVariationStore = new r.Struct({
                  format: r.uint16,
                  variationRegionList: new r.Pointer(
                    r.uint32,
                    VariationRegionList
                  ),
                  variationDataCount: r.uint16,
                  itemVariationData: new r.Array(
                    new r.Pointer(r.uint32, ItemVariationData),
                    "variationDataCount"
                  ),
                });
                var ConditionTable = new r.VersionedStruct(r.uint16, {
                  1:
                    ((_ = { axisIndex: r.uint16 }),
                    (_["axisIndex"] = r.uint16),
                    (_.filterRangeMinValue = F2DOT14),
                    (_.filterRangeMaxValue = F2DOT14),
                    _),
                });
                var ConditionSet = new r.Struct({
                  conditionCount: r.uint16,
                  conditionTable: new r.Array(
                    new r.Pointer(r.uint32, ConditionTable),
                    "conditionCount"
                  ),
                });
                var FeatureTableSubstitutionRecord = new r.Struct({
                  featureIndex: r.uint16,
                  alternateFeatureTable: new r.Pointer(r.uint32, Feature, {
                    type: "parent",
                  }),
                });
                var FeatureTableSubstitution = new r.Struct({
                  version: r.fixed32,
                  substitutionCount: r.uint16,
                  substitutions: new r.Array(
                    FeatureTableSubstitutionRecord,
                    "substitutionCount"
                  ),
                });
                var FeatureVariationRecord = new r.Struct({
                  conditionSet: new r.Pointer(r.uint32, ConditionSet, {
                    type: "parent",
                  }),
                  featureTableSubstitution: new r.Pointer(
                    r.uint32,
                    FeatureTableSubstitution,
                    { type: "parent" }
                  ),
                });
                var FeatureVariations = new r.Struct({
                  majorVersion: r.uint16,
                  minorVersion: r.uint16,
                  featureVariationRecordCount: r.uint32,
                  featureVariationRecords: new r.Array(
                    FeatureVariationRecord,
                    "featureVariationRecordCount"
                  ),
                });
                var PredefinedOp = (function () {
                  function PredefinedOp(predefinedOps, type) {
                    _classCallCheck(this, PredefinedOp);
                    this.predefinedOps = predefinedOps;
                    this.type = type;
                  }
                  PredefinedOp.prototype.decode = function decode(
                    stream,
                    parent,
                    operands
                  ) {
                    if (this.predefinedOps[operands[0]]) {
                      return this.predefinedOps[operands[0]];
                    }
                    return this.type.decode(stream, parent, operands);
                  };
                  PredefinedOp.prototype.size = function size(value, ctx) {
                    return this.type.size(value, ctx);
                  };
                  PredefinedOp.prototype.encode = function encode(
                    stream,
                    value,
                    ctx
                  ) {
                    var index = this.predefinedOps.indexOf(value);
                    if (index !== -1) {
                      return index;
                    }
                    return this.type.encode(stream, value, ctx);
                  };
                  return PredefinedOp;
                })();
                var CFFEncodingVersion = (function (_r$Number) {
                  _inherits(CFFEncodingVersion, _r$Number);
                  function CFFEncodingVersion() {
                    _classCallCheck(this, CFFEncodingVersion);
                    return _possibleConstructorReturn(
                      this,
                      _r$Number.call(this, "UInt8")
                    );
                  }
                  CFFEncodingVersion.prototype.decode = function decode(stream) {
                    return r.uint8.decode(stream) & 127;
                  };
                  return CFFEncodingVersion;
                })(r.Number);
                var Range1 = new r.Struct({
                  first: r.uint16,
                  nLeft: r.uint8,
                });
                var Range2 = new r.Struct({
                  first: r.uint16,
                  nLeft: r.uint16,
                });
                var CFFCustomEncoding = new r.VersionedStruct(
                  new CFFEncodingVersion(),
                  {
                    0: {
                      nCodes: r.uint8,
                      codes: new r.Array(r.uint8, "nCodes"),
                    },
                    1: {
                      nRanges: r.uint8,
                      ranges: new r.Array(Range1, "nRanges"),
                    },
                  }
                );
                var CFFEncoding = new PredefinedOp(
                  [StandardEncoding, ExpertEncoding],
                  new CFFPointer(CFFCustomEncoding, { lazy: true })
                );
                var RangeArray = (function (_r$Array) {
                  _inherits(RangeArray, _r$Array);
                  function RangeArray() {
                    _classCallCheck(this, RangeArray);
                    return _possibleConstructorReturn(
                      this,
                      _r$Array.apply(this, arguments)
                    );
                  }
                  RangeArray.prototype.decode = function decode(stream, parent) {
                    var length = restructure_src_utils.resolveLength(
                      this.length,
                      stream,
                      parent
                    );
                    var count = 0;
                    var res = [];
                    while (count < length) {
                      var range = this.type.decode(stream, parent);
                      range.offset = count;
                      count += range.nLeft + 1;
                      res.push(range);
                    }
                    return res;
                  };
                  return RangeArray;
                })(r.Array);
                var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
                  0: {
                    glyphs: new r.Array(r.uint16, function (t) {
                      return t.parent.CharStrings.length - 1;
                    }),
                  },
                  1: {
                    ranges: new RangeArray(Range1, function (t) {
                      return t.parent.CharStrings.length - 1;
                    }),
                  },
                  2: {
                    ranges: new RangeArray(Range2, function (t) {
                      return t.parent.CharStrings.length - 1;
                    }),
                  },
                });
                var CFFCharset = new PredefinedOp(
                  [ISOAdobeCharset, ExpertCharset, ExpertSubsetCharset],
                  new CFFPointer(CFFCustomCharset, { lazy: true })
                );
                var FDRange3 = new r.Struct({
                  first: r.uint16,
                  fd: r.uint8,
                });
                var FDRange4 = new r.Struct({
                  first: r.uint32,
                  fd: r.uint16,
                });
                var FDSelect = new r.VersionedStruct(r.uint8, {
                  0: {
                    fds: new r.Array(r.uint8, function (t) {
                      return t.parent.CharStrings.length;
                    }),
                  },
                  3: {
                    nRanges: r.uint16,
                    ranges: new r.Array(FDRange3, "nRanges"),
                    sentinel: r.uint16,
                  },
                  4: {
                    nRanges: r.uint32,
                    ranges: new r.Array(FDRange4, "nRanges"),
                    sentinel: r.uint32,
                  },
                });
                var ptr = new CFFPointer(CFFPrivateDict);
                var CFFPrivateOp = (function () {
                  function CFFPrivateOp() {
                    _classCallCheck(this, CFFPrivateOp);
                  }
                  CFFPrivateOp.prototype.decode = function decode(
                    stream,
                    parent,
                    operands
                  ) {
                    parent.length = operands[0];
                    return ptr.decode(stream, parent, [operands[1]]);
                  };
                  CFFPrivateOp.prototype.size = function size(dict, ctx) {
                    return [
                      CFFPrivateDict.size(dict, ctx, false),
                      ptr.size(dict, ctx)[0],
                    ];
                  };
                  CFFPrivateOp.prototype.encode = function encode(
                    stream,
                    dict,
                    ctx
                  ) {
                    return [
                      CFFPrivateDict.size(dict, ctx, false),
                      ptr.encode(stream, dict, ctx)[0],
                    ];
                  };
                  return CFFPrivateOp;
                })();
                var FontDict = new CFFDict([
                  [18, "Private", new CFFPrivateOp(), null],
                  [[12, 38], "FontName", "sid", null],
                  [[12, 7], "FontMatrix", "array", [0.001, 0, 0, 0.001, 0, 0]],
                  [[12, 5], "PaintType", "number", 0],
                ]);
                var CFFTopDict = new CFFDict([
                  [[12, 30], "ROS", ["sid", "sid", "number"], null],
                  [0, "version", "sid", null],
                  [1, "Notice", "sid", null],
                  [[12, 0], "Copyright", "sid", null],
                  [2, "FullName", "sid", null],
                  [3, "FamilyName", "sid", null],
                  [4, "Weight", "sid", null],
                  [[12, 1], "isFixedPitch", "boolean", false],
                  [[12, 2], "ItalicAngle", "number", 0],
                  [[12, 3], "UnderlinePosition", "number", -100],
                  [[12, 4], "UnderlineThickness", "number", 50],
                  [[12, 5], "PaintType", "number", 0],
                  [[12, 6], "CharstringType", "number", 2],
                  [[12, 7], "FontMatrix", "array", [0.001, 0, 0, 0.001, 0, 0]],
                  [13, "UniqueID", "number", null],
                  [5, "FontBBox", "array", [0, 0, 0, 0]],
                  [[12, 8], "StrokeWidth", "number", 0],
                  [14, "XUID", "array", null],
                  [15, "charset", CFFCharset, ISOAdobeCharset],
                  [16, "Encoding", CFFEncoding, StandardEncoding],
                  [17, "CharStrings", new CFFPointer(new CFFIndex()), null],
                  [18, "Private", new CFFPrivateOp(), null],
                  [[12, 20], "SyntheticBase", "number", null],
                  [[12, 21], "PostScript", "sid", null],
                  [[12, 22], "BaseFontName", "sid", null],
                  [[12, 23], "BaseFontBlend", "delta", null],
                  [[12, 31], "CIDFontVersion", "number", 0],
                  [[12, 32], "CIDFontRevision", "number", 0],
                  [[12, 33], "CIDFontType", "number", 0],
                  [[12, 34], "CIDCount", "number", 8720],
                  [[12, 35], "UIDBase", "number", null],
                  [[12, 37], "FDSelect", new CFFPointer(FDSelect), null],
                  [
                    [12, 36],
                    "FDArray",
                    new CFFPointer(new CFFIndex(FontDict)),
                    null,
                  ],
                  [[12, 38], "FontName", "sid", null],
                ]);
                var VariationStore = new r.Struct({
                  length: r.uint16,
                  itemVariationStore: ItemVariationStore,
                });
                var CFF2TopDict = new CFFDict([
                  [[12, 7], "FontMatrix", "array", [0.001, 0, 0, 0.001, 0, 0]],
                  [17, "CharStrings", new CFFPointer(new CFFIndex()), null],
                  [[12, 37], "FDSelect", new CFFPointer(FDSelect), null],
                  [
                    [12, 36],
                    "FDArray",
                    new CFFPointer(new CFFIndex(FontDict)),
                    null,
                  ],
                  [24, "vstore", new CFFPointer(VariationStore), null],
                  [25, "maxstack", "number", 193],
                ]);
                var CFFTop = new r.VersionedStruct(r.fixed16, {
                  1: {
                    hdrSize: r.uint8,
                    offSize: r.uint8,
                    nameIndex: new CFFIndex(new r.String("length")),
                    topDictIndex: new CFFIndex(CFFTopDict),
                    stringIndex: new CFFIndex(new r.String("length")),
                    globalSubrIndex: new CFFIndex(),
                  },
                  2: {
                    hdrSize: r.uint8,
                    length: r.uint16,
                    topDict: CFF2TopDict,
                    globalSubrIndex: new CFFIndex(),
                  },
                });
                var CFFFont = (function () {
                  function CFFFont(stream) {
                    _classCallCheck(this, CFFFont);
                    this.stream = stream;
                    this.decode();
                  }
                  CFFFont.decode = function decode(stream) {
                    return new CFFFont(stream);
                  };
                  CFFFont.prototype.decode = function decode() {
                    var start = this.stream.pos;
                    var top = CFFTop.decode(this.stream);
                    for (var key in top) {
                      var val = top[key];
                      this[key] = val;
                    }
                    if (this.version < 2) {
                      if (this.topDictIndex.length !== 1) {
                        throw new Error("Only a single font is allowed in CFF");
                      }
                      this.topDict = this.topDictIndex[0];
                    }
                    this.isCIDFont = this.topDict.ROS != null;
                    return this;
                  };
                  CFFFont.prototype.string = function string(sid) {
                    if (this.version >= 2) {
                      return null;
                    }
                    if (sid < standardStrings.length) {
                      return standardStrings[sid];
                    }
                    return this.stringIndex[sid - standardStrings.length];
                  };
                  CFFFont.prototype.getCharString = function getCharString(
                    glyph
                  ) {
                    this.stream.pos = this.topDict.CharStrings[glyph].offset;
                    return this.stream.readBuffer(
                      this.topDict.CharStrings[glyph].length
                    );
                  };
                  CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
                    if (this.version >= 2) {
                      return null;
                    }
                    if (this.isCIDFont) {
                      return null;
                    }
                    var charset = this.topDict.charset;
                    if (Array.isArray(charset)) {
                      return charset[gid];
                    }
                    if (gid === 0) {
                      return ".notdef";
                    }
                    gid -= 1;
                    switch (charset.version) {
                      case 0:
                        return this.string(charset.glyphs[gid]);
                      case 1:
                      case 2:
                        for (var i = 0; i < charset.ranges.length; i++) {
                          var range = charset.ranges[i];
                          if (
                            range.offset <= gid &&
                            gid <= range.offset + range.nLeft
                          ) {
                            return this.string(
                              range.first + (gid - range.offset)
                            );
                          }
                        }
                        break;
                    }
                    return null;
                  };
                  CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
                    if (!this.topDict.FDSelect) {
                      return null;
                    }
                    switch (this.topDict.FDSelect.version) {
                      case 0:
                        return this.topDict.FDSelect.fds[gid];
                      case 3:
                      case 4:
                        var ranges = this.topDict.FDSelect.ranges;
                        var low = 0;
                        var high = ranges.length - 1;
                        while (low <= high) {
                          var mid = (low + high) >> 1;
                          if (gid < ranges[mid].first) {
                            high = mid - 1;
                          } else if (mid < high && gid >= ranges[mid + 1].first) {
                            low = mid + 1;
                          } else {
                            return ranges[mid].fd;
                          }
                        }
                      default:
                        throw new Error(
                          "Unknown FDSelect version: " +
                            this.topDict.FDSelect.version
                        );
                    }
                  };
                  CFFFont.prototype.privateDictForGlyph =
                    function privateDictForGlyph(gid) {
                      if (this.topDict.FDSelect) {
                        var fd = this.fdForGlyph(gid);
                        if (this.topDict.FDArray[fd]) {
                          return this.topDict.FDArray[fd].Private;
                        }
                        return null;
                      }
                      if (this.version < 2) {
                        return this.topDict.Private;
                      }
                      return this.topDict.FDArray[0].Private;
                    };
                  _createClass(CFFFont, [
                    {
                      key: "postscriptName",
                      get: function get() {
                        if (this.version < 2) {
                          return this.nameIndex[0];
                        }
                        return null;
                      },
                    },
                    {
                      key: "fullName",
                      get: function get() {
                        return this.string(this.topDict.FullName);
                      },
                    },
                    {
                      key: "familyName",
                      get: function get() {
                        return this.string(this.topDict.FamilyName);
                      },
                    },
                  ]);
                  return CFFFont;
                })();
                var VerticalOrigin = new r.Struct({
                  glyphIndex: r.uint16,
                  vertOriginY: r.int16,
                });
                var VORG = new r.Struct({
                  majorVersion: r.uint16,
                  minorVersion: r.uint16,
                  defaultVertOriginY: r.int16,
                  numVertOriginYMetrics: r.uint16,
                  metrics: new r.Array(VerticalOrigin, "numVertOriginYMetrics"),
                });
                var BigMetrics = new r.Struct({
                  height: r.uint8,
                  width: r.uint8,
                  horiBearingX: r.int8,
                  horiBearingY: r.int8,
                  horiAdvance: r.uint8,
                  vertBearingX: r.int8,
                  vertBearingY: r.int8,
                  vertAdvance: r.uint8,
                });
                var SmallMetrics = new r.Struct({
                  height: r.uint8,
                  width: r.uint8,
                  bearingX: r.int8,
                  bearingY: r.int8,
                  advance: r.uint8,
                });
                var EBDTComponent = new r.Struct({
                  glyph: r.uint16,
                  xOffset: r.int8,
                  yOffset: r.int8,
                });
                var ByteAligned = function ByteAligned() {
                  _classCallCheck(this, ByteAligned);
                };
                var BitAligned = function BitAligned() {
                  _classCallCheck(this, BitAligned);
                };
                var glyph = new r.VersionedStruct("version", {
                  1: {
                    metrics: SmallMetrics,
                    data: ByteAligned,
                  },
                  2: {
                    metrics: SmallMetrics,
                    data: BitAligned,
                  },
                  5: { data: BitAligned },
                  6: {
                    metrics: BigMetrics,
                    data: ByteAligned,
                  },
                  7: {
                    metrics: BigMetrics,
                    data: BitAligned,
                  },
                  8: {
                    metrics: SmallMetrics,
                    pad: new r.Reserved(r.uint8),
                    numComponents: r.uint16,
                    components: new r.Array(EBDTComponent, "numComponents"),
                  },
                  9: {
                    metrics: BigMetrics,
                    pad: new r.Reserved(r.uint8),
                    numComponents: r.uint16,
                    components: new r.Array(EBDTComponent, "numComponents"),
                  },
                  17: {
                    metrics: SmallMetrics,
                    dataLen: r.uint32,
                    data: new r.Buffer("dataLen"),
                  },
                  18: {
                    metrics: BigMetrics,
                    dataLen: r.uint32,
                    data: new r.Buffer("dataLen"),
                  },
                  19: {
                    dataLen: r.uint32,
                    data: new r.Buffer("dataLen"),
                  },
                });
                var SBitLineMetrics = new r.Struct({
                  ascender: r.int8,
                  descender: r.int8,
                  widthMax: r.uint8,
                  caretSlopeNumerator: r.int8,
                  caretSlopeDenominator: r.int8,
                  caretOffset: r.int8,
                  minOriginSB: r.int8,
                  minAdvanceSB: r.int8,
                  maxBeforeBL: r.int8,
                  minAfterBL: r.int8,
                  pad: new r.Reserved(r.int8, 2),
                });
                var CodeOffsetPair = new r.Struct({
                  glyphCode: r.uint16,
                  offset: r.uint16,
                });
                var IndexSubtable = new r.VersionedStruct(r.uint16, {
                  header: {
                    imageFormat: r.uint16,
                    imageDataOffset: r.uint32,
                  },
                  1: {
                    offsetArray: new r.Array(r.uint32, function (t) {
                      return (
                        t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1
                      );
                    }),
                  },
                  2: {
                    imageSize: r.uint32,
                    bigMetrics: BigMetrics,
                  },
                  3: {
                    offsetArray: new r.Array(r.uint16, function (t) {
                      return (
                        t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1
                      );
                    }),
                  },
                  4: {
                    numGlyphs: r.uint32,
                    glyphArray: new r.Array(CodeOffsetPair, function (t) {
                      return t.numGlyphs + 1;
                    }),
                  },
                  5: {
                    imageSize: r.uint32,
                    bigMetrics: BigMetrics,
                    numGlyphs: r.uint32,
                    glyphCodeArray: new r.Array(r.uint16, "numGlyphs"),
                  },
                });
                var IndexSubtableArray = new r.Struct({
                  firstGlyphIndex: r.uint16,
                  lastGlyphIndex: r.uint16,
                  subtable: new r.Pointer(r.uint32, IndexSubtable),
                });
                var BitmapSizeTable = new r.Struct({
                  indexSubTableArray: new r.Pointer(
                    r.uint32,
                    new r.Array(IndexSubtableArray, 1),
                    { type: "parent" }
                  ),
                  indexTablesSize: r.uint32,
                  numberOfIndexSubTables: r.uint32,
                  colorRef: r.uint32,
                  hori: SBitLineMetrics,
                  vert: SBitLineMetrics,
                  startGlyphIndex: r.uint16,
                  endGlyphIndex: r.uint16,
                  ppemX: r.uint8,
                  ppemY: r.uint8,
                  bitDepth: r.uint8,
                  flags: new r.Bitfield(r.uint8, ["horizontal", "vertical"]),
                });
                var EBLC = new r.Struct({
                  version: r.uint32,
                  numSizes: r.uint32,
                  sizes: new r.Array(BitmapSizeTable, "numSizes"),
                });
                var ImageTable = new r.Struct({
                  ppem: r.uint16,
                  resolution: r.uint16,
                  imageOffsets: new r.Array(
                    new r.Pointer(r.uint32, "void"),
                    function (t) {
                      return t.parent.parent.maxp.numGlyphs + 1;
                    }
                  ),
                });
                var sbix = new r.Struct({
                  version: r.uint16,
                  flags: new r.Bitfield(r.uint16, ["renderOutlines"]),
                  numImgTables: r.uint32,
                  imageTables: new r.Array(
                    new r.Pointer(r.uint32, ImageTable),
                    "numImgTables"
                  ),
                });
                var LayerRecord = new r.Struct({
                  gid: r.uint16,
                  paletteIndex: r.uint16,
                });
                var BaseGlyphRecord = new r.Struct({
                  gid: r.uint16,
                  firstLayerIndex: r.uint16,
                  numLayers: r.uint16,
                });
                var COLR = new r.Struct({
                  version: r.uint16,
                  numBaseGlyphRecords: r.uint16,
                  baseGlyphRecord: new r.Pointer(
                    r.uint32,
                    new r.Array(BaseGlyphRecord, "numBaseGlyphRecords")
                  ),
                  layerRecords: new r.Pointer(
                    r.uint32,
                    new r.Array(LayerRecord, "numLayerRecords"),
                    { lazy: true }
                  ),
                  numLayerRecords: r.uint16,
                });
                var ColorRecord = new r.Struct({
                  blue: r.uint8,
                  green: r.uint8,
                  red: r.uint8,
                  alpha: r.uint8,
                });
                var CPAL = new r.VersionedStruct(r.uint16, {
                  header: {
                    numPaletteEntries: r.uint16,
                    numPalettes: r.uint16,
                    numColorRecords: r.uint16,
                    colorRecords: new r.Pointer(
                      r.uint32,
                      new r.Array(ColorRecord, "numColorRecords")
                    ),
                    colorRecordIndices: new r.Array(r.uint16, "numPalettes"),
                  },
                  0: {},
                  1: {
                    offsetPaletteTypeArray: new r.Pointer(
                      r.uint32,
                      new r.Array(r.uint32, "numPalettes")
                    ),
                    offsetPaletteLabelArray: new r.Pointer(
                      r.uint32,
                      new r.Array(r.uint16, "numPalettes")
                    ),
                    offsetPaletteEntryLabelArray: new r.Pointer(
                      r.uint32,
                      new r.Array(r.uint16, "numPaletteEntries")
                    ),
                  },
                });
                var BaseCoord = new r.VersionedStruct(r.uint16, {
                  1: { coordinate: r.int16 },
                  2: {
                    coordinate: r.int16,
                    referenceGlyph: r.uint16,
                    baseCoordPoint: r.uint16,
                  },
                  3: {
                    coordinate: r.int16,
                    deviceTable: new r.Pointer(r.uint16, Device),
                  },
                });
                var BaseValues = new r.Struct({
                  defaultIndex: r.uint16,
                  baseCoordCount: r.uint16,
                  baseCoords: new r.Array(
                    new r.Pointer(r.uint16, BaseCoord),
                    "baseCoordCount"
                  ),
                });
                var FeatMinMaxRecord = new r.Struct({
                  tag: new r.String(4),
                  minCoord: new r.Pointer(r.uint16, BaseCoord, {
                    type: "parent",
                  }),
                  maxCoord: new r.Pointer(r.uint16, BaseCoord, {
                    type: "parent",
                  }),
                });
                var MinMax = new r.Struct({
                  minCoord: new r.Pointer(r.uint16, BaseCoord),
                  maxCoord: new r.Pointer(r.uint16, BaseCoord),
                  featMinMaxCount: r.uint16,
                  featMinMaxRecords: new r.Array(
                    FeatMinMaxRecord,
                    "featMinMaxCount"
                  ),
                });
                var BaseLangSysRecord = new r.Struct({
                  tag: new r.String(4),
                  minMax: new r.Pointer(r.uint16, MinMax, { type: "parent" }),
                });
                var BaseScript = new r.Struct({
                  baseValues: new r.Pointer(r.uint16, BaseValues),
                  defaultMinMax: new r.Pointer(r.uint16, MinMax),
                  baseLangSysCount: r.uint16,
                  baseLangSysRecords: new r.Array(
                    BaseLangSysRecord,
                    "baseLangSysCount"
                  ),
                });
                var BaseScriptRecord = new r.Struct({
                  tag: new r.String(4),
                  script: new r.Pointer(r.uint16, BaseScript, { type: "parent" }),
                });
                var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16);
                var BaseTagList = new r.Array(new r.String(4), r.uint16);
                var Axis = new r.Struct({
                  baseTagList: new r.Pointer(r.uint16, BaseTagList),
                  baseScriptList: new r.Pointer(r.uint16, BaseScriptList),
                });
                var BASE = new r.VersionedStruct(r.uint32, {
                  header: {
                    horizAxis: new r.Pointer(r.uint16, Axis),
                    vertAxis: new r.Pointer(r.uint16, Axis),
                  },
                  65536: {},
                  65537: {
                    itemVariationStore: new r.Pointer(
                      r.uint32,
                      ItemVariationStore
                    ),
                  },
                });
                var AttachPoint = new r.Array(r.uint16, r.uint16);
                var AttachList = new r.Struct({
                  coverage: new r.Pointer(r.uint16, Coverage),
                  glyphCount: r.uint16,
                  attachPoints: new r.Array(
                    new r.Pointer(r.uint16, AttachPoint),
                    "glyphCount"
                  ),
                });
                var CaretValue = new r.VersionedStruct(r.uint16, {
                  1: { coordinate: r.int16 },
                  2: { caretValuePoint: r.uint16 },
                  3: {
                    coordinate: r.int16,
                    deviceTable: new r.Pointer(r.uint16, Device),
                  },
                });
                var LigGlyph = new r.Array(
                  new r.Pointer(r.uint16, CaretValue),
                  r.uint16
                );
                var LigCaretList = new r.Struct({
                  coverage: new r.Pointer(r.uint16, Coverage),
                  ligGlyphCount: r.uint16,
                  ligGlyphs: new r.Array(
                    new r.Pointer(r.uint16, LigGlyph),
                    "ligGlyphCount"
                  ),
                });
                var MarkGlyphSetsDef = new r.Struct({
                  markSetTableFormat: r.uint16,
                  markSetCount: r.uint16,
                  coverage: new r.Array(
                    new r.Pointer(r.uint32, Coverage),
                    "markSetCount"
                  ),
                });
                var GDEF = new r.VersionedStruct(r.uint32, {
                  header: {
                    glyphClassDef: new r.Pointer(r.uint16, ClassDef),
                    attachList: new r.Pointer(r.uint16, AttachList),
                    ligCaretList: new r.Pointer(r.uint16, LigCaretList),
                    markAttachClassDef: new r.Pointer(r.uint16, ClassDef),
                  },
                  65536: {},
                  65538: {
                    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
                  },
                  65539: {
                    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
                    itemVariationStore: new r.Pointer(
                      r.uint32,
                      ItemVariationStore
                    ),
                  },
                });
                var ValueFormat = new r.Bitfield(r.uint16, [
                  "xPlacement",
                  "yPlacement",
                  "xAdvance",
                  "yAdvance",
                  "xPlaDevice",
                  "yPlaDevice",
                  "xAdvDevice",
                  "yAdvDevice",
                ]);
                var types = {
                  xPlacement: r.int16,
                  yPlacement: r.int16,
                  xAdvance: r.int16,
                  yAdvance: r.int16,
                  xPlaDevice: new r.Pointer(r.uint16, Device, {
                    type: "global",
                    relativeTo: "rel",
                  }),
                  yPlaDevice: new r.Pointer(r.uint16, Device, {
                    type: "global",
                    relativeTo: "rel",
                  }),
                  xAdvDevice: new r.Pointer(r.uint16, Device, {
                    type: "global",
                    relativeTo: "rel",
                  }),
                  yAdvDevice: new r.Pointer(r.uint16, Device, {
                    type: "global",
                    relativeTo: "rel",
                  }),
                };
                var ValueRecord = (function () {
                  function ValueRecord() {
                    var key =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : "valueFormat";
                    _classCallCheck(this, ValueRecord);
                    this.key = key;
                  }
                  ValueRecord.prototype.buildStruct = function buildStruct(
                    parent
                  ) {
                    var struct = parent;
                    while (!struct[this.key] && struct.parent) {
                      struct = struct.parent;
                    }
                    if (!struct[this.key]) return;
                    var fields = {};
                    fields.rel = function () {
                      return struct._startOffset;
                    };
                    var format = struct[this.key];
                    for (var key in format) {
                      if (format[key]) {
                        fields[key] = types[key];
                      }
                    }
                    return new r.Struct(fields);
                  };
                  ValueRecord.prototype.size = function size(val, ctx) {
                    return this.buildStruct(ctx).size(val, ctx);
                  };
                  ValueRecord.prototype.decode = function decode(stream, parent) {
                    var res = this.buildStruct(parent).decode(stream, parent);
                    delete res.rel;
                    return res;
                  };
                  return ValueRecord;
                })();
                var PairValueRecord = new r.Struct({
                  secondGlyph: r.uint16,
                  value1: new ValueRecord("valueFormat1"),
                  value2: new ValueRecord("valueFormat2"),
                });
                var PairSet = new r.Array(PairValueRecord, r.uint16);
                var Class2Record = new r.Struct({
                  value1: new ValueRecord("valueFormat1"),
                  value2: new ValueRecord("valueFormat2"),
                });
                var Anchor = new r.VersionedStruct(r.uint16, {
                  1: {
                    xCoordinate: r.int16,
                    yCoordinate: r.int16,
                  },
                  2: {
                    xCoordinate: r.int16,
                    yCoordinate: r.int16,
                    anchorPoint: r.uint16,
                  },
                  3: {
                    xCoordinate: r.int16,
                    yCoordinate: r.int16,
                    xDeviceTable: new r.Pointer(r.uint16, Device),
                    yDeviceTable: new r.Pointer(r.uint16, Device),
                  },
                });
                var EntryExitRecord = new r.Struct({
                  entryAnchor: new r.Pointer(r.uint16, Anchor, {
                    type: "parent",
                  }),
                  exitAnchor: new r.Pointer(r.uint16, Anchor, { type: "parent" }),
                });
                var MarkRecord = new r.Struct({
                  class: r.uint16,
                  markAnchor: new r.Pointer(r.uint16, Anchor, { type: "parent" }),
                });
                var MarkArray = new r.Array(MarkRecord, r.uint16);
                var BaseRecord = new r.Array(
                  new r.Pointer(r.uint16, Anchor),
                  function (t) {
                    return t.parent.classCount;
                  }
                );
                var BaseArray = new r.Array(BaseRecord, r.uint16);
                var ComponentRecord = new r.Array(
                  new r.Pointer(r.uint16, Anchor),
                  function (t) {
                    return t.parent.parent.classCount;
                  }
                );
                var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
                var LigatureArray = new r.Array(
                  new r.Pointer(r.uint16, LigatureAttach),
                  r.uint16
                );
                var GPOSLookup = new r.VersionedStruct("lookupType", {
                  1: new r.VersionedStruct(r.uint16, {
                    1: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      valueFormat: ValueFormat,
                      value: new ValueRecord(),
                    },
                    2: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      valueFormat: ValueFormat,
                      valueCount: r.uint16,
                      values: new r.LazyArray(new ValueRecord(), "valueCount"),
                    },
                  }),
                  2: new r.VersionedStruct(r.uint16, {
                    1: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      valueFormat1: ValueFormat,
                      valueFormat2: ValueFormat,
                      pairSetCount: r.uint16,
                      pairSets: new r.LazyArray(
                        new r.Pointer(r.uint16, PairSet),
                        "pairSetCount"
                      ),
                    },
                    2: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      valueFormat1: ValueFormat,
                      valueFormat2: ValueFormat,
                      classDef1: new r.Pointer(r.uint16, ClassDef),
                      classDef2: new r.Pointer(r.uint16, ClassDef),
                      class1Count: r.uint16,
                      class2Count: r.uint16,
                      classRecords: new r.LazyArray(
                        new r.LazyArray(Class2Record, "class2Count"),
                        "class1Count"
                      ),
                    },
                  }),
                  3: {
                    format: r.uint16,
                    coverage: new r.Pointer(r.uint16, Coverage),
                    entryExitCount: r.uint16,
                    entryExitRecords: new r.Array(
                      EntryExitRecord,
                      "entryExitCount"
                    ),
                  },
                  4: {
                    format: r.uint16,
                    markCoverage: new r.Pointer(r.uint16, Coverage),
                    baseCoverage: new r.Pointer(r.uint16, Coverage),
                    classCount: r.uint16,
                    markArray: new r.Pointer(r.uint16, MarkArray),
                    baseArray: new r.Pointer(r.uint16, BaseArray),
                  },
                  5: {
                    format: r.uint16,
                    markCoverage: new r.Pointer(r.uint16, Coverage),
                    ligatureCoverage: new r.Pointer(r.uint16, Coverage),
                    classCount: r.uint16,
                    markArray: new r.Pointer(r.uint16, MarkArray),
                    ligatureArray: new r.Pointer(r.uint16, LigatureArray),
                  },
                  6: {
                    format: r.uint16,
                    mark1Coverage: new r.Pointer(r.uint16, Coverage),
                    mark2Coverage: new r.Pointer(r.uint16, Coverage),
                    classCount: r.uint16,
                    mark1Array: new r.Pointer(r.uint16, MarkArray),
                    mark2Array: new r.Pointer(r.uint16, BaseArray),
                  },
                  7: Context,
                  8: ChainingContext,
                  9: {
                    posFormat: r.uint16,
                    lookupType: r.uint16,
                    extension: new r.Pointer(r.uint32, GPOSLookup),
                  },
                });
                GPOSLookup.versions[9].extension.type = GPOSLookup;
                var GPOS = new r.VersionedStruct(r.uint32, {
                  header: {
                    scriptList: new r.Pointer(r.uint16, ScriptList),
                    featureList: new r.Pointer(r.uint16, FeatureList),
                    lookupList: new r.Pointer(
                      r.uint16,
                      new LookupList(GPOSLookup)
                    ),
                  },
                  65536: {},
                  65537: {
                    featureVariations: new r.Pointer(r.uint32, FeatureVariations),
                  },
                });
                var Sequence = new r.Array(r.uint16, r.uint16);
                var AlternateSet = Sequence;
                var Ligature = new r.Struct({
                  glyph: r.uint16,
                  compCount: r.uint16,
                  components: new r.Array(r.uint16, function (t) {
                    return t.compCount - 1;
                  }),
                });
                var LigatureSet = new r.Array(
                  new r.Pointer(r.uint16, Ligature),
                  r.uint16
                );
                var GSUBLookup = new r.VersionedStruct("lookupType", {
                  1: new r.VersionedStruct(r.uint16, {
                    1: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      deltaGlyphID: r.int16,
                    },
                    2: {
                      coverage: new r.Pointer(r.uint16, Coverage),
                      glyphCount: r.uint16,
                      substitute: new r.LazyArray(r.uint16, "glyphCount"),
                    },
                  }),
                  2: {
                    substFormat: r.uint16,
                    coverage: new r.Pointer(r.uint16, Coverage),
                    count: r.uint16,
                    sequences: new r.LazyArray(
                      new r.Pointer(r.uint16, Sequence),
                      "count"
                    ),
                  },
                  3: {
                    substFormat: r.uint16,
                    coverage: new r.Pointer(r.uint16, Coverage),
                    count: r.uint16,
                    alternateSet: new r.LazyArray(
                      new r.Pointer(r.uint16, AlternateSet),
                      "count"
                    ),
                  },
                  4: {
                    substFormat: r.uint16,
                    coverage: new r.Pointer(r.uint16, Coverage),
                    count: r.uint16,
                    ligatureSets: new r.LazyArray(
                      new r.Pointer(r.uint16, LigatureSet),
                      "count"
                    ),
                  },
                  5: Context,
                  6: ChainingContext,
                  7: {
                    substFormat: r.uint16,
                    lookupType: r.uint16,
                    extension: new r.Pointer(r.uint32, GSUBLookup),
                  },
                  8: {
                    substFormat: r.uint16,
                    coverage: new r.Pointer(r.uint16, Coverage),
                    backtrackCoverage: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "backtrackGlyphCount"
                    ),
                    lookaheadGlyphCount: r.uint16,
                    lookaheadCoverage: new r.Array(
                      new r.Pointer(r.uint16, Coverage),
                      "lookaheadGlyphCount"
                    ),
                    glyphCount: r.uint16,
                    substitutes: new r.Array(r.uint16, "glyphCount"),
                  },
                });
                GSUBLookup.versions[7].extension.type = GSUBLookup;
                var GSUB = new r.VersionedStruct(r.uint32, {
                  header: {
                    scriptList: new r.Pointer(r.uint16, ScriptList),
                    featureList: new r.Pointer(r.uint16, FeatureList),
                    lookupList: new r.Pointer(
                      r.uint16,
                      new LookupList(GSUBLookup)
                    ),
                  },
                  65536: {},
                  65537: {
                    featureVariations: new r.Pointer(r.uint32, FeatureVariations),
                  },
                });
                var JstfGSUBModList = new r.Array(r.uint16, r.uint16);
                var JstfPriority = new r.Struct({
                  shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                  shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                  shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                  shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                  shrinkageJstfMax: new r.Pointer(
                    r.uint16,
                    new LookupList(GPOSLookup)
                  ),
                  extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                  extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
                  extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                  extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
                  extensionJstfMax: new r.Pointer(
                    r.uint16,
                    new LookupList(GPOSLookup)
                  ),
                });
                var JstfLangSys = new r.Array(
                  new r.Pointer(r.uint16, JstfPriority),
                  r.uint16
                );
                var JstfLangSysRecord = new r.Struct({
                  tag: new r.String(4),
                  jstfLangSys: new r.Pointer(r.uint16, JstfLangSys),
                });
                var JstfScript = new r.Struct({
                  extenderGlyphs: new r.Pointer(
                    r.uint16,
                    new r.Array(r.uint16, r.uint16)
                  ),
                  defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
                  langSysCount: r.uint16,
                  langSysRecords: new r.Array(JstfLangSysRecord, "langSysCount"),
                });
                var JstfScriptRecord = new r.Struct({
                  tag: new r.String(4),
                  script: new r.Pointer(r.uint16, JstfScript, { type: "parent" }),
                });
                var JSTF = new r.Struct({
                  version: r.uint32,
                  scriptCount: r.uint16,
                  scriptList: new r.Array(JstfScriptRecord, "scriptCount"),
                });
                var VariableSizeNumber = (function () {
                  function VariableSizeNumber(size) {
                    _classCallCheck(this, VariableSizeNumber);
                    this._size = size;
                  }
                  VariableSizeNumber.prototype.decode = function decode(
                    stream,
                    parent
                  ) {
                    switch (this.size(0, parent)) {
                      case 1:
                        return stream.readUInt8();
                      case 2:
                        return stream.readUInt16BE();
                      case 3:
                        return stream.readUInt24BE();
                      case 4:
                        return stream.readUInt32BE();
                    }
                  };
                  VariableSizeNumber.prototype.size = function size(val, parent) {
                    return restructure_src_utils.resolveLength(
                      this._size,
                      null,
                      parent
                    );
                  };
                  return VariableSizeNumber;
                })();
                var MapDataEntry = new r.Struct({
                  entry: new VariableSizeNumber(function (t) {
                    return ((t.parent.entryFormat & 48) >> 4) + 1;
                  }),
                  outerIndex: function outerIndex(t) {
                    return t.entry >> ((t.parent.entryFormat & 15) + 1);
                  },
                  innerIndex: function innerIndex(t) {
                    return (
                      t.entry & ((1 << ((t.parent.entryFormat & 15) + 1)) - 1)
                    );
                  },
                });
                var DeltaSetIndexMap = new r.Struct({
                  entryFormat: r.uint16,
                  mapCount: r.uint16,
                  mapData: new r.Array(MapDataEntry, "mapCount"),
                });
                var HVAR = new r.Struct({
                  majorVersion: r.uint16,
                  minorVersion: r.uint16,
                  itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
                  advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                  LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                  RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
                });
                var Signature = new r.Struct({
                  format: r.uint32,
                  length: r.uint32,
                  offset: r.uint32,
                });
                var SignatureBlock = new r.Struct({
                  reserved: new r.Reserved(r.uint16, 2),
                  cbSignature: r.uint32,
                  signature: new r.Buffer("cbSignature"),
                });
                var DSIG = new r.Struct({
                  ulVersion: r.uint32,
                  usNumSigs: r.uint16,
                  usFlag: r.uint16,
                  signatures: new r.Array(Signature, "usNumSigs"),
                  signatureBlocks: new r.Array(SignatureBlock, "usNumSigs"),
                });
                var GaspRange = new r.Struct({
                  rangeMaxPPEM: r.uint16,
                  rangeGaspBehavior: new r.Bitfield(r.uint16, [
                    "grayscale",
                    "gridfit",
                    "symmetricSmoothing",
                    "symmetricGridfit",
                  ]),
                });
                var gasp = new r.Struct({
                  version: r.uint16,
                  numRanges: r.uint16,
                  gaspRanges: new r.Array(GaspRange, "numRanges"),
                });
                var DeviceRecord = new r.Struct({
                  pixelSize: r.uint8,
                  maximumWidth: r.uint8,
                  widths: new r.Array(r.uint8, function (t) {
                    return t.parent.parent.maxp.numGlyphs;
                  }),
                });
                var hdmx = new r.Struct({
                  version: r.uint16,
                  numRecords: r.int16,
                  sizeDeviceRecord: r.int32,
                  records: new r.Array(DeviceRecord, "numRecords"),
                });
                var KernPair = new r.Struct({
                  left: r.uint16,
                  right: r.uint16,
                  value: r.int16,
                });
                var ClassTable = new r.Struct({
                  firstGlyph: r.uint16,
                  nGlyphs: r.uint16,
                  offsets: new r.Array(r.uint16, "nGlyphs"),
                  max: function max(t) {
                    return t.offsets.length && Math.max.apply(Math, t.offsets);
                  },
                });
                var Kern2Array = new r.Struct({
                  off: function off(t) {
                    return t._startOffset - t.parent.parent._startOffset;
                  },
                  len: function len(t) {
                    return (
                      ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) *
                      (t.parent.rowWidth / 2)
                    );
                  },
                  values: new r.LazyArray(r.int16, "len"),
                });
                var KernSubtable = new r.VersionedStruct("format", {
                  0: {
                    nPairs: r.uint16,
                    searchRange: r.uint16,
                    entrySelector: r.uint16,
                    rangeShift: r.uint16,
                    pairs: new r.Array(KernPair, "nPairs"),
                  },
                  2: {
                    rowWidth: r.uint16,
                    leftTable: new r.Pointer(r.uint16, ClassTable, {
                      type: "parent",
                    }),
                    rightTable: new r.Pointer(r.uint16, ClassTable, {
                      type: "parent",
                    }),
                    array: new r.Pointer(r.uint16, Kern2Array, {
                      type: "parent",
                    }),
                  },
                  3: {
                    glyphCount: r.uint16,
                    kernValueCount: r.uint8,
                    leftClassCount: r.uint8,
                    rightClassCount: r.uint8,
                    flags: r.uint8,
                    kernValue: new r.Array(r.int16, "kernValueCount"),
                    leftClass: new r.Array(r.uint8, "glyphCount"),
                    rightClass: new r.Array(r.uint8, "glyphCount"),
                    kernIndex: new r.Array(r.uint8, function (t) {
                      return t.leftClassCount * t.rightClassCount;
                    }),
                  },
                });
                var KernTable = new r.VersionedStruct("version", {
                  0: {
                    subVersion: r.uint16,
                    length: r.uint16,
                    format: r.uint8,
                    coverage: new r.Bitfield(r.uint8, [
                      "horizontal",
                      "minimum",
                      "crossStream",
                      "override",
                    ]),
                    subtable: KernSubtable,
                    padding: new r.Reserved(r.uint8, function (t) {
                      return t.length - t._currentOffset;
                    }),
                  },
                  1: {
                    length: r.uint32,
                    coverage: new r.Bitfield(r.uint8, [
                      null,
                      null,
                      null,
                      null,
                      null,
                      "variation",
                      "crossStream",
                      "vertical",
                    ]),
                    format: r.uint8,
                    tupleIndex: r.uint16,
                    subtable: KernSubtable,
                    padding: new r.Reserved(r.uint8, function (t) {
                      return t.length - t._currentOffset;
                    }),
                  },
                });
                var kern = new r.VersionedStruct(r.uint16, {
                  0: {
                    nTables: r.uint16,
                    tables: new r.Array(KernTable, "nTables"),
                  },
                  1: {
                    reserved: new r.Reserved(r.uint16),
                    nTables: r.uint32,
                    tables: new r.Array(KernTable, "nTables"),
                  },
                });
                var LTSH = new r.Struct({
                  version: r.uint16,
                  numGlyphs: r.uint16,
                  yPels: new r.Array(r.uint8, "numGlyphs"),
                });
                var PCLT = new r.Struct({
                  version: r.uint16,
                  fontNumber: r.uint32,
                  pitch: r.uint16,
                  xHeight: r.uint16,
                  style: r.uint16,
                  typeFamily: r.uint16,
                  capHeight: r.uint16,
                  symbolSet: r.uint16,
                  typeface: new r.String(16),
                  characterComplement: new r.String(8),
                  fileName: new r.String(6),
                  strokeWeight: new r.String(1),
                  widthType: new r.String(1),
                  serifStyle: r.uint8,
                  reserved: new r.Reserved(r.uint8),
                });
                var Ratio = new r.Struct({
                  bCharSet: r.uint8,
                  xRatio: r.uint8,
                  yStartRatio: r.uint8,
                  yEndRatio: r.uint8,
                });
                var vTable = new r.Struct({
                  yPelHeight: r.uint16,
                  yMax: r.int16,
                  yMin: r.int16,
                });
                var VdmxGroup = new r.Struct({
                  recs: r.uint16,
                  startsz: r.uint8,
                  endsz: r.uint8,
                  entries: new r.Array(vTable, "recs"),
                });
                var VDMX = new r.Struct({
                  version: r.uint16,
                  numRecs: r.uint16,
                  numRatios: r.uint16,
                  ratioRanges: new r.Array(Ratio, "numRatios"),
                  offsets: new r.Array(r.uint16, "numRatios"),
                  groups: new r.Array(VdmxGroup, "numRecs"),
                });
                var vhea = new r.Struct({
                  version: r.uint16,
                  ascent: r.int16,
                  descent: r.int16,
                  lineGap: r.int16,
                  advanceHeightMax: r.int16,
                  minTopSideBearing: r.int16,
                  minBottomSideBearing: r.int16,
                  yMaxExtent: r.int16,
                  caretSlopeRise: r.int16,
                  caretSlopeRun: r.int16,
                  caretOffset: r.int16,
                  reserved: new r.Reserved(r.int16, 4),
                  metricDataFormat: r.int16,
                  numberOfMetrics: r.uint16,
                });
                var VmtxEntry = new r.Struct({
                  advance: r.uint16,
                  bearing: r.int16,
                });
                var vmtx = new r.Struct({
                  metrics: new r.LazyArray(VmtxEntry, function (t) {
                    return t.parent.vhea.numberOfMetrics;
                  }),
                  bearings: new r.LazyArray(r.int16, function (t) {
                    return (
                      t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics
                    );
                  }),
                });
                var shortFrac = new r.Fixed(16, "BE", 14);
                var Correspondence = new r.Struct({
                  fromCoord: shortFrac,
                  toCoord: shortFrac,
                });
                var Segment = new r.Struct({
                  pairCount: r.uint16,
                  correspondence: new r.Array(Correspondence, "pairCount"),
                });
                var avar = new r.Struct({
                  version: r.fixed32,
                  axisCount: r.uint32,
                  segment: new r.Array(Segment, "axisCount"),
                });
                var UnboundedArrayAccessor = (function () {
                  function UnboundedArrayAccessor(type, stream, parent) {
                    _classCallCheck(this, UnboundedArrayAccessor);
                    this.type = type;
                    this.stream = stream;
                    this.parent = parent;
                    this.base = this.stream.pos;
                    this._items = [];
                  }
                  UnboundedArrayAccessor.prototype.getItem = function getItem(
                    index
                  ) {
                    if (this._items[index] == null) {
                      var pos = this.stream.pos;
                      this.stream.pos =
                        this.base + this.type.size(null, this.parent) * index;
                      this._items[index] = this.type.decode(
                        this.stream,
                        this.parent
                      );
                      this.stream.pos = pos;
                    }
                    return this._items[index];
                  };
                  UnboundedArrayAccessor.prototype.inspect = function inspect() {
                    return "[UnboundedArray " + this.type.constructor.name + "]";
                  };
                  return UnboundedArrayAccessor;
                })();
                var UnboundedArray = (function (_r$Array) {
                  _inherits(UnboundedArray, _r$Array);
                  function UnboundedArray(type) {
                    _classCallCheck(this, UnboundedArray);
                    return _possibleConstructorReturn(
                      this,
                      _r$Array.call(this, type, 0)
                    );
                  }
                  UnboundedArray.prototype.decode = function decode(
                    stream,
                    parent
                  ) {
                    return new UnboundedArrayAccessor(this.type, stream, parent);
                  };
                  return UnboundedArray;
                })(r.Array);
                var LookupTable = function LookupTable() {
                  var ValueType =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : r.uint16;
                  var Shadow = (function () {
                    function Shadow(type) {
                      _classCallCheck(this, Shadow);
                      this.type = type;
                    }
                    Shadow.prototype.decode = function decode(stream, ctx) {
                      ctx = ctx.parent.parent;
                      return this.type.decode(stream, ctx);
                    };
                    Shadow.prototype.size = function size(val, ctx) {
                      ctx = ctx.parent.parent;
                      return this.type.size(val, ctx);
                    };
                    Shadow.prototype.encode = function encode(stream, val, ctx) {
                      ctx = ctx.parent.parent;
                      return this.type.encode(stream, val, ctx);
                    };
                    return Shadow;
                  })();
                  ValueType = new Shadow(ValueType);
                  var BinarySearchHeader = new r.Struct({
                    unitSize: r.uint16,
                    nUnits: r.uint16,
                    searchRange: r.uint16,
                    entrySelector: r.uint16,
                    rangeShift: r.uint16,
                  });
                  var LookupSegmentSingle = new r.Struct({
                    lastGlyph: r.uint16,
                    firstGlyph: r.uint16,
                    value: ValueType,
                  });
                  var LookupSegmentArray = new r.Struct({
                    lastGlyph: r.uint16,
                    firstGlyph: r.uint16,
                    values: new r.Pointer(
                      r.uint16,
                      new r.Array(ValueType, function (t) {
                        return t.lastGlyph - t.firstGlyph + 1;
                      }),
                      { type: "parent" }
                    ),
                  });
                  var LookupSingle = new r.Struct({
                    glyph: r.uint16,
                    value: ValueType,
                  });
                  return new r.VersionedStruct(r.uint16, {
                    0: { values: new UnboundedArray(ValueType) },
                    2: {
                      binarySearchHeader: BinarySearchHeader,
                      segments: new r.Array(LookupSegmentSingle, function (t) {
                        return t.binarySearchHeader.nUnits;
                      }),
                    },
                    4: {
                      binarySearchHeader: BinarySearchHeader,
                      segments: new r.Array(LookupSegmentArray, function (t) {
                        return t.binarySearchHeader.nUnits;
                      }),
                    },
                    6: {
                      binarySearchHeader: BinarySearchHeader,
                      segments: new r.Array(LookupSingle, function (t) {
                        return t.binarySearchHeader.nUnits;
                      }),
                    },
                    8: {
                      firstGlyph: r.uint16,
                      count: r.uint16,
                      values: new r.Array(ValueType, "count"),
                    },
                  });
                };
                function StateTable() {
                  var entryData =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : {};
                  var lookupType =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : r.uint16;
                  var entry = _Object$assign(
                    {
                      newState: r.uint16,
                      flags: r.uint16,
                    },
                    entryData
                  );
                  var Entry = new r.Struct(entry);
                  var StateArray = new UnboundedArray(
                    new r.Array(r.uint16, function (t) {
                      return t.nClasses;
                    })
                  );
                  var StateHeader = new r.Struct({
                    nClasses: r.uint32,
                    classTable: new r.Pointer(
                      r.uint32,
                      new LookupTable(lookupType)
                    ),
                    stateArray: new r.Pointer(r.uint32, StateArray),
                    entryTable: new r.Pointer(
                      r.uint32,
                      new UnboundedArray(Entry)
                    ),
                  });
                  return StateHeader;
                }
                function StateTable1() {
                  var entryData =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : {};
                  var lookupType =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : r.uint16;
                  var ClassLookupTable = new r.Struct({
                    version: function version() {
                      return 8;
                    },
                    firstGlyph: r.uint16,
                    values: new r.Array(r.uint8, r.uint16),
                  });
                  var entry = _Object$assign(
                    {
                      newStateOffset: r.uint16,
                      newState: function newState(t) {
                        return (
                          (t.newStateOffset -
                            (t.parent.stateArray.base - t.parent._startOffset)) /
                          t.parent.nClasses
                        );
                      },
                      flags: r.uint16,
                    },
                    entryData
                  );
                  var Entry = new r.Struct(entry);
                  var StateArray = new UnboundedArray(
                    new r.Array(r.uint8, function (t) {
                      return t.nClasses;
                    })
                  );
                  var StateHeader1 = new r.Struct({
                    nClasses: r.uint16,
                    classTable: new r.Pointer(r.uint16, ClassLookupTable),
                    stateArray: new r.Pointer(r.uint16, StateArray),
                    entryTable: new r.Pointer(
                      r.uint16,
                      new UnboundedArray(Entry)
                    ),
                  });
                  return StateHeader1;
                }
                var BslnSubtable = new r.VersionedStruct("format", {
                  0: { deltas: new r.Array(r.int16, 32) },
                  1: {
                    deltas: new r.Array(r.int16, 32),
                    mappingData: new LookupTable(r.uint16),
                  },
                  2: {
                    standardGlyph: r.uint16,
                    controlPoints: new r.Array(r.uint16, 32),
                  },
                  3: {
                    standardGlyph: r.uint16,
                    controlPoints: new r.Array(r.uint16, 32),
                    mappingData: new LookupTable(r.uint16),
                  },
                });
                var bsln = new r.Struct({
                  version: r.fixed32,
                  format: r.uint16,
                  defaultBaseline: r.uint16,
                  subtable: BslnSubtable,
                });
                var Setting = new r.Struct({
                  setting: r.uint16,
                  nameIndex: r.int16,
                  name: function name(t) {
                    return t.parent.parent.parent.name.records.fontFeatures[
                      t.nameIndex
                    ];
                  },
                });
                var FeatureName = new r.Struct({
                  feature: r.uint16,
                  nSettings: r.uint16,
                  settingTable: new r.Pointer(
                    r.uint32,
                    new r.Array(Setting, "nSettings"),
                    { type: "parent" }
                  ),
                  featureFlags: new r.Bitfield(r.uint8, [
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "hasDefault",
                    "exclusive",
                  ]),
                  defaultSetting: r.uint8,
                  nameIndex: r.int16,
                  name: function name(t) {
                    return t.parent.parent.name.records.fontFeatures[t.nameIndex];
                  },
                });
                var feat = new r.Struct({
                  version: r.fixed32,
                  featureNameCount: r.uint16,
                  reserved1: new r.Reserved(r.uint16),
                  reserved2: new r.Reserved(r.uint32),
                  featureNames: new r.Array(FeatureName, "featureNameCount"),
                });
                var Axis$1 = new r.Struct({
                  axisTag: new r.String(4),
                  minValue: r.fixed32,
                  defaultValue: r.fixed32,
                  maxValue: r.fixed32,
                  flags: r.uint16,
                  nameID: r.uint16,
                  name: function name(t) {
                    return t.parent.parent.name.records.fontFeatures[t.nameID];
                  },
                });
                var Instance = new r.Struct({
                  nameID: r.uint16,
                  name: function name(t) {
                    return t.parent.parent.name.records.fontFeatures[t.nameID];
                  },
                  flags: r.uint16,
                  coord: new r.Array(r.fixed32, function (t) {
                    return t.parent.axisCount;
                  }),
                  postscriptNameID: new r.Optional(r.uint16, function (t) {
                    return t.parent.instanceSize - t._currentOffset > 0;
                  }),
                });
                var fvar = new r.Struct({
                  version: r.fixed32,
                  offsetToData: r.uint16,
                  countSizePairs: r.uint16,
                  axisCount: r.uint16,
                  axisSize: r.uint16,
                  instanceCount: r.uint16,
                  instanceSize: r.uint16,
                  axis: new r.Array(Axis$1, "axisCount"),
                  instance: new r.Array(Instance, "instanceCount"),
                });
                var shortFrac$1 = new r.Fixed(16, "BE", 14);
                var Offset = (function () {
                  function Offset() {
                    _classCallCheck(this, Offset);
                  }
                  Offset.decode = function decode(stream, parent) {
                    return parent.flags
                      ? stream.readUInt32BE()
                      : stream.readUInt16BE() * 2;
                  };
                  return Offset;
                })();
                var gvar = new r.Struct({
                  version: r.uint16,
                  reserved: new r.Reserved(r.uint16),
                  axisCount: r.uint16,
                  globalCoordCount: r.uint16,
                  globalCoords: new r.Pointer(
                    r.uint32,
                    new r.Array(
                      new r.Array(shortFrac$1, "axisCount"),
                      "globalCoordCount"
                    )
                  ),
                  glyphCount: r.uint16,
                  flags: r.uint16,
                  offsetToData: r.uint32,
                  offsets: new r.Array(
                    new r.Pointer(Offset, "void", {
                      relativeTo: "offsetToData",
                      allowNull: false,
                    }),
                    function (t) {
                      return t.glyphCount + 1;
                    }
                  ),
                });
                var ClassTable$1 = new r.Struct({
                  length: r.uint16,
                  coverage: r.uint16,
                  subFeatureFlags: r.uint32,
                  stateTable: new StateTable1(),
                });
                var WidthDeltaRecord = new r.Struct({
                  justClass: r.uint32,
                  beforeGrowLimit: r.fixed32,
                  beforeShrinkLimit: r.fixed32,
                  afterGrowLimit: r.fixed32,
                  afterShrinkLimit: r.fixed32,
                  growFlags: r.uint16,
                  shrinkFlags: r.uint16,
                });
                var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);
                var ActionData = new r.VersionedStruct("actionType", {
                  0: {
                    lowerLimit: r.fixed32,
                    upperLimit: r.fixed32,
                    order: r.uint16,
                    glyphs: new r.Array(r.uint16, r.uint16),
                  },
                  1: { addGlyph: r.uint16 },
                  2: {
                    substThreshold: r.fixed32,
                    addGlyph: r.uint16,
                    substGlyph: r.uint16,
                  },
                  3: {},
                  4: {
                    variationAxis: r.uint32,
                    minimumLimit: r.fixed32,
                    noStretchValue: r.fixed32,
                    maximumLimit: r.fixed32,
                  },
                  5: {
                    flags: r.uint16,
                    glyph: r.uint16,
                  },
                });
                var Action = new r.Struct({
                  actionClass: r.uint16,
                  actionType: r.uint16,
                  actionLength: r.uint32,
                  actionData: ActionData,
                  padding: new r.Reserved(r.uint8, function (t) {
                    return t.actionLength - t._currentOffset;
                  }),
                });
                var PostcompensationAction = new r.Array(Action, r.uint32);
                var PostCompensationTable = new r.Struct({
                  lookupTable: new LookupTable(
                    new r.Pointer(r.uint16, PostcompensationAction)
                  ),
                });
                var JustificationTable = new r.Struct({
                  classTable: new r.Pointer(r.uint16, ClassTable$1, {
                    type: "parent",
                  }),
                  wdcOffset: r.uint16,
                  postCompensationTable: new r.Pointer(
                    r.uint16,
                    PostCompensationTable,
                    { type: "parent" }
                  ),
                  widthDeltaClusters: new LookupTable(
                    new r.Pointer(r.uint16, WidthDeltaCluster, {
                      type: "parent",
                      relativeTo: "wdcOffset",
                    })
                  ),
                });
                var just = new r.Struct({
                  version: r.uint32,
                  format: r.uint16,
                  horizontal: new r.Pointer(r.uint16, JustificationTable),
                  vertical: new r.Pointer(r.uint16, JustificationTable),
                });
                var LigatureData = { action: r.uint16 };
                var ContextualData = {
                  markIndex: r.uint16,
                  currentIndex: r.uint16,
                };
                var InsertionData = {
                  currentInsertIndex: r.uint16,
                  markedInsertIndex: r.uint16,
                };
                var SubstitutionTable = new r.Struct({
                  items: new UnboundedArray(
                    new r.Pointer(r.uint32, new LookupTable())
                  ),
                });
                var SubtableData = new r.VersionedStruct("type", {
                  0: { stateTable: new StateTable() },
                  1: {
                    stateTable: new StateTable(ContextualData),
                    substitutionTable: new r.Pointer(r.uint32, SubstitutionTable),
                  },
                  2: {
                    stateTable: new StateTable(LigatureData),
                    ligatureActions: new r.Pointer(
                      r.uint32,
                      new UnboundedArray(r.uint32)
                    ),
                    components: new r.Pointer(
                      r.uint32,
                      new UnboundedArray(r.uint16)
                    ),
                    ligatureList: new r.Pointer(
                      r.uint32,
                      new UnboundedArray(r.uint16)
                    ),
                  },
                  4: { lookupTable: new LookupTable() },
                  5: {
                    stateTable: new StateTable(InsertionData),
                    insertionActions: new r.Pointer(
                      r.uint32,
                      new UnboundedArray(r.uint16)
                    ),
                  },
                });
                var Subtable = new r.Struct({
                  length: r.uint32,
                  coverage: r.uint24,
                  type: r.uint8,
                  subFeatureFlags: r.uint32,
                  table: SubtableData,
                  padding: new r.Reserved(r.uint8, function (t) {
                    return t.length - t._currentOffset;
                  }),
                });
                var FeatureEntry = new r.Struct({
                  featureType: r.uint16,
                  featureSetting: r.uint16,
                  enableFlags: r.uint32,
                  disableFlags: r.uint32,
                });
                var MorxChain = new r.Struct({
                  defaultFlags: r.uint32,
                  chainLength: r.uint32,
                  nFeatureEntries: r.uint32,
                  nSubtables: r.uint32,
                  features: new r.Array(FeatureEntry, "nFeatureEntries"),
                  subtables: new r.Array(Subtable, "nSubtables"),
                });
                var morx = new r.Struct({
                  version: r.uint16,
                  unused: new r.Reserved(r.uint16),
                  nChains: r.uint32,
                  chains: new r.Array(MorxChain, "nChains"),
                });
                var OpticalBounds = new r.Struct({
                  left: r.int16,
                  top: r.int16,
                  right: r.int16,
                  bottom: r.int16,
                });
                var opbd = new r.Struct({
                  version: r.fixed32,
                  format: r.uint16,
                  lookupTable: new LookupTable(OpticalBounds),
                });
                var tables = {};
                tables.cmap = cmap;
                tables.head = head;
                tables.hhea = hhea;
                tables.hmtx = hmtx;
                tables.maxp = maxp;
                tables.name = NameTable;
                tables["OS/2"] = OS2;
                tables.post = post;
                tables.fpgm = fpgm;
                tables.loca = loca;
                tables.prep = prep;
                tables["cvt "] = cvt;
                tables.glyf = glyf;
                tables["CFF "] = CFFFont;
                tables["CFF2"] = CFFFont;
                tables.VORG = VORG;
                tables.EBLC = EBLC;
                tables.CBLC = tables.EBLC;
                tables.sbix = sbix;
                tables.COLR = COLR;
                tables.CPAL = CPAL;
                tables.BASE = BASE;
                tables.GDEF = GDEF;
                tables.GPOS = GPOS;
                tables.GSUB = GSUB;
                tables.JSTF = JSTF;
                tables.HVAR = HVAR;
                tables.DSIG = DSIG;
                tables.gasp = gasp;
                tables.hdmx = hdmx;
                tables.kern = kern;
                tables.LTSH = LTSH;
                tables.PCLT = PCLT;
                tables.VDMX = VDMX;
                tables.vhea = vhea;
                tables.vmtx = vmtx;
                tables.avar = avar;
                tables.bsln = bsln;
                tables.feat = feat;
                tables.fvar = fvar;
                tables.gvar = gvar;
                tables.just = just;
                tables.morx = morx;
                tables.opbd = opbd;
                var TableEntry = new r.Struct({
                  tag: new r.String(4),
                  checkSum: r.uint32,
                  offset: new r.Pointer(r.uint32, "void", { type: "global" }),
                  length: r.uint32,
                });
                var Directory = new r.Struct({
                  tag: new r.String(4),
                  numTables: r.uint16,
                  searchRange: r.uint16,
                  entrySelector: r.uint16,
                  rangeShift: r.uint16,
                  tables: new r.Array(TableEntry, "numTables"),
                });
                Directory.process = function () {
                  var tables = {};
                  for (
                    var _iterator = this.tables,
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var table = _ref;
                    tables[table.tag] = table;
                  }
                  this.tables = tables;
                };
                Directory.preEncode = function (stream) {
                  var tables$$ = [];
                  for (var tag in this.tables) {
                    var table = this.tables[tag];
                    if (table) {
                      tables$$.push({
                        tag: tag,
                        checkSum: 0,
                        offset: new r.VoidPointer(tables[tag], table),
                        length: tables[tag].size(table),
                      });
                    }
                  }
                  this.tag = "true";
                  this.numTables = tables$$.length;
                  this.tables = tables$$;
                  var maxExponentFor2 = Math.floor(
                    Math.log(this.numTables) / Math.LN2
                  );
                  var maxPowerOf2 = Math.pow(2, maxExponentFor2);
                  this.searchRange = maxPowerOf2 * 16;
                  this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
                  this.rangeShift = this.numTables * 16 - this.searchRange;
                };
                function binarySearch(arr, cmp) {
                  var min = 0;
                  var max = arr.length - 1;
                  while (min <= max) {
                    var mid = (min + max) >> 1;
                    var res = cmp(arr[mid]);
                    if (res < 0) {
                      max = mid - 1;
                    } else if (res > 0) {
                      min = mid + 1;
                    } else {
                      return mid;
                    }
                  }
                  return -1;
                }
                function range(index, end) {
                  var range = [];
                  while (index < end) {
                    range.push(index++);
                  }
                  return range;
                }
                var _class$1;
                function _applyDecoratedDescriptor$1(
                  target,
                  property,
                  decorators,
                  descriptor,
                  context
                ) {
                  var desc = {};
                  Object["ke" + "ys"](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                  });
                  desc.enumerable = !!desc.enumerable;
                  desc.configurable = !!desc.configurable;
                  if ("value" in desc || desc.initializer) {
                    desc.writable = true;
                  }
                  desc = decorators
                    .slice()
                    .reverse()
                    .reduce(function (desc, decorator) {
                      return decorator(target, property, desc) || desc;
                    }, desc);
                  if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer
                      ? desc.initializer.call(context)
                      : void 0;
                    desc.initializer = undefined;
                  }
                  if (desc.initializer === void 0) {
                    Object["define" + "Property"](target, property, desc);
                    desc = null;
                  }
                  return desc;
                }
                try {
                  var iconv = require("iconv-lite");
                } catch (err) {}
                var CmapProcessor =
                  ((_class$1 = (function () {
                    function CmapProcessor(cmapTable) {
                      _classCallCheck(this, CmapProcessor);
                      this.encoding = null;
                      this.cmap = this.findSubtable(cmapTable, [
                        [3, 10],
                        [0, 6],
                        [0, 4],
                        [3, 1],
                        [0, 3],
                        [0, 2],
                        [0, 1],
                        [0, 0],
                      ]);
                      if (!this.cmap && iconv) {
                        for (
                          var _iterator = cmapTable.tables,
                            _isArray = Array.isArray(_iterator),
                            _i = 0,
                            _iterator = _isArray
                              ? _iterator
                              : _getIterator(_iterator);
                          ;
  
                        ) {
                          var _ref;
                          if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                          } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                          }
                          var cmap = _ref;
                          var encoding = getEncoding(
                            cmap.platformID,
                            cmap.encodingID,
                            cmap.table.language - 1
                          );
                          if (iconv.encodingExists(encoding)) {
                            this.cmap = cmap.table;
                            this.encoding = encoding;
                          }
                        }
                      }
                      if (!this.cmap) {
                        throw new Error("Could not find a supported cmap table");
                      }
                      this.uvs = this.findSubtable(cmapTable, [[0, 5]]);
                      if (this.uvs && this.uvs.version !== 14) {
                        this.uvs = null;
                      }
                    }
                    CmapProcessor.prototype.findSubtable = function findSubtable(
                      cmapTable,
                      pairs
                    ) {
                      for (
                        var _iterator2 = pairs,
                          _isArray2 = Array.isArray(_iterator2),
                          _i2 = 0,
                          _iterator2 = _isArray2
                            ? _iterator2
                            : _getIterator(_iterator2);
                        ;
  
                      ) {
                        var _ref2;
                        if (_isArray2) {
                          if (_i2 >= _iterator2.length) break;
                          _ref2 = _iterator2[_i2++];
                        } else {
                          _i2 = _iterator2.next();
                          if (_i2.done) break;
                          _ref2 = _i2.value;
                        }
                        var _ref3 = _ref2,
                          platformID = _ref3[0],
                          encodingID = _ref3[1];
                        for (
                          var _iterator3 = cmapTable.tables,
                            _isArray3 = Array.isArray(_iterator3),
                            _i3 = 0,
                            _iterator3 = _isArray3
                              ? _iterator3
                              : _getIterator(_iterator3);
                          ;
  
                        ) {
                          var _ref4;
                          if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref4 = _iterator3[_i3++];
                          } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref4 = _i3.value;
                          }
                          var cmap = _ref4;
                          if (
                            cmap.platformID === platformID &&
                            cmap.encodingID === encodingID
                          ) {
                            return cmap.table;
                          }
                        }
                      }
                      return null;
                    };
                    CmapProcessor.prototype.lookup = function lookup(
                      codepoint,
                      variationSelector
                    ) {
                      if (this.encoding) {
                        var buf = iconv.encode(
                          _String$fromCodePoint(codepoint),
                          this.encoding
                        );
                        codepoint = 0;
                        for (var i = 0; i < buf.length; i++) {
                          codepoint = (codepoint << 8) | buf[i];
                        }
                      } else if (variationSelector) {
                        var gid = this.getVariationSelector(
                          codepoint,
                          variationSelector
                        );
                        if (gid) {
                          return gid;
                        }
                      }
                      var cmap = this.cmap;
                      switch (cmap.version) {
                        case 0:
                          return cmap.codeMap.get(codepoint) || 0;
                        case 4: {
                          var min = 0;
                          var max = cmap.segCount - 1;
                          while (min <= max) {
                            var mid = (min + max) >> 1;
                            if (codepoint < cmap.startCode.get(mid)) {
                              max = mid - 1;
                            } else if (codepoint > cmap.endCode.get(mid)) {
                              min = mid + 1;
                            } else {
                              var rangeOffset = cmap.idRangeOffset.get(mid);
                              var _gid = void 0;
                              if (rangeOffset === 0) {
                                _gid = codepoint + cmap.idDelta.get(mid);
                              } else {
                                var index =
                                  rangeOffset / 2 +
                                  (codepoint - cmap.startCode.get(mid)) -
                                  (cmap.segCount - mid);
                                _gid = cmap.glyphIndexArray.get(index) || 0;
                                if (_gid !== 0) {
                                  _gid += cmap.idDelta.get(mid);
                                }
                              }
                              return _gid & 65535;
                            }
                          }
                          return 0;
                        }
                        case 8:
                          throw new Error("TODO: cmap format 8");
                        case 6:
                        case 10:
                          return (
                            cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0
                          );
                        case 12:
                        case 13: {
                          var _min = 0;
                          var _max = cmap.nGroups - 1;
                          while (_min <= _max) {
                            var _mid = (_min + _max) >> 1;
                            var group = cmap.groups.get(_mid);
                            if (codepoint < group.startCharCode) {
                              _max = _mid - 1;
                            } else if (codepoint > group.endCharCode) {
                              _min = _mid + 1;
                            } else {
                              if (cmap.version === 12) {
                                return (
                                  group.glyphID +
                                  (codepoint - group.startCharCode)
                                );
                              } else {
                                return group.glyphID;
                              }
                            }
                          }
                          return 0;
                        }
                        case 14:
                          throw new Error("TODO: cmap format 14");
                        default:
                          throw new Error("Unknown cmap format " + cmap.version);
                      }
                    };
                    CmapProcessor.prototype.getVariationSelector =
                      function getVariationSelector(
                        codepoint,
                        variationSelector
                      ) {
                        if (!this.uvs) {
                          return 0;
                        }
                        var selectors = this.uvs.varSelectors.toArray();
                        var i = binarySearch(selectors, function (x) {
                          return variationSelector - x.varSelector;
                        });
                        var sel = selectors[i];
                        if (i !== -1 && sel.defaultUVS) {
                          i = binarySearch(sel.defaultUVS, function (x) {
                            return codepoint < x.startUnicodeValue
                              ? -1
                              : codepoint >
                                x.startUnicodeValue + x.additionalCount
                              ? +1
                              : 0;
                          });
                        }
                        if (i !== -1 && sel.nonDefaultUVS) {
                          i = binarySearch(sel.nonDefaultUVS, function (x) {
                            return codepoint - x.unicodeValue;
                          });
                          if (i !== -1) {
                            return sel.nonDefaultUVS[i].glyphID;
                          }
                        }
                        return 0;
                      };
                    CmapProcessor.prototype.getCharacterSet =
                      function getCharacterSet() {
                        var cmap = this.cmap;
                        switch (cmap.version) {
                          case 0:
                            return range(0, cmap.codeMap.length);
                          case 4: {
                            var res = [];
                            var endCodes = cmap.endCode.toArray();
                            for (var i = 0; i < endCodes.length; i++) {
                              var tail = endCodes[i] + 1;
                              var start = cmap.startCode.get(i);
                              res.push.apply(res, range(start, tail));
                            }
                            return res;
                          }
                          case 8:
                            throw new Error("TODO: cmap format 8");
                          case 6:
                          case 10:
                            return range(
                              cmap.firstCode,
                              cmap.firstCode + cmap.glyphIndices.length
                            );
                          case 12:
                          case 13: {
                            var _res = [];
                            for (
                              var _iterator4 = cmap.groups.toArray(),
                                _isArray4 = Array.isArray(_iterator4),
                                _i4 = 0,
                                _iterator4 = _isArray4
                                  ? _iterator4
                                  : _getIterator(_iterator4);
                              ;
  
                            ) {
                              var _ref5;
                              if (_isArray4) {
                                if (_i4 >= _iterator4.length) break;
                                _ref5 = _iterator4[_i4++];
                              } else {
                                _i4 = _iterator4.next();
                                if (_i4.done) break;
                                _ref5 = _i4.value;
                              }
                              var group = _ref5;
                              _res.push.apply(
                                _res,
                                range(group.startCharCode, group.endCharCode + 1)
                              );
                            }
                            return _res;
                          }
                          case 14:
                            throw new Error("TODO: cmap format 14");
                          default:
                            throw new Error(
                              "Unknown cmap format " + cmap.version
                            );
                        }
                      };
                    CmapProcessor.prototype.codePointsForGlyph =
                      function codePointsForGlyph(gid) {
                        var cmap = this.cmap;
                        switch (cmap.version) {
                          case 0: {
                            var res = [];
                            for (var i = 0; i < 256; i++) {
                              if (cmap.codeMap.get(i) === gid) {
                                res.push(i);
                              }
                            }
                            return res;
                          }
                          case 4: {
                            var _res2 = [];
                            for (var _i5 = 0; _i5 < cmap.segCount; _i5++) {
                              var end = cmap.endCode.get(_i5);
                              var start = cmap.startCode.get(_i5);
                              var rangeOffset = cmap.idRangeOffset.get(_i5);
                              var delta = cmap.idDelta.get(_i5);
                              for (var c = start; c <= end; c++) {
                                var g = 0;
                                if (rangeOffset === 0) {
                                  g = c + delta;
                                } else {
                                  var index =
                                    rangeOffset / 2 +
                                    (c - start) -
                                    (cmap.segCount - _i5);
                                  g = cmap.glyphIndexArray.get(index) || 0;
                                  if (g !== 0) {
                                    g += delta;
                                  }
                                }
                                if (g === gid) {
                                  _res2.push(c);
                                }
                              }
                            }
                            return _res2;
                          }
                          case 12: {
                            var _res3 = [];
                            for (
                              var _iterator5 = cmap.groups.toArray(),
                                _isArray5 = Array.isArray(_iterator5),
                                _i6 = 0,
                                _iterator5 = _isArray5
                                  ? _iterator5
                                  : _getIterator(_iterator5);
                              ;
  
                            ) {
                              var _ref6;
                              if (_isArray5) {
                                if (_i6 >= _iterator5.length) break;
                                _ref6 = _iterator5[_i6++];
                              } else {
                                _i6 = _iterator5.next();
                                if (_i6.done) break;
                                _ref6 = _i6.value;
                              }
                              var group = _ref6;
                              if (
                                gid >= group.glyphID &&
                                gid <=
                                  group.glyphID +
                                    (group.endCharCode - group.startCharCode)
                              ) {
                                _res3.push(
                                  group.startCharCode + (gid - group.glyphID)
                                );
                              }
                            }
                            return _res3;
                          }
                          case 13: {
                            var _res4 = [];
                            for (
                              var _iterator6 = cmap.groups.toArray(),
                                _isArray6 = Array.isArray(_iterator6),
                                _i7 = 0,
                                _iterator6 = _isArray6
                                  ? _iterator6
                                  : _getIterator(_iterator6);
                              ;
  
                            ) {
                              var _ref7;
                              if (_isArray6) {
                                if (_i7 >= _iterator6.length) break;
                                _ref7 = _iterator6[_i7++];
                              } else {
                                _i7 = _iterator6.next();
                                if (_i7.done) break;
                                _ref7 = _i7.value;
                              }
                              var _group = _ref7;
                              if (gid === _group.glyphID) {
                                _res4.push.apply(
                                  _res4,
                                  range(
                                    _group.startCharCode,
                                    _group.endCharCode + 1
                                  )
                                );
                              }
                            }
                            return _res4;
                          }
                          default:
                            throw new Error(
                              "Unknown cmap format " + cmap.version
                            );
                        }
                      };
                    return CmapProcessor;
                  })()),
                  (_applyDecoratedDescriptor$1(
                    _class$1.prototype,
                    "getCharacterSet",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$1.prototype,
                      "getCharacterSet"
                    ),
                    _class$1.prototype
                  ),
                  _applyDecoratedDescriptor$1(
                    _class$1.prototype,
                    "codePointsForGlyph",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$1.prototype,
                      "codePointsForGlyph"
                    ),
                    _class$1.prototype
                  )),
                  _class$1);
                var KernProcessor = (function () {
                  function KernProcessor(font) {
                    _classCallCheck(this, KernProcessor);
                    this.kern = font.kern;
                  }
                  KernProcessor.prototype.process = function process(
                    glyphs,
                    positions
                  ) {
                    for (
                      var glyphIndex = 0;
                      glyphIndex < glyphs.length - 1;
                      glyphIndex++
                    ) {
                      var left = glyphs[glyphIndex].id;
                      var right = glyphs[glyphIndex + 1].id;
                      positions[glyphIndex].xAdvance += this.getKerning(
                        left,
                        right
                      );
                    }
                  };
                  KernProcessor.prototype.getKerning = function getKerning(
                    left,
                    right
                  ) {
                    var res = 0;
                    for (
                      var _iterator = this.kern.tables,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var table = _ref;
                      if (table.coverage.crossStream) {
                        continue;
                      }
                      switch (table.version) {
                        case 0:
                          if (!table.coverage.horizontal) {
                            continue;
                          }
                          break;
                        case 1:
                          if (
                            table.coverage.vertical ||
                            table.coverage.variation
                          ) {
                            continue;
                          }
                          break;
                        default:
                          throw new Error(
                            "Unsupported kerning table version " + table.version
                          );
                      }
                      var val = 0;
                      var s = table.subtable;
                      switch (table.format) {
                        case 0:
                          var pairIdx = binarySearch(s.pairs, function (pair) {
                            return left - pair.left || right - pair.right;
                          });
                          if (pairIdx >= 0) {
                            val = s.pairs[pairIdx].value;
                          }
                          break;
                        case 2:
                          var leftOffset = 0,
                            rightOffset = 0;
                          if (
                            left >= s.leftTable.firstGlyph &&
                            left < s.leftTable.firstGlyph + s.leftTable.nGlyphs
                          ) {
                            leftOffset =
                              s.leftTable.offsets[left - s.leftTable.firstGlyph];
                          } else {
                            leftOffset = s.array.off;
                          }
                          if (
                            right >= s.rightTable.firstGlyph &&
                            right < s.rightTable.firstGlyph + s.rightTable.nGlyphs
                          ) {
                            rightOffset =
                              s.rightTable.offsets[
                                right - s.rightTable.firstGlyph
                              ];
                          }
                          var index =
                            (leftOffset + rightOffset - s.array.off) / 2;
                          val = s.array.values.get(index);
                          break;
                        case 3:
                          if (left >= s.glyphCount || right >= s.glyphCount) {
                            return 0;
                          }
                          val =
                            s.kernValue[
                              s.kernIndex[
                                s.leftClass[left] * s.rightClassCount +
                                  s.rightClass[right]
                              ]
                            ];
                          break;
                        default:
                          throw new Error(
                            "Unsupported kerning sub-table format " + table.format
                          );
                      }
                      if (table.coverage.override) {
                        res = val;
                      } else {
                        res += val;
                      }
                    }
                    return res;
                  };
                  return KernProcessor;
                })();
                var UnicodeLayoutEngine = (function () {
                  function UnicodeLayoutEngine(font) {
                    _classCallCheck(this, UnicodeLayoutEngine);
                    this.font = font;
                  }
                  UnicodeLayoutEngine.prototype.positionGlyphs =
                    function positionGlyphs(glyphs, positions) {
                      var clusterStart = 0;
                      var clusterEnd = 0;
                      for (var index = 0; index < glyphs.length; index++) {
                        var glyph = glyphs[index];
                        if (glyph.isMark) {
                          clusterEnd = index;
                        } else {
                          if (clusterStart !== clusterEnd) {
                            this.positionCluster(
                              glyphs,
                              positions,
                              clusterStart,
                              clusterEnd
                            );
                          }
                          clusterStart = clusterEnd = index;
                        }
                      }
                      if (clusterStart !== clusterEnd) {
                        this.positionCluster(
                          glyphs,
                          positions,
                          clusterStart,
                          clusterEnd
                        );
                      }
                      return positions;
                    };
                  UnicodeLayoutEngine.prototype.positionCluster =
                    function positionCluster(
                      glyphs,
                      positions,
                      clusterStart,
                      clusterEnd
                    ) {
                      var base = glyphs[clusterStart];
                      var baseBox = base.cbox.copy();
                      if (base.codePoints.length > 1) {
                        baseBox.minX +=
                          ((base.codePoints.length - 1) * baseBox.width) /
                          base.codePoints.length;
                      }
                      var xOffset = -positions[clusterStart].xAdvance;
                      var yOffset = 0;
                      var yGap = this.font.unitsPerEm / 16;
                      for (
                        var index = clusterStart + 1;
                        index <= clusterEnd;
                        index++
                      ) {
                        var mark = glyphs[index];
                        var markBox = mark.cbox;
                        var position = positions[index];
                        var combiningClass = this.getCombiningClass(
                          mark.codePoints[0]
                        );
                        if (combiningClass !== "Not_Reordered") {
                          position.xOffset = position.yOffset = 0;
                          switch (combiningClass) {
                            case "Double_Above":
                            case "Double_Below":
                              position.xOffset +=
                                baseBox.minX - markBox.width / 2 - markBox.minX;
                              break;
                            case "Attached_Below_Left":
                            case "Below_Left":
                            case "Above_Left":
                              position.xOffset += baseBox.minX - markBox.minX;
                              break;
                            case "Attached_Above_Right":
                            case "Below_Right":
                            case "Above_Right":
                              position.xOffset +=
                                baseBox.maxX - markBox.width - markBox.minX;
                              break;
                            default:
                              position.xOffset +=
                                baseBox.minX +
                                (baseBox.width - markBox.width) / 2 -
                                markBox.minX;
                          }
                          switch (combiningClass) {
                            case "Double_Below":
                            case "Below_Left":
                            case "Below":
                            case "Below_Right":
                            case "Attached_Below_Left":
                            case "Attached_Below":
                              if (
                                combiningClass === "Attached_Below_Left" ||
                                combiningClass === "Attached_Below"
                              ) {
                                baseBox.minY += yGap;
                              }
                              position.yOffset = -baseBox.minY - markBox.maxY;
                              baseBox.minY += markBox.height;
                              break;
                            case "Double_Above":
                            case "Above_Left":
                            case "Above":
                            case "Above_Right":
                            case "Attached_Above":
                            case "Attached_Above_Right":
                              if (
                                combiningClass === "Attached_Above" ||
                                combiningClass === "Attached_Above_Right"
                              ) {
                                baseBox.maxY += yGap;
                              }
                              position.yOffset = baseBox.maxY - markBox.minY;
                              baseBox.maxY += markBox.height;
                              break;
                          }
                          position.xAdvance = position.yAdvance = 0;
                          position.xOffset += xOffset;
                          position.yOffset += yOffset;
                        } else {
                          xOffset -= position.xAdvance;
                          yOffset -= position.yAdvance;
                        }
                      }
                      return;
                    };
                  UnicodeLayoutEngine.prototype.getCombiningClass =
                    function getCombiningClass(codePoint) {
                      var combiningClass = unicode.getCombiningClass(codePoint);
                      if ((codePoint & ~255) === 3584) {
                        if (combiningClass === "Not_Reordered") {
                          switch (codePoint) {
                            case 3633:
                            case 3636:
                            case 3637:
                            case 3638:
                            case 3639:
                            case 3655:
                            case 3660:
                            case 3645:
                            case 3662:
                              return "Above_Right";
                            case 3761:
                            case 3764:
                            case 3765:
                            case 3766:
                            case 3767:
                            case 3771:
                            case 3788:
                            case 3789:
                              return "Above";
                            case 3772:
                              return "Below";
                          }
                        } else if (codePoint === 3642) {
                          return "Below_Right";
                        }
                      }
                      switch (combiningClass) {
                        case "CCC10":
                        case "CCC11":
                        case "CCC12":
                        case "CCC13":
                        case "CCC14":
                        case "CCC15":
                        case "CCC16":
                        case "CCC17":
                        case "CCC18":
                        case "CCC20":
                        case "CCC22":
                          return "Below";
                        case "CCC23":
                          return "Attached_Above";
                        case "CCC24":
                          return "Above_Right";
                        case "CCC25":
                        case "CCC19":
                          return "Above_Left";
                        case "CCC26":
                          return "Above";
                        case "CCC21":
                          break;
                        case "CCC27":
                        case "CCC28":
                        case "CCC30":
                        case "CCC31":
                        case "CCC33":
                        case "CCC34":
                        case "CCC35":
                        case "CCC36":
                          return "Above";
                        case "CCC29":
                        case "CCC32":
                          return "Below";
                        case "CCC103":
                          return "Below_Right";
                        case "CCC107":
                          return "Above_Right";
                        case "CCC118":
                          return "Below";
                        case "CCC122":
                          return "Above";
                        case "CCC129":
                        case "CCC132":
                          return "Below";
                        case "CCC130":
                          return "Above";
                      }
                      return combiningClass;
                    };
                  return UnicodeLayoutEngine;
                })();
                var BBox = (function () {
                  function BBox() {
                    var minX =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : Infinity;
                    var minY =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : Infinity;
                    var maxX =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : -Infinity;
                    var maxY =
                      arguments.length > 3 && arguments[3] !== undefined
                        ? arguments[3]
                        : -Infinity;
                    _classCallCheck(this, BBox);
                    this.minX = minX;
                    this.minY = minY;
                    this.maxX = maxX;
                    this.maxY = maxY;
                  }
                  BBox.prototype.addPoint = function addPoint(x, y) {
                    if (Math.abs(x) !== Infinity) {
                      if (x < this.minX) {
                        this.minX = x;
                      }
                      if (x > this.maxX) {
                        this.maxX = x;
                      }
                    }
                    if (Math.abs(y) !== Infinity) {
                      if (y < this.minY) {
                        this.minY = y;
                      }
                      if (y > this.maxY) {
                        this.maxY = y;
                      }
                    }
                  };
                  BBox.prototype.copy = function copy() {
                    return new BBox(this.minX, this.minY, this.maxX, this.maxY);
                  };
                  _createClass(BBox, [
                    {
                      key: "width",
                      get: function get() {
                        return this.maxX - this.minX;
                      },
                    },
                    {
                      key: "height",
                      get: function get() {
                        return this.maxY - this.minY;
                      },
                    },
                  ]);
                  return BBox;
                })();
                var UNICODE_SCRIPTS = {
                  Caucasian_Albanian: "aghb",
                  Arabic: "arab",
                  Imperial_Aramaic: "armi",
                  Armenian: "armn",
                  Avestan: "avst",
                  Balinese: "bali",
                  Bamum: "bamu",
                  Bassa_Vah: "bass",
                  Batak: "batk",
                  Bengali: ["bng2", "beng"],
                  Bopomofo: "bopo",
                  Brahmi: "brah",
                  Braille: "brai",
                  Buginese: "bugi",
                  Buhid: "buhd",
                  Chakma: "cakm",
                  Canadian_Aboriginal: "cans",
                  Carian: "cari",
                  Cham: "cham",
                  Cherokee: "cher",
                  Coptic: "copt",
                  Cypriot: "cprt",
                  Cyrillic: "cyrl",
                  Devanagari: ["dev2", "deva"],
                  Deseret: "dsrt",
                  Duployan: "dupl",
                  Egyptian_Hieroglyphs: "egyp",
                  Elbasan: "elba",
                  Ethiopic: "ethi",
                  Georgian: "geor",
                  Glagolitic: "glag",
                  Gothic: "goth",
                  Grantha: "gran",
                  Greek: "grek",
                  Gujarati: ["gjr2", "gujr"],
                  Gurmukhi: ["gur2", "guru"],
                  Hangul: "hang",
                  Han: "hani",
                  Hanunoo: "hano",
                  Hebrew: "hebr",
                  Hiragana: "hira",
                  Pahawh_Hmong: "hmng",
                  Katakana_Or_Hiragana: "hrkt",
                  Old_Italic: "ital",
                  Javanese: "java",
                  Kayah_Li: "kali",
                  Katakana: "kana",
                  Kharoshthi: "khar",
                  Khmer: "khmr",
                  Khojki: "khoj",
                  Kannada: ["knd2", "knda"],
                  Kaithi: "kthi",
                  Tai_Tham: "lana",
                  Lao: "lao ",
                  Latin: "latn",
                  Lepcha: "lepc",
                  Limbu: "limb",
                  Linear_A: "lina",
                  Linear_B: "linb",
                  Lisu: "lisu",
                  Lycian: "lyci",
                  Lydian: "lydi",
                  Mahajani: "mahj",
                  Mandaic: "mand",
                  Manichaean: "mani",
                  Mende_Kikakui: "mend",
                  Meroitic_Cursive: "merc",
                  Meroitic_Hieroglyphs: "mero",
                  Malayalam: ["mlm2", "mlym"],
                  Modi: "modi",
                  Mongolian: "mong",
                  Mro: "mroo",
                  Meetei_Mayek: "mtei",
                  Myanmar: ["mym2", "mymr"],
                  Old_North_Arabian: "narb",
                  Nabataean: "nbat",
                  Nko: "nko ",
                  Ogham: "ogam",
                  Ol_Chiki: "olck",
                  Old_Turkic: "orkh",
                  Oriya: ["ory2", "orya"],
                  Osmanya: "osma",
                  Palmyrene: "palm",
                  Pau_Cin_Hau: "pauc",
                  Old_Permic: "perm",
                  Phags_Pa: "phag",
                  Inscriptional_Pahlavi: "phli",
                  Psalter_Pahlavi: "phlp",
                  Phoenician: "phnx",
                  Miao: "plrd",
                  Inscriptional_Parthian: "prti",
                  Rejang: "rjng",
                  Runic: "runr",
                  Samaritan: "samr",
                  Old_South_Arabian: "sarb",
                  Saurashtra: "saur",
                  Shavian: "shaw",
                  Sharada: "shrd",
                  Siddham: "sidd",
                  Khudawadi: "sind",
                  Sinhala: "sinh",
                  Sora_Sompeng: "sora",
                  Sundanese: "sund",
                  Syloti_Nagri: "sylo",
                  Syriac: "syrc",
                  Tagbanwa: "tagb",
                  Takri: "takr",
                  Tai_Le: "tale",
                  New_Tai_Lue: "talu",
                  Tamil: ["tml2", "taml"],
                  Tai_Viet: "tavt",
                  Telugu: ["tel2", "telu"],
                  Tifinagh: "tfng",
                  Tagalog: "tglg",
                  Thaana: "thaa",
                  Thai: "thai",
                  Tibetan: "tibt",
                  Tirhuta: "tirh",
                  Ugaritic: "ugar",
                  Vai: "vai ",
                  Warang_Citi: "wara",
                  Old_Persian: "xpeo",
                  Cuneiform: "xsux",
                  Yi: "yi  ",
                  Inherited: "zinh",
                  Common: "zyyy",
                  Unknown: "zzzz",
                };
                var OPENTYPE_SCRIPTS = {};
                for (var script in UNICODE_SCRIPTS) {
                  var tag = UNICODE_SCRIPTS[script];
                  if (Array.isArray(tag)) {
                    for (
                      var _iterator = tag,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var t = _ref;
                      OPENTYPE_SCRIPTS[t] = script;
                    }
                  } else {
                    OPENTYPE_SCRIPTS[tag] = script;
                  }
                }
                function fromOpenType(tag) {
                  return OPENTYPE_SCRIPTS[tag];
                }
                function forString(string) {
                  var len = string.length;
                  var idx = 0;
                  while (idx < len) {
                    var code = string.charCodeAt(idx++);
                    if (55296 <= code && code <= 56319 && idx < len) {
                      var next = string.charCodeAt(idx);
                      if (56320 <= next && next <= 57343) {
                        idx++;
                        code = ((code & 1023) << 10) + (next & 1023) + 65536;
                      }
                    }
                    var _script = unicode.getScript(code);
                    if (
                      _script !== "Common" &&
                      _script !== "Inherited" &&
                      _script !== "Unknown"
                    ) {
                      return UNICODE_SCRIPTS[_script];
                    }
                  }
                  return UNICODE_SCRIPTS.Unknown;
                }
                function forCodePoints(codePoints) {
                  for (var i = 0; i < codePoints.length; i++) {
                    var codePoint = codePoints[i];
                    var _script2 = unicode.getScript(codePoint);
                    if (
                      _script2 !== "Common" &&
                      _script2 !== "Inherited" &&
                      _script2 !== "Unknown"
                    ) {
                      return UNICODE_SCRIPTS[_script2];
                    }
                  }
                  return UNICODE_SCRIPTS.Unknown;
                }
                var RTL = {
                  arab: true,
                  hebr: true,
                  syrc: true,
                  thaa: true,
                  cprt: true,
                  khar: true,
                  phnx: true,
                  "nko ": true,
                  lydi: true,
                  avst: true,
                  armi: true,
                  phli: true,
                  prti: true,
                  sarb: true,
                  orkh: true,
                  samr: true,
                  mand: true,
                  merc: true,
                  mero: true,
                  mani: true,
                  mend: true,
                  nbat: true,
                  narb: true,
                  palm: true,
                  phlp: true,
                };
                function direction(script) {
                  if (RTL[script]) {
                    return "rtl";
                  }
                  return "ltr";
                }
                var GlyphRun = (function () {
                  function GlyphRun(
                    glyphs,
                    features,
                    script,
                    language,
                    direction$$
                  ) {
                    _classCallCheck(this, GlyphRun);
                    this.glyphs = glyphs;
                    this.positions = null;
                    this.script = script;
                    this.language = language || null;
                    this.direction = direction$$ || direction(script);
                    this.features = {};
                    if (Array.isArray(features)) {
                      for (
                        var _iterator = features,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var tag = _ref;
                        this.features[tag] = true;
                      }
                    } else if (
                      (typeof features === "undefined"
                        ? "undefined"
                        : _typeof(features)) === "object"
                    ) {
                      this.features = features;
                    }
                  }
                  _createClass(GlyphRun, [
                    {
                      key: "advanceWidth",
                      get: function get() {
                        var width = 0;
                        for (
                          var _iterator2 = this.positions,
                            _isArray2 = Array.isArray(_iterator2),
                            _i2 = 0,
                            _iterator2 = _isArray2
                              ? _iterator2
                              : _getIterator(_iterator2);
                          ;
  
                        ) {
                          var _ref2;
                          if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                          } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                          }
                          var position = _ref2;
                          width += position.xAdvance;
                        }
                        return width;
                      },
                    },
                    {
                      key: "advanceHeight",
                      get: function get() {
                        var height = 0;
                        for (
                          var _iterator3 = this.positions,
                            _isArray3 = Array.isArray(_iterator3),
                            _i3 = 0,
                            _iterator3 = _isArray3
                              ? _iterator3
                              : _getIterator(_iterator3);
                          ;
  
                        ) {
                          var _ref3;
                          if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                          } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                          }
                          var position = _ref3;
                          height += position.yAdvance;
                        }
                        return height;
                      },
                    },
                    {
                      key: "bbox",
                      get: function get() {
                        var bbox = new BBox();
                        var x = 0;
                        var y = 0;
                        for (var index = 0; index < this.glyphs.length; index++) {
                          var glyph = this.glyphs[index];
                          var p = this.positions[index];
                          var b = glyph.bbox;
                          bbox.addPoint(
                            b.minX + x + p.xOffset,
                            b.minY + y + p.yOffset
                          );
                          bbox.addPoint(
                            b.maxX + x + p.xOffset,
                            b.maxY + y + p.yOffset
                          );
                          x += p.xAdvance;
                          y += p.yAdvance;
                        }
                        return bbox;
                      },
                    },
                  ]);
                  return GlyphRun;
                })();
                var GlyphPosition = function GlyphPosition() {
                  var xAdvance =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : 0;
                  var yAdvance =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : 0;
                  var xOffset =
                    arguments.length > 2 && arguments[2] !== undefined
                      ? arguments[2]
                      : 0;
                  var yOffset =
                    arguments.length > 3 && arguments[3] !== undefined
                      ? arguments[3]
                      : 0;
                  _classCallCheck(this, GlyphPosition);
                  this.xAdvance = xAdvance;
                  this.yAdvance = yAdvance;
                  this.xOffset = xOffset;
                  this.yOffset = yOffset;
                };
                var features = {
                  allTypographicFeatures: {
                    code: 0,
                    exclusive: false,
                    allTypeFeatures: 0,
                  },
                  ligatures: {
                    code: 1,
                    exclusive: false,
                    requiredLigatures: 0,
                    commonLigatures: 2,
                    rareLigatures: 4,
                    rebusPictures: 8,
                    diphthongLigatures: 10,
                    squaredLigatures: 12,
                    abbrevSquaredLigatures: 14,
                    symbolLigatures: 16,
                    contextualLigatures: 18,
                    historicalLigatures: 20,
                  },
                  cursiveConnection: {
                    code: 2,
                    exclusive: true,
                    unconnected: 0,
                    partiallyConnected: 1,
                    cursive: 2,
                  },
                  letterCase: {
                    code: 3,
                    exclusive: true,
                  },
                  verticalSubstitution: {
                    code: 4,
                    exclusive: false,
                    substituteVerticalForms: 0,
                  },
                  linguisticRearrangement: {
                    code: 5,
                    exclusive: false,
                    linguisticRearrangement: 0,
                  },
                  numberSpacing: {
                    code: 6,
                    exclusive: true,
                    monospacedNumbers: 0,
                    proportionalNumbers: 1,
                    thirdWidthNumbers: 2,
                    quarterWidthNumbers: 3,
                  },
                  smartSwash: {
                    code: 8,
                    exclusive: false,
                    wordInitialSwashes: 0,
                    wordFinalSwashes: 2,
                    nonFinalSwashes: 8,
                  },
                  diacritics: {
                    code: 9,
                    exclusive: true,
                    showDiacritics: 0,
                    hideDiacritics: 1,
                    decomposeDiacritics: 2,
                  },
                  verticalPosition: {
                    code: 10,
                    exclusive: true,
                    normalPosition: 0,
                    superiors: 1,
                    inferiors: 2,
                    ordinals: 3,
                    scientificInferiors: 4,
                  },
                  fractions: {
                    code: 11,
                    exclusive: true,
                    noFractions: 0,
                    verticalFractions: 1,
                    diagonalFractions: 2,
                  },
                  overlappingCharacters: {
                    code: 13,
                    exclusive: false,
                    preventOverlap: 0,
                  },
                  typographicExtras: {
                    code: 14,
                    exclusive: false,
                    slashedZero: 4,
                  },
                  mathematicalExtras: {
                    code: 15,
                    exclusive: false,
                    mathematicalGreek: 10,
                  },
                  ornamentSets: {
                    code: 16,
                    exclusive: true,
                    noOrnaments: 0,
                    dingbats: 1,
                    piCharacters: 2,
                    fleurons: 3,
                    decorativeBorders: 4,
                    internationalSymbols: 5,
                    mathSymbols: 6,
                  },
                  characterAlternatives: {
                    code: 17,
                    exclusive: true,
                    noAlternates: 0,
                  },
                  designComplexity: {
                    code: 18,
                    exclusive: true,
                    designLevel1: 0,
                    designLevel2: 1,
                    designLevel3: 2,
                    designLevel4: 3,
                    designLevel5: 4,
                  },
                  styleOptions: {
                    code: 19,
                    exclusive: true,
                    noStyleOptions: 0,
                    displayText: 1,
                    engravedText: 2,
                    illuminatedCaps: 3,
                    titlingCaps: 4,
                    tallCaps: 5,
                  },
                  characterShape: {
                    code: 20,
                    exclusive: true,
                    traditionalCharacters: 0,
                    simplifiedCharacters: 1,
                    JIS1978Characters: 2,
                    JIS1983Characters: 3,
                    JIS1990Characters: 4,
                    traditionalAltOne: 5,
                    traditionalAltTwo: 6,
                    traditionalAltThree: 7,
                    traditionalAltFour: 8,
                    traditionalAltFive: 9,
                    expertCharacters: 10,
                    JIS2004Characters: 11,
                    hojoCharacters: 12,
                    NLCCharacters: 13,
                    traditionalNamesCharacters: 14,
                  },
                  numberCase: {
                    code: 21,
                    exclusive: true,
                    lowerCaseNumbers: 0,
                    upperCaseNumbers: 1,
                  },
                  textSpacing: {
                    code: 22,
                    exclusive: true,
                    proportionalText: 0,
                    monospacedText: 1,
                    halfWidthText: 2,
                    thirdWidthText: 3,
                    quarterWidthText: 4,
                    altProportionalText: 5,
                    altHalfWidthText: 6,
                  },
                  transliteration: {
                    code: 23,
                    exclusive: true,
                    noTransliteration: 0,
                  },
                  annotation: {
                    code: 24,
                    exclusive: true,
                    noAnnotation: 0,
                    boxAnnotation: 1,
                    roundedBoxAnnotation: 2,
                    circleAnnotation: 3,
                    invertedCircleAnnotation: 4,
                    parenthesisAnnotation: 5,
                    periodAnnotation: 6,
                    romanNumeralAnnotation: 7,
                    diamondAnnotation: 8,
                    invertedBoxAnnotation: 9,
                    invertedRoundedBoxAnnotation: 10,
                  },
                  kanaSpacing: {
                    code: 25,
                    exclusive: true,
                    fullWidthKana: 0,
                    proportionalKana: 1,
                  },
                  ideographicSpacing: {
                    code: 26,
                    exclusive: true,
                    fullWidthIdeographs: 0,
                    proportionalIdeographs: 1,
                    halfWidthIdeographs: 2,
                  },
                  unicodeDecomposition: {
                    code: 27,
                    exclusive: false,
                    canonicalComposition: 0,
                    compatibilityComposition: 2,
                    transcodingComposition: 4,
                  },
                  rubyKana: {
                    code: 28,
                    exclusive: false,
                    rubyKana: 2,
                  },
                  CJKSymbolAlternatives: {
                    code: 29,
                    exclusive: true,
                    noCJKSymbolAlternatives: 0,
                    CJKSymbolAltOne: 1,
                    CJKSymbolAltTwo: 2,
                    CJKSymbolAltThree: 3,
                    CJKSymbolAltFour: 4,
                    CJKSymbolAltFive: 5,
                  },
                  ideographicAlternatives: {
                    code: 30,
                    exclusive: true,
                    noIdeographicAlternatives: 0,
                    ideographicAltOne: 1,
                    ideographicAltTwo: 2,
                    ideographicAltThree: 3,
                    ideographicAltFour: 4,
                    ideographicAltFive: 5,
                  },
                  CJKVerticalRomanPlacement: {
                    code: 31,
                    exclusive: true,
                    CJKVerticalRomanCentered: 0,
                    CJKVerticalRomanHBaseline: 1,
                  },
                  italicCJKRoman: {
                    code: 32,
                    exclusive: false,
                    CJKItalicRoman: 2,
                  },
                  caseSensitiveLayout: {
                    code: 33,
                    exclusive: false,
                    caseSensitiveLayout: 0,
                    caseSensitiveSpacing: 2,
                  },
                  alternateKana: {
                    code: 34,
                    exclusive: false,
                    alternateHorizKana: 0,
                    alternateVertKana: 2,
                  },
                  stylisticAlternatives: {
                    code: 35,
                    exclusive: false,
                    noStylisticAlternates: 0,
                    stylisticAltOne: 2,
                    stylisticAltTwo: 4,
                    stylisticAltThree: 6,
                    stylisticAltFour: 8,
                    stylisticAltFive: 10,
                    stylisticAltSix: 12,
                    stylisticAltSeven: 14,
                    stylisticAltEight: 16,
                    stylisticAltNine: 18,
                    stylisticAltTen: 20,
                    stylisticAltEleven: 22,
                    stylisticAltTwelve: 24,
                    stylisticAltThirteen: 26,
                    stylisticAltFourteen: 28,
                    stylisticAltFifteen: 30,
                    stylisticAltSixteen: 32,
                    stylisticAltSeventeen: 34,
                    stylisticAltEighteen: 36,
                    stylisticAltNineteen: 38,
                    stylisticAltTwenty: 40,
                  },
                  contextualAlternates: {
                    code: 36,
                    exclusive: false,
                    contextualAlternates: 0,
                    swashAlternates: 2,
                    contextualSwashAlternates: 4,
                  },
                  lowerCase: {
                    code: 37,
                    exclusive: true,
                    defaultLowerCase: 0,
                    lowerCaseSmallCaps: 1,
                    lowerCasePetiteCaps: 2,
                  },
                  upperCase: {
                    code: 38,
                    exclusive: true,
                    defaultUpperCase: 0,
                    upperCaseSmallCaps: 1,
                    upperCasePetiteCaps: 2,
                  },
                  languageTag: {
                    code: 39,
                    exclusive: true,
                  },
                  CJKRomanSpacing: {
                    code: 103,
                    exclusive: true,
                    halfWidthCJKRoman: 0,
                    proportionalCJKRoman: 1,
                    defaultCJKRoman: 2,
                    fullWidthCJKRoman: 3,
                  },
                };
                var feature = function feature(name, selector) {
                  return [features[name].code, features[name][selector]];
                };
                var OTMapping = {
                  rlig: feature("ligatures", "requiredLigatures"),
                  clig: feature("ligatures", "contextualLigatures"),
                  dlig: feature("ligatures", "rareLigatures"),
                  hlig: feature("ligatures", "historicalLigatures"),
                  liga: feature("ligatures", "commonLigatures"),
                  hist: feature("ligatures", "historicalLigatures"),
                  smcp: feature("lowerCase", "lowerCaseSmallCaps"),
                  pcap: feature("lowerCase", "lowerCasePetiteCaps"),
                  frac: feature("fractions", "diagonalFractions"),
                  dnom: feature("fractions", "diagonalFractions"),
                  numr: feature("fractions", "diagonalFractions"),
                  afrc: feature("fractions", "verticalFractions"),
                  case: feature("caseSensitiveLayout", "caseSensitiveLayout"),
                  ccmp: feature("unicodeDecomposition", "canonicalComposition"),
                  cpct: feature(
                    "CJKVerticalRomanPlacement",
                    "CJKVerticalRomanCentered"
                  ),
                  valt: feature(
                    "CJKVerticalRomanPlacement",
                    "CJKVerticalRomanCentered"
                  ),
                  swsh: feature("contextualAlternates", "swashAlternates"),
                  cswh: feature(
                    "contextualAlternates",
                    "contextualSwashAlternates"
                  ),
                  curs: feature("cursiveConnection", "cursive"),
                  c2pc: feature("upperCase", "upperCasePetiteCaps"),
                  c2sc: feature("upperCase", "upperCaseSmallCaps"),
                  init: feature("smartSwash", "wordInitialSwashes"),
                  fin2: feature("smartSwash", "wordFinalSwashes"),
                  medi: feature("smartSwash", "nonFinalSwashes"),
                  med2: feature("smartSwash", "nonFinalSwashes"),
                  fin3: feature("smartSwash", "wordFinalSwashes"),
                  fina: feature("smartSwash", "wordFinalSwashes"),
                  pkna: feature("kanaSpacing", "proportionalKana"),
                  half: feature("textSpacing", "halfWidthText"),
                  halt: feature("textSpacing", "altHalfWidthText"),
                  hkna: feature("alternateKana", "alternateHorizKana"),
                  vkna: feature("alternateKana", "alternateVertKana"),
                  ital: feature("italicCJKRoman", "CJKItalicRoman"),
                  lnum: feature("numberCase", "upperCaseNumbers"),
                  onum: feature("numberCase", "lowerCaseNumbers"),
                  mgrk: feature("mathematicalExtras", "mathematicalGreek"),
                  calt: feature("contextualAlternates", "contextualAlternates"),
                  vrt2: feature(
                    "verticalSubstitution",
                    "substituteVerticalForms"
                  ),
                  vert: feature(
                    "verticalSubstitution",
                    "substituteVerticalForms"
                  ),
                  tnum: feature("numberSpacing", "monospacedNumbers"),
                  pnum: feature("numberSpacing", "proportionalNumbers"),
                  sups: feature("verticalPosition", "superiors"),
                  subs: feature("verticalPosition", "inferiors"),
                  ordn: feature("verticalPosition", "ordinals"),
                  pwid: feature("textSpacing", "proportionalText"),
                  hwid: feature("textSpacing", "halfWidthText"),
                  qwid: feature("textSpacing", "quarterWidthText"),
                  twid: feature("textSpacing", "thirdWidthText"),
                  fwid: feature("textSpacing", "proportionalText"),
                  palt: feature("textSpacing", "altProportionalText"),
                  trad: feature("characterShape", "traditionalCharacters"),
                  smpl: feature("characterShape", "simplifiedCharacters"),
                  jp78: feature("characterShape", "JIS1978Characters"),
                  jp83: feature("characterShape", "JIS1983Characters"),
                  jp90: feature("characterShape", "JIS1990Characters"),
                  jp04: feature("characterShape", "JIS2004Characters"),
                  expt: feature("characterShape", "expertCharacters"),
                  hojo: feature("characterShape", "hojoCharacters"),
                  nlck: feature("characterShape", "NLCCharacters"),
                  tnam: feature("characterShape", "traditionalNamesCharacters"),
                  ruby: feature("rubyKana", "rubyKana"),
                  titl: feature("styleOptions", "titlingCaps"),
                  zero: feature("typographicExtras", "slashedZero"),
                  ss01: feature("stylisticAlternatives", "stylisticAltOne"),
                  ss02: feature("stylisticAlternatives", "stylisticAltTwo"),
                  ss03: feature("stylisticAlternatives", "stylisticAltThree"),
                  ss04: feature("stylisticAlternatives", "stylisticAltFour"),
                  ss05: feature("stylisticAlternatives", "stylisticAltFive"),
                  ss06: feature("stylisticAlternatives", "stylisticAltSix"),
                  ss07: feature("stylisticAlternatives", "stylisticAltSeven"),
                  ss08: feature("stylisticAlternatives", "stylisticAltEight"),
                  ss09: feature("stylisticAlternatives", "stylisticAltNine"),
                  ss10: feature("stylisticAlternatives", "stylisticAltTen"),
                  ss11: feature("stylisticAlternatives", "stylisticAltEleven"),
                  ss12: feature("stylisticAlternatives", "stylisticAltTwelve"),
                  ss13: feature("stylisticAlternatives", "stylisticAltThirteen"),
                  ss14: feature("stylisticAlternatives", "stylisticAltFourteen"),
                  ss15: feature("stylisticAlternatives", "stylisticAltFifteen"),
                  ss16: feature("stylisticAlternatives", "stylisticAltSixteen"),
                  ss17: feature("stylisticAlternatives", "stylisticAltSeventeen"),
                  ss18: feature("stylisticAlternatives", "stylisticAltEighteen"),
                  ss19: feature("stylisticAlternatives", "stylisticAltNineteen"),
                  ss20: feature("stylisticAlternatives", "stylisticAltTwenty"),
                };
                for (var i = 1; i <= 99; i++) {
                  OTMapping["cv" + ("00" + i).slice(-2)] = [
                    features.characterAlternatives.code,
                    i,
                  ];
                }
                var AATMapping = {};
                for (var ot in OTMapping) {
                  var aat = OTMapping[ot];
                  if (AATMapping[aat[0]] == null) {
                    AATMapping[aat[0]] = {};
                  }
                  AATMapping[aat[0]][aat[1]] = ot;
                }
                function mapOTToAAT(features) {
                  var res = {};
                  for (var k in features) {
                    var r = void 0;
                    if ((r = OTMapping[k])) {
                      if (res[r[0]] == null) {
                        res[r[0]] = {};
                      }
                      res[r[0]][r[1]] = features[k];
                    }
                  }
                  return res;
                }
                function mapFeatureStrings(f) {
                  var type = f[0],
                    setting = f[1];
                  if (isNaN(type)) {
                    var typeCode = features[type] && features[type].code;
                  } else {
                    var typeCode = type;
                  }
                  if (isNaN(setting)) {
                    var settingCode = features[type] && features[type][setting];
                  } else {
                    var settingCode = setting;
                  }
                  return [typeCode, settingCode];
                }
                function mapAATToOT(features) {
                  var res = {};
                  if (Array.isArray(features)) {
                    for (var k = 0; k < features.length; k++) {
                      var r = void 0;
                      var f = mapFeatureStrings(features[k]);
                      if ((r = AATMapping[f[0]] && AATMapping[f[0]][f[1]])) {
                        res[r] = true;
                      }
                    }
                  } else if (
                    (typeof features === "undefined"
                      ? "undefined"
                      : _typeof(features)) === "object"
                  ) {
                    for (var type in features) {
                      var _feature = features[type];
                      for (var setting in _feature) {
                        var _r = void 0;
                        var _f = mapFeatureStrings([type, setting]);
                        if (
                          _feature[setting] &&
                          (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])
                        ) {
                          res[_r] = true;
                        }
                      }
                    }
                  }
                  return _Object$keys(res);
                }
                var _class$3;
                function _applyDecoratedDescriptor$3(
                  target,
                  property,
                  decorators,
                  descriptor,
                  context
                ) {
                  var desc = {};
                  Object["ke" + "ys"](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                  });
                  desc.enumerable = !!desc.enumerable;
                  desc.configurable = !!desc.configurable;
                  if ("value" in desc || desc.initializer) {
                    desc.writable = true;
                  }
                  desc = decorators
                    .slice()
                    .reverse()
                    .reduce(function (desc, decorator) {
                      return decorator(target, property, desc) || desc;
                    }, desc);
                  if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer
                      ? desc.initializer.call(context)
                      : void 0;
                    desc.initializer = undefined;
                  }
                  if (desc.initializer === void 0) {
                    Object["define" + "Property"](target, property, desc);
                    desc = null;
                  }
                  return desc;
                }
                var AATLookupTable =
                  ((_class$3 = (function () {
                    function AATLookupTable(table) {
                      _classCallCheck(this, AATLookupTable);
                      this.table = table;
                    }
                    AATLookupTable.prototype.lookup = function lookup(glyph) {
                      switch (this.table.version) {
                        case 0:
                          return this.table.values.getItem(glyph);
                        case 2:
                        case 4: {
                          var min = 0;
                          var max = this.table.binarySearchHeader.nUnits - 1;
                          while (min <= max) {
                            var mid = (min + max) >> 1;
                            var seg = this.table.segments[mid];
                            if (seg.firstGlyph === 65535) {
                              return null;
                            }
                            if (glyph < seg.firstGlyph) {
                              max = mid - 1;
                            } else if (glyph > seg.lastGlyph) {
                              min = mid + 1;
                            } else {
                              if (this.table.version === 2) {
                                return seg.value;
                              } else {
                                return seg.values[glyph - seg.firstGlyph];
                              }
                            }
                          }
                          return null;
                        }
                        case 6: {
                          var _min = 0;
                          var _max = this.table.binarySearchHeader.nUnits - 1;
                          while (_min <= _max) {
                            var mid = (_min + _max) >> 1;
                            var seg = this.table.segments[mid];
                            if (seg.glyph === 65535) {
                              return null;
                            }
                            if (glyph < seg.glyph) {
                              _max = mid - 1;
                            } else if (glyph > seg.glyph) {
                              _min = mid + 1;
                            } else {
                              return seg.value;
                            }
                          }
                          return null;
                        }
                        case 8:
                          return this.table.values[glyph - this.table.firstGlyph];
                        default:
                          throw new Error(
                            "Unknown lookup table format: " + this.table.version
                          );
                      }
                    };
                    AATLookupTable.prototype.glyphsForValue =
                      function glyphsForValue(classValue) {
                        var res = [];
                        switch (this.table.version) {
                          case 2:
                          case 4: {
                            for (
                              var _iterator = this.table.segments,
                                _isArray = Array.isArray(_iterator),
                                _i = 0,
                                _iterator = _isArray
                                  ? _iterator
                                  : _getIterator(_iterator);
                              ;
  
                            ) {
                              var _ref;
                              if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                              } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                              }
                              var segment = _ref;
                              if (
                                this.table.version === 2 &&
                                segment.value === classValue
                              ) {
                                res.push.apply(
                                  res,
                                  range(segment.firstGlyph, segment.lastGlyph + 1)
                                );
                              } else {
                                for (
                                  var index = 0;
                                  index < segment.values.length;
                                  index++
                                ) {
                                  if (segment.values[index] === classValue) {
                                    res.push(segment.firstGlyph + index);
                                  }
                                }
                              }
                            }
                            break;
                          }
                          case 6: {
                            for (
                              var _iterator2 = this.table.segments,
                                _isArray2 = Array.isArray(_iterator2),
                                _i2 = 0,
                                _iterator2 = _isArray2
                                  ? _iterator2
                                  : _getIterator(_iterator2);
                              ;
  
                            ) {
                              var _ref2;
                              if (_isArray2) {
                                if (_i2 >= _iterator2.length) break;
                                _ref2 = _iterator2[_i2++];
                              } else {
                                _i2 = _iterator2.next();
                                if (_i2.done) break;
                                _ref2 = _i2.value;
                              }
                              var _segment = _ref2;
                              if (_segment.value === classValue) {
                                res.push(_segment.glyph);
                              }
                            }
                            break;
                          }
                          case 8: {
                            for (var i = 0; i < this.table.values.length; i++) {
                              if (this.table.values[i] === classValue) {
                                res.push(this.table.firstGlyph + i);
                              }
                            }
                            break;
                          }
                          default:
                            throw new Error(
                              "Unknown lookup table format: " + this.table.version
                            );
                        }
                        return res;
                      };
                    return AATLookupTable;
                  })()),
                  _applyDecoratedDescriptor$3(
                    _class$3.prototype,
                    "glyphsForValue",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$3.prototype,
                      "glyphsForValue"
                    ),
                    _class$3.prototype
                  ),
                  _class$3);
                var START_OF_TEXT_STATE = 0;
                var END_OF_TEXT_CLASS = 0;
                var OUT_OF_BOUNDS_CLASS = 1;
                var DELETED_GLYPH_CLASS = 2;
                var DONT_ADVANCE = 16384;
                var AATStateMachine = (function () {
                  function AATStateMachine(stateTable) {
                    _classCallCheck(this, AATStateMachine);
                    this.stateTable = stateTable;
                    this.lookupTable = new AATLookupTable(stateTable.classTable);
                  }
                  AATStateMachine.prototype.process = function process(
                    glyphs,
                    reverse,
                    processEntry
                  ) {
                    var currentState = START_OF_TEXT_STATE;
                    var index = reverse ? glyphs.length - 1 : 0;
                    var dir = reverse ? -1 : 1;
                    while (
                      (dir === 1 && index <= glyphs.length) ||
                      (dir === -1 && index >= -1)
                    ) {
                      var glyph = null;
                      var classCode = OUT_OF_BOUNDS_CLASS;
                      var shouldAdvance = true;
                      if (index === glyphs.length || index === -1) {
                        classCode = END_OF_TEXT_CLASS;
                      } else {
                        glyph = glyphs[index];
                        if (glyph.id === 65535) {
                          classCode = DELETED_GLYPH_CLASS;
                        } else {
                          classCode = this.lookupTable.lookup(glyph.id);
                          if (classCode == null) {
                            classCode = OUT_OF_BOUNDS_CLASS;
                          }
                        }
                      }
                      var row = this.stateTable.stateArray.getItem(currentState);
                      var entryIndex = row[classCode];
                      var entry = this.stateTable.entryTable.getItem(entryIndex);
                      if (
                        classCode !== END_OF_TEXT_CLASS &&
                        classCode !== DELETED_GLYPH_CLASS
                      ) {
                        processEntry(glyph, entry, index);
                        shouldAdvance = !(entry.flags & DONT_ADVANCE);
                      }
                      currentState = entry.newState;
                      if (shouldAdvance) {
                        index += dir;
                      }
                    }
                    return glyphs;
                  };
                  AATStateMachine.prototype.traverse = function traverse(opts) {
                    var state =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : 0;
                    var visited =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : new _Set();
                    if (visited.has(state)) {
                      return;
                    }
                    visited.add(state);
                    var _stateTable = this.stateTable,
                      nClasses = _stateTable.nClasses,
                      stateArray = _stateTable.stateArray,
                      entryTable = _stateTable.entryTable;
                    var row = stateArray.getItem(state);
                    for (var classCode = 4; classCode < nClasses; classCode++) {
                      var entryIndex = row[classCode];
                      var entry = entryTable.getItem(entryIndex);
                      for (
                        var _iterator =
                            this.lookupTable.glyphsForValue(classCode),
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var glyph = _ref;
                        if (opts.enter) {
                          opts.enter(glyph, entry);
                        }
                        if (entry.newState !== 0) {
                          this.traverse(opts, entry.newState, visited);
                        }
                        if (opts.exit) {
                          opts.exit(glyph, entry);
                        }
                      }
                    }
                  };
                  return AATStateMachine;
                })();
                var _class$2;
                function _applyDecoratedDescriptor$2(
                  target,
                  property,
                  decorators,
                  descriptor,
                  context
                ) {
                  var desc = {};
                  Object["ke" + "ys"](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                  });
                  desc.enumerable = !!desc.enumerable;
                  desc.configurable = !!desc.configurable;
                  if ("value" in desc || desc.initializer) {
                    desc.writable = true;
                  }
                  desc = decorators
                    .slice()
                    .reverse()
                    .reduce(function (desc, decorator) {
                      return decorator(target, property, desc) || desc;
                    }, desc);
                  if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer
                      ? desc.initializer.call(context)
                      : void 0;
                    desc.initializer = undefined;
                  }
                  if (desc.initializer === void 0) {
                    Object["define" + "Property"](target, property, desc);
                    desc = null;
                  }
                  return desc;
                }
                var MARK_FIRST = 32768;
                var MARK_LAST = 8192;
                var VERB = 15;
                var SET_MARK = 32768;
                var SET_COMPONENT = 32768;
                var PERFORM_ACTION = 8192;
                var LAST_MASK = 2147483648;
                var STORE_MASK = 1073741824;
                var OFFSET_MASK = 1073741823;
                var REVERSE_DIRECTION = 4194304;
                var CURRENT_INSERT_BEFORE = 2048;
                var MARKED_INSERT_BEFORE = 1024;
                var CURRENT_INSERT_COUNT = 992;
                var MARKED_INSERT_COUNT = 31;
                var AATMorxProcessor =
                  ((_class$2 = (function () {
                    function AATMorxProcessor(font) {
                      _classCallCheck(this, AATMorxProcessor);
                      this.processIndicRearragement =
                        this.processIndicRearragement.bind(this);
                      this.processContextualSubstitution =
                        this.processContextualSubstitution.bind(this);
                      this.processLigature = this.processLigature.bind(this);
                      this.processNoncontextualSubstitutions =
                        this.processNoncontextualSubstitutions.bind(this);
                      this.processGlyphInsertion =
                        this.processGlyphInsertion.bind(this);
                      this.font = font;
                      this.morx = font.morx;
                      this.inputCache = null;
                    }
                    AATMorxProcessor.prototype.process = function process(
                      glyphs
                    ) {
                      var features =
                        arguments.length > 1 && arguments[1] !== undefined
                          ? arguments[1]
                          : {};
                      for (
                        var _iterator = this.morx.chains,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var chain = _ref;
                        var flags = chain.defaultFlags;
                        for (
                          var _iterator2 = chain.features,
                            _isArray2 = Array.isArray(_iterator2),
                            _i2 = 0,
                            _iterator2 = _isArray2
                              ? _iterator2
                              : _getIterator(_iterator2);
                          ;
  
                        ) {
                          var _ref2;
                          if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                          } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                          }
                          var feature = _ref2;
                          var f = void 0;
                          if ((f = features[feature.featureType])) {
                            if (f[feature.featureSetting]) {
                              flags &= feature.disableFlags;
                              flags |= feature.enableFlags;
                            } else if (f[feature.featureSetting] === false) {
                              flags |= ~feature.disableFlags;
                              flags &= ~feature.enableFlags;
                            }
                          }
                        }
                        for (
                          var _iterator3 = chain.subtables,
                            _isArray3 = Array.isArray(_iterator3),
                            _i3 = 0,
                            _iterator3 = _isArray3
                              ? _iterator3
                              : _getIterator(_iterator3);
                          ;
  
                        ) {
                          var _ref3;
                          if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                          } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                          }
                          var subtable = _ref3;
                          if (subtable.subFeatureFlags & flags) {
                            this.processSubtable(subtable, glyphs);
                          }
                        }
                      }
                      var index = glyphs.length - 1;
                      while (index >= 0) {
                        if (glyphs[index].id === 65535) {
                          glyphs.splice(index, 1);
                        }
                        index--;
                      }
                      return glyphs;
                    };
                    AATMorxProcessor.prototype.processSubtable =
                      function processSubtable(subtable, glyphs) {
                        this.subtable = subtable;
                        this.glyphs = glyphs;
                        if (this.subtable.type === 4) {
                          this.processNoncontextualSubstitutions(
                            this.subtable,
                            this.glyphs
                          );
                          return;
                        }
                        this.ligatureStack = [];
                        this.markedGlyph = null;
                        this.firstGlyph = null;
                        this.lastGlyph = null;
                        this.markedIndex = null;
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var reverse = !!(
                          this.subtable.coverage & REVERSE_DIRECTION
                        );
                        return stateMachine.process(
                          this.glyphs,
                          reverse,
                          process
                        );
                      };
                    AATMorxProcessor.prototype.getStateMachine =
                      function getStateMachine(subtable) {
                        return new AATStateMachine(subtable.table.stateTable);
                      };
                    AATMorxProcessor.prototype.getProcessor =
                      function getProcessor() {
                        switch (this.subtable.type) {
                          case 0:
                            return this.processIndicRearragement;
                          case 1:
                            return this.processContextualSubstitution;
                          case 2:
                            return this.processLigature;
                          case 4:
                            return this.processNoncontextualSubstitutions;
                          case 5:
                            return this.processGlyphInsertion;
                          default:
                            throw new Error(
                              "Invalid morx subtable type: " + this.subtable.type
                            );
                        }
                      };
                    AATMorxProcessor.prototype.processIndicRearragement =
                      function processIndicRearragement(glyph, entry, index) {
                        if (entry.flags & MARK_FIRST) {
                          this.firstGlyph = index;
                        }
                        if (entry.flags & MARK_LAST) {
                          this.lastGlyph = index;
                        }
                        reorderGlyphs(
                          this.glyphs,
                          entry.flags & VERB,
                          this.firstGlyph,
                          this.lastGlyph
                        );
                      };
                    AATMorxProcessor.prototype.processContextualSubstitution =
                      function processContextualSubstitution(
                        glyph,
                        entry,
                        index
                      ) {
                        var subsitutions =
                          this.subtable.table.substitutionTable.items;
                        if (entry.markIndex !== 65535) {
                          var lookup = subsitutions.getItem(entry.markIndex);
                          var lookupTable = new AATLookupTable(lookup);
                          glyph = this.glyphs[this.markedGlyph];
                          var gid = lookupTable.lookup(glyph.id);
                          if (gid) {
                            this.glyphs[this.markedGlyph] = this.font.getGlyph(
                              gid,
                              glyph.codePoints
                            );
                          }
                        }
                        if (entry.currentIndex !== 65535) {
                          var _lookup = subsitutions.getItem(entry.currentIndex);
                          var _lookupTable = new AATLookupTable(_lookup);
                          glyph = this.glyphs[index];
                          var gid = _lookupTable.lookup(glyph.id);
                          if (gid) {
                            this.glyphs[index] = this.font.getGlyph(
                              gid,
                              glyph.codePoints
                            );
                          }
                        }
                        if (entry.flags & SET_MARK) {
                          this.markedGlyph = index;
                        }
                      };
                    AATMorxProcessor.prototype.processLigature =
                      function processLigature(glyph, entry, index) {
                        if (entry.flags & SET_COMPONENT) {
                          this.ligatureStack.push(index);
                        }
                        if (entry.flags & PERFORM_ACTION) {
                          var _ligatureStack;
                          var actions = this.subtable.table.ligatureActions;
                          var components = this.subtable.table.components;
                          var ligatureList = this.subtable.table.ligatureList;
                          var actionIndex = entry.action;
                          var last = false;
                          var ligatureIndex = 0;
                          var codePoints = [];
                          var ligatureGlyphs = [];
                          while (!last) {
                            var _codePoints;
                            var componentGlyph = this.ligatureStack.pop();
                            (_codePoints = codePoints).unshift.apply(
                              _codePoints,
                              this.glyphs[componentGlyph].codePoints
                            );
                            var action = actions.getItem(actionIndex++);
                            last = !!(action & LAST_MASK);
                            var store = !!(action & STORE_MASK);
                            var offset = ((action & OFFSET_MASK) << 2) >> 2;
                            offset += this.glyphs[componentGlyph].id;
                            var component = components.getItem(offset);
                            ligatureIndex += component;
                            if (last || store) {
                              var ligatureEntry =
                                ligatureList.getItem(ligatureIndex);
                              this.glyphs[componentGlyph] = this.font.getGlyph(
                                ligatureEntry,
                                codePoints
                              );
                              ligatureGlyphs.push(componentGlyph);
                              ligatureIndex = 0;
                              codePoints = [];
                            } else {
                              this.glyphs[componentGlyph] =
                                this.font.getGlyph(65535);
                            }
                          }
                          (_ligatureStack = this.ligatureStack).push.apply(
                            _ligatureStack,
                            ligatureGlyphs
                          );
                        }
                      };
                    AATMorxProcessor.prototype.processNoncontextualSubstitutions =
                      function processNoncontextualSubstitutions(
                        subtable,
                        glyphs,
                        index
                      ) {
                        var lookupTable = new AATLookupTable(
                          subtable.table.lookupTable
                        );
                        for (index = 0; index < glyphs.length; index++) {
                          var glyph = glyphs[index];
                          if (glyph.id !== 65535) {
                            var gid = lookupTable.lookup(glyph.id);
                            if (gid) {
                              glyphs[index] = this.font.getGlyph(
                                gid,
                                glyph.codePoints
                              );
                            }
                          }
                        }
                      };
                    AATMorxProcessor.prototype._insertGlyphs =
                      function _insertGlyphs(
                        glyphIndex,
                        insertionActionIndex,
                        count,
                        isBefore
                      ) {
                        var _glyphs;
                        var insertions = [];
                        while (count--) {
                          var gid = this.subtable.table.insertionActions.getItem(
                            insertionActionIndex++
                          );
                          insertions.push(this.font.getGlyph(gid));
                        }
                        if (!isBefore) {
                          glyphIndex++;
                        }
                        (_glyphs = this.glyphs).splice.apply(
                          _glyphs,
                          [glyphIndex, 0].concat(insertions)
                        );
                      };
                    AATMorxProcessor.prototype.processGlyphInsertion =
                      function processGlyphInsertion(glyph, entry, index) {
                        if (entry.flags & SET_MARK) {
                          this.markedIndex = index;
                        }
                        if (entry.markedInsertIndex !== 65535) {
                          var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
                          var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
                          this._insertGlyphs(
                            this.markedIndex,
                            entry.markedInsertIndex,
                            count,
                            isBefore
                          );
                        }
                        if (entry.currentInsertIndex !== 65535) {
                          var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
                          var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
                          this._insertGlyphs(
                            index,
                            entry.currentInsertIndex,
                            _count,
                            _isBefore
                          );
                        }
                      };
                    AATMorxProcessor.prototype.getSupportedFeatures =
                      function getSupportedFeatures() {
                        var features = [];
                        for (
                          var _iterator4 = this.morx.chains,
                            _isArray4 = Array.isArray(_iterator4),
                            _i4 = 0,
                            _iterator4 = _isArray4
                              ? _iterator4
                              : _getIterator(_iterator4);
                          ;
  
                        ) {
                          var _ref4;
                          if (_isArray4) {
                            if (_i4 >= _iterator4.length) break;
                            _ref4 = _iterator4[_i4++];
                          } else {
                            _i4 = _iterator4.next();
                            if (_i4.done) break;
                            _ref4 = _i4.value;
                          }
                          var chain = _ref4;
                          for (
                            var _iterator5 = chain.features,
                              _isArray5 = Array.isArray(_iterator5),
                              _i5 = 0,
                              _iterator5 = _isArray5
                                ? _iterator5
                                : _getIterator(_iterator5);
                            ;
  
                          ) {
                            var _ref5;
                            if (_isArray5) {
                              if (_i5 >= _iterator5.length) break;
                              _ref5 = _iterator5[_i5++];
                            } else {
                              _i5 = _iterator5.next();
                              if (_i5.done) break;
                              _ref5 = _i5.value;
                            }
                            var feature = _ref5;
                            features.push([
                              feature.featureType,
                              feature.featureSetting,
                            ]);
                          }
                        }
                        return features;
                      };
                    AATMorxProcessor.prototype.generateInputs =
                      function generateInputs(gid) {
                        if (!this.inputCache) {
                          this.generateInputCache();
                        }
                        return this.inputCache[gid] || [];
                      };
                    AATMorxProcessor.prototype.generateInputCache =
                      function generateInputCache() {
                        this.inputCache = {};
                        for (
                          var _iterator6 = this.morx.chains,
                            _isArray6 = Array.isArray(_iterator6),
                            _i6 = 0,
                            _iterator6 = _isArray6
                              ? _iterator6
                              : _getIterator(_iterator6);
                          ;
  
                        ) {
                          var _ref6;
                          if (_isArray6) {
                            if (_i6 >= _iterator6.length) break;
                            _ref6 = _iterator6[_i6++];
                          } else {
                            _i6 = _iterator6.next();
                            if (_i6.done) break;
                            _ref6 = _i6.value;
                          }
                          var chain = _ref6;
                          var flags = chain.defaultFlags;
                          for (
                            var _iterator7 = chain.subtables,
                              _isArray7 = Array.isArray(_iterator7),
                              _i7 = 0,
                              _iterator7 = _isArray7
                                ? _iterator7
                                : _getIterator(_iterator7);
                            ;
  
                          ) {
                            var _ref7;
                            if (_isArray7) {
                              if (_i7 >= _iterator7.length) break;
                              _ref7 = _iterator7[_i7++];
                            } else {
                              _i7 = _iterator7.next();
                              if (_i7.done) break;
                              _ref7 = _i7.value;
                            }
                            var subtable = _ref7;
                            if (subtable.subFeatureFlags & flags) {
                              this.generateInputsForSubtable(subtable);
                            }
                          }
                        }
                      };
                    AATMorxProcessor.prototype.generateInputsForSubtable =
                      function generateInputsForSubtable(subtable) {
                        var _this = this;
                        if (subtable.type !== 2) {
                          return;
                        }
                        var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
                        if (reverse) {
                          throw new Error("Reverse subtable, not supported.");
                        }
                        this.subtable = subtable;
                        this.ligatureStack = [];
                        var stateMachine = this.getStateMachine(subtable);
                        var process = this.getProcessor();
                        var input = [];
                        var stack = [];
                        this.glyphs = [];
                        stateMachine.traverse({
                          enter: function enter(glyph, entry) {
                            var glyphs = _this.glyphs;
                            stack.push({
                              glyphs: glyphs.slice(),
                              ligatureStack: _this.ligatureStack.slice(),
                            });
                            var g = _this.font.getGlyph(glyph);
                            input.push(g);
                            glyphs.push(input[input.length - 1]);
                            process(
                              glyphs[glyphs.length - 1],
                              entry,
                              glyphs.length - 1
                            );
                            var count = 0;
                            var found = 0;
                            for (
                              var i = 0;
                              i < glyphs.length && count <= 1;
                              i++
                            ) {
                              if (glyphs[i].id !== 65535) {
                                count++;
                                found = glyphs[i].id;
                              }
                            }
                            if (count === 1) {
                              var result = input.map(function (g) {
                                return g.id;
                              });
                              var _cache = _this.inputCache[found];
                              if (_cache) {
                                _cache.push(result);
                              } else {
                                _this.inputCache[found] = [result];
                              }
                            }
                          },
                          exit: function exit() {
                            var _stack$pop = stack.pop();
                            _this.glyphs = _stack$pop.glyphs;
                            _this.ligatureStack = _stack$pop.ligatureStack;
                            input.pop();
                          },
                        });
                      };
                    return AATMorxProcessor;
                  })()),
                  _applyDecoratedDescriptor$2(
                    _class$2.prototype,
                    "getStateMachine",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$2.prototype,
                      "getStateMachine"
                    ),
                    _class$2.prototype
                  ),
                  _class$2);
                function swap(glyphs, rangeA, rangeB) {
                  var reverseA =
                    arguments.length > 3 && arguments[3] !== undefined
                      ? arguments[3]
                      : false;
                  var reverseB =
                    arguments.length > 4 && arguments[4] !== undefined
                      ? arguments[4]
                      : false;
                  var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
                  if (reverseB) {
                    end.reverse();
                  }
                  var start = glyphs.splice.apply(
                    glyphs,
                    [rangeA[0], rangeA[1]].concat(end)
                  );
                  if (reverseA) {
                    start.reverse();
                  }
                  glyphs.splice.apply(
                    glyphs,
                    [rangeB[0] - (rangeA[1] - 1), 0].concat(start)
                  );
                  return glyphs;
                }
                function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
                  var length = lastGlyph - firstGlyph + 1;
                  switch (verb) {
                    case 0:
                      return glyphs;
                    case 1:
                      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 0]);
                    case 2:
                      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 1]);
                    case 3:
                      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 1]);
                    case 4:
                      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0]);
                    case 5:
                      return swap(
                        glyphs,
                        [firstGlyph, 2],
                        [lastGlyph, 0],
                        true,
                        false
                      );
                    case 6:
                      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2]);
                    case 7:
                      return swap(
                        glyphs,
                        [firstGlyph, 0],
                        [lastGlyph, 2],
                        false,
                        true
                      );
                    case 8:
                      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2]);
                    case 9:
                      return swap(
                        glyphs,
                        [firstGlyph, 1],
                        [lastGlyph, 2],
                        false,
                        true
                      );
                    case 10:
                      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1]);
                    case 11:
                      return swap(
                        glyphs,
                        [firstGlyph, 2],
                        [lastGlyph, 1],
                        true,
                        false
                      );
                    case 12:
                      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2]);
                    case 13:
                      return swap(
                        glyphs,
                        [firstGlyph, 2],
                        [lastGlyph, 2],
                        true,
                        false
                      );
                    case 14:
                      return swap(
                        glyphs,
                        [firstGlyph, 2],
                        [lastGlyph, 2],
                        false,
                        true
                      );
                    case 15:
                      return swap(
                        glyphs,
                        [firstGlyph, 2],
                        [lastGlyph, 2],
                        true,
                        true
                      );
                    default:
                      throw new Error("Unknown verb: " + verb);
                  }
                }
                var AATLayoutEngine = (function () {
                  function AATLayoutEngine(font) {
                    _classCallCheck(this, AATLayoutEngine);
                    this.font = font;
                    this.morxProcessor = new AATMorxProcessor(font);
                    this.fallbackPosition = false;
                  }
                  AATLayoutEngine.prototype.substitute = function substitute(
                    glyphRun
                  ) {
                    if (glyphRun.direction === "rtl") {
                      glyphRun.glyphs.reverse();
                    }
                    this.morxProcessor.process(
                      glyphRun.glyphs,
                      mapOTToAAT(glyphRun.features)
                    );
                  };
                  AATLayoutEngine.prototype.getAvailableFeatures =
                    function getAvailableFeatures(script, language) {
                      return mapAATToOT(
                        this.morxProcessor.getSupportedFeatures()
                      );
                    };
                  AATLayoutEngine.prototype.stringsForGlyph =
                    function stringsForGlyph(gid) {
                      var glyphStrings = this.morxProcessor.generateInputs(gid);
                      var result = new _Set();
                      for (
                        var _iterator = glyphStrings,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var glyphs = _ref;
                        this._addStrings(glyphs, 0, result, "");
                      }
                      return result;
                    };
                  AATLayoutEngine.prototype._addStrings = function _addStrings(
                    glyphs,
                    index,
                    strings,
                    string
                  ) {
                    var codePoints = this.font._cmapProcessor.codePointsForGlyph(
                      glyphs[index]
                    );
                    for (
                      var _iterator2 = codePoints,
                        _isArray2 = Array.isArray(_iterator2),
                        _i2 = 0,
                        _iterator2 = _isArray2
                          ? _iterator2
                          : _getIterator(_iterator2);
                      ;
  
                    ) {
                      var _ref2;
                      if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                      } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                      }
                      var codePoint = _ref2;
                      var s = string + _String$fromCodePoint(codePoint);
                      if (index < glyphs.length - 1) {
                        this._addStrings(glyphs, index + 1, strings, s);
                      } else {
                        strings.add(s);
                      }
                    }
                  };
                  return AATLayoutEngine;
                })();
                var ShapingPlan = (function () {
                  function ShapingPlan(font, script, direction) {
                    _classCallCheck(this, ShapingPlan);
                    this.font = font;
                    this.script = script;
                    this.direction = direction;
                    this.stages = [];
                    this.globalFeatures = {};
                    this.allFeatures = {};
                  }
                  ShapingPlan.prototype._addFeatures = function _addFeatures(
                    features,
                    global
                  ) {
                    var stageIndex = this.stages.length - 1;
                    var stage = this.stages[stageIndex];
                    for (
                      var _iterator = features,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var feature = _ref;
                      if (this.allFeatures[feature] == null) {
                        stage.push(feature);
                        this.allFeatures[feature] = stageIndex;
                        if (global) {
                          this.globalFeatures[feature] = true;
                        }
                      }
                    }
                  };
                  ShapingPlan.prototype.add = function add(arg) {
                    var global =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : true;
                    if (this.stages.length === 0) {
                      this.stages.push([]);
                    }
                    if (typeof arg === "string") {
                      arg = [arg];
                    }
                    if (Array.isArray(arg)) {
                      this._addFeatures(arg, global);
                    } else if (
                      (typeof arg === "undefined"
                        ? "undefined"
                        : _typeof(arg)) === "object"
                    ) {
                      this._addFeatures(arg.global || [], true);
                      this._addFeatures(arg.local || [], false);
                    } else {
                      throw new Error("Unsupported argument to ShapingPlan#add");
                    }
                  };
                  ShapingPlan.prototype.addStage = function addStage(
                    arg,
                    global
                  ) {
                    if (typeof arg === "function") {
                      this.stages.push(arg, []);
                    } else {
                      this.stages.push([]);
                      this.add(arg, global);
                    }
                  };
                  ShapingPlan.prototype.setFeatureOverrides =
                    function setFeatureOverrides(features) {
                      if (Array.isArray(features)) {
                        this.add(features);
                      } else if (
                        (typeof features === "undefined"
                          ? "undefined"
                          : _typeof(features)) === "object"
                      ) {
                        for (var tag in features) {
                          if (features[tag]) {
                            this.add(tag);
                          } else if (this.allFeatures[tag] != null) {
                            var stage = this.stages[this.allFeatures[tag]];
                            stage.splice(stage.indexOf(tag), 1);
                            delete this.allFeatures[tag];
                            delete this.globalFeatures[tag];
                          }
                        }
                      }
                    };
                  ShapingPlan.prototype.assignGlobalFeatures =
                    function assignGlobalFeatures(glyphs) {
                      for (
                        var _iterator2 = glyphs,
                          _isArray2 = Array.isArray(_iterator2),
                          _i2 = 0,
                          _iterator2 = _isArray2
                            ? _iterator2
                            : _getIterator(_iterator2);
                        ;
  
                      ) {
                        var _ref2;
                        if (_isArray2) {
                          if (_i2 >= _iterator2.length) break;
                          _ref2 = _iterator2[_i2++];
                        } else {
                          _i2 = _iterator2.next();
                          if (_i2.done) break;
                          _ref2 = _i2.value;
                        }
                        var glyph = _ref2;
                        for (var feature in this.globalFeatures) {
                          glyph.features[feature] = true;
                        }
                      }
                    };
                  ShapingPlan.prototype.process = function process(
                    processor,
                    glyphs,
                    positions
                  ) {
                    for (
                      var _iterator3 = this.stages,
                        _isArray3 = Array.isArray(_iterator3),
                        _i3 = 0,
                        _iterator3 = _isArray3
                          ? _iterator3
                          : _getIterator(_iterator3);
                      ;
  
                    ) {
                      var _ref3;
                      if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i3++];
                      } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref3 = _i3.value;
                      }
                      var stage = _ref3;
                      if (typeof stage === "function") {
                        if (!positions) {
                          stage(this.font, glyphs, this);
                        }
                      } else if (stage.length > 0) {
                        processor.applyFeatures(stage, glyphs, positions);
                      }
                    }
                  };
                  return ShapingPlan;
                })();
                var _class$4;
                var _temp;
                var VARIATION_FEATURES = ["rvrn"];
                var COMMON_FEATURES = ["ccmp", "locl", "rlig", "mark", "mkmk"];
                var FRACTIONAL_FEATURES = ["frac", "numr", "dnom"];
                var HORIZONTAL_FEATURES = [
                  "calt",
                  "clig",
                  "liga",
                  "rclt",
                  "curs",
                  "kern",
                ];
                var DIRECTIONAL_FEATURES = {
                  ltr: ["ltra", "ltrm"],
                  rtl: ["rtla", "rtlm"],
                };
                var DefaultShaper =
                  ((_temp = _class$4 =
                    (function () {
                      function DefaultShaper() {
                        _classCallCheck(this, DefaultShaper);
                      }
                      DefaultShaper.plan = function plan(
                        _plan,
                        glyphs,
                        features
                      ) {
                        this.planPreprocessing(_plan);
                        this.planFeatures(_plan);
                        this.planPostprocessing(_plan, features);
                        _plan.assignGlobalFeatures(glyphs);
                        this.assignFeatures(_plan, glyphs);
                      };
                      DefaultShaper.planPreprocessing =
                        function planPreprocessing(plan) {
                          plan.add({
                            global: [].concat(
                              VARIATION_FEATURES,
                              DIRECTIONAL_FEATURES[plan.direction]
                            ),
                            local: FRACTIONAL_FEATURES,
                          });
                        };
                      DefaultShaper.planFeatures = function planFeatures(plan) {};
                      DefaultShaper.planPostprocessing =
                        function planPostprocessing(plan, userFeatures) {
                          plan.add(
                            [].concat(COMMON_FEATURES, HORIZONTAL_FEATURES)
                          );
                          plan.setFeatureOverrides(userFeatures);
                        };
                      DefaultShaper.assignFeatures = function assignFeatures(
                        plan,
                        glyphs
                      ) {
                        for (var i = 0; i < glyphs.length; i++) {
                          var glyph = glyphs[i];
                          if (glyph.codePoints[0] === 8260) {
                            var start = i;
                            var end = i + 1;
                            while (
                              start > 0 &&
                              unicode.isDigit(glyphs[start - 1].codePoints[0])
                            ) {
                              glyphs[start - 1].features.numr = true;
                              glyphs[start - 1].features.frac = true;
                              start--;
                            }
                            while (
                              end < glyphs.length &&
                              unicode.isDigit(glyphs[end].codePoints[0])
                            ) {
                              glyphs[end].features.dnom = true;
                              glyphs[end].features.frac = true;
                              end++;
                            }
                            glyph.features.frac = true;
                            i = end - 1;
                          }
                        }
                      };
                      return DefaultShaper;
                    })()),
                  (_class$4.zeroMarkWidths = "AFTER_GPOS"),
                  _temp);
                var trie = new UnicodeTrie(
                  Buffer(
                    "AAHwAAAAAAAAADgAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==",
                    "base64"
                  )
                );
                var FEATURES = [
                  "isol",
                  "fina",
                  "fin2",
                  "fin3",
                  "medi",
                  "med2",
                  "init",
                ];
                var ShapingClasses = {
                  Non_Joining: 0,
                  Left_Joining: 1,
                  Right_Joining: 2,
                  Dual_Joining: 3,
                  Join_Causing: 3,
                  ALAPH: 4,
                  "DALATH RISH": 5,
                  Transparent: 6,
                };
                var ISOL = "isol";
                var FINA = "fina";
                var FIN2 = "fin2";
                var FIN3 = "fin3";
                var MEDI = "medi";
                var MED2 = "med2";
                var INIT = "init";
                var NONE = null;
                var STATE_TABLE = [
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [NONE, ISOL, 1],
                    [NONE, ISOL, 2],
                    [NONE, ISOL, 1],
                    [NONE, ISOL, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [NONE, ISOL, 1],
                    [NONE, ISOL, 2],
                    [NONE, FIN2, 5],
                    [NONE, ISOL, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [INIT, FINA, 1],
                    [INIT, FINA, 3],
                    [INIT, FINA, 4],
                    [INIT, FINA, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [MEDI, FINA, 1],
                    [MEDI, FINA, 3],
                    [MEDI, FINA, 4],
                    [MEDI, FINA, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [MED2, ISOL, 1],
                    [MED2, ISOL, 2],
                    [MED2, FIN2, 5],
                    [MED2, ISOL, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [ISOL, ISOL, 1],
                    [ISOL, ISOL, 2],
                    [ISOL, FIN2, 5],
                    [ISOL, ISOL, 6],
                  ],
                  [
                    [NONE, NONE, 0],
                    [NONE, ISOL, 2],
                    [NONE, ISOL, 1],
                    [NONE, ISOL, 2],
                    [NONE, FIN3, 5],
                    [NONE, ISOL, 6],
                  ],
                ];
                var ArabicShaper = (function (_DefaultShaper) {
                  _inherits(ArabicShaper, _DefaultShaper);
                  function ArabicShaper() {
                    _classCallCheck(this, ArabicShaper);
                    return _possibleConstructorReturn(
                      this,
                      _DefaultShaper.apply(this, arguments)
                    );
                  }
                  ArabicShaper.planFeatures = function planFeatures(plan) {
                    plan.add(["ccmp", "locl"]);
                    for (var i = 0; i < FEATURES.length; i++) {
                      var feature = FEATURES[i];
                      plan.addStage(feature, false);
                    }
                    plan.addStage("mset");
                  };
                  ArabicShaper.assignFeatures = function assignFeatures(
                    plan,
                    glyphs
                  ) {
                    _DefaultShaper.assignFeatures.call(this, plan, glyphs);
                    var prev = -1;
                    var state = 0;
                    var actions = [];
                    for (var i = 0; i < glyphs.length; i++) {
                      var curAction = void 0,
                        prevAction = void 0;
                      var glyph = glyphs[i];
                      var type = getShapingClass(glyph.codePoints[0]);
                      if (type === ShapingClasses.Transparent) {
                        actions[i] = NONE;
                        continue;
                      }
                      var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
                      prevAction = _STATE_TABLE$state$ty[0];
                      curAction = _STATE_TABLE$state$ty[1];
                      state = _STATE_TABLE$state$ty[2];
                      if (prevAction !== NONE && prev !== -1) {
                        actions[prev] = prevAction;
                      }
                      actions[i] = curAction;
                      prev = i;
                    }
                    for (var index = 0; index < glyphs.length; index++) {
                      var feature = void 0;
                      var glyph = glyphs[index];
                      if ((feature = actions[index])) {
                        glyph.features[feature] = true;
                      }
                    }
                  };
                  return ArabicShaper;
                })(DefaultShaper);
                function getShapingClass(codePoint) {
                  var res = trie.get(codePoint);
                  if (res) {
                    return res - 1;
                  }
                  var category = unicode.getCategory(codePoint);
                  if (
                    category === "Mn" ||
                    category === "Me" ||
                    category === "Cf"
                  ) {
                    return ShapingClasses.Transparent;
                  }
                  return ShapingClasses.Non_Joining;
                }
                var GlyphIterator = (function () {
                  function GlyphIterator(glyphs, options) {
                    _classCallCheck(this, GlyphIterator);
                    this.glyphs = glyphs;
                    this.reset(options);
                  }
                  GlyphIterator.prototype.reset = function reset() {
                    var options =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : {};
                    var index =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : 0;
                    this.options = options;
                    this.flags = options.flags || {};
                    this.markAttachmentType = options.markAttachmentType || 0;
                    this.index = index;
                  };
                  GlyphIterator.prototype.shouldIgnore = function shouldIgnore(
                    glyph
                  ) {
                    return (
                      (this.flags.ignoreMarks && glyph.isMark) ||
                      (this.flags.ignoreBaseGlyphs && glyph.isBase) ||
                      (this.flags.ignoreLigatures && glyph.isLigature) ||
                      (this.markAttachmentType &&
                        glyph.isMark &&
                        glyph.markAttachmentType !== this.markAttachmentType)
                    );
                  };
                  GlyphIterator.prototype.move = function move(dir) {
                    this.index += dir;
                    while (
                      0 <= this.index &&
                      this.index < this.glyphs.length &&
                      this.shouldIgnore(this.glyphs[this.index])
                    ) {
                      this.index += dir;
                    }
                    if (0 > this.index || this.index >= this.glyphs.length) {
                      return null;
                    }
                    return this.glyphs[this.index];
                  };
                  GlyphIterator.prototype.next = function next() {
                    return this.move(+1);
                  };
                  GlyphIterator.prototype.prev = function prev() {
                    return this.move(-1);
                  };
                  GlyphIterator.prototype.peek = function peek() {
                    var count =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : 1;
                    var idx = this.index;
                    var res = this.increment(count);
                    this.index = idx;
                    return res;
                  };
                  GlyphIterator.prototype.peekIndex = function peekIndex() {
                    var count =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : 1;
                    var idx = this.index;
                    this.increment(count);
                    var res = this.index;
                    this.index = idx;
                    return res;
                  };
                  GlyphIterator.prototype.increment = function increment() {
                    var count =
                      arguments.length > 0 && arguments[0] !== undefined
                        ? arguments[0]
                        : 1;
                    var dir = count < 0 ? -1 : 1;
                    count = Math.abs(count);
                    while (count--) {
                      this.move(dir);
                    }
                    return this.glyphs[this.index];
                  };
                  _createClass(GlyphIterator, [
                    {
                      key: "cur",
                      get: function get() {
                        return this.glyphs[this.index] || null;
                      },
                    },
                  ]);
                  return GlyphIterator;
                })();
                var DEFAULT_SCRIPTS = ["DFLT", "dflt", "latn"];
                var OTProcessor = (function () {
                  function OTProcessor(font, table) {
                    _classCallCheck(this, OTProcessor);
                    this.font = font;
                    this.table = table;
                    this.script = null;
                    this.scriptTag = null;
                    this.language = null;
                    this.languageTag = null;
                    this.features = {};
                    this.lookups = {};
                    this.variationsIndex = font._variationProcessor
                      ? this.findVariationsIndex(
                          font._variationProcessor.normalizedCoords
                        )
                      : -1;
                    this.selectScript();
                    this.glyphs = [];
                    this.positions = [];
                    this.ligatureID = 1;
                    this.currentFeature = null;
                  }
                  OTProcessor.prototype.findScript = function findScript(script) {
                    if (this.table.scriptList == null) {
                      return null;
                    }
                    if (!Array.isArray(script)) {
                      script = [script];
                    }
                    for (
                      var _iterator = script,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var s = _ref;
                      for (
                        var _iterator2 = this.table.scriptList,
                          _isArray2 = Array.isArray(_iterator2),
                          _i2 = 0,
                          _iterator2 = _isArray2
                            ? _iterator2
                            : _getIterator(_iterator2);
                        ;
  
                      ) {
                        var _ref2;
                        if (_isArray2) {
                          if (_i2 >= _iterator2.length) break;
                          _ref2 = _iterator2[_i2++];
                        } else {
                          _i2 = _iterator2.next();
                          if (_i2.done) break;
                          _ref2 = _i2.value;
                        }
                        var entry = _ref2;
                        if (entry.tag === s) {
                          return entry;
                        }
                      }
                    }
                    return null;
                  };
                  OTProcessor.prototype.selectScript = function selectScript(
                    script,
                    language,
                    direction$$
                  ) {
                    var changed = false;
                    var entry = void 0;
                    if (!this.script || script !== this.scriptTag) {
                      entry = this.findScript(script);
                      if (!entry) {
                        entry = this.findScript(DEFAULT_SCRIPTS);
                      }
                      if (!entry) {
                        return this.scriptTag;
                      }
                      this.scriptTag = entry.tag;
                      this.script = entry.script;
                      this.language = null;
                      this.languageTag = null;
                      changed = true;
                    }
                    if (!direction$$ || direction$$ !== this.direction) {
                      this.direction = direction$$ || direction(script);
                    }
                    if (language && language.length < 4) {
                      language += " ".repeat(4 - language.length);
                    }
                    if (!language || language !== this.languageTag) {
                      this.language = null;
                      for (
                        var _iterator3 = this.script.langSysRecords,
                          _isArray3 = Array.isArray(_iterator3),
                          _i3 = 0,
                          _iterator3 = _isArray3
                            ? _iterator3
                            : _getIterator(_iterator3);
                        ;
  
                      ) {
                        var _ref3;
                        if (_isArray3) {
                          if (_i3 >= _iterator3.length) break;
                          _ref3 = _iterator3[_i3++];
                        } else {
                          _i3 = _iterator3.next();
                          if (_i3.done) break;
                          _ref3 = _i3.value;
                        }
                        var lang = _ref3;
                        if (lang.tag === language) {
                          this.language = lang.langSys;
                          this.languageTag = lang.tag;
                          break;
                        }
                      }
                      if (!this.language) {
                        this.language = this.script.defaultLangSys;
                        this.languageTag = null;
                      }
                      changed = true;
                    }
                    if (changed) {
                      this.features = {};
                      if (this.language) {
                        for (
                          var _iterator4 = this.language.featureIndexes,
                            _isArray4 = Array.isArray(_iterator4),
                            _i4 = 0,
                            _iterator4 = _isArray4
                              ? _iterator4
                              : _getIterator(_iterator4);
                          ;
  
                        ) {
                          var _ref4;
                          if (_isArray4) {
                            if (_i4 >= _iterator4.length) break;
                            _ref4 = _iterator4[_i4++];
                          } else {
                            _i4 = _iterator4.next();
                            if (_i4.done) break;
                            _ref4 = _i4.value;
                          }
                          var featureIndex = _ref4;
                          var record = this.table.featureList[featureIndex];
                          var substituteFeature =
                            this.substituteFeatureForVariations(featureIndex);
                          this.features[record.tag] =
                            substituteFeature || record.feature;
                        }
                      }
                    }
                    return this.scriptTag;
                  };
                  OTProcessor.prototype.lookupsForFeatures =
                    function lookupsForFeatures() {
                      var userFeatures =
                        arguments.length > 0 && arguments[0] !== undefined
                          ? arguments[0]
                          : [];
                      var exclude = arguments[1];
                      var lookups = [];
                      for (
                        var _iterator5 = userFeatures,
                          _isArray5 = Array.isArray(_iterator5),
                          _i5 = 0,
                          _iterator5 = _isArray5
                            ? _iterator5
                            : _getIterator(_iterator5);
                        ;
  
                      ) {
                        var _ref5;
                        if (_isArray5) {
                          if (_i5 >= _iterator5.length) break;
                          _ref5 = _iterator5[_i5++];
                        } else {
                          _i5 = _iterator5.next();
                          if (_i5.done) break;
                          _ref5 = _i5.value;
                        }
                        var tag = _ref5;
                        var feature = this.features[tag];
                        if (!feature) {
                          continue;
                        }
                        for (
                          var _iterator6 = feature.lookupListIndexes,
                            _isArray6 = Array.isArray(_iterator6),
                            _i6 = 0,
                            _iterator6 = _isArray6
                              ? _iterator6
                              : _getIterator(_iterator6);
                          ;
  
                        ) {
                          var _ref6;
                          if (_isArray6) {
                            if (_i6 >= _iterator6.length) break;
                            _ref6 = _iterator6[_i6++];
                          } else {
                            _i6 = _iterator6.next();
                            if (_i6.done) break;
                            _ref6 = _i6.value;
                          }
                          var lookupIndex = _ref6;
                          if (exclude && exclude.indexOf(lookupIndex) !== -1) {
                            continue;
                          }
                          lookups.push({
                            feature: tag,
                            index: lookupIndex,
                            lookup: this.table.lookupList.get(lookupIndex),
                          });
                        }
                      }
                      lookups.sort(function (a, b) {
                        return a.index - b.index;
                      });
                      return lookups;
                    };
                  OTProcessor.prototype.substituteFeatureForVariations =
                    function substituteFeatureForVariations(featureIndex) {
                      if (this.variationsIndex === -1) {
                        return null;
                      }
                      var record =
                        this.table.featureVariations.featureVariationRecords[
                          this.variationsIndex
                        ];
                      var substitutions =
                        record.featureTableSubstitution.substitutions;
                      for (
                        var _iterator7 = substitutions,
                          _isArray7 = Array.isArray(_iterator7),
                          _i7 = 0,
                          _iterator7 = _isArray7
                            ? _iterator7
                            : _getIterator(_iterator7);
                        ;
  
                      ) {
                        var _ref7;
                        if (_isArray7) {
                          if (_i7 >= _iterator7.length) break;
                          _ref7 = _iterator7[_i7++];
                        } else {
                          _i7 = _iterator7.next();
                          if (_i7.done) break;
                          _ref7 = _i7.value;
                        }
                        var substitution = _ref7;
                        if (substitution.featureIndex === featureIndex) {
                          return substitution.alternateFeatureTable;
                        }
                      }
                      return null;
                    };
                  OTProcessor.prototype.findVariationsIndex =
                    function findVariationsIndex(coords) {
                      var variations = this.table.featureVariations;
                      if (!variations) {
                        return -1;
                      }
                      var records = variations.featureVariationRecords;
                      for (var i = 0; i < records.length; i++) {
                        var conditions = records[i].conditionSet.conditionTable;
                        if (this.variationConditionsMatch(conditions, coords)) {
                          return i;
                        }
                      }
                      return -1;
                    };
                  OTProcessor.prototype.variationConditionsMatch =
                    function variationConditionsMatch(conditions, coords) {
                      return conditions.every(function (condition) {
                        var coord =
                          condition.axisIndex < coords.length
                            ? coords[condition.axisIndex]
                            : 0;
                        return (
                          condition.filterRangeMinValue <= coord &&
                          coord <= condition.filterRangeMaxValue
                        );
                      });
                    };
                  OTProcessor.prototype.applyFeatures = function applyFeatures(
                    userFeatures,
                    glyphs,
                    advances
                  ) {
                    var lookups = this.lookupsForFeatures(userFeatures);
                    this.applyLookups(lookups, glyphs, advances);
                  };
                  OTProcessor.prototype.applyLookups = function applyLookups(
                    lookups,
                    glyphs,
                    positions
                  ) {
                    this.glyphs = glyphs;
                    this.positions = positions;
                    this.glyphIterator = new GlyphIterator(glyphs);
                    for (
                      var _iterator8 = lookups,
                        _isArray8 = Array.isArray(_iterator8),
                        _i8 = 0,
                        _iterator8 = _isArray8
                          ? _iterator8
                          : _getIterator(_iterator8);
                      ;
  
                    ) {
                      var _ref8;
                      if (_isArray8) {
                        if (_i8 >= _iterator8.length) break;
                        _ref8 = _iterator8[_i8++];
                      } else {
                        _i8 = _iterator8.next();
                        if (_i8.done) break;
                        _ref8 = _i8.value;
                      }
                      var _ref9 = _ref8,
                        feature = _ref9.feature,
                        lookup = _ref9.lookup;
                      this.currentFeature = feature;
                      this.glyphIterator.reset(lookup.flags);
                      while (this.glyphIterator.index < glyphs.length) {
                        if (!(feature in this.glyphIterator.cur.features)) {
                          this.glyphIterator.next();
                          continue;
                        }
                        for (
                          var _iterator9 = lookup.subTables,
                            _isArray9 = Array.isArray(_iterator9),
                            _i9 = 0,
                            _iterator9 = _isArray9
                              ? _iterator9
                              : _getIterator(_iterator9);
                          ;
  
                        ) {
                          var _ref10;
                          if (_isArray9) {
                            if (_i9 >= _iterator9.length) break;
                            _ref10 = _iterator9[_i9++];
                          } else {
                            _i9 = _iterator9.next();
                            if (_i9.done) break;
                            _ref10 = _i9.value;
                          }
                          var table = _ref10;
                          var res = this.applyLookup(lookup.lookupType, table);
                          if (res) {
                            break;
                          }
                        }
                        this.glyphIterator.next();
                      }
                    }
                  };
                  OTProcessor.prototype.applyLookup = function applyLookup(
                    lookup,
                    table
                  ) {
                    throw new Error(
                      "applyLookup must be implemented by subclasses"
                    );
                  };
                  OTProcessor.prototype.applyLookupList =
                    function applyLookupList(lookupRecords) {
                      var options = this.glyphIterator.options;
                      var glyphIndex = this.glyphIterator.index;
                      for (
                        var _iterator10 = lookupRecords,
                          _isArray10 = Array.isArray(_iterator10),
                          _i10 = 0,
                          _iterator10 = _isArray10
                            ? _iterator10
                            : _getIterator(_iterator10);
                        ;
  
                      ) {
                        var _ref11;
                        if (_isArray10) {
                          if (_i10 >= _iterator10.length) break;
                          _ref11 = _iterator10[_i10++];
                        } else {
                          _i10 = _iterator10.next();
                          if (_i10.done) break;
                          _ref11 = _i10.value;
                        }
                        var lookupRecord = _ref11;
                        this.glyphIterator.reset(options, glyphIndex);
                        this.glyphIterator.increment(lookupRecord.sequenceIndex);
                        var lookup = this.table.lookupList.get(
                          lookupRecord.lookupListIndex
                        );
                        this.glyphIterator.reset(
                          lookup.flags,
                          this.glyphIterator.index
                        );
                        for (
                          var _iterator11 = lookup.subTables,
                            _isArray11 = Array.isArray(_iterator11),
                            _i11 = 0,
                            _iterator11 = _isArray11
                              ? _iterator11
                              : _getIterator(_iterator11);
                          ;
  
                        ) {
                          var _ref12;
                          if (_isArray11) {
                            if (_i11 >= _iterator11.length) break;
                            _ref12 = _iterator11[_i11++];
                          } else {
                            _i11 = _iterator11.next();
                            if (_i11.done) break;
                            _ref12 = _i11.value;
                          }
                          var table = _ref12;
                          if (this.applyLookup(lookup.lookupType, table)) {
                            break;
                          }
                        }
                      }
                      this.glyphIterator.reset(options, glyphIndex);
                      return true;
                    };
                  OTProcessor.prototype.coverageIndex = function coverageIndex(
                    coverage,
                    glyph
                  ) {
                    if (glyph == null) {
                      glyph = this.glyphIterator.cur.id;
                    }
                    switch (coverage.version) {
                      case 1:
                        return coverage.glyphs.indexOf(glyph);
                      case 2:
                        for (
                          var _iterator12 = coverage.rangeRecords,
                            _isArray12 = Array.isArray(_iterator12),
                            _i12 = 0,
                            _iterator12 = _isArray12
                              ? _iterator12
                              : _getIterator(_iterator12);
                          ;
  
                        ) {
                          var _ref13;
                          if (_isArray12) {
                            if (_i12 >= _iterator12.length) break;
                            _ref13 = _iterator12[_i12++];
                          } else {
                            _i12 = _iterator12.next();
                            if (_i12.done) break;
                            _ref13 = _i12.value;
                          }
                          var range = _ref13;
                          if (range.start <= glyph && glyph <= range.end) {
                            return range.startCoverageIndex + glyph - range.start;
                          }
                        }
                        break;
                    }
                    return -1;
                  };
                  OTProcessor.prototype.match = function match(
                    sequenceIndex,
                    sequence,
                    fn,
                    matched
                  ) {
                    var pos = this.glyphIterator.index;
                    var glyph = this.glyphIterator.increment(sequenceIndex);
                    var idx = 0;
                    while (
                      idx < sequence.length &&
                      glyph &&
                      fn(sequence[idx], glyph)
                    ) {
                      if (matched) {
                        matched.push(this.glyphIterator.index);
                      }
                      idx++;
                      glyph = this.glyphIterator.next();
                    }
                    this.glyphIterator.index = pos;
                    if (idx < sequence.length) {
                      return false;
                    }
                    return matched || true;
                  };
                  OTProcessor.prototype.sequenceMatches =
                    function sequenceMatches(sequenceIndex, sequence) {
                      return this.match(
                        sequenceIndex,
                        sequence,
                        function (component, glyph) {
                          return component === glyph.id;
                        }
                      );
                    };
                  OTProcessor.prototype.sequenceMatchIndices =
                    function sequenceMatchIndices(sequenceIndex, sequence) {
                      var _this = this;
                      return this.match(
                        sequenceIndex,
                        sequence,
                        function (component, glyph) {
                          if (!(_this.currentFeature in glyph.features)) {
                            return false;
                          }
                          return component === glyph.id;
                        },
                        []
                      );
                    };
                  OTProcessor.prototype.coverageSequenceMatches =
                    function coverageSequenceMatches(sequenceIndex, sequence) {
                      var _this2 = this;
                      return this.match(
                        sequenceIndex,
                        sequence,
                        function (coverage, glyph) {
                          return _this2.coverageIndex(coverage, glyph.id) >= 0;
                        }
                      );
                    };
                  OTProcessor.prototype.getClassID = function getClassID(
                    glyph,
                    classDef
                  ) {
                    switch (classDef.version) {
                      case 1:
                        var i = glyph - classDef.startGlyph;
                        if (i >= 0 && i < classDef.classValueArray.length) {
                          return classDef.classValueArray[i];
                        }
                        break;
                      case 2:
                        for (
                          var _iterator13 = classDef.classRangeRecord,
                            _isArray13 = Array.isArray(_iterator13),
                            _i13 = 0,
                            _iterator13 = _isArray13
                              ? _iterator13
                              : _getIterator(_iterator13);
                          ;
  
                        ) {
                          var _ref14;
                          if (_isArray13) {
                            if (_i13 >= _iterator13.length) break;
                            _ref14 = _iterator13[_i13++];
                          } else {
                            _i13 = _iterator13.next();
                            if (_i13.done) break;
                            _ref14 = _i13.value;
                          }
                          var range = _ref14;
                          if (range.start <= glyph && glyph <= range.end) {
                            return range.class;
                          }
                        }
                        break;
                    }
                    return 0;
                  };
                  OTProcessor.prototype.classSequenceMatches =
                    function classSequenceMatches(
                      sequenceIndex,
                      sequence,
                      classDef
                    ) {
                      var _this3 = this;
                      return this.match(
                        sequenceIndex,
                        sequence,
                        function (classID, glyph) {
                          return (
                            classID === _this3.getClassID(glyph.id, classDef)
                          );
                        }
                      );
                    };
                  OTProcessor.prototype.applyContext = function applyContext(
                    table
                  ) {
                    switch (table.version) {
                      case 1:
                        var index = this.coverageIndex(table.coverage);
                        if (index === -1) {
                          return false;
                        }
                        var set = table.ruleSets[index];
                        for (
                          var _iterator14 = set,
                            _isArray14 = Array.isArray(_iterator14),
                            _i14 = 0,
                            _iterator14 = _isArray14
                              ? _iterator14
                              : _getIterator(_iterator14);
                          ;
  
                        ) {
                          var _ref15;
                          if (_isArray14) {
                            if (_i14 >= _iterator14.length) break;
                            _ref15 = _iterator14[_i14++];
                          } else {
                            _i14 = _iterator14.next();
                            if (_i14.done) break;
                            _ref15 = _i14.value;
                          }
                          var rule = _ref15;
                          if (this.sequenceMatches(1, rule.input)) {
                            return this.applyLookupList(rule.lookupRecords);
                          }
                        }
                        break;
                      case 2:
                        if (this.coverageIndex(table.coverage) === -1) {
                          return false;
                        }
                        index = this.getClassID(
                          this.glyphIterator.cur.id,
                          table.classDef
                        );
                        if (index === -1) {
                          return false;
                        }
                        set = table.classSet[index];
                        for (
                          var _iterator15 = set,
                            _isArray15 = Array.isArray(_iterator15),
                            _i15 = 0,
                            _iterator15 = _isArray15
                              ? _iterator15
                              : _getIterator(_iterator15);
                          ;
  
                        ) {
                          var _ref16;
                          if (_isArray15) {
                            if (_i15 >= _iterator15.length) break;
                            _ref16 = _iterator15[_i15++];
                          } else {
                            _i15 = _iterator15.next();
                            if (_i15.done) break;
                            _ref16 = _i15.value;
                          }
                          var _rule = _ref16;
                          if (
                            this.classSequenceMatches(
                              1,
                              _rule.classes,
                              table.classDef
                            )
                          ) {
                            return this.applyLookupList(_rule.lookupRecords);
                          }
                        }
                        break;
                      case 3:
                        if (this.coverageSequenceMatches(0, table.coverages)) {
                          return this.applyLookupList(table.lookupRecords);
                        }
                        break;
                    }
                    return false;
                  };
                  OTProcessor.prototype.applyChainingContext =
                    function applyChainingContext(table) {
                      switch (table.version) {
                        case 1:
                          var index = this.coverageIndex(table.coverage);
                          if (index === -1) {
                            return false;
                          }
                          var set = table.chainRuleSets[index];
                          for (
                            var _iterator16 = set,
                              _isArray16 = Array.isArray(_iterator16),
                              _i16 = 0,
                              _iterator16 = _isArray16
                                ? _iterator16
                                : _getIterator(_iterator16);
                            ;
  
                          ) {
                            var _ref17;
                            if (_isArray16) {
                              if (_i16 >= _iterator16.length) break;
                              _ref17 = _iterator16[_i16++];
                            } else {
                              _i16 = _iterator16.next();
                              if (_i16.done) break;
                              _ref17 = _i16.value;
                            }
                            var rule = _ref17;
                            if (
                              this.sequenceMatches(
                                -rule.backtrack.length,
                                rule.backtrack
                              ) &&
                              this.sequenceMatches(1, rule.input) &&
                              this.sequenceMatches(
                                1 + rule.input.length,
                                rule.lookahead
                              )
                            ) {
                              return this.applyLookupList(rule.lookupRecords);
                            }
                          }
                          break;
                        case 2:
                          if (this.coverageIndex(table.coverage) === -1) {
                            return false;
                          }
                          index = this.getClassID(
                            this.glyphIterator.cur.id,
                            table.inputClassDef
                          );
                          var rules = table.chainClassSet[index];
                          if (!rules) {
                            return false;
                          }
                          for (
                            var _iterator17 = rules,
                              _isArray17 = Array.isArray(_iterator17),
                              _i17 = 0,
                              _iterator17 = _isArray17
                                ? _iterator17
                                : _getIterator(_iterator17);
                            ;
  
                          ) {
                            var _ref18;
                            if (_isArray17) {
                              if (_i17 >= _iterator17.length) break;
                              _ref18 = _iterator17[_i17++];
                            } else {
                              _i17 = _iterator17.next();
                              if (_i17.done) break;
                              _ref18 = _i17.value;
                            }
                            var _rule2 = _ref18;
                            if (
                              this.classSequenceMatches(
                                -_rule2.backtrack.length,
                                _rule2.backtrack,
                                table.backtrackClassDef
                              ) &&
                              this.classSequenceMatches(
                                1,
                                _rule2.input,
                                table.inputClassDef
                              ) &&
                              this.classSequenceMatches(
                                1 + _rule2.input.length,
                                _rule2.lookahead,
                                table.lookaheadClassDef
                              )
                            ) {
                              return this.applyLookupList(_rule2.lookupRecords);
                            }
                          }
                          break;
                        case 3:
                          if (
                            this.coverageSequenceMatches(
                              -table.backtrackGlyphCount,
                              table.backtrackCoverage
                            ) &&
                            this.coverageSequenceMatches(
                              0,
                              table.inputCoverage
                            ) &&
                            this.coverageSequenceMatches(
                              table.inputGlyphCount,
                              table.lookaheadCoverage
                            )
                          ) {
                            return this.applyLookupList(table.lookupRecords);
                          }
                          break;
                      }
                      return false;
                    };
                  return OTProcessor;
                })();
                var GlyphInfo = (function () {
                  function GlyphInfo(font, id) {
                    var codePoints =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : [];
                    var features = arguments[3];
                    _classCallCheck(this, GlyphInfo);
                    this._font = font;
                    this.codePoints = codePoints;
                    this.id = id;
                    this.features = {};
                    if (Array.isArray(features)) {
                      for (var i = 0; i < features.length; i++) {
                        var feature = features[i];
                        this.features[feature] = true;
                      }
                    } else if (
                      (typeof features === "undefined"
                        ? "undefined"
                        : _typeof(features)) === "object"
                    ) {
                      _Object$assign(this.features, features);
                    }
                    this.ligatureID = null;
                    this.ligatureComponent = null;
                    this.isLigated = false;
                    this.cursiveAttachment = null;
                    this.markAttachment = null;
                    this.shaperInfo = null;
                    this.substituted = false;
                    this.isMultiplied = false;
                  }
                  GlyphInfo.prototype.copy = function copy() {
                    return new GlyphInfo(
                      this._font,
                      this.id,
                      this.codePoints,
                      this.features
                    );
                  };
                  _createClass(GlyphInfo, [
                    {
                      key: "id",
                      get: function get() {
                        return this._id;
                      },
                      set: function set(id) {
                        this._id = id;
                        this.substituted = true;
                        var GDEF = this._font.GDEF;
                        if (GDEF && GDEF.glyphClassDef) {
                          var classID = OTProcessor.prototype.getClassID(
                            id,
                            GDEF.glyphClassDef
                          );
                          this.isBase = classID === 1;
                          this.isLigature = classID === 2;
                          this.isMark = classID === 3;
                          this.markAttachmentType = GDEF.markAttachClassDef
                            ? OTProcessor.prototype.getClassID(
                                id,
                                GDEF.markAttachClassDef
                              )
                            : 0;
                        } else {
                          this.isMark =
                            this.codePoints.length > 0 &&
                            this.codePoints.every(unicode.isMark);
                          this.isBase = !this.isMark;
                          this.isLigature = this.codePoints.length > 1;
                          this.markAttachmentType = 0;
                        }
                      },
                    },
                  ]);
                  return GlyphInfo;
                })();
                var _class$5;
                var _temp$1;
                var HangulShaper =
                  ((_temp$1 = _class$5 =
                    (function (_DefaultShaper) {
                      _inherits(HangulShaper, _DefaultShaper);
                      function HangulShaper() {
                        _classCallCheck(this, HangulShaper);
                        return _possibleConstructorReturn(
                          this,
                          _DefaultShaper.apply(this, arguments)
                        );
                      }
                      HangulShaper.planFeatures = function planFeatures(plan) {
                        plan.add(["ljmo", "vjmo", "tjmo"], false);
                      };
                      HangulShaper.assignFeatures = function assignFeatures(
                        plan,
                        glyphs
                      ) {
                        var state = 0;
                        var i = 0;
                        while (i < glyphs.length) {
                          var action = void 0;
                          var glyph = glyphs[i];
                          var code = glyph.codePoints[0];
                          var type = getType(code);
                          var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
                          action = _STATE_TABLE$state$ty[0];
                          state = _STATE_TABLE$state$ty[1];
                          switch (action) {
                            case DECOMPOSE:
                              if (!plan.font.hasGlyphForCodePoint(code)) {
                                i = decompose(glyphs, i, plan.font);
                              }
                              break;
                            case COMPOSE:
                              i = compose(glyphs, i, plan.font);
                              break;
                            case TONE_MARK:
                              reorderToneMark(glyphs, i, plan.font);
                              break;
                            case INVALID:
                              i = insertDottedCircle(glyphs, i, plan.font);
                              break;
                          }
                          i++;
                        }
                      };
                      return HangulShaper;
                    })(DefaultShaper)),
                  (_class$5.zeroMarkWidths = "NONE"),
                  _temp$1);
                var HANGUL_BASE = 44032;
                var HANGUL_END = 55204;
                var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
                var L_BASE = 4352;
                var V_BASE = 4449;
                var T_BASE = 4519;
                var L_COUNT = 19;
                var V_COUNT = 21;
                var T_COUNT = 28;
                var L_END = L_BASE + L_COUNT - 1;
                var V_END = V_BASE + V_COUNT - 1;
                var T_END = T_BASE + T_COUNT - 1;
                var DOTTED_CIRCLE = 9676;
                var isL = function isL(code) {
                  return (
                    (4352 <= code && code <= 4447) ||
                    (43360 <= code && code <= 43388)
                  );
                };
                var isV = function isV(code) {
                  return (
                    (4448 <= code && code <= 4519) ||
                    (55216 <= code && code <= 55238)
                  );
                };
                var isT = function isT(code) {
                  return (
                    (4520 <= code && code <= 4607) ||
                    (55243 <= code && code <= 55291)
                  );
                };
                var isTone = function isTone(code) {
                  return 12334 <= code && code <= 12335;
                };
                var isLVT = function isLVT(code) {
                  return HANGUL_BASE <= code && code <= HANGUL_END;
                };
                var isLV = function isLV(code) {
                  return (
                    code - HANGUL_BASE < HANGUL_COUNT &&
                    (code - HANGUL_BASE) % T_COUNT === 0
                  );
                };
                var isCombiningL = function isCombiningL(code) {
                  return L_BASE <= code && code <= L_END;
                };
                var isCombiningV = function isCombiningV(code) {
                  return V_BASE <= code && code <= V_END;
                };
                var isCombiningT = function isCombiningT(code) {
                  return T_BASE + 1 && 1 <= code && code <= T_END;
                };
                var X = 0;
                var L = 1;
                var V = 2;
                var T = 3;
                var LV = 4;
                var LVT = 5;
                var M = 6;
                function getType(code) {
                  if (isL(code)) {
                    return L;
                  }
                  if (isV(code)) {
                    return V;
                  }
                  if (isT(code)) {
                    return T;
                  }
                  if (isLV(code)) {
                    return LV;
                  }
                  if (isLVT(code)) {
                    return LVT;
                  }
                  if (isTone(code)) {
                    return M;
                  }
                  return X;
                }
                var NO_ACTION = 0;
                var DECOMPOSE = 1;
                var COMPOSE = 2;
                var TONE_MARK = 4;
                var INVALID = 5;
                var STATE_TABLE$1 = [
                  [
                    [NO_ACTION, 0],
                    [NO_ACTION, 1],
                    [NO_ACTION, 0],
                    [NO_ACTION, 0],
                    [DECOMPOSE, 2],
                    [DECOMPOSE, 3],
                    [INVALID, 0],
                  ],
                  [
                    [NO_ACTION, 0],
                    [NO_ACTION, 1],
                    [COMPOSE, 2],
                    [NO_ACTION, 0],
                    [DECOMPOSE, 2],
                    [DECOMPOSE, 3],
                    [INVALID, 0],
                  ],
                  [
                    [NO_ACTION, 0],
                    [NO_ACTION, 1],
                    [NO_ACTION, 0],
                    [COMPOSE, 3],
                    [DECOMPOSE, 2],
                    [DECOMPOSE, 3],
                    [TONE_MARK, 0],
                  ],
                  [
                    [NO_ACTION, 0],
                    [NO_ACTION, 1],
                    [NO_ACTION, 0],
                    [NO_ACTION, 0],
                    [DECOMPOSE, 2],
                    [DECOMPOSE, 3],
                    [TONE_MARK, 0],
                  ],
                ];
                function getGlyph(font, code, features) {
                  return new GlyphInfo(
                    font,
                    font.glyphForCodePoint(code).id,
                    [code],
                    features
                  );
                }
                function decompose(glyphs, i, font) {
                  var glyph = glyphs[i];
                  var code = glyph.codePoints[0];
                  var s = code - HANGUL_BASE;
                  var t = T_BASE + (s % T_COUNT);
                  s = (s / T_COUNT) | 0;
                  var l = (L_BASE + s / V_COUNT) | 0;
                  var v = V_BASE + (s % V_COUNT);
                  if (
                    !font.hasGlyphForCodePoint(l) ||
                    !font.hasGlyphForCodePoint(v) ||
                    (t !== T_BASE && !font.hasGlyphForCodePoint(t))
                  ) {
                    return i;
                  }
                  var ljmo = getGlyph(font, l, glyph.features);
                  ljmo.features.ljmo = true;
                  var vjmo = getGlyph(font, v, glyph.features);
                  vjmo.features.vjmo = true;
                  var insert = [ljmo, vjmo];
                  if (t > T_BASE) {
                    var tjmo = getGlyph(font, t, glyph.features);
                    tjmo.features.tjmo = true;
                    insert.push(tjmo);
                  }
                  glyphs.splice.apply(glyphs, [i, 1].concat(insert));
                  return i + insert.length - 1;
                }
                function compose(glyphs, i, font) {
                  var glyph = glyphs[i];
                  var code = glyphs[i].codePoints[0];
                  var type = getType(code);
                  var prev = glyphs[i - 1].codePoints[0];
                  var prevType = getType(prev);
                  var lv = void 0,
                    ljmo = void 0,
                    vjmo = void 0,
                    tjmo = void 0;
                  if (prevType === LV && type === T) {
                    lv = prev;
                    tjmo = glyph;
                  } else {
                    if (type === V) {
                      ljmo = glyphs[i - 1];
                      vjmo = glyph;
                    } else {
                      ljmo = glyphs[i - 2];
                      vjmo = glyphs[i - 1];
                      tjmo = glyph;
                    }
                    var l = ljmo.codePoints[0];
                    var v = vjmo.codePoints[0];
                    if (isCombiningL(l) && isCombiningV(v)) {
                      lv =
                        HANGUL_BASE +
                        ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
                    }
                  }
                  var t = (tjmo && tjmo.codePoints[0]) || T_BASE;
                  if (lv != null && (t === T_BASE || isCombiningT(t))) {
                    var s = lv + (t - T_BASE);
                    if (font.hasGlyphForCodePoint(s)) {
                      var del = prevType === V ? 3 : 2;
                      glyphs.splice(
                        i - del + 1,
                        del,
                        getGlyph(font, s, glyph.features)
                      );
                      return i - del + 1;
                    }
                  }
                  if (ljmo) {
                    ljmo.features.ljmo = true;
                  }
                  if (vjmo) {
                    vjmo.features.vjmo = true;
                  }
                  if (tjmo) {
                    tjmo.features.tjmo = true;
                  }
                  if (prevType === LV) {
                    decompose(glyphs, i - 1, font);
                    return i + 1;
                  }
                  return i;
                }
                function getLength(code) {
                  switch (getType(code)) {
                    case LV:
                    case LVT:
                      return 1;
                    case V:
                      return 2;
                    case T:
                      return 3;
                  }
                }
                function reorderToneMark(glyphs, i, font) {
                  var glyph = glyphs[i];
                  var code = glyphs[i].codePoints[0];
                  if (font.glyphForCodePoint(code).advanceWidth === 0) {
                    return;
                  }
                  var prev = glyphs[i - 1].codePoints[0];
                  var len = getLength(prev);
                  glyphs.splice(i, 1);
                  return glyphs.splice(i - len, 0, glyph);
                }
                function insertDottedCircle(glyphs, i, font) {
                  var glyph = glyphs[i];
                  var code = glyphs[i].codePoints[0];
                  if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
                    var dottedCircle = getGlyph(
                      font,
                      DOTTED_CIRCLE,
                      glyph.features
                    );
                    var idx =
                      font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
                    glyphs.splice(idx, 0, dottedCircle);
                    i++;
                  }
                  return i;
                }
                var stateTable = [
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16,
                    17,
                  ],
                  [
                    0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0,
                    37, 0,
                  ],
                  [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0],
                  [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0],
                  [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0],
                  [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0],
                  [
                    0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0,
                    62, 0,
                  ],
                  [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0],
                  [
                    0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0,
                    0,
                  ],
                  [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0],
                  [
                    0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0,
                    27, 0,
                  ],
                  [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0],
                  [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27,
                    0,
                  ],
                  [
                    0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27,
                    0,
                  ],
                  [
                    0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37,
                    0,
                  ],
                  [
                    0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37,
                    0,
                  ],
                  [
                    0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0],
                  [
                    0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0],
                  [
                    0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39,
                    0, 0,
                  ],
                  [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0],
                  [
                    0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0,
                    62, 0,
                  ],
                  [
                    0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62,
                    0,
                  ],
                  [
                    0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    150, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0,
                    75, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0],
                  [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0],
                  [
                    0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27,
                    0,
                  ],
                  [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0],
                  [
                    0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75,
                    0, 0,
                  ],
                  [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0],
                  [
                    0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0,
                    0, 27, 0,
                  ],
                  [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96,
                    0, 0,
                  ],
                  [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0],
                  [
                    0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0,
                    0, 37, 0,
                  ],
                  [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62,
                    0,
                  ],
                  [
                    0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0,
                    136, 0, 0,
                  ],
                  [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0],
                  [
                    0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    249, 0, 0,
                  ],
                  [
                    0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0,
                    75, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0],
                  [
                    0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223,
                    0, 0,
                  ],
                  [
                    0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0],
                  [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    340, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    136, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0,
                    0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362,
                    0, 0, 0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120,
                    0, 0, 16, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0,
                    279, 0, 0,
                  ],
                  [
                    0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0],
                  [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0,
                    37, 0,
                  ],
                  [
                    0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0,
                    299, 0, 0,
                  ],
                  [
                    0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0],
                  [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410,
                    0, 0,
                  ],
                  [
                    0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223,
                    0, 0,
                  ],
                  [
                    0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0,
                    16, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0],
                  [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0,
                    62, 0,
                  ],
                  [
                    0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0,
                    337, 0, 0,
                  ],
                  [
                    0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0],
                  [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120,
                    0, 0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0,
                    0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362,
                    0, 0, 0, 0,
                  ],
                  [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120,
                    0, 0, 16, 0,
                  ],
                  [
                    0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451,
                    0, 0,
                  ],
                  [
                    0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279,
                    0, 0,
                  ],
                  [
                    0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0,
                    279, 0, 0,
                  ],
                  [
                    0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0,
                    0, 27, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0],
                  [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460,
                    0, 0,
                  ],
                  [
                    0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299,
                    0, 0,
                  ],
                  [
                    0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0,
                    299, 0, 0,
                  ],
                  [
                    0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0,
                    0, 37, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0],
                  [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0,
                    0,
                  ],
                  [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0,
                    16, 0,
                  ],
                  [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0],
                  [
                    0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407,
                    0, 0,
                  ],
                  [
                    0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0],
                  [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    482, 0, 0,
                  ],
                  [
                    0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337,
                    0, 0,
                  ],
                  [
                    0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    337, 0, 0,
                  ],
                  [
                    0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0],
                  [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120,
                    0, 0, 16, 0,
                  ],
                  [
                    0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0,
                    0, 16, 0,
                  ],
                  [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0,
                    0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362,
                    0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0,
                    448, 0, 0,
                  ],
                  [
                    0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0,
                    0, 27, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0],
                  [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0,
                    37, 0,
                  ],
                  [
                    0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0,
                    457, 0, 0,
                  ],
                  [
                    0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0,
                    0, 37, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0],
                  [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530,
                    0, 0,
                  ],
                  [
                    0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407,
                    0, 0,
                  ],
                  [
                    0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0,
                    0, 16, 0,
                  ],
                  [
                    0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0,
                    16, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0],
                  [
                    0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0,
                    62, 0,
                  ],
                  [
                    0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0,
                    479, 0, 0,
                  ],
                  [
                    0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0],
                  [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0],
                  [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0,
                    0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0,
                    0, 0, 0,
                  ],
                  [
                    0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556,
                    0, 0,
                  ],
                  [
                    0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448,
                    0, 0,
                  ],
                  [
                    0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0,
                    448, 0, 0,
                  ],
                  [
                    0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0,
                    0, 27, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0],
                  [
                    0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562,
                    0, 0,
                  ],
                  [
                    0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457,
                    0, 0,
                  ],
                  [
                    0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0,
                    457, 0, 0,
                  ],
                  [
                    0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0,
                    0, 37, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0],
                  [
                    0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0,
                    16, 0,
                  ],
                  [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0],
                  [
                    0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527,
                    0, 0,
                  ],
                  [
                    0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    578, 0, 0,
                  ],
                  [
                    0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479,
                    0, 0,
                  ],
                  [
                    0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    479, 0, 0,
                  ],
                  [
                    0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0],
                  [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0,
                    0, 0,
                  ],
                  [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0,
                    553, 0, 0,
                  ],
                  [
                    0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0,
                    0, 27, 0,
                  ],
                  [
                    0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0,
                    37, 0,
                  ],
                  [
                    0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0,
                    559, 0, 0,
                  ],
                  [
                    0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16,
                    0,
                  ],
                  [
                    0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527,
                    0, 0,
                  ],
                  [
                    0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0,
                    16, 0,
                  ],
                  [
                    0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0,
                    62, 0,
                  ],
                  [
                    0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0,
                    575, 0, 0,
                  ],
                  [
                    0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0],
                  [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                  [
                    0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553,
                    0, 0,
                  ],
                  [
                    0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0,
                    553, 0, 0,
                  ],
                  [
                    0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0,
                    27, 0,
                  ],
                  [
                    0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559,
                    0, 0,
                  ],
                  [
                    0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0,
                    559, 0, 0,
                  ],
                  [
                    0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0,
                    0, 37, 0,
                  ],
                  [
                    0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0,
                    0, 37, 0,
                  ],
                  [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0],
                  [
                    0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575,
                    0, 0,
                  ],
                  [
                    0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0,
                    575, 0, 0,
                  ],
                  [
                    0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0,
                    0, 0,
                  ],
                  [
                    0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0,
                    0, 62, 0,
                  ],
                  [
                    0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0,
                    0, 62, 0,
                  ],
                  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0],
                  [
                    0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0,
                    37, 0,
                  ],
                  [
                    0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0,
                    62, 0,
                  ],
                ];
                var accepting = [
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  false,
                  false,
                  false,
                  false,
                  true,
                  true,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  false,
                  false,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                ];
                var tags = [
                  [],
                  ["broken_cluster"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["consonant_syllable"],
                  ["broken_cluster"],
                  ["symbol_cluster"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["symbol_cluster"],
                  [],
                  ["symbol_cluster"],
                  ["symbol_cluster"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["symbol_cluster"],
                  ["symbol_cluster"],
                  ["symbol_cluster"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["broken_cluster"],
                  ["symbol_cluster"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  [],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  [],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  [],
                  [],
                  ["broken_cluster"],
                  [],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  [],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  [],
                  [],
                  ["vowel_syllable"],
                  [],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  [],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  [],
                  ["standalone_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  [],
                  [],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  [],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  [],
                  [],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  [],
                  [],
                  ["consonant_syllable", "broken_cluster"],
                  ["consonant_syllable", "broken_cluster"],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  [],
                  [],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  [],
                  ["consonant_syllable"],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  [],
                  ["vowel_syllable"],
                  ["vowel_syllable"],
                  ["broken_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["standalone_cluster"],
                  ["standalone_cluster"],
                  [],
                  ["consonant_syllable"],
                  ["vowel_syllable"],
                  ["standalone_cluster"],
                ];
                var indicMachine = {
                  stateTable: stateTable,
                  accepting: accepting,
                  tags: tags,
                };
                var categories = [
                  "O",
                  "IND",
                  "S",
                  "GB",
                  "B",
                  "FM",
                  "CGJ",
                  "VMAbv",
                  "VMPst",
                  "VAbv",
                  "VPst",
                  "CMBlw",
                  "VPre",
                  "VBlw",
                  "H",
                  "VMBlw",
                  "CMAbv",
                  "MBlw",
                  "CS",
                  "R",
                  "SUB",
                  "MPst",
                  "MPre",
                  "FAbv",
                  "FPst",
                  "FBlw",
                  "null",
                  "SMAbv",
                  "SMBlw",
                  "VMPre",
                  "ZWNJ",
                  "ZWJ",
                  "WJ",
                  "M",
                  "VS",
                  "N",
                  "HN",
                  "MAbv",
                ];
                var decompositions$1 = {
                  2507: [2503, 2494],
                  2508: [2503, 2519],
                  2888: [2887, 2902],
                  2891: [2887, 2878],
                  2892: [2887, 2903],
                  3018: [3014, 3006],
                  3019: [3015, 3006],
                  3020: [3014, 3031],
                  3144: [3142, 3158],
                  3264: [3263, 3285],
                  3271: [3270, 3285],
                  3272: [3270, 3286],
                  3274: [3270, 3266],
                  3275: [3270, 3266, 3285],
                  3402: [3398, 3390],
                  3403: [3399, 3390],
                  3404: [3398, 3415],
                  3546: [3545, 3530],
                  3548: [3545, 3535],
                  3549: [3545, 3535, 3530],
                  3550: [3545, 3551],
                  3635: [3661, 3634],
                  3763: [3789, 3762],
                  3955: [3953, 3954],
                  3957: [3953, 3956],
                  3958: [4018, 3968],
                  3959: [4018, 3953, 3968],
                  3960: [4019, 3968],
                  3961: [4019, 3953, 3968],
                  3969: [3953, 3968],
                  6971: [6970, 6965],
                  6973: [6972, 6965],
                  6976: [6974, 6965],
                  6977: [6975, 6965],
                  6979: [6978, 6965],
                  69934: [69937, 69927],
                  69935: [69938, 69927],
                  70475: [70471, 70462],
                  70476: [70471, 70487],
                  70843: [70841, 70842],
                  70844: [70841, 70832],
                  70846: [70841, 70845],
                  71098: [71096, 71087],
                  71099: [71097, 71087],
                };
                var stateTable$1 = [
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                    0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 2, 0, 0, 24,
                    0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 27, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 39,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0,
                    0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0,
                    25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                    0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0,
                    0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0,
                    0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                    0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0,
                    0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16,
                    0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 49, 0,
                    0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0,
                    0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0,
                    0, 0, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0,
                    0, 0, 11, 0, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0,
                    0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0,
                    0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0,
                    0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0,
                    0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0,
                    0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0,
                    0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0,
                    0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 53,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40,
                    0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0,
                    47,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0,
                    0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40,
                    0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0,
                    0,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0,
                    0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0,
                    25,
                  ],
                  [
                    0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16,
                    0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0,
                    0, 25,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52,
                    40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 0, 46, 0, 0, 0, 0, 0,
                    0, 0, 47,
                  ],
                  [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0,
                  ],
                ];
                var accepting$1 = [
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  false,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                  true,
                ];
                var tags$1 = [
                  [],
                  ["broken_cluster"],
                  ["independent_cluster"],
                  ["symbol_cluster"],
                  ["standard_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  [],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["numeral_cluster"],
                  ["broken_cluster"],
                  ["independent_cluster"],
                  ["symbol_cluster"],
                  ["symbol_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["virama_terminated_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["broken_cluster"],
                  ["broken_cluster"],
                  ["numeral_cluster"],
                  ["number_joiner_terminated_cluster"],
                  ["standard_cluster"],
                  ["standard_cluster"],
                  ["numeral_cluster"],
                ];
                var useData = {
                  categories: categories,
                  decompositions: decompositions$1,
                  stateTable: stateTable$1,
                  accepting: accepting$1,
                  tags: tags$1,
                };
                var CATEGORIES = {
                  X: 1 << 0,
                  C: 1 << 1,
                  V: 1 << 2,
                  N: 1 << 3,
                  H: 1 << 4,
                  ZWNJ: 1 << 5,
                  ZWJ: 1 << 6,
                  M: 1 << 7,
                  SM: 1 << 8,
                  VD: 1 << 9,
                  A: 1 << 10,
                  Placeholder: 1 << 11,
                  Dotted_Circle: 1 << 12,
                  RS: 1 << 13,
                  Coeng: 1 << 14,
                  Repha: 1 << 15,
                  Ra: 1 << 16,
                  CM: 1 << 17,
                  Symbol: 1 << 18,
                };
                var POSITIONS = {
                  Start: 1 << 0,
                  Ra_To_Become_Reph: 1 << 1,
                  Pre_M: 1 << 2,
                  Pre_C: 1 << 3,
                  Base_C: 1 << 4,
                  After_Main: 1 << 5,
                  Above_C: 1 << 6,
                  Before_Sub: 1 << 7,
                  Below_C: 1 << 8,
                  After_Sub: 1 << 9,
                  Before_Post: 1 << 10,
                  Post_C: 1 << 11,
                  After_Post: 1 << 12,
                  Final_C: 1 << 13,
                  SMVD: 1 << 14,
                  End: 1 << 15,
                };
                var CONSONANT_FLAGS =
                  CATEGORIES.C |
                  CATEGORIES.Ra |
                  CATEGORIES.CM |
                  CATEGORIES.V |
                  CATEGORIES.Placeholder |
                  CATEGORIES.Dotted_Circle;
                var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
                var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
                var INDIC_CONFIGS = {
                  Default: {
                    hasOldSpec: false,
                    virama: 0,
                    basePos: "Last",
                    rephPos: POSITIONS.Before_Post,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Devanagari: {
                    hasOldSpec: true,
                    virama: 2381,
                    basePos: "Last",
                    rephPos: POSITIONS.Before_Post,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Bengali: {
                    hasOldSpec: true,
                    virama: 2509,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Sub,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Gurmukhi: {
                    hasOldSpec: true,
                    virama: 2637,
                    basePos: "Last",
                    rephPos: POSITIONS.Before_Sub,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Gujarati: {
                    hasOldSpec: true,
                    virama: 2765,
                    basePos: "Last",
                    rephPos: POSITIONS.Before_Post,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Oriya: {
                    hasOldSpec: true,
                    virama: 2893,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Main,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Tamil: {
                    hasOldSpec: true,
                    virama: 3021,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Post,
                    rephMode: "Implicit",
                    blwfMode: "Pre_And_Post",
                  },
                  Telugu: {
                    hasOldSpec: true,
                    virama: 3149,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Post,
                    rephMode: "Explicit",
                    blwfMode: "Post_Only",
                  },
                  Kannada: {
                    hasOldSpec: true,
                    virama: 3277,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Post,
                    rephMode: "Implicit",
                    blwfMode: "Post_Only",
                  },
                  Malayalam: {
                    hasOldSpec: true,
                    virama: 3405,
                    basePos: "Last",
                    rephPos: POSITIONS.After_Main,
                    rephMode: "Log_Repha",
                    blwfMode: "Pre_And_Post",
                  },
                  Khmer: {
                    hasOldSpec: false,
                    virama: 6098,
                    basePos: "First",
                    rephPos: POSITIONS.Ra_To_Become_Reph,
                    rephMode: "Vis_Repha",
                    blwfMode: "Pre_And_Post",
                  },
                };
                var INDIC_DECOMPOSITIONS = {
                  6078: [6081, 6078],
                  6079: [6081, 6079],
                  6080: [6081, 6080],
                  6084: [6081, 6084],
                  6085: [6081, 6085],
                };
                var _class$6;
                var _temp$2;
                var decompositions = useData.decompositions;
                var trie$1 = new UnicodeTrie(
                  Buffer(
                    "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",
                    "base64"
                  )
                );
                var stateMachine = new StateMachine(indicMachine);
                var IndicShaper =
                  ((_temp$2 = _class$6 =
                    (function (_DefaultShaper) {
                      _inherits(IndicShaper, _DefaultShaper);
                      function IndicShaper() {
                        _classCallCheck(this, IndicShaper);
                        return _possibleConstructorReturn(
                          this,
                          _DefaultShaper.apply(this, arguments)
                        );
                      }
                      IndicShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables);
                        plan.addStage(["locl", "ccmp"]);
                        plan.addStage(initialReordering);
                        plan.addStage("nukt");
                        plan.addStage("akhn");
                        plan.addStage("rphf", false);
                        plan.addStage("rkrf");
                        plan.addStage("pref", false);
                        plan.addStage("blwf", false);
                        plan.addStage("abvf", false);
                        plan.addStage("half", false);
                        plan.addStage("pstf", false);
                        plan.addStage("vatu");
                        plan.addStage("cjct");
                        plan.addStage("cfar", false);
                        plan.addStage(finalReordering);
                        plan.addStage({
                          local: ["init"],
                          global: [
                            "pres",
                            "abvs",
                            "blws",
                            "psts",
                            "haln",
                            "dist",
                            "abvm",
                            "blwm",
                            "calt",
                            "clig",
                          ],
                        });
                        plan.unicodeScript = fromOpenType(plan.script);
                        plan.indicConfig =
                          INDIC_CONFIGS[plan.unicodeScript] ||
                          INDIC_CONFIGS.Default;
                        plan.isOldSpec =
                          plan.indicConfig.hasOldSpec &&
                          plan.script[plan.script.length - 1] !== "2";
                      };
                      IndicShaper.assignFeatures = function assignFeatures(
                        plan,
                        glyphs
                      ) {
                        var _loop = function _loop(i) {
                          var codepoint = glyphs[i].codePoints[0];
                          var d =
                            INDIC_DECOMPOSITIONS[codepoint] ||
                            decompositions[codepoint];
                          if (d) {
                            var decomposed = d.map(function (c) {
                              var g = plan.font.glyphForCodePoint(c);
                              return new GlyphInfo(
                                plan.font,
                                g.id,
                                [c],
                                glyphs[i].features
                              );
                            });
                            glyphs.splice.apply(
                              glyphs,
                              [i, 1].concat(decomposed)
                            );
                          }
                        };
                        for (var i = glyphs.length - 1; i >= 0; i--) {
                          _loop(i);
                        }
                      };
                      return IndicShaper;
                    })(DefaultShaper)),
                  (_class$6.zeroMarkWidths = "NONE"),
                  _temp$2);
                function indicCategory(glyph) {
                  return trie$1.get(glyph.codePoints[0]) >> 8;
                }
                function indicPosition(glyph) {
                  return 1 << (trie$1.get(glyph.codePoints[0]) & 255);
                }
                var IndicInfo = function IndicInfo(
                  category,
                  position,
                  syllableType,
                  syllable
                ) {
                  _classCallCheck(this, IndicInfo);
                  this.category = category;
                  this.position = position;
                  this.syllableType = syllableType;
                  this.syllable = syllable;
                };
                function setupSyllables(font, glyphs) {
                  var syllable = 0;
                  var last = 0;
                  for (
                    var _iterator = stateMachine.match(glyphs.map(indicCategory)),
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var _ref2 = _ref,
                      start = _ref2[0],
                      end = _ref2[1],
                      tags = _ref2[2];
                    if (start > last) {
                      ++syllable;
                      for (var _i2 = last; _i2 < start; _i2++) {
                        glyphs[_i2].shaperInfo = new IndicInfo(
                          CATEGORIES.X,
                          POSITIONS.End,
                          "non_indic_cluster",
                          syllable
                        );
                      }
                    }
                    ++syllable;
                    for (var _i3 = start; _i3 <= end; _i3++) {
                      glyphs[_i3].shaperInfo = new IndicInfo(
                        1 << indicCategory(glyphs[_i3]),
                        indicPosition(glyphs[_i3]),
                        tags[0],
                        syllable
                      );
                    }
                    last = end + 1;
                  }
                  if (last < glyphs.length) {
                    ++syllable;
                    for (var i = last; i < glyphs.length; i++) {
                      glyphs[i].shaperInfo = new IndicInfo(
                        CATEGORIES.X,
                        POSITIONS.End,
                        "non_indic_cluster",
                        syllable
                      );
                    }
                  }
                }
                function isConsonant(glyph) {
                  return glyph.shaperInfo.category & CONSONANT_FLAGS;
                }
                function isJoiner(glyph) {
                  return glyph.shaperInfo.category & JOINER_FLAGS;
                }
                function isHalantOrCoeng(glyph) {
                  return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
                }
                function wouldSubstitute(glyphs, feature) {
                  for (
                    var _iterator2 = glyphs,
                      _isArray2 = Array.isArray(_iterator2),
                      _i4 = 0,
                      _iterator2 = _isArray2
                        ? _iterator2
                        : _getIterator(_iterator2);
                    ;
  
                  ) {
                    var _glyph$features;
                    var _ref3;
                    if (_isArray2) {
                      if (_i4 >= _iterator2.length) break;
                      _ref3 = _iterator2[_i4++];
                    } else {
                      _i4 = _iterator2.next();
                      if (_i4.done) break;
                      _ref3 = _i4.value;
                    }
                    var glyph = _ref3;
                    glyph.features =
                      ((_glyph$features = {}),
                      (_glyph$features[feature] = true),
                      _glyph$features);
                  }
                  var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
                  GSUB.applyFeatures([feature], glyphs);
                  return glyphs.length === 1;
                }
                function consonantPosition(font, consonant, virama) {
                  var glyphs = [virama, consonant, virama];
                  if (
                    wouldSubstitute(glyphs.slice(0, 2), "blwf") ||
                    wouldSubstitute(glyphs.slice(1, 3), "blwf")
                  ) {
                    return POSITIONS.Below_C;
                  } else if (
                    wouldSubstitute(glyphs.slice(0, 2), "pstf") ||
                    wouldSubstitute(glyphs.slice(1, 3), "pstf")
                  ) {
                    return POSITIONS.Post_C;
                  } else if (
                    wouldSubstitute(glyphs.slice(0, 2), "pref") ||
                    wouldSubstitute(glyphs.slice(1, 3), "pref")
                  ) {
                    return POSITIONS.Post_C;
                  }
                  return POSITIONS.Base_C;
                }
                function initialReordering(font, glyphs, plan) {
                  var indicConfig = plan.indicConfig;
                  var features = font._layoutEngine.engine.GSUBProcessor.features;
                  var dottedCircle = font.glyphForCodePoint(9676).id;
                  var virama = font.glyphForCodePoint(indicConfig.virama).id;
                  if (virama) {
                    var info = new GlyphInfo(font, virama, [indicConfig.virama]);
                    for (var i = 0; i < glyphs.length; i++) {
                      if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
                        glyphs[i].shaperInfo.position = consonantPosition(
                          font,
                          glyphs[i].copy(),
                          info
                        );
                      }
                    }
                  }
                  for (
                    var start = 0, end = nextSyllable(glyphs, 0);
                    start < glyphs.length;
                    start = end, end = nextSyllable(glyphs, start)
                  ) {
                    var _glyphs$start$shaperI = glyphs[start].shaperInfo,
                      category = _glyphs$start$shaperI.category,
                      syllableType = _glyphs$start$shaperI.syllableType;
                    if (
                      syllableType === "symbol_cluster" ||
                      syllableType === "non_indic_cluster"
                    ) {
                      continue;
                    }
                    if (syllableType === "broken_cluster" && dottedCircle) {
                      var g = new GlyphInfo(font, dottedCircle, [9676]);
                      g.shaperInfo = new IndicInfo(
                        1 << indicCategory(g),
                        indicPosition(g),
                        glyphs[start].shaperInfo.syllableType,
                        glyphs[start].shaperInfo.syllable
                      );
                      var _i5 = start;
                      while (
                        _i5 < end &&
                        glyphs[_i5].shaperInfo.category === CATEGORIES.Repha
                      ) {
                        _i5++;
                      }
                      glyphs.splice(_i5++, 0, g);
                      end++;
                    }
                    var base = end;
                    var limit = start;
                    var hasReph = false;
                    if (
                      indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph &&
                      features.rphf &&
                      start + 3 <= end &&
                      ((indicConfig.rephMode === "Implicit" &&
                        !isJoiner(glyphs[start + 2])) ||
                        (indicConfig.rephMode === "Explicit" &&
                          glyphs[start + 2].shaperInfo.category ===
                            CATEGORIES.ZWJ))
                    ) {
                      var _g = [
                        glyphs[start].copy(),
                        glyphs[start + 1].copy(),
                        glyphs[start + 2].copy(),
                      ];
                      if (
                        wouldSubstitute(_g.slice(0, 2), "rphf") ||
                        (indicConfig.rephMode === "Explicit" &&
                          wouldSubstitute(_g, "rphf"))
                      ) {
                        limit += 2;
                        while (limit < end && isJoiner(glyphs[limit])) {
                          limit++;
                        }
                        base = start;
                        hasReph = true;
                      }
                    } else if (
                      indicConfig.rephMode === "Log_Repha" &&
                      glyphs[start].shaperInfo.category === CATEGORIES.Repha
                    ) {
                      limit++;
                      while (limit < end && isJoiner(glyphs[limit])) {
                        limit++;
                      }
                      base = start;
                      hasReph = true;
                    }
                    switch (indicConfig.basePos) {
                      case "Last": {
                        var _i6 = end;
                        var seenBelow = false;
                        do {
                          var _info = glyphs[--_i6].shaperInfo;
                          if (isConsonant(glyphs[_i6])) {
                            if (
                              _info.position !== POSITIONS.Below_C &&
                              (_info.position !== POSITIONS.Post_C || seenBelow)
                            ) {
                              base = _i6;
                              break;
                            }
                            if (_info.position === POSITIONS.Below_C) {
                              seenBelow = true;
                            }
                            base = _i6;
                          } else if (
                            start < _i6 &&
                            _info.category === CATEGORIES.ZWJ &&
                            glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H
                          ) {
                            break;
                          }
                        } while (_i6 > limit);
                        break;
                      }
                      case "First": {
                        base = start;
                        for (var _i7 = base + 1; _i7 < end; _i7++) {
                          if (isConsonant(glyphs[_i7])) {
                            glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
                          }
                        }
                      }
                    }
                    if (hasReph && base === start && limit - base <= 2) {
                      hasReph = false;
                    }
                    for (var _i8 = start; _i8 < base; _i8++) {
                      var _info2 = glyphs[_i8].shaperInfo;
                      _info2.position = Math.min(
                        POSITIONS.Pre_C,
                        _info2.position
                      );
                    }
                    if (base < end) {
                      glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                    }
                    for (var _i9 = base + 1; _i9 < end; _i9++) {
                      if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
                        for (var j = _i9 + 1; j < end; j++) {
                          if (isConsonant(glyphs[j])) {
                            glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                            break;
                          }
                        }
                        break;
                      }
                    }
                    if (hasReph) {
                      glyphs[start].shaperInfo.position =
                        POSITIONS.Ra_To_Become_Reph;
                    }
                    if (plan.isOldSpec) {
                      var disallowDoubleHalants =
                        plan.unicodeScript !== "Malayalam";
                      for (var _i10 = base + 1; _i10 < end; _i10++) {
                        if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
                          var _j = void 0;
                          for (_j = end - 1; _j > _i10; _j--) {
                            if (
                              isConsonant(glyphs[_j]) ||
                              (disallowDoubleHalants &&
                                glyphs[_j].shaperInfo.category === CATEGORIES.H)
                            ) {
                              break;
                            }
                          }
                          if (
                            glyphs[_j].shaperInfo.category !== CATEGORIES.H &&
                            _j > _i10
                          ) {
                            var t = glyphs[_i10];
                            glyphs.splice.apply(
                              glyphs,
                              [_i10, 0].concat(glyphs.splice(_i10 + 1, _j - _i10))
                            );
                            glyphs[_j] = t;
                          }
                          break;
                        }
                      }
                    }
                    var lastPos = POSITIONS.Start;
                    for (var _i11 = start; _i11 < end; _i11++) {
                      var _info3 = glyphs[_i11].shaperInfo;
                      if (
                        _info3.category &
                        (JOINER_FLAGS |
                          CATEGORIES.N |
                          CATEGORIES.RS |
                          CATEGORIES.CM |
                          (HALANT_OR_COENG_FLAGS & _info3.category))
                      ) {
                        _info3.position = lastPos;
                        if (
                          _info3.category === CATEGORIES.H &&
                          _info3.position === POSITIONS.Pre_M
                        ) {
                          for (var _j2 = _i11; _j2 > start; _j2--) {
                            if (
                              glyphs[_j2 - 1].shaperInfo.position !==
                              POSITIONS.Pre_M
                            ) {
                              _info3.position =
                                glyphs[_j2 - 1].shaperInfo.position;
                              break;
                            }
                          }
                        }
                      } else if (_info3.position !== POSITIONS.SMVD) {
                        lastPos = _info3.position;
                      }
                    }
                    var last = base;
                    for (var _i12 = base + 1; _i12 < end; _i12++) {
                      if (isConsonant(glyphs[_i12])) {
                        for (var _j3 = last + 1; _j3 < _i12; _j3++) {
                          if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
                            glyphs[_j3].shaperInfo.position =
                              glyphs[_i12].shaperInfo.position;
                          }
                        }
                        last = _i12;
                      } else if (
                        glyphs[_i12].shaperInfo.category === CATEGORIES.M
                      ) {
                        last = _i12;
                      }
                    }
                    var arr = glyphs.slice(start, end);
                    arr.sort(function (a, b) {
                      return a.shaperInfo.position - b.shaperInfo.position;
                    });
                    glyphs.splice.apply(glyphs, [start, arr.length].concat(arr));
                    for (var _i13 = start; _i13 < end; _i13++) {
                      if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
                        base = _i13;
                        break;
                      }
                    }
                    for (
                      var _i14 = start;
                      _i14 < end &&
                      glyphs[_i14].shaperInfo.position ===
                        POSITIONS.Ra_To_Become_Reph;
                      _i14++
                    ) {
                      glyphs[_i14].features.rphf = true;
                    }
                    var blwf =
                      !plan.isOldSpec && indicConfig.blwfMode === "Pre_And_Post";
                    for (var _i15 = start; _i15 < base; _i15++) {
                      glyphs[_i15].features.half = true;
                      if (blwf) {
                        glyphs[_i15].features.blwf = true;
                      }
                    }
                    for (var _i16 = base + 1; _i16 < end; _i16++) {
                      glyphs[_i16].features.abvf = true;
                      glyphs[_i16].features.pstf = true;
                      glyphs[_i16].features.blwf = true;
                    }
                    if (plan.isOldSpec && plan.unicodeScript === "Devanagari") {
                      for (var _i17 = start; _i17 + 1 < base; _i17++) {
                        if (
                          glyphs[_i17].shaperInfo.category === CATEGORIES.Ra &&
                          glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H &&
                          (_i17 + 1 === base ||
                            glyphs[_i17 + 2].shaperInfo.category ===
                              CATEGORIES.ZWJ)
                        ) {
                          glyphs[_i17].features.blwf = true;
                          glyphs[_i17 + 1].features.blwf = true;
                        }
                      }
                    }
                    var prefLen = 2;
                    if (features.pref && base + prefLen < end) {
                      for (
                        var _i18 = base + 1;
                        _i18 + prefLen - 1 < end;
                        _i18++
                      ) {
                        var _g2 = [glyphs[_i18].copy(), glyphs[_i18 + 1].copy()];
                        if (wouldSubstitute(_g2, "pref")) {
                          for (var _j4 = 0; _j4 < prefLen; _j4++) {
                            glyphs[_i18++].features.pref = true;
                          }
                          if (features.cfar) {
                            for (; _i18 < end; _i18++) {
                              glyphs[_i18].features.cfar = true;
                            }
                          }
                          break;
                        }
                      }
                    }
                    for (var _i19 = start + 1; _i19 < end; _i19++) {
                      if (isJoiner(glyphs[_i19])) {
                        var nonJoiner =
                          glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
                        var _j5 = _i19;
                        do {
                          _j5--;
                          if (nonJoiner) {
                            delete glyphs[_j5].features.half;
                          }
                        } while (_j5 > start && !isConsonant(glyphs[_j5]));
                      }
                    }
                  }
                }
                function finalReordering(font, glyphs, plan) {
                  var indicConfig = plan.indicConfig;
                  var features = font._layoutEngine.engine.GSUBProcessor.features;
                  for (
                    var start = 0, end = nextSyllable(glyphs, 0);
                    start < glyphs.length;
                    start = end, end = nextSyllable(glyphs, start)
                  ) {
                    var tryPref = !!features.pref;
                    var base = start;
                    for (; base < end; base++) {
                      if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
                        if (tryPref && base + 1 < end) {
                          for (var i = base + 1; i < end; i++) {
                            if (glyphs[i].features.pref) {
                              if (
                                !(
                                  glyphs[i].substituted &&
                                  glyphs[i].isLigated &&
                                  !glyphs[i].isMultiplied
                                )
                              ) {
                                base = i;
                                while (
                                  base < end &&
                                  isHalantOrCoeng(glyphs[base])
                                ) {
                                  base++;
                                }
                                glyphs[base].shaperInfo.position =
                                  POSITIONS.BASE_C;
                                tryPref = false;
                              }
                              break;
                            }
                          }
                        }
                        if (plan.unicodeScript === "Malayalam") {
                          for (var _i20 = base + 1; _i20 < end; _i20++) {
                            while (_i20 < end && isJoiner(glyphs[_i20])) {
                              _i20++;
                            }
                            if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) {
                              break;
                            }
                            _i20++;
                            while (_i20 < end && isJoiner(glyphs[_i20])) {
                              _i20++;
                            }
                            if (
                              _i20 < end &&
                              isConsonant(glyphs[_i20]) &&
                              glyphs[_i20].shaperInfo.position ===
                                POSITIONS.Below_C
                            ) {
                              base = _i20;
                              glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                            }
                          }
                        }
                        if (
                          start < base &&
                          glyphs[base].shaperInfo.position > POSITIONS.Base_C
                        ) {
                          base--;
                        }
                        break;
                      }
                    }
                    if (
                      base === end &&
                      start < base &&
                      glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ
                    ) {
                      base--;
                    }
                    if (base < end) {
                      while (
                        start < base &&
                        glyphs[base].shaperInfo.category &
                          (CATEGORIES.N | HALANT_OR_COENG_FLAGS)
                      ) {
                        base--;
                      }
                    }
                    if (start + 1 < end && start < base) {
                      var newPos = base === end ? base - 2 : base - 1;
                      if (
                        plan.unicodeScript !== "Malayalam" &&
                        plan.unicodeScript !== "Tamil"
                      ) {
                        while (
                          newPos > start &&
                          !(
                            glyphs[newPos].shaperInfo.category &
                            (CATEGORIES.M | HALANT_OR_COENG_FLAGS)
                          )
                        ) {
                          newPos--;
                        }
                        if (
                          isHalantOrCoeng(glyphs[newPos]) &&
                          glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M
                        ) {
                          if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
                            newPos++;
                          }
                        } else {
                          newPos = start;
                        }
                      }
                      if (
                        start < newPos &&
                        glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M
                      ) {
                        for (var _i21 = newPos; _i21 > start; _i21--) {
                          if (
                            glyphs[_i21 - 1].shaperInfo.position ===
                            POSITIONS.Pre_M
                          ) {
                            var oldPos = _i21 - 1;
                            if (oldPos < base && base <= newPos) {
                              base--;
                            }
                            var tmp = glyphs[oldPos];
                            glyphs.splice.apply(
                              glyphs,
                              [oldPos, 0].concat(
                                glyphs.splice(oldPos + 1, newPos - oldPos)
                              )
                            );
                            glyphs[newPos] = tmp;
                            newPos--;
                          }
                        }
                      }
                    }
                    if (
                      start + 1 < end &&
                      glyphs[start].shaperInfo.position ===
                        POSITIONS.Ra_To_Become_Reph &&
                      (glyphs[start].shaperInfo.category === CATEGORIES.Repha) !==
                        (glyphs[start].isLigated && !glyphs[start].isMultiplied)
                    ) {
                      var newRephPos = void 0;
                      var rephPos = indicConfig.rephPos;
                      var found = false;
                      if (rephPos !== POSITIONS.After_Post) {
                        newRephPos = start + 1;
                        while (
                          newRephPos < base &&
                          !isHalantOrCoeng(glyphs[newRephPos])
                        ) {
                          newRephPos++;
                        }
                        if (
                          newRephPos < base &&
                          isHalantOrCoeng(glyphs[newRephPos])
                        ) {
                          if (
                            newRephPos + 1 < base &&
                            isJoiner(glyphs[newRephPos + 1])
                          ) {
                            newRephPos++;
                          }
                          found = true;
                        }
                        if (!found && rephPos === POSITIONS.After_Main) {
                          newRephPos = base;
                          while (
                            newRephPos + 1 < end &&
                            glyphs[newRephPos + 1].shaperInfo.position <=
                              POSITIONS.After_Main
                          ) {
                            newRephPos++;
                          }
                          found = newRephPos < end;
                        }
                        if (!found && rephPos === POSITIONS.After_Sub) {
                          newRephPos = base;
                          while (
                            newRephPos + 1 < end &&
                            !(
                              glyphs[newRephPos + 1].shaperInfo.position &
                              (POSITIONS.Post_C |
                                POSITIONS.After_Post |
                                POSITIONS.SMVD)
                            )
                          ) {
                            newRephPos++;
                          }
                          found = newRephPos < end;
                        }
                      }
                      if (!found) {
                        newRephPos = start + 1;
                        while (
                          newRephPos < base &&
                          !isHalantOrCoeng(glyphs[newRephPos])
                        ) {
                          newRephPos++;
                        }
                        if (
                          newRephPos < base &&
                          isHalantOrCoeng(glyphs[newRephPos])
                        ) {
                          if (
                            newRephPos + 1 < base &&
                            isJoiner(glyphs[newRephPos + 1])
                          ) {
                            newRephPos++;
                          }
                          found = true;
                        }
                      }
                      if (!found) {
                        newRephPos = end - 1;
                        while (
                          newRephPos > start &&
                          glyphs[newRephPos].shaperInfo.position ===
                            POSITIONS.SMVD
                        ) {
                          newRephPos--;
                        }
                        if (isHalantOrCoeng(glyphs[newRephPos])) {
                          for (var _i22 = base + 1; _i22 < newRephPos; _i22++) {
                            if (
                              glyphs[_i22].shaperInfo.category === CATEGORIES.M
                            ) {
                              newRephPos--;
                            }
                          }
                        }
                      }
                      var reph = glyphs[start];
                      glyphs.splice.apply(
                        glyphs,
                        [start, 0].concat(
                          glyphs.splice(start + 1, newRephPos - start)
                        )
                      );
                      glyphs[newRephPos] = reph;
                      if (start < base && base <= newRephPos) {
                        base--;
                      }
                    }
                    if (tryPref && base + 1 < end) {
                      for (var _i23 = base + 1; _i23 < end; _i23++) {
                        if (glyphs[_i23].features.pref) {
                          if (
                            glyphs[_i23].isLigated &&
                            !glyphs[_i23].isMultiplied
                          ) {
                            var _newPos = base;
                            if (
                              plan.unicodeScript !== "Malayalam" &&
                              plan.unicodeScript !== "Tamil"
                            ) {
                              while (
                                _newPos > start &&
                                !(
                                  glyphs[_newPos - 1].shaperInfo.category &
                                  (CATEGORIES.M | HALANT_OR_COENG_FLAGS)
                                )
                              ) {
                                _newPos--;
                              }
                              if (
                                _newPos > start &&
                                glyphs[_newPos - 1].shaperInfo.category ===
                                  CATEGORIES.M
                              ) {
                                var _oldPos2 = _i23;
                                for (var j = base + 1; j < _oldPos2; j++) {
                                  if (
                                    glyphs[j].shaperInfo.category === CATEGORIES.M
                                  ) {
                                    _newPos--;
                                    break;
                                  }
                                }
                              }
                            }
                            if (
                              _newPos > start &&
                              isHalantOrCoeng(glyphs[_newPos - 1])
                            ) {
                              if (_newPos < end && isJoiner(glyphs[_newPos])) {
                                _newPos++;
                              }
                            }
                            var _oldPos = _i23;
                            var _tmp = glyphs[_oldPos];
                            glyphs.splice.apply(
                              glyphs,
                              [_newPos + 1, 0].concat(
                                glyphs.splice(_newPos, _oldPos - _newPos)
                              )
                            );
                            glyphs[_newPos] = _tmp;
                            if (_newPos <= base && base < _oldPos) {
                              base++;
                            }
                          }
                          break;
                        }
                      }
                    }
                    if (
                      glyphs[start].shaperInfo.position === POSITIONS.Pre_M &&
                      (!start ||
                        !/Cf|Mn/.test(
                          unicode.getCategory(glyphs[start - 1].codePoints[0])
                        ))
                    ) {
                      glyphs[start].features.init = true;
                    }
                  }
                }
                function nextSyllable(glyphs, start) {
                  if (start >= glyphs.length) return start;
                  var syllable = glyphs[start].shaperInfo.syllable;
                  while (
                    ++start < glyphs.length &&
                    glyphs[start].shaperInfo.syllable === syllable
                  ) {}
                  return start;
                }
                var _class$7;
                var _temp$3;
                var categories$1 = useData.categories;
                var decompositions$2 = useData.decompositions;
                var trie$2 = new UnicodeTrie(
                  Buffer(
                    "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",
                    "base64"
                  )
                );
                var stateMachine$1 = new StateMachine(useData);
                var UniversalShaper =
                  ((_temp$3 = _class$7 =
                    (function (_DefaultShaper) {
                      _inherits(UniversalShaper, _DefaultShaper);
                      function UniversalShaper() {
                        _classCallCheck(this, UniversalShaper);
                        return _possibleConstructorReturn(
                          this,
                          _DefaultShaper.apply(this, arguments)
                        );
                      }
                      UniversalShaper.planFeatures = function planFeatures(plan) {
                        plan.addStage(setupSyllables$1);
                        plan.addStage(["locl", "ccmp", "nukt", "akhn"]);
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage(["rphf"], false);
                        plan.addStage(recordRphf);
                        plan.addStage(clearSubstitutionFlags);
                        plan.addStage(["pref"]);
                        plan.addStage(recordPref);
                        plan.addStage([
                          "rkrf",
                          "abvf",
                          "blwf",
                          "half",
                          "pstf",
                          "vatu",
                          "cjct",
                        ]);
                        plan.addStage(reorder);
                        plan.addStage([
                          "abvs",
                          "blws",
                          "pres",
                          "psts",
                          "dist",
                          "abvm",
                          "blwm",
                        ]);
                      };
                      UniversalShaper.assignFeatures = function assignFeatures(
                        plan,
                        glyphs
                      ) {
                        var _loop = function _loop(i) {
                          var codepoint = glyphs[i].codePoints[0];
                          if (decompositions$2[codepoint]) {
                            var decomposed = decompositions$2[codepoint].map(
                              function (c) {
                                var g = plan.font.glyphForCodePoint(c);
                                return new GlyphInfo(
                                  plan.font,
                                  g.id,
                                  [c],
                                  glyphs[i].features
                                );
                              }
                            );
                            glyphs.splice.apply(
                              glyphs,
                              [i, 1].concat(decomposed)
                            );
                          }
                        };
                        for (var i = glyphs.length - 1; i >= 0; i--) {
                          _loop(i);
                        }
                      };
                      return UniversalShaper;
                    })(DefaultShaper)),
                  (_class$7.zeroMarkWidths = "BEFORE_GPOS"),
                  _temp$3);
                function useCategory(glyph) {
                  return trie$2.get(glyph.codePoints[0]);
                }
                var USEInfo = function USEInfo(category, syllableType, syllable) {
                  _classCallCheck(this, USEInfo);
                  this.category = category;
                  this.syllableType = syllableType;
                  this.syllable = syllable;
                };
                function setupSyllables$1(font, glyphs) {
                  var syllable = 0;
                  for (
                    var _iterator = stateMachine$1.match(glyphs.map(useCategory)),
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var _ref2 = _ref,
                      start = _ref2[0],
                      end = _ref2[1],
                      tags = _ref2[2];
                    ++syllable;
                    for (var i = start; i <= end; i++) {
                      glyphs[i].shaperInfo = new USEInfo(
                        categories$1[useCategory(glyphs[i])],
                        tags[0],
                        syllable
                      );
                    }
                    var limit =
                      glyphs[start].shaperInfo.category === "R"
                        ? 1
                        : Math.min(3, end - start);
                    for (var _i2 = start; _i2 < start + limit; _i2++) {
                      glyphs[_i2].features.rphf = true;
                    }
                  }
                }
                function clearSubstitutionFlags(font, glyphs) {
                  for (
                    var _iterator2 = glyphs,
                      _isArray2 = Array.isArray(_iterator2),
                      _i3 = 0,
                      _iterator2 = _isArray2
                        ? _iterator2
                        : _getIterator(_iterator2);
                    ;
  
                  ) {
                    var _ref3;
                    if (_isArray2) {
                      if (_i3 >= _iterator2.length) break;
                      _ref3 = _iterator2[_i3++];
                    } else {
                      _i3 = _iterator2.next();
                      if (_i3.done) break;
                      _ref3 = _i3.value;
                    }
                    var glyph = _ref3;
                    glyph.substituted = false;
                  }
                }
                function recordRphf(font, glyphs) {
                  for (
                    var _iterator3 = glyphs,
                      _isArray3 = Array.isArray(_iterator3),
                      _i4 = 0,
                      _iterator3 = _isArray3
                        ? _iterator3
                        : _getIterator(_iterator3);
                    ;
  
                  ) {
                    var _ref4;
                    if (_isArray3) {
                      if (_i4 >= _iterator3.length) break;
                      _ref4 = _iterator3[_i4++];
                    } else {
                      _i4 = _iterator3.next();
                      if (_i4.done) break;
                      _ref4 = _i4.value;
                    }
                    var glyph = _ref4;
                    if (glyph.substituted && glyph.features.rphf) {
                      glyph.shaperInfo.category = "R";
                    }
                  }
                }
                function recordPref(font, glyphs) {
                  for (
                    var _iterator4 = glyphs,
                      _isArray4 = Array.isArray(_iterator4),
                      _i5 = 0,
                      _iterator4 = _isArray4
                        ? _iterator4
                        : _getIterator(_iterator4);
                    ;
  
                  ) {
                    var _ref5;
                    if (_isArray4) {
                      if (_i5 >= _iterator4.length) break;
                      _ref5 = _iterator4[_i5++];
                    } else {
                      _i5 = _iterator4.next();
                      if (_i5.done) break;
                      _ref5 = _i5.value;
                    }
                    var glyph = _ref5;
                    if (glyph.substituted) {
                      glyph.shaperInfo.category = "VPre";
                    }
                  }
                }
                function reorder(font, glyphs) {
                  var dottedCircle = font.glyphForCodePoint(9676).id;
                  for (
                    var start = 0, end = nextSyllable$1(glyphs, 0);
                    start < glyphs.length;
                    start = end, end = nextSyllable$1(glyphs, start)
                  ) {
                    var i = void 0,
                      j = void 0;
                    var info = glyphs[start].shaperInfo;
                    var type = info.syllableType;
                    if (
                      type !== "virama_terminated_cluster" &&
                      type !== "standard_cluster" &&
                      type !== "broken_cluster"
                    ) {
                      continue;
                    }
                    if (type === "broken_cluster" && dottedCircle) {
                      var g = new GlyphInfo(font, dottedCircle, [9676]);
                      g.shaperInfo = info;
                      for (
                        i = start;
                        i < end && glyphs[i].shaperInfo.category === "R";
                        i++
                      ) {}
                      glyphs.splice(++i, 0, g);
                      end++;
                    }
                    if (info.category === "R" && end - start > 1) {
                      for (i = start + 1; i < end; i++) {
                        info = glyphs[i].shaperInfo;
                        if (isBase(info) || isHalant(glyphs[i])) {
                          if (isHalant(glyphs[i])) {
                            i--;
                          }
                          glyphs.splice.apply(
                            glyphs,
                            [start, 0].concat(
                              glyphs.splice(start + 1, i - start),
                              [glyphs[i]]
                            )
                          );
                          break;
                        }
                      }
                    }
                    for (i = start, j = end; i < end; i++) {
                      info = glyphs[i].shaperInfo;
                      if (isBase(info) || isHalant(glyphs[i])) {
                        j = isHalant(glyphs[i]) ? i + 1 : i;
                      } else if (
                        (info.category === "VPre" || info.category === "VMPre") &&
                        j < i
                      ) {
                        glyphs.splice.apply(
                          glyphs,
                          [j, 1, glyphs[i]].concat(glyphs.splice(j, i - j))
                        );
                      }
                    }
                  }
                }
                function nextSyllable$1(glyphs, start) {
                  if (start >= glyphs.length) return start;
                  var syllable = glyphs[start].shaperInfo.syllable;
                  while (
                    ++start < glyphs.length &&
                    glyphs[start].shaperInfo.syllable === syllable
                  ) {}
                  return start;
                }
                function isHalant(glyph) {
                  return glyph.shaperInfo.category === "H" && !glyph.isLigated;
                }
                function isBase(info) {
                  return info.category === "B" || info.category === "GB";
                }
                var SHAPERS = {
                  arab: ArabicShaper,
                  mong: ArabicShaper,
                  syrc: ArabicShaper,
                  "nko ": ArabicShaper,
                  phag: ArabicShaper,
                  mand: ArabicShaper,
                  mani: ArabicShaper,
                  phlp: ArabicShaper,
                  hang: HangulShaper,
                  bng2: IndicShaper,
                  beng: IndicShaper,
                  dev2: IndicShaper,
                  deva: IndicShaper,
                  gjr2: IndicShaper,
                  gujr: IndicShaper,
                  guru: IndicShaper,
                  gur2: IndicShaper,
                  knda: IndicShaper,
                  knd2: IndicShaper,
                  mlm2: IndicShaper,
                  mlym: IndicShaper,
                  ory2: IndicShaper,
                  orya: IndicShaper,
                  taml: IndicShaper,
                  tml2: IndicShaper,
                  telu: IndicShaper,
                  tel2: IndicShaper,
                  khmr: IndicShaper,
                  bali: UniversalShaper,
                  batk: UniversalShaper,
                  brah: UniversalShaper,
                  bugi: UniversalShaper,
                  buhd: UniversalShaper,
                  cakm: UniversalShaper,
                  cham: UniversalShaper,
                  dupl: UniversalShaper,
                  egyp: UniversalShaper,
                  gran: UniversalShaper,
                  hano: UniversalShaper,
                  java: UniversalShaper,
                  kthi: UniversalShaper,
                  kali: UniversalShaper,
                  khar: UniversalShaper,
                  khoj: UniversalShaper,
                  sind: UniversalShaper,
                  lepc: UniversalShaper,
                  limb: UniversalShaper,
                  mahj: UniversalShaper,
                  mtei: UniversalShaper,
                  modi: UniversalShaper,
                  hmng: UniversalShaper,
                  rjng: UniversalShaper,
                  saur: UniversalShaper,
                  shrd: UniversalShaper,
                  sidd: UniversalShaper,
                  sinh: UniversalShaper,
                  sund: UniversalShaper,
                  sylo: UniversalShaper,
                  tglg: UniversalShaper,
                  tagb: UniversalShaper,
                  tale: UniversalShaper,
                  lana: UniversalShaper,
                  tavt: UniversalShaper,
                  takr: UniversalShaper,
                  tibt: UniversalShaper,
                  tfng: UniversalShaper,
                  tirh: UniversalShaper,
                  latn: DefaultShaper,
                  DFLT: DefaultShaper,
                };
                function choose(script) {
                  if (!Array.isArray(script)) {
                    script = [script];
                  }
                  for (
                    var _iterator = script,
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var s = _ref;
                    var shaper = SHAPERS[s];
                    if (shaper) {
                      return shaper;
                    }
                  }
                  return DefaultShaper;
                }
                var GSUBProcessor = (function (_OTProcessor) {
                  _inherits(GSUBProcessor, _OTProcessor);
                  function GSUBProcessor() {
                    _classCallCheck(this, GSUBProcessor);
                    return _possibleConstructorReturn(
                      this,
                      _OTProcessor.apply(this, arguments)
                    );
                  }
                  GSUBProcessor.prototype.applyLookup = function applyLookup(
                    lookupType,
                    table
                  ) {
                    var _this2 = this;
                    switch (lookupType) {
                      case 1: {
                        var index = this.coverageIndex(table.coverage);
                        if (index === -1) {
                          return false;
                        }
                        var glyph = this.glyphIterator.cur;
                        switch (table.version) {
                          case 1:
                            glyph.id = (glyph.id + table.deltaGlyphID) & 65535;
                            break;
                          case 2:
                            glyph.id = table.substitute.get(index);
                            break;
                        }
                        return true;
                      }
                      case 2: {
                        var _index = this.coverageIndex(table.coverage);
                        if (_index !== -1) {
                          var _glyphs;
                          var sequence = table.sequences.get(_index);
                          if (sequence.length === 0) {
                            this.glyphs.splice(this.glyphIterator.index, 1);
                            return true;
                          }
                          this.glyphIterator.cur.id = sequence[0];
                          this.glyphIterator.cur.ligatureComponent = 0;
                          var features = this.glyphIterator.cur.features;
                          var curGlyph = this.glyphIterator.cur;
                          var replacement = sequence
                            .slice(1)
                            .map(function (gid, i) {
                              var glyph = new GlyphInfo(
                                _this2.font,
                                gid,
                                undefined,
                                features
                              );
                              glyph.shaperInfo = curGlyph.shaperInfo;
                              glyph.isLigated = curGlyph.isLigated;
                              glyph.ligatureComponent = i + 1;
                              glyph.substituted = true;
                              glyph.isMultiplied = true;
                              return glyph;
                            });
                          (_glyphs = this.glyphs).splice.apply(
                            _glyphs,
                            [this.glyphIterator.index + 1, 0].concat(replacement)
                          );
                          return true;
                        }
                        return false;
                      }
                      case 3: {
                        var _index2 = this.coverageIndex(table.coverage);
                        if (_index2 !== -1) {
                          var USER_INDEX = 0;
                          this.glyphIterator.cur.id =
                            table.alternateSet.get(_index2)[USER_INDEX];
                          return true;
                        }
                        return false;
                      }
                      case 4: {
                        var _index3 = this.coverageIndex(table.coverage);
                        if (_index3 === -1) {
                          return false;
                        }
                        for (
                          var _iterator = table.ligatureSets.get(_index3),
                            _isArray = Array.isArray(_iterator),
                            _i = 0,
                            _iterator = _isArray
                              ? _iterator
                              : _getIterator(_iterator);
                          ;
  
                        ) {
                          var _ref;
                          if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                          } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                          }
                          var ligature = _ref;
                          var matched = this.sequenceMatchIndices(
                            1,
                            ligature.components
                          );
                          if (!matched) {
                            continue;
                          }
                          var _curGlyph = this.glyphIterator.cur;
                          var characters = _curGlyph.codePoints.slice();
                          for (
                            var _iterator2 = matched,
                              _isArray2 = Array.isArray(_iterator2),
                              _i2 = 0,
                              _iterator2 = _isArray2
                                ? _iterator2
                                : _getIterator(_iterator2);
                            ;
  
                          ) {
                            var _ref2;
                            if (_isArray2) {
                              if (_i2 >= _iterator2.length) break;
                              _ref2 = _iterator2[_i2++];
                            } else {
                              _i2 = _iterator2.next();
                              if (_i2.done) break;
                              _ref2 = _i2.value;
                            }
                            var _index4 = _ref2;
                            characters.push.apply(
                              characters,
                              this.glyphs[_index4].codePoints
                            );
                          }
                          var ligatureGlyph = new GlyphInfo(
                            this.font,
                            ligature.glyph,
                            characters,
                            _curGlyph.features
                          );
                          ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                          ligatureGlyph.isLigated = true;
                          ligatureGlyph.substituted = true;
                          var isMarkLigature = _curGlyph.isMark;
                          for (
                            var i = 0;
                            i < matched.length && isMarkLigature;
                            i++
                          ) {
                            isMarkLigature = this.glyphs[matched[i]].isMark;
                          }
                          ligatureGlyph.ligatureID = isMarkLigature
                            ? null
                            : this.ligatureID++;
                          var lastLigID = _curGlyph.ligatureID;
                          var lastNumComps = _curGlyph.codePoints.length;
                          var curComps = lastNumComps;
                          var idx = this.glyphIterator.index + 1;
                          for (
                            var _iterator3 = matched,
                              _isArray3 = Array.isArray(_iterator3),
                              _i3 = 0,
                              _iterator3 = _isArray3
                                ? _iterator3
                                : _getIterator(_iterator3);
                            ;
  
                          ) {
                            var _ref3;
                            if (_isArray3) {
                              if (_i3 >= _iterator3.length) break;
                              _ref3 = _iterator3[_i3++];
                            } else {
                              _i3 = _iterator3.next();
                              if (_i3.done) break;
                              _ref3 = _i3.value;
                            }
                            var matchIndex = _ref3;
                            if (isMarkLigature) {
                              idx = matchIndex;
                            } else {
                              while (idx < matchIndex) {
                                var ligatureComponent =
                                  curComps -
                                  lastNumComps +
                                  Math.min(
                                    this.glyphs[idx].ligatureComponent || 1,
                                    lastNumComps
                                  );
                                this.glyphs[idx].ligatureID =
                                  ligatureGlyph.ligatureID;
                                this.glyphs[idx].ligatureComponent =
                                  ligatureComponent;
                                idx++;
                              }
                            }
                            lastLigID = this.glyphs[idx].ligatureID;
                            lastNumComps = this.glyphs[idx].codePoints.length;
                            curComps += lastNumComps;
                            idx++;
                          }
                          if (lastLigID && !isMarkLigature) {
                            for (var _i4 = idx; _i4 < this.glyphs.length; _i4++) {
                              if (this.glyphs[_i4].ligatureID === lastLigID) {
                                var ligatureComponent =
                                  curComps -
                                  lastNumComps +
                                  Math.min(
                                    this.glyphs[_i4].ligatureComponent || 1,
                                    lastNumComps
                                  );
                                this.glyphs[_i4].ligatureComponent =
                                  ligatureComponent;
                              } else {
                                break;
                              }
                            }
                          }
                          for (var _i5 = matched.length - 1; _i5 >= 0; _i5--) {
                            this.glyphs.splice(matched[_i5], 1);
                          }
                          this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                          return true;
                        }
                        return false;
                      }
                      case 5:
                        return this.applyContext(table);
                      case 6:
                        return this.applyChainingContext(table);
                      case 7:
                        return this.applyLookup(
                          table.lookupType,
                          table.extension
                        );
                      default:
                        throw new Error(
                          "GSUB lookupType " + lookupType + " is not supported"
                        );
                    }
                  };
                  return GSUBProcessor;
                })(OTProcessor);
                var GPOSProcessor = (function (_OTProcessor) {
                  _inherits(GPOSProcessor, _OTProcessor);
                  function GPOSProcessor() {
                    _classCallCheck(this, GPOSProcessor);
                    return _possibleConstructorReturn(
                      this,
                      _OTProcessor.apply(this, arguments)
                    );
                  }
                  GPOSProcessor.prototype.applyPositionValue =
                    function applyPositionValue(sequenceIndex, value) {
                      var position =
                        this.positions[
                          this.glyphIterator.peekIndex(sequenceIndex)
                        ];
                      if (value.xAdvance != null) {
                        position.xAdvance += value.xAdvance;
                      }
                      if (value.yAdvance != null) {
                        position.yAdvance += value.yAdvance;
                      }
                      if (value.xPlacement != null) {
                        position.xOffset += value.xPlacement;
                      }
                      if (value.yPlacement != null) {
                        position.yOffset += value.yPlacement;
                      }
                      var variationProcessor = this.font._variationProcessor;
                      var variationStore =
                        this.font.GDEF && this.font.GDEF.itemVariationStore;
                      if (variationProcessor && variationStore) {
                        if (value.xPlaDevice) {
                          position.xOffset += variationProcessor.getDelta(
                            variationStore,
                            value.xPlaDevice.a,
                            value.xPlaDevice.b
                          );
                        }
                        if (value.yPlaDevice) {
                          position.yOffset += variationProcessor.getDelta(
                            variationStore,
                            value.yPlaDevice.a,
                            value.yPlaDevice.b
                          );
                        }
                        if (value.xAdvDevice) {
                          position.xAdvance += variationProcessor.getDelta(
                            variationStore,
                            value.xAdvDevice.a,
                            value.xAdvDevice.b
                          );
                        }
                        if (value.yAdvDevice) {
                          position.yAdvance += variationProcessor.getDelta(
                            variationStore,
                            value.yAdvDevice.a,
                            value.yAdvDevice.b
                          );
                        }
                      }
                    };
                  GPOSProcessor.prototype.applyLookup = function applyLookup(
                    lookupType,
                    table
                  ) {
                    switch (lookupType) {
                      case 1: {
                        var index = this.coverageIndex(table.coverage);
                        if (index === -1) {
                          return false;
                        }
                        switch (table.version) {
                          case 1:
                            this.applyPositionValue(0, table.value);
                            break;
                          case 2:
                            this.applyPositionValue(0, table.values.get(index));
                            break;
                        }
                        return true;
                      }
                      case 2: {
                        var nextGlyph = this.glyphIterator.peek();
                        if (!nextGlyph) {
                          return false;
                        }
                        var _index = this.coverageIndex(table.coverage);
                        if (_index === -1) {
                          return false;
                        }
                        switch (table.version) {
                          case 1:
                            var set = table.pairSets.get(_index);
                            for (
                              var _iterator = set,
                                _isArray = Array.isArray(_iterator),
                                _i = 0,
                                _iterator = _isArray
                                  ? _iterator
                                  : _getIterator(_iterator);
                              ;
  
                            ) {
                              var _ref;
                              if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                              } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                              }
                              var _pair = _ref;
                              if (_pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, _pair.value1);
                                this.applyPositionValue(1, _pair.value2);
                                return true;
                              }
                            }
                            return false;
                          case 2:
                            var class1 = this.getClassID(
                              this.glyphIterator.cur.id,
                              table.classDef1
                            );
                            var class2 = this.getClassID(
                              nextGlyph.id,
                              table.classDef2
                            );
                            if (class1 === -1 || class2 === -1) {
                              return false;
                            }
                            var pair = table.classRecords.get(class1).get(class2);
                            this.applyPositionValue(0, pair.value1);
                            this.applyPositionValue(1, pair.value2);
                            return true;
                        }
                      }
                      case 3: {
                        var nextIndex = this.glyphIterator.peekIndex();
                        var _nextGlyph = this.glyphs[nextIndex];
                        if (!_nextGlyph) {
                          return false;
                        }
                        var curRecord =
                          table.entryExitRecords[
                            this.coverageIndex(table.coverage)
                          ];
                        if (!curRecord || !curRecord.exitAnchor) {
                          return false;
                        }
                        var nextRecord =
                          table.entryExitRecords[
                            this.coverageIndex(table.coverage, _nextGlyph.id)
                          ];
                        if (!nextRecord || !nextRecord.entryAnchor) {
                          return false;
                        }
                        var entry = this.getAnchor(nextRecord.entryAnchor);
                        var exit = this.getAnchor(curRecord.exitAnchor);
                        var cur = this.positions[this.glyphIterator.index];
                        var next = this.positions[nextIndex];
                        switch (this.direction) {
                          case "ltr":
                            cur.xAdvance = exit.x + cur.xOffset;
                            var d = entry.x + next.xOffset;
                            next.xAdvance -= d;
                            next.xOffset -= d;
                            break;
                          case "rtl":
                            d = exit.x + cur.xOffset;
                            cur.xAdvance -= d;
                            cur.xOffset -= d;
                            next.xAdvance = entry.x + next.xOffset;
                            break;
                        }
                        if (this.glyphIterator.flags.rightToLeft) {
                          this.glyphIterator.cur.cursiveAttachment = nextIndex;
                          cur.yOffset = entry.y - exit.y;
                        } else {
                          _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                          cur.yOffset = exit.y - entry.y;
                        }
                        return true;
                      }
                      case 4: {
                        var markIndex = this.coverageIndex(table.markCoverage);
                        if (markIndex === -1) {
                          return false;
                        }
                        var baseGlyphIndex = this.glyphIterator.index;
                        while (
                          --baseGlyphIndex >= 0 &&
                          (this.glyphs[baseGlyphIndex].isMark ||
                            this.glyphs[baseGlyphIndex].ligatureComponent > 0)
                        ) {}
                        if (baseGlyphIndex < 0) {
                          return false;
                        }
                        var baseIndex = this.coverageIndex(
                          table.baseCoverage,
                          this.glyphs[baseGlyphIndex].id
                        );
                        if (baseIndex === -1) {
                          return false;
                        }
                        var markRecord = table.markArray[markIndex];
                        var baseAnchor =
                          table.baseArray[baseIndex][markRecord.class];
                        this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                        return true;
                      }
                      case 5: {
                        var _markIndex = this.coverageIndex(table.markCoverage);
                        if (_markIndex === -1) {
                          return false;
                        }
                        var _baseGlyphIndex = this.glyphIterator.index;
                        while (
                          --_baseGlyphIndex >= 0 &&
                          this.glyphs[_baseGlyphIndex].isMark
                        ) {}
                        if (_baseGlyphIndex < 0) {
                          return false;
                        }
                        var ligIndex = this.coverageIndex(
                          table.ligatureCoverage,
                          this.glyphs[_baseGlyphIndex].id
                        );
                        if (ligIndex === -1) {
                          return false;
                        }
                        var ligAttach = table.ligatureArray[ligIndex];
                        var markGlyph = this.glyphIterator.cur;
                        var ligGlyph = this.glyphs[_baseGlyphIndex];
                        var compIndex =
                          ligGlyph.ligatureID &&
                          ligGlyph.ligatureID === markGlyph.ligatureID &&
                          markGlyph.ligatureComponent > 0
                            ? Math.min(
                                markGlyph.ligatureComponent,
                                ligGlyph.codePoints.length
                              ) - 1
                            : ligGlyph.codePoints.length - 1;
                        var _markRecord = table.markArray[_markIndex];
                        var _baseAnchor = ligAttach[compIndex][_markRecord.class];
                        this.applyAnchor(
                          _markRecord,
                          _baseAnchor,
                          _baseGlyphIndex
                        );
                        return true;
                      }
                      case 6: {
                        var mark1Index = this.coverageIndex(table.mark1Coverage);
                        if (mark1Index === -1) {
                          return false;
                        }
                        var prevIndex = this.glyphIterator.peekIndex(-1);
                        var prev = this.glyphs[prevIndex];
                        if (!prev || !prev.isMark) {
                          return false;
                        }
                        var _cur = this.glyphIterator.cur;
                        var good = false;
                        if (_cur.ligatureID === prev.ligatureID) {
                          if (!_cur.ligatureID) {
                            good = true;
                          } else if (
                            _cur.ligatureComponent === prev.ligatureComponent
                          ) {
                            good = true;
                          }
                        } else {
                          if (
                            (_cur.ligatureID && !_cur.ligatureComponent) ||
                            (prev.ligatureID && !prev.ligatureComponent)
                          ) {
                            good = true;
                          }
                        }
                        if (!good) {
                          return false;
                        }
                        var mark2Index = this.coverageIndex(
                          table.mark2Coverage,
                          prev.id
                        );
                        if (mark2Index === -1) {
                          return false;
                        }
                        var _markRecord2 = table.mark1Array[mark1Index];
                        var _baseAnchor2 =
                          table.mark2Array[mark2Index][_markRecord2.class];
                        this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                        return true;
                      }
                      case 7:
                        return this.applyContext(table);
                      case 8:
                        return this.applyChainingContext(table);
                      case 9:
                        return this.applyLookup(
                          table.lookupType,
                          table.extension
                        );
                      default:
                        throw new Error("Unsupported GPOS table: " + lookupType);
                    }
                  };
                  GPOSProcessor.prototype.applyAnchor = function applyAnchor(
                    markRecord,
                    baseAnchor,
                    baseGlyphIndex
                  ) {
                    var baseCoords = this.getAnchor(baseAnchor);
                    var markCoords = this.getAnchor(markRecord.markAnchor);
                    var basePos = this.positions[baseGlyphIndex];
                    var markPos = this.positions[this.glyphIterator.index];
                    markPos.xOffset = baseCoords.x - markCoords.x;
                    markPos.yOffset = baseCoords.y - markCoords.y;
                    this.glyphIterator.cur.markAttachment = baseGlyphIndex;
                  };
                  GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
                    var x = anchor.xCoordinate;
                    var y = anchor.yCoordinate;
                    var variationProcessor = this.font._variationProcessor;
                    var variationStore =
                      this.font.GDEF && this.font.GDEF.itemVariationStore;
                    if (variationProcessor && variationStore) {
                      if (anchor.xDeviceTable) {
                        x += variationProcessor.getDelta(
                          variationStore,
                          anchor.xDeviceTable.a,
                          anchor.xDeviceTable.b
                        );
                      }
                      if (anchor.yDeviceTable) {
                        y += variationProcessor.getDelta(
                          variationStore,
                          anchor.yDeviceTable.a,
                          anchor.yDeviceTable.b
                        );
                      }
                    }
                    return {
                      x: x,
                      y: y,
                    };
                  };
                  GPOSProcessor.prototype.applyFeatures = function applyFeatures(
                    userFeatures,
                    glyphs,
                    advances
                  ) {
                    _OTProcessor.prototype.applyFeatures.call(
                      this,
                      userFeatures,
                      glyphs,
                      advances
                    );
                    for (var i = 0; i < this.glyphs.length; i++) {
                      this.fixCursiveAttachment(i);
                    }
                    this.fixMarkAttachment();
                  };
                  GPOSProcessor.prototype.fixCursiveAttachment =
                    function fixCursiveAttachment(i) {
                      var glyph = this.glyphs[i];
                      if (glyph.cursiveAttachment != null) {
                        var j = glyph.cursiveAttachment;
                        glyph.cursiveAttachment = null;
                        this.fixCursiveAttachment(j);
                        this.positions[i].yOffset += this.positions[j].yOffset;
                      }
                    };
                  GPOSProcessor.prototype.fixMarkAttachment =
                    function fixMarkAttachment() {
                      for (var i = 0; i < this.glyphs.length; i++) {
                        var glyph = this.glyphs[i];
                        if (glyph.markAttachment != null) {
                          var j = glyph.markAttachment;
                          this.positions[i].xOffset += this.positions[j].xOffset;
                          this.positions[i].yOffset += this.positions[j].yOffset;
                          if (this.direction === "ltr") {
                            for (var k = j; k < i; k++) {
                              this.positions[i].xOffset -=
                                this.positions[k].xAdvance;
                              this.positions[i].yOffset -=
                                this.positions[k].yAdvance;
                            }
                          } else {
                            for (var _k = j + 1; _k < i + 1; _k++) {
                              this.positions[i].xOffset +=
                                this.positions[_k].xAdvance;
                              this.positions[i].yOffset +=
                                this.positions[_k].yAdvance;
                            }
                          }
                        }
                      }
                    };
                  return GPOSProcessor;
                })(OTProcessor);
                var OTLayoutEngine = (function () {
                  function OTLayoutEngine(font) {
                    _classCallCheck(this, OTLayoutEngine);
                    this.font = font;
                    this.glyphInfos = null;
                    this.plan = null;
                    this.GSUBProcessor = null;
                    this.GPOSProcessor = null;
                    this.fallbackPosition = true;
                    if (font.GSUB) {
                      this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
                    }
                    if (font.GPOS) {
                      this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
                    }
                  }
                  OTLayoutEngine.prototype.setup = function setup(glyphRun) {
                    var _this = this;
                    this.glyphInfos = glyphRun.glyphs.map(function (glyph) {
                      return new GlyphInfo(
                        _this.font,
                        glyph.id,
                        [].concat(glyph.codePoints)
                      );
                    });
                    var script = null;
                    if (this.GPOSProcessor) {
                      script = this.GPOSProcessor.selectScript(
                        glyphRun.script,
                        glyphRun.language,
                        glyphRun.direction
                      );
                    }
                    if (this.GSUBProcessor) {
                      script = this.GSUBProcessor.selectScript(
                        glyphRun.script,
                        glyphRun.language,
                        glyphRun.direction
                      );
                    }
                    this.shaper = choose(script);
                    this.plan = new ShapingPlan(
                      this.font,
                      script,
                      glyphRun.direction
                    );
                    this.shaper.plan(
                      this.plan,
                      this.glyphInfos,
                      glyphRun.features
                    );
                    for (var key in this.plan.allFeatures) {
                      glyphRun.features[key] = true;
                    }
                  };
                  OTLayoutEngine.prototype.substitute = function substitute(
                    glyphRun
                  ) {
                    var _this2 = this;
                    if (this.GSUBProcessor) {
                      this.plan.process(this.GSUBProcessor, this.glyphInfos);
                      glyphRun.glyphs = this.glyphInfos.map(function (glyphInfo) {
                        return _this2.font.getGlyph(
                          glyphInfo.id,
                          glyphInfo.codePoints
                        );
                      });
                    }
                  };
                  OTLayoutEngine.prototype.position = function position(
                    glyphRun
                  ) {
                    if (this.shaper.zeroMarkWidths === "BEFORE_GPOS") {
                      this.zeroMarkAdvances(glyphRun.positions);
                    }
                    if (this.GPOSProcessor) {
                      this.plan.process(
                        this.GPOSProcessor,
                        this.glyphInfos,
                        glyphRun.positions
                      );
                    }
                    if (this.shaper.zeroMarkWidths === "AFTER_GPOS") {
                      this.zeroMarkAdvances(glyphRun.positions);
                    }
                    if (glyphRun.direction === "rtl") {
                      glyphRun.glyphs.reverse();
                      glyphRun.positions.reverse();
                    }
                    return this.GPOSProcessor && this.GPOSProcessor.features;
                  };
                  OTLayoutEngine.prototype.zeroMarkAdvances =
                    function zeroMarkAdvances(positions) {
                      for (var i = 0; i < this.glyphInfos.length; i++) {
                        if (this.glyphInfos[i].isMark) {
                          positions[i].xAdvance = 0;
                          positions[i].yAdvance = 0;
                        }
                      }
                    };
                  OTLayoutEngine.prototype.cleanup = function cleanup() {
                    this.glyphInfos = null;
                    this.plan = null;
                    this.shaper = null;
                  };
                  OTLayoutEngine.prototype.getAvailableFeatures =
                    function getAvailableFeatures(script, language) {
                      var features = [];
                      if (this.GSUBProcessor) {
                        this.GSUBProcessor.selectScript(script, language);
                        features.push.apply(
                          features,
                          _Object$keys(this.GSUBProcessor.features)
                        );
                      }
                      if (this.GPOSProcessor) {
                        this.GPOSProcessor.selectScript(script, language);
                        features.push.apply(
                          features,
                          _Object$keys(this.GPOSProcessor.features)
                        );
                      }
                      return features;
                    };
                  return OTLayoutEngine;
                })();
                var LayoutEngine = (function () {
                  function LayoutEngine(font) {
                    _classCallCheck(this, LayoutEngine);
                    this.font = font;
                    this.unicodeLayoutEngine = null;
                    this.kernProcessor = null;
                    if (this.font.morx) {
                      this.engine = new AATLayoutEngine(this.font);
                    } else if (this.font.GSUB || this.font.GPOS) {
                      this.engine = new OTLayoutEngine(this.font);
                    }
                  }
                  LayoutEngine.prototype.layout = function layout(
                    string,
                    features,
                    script,
                    language,
                    direction
                  ) {
                    if (typeof features === "string") {
                      direction = language;
                      language = script;
                      script = features;
                      features = [];
                    }
                    if (typeof string === "string") {
                      if (script == null) {
                        script = forString(string);
                      }
                      var glyphs = this.font.glyphsForString(string);
                    } else {
                      if (script == null) {
                        var codePoints = [];
                        for (
                          var _iterator = string,
                            _isArray = Array.isArray(_iterator),
                            _i = 0,
                            _iterator = _isArray
                              ? _iterator
                              : _getIterator(_iterator);
                          ;
  
                        ) {
                          var _ref;
                          if (_isArray) {
                            if (_i >= _iterator.length) break;
                            _ref = _iterator[_i++];
                          } else {
                            _i = _iterator.next();
                            if (_i.done) break;
                            _ref = _i.value;
                          }
                          var glyph = _ref;
                          codePoints.push.apply(codePoints, glyph.codePoints);
                        }
                        script = forCodePoints(codePoints);
                      }
                      var glyphs = string;
                    }
                    var glyphRun = new GlyphRun(
                      glyphs,
                      features,
                      script,
                      language,
                      direction
                    );
                    if (glyphs.length === 0) {
                      glyphRun.positions = [];
                      return glyphRun;
                    }
                    if (this.engine && this.engine.setup) {
                      this.engine.setup(glyphRun);
                    }
                    this.substitute(glyphRun);
                    this.position(glyphRun);
                    this.hideDefaultIgnorables(
                      glyphRun.glyphs,
                      glyphRun.positions
                    );
                    if (this.engine && this.engine.cleanup) {
                      this.engine.cleanup();
                    }
                    return glyphRun;
                  };
                  LayoutEngine.prototype.substitute = function substitute(
                    glyphRun
                  ) {
                    if (this.engine && this.engine.substitute) {
                      this.engine.substitute(glyphRun);
                    }
                  };
                  LayoutEngine.prototype.position = function position(glyphRun) {
                    glyphRun.positions = glyphRun.glyphs.map(function (glyph) {
                      return new GlyphPosition(glyph.advanceWidth);
                    });
                    var positioned = null;
                    if (this.engine && this.engine.position) {
                      positioned = this.engine.position(glyphRun);
                    }
                    if (
                      !positioned &&
                      (!this.engine || this.engine.fallbackPosition)
                    ) {
                      if (!this.unicodeLayoutEngine) {
                        this.unicodeLayoutEngine = new UnicodeLayoutEngine(
                          this.font
                        );
                      }
                      this.unicodeLayoutEngine.positionGlyphs(
                        glyphRun.glyphs,
                        glyphRun.positions
                      );
                    }
                    if (
                      (!positioned || !positioned.kern) &&
                      glyphRun.features.kern !== false &&
                      this.font.kern
                    ) {
                      if (!this.kernProcessor) {
                        this.kernProcessor = new KernProcessor(this.font);
                      }
                      this.kernProcessor.process(
                        glyphRun.glyphs,
                        glyphRun.positions
                      );
                      glyphRun.features.kern = true;
                    }
                  };
                  LayoutEngine.prototype.hideDefaultIgnorables =
                    function hideDefaultIgnorables(glyphs, positions) {
                      var space = this.font.glyphForCodePoint(32);
                      for (var i = 0; i < glyphs.length; i++) {
                        if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
                          glyphs[i] = space;
                          positions[i].xAdvance = 0;
                          positions[i].yAdvance = 0;
                        }
                      }
                    };
                  LayoutEngine.prototype.isDefaultIgnorable =
                    function isDefaultIgnorable(ch) {
                      var plane = ch >> 16;
                      if (plane === 0) {
                        switch (ch >> 8) {
                          case 0:
                            return ch === 173;
                          case 3:
                            return ch === 847;
                          case 6:
                            return ch === 1564;
                          case 23:
                            return 6068 <= ch && ch <= 6069;
                          case 24:
                            return 6155 <= ch && ch <= 6158;
                          case 32:
                            return (
                              (8203 <= ch && ch <= 8207) ||
                              (8234 <= ch && ch <= 8238) ||
                              (8288 <= ch && ch <= 8303)
                            );
                          case 254:
                            return (65024 <= ch && ch <= 65039) || ch === 65279;
                          case 255:
                            return 65520 <= ch && ch <= 65528;
                          default:
                            return false;
                        }
                      } else {
                        switch (plane) {
                          case 1:
                            return (
                              (113824 <= ch && ch <= 113827) ||
                              (119155 <= ch && ch <= 119162)
                            );
                          case 14:
                            return 917504 <= ch && ch <= 921599;
                          default:
                            return false;
                        }
                      }
                    };
                  LayoutEngine.prototype.getAvailableFeatures =
                    function getAvailableFeatures(script, language) {
                      var features = [];
                      if (this.engine) {
                        features.push.apply(
                          features,
                          this.engine.getAvailableFeatures(script, language)
                        );
                      }
                      if (this.font.kern && features.indexOf("kern") === -1) {
                        features.push("kern");
                      }
                      return features;
                    };
                  LayoutEngine.prototype.stringsForGlyph =
                    function stringsForGlyph(gid) {
                      var result = new _Set();
                      var codePoints =
                        this.font._cmapProcessor.codePointsForGlyph(gid);
                      for (
                        var _iterator2 = codePoints,
                          _isArray2 = Array.isArray(_iterator2),
                          _i2 = 0,
                          _iterator2 = _isArray2
                            ? _iterator2
                            : _getIterator(_iterator2);
                        ;
  
                      ) {
                        var _ref2;
                        if (_isArray2) {
                          if (_i2 >= _iterator2.length) break;
                          _ref2 = _iterator2[_i2++];
                        } else {
                          _i2 = _iterator2.next();
                          if (_i2.done) break;
                          _ref2 = _i2.value;
                        }
                        var codePoint = _ref2;
                        result.add(_String$fromCodePoint(codePoint));
                      }
                      if (this.engine && this.engine.stringsForGlyph) {
                        for (
                          var _iterator3 = this.engine.stringsForGlyph(gid),
                            _isArray3 = Array.isArray(_iterator3),
                            _i3 = 0,
                            _iterator3 = _isArray3
                              ? _iterator3
                              : _getIterator(_iterator3);
                          ;
  
                        ) {
                          var _ref3;
                          if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                          } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                          }
                          var string = _ref3;
                          result.add(string);
                        }
                      }
                      return _Array$from(result);
                    };
                  return LayoutEngine;
                })();
                var SVG_COMMANDS = {
                  moveTo: "M",
                  lineTo: "L",
                  quadraticCurveTo: "Q",
                  bezierCurveTo: "C",
                  closePath: "Z",
                };
                var Path = (function () {
                  function Path() {
                    _classCallCheck(this, Path);
                    this.commands = [];
                    this._bbox = null;
                    this._cbox = null;
                  }
                  Path.prototype.toFunction = function toFunction() {
                    var _this = this;
                    return function (ctx) {
                      _this.commands.forEach(function (c) {
                        return ctx[c.command].apply(ctx, c.args);
                      });
                    };
                  };
                  Path.prototype.toSVG = function toSVG() {
                    var cmds = this.commands.map(function (c) {
                      var args = c.args.map(function (arg) {
                        return Math.round(arg * 100) / 100;
                      });
                      return "" + SVG_COMMANDS[c.command] + args.join(" ");
                    });
                    return cmds.join("");
                  };
                  Path.prototype.mapPoints = function mapPoints(fn) {
                    var path = new Path();
                    for (
                      var _iterator = this.commands,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var c = _ref;
                      var args = [];
                      for (var _i2 = 0; _i2 < c.args.length; _i2 += 2) {
                        var _fn = fn(c.args[_i2], c.args[_i2 + 1]),
                          x = _fn[0],
                          y = _fn[1];
                        args.push(x, y);
                      }
                      path[c.command].apply(path, args);
                    }
                    return path;
                  };
                  Path.prototype.transform = function transform(
                    m0,
                    m1,
                    m2,
                    m3,
                    m4,
                    m5
                  ) {
                    return this.mapPoints(function (x, y) {
                      x = m0 * x + m2 * y + m4;
                      y = m1 * x + m3 * y + m5;
                      return [x, y];
                    });
                  };
                  Path.prototype.translate = function translate(x, y) {
                    return this.transform(1, 0, 0, 1, x, y);
                  };
                  Path.prototype.rotate = function rotate(angle) {
                    var cos = Math.cos(angle);
                    var sin = Math.sin(angle);
                    return this.transform(cos, sin, -sin, cos, 0, 0);
                  };
                  Path.prototype.scale = function scale(scaleX) {
                    var scaleY =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : scaleX;
                    return this.transform(scaleX, 0, 0, scaleY, 0, 0);
                  };
                  _createClass(Path, [
                    {
                      key: "cbox",
                      get: function get() {
                        if (!this._cbox) {
                          var cbox = new BBox();
                          for (
                            var _iterator2 = this.commands,
                              _isArray2 = Array.isArray(_iterator2),
                              _i3 = 0,
                              _iterator2 = _isArray2
                                ? _iterator2
                                : _getIterator(_iterator2);
                            ;
  
                          ) {
                            var _ref2;
                            if (_isArray2) {
                              if (_i3 >= _iterator2.length) break;
                              _ref2 = _iterator2[_i3++];
                            } else {
                              _i3 = _iterator2.next();
                              if (_i3.done) break;
                              _ref2 = _i3.value;
                            }
                            var command = _ref2;
                            for (
                              var _i4 = 0;
                              _i4 < command.args.length;
                              _i4 += 2
                            ) {
                              cbox.addPoint(
                                command.args[_i4],
                                command.args[_i4 + 1]
                              );
                            }
                          }
                          this._cbox = _Object$freeze(cbox);
                        }
                        return this._cbox;
                      },
                    },
                    {
                      key: "bbox",
                      get: function get() {
                        if (this._bbox) {
                          return this._bbox;
                        }
                        var bbox = new BBox();
                        var cx = 0,
                          cy = 0;
                        var f = function f(t) {
                          return (
                            Math.pow(1 - t, 3) * p0[i] +
                            3 * Math.pow(1 - t, 2) * t * p1[i] +
                            3 * (1 - t) * Math.pow(t, 2) * p2[i] +
                            Math.pow(t, 3) * p3[i]
                          );
                        };
                        for (
                          var _iterator3 = this.commands,
                            _isArray3 = Array.isArray(_iterator3),
                            _i5 = 0,
                            _iterator3 = _isArray3
                              ? _iterator3
                              : _getIterator(_iterator3);
                          ;
  
                        ) {
                          var _ref3;
                          if (_isArray3) {
                            if (_i5 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i5++];
                          } else {
                            _i5 = _iterator3.next();
                            if (_i5.done) break;
                            _ref3 = _i5.value;
                          }
                          var c = _ref3;
                          switch (c.command) {
                            case "moveTo":
                            case "lineTo":
                              var _c$args = c.args,
                                x = _c$args[0],
                                y = _c$args[1];
                              bbox.addPoint(x, y);
                              cx = x;
                              cy = y;
                              break;
                            case "quadraticCurveTo":
                            case "bezierCurveTo":
                              if (c.command === "quadraticCurveTo") {
                                var _c$args2 = c.args,
                                  qp1x = _c$args2[0],
                                  qp1y = _c$args2[1],
                                  p3x = _c$args2[2],
                                  p3y = _c$args2[3];
                                var cp1x = cx + (2 / 3) * (qp1x - cx);
                                var cp1y = cy + (2 / 3) * (qp1y - cy);
                                var cp2x = p3x + (2 / 3) * (qp1x - p3x);
                                var cp2y = p3y + (2 / 3) * (qp1y - p3y);
                              } else {
                                var _c$args3 = c.args,
                                  cp1x = _c$args3[0],
                                  cp1y = _c$args3[1],
                                  cp2x = _c$args3[2],
                                  cp2y = _c$args3[3],
                                  p3x = _c$args3[4],
                                  p3y = _c$args3[5];
                              }
                              bbox.addPoint(p3x, p3y);
                              var p0 = [cx, cy];
                              var p1 = [cp1x, cp1y];
                              var p2 = [cp2x, cp2y];
                              var p3 = [p3x, p3y];
                              for (var i = 0; i <= 1; i++) {
                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                var a =
                                  -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                c = 3 * p1[i] - 3 * p0[i];
                                if (a === 0) {
                                  if (b === 0) {
                                    continue;
                                  }
                                  var t = -c / b;
                                  if (0 < t && t < 1) {
                                    if (i === 0) {
                                      bbox.addPoint(f(t), bbox.maxY);
                                    } else if (i === 1) {
                                      bbox.addPoint(bbox.maxX, f(t));
                                    }
                                  }
                                  continue;
                                }
                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                if (b2ac < 0) {
                                  continue;
                                }
                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t1 && t1 < 1) {
                                  if (i === 0) {
                                    bbox.addPoint(f(t1), bbox.maxY);
                                  } else if (i === 1) {
                                    bbox.addPoint(bbox.maxX, f(t1));
                                  }
                                }
                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t2 && t2 < 1) {
                                  if (i === 0) {
                                    bbox.addPoint(f(t2), bbox.maxY);
                                  } else if (i === 1) {
                                    bbox.addPoint(bbox.maxX, f(t2));
                                  }
                                }
                              }
                              cx = p3x;
                              cy = p3y;
                              break;
                          }
                        }
                        return (this._bbox = _Object$freeze(bbox));
                      },
                    },
                  ]);
                  return Path;
                })();
                var _arr = [
                  "moveTo",
                  "lineTo",
                  "quadraticCurveTo",
                  "bezierCurveTo",
                  "closePath",
                ];
                var _loop = function _loop() {
                  var command = _arr[_i6];
                  Path.prototype[command] = function () {
                    for (
                      var _len = arguments.length, args = Array(_len), _key = 0;
                      _key < _len;
                      _key++
                    ) {
                      args[_key] = arguments[_key];
                    }
                    this._bbox = this._cbox = null;
                    this.commands.push({
                      command: command,
                      args: args,
                    });
                    return this;
                  };
                };
                for (var _i6 = 0; _i6 < _arr.length; _i6++) {
                  _loop();
                }
                var StandardNames = [
                  ".notdef",
                  ".null",
                  "nonmarkingreturn",
                  "space",
                  "exclam",
                  "quotedbl",
                  "numbersign",
                  "dollar",
                  "percent",
                  "ampersand",
                  "quotesingle",
                  "parenleft",
                  "parenright",
                  "asterisk",
                  "plus",
                  "comma",
                  "hyphen",
                  "period",
                  "slash",
                  "zero",
                  "one",
                  "two",
                  "three",
                  "four",
                  "five",
                  "six",
                  "seven",
                  "eight",
                  "nine",
                  "colon",
                  "semicolon",
                  "less",
                  "equal",
                  "greater",
                  "question",
                  "at",
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                  "M",
                  "N",
                  "O",
                  "P",
                  "Q",
                  "R",
                  "S",
                  "T",
                  "U",
                  "V",
                  "W",
                  "X",
                  "Y",
                  "Z",
                  "bracketleft",
                  "backslash",
                  "bracketright",
                  "asciicircum",
                  "underscore",
                  "grave",
                  "a",
                  "b",
                  "c",
                  "d",
                  "e",
                  "f",
                  "g",
                  "h",
                  "i",
                  "j",
                  "k",
                  "l",
                  "m",
                  "n",
                  "o",
                  "p",
                  "q",
                  "r",
                  "s",
                  "t",
                  "u",
                  "v",
                  "w",
                  "x",
                  "y",
                  "z",
                  "braceleft",
                  "bar",
                  "braceright",
                  "asciitilde",
                  "Adieresis",
                  "Aring",
                  "Ccedilla",
                  "Eacute",
                  "Ntilde",
                  "Odieresis",
                  "Udieresis",
                  "aacute",
                  "agrave",
                  "acircumflex",
                  "adieresis",
                  "atilde",
                  "aring",
                  "ccedilla",
                  "eacute",
                  "egrave",
                  "ecircumflex",
                  "edieresis",
                  "iacute",
                  "igrave",
                  "icircumflex",
                  "idieresis",
                  "ntilde",
                  "oacute",
                  "ograve",
                  "ocircumflex",
                  "odieresis",
                  "otilde",
                  "uacute",
                  "ugrave",
                  "ucircumflex",
                  "udieresis",
                  "dagger",
                  "degree",
                  "cent",
                  "sterling",
                  "section",
                  "bullet",
                  "paragraph",
                  "germandbls",
                  "registered",
                  "copyright",
                  "trademark",
                  "acute",
                  "dieresis",
                  "notequal",
                  "AE",
                  "Oslash",
                  "infinity",
                  "plusminus",
                  "lessequal",
                  "greaterequal",
                  "yen",
                  "mu",
                  "partialdiff",
                  "summation",
                  "product",
                  "pi",
                  "integral",
                  "ordfeminine",
                  "ordmasculine",
                  "Omega",
                  "ae",
                  "oslash",
                  "questiondown",
                  "exclamdown",
                  "logicalnot",
                  "radical",
                  "florin",
                  "approxequal",
                  "Delta",
                  "guillemotleft",
                  "guillemotright",
                  "ellipsis",
                  "nonbreakingspace",
                  "Agrave",
                  "Atilde",
                  "Otilde",
                  "OE",
                  "oe",
                  "endash",
                  "emdash",
                  "quotedblleft",
                  "quotedblright",
                  "quoteleft",
                  "quoteright",
                  "divide",
                  "lozenge",
                  "ydieresis",
                  "Ydieresis",
                  "fraction",
                  "currency",
                  "guilsinglleft",
                  "guilsinglright",
                  "fi",
                  "fl",
                  "daggerdbl",
                  "periodcentered",
                  "quotesinglbase",
                  "quotedblbase",
                  "perthousand",
                  "Acircumflex",
                  "Ecircumflex",
                  "Aacute",
                  "Edieresis",
                  "Egrave",
                  "Iacute",
                  "Icircumflex",
                  "Idieresis",
                  "Igrave",
                  "Oacute",
                  "Ocircumflex",
                  "apple",
                  "Ograve",
                  "Uacute",
                  "Ucircumflex",
                  "Ugrave",
                  "dotlessi",
                  "circumflex",
                  "tilde",
                  "macron",
                  "breve",
                  "dotaccent",
                  "ring",
                  "cedilla",
                  "hungarumlaut",
                  "ogonek",
                  "caron",
                  "Lslash",
                  "lslash",
                  "Scaron",
                  "scaron",
                  "Zcaron",
                  "zcaron",
                  "brokenbar",
                  "Eth",
                  "eth",
                  "Yacute",
                  "yacute",
                  "Thorn",
                  "thorn",
                  "minus",
                  "multiply",
                  "onesuperior",
                  "twosuperior",
                  "threesuperior",
                  "onehalf",
                  "onequarter",
                  "threequarters",
                  "franc",
                  "Gbreve",
                  "gbreve",
                  "Idotaccent",
                  "Scedilla",
                  "scedilla",
                  "Cacute",
                  "cacute",
                  "Ccaron",
                  "ccaron",
                  "dcroat",
                ];
                var _class$8;
                function _applyDecoratedDescriptor$4(
                  target,
                  property,
                  decorators,
                  descriptor,
                  context
                ) {
                  var desc = {};
                  Object["ke" + "ys"](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                  });
                  desc.enumerable = !!desc.enumerable;
                  desc.configurable = !!desc.configurable;
                  if ("value" in desc || desc.initializer) {
                    desc.writable = true;
                  }
                  desc = decorators
                    .slice()
                    .reverse()
                    .reduce(function (desc, decorator) {
                      return decorator(target, property, desc) || desc;
                    }, desc);
                  if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer
                      ? desc.initializer.call(context)
                      : void 0;
                    desc.initializer = undefined;
                  }
                  if (desc.initializer === void 0) {
                    Object["define" + "Property"](target, property, desc);
                    desc = null;
                  }
                  return desc;
                }
                var Glyph =
                  ((_class$8 = (function () {
                    function Glyph(id, codePoints, font) {
                      _classCallCheck(this, Glyph);
                      this.id = id;
                      this.codePoints = codePoints;
                      this._font = font;
                      this.isMark =
                        this.codePoints.length > 0 &&
                        this.codePoints.every(unicode.isMark);
                      this.isLigature = this.codePoints.length > 1;
                    }
                    Glyph.prototype._getPath = function _getPath() {
                      return new Path();
                    };
                    Glyph.prototype._getCBox = function _getCBox() {
                      return this.path.cbox;
                    };
                    Glyph.prototype._getBBox = function _getBBox() {
                      return this.path.bbox;
                    };
                    Glyph.prototype._getTableMetrics = function _getTableMetrics(
                      table
                    ) {
                      if (this.id < table.metrics.length) {
                        return table.metrics.get(this.id);
                      }
                      var metric = table.metrics.get(table.metrics.length - 1);
                      var res = {
                        advance: metric ? metric.advance : 0,
                        bearing:
                          table.bearings.get(this.id - table.metrics.length) || 0,
                      };
                      return res;
                    };
                    Glyph.prototype._getMetrics = function _getMetrics(cbox) {
                      if (this._metrics) {
                        return this._metrics;
                      }
                      var _getTableMetrics2 = this._getTableMetrics(
                          this._font.hmtx
                        ),
                        advanceWidth = _getTableMetrics2.advance,
                        leftBearing = _getTableMetrics2.bearing;
                      if (this._font.vmtx) {
                        var _getTableMetrics3 = this._getTableMetrics(
                            this._font.vmtx
                          ),
                          advanceHeight = _getTableMetrics3.advance,
                          topBearing = _getTableMetrics3.bearing;
                      } else {
                        var os2 = void 0;
                        if (typeof cbox === "undefined" || cbox === null) {
                          cbox = this.cbox;
                        }
                        if ((os2 = this._font["OS/2"]) && os2.version > 0) {
                          var advanceHeight = Math.abs(
                            os2.typoAscender - os2.typoDescender
                          );
                          var topBearing = os2.typoAscender - cbox.maxY;
                        } else {
                          var hhea = this._font.hhea;
                          var advanceHeight = Math.abs(
                            hhea.ascent - hhea.descent
                          );
                          var topBearing = hhea.ascent - cbox.maxY;
                        }
                      }
                      if (this._font._variationProcessor && this._font.HVAR) {
                        advanceWidth +=
                          this._font._variationProcessor.getAdvanceAdjustment(
                            this.id,
                            this._font.HVAR
                          );
                      }
                      return (this._metrics = {
                        advanceWidth: advanceWidth,
                        advanceHeight: advanceHeight,
                        leftBearing: leftBearing,
                        topBearing: topBearing,
                      });
                    };
                    Glyph.prototype.getScaledPath = function getScaledPath(size) {
                      var scale = (1 / this._font.unitsPerEm) * size;
                      return this.path.scale(scale);
                    };
                    Glyph.prototype._getName = function _getName() {
                      var post = this._font.post;
                      if (!post) {
                        return null;
                      }
                      switch (post.version) {
                        case 1:
                          return StandardNames[this.id];
                        case 2:
                          var id = post.glyphNameIndex[this.id];
                          if (id < StandardNames.length) {
                            return StandardNames[id];
                          }
                          return post.names[id - StandardNames.length];
                        case 2.5:
                          return StandardNames[this.id + post.offsets[this.id]];
                        case 4:
                          return String.fromCharCode(post.map[this.id]);
                      }
                    };
                    Glyph.prototype.render = function render(ctx, size) {
                      ctx.save();
                      var scale = (1 / this._font.head.unitsPerEm) * size;
                      ctx.scale(scale, scale);
                      var fn = this.path.toFunction();
                      fn(ctx);
                      ctx.fill();
                      ctx.restore();
                    };
                    _createClass(Glyph, [
                      {
                        key: "cbox",
                        get: function get() {
                          return this._getCBox();
                        },
                      },
                      {
                        key: "bbox",
                        get: function get() {
                          return this._getBBox();
                        },
                      },
                      {
                        key: "path",
                        get: function get() {
                          return this._getPath();
                        },
                      },
                      {
                        key: "advanceWidth",
                        get: function get() {
                          return this._getMetrics().advanceWidth;
                        },
                      },
                      {
                        key: "advanceHeight",
                        get: function get() {
                          return this._getMetrics().advanceHeight;
                        },
                      },
                      {
                        key: "ligatureCaretPositions",
                        get: function get() {},
                      },
                      {
                        key: "name",
                        get: function get() {
                          return this._getName();
                        },
                      },
                    ]);
                    return Glyph;
                  })()),
                  (_applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "cbox",
                    [cache],
                    _Object$getOwnPropertyDescriptor(_class$8.prototype, "cbox"),
                    _class$8.prototype
                  ),
                  _applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "bbox",
                    [cache],
                    _Object$getOwnPropertyDescriptor(_class$8.prototype, "bbox"),
                    _class$8.prototype
                  ),
                  _applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "path",
                    [cache],
                    _Object$getOwnPropertyDescriptor(_class$8.prototype, "path"),
                    _class$8.prototype
                  ),
                  _applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "advanceWidth",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$8.prototype,
                      "advanceWidth"
                    ),
                    _class$8.prototype
                  ),
                  _applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "advanceHeight",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class$8.prototype,
                      "advanceHeight"
                    ),
                    _class$8.prototype
                  ),
                  _applyDecoratedDescriptor$4(
                    _class$8.prototype,
                    "name",
                    [cache],
                    _Object$getOwnPropertyDescriptor(_class$8.prototype, "name"),
                    _class$8.prototype
                  )),
                  _class$8);
                var GlyfHeader = new r.Struct({
                  numberOfContours: r.int16,
                  xMin: r.int16,
                  yMin: r.int16,
                  xMax: r.int16,
                  yMax: r.int16,
                });
                var ON_CURVE = 1 << 0;
                var X_SHORT_VECTOR = 1 << 1;
                var Y_SHORT_VECTOR = 1 << 2;
                var REPEAT = 1 << 3;
                var SAME_X = 1 << 4;
                var SAME_Y = 1 << 5;
                var ARG_1_AND_2_ARE_WORDS = 1 << 0;
                var WE_HAVE_A_SCALE = 1 << 3;
                var MORE_COMPONENTS = 1 << 5;
                var WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
                var WE_HAVE_A_TWO_BY_TWO = 1 << 7;
                var WE_HAVE_INSTRUCTIONS = 1 << 8;
                var Point = (function () {
                  function Point(onCurve, endContour) {
                    var x =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : 0;
                    var y =
                      arguments.length > 3 && arguments[3] !== undefined
                        ? arguments[3]
                        : 0;
                    _classCallCheck(this, Point);
                    this.onCurve = onCurve;
                    this.endContour = endContour;
                    this.x = x;
                    this.y = y;
                  }
                  Point.prototype.copy = function copy() {
                    return new Point(
                      this.onCurve,
                      this.endContour,
                      this.x,
                      this.y
                    );
                  };
                  return Point;
                })();
                var Component = function Component(glyphID, dx, dy) {
                  _classCallCheck(this, Component);
                  this.glyphID = glyphID;
                  this.dx = dx;
                  this.dy = dy;
                  this.pos = 0;
                  this.scaleX = this.scaleY = 1;
                  this.scale01 = this.scale10 = 0;
                };
                var TTFGlyph = (function (_Glyph) {
                  _inherits(TTFGlyph, _Glyph);
                  function TTFGlyph() {
                    _classCallCheck(this, TTFGlyph);
                    return _possibleConstructorReturn(
                      this,
                      _Glyph.apply(this, arguments)
                    );
                  }
                  TTFGlyph.prototype._getCBox = function _getCBox(internal) {
                    if (this._font._variationProcessor && !internal) {
                      return this.path.cbox;
                    }
                    var stream = this._font._getTableStream("glyf");
                    stream.pos += this._font.loca.offsets[this.id];
                    var glyph = GlyfHeader.decode(stream);
                    var cbox = new BBox(
                      glyph.xMin,
                      glyph.yMin,
                      glyph.xMax,
                      glyph.yMax
                    );
                    return _Object$freeze(cbox);
                  };
                  TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(
                    stream,
                    prev,
                    short,
                    same
                  ) {
                    if (short) {
                      var val = stream.readUInt8();
                      if (!same) {
                        val = -val;
                      }
                      val += prev;
                    } else {
                      if (same) {
                        var val = prev;
                      } else {
                        var val = prev + stream.readInt16BE();
                      }
                    }
                    return val;
                  };
                  TTFGlyph.prototype._decode = function _decode() {
                    var glyfPos = this._font.loca.offsets[this.id];
                    var nextPos = this._font.loca.offsets[this.id + 1];
                    if (glyfPos === nextPos) {
                      return null;
                    }
                    var stream = this._font._getTableStream("glyf");
                    stream.pos += glyfPos;
                    var startPos = stream.pos;
                    var glyph = GlyfHeader.decode(stream);
                    if (glyph.numberOfContours > 0) {
                      this._decodeSimple(glyph, stream);
                    } else if (glyph.numberOfContours < 0) {
                      this._decodeComposite(glyph, stream, startPos);
                    }
                    return glyph;
                  };
                  TTFGlyph.prototype._decodeSimple = function _decodeSimple(
                    glyph,
                    stream
                  ) {
                    glyph.points = [];
                    var endPtsOfContours = new r.Array(
                      r.uint16,
                      glyph.numberOfContours
                    ).decode(stream);
                    glyph.instructions = new r.Array(r.uint8, r.uint16).decode(
                      stream
                    );
                    var flags = [];
                    var numCoords =
                      endPtsOfContours[endPtsOfContours.length - 1] + 1;
                    while (flags.length < numCoords) {
                      var flag = stream.readUInt8();
                      flags.push(flag);
                      if (flag & REPEAT) {
                        var count = stream.readUInt8();
                        for (var j = 0; j < count; j++) {
                          flags.push(flag);
                        }
                      }
                    }
                    for (var i = 0; i < flags.length; i++) {
                      var flag = flags[i];
                      var point = new Point(
                        !!(flag & ON_CURVE),
                        endPtsOfContours.indexOf(i) >= 0,
                        0,
                        0
                      );
                      glyph.points.push(point);
                    }
                    var px = 0;
                    for (var i = 0; i < flags.length; i++) {
                      var flag = flags[i];
                      glyph.points[i].x = px = this._parseGlyphCoord(
                        stream,
                        px,
                        flag & X_SHORT_VECTOR,
                        flag & SAME_X
                      );
                    }
                    var py = 0;
                    for (var i = 0; i < flags.length; i++) {
                      var flag = flags[i];
                      glyph.points[i].y = py = this._parseGlyphCoord(
                        stream,
                        py,
                        flag & Y_SHORT_VECTOR,
                        flag & SAME_Y
                      );
                    }
                    if (this._font._variationProcessor) {
                      var points = glyph.points.slice();
                      points.push.apply(points, this._getPhantomPoints(glyph));
                      this._font._variationProcessor.transformPoints(
                        this.id,
                        points
                      );
                      glyph.phantomPoints = points.slice(-4);
                    }
                    return;
                  };
                  TTFGlyph.prototype._decodeComposite = function _decodeComposite(
                    glyph,
                    stream
                  ) {
                    var offset =
                      arguments.length > 2 && arguments[2] !== undefined
                        ? arguments[2]
                        : 0;
                    glyph.components = [];
                    var haveInstructions = false;
                    var flags = MORE_COMPONENTS;
                    while (flags & MORE_COMPONENTS) {
                      flags = stream.readUInt16BE();
                      var gPos = stream.pos - offset;
                      var glyphID = stream.readUInt16BE();
                      if (!haveInstructions) {
                        haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
                      }
                      if (flags & ARG_1_AND_2_ARE_WORDS) {
                        var dx = stream.readInt16BE();
                        var dy = stream.readInt16BE();
                      } else {
                        var dx = stream.readInt8();
                        var dy = stream.readInt8();
                      }
                      var component = new Component(glyphID, dx, dy);
                      component.pos = gPos;
                      if (flags & WE_HAVE_A_SCALE) {
                        component.scaleX = component.scaleY =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                      } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                        component.scaleX =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                        component.scaleY =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                      } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                        component.scaleX =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                        component.scale01 =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                        component.scale10 =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                        component.scaleY =
                          ((stream.readUInt8() << 24) |
                            (stream.readUInt8() << 16)) /
                          1073741824;
                      }
                      glyph.components.push(component);
                    }
                    if (this._font._variationProcessor) {
                      var points = [];
                      for (var j = 0; j < glyph.components.length; j++) {
                        var component = glyph.components[j];
                        points.push(
                          new Point(true, true, component.dx, component.dy)
                        );
                      }
                      points.push.apply(points, this._getPhantomPoints(glyph));
                      this._font._variationProcessor.transformPoints(
                        this.id,
                        points
                      );
                      glyph.phantomPoints = points.splice(-4, 4);
                      for (var i = 0; i < points.length; i++) {
                        var point = points[i];
                        glyph.components[i].dx = point.x;
                        glyph.components[i].dy = point.y;
                      }
                    }
                    return haveInstructions;
                  };
                  TTFGlyph.prototype._getPhantomPoints =
                    function _getPhantomPoints(glyph) {
                      var cbox = this._getCBox(true);
                      if (this._metrics == null) {
                        this._metrics = Glyph.prototype._getMetrics.call(
                          this,
                          cbox
                        );
                      }
                      var _metrics = this._metrics,
                        advanceWidth = _metrics.advanceWidth,
                        advanceHeight = _metrics.advanceHeight,
                        leftBearing = _metrics.leftBearing,
                        topBearing = _metrics.topBearing;
                      return [
                        new Point(false, true, glyph.xMin - leftBearing, 0),
                        new Point(
                          false,
                          true,
                          glyph.xMin - leftBearing + advanceWidth,
                          0
                        ),
                        new Point(false, true, 0, glyph.yMax + topBearing),
                        new Point(
                          false,
                          true,
                          0,
                          glyph.yMax + topBearing + advanceHeight
                        ),
                      ];
                    };
                  TTFGlyph.prototype._getContours = function _getContours() {
                    var glyph = this._decode();
                    if (!glyph) {
                      return [];
                    }
                    var points = [];
                    if (glyph.numberOfContours < 0) {
                      for (
                        var _iterator = glyph.components,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var component = _ref;
                        var _contours = this._font
                          .getGlyph(component.glyphID)
                          ._getContours();
                        for (var i = 0; i < _contours.length; i++) {
                          var contour = _contours[i];
                          for (var j = 0; j < contour.length; j++) {
                            var _point = contour[j];
                            var x =
                              _point.x * component.scaleX +
                              _point.y * component.scale01 +
                              component.dx;
                            var y =
                              _point.y * component.scaleY +
                              _point.x * component.scale10 +
                              component.dy;
                            points.push(
                              new Point(_point.onCurve, _point.endContour, x, y)
                            );
                          }
                        }
                      }
                    } else {
                      points = glyph.points || [];
                    }
                    if (
                      glyph.phantomPoints &&
                      !this._font.directory.tables.HVAR
                    ) {
                      this._metrics.advanceWidth =
                        glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
                      this._metrics.advanceHeight =
                        glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
                      this._metrics.leftBearing =
                        glyph.xMin - glyph.phantomPoints[0].x;
                      this._metrics.topBearing =
                        glyph.phantomPoints[2].y - glyph.yMax;
                    }
                    var contours = [];
                    var cur = [];
                    for (var k = 0; k < points.length; k++) {
                      var point = points[k];
                      cur.push(point);
                      if (point.endContour) {
                        contours.push(cur);
                        cur = [];
                      }
                    }
                    return contours;
                  };
                  TTFGlyph.prototype._getMetrics = function _getMetrics() {
                    if (this._metrics) {
                      return this._metrics;
                    }
                    var cbox = this._getCBox(true);
                    _Glyph.prototype._getMetrics.call(this, cbox);
                    if (this._font._variationProcessor && !this._font.HVAR) {
                      this.path;
                    }
                    return this._metrics;
                  };
                  TTFGlyph.prototype._getPath = function _getPath() {
                    var contours = this._getContours();
                    var path = new Path();
                    for (var i = 0; i < contours.length; i++) {
                      var contour = contours[i];
                      var firstPt = contour[0];
                      var lastPt = contour[contour.length - 1];
                      var start = 0;
                      if (firstPt.onCurve) {
                        var curvePt = null;
                        start = 1;
                      } else {
                        if (lastPt.onCurve) {
                          firstPt = lastPt;
                        } else {
                          firstPt = new Point(
                            false,
                            false,
                            (firstPt.x + lastPt.x) / 2,
                            (firstPt.y + lastPt.y) / 2
                          );
                        }
                        var curvePt = firstPt;
                      }
                      path.moveTo(firstPt.x, firstPt.y);
                      for (var j = start; j < contour.length; j++) {
                        var pt = contour[j];
                        var prevPt = j === 0 ? firstPt : contour[j - 1];
                        if (prevPt.onCurve && pt.onCurve) {
                          path.lineTo(pt.x, pt.y);
                        } else if (prevPt.onCurve && !pt.onCurve) {
                          var curvePt = pt;
                        } else if (!prevPt.onCurve && !pt.onCurve) {
                          var midX = (prevPt.x + pt.x) / 2;
                          var midY = (prevPt.y + pt.y) / 2;
                          path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                          var curvePt = pt;
                        } else if (!prevPt.onCurve && pt.onCurve) {
                          path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                          var curvePt = null;
                        } else {
                          throw new Error("Unknown TTF path state");
                        }
                      }
                      if (curvePt) {
                        path.quadraticCurveTo(
                          curvePt.x,
                          curvePt.y,
                          firstPt.x,
                          firstPt.y
                        );
                      }
                      path.closePath();
                    }
                    return path;
                  };
                  return TTFGlyph;
                })(Glyph);
                var CFFGlyph = (function (_Glyph) {
                  _inherits(CFFGlyph, _Glyph);
                  function CFFGlyph() {
                    _classCallCheck(this, CFFGlyph);
                    return _possibleConstructorReturn(
                      this,
                      _Glyph.apply(this, arguments)
                    );
                  }
                  CFFGlyph.prototype._getName = function _getName() {
                    if (this._font.CFF2) {
                      return _Glyph.prototype._getName.call(this);
                    }
                    return this._font["CFF "].getGlyphName(this.id);
                  };
                  CFFGlyph.prototype.bias = function bias(s) {
                    if (s.length < 1240) {
                      return 107;
                    } else if (s.length < 33900) {
                      return 1131;
                    } else {
                      return 32768;
                    }
                  };
                  CFFGlyph.prototype._getPath = function _getPath() {
                    var cff = this._font.CFF2 || this._font["CFF "];
                    var stream = cff.stream;
                    var str = cff.topDict.CharStrings[this.id];
                    var end = str.offset + str.length;
                    stream.pos = str.offset;
                    var path = new Path();
                    var stack = [];
                    var trans = [];
                    var width = null;
                    var nStems = 0;
                    var x = 0,
                      y = 0;
                    var usedGsubrs = void 0;
                    var usedSubrs = void 0;
                    var open = false;
                    this._usedGsubrs = usedGsubrs = {};
                    this._usedSubrs = usedSubrs = {};
                    var gsubrs = cff.globalSubrIndex || [];
                    var gsubrsBias = this.bias(gsubrs);
                    var privateDict = cff.privateDictForGlyph(this.id) || {};
                    var subrs = privateDict.Subrs || [];
                    var subrsBias = this.bias(subrs);
                    var vstore =
                      cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
                    var vsindex = privateDict.vsindex;
                    var variationProcessor = this._font._variationProcessor;
                    function checkWidth() {
                      if (width == null) {
                        width = stack.shift() + privateDict.nominalWidthX;
                      }
                    }
                    function parseStems() {
                      if (stack.length % 2 !== 0) {
                        checkWidth();
                      }
                      nStems += stack.length >> 1;
                      return (stack.length = 0);
                    }
                    function moveTo(x, y) {
                      if (open) {
                        path.closePath();
                      }
                      path.moveTo(x, y);
                      open = true;
                    }
                    var parse = function parse() {
                      while (stream.pos < end) {
                        var op = stream.readUInt8();
                        if (op < 32) {
                          switch (op) {
                            case 1:
                            case 3:
                            case 18:
                            case 23:
                              parseStems();
                              break;
                            case 4:
                              if (stack.length > 1) {
                                checkWidth();
                              }
                              y += stack.shift();
                              moveTo(x, y);
                              break;
                            case 5:
                              while (stack.length >= 2) {
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                              }
                              break;
                            case 6:
                            case 7:
                              var phase = op === 6;
                              while (stack.length >= 1) {
                                if (phase) {
                                  x += stack.shift();
                                } else {
                                  y += stack.shift();
                                }
                                path.lineTo(x, y);
                                phase = !phase;
                              }
                              break;
                            case 8:
                              while (stack.length > 0) {
                                var c1x = x + stack.shift();
                                var c1y = y + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                              }
                              break;
                            case 10:
                              var index = stack.pop() + subrsBias;
                              var subr = subrs[index];
                              if (subr) {
                                usedSubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                              }
                              break;
                            case 11:
                              if (cff.version >= 2) {
                                break;
                              }
                              return;
                            case 14:
                              if (cff.version >= 2) {
                                break;
                              }
                              if (stack.length > 0) {
                                checkWidth();
                              }
                              if (open) {
                                path.closePath();
                                open = false;
                              }
                              break;
                            case 15: {
                              if (cff.version < 2) {
                                throw new Error(
                                  "vsindex operator not supported in CFF v1"
                                );
                              }
                              vsindex = stack.pop();
                              break;
                            }
                            case 16: {
                              if (cff.version < 2) {
                                throw new Error(
                                  "blend operator not supported in CFF v1"
                                );
                              }
                              if (!variationProcessor) {
                                throw new Error(
                                  "blend operator in non-variation font"
                                );
                              }
                              var blendVector = variationProcessor.getBlendVector(
                                vstore,
                                vsindex
                              );
                              var numBlends = stack.pop();
                              var numOperands = numBlends * blendVector.length;
                              var delta = stack.length - numOperands;
                              var base = delta - numBlends;
                              for (var i = 0; i < numBlends; i++) {
                                var sum = stack[base + i];
                                for (var j = 0; j < blendVector.length; j++) {
                                  sum += blendVector[j] * stack[delta++];
                                }
                                stack[base + i] = sum;
                              }
                              while (numOperands--) {
                                stack.pop();
                              }
                              break;
                            }
                            case 19:
                            case 20:
                              parseStems();
                              stream.pos += (nStems + 7) >> 3;
                              break;
                            case 21:
                              if (stack.length > 2) {
                                checkWidth();
                              }
                              x += stack.shift();
                              y += stack.shift();
                              moveTo(x, y);
                              break;
                            case 22:
                              if (stack.length > 1) {
                                checkWidth();
                              }
                              x += stack.shift();
                              moveTo(x, y);
                              break;
                            case 24:
                              while (stack.length >= 8) {
                                var c1x = x + stack.shift();
                                var c1y = y + stack.shift();
                                var c2x = c1x + stack.shift();
                                var c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                              }
                              x += stack.shift();
                              y += stack.shift();
                              path.lineTo(x, y);
                              break;
                            case 25:
                              while (stack.length >= 8) {
                                x += stack.shift();
                                y += stack.shift();
                                path.lineTo(x, y);
                              }
                              var c1x = x + stack.shift();
                              var c1y = y + stack.shift();
                              var c2x = c1x + stack.shift();
                              var c2y = c1y + stack.shift();
                              x = c2x + stack.shift();
                              y = c2y + stack.shift();
                              path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                              break;
                            case 26:
                              if (stack.length % 2) {
                                x += stack.shift();
                              }
                              while (stack.length >= 4) {
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x;
                                y = c2y + stack.shift();
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                              }
                              break;
                            case 27:
                              if (stack.length % 2) {
                                y += stack.shift();
                              }
                              while (stack.length >= 4) {
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                              }
                              break;
                            case 28:
                              stack.push(stream.readInt16BE());
                              break;
                            case 29:
                              index = stack.pop() + gsubrsBias;
                              subr = gsubrs[index];
                              if (subr) {
                                usedGsubrs[index] = true;
                                var p = stream.pos;
                                var e = end;
                                stream.pos = subr.offset;
                                end = subr.offset + subr.length;
                                parse();
                                stream.pos = p;
                                end = e;
                              }
                              break;
                            case 30:
                            case 31:
                              phase = op === 31;
                              while (stack.length >= 4) {
                                if (phase) {
                                  c1x = x + stack.shift();
                                  c1y = y;
                                  c2x = c1x + stack.shift();
                                  c2y = c1y + stack.shift();
                                  y = c2y + stack.shift();
                                  x =
                                    c2x +
                                    (stack.length === 1 ? stack.shift() : 0);
                                } else {
                                  c1x = x;
                                  c1y = y + stack.shift();
                                  c2x = c1x + stack.shift();
                                  c2y = c1y + stack.shift();
                                  x = c2x + stack.shift();
                                  y =
                                    c2y +
                                    (stack.length === 1 ? stack.shift() : 0);
                                }
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                                phase = !phase;
                              }
                              break;
                            case 12:
                              op = stream.readUInt8();
                              switch (op) {
                                case 3:
                                  var a = stack.pop();
                                  var b = stack.pop();
                                  stack.push(a && b ? 1 : 0);
                                  break;
                                case 4:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a || b ? 1 : 0);
                                  break;
                                case 5:
                                  a = stack.pop();
                                  stack.push(a ? 0 : 1);
                                  break;
                                case 9:
                                  a = stack.pop();
                                  stack.push(Math.abs(a));
                                  break;
                                case 10:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a + b);
                                  break;
                                case 11:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a - b);
                                  break;
                                case 12:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a / b);
                                  break;
                                case 14:
                                  a = stack.pop();
                                  stack.push(-a);
                                  break;
                                case 15:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a === b ? 1 : 0);
                                  break;
                                case 18:
                                  stack.pop();
                                  break;
                                case 20:
                                  var val = stack.pop();
                                  var idx = stack.pop();
                                  trans[idx] = val;
                                  break;
                                case 21:
                                  idx = stack.pop();
                                  stack.push(trans[idx] || 0);
                                  break;
                                case 22:
                                  var s1 = stack.pop();
                                  var s2 = stack.pop();
                                  var v1 = stack.pop();
                                  var v2 = stack.pop();
                                  stack.push(v1 <= v2 ? s1 : s2);
                                  break;
                                case 23:
                                  stack.push(Math.random());
                                  break;
                                case 24:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(a * b);
                                  break;
                                case 26:
                                  a = stack.pop();
                                  stack.push(Math.sqrt(a));
                                  break;
                                case 27:
                                  a = stack.pop();
                                  stack.push(a, a);
                                  break;
                                case 28:
                                  a = stack.pop();
                                  b = stack.pop();
                                  stack.push(b, a);
                                  break;
                                case 29:
                                  idx = stack.pop();
                                  if (idx < 0) {
                                    idx = 0;
                                  } else if (idx > stack.length - 1) {
                                    idx = stack.length - 1;
                                  }
                                  stack.push(stack[idx]);
                                  break;
                                case 30:
                                  var n = stack.pop();
                                  var _j = stack.pop();
                                  if (_j >= 0) {
                                    while (_j > 0) {
                                      var t = stack[n - 1];
                                      for (var _i = n - 2; _i >= 0; _i--) {
                                        stack[_i + 1] = stack[_i];
                                      }
                                      stack[0] = t;
                                      _j--;
                                    }
                                  } else {
                                    while (_j < 0) {
                                      var t = stack[0];
                                      for (var _i2 = 0; _i2 <= n; _i2++) {
                                        stack[_i2] = stack[_i2 + 1];
                                      }
                                      stack[n - 1] = t;
                                      _j++;
                                    }
                                  }
                                  break;
                                case 34:
                                  c1x = x + stack.shift();
                                  c1y = y;
                                  c2x = c1x + stack.shift();
                                  c2y = c1y + stack.shift();
                                  var c3x = c2x + stack.shift();
                                  var c3y = c2y;
                                  var c4x = c3x + stack.shift();
                                  var c4y = c3y;
                                  var c5x = c4x + stack.shift();
                                  var c5y = c4y;
                                  var c6x = c5x + stack.shift();
                                  var c6y = c5y;
                                  x = c6x;
                                  y = c6y;
                                  path.bezierCurveTo(
                                    c1x,
                                    c1y,
                                    c2x,
                                    c2y,
                                    c3x,
                                    c3y
                                  );
                                  path.bezierCurveTo(
                                    c4x,
                                    c4y,
                                    c5x,
                                    c5y,
                                    c6x,
                                    c6y
                                  );
                                  break;
                                case 35:
                                  var pts = [];
                                  for (var _i3 = 0; _i3 <= 5; _i3++) {
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                  }
                                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                  path.bezierCurveTo.apply(path, pts.slice(6));
                                  stack.shift();
                                  break;
                                case 36:
                                  c1x = x + stack.shift();
                                  c1y = y + stack.shift();
                                  c2x = c1x + stack.shift();
                                  c2y = c1y + stack.shift();
                                  c3x = c2x + stack.shift();
                                  c3y = c2y;
                                  c4x = c3x + stack.shift();
                                  c4y = c3y;
                                  c5x = c4x + stack.shift();
                                  c5y = c4y + stack.shift();
                                  c6x = c5x + stack.shift();
                                  c6y = c5y;
                                  x = c6x;
                                  y = c6y;
                                  path.bezierCurveTo(
                                    c1x,
                                    c1y,
                                    c2x,
                                    c2y,
                                    c3x,
                                    c3y
                                  );
                                  path.bezierCurveTo(
                                    c4x,
                                    c4y,
                                    c5x,
                                    c5y,
                                    c6x,
                                    c6y
                                  );
                                  break;
                                case 37:
                                  var startx = x;
                                  var starty = y;
                                  pts = [];
                                  for (var _i4 = 0; _i4 <= 4; _i4++) {
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                  }
                                  if (
                                    Math.abs(x - startx) > Math.abs(y - starty)
                                  ) {
                                    x += stack.shift();
                                    y = starty;
                                  } else {
                                    x = startx;
                                    y += stack.shift();
                                  }
                                  pts.push(x, y);
                                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                  path.bezierCurveTo.apply(path, pts.slice(6));
                                  break;
                                default:
                                  throw new Error("Unknown op: 12 " + op);
                              }
                              break;
                            default:
                              throw new Error("Unknown op: " + op);
                          }
                        } else if (op < 247) {
                          stack.push(op - 139);
                        } else if (op < 251) {
                          var b1 = stream.readUInt8();
                          stack.push((op - 247) * 256 + b1 + 108);
                        } else if (op < 255) {
                          var b1 = stream.readUInt8();
                          stack.push(-(op - 251) * 256 - b1 - 108);
                        } else {
                          stack.push(stream.readInt32BE() / 65536);
                        }
                      }
                    };
                    parse();
                    if (open) {
                      path.closePath();
                    }
                    return path;
                  };
                  return CFFGlyph;
                })(Glyph);
                var SBIXImage = new r.Struct({
                  originX: r.uint16,
                  originY: r.uint16,
                  type: new r.String(4),
                  data: new r.Buffer(function (t) {
                    return t.parent.buflen - t._currentOffset;
                  }),
                });
                var SBIXGlyph = (function (_TTFGlyph) {
                  _inherits(SBIXGlyph, _TTFGlyph);
                  function SBIXGlyph() {
                    _classCallCheck(this, SBIXGlyph);
                    return _possibleConstructorReturn(
                      this,
                      _TTFGlyph.apply(this, arguments)
                    );
                  }
                  SBIXGlyph.prototype.getImageForSize = function getImageForSize(
                    size
                  ) {
                    for (var i = 0; i < this._font.sbix.imageTables.length; i++) {
                      var table = this._font.sbix.imageTables[i];
                      if (table.ppem >= size) {
                        break;
                      }
                    }
                    var offsets = table.imageOffsets;
                    var start = offsets[this.id];
                    var end = offsets[this.id + 1];
                    if (start === end) {
                      return null;
                    }
                    this._font.stream.pos = start;
                    return SBIXImage.decode(this._font.stream, {
                      buflen: end - start,
                    });
                  };
                  SBIXGlyph.prototype.render = function render(ctx, size) {
                    var img = this.getImageForSize(size);
                    if (img != null) {
                      var scale = size / this._font.unitsPerEm;
                      ctx.image(img.data, {
                        height: size,
                        x: img.originX,
                        y: (this.bbox.minY - img.originY) * scale,
                      });
                    }
                    if (this._font.sbix.flags.renderOutlines) {
                      _TTFGlyph.prototype.render.call(this, ctx, size);
                    }
                  };
                  return SBIXGlyph;
                })(TTFGlyph);
                var COLRLayer = function COLRLayer(glyph, color) {
                  _classCallCheck(this, COLRLayer);
                  this.glyph = glyph;
                  this.color = color;
                };
                var COLRGlyph = (function (_Glyph) {
                  _inherits(COLRGlyph, _Glyph);
                  function COLRGlyph() {
                    _classCallCheck(this, COLRGlyph);
                    return _possibleConstructorReturn(
                      this,
                      _Glyph.apply(this, arguments)
                    );
                  }
                  COLRGlyph.prototype._getBBox = function _getBBox() {
                    var bbox = new BBox();
                    for (var i = 0; i < this.layers.length; i++) {
                      var layer = this.layers[i];
                      var b = layer.glyph.bbox;
                      bbox.addPoint(b.minX, b.minY);
                      bbox.addPoint(b.maxX, b.maxY);
                    }
                    return bbox;
                  };
                  COLRGlyph.prototype.render = function render(ctx, size) {
                    for (
                      var _iterator = this.layers,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var _ref2 = _ref,
                        glyph = _ref2.glyph,
                        color = _ref2.color;
                      ctx.fillColor(
                        [color.red, color.green, color.blue],
                        (color.alpha / 255) * 100
                      );
                      glyph.render(ctx, size);
                    }
                    return;
                  };
                  _createClass(COLRGlyph, [
                    {
                      key: "layers",
                      get: function get() {
                        var cpal = this._font.CPAL;
                        var colr = this._font.COLR;
                        var low = 0;
                        var high = colr.baseGlyphRecord.length - 1;
                        while (low <= high) {
                          var mid = (low + high) >> 1;
                          var rec = colr.baseGlyphRecord[mid];
                          if (this.id < rec.gid) {
                            high = mid - 1;
                          } else if (this.id > rec.gid) {
                            low = mid + 1;
                          } else {
                            var baseLayer = rec;
                            break;
                          }
                        }
                        if (baseLayer == null) {
                          var g = this._font._getBaseGlyph(this.id);
                          var color = {
                            red: 0,
                            green: 0,
                            blue: 0,
                            alpha: 255,
                          };
                          return [new COLRLayer(g, color)];
                        }
                        var layers = [];
                        for (
                          var i = baseLayer.firstLayerIndex;
                          i < baseLayer.firstLayerIndex + baseLayer.numLayers;
                          i++
                        ) {
                          var rec = colr.layerRecords[i];
                          var color = cpal.colorRecords[rec.paletteIndex];
                          var g = this._font._getBaseGlyph(rec.gid);
                          layers.push(new COLRLayer(g, color));
                        }
                        return layers;
                      },
                    },
                  ]);
                  return COLRGlyph;
                })(Glyph);
                var TUPLES_SHARE_POINT_NUMBERS = 32768;
                var TUPLE_COUNT_MASK = 4095;
                var EMBEDDED_TUPLE_COORD = 32768;
                var INTERMEDIATE_TUPLE = 16384;
                var PRIVATE_POINT_NUMBERS = 8192;
                var TUPLE_INDEX_MASK = 4095;
                var POINTS_ARE_WORDS = 128;
                var POINT_RUN_COUNT_MASK = 127;
                var DELTAS_ARE_ZERO = 128;
                var DELTAS_ARE_WORDS = 64;
                var DELTA_RUN_COUNT_MASK = 63;
                var GlyphVariationProcessor = (function () {
                  function GlyphVariationProcessor(font, coords) {
                    _classCallCheck(this, GlyphVariationProcessor);
                    this.font = font;
                    this.normalizedCoords = this.normalizeCoords(coords);
                    this.blendVectors = new _Map();
                  }
                  GlyphVariationProcessor.prototype.normalizeCoords =
                    function normalizeCoords(coords) {
                      var normalized = [];
                      for (var i = 0; i < this.font.fvar.axis.length; i++) {
                        var axis = this.font.fvar.axis[i];
                        if (coords[i] < axis.defaultValue) {
                          normalized.push(
                            (coords[i] - axis.defaultValue + _Number$EPSILON) /
                              (axis.defaultValue -
                                axis.minValue +
                                _Number$EPSILON)
                          );
                        } else {
                          normalized.push(
                            (coords[i] - axis.defaultValue + _Number$EPSILON) /
                              (axis.maxValue -
                                axis.defaultValue +
                                _Number$EPSILON)
                          );
                        }
                      }
                      if (this.font.avar) {
                        for (var i = 0; i < this.font.avar.segment.length; i++) {
                          var segment = this.font.avar.segment[i];
                          for (
                            var j = 0;
                            j < segment.correspondence.length;
                            j++
                          ) {
                            var pair = segment.correspondence[j];
                            if (j >= 1 && normalized[i] < pair.fromCoord) {
                              var prev = segment.correspondence[j - 1];
                              normalized[i] =
                                ((normalized[i] - prev.fromCoord) *
                                  (pair.toCoord - prev.toCoord) +
                                  _Number$EPSILON) /
                                  (pair.fromCoord -
                                    prev.fromCoord +
                                    _Number$EPSILON) +
                                prev.toCoord;
                              break;
                            }
                          }
                        }
                      }
                      return normalized;
                    };
                  GlyphVariationProcessor.prototype.transformPoints =
                    function transformPoints(gid, glyphPoints) {
                      if (!this.font.fvar || !this.font.gvar) {
                        return;
                      }
                      var gvar = this.font.gvar;
                      if (gid >= gvar.glyphCount) {
                        return;
                      }
                      var offset = gvar.offsets[gid];
                      if (offset === gvar.offsets[gid + 1]) {
                        return;
                      }
                      var stream = this.font.stream;
                      stream.pos = offset;
                      if (stream.pos >= stream.length) {
                        return;
                      }
                      var tupleCount = stream.readUInt16BE();
                      var offsetToData = offset + stream.readUInt16BE();
                      if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
                        var here = stream.pos;
                        stream.pos = offsetToData;
                        var sharedPoints = this.decodePoints();
                        offsetToData = stream.pos;
                        stream.pos = here;
                      }
                      var origPoints = glyphPoints.map(function (pt) {
                        return pt.copy();
                      });
                      tupleCount &= TUPLE_COUNT_MASK;
                      for (var i = 0; i < tupleCount; i++) {
                        var tupleDataSize = stream.readUInt16BE();
                        var tupleIndex = stream.readUInt16BE();
                        if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                          var tupleCoords = [];
                          for (var a = 0; a < gvar.axisCount; a++) {
                            tupleCoords.push(stream.readInt16BE() / 16384);
                          }
                        } else {
                          if (
                            (tupleIndex & TUPLE_INDEX_MASK) >=
                            gvar.globalCoordCount
                          ) {
                            throw new Error("Invalid gvar table");
                          }
                          var tupleCoords =
                            gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
                        }
                        if (tupleIndex & INTERMEDIATE_TUPLE) {
                          var startCoords = [];
                          for (var _a = 0; _a < gvar.axisCount; _a++) {
                            startCoords.push(stream.readInt16BE() / 16384);
                          }
                          var endCoords = [];
                          for (var _a2 = 0; _a2 < gvar.axisCount; _a2++) {
                            endCoords.push(stream.readInt16BE() / 16384);
                          }
                        }
                        var factor = this.tupleFactor(
                          tupleIndex,
                          tupleCoords,
                          startCoords,
                          endCoords
                        );
                        if (factor === 0) {
                          offsetToData += tupleDataSize;
                          continue;
                        }
                        var here = stream.pos;
                        stream.pos = offsetToData;
                        if (tupleIndex & PRIVATE_POINT_NUMBERS) {
                          var points = this.decodePoints();
                        } else {
                          var points = sharedPoints;
                        }
                        var nPoints =
                          points.length === 0
                            ? glyphPoints.length
                            : points.length;
                        var xDeltas = this.decodeDeltas(nPoints);
                        var yDeltas = this.decodeDeltas(nPoints);
                        if (points.length === 0) {
                          for (var _i = 0; _i < glyphPoints.length; _i++) {
                            var point = glyphPoints[_i];
                            point.x += Math.round(xDeltas[_i] * factor);
                            point.y += Math.round(yDeltas[_i] * factor);
                          }
                        } else {
                          var outPoints = origPoints.map(function (pt) {
                            return pt.copy();
                          });
                          var hasDelta = glyphPoints.map(function () {
                            return false;
                          });
                          for (var _i2 = 0; _i2 < points.length; _i2++) {
                            var idx = points[_i2];
                            if (idx < glyphPoints.length) {
                              var _point = outPoints[idx];
                              hasDelta[idx] = true;
                              _point.x += Math.round(xDeltas[_i2] * factor);
                              _point.y += Math.round(yDeltas[_i2] * factor);
                            }
                          }
                          this.interpolateMissingDeltas(
                            outPoints,
                            origPoints,
                            hasDelta
                          );
                          for (var _i3 = 0; _i3 < glyphPoints.length; _i3++) {
                            var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                            var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                            glyphPoints[_i3].x += deltaX;
                            glyphPoints[_i3].y += deltaY;
                          }
                        }
                        offsetToData += tupleDataSize;
                        stream.pos = here;
                      }
                    };
                  GlyphVariationProcessor.prototype.decodePoints =
                    function decodePoints() {
                      var stream = this.font.stream;
                      var count = stream.readUInt8();
                      if (count & POINTS_ARE_WORDS) {
                        count =
                          ((count & POINT_RUN_COUNT_MASK) << 8) |
                          stream.readUInt8();
                      }
                      var points = new Uint16Array(count);
                      var i = 0;
                      var point = 0;
                      while (i < count) {
                        var run = stream.readUInt8();
                        var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
                        var fn =
                          run & POINTS_ARE_WORDS
                            ? stream.readUInt16
                            : stream.readUInt8;
                        for (var j = 0; j < runCount && i < count; j++) {
                          point += fn.call(stream);
                          points[i++] = point;
                        }
                      }
                      return points;
                    };
                  GlyphVariationProcessor.prototype.decodeDeltas =
                    function decodeDeltas(count) {
                      var stream = this.font.stream;
                      var i = 0;
                      var deltas = new Int16Array(count);
                      while (i < count) {
                        var run = stream.readUInt8();
                        var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
                        if (run & DELTAS_ARE_ZERO) {
                          i += runCount;
                        } else {
                          var fn =
                            run & DELTAS_ARE_WORDS
                              ? stream.readInt16BE
                              : stream.readInt8;
                          for (var j = 0; j < runCount && i < count; j++) {
                            deltas[i++] = fn.call(stream);
                          }
                        }
                      }
                      return deltas;
                    };
                  GlyphVariationProcessor.prototype.tupleFactor =
                    function tupleFactor(
                      tupleIndex,
                      tupleCoords,
                      startCoords,
                      endCoords
                    ) {
                      var normalized = this.normalizedCoords;
                      var gvar = this.font.gvar;
                      var factor = 1;
                      for (var i = 0; i < gvar.axisCount; i++) {
                        if (tupleCoords[i] === 0) {
                          continue;
                        }
                        if (normalized[i] === 0) {
                          return 0;
                        }
                        if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                          if (
                            normalized[i] < Math.min(0, tupleCoords[i]) ||
                            normalized[i] > Math.max(0, tupleCoords[i])
                          ) {
                            return 0;
                          }
                          factor =
                            (factor * normalized[i] + _Number$EPSILON) /
                            (tupleCoords[i] + _Number$EPSILON);
                        } else {
                          if (
                            normalized[i] < startCoords[i] ||
                            normalized[i] > endCoords[i]
                          ) {
                            return 0;
                          } else if (normalized[i] < tupleCoords[i]) {
                            factor =
                              (factor *
                                (normalized[i] -
                                  startCoords[i] +
                                  _Number$EPSILON)) /
                              (tupleCoords[i] - startCoords[i] + _Number$EPSILON);
                          } else {
                            factor =
                              (factor *
                                (endCoords[i] -
                                  normalized[i] +
                                  _Number$EPSILON)) /
                              (endCoords[i] - tupleCoords[i] + _Number$EPSILON);
                          }
                        }
                      }
                      return factor;
                    };
                  GlyphVariationProcessor.prototype.interpolateMissingDeltas =
                    function interpolateMissingDeltas(
                      points,
                      inPoints,
                      hasDelta
                    ) {
                      if (points.length === 0) {
                        return;
                      }
                      var point = 0;
                      while (point < points.length) {
                        var firstPoint = point;
                        var endPoint = point;
                        var pt = points[endPoint];
                        while (!pt.endContour) {
                          pt = points[++endPoint];
                        }
                        while (point <= endPoint && !hasDelta[point]) {
                          point++;
                        }
                        if (point > endPoint) {
                          continue;
                        }
                        var firstDelta = point;
                        var curDelta = point;
                        point++;
                        while (point <= endPoint) {
                          if (hasDelta[point]) {
                            this.deltaInterpolate(
                              curDelta + 1,
                              point - 1,
                              curDelta,
                              point,
                              inPoints,
                              points
                            );
                            curDelta = point;
                          }
                          point++;
                        }
                        if (curDelta === firstDelta) {
                          this.deltaShift(
                            firstPoint,
                            endPoint,
                            curDelta,
                            inPoints,
                            points
                          );
                        } else {
                          this.deltaInterpolate(
                            curDelta + 1,
                            endPoint,
                            curDelta,
                            firstDelta,
                            inPoints,
                            points
                          );
                          if (firstDelta > 0) {
                            this.deltaInterpolate(
                              firstPoint,
                              firstDelta - 1,
                              curDelta,
                              firstDelta,
                              inPoints,
                              points
                            );
                          }
                        }
                        point = endPoint + 1;
                      }
                    };
                  GlyphVariationProcessor.prototype.deltaInterpolate =
                    function deltaInterpolate(
                      p1,
                      p2,
                      ref1,
                      ref2,
                      inPoints,
                      outPoints
                    ) {
                      if (p1 > p2) {
                        return;
                      }
                      var iterable = ["x", "y"];
                      for (var i = 0; i < iterable.length; i++) {
                        var k = iterable[i];
                        if (inPoints[ref1][k] > inPoints[ref2][k]) {
                          var p = ref1;
                          ref1 = ref2;
                          ref2 = p;
                        }
                        var in1 = inPoints[ref1][k];
                        var in2 = inPoints[ref2][k];
                        var out1 = outPoints[ref1][k];
                        var out2 = outPoints[ref2][k];
                        if (in1 !== in2 || out1 === out2) {
                          var scale =
                            in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                          for (var _p = p1; _p <= p2; _p++) {
                            var out = inPoints[_p][k];
                            if (out <= in1) {
                              out += out1 - in1;
                            } else if (out >= in2) {
                              out += out2 - in2;
                            } else {
                              out = out1 + (out - in1) * scale;
                            }
                            outPoints[_p][k] = out;
                          }
                        }
                      }
                    };
                  GlyphVariationProcessor.prototype.deltaShift =
                    function deltaShift(p1, p2, ref, inPoints, outPoints) {
                      var deltaX = outPoints[ref].x - inPoints[ref].x;
                      var deltaY = outPoints[ref].y - inPoints[ref].y;
                      if (deltaX === 0 && deltaY === 0) {
                        return;
                      }
                      for (var p = p1; p <= p2; p++) {
                        if (p !== ref) {
                          outPoints[p].x += deltaX;
                          outPoints[p].y += deltaY;
                        }
                      }
                    };
                  GlyphVariationProcessor.prototype.getAdvanceAdjustment =
                    function getAdvanceAdjustment(gid, table) {
                      var outerIndex = void 0,
                        innerIndex = void 0;
                      if (table.advanceWidthMapping) {
                        var idx = gid;
                        if (idx >= table.advanceWidthMapping.mapCount) {
                          idx = table.advanceWidthMapping.mapCount - 1;
                        }
                        var entryFormat = table.advanceWidthMapping.entryFormat;
                        var _table$advanceWidthMa =
                          table.advanceWidthMapping.mapData[idx];
                        outerIndex = _table$advanceWidthMa.outerIndex;
                        innerIndex = _table$advanceWidthMa.innerIndex;
                      } else {
                        outerIndex = 0;
                        innerIndex = gid;
                      }
                      return this.getDelta(
                        table.itemVariationStore,
                        outerIndex,
                        innerIndex
                      );
                    };
                  GlyphVariationProcessor.prototype.getDelta = function getDelta(
                    itemStore,
                    outerIndex,
                    innerIndex
                  ) {
                    if (outerIndex >= itemStore.itemVariationData.length) {
                      return 0;
                    }
                    var varData = itemStore.itemVariationData[outerIndex];
                    if (innerIndex >= varData.deltaSets.length) {
                      return 0;
                    }
                    var deltaSet = varData.deltaSets[innerIndex];
                    var blendVector = this.getBlendVector(itemStore, outerIndex);
                    var netAdjustment = 0;
                    for (
                      var master = 0;
                      master < varData.regionIndexCount;
                      master++
                    ) {
                      netAdjustment +=
                        deltaSet.deltas[master] * blendVector[master];
                    }
                    return netAdjustment;
                  };
                  GlyphVariationProcessor.prototype.getBlendVector =
                    function getBlendVector(itemStore, outerIndex) {
                      var varData = itemStore.itemVariationData[outerIndex];
                      if (this.blendVectors.has(varData)) {
                        return this.blendVectors.get(varData);
                      }
                      var normalizedCoords = this.normalizedCoords;
                      var blendVector = [];
                      for (
                        var master = 0;
                        master < varData.regionIndexCount;
                        master++
                      ) {
                        var scalar = 1;
                        var regionIndex = varData.regionIndexes[master];
                        var axes =
                          itemStore.variationRegionList.variationRegions[
                            regionIndex
                          ];
                        for (var j = 0; j < axes.length; j++) {
                          var axis = axes[j];
                          var axisScalar = void 0;
                          if (
                            axis.startCoord > axis.peakCoord ||
                            axis.peakCoord > axis.endCoord
                          ) {
                            axisScalar = 1;
                          } else if (
                            axis.startCoord < 0 &&
                            axis.endCoord > 0 &&
                            axis.peakCoord !== 0
                          ) {
                            axisScalar = 1;
                          } else if (axis.peakCoord === 0) {
                            axisScalar = 1;
                          } else if (
                            normalizedCoords[j] < axis.startCoord ||
                            normalizedCoords[j] > axis.endCoord
                          ) {
                            axisScalar = 0;
                          } else {
                            if (normalizedCoords[j] === axis.peakCoord) {
                              axisScalar = 1;
                            } else if (normalizedCoords[j] < axis.peakCoord) {
                              axisScalar =
                                (normalizedCoords[j] -
                                  axis.startCoord +
                                  _Number$EPSILON) /
                                (axis.peakCoord -
                                  axis.startCoord +
                                  _Number$EPSILON);
                            } else {
                              axisScalar =
                                (axis.endCoord -
                                  normalizedCoords[j] +
                                  _Number$EPSILON) /
                                (axis.endCoord -
                                  axis.peakCoord +
                                  _Number$EPSILON);
                            }
                          }
                          scalar *= axisScalar;
                        }
                        blendVector[master] = scalar;
                      }
                      this.blendVectors.set(varData, blendVector);
                      return blendVector;
                    };
                  return GlyphVariationProcessor;
                })();
                var resolved = _Promise.resolve();
                var Subset = (function () {
                  function Subset(font) {
                    _classCallCheck(this, Subset);
                    this.font = font;
                    this.glyphs = [];
                    this.mapping = {};
                    this.includeGlyph(0);
                  }
                  Subset.prototype.includeGlyph = function includeGlyph(glyph) {
                    if (
                      (typeof glyph === "undefined"
                        ? "undefined"
                        : _typeof(glyph)) === "object"
                    ) {
                      glyph = glyph.id;
                    }
                    if (this.mapping[glyph] == null) {
                      this.glyphs.push(glyph);
                      this.mapping[glyph] = this.glyphs.length - 1;
                    }
                    return this.mapping[glyph];
                  };
                  Subset.prototype.encodeStream = function encodeStream() {
                    var _this = this;
                    var s = new r.EncodeStream();
                    resolved.then(function () {
                      _this.encode(s);
                      return s.end();
                    });
                    return s;
                  };
                  return Subset;
                })();
                var ON_CURVE$1 = 1 << 0;
                var X_SHORT_VECTOR$1 = 1 << 1;
                var Y_SHORT_VECTOR$1 = 1 << 2;
                var REPEAT$1 = 1 << 3;
                var SAME_X$1 = 1 << 4;
                var SAME_Y$1 = 1 << 5;
                var Point$1 = (function () {
                  function Point() {
                    _classCallCheck(this, Point);
                  }
                  Point.size = function size(val) {
                    return val >= 0 && val <= 255 ? 1 : 2;
                  };
                  Point.encode = function encode(stream, value) {
                    if (value >= 0 && value <= 255) {
                      stream.writeUInt8(value);
                    } else {
                      stream.writeInt16BE(value);
                    }
                  };
                  return Point;
                })();
                var Glyf = new r.Struct({
                  numberOfContours: r.int16,
                  xMin: r.int16,
                  yMin: r.int16,
                  xMax: r.int16,
                  yMax: r.int16,
                  endPtsOfContours: new r.Array(r.uint16, "numberOfContours"),
                  instructions: new r.Array(r.uint8, r.uint16),
                  flags: new r.Array(r.uint8, 0),
                  xPoints: new r.Array(Point$1, 0),
                  yPoints: new r.Array(Point$1, 0),
                });
                var TTFGlyphEncoder = (function () {
                  function TTFGlyphEncoder() {
                    _classCallCheck(this, TTFGlyphEncoder);
                  }
                  TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(
                    path
                  ) {
                    var instructions =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : [];
                    var endPtsOfContours = [];
                    var xPoints = [];
                    var yPoints = [];
                    var flags = [];
                    var same = 0;
                    var lastX = 0,
                      lastY = 0,
                      lastFlag = 0;
                    var pointCount = 0;
                    for (var i = 0; i < path.commands.length; i++) {
                      var c = path.commands[i];
                      for (var j = 0; j < c.args.length; j += 2) {
                        var x = c.args[j];
                        var y = c.args[j + 1];
                        var flag = 0;
                        if (c.command === "quadraticCurveTo" && j === 2) {
                          var next = path.commands[i + 1];
                          if (next && next.command === "quadraticCurveTo") {
                            var midX = (lastX + next.args[0]) / 2;
                            var midY = (lastY + next.args[1]) / 2;
                            if (x === midX && y === midY) {
                              continue;
                            }
                          }
                        }
                        if (!(c.command === "quadraticCurveTo" && j === 0)) {
                          flag |= ON_CURVE$1;
                        }
                        flag = this._encodePoint(
                          x,
                          lastX,
                          xPoints,
                          flag,
                          X_SHORT_VECTOR$1,
                          SAME_X$1
                        );
                        flag = this._encodePoint(
                          y,
                          lastY,
                          yPoints,
                          flag,
                          Y_SHORT_VECTOR$1,
                          SAME_Y$1
                        );
                        if (flag === lastFlag && same < 255) {
                          flags[flags.length - 1] |= REPEAT$1;
                          same++;
                        } else {
                          if (same > 0) {
                            flags.push(same);
                            same = 0;
                          }
                          flags.push(flag);
                          lastFlag = flag;
                        }
                        lastX = x;
                        lastY = y;
                        pointCount++;
                      }
                      if (c.command === "closePath") {
                        endPtsOfContours.push(pointCount - 1);
                      }
                    }
                    if (
                      path.commands.length > 1 &&
                      path.commands[path.commands.length - 1].command !==
                        "closePath"
                    ) {
                      endPtsOfContours.push(pointCount - 1);
                    }
                    var bbox = path.bbox;
                    var glyf = {
                      numberOfContours: endPtsOfContours.length,
                      xMin: bbox.minX,
                      yMin: bbox.minY,
                      xMax: bbox.maxX,
                      yMax: bbox.maxY,
                      endPtsOfContours: endPtsOfContours,
                      instructions: instructions,
                      flags: flags,
                      xPoints: xPoints,
                      yPoints: yPoints,
                    };
                    var size = Glyf.size(glyf);
                    var tail = 4 - (size % 4);
                    var stream = new r.EncodeStream(size + tail);
                    Glyf.encode(stream, glyf);
                    if (tail !== 0) {
                      stream.fill(0, tail);
                    }
                    return stream.buffer;
                  };
                  TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(
                    value,
                    last,
                    points,
                    flag,
                    shortFlag,
                    sameFlag
                  ) {
                    var diff = value - last;
                    if (value === last) {
                      flag |= sameFlag;
                    } else {
                      if (-255 <= diff && diff <= 255) {
                        flag |= shortFlag;
                        if (diff < 0) {
                          diff = -diff;
                        } else {
                          flag |= sameFlag;
                        }
                      }
                      points.push(diff);
                    }
                    return flag;
                  };
                  return TTFGlyphEncoder;
                })();
                var TTFSubset = (function (_Subset) {
                  _inherits(TTFSubset, _Subset);
                  function TTFSubset(font) {
                    _classCallCheck(this, TTFSubset);
                    var _this = _possibleConstructorReturn(
                      this,
                      _Subset.call(this, font)
                    );
                    _this.glyphEncoder = new TTFGlyphEncoder();
                    return _this;
                  }
                  TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
                    var glyph = this.font.getGlyph(gid);
                    var glyf = glyph._decode();
                    var curOffset = this.font.loca.offsets[gid];
                    var nextOffset = this.font.loca.offsets[gid + 1];
                    var stream = this.font._getTableStream("glyf");
                    stream.pos += curOffset;
                    var buffer = stream.readBuffer(nextOffset - curOffset);
                    if (glyf && glyf.numberOfContours < 0) {
                      buffer = new Buffer(buffer);
                      for (
                        var _iterator = glyf.components,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var component = _ref;
                        gid = this.includeGlyph(component.glyphID);
                        buffer.writeUInt16BE(gid, component.pos);
                      }
                    } else if (glyf && this.font._variationProcessor) {
                      buffer = this.glyphEncoder.encodeSimple(
                        glyph.path,
                        glyf.instructions
                      );
                    }
                    this.glyf.push(buffer);
                    this.loca.offsets.push(this.offset);
                    this.hmtx.metrics.push({
                      advance: glyph.advanceWidth,
                      bearing: glyph._getMetrics().leftBearing,
                    });
                    this.offset += buffer.length;
                    return this.glyf.length - 1;
                  };
                  TTFSubset.prototype.encode = function encode(stream) {
                    this.glyf = [];
                    this.offset = 0;
                    this.loca = {
                      offsets: [],
                      version: this.font.loca.version,
                    };
                    this.hmtx = {
                      metrics: [],
                      bearings: [],
                    };
                    var i = 0;
                    while (i < this.glyphs.length) {
                      this._addGlyph(this.glyphs[i++]);
                    }
                    var maxp = cloneDeep(this.font.maxp);
                    maxp.numGlyphs = this.glyf.length;
                    this.loca.offsets.push(this.offset);
                    var head = cloneDeep(this.font.head);
                    head.indexToLocFormat = this.loca.version;
                    var hhea = cloneDeep(this.font.hhea);
                    hhea.numberOfMetrics = this.hmtx.metrics.length;
                    Directory.encode(stream, {
                      tables: {
                        head: head,
                        hhea: hhea,
                        loca: this.loca,
                        maxp: maxp,
                        "cvt ": this.font["cvt "],
                        prep: this.font.prep,
                        glyf: this.glyf,
                        hmtx: this.hmtx,
                        fpgm: this.font.fpgm,
                      },
                    });
                  };
                  return TTFSubset;
                })(Subset);
                var CFFSubset = (function (_Subset) {
                  _inherits(CFFSubset, _Subset);
                  function CFFSubset(font) {
                    _classCallCheck(this, CFFSubset);
                    var _this = _possibleConstructorReturn(
                      this,
                      _Subset.call(this, font)
                    );
                    _this.cff = _this.font["CFF "];
                    if (!_this.cff) {
                      throw new Error("Not a CFF Font");
                    }
                    return _this;
                  }
                  CFFSubset.prototype.subsetCharstrings =
                    function subsetCharstrings() {
                      this.charstrings = [];
                      var gsubrs = {};
                      for (
                        var _iterator = this.glyphs,
                          _isArray = Array.isArray(_iterator),
                          _i = 0,
                          _iterator = _isArray
                            ? _iterator
                            : _getIterator(_iterator);
                        ;
  
                      ) {
                        var _ref;
                        if (_isArray) {
                          if (_i >= _iterator.length) break;
                          _ref = _iterator[_i++];
                        } else {
                          _i = _iterator.next();
                          if (_i.done) break;
                          _ref = _i.value;
                        }
                        var gid = _ref;
                        this.charstrings.push(this.cff.getCharString(gid));
                        var glyph = this.font.getGlyph(gid);
                        var path = glyph.path;
                        for (var subr in glyph._usedGsubrs) {
                          gsubrs[subr] = true;
                        }
                      }
                      this.gsubrs = this.subsetSubrs(
                        this.cff.globalSubrIndex,
                        gsubrs
                      );
                    };
                  CFFSubset.prototype.subsetSubrs = function subsetSubrs(
                    subrs,
                    used
                  ) {
                    var res = [];
                    for (var i = 0; i < subrs.length; i++) {
                      var subr = subrs[i];
                      if (used[i]) {
                        this.cff.stream.pos = subr.offset;
                        res.push(this.cff.stream.readBuffer(subr.length));
                      } else {
                        res.push(new Buffer([11]));
                      }
                    }
                    return res;
                  };
                  CFFSubset.prototype.subsetFontdict = function subsetFontdict(
                    topDict
                  ) {
                    topDict.FDArray = [];
                    topDict.FDSelect = {
                      version: 0,
                      fds: [],
                    };
                    var used_fds = {};
                    var used_subrs = [];
                    for (
                      var _iterator2 = this.glyphs,
                        _isArray2 = Array.isArray(_iterator2),
                        _i2 = 0,
                        _iterator2 = _isArray2
                          ? _iterator2
                          : _getIterator(_iterator2);
                      ;
  
                    ) {
                      var _ref2;
                      if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                      } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                      }
                      var gid = _ref2;
                      var fd = this.cff.fdForGlyph(gid);
                      if (fd == null) {
                        continue;
                      }
                      if (!used_fds[fd]) {
                        topDict.FDArray.push(
                          _Object$assign({}, this.cff.topDict.FDArray[fd])
                        );
                        used_subrs.push({});
                      }
                      used_fds[fd] = true;
                      topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
                      var glyph = this.font.getGlyph(gid);
                      var path = glyph.path;
                      for (var subr in glyph._usedSubrs) {
                        used_subrs[used_subrs.length - 1][subr] = true;
                      }
                    }
                    for (var i = 0; i < topDict.FDArray.length; i++) {
                      var dict = topDict.FDArray[i];
                      delete dict.FontName;
                      if (dict.Private && dict.Private.Subrs) {
                        dict.Private = _Object$assign({}, dict.Private);
                        dict.Private.Subrs = this.subsetSubrs(
                          dict.Private.Subrs,
                          used_subrs[i]
                        );
                      }
                    }
                    return;
                  };
                  CFFSubset.prototype.createCIDFontdict =
                    function createCIDFontdict(topDict) {
                      var used_subrs = {};
                      for (
                        var _iterator3 = this.glyphs,
                          _isArray3 = Array.isArray(_iterator3),
                          _i3 = 0,
                          _iterator3 = _isArray3
                            ? _iterator3
                            : _getIterator(_iterator3);
                        ;
  
                      ) {
                        var _ref3;
                        if (_isArray3) {
                          if (_i3 >= _iterator3.length) break;
                          _ref3 = _iterator3[_i3++];
                        } else {
                          _i3 = _iterator3.next();
                          if (_i3.done) break;
                          _ref3 = _i3.value;
                        }
                        var gid = _ref3;
                        var glyph = this.font.getGlyph(gid);
                        var path = glyph.path;
                        for (var subr in glyph._usedSubrs) {
                          used_subrs[subr] = true;
                        }
                      }
                      var privateDict = _Object$assign(
                        {},
                        this.cff.topDict.Private
                      );
                      if (
                        this.cff.topDict.Private &&
                        this.cff.topDict.Private.Subrs
                      ) {
                        privateDict.Subrs = this.subsetSubrs(
                          this.cff.topDict.Private.Subrs,
                          used_subrs
                        );
                      }
                      topDict.FDArray = [{ Private: privateDict }];
                      return (topDict.FDSelect = {
                        version: 3,
                        nRanges: 1,
                        ranges: [
                          {
                            first: 0,
                            fd: 0,
                          },
                        ],
                        sentinel: this.charstrings.length,
                      });
                    };
                  CFFSubset.prototype.addString = function addString(string) {
                    if (!string) {
                      return null;
                    }
                    if (!this.strings) {
                      this.strings = [];
                    }
                    this.strings.push(string);
                    return standardStrings.length + this.strings.length - 1;
                  };
                  CFFSubset.prototype.encode = function encode(stream) {
                    this.subsetCharstrings();
                    var charset = {
                      version: this.charstrings.length > 255 ? 2 : 1,
                      ranges: [
                        {
                          first: 1,
                          nLeft: this.charstrings.length - 2,
                        },
                      ],
                    };
                    var topDict = _Object$assign({}, this.cff.topDict);
                    topDict.Private = null;
                    topDict.charset = charset;
                    topDict.Encoding = null;
                    topDict.CharStrings = this.charstrings;
                    var _arr = [
                      "version",
                      "Notice",
                      "Copyright",
                      "FullName",
                      "FamilyName",
                      "Weight",
                      "PostScript",
                      "BaseFontName",
                      "FontName",
                    ];
                    for (var _i4 = 0; _i4 < _arr.length; _i4++) {
                      var key = _arr[_i4];
                      topDict[key] = this.addString(
                        this.cff.string(topDict[key])
                      );
                    }
                    topDict.ROS = [
                      this.addString("Adobe"),
                      this.addString("Identity"),
                      0,
                    ];
                    topDict.CIDCount = this.charstrings.length;
                    if (this.cff.isCIDFont) {
                      this.subsetFontdict(topDict);
                    } else {
                      this.createCIDFontdict(topDict);
                    }
                    var top = {
                      version: 1,
                      hdrSize: this.cff.hdrSize,
                      offSize: 4,
                      header: this.cff.header,
                      nameIndex: [this.cff.postscriptName],
                      topDictIndex: [topDict],
                      stringIndex: this.strings,
                      globalSubrIndex: this.gsubrs,
                    };
                    CFFTop.encode(stream, top);
                  };
                  return CFFSubset;
                })(Subset);
                var _class;
                function _applyDecoratedDescriptor(
                  target,
                  property,
                  decorators,
                  descriptor,
                  context
                ) {
                  var desc = {};
                  Object["ke" + "ys"](descriptor).forEach(function (key) {
                    desc[key] = descriptor[key];
                  });
                  desc.enumerable = !!desc.enumerable;
                  desc.configurable = !!desc.configurable;
                  if ("value" in desc || desc.initializer) {
                    desc.writable = true;
                  }
                  desc = decorators
                    .slice()
                    .reverse()
                    .reduce(function (desc, decorator) {
                      return decorator(target, property, desc) || desc;
                    }, desc);
                  if (context && desc.initializer !== void 0) {
                    desc.value = desc.initializer
                      ? desc.initializer.call(context)
                      : void 0;
                    desc.initializer = undefined;
                  }
                  if (desc.initializer === void 0) {
                    Object["define" + "Property"](target, property, desc);
                    desc = null;
                  }
                  return desc;
                }
                var TTFFont =
                  ((_class = (function () {
                    TTFFont.probe = function probe(buffer) {
                      var format = buffer.toString("ascii", 0, 4);
                      return (
                        format === "true" ||
                        format === "OTTO" ||
                        format === String.fromCharCode(0, 1, 0, 0)
                      );
                    };
                    function TTFFont(stream) {
                      var variationCoords =
                        arguments.length > 1 && arguments[1] !== undefined
                          ? arguments[1]
                          : null;
                      _classCallCheck(this, TTFFont);
                      this.defaultLanguage = null;
                      this.stream = stream;
                      this.variationCoords = variationCoords;
                      this._directoryPos = this.stream.pos;
                      this._tables = {};
                      this._glyphs = {};
                      this._decodeDirectory();
                      for (var tag in this.directory.tables) {
                        var table = this.directory.tables[tag];
                        if (tables[tag] && table.length > 0) {
                          _Object$defineProperty(this, tag, {
                            get: this._getTable.bind(this, table),
                          });
                        }
                      }
                    }
                    TTFFont.prototype.setDefaultLanguage =
                      function setDefaultLanguage() {
                        var lang =
                          arguments.length > 0 && arguments[0] !== undefined
                            ? arguments[0]
                            : null;
                        this.defaultLanguage = lang;
                      };
                    TTFFont.prototype._getTable = function _getTable(table) {
                      if (!(table.tag in this._tables)) {
                        try {
                          this._tables[table.tag] = this._decodeTable(table);
                        } catch (e) {
                          if (fontkit.logErrors) {
                            console.error("Error decoding table " + table.tag);
                            console.error(e.stack);
                          }
                        }
                      }
                      return this._tables[table.tag];
                    };
                    TTFFont.prototype._getTableStream = function _getTableStream(
                      tag
                    ) {
                      var table = this.directory.tables[tag];
                      if (table) {
                        this.stream.pos = table.offset;
                        return this.stream;
                      }
                      return null;
                    };
                    TTFFont.prototype._decodeDirectory =
                      function _decodeDirectory() {
                        return (this.directory = Directory.decode(this.stream, {
                          _startOffset: 0,
                        }));
                      };
                    TTFFont.prototype._decodeTable = function _decodeTable(
                      table
                    ) {
                      var pos = this.stream.pos;
                      var stream = this._getTableStream(table.tag);
                      var result = tables[table.tag].decode(
                        stream,
                        this,
                        table.length
                      );
                      this.stream.pos = pos;
                      return result;
                    };
                    TTFFont.prototype.getName = function getName(key) {
                      var lang =
                        arguments.length > 1 && arguments[1] !== undefined
                          ? arguments[1]
                          : this.defaultLanguage || fontkit.defaultLanguage;
                      var record = this.name && this.name.records[key];
                      if (record) {
                        return (
                          record[lang] ||
                          record[this.defaultLanguage] ||
                          record[fontkit.defaultLanguage] ||
                          record["en"] ||
                          record[_Object$keys(record)[0]] ||
                          null
                        );
                      }
                      return null;
                    };
                    TTFFont.prototype.hasGlyphForCodePoint =
                      function hasGlyphForCodePoint(codePoint) {
                        return !!this._cmapProcessor.lookup(codePoint);
                      };
                    TTFFont.prototype.glyphForCodePoint =
                      function glyphForCodePoint(codePoint) {
                        return this.getGlyph(
                          this._cmapProcessor.lookup(codePoint),
                          [codePoint]
                        );
                      };
                    TTFFont.prototype.glyphsForString = function glyphsForString(
                      string
                    ) {
                      var glyphs = [];
                      var len = string.length;
                      var idx = 0;
                      var last = -1;
                      var state = -1;
                      while (idx <= len) {
                        var code = 0;
                        var nextState = 0;
                        if (idx < len) {
                          code = string.charCodeAt(idx++);
                          if (55296 <= code && code <= 56319 && idx < len) {
                            var next = string.charCodeAt(idx);
                            if (56320 <= next && next <= 57343) {
                              idx++;
                              code =
                                ((code & 1023) << 10) + (next & 1023) + 65536;
                            }
                          }
                          nextState =
                            (65024 <= code && code <= 65039) ||
                            (917760 <= code && code <= 917999)
                              ? 1
                              : 0;
                        } else {
                          idx++;
                        }
                        if (state === 0 && nextState === 1) {
                          glyphs.push(
                            this.getGlyph(
                              this._cmapProcessor.lookup(last, code),
                              [last, code]
                            )
                          );
                        } else if (state === 0 && nextState === 0) {
                          glyphs.push(this.glyphForCodePoint(last));
                        }
                        last = code;
                        state = nextState;
                      }
                      return glyphs;
                    };
                    TTFFont.prototype.layout = function layout(
                      string,
                      userFeatures,
                      script,
                      language,
                      direction
                    ) {
                      return this._layoutEngine.layout(
                        string,
                        userFeatures,
                        script,
                        language,
                        direction
                      );
                    };
                    TTFFont.prototype.stringsForGlyph = function stringsForGlyph(
                      gid
                    ) {
                      return this._layoutEngine.stringsForGlyph(gid);
                    };
                    TTFFont.prototype.getAvailableFeatures =
                      function getAvailableFeatures(script, language) {
                        return this._layoutEngine.getAvailableFeatures(
                          script,
                          language
                        );
                      };
                    TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(
                      glyph
                    ) {
                      var characters =
                        arguments.length > 1 && arguments[1] !== undefined
                          ? arguments[1]
                          : [];
                      if (!this._glyphs[glyph]) {
                        if (this.directory.tables.glyf) {
                          this._glyphs[glyph] = new TTFGlyph(
                            glyph,
                            characters,
                            this
                          );
                        } else if (
                          this.directory.tables["CFF "] ||
                          this.directory.tables.CFF2
                        ) {
                          this._glyphs[glyph] = new CFFGlyph(
                            glyph,
                            characters,
                            this
                          );
                        }
                      }
                      return this._glyphs[glyph] || null;
                    };
                    TTFFont.prototype.getGlyph = function getGlyph(glyph) {
                      var characters =
                        arguments.length > 1 && arguments[1] !== undefined
                          ? arguments[1]
                          : [];
                      if (!this._glyphs[glyph]) {
                        if (this.directory.tables.sbix) {
                          this._glyphs[glyph] = new SBIXGlyph(
                            glyph,
                            characters,
                            this
                          );
                        } else if (
                          this.directory.tables.COLR &&
                          this.directory.tables.CPAL
                        ) {
                          this._glyphs[glyph] = new COLRGlyph(
                            glyph,
                            characters,
                            this
                          );
                        } else {
                          this._getBaseGlyph(glyph, characters);
                        }
                      }
                      return this._glyphs[glyph] || null;
                    };
                    TTFFont.prototype.createSubset = function createSubset() {
                      if (this.directory.tables["CFF "]) {
                        return new CFFSubset(this);
                      }
                      return new TTFSubset(this);
                    };
                    TTFFont.prototype.getVariation = function getVariation(
                      settings
                    ) {
                      if (
                        !(
                          this.directory.tables.fvar &&
                          ((this.directory.tables.gvar &&
                            this.directory.tables.glyf) ||
                            this.directory.tables.CFF2)
                        )
                      ) {
                        throw new Error(
                          "Variations require a font with the fvar, gvar and glyf, or CFF2 tables."
                        );
                      }
                      if (typeof settings === "string") {
                        settings = this.namedVariations[settings];
                      }
                      if (
                        (typeof settings === "undefined"
                          ? "undefined"
                          : _typeof(settings)) !== "object"
                      ) {
                        throw new Error(
                          "Variation settings must be either a variation name or settings object."
                        );
                      }
                      var coords = this.fvar.axis.map(function (axis, i) {
                        var axisTag = axis.axisTag.trim();
                        if (axisTag in settings) {
                          return Math.max(
                            axis.minValue,
                            Math.min(axis.maxValue, settings[axisTag])
                          );
                        } else {
                          return axis.defaultValue;
                        }
                      });
                      var stream = new r.DecodeStream(this.stream.buffer);
                      stream.pos = this._directoryPos;
                      var font = new TTFFont(stream, coords);
                      font._tables = this._tables;
                      return font;
                    };
                    TTFFont.prototype.getFont = function getFont(name) {
                      return this.getVariation(name);
                    };
                    _createClass(TTFFont, [
                      {
                        key: "postscriptName",
                        get: function get() {
                          return this.getName("postscriptName");
                        },
                      },
                      {
                        key: "fullName",
                        get: function get() {
                          return this.getName("fullName");
                        },
                      },
                      {
                        key: "familyName",
                        get: function get() {
                          return this.getName("fontFamily");
                        },
                      },
                      {
                        key: "subfamilyName",
                        get: function get() {
                          return this.getName("fontSubfamily");
                        },
                      },
                      {
                        key: "copyright",
                        get: function get() {
                          return this.getName("copyright");
                        },
                      },
                      {
                        key: "version",
                        get: function get() {
                          return this.getName("version");
                        },
                      },
                      {
                        key: "ascent",
                        get: function get() {
                          return this.hhea.ascent;
                        },
                      },
                      {
                        key: "descent",
                        get: function get() {
                          return this.hhea.descent;
                        },
                      },
                      {
                        key: "lineGap",
                        get: function get() {
                          return this.hhea.lineGap;
                        },
                      },
                      {
                        key: "underlinePosition",
                        get: function get() {
                          return this.post.underlinePosition;
                        },
                      },
                      {
                        key: "underlineThickness",
                        get: function get() {
                          return this.post.underlineThickness;
                        },
                      },
                      {
                        key: "italicAngle",
                        get: function get() {
                          return this.post.italicAngle;
                        },
                      },
                      {
                        key: "capHeight",
                        get: function get() {
                          var os2 = this["OS/2"];
                          return os2 ? os2.capHeight : this.ascent;
                        },
                      },
                      {
                        key: "xHeight",
                        get: function get() {
                          var os2 = this["OS/2"];
                          return os2 ? os2.xHeight : 0;
                        },
                      },
                      {
                        key: "numGlyphs",
                        get: function get() {
                          return this.maxp.numGlyphs;
                        },
                      },
                      {
                        key: "unitsPerEm",
                        get: function get() {
                          return this.head.unitsPerEm;
                        },
                      },
                      {
                        key: "bbox",
                        get: function get() {
                          return _Object$freeze(
                            new BBox(
                              this.head.xMin,
                              this.head.yMin,
                              this.head.xMax,
                              this.head.yMax
                            )
                          );
                        },
                      },
                      {
                        key: "_cmapProcessor",
                        get: function get() {
                          return new CmapProcessor(this.cmap);
                        },
                      },
                      {
                        key: "characterSet",
                        get: function get() {
                          return this._cmapProcessor.getCharacterSet();
                        },
                      },
                      {
                        key: "_layoutEngine",
                        get: function get() {
                          return new LayoutEngine(this);
                        },
                      },
                      {
                        key: "availableFeatures",
                        get: function get() {
                          return this._layoutEngine.getAvailableFeatures();
                        },
                      },
                      {
                        key: "variationAxes",
                        get: function get() {
                          var res = {};
                          if (!this.fvar) {
                            return res;
                          }
                          for (
                            var _iterator = this.fvar.axis,
                              _isArray = Array.isArray(_iterator),
                              _i = 0,
                              _iterator = _isArray
                                ? _iterator
                                : _getIterator(_iterator);
                            ;
  
                          ) {
                            var _ref;
                            if (_isArray) {
                              if (_i >= _iterator.length) break;
                              _ref = _iterator[_i++];
                            } else {
                              _i = _iterator.next();
                              if (_i.done) break;
                              _ref = _i.value;
                            }
                            var axis = _ref;
                            res[axis.axisTag.trim()] = {
                              name: axis.name.en,
                              min: axis.minValue,
                              default: axis.defaultValue,
                              max: axis.maxValue,
                            };
                          }
                          return res;
                        },
                      },
                      {
                        key: "namedVariations",
                        get: function get() {
                          var res = {};
                          if (!this.fvar) {
                            return res;
                          }
                          for (
                            var _iterator2 = this.fvar.instance,
                              _isArray2 = Array.isArray(_iterator2),
                              _i2 = 0,
                              _iterator2 = _isArray2
                                ? _iterator2
                                : _getIterator(_iterator2);
                            ;
  
                          ) {
                            var _ref2;
                            if (_isArray2) {
                              if (_i2 >= _iterator2.length) break;
                              _ref2 = _iterator2[_i2++];
                            } else {
                              _i2 = _iterator2.next();
                              if (_i2.done) break;
                              _ref2 = _i2.value;
                            }
                            var instance = _ref2;
                            var settings = {};
                            for (var i = 0; i < this.fvar.axis.length; i++) {
                              var axis = this.fvar.axis[i];
                              settings[axis.axisTag.trim()] = instance.coord[i];
                            }
                            res[instance.name.en] = settings;
                          }
                          return res;
                        },
                      },
                      {
                        key: "_variationProcessor",
                        get: function get() {
                          if (!this.fvar) {
                            return null;
                          }
                          var variationCoords = this.variationCoords;
                          if (!variationCoords && !this.CFF2) {
                            return null;
                          }
                          if (!variationCoords) {
                            variationCoords = this.fvar.axis.map(function (axis) {
                              return axis.defaultValue;
                            });
                          }
                          return new GlyphVariationProcessor(
                            this,
                            variationCoords
                          );
                        },
                      },
                    ]);
                    return TTFFont;
                  })()),
                  (_applyDecoratedDescriptor(
                    _class.prototype,
                    "bbox",
                    [cache],
                    _Object$getOwnPropertyDescriptor(_class.prototype, "bbox"),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "_cmapProcessor",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "_cmapProcessor"
                    ),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "characterSet",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "characterSet"
                    ),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "_layoutEngine",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "_layoutEngine"
                    ),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "variationAxes",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "variationAxes"
                    ),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "namedVariations",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "namedVariations"
                    ),
                    _class.prototype
                  ),
                  _applyDecoratedDescriptor(
                    _class.prototype,
                    "_variationProcessor",
                    [cache],
                    _Object$getOwnPropertyDescriptor(
                      _class.prototype,
                      "_variationProcessor"
                    ),
                    _class.prototype
                  )),
                  _class);
                var WOFFDirectoryEntry = new r.Struct({
                  tag: new r.String(4),
                  offset: new r.Pointer(r.uint32, "void", { type: "global" }),
                  compLength: r.uint32,
                  length: r.uint32,
                  origChecksum: r.uint32,
                });
                var WOFFDirectory = new r.Struct({
                  tag: new r.String(4),
                  flavor: r.uint32,
                  length: r.uint32,
                  numTables: r.uint16,
                  reserved: new r.Reserved(r.uint16),
                  totalSfntSize: r.uint32,
                  majorVersion: r.uint16,
                  minorVersion: r.uint16,
                  metaOffset: r.uint32,
                  metaLength: r.uint32,
                  metaOrigLength: r.uint32,
                  privOffset: r.uint32,
                  privLength: r.uint32,
                  tables: new r.Array(WOFFDirectoryEntry, "numTables"),
                });
                WOFFDirectory.process = function () {
                  var tables = {};
                  for (
                    var _iterator = this.tables,
                      _isArray = Array.isArray(_iterator),
                      _i = 0,
                      _iterator = _isArray ? _iterator : _getIterator(_iterator);
                    ;
  
                  ) {
                    var _ref;
                    if (_isArray) {
                      if (_i >= _iterator.length) break;
                      _ref = _iterator[_i++];
                    } else {
                      _i = _iterator.next();
                      if (_i.done) break;
                      _ref = _i.value;
                    }
                    var table = _ref;
                    tables[table.tag] = table;
                  }
                  this.tables = tables;
                };
                var WOFFFont = (function (_TTFFont) {
                  _inherits(WOFFFont, _TTFFont);
                  function WOFFFont() {
                    _classCallCheck(this, WOFFFont);
                    return _possibleConstructorReturn(
                      this,
                      _TTFFont.apply(this, arguments)
                    );
                  }
                  WOFFFont.probe = function probe(buffer) {
                    return buffer.toString("ascii", 0, 4) === "wOFF";
                  };
                  WOFFFont.prototype._decodeDirectory =
                    function _decodeDirectory() {
                      this.directory = WOFFDirectory.decode(this.stream, {
                        _startOffset: 0,
                      });
                    };
                  WOFFFont.prototype._getTableStream = function _getTableStream(
                    tag
                  ) {
                    var table = this.directory.tables[tag];
                    if (table) {
                      this.stream.pos = table.offset;
                      if (table.compLength < table.length) {
                        this.stream.pos += 2;
                        var outBuffer = new Buffer(table.length);
                        var buf = inflate(
                          this.stream.readBuffer(table.compLength - 2),
                          outBuffer
                        );
                        return new r.DecodeStream(buf);
                      } else {
                        return this.stream;
                      }
                    }
                    return null;
                  };
                  return WOFFFont;
                })(TTFFont);
                var WOFF2Glyph = (function (_TTFGlyph) {
                  _inherits(WOFF2Glyph, _TTFGlyph);
                  function WOFF2Glyph() {
                    _classCallCheck(this, WOFF2Glyph);
                    return _possibleConstructorReturn(
                      this,
                      _TTFGlyph.apply(this, arguments)
                    );
                  }
                  WOFF2Glyph.prototype._decode = function _decode() {
                    return this._font._transformedGlyphs[this.id];
                  };
                  WOFF2Glyph.prototype._getCBox = function _getCBox() {
                    return this.path.bbox;
                  };
                  return WOFF2Glyph;
                })(TTFGlyph);
                var Base128 = {
                  decode: function decode(stream) {
                    var result = 0;
                    var iterable = [0, 1, 2, 3, 4];
                    for (var j = 0; j < iterable.length; j++) {
                      var i = iterable[j];
                      var code = stream.readUInt8();
                      if (result & 3758096384) {
                        throw new Error("Overflow");
                      }
                      result = (result << 7) | (code & 127);
                      if ((code & 128) === 0) {
                        return result;
                      }
                    }
                    throw new Error("Bad base 128 number");
                  },
                };
                var knownTags = [
                  "cmap",
                  "head",
                  "hhea",
                  "hmtx",
                  "maxp",
                  "name",
                  "OS/2",
                  "post",
                  "cvt ",
                  "fpgm",
                  "glyf",
                  "loca",
                  "prep",
                  "CFF ",
                  "VORG",
                  "EBDT",
                  "EBLC",
                  "gasp",
                  "hdmx",
                  "kern",
                  "LTSH",
                  "PCLT",
                  "VDMX",
                  "vhea",
                  "vmtx",
                  "BASE",
                  "GDEF",
                  "GPOS",
                  "GSUB",
                  "EBSC",
                  "JSTF",
                  "MATH",
                  "CBDT",
                  "CBLC",
                  "COLR",
                  "CPAL",
                  "SVG ",
                  "sbix",
                  "acnt",
                  "avar",
                  "bdat",
                  "bloc",
                  "bsln",
                  "cvar",
                  "fdsc",
                  "feat",
                  "fmtx",
                  "fvar",
                  "gvar",
                  "hsty",
                  "just",
                  "lcar",
                  "mort",
                  "morx",
                  "opbd",
                  "prop",
                  "trak",
                  "Zapf",
                  "Silf",
                  "Glat",
                  "Gloc",
                  "Feat",
                  "Sill",
                ];
                var WOFF2DirectoryEntry = new r.Struct({
                  flags: r.uint8,
                  customTag: new r.Optional(new r.String(4), function (t) {
                    return (t.flags & 63) === 63;
                  }),
                  tag: function tag(t) {
                    return t.customTag || knownTags[t.flags & 63];
                  },
                  length: Base128,
                  transformVersion: function transformVersion(t) {
                    return (t.flags >>> 6) & 3;
                  },
                  transformed: function transformed(t) {
                    return t.tag === "glyf" || t.tag === "loca"
                      ? t.transformVersion === 0
                      : t.transformVersion !== 0;
                  },
                  transformLength: new r.Optional(Base128, function (t) {
                    return t.transformed;
                  }),
                });
                var WOFF2Directory = new r.Struct({
                  tag: new r.String(4),
                  flavor: r.uint32,
                  length: r.uint32,
                  numTables: r.uint16,
                  reserved: new r.Reserved(r.uint16),
                  totalSfntSize: r.uint32,
                  totalCompressedSize: r.uint32,
                  majorVersion: r.uint16,
                  minorVersion: r.uint16,
                  metaOffset: r.uint32,
                  metaLength: r.uint32,
                  metaOrigLength: r.uint32,
                  privOffset: r.uint32,
                  privLength: r.uint32,
                  tables: new r.Array(WOFF2DirectoryEntry, "numTables"),
                });
                WOFF2Directory.process = function () {
                  var tables = {};
                  for (var i = 0; i < this.tables.length; i++) {
                    var table = this.tables[i];
                    tables[table.tag] = table;
                  }
                  return (this.tables = tables);
                };
                var WOFF2Font = (function (_TTFFont) {
                  _inherits(WOFF2Font, _TTFFont);
                  function WOFF2Font() {
                    _classCallCheck(this, WOFF2Font);
                    return _possibleConstructorReturn(
                      this,
                      _TTFFont.apply(this, arguments)
                    );
                  }
                  WOFF2Font.probe = function probe(buffer) {
                    return buffer.toString("ascii", 0, 4) === "wOF2";
                  };
                  WOFF2Font.prototype._decodeDirectory =
                    function _decodeDirectory() {
                      this.directory = WOFF2Directory.decode(this.stream);
                      this._dataPos = this.stream.pos;
                    };
                  WOFF2Font.prototype._decompress = function _decompress() {
                    if (!this._decompressed) {
                      this.stream.pos = this._dataPos;
                      var buffer = this.stream.readBuffer(
                        this.directory.totalCompressedSize
                      );
                      var decompressedSize = 0;
                      for (var tag in this.directory.tables) {
                        var entry = this.directory.tables[tag];
                        entry.offset = decompressedSize;
                        decompressedSize +=
                          entry.transformLength != null
                            ? entry.transformLength
                            : entry.length;
                      }
                      var decompressed = brotli(buffer, decompressedSize);
                      if (!decompressed) {
                        throw new Error(
                          "Error decoding compressed data in WOFF2"
                        );
                      }
                      this.stream = new r.DecodeStream(new Buffer(decompressed));
                      this._decompressed = true;
                    }
                  };
                  WOFF2Font.prototype._decodeTable = function _decodeTable(
                    table
                  ) {
                    this._decompress();
                    return _TTFFont.prototype._decodeTable.call(this, table);
                  };
                  WOFF2Font.prototype._getBaseGlyph = function _getBaseGlyph(
                    glyph
                  ) {
                    var characters =
                      arguments.length > 1 && arguments[1] !== undefined
                        ? arguments[1]
                        : [];
                    if (!this._glyphs[glyph]) {
                      if (
                        this.directory.tables.glyf &&
                        this.directory.tables.glyf.transformed
                      ) {
                        if (!this._transformedGlyphs) {
                          this._transformGlyfTable();
                        }
                        return (this._glyphs[glyph] = new WOFF2Glyph(
                          glyph,
                          characters,
                          this
                        ));
                      } else {
                        return _TTFFont.prototype._getBaseGlyph.call(
                          this,
                          glyph,
                          characters
                        );
                      }
                    }
                  };
                  WOFF2Font.prototype._transformGlyfTable =
                    function _transformGlyfTable() {
                      this._decompress();
                      this.stream.pos = this.directory.tables.glyf.offset;
                      var table = GlyfTable.decode(this.stream);
                      var glyphs = [];
                      for (var index = 0; index < table.numGlyphs; index++) {
                        var glyph = {};
                        var nContours = table.nContours.readInt16BE();
                        glyph.numberOfContours = nContours;
                        if (nContours > 0) {
                          var nPoints = [];
                          var totalPoints = 0;
                          for (var i = 0; i < nContours; i++) {
                            var _r = read255UInt16(table.nPoints);
                            totalPoints += _r;
                            nPoints.push(totalPoints);
                          }
                          glyph.points = decodeTriplet(
                            table.flags,
                            table.glyphs,
                            totalPoints
                          );
                          for (var _i = 0; _i < nContours; _i++) {
                            glyph.points[nPoints[_i] - 1].endContour = true;
                          }
                          var instructionSize = read255UInt16(table.glyphs);
                        } else if (nContours < 0) {
                          var haveInstructions =
                            TTFGlyph.prototype._decodeComposite.call(
                              { _font: this },
                              glyph,
                              table.composites
                            );
                          if (haveInstructions) {
                            var instructionSize = read255UInt16(table.glyphs);
                          }
                        }
                        glyphs.push(glyph);
                      }
                      this._transformedGlyphs = glyphs;
                    };
                  return WOFF2Font;
                })(TTFFont);
                var Substream = (function () {
                  function Substream(length) {
                    _classCallCheck(this, Substream);
                    this.length = length;
                    this._buf = new r.Buffer(length);
                  }
                  Substream.prototype.decode = function decode(stream, parent) {
                    return new r.DecodeStream(this._buf.decode(stream, parent));
                  };
                  return Substream;
                })();
                var GlyfTable = new r.Struct({
                  version: r.uint32,
                  numGlyphs: r.uint16,
                  indexFormat: r.uint16,
                  nContourStreamSize: r.uint32,
                  nPointsStreamSize: r.uint32,
                  flagStreamSize: r.uint32,
                  glyphStreamSize: r.uint32,
                  compositeStreamSize: r.uint32,
                  bboxStreamSize: r.uint32,
                  instructionStreamSize: r.uint32,
                  nContours: new Substream("nContourStreamSize"),
                  nPoints: new Substream("nPointsStreamSize"),
                  flags: new Substream("flagStreamSize"),
                  glyphs: new Substream("glyphStreamSize"),
                  composites: new Substream("compositeStreamSize"),
                  bboxes: new Substream("bboxStreamSize"),
                  instructions: new Substream("instructionStreamSize"),
                });
                var WORD_CODE = 253;
                var ONE_MORE_BYTE_CODE2 = 254;
                var ONE_MORE_BYTE_CODE1 = 255;
                var LOWEST_U_CODE = 253;
                function read255UInt16(stream) {
                  var code = stream.readUInt8();
                  if (code === WORD_CODE) {
                    return stream.readUInt16BE();
                  }
                  if (code === ONE_MORE_BYTE_CODE1) {
                    return stream.readUInt8() + LOWEST_U_CODE;
                  }
                  if (code === ONE_MORE_BYTE_CODE2) {
                    return stream.readUInt8() + LOWEST_U_CODE * 2;
                  }
                  return code;
                }
                function withSign(flag, baseval) {
                  return flag & 1 ? baseval : -baseval;
                }
                function decodeTriplet(flags, glyphs, nPoints) {
                  var y = void 0;
                  var x = (y = 0);
                  var res = [];
                  for (var i = 0; i < nPoints; i++) {
                    var dx = 0,
                      dy = 0;
                    var flag = flags.readUInt8();
                    var onCurve = !(flag >> 7);
                    flag &= 127;
                    if (flag < 10) {
                      dx = 0;
                      dy = withSign(
                        flag,
                        ((flag & 14) << 7) + glyphs.readUInt8()
                      );
                    } else if (flag < 20) {
                      dx = withSign(
                        flag,
                        (((flag - 10) & 14) << 7) + glyphs.readUInt8()
                      );
                      dy = 0;
                    } else if (flag < 84) {
                      var b0 = flag - 20;
                      var b1 = glyphs.readUInt8();
                      dx = withSign(flag, 1 + (b0 & 48) + (b1 >> 4));
                      dy = withSign(flag >> 1, 1 + ((b0 & 12) << 2) + (b1 & 15));
                    } else if (flag < 120) {
                      var b0 = flag - 84;
                      dx = withSign(
                        flag,
                        1 + ((b0 / 12) << 8) + glyphs.readUInt8()
                      );
                      dy = withSign(
                        flag >> 1,
                        1 + ((b0 % 12 >> 2) << 8) + glyphs.readUInt8()
                      );
                    } else if (flag < 124) {
                      var b1 = glyphs.readUInt8();
                      var b2 = glyphs.readUInt8();
                      dx = withSign(flag, (b1 << 4) + (b2 >> 4));
                      dy = withSign(
                        flag >> 1,
                        ((b2 & 15) << 8) + glyphs.readUInt8()
                      );
                    } else {
                      dx = withSign(flag, glyphs.readUInt16BE());
                      dy = withSign(flag >> 1, glyphs.readUInt16BE());
                    }
                    x += dx;
                    y += dy;
                    res.push(new Point(onCurve, false, x, y));
                  }
                  return res;
                }
                var TTCHeader = new r.VersionedStruct(r.uint32, {
                  65536: {
                    numFonts: r.uint32,
                    offsets: new r.Array(r.uint32, "numFonts"),
                  },
                  131072: {
                    numFonts: r.uint32,
                    offsets: new r.Array(r.uint32, "numFonts"),
                    dsigTag: r.uint32,
                    dsigLength: r.uint32,
                    dsigOffset: r.uint32,
                  },
                });
                var TrueTypeCollection = (function () {
                  TrueTypeCollection.probe = function probe(buffer) {
                    return buffer.toString("ascii", 0, 4) === "ttcf";
                  };
                  function TrueTypeCollection(stream) {
                    _classCallCheck(this, TrueTypeCollection);
                    this.stream = stream;
                    if (stream.readString(4) !== "ttcf") {
                      throw new Error("Not a TrueType collection");
                    }
                    this.header = TTCHeader.decode(stream);
                  }
                  TrueTypeCollection.prototype.getFont = function getFont(name) {
                    for (
                      var _iterator = this.header.offsets,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var offset = _ref;
                      var stream = new r.DecodeStream(this.stream.buffer);
                      stream.pos = offset;
                      var font = new TTFFont(stream);
                      if (font.postscriptName === name) {
                        return font;
                      }
                    }
                    return null;
                  };
                  _createClass(TrueTypeCollection, [
                    {
                      key: "fonts",
                      get: function get() {
                        var fonts = [];
                        for (
                          var _iterator2 = this.header.offsets,
                            _isArray2 = Array.isArray(_iterator2),
                            _i2 = 0,
                            _iterator2 = _isArray2
                              ? _iterator2
                              : _getIterator(_iterator2);
                          ;
  
                        ) {
                          var _ref2;
                          if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                          } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                          }
                          var offset = _ref2;
                          var stream = new r.DecodeStream(this.stream.buffer);
                          stream.pos = offset;
                          fonts.push(new TTFFont(stream));
                        }
                        return fonts;
                      },
                    },
                  ]);
                  return TrueTypeCollection;
                })();
                var DFontName = new r.String(r.uint8);
                var DFontData = new r.Struct({
                  len: r.uint32,
                  buf: new r.Buffer("len"),
                });
                var Ref = new r.Struct({
                  id: r.uint16,
                  nameOffset: r.int16,
                  attr: r.uint8,
                  dataOffset: r.uint24,
                  handle: r.uint32,
                });
                var Type = new r.Struct({
                  name: new r.String(4),
                  maxTypeIndex: r.uint16,
                  refList: new r.Pointer(
                    r.uint16,
                    new r.Array(Ref, function (t) {
                      return t.maxTypeIndex + 1;
                    }),
                    { type: "parent" }
                  ),
                });
                var TypeList = new r.Struct({
                  length: r.uint16,
                  types: new r.Array(Type, function (t) {
                    return t.length + 1;
                  }),
                });
                var DFontMap = new r.Struct({
                  reserved: new r.Reserved(r.uint8, 24),
                  typeList: new r.Pointer(r.uint16, TypeList),
                  nameListOffset: new r.Pointer(r.uint16, "void"),
                });
                var DFontHeader = new r.Struct({
                  dataOffset: r.uint32,
                  map: new r.Pointer(r.uint32, DFontMap),
                  dataLength: r.uint32,
                  mapLength: r.uint32,
                });
                var DFont = (function () {
                  DFont.probe = function probe(buffer) {
                    var stream = new r.DecodeStream(buffer);
                    try {
                      var header = DFontHeader.decode(stream);
                    } catch (e) {
                      return false;
                    }
                    for (
                      var _iterator = header.map.typeList.types,
                        _isArray = Array.isArray(_iterator),
                        _i = 0,
                        _iterator = _isArray
                          ? _iterator
                          : _getIterator(_iterator);
                      ;
  
                    ) {
                      var _ref;
                      if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                      } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                      }
                      var type = _ref;
                      if (type.name === "sfnt") {
                        return true;
                      }
                    }
                    return false;
                  };
                  function DFont(stream) {
                    _classCallCheck(this, DFont);
                    this.stream = stream;
                    this.header = DFontHeader.decode(this.stream);
                    for (
                      var _iterator2 = this.header.map.typeList.types,
                        _isArray2 = Array.isArray(_iterator2),
                        _i2 = 0,
                        _iterator2 = _isArray2
                          ? _iterator2
                          : _getIterator(_iterator2);
                      ;
  
                    ) {
                      var _ref2;
                      if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                      } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                      }
                      var type = _ref2;
                      for (
                        var _iterator3 = type.refList,
                          _isArray3 = Array.isArray(_iterator3),
                          _i3 = 0,
                          _iterator3 = _isArray3
                            ? _iterator3
                            : _getIterator(_iterator3);
                        ;
  
                      ) {
                        var _ref3;
                        if (_isArray3) {
                          if (_i3 >= _iterator3.length) break;
                          _ref3 = _iterator3[_i3++];
                        } else {
                          _i3 = _iterator3.next();
                          if (_i3.done) break;
                          _ref3 = _i3.value;
                        }
                        var ref = _ref3;
                        if (ref.nameOffset >= 0) {
                          this.stream.pos =
                            ref.nameOffset + this.header.map.nameListOffset;
                          ref.name = DFontName.decode(this.stream);
                        } else {
                          ref.name = null;
                        }
                      }
                      if (type.name === "sfnt") {
                        this.sfnt = type;
                      }
                    }
                  }
                  DFont.prototype.getFont = function getFont(name) {
                    if (!this.sfnt) {
                      return null;
                    }
                    for (
                      var _iterator4 = this.sfnt.refList,
                        _isArray4 = Array.isArray(_iterator4),
                        _i4 = 0,
                        _iterator4 = _isArray4
                          ? _iterator4
                          : _getIterator(_iterator4);
                      ;
  
                    ) {
                      var _ref4;
                      if (_isArray4) {
                        if (_i4 >= _iterator4.length) break;
                        _ref4 = _iterator4[_i4++];
                      } else {
                        _i4 = _iterator4.next();
                        if (_i4.done) break;
                        _ref4 = _i4.value;
                      }
                      var ref = _ref4;
                      var pos = this.header.dataOffset + ref.dataOffset + 4;
                      var stream = new r.DecodeStream(
                        this.stream.buffer.slice(pos)
                      );
                      var font = new TTFFont(stream);
                      if (font.postscriptName === name) {
                        return font;
                      }
                    }
                    return null;
                  };
                  _createClass(DFont, [
                    {
                      key: "fonts",
                      get: function get() {
                        var fonts = [];
                        for (
                          var _iterator5 = this.sfnt.refList,
                            _isArray5 = Array.isArray(_iterator5),
                            _i5 = 0,
                            _iterator5 = _isArray5
                              ? _iterator5
                              : _getIterator(_iterator5);
                          ;
  
                        ) {
                          var _ref5;
                          if (_isArray5) {
                            if (_i5 >= _iterator5.length) break;
                            _ref5 = _iterator5[_i5++];
                          } else {
                            _i5 = _iterator5.next();
                            if (_i5.done) break;
                            _ref5 = _i5.value;
                          }
                          var ref = _ref5;
                          var pos = this.header.dataOffset + ref.dataOffset + 4;
                          var stream = new r.DecodeStream(
                            this.stream.buffer.slice(pos)
                          );
                          fonts.push(new TTFFont(stream));
                        }
                        return fonts;
                      },
                    },
                  ]);
                  return DFont;
                })();
                fontkit.registerFormat(TTFFont);
                fontkit.registerFormat(WOFFFont);
                fontkit.registerFormat(WOFF2Font);
                fontkit.registerFormat(TrueTypeCollection);
                fontkit.registerFormat(DFont);
                module.exports = fontkit;
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          {
            "babel-runtime/core-js/array/from": 6,
            "babel-runtime/core-js/get-iterator": 7,
            "babel-runtime/core-js/map": 8,
            "babel-runtime/core-js/number/epsilon": 9,
            "babel-runtime/core-js/object/assign": 10,
            "babel-runtime/core-js/object/define-properties": 12,
            "babel-runtime/core-js/object/define-property": 13,
            "babel-runtime/core-js/object/freeze": 14,
            "babel-runtime/core-js/object/get-own-property-descriptor": 15,
            "babel-runtime/core-js/object/keys": 16,
            "babel-runtime/core-js/promise": 18,
            "babel-runtime/core-js/set": 19,
            "babel-runtime/core-js/string/from-code-point": 20,
            "babel-runtime/helpers/classCallCheck": 23,
            "babel-runtime/helpers/createClass": 24,
            "babel-runtime/helpers/inherits": 25,
            "babel-runtime/helpers/possibleConstructorReturn": 26,
            "babel-runtime/helpers/typeof": 27,
            "brotli/decompress": 39,
            buffer: 55,
            clone: 59,
            "deep-equal": 228,
            dfa: 230,
            fs: 54,
            "iconv-lite": 54,
            restructure: 279,
            "restructure/src/utils": 295,
            "tiny-inflate": 300,
            "unicode-properties": 303,
            "unicode-trie": 304,
          },
        ],
        233: [
          function (require, module, exports) {
            "use strict";
  
            /* eslint no-invalid-this: 1 */
  
            var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
            var slice = Array.prototype.slice;
            var toStr = Object.prototype.toString;
            var funcType = "[object Function]";
  
            module.exports = function bind(that) {
              var target = this;
              if (
                typeof target !== "function" ||
                toStr.call(target) !== funcType
              ) {
                throw new TypeError(ERROR_MESSAGE + target);
              }
              var args = slice.call(arguments, 1);
  
              var bound;
              var binder = function () {
                if (this instanceof bound) {
                  var result = target.apply(
                    this,
                    args.concat(slice.call(arguments))
                  );
                  if (Object(result) === result) {
                    return result;
                  }
                  return this;
                } else {
                  return target.apply(that, args.concat(slice.call(arguments)));
                }
              };
  
              var boundLength = Math.max(0, target.length - args.length);
              var boundArgs = [];
              for (var i = 0; i < boundLength; i++) {
                boundArgs.push("$" + i);
              }
  
              bound = Function(
                "binder",
                "return function (" +
                  boundArgs.join(",") +
                  "){ return binder.apply(this,arguments); }"
              )(binder);
  
              if (target.prototype) {
                var Empty = function Empty() {};
                Empty.prototype = target.prototype;
                bound.prototype = new Empty();
                Empty.prototype = null;
              }
  
              return bound;
            };
          },
          {},
        ],
        234: [
          function (require, module, exports) {
            "use strict";
  
            var implementation = require("./implementation");
  
            module.exports = Function.prototype.bind || implementation;
          },
          { "./implementation": 233 },
        ],
        235: [
          function (require, module, exports) {
            "use strict";
  
            var undefined;
  
            var $SyntaxError = SyntaxError;
            var $Function = Function;
            var $TypeError = TypeError;
  
            // eslint-disable-next-line consistent-return
            var getEvalledConstructor = function (expressionSyntax) {
              try {
                return $Function(
                  '"use strict"; return (' + expressionSyntax + ").constructor;"
                )();
              } catch (e) {}
            };
  
            var $gOPD = Object.getOwnPropertyDescriptor;
            if ($gOPD) {
              try {
                $gOPD({}, "");
              } catch (e) {
                $gOPD = null; // this is IE 8, which has a broken gOPD
              }
            }
  
            var throwTypeError = function () {
              throw new $TypeError();
            };
            var ThrowTypeError = $gOPD
              ? (function () {
                  try {
                    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
                    arguments.callee; // IE 8 does not throw here
                    return throwTypeError;
                  } catch (calleeThrows) {
                    try {
                      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
                      return $gOPD(arguments, "callee").get;
                    } catch (gOPDthrows) {
                      return throwTypeError;
                    }
                  }
                })()
              : throwTypeError;
  
            var hasSymbols = require("has-symbols")();
  
            var getProto =
              Object.getPrototypeOf ||
              function (x) {
                return x.__proto__;
              }; // eslint-disable-line no-proto
  
            var needsEval = {};
  
            var TypedArray =
              typeof Uint8Array === "undefined"
                ? undefined
                : getProto(Uint8Array);
  
            var INTRINSICS = {
              "%AggregateError%":
                typeof AggregateError === "undefined"
                  ? undefined
                  : AggregateError,
              "%Array%": Array,
              "%ArrayBuffer%":
                typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
              "%ArrayIteratorPrototype%": hasSymbols
                ? getProto([][Symbol.iterator]())
                : undefined,
              "%AsyncFromSyncIteratorPrototype%": undefined,
              "%AsyncFunction%": needsEval,
              "%AsyncGenerator%": needsEval,
              "%AsyncGeneratorFunction%": needsEval,
              "%AsyncIteratorPrototype%": needsEval,
              "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
              "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
              "%Boolean%": Boolean,
              "%DataView%":
                typeof DataView === "undefined" ? undefined : DataView,
              "%Date%": Date,
              "%decodeURI%": decodeURI,
              "%decodeURIComponent%": decodeURIComponent,
              "%encodeURI%": encodeURI,
              "%encodeURIComponent%": encodeURIComponent,
              "%Error%": Error,
              "%eval%": eval, // eslint-disable-line no-eval
              "%EvalError%": EvalError,
              "%Float32Array%":
                typeof Float32Array === "undefined" ? undefined : Float32Array,
              "%Float64Array%":
                typeof Float64Array === "undefined" ? undefined : Float64Array,
              "%FinalizationRegistry%":
                typeof FinalizationRegistry === "undefined"
                  ? undefined
                  : FinalizationRegistry,
              "%Function%": $Function,
              "%GeneratorFunction%": needsEval,
              "%Int8Array%":
                typeof Int8Array === "undefined" ? undefined : Int8Array,
              "%Int16Array%":
                typeof Int16Array === "undefined" ? undefined : Int16Array,
              "%Int32Array%":
                typeof Int32Array === "undefined" ? undefined : Int32Array,
              "%isFinite%": isFinite,
              "%isNaN%": isNaN,
              "%IteratorPrototype%": hasSymbols
                ? getProto(getProto([][Symbol.iterator]()))
                : undefined,
              "%JSON%": typeof JSON === "object" ? JSON : undefined,
              "%Map%": typeof Map === "undefined" ? undefined : Map,
              "%MapIteratorPrototype%":
                typeof Map === "undefined" || !hasSymbols
                  ? undefined
                  : getProto(new Map()[Symbol.iterator]()),
              "%Math%": Math,
              "%Number%": Number,
              "%Object%": Object,
              "%parseFloat%": parseFloat,
              "%parseInt%": parseInt,
              "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
              "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
              "%RangeError%": RangeError,
              "%ReferenceError%": ReferenceError,
              "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
              "%RegExp%": RegExp,
              "%Set%": typeof Set === "undefined" ? undefined : Set,
              "%SetIteratorPrototype%":
                typeof Set === "undefined" || !hasSymbols
                  ? undefined
                  : getProto(new Set()[Symbol.iterator]()),
              "%SharedArrayBuffer%":
                typeof SharedArrayBuffer === "undefined"
                  ? undefined
                  : SharedArrayBuffer,
              "%String%": String,
              "%StringIteratorPrototype%": hasSymbols
                ? getProto(""[Symbol.iterator]())
                : undefined,
              "%Symbol%": hasSymbols ? Symbol : undefined,
              "%SyntaxError%": $SyntaxError,
              "%ThrowTypeError%": ThrowTypeError,
              "%TypedArray%": TypedArray,
              "%TypeError%": $TypeError,
              "%Uint8Array%":
                typeof Uint8Array === "undefined" ? undefined : Uint8Array,
              "%Uint8ClampedArray%":
                typeof Uint8ClampedArray === "undefined"
                  ? undefined
                  : Uint8ClampedArray,
              "%Uint16Array%":
                typeof Uint16Array === "undefined" ? undefined : Uint16Array,
              "%Uint32Array%":
                typeof Uint32Array === "undefined" ? undefined : Uint32Array,
              "%URIError%": URIError,
              "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
              "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
              "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet,
            };
  
            var doEval = function doEval(name) {
              var value;
              if (name === "%AsyncFunction%") {
                value = getEvalledConstructor("async function () {}");
              } else if (name === "%GeneratorFunction%") {
                value = getEvalledConstructor("function* () {}");
              } else if (name === "%AsyncGeneratorFunction%") {
                value = getEvalledConstructor("async function* () {}");
              } else if (name === "%AsyncGenerator%") {
                var fn = doEval("%AsyncGeneratorFunction%");
                if (fn) {
                  value = fn.prototype;
                }
              } else if (name === "%AsyncIteratorPrototype%") {
                var gen = doEval("%AsyncGenerator%");
                if (gen) {
                  value = getProto(gen.prototype);
                }
              }
  
              INTRINSICS[name] = value;
  
              return value;
            };
  
            var LEGACY_ALIASES = {
              "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
              "%ArrayPrototype%": ["Array", "prototype"],
              "%ArrayProto_entries%": ["Array", "prototype", "entries"],
              "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
              "%ArrayProto_keys%": ["Array", "prototype", "keys"],
              "%ArrayProto_values%": ["Array", "prototype", "values"],
              "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
              "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
              "%AsyncGeneratorPrototype%": [
                "AsyncGeneratorFunction",
                "prototype",
                "prototype",
              ],
              "%BooleanPrototype%": ["Boolean", "prototype"],
              "%DataViewPrototype%": ["DataView", "prototype"],
              "%DatePrototype%": ["Date", "prototype"],
              "%ErrorPrototype%": ["Error", "prototype"],
              "%EvalErrorPrototype%": ["EvalError", "prototype"],
              "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
              "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
              "%FunctionPrototype%": ["Function", "prototype"],
              "%Generator%": ["GeneratorFunction", "prototype"],
              "%GeneratorPrototype%": [
                "GeneratorFunction",
                "prototype",
                "prototype",
              ],
              "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
              "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
              "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
              "%JSONParse%": ["JSON", "parse"],
              "%JSONStringify%": ["JSON", "stringify"],
              "%MapPrototype%": ["Map", "prototype"],
              "%NumberPrototype%": ["Number", "prototype"],
              "%ObjectPrototype%": ["Object", "prototype"],
              "%ObjProto_toString%": ["Object", "prototype", "toString"],
              "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
              "%PromisePrototype%": ["Promise", "prototype"],
              "%PromiseProto_then%": ["Promise", "prototype", "then"],
              "%Promise_all%": ["Promise", "all"],
              "%Promise_reject%": ["Promise", "reject"],
              "%Promise_resolve%": ["Promise", "resolve"],
              "%RangeErrorPrototype%": ["RangeError", "prototype"],
              "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
              "%RegExpPrototype%": ["RegExp", "prototype"],
              "%SetPrototype%": ["Set", "prototype"],
              "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
              "%StringPrototype%": ["String", "prototype"],
              "%SymbolPrototype%": ["Symbol", "prototype"],
              "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
              "%TypedArrayPrototype%": ["TypedArray", "prototype"],
              "%TypeErrorPrototype%": ["TypeError", "prototype"],
              "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
              "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
              "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
              "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
              "%URIErrorPrototype%": ["URIError", "prototype"],
              "%WeakMapPrototype%": ["WeakMap", "prototype"],
              "%WeakSetPrototype%": ["WeakSet", "prototype"],
            };
  
            var bind = require("function-bind");
            var hasOwn = require("has");
            var $concat = bind.call(Function.call, Array.prototype.concat);
            var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
            var $replace = bind.call(Function.call, String.prototype.replace);
            var $strSlice = bind.call(Function.call, String.prototype.slice);
  
            /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
            var rePropName =
              /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
            var reEscapeChar =
              /\\(\\)?/g; /** Used to match backslashes in property paths. */
            var stringToPath = function stringToPath(string) {
              var first = $strSlice(string, 0, 1);
              var last = $strSlice(string, -1);
              if (first === "%" && last !== "%") {
                throw new $SyntaxError(
                  "invalid intrinsic syntax, expected closing `%`"
                );
              } else if (last === "%" && first !== "%") {
                throw new $SyntaxError(
                  "invalid intrinsic syntax, expected opening `%`"
                );
              }
              var result = [];
              $replace(
                string,
                rePropName,
                function (match, number, quote, subString) {
                  result[result.length] = quote
                    ? $replace(subString, reEscapeChar, "$1")
                    : number || match;
                }
              );
              return result;
            };
            /* end adaptation */
  
            var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
              var intrinsicName = name;
              var alias;
              if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
                alias = LEGACY_ALIASES[intrinsicName];
                intrinsicName = "%" + alias[0] + "%";
              }
  
              if (hasOwn(INTRINSICS, intrinsicName)) {
                var value = INTRINSICS[intrinsicName];
                if (value === needsEval) {
                  value = doEval(intrinsicName);
                }
                if (typeof value === "undefined" && !allowMissing) {
                  throw new $TypeError(
                    "intrinsic " +
                      name +
                      " exists, but is not available. Please file an issue!"
                  );
                }
  
                return {
                  alias: alias,
                  name: intrinsicName,
                  value: value,
                };
              }
  
              throw new $SyntaxError("intrinsic " + name + " does not exist!");
            };
  
            module.exports = function GetIntrinsic(name, allowMissing) {
              if (typeof name !== "string" || name.length === 0) {
                throw new $TypeError("intrinsic name must be a non-empty string");
              }
              if (arguments.length > 1 && typeof allowMissing !== "boolean") {
                throw new $TypeError('"allowMissing" argument must be a boolean');
              }
  
              var parts = stringToPath(name);
              var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  
              var intrinsic = getBaseIntrinsic(
                "%" + intrinsicBaseName + "%",
                allowMissing
              );
              var intrinsicRealName = intrinsic.name;
              var value = intrinsic.value;
              var skipFurtherCaching = false;
  
              var alias = intrinsic.alias;
              if (alias) {
                intrinsicBaseName = alias[0];
                $spliceApply(parts, $concat([0, 1], alias));
              }
  
              for (var i = 1, isOwn = true; i < parts.length; i += 1) {
                var part = parts[i];
                var first = $strSlice(part, 0, 1);
                var last = $strSlice(part, -1);
                if (
                  (first === '"' ||
                    first === "'" ||
                    first === "`" ||
                    last === '"' ||
                    last === "'" ||
                    last === "`") &&
                  first !== last
                ) {
                  throw new $SyntaxError(
                    "property names with quotes must have matching quotes"
                  );
                }
                if (part === "constructor" || !isOwn) {
                  skipFurtherCaching = true;
                }
  
                intrinsicBaseName += "." + part;
                intrinsicRealName = "%" + intrinsicBaseName + "%";
  
                if (hasOwn(INTRINSICS, intrinsicRealName)) {
                  value = INTRINSICS[intrinsicRealName];
                } else if (value != null) {
                  if (!(part in value)) {
                    if (!allowMissing) {
                      throw new $TypeError(
                        "base intrinsic for " +
                          name +
                          " exists, but the property is not available."
                      );
                    }
                    return void undefined;
                  }
                  if ($gOPD && i + 1 >= parts.length) {
                    var desc = $gOPD(value, part);
                    isOwn = !!desc;
  
                    // By convention, when a data property is converted to an accessor
                    // property to emulate a data property that does not suffer from
                    // the override mistake, that accessor's getter is marked with
                    // an `originalValue` property. Here, when we detect this, we
                    // uphold the illusion by pretending to see that original data
                    // property, i.e., returning the value rather than the getter
                    // itself.
                    if (
                      isOwn &&
                      "get" in desc &&
                      !("originalValue" in desc.get)
                    ) {
                      value = desc.get;
                    } else {
                      value = value[part];
                    }
                  } else {
                    isOwn = hasOwn(value, part);
                    value = value[part];
                  }
  
                  if (isOwn && !skipFurtherCaching) {
                    INTRINSICS[intrinsicRealName] = value;
                  }
                }
              }
              return value;
            };
          },
          { "function-bind": 234, has: 238, "has-symbols": 236 },
        ],
        236: [
          function (require, module, exports) {
            "use strict";
  
            var origSymbol = typeof Symbol !== "undefined" && Symbol;
            var hasSymbolSham = require("./shams");
  
            module.exports = function hasNativeSymbols() {
              if (typeof origSymbol !== "function") {
                return false;
              }
              if (typeof Symbol !== "function") {
                return false;
              }
              if (typeof origSymbol("foo") !== "symbol") {
                return false;
              }
              if (typeof Symbol("bar") !== "symbol") {
                return false;
              }
  
              return hasSymbolSham();
            };
          },
          { "./shams": 237 },
        ],
        237: [
          function (require, module, exports) {
            "use strict";
  
            /* eslint complexity: [2, 18], max-statements: [2, 33] */
            module.exports = function hasSymbols() {
              if (
                typeof Symbol !== "function" ||
                typeof Object.getOwnPropertySymbols !== "function"
              ) {
                return false;
              }
              if (typeof Symbol.iterator === "symbol") {
                return true;
              }
  
              var obj = {};
              var sym = Symbol("test");
              var symObj = Object(sym);
              if (typeof sym === "string") {
                return false;
              }
  
              if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
                return false;
              }
              if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
                return false;
              }
  
              // temp disabled per https://github.com/ljharb/object.assign/issues/17
              // if (sym instanceof Symbol) { return false; }
              // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
              // if (!(symObj instanceof Symbol)) { return false; }
  
              // if (typeof Symbol.prototype.toString !== 'function') { return false; }
              // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
  
              var symVal = 42;
              obj[sym] = symVal;
              for (sym in obj) {
                return false;
              } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
              if (
                typeof Object.keys === "function" &&
                Object.keys(obj).length !== 0
              ) {
                return false;
              }
  
              if (
                typeof Object.getOwnPropertyNames === "function" &&
                Object.getOwnPropertyNames(obj).length !== 0
              ) {
                return false;
              }
  
              var syms = Object.getOwnPropertySymbols(obj);
              if (syms.length !== 1 || syms[0] !== sym) {
                return false;
              }
  
              if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
                return false;
              }
  
              if (typeof Object.getOwnPropertyDescriptor === "function") {
                var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
                if (
                  descriptor.value !== symVal ||
                  descriptor.enumerable !== true
                ) {
                  return false;
                }
              }
  
              return true;
            };
          },
          {},
        ],
        238: [
          function (require, module, exports) {
            "use strict";
  
            var bind = require("function-bind");
  
            module.exports = bind.call(
              Function.call,
              Object.prototype.hasOwnProperty
            );
          },
          { "function-bind": 234 },
        ],
        239: [
          function (require, module, exports) {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
            exports.read = function (buffer, offset, isLE, mLen, nBytes) {
              var e, m;
              var eLen = nBytes * 8 - mLen - 1;
              var eMax = (1 << eLen) - 1;
              var eBias = eMax >> 1;
              var nBits = -7;
              var i = isLE ? nBytes - 1 : 0;
              var d = isLE ? -1 : 1;
              var s = buffer[offset + i];
  
              i += d;
  
              e = s & ((1 << -nBits) - 1);
              s >>= -nBits;
              nBits += eLen;
              for (
                ;
                nBits > 0;
                e = e * 256 + buffer[offset + i], i += d, nBits -= 8
              ) {}
  
              m = e & ((1 << -nBits) - 1);
              e >>= -nBits;
              nBits += mLen;
              for (
                ;
                nBits > 0;
                m = m * 256 + buffer[offset + i], i += d, nBits -= 8
              ) {}
  
              if (e === 0) {
                e = 1 - eBias;
              } else if (e === eMax) {
                return m ? NaN : (s ? -1 : 1) * Infinity;
              } else {
                m = m + Math.pow(2, mLen);
                e = e - eBias;
              }
              return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
            };
  
            exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
              var e, m, c;
              var eLen = nBytes * 8 - mLen - 1;
              var eMax = (1 << eLen) - 1;
              var eBias = eMax >> 1;
              var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
              var i = isLE ? 0 : nBytes - 1;
              var d = isLE ? 1 : -1;
              var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
  
              value = Math.abs(value);
  
              if (isNaN(value) || value === Infinity) {
                m = isNaN(value) ? 1 : 0;
                e = eMax;
              } else {
                e = Math.floor(Math.log(value) / Math.LN2);
                if (value * (c = Math.pow(2, -e)) < 1) {
                  e--;
                  c *= 2;
                }
                if (e + eBias >= 1) {
                  value += rt / c;
                } else {
                  value += rt * Math.pow(2, 1 - eBias);
                }
                if (value * c >= 2) {
                  e++;
                  c /= 2;
                }
  
                if (e + eBias >= eMax) {
                  m = 0;
                  e = eMax;
                } else if (e + eBias >= 1) {
                  m = (value * c - 1) * Math.pow(2, mLen);
                  e = e + eBias;
                } else {
                  m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
                  e = 0;
                }
              }
  
              for (
                ;
                mLen >= 8;
                buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8
              ) {}
  
              e = (e << mLen) | m;
              eLen += mLen;
              for (
                ;
                eLen > 0;
                buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8
              ) {}
  
              buffer[offset + i - d] |= s * 128;
            };
          },
          {},
        ],
        240: [
          function (require, module, exports) {
            arguments[4][3][0].apply(exports, arguments);
          },
          { dup: 3 },
        ],
        241: [
          function (require, module, exports) {
            "use strict";
  
            var hasToStringTag =
              typeof Symbol === "function" &&
              typeof Symbol.toStringTag === "symbol";
            var callBound = require("call-bind/callBound");
  
            var $toString = callBound("Object.prototype.toString");
  
            var isStandardArguments = function isArguments(value) {
              if (
                hasToStringTag &&
                value &&
                typeof value === "object" &&
                Symbol.toStringTag in value
              ) {
                return false;
              }
              return $toString(value) === "[object Arguments]";
            };
  
            var isLegacyArguments = function isArguments(value) {
              if (isStandardArguments(value)) {
                return true;
              }
              return (
                value !== null &&
                typeof value === "object" &&
                typeof value.length === "number" &&
                value.length >= 0 &&
                $toString(value) !== "[object Array]" &&
                $toString(value.callee) === "[object Function]"
              );
            };
  
            var supportsStandardArguments = (function () {
              return isStandardArguments(arguments);
            })();
  
            isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
  
            module.exports = supportsStandardArguments
              ? isStandardArguments
              : isLegacyArguments;
          },
          { "call-bind/callBound": 57 },
        ],
        242: [
          function (require, module, exports) {
            /*!
             * Determine if an object is a Buffer
             *
             * @author   Feross Aboukhadijeh <https://feross.org>
             * @license  MIT
             */
  
            // The _isBuffer check is for Safari 5-7 support, because it's missing
            // Object.prototype.constructor. Remove this eventually
            module.exports = function (obj) {
              return (
                obj != null &&
                (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
              );
            };
  
            function isBuffer(obj) {
              return (
                !!obj.constructor &&
                typeof obj.constructor.isBuffer === "function" &&
                obj.constructor.isBuffer(obj)
              );
            }
  
            // For Node v0.10 support. Remove this eventually.
            function isSlowBuffer(obj) {
              return (
                typeof obj.readFloatLE === "function" &&
                typeof obj.slice === "function" &&
                isBuffer(obj.slice(0, 0))
              );
            }
          },
          {},
        ],
        243: [
          function (require, module, exports) {
            "use strict";
  
            var getDay = Date.prototype.getDay;
            var tryDateObject = function tryDateGetDayCall(value) {
              try {
                getDay.call(value);
                return true;
              } catch (e) {
                return false;
              }
            };
  
            var toStr = Object.prototype.toString;
            var dateClass = "[object Date]";
            var hasToStringTag =
              typeof Symbol === "function" && !!Symbol.toStringTag;
  
            module.exports = function isDateObject(value) {
              if (typeof value !== "object" || value === null) {
                return false;
              }
              return hasToStringTag
                ? tryDateObject(value)
                : toStr.call(value) === dateClass;
            };
          },
          {},
        ],
        244: [
          function (require, module, exports) {
            "use strict";
  
            var has = require("has");
            var regexExec = RegExp.prototype.exec;
            var gOPD = Object.getOwnPropertyDescriptor;
  
            var tryRegexExecCall = function tryRegexExec(value) {
              try {
                var lastIndex = value.lastIndex;
                value.lastIndex = 0;
  
                regexExec.call(value);
                return true;
              } catch (e) {
                return false;
              } finally {
                value.lastIndex = lastIndex;
              }
            };
            var toStr = Object.prototype.toString;
            var regexClass = "[object RegExp]";
            var hasToStringTag =
              typeof Symbol === "function" &&
              typeof Symbol.toStringTag === "symbol";
  
            module.exports = function isRegex(value) {
              if (!value || typeof value !== "object") {
                return false;
              }
              if (!hasToStringTag) {
                return toStr.call(value) === regexClass;
              }
  
              var descriptor = gOPD(value, "lastIndex");
              var hasLastIndexDataProperty =
                descriptor && has(descriptor, "value");
              if (!hasLastIndexDataProperty) {
                return false;
              }
  
              return tryRegexExecCall(value);
            };
          },
          { has: 238 },
        ],
        245: [
          function (require, module, exports) {
            var toString = {}.toString;
  
            module.exports =
              Array.isArray ||
              function (arr) {
                return toString.call(arr) == "[object Array]";
              };
          },
          {},
        ],
        246: [
          function (require, module, exports) {
            var lookup =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
  
            (function (exports) {
              "use strict";
  
              var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
  
              var PLUS = "+".charCodeAt(0);
              var SLASH = "/".charCodeAt(0);
              var NUMBER = "0".charCodeAt(0);
              var LOWER = "a".charCodeAt(0);
              var UPPER = "A".charCodeAt(0);
              var PLUS_URL_SAFE = "-".charCodeAt(0);
              var SLASH_URL_SAFE = "_".charCodeAt(0);
  
              function decode(elt) {
                var code = elt.charCodeAt(0);
                if (code === PLUS || code === PLUS_URL_SAFE) return 62; // '+'
                if (code === SLASH || code === SLASH_URL_SAFE) return 63; // '/'
                if (code < NUMBER) return -1; //no match
                if (code < NUMBER + 10) return code - NUMBER + 26 + 26;
                if (code < UPPER + 26) return code - UPPER;
                if (code < LOWER + 26) return code - LOWER + 26;
              }
  
              function b64ToByteArray(b64) {
                var i, j, l, tmp, placeHolders, arr;
  
                if (b64.length % 4 > 0) {
                  throw new Error(
                    "Invalid string. Length must be a multiple of 4"
                  );
                }
  
                // the number of equal signs (place holders)
                // if there are two placeholders, than the two characters before it
                // represent one byte
                // if there is only one, then the three characters before it represent 2 bytes
                // this is just a cheap hack to not do indexOf twice
                var len = b64.length;
                placeHolders =
                  "=" === b64.charAt(len - 2)
                    ? 2
                    : "=" === b64.charAt(len - 1)
                    ? 1
                    : 0;
  
                // base64 is 4/3 + up to two characters of the original data
                arr = new Arr((b64.length * 3) / 4 - placeHolders);
  
                // if there are placeholders, only get up to the last complete 4 chars
                l = placeHolders > 0 ? b64.length - 4 : b64.length;
  
                var L = 0;
  
                function push(v) {
                  arr[L++] = v;
                }
  
                for (i = 0, j = 0; i < l; i += 4, j += 3) {
                  tmp =
                    (decode(b64.charAt(i)) << 18) |
                    (decode(b64.charAt(i + 1)) << 12) |
                    (decode(b64.charAt(i + 2)) << 6) |
                    decode(b64.charAt(i + 3));
                  push((tmp & 0xff0000) >> 16);
                  push((tmp & 0xff00) >> 8);
                  push(tmp & 0xff);
                }
  
                if (placeHolders === 2) {
                  tmp =
                    (decode(b64.charAt(i)) << 2) |
                    (decode(b64.charAt(i + 1)) >> 4);
                  push(tmp & 0xff);
                } else if (placeHolders === 1) {
                  tmp =
                    (decode(b64.charAt(i)) << 10) |
                    (decode(b64.charAt(i + 1)) << 4) |
                    (decode(b64.charAt(i + 2)) >> 2);
                  push((tmp >> 8) & 0xff);
                  push(tmp & 0xff);
                }
  
                return arr;
              }
  
              function uint8ToBase64(uint8) {
                var i,
                  extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
                  output = "",
                  temp,
                  length;
  
                function encode(num) {
                  return lookup.charAt(num);
                }
  
                function tripletToBase64(num) {
                  return (
                    encode((num >> 18) & 0x3f) +
                    encode((num >> 12) & 0x3f) +
                    encode((num >> 6) & 0x3f) +
                    encode(num & 0x3f)
                  );
                }
  
                // go through the array every three bytes, we'll deal with trailing stuff later
                for (
                  i = 0, length = uint8.length - extraBytes;
                  i < length;
                  i += 3
                ) {
                  temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + uint8[i + 2];
                  output += tripletToBase64(temp);
                }
  
                // pad the end with zeros, but make sure to not forget the extra bytes
                switch (extraBytes) {
                  case 1:
                    temp = uint8[uint8.length - 1];
                    output += encode(temp >> 2);
                    output += encode((temp << 4) & 0x3f);
                    output += "==";
                    break;
                  case 2:
                    temp =
                      (uint8[uint8.length - 2] << 8) + uint8[uint8.length - 1];
                    output += encode(temp >> 10);
                    output += encode((temp >> 4) & 0x3f);
                    output += encode((temp << 2) & 0x3f);
                    output += "=";
                    break;
                }
  
                return output;
              }
  
              exports.toByteArray = b64ToByteArray;
              exports.fromByteArray = uint8ToBase64;
            })(typeof exports === "undefined" ? (this.base64js = {}) : exports);
          },
          {},
        ],
        247: [
          function (require, module, exports) {
            const inflate = require("tiny-inflate");
  
            // Shift size for getting the index-1 table offset.
            const SHIFT_1 = 6 + 5;
  
            // Shift size for getting the index-2 table offset.
            const SHIFT_2 = 5;
  
            // Difference between the two shift sizes,
            // for getting an index-1 offset from an index-2 offset. 6=11-5
            const SHIFT_1_2 = SHIFT_1 - SHIFT_2;
  
            // Number of index-1 entries for the BMP. 32=0x20
            // This part of the index-1 table is omitted from the serialized form.
            const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
  
            // Number of entries in an index-2 block. 64=0x40
            const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
  
            // Mask for getting the lower bits for the in-index-2-block offset. */
            const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
  
            // Shift size for shifting left the index array values.
            // Increases possible data size with 16-bit index values at the cost
            // of compactability.
            // This requires data blocks to be aligned by DATA_GRANULARITY.
            const INDEX_SHIFT = 2;
  
            // Number of entries in a data block. 32=0x20
            const DATA_BLOCK_LENGTH = 1 << SHIFT_2;
  
            // Mask for getting the lower bits for the in-data-block offset.
            const DATA_MASK = DATA_BLOCK_LENGTH - 1;
  
            // The part of the index-2 table for U+D800..U+DBFF stores values for
            // lead surrogate code _units_ not code _points_.
            // Values for lead surrogate code _points_ are indexed with this portion of the table.
            // Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
            const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
            const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
  
            // Count the lengths of both BMP pieces. 2080=0x820
            const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
  
            // The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
            // Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
            const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
            const UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; // U+0800 is the first code point after 2-byte UTF-8
  
            // The index-1 table, only used for supplementary code points, at offset 2112=0x840.
            // Variable length, for code points up to highStart, where the last single-value range starts.
            // Maximum length 512=0x200=0x100000>>SHIFT_1.
            // (For 0x100000 supplementary code points U+10000..U+10ffff.)
            //
            // The part of the index-2 table for supplementary code points starts
            // after this index-1 table.
            //
            // Both the index-1 table and the following part of the index-2 table
            // are omitted completely if there is only BMP data.
            const INDEX_1_OFFSET =
              UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
  
            // The alignment size of a data block. Also the granularity for compaction.
            const DATA_GRANULARITY = 1 << INDEX_SHIFT;
  
            class UnicodeTrie {
              constructor(data) {
                const isBuffer =
                  typeof data.readUInt32BE === "function" &&
                  typeof data.slice === "function";
  
                if (isBuffer || data instanceof Uint8Array) {
                  // read binary format
                  let uncompressedLength;
                  if (isBuffer) {
                    this.highStart = data.readUInt32BE(0);
                    this.errorValue = data.readUInt32BE(4);
                    uncompressedLength = data.readUInt32BE(8);
                    data = data.slice(12);
                  } else {
                    const view = new DataView(data.buffer);
                    this.highStart = view.getUint32(0);
                    this.errorValue = view.getUint32(4);
                    uncompressedLength = view.getUint32(8);
                    data = data.subarray(12);
                  }
  
                  // double inflate the actual trie data
                  data = inflate(data, new Uint8Array(uncompressedLength));
                  data = inflate(data, new Uint8Array(uncompressedLength));
                  this.data = new Uint32Array(data.buffer);
                } else {
                  // pre-parsed data
                  ({
                    data: this.data,
                    highStart: this.highStart,
                    errorValue: this.errorValue,
                  } = data);
                }
              }
  
              get(codePoint) {
                let index;
                if (codePoint < 0 || codePoint > 0x10ffff) {
                  return this.errorValue;
                }
  
                if (
                  codePoint < 0xd800 ||
                  (codePoint > 0xdbff && codePoint <= 0xffff)
                ) {
                  // Ordinary BMP code point, excluding leading surrogates.
                  // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
                  // data is stored in the index array itself.
                  index =
                    (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                if (codePoint <= 0xffff) {
                  // Lead Surrogate Code Point.  A Separate index section is stored for
                  // lead surrogate code units and code points.
                  //   The main index has the code unit data.
                  //   For this function, we need the code point data.
                  index =
                    (this.data[
                      LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)
                    ] <<
                      INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                if (codePoint < this.highStart) {
                  // Supplemental code point, use two-level lookup.
                  index =
                    this.data[
                      INDEX_1_OFFSET -
                        OMITTED_BMP_INDEX_1_LENGTH +
                        (codePoint >> SHIFT_1)
                    ];
                  index =
                    this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
                  index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                return this.data[this.data.length - DATA_GRANULARITY];
              }
            }
  
            module.exports = UnicodeTrie;
          },
          { "tiny-inflate": 300 },
        ],
        248: [
          function (require, module, exports) {
            // The following break classes are handled by the pair table
  
            exports.OP = 0; // Opening punctuation
            exports.CL = 1; // Closing punctuation
            exports.CP = 2; // Closing parenthesis
            exports.QU = 3; // Ambiguous quotation
            exports.GL = 4; // Glue
            exports.NS = 5; // Non-starters
            exports.EX = 6; // Exclamation/Interrogation
            exports.SY = 7; // Symbols allowing break after
            exports.IS = 8; // Infix separator
            exports.PR = 9; // Prefix
            exports.PO = 10; // Postfix
            exports.NU = 11; // Numeric
            exports.AL = 12; // Alphabetic
            exports.HL = 13; // Hebrew Letter
            exports.ID = 14; // Ideographic
            exports.IN = 15; // Inseparable characters
            exports.HY = 16; // Hyphen
            exports.BA = 17; // Break after
            exports.BB = 18; // Break before
            exports.B2 = 19; // Break on either side (but not pair)
            exports.ZW = 20; // Zero-width space
            exports.CM = 21; // Combining marks
            exports.WJ = 22; // Word joiner
            exports.H2 = 23; // Hangul LV
            exports.H3 = 24; // Hangul LVT
            exports.JL = 25; // Hangul L Jamo
            exports.JV = 26; // Hangul V Jamo
            exports.JT = 27; // Hangul T Jamo
            exports.RI = 28; // Regional Indicator
  
            // The following break classes are not handled by the pair table
            exports.AI = 29; // Ambiguous (Alphabetic or Ideograph)
            exports.BK = 30; // Break (mandatory)
            exports.CB = 31; // Contingent break
            exports.CJ = 32; // Conditional Japanese Starter
            exports.CR = 33; // Carriage return
            exports.LF = 34; // Line feed
            exports.NL = 35; // Next line
            exports.SA = 36; // South-East Asian
            exports.SG = 37; // Surrogates
            exports.SP = 38; // Space
            exports.XX = 39; // Unknown
          },
          {},
        ],
        249: [
          function (require, module, exports) {
            let AI, AL, BA, BK, CB, CJ, CR, ID, LF, NL, NS, SA, SG, SP, WJ, XX;
            const UnicodeTrie = require("unicode-trie");
  
            const base64 = require("base64-js");
            ({
              BK,
              CR,
              LF,
              NL,
              CB,
              BA,
              SP,
              WJ,
              SP,
              BK,
              LF,
              NL,
              AI,
              AL,
              SA,
              SG,
              XX,
              CJ,
              ID,
              NS,
            } = require("./classes"));
            const {
              DI_BRK,
              IN_BRK,
              CI_BRK,
              CP_BRK,
              PR_BRK,
              pairTable,
            } = require("./pairs");
  
            const data = base64.toByteArray(
              "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"
            );
            const classTrie = new UnicodeTrie(data);
  
            const mapClass = function (c) {
              switch (c) {
                case AI:
                  return AL;
                case SA:
                case SG:
                case XX:
                  return AL;
                case CJ:
                  return NS;
                default:
                  return c;
              }
            };
  
            const mapFirst = function (c) {
              switch (c) {
                case LF:
                case NL:
                  return BK;
                case CB:
                  return BA;
                case SP:
                  return WJ;
                default:
                  return c;
              }
            };
  
            class Break {
              constructor(position, required = false) {
                this.position = position;
                this.required = required;
              }
            }
  
            class LineBreaker {
              constructor(string) {
                this.string = string;
                this.pos = 0;
                this.lastPos = 0;
                this.curClass = null;
                this.nextClass = null;
              }
  
              nextCodePoint() {
                const code = this.string.charCodeAt(this.pos++);
                const next = this.string.charCodeAt(this.pos);
  
                // If a surrogate pair
                if (
                  0xd800 <= code &&
                  code <= 0xdbff &&
                  0xdc00 <= next &&
                  next <= 0xdfff
                ) {
                  this.pos++;
                  return (code - 0xd800) * 0x400 + (next - 0xdc00) + 0x10000;
                }
  
                return code;
              }
  
              nextCharClass() {
                return mapClass(classTrie.get(this.nextCodePoint()));
              }
  
              nextBreak() {
                // get the first char if we're at the beginning of the string
                if (this.curClass == null) {
                  this.curClass = mapFirst(this.nextCharClass());
                }
  
                while (this.pos < this.string.length) {
                  this.lastPos = this.pos;
                  const lastClass = this.nextClass;
                  this.nextClass = this.nextCharClass();
  
                  // explicit newline
                  if (
                    this.curClass === BK ||
                    (this.curClass === CR && this.nextClass !== LF)
                  ) {
                    this.curClass = mapFirst(mapClass(this.nextClass));
                    return new Break(this.lastPos, true);
                  }
  
                  // handle classes not handled by the pair table
                  let cur;
                  switch (this.nextClass) {
                    case SP:
                      cur = this.curClass;
                      break;
                    case BK:
                    case LF:
                    case NL:
                      cur = BK;
                      break;
                    case CR:
                      cur = CR;
                      break;
                    case CB:
                      cur = BA;
                      break;
                  }
  
                  if (cur != null) {
                    this.curClass = cur;
                    if (this.nextClass === CB) {
                      return new Break(this.lastPos);
                    }
                    continue;
                  }
  
                  // if not handled already, use the pair table
                  let shouldBreak = false;
                  switch (pairTable[this.curClass][this.nextClass]) {
                    case DI_BRK: // Direct break
                      shouldBreak = true;
                      break;
  
                    case IN_BRK: // possible indirect break
                      shouldBreak = lastClass === SP;
                      break;
  
                    case CI_BRK:
                      shouldBreak = lastClass === SP;
                      if (!shouldBreak) {
                        continue;
                      }
                      break;
  
                    case CP_BRK: // prohibited for combining marks
                      if (lastClass !== SP) {
                        continue;
                      }
                      break;
                  }
  
                  this.curClass = this.nextClass;
                  if (shouldBreak) {
                    return new Break(this.lastPos);
                  }
                }
  
                if (this.pos >= this.string.length) {
                  if (this.lastPos < this.string.length) {
                    this.lastPos = this.string.length;
                    return new Break(this.string.length);
                  } else {
                    return null;
                  }
                }
              }
            }
  
            module.exports = LineBreaker;
          },
          {
            "./classes": 248,
            "./pairs": 250,
            "base64-js": 246,
            "unicode-trie": 247,
          },
        ],
        250: [
          function (require, module, exports) {
            let CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;
            exports.DI_BRK = DI_BRK = 0; // Direct break opportunity
            exports.IN_BRK = IN_BRK = 1; // Indirect break opportunity
            exports.CI_BRK = CI_BRK = 2; // Indirect break opportunity for combining marks
            exports.CP_BRK = CP_BRK = 3; // Prohibited break for combining marks
            exports.PR_BRK = PR_BRK = 4; // Prohibited break
  
            // table generated from http://www.unicode.org/reports/tr14/#Table2
            exports.pairTable = [
              [
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                CP_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                PR_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                IN_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                DI_BRK,
              ],
              [
                DI_BRK,
                PR_BRK,
                PR_BRK,
                IN_BRK,
                IN_BRK,
                IN_BRK,
                PR_BRK,
                PR_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
                IN_BRK,
                DI_BRK,
                DI_BRK,
                PR_BRK,
                CI_BRK,
                PR_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                DI_BRK,
                IN_BRK,
              ],
            ];
          },
          {},
        ],
        251: [
          function (require, module, exports) {
            /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  
            "use strict";
            /* eslint-disable no-unused-vars */
            var getOwnPropertySymbols = Object.getOwnPropertySymbols;
            var hasOwnProperty = Object.prototype.hasOwnProperty;
            var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  
            function toObject(val) {
              if (val === null || val === undefined) {
                throw new TypeError(
                  "Object.assign cannot be called with null or undefined"
                );
              }
  
              return Object(val);
            }
  
            function shouldUseNative() {
              try {
                if (!Object.assign) {
                  return false;
                }
  
                // Detect buggy property enumeration order in older V8 versions.
  
                // https://bugs.chromium.org/p/v8/issues/detail?id=4118
                var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
                test1[5] = "de";
                if (Object.getOwnPropertyNames(test1)[0] === "5") {
                  return false;
                }
  
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test2 = {};
                for (var i = 0; i < 10; i++) {
                  test2["_" + String.fromCharCode(i)] = i;
                }
                var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                  return test2[n];
                });
                if (order2.join("") !== "0123456789") {
                  return false;
                }
  
                // https://bugs.chromium.org/p/v8/issues/detail?id=3056
                var test3 = {};
                "abcdefghijklmnopqrst".split("").forEach(function (letter) {
                  test3[letter] = letter;
                });
                if (
                  Object.keys(Object.assign({}, test3)).join("") !==
                  "abcdefghijklmnopqrst"
                ) {
                  return false;
                }
  
                return true;
              } catch (err) {
                // We don't expect any of the above to throw, but better to be safe.
                return false;
              }
            }
  
            module.exports = shouldUseNative()
              ? Object.assign
              : function (target, source) {
                  var from;
                  var to = toObject(target);
                  var symbols;
  
                  for (var s = 1; s < arguments.length; s++) {
                    from = Object(arguments[s]);
  
                    for (var key in from) {
                      if (hasOwnProperty.call(from, key)) {
                        to[key] = from[key];
                      }
                    }
  
                    if (getOwnPropertySymbols) {
                      symbols = getOwnPropertySymbols(from);
                      for (var i = 0; i < symbols.length; i++) {
                        if (propIsEnumerable.call(from, symbols[i])) {
                          to[symbols[i]] = from[symbols[i]];
                        }
                      }
                    }
                  }
  
                  return to;
                };
          },
          {},
        ],
        252: [
          function (require, module, exports) {
            "use strict";
  
            var numberIsNaN = function (value) {
              return value !== value;
            };
  
            module.exports = function is(a, b) {
              if (a === 0 && b === 0) {
                return 1 / a === 1 / b;
              }
              if (a === b) {
                return true;
              }
              if (numberIsNaN(a) && numberIsNaN(b)) {
                return true;
              }
              return false;
            };
          },
          {},
        ],
        253: [
          function (require, module, exports) {
            "use strict";
  
            var define = require("define-properties");
            var callBind = require("call-bind");
  
            var implementation = require("./implementation");
            var getPolyfill = require("./polyfill");
            var shim = require("./shim");
  
            var polyfill = callBind(getPolyfill(), Object);
  
            define(polyfill, {
              getPolyfill: getPolyfill,
              implementation: implementation,
              shim: shim,
            });
  
            module.exports = polyfill;
          },
          {
            "./implementation": 252,
            "./polyfill": 254,
            "./shim": 255,
            "call-bind": 58,
            "define-properties": 229,
          },
        ],
        254: [
          function (require, module, exports) {
            "use strict";
  
            var implementation = require("./implementation");
  
            module.exports = function getPolyfill() {
              return typeof Object.is === "function" ? Object.is : implementation;
            };
          },
          { "./implementation": 252 },
        ],
        255: [
          function (require, module, exports) {
            "use strict";
  
            var getPolyfill = require("./polyfill");
            var define = require("define-properties");
  
            module.exports = function shimObjectIs() {
              var polyfill = getPolyfill();
              define(
                Object,
                { is: polyfill },
                {
                  is: function testObjectIs() {
                    return Object.is !== polyfill;
                  },
                }
              );
              return polyfill;
            };
          },
          { "./polyfill": 254, "define-properties": 229 },
        ],
        256: [
          function (require, module, exports) {
            "use strict";
  
            var keysShim;
            if (!Object.keys) {
              // modified from https://github.com/es-shims/es5-shim
              var has = Object.prototype.hasOwnProperty;
              var toStr = Object.prototype.toString;
              var isArgs = require("./isArguments"); // eslint-disable-line global-require
              var isEnumerable = Object.prototype.propertyIsEnumerable;
              var hasDontEnumBug = !isEnumerable.call(
                { toString: null },
                "toString"
              );
              var hasProtoEnumBug = isEnumerable.call(function () {},
              "prototype");
              var dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor",
              ];
              var equalsConstructorPrototype = function (o) {
                var ctor = o.constructor;
                return ctor && ctor.prototype === o;
              };
              var excludedKeys = {
                $applicationCache: true,
                $console: true,
                $external: true,
                $frame: true,
                $frameElement: true,
                $frames: true,
                $innerHeight: true,
                $innerWidth: true,
                $onmozfullscreenchange: true,
                $onmozfullscreenerror: true,
                $outerHeight: true,
                $outerWidth: true,
                $pageXOffset: true,
                $pageYOffset: true,
                $parent: true,
                $scrollLeft: true,
                $scrollTop: true,
                $scrollX: true,
                $scrollY: true,
                $self: true,
                $webkitIndexedDB: true,
                $webkitStorageInfo: true,
                $window: true,
              };
              var hasAutomationEqualityBug = (function () {
                /* global window */
                if (typeof window === "undefined") {
                  return false;
                }
                for (var k in window) {
                  try {
                    if (
                      !excludedKeys["$" + k] &&
                      has.call(window, k) &&
                      window[k] !== null &&
                      typeof window[k] === "object"
                    ) {
                      try {
                        equalsConstructorPrototype(window[k]);
                      } catch (e) {
                        return true;
                      }
                    }
                  } catch (e) {
                    return true;
                  }
                }
                return false;
              })();
              var equalsConstructorPrototypeIfNotBuggy = function (o) {
                /* global window */
                if (typeof window === "undefined" || !hasAutomationEqualityBug) {
                  return equalsConstructorPrototype(o);
                }
                try {
                  return equalsConstructorPrototype(o);
                } catch (e) {
                  return false;
                }
              };
  
              keysShim = function keys(object) {
                var isObject = object !== null && typeof object === "object";
                var isFunction = toStr.call(object) === "[object Function]";
                var isArguments = isArgs(object);
                var isString =
                  isObject && toStr.call(object) === "[object String]";
                var theKeys = [];
  
                if (!isObject && !isFunction && !isArguments) {
                  throw new TypeError("Object.keys called on a non-object");
                }
  
                var skipProto = hasProtoEnumBug && isFunction;
                if (isString && object.length > 0 && !has.call(object, 0)) {
                  for (var i = 0; i < object.length; ++i) {
                    theKeys.push(String(i));
                  }
                }
  
                if (isArguments && object.length > 0) {
                  for (var j = 0; j < object.length; ++j) {
                    theKeys.push(String(j));
                  }
                } else {
                  for (var name in object) {
                    if (
                      !(skipProto && name === "prototype") &&
                      has.call(object, name)
                    ) {
                      theKeys.push(String(name));
                    }
                  }
                }
  
                if (hasDontEnumBug) {
                  var skipConstructor =
                    equalsConstructorPrototypeIfNotBuggy(object);
  
                  for (var k = 0; k < dontEnums.length; ++k) {
                    if (
                      !(skipConstructor && dontEnums[k] === "constructor") &&
                      has.call(object, dontEnums[k])
                    ) {
                      theKeys.push(dontEnums[k]);
                    }
                  }
                }
                return theKeys;
              };
            }
            module.exports = keysShim;
          },
          { "./isArguments": 258 },
        ],
        257: [
          function (require, module, exports) {
            "use strict";
  
            var slice = Array.prototype.slice;
            var isArgs = require("./isArguments");
  
            var origKeys = Object.keys;
            var keysShim = origKeys
              ? function keys(o) {
                  return origKeys(o);
                }
              : require("./implementation");
  
            var originalKeys = Object.keys;
  
            keysShim.shim = function shimObjectKeys() {
              if (Object.keys) {
                var keysWorksWithArguments = (function () {
                  // Safari 5.0 bug
                  var args = Object.keys(arguments);
                  return args && args.length === arguments.length;
                })(1, 2);
                if (!keysWorksWithArguments) {
                  Object.keys = function keys(object) {
                    // eslint-disable-line func-name-matching
                    if (isArgs(object)) {
                      return originalKeys(slice.call(object));
                    }
                    return originalKeys(object);
                  };
                }
              } else {
                Object.keys = keysShim;
              }
              return Object.keys || keysShim;
            };
  
            module.exports = keysShim;
          },
          { "./implementation": 256, "./isArguments": 258 },
        ],
        258: [
          function (require, module, exports) {
            "use strict";
  
            var toStr = Object.prototype.toString;
  
            module.exports = function isArguments(value) {
              var str = toStr.call(value);
              var isArgs = str === "[object Arguments]";
              if (!isArgs) {
                isArgs =
                  str !== "[object Array]" &&
                  value !== null &&
                  typeof value === "object" &&
                  typeof value.length === "number" &&
                  value.length >= 0 &&
                  toStr.call(value.callee) === "[object Function]";
              }
              return isArgs;
            };
          },
          {},
        ],
        259: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                /*
                 * MIT LICENSE
                 * Copyright (c) 2011 Devon Govett
                 *
                 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
                 * software and associated documentation files (the "Software"), to deal in the Software
                 * without restriction, including without limitation the rights to use, copy, modify, merge,
                 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons
                 * to whom the Software is furnished to do so, subject to the following conditions:
                 *
                 * The above copyright notice and this permission notice shall be included in all copies or
                 * substantial portions of the Software.
                 *
                 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
                 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                 */
  
                const fs = require("fs");
                const zlib = require("zlib");
  
                module.exports = class PNG {
                  static decode(path, fn) {
                    return fs.readFile(path, function (err, file) {
                      const png = new PNG(file);
                      return png.decode((pixels) => fn(pixels));
                    });
                  }
  
                  static load(path) {
                    const file = fs.readFileSync(path);
                    return new PNG(file);
                  }
  
                  constructor(data) {
                    let i;
                    this.data = data;
                    this.pos = 8; // Skip the default header
  
                    this.palette = [];
                    this.imgData = [];
                    this.transparency = {};
                    this.text = {};
  
                    while (true) {
                      const chunkSize = this.readUInt32();
                      let section = "";
                      for (i = 0; i < 4; i++) {
                        section += String.fromCharCode(this.data[this.pos++]);
                      }
  
                      switch (section) {
                        case "IHDR":
                          // we can grab  interesting values from here (like width, height, etc)
                          this.width = this.readUInt32();
                          this.height = this.readUInt32();
                          this.bits = this.data[this.pos++];
                          this.colorType = this.data[this.pos++];
                          this.compressionMethod = this.data[this.pos++];
                          this.filterMethod = this.data[this.pos++];
                          this.interlaceMethod = this.data[this.pos++];
                          break;
  
                        case "PLTE":
                          this.palette = this.read(chunkSize);
                          break;
  
                        case "IDAT":
                          for (i = 0; i < chunkSize; i++) {
                            this.imgData.push(this.data[this.pos++]);
                          }
                          break;
  
                        case "tRNS":
                          // This chunk can only occur once and it must occur after the
                          // PLTE chunk and before the IDAT chunk.
                          this.transparency = {};
                          switch (this.colorType) {
                            case 3:
                              // Indexed color, RGB. Each byte in this chunk is an alpha for
                              // the palette index in the PLTE ("palette") chunk up until the
                              // last non-opaque entry. Set up an array, stretching over all
                              // palette entries which will be 0 (opaque) or 1 (transparent).
                              this.transparency.indexed = this.read(chunkSize);
                              var short = 255 - this.transparency.indexed.length;
                              if (short > 0) {
                                for (i = 0; i < short; i++) {
                                  this.transparency.indexed.push(255);
                                }
                              }
                              break;
                            case 0:
                              // Greyscale. Corresponding to entries in the PLTE chunk.
                              // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                              this.transparency.grayscale =
                                this.read(chunkSize)[0];
                              break;
                            case 2:
                              // True color with proper alpha channel.
                              this.transparency.rgb = this.read(chunkSize);
                              break;
                          }
                          break;
  
                        case "tEXt":
                          var text = this.read(chunkSize);
                          var index = text.indexOf(0);
                          var key = String.fromCharCode.apply(
                            String,
                            text.slice(0, index)
                          );
                          this.text[key] = String.fromCharCode.apply(
                            String,
                            text.slice(index + 1)
                          );
                          break;
  
                        case "IEND":
                          // we've got everything we need!
                          switch (this.colorType) {
                            case 0:
                            case 3:
                            case 4:
                              this.colors = 1;
                              break;
                            case 2:
                            case 6:
                              this.colors = 3;
                              break;
                          }
  
                          this.hasAlphaChannel = [4, 6].includes(this.colorType);
                          var colors =
                            this.colors + (this.hasAlphaChannel ? 1 : 0);
                          this.pixelBitlength = this.bits * colors;
  
                          switch (this.colors) {
                            case 1:
                              this.colorSpace = "DeviceGray";
                              break;
                            case 3:
                              this.colorSpace = "DeviceRGB";
                              break;
                          }
  
                          this.imgData = new Buffer(this.imgData);
                          return;
                          break;
  
                        default:
                          // unknown (or unimportant) section, skip it
                          this.pos += chunkSize;
                      }
  
                      this.pos += 4; // Skip the CRC
  
                      if (this.pos > this.data.length) {
                        throw new Error("Incomplete or corrupt PNG file");
                      }
                    }
                  }
  
                  read(bytes) {
                    const result = new Array(bytes);
                    for (let i = 0; i < bytes; i++) {
                      result[i] = this.data[this.pos++];
                    }
                    return result;
                  }
  
                  readUInt32() {
                    const b1 = this.data[this.pos++] << 24;
                    const b2 = this.data[this.pos++] << 16;
                    const b3 = this.data[this.pos++] << 8;
                    const b4 = this.data[this.pos++];
                    return b1 | b2 | b3 | b4;
                  }
  
                  readUInt16() {
                    const b1 = this.data[this.pos++] << 8;
                    const b2 = this.data[this.pos++];
                    return b1 | b2;
                  }
  
                  decodePixels(fn) {
                    return zlib.inflate(this.imgData, (err, data) => {
                      if (err) {
                        throw err;
                      }
  
                      const { width, height } = this;
                      const pixelBytes = this.pixelBitlength / 8;
  
                      const pixels = new Buffer(width * height * pixelBytes);
                      const { length } = data;
                      let pos = 0;
  
                      function pass(x0, y0, dx, dy, singlePass = false) {
                        const w = Math.ceil((width - x0) / dx);
                        const h = Math.ceil((height - y0) / dy);
                        const scanlineLength = pixelBytes * w;
                        const buffer = singlePass
                          ? pixels
                          : new Buffer(scanlineLength * h);
                        let row = 0;
                        let c = 0;
                        while (row < h && pos < length) {
                          var byte, col, i, left, upper;
                          switch (data[pos++]) {
                            case 0: // None
                              for (i = 0; i < scanlineLength; i++) {
                                buffer[c++] = data[pos++];
                              }
                              break;
  
                            case 1: // Sub
                              for (i = 0; i < scanlineLength; i++) {
                                byte = data[pos++];
                                left =
                                  i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                buffer[c++] = (byte + left) % 256;
                              }
                              break;
  
                            case 2: // Up
                              for (i = 0; i < scanlineLength; i++) {
                                byte = data[pos++];
                                col = (i - (i % pixelBytes)) / pixelBytes;
                                upper =
                                  row &&
                                  buffer[
                                    (row - 1) * scanlineLength +
                                      col * pixelBytes +
                                      (i % pixelBytes)
                                  ];
                                buffer[c++] = (upper + byte) % 256;
                              }
                              break;
  
                            case 3: // Average
                              for (i = 0; i < scanlineLength; i++) {
                                byte = data[pos++];
                                col = (i - (i % pixelBytes)) / pixelBytes;
                                left =
                                  i < pixelBytes ? 0 : buffer[c - pixelBytes];
                                upper =
                                  row &&
                                  buffer[
                                    (row - 1) * scanlineLength +
                                      col * pixelBytes +
                                      (i % pixelBytes)
                                  ];
                                buffer[c++] =
                                  (byte + Math.floor((left + upper) / 2)) % 256;
                              }
                              break;
  
                            case 4: // Paeth
                              for (i = 0; i < scanlineLength; i++) {
                                var paeth, upperLeft;
                                byte = data[pos++];
                                col = (i - (i % pixelBytes)) / pixelBytes;
                                left =
                                  i < pixelBytes ? 0 : buffer[c - pixelBytes];
  
                                if (row === 0) {
                                  upper = upperLeft = 0;
                                } else {
                                  upper =
                                    buffer[
                                      (row - 1) * scanlineLength +
                                        col * pixelBytes +
                                        (i % pixelBytes)
                                    ];
                                  upperLeft =
                                    col &&
                                    buffer[
                                      (row - 1) * scanlineLength +
                                        (col - 1) * pixelBytes +
                                        (i % pixelBytes)
                                    ];
                                }
  
                                const p = left + upper - upperLeft;
                                const pa = Math.abs(p - left);
                                const pb = Math.abs(p - upper);
                                const pc = Math.abs(p - upperLeft);
  
                                if (pa <= pb && pa <= pc) {
                                  paeth = left;
                                } else if (pb <= pc) {
                                  paeth = upper;
                                } else {
                                  paeth = upperLeft;
                                }
  
                                buffer[c++] = (byte + paeth) % 256;
                              }
                              break;
  
                            default:
                              throw new Error(
                                `Invalid filter algorithm: ${data[pos - 1]}`
                              );
                          }
  
                          if (!singlePass) {
                            let pixelsPos =
                              ((y0 + row * dy) * width + x0) * pixelBytes;
                            let bufferPos = row * scanlineLength;
                            for (i = 0; i < w; i++) {
                              for (let j = 0; j < pixelBytes; j++)
                                pixels[pixelsPos++] = buffer[bufferPos++];
                              pixelsPos += (dx - 1) * pixelBytes;
                            }
                          }
  
                          row++;
                        }
                      }
  
                      if (this.interlaceMethod === 1) {
                        /*
            1 6 4 6 2 6 4 6
            7 7 7 7 7 7 7 7
            5 6 5 6 5 6 5 6
            7 7 7 7 7 7 7 7
            3 6 4 6 3 6 4 6
            7 7 7 7 7 7 7 7
            5 6 5 6 5 6 5 6
            7 7 7 7 7 7 7 7
          */
                        pass(0, 0, 8, 8); // 1
                        pass(4, 0, 8, 8); // 2
                        pass(0, 4, 4, 8); // 3
                        pass(2, 0, 4, 4); // 4
                        pass(0, 2, 2, 4); // 5
                        pass(1, 0, 2, 2); // 6
                        pass(0, 1, 1, 2); // 7
                      } else {
                        pass(0, 0, 1, 1, true);
                      }
  
                      return fn(pixels);
                    });
                  }
  
                  decodePalette() {
                    const { palette } = this;
                    const { length } = palette;
                    const transparency = this.transparency.indexed || [];
                    const ret = new Buffer(transparency.length + length);
                    let pos = 0;
                    let c = 0;
  
                    for (let i = 0; i < length; i += 3) {
                      var left;
                      ret[pos++] = palette[i];
                      ret[pos++] = palette[i + 1];
                      ret[pos++] = palette[i + 2];
                      ret[pos++] =
                        (left = transparency[c++]) != null ? left : 255;
                    }
  
                    return ret;
                  }
  
                  copyToImageData(imageData, pixels) {
                    let j, k;
                    let { colors } = this;
                    let palette = null;
                    let alpha = this.hasAlphaChannel;
  
                    if (this.palette.length) {
                      palette =
                        this._decodedPalette ||
                        (this._decodedPalette = this.decodePalette());
                      colors = 4;
                      alpha = true;
                    }
  
                    const data = imageData.data || imageData;
                    const { length } = data;
                    const input = palette || pixels;
                    let i = (j = 0);
  
                    if (colors === 1) {
                      while (i < length) {
                        k = palette ? pixels[i / 4] * 4 : j;
                        const v = input[k++];
                        data[i++] = v;
                        data[i++] = v;
                        data[i++] = v;
                        data[i++] = alpha ? input[k++] : 255;
                        j = k;
                      }
                    } else {
                      while (i < length) {
                        k = palette ? pixels[i / 4] * 4 : j;
                        data[i++] = input[k++];
                        data[i++] = input[k++];
                        data[i++] = input[k++];
                        data[i++] = alpha ? input[k++] : 255;
                        j = k;
                      }
                    }
                  }
  
                  decode(fn) {
                    const ret = new Buffer(this.width * this.height * 4);
                    return this.decodePixels((pixels) => {
                      this.copyToImageData(ret, pixels);
                      return fn(ret);
                    });
                  }
                };
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { buffer: 55, fs: 54, zlib: 42 },
        ],
        260: [
          function (require, module, exports) {
            (function (process) {
              (function () {
                "use strict";
  
                if (
                  !process.version ||
                  process.version.indexOf("v0.") === 0 ||
                  (process.version.indexOf("v1.") === 0 &&
                    process.version.indexOf("v1.8.") !== 0)
                ) {
                  module.exports = { nextTick: nextTick };
                } else {
                  module.exports = process;
                }
  
                function nextTick(fn, arg1, arg2, arg3) {
                  if (typeof fn !== "function") {
                    throw new TypeError('"callback" argument must be a function');
                  }
                  var len = arguments.length;
                  var args, i;
                  switch (len) {
                    case 0:
                    case 1:
                      return process.nextTick(fn);
                    case 2:
                      return process.nextTick(function afterTickOne() {
                        fn.call(null, arg1);
                      });
                    case 3:
                      return process.nextTick(function afterTickTwo() {
                        fn.call(null, arg1, arg2);
                      });
                    case 4:
                      return process.nextTick(function afterTickThree() {
                        fn.call(null, arg1, arg2, arg3);
                      });
                    default:
                      args = new Array(len - 1);
                      i = 0;
                      while (i < args.length) {
                        args[i++] = arguments[i];
                      }
                      return process.nextTick(function afterTick() {
                        fn.apply(null, args);
                      });
                  }
                }
              }.call(this));
            }.call(this, require("_process")));
          },
          { _process: 261 },
        ],
        261: [
          function (require, module, exports) {
            // shim for using process in browser
            var process = (module.exports = {});
  
            // cached from whatever global is present so that test runners that stub it
            // don't break things.  But we need to wrap it in a try catch in case it is
            // wrapped in strict mode code which doesn't define any globals.  It's inside a
            // function because try/catches deoptimize in certain engines.
  
            var cachedSetTimeout;
            var cachedClearTimeout;
  
            function defaultSetTimout() {
              throw new Error("setTimeout has not been defined");
            }
            function defaultClearTimeout() {
              throw new Error("clearTimeout has not been defined");
            }
            (function () {
              try {
                if (typeof setTimeout === "function") {
                  cachedSetTimeout = setTimeout;
                } else {
                  cachedSetTimeout = defaultSetTimout;
                }
              } catch (e) {
                cachedSetTimeout = defaultSetTimout;
              }
              try {
                if (typeof clearTimeout === "function") {
                  cachedClearTimeout = clearTimeout;
                } else {
                  cachedClearTimeout = defaultClearTimeout;
                }
              } catch (e) {
                cachedClearTimeout = defaultClearTimeout;
              }
            })();
            function runTimeout(fun) {
              if (cachedSetTimeout === setTimeout) {
                //normal enviroments in sane situations
                return setTimeout(fun, 0);
              }
              // if setTimeout wasn't available but was latter defined
              if (
                (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
                setTimeout
              ) {
                cachedSetTimeout = setTimeout;
                return setTimeout(fun, 0);
              }
              try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedSetTimeout(fun, 0);
              } catch (e) {
                try {
                  // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                  return cachedSetTimeout.call(null, fun, 0);
                } catch (e) {
                  // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                  return cachedSetTimeout.call(this, fun, 0);
                }
              }
            }
            function runClearTimeout(marker) {
              if (cachedClearTimeout === clearTimeout) {
                //normal enviroments in sane situations
                return clearTimeout(marker);
              }
              // if clearTimeout wasn't available but was latter defined
              if (
                (cachedClearTimeout === defaultClearTimeout ||
                  !cachedClearTimeout) &&
                clearTimeout
              ) {
                cachedClearTimeout = clearTimeout;
                return clearTimeout(marker);
              }
              try {
                // when when somebody has screwed with setTimeout but no I.E. maddness
                return cachedClearTimeout(marker);
              } catch (e) {
                try {
                  // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                  return cachedClearTimeout.call(null, marker);
                } catch (e) {
                  // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                  // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                  return cachedClearTimeout.call(this, marker);
                }
              }
            }
            var queue = [];
            var draining = false;
            var currentQueue;
            var queueIndex = -1;
  
            function cleanUpNextTick() {
              if (!draining || !currentQueue) {
                return;
              }
              draining = false;
              if (currentQueue.length) {
                queue = currentQueue.concat(queue);
              } else {
                queueIndex = -1;
              }
              if (queue.length) {
                drainQueue();
              }
            }
  
            function drainQueue() {
              if (draining) {
                return;
              }
              var timeout = runTimeout(cleanUpNextTick);
              draining = true;
  
              var len = queue.length;
              while (len) {
                currentQueue = queue;
                queue = [];
                while (++queueIndex < len) {
                  if (currentQueue) {
                    currentQueue[queueIndex].run();
                  }
                }
                queueIndex = -1;
                len = queue.length;
              }
              currentQueue = null;
              draining = false;
              runClearTimeout(timeout);
            }
  
            process.nextTick = function (fun) {
              var args = new Array(arguments.length - 1);
              if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                  args[i - 1] = arguments[i];
                }
              }
              queue.push(new Item(fun, args));
              if (queue.length === 1 && !draining) {
                runTimeout(drainQueue);
              }
            };
  
            // v8 likes predictible objects
            function Item(fun, array) {
              this.fun = fun;
              this.array = array;
            }
            Item.prototype.run = function () {
              this.fun.apply(null, this.array);
            };
            process.title = "browser";
            process.browser = true;
            process.env = {};
            process.argv = [];
            process.version = ""; // empty string to avoid regexp issues
            process.versions = {};
  
            function noop() {}
  
            process.on = noop;
            process.addListener = noop;
            process.once = noop;
            process.off = noop;
            process.removeListener = noop;
            process.removeAllListeners = noop;
            process.emit = noop;
            process.prependListener = noop;
            process.prependOnceListener = noop;
  
            process.listeners = function (name) {
              return [];
            };
  
            process.binding = function (name) {
              throw new Error("process.binding is not supported");
            };
  
            process.cwd = function () {
              return "/";
            };
            process.chdir = function (dir) {
              throw new Error("process.chdir is not supported");
            };
            process.umask = function () {
              return 0;
            };
          },
          {},
        ],
        262: [
          function (require, module, exports) {
            module.exports = require("./lib/_stream_duplex.js");
          },
          { "./lib/_stream_duplex.js": 263 },
        ],
        263: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            // a duplex stream is just a stream that is both readable and writable.
            // Since JS doesn't have multiple prototypal inheritance, this class
            // prototypally inherits from Readable, and then parasitically from
            // Writable.
  
            "use strict";
  
            /*<replacement>*/
  
            var pna = require("process-nextick-args");
            /*</replacement>*/
  
            /*<replacement>*/
            var objectKeys =
              Object.keys ||
              function (obj) {
                var keys = [];
                for (var key in obj) {
                  keys.push(key);
                }
                return keys;
              };
            /*</replacement>*/
  
            module.exports = Duplex;
  
            /*<replacement>*/
            var util = require("core-util-is");
            util.inherits = require("inherits");
            /*</replacement>*/
  
            var Readable = require("./_stream_readable");
            var Writable = require("./_stream_writable");
  
            util.inherits(Duplex, Readable);
  
            {
              // avoid scope creep, the keys array can then be collected
              var keys = objectKeys(Writable.prototype);
              for (var v = 0; v < keys.length; v++) {
                var method = keys[v];
                if (!Duplex.prototype[method])
                  Duplex.prototype[method] = Writable.prototype[method];
              }
            }
  
            function Duplex(options) {
              if (!(this instanceof Duplex)) return new Duplex(options);
  
              Readable.call(this, options);
              Writable.call(this, options);
  
              if (options && options.readable === false) this.readable = false;
  
              if (options && options.writable === false) this.writable = false;
  
              this.allowHalfOpen = true;
              if (options && options.allowHalfOpen === false)
                this.allowHalfOpen = false;
  
              this.once("end", onend);
            }
  
            Object.defineProperty(Duplex.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: false,
              get: function () {
                return this._writableState.highWaterMark;
              },
            });
  
            // the no-half-open enforcer
            function onend() {
              // if we allow half-open state, or if the writable side ended,
              // then we're ok.
              if (this.allowHalfOpen || this._writableState.ended) return;
  
              // no more data can be written.
              // But allow more writes to happen in this tick.
              pna.nextTick(onEndNT, this);
            }
  
            function onEndNT(self) {
              self.end();
            }
  
            Object.defineProperty(Duplex.prototype, "destroyed", {
              get: function () {
                if (
                  this._readableState === undefined ||
                  this._writableState === undefined
                ) {
                  return false;
                }
                return (
                  this._readableState.destroyed && this._writableState.destroyed
                );
              },
              set: function (value) {
                // we ignore the value if the stream
                // has not been initialized yet
                if (
                  this._readableState === undefined ||
                  this._writableState === undefined
                ) {
                  return;
                }
  
                // backward compatibility, the user is explicitly
                // managing destroyed
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
              },
            });
  
            Duplex.prototype._destroy = function (err, cb) {
              this.push(null);
              this.end();
  
              pna.nextTick(cb, err);
            };
          },
          {
            "./_stream_readable": 265,
            "./_stream_writable": 267,
            "core-util-is": 193,
            inherits: 240,
            "process-nextick-args": 260,
          },
        ],
        264: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            // a passthrough stream.
            // basically just the most minimal sort of Transform stream.
            // Every written chunk gets output as-is.
  
            "use strict";
  
            module.exports = PassThrough;
  
            var Transform = require("./_stream_transform");
  
            /*<replacement>*/
            var util = require("core-util-is");
            util.inherits = require("inherits");
            /*</replacement>*/
  
            util.inherits(PassThrough, Transform);
  
            function PassThrough(options) {
              if (!(this instanceof PassThrough)) return new PassThrough(options);
  
              Transform.call(this, options);
            }
  
            PassThrough.prototype._transform = function (chunk, encoding, cb) {
              cb(null, chunk);
            };
          },
          { "./_stream_transform": 266, "core-util-is": 193, inherits: 240 },
        ],
        265: [
          function (require, module, exports) {
            (function (process, global) {
              (function () {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
                "use strict";
  
                /*<replacement>*/
  
                var pna = require("process-nextick-args");
                /*</replacement>*/
  
                module.exports = Readable;
  
                /*<replacement>*/
                var isArray = require("isarray");
                /*</replacement>*/
  
                /*<replacement>*/
                var Duplex;
                /*</replacement>*/
  
                Readable.ReadableState = ReadableState;
  
                /*<replacement>*/
                var EE = require("events").EventEmitter;
  
                var EElistenerCount = function (emitter, type) {
                  return emitter.listeners(type).length;
                };
                /*</replacement>*/
  
                /*<replacement>*/
                var Stream = require("./internal/streams/stream");
                /*</replacement>*/
  
                /*<replacement>*/
  
                var Buffer = require("safe-buffer").Buffer;
                var OurUint8Array = global.Uint8Array || function () {};
                function _uint8ArrayToBuffer(chunk) {
                  return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
  
                /*</replacement>*/
  
                /*<replacement>*/
                var util = require("core-util-is");
                util.inherits = require("inherits");
                /*</replacement>*/
  
                /*<replacement>*/
                var debugUtil = require("util");
                var debug = void 0;
                if (debugUtil && debugUtil.debuglog) {
                  debug = debugUtil.debuglog("stream");
                } else {
                  debug = function () {};
                }
                /*</replacement>*/
  
                var BufferList = require("./internal/streams/BufferList");
                var destroyImpl = require("./internal/streams/destroy");
                var StringDecoder;
  
                util.inherits(Readable, Stream);
  
                var kProxyEvents = [
                  "error",
                  "close",
                  "destroy",
                  "pause",
                  "resume",
                ];
  
                function prependListener(emitter, event, fn) {
                  // Sadly this is not cacheable as some libraries bundle their own
                  // event emitter implementation with them.
                  if (typeof emitter.prependListener === "function")
                    return emitter.prependListener(event, fn);
  
                  // This is a hack to make sure that our error handler is attached before any
                  // userland ones.  NEVER DO THIS. This is here only because this code needs
                  // to continue to work with older versions of Node.js that do not include
                  // the prependListener() method. The goal is to eventually remove this hack.
                  if (!emitter._events || !emitter._events[event])
                    emitter.on(event, fn);
                  else if (isArray(emitter._events[event]))
                    emitter._events[event].unshift(fn);
                  else emitter._events[event] = [fn, emitter._events[event]];
                }
  
                function ReadableState(options, stream) {
                  Duplex = Duplex || require("./_stream_duplex");
  
                  options = options || {};
  
                  // Duplex streams are both readable and writable, but share
                  // the same options object.
                  // However, some cases require setting options to different
                  // values for the readable and the writable sides of the duplex stream.
                  // These options can be provided separately as readableXXX and writableXXX.
                  var isDuplex = stream instanceof Duplex;
  
                  // object stream flag. Used to make read(n) ignore n and to
                  // make all the buffer merging and length checks go away
                  this.objectMode = !!options.objectMode;
  
                  if (isDuplex)
                    this.objectMode =
                      this.objectMode || !!options.readableObjectMode;
  
                  // the point at which it stops calling _read() to fill the buffer
                  // Note: 0 is a valid value, means "don't call _read preemptively ever"
                  var hwm = options.highWaterMark;
                  var readableHwm = options.readableHighWaterMark;
                  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  
                  if (hwm || hwm === 0) this.highWaterMark = hwm;
                  else if (isDuplex && (readableHwm || readableHwm === 0))
                    this.highWaterMark = readableHwm;
                  else this.highWaterMark = defaultHwm;
  
                  // cast to ints.
                  this.highWaterMark = Math.floor(this.highWaterMark);
  
                  // A linked list is used to store data chunks instead of an array because the
                  // linked list can remove elements from the beginning faster than
                  // array.shift()
                  this.buffer = new BufferList();
                  this.length = 0;
                  this.pipes = null;
                  this.pipesCount = 0;
                  this.flowing = null;
                  this.ended = false;
                  this.endEmitted = false;
                  this.reading = false;
  
                  // a flag to be able to tell if the event 'readable'/'data' is emitted
                  // immediately, or on a later tick.  We set this to true at first, because
                  // any actions that shouldn't happen until "later" should generally also
                  // not happen before the first read call.
                  this.sync = true;
  
                  // whenever we return null, then we set a flag to say
                  // that we're awaiting a 'readable' event emission.
                  this.needReadable = false;
                  this.emittedReadable = false;
                  this.readableListening = false;
                  this.resumeScheduled = false;
  
                  // has it been destroyed
                  this.destroyed = false;
  
                  // Crypto is kind of old and crusty.  Historically, its default string
                  // encoding is 'binary' so we have to make this configurable.
                  // Everything else in the universe uses 'utf8', though.
                  this.defaultEncoding = options.defaultEncoding || "utf8";
  
                  // the number of writers that are awaiting a drain event in .pipe()s
                  this.awaitDrain = 0;
  
                  // if true, a maybeReadMore has been scheduled
                  this.readingMore = false;
  
                  this.decoder = null;
                  this.encoding = null;
                  if (options.encoding) {
                    if (!StringDecoder)
                      StringDecoder = require("string_decoder/").StringDecoder;
                    this.decoder = new StringDecoder(options.encoding);
                    this.encoding = options.encoding;
                  }
                }
  
                function Readable(options) {
                  Duplex = Duplex || require("./_stream_duplex");
  
                  if (!(this instanceof Readable)) return new Readable(options);
  
                  this._readableState = new ReadableState(options, this);
  
                  // legacy
                  this.readable = true;
  
                  if (options) {
                    if (typeof options.read === "function")
                      this._read = options.read;
  
                    if (typeof options.destroy === "function")
                      this._destroy = options.destroy;
                  }
  
                  Stream.call(this);
                }
  
                Object.defineProperty(Readable.prototype, "destroyed", {
                  get: function () {
                    if (this._readableState === undefined) {
                      return false;
                    }
                    return this._readableState.destroyed;
                  },
                  set: function (value) {
                    // we ignore the value if the stream
                    // has not been initialized yet
                    if (!this._readableState) {
                      return;
                    }
  
                    // backward compatibility, the user is explicitly
                    // managing destroyed
                    this._readableState.destroyed = value;
                  },
                });
  
                Readable.prototype.destroy = destroyImpl.destroy;
                Readable.prototype._undestroy = destroyImpl.undestroy;
                Readable.prototype._destroy = function (err, cb) {
                  this.push(null);
                  cb(err);
                };
  
                // Manually shove something into the read() buffer.
                // This returns true if the highWaterMark has not been hit yet,
                // similar to how Writable.write() returns true if you should
                // write() some more.
                Readable.prototype.push = function (chunk, encoding) {
                  var state = this._readableState;
                  var skipChunkCheck;
  
                  if (!state.objectMode) {
                    if (typeof chunk === "string") {
                      encoding = encoding || state.defaultEncoding;
                      if (encoding !== state.encoding) {
                        chunk = Buffer.from(chunk, encoding);
                        encoding = "";
                      }
                      skipChunkCheck = true;
                    }
                  } else {
                    skipChunkCheck = true;
                  }
  
                  return readableAddChunk(
                    this,
                    chunk,
                    encoding,
                    false,
                    skipChunkCheck
                  );
                };
  
                // Unshift should *always* be something directly out of read()
                Readable.prototype.unshift = function (chunk) {
                  return readableAddChunk(this, chunk, null, true, false);
                };
  
                function readableAddChunk(
                  stream,
                  chunk,
                  encoding,
                  addToFront,
                  skipChunkCheck
                ) {
                  var state = stream._readableState;
                  if (chunk === null) {
                    state.reading = false;
                    onEofChunk(stream, state);
                  } else {
                    var er;
                    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
                    if (er) {
                      stream.emit("error", er);
                    } else if (state.objectMode || (chunk && chunk.length > 0)) {
                      if (
                        typeof chunk !== "string" &&
                        !state.objectMode &&
                        Object.getPrototypeOf(chunk) !== Buffer.prototype
                      ) {
                        chunk = _uint8ArrayToBuffer(chunk);
                      }
  
                      if (addToFront) {
                        if (state.endEmitted)
                          stream.emit(
                            "error",
                            new Error("stream.unshift() after end event")
                          );
                        else addChunk(stream, state, chunk, true);
                      } else if (state.ended) {
                        stream.emit(
                          "error",
                          new Error("stream.push() after EOF")
                        );
                      } else {
                        state.reading = false;
                        if (state.decoder && !encoding) {
                          chunk = state.decoder.write(chunk);
                          if (state.objectMode || chunk.length !== 0)
                            addChunk(stream, state, chunk, false);
                          else maybeReadMore(stream, state);
                        } else {
                          addChunk(stream, state, chunk, false);
                        }
                      }
                    } else if (!addToFront) {
                      state.reading = false;
                    }
                  }
  
                  return needMoreData(state);
                }
  
                function addChunk(stream, state, chunk, addToFront) {
                  if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit("data", chunk);
                    stream.read(0);
                  } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
  
                    if (state.needReadable) emitReadable(stream);
                  }
                  maybeReadMore(stream, state);
                }
  
                function chunkInvalid(state, chunk) {
                  var er;
                  if (
                    !_isUint8Array(chunk) &&
                    typeof chunk !== "string" &&
                    chunk !== undefined &&
                    !state.objectMode
                  ) {
                    er = new TypeError("Invalid non-string/buffer chunk");
                  }
                  return er;
                }
  
                // if it's past the high water mark, we can push in some more.
                // Also, if we have no data yet, we can stand some
                // more bytes.  This is to work around cases where hwm=0,
                // such as the repl.  Also, if the push() triggered a
                // readable event, and the user called read(largeNumber) such that
                // needReadable was set, then we ought to push more, so that another
                // 'readable' event will be triggered.
                function needMoreData(state) {
                  return (
                    !state.ended &&
                    (state.needReadable ||
                      state.length < state.highWaterMark ||
                      state.length === 0)
                  );
                }
  
                Readable.prototype.isPaused = function () {
                  return this._readableState.flowing === false;
                };
  
                // backwards compatibility.
                Readable.prototype.setEncoding = function (enc) {
                  if (!StringDecoder)
                    StringDecoder = require("string_decoder/").StringDecoder;
                  this._readableState.decoder = new StringDecoder(enc);
                  this._readableState.encoding = enc;
                  return this;
                };
  
                // Don't raise the hwm > 8MB
                var MAX_HWM = 0x800000;
                function computeNewHighWaterMark(n) {
                  if (n >= MAX_HWM) {
                    n = MAX_HWM;
                  } else {
                    // Get the next highest power of 2 to prevent increasing hwm excessively in
                    // tiny amounts
                    n--;
                    n |= n >>> 1;
                    n |= n >>> 2;
                    n |= n >>> 4;
                    n |= n >>> 8;
                    n |= n >>> 16;
                    n++;
                  }
                  return n;
                }
  
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function howMuchToRead(n, state) {
                  if (n <= 0 || (state.length === 0 && state.ended)) return 0;
                  if (state.objectMode) return 1;
                  if (n !== n) {
                    // Only flow one buffer at a time
                    if (state.flowing && state.length)
                      return state.buffer.head.data.length;
                    else return state.length;
                  }
                  // If we're asking for more than the current hwm, then raise the hwm.
                  if (n > state.highWaterMark)
                    state.highWaterMark = computeNewHighWaterMark(n);
                  if (n <= state.length) return n;
                  // Don't have enough
                  if (!state.ended) {
                    state.needReadable = true;
                    return 0;
                  }
                  return state.length;
                }
  
                // you can override either this method, or the async _read(n) below.
                Readable.prototype.read = function (n) {
                  debug("read", n);
                  n = parseInt(n, 10);
                  var state = this._readableState;
                  var nOrig = n;
  
                  if (n !== 0) state.emittedReadable = false;
  
                  // if we're doing read(0) to trigger a readable event, but we
                  // already have a bunch of data in the buffer, then just trigger
                  // the 'readable' event and move on.
                  if (
                    n === 0 &&
                    state.needReadable &&
                    (state.length >= state.highWaterMark || state.ended)
                  ) {
                    debug("read: emitReadable", state.length, state.ended);
                    if (state.length === 0 && state.ended) endReadable(this);
                    else emitReadable(this);
                    return null;
                  }
  
                  n = howMuchToRead(n, state);
  
                  // if we've ended, and we're now clear, then finish it up.
                  if (n === 0 && state.ended) {
                    if (state.length === 0) endReadable(this);
                    return null;
                  }
  
                  // All the actual chunk generation logic needs to be
                  // *below* the call to _read.  The reason is that in certain
                  // synthetic stream cases, such as passthrough streams, _read
                  // may be a completely synchronous operation which may change
                  // the state of the read buffer, providing enough data when
                  // before there was *not* enough.
                  //
                  // So, the steps are:
                  // 1. Figure out what the state of things will be after we do
                  // a read from the buffer.
                  //
                  // 2. If that resulting state will trigger a _read, then call _read.
                  // Note that this may be asynchronous, or synchronous.  Yes, it is
                  // deeply ugly to write APIs this way, but that still doesn't mean
                  // that the Readable class should behave improperly, as streams are
                  // designed to be sync/async agnostic.
                  // Take note if the _read call is sync or async (ie, if the read call
                  // has returned yet), so that we know whether or not it's safe to emit
                  // 'readable' etc.
                  //
                  // 3. Actually pull the requested chunks out of the buffer and return.
  
                  // if we need a readable event, then we need to do some reading.
                  var doRead = state.needReadable;
                  debug("need readable", doRead);
  
                  // if we currently have less than the highWaterMark, then also read some
                  if (
                    state.length === 0 ||
                    state.length - n < state.highWaterMark
                  ) {
                    doRead = true;
                    debug("length less than watermark", doRead);
                  }
  
                  // however, if we've ended, then there's no point, and if we're already
                  // reading, then it's unnecessary.
                  if (state.ended || state.reading) {
                    doRead = false;
                    debug("reading or ended", doRead);
                  } else if (doRead) {
                    debug("do read");
                    state.reading = true;
                    state.sync = true;
                    // if the length is currently zero, then we *need* a readable event.
                    if (state.length === 0) state.needReadable = true;
                    // call internal read method
                    this._read(state.highWaterMark);
                    state.sync = false;
                    // If _read pushed data synchronously, then `reading` will be false,
                    // and we need to re-evaluate how much data we can return to the user.
                    if (!state.reading) n = howMuchToRead(nOrig, state);
                  }
  
                  var ret;
                  if (n > 0) ret = fromList(n, state);
                  else ret = null;
  
                  if (ret === null) {
                    state.needReadable = true;
                    n = 0;
                  } else {
                    state.length -= n;
                  }
  
                  if (state.length === 0) {
                    // If we have nothing in the buffer, then we want to know
                    // as soon as we *do* get something into the buffer.
                    if (!state.ended) state.needReadable = true;
  
                    // If we tried to read() past the EOF, then emit end on the next tick.
                    if (nOrig !== n && state.ended) endReadable(this);
                  }
  
                  if (ret !== null) this.emit("data", ret);
  
                  return ret;
                };
  
                function onEofChunk(stream, state) {
                  if (state.ended) return;
                  if (state.decoder) {
                    var chunk = state.decoder.end();
                    if (chunk && chunk.length) {
                      state.buffer.push(chunk);
                      state.length += state.objectMode ? 1 : chunk.length;
                    }
                  }
                  state.ended = true;
  
                  // emit 'readable' now to make sure it gets picked up.
                  emitReadable(stream);
                }
  
                // Don't emit readable right away in sync mode, because this can trigger
                // another read() call => stack overflow.  This way, it might trigger
                // a nextTick recursion warning, but that's not so bad.
                function emitReadable(stream) {
                  var state = stream._readableState;
                  state.needReadable = false;
                  if (!state.emittedReadable) {
                    debug("emitReadable", state.flowing);
                    state.emittedReadable = true;
                    if (state.sync) pna.nextTick(emitReadable_, stream);
                    else emitReadable_(stream);
                  }
                }
  
                function emitReadable_(stream) {
                  debug("emit readable");
                  stream.emit("readable");
                  flow(stream);
                }
  
                // at this point, the user has presumably seen the 'readable' event,
                // and called read() to consume some data.  that may have triggered
                // in turn another _read(n) call, in which case reading = true if
                // it's in progress.
                // However, if we're not ended, or reading, and the length < hwm,
                // then go ahead and try to read some more preemptively.
                function maybeReadMore(stream, state) {
                  if (!state.readingMore) {
                    state.readingMore = true;
                    pna.nextTick(maybeReadMore_, stream, state);
                  }
                }
  
                function maybeReadMore_(stream, state) {
                  var len = state.length;
                  while (
                    !state.reading &&
                    !state.flowing &&
                    !state.ended &&
                    state.length < state.highWaterMark
                  ) {
                    debug("maybeReadMore read 0");
                    stream.read(0);
                    if (len === state.length)
                      // didn't get any data, stop spinning.
                      break;
                    else len = state.length;
                  }
                  state.readingMore = false;
                }
  
                // abstract method.  to be overridden in specific implementation classes.
                // call cb(er, data) where data is <= n in length.
                // for virtual (non-string, non-buffer) streams, "length" is somewhat
                // arbitrary, and perhaps not very meaningful.
                Readable.prototype._read = function (n) {
                  this.emit("error", new Error("_read() is not implemented"));
                };
  
                Readable.prototype.pipe = function (dest, pipeOpts) {
                  var src = this;
                  var state = this._readableState;
  
                  switch (state.pipesCount) {
                    case 0:
                      state.pipes = dest;
                      break;
                    case 1:
                      state.pipes = [state.pipes, dest];
                      break;
                    default:
                      state.pipes.push(dest);
                      break;
                  }
                  state.pipesCount += 1;
                  debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
  
                  var doEnd =
                    (!pipeOpts || pipeOpts.end !== false) &&
                    dest !== process.stdout &&
                    dest !== process.stderr;
  
                  var endFn = doEnd ? onend : unpipe;
                  if (state.endEmitted) pna.nextTick(endFn);
                  else src.once("end", endFn);
  
                  dest.on("unpipe", onunpipe);
                  function onunpipe(readable, unpipeInfo) {
                    debug("onunpipe");
                    if (readable === src) {
                      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                        unpipeInfo.hasUnpiped = true;
                        cleanup();
                      }
                    }
                  }
  
                  function onend() {
                    debug("onend");
                    dest.end();
                  }
  
                  // when the dest drains, it reduces the awaitDrain counter
                  // on the source.  This would be more elegant with a .once()
                  // handler in flow(), but adding and removing repeatedly is
                  // too slow.
                  var ondrain = pipeOnDrain(src);
                  dest.on("drain", ondrain);
  
                  var cleanedUp = false;
                  function cleanup() {
                    debug("cleanup");
                    // cleanup event handlers once the pipe is broken
                    dest.removeListener("close", onclose);
                    dest.removeListener("finish", onfinish);
                    dest.removeListener("drain", ondrain);
                    dest.removeListener("error", onerror);
                    dest.removeListener("unpipe", onunpipe);
                    src.removeListener("end", onend);
                    src.removeListener("end", unpipe);
                    src.removeListener("data", ondata);
  
                    cleanedUp = true;
  
                    // if the reader is waiting for a drain event from this
                    // specific writer, then it would cause it to never start
                    // flowing again.
                    // So, if this is awaiting a drain, then we just call it now.
                    // If we don't know, then assume that we are waiting for one.
                    if (
                      state.awaitDrain &&
                      (!dest._writableState || dest._writableState.needDrain)
                    )
                      ondrain();
                  }
  
                  // If the user pushes more data while we're writing to dest then we'll end up
                  // in ondata again. However, we only want to increase awaitDrain once because
                  // dest will only emit one 'drain' event for the multiple writes.
                  // => Introduce a guard on increasing awaitDrain.
                  var increasedAwaitDrain = false;
                  src.on("data", ondata);
                  function ondata(chunk) {
                    debug("ondata");
                    increasedAwaitDrain = false;
                    var ret = dest.write(chunk);
                    if (false === ret && !increasedAwaitDrain) {
                      // If the user unpiped during `dest.write()`, it is possible
                      // to get stuck in a permanently paused state if that write
                      // also returned false.
                      // => Check whether `dest` is still a piping destination.
                      if (
                        ((state.pipesCount === 1 && state.pipes === dest) ||
                          (state.pipesCount > 1 &&
                            indexOf(state.pipes, dest) !== -1)) &&
                        !cleanedUp
                      ) {
                        debug(
                          "false write response, pause",
                          src._readableState.awaitDrain
                        );
                        src._readableState.awaitDrain++;
                        increasedAwaitDrain = true;
                      }
                      src.pause();
                    }
                  }
  
                  // if the dest has an error, then stop piping into it.
                  // however, don't suppress the throwing behavior for this.
                  function onerror(er) {
                    debug("onerror", er);
                    unpipe();
                    dest.removeListener("error", onerror);
                    if (EElistenerCount(dest, "error") === 0)
                      dest.emit("error", er);
                  }
  
                  // Make sure our error handler is attached before userland ones.
                  prependListener(dest, "error", onerror);
  
                  // Both close and finish should trigger unpipe, but only once.
                  function onclose() {
                    dest.removeListener("finish", onfinish);
                    unpipe();
                  }
                  dest.once("close", onclose);
                  function onfinish() {
                    debug("onfinish");
                    dest.removeListener("close", onclose);
                    unpipe();
                  }
                  dest.once("finish", onfinish);
  
                  function unpipe() {
                    debug("unpipe");
                    src.unpipe(dest);
                  }
  
                  // tell the dest that it's being piped to
                  dest.emit("pipe", src);
  
                  // start the flow if it hasn't been started already.
                  if (!state.flowing) {
                    debug("pipe resume");
                    src.resume();
                  }
  
                  return dest;
                };
  
                function pipeOnDrain(src) {
                  return function () {
                    var state = src._readableState;
                    debug("pipeOnDrain", state.awaitDrain);
                    if (state.awaitDrain) state.awaitDrain--;
                    if (state.awaitDrain === 0 && EElistenerCount(src, "data")) {
                      state.flowing = true;
                      flow(src);
                    }
                  };
                }
  
                Readable.prototype.unpipe = function (dest) {
                  var state = this._readableState;
                  var unpipeInfo = { hasUnpiped: false };
  
                  // if we're not piping anywhere, then do nothing.
                  if (state.pipesCount === 0) return this;
  
                  // just one destination.  most common case.
                  if (state.pipesCount === 1) {
                    // passed in one, but it's not the right one.
                    if (dest && dest !== state.pipes) return this;
  
                    if (!dest) dest = state.pipes;
  
                    // got a match.
                    state.pipes = null;
                    state.pipesCount = 0;
                    state.flowing = false;
                    if (dest) dest.emit("unpipe", this, unpipeInfo);
                    return this;
                  }
  
                  // slow case. multiple pipe destinations.
  
                  if (!dest) {
                    // remove all.
                    var dests = state.pipes;
                    var len = state.pipesCount;
                    state.pipes = null;
                    state.pipesCount = 0;
                    state.flowing = false;
  
                    for (var i = 0; i < len; i++) {
                      dests[i].emit("unpipe", this, unpipeInfo);
                    }
                    return this;
                  }
  
                  // try to find the right one.
                  var index = indexOf(state.pipes, dest);
                  if (index === -1) return this;
  
                  state.pipes.splice(index, 1);
                  state.pipesCount -= 1;
                  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  
                  dest.emit("unpipe", this, unpipeInfo);
  
                  return this;
                };
  
                // set up data events if they are asked for
                // Ensure readable listeners eventually get something
                Readable.prototype.on = function (ev, fn) {
                  var res = Stream.prototype.on.call(this, ev, fn);
  
                  if (ev === "data") {
                    // Start flowing on next tick if stream isn't explicitly paused
                    if (this._readableState.flowing !== false) this.resume();
                  } else if (ev === "readable") {
                    var state = this._readableState;
                    if (!state.endEmitted && !state.readableListening) {
                      state.readableListening = state.needReadable = true;
                      state.emittedReadable = false;
                      if (!state.reading) {
                        pna.nextTick(nReadingNextTick, this);
                      } else if (state.length) {
                        emitReadable(this);
                      }
                    }
                  }
  
                  return res;
                };
                Readable.prototype.addListener = Readable.prototype.on;
  
                function nReadingNextTick(self) {
                  debug("readable nexttick read 0");
                  self.read(0);
                }
  
                // pause() and resume() are remnants of the legacy readable stream API
                // If the user uses them, then switch into old mode.
                Readable.prototype.resume = function () {
                  var state = this._readableState;
                  if (!state.flowing) {
                    debug("resume");
                    state.flowing = true;
                    resume(this, state);
                  }
                  return this;
                };
  
                function resume(stream, state) {
                  if (!state.resumeScheduled) {
                    state.resumeScheduled = true;
                    pna.nextTick(resume_, stream, state);
                  }
                }
  
                function resume_(stream, state) {
                  if (!state.reading) {
                    debug("resume read 0");
                    stream.read(0);
                  }
  
                  state.resumeScheduled = false;
                  state.awaitDrain = 0;
                  stream.emit("resume");
                  flow(stream);
                  if (state.flowing && !state.reading) stream.read(0);
                }
  
                Readable.prototype.pause = function () {
                  debug("call pause flowing=%j", this._readableState.flowing);
                  if (false !== this._readableState.flowing) {
                    debug("pause");
                    this._readableState.flowing = false;
                    this.emit("pause");
                  }
                  return this;
                };
  
                function flow(stream) {
                  var state = stream._readableState;
                  debug("flow", state.flowing);
                  while (state.flowing && stream.read() !== null) {}
                }
  
                // wrap an old-style stream as the async data source.
                // This is *not* part of the readable stream interface.
                // It is an ugly unfortunate mess of history.
                Readable.prototype.wrap = function (stream) {
                  var _this = this;
  
                  var state = this._readableState;
                  var paused = false;
  
                  stream.on("end", function () {
                    debug("wrapped end");
                    if (state.decoder && !state.ended) {
                      var chunk = state.decoder.end();
                      if (chunk && chunk.length) _this.push(chunk);
                    }
  
                    _this.push(null);
                  });
  
                  stream.on("data", function (chunk) {
                    debug("wrapped data");
                    if (state.decoder) chunk = state.decoder.write(chunk);
  
                    // don't skip over falsy values in objectMode
                    if (
                      state.objectMode &&
                      (chunk === null || chunk === undefined)
                    )
                      return;
                    else if (!state.objectMode && (!chunk || !chunk.length))
                      return;
  
                    var ret = _this.push(chunk);
                    if (!ret) {
                      paused = true;
                      stream.pause();
                    }
                  });
  
                  // proxy all the other methods.
                  // important when wrapping filters and duplexes.
                  for (var i in stream) {
                    if (
                      this[i] === undefined &&
                      typeof stream[i] === "function"
                    ) {
                      this[i] = (function (method) {
                        return function () {
                          return stream[method].apply(stream, arguments);
                        };
                      })(i);
                    }
                  }
  
                  // proxy certain important events.
                  for (var n = 0; n < kProxyEvents.length; n++) {
                    stream.on(
                      kProxyEvents[n],
                      this.emit.bind(this, kProxyEvents[n])
                    );
                  }
  
                  // when we try to consume some more bytes, simply unpause the
                  // underlying stream.
                  this._read = function (n) {
                    debug("wrapped _read", n);
                    if (paused) {
                      paused = false;
                      stream.resume();
                    }
                  };
  
                  return this;
                };
  
                Object.defineProperty(
                  Readable.prototype,
                  "readableHighWaterMark",
                  {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function () {
                      return this._readableState.highWaterMark;
                    },
                  }
                );
  
                // exposed for testing purposes only.
                Readable._fromList = fromList;
  
                // Pluck off n bytes from an array of buffers.
                // Length is the combined lengths of all the buffers in the list.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromList(n, state) {
                  // nothing buffered
                  if (state.length === 0) return null;
  
                  var ret;
                  if (state.objectMode) ret = state.buffer.shift();
                  else if (!n || n >= state.length) {
                    // read it all, truncate the list
                    if (state.decoder) ret = state.buffer.join("");
                    else if (state.buffer.length === 1)
                      ret = state.buffer.head.data;
                    else ret = state.buffer.concat(state.length);
                    state.buffer.clear();
                  } else {
                    // read part of list
                    ret = fromListPartial(n, state.buffer, state.decoder);
                  }
  
                  return ret;
                }
  
                // Extracts only enough buffered data to satisfy the amount requested.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function fromListPartial(n, list, hasStrings) {
                  var ret;
                  if (n < list.head.data.length) {
                    // slice is the same for buffers and strings
                    ret = list.head.data.slice(0, n);
                    list.head.data = list.head.data.slice(n);
                  } else if (n === list.head.data.length) {
                    // first chunk is a perfect match
                    ret = list.shift();
                  } else {
                    // result spans more than one buffer
                    ret = hasStrings
                      ? copyFromBufferString(n, list)
                      : copyFromBuffer(n, list);
                  }
                  return ret;
                }
  
                // Copies a specified amount of characters from the list of buffered data
                // chunks.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function copyFromBufferString(n, list) {
                  var p = list.head;
                  var c = 1;
                  var ret = p.data;
                  n -= ret.length;
                  while ((p = p.next)) {
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                      if (nb === str.length) {
                        ++c;
                        if (p.next) list.head = p.next;
                        else list.head = list.tail = null;
                      } else {
                        list.head = p;
                        p.data = str.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  list.length -= c;
                  return ret;
                }
  
                // Copies a specified amount of bytes from the list of buffered data chunks.
                // This function is designed to be inlinable, so please take care when making
                // changes to the function body.
                function copyFromBuffer(n, list) {
                  var ret = Buffer.allocUnsafe(n);
                  var p = list.head;
                  var c = 1;
                  p.data.copy(ret);
                  n -= p.data.length;
                  while ((p = p.next)) {
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                      if (nb === buf.length) {
                        ++c;
                        if (p.next) list.head = p.next;
                        else list.head = list.tail = null;
                      } else {
                        list.head = p;
                        p.data = buf.slice(nb);
                      }
                      break;
                    }
                    ++c;
                  }
                  list.length -= c;
                  return ret;
                }
  
                function endReadable(stream) {
                  var state = stream._readableState;
  
                  // If we get here before consuming all the bytes, then that is a
                  // bug in node.  Should never happen.
                  if (state.length > 0)
                    throw new Error('"endReadable()" called on non-empty stream');
  
                  if (!state.endEmitted) {
                    state.ended = true;
                    pna.nextTick(endReadableNT, state, stream);
                  }
                }
  
                function endReadableNT(state, stream) {
                  // Check that we didn't get one last unshift.
                  if (!state.endEmitted && state.length === 0) {
                    state.endEmitted = true;
                    stream.readable = false;
                    stream.emit("end");
                  }
                }
  
                function indexOf(xs, x) {
                  for (var i = 0, l = xs.length; i < l; i++) {
                    if (xs[i] === x) return i;
                  }
                  return -1;
                }
              }.call(this));
            }.call(
              this,
              require("_process"),
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {}
            ));
          },
          {
            "./_stream_duplex": 263,
            "./internal/streams/BufferList": 268,
            "./internal/streams/destroy": 269,
            "./internal/streams/stream": 270,
            _process: 261,
            "core-util-is": 193,
            events: 231,
            inherits: 240,
            isarray: 245,
            "process-nextick-args": 260,
            "safe-buffer": 296,
            "string_decoder/": 298,
            util: 40,
          },
        ],
        266: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            // a transform stream is a readable/writable stream where you do
            // something with the data.  Sometimes it's called a "filter",
            // but that's not a great name for it, since that implies a thing where
            // some bits pass through, and others are simply ignored.  (That would
            // be a valid example of a transform, of course.)
            //
            // While the output is causally related to the input, it's not a
            // necessarily symmetric or synchronous transformation.  For example,
            // a zlib stream might take multiple plain-text writes(), and then
            // emit a single compressed chunk some time in the future.
            //
            // Here's how this works:
            //
            // The Transform stream has all the aspects of the readable and writable
            // stream classes.  When you write(chunk), that calls _write(chunk,cb)
            // internally, and returns false if there's a lot of pending writes
            // buffered up.  When you call read(), that calls _read(n) until
            // there's enough pending readable data buffered up.
            //
            // In a transform stream, the written data is placed in a buffer.  When
            // _read(n) is called, it transforms the queued up data, calling the
            // buffered _write cb's as it consumes chunks.  If consuming a single
            // written chunk would result in multiple output chunks, then the first
            // outputted bit calls the readcb, and subsequent chunks just go into
            // the read buffer, and will cause it to emit 'readable' if necessary.
            //
            // This way, back-pressure is actually determined by the reading side,
            // since _read has to be called to start processing a new chunk.  However,
            // a pathological inflate type of transform can cause excessive buffering
            // here.  For example, imagine a stream where every byte of input is
            // interpreted as an integer from 0-255, and then results in that many
            // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
            // 1kb of data being output.  In this case, you could write a very small
            // amount of input, and end up with a very large amount of output.  In
            // such a pathological inflating mechanism, there'd be no way to tell
            // the system to stop doing the transform.  A single 4MB write could
            // cause the system to run out of memory.
            //
            // However, even in such a pathological case, only a single written chunk
            // would be consumed, and then the rest would wait (un-transformed) until
            // the results of the previous transformed chunk were consumed.
  
            "use strict";
  
            module.exports = Transform;
  
            var Duplex = require("./_stream_duplex");
  
            /*<replacement>*/
            var util = require("core-util-is");
            util.inherits = require("inherits");
            /*</replacement>*/
  
            util.inherits(Transform, Duplex);
  
            function afterTransform(er, data) {
              var ts = this._transformState;
              ts.transforming = false;
  
              var cb = ts.writecb;
  
              if (!cb) {
                return this.emit(
                  "error",
                  new Error("write callback called multiple times")
                );
              }
  
              ts.writechunk = null;
              ts.writecb = null;
  
              if (data != null)
                // single equals check for both `null` and `undefined`
                this.push(data);
  
              cb(er);
  
              var rs = this._readableState;
              rs.reading = false;
              if (rs.needReadable || rs.length < rs.highWaterMark) {
                this._read(rs.highWaterMark);
              }
            }
  
            function Transform(options) {
              if (!(this instanceof Transform)) return new Transform(options);
  
              Duplex.call(this, options);
  
              this._transformState = {
                afterTransform: afterTransform.bind(this),
                needTransform: false,
                transforming: false,
                writecb: null,
                writechunk: null,
                writeencoding: null,
              };
  
              // start out asking for a readable event once data is transformed.
              this._readableState.needReadable = true;
  
              // we have implemented the _read method, and done the other things
              // that Readable wants before the first _read call, so unset the
              // sync guard flag.
              this._readableState.sync = false;
  
              if (options) {
                if (typeof options.transform === "function")
                  this._transform = options.transform;
  
                if (typeof options.flush === "function")
                  this._flush = options.flush;
              }
  
              // When the writable side finishes, then flush out anything remaining.
              this.on("prefinish", prefinish);
            }
  
            function prefinish() {
              var _this = this;
  
              if (typeof this._flush === "function") {
                this._flush(function (er, data) {
                  done(_this, er, data);
                });
              } else {
                done(this, null, null);
              }
            }
  
            Transform.prototype.push = function (chunk, encoding) {
              this._transformState.needTransform = false;
              return Duplex.prototype.push.call(this, chunk, encoding);
            };
  
            // This is the part where you do stuff!
            // override this function in implementation classes.
            // 'chunk' is an input chunk.
            //
            // Call `push(newChunk)` to pass along transformed output
            // to the readable side.  You may call 'push' zero or more times.
            //
            // Call `cb(err)` when you are done with this chunk.  If you pass
            // an error, then that'll put the hurt on the whole operation.  If you
            // never call cb(), then you'll never get another chunk.
            Transform.prototype._transform = function (chunk, encoding, cb) {
              throw new Error("_transform() is not implemented");
            };
  
            Transform.prototype._write = function (chunk, encoding, cb) {
              var ts = this._transformState;
              ts.writecb = cb;
              ts.writechunk = chunk;
              ts.writeencoding = encoding;
              if (!ts.transforming) {
                var rs = this._readableState;
                if (
                  ts.needTransform ||
                  rs.needReadable ||
                  rs.length < rs.highWaterMark
                )
                  this._read(rs.highWaterMark);
              }
            };
  
            // Doesn't matter what the args are here.
            // _transform does all the work.
            // That we got here means that the readable side wants more data.
            Transform.prototype._read = function (n) {
              var ts = this._transformState;
  
              if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
                ts.transforming = true;
                this._transform(
                  ts.writechunk,
                  ts.writeencoding,
                  ts.afterTransform
                );
              } else {
                // mark that we need a transform, so that any data that comes in
                // will get processed, now that we've asked for it.
                ts.needTransform = true;
              }
            };
  
            Transform.prototype._destroy = function (err, cb) {
              var _this2 = this;
  
              Duplex.prototype._destroy.call(this, err, function (err2) {
                cb(err2);
                _this2.emit("close");
              });
            };
  
            function done(stream, er, data) {
              if (er) return stream.emit("error", er);
  
              if (data != null)
                // single equals check for both `null` and `undefined`
                stream.push(data);
  
              // if there's nothing in the write buffer, then that means
              // that nothing more will ever be provided
              if (stream._writableState.length)
                throw new Error("Calling transform done when ws.length != 0");
  
              if (stream._transformState.transforming)
                throw new Error("Calling transform done when still transforming");
  
              return stream.push(null);
            }
          },
          { "./_stream_duplex": 263, "core-util-is": 193, inherits: 240 },
        ],
        267: [
          function (require, module, exports) {
            (function (process, global, setImmediate) {
              (function () {
                // Copyright Joyent, Inc. and other Node contributors.
                //
                // Permission is hereby granted, free of charge, to any person obtaining a
                // copy of this software and associated documentation files (the
                // "Software"), to deal in the Software without restriction, including
                // without limitation the rights to use, copy, modify, merge, publish,
                // distribute, sublicense, and/or sell copies of the Software, and to permit
                // persons to whom the Software is furnished to do so, subject to the
                // following conditions:
                //
                // The above copyright notice and this permission notice shall be included
                // in all copies or substantial portions of the Software.
                //
                // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
                // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
                // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
                // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
                // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
                // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
                // A bit simpler than readable streams.
                // Implement an async ._write(chunk, encoding, cb), and it'll handle all
                // the drain event emission and buffering.
  
                "use strict";
  
                /*<replacement>*/
  
                var pna = require("process-nextick-args");
                /*</replacement>*/
  
                module.exports = Writable;
  
                /* <replacement> */
                function WriteReq(chunk, encoding, cb) {
                  this.chunk = chunk;
                  this.encoding = encoding;
                  this.callback = cb;
                  this.next = null;
                }
  
                // It seems a linked list but it is not
                // there will be only 2 of these for each stream
                function CorkedRequest(state) {
                  var _this = this;
  
                  this.next = null;
                  this.entry = null;
                  this.finish = function () {
                    onCorkedFinish(_this, state);
                  };
                }
                /* </replacement> */
  
                /*<replacement>*/
                var asyncWrite =
                  !process.browser &&
                  ["v0.10", "v0.9."].indexOf(process.version.slice(0, 5)) > -1
                    ? setImmediate
                    : pna.nextTick;
                /*</replacement>*/
  
                /*<replacement>*/
                var Duplex;
                /*</replacement>*/
  
                Writable.WritableState = WritableState;
  
                /*<replacement>*/
                var util = require("core-util-is");
                util.inherits = require("inherits");
                /*</replacement>*/
  
                /*<replacement>*/
                var internalUtil = {
                  deprecate: require("util-deprecate"),
                };
                /*</replacement>*/
  
                /*<replacement>*/
                var Stream = require("./internal/streams/stream");
                /*</replacement>*/
  
                /*<replacement>*/
  
                var Buffer = require("safe-buffer").Buffer;
                var OurUint8Array = global.Uint8Array || function () {};
                function _uint8ArrayToBuffer(chunk) {
                  return Buffer.from(chunk);
                }
                function _isUint8Array(obj) {
                  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
                }
  
                /*</replacement>*/
  
                var destroyImpl = require("./internal/streams/destroy");
  
                util.inherits(Writable, Stream);
  
                function nop() {}
  
                function WritableState(options, stream) {
                  Duplex = Duplex || require("./_stream_duplex");
  
                  options = options || {};
  
                  // Duplex streams are both readable and writable, but share
                  // the same options object.
                  // However, some cases require setting options to different
                  // values for the readable and the writable sides of the duplex stream.
                  // These options can be provided separately as readableXXX and writableXXX.
                  var isDuplex = stream instanceof Duplex;
  
                  // object stream flag to indicate whether or not this stream
                  // contains buffers or objects.
                  this.objectMode = !!options.objectMode;
  
                  if (isDuplex)
                    this.objectMode =
                      this.objectMode || !!options.writableObjectMode;
  
                  // the point at which write() starts returning false
                  // Note: 0 is a valid value, means that we always return false if
                  // the entire buffer is not flushed immediately on write()
                  var hwm = options.highWaterMark;
                  var writableHwm = options.writableHighWaterMark;
                  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  
                  if (hwm || hwm === 0) this.highWaterMark = hwm;
                  else if (isDuplex && (writableHwm || writableHwm === 0))
                    this.highWaterMark = writableHwm;
                  else this.highWaterMark = defaultHwm;
  
                  // cast to ints.
                  this.highWaterMark = Math.floor(this.highWaterMark);
  
                  // if _final has been called
                  this.finalCalled = false;
  
                  // drain event flag.
                  this.needDrain = false;
                  // at the start of calling end()
                  this.ending = false;
                  // when end() has been called, and returned
                  this.ended = false;
                  // when 'finish' is emitted
                  this.finished = false;
  
                  // has it been destroyed
                  this.destroyed = false;
  
                  // should we decode strings into buffers before passing to _write?
                  // this is here so that some node-core streams can optimize string
                  // handling at a lower level.
                  var noDecode = options.decodeStrings === false;
                  this.decodeStrings = !noDecode;
  
                  // Crypto is kind of old and crusty.  Historically, its default string
                  // encoding is 'binary' so we have to make this configurable.
                  // Everything else in the universe uses 'utf8', though.
                  this.defaultEncoding = options.defaultEncoding || "utf8";
  
                  // not an actual buffer we keep track of, but a measurement
                  // of how much we're waiting to get pushed to some underlying
                  // socket or file.
                  this.length = 0;
  
                  // a flag to see when we're in the middle of a write.
                  this.writing = false;
  
                  // when true all writes will be buffered until .uncork() call
                  this.corked = 0;
  
                  // a flag to be able to tell if the onwrite cb is called immediately,
                  // or on a later tick.  We set this to true at first, because any
                  // actions that shouldn't happen until "later" should generally also
                  // not happen before the first write call.
                  this.sync = true;
  
                  // a flag to know if we're processing previously buffered items, which
                  // may call the _write() callback in the same tick, so that we don't
                  // end up in an overlapped onwrite situation.
                  this.bufferProcessing = false;
  
                  // the callback that's passed to _write(chunk,cb)
                  this.onwrite = function (er) {
                    onwrite(stream, er);
                  };
  
                  // the callback that the user supplies to write(chunk,encoding,cb)
                  this.writecb = null;
  
                  // the amount that is being written when _write is called.
                  this.writelen = 0;
  
                  this.bufferedRequest = null;
                  this.lastBufferedRequest = null;
  
                  // number of pending user-supplied write callbacks
                  // this must be 0 before 'finish' can be emitted
                  this.pendingcb = 0;
  
                  // emit prefinish if the only thing we're waiting for is _write cbs
                  // This is relevant for synchronous Transform streams
                  this.prefinished = false;
  
                  // True if the error was already emitted and should not be thrown again
                  this.errorEmitted = false;
  
                  // count buffered requests
                  this.bufferedRequestCount = 0;
  
                  // allocate the first CorkedRequest, there is always
                  // one allocated and free to use, and we maintain at most two
                  this.corkedRequestsFree = new CorkedRequest(this);
                }
  
                WritableState.prototype.getBuffer = function getBuffer() {
                  var current = this.bufferedRequest;
                  var out = [];
                  while (current) {
                    out.push(current);
                    current = current.next;
                  }
                  return out;
                };
  
                (function () {
                  try {
                    Object.defineProperty(WritableState.prototype, "buffer", {
                      get: internalUtil.deprecate(
                        function () {
                          return this.getBuffer();
                        },
                        "_writableState.buffer is deprecated. Use _writableState.getBuffer " +
                          "instead.",
                        "DEP0003"
                      ),
                    });
                  } catch (_) {}
                })();
  
                // Test _writableState for inheritance to account for Duplex streams,
                // whose prototype chain only points to Readable.
                var realHasInstance;
                if (
                  typeof Symbol === "function" &&
                  Symbol.hasInstance &&
                  typeof Function.prototype[Symbol.hasInstance] === "function"
                ) {
                  realHasInstance = Function.prototype[Symbol.hasInstance];
                  Object.defineProperty(Writable, Symbol.hasInstance, {
                    value: function (object) {
                      if (realHasInstance.call(this, object)) return true;
                      if (this !== Writable) return false;
  
                      return (
                        object && object._writableState instanceof WritableState
                      );
                    },
                  });
                } else {
                  realHasInstance = function (object) {
                    return object instanceof this;
                  };
                }
  
                function Writable(options) {
                  Duplex = Duplex || require("./_stream_duplex");
  
                  // Writable ctor is applied to Duplexes, too.
                  // `realHasInstance` is necessary because using plain `instanceof`
                  // would return false, as no `_writableState` property is attached.
  
                  // Trying to use the custom `instanceof` for Writable here will also break the
                  // Node.js LazyTransform implementation, which has a non-trivial getter for
                  // `_writableState` that would lead to infinite recursion.
                  if (
                    !realHasInstance.call(Writable, this) &&
                    !(this instanceof Duplex)
                  ) {
                    return new Writable(options);
                  }
  
                  this._writableState = new WritableState(options, this);
  
                  // legacy.
                  this.writable = true;
  
                  if (options) {
                    if (typeof options.write === "function")
                      this._write = options.write;
  
                    if (typeof options.writev === "function")
                      this._writev = options.writev;
  
                    if (typeof options.destroy === "function")
                      this._destroy = options.destroy;
  
                    if (typeof options.final === "function")
                      this._final = options.final;
                  }
  
                  Stream.call(this);
                }
  
                // Otherwise people can pipe Writable streams, which is just wrong.
                Writable.prototype.pipe = function () {
                  this.emit("error", new Error("Cannot pipe, not readable"));
                };
  
                function writeAfterEnd(stream, cb) {
                  var er = new Error("write after end");
                  // TODO: defer error events consistently everywhere, not just the cb
                  stream.emit("error", er);
                  pna.nextTick(cb, er);
                }
  
                // Checks that a user-supplied chunk is valid, especially for the particular
                // mode the stream is in. Currently this means that `null` is never accepted
                // and undefined/non-string values are only allowed in object mode.
                function validChunk(stream, state, chunk, cb) {
                  var valid = true;
                  var er = false;
  
                  if (chunk === null) {
                    er = new TypeError("May not write null values to stream");
                  } else if (
                    typeof chunk !== "string" &&
                    chunk !== undefined &&
                    !state.objectMode
                  ) {
                    er = new TypeError("Invalid non-string/buffer chunk");
                  }
                  if (er) {
                    stream.emit("error", er);
                    pna.nextTick(cb, er);
                    valid = false;
                  }
                  return valid;
                }
  
                Writable.prototype.write = function (chunk, encoding, cb) {
                  var state = this._writableState;
                  var ret = false;
                  var isBuf = !state.objectMode && _isUint8Array(chunk);
  
                  if (isBuf && !Buffer.isBuffer(chunk)) {
                    chunk = _uint8ArrayToBuffer(chunk);
                  }
  
                  if (typeof encoding === "function") {
                    cb = encoding;
                    encoding = null;
                  }
  
                  if (isBuf) encoding = "buffer";
                  else if (!encoding) encoding = state.defaultEncoding;
  
                  if (typeof cb !== "function") cb = nop;
  
                  if (state.ended) writeAfterEnd(this, cb);
                  else if (isBuf || validChunk(this, state, chunk, cb)) {
                    state.pendingcb++;
                    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
                  }
  
                  return ret;
                };
  
                Writable.prototype.cork = function () {
                  var state = this._writableState;
  
                  state.corked++;
                };
  
                Writable.prototype.uncork = function () {
                  var state = this._writableState;
  
                  if (state.corked) {
                    state.corked--;
  
                    if (
                      !state.writing &&
                      !state.corked &&
                      !state.finished &&
                      !state.bufferProcessing &&
                      state.bufferedRequest
                    )
                      clearBuffer(this, state);
                  }
                };
  
                Writable.prototype.setDefaultEncoding =
                  function setDefaultEncoding(encoding) {
                    // node::ParseEncoding() requires lower case.
                    if (typeof encoding === "string")
                      encoding = encoding.toLowerCase();
                    if (
                      !(
                        [
                          "hex",
                          "utf8",
                          "utf-8",
                          "ascii",
                          "binary",
                          "base64",
                          "ucs2",
                          "ucs-2",
                          "utf16le",
                          "utf-16le",
                          "raw",
                        ].indexOf((encoding + "").toLowerCase()) > -1
                      )
                    )
                      throw new TypeError("Unknown encoding: " + encoding);
                    this._writableState.defaultEncoding = encoding;
                    return this;
                  };
  
                function decodeChunk(state, chunk, encoding) {
                  if (
                    !state.objectMode &&
                    state.decodeStrings !== false &&
                    typeof chunk === "string"
                  ) {
                    chunk = Buffer.from(chunk, encoding);
                  }
                  return chunk;
                }
  
                Object.defineProperty(
                  Writable.prototype,
                  "writableHighWaterMark",
                  {
                    // making it explicit this property is not enumerable
                    // because otherwise some prototype manipulation in
                    // userland will fail
                    enumerable: false,
                    get: function () {
                      return this._writableState.highWaterMark;
                    },
                  }
                );
  
                // if we're already writing something, then just put this
                // in the queue, and wait our turn.  Otherwise, call _write
                // If we return false, then we need a drain event, so set that flag.
                function writeOrBuffer(
                  stream,
                  state,
                  isBuf,
                  chunk,
                  encoding,
                  cb
                ) {
                  if (!isBuf) {
                    var newChunk = decodeChunk(state, chunk, encoding);
                    if (chunk !== newChunk) {
                      isBuf = true;
                      encoding = "buffer";
                      chunk = newChunk;
                    }
                  }
                  var len = state.objectMode ? 1 : chunk.length;
  
                  state.length += len;
  
                  var ret = state.length < state.highWaterMark;
                  // we must ensure that previous needDrain will not be reset to false.
                  if (!ret) state.needDrain = true;
  
                  if (state.writing || state.corked) {
                    var last = state.lastBufferedRequest;
                    state.lastBufferedRequest = {
                      chunk: chunk,
                      encoding: encoding,
                      isBuf: isBuf,
                      callback: cb,
                      next: null,
                    };
                    if (last) {
                      last.next = state.lastBufferedRequest;
                    } else {
                      state.bufferedRequest = state.lastBufferedRequest;
                    }
                    state.bufferedRequestCount += 1;
                  } else {
                    doWrite(stream, state, false, len, chunk, encoding, cb);
                  }
  
                  return ret;
                }
  
                function doWrite(
                  stream,
                  state,
                  writev,
                  len,
                  chunk,
                  encoding,
                  cb
                ) {
                  state.writelen = len;
                  state.writecb = cb;
                  state.writing = true;
                  state.sync = true;
                  if (writev) stream._writev(chunk, state.onwrite);
                  else stream._write(chunk, encoding, state.onwrite);
                  state.sync = false;
                }
  
                function onwriteError(stream, state, sync, er, cb) {
                  --state.pendingcb;
  
                  if (sync) {
                    // defer the callback if we are being called synchronously
                    // to avoid piling up things on the stack
                    pna.nextTick(cb, er);
                    // this can emit finish, and it will always happen
                    // after error
                    pna.nextTick(finishMaybe, stream, state);
                    stream._writableState.errorEmitted = true;
                    stream.emit("error", er);
                  } else {
                    // the caller expect this to happen before if
                    // it is async
                    cb(er);
                    stream._writableState.errorEmitted = true;
                    stream.emit("error", er);
                    // this can emit finish, but finish must
                    // always follow error
                    finishMaybe(stream, state);
                  }
                }
  
                function onwriteStateUpdate(state) {
                  state.writing = false;
                  state.writecb = null;
                  state.length -= state.writelen;
                  state.writelen = 0;
                }
  
                function onwrite(stream, er) {
                  var state = stream._writableState;
                  var sync = state.sync;
                  var cb = state.writecb;
  
                  onwriteStateUpdate(state);
  
                  if (er) onwriteError(stream, state, sync, er, cb);
                  else {
                    // Check if we're actually ready to finish, but don't emit yet
                    var finished = needFinish(state);
  
                    if (
                      !finished &&
                      !state.corked &&
                      !state.bufferProcessing &&
                      state.bufferedRequest
                    ) {
                      clearBuffer(stream, state);
                    }
  
                    if (sync) {
                      /*<replacement>*/
                      asyncWrite(afterWrite, stream, state, finished, cb);
                      /*</replacement>*/
                    } else {
                      afterWrite(stream, state, finished, cb);
                    }
                  }
                }
  
                function afterWrite(stream, state, finished, cb) {
                  if (!finished) onwriteDrain(stream, state);
                  state.pendingcb--;
                  cb();
                  finishMaybe(stream, state);
                }
  
                // Must force callback to be called on nextTick, so that we don't
                // emit 'drain' before the write() consumer gets the 'false' return
                // value, and has a chance to attach a 'drain' listener.
                function onwriteDrain(stream, state) {
                  if (state.length === 0 && state.needDrain) {
                    state.needDrain = false;
                    stream.emit("drain");
                  }
                }
  
                // if there's something in the buffer waiting, then process it
                function clearBuffer(stream, state) {
                  state.bufferProcessing = true;
                  var entry = state.bufferedRequest;
  
                  if (stream._writev && entry && entry.next) {
                    // Fast case, write everything using _writev()
                    var l = state.bufferedRequestCount;
                    var buffer = new Array(l);
                    var holder = state.corkedRequestsFree;
                    holder.entry = entry;
  
                    var count = 0;
                    var allBuffers = true;
                    while (entry) {
                      buffer[count] = entry;
                      if (!entry.isBuf) allBuffers = false;
                      entry = entry.next;
                      count += 1;
                    }
                    buffer.allBuffers = allBuffers;
  
                    doWrite(
                      stream,
                      state,
                      true,
                      state.length,
                      buffer,
                      "",
                      holder.finish
                    );
  
                    // doWrite is almost always async, defer these to save a bit of time
                    // as the hot path ends with doWrite
                    state.pendingcb++;
                    state.lastBufferedRequest = null;
                    if (holder.next) {
                      state.corkedRequestsFree = holder.next;
                      holder.next = null;
                    } else {
                      state.corkedRequestsFree = new CorkedRequest(state);
                    }
                    state.bufferedRequestCount = 0;
                  } else {
                    // Slow case, write chunks one-by-one
                    while (entry) {
                      var chunk = entry.chunk;
                      var encoding = entry.encoding;
                      var cb = entry.callback;
                      var len = state.objectMode ? 1 : chunk.length;
  
                      doWrite(stream, state, false, len, chunk, encoding, cb);
                      entry = entry.next;
                      state.bufferedRequestCount--;
                      // if we didn't call the onwrite immediately, then
                      // it means that we need to wait until it does.
                      // also, that means that the chunk and cb are currently
                      // being processed, so move the buffer counter past them.
                      if (state.writing) {
                        break;
                      }
                    }
  
                    if (entry === null) state.lastBufferedRequest = null;
                  }
  
                  state.bufferedRequest = entry;
                  state.bufferProcessing = false;
                }
  
                Writable.prototype._write = function (chunk, encoding, cb) {
                  cb(new Error("_write() is not implemented"));
                };
  
                Writable.prototype._writev = null;
  
                Writable.prototype.end = function (chunk, encoding, cb) {
                  var state = this._writableState;
  
                  if (typeof chunk === "function") {
                    cb = chunk;
                    chunk = null;
                    encoding = null;
                  } else if (typeof encoding === "function") {
                    cb = encoding;
                    encoding = null;
                  }
  
                  if (chunk !== null && chunk !== undefined)
                    this.write(chunk, encoding);
  
                  // .end() fully uncorks
                  if (state.corked) {
                    state.corked = 1;
                    this.uncork();
                  }
  
                  // ignore unnecessary end() calls.
                  if (!state.ending && !state.finished)
                    endWritable(this, state, cb);
                };
  
                function needFinish(state) {
                  return (
                    state.ending &&
                    state.length === 0 &&
                    state.bufferedRequest === null &&
                    !state.finished &&
                    !state.writing
                  );
                }
                function callFinal(stream, state) {
                  stream._final(function (err) {
                    state.pendingcb--;
                    if (err) {
                      stream.emit("error", err);
                    }
                    state.prefinished = true;
                    stream.emit("prefinish");
                    finishMaybe(stream, state);
                  });
                }
                function prefinish(stream, state) {
                  if (!state.prefinished && !state.finalCalled) {
                    if (typeof stream._final === "function") {
                      state.pendingcb++;
                      state.finalCalled = true;
                      pna.nextTick(callFinal, stream, state);
                    } else {
                      state.prefinished = true;
                      stream.emit("prefinish");
                    }
                  }
                }
  
                function finishMaybe(stream, state) {
                  var need = needFinish(state);
                  if (need) {
                    prefinish(stream, state);
                    if (state.pendingcb === 0) {
                      state.finished = true;
                      stream.emit("finish");
                    }
                  }
                  return need;
                }
  
                function endWritable(stream, state, cb) {
                  state.ending = true;
                  finishMaybe(stream, state);
                  if (cb) {
                    if (state.finished) pna.nextTick(cb);
                    else stream.once("finish", cb);
                  }
                  state.ended = true;
                  stream.writable = false;
                }
  
                function onCorkedFinish(corkReq, state, err) {
                  var entry = corkReq.entry;
                  corkReq.entry = null;
                  while (entry) {
                    var cb = entry.callback;
                    state.pendingcb--;
                    cb(err);
                    entry = entry.next;
                  }
                  if (state.corkedRequestsFree) {
                    state.corkedRequestsFree.next = corkReq;
                  } else {
                    state.corkedRequestsFree = corkReq;
                  }
                }
  
                Object.defineProperty(Writable.prototype, "destroyed", {
                  get: function () {
                    if (this._writableState === undefined) {
                      return false;
                    }
                    return this._writableState.destroyed;
                  },
                  set: function (value) {
                    // we ignore the value if the stream
                    // has not been initialized yet
                    if (!this._writableState) {
                      return;
                    }
  
                    // backward compatibility, the user is explicitly
                    // managing destroyed
                    this._writableState.destroyed = value;
                  },
                });
  
                Writable.prototype.destroy = destroyImpl.destroy;
                Writable.prototype._undestroy = destroyImpl.undestroy;
                Writable.prototype._destroy = function (err, cb) {
                  this.end();
                  cb(err);
                };
              }.call(this));
            }.call(
              this,
              require("_process"),
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {},
              require("timers").setImmediate
            ));
          },
          {
            "./_stream_duplex": 263,
            "./internal/streams/destroy": 269,
            "./internal/streams/stream": 270,
            _process: 261,
            "core-util-is": 193,
            inherits: 240,
            "process-nextick-args": 260,
            "safe-buffer": 296,
            timers: 299,
            "util-deprecate": 305,
          },
        ],
        268: [
          function (require, module, exports) {
            "use strict";
  
            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
              }
            }
  
            var Buffer = require("safe-buffer").Buffer;
            var util = require("util");
  
            function copyBuffer(src, target, offset) {
              src.copy(target, offset);
            }
  
            module.exports = (function () {
              function BufferList() {
                _classCallCheck(this, BufferList);
  
                this.head = null;
                this.tail = null;
                this.length = 0;
              }
  
              BufferList.prototype.push = function push(v) {
                var entry = { data: v, next: null };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
              };
  
              BufferList.prototype.unshift = function unshift(v) {
                var entry = { data: v, next: this.head };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
              };
  
              BufferList.prototype.shift = function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
              };
  
              BufferList.prototype.clear = function clear() {
                this.head = this.tail = null;
                this.length = 0;
              };
  
              BufferList.prototype.join = function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while ((p = p.next)) {
                  ret += s + p.data;
                }
                return ret;
              };
  
              BufferList.prototype.concat = function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                if (this.length === 1) return this.head.data;
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while (p) {
                  copyBuffer(p.data, ret, i);
                  i += p.data.length;
                  p = p.next;
                }
                return ret;
              };
  
              return BufferList;
            })();
  
            if (util && util.inspect && util.inspect.custom) {
              module.exports.prototype[util.inspect.custom] = function () {
                var obj = util.inspect({ length: this.length });
                return this.constructor.name + " " + obj;
              };
            }
          },
          { "safe-buffer": 296, util: 40 },
        ],
        269: [
          function (require, module, exports) {
            "use strict";
  
            /*<replacement>*/
  
            var pna = require("process-nextick-args");
            /*</replacement>*/
  
            // undocumented cb() API, needed for core, not for public API
            function destroy(err, cb) {
              var _this = this;
  
              var readableDestroyed =
                this._readableState && this._readableState.destroyed;
              var writableDestroyed =
                this._writableState && this._writableState.destroyed;
  
              if (readableDestroyed || writableDestroyed) {
                if (cb) {
                  cb(err);
                } else if (
                  err &&
                  (!this._writableState || !this._writableState.errorEmitted)
                ) {
                  pna.nextTick(emitErrorNT, this, err);
                }
                return this;
              }
  
              // we set destroyed to true before firing error callbacks in order
              // to make it re-entrance safe in case destroy() is called within callbacks
  
              if (this._readableState) {
                this._readableState.destroyed = true;
              }
  
              // if this is a duplex stream mark the writable part as destroyed as well
              if (this._writableState) {
                this._writableState.destroyed = true;
              }
  
              this._destroy(err || null, function (err) {
                if (!cb && err) {
                  pna.nextTick(emitErrorNT, _this, err);
                  if (_this._writableState) {
                    _this._writableState.errorEmitted = true;
                  }
                } else if (cb) {
                  cb(err);
                }
              });
  
              return this;
            }
  
            function undestroy() {
              if (this._readableState) {
                this._readableState.destroyed = false;
                this._readableState.reading = false;
                this._readableState.ended = false;
                this._readableState.endEmitted = false;
              }
  
              if (this._writableState) {
                this._writableState.destroyed = false;
                this._writableState.ended = false;
                this._writableState.ending = false;
                this._writableState.finished = false;
                this._writableState.errorEmitted = false;
              }
            }
  
            function emitErrorNT(self, err) {
              self.emit("error", err);
            }
  
            module.exports = {
              destroy: destroy,
              undestroy: undestroy,
            };
          },
          { "process-nextick-args": 260 },
        ],
        270: [
          function (require, module, exports) {
            module.exports = require("events").EventEmitter;
          },
          { events: 231 },
        ],
        271: [
          function (require, module, exports) {
            module.exports = require("./readable").PassThrough;
          },
          { "./readable": 272 },
        ],
        272: [
          function (require, module, exports) {
            exports = module.exports = require("./lib/_stream_readable.js");
            exports.Stream = exports;
            exports.Readable = exports;
            exports.Writable = require("./lib/_stream_writable.js");
            exports.Duplex = require("./lib/_stream_duplex.js");
            exports.Transform = require("./lib/_stream_transform.js");
            exports.PassThrough = require("./lib/_stream_passthrough.js");
          },
          {
            "./lib/_stream_duplex.js": 263,
            "./lib/_stream_passthrough.js": 264,
            "./lib/_stream_readable.js": 265,
            "./lib/_stream_transform.js": 266,
            "./lib/_stream_writable.js": 267,
          },
        ],
        273: [
          function (require, module, exports) {
            module.exports = require("./readable").Transform;
          },
          { "./readable": 272 },
        ],
        274: [
          function (require, module, exports) {
            module.exports = require("./lib/_stream_writable.js");
          },
          { "./lib/_stream_writable.js": 267 },
        ],
        275: [
          function (require, module, exports) {
            "use strict";
  
            var $Object = Object;
            var $TypeError = TypeError;
  
            module.exports = function flags() {
              if (this != null && this !== $Object(this)) {
                throw new $TypeError(
                  "RegExp.prototype.flags getter called on non-object"
                );
              }
              var result = "";
              if (this.global) {
                result += "g";
              }
              if (this.ignoreCase) {
                result += "i";
              }
              if (this.multiline) {
                result += "m";
              }
              if (this.dotAll) {
                result += "s";
              }
              if (this.unicode) {
                result += "u";
              }
              if (this.sticky) {
                result += "y";
              }
              return result;
            };
          },
          {},
        ],
        276: [
          function (require, module, exports) {
            "use strict";
  
            var define = require("define-properties");
            var callBind = require("call-bind");
  
            var implementation = require("./implementation");
            var getPolyfill = require("./polyfill");
            var shim = require("./shim");
  
            var flagsBound = callBind(implementation);
  
            define(flagsBound, {
              getPolyfill: getPolyfill,
              implementation: implementation,
              shim: shim,
            });
  
            module.exports = flagsBound;
          },
          {
            "./implementation": 275,
            "./polyfill": 277,
            "./shim": 278,
            "call-bind": 58,
            "define-properties": 229,
          },
        ],
        277: [
          function (require, module, exports) {
            "use strict";
  
            var implementation = require("./implementation");
  
            var supportsDescriptors =
              require("define-properties").supportsDescriptors;
            var $gOPD = Object.getOwnPropertyDescriptor;
            var $TypeError = TypeError;
  
            module.exports = function getPolyfill() {
              if (!supportsDescriptors) {
                throw new $TypeError(
                  "RegExp.prototype.flags requires a true ES5 environment that supports property descriptors"
                );
              }
              if (/a/gim.flags === "gim") {
                var descriptor = $gOPD(RegExp.prototype, "flags");
                if (
                  descriptor &&
                  typeof descriptor.get === "function" &&
                  typeof /a/.dotAll === "boolean"
                ) {
                  return descriptor.get;
                }
              }
              return implementation;
            };
          },
          { "./implementation": 275, "define-properties": 229 },
        ],
        278: [
          function (require, module, exports) {
            "use strict";
  
            var supportsDescriptors =
              require("define-properties").supportsDescriptors;
            var getPolyfill = require("./polyfill");
            var gOPD = Object.getOwnPropertyDescriptor;
            var defineProperty = Object.defineProperty;
            var TypeErr = TypeError;
            var getProto = Object.getPrototypeOf;
            var regex = /a/;
  
            module.exports = function shimFlags() {
              if (!supportsDescriptors || !getProto) {
                throw new TypeErr(
                  "RegExp.prototype.flags requires a true ES5 environment that supports property descriptors"
                );
              }
              var polyfill = getPolyfill();
              var proto = getProto(regex);
              var descriptor = gOPD(proto, "flags");
              if (!descriptor || descriptor.get !== polyfill) {
                defineProperty(proto, "flags", {
                  configurable: true,
                  enumerable: false,
                  get: polyfill,
                });
              }
              return polyfill;
            };
          },
          { "./polyfill": 277, "define-properties": 229 },
        ],
        279: [
          function (require, module, exports) {
            (function () {
              var key, val, _ref, _ref1;
              exports.EncodeStream = require("./src/EncodeStream");
              exports.DecodeStream = require("./src/DecodeStream");
              exports.Array = require("./src/Array");
              exports.LazyArray = require("./src/LazyArray");
              exports.Bitfield = require("./src/Bitfield");
              exports.Boolean = require("./src/Boolean");
              exports.Buffer = require("./src/Buffer");
              exports.Enum = require("./src/Enum");
              exports.Optional = require("./src/Optional");
              exports.Reserved = require("./src/Reserved");
              exports.String = require("./src/String");
              exports.Struct = require("./src/Struct");
              exports.VersionedStruct = require("./src/VersionedStruct");
              _ref = require("./src/Number");
              for (key in _ref) {
                val = _ref[key];
                exports[key] = val;
              }
              _ref1 = require("./src/Pointer");
              for (key in _ref1) {
                val = _ref1[key];
                exports[key] = val;
              }
            }.call(this));
          },
          {
            "./src/Array": 280,
            "./src/Bitfield": 281,
            "./src/Boolean": 282,
            "./src/Buffer": 283,
            "./src/DecodeStream": 284,
            "./src/EncodeStream": 285,
            "./src/Enum": 286,
            "./src/LazyArray": 287,
            "./src/Number": 288,
            "./src/Optional": 289,
            "./src/Pointer": 290,
            "./src/Reserved": 291,
            "./src/String": 292,
            "./src/Struct": 293,
            "./src/VersionedStruct": 294,
          },
        ],
        280: [
          function (require, module, exports) {
            (function () {
              var ArrayT, NumberT, utils;
              NumberT = require("./Number").Number;
              utils = require("./utils");
              ArrayT = (function () {
                function ArrayT(type, length, lengthType) {
                  this.type = type;
                  this.length = length;
                  this.lengthType = lengthType != null ? lengthType : "count";
                }
                ArrayT.prototype.decode = function (stream, parent) {
                  var ctx, i, length, pos, res, target, _i;
                  pos = stream.pos;
                  res = [];
                  ctx = parent;
                  if (this.length != null) {
                    length = utils.resolveLength(this.length, stream, parent);
                  }
                  if (this.length instanceof NumberT) {
                    Object.defineProperties(res, {
                      parent: { value: parent },
                      _startOffset: { value: pos },
                      _currentOffset: {
                        value: 0,
                        writable: true,
                      },
                      _length: { value: length },
                    });
                    ctx = res;
                  }
                  if (length == null || this.lengthType === "bytes") {
                    target =
                      length != null
                        ? stream.pos + length
                        : (parent != null ? parent._length : void 0)
                        ? parent._startOffset + parent._length
                        : stream.length;
                    while (stream.pos < target) {
                      res.push(this.type.decode(stream, ctx));
                    }
                  } else {
                    for (i = _i = 0; _i < length; i = _i += 1) {
                      res.push(this.type.decode(stream, ctx));
                    }
                  }
                  return res;
                };
                ArrayT.prototype.size = function (array, ctx) {
                  var item, size, _i, _len;
                  if (!array) {
                    return (
                      this.type.size(null, ctx) *
                      utils.resolveLength(this.length, null, ctx)
                    );
                  }
                  size = 0;
                  if (this.length instanceof NumberT) {
                    size += this.length.size();
                    ctx = { parent: ctx };
                  }
                  for (_i = 0, _len = array.length; _i < _len; _i++) {
                    item = array[_i];
                    size += this.type.size(item, ctx);
                  }
                  return size;
                };
                ArrayT.prototype.encode = function (stream, array, parent) {
                  var ctx, i, item, ptr, _i, _len;
                  ctx = parent;
                  if (this.length instanceof NumberT) {
                    ctx = {
                      pointers: [],
                      startOffset: stream.pos,
                      parent: parent,
                    };
                    ctx.pointerOffset = stream.pos + this.size(array, ctx);
                    this.length.encode(stream, array.length);
                  }
                  for (_i = 0, _len = array.length; _i < _len; _i++) {
                    item = array[_i];
                    this.type.encode(stream, item, ctx);
                  }
                  if (this.length instanceof NumberT) {
                    i = 0;
                    while (i < ctx.pointers.length) {
                      ptr = ctx.pointers[i++];
                      ptr.type.encode(stream, ptr.val);
                    }
                  }
                };
                return ArrayT;
              })();
              module.exports = ArrayT;
            }.call(this));
          },
          { "./Number": 288, "./utils": 295 },
        ],
        281: [
          function (require, module, exports) {
            (function () {
              var Bitfield;
              Bitfield = (function () {
                function Bitfield(type, flags) {
                  this.type = type;
                  this.flags = flags != null ? flags : [];
                }
                Bitfield.prototype.decode = function (stream) {
                  var flag, i, res, val, _i, _len, _ref;
                  val = this.type.decode(stream);
                  res = {};
                  _ref = this.flags;
                  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                    flag = _ref[i];
                    if (flag != null) {
                      res[flag] = !!(val & (1 << i));
                    }
                  }
                  return res;
                };
                Bitfield.prototype.size = function () {
                  return this.type.size();
                };
                Bitfield.prototype.encode = function (stream, keys) {
                  var flag, i, val, _i, _len, _ref;
                  val = 0;
                  _ref = this.flags;
                  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
                    flag = _ref[i];
                    if (flag != null) {
                      if (keys[flag]) {
                        val |= 1 << i;
                      }
                    }
                  }
                  return this.type.encode(stream, val);
                };
                return Bitfield;
              })();
              module.exports = Bitfield;
            }.call(this));
          },
          {},
        ],
        282: [
          function (require, module, exports) {
            (function () {
              var BooleanT;
              BooleanT = (function () {
                function BooleanT(type) {
                  this.type = type;
                }
                BooleanT.prototype.decode = function (stream, parent) {
                  return !!this.type.decode(stream, parent);
                };
                BooleanT.prototype.size = function (val, parent) {
                  return this.type.size(val, parent);
                };
                BooleanT.prototype.encode = function (stream, val, parent) {
                  return this.type.encode(stream, +val, parent);
                };
                return BooleanT;
              })();
              module.exports = BooleanT;
            }.call(this));
          },
          {},
        ],
        283: [
          function (require, module, exports) {
            (function () {
              var BufferT, NumberT, utils;
              utils = require("./utils");
              NumberT = require("./Number").Number;
              BufferT = (function () {
                function BufferT(length) {
                  this.length = length;
                }
                BufferT.prototype.decode = function (stream, parent) {
                  var length;
                  length = utils.resolveLength(this.length, stream, parent);
                  return stream.readBuffer(length);
                };
                BufferT.prototype.size = function (val, parent) {
                  if (!val) {
                    return utils.resolveLength(this.length, null, parent);
                  }
                  return val.length;
                };
                BufferT.prototype.encode = function (stream, buf, parent) {
                  if (this.length instanceof NumberT) {
                    this.length.encode(stream, buf.length);
                  }
                  return stream.writeBuffer(buf);
                };
                return BufferT;
              })();
              module.exports = BufferT;
            }.call(this));
          },
          { "./Number": 288, "./utils": 295 },
        ],
        284: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                (function () {
                  var DecodeStream, iconv;
                  try {
                    iconv = require("iconv-lite");
                  } catch (_error) {}
                  DecodeStream = (function () {
                    var key;
                    function DecodeStream(buffer) {
                      this.buffer = buffer;
                      this.pos = 0;
                      this.length = this.buffer.length;
                    }
                    DecodeStream.TYPES = {
                      UInt8: 1,
                      UInt16: 2,
                      UInt24: 3,
                      UInt32: 4,
                      Int8: 1,
                      Int16: 2,
                      Int24: 3,
                      Int32: 4,
                      Float: 4,
                      Double: 8,
                    };
                    for (key in Buffer.prototype) {
                      if (key.slice(0, 4) === "read") {
                        (function (key) {
                          var bytes;
                          bytes =
                            DecodeStream.TYPES[key.replace(/read|[BL]E/g, "")];
                          return (DecodeStream.prototype[key] = function () {
                            var ret;
                            ret = this.buffer[key](this.pos);
                            this.pos += bytes;
                            return ret;
                          });
                        })(key);
                      }
                    }
                    DecodeStream.prototype.readString = function (
                      length,
                      encoding
                    ) {
                      var buf, byte, i, _i, _ref;
                      if (encoding == null) {
                        encoding = "ascii";
                      }
                      switch (encoding) {
                        case "utf16le":
                        case "ucs2":
                        case "utf8":
                        case "ascii":
                          return this.buffer.toString(
                            encoding,
                            this.pos,
                            (this.pos += length)
                          );
                        case "utf16be":
                          buf = new Buffer(this.readBuffer(length));
                          for (
                            i = _i = 0, _ref = buf.length - 1;
                            _i < _ref;
                            i = _i += 2
                          ) {
                            byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = byte;
                          }
                          return buf.toString("utf16le");
                        default:
                          buf = this.readBuffer(length);
                          if (iconv) {
                            try {
                              return iconv.decode(buf, encoding);
                            } catch (_error) {}
                          }
                          return buf;
                      }
                    };
                    DecodeStream.prototype.readBuffer = function (length) {
                      return this.buffer.slice(this.pos, (this.pos += length));
                    };
                    DecodeStream.prototype.readUInt24BE = function () {
                      return (this.readUInt16BE() << 8) + this.readUInt8();
                    };
                    DecodeStream.prototype.readUInt24LE = function () {
                      return this.readUInt16LE() + (this.readUInt8() << 16);
                    };
                    DecodeStream.prototype.readInt24BE = function () {
                      return (this.readInt16BE() << 8) + this.readUInt8();
                    };
                    DecodeStream.prototype.readInt24LE = function () {
                      return this.readUInt16LE() + (this.readInt8() << 16);
                    };
                    return DecodeStream;
                  })();
                  module.exports = DecodeStream;
                }.call(this));
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { buffer: 55, "iconv-lite": 54 },
        ],
        285: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                (function () {
                  var DecodeStream,
                    EncodeStream,
                    iconv,
                    stream,
                    __hasProp = {}.hasOwnProperty,
                    __extends = function (child, parent) {
                      for (var key in parent) {
                        if (__hasProp.call(parent, key)) child[key] = parent[key];
                      }
                      function ctor() {
                        this.constructor = child;
                      }
                      ctor.prototype = parent.prototype;
                      child.prototype = new ctor();
                      child.__super__ = parent.prototype;
                      return child;
                    };
                  stream = require("stream");
                  DecodeStream = require("./DecodeStream");
                  try {
                    iconv = require("iconv-lite");
                  } catch (_error) {}
                  EncodeStream = (function (_super) {
                    var key;
                    __extends(EncodeStream, _super);
                    function EncodeStream(bufferSize) {
                      if (bufferSize == null) {
                        bufferSize = 65536;
                      }
                      EncodeStream.__super__.constructor.apply(this, arguments);
                      this.buffer = new Buffer(bufferSize);
                      this.bufferOffset = 0;
                      this.pos = 0;
                    }
                    for (key in Buffer.prototype) {
                      if (key.slice(0, 5) === "write") {
                        (function (key) {
                          var bytes;
                          bytes =
                            +DecodeStream.TYPES[key.replace(/write|[BL]E/g, "")];
                          return (EncodeStream.prototype[key] = function (value) {
                            this.ensure(bytes);
                            this.buffer[key](value, this.bufferOffset);
                            this.bufferOffset += bytes;
                            return (this.pos += bytes);
                          });
                        })(key);
                      }
                    }
                    EncodeStream.prototype._read = function () {};
                    EncodeStream.prototype.ensure = function (bytes) {
                      if (this.bufferOffset + bytes > this.buffer.length) {
                        return this.flush();
                      }
                    };
                    EncodeStream.prototype.flush = function () {
                      if (this.bufferOffset > 0) {
                        this.push(
                          new Buffer(this.buffer.slice(0, this.bufferOffset))
                        );
                        return (this.bufferOffset = 0);
                      }
                    };
                    EncodeStream.prototype.writeBuffer = function (buffer) {
                      this.flush();
                      this.push(buffer);
                      return (this.pos += buffer.length);
                    };
                    EncodeStream.prototype.writeString = function (
                      string,
                      encoding
                    ) {
                      var buf, byte, i, _i, _ref;
                      if (encoding == null) {
                        encoding = "ascii";
                      }
                      switch (encoding) {
                        case "utf16le":
                        case "ucs2":
                        case "utf8":
                        case "ascii":
                          return this.writeBuffer(new Buffer(string, encoding));
                        case "utf16be":
                          buf = new Buffer(string, "utf16le");
                          for (
                            i = _i = 0, _ref = buf.length - 1;
                            _i < _ref;
                            i = _i += 2
                          ) {
                            byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = byte;
                          }
                          return this.writeBuffer(buf);
                        default:
                          if (iconv) {
                            return this.writeBuffer(
                              iconv.encode(string, encoding)
                            );
                          } else {
                            throw new Error(
                              "Install iconv-lite to enable additional string encodings."
                            );
                          }
                      }
                    };
                    EncodeStream.prototype.writeUInt24BE = function (val) {
                      this.ensure(3);
                      this.buffer[this.bufferOffset++] = (val >>> 16) & 255;
                      this.buffer[this.bufferOffset++] = (val >>> 8) & 255;
                      this.buffer[this.bufferOffset++] = val & 255;
                      return (this.pos += 3);
                    };
                    EncodeStream.prototype.writeUInt24LE = function (val) {
                      this.ensure(3);
                      this.buffer[this.bufferOffset++] = val & 255;
                      this.buffer[this.bufferOffset++] = (val >>> 8) & 255;
                      this.buffer[this.bufferOffset++] = (val >>> 16) & 255;
                      return (this.pos += 3);
                    };
                    EncodeStream.prototype.writeInt24BE = function (val) {
                      if (val >= 0) {
                        return this.writeUInt24BE(val);
                      } else {
                        return this.writeUInt24BE(val + 16777215 + 1);
                      }
                    };
                    EncodeStream.prototype.writeInt24LE = function (val) {
                      if (val >= 0) {
                        return this.writeUInt24LE(val);
                      } else {
                        return this.writeUInt24LE(val + 16777215 + 1);
                      }
                    };
                    EncodeStream.prototype.fill = function (val, length) {
                      var buf;
                      if (length < this.buffer.length) {
                        this.ensure(length);
                        this.buffer.fill(
                          val,
                          this.bufferOffset,
                          this.bufferOffset + length
                        );
                        this.bufferOffset += length;
                        return (this.pos += length);
                      } else {
                        buf = new Buffer(length);
                        buf.fill(val);
                        return this.writeBuffer(buf);
                      }
                    };
                    EncodeStream.prototype.end = function () {
                      this.flush();
                      return this.push(null);
                    };
                    return EncodeStream;
                  })(stream.Readable);
                  module.exports = EncodeStream;
                }.call(this));
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { "./DecodeStream": 284, buffer: 55, "iconv-lite": 54, stream: 297 },
        ],
        286: [
          function (require, module, exports) {
            (function () {
              var Enum;
              Enum = (function () {
                function Enum(type, options) {
                  this.type = type;
                  this.options = options != null ? options : [];
                }
                Enum.prototype.decode = function (stream) {
                  var index;
                  index = this.type.decode(stream);
                  return this.options[index] || index;
                };
                Enum.prototype.size = function () {
                  return this.type.size();
                };
                Enum.prototype.encode = function (stream, val) {
                  var index;
                  index = this.options.indexOf(val);
                  if (index === -1) {
                    throw new Error("Unknown option in enum: " + val);
                  }
                  return this.type.encode(stream, index);
                };
                return Enum;
              })();
              module.exports = Enum;
            }.call(this));
          },
          {},
        ],
        287: [
          function (require, module, exports) {
            (function () {
              var ArrayT,
                LazyArray,
                LazyArrayT,
                NumberT,
                inspect,
                utils,
                __hasProp = {}.hasOwnProperty,
                __extends = function (child, parent) {
                  for (var key in parent) {
                    if (__hasProp.call(parent, key)) child[key] = parent[key];
                  }
                  function ctor() {
                    this.constructor = child;
                  }
                  ctor.prototype = parent.prototype;
                  child.prototype = new ctor();
                  child.__super__ = parent.prototype;
                  return child;
                };
              ArrayT = require("./Array");
              NumberT = require("./Number").Number;
              utils = require("./utils");
              inspect = require("util").inspect;
              LazyArrayT = (function (_super) {
                __extends(LazyArrayT, _super);
                function LazyArrayT() {
                  return LazyArrayT.__super__.constructor.apply(this, arguments);
                }
                LazyArrayT.prototype.decode = function (stream, parent) {
                  var length, pos, res;
                  pos = stream.pos;
                  length = utils.resolveLength(this.length, stream, parent);
                  if (this.length instanceof NumberT) {
                    parent = {
                      parent: parent,
                      _startOffset: pos,
                      _currentOffset: 0,
                      _length: length,
                    };
                  }
                  res = new LazyArray(this.type, length, stream, parent);
                  stream.pos += length * this.type.size(null, parent);
                  return res;
                };
                LazyArrayT.prototype.size = function (val, ctx) {
                  if (val instanceof LazyArray) {
                    val = val.toArray();
                  }
                  return LazyArrayT.__super__.size.call(this, val, ctx);
                };
                LazyArrayT.prototype.encode = function (stream, val, ctx) {
                  if (val instanceof LazyArray) {
                    val = val.toArray();
                  }
                  return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
                };
                return LazyArrayT;
              })(ArrayT);
              LazyArray = (function () {
                function LazyArray(type, length, stream, ctx) {
                  this.type = type;
                  this.length = length;
                  this.stream = stream;
                  this.ctx = ctx;
                  this.base = this.stream.pos;
                  this.items = [];
                }
                LazyArray.prototype.get = function (index) {
                  var pos;
                  if (index < 0 || index >= this.length) {
                    return void 0;
                  }
                  if (this.items[index] == null) {
                    pos = this.stream.pos;
                    this.stream.pos =
                      this.base + this.type.size(null, this.ctx) * index;
                    this.items[index] = this.type.decode(this.stream, this.ctx);
                    this.stream.pos = pos;
                  }
                  return this.items[index];
                };
                LazyArray.prototype.toArray = function () {
                  var i, _i, _ref, _results;
                  _results = [];
                  for (i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1) {
                    _results.push(this.get(i));
                  }
                  return _results;
                };
                LazyArray.prototype.inspect = function () {
                  return inspect(this.toArray());
                };
                return LazyArray;
              })();
              module.exports = LazyArrayT;
            }.call(this));
          },
          { "./Array": 280, "./Number": 288, "./utils": 295, util: 307 },
        ],
        288: [
          function (require, module, exports) {
            (function () {
              var DecodeStream,
                Fixed,
                NumberT,
                __hasProp = {}.hasOwnProperty,
                __extends = function (child, parent) {
                  for (var key in parent) {
                    if (__hasProp.call(parent, key)) child[key] = parent[key];
                  }
                  function ctor() {
                    this.constructor = child;
                  }
                  ctor.prototype = parent.prototype;
                  child.prototype = new ctor();
                  child.__super__ = parent.prototype;
                  return child;
                };
              DecodeStream = require("./DecodeStream");
              NumberT = (function () {
                function NumberT(type, endian) {
                  this.type = type;
                  this.endian = endian != null ? endian : "BE";
                  this.fn = this.type;
                  if (this.type[this.type.length - 1] !== "8") {
                    this.fn += this.endian;
                  }
                }
                NumberT.prototype.size = function () {
                  return DecodeStream.TYPES[this.type];
                };
                NumberT.prototype.decode = function (stream) {
                  return stream["read" + this.fn]();
                };
                NumberT.prototype.encode = function (stream, val) {
                  return stream["write" + this.fn](val);
                };
                return NumberT;
              })();
              exports.Number = NumberT;
              exports.uint8 = new NumberT("UInt8");
              exports.uint16be = exports.uint16 = new NumberT("UInt16", "BE");
              exports.uint16le = new NumberT("UInt16", "LE");
              exports.uint24be = exports.uint24 = new NumberT("UInt24", "BE");
              exports.uint24le = new NumberT("UInt24", "LE");
              exports.uint32be = exports.uint32 = new NumberT("UInt32", "BE");
              exports.uint32le = new NumberT("UInt32", "LE");
              exports.int8 = new NumberT("Int8");
              exports.int16be = exports.int16 = new NumberT("Int16", "BE");
              exports.int16le = new NumberT("Int16", "LE");
              exports.int24be = exports.int24 = new NumberT("Int24", "BE");
              exports.int24le = new NumberT("Int24", "LE");
              exports.int32be = exports.int32 = new NumberT("Int32", "BE");
              exports.int32le = new NumberT("Int32", "LE");
              exports.floatbe = exports.float = new NumberT("Float", "BE");
              exports.floatle = new NumberT("Float", "LE");
              exports.doublebe = exports.double = new NumberT("Double", "BE");
              exports.doublele = new NumberT("Double", "LE");
              Fixed = (function (_super) {
                __extends(Fixed, _super);
                function Fixed(size, endian, fracBits) {
                  if (fracBits == null) {
                    fracBits = size >> 1;
                  }
                  Fixed.__super__.constructor.call(this, "Int" + size, endian);
                  this._point = 1 << fracBits;
                }
                Fixed.prototype.decode = function (stream) {
                  return Fixed.__super__.decode.call(this, stream) / this._point;
                };
                Fixed.prototype.encode = function (stream, val) {
                  return Fixed.__super__.encode.call(
                    this,
                    stream,
                    (val * this._point) | 0
                  );
                };
                return Fixed;
              })(NumberT);
              exports.Fixed = Fixed;
              exports.fixed16be = exports.fixed16 = new Fixed(16, "BE");
              exports.fixed16le = new Fixed(16, "LE");
              exports.fixed32be = exports.fixed32 = new Fixed(32, "BE");
              exports.fixed32le = new Fixed(32, "LE");
            }.call(this));
          },
          { "./DecodeStream": 284 },
        ],
        289: [
          function (require, module, exports) {
            (function () {
              var Optional;
              Optional = (function () {
                function Optional(type, condition) {
                  this.type = type;
                  this.condition = condition != null ? condition : true;
                }
                Optional.prototype.decode = function (stream, parent) {
                  var condition;
                  condition = this.condition;
                  if (typeof condition === "function") {
                    condition = condition.call(parent, parent);
                  }
                  if (condition) {
                    return this.type.decode(stream, parent);
                  }
                };
                Optional.prototype.size = function (val, parent) {
                  var condition;
                  condition = this.condition;
                  if (typeof condition === "function") {
                    condition = condition.call(parent, parent);
                  }
                  if (condition) {
                    return this.type.size(val, parent);
                  } else {
                    return 0;
                  }
                };
                Optional.prototype.encode = function (stream, val, parent) {
                  var condition;
                  condition = this.condition;
                  if (typeof condition === "function") {
                    condition = condition.call(parent, parent);
                  }
                  if (condition) {
                    return this.type.encode(stream, val, parent);
                  }
                };
                return Optional;
              })();
              module.exports = Optional;
            }.call(this));
          },
          {},
        ],
        290: [
          function (require, module, exports) {
            (function () {
              var Pointer, VoidPointer, utils;
              utils = require("./utils");
              Pointer = (function () {
                function Pointer(offsetType, type, options) {
                  var _base, _base1, _base2, _base3;
                  this.offsetType = offsetType;
                  this.type = type;
                  this.options = options != null ? options : {};
                  if (this.type === "void") {
                    this.type = null;
                  }
                  if ((_base = this.options).type == null) {
                    _base.type = "local";
                  }
                  if ((_base1 = this.options).allowNull == null) {
                    _base1.allowNull = true;
                  }
                  if ((_base2 = this.options).nullValue == null) {
                    _base2.nullValue = 0;
                  }
                  if ((_base3 = this.options).lazy == null) {
                    _base3.lazy = false;
                  }
                  if (this.options.relativeTo) {
                    this.relativeToGetter = new Function(
                      "ctx",
                      "return ctx." + this.options.relativeTo
                    );
                  }
                }
                Pointer.prototype.decode = function (stream, ctx) {
                  var c, decodeValue, offset, ptr, relative, val;
                  offset = this.offsetType.decode(stream, ctx);
                  if (
                    offset === this.options.nullValue &&
                    this.options.allowNull
                  ) {
                    return null;
                  }
                  relative = function () {
                    switch (this.options.type) {
                      case "local":
                        return ctx._startOffset;
                      case "immediate":
                        return stream.pos - this.offsetType.size();
                      case "parent":
                        return ctx.parent._startOffset;
                      default:
                        c = ctx;
                        while (c.parent) {
                          c = c.parent;
                        }
                        return c._startOffset || 0;
                    }
                  }.call(this);
                  if (this.options.relativeTo) {
                    relative += this.relativeToGetter(ctx);
                  }
                  ptr = offset + relative;
                  if (this.type != null) {
                    val = null;
                    decodeValue = (function (_this) {
                      return function () {
                        var pos;
                        if (val != null) {
                          return val;
                        }
                        pos = stream.pos;
                        stream.pos = ptr;
                        val = _this.type.decode(stream, ctx);
                        stream.pos = pos;
                        return val;
                      };
                    })(this);
                    if (this.options.lazy) {
                      return new utils.PropertyDescriptor({ get: decodeValue });
                    }
                    return decodeValue();
                  } else {
                    return ptr;
                  }
                };
                Pointer.prototype.size = function (val, ctx) {
                  var parent, type;
                  parent = ctx;
                  switch (this.options.type) {
                    case "local":
                    case "immediate":
                      break;
                    case "parent":
                      ctx = ctx.parent;
                      break;
                    default:
                      while (ctx.parent) {
                        ctx = ctx.parent;
                      }
                  }
                  type = this.type;
                  if (type == null) {
                    if (!(val instanceof VoidPointer)) {
                      throw new Error("Must be a VoidPointer");
                    }
                    type = val.type;
                    val = val.value;
                  }
                  if (val && ctx) {
                    ctx.pointerSize += type.size(val, parent);
                  }
                  return this.offsetType.size();
                };
                Pointer.prototype.encode = function (stream, val, ctx) {
                  var parent, relative, type;
                  parent = ctx;
                  if (val == null) {
                    this.offsetType.encode(stream, this.options.nullValue);
                    return;
                  }
                  switch (this.options.type) {
                    case "local":
                      relative = ctx.startOffset;
                      break;
                    case "immediate":
                      relative = stream.pos + this.offsetType.size(val, parent);
                      break;
                    case "parent":
                      ctx = ctx.parent;
                      relative = ctx.startOffset;
                      break;
                    default:
                      relative = 0;
                      while (ctx.parent) {
                        ctx = ctx.parent;
                      }
                  }
                  if (this.options.relativeTo) {
                    relative += this.relativeToGetter(parent.val);
                  }
                  this.offsetType.encode(stream, ctx.pointerOffset - relative);
                  type = this.type;
                  if (type == null) {
                    if (!(val instanceof VoidPointer)) {
                      throw new Error("Must be a VoidPointer");
                    }
                    type = val.type;
                    val = val.value;
                  }
                  ctx.pointers.push({
                    type: type,
                    val: val,
                    parent: parent,
                  });
                  return (ctx.pointerOffset += type.size(val, parent));
                };
                return Pointer;
              })();
              VoidPointer = (function () {
                function VoidPointer(type, value) {
                  this.type = type;
                  this.value = value;
                }
                return VoidPointer;
              })();
              exports.Pointer = Pointer;
              exports.VoidPointer = VoidPointer;
            }.call(this));
          },
          { "./utils": 295 },
        ],
        291: [
          function (require, module, exports) {
            (function () {
              var Reserved, utils;
              utils = require("./utils");
              Reserved = (function () {
                function Reserved(type, count) {
                  this.type = type;
                  this.count = count != null ? count : 1;
                }
                Reserved.prototype.decode = function (stream, parent) {
                  stream.pos += this.size(null, parent);
                  return void 0;
                };
                Reserved.prototype.size = function (data, parent) {
                  var count;
                  count = utils.resolveLength(this.count, null, parent);
                  return this.type.size() * count;
                };
                Reserved.prototype.encode = function (stream, val, parent) {
                  return stream.fill(0, this.size(val, parent));
                };
                return Reserved;
              })();
              module.exports = Reserved;
            }.call(this));
          },
          { "./utils": 295 },
        ],
        292: [
          function (require, module, exports) {
            (function (Buffer) {
              (function () {
                (function () {
                  var NumberT, StringT, utils;
                  NumberT = require("./Number").Number;
                  utils = require("./utils");
                  StringT = (function () {
                    function StringT(length, encoding) {
                      this.length = length;
                      this.encoding = encoding != null ? encoding : "ascii";
                    }
                    StringT.prototype.decode = function (stream, parent) {
                      var buffer, encoding, length, pos, string;
                      length = function () {
                        if (this.length != null) {
                          return utils.resolveLength(this.length, stream, parent);
                        } else {
                          (buffer = stream.buffer),
                            (length = stream.length),
                            (pos = stream.pos);
                          while (pos < length && buffer[pos] !== 0) {
                            ++pos;
                          }
                          return pos - stream.pos;
                        }
                      }.call(this);
                      encoding = this.encoding;
                      if (typeof encoding === "function") {
                        encoding = encoding.call(parent, parent) || "ascii";
                      }
                      string = stream.readString(length, encoding);
                      if (this.length == null && stream.pos < stream.length) {
                        stream.pos++;
                      }
                      return string;
                    };
                    StringT.prototype.size = function (val, parent) {
                      var encoding, size;
                      if (!val) {
                        return utils.resolveLength(this.length, null, parent);
                      }
                      encoding = this.encoding;
                      if (typeof encoding === "function") {
                        encoding =
                          encoding.call(
                            parent != null ? parent.val : void 0,
                            parent != null ? parent.val : void 0
                          ) || "ascii";
                      }
                      if (encoding === "utf16be") {
                        encoding = "utf16le";
                      }
                      size = Buffer.byteLength(val, encoding);
                      if (this.length instanceof NumberT) {
                        size += this.length.size();
                      }
                      if (this.length == null) {
                        size++;
                      }
                      return size;
                    };
                    StringT.prototype.encode = function (stream, val, parent) {
                      var encoding;
                      encoding = this.encoding;
                      if (typeof encoding === "function") {
                        encoding =
                          encoding.call(
                            parent != null ? parent.val : void 0,
                            parent != null ? parent.val : void 0
                          ) || "ascii";
                      }
                      if (this.length instanceof NumberT) {
                        this.length.encode(
                          stream,
                          Buffer.byteLength(val, encoding)
                        );
                      }
                      stream.writeString(val, encoding);
                      if (this.length == null) {
                        return stream.writeUInt8(0);
                      }
                    };
                    return StringT;
                  })();
                  module.exports = StringT;
                }.call(this));
              }.call(this));
            }.call(this, require("buffer").Buffer));
          },
          { "./Number": 288, "./utils": 295, buffer: 55 },
        ],
        293: [
          function (require, module, exports) {
            (function () {
              var Struct, utils;
              utils = require("./utils");
              Struct = (function () {
                function Struct(fields) {
                  this.fields = fields != null ? fields : {};
                }
                Struct.prototype.decode = function (stream, parent, length) {
                  var res, _ref;
                  if (length == null) {
                    length = 0;
                  }
                  res = this._setup(stream, parent, length);
                  this._parseFields(stream, res, this.fields);
                  if ((_ref = this.process) != null) {
                    _ref.call(res, stream);
                  }
                  return res;
                };
                Struct.prototype._setup = function (stream, parent, length) {
                  var res;
                  res = {};
                  Object.defineProperties(res, {
                    parent: { value: parent },
                    _startOffset: { value: stream.pos },
                    _currentOffset: {
                      value: 0,
                      writable: true,
                    },
                    _length: { value: length },
                  });
                  return res;
                };
                Struct.prototype._parseFields = function (stream, res, fields) {
                  var key, type, val;
                  for (key in fields) {
                    type = fields[key];
                    if (typeof type === "function") {
                      val = type.call(res, res);
                    } else {
                      val = type.decode(stream, res);
                    }
                    if (val !== void 0) {
                      if (val instanceof utils.PropertyDescriptor) {
                        Object.defineProperty(res, key, val);
                      } else {
                        res[key] = val;
                      }
                    }
                    res._currentOffset = stream.pos - res._startOffset;
                  }
                };
                Struct.prototype.size = function (val, parent, includePointers) {
                  var ctx, key, size, type, _ref;
                  if (val == null) {
                    val = {};
                  }
                  if (includePointers == null) {
                    includePointers = true;
                  }
                  ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0,
                  };
                  size = 0;
                  _ref = this.fields;
                  for (key in _ref) {
                    type = _ref[key];
                    if (type.size != null) {
                      size += type.size(val[key], ctx);
                    }
                  }
                  if (includePointers) {
                    size += ctx.pointerSize;
                  }
                  return size;
                };
                Struct.prototype.encode = function (stream, val, parent) {
                  var ctx, i, key, ptr, type, _ref, _ref1;
                  if ((_ref = this.preEncode) != null) {
                    _ref.call(val, stream);
                  }
                  ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0,
                  };
                  ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                  _ref1 = this.fields;
                  for (key in _ref1) {
                    type = _ref1[key];
                    if (type.encode != null) {
                      type.encode(stream, val[key], ctx);
                    }
                  }
                  i = 0;
                  while (i < ctx.pointers.length) {
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                  }
                };
                return Struct;
              })();
              module.exports = Struct;
            }.call(this));
          },
          { "./utils": 295 },
        ],
        294: [
          function (require, module, exports) {
            (function () {
              var Struct,
                VersionedStruct,
                __hasProp = {}.hasOwnProperty,
                __extends = function (child, parent) {
                  for (var key in parent) {
                    if (__hasProp.call(parent, key)) child[key] = parent[key];
                  }
                  function ctor() {
                    this.constructor = child;
                  }
                  ctor.prototype = parent.prototype;
                  child.prototype = new ctor();
                  child.__super__ = parent.prototype;
                  return child;
                };
              Struct = require("./Struct");
              VersionedStruct = (function (_super) {
                __extends(VersionedStruct, _super);
                function VersionedStruct(type, versions) {
                  this.type = type;
                  this.versions = versions != null ? versions : {};
                  if (typeof this.type === "string") {
                    this.versionGetter = new Function(
                      "parent",
                      "return parent." + this.type
                    );
                    this.versionSetter = new Function(
                      "parent",
                      "version",
                      "return parent." + this.type + " = version"
                    );
                  }
                }
                VersionedStruct.prototype.decode = function (
                  stream,
                  parent,
                  length
                ) {
                  var fields, res, _ref;
                  if (length == null) {
                    length = 0;
                  }
                  res = this._setup(stream, parent, length);
                  if (typeof this.type === "string") {
                    res.version = this.versionGetter(parent);
                  } else {
                    res.version = this.type.decode(stream);
                  }
                  if (this.versions.header) {
                    this._parseFields(stream, res, this.versions.header);
                  }
                  fields = this.versions[res.version];
                  if (fields == null) {
                    throw new Error("Unknown version " + res.version);
                  }
                  if (fields instanceof VersionedStruct) {
                    return fields.decode(stream, parent);
                  }
                  this._parseFields(stream, res, fields);
                  if ((_ref = this.process) != null) {
                    _ref.call(res, stream);
                  }
                  return res;
                };
                VersionedStruct.prototype.size = function (
                  val,
                  parent,
                  includePointers
                ) {
                  var ctx, fields, key, size, type, _ref;
                  if (includePointers == null) {
                    includePointers = true;
                  }
                  if (!val) {
                    throw new Error("Not a fixed size");
                  }
                  ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0,
                  };
                  size = 0;
                  if (typeof this.type !== "string") {
                    size += this.type.size(val.version, ctx);
                  }
                  if (this.versions.header) {
                    _ref = this.versions.header;
                    for (key in _ref) {
                      type = _ref[key];
                      if (type.size != null) {
                        size += type.size(val[key], ctx);
                      }
                    }
                  }
                  fields = this.versions[val.version];
                  if (fields == null) {
                    throw new Error("Unknown version " + val.version);
                  }
                  for (key in fields) {
                    type = fields[key];
                    if (type.size != null) {
                      size += type.size(val[key], ctx);
                    }
                  }
                  if (includePointers) {
                    size += ctx.pointerSize;
                  }
                  return size;
                };
                VersionedStruct.prototype.encode = function (
                  stream,
                  val,
                  parent
                ) {
                  var ctx, fields, i, key, ptr, type, _ref, _ref1;
                  if ((_ref = this.preEncode) != null) {
                    _ref.call(val, stream);
                  }
                  ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0,
                  };
                  ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                  if (typeof this.type !== "string") {
                    this.type.encode(stream, val.version);
                  }
                  if (this.versions.header) {
                    _ref1 = this.versions.header;
                    for (key in _ref1) {
                      type = _ref1[key];
                      if (type.encode != null) {
                        type.encode(stream, val[key], ctx);
                      }
                    }
                  }
                  fields = this.versions[val.version];
                  for (key in fields) {
                    type = fields[key];
                    if (type.encode != null) {
                      type.encode(stream, val[key], ctx);
                    }
                  }
                  i = 0;
                  while (i < ctx.pointers.length) {
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                  }
                };
                return VersionedStruct;
              })(Struct);
              module.exports = VersionedStruct;
            }.call(this));
          },
          { "./Struct": 293 },
        ],
        295: [
          function (require, module, exports) {
            (function () {
              var NumberT, PropertyDescriptor;
              NumberT = require("./Number").Number;
              exports.resolveLength = function (length, stream, parent) {
                var res;
                if (typeof length === "number") {
                  res = length;
                } else if (typeof length === "function") {
                  res = length.call(parent, parent);
                } else if (parent && typeof length === "string") {
                  res = parent[length];
                } else if (stream && length instanceof NumberT) {
                  res = length.decode(stream);
                }
                if (isNaN(res)) {
                  throw new Error("Not a fixed size");
                }
                return res;
              };
              PropertyDescriptor = (function () {
                function PropertyDescriptor(opts) {
                  var key, val;
                  if (opts == null) {
                    opts = {};
                  }
                  this.enumerable = true;
                  this.configurable = true;
                  for (key in opts) {
                    val = opts[key];
                    this[key] = val;
                  }
                }
                return PropertyDescriptor;
              })();
              exports.PropertyDescriptor = PropertyDescriptor;
            }.call(this));
          },
          { "./Number": 288 },
        ],
        296: [
          function (require, module, exports) {
            /* eslint-disable node/no-deprecated-api */
            var buffer = require("buffer");
            var Buffer = buffer.Buffer;
  
            // alternative to using Object.keys for old browsers
            function copyProps(src, dst) {
              for (var key in src) {
                dst[key] = src[key];
              }
            }
            if (
              Buffer.from &&
              Buffer.alloc &&
              Buffer.allocUnsafe &&
              Buffer.allocUnsafeSlow
            ) {
              module.exports = buffer;
            } else {
              // Copy properties from require('buffer')
              copyProps(buffer, exports);
              exports.Buffer = SafeBuffer;
            }
  
            function SafeBuffer(arg, encodingOrOffset, length) {
              return Buffer(arg, encodingOrOffset, length);
            }
  
            // Copy static methods from Buffer
            copyProps(Buffer, SafeBuffer);
  
            SafeBuffer.from = function (arg, encodingOrOffset, length) {
              if (typeof arg === "number") {
                throw new TypeError("Argument must not be a number");
              }
              return Buffer(arg, encodingOrOffset, length);
            };
  
            SafeBuffer.alloc = function (size, fill, encoding) {
              if (typeof size !== "number") {
                throw new TypeError("Argument must be a number");
              }
              var buf = Buffer(size);
              if (fill !== undefined) {
                if (typeof encoding === "string") {
                  buf.fill(fill, encoding);
                } else {
                  buf.fill(fill);
                }
              } else {
                buf.fill(0);
              }
              return buf;
            };
  
            SafeBuffer.allocUnsafe = function (size) {
              if (typeof size !== "number") {
                throw new TypeError("Argument must be a number");
              }
              return Buffer(size);
            };
  
            SafeBuffer.allocUnsafeSlow = function (size) {
              if (typeof size !== "number") {
                throw new TypeError("Argument must be a number");
              }
              return buffer.SlowBuffer(size);
            };
          },
          { buffer: 55 },
        ],
        297: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            module.exports = Stream;
  
            var EE = require("events").EventEmitter;
            var inherits = require("inherits");
  
            inherits(Stream, EE);
            Stream.Readable = require("readable-stream/readable.js");
            Stream.Writable = require("readable-stream/writable.js");
            Stream.Duplex = require("readable-stream/duplex.js");
            Stream.Transform = require("readable-stream/transform.js");
            Stream.PassThrough = require("readable-stream/passthrough.js");
  
            // Backwards-compat with node 0.4.x
            Stream.Stream = Stream;
  
            // old-style streams.  Note that the pipe method (the only relevant
            // part of this class) is overridden in the Readable class.
  
            function Stream() {
              EE.call(this);
            }
  
            Stream.prototype.pipe = function (dest, options) {
              var source = this;
  
              function ondata(chunk) {
                if (dest.writable) {
                  if (false === dest.write(chunk) && source.pause) {
                    source.pause();
                  }
                }
              }
  
              source.on("data", ondata);
  
              function ondrain() {
                if (source.readable && source.resume) {
                  source.resume();
                }
              }
  
              dest.on("drain", ondrain);
  
              // If the 'end' option is not supplied, dest.end() will be called when
              // source gets the 'end' or 'close' events.  Only dest.end() once.
              if (!dest._isStdio && (!options || options.end !== false)) {
                source.on("end", onend);
                source.on("close", onclose);
              }
  
              var didOnEnd = false;
              function onend() {
                if (didOnEnd) return;
                didOnEnd = true;
  
                dest.end();
              }
  
              function onclose() {
                if (didOnEnd) return;
                didOnEnd = true;
  
                if (typeof dest.destroy === "function") dest.destroy();
              }
  
              // don't leave dangling pipes when there are errors.
              function onerror(er) {
                cleanup();
                if (EE.listenerCount(this, "error") === 0) {
                  throw er; // Unhandled stream error in pipe.
                }
              }
  
              source.on("error", onerror);
              dest.on("error", onerror);
  
              // remove all the event listeners that were added.
              function cleanup() {
                source.removeListener("data", ondata);
                dest.removeListener("drain", ondrain);
  
                source.removeListener("end", onend);
                source.removeListener("close", onclose);
  
                source.removeListener("error", onerror);
                dest.removeListener("error", onerror);
  
                source.removeListener("end", cleanup);
                source.removeListener("close", cleanup);
  
                dest.removeListener("close", cleanup);
              }
  
              source.on("end", cleanup);
              source.on("close", cleanup);
  
              dest.on("close", cleanup);
  
              dest.emit("pipe", source);
  
              // Allow for unix-like usage: A.pipe(B).pipe(C)
              return dest;
            };
          },
          {
            events: 231,
            inherits: 240,
            "readable-stream/duplex.js": 262,
            "readable-stream/passthrough.js": 271,
            "readable-stream/readable.js": 272,
            "readable-stream/transform.js": 273,
            "readable-stream/writable.js": 274,
          },
        ],
        298: [
          function (require, module, exports) {
            // Copyright Joyent, Inc. and other Node contributors.
            //
            // Permission is hereby granted, free of charge, to any person obtaining a
            // copy of this software and associated documentation files (the
            // "Software"), to deal in the Software without restriction, including
            // without limitation the rights to use, copy, modify, merge, publish,
            // distribute, sublicense, and/or sell copies of the Software, and to permit
            // persons to whom the Software is furnished to do so, subject to the
            // following conditions:
            //
            // The above copyright notice and this permission notice shall be included
            // in all copies or substantial portions of the Software.
            //
            // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
            // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
            // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
            // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
            "use strict";
  
            /*<replacement>*/
  
            var Buffer = require("safe-buffer").Buffer;
            /*</replacement>*/
  
            var isEncoding =
              Buffer.isEncoding ||
              function (encoding) {
                encoding = "" + encoding;
                switch (encoding && encoding.toLowerCase()) {
                  case "hex":
                  case "utf8":
                  case "utf-8":
                  case "ascii":
                  case "binary":
                  case "base64":
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                  case "raw":
                    return true;
                  default:
                    return false;
                }
              };
  
            function _normalizeEncoding(enc) {
              if (!enc) return "utf8";
              var retried;
              while (true) {
                switch (enc) {
                  case "utf8":
                  case "utf-8":
                    return "utf8";
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return "utf16le";
                  case "latin1":
                  case "binary":
                    return "latin1";
                  case "base64":
                  case "ascii":
                  case "hex":
                    return enc;
                  default: // undefined
                    if (retried) return;
                    enc = ("" + enc).toLowerCase();
                    retried = true;
                }
              }
            }
  
            // Do not cache `Buffer.isEncoding` when checking encoding names as some
            // modules monkey-patch it to support additional encodings
            function normalizeEncoding(enc) {
              var nenc = _normalizeEncoding(enc);
              if (
                typeof nenc !== "string" &&
                (Buffer.isEncoding === isEncoding || !isEncoding(enc))
              )
                throw new Error("Unknown encoding: " + enc);
              return nenc || enc;
            }
  
            // StringDecoder provides an interface for efficiently splitting a series of
            // buffers into a series of JS strings without breaking apart multi-byte
            // characters.
            exports.StringDecoder = StringDecoder;
            function StringDecoder(encoding) {
              this.encoding = normalizeEncoding(encoding);
              var nb;
              switch (this.encoding) {
                case "utf16le":
                  this.text = utf16Text;
                  this.end = utf16End;
                  nb = 4;
                  break;
                case "utf8":
                  this.fillLast = utf8FillLast;
                  nb = 4;
                  break;
                case "base64":
                  this.text = base64Text;
                  this.end = base64End;
                  nb = 3;
                  break;
                default:
                  this.write = simpleWrite;
                  this.end = simpleEnd;
                  return;
              }
              this.lastNeed = 0;
              this.lastTotal = 0;
              this.lastChar = Buffer.allocUnsafe(nb);
            }
  
            StringDecoder.prototype.write = function (buf) {
              if (buf.length === 0) return "";
              var r;
              var i;
              if (this.lastNeed) {
                r = this.fillLast(buf);
                if (r === undefined) return "";
                i = this.lastNeed;
                this.lastNeed = 0;
              } else {
                i = 0;
              }
              if (i < buf.length)
                return r ? r + this.text(buf, i) : this.text(buf, i);
              return r || "";
            };
  
            StringDecoder.prototype.end = utf8End;
  
            // Returns only complete characters in a Buffer
            StringDecoder.prototype.text = utf8Text;
  
            // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
            StringDecoder.prototype.fillLast = function (buf) {
              if (this.lastNeed <= buf.length) {
                buf.copy(
                  this.lastChar,
                  this.lastTotal - this.lastNeed,
                  0,
                  this.lastNeed
                );
                return this.lastChar.toString(this.encoding, 0, this.lastTotal);
              }
              buf.copy(
                this.lastChar,
                this.lastTotal - this.lastNeed,
                0,
                buf.length
              );
              this.lastNeed -= buf.length;
            };
  
            // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
            // continuation byte. If an invalid byte is detected, -2 is returned.
            function utf8CheckByte(byte) {
              if (byte <= 0x7f) return 0;
              else if (byte >> 5 === 0x06) return 2;
              else if (byte >> 4 === 0x0e) return 3;
              else if (byte >> 3 === 0x1e) return 4;
              return byte >> 6 === 0x02 ? -1 : -2;
            }
  
            // Checks at most 3 bytes at the end of a Buffer in order to detect an
            // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
            // needed to complete the UTF-8 character (if applicable) are returned.
            function utf8CheckIncomplete(self, buf, i) {
              var j = buf.length - 1;
              if (j < i) return 0;
              var nb = utf8CheckByte(buf[j]);
              if (nb >= 0) {
                if (nb > 0) self.lastNeed = nb - 1;
                return nb;
              }
              if (--j < i || nb === -2) return 0;
              nb = utf8CheckByte(buf[j]);
              if (nb >= 0) {
                if (nb > 0) self.lastNeed = nb - 2;
                return nb;
              }
              if (--j < i || nb === -2) return 0;
              nb = utf8CheckByte(buf[j]);
              if (nb >= 0) {
                if (nb > 0) {
                  if (nb === 2) nb = 0;
                  else self.lastNeed = nb - 3;
                }
                return nb;
              }
              return 0;
            }
  
            // Validates as many continuation bytes for a multi-byte UTF-8 character as
            // needed or are available. If we see a non-continuation byte where we expect
            // one, we "replace" the validated continuation bytes we've seen so far with
            // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
            // behavior. The continuation byte check is included three times in the case
            // where all of the continuation bytes for a character exist in the same buffer.
            // It is also done this way as a slight performance increase instead of using a
            // loop.
            function utf8CheckExtraBytes(self, buf, p) {
              if ((buf[0] & 0xc0) !== 0x80) {
                self.lastNeed = 0;
                return "\ufffd";
              }
              if (self.lastNeed > 1 && buf.length > 1) {
                if ((buf[1] & 0xc0) !== 0x80) {
                  self.lastNeed = 1;
                  return "\ufffd";
                }
                if (self.lastNeed > 2 && buf.length > 2) {
                  if ((buf[2] & 0xc0) !== 0x80) {
                    self.lastNeed = 2;
                    return "\ufffd";
                  }
                }
              }
            }
  
            // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
            function utf8FillLast(buf) {
              var p = this.lastTotal - this.lastNeed;
              var r = utf8CheckExtraBytes(this, buf, p);
              if (r !== undefined) return r;
              if (this.lastNeed <= buf.length) {
                buf.copy(this.lastChar, p, 0, this.lastNeed);
                return this.lastChar.toString(this.encoding, 0, this.lastTotal);
              }
              buf.copy(this.lastChar, p, 0, buf.length);
              this.lastNeed -= buf.length;
            }
  
            // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
            // partial character, the character's bytes are buffered until the required
            // number of bytes are available.
            function utf8Text(buf, i) {
              var total = utf8CheckIncomplete(this, buf, i);
              if (!this.lastNeed) return buf.toString("utf8", i);
              this.lastTotal = total;
              var end = buf.length - (total - this.lastNeed);
              buf.copy(this.lastChar, 0, end);
              return buf.toString("utf8", i, end);
            }
  
            // For UTF-8, a replacement character is added when ending on a partial
            // character.
            function utf8End(buf) {
              var r = buf && buf.length ? this.write(buf) : "";
              if (this.lastNeed) return r + "\ufffd";
              return r;
            }
  
            // UTF-16LE typically needs two bytes per character, but even if we have an even
            // number of bytes available, we need to check if we end on a leading/high
            // surrogate. In that case, we need to wait for the next two bytes in order to
            // decode the last character properly.
            function utf16Text(buf, i) {
              if ((buf.length - i) % 2 === 0) {
                var r = buf.toString("utf16le", i);
                if (r) {
                  var c = r.charCodeAt(r.length - 1);
                  if (c >= 0xd800 && c <= 0xdbff) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                  }
                }
                return r;
              }
              this.lastNeed = 1;
              this.lastTotal = 2;
              this.lastChar[0] = buf[buf.length - 1];
              return buf.toString("utf16le", i, buf.length - 1);
            }
  
            // For UTF-16LE we do not explicitly append special replacement characters if we
            // end on a partial character, we simply let v8 handle that.
            function utf16End(buf) {
              var r = buf && buf.length ? this.write(buf) : "";
              if (this.lastNeed) {
                var end = this.lastTotal - this.lastNeed;
                return r + this.lastChar.toString("utf16le", 0, end);
              }
              return r;
            }
  
            function base64Text(buf, i) {
              var n = (buf.length - i) % 3;
              if (n === 0) return buf.toString("base64", i);
              this.lastNeed = 3 - n;
              this.lastTotal = 3;
              if (n === 1) {
                this.lastChar[0] = buf[buf.length - 1];
              } else {
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
              }
              return buf.toString("base64", i, buf.length - n);
            }
  
            function base64End(buf) {
              var r = buf && buf.length ? this.write(buf) : "";
              if (this.lastNeed)
                return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
              return r;
            }
  
            // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
            function simpleWrite(buf) {
              return buf.toString(this.encoding);
            }
  
            function simpleEnd(buf) {
              return buf && buf.length ? this.write(buf) : "";
            }
          },
          { "safe-buffer": 296 },
        ],
        299: [
          function (require, module, exports) {
            (function (setImmediate, clearImmediate) {
              (function () {
                var nextTick = require("process/browser.js").nextTick;
                var apply = Function.prototype.apply;
                var slice = Array.prototype.slice;
                var immediateIds = {};
                var nextImmediateId = 0;
  
                // DOM APIs, for completeness
  
                exports.setTimeout = function () {
                  return new Timeout(
                    apply.call(setTimeout, window, arguments),
                    clearTimeout
                  );
                };
                exports.setInterval = function () {
                  return new Timeout(
                    apply.call(setInterval, window, arguments),
                    clearInterval
                  );
                };
                exports.clearTimeout = exports.clearInterval = function (
                  timeout
                ) {
                  timeout.close();
                };
  
                function Timeout(id, clearFn) {
                  this._id = id;
                  this._clearFn = clearFn;
                }
                Timeout.prototype.unref = Timeout.prototype.ref = function () {};
                Timeout.prototype.close = function () {
                  this._clearFn.call(window, this._id);
                };
  
                // Does not start the time, just sets up the members needed.
                exports.enroll = function (item, msecs) {
                  clearTimeout(item._idleTimeoutId);
                  item._idleTimeout = msecs;
                };
  
                exports.unenroll = function (item) {
                  clearTimeout(item._idleTimeoutId);
                  item._idleTimeout = -1;
                };
  
                exports._unrefActive = exports.active = function (item) {
                  clearTimeout(item._idleTimeoutId);
  
                  var msecs = item._idleTimeout;
                  if (msecs >= 0) {
                    item._idleTimeoutId = setTimeout(function onTimeout() {
                      if (item._onTimeout) item._onTimeout();
                    }, msecs);
                  }
                };
  
                // That's not how node.js implements it but the exposed api is the same.
                exports.setImmediate =
                  typeof setImmediate === "function"
                    ? setImmediate
                    : function (fn) {
                        var id = nextImmediateId++;
                        var args =
                          arguments.length < 2 ? false : slice.call(arguments, 1);
  
                        immediateIds[id] = true;
  
                        nextTick(function onNextTick() {
                          if (immediateIds[id]) {
                            // fn.call() is faster so we optimize for the common use-case
                            // @see http://jsperf.com/call-apply-segu
                            if (args) {
                              fn.apply(null, args);
                            } else {
                              fn.call(null);
                            }
                            // Prevent ids from leaking
                            exports.clearImmediate(id);
                          }
                        });
  
                        return id;
                      };
  
                exports.clearImmediate =
                  typeof clearImmediate === "function"
                    ? clearImmediate
                    : function (id) {
                        delete immediateIds[id];
                      };
              }.call(this));
            }.call(
              this,
              require("timers").setImmediate,
              require("timers").clearImmediate
            ));
          },
          { "process/browser.js": 261, timers: 299 },
        ],
        300: [
          function (require, module, exports) {
            var TINF_OK = 0;
            var TINF_DATA_ERROR = -3;
  
            function Tree() {
              this.table = new Uint16Array(16); /* table of code length counts */
              this.trans = new Uint16Array(
                288
              ); /* code -> symbol translation table */
            }
  
            function Data(source, dest) {
              this.source = source;
              this.sourceIndex = 0;
              this.tag = 0;
              this.bitcount = 0;
  
              this.dest = dest;
              this.destLen = 0;
  
              this.ltree = new Tree(); /* dynamic length/symbol tree */
              this.dtree = new Tree(); /* dynamic distance tree */
            }
  
            /* --------------------------------------------------- *
             * -- uninitialized global data (static structures) -- *
             * --------------------------------------------------- */
  
            var sltree = new Tree();
            var sdtree = new Tree();
  
            /* extra bits and base tables for length codes */
            var length_bits = new Uint8Array(30);
            var length_base = new Uint16Array(30);
  
            /* extra bits and base tables for distance codes */
            var dist_bits = new Uint8Array(30);
            var dist_base = new Uint16Array(30);
  
            /* special ordering of code length codes */
            var clcidx = new Uint8Array([
              16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15,
            ]);
  
            /* used by tinf_decode_trees, avoids allocations every call */
            var code_tree = new Tree();
            var lengths = new Uint8Array(288 + 32);
  
            /* ----------------------- *
             * -- utility functions -- *
             * ----------------------- */
  
            /* build extra bits and base tables */
            function tinf_build_bits_base(bits, base, delta, first) {
              var i, sum;
  
              /* build bits table */
              for (i = 0; i < delta; ++i) bits[i] = 0;
              for (i = 0; i < 30 - delta; ++i) bits[i + delta] = (i / delta) | 0;
  
              /* build base table */
              for (sum = first, i = 0; i < 30; ++i) {
                base[i] = sum;
                sum += 1 << bits[i];
              }
            }
  
            /* build the fixed huffman trees */
            function tinf_build_fixed_trees(lt, dt) {
              var i;
  
              /* build fixed length tree */
              for (i = 0; i < 7; ++i) lt.table[i] = 0;
  
              lt.table[7] = 24;
              lt.table[8] = 152;
              lt.table[9] = 112;
  
              for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
              for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
              for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
              for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;
  
              /* build fixed distance tree */
              for (i = 0; i < 5; ++i) dt.table[i] = 0;
  
              dt.table[5] = 32;
  
              for (i = 0; i < 32; ++i) dt.trans[i] = i;
            }
  
            /* given an array of code lengths, build a tree */
            var offs = new Uint16Array(16);
  
            function tinf_build_tree(t, lengths, off, num) {
              var i, sum;
  
              /* clear code length count table */
              for (i = 0; i < 16; ++i) t.table[i] = 0;
  
              /* scan symbol lengths, and sum code length counts */
              for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;
  
              t.table[0] = 0;
  
              /* compute offset table for distribution sort */
              for (sum = 0, i = 0; i < 16; ++i) {
                offs[i] = sum;
                sum += t.table[i];
              }
  
              /* create code->symbol translation table (symbols sorted by code) */
              for (i = 0; i < num; ++i) {
                if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
              }
            }
  
            /* ---------------------- *
             * -- decode functions -- *
             * ---------------------- */
  
            /* get one bit from source stream */
            function tinf_getbit(d) {
              /* check if tag is empty */
              if (!d.bitcount--) {
                /* load next tag */
                d.tag = d.source[d.sourceIndex++];
                d.bitcount = 7;
              }
  
              /* shift bit out of tag */
              var bit = d.tag & 1;
              d.tag >>>= 1;
  
              return bit;
            }
  
            /* read a num bit value from a stream and add base */
            function tinf_read_bits(d, num, base) {
              if (!num) return base;
  
              while (d.bitcount < 24) {
                d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                d.bitcount += 8;
              }
  
              var val = d.tag & (0xffff >>> (16 - num));
              d.tag >>>= num;
              d.bitcount -= num;
              return val + base;
            }
  
            /* given a data stream and a tree, decode a symbol */
            function tinf_decode_symbol(d, t) {
              while (d.bitcount < 24) {
                d.tag |= d.source[d.sourceIndex++] << d.bitcount;
                d.bitcount += 8;
              }
  
              var sum = 0,
                cur = 0,
                len = 0;
              var tag = d.tag;
  
              /* get more bits while code value is above sum */
              do {
                cur = 2 * cur + (tag & 1);
                tag >>>= 1;
                ++len;
  
                sum += t.table[len];
                cur -= t.table[len];
              } while (cur >= 0);
  
              d.tag = tag;
              d.bitcount -= len;
  
              return t.trans[sum + cur];
            }
  
            /* given a data stream, decode dynamic trees from it */
            function tinf_decode_trees(d, lt, dt) {
              var hlit, hdist, hclen;
              var i, num, length;
  
              /* get 5 bits HLIT (257-286) */
              hlit = tinf_read_bits(d, 5, 257);
  
              /* get 5 bits HDIST (1-32) */
              hdist = tinf_read_bits(d, 5, 1);
  
              /* get 4 bits HCLEN (4-19) */
              hclen = tinf_read_bits(d, 4, 4);
  
              for (i = 0; i < 19; ++i) lengths[i] = 0;
  
              /* read code lengths for code length alphabet */
              for (i = 0; i < hclen; ++i) {
                /* get 3 bits code length (0-7) */
                var clen = tinf_read_bits(d, 3, 0);
                lengths[clcidx[i]] = clen;
              }
  
              /* build code length tree */
              tinf_build_tree(code_tree, lengths, 0, 19);
  
              /* decode code lengths for the dynamic trees */
              for (num = 0; num < hlit + hdist; ) {
                var sym = tinf_decode_symbol(d, code_tree);
  
                switch (sym) {
                  case 16:
                    /* copy previous code length 3-6 times (read 2 bits) */
                    var prev = lengths[num - 1];
                    for (length = tinf_read_bits(d, 2, 3); length; --length) {
                      lengths[num++] = prev;
                    }
                    break;
                  case 17:
                    /* repeat code length 0 for 3-10 times (read 3 bits) */
                    for (length = tinf_read_bits(d, 3, 3); length; --length) {
                      lengths[num++] = 0;
                    }
                    break;
                  case 18:
                    /* repeat code length 0 for 11-138 times (read 7 bits) */
                    for (length = tinf_read_bits(d, 7, 11); length; --length) {
                      lengths[num++] = 0;
                    }
                    break;
                  default:
                    /* values 0-15 represent the actual code lengths */
                    lengths[num++] = sym;
                    break;
                }
              }
  
              /* build dynamic trees */
              tinf_build_tree(lt, lengths, 0, hlit);
              tinf_build_tree(dt, lengths, hlit, hdist);
            }
  
            /* ----------------------------- *
             * -- block inflate functions -- *
             * ----------------------------- */
  
            /* given a stream and two trees, inflate a block of data */
            function tinf_inflate_block_data(d, lt, dt) {
              while (1) {
                var sym = tinf_decode_symbol(d, lt);
  
                /* check for end of block */
                if (sym === 256) {
                  return TINF_OK;
                }
  
                if (sym < 256) {
                  d.dest[d.destLen++] = sym;
                } else {
                  var length, dist, offs;
                  var i;
  
                  sym -= 257;
  
                  /* possibly get more bits from length code */
                  length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
  
                  dist = tinf_decode_symbol(d, dt);
  
                  /* possibly get more bits from distance code */
                  offs =
                    d.destLen -
                    tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
  
                  /* copy match */
                  for (i = offs; i < offs + length; ++i) {
                    d.dest[d.destLen++] = d.dest[i];
                  }
                }
              }
            }
  
            /* inflate an uncompressed block of data */
            function tinf_inflate_uncompressed_block(d) {
              var length, invlength;
              var i;
  
              /* unread from bitbuffer */
              while (d.bitcount > 8) {
                d.sourceIndex--;
                d.bitcount -= 8;
              }
  
              /* get length */
              length = d.source[d.sourceIndex + 1];
              length = 256 * length + d.source[d.sourceIndex];
  
              /* get one's complement of length */
              invlength = d.source[d.sourceIndex + 3];
              invlength = 256 * invlength + d.source[d.sourceIndex + 2];
  
              /* check length */
              if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
  
              d.sourceIndex += 4;
  
              /* copy block */
              for (i = length; i; --i)
                d.dest[d.destLen++] = d.source[d.sourceIndex++];
  
              /* make sure we start next block on a byte boundary */
              d.bitcount = 0;
  
              return TINF_OK;
            }
  
            /* inflate stream from source to dest */
            function tinf_uncompress(source, dest) {
              var d = new Data(source, dest);
              var bfinal, btype, res;
  
              do {
                /* read final block flag */
                bfinal = tinf_getbit(d);
  
                /* read block type (2 bits) */
                btype = tinf_read_bits(d, 2, 0);
  
                /* decompress block */
                switch (btype) {
                  case 0:
                    /* decompress uncompressed block */
                    res = tinf_inflate_uncompressed_block(d);
                    break;
                  case 1:
                    /* decompress block with fixed huffman trees */
                    res = tinf_inflate_block_data(d, sltree, sdtree);
                    break;
                  case 2:
                    /* decompress block with dynamic huffman trees */
                    tinf_decode_trees(d, d.ltree, d.dtree);
                    res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                    break;
                  default:
                    res = TINF_DATA_ERROR;
                }
  
                if (res !== TINF_OK) throw new Error("Data error");
              } while (!bfinal);
  
              if (d.destLen < d.dest.length) {
                if (typeof d.dest.slice === "function")
                  return d.dest.slice(0, d.destLen);
                else return d.dest.subarray(0, d.destLen);
              }
  
              return d.dest;
            }
  
            /* -------------------- *
             * -- initialization -- *
             * -------------------- */
  
            /* build fixed huffman trees */
            tinf_build_fixed_trees(sltree, sdtree);
  
            /* build extra bits and base tables */
            tinf_build_bits_base(length_bits, length_base, 4, 3);
            tinf_build_bits_base(dist_bits, dist_base, 2, 1);
  
            /* fix a special case */
            length_bits[28] = 0;
            length_base[28] = 258;
  
            module.exports = tinf_uncompress;
          },
          {},
        ],
        301: [
          function (require, module, exports) {
            const inflate = require("tiny-inflate");
            const { swap32LE } = require("./swap");
  
            // Shift size for getting the index-1 table offset.
            const SHIFT_1 = 6 + 5;
  
            // Shift size for getting the index-2 table offset.
            const SHIFT_2 = 5;
  
            // Difference between the two shift sizes,
            // for getting an index-1 offset from an index-2 offset. 6=11-5
            const SHIFT_1_2 = SHIFT_1 - SHIFT_2;
  
            // Number of index-1 entries for the BMP. 32=0x20
            // This part of the index-1 table is omitted from the serialized form.
            const OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
  
            // Number of entries in an index-2 block. 64=0x40
            const INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
  
            // Mask for getting the lower bits for the in-index-2-block offset. */
            const INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
  
            // Shift size for shifting left the index array values.
            // Increases possible data size with 16-bit index values at the cost
            // of compactability.
            // This requires data blocks to be aligned by DATA_GRANULARITY.
            const INDEX_SHIFT = 2;
  
            // Number of entries in a data block. 32=0x20
            const DATA_BLOCK_LENGTH = 1 << SHIFT_2;
  
            // Mask for getting the lower bits for the in-data-block offset.
            const DATA_MASK = DATA_BLOCK_LENGTH - 1;
  
            // The part of the index-2 table for U+D800..U+DBFF stores values for
            // lead surrogate code _units_ not code _points_.
            // Values for lead surrogate code _points_ are indexed with this portion of the table.
            // Length=32=0x20=0x400>>SHIFT_2. (There are 1024=0x400 lead surrogates.)
            const LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
            const LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
  
            // Count the lengths of both BMP pieces. 2080=0x820
            const INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
  
            // The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
            // Length 32=0x20 for lead bytes C0..DF, regardless of SHIFT_2.
            const UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
            const UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; // U+0800 is the first code point after 2-byte UTF-8
  
            // The index-1 table, only used for supplementary code points, at offset 2112=0x840.
            // Variable length, for code points up to highStart, where the last single-value range starts.
            // Maximum length 512=0x200=0x100000>>SHIFT_1.
            // (For 0x100000 supplementary code points U+10000..U+10ffff.)
            //
            // The part of the index-2 table for supplementary code points starts
            // after this index-1 table.
            //
            // Both the index-1 table and the following part of the index-2 table
            // are omitted completely if there is only BMP data.
            const INDEX_1_OFFSET =
              UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
  
            // The alignment size of a data block. Also the granularity for compaction.
            const DATA_GRANULARITY = 1 << INDEX_SHIFT;
  
            class UnicodeTrie {
              constructor(data) {
                const isBuffer =
                  typeof data.readUInt32BE === "function" &&
                  typeof data.slice === "function";
  
                if (isBuffer || data instanceof Uint8Array) {
                  // read binary format
                  let uncompressedLength;
                  if (isBuffer) {
                    this.highStart = data.readUInt32LE(0);
                    this.errorValue = data.readUInt32LE(4);
                    uncompressedLength = data.readUInt32LE(8);
                    data = data.slice(12);
                  } else {
                    const view = new DataView(data.buffer);
                    this.highStart = view.getUint32(0, true);
                    this.errorValue = view.getUint32(4, true);
                    uncompressedLength = view.getUint32(8, true);
                    data = data.subarray(12);
                  }
  
                  // double inflate the actual trie data
                  data = inflate(data, new Uint8Array(uncompressedLength));
                  data = inflate(data, new Uint8Array(uncompressedLength));
  
                  // swap bytes from little-endian
                  swap32LE(data);
  
                  this.data = new Uint32Array(data.buffer);
                } else {
                  // pre-parsed data
                  ({
                    data: this.data,
                    highStart: this.highStart,
                    errorValue: this.errorValue,
                  } = data);
                }
              }
  
              get(codePoint) {
                let index;
                if (codePoint < 0 || codePoint > 0x10ffff) {
                  return this.errorValue;
                }
  
                if (
                  codePoint < 0xd800 ||
                  (codePoint > 0xdbff && codePoint <= 0xffff)
                ) {
                  // Ordinary BMP code point, excluding leading surrogates.
                  // BMP uses a single level lookup.  BMP index starts at offset 0 in the index.
                  // data is stored in the index array itself.
                  index =
                    (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                if (codePoint <= 0xffff) {
                  // Lead Surrogate Code Point.  A Separate index section is stored for
                  // lead surrogate code units and code points.
                  //   The main index has the code unit data.
                  //   For this function, we need the code point data.
                  index =
                    (this.data[
                      LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)
                    ] <<
                      INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                if (codePoint < this.highStart) {
                  // Supplemental code point, use two-level lookup.
                  index =
                    this.data[
                      INDEX_1_OFFSET -
                        OMITTED_BMP_INDEX_1_LENGTH +
                        (codePoint >> SHIFT_1)
                    ];
                  index =
                    this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
                  index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
                  return this.data[index];
                }
  
                return this.data[this.data.length - DATA_GRANULARITY];
              }
            }
  
            module.exports = UnicodeTrie;
          },
          { "./swap": 302, "tiny-inflate": 300 },
        ],
        302: [
          function (require, module, exports) {
            const isBigEndian =
              new Uint8Array(new Uint32Array([0x12345678]).buffer)[0] === 0x12;
  
            const swap = (b, n, m) => {
              let i = b[n];
              b[n] = b[m];
              b[m] = i;
            };
  
            const swap32 = (array) => {
              const len = array.length;
              for (let i = 0; i < len; i += 4) {
                swap(array, i, i + 3);
                swap(array, i + 1, i + 2);
              }
            };
  
            const swap32LE = (array) => {
              if (isBigEndian) {
                swap32(array);
              }
            };
  
            module.exports = {
              swap32LE: swap32LE,
            };
          },
          {},
        ],
        303: [
          function (require, module, exports) {
            "use strict";
  
            var UnicodeTrie = require("unicode-trie");
            var base64 = require("base64-js");
  
            var categories = [
              "Cc",
              "Zs",
              "Po",
              "Sc",
              "Ps",
              "Pe",
              "Sm",
              "Pd",
              "Nd",
              "Lu",
              "Sk",
              "Pc",
              "Ll",
              "So",
              "Lo",
              "Pi",
              "Cf",
              "No",
              "Pf",
              "Lt",
              "Lm",
              "Mn",
              "Me",
              "Mc",
              "Nl",
              "Zl",
              "Zp",
              "Cs",
              "Co",
            ];
            var combiningClasses = [
              "Not_Reordered",
              "Above",
              "Above_Right",
              "Below",
              "Attached_Above_Right",
              "Attached_Below",
              "Overlay",
              "Iota_Subscript",
              "Double_Below",
              "Double_Above",
              "Below_Right",
              "Above_Left",
              "CCC10",
              "CCC11",
              "CCC12",
              "CCC13",
              "CCC14",
              "CCC15",
              "CCC16",
              "CCC17",
              "CCC18",
              "CCC19",
              "CCC20",
              "CCC21",
              "CCC22",
              "CCC23",
              "CCC24",
              "CCC25",
              "CCC30",
              "CCC31",
              "CCC32",
              "CCC27",
              "CCC28",
              "CCC29",
              "CCC33",
              "CCC34",
              "CCC35",
              "CCC36",
              "Nukta",
              "Virama",
              "CCC84",
              "CCC91",
              "CCC103",
              "CCC107",
              "CCC118",
              "CCC122",
              "CCC129",
              "CCC130",
              "CCC132",
              "Attached_Above",
              "Below_Left",
              "Left",
              "Kana_Voicing",
              "CCC26",
              "Right",
            ];
            var scripts = [
              "Common",
              "Latin",
              "Bopomofo",
              "Inherited",
              "Greek",
              "Coptic",
              "Cyrillic",
              "Armenian",
              "Hebrew",
              "Arabic",
              "Syriac",
              "Thaana",
              "Nko",
              "Samaritan",
              "Mandaic",
              "Devanagari",
              "Bengali",
              "Gurmukhi",
              "Gujarati",
              "Oriya",
              "Tamil",
              "Telugu",
              "Kannada",
              "Malayalam",
              "Sinhala",
              "Thai",
              "Lao",
              "Tibetan",
              "Myanmar",
              "Georgian",
              "Hangul",
              "Ethiopic",
              "Cherokee",
              "Canadian_Aboriginal",
              "Ogham",
              "Runic",
              "Tagalog",
              "Hanunoo",
              "Buhid",
              "Tagbanwa",
              "Khmer",
              "Mongolian",
              "Limbu",
              "Tai_Le",
              "New_Tai_Lue",
              "Buginese",
              "Tai_Tham",
              "Balinese",
              "Sundanese",
              "Batak",
              "Lepcha",
              "Ol_Chiki",
              "Braille",
              "Glagolitic",
              "Tifinagh",
              "Han",
              "Hiragana",
              "Katakana",
              "Yi",
              "Lisu",
              "Vai",
              "Bamum",
              "Syloti_Nagri",
              "Phags_Pa",
              "Saurashtra",
              "Kayah_Li",
              "Rejang",
              "Javanese",
              "Cham",
              "Tai_Viet",
              "Meetei_Mayek",
              "null",
              "Linear_B",
              "Lycian",
              "Carian",
              "Old_Italic",
              "Gothic",
              "Old_Permic",
              "Ugaritic",
              "Old_Persian",
              "Deseret",
              "Shavian",
              "Osmanya",
              "Osage",
              "Elbasan",
              "Caucasian_Albanian",
              "Linear_A",
              "Cypriot",
              "Imperial_Aramaic",
              "Palmyrene",
              "Nabataean",
              "Hatran",
              "Phoenician",
              "Lydian",
              "Meroitic_Hieroglyphs",
              "Meroitic_Cursive",
              "Kharoshthi",
              "Old_South_Arabian",
              "Old_North_Arabian",
              "Manichaean",
              "Avestan",
              "Inscriptional_Parthian",
              "Inscriptional_Pahlavi",
              "Psalter_Pahlavi",
              "Old_Turkic",
              "Old_Hungarian",
              "Hanifi_Rohingya",
              "Old_Sogdian",
              "Sogdian",
              "Elymaic",
              "Brahmi",
              "Kaithi",
              "Sora_Sompeng",
              "Chakma",
              "Mahajani",
              "Sharada",
              "Khojki",
              "Multani",
              "Khudawadi",
              "Grantha",
              "Newa",
              "Tirhuta",
              "Siddham",
              "Modi",
              "Takri",
              "Ahom",
              "Dogra",
              "Warang_Citi",
              "Nandinagari",
              "Zanabazar_Square",
              "Soyombo",
              "Pau_Cin_Hau",
              "Bhaiksuki",
              "Marchen",
              "Masaram_Gondi",
              "Gunjala_Gondi",
              "Makasar",
              "Cuneiform",
              "Egyptian_Hieroglyphs",
              "Anatolian_Hieroglyphs",
              "Mro",
              "Bassa_Vah",
              "Pahawh_Hmong",
              "Medefaidrin",
              "Miao",
              "Tangut",
              "Nushu",
              "Duployan",
              "SignWriting",
              "Nyiakeng_Puachue_Hmong",
              "Wancho",
              "Mende_Kikakui",
              "Adlam",
            ];
            var eaw = ["N", "Na", "A", "W", "H", "F"];
            var data = {
              categories: categories,
              combiningClasses: combiningClasses,
              scripts: scripts,
              eaw: eaw,
            };
  
            var data$1 =
              "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";
            var trieData = { data: data$1 };
  
            var log2 = Math.log2 || ((n) => Math.log(n) / Math.LN2);
  
            var bits = (n) => (log2(n) + 1) | 0;
  
            var buildUnicodeProperties = (data, trie) => {
              // compute the number of bits stored for each field
              var CATEGORY_BITS = bits(data.categories.length - 1);
              var COMBINING_BITS = bits(data.combiningClasses.length - 1);
              var SCRIPT_BITS = bits(data.scripts.length - 1);
              var EAW_BITS = bits(data.eaw.length - 1);
              var NUMBER_BITS = 10; // compute shift and mask values for each field
  
              var CATEGORY_SHIFT =
                COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
              var COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
              var SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;
              var EAW_SHIFT = NUMBER_BITS;
              var CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;
              var COMBINING_MASK = (1 << COMBINING_BITS) - 1;
              var SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;
              var EAW_MASK = (1 << EAW_BITS) - 1;
              var NUMBER_MASK = (1 << NUMBER_BITS) - 1;
  
              var getCategory = (codePoint) => {
                var val = trie.get(codePoint);
                return data.categories[(val >> CATEGORY_SHIFT) & CATEGORY_MASK];
              };
  
              var getCombiningClass = (codePoint) => {
                var val = trie.get(codePoint);
                return data.combiningClasses[
                  (val >> COMBINING_SHIFT) & COMBINING_MASK
                ];
              };
  
              var getScript = (codePoint) => {
                var val = trie.get(codePoint);
                return data.scripts[(val >> SCRIPT_SHIFT) & SCRIPT_MASK];
              };
  
              var getEastAsianWidth = (codePoint) => {
                var val = trie.get(codePoint);
                return data.eaw[(val >> EAW_SHIFT) & EAW_MASK];
              };
  
              var getNumericValue = (codePoint) => {
                var val = trie.get(codePoint);
                var num = val & NUMBER_MASK;
  
                if (num === 0) {
                  return null;
                } else if (num <= 50) {
                  return num - 1;
                } else if (num < 0x1e0) {
                  var numerator = (num >> 4) - 12;
                  var denominator = (num & 0xf) + 1;
                  return numerator / denominator;
                } else if (num < 0x300) {
                  val = (num >> 5) - 14;
                  var exp = (num & 0x1f) + 2;
  
                  while (exp > 0) {
                    val *= 10;
                    exp--;
                  }
  
                  return val;
                } else {
                  val = (num >> 2) - 0xbf;
  
                  var _exp = (num & 3) + 1;
  
                  while (_exp > 0) {
                    val *= 60;
                    _exp--;
                  }
  
                  return val;
                }
              };
  
              var isAlphabetic = (codePoint) => {
                var category = getCategory(codePoint);
                return (
                  category === "Lu" ||
                  category === "Ll" ||
                  category === "Lt" ||
                  category === "Lm" ||
                  category === "Lo" ||
                  category === "Nl"
                );
              };
  
              var isDigit = (codePoint) => getCategory(codePoint) === "Nd";
  
              var isPunctuation = (codePoint) => {
                var category = getCategory(codePoint);
                return (
                  category === "Pc" ||
                  category === "Pd" ||
                  category === "Pe" ||
                  category === "Pf" ||
                  category === "Pi" ||
                  category === "Po" ||
                  category === "Ps"
                );
              };
  
              var isLowerCase = (codePoint) => {
                return getCategory(codePoint) === "Ll";
              };
  
              var isUpperCase = (codePoint) => getCategory(codePoint) === "Lu";
  
              var isTitleCase = (codePoint) => getCategory(codePoint) === "Lt";
  
              var isWhiteSpace = (codePoint) => {
                var category = getCategory(codePoint);
                return (
                  category === "Zs" || category === "Zl" || category === "Zp"
                );
              };
  
              var isBaseForm = (codePoint) => {
                var category = getCategory(codePoint);
                return (
                  category === "Nd" ||
                  category === "No" ||
                  category === "Nl" ||
                  category === "Lu" ||
                  category === "Ll" ||
                  category === "Lt" ||
                  category === "Lm" ||
                  category === "Lo" ||
                  category === "Me" ||
                  category === "Mc"
                );
              };
  
              var isMark = (codePoint) => {
                var category = getCategory(codePoint);
                return (
                  category === "Mn" || category === "Me" || category === "Mc"
                );
              };
  
              return {
                getCategory,
                getCombiningClass,
                getScript,
                getEastAsianWidth,
                getNumericValue,
                isAlphabetic,
                isDigit,
                isPunctuation,
                isLowerCase,
                isUpperCase,
                isTitleCase,
                isWhiteSpace,
                isBaseForm,
                isMark,
              };
            };
  
            var trie = new UnicodeTrie(base64.toByteArray(trieData.data));
            var unicodeProperties = buildUnicodeProperties(data, trie);
  
            module.exports = unicodeProperties;
          },
          { "base64-js": 28, "unicode-trie": 301 },
        ],
        304: [
          function (require, module, exports) {
            // Generated by CoffeeScript 1.7.1
            var UnicodeTrie, inflate;
  
            inflate = require("tiny-inflate");
  
            UnicodeTrie = (function () {
              var DATA_BLOCK_LENGTH,
                DATA_GRANULARITY,
                DATA_MASK,
                INDEX_1_OFFSET,
                INDEX_2_BLOCK_LENGTH,
                INDEX_2_BMP_LENGTH,
                INDEX_2_MASK,
                INDEX_SHIFT,
                LSCP_INDEX_2_LENGTH,
                LSCP_INDEX_2_OFFSET,
                OMITTED_BMP_INDEX_1_LENGTH,
                SHIFT_1,
                SHIFT_1_2,
                SHIFT_2,
                UTF8_2B_INDEX_2_LENGTH,
                UTF8_2B_INDEX_2_OFFSET;
  
              SHIFT_1 = 6 + 5;
  
              SHIFT_2 = 5;
  
              SHIFT_1_2 = SHIFT_1 - SHIFT_2;
  
              OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
  
              INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
  
              INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
  
              INDEX_SHIFT = 2;
  
              DATA_BLOCK_LENGTH = 1 << SHIFT_2;
  
              DATA_MASK = DATA_BLOCK_LENGTH - 1;
  
              LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
  
              LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
  
              INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
  
              UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
  
              UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;
  
              INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
  
              DATA_GRANULARITY = 1 << INDEX_SHIFT;
  
              function UnicodeTrie(data) {
                var isBuffer, uncompressedLength, view;
                isBuffer =
                  typeof data.readUInt32BE === "function" &&
                  typeof data.slice === "function";
                if (isBuffer || data instanceof Uint8Array) {
                  if (isBuffer) {
                    this.highStart = data.readUInt32BE(0);
                    this.errorValue = data.readUInt32BE(4);
                    uncompressedLength = data.readUInt32BE(8);
                    data = data.slice(12);
                  } else {
                    view = new DataView(data.buffer);
                    this.highStart = view.getUint32(0);
                    this.errorValue = view.getUint32(4);
                    uncompressedLength = view.getUint32(8);
                    data = data.subarray(12);
                  }
                  data = inflate(data, new Uint8Array(uncompressedLength));
                  data = inflate(data, new Uint8Array(uncompressedLength));
                  this.data = new Uint32Array(data.buffer);
                } else {
                  (this.data = data.data),
                    (this.highStart = data.highStart),
                    (this.errorValue = data.errorValue);
                }
              }
  
              UnicodeTrie.prototype.get = function (codePoint) {
                var index;
                if (codePoint < 0 || codePoint > 0x10ffff) {
                  return this.errorValue;
                }
                if (
                  codePoint < 0xd800 ||
                  (codePoint > 0xdbff && codePoint <= 0xffff)
                ) {
                  index =
                    (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
                if (codePoint <= 0xffff) {
                  index =
                    (this.data[
                      LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)
                    ] <<
                      INDEX_SHIFT) +
                    (codePoint & DATA_MASK);
                  return this.data[index];
                }
                if (codePoint < this.highStart) {
                  index =
                    this.data[
                      INDEX_1_OFFSET -
                        OMITTED_BMP_INDEX_1_LENGTH +
                        (codePoint >> SHIFT_1)
                    ];
                  index =
                    this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
                  index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
                  return this.data[index];
                }
                return this.data[this.data.length - DATA_GRANULARITY];
              };
  
              return UnicodeTrie;
            })();
  
            module.exports = UnicodeTrie;
          },
          { "tiny-inflate": 300 },
        ],
        305: [
          function (require, module, exports) {
            (function (global) {
              (function () {
                /**
                 * Module exports.
                 */
  
                module.exports = deprecate;
  
                /**
                 * Mark that a method should not be used.
                 * Returns a modified function which warns once by default.
                 *
                 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
                 *
                 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
                 * will throw an Error when invoked.
                 *
                 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
                 * will invoke `console.trace()` instead of `console.error()`.
                 *
                 * @param {Function} fn - the function to deprecate
                 * @param {String} msg - the string to print to the console when `fn` is invoked
                 * @returns {Function} a new "deprecated" version of `fn`
                 * @api public
                 */
  
                function deprecate(fn, msg) {
                  if (config("noDeprecation")) {
                    return fn;
                  }
  
                  var warned = false;
                  function deprecated() {
                    if (!warned) {
                      if (config("throwDeprecation")) {
                        throw new Error(msg);
                      } else if (config("traceDeprecation")) {
                        console.trace(msg);
                      } else {
                        console.warn(msg);
                      }
                      warned = true;
                    }
                    return fn.apply(this, arguments);
                  }
  
                  return deprecated;
                }
  
                /**
                 * Checks `localStorage` for boolean values for the given `name`.
                 *
                 * @param {String} name
                 * @returns {Boolean}
                 * @api private
                 */
  
                function config(name) {
                  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
                  try {
                    if (!global.localStorage) return false;
                  } catch (_) {
                    return false;
                  }
                  var val = global.localStorage[name];
                  if (null == val) return false;
                  return String(val).toLowerCase() === "true";
                }
              }.call(this));
            }.call(
              this,
              typeof global !== "undefined"
                ? global
                : typeof self !== "undefined"
                ? self
                : typeof window !== "undefined"
                ? window
                : {}
            ));
          },
          {},
        ],
        306: [
          function (require, module, exports) {
            arguments[4][4][0].apply(exports, arguments);
          },
          { dup: 4 },
        ],
        307: [
          function (require, module, exports) {
            arguments[4][5][0].apply(exports, arguments);
          },
          { "./support/isBuffer": 306, _process: 261, dup: 5, inherits: 240 },
        ],
      },
      {},
      [1]
    )(1);
  });